import { jsx, Fragment, jsxs } from '@emotion/react/jsx-runtime';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import '@fontsource/nunito-sans/300.css';
import '@fontsource/nunito-sans/400.css';
import '@fontsource/nunito-sans/700.css';
import { Backdrop, CircularProgress, Typography, Stack, Paper, Collapse, Divider, TextField, InputAdornment, IconButton, Button, List, ListItem, ListItemAvatar, Avatar, ListItemText, FormControl as FormControl$1, InputLabel, Input, Box, FormHelperText, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Popover, FormControlLabel, Switch as Switch$1, Accordion, AccordionSummary, AccordionDetails, Alert, Snackbar, Table, tableCellClasses, TableBody, TableRow, TableCell, Tooltip, ButtonBase, Select as Select$1, Link, MenuItem, ListItemIcon, Checkbox as Checkbox$1, ToggleButtonGroup, ToggleButton, ListItemButton, InputBase, Slider, RadioGroup, Radio as Radio$1, Slide, createTheme, ButtonGroup, Tab, Tabs, AppBar, Toolbar, Zoom, GlobalStyles, ScopedCssBaseline, Autocomplete } from '@mui/material';
import { styled, ThemeProvider as ThemeProvider$1 } from '@mui/material/styles';
import { deDE, LicenseInfo } from '@mui/x-data-grid-pro';
import { useQueryClient, useMutation, useQuery, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import * as React from 'react';
import React__default, { useState, useEffect, createContext, useCallback, useMemo, useRef, forwardRef, useContext, useLayoutEffect, Suspense, cloneElement, Children, lazy } from 'react';
import { createDispatchHook, createSelectorHook, batch, Provider } from 'react-redux';
import { useNavigate, useLocation, Link as Link$1, useParams, Routes, Route, HashRouter } from 'react-router-dom';
import { createElement as createElement$2, ThemeProvider } from '@emotion/react';
import { initReactI18next, useTranslation } from 'react-i18next';
import { nanoid, createSelector, createSlice, configureStore, combineReducers } from '@reduxjs/toolkit';
import _$1, { keyBy, isFunction, isString as isString$1, isObject as isObject$h, values as values$5, partition, groupBy, clamp, uniq, uniqBy, compact, forEach as forEach$2, isArray as isArray$6, uniqueId, omit, cloneDeep, isNumber, isRegExp as isRegExp$3, first as first$1, memoize, isEmpty, get as get$2, lowerCase, intersection, debounce, merge as merge$1, identity, map as map$1, mapValues as mapValues$1, includes as includes$1, some, assignWith, intersectionBy, has as has$2, filter as filter$1, isEqual, reduce as reduce$1, sortBy, maxBy, flow as flow$1, throttle, chain } from 'lodash';
import * as _ from 'lodash/fp';
import { mapValues, map, reduce, pickBy, forEach as forEach$1, curry, mergeWith, isArray as isArray$5, flow, first, has as has$1, assign as assign$2, equals, toNumber, anyPass, overEvery, includes, filter, indexBy, keys as keys$3, endsWith, reject, get as get$3, pick, isEmpty as isEmpty$1, split as split$4, last, set as set$4, merge as merge$2, compact as compact$1, uniq as uniq$1, find as find$1, clamp as clamp$1, toString as toString$j, identity as identity$1, noop as noop$1, isNumber as isNumber$1, omit as omit$1, findIndex, replace as replace$9, some as some$1, join as join$4 } from 'lodash/fp';
import i18n, { t } from 'i18next';
import ReactGA from 'react-ga4';
import ohm from 'ohm-js';
import * as Drei from '@react-three/drei';
import { Box as Box$1, Line, Text as Text$5, useGLTF, useProgress, useBounds, Html, PivotControls, useContextBridge } from '@react-three/drei';
import * as THREE from 'three';
import { Vector3, MeshStandardMaterial, Box3, Quaternion, Euler, MathUtils, Matrix4, PerspectiveCamera } from 'three';
import Konva from 'konva';
import MobileDetect from 'mobile-detect';
import { AspectRatioOutlined, Calculate, ExpandMore, CloudUpload, Clear, Add, Remove, Edit as Edit$4, ErrorOutline, VisibilityOff, InfoOutlined, CheckOutlined, Delete, Search, SwapVert, NavigateNext, ArrowBack, ArrowCircleRight, ArrowCircleLeft, Check, Facebook, Twitter, LinkedIn, CropRotate, Cancel as Cancel$4, SaveAs, AddCircle, Refresh, Close } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import Folder from '@mui/icons-material/Folder';
import FormControl from '@mui/material/FormControl';
import TextField$1 from '@mui/material/TextField';
import Typography$1 from '@mui/material/Typography';
import SettingsIcon from '@mui/icons-material/Settings';
import Editor$4 from '@monaco-editor/react';
import { colord, extend } from 'colord';
import { RgbStringColorPicker } from 'react-colorful';
import * as R3F from '@react-three/fiber';
import { useThree, useFrame, Canvas } from '@react-three/fiber';
import Compiler from 'react-jsx-compiler';
import uuidv4 from 'uuid-browser';
import ViewInArIcon from '@mui/icons-material/ViewInAr';
import clsx from 'clsx';
import CircularProgress$1 from '@mui/material/CircularProgress';
import QRCode from 'react-qr-code';
import DoneIcon from '@mui/icons-material/Done';
import { GLTFExporter } from 'three/examples/jsm/exporters/GLTFExporter';
import { USDZExporter } from 'three/examples/jsm/exporters/USDZExporter';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Dialog$1 from '@mui/material/Dialog';
import Paper$1 from '@mui/material/Paper';
import Table$1 from '@mui/material/Table';
import TableBody$1 from '@mui/material/TableBody';
import TableCell$1 from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow$1 from '@mui/material/TableRow';
import Box$2 from '@mui/material/Box';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Tooltip$1 from '@mui/material/Tooltip';
import harmonies from 'colord/plugins/harmonies';
import EditIcon from '@mui/icons-material/Edit';
import { create as create$9 } from 'zustand';
import AddIcon from '@mui/icons-material/Add';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AspectRatioIcon from '@mui/icons-material/AspectRatio';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment$1 from '@mui/material/InputAdornment';
import { FixedSizeList } from 'react-window';
import useMediaQuery from '@mui/material/useMediaQuery';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import parse from 'html-react-parser';
import * as yup from 'yup';
import DialogContent$1 from '@mui/material/DialogContent';
import Button$1 from '@mui/material/Button';
import DialogActions$1 from '@mui/material/DialogActions';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle$1 from '@mui/material/DialogTitle';
import IconButton$1 from '@mui/material/IconButton';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import useMeasure from 'react-use-measure';
import { deepmerge } from '@mui/utils';
import { grey } from '@mui/material/colors';
import * as PP from '@react-three/postprocessing';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import WarningIcon from '@mui/icons-material/Warning';
import DragIndicator from '@mui/icons-material/DragIndicator';
import { Draggable, DragDropContext, Droppable } from 'react-beautiful-dnd';
import Grid from '@mui/material/Grid';
import Tab$1 from '@mui/material/Tab';
import Tabs$1 from '@mui/material/Tabs';
import Checkbox$2 from '@mui/material/Checkbox';
import CheckIcon from '@mui/icons-material/Check';
import { MoonLoader } from 'react-spinners';
import Snackbar$1 from '@mui/material/Snackbar/Snackbar';

const K3_PACKAGE_VERSION = "5.0.3";

const K3_EXTERNAL_VERSION = "3.0";

var _getEnv;
const getEnv = name => process.env[`NX_${name}`] || process.env[`REACT_APP_${name}`];
const throwMissingEnv = envVar => {
  throw new Error(`environment variable ${envVar} not provided.`);
};
const env = {
  /** The URL of the API */
  apiUrl: getEnv("API_URL") || throwMissingEnv("API_URL"),
  /** The Analytics key for the Admin Analytics. Only provide this in Frontend */
  adminAnalytics: getEnv("ADMIN_ANALYTICS") || null,
  /** The URL of the docs */
  helpUrl: getEnv("HELP_URL") || throwMissingEnv("HELP_URL"),
  /** The URL of assets not shipped by the API */
  docUrl: getEnv("DOC_URL") || throwMissingEnv("DOC_URL"),
  /* Key for bugsnag exception tracking or null */
  bugsnagKey: getEnv("BUGSNAG_KEY") || null,
  /** The Draco compression lib url */
  libsUrl: getEnv("LIBS_URL") || throwMissingEnv("LIBS_URL"),
  disable3D: (_getEnv = getEnv("DISABLE_3D")) != null ? _getEnv : false,
  originalDomain: getEnv("ORIGINAL_DOMAIN") || "k3.objectcode.de"
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$w =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$A = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$z = fails$A;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$z(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var fails$y = fails$A;

var functionBindNative = !fails$y(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$3 = functionBindNative;

var call$r = Function.prototype.call;

var functionCall = NATIVE_BIND$3 ? call$r.bind(call$r) : function () {
  return call$r.apply(call$r, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$4 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$4 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$4(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$6 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var NATIVE_BIND$2 = functionBindNative;

var FunctionPrototype$2 = Function.prototype;
var call$q = FunctionPrototype$2.call;
var uncurryThisWithBind = NATIVE_BIND$2 && FunctionPrototype$2.bind.bind(call$q, call$q);

var functionUncurryThis = NATIVE_BIND$2 ? uncurryThisWithBind : function (fn) {
  return function () {
    return call$q.apply(fn, arguments);
  };
};

var uncurryThis$D = functionUncurryThis;

var toString$i = uncurryThis$D({}.toString);
var stringSlice$b = uncurryThis$D(''.slice);

var classofRaw$2 = function (it) {
  return stringSlice$b(toString$i(it), 8, -1);
};

var uncurryThis$C = functionUncurryThis;
var fails$x = fails$A;
var classof$e = classofRaw$2;

var $Object$4 = Object;
var split$3 = uncurryThis$C(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$x(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$4('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$e(it) == 'String' ? split$3(it, '') : $Object$4(it);
} : $Object$4;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined$8 = function (it) {
  return it === null || it === undefined;
};

var isNullOrUndefined$7 = isNullOrUndefined$8;

var $TypeError$j = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$b = function (it) {
  if (isNullOrUndefined$7(it)) throw $TypeError$j("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$3 = indexedObject;
var requireObjectCoercible$a = requireObjectCoercible$b;

var toIndexedObject$6 = function (it) {
  return IndexedObject$3(requireObjectCoercible$a(it));
};

var documentAll$2 = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var IS_HTMLDDA = typeof documentAll$2 == 'undefined' && documentAll$2 !== undefined;

var documentAll_1 = {
  all: documentAll$2,
  IS_HTMLDDA: IS_HTMLDDA
};

var $documentAll$1 = documentAll_1;

var documentAll$1 = $documentAll$1.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$q = $documentAll$1.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll$1;
} : function (argument) {
  return typeof argument == 'function';
};

var isCallable$p = isCallable$q;
var $documentAll = documentAll_1;

var documentAll = $documentAll.all;

var isObject$g = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable$p(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable$p(it);
};

var global$v = global$w;
var isCallable$o = isCallable$q;

var aFunction = function (argument) {
  return isCallable$o(argument) ? argument : undefined;
};

var getBuiltIn$7 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$v[namespace]) : global$v[namespace] && global$v[namespace][method];
};

var uncurryThis$B = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$B({}.isPrototypeOf);

var engineUserAgent = typeof navigator != 'undefined' && String(navigator.userAgent) || '';

var global$u = global$w;
var userAgent$5 = engineUserAgent;

var process$4 = global$u.process;
var Deno$1 = global$u.Deno;
var versions = process$4 && process$4.versions || Deno$1 && Deno$1.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent$5) {
  match = userAgent$5.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent$5.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */

var V8_VERSION$1 = engineV8Version;
var fails$w = fails$A;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$w(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION$1 && V8_VERSION$1 < 41;
});

/* eslint-disable es/no-symbol -- required for testing */

var NATIVE_SYMBOL$2 = symbolConstructorDetection;

var useSymbolAsUid = NATIVE_SYMBOL$2
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var getBuiltIn$6 = getBuiltIn$7;
var isCallable$n = isCallable$q;
var isPrototypeOf$7 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var $Object$3 = Object;

var isSymbol$3 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$6('Symbol');
  return isCallable$n($Symbol) && isPrototypeOf$7($Symbol.prototype, $Object$3(it));
};

var $String$5 = String;

var tryToString$6 = function (argument) {
  try {
    return $String$5(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$m = isCallable$q;
var tryToString$5 = tryToString$6;

var $TypeError$i = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$c = function (argument) {
  if (isCallable$m(argument)) return argument;
  throw $TypeError$i(tryToString$5(argument) + ' is not a function');
};

var aCallable$b = aCallable$c;
var isNullOrUndefined$6 = isNullOrUndefined$8;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$7 = function (V, P) {
  var func = V[P];
  return isNullOrUndefined$6(func) ? undefined : aCallable$b(func);
};

var call$p = functionCall;
var isCallable$l = isCallable$q;
var isObject$f = isObject$g;

var $TypeError$h = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$l(fn = input.toString) && !isObject$f(val = call$p(fn, input))) return val;
  if (isCallable$l(fn = input.valueOf) && !isObject$f(val = call$p(fn, input))) return val;
  if (pref !== 'string' && isCallable$l(fn = input.toString) && !isObject$f(val = call$p(fn, input))) return val;
  throw $TypeError$h("Can't convert object to primitive value");
};

var shared$4 = {exports: {}};

var isPure = false;

var global$t = global$w;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$7 = Object.defineProperty;

var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$7(global$t, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$t[key] = value;
  } return value;
};

var global$s = global$w;
var defineGlobalProperty$2 = defineGlobalProperty$3;

var SHARED = '__core-js_shared__';
var store$3 = global$s[SHARED] || defineGlobalProperty$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$4.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.28.0',
  mode: 'global',
  copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.28.0/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var requireObjectCoercible$9 = requireObjectCoercible$b;

var $Object$2 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$c = function (argument) {
  return $Object$2(requireObjectCoercible$9(argument));
};

var uncurryThis$A = functionUncurryThis;
var toObject$b = toObject$c;

var hasOwnProperty = uncurryThis$A({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$b(it), key);
};

var uncurryThis$z = functionUncurryThis;

var id$1 = 0;
var postfix = Math.random();
var toString$h = uncurryThis$z(1.0.toString);

var uid$3 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$h(++id$1 + postfix, 36);
};

var global$r = global$w;
var shared$3 = shared$4.exports;
var hasOwn$g = hasOwnProperty_1;
var uid$2 = uid$3;
var NATIVE_SYMBOL$1 = symbolConstructorDetection;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var Symbol$3 = global$r.Symbol;
var WellKnownSymbolsStore = shared$3('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$3['for'] || Symbol$3 : Symbol$3 && Symbol$3.withoutSetter || uid$2;

var wellKnownSymbol$o = function (name) {
  if (!hasOwn$g(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL$1 && hasOwn$g(Symbol$3, name)
      ? Symbol$3[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

var call$o = functionCall;
var isObject$e = isObject$g;
var isSymbol$2 = isSymbol$3;
var getMethod$6 = getMethod$7;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$n = wellKnownSymbol$o;

var $TypeError$g = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$n('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$2 = function (input, pref) {
  if (!isObject$e(input) || isSymbol$2(input)) return input;
  var exoticToPrim = getMethod$6(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$o(exoticToPrim, input, pref);
    if (!isObject$e(result) || isSymbol$2(result)) return result;
    throw $TypeError$g("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive$1 = toPrimitive$2;
var isSymbol$1 = isSymbol$3;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$4 = function (argument) {
  var key = toPrimitive$1(argument, 'string');
  return isSymbol$1(key) ? key : key + '';
};

var global$q = global$w;
var isObject$d = isObject$g;

var document$3 = global$q.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$d(document$3) && isObject$d(document$3.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$3.createElement(it) : {};
};

var DESCRIPTORS$h = descriptors;
var fails$v = fails$A;
var createElement$1 = documentCreateElement$2;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$h && !fails$v(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement$1('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var DESCRIPTORS$g = descriptors;
var call$n = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$5 = createPropertyDescriptor$6;
var toIndexedObject$5 = toIndexedObject$6;
var toPropertyKey$3 = toPropertyKey$4;
var hasOwn$f = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$g ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$5(O);
  P = toPropertyKey$3(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$f(O, P)) return createPropertyDescriptor$5(!call$n(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var objectDefineProperty = {};

var DESCRIPTORS$f = descriptors;
var fails$u = fails$A;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$f && fails$u(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});

var isObject$c = isObject$g;

var $String$4 = String;
var $TypeError$f = TypeError;

// `Assert: Type(argument) is Object`
var anObject$k = function (argument) {
  if (isObject$c(argument)) return argument;
  throw $TypeError$f($String$4(argument) + ' is not an object');
};

var DESCRIPTORS$e = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$j = anObject$k;
var toPropertyKey$2 = toPropertyKey$4;

var $TypeError$e = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$e ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$j(O);
  P = toPropertyKey$2(P);
  anObject$j(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$j(O);
  P = toPropertyKey$2(P);
  anObject$j(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError$e('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$d = descriptors;
var definePropertyModule$5 = objectDefineProperty;
var createPropertyDescriptor$4 = createPropertyDescriptor$6;

var createNonEnumerableProperty$9 = DESCRIPTORS$d ? function (object, key, value) {
  return definePropertyModule$5.f(object, key, createPropertyDescriptor$4(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var makeBuiltIn$3 = {exports: {}};

var DESCRIPTORS$c = descriptors;
var hasOwn$e = hasOwnProperty_1;

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$c && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$e(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$c || (DESCRIPTORS$c && getDescriptor(FunctionPrototype$1, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$y = functionUncurryThis;
var isCallable$k = isCallable$q;
var store$1 = sharedStore;

var functionToString = uncurryThis$y(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$k(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$3 = store$1.inspectSource;

var global$p = global$w;
var isCallable$j = isCallable$q;

var WeakMap$1 = global$p.WeakMap;

var weakMapBasicDetection = isCallable$j(WeakMap$1) && /native code/.test(String(WeakMap$1));

var shared$2 = shared$4.exports;
var uid$1 = uid$3;

var keys$2 = shared$2('keys');

var sharedKey$3 = function (key) {
  return keys$2[key] || (keys$2[key] = uid$1(key));
};

var hiddenKeys$4 = {};

var NATIVE_WEAK_MAP = weakMapBasicDetection;
var global$o = global$w;
var isObject$b = isObject$g;
var createNonEnumerableProperty$8 = createNonEnumerableProperty$9;
var hasOwn$d = hasOwnProperty_1;
var shared$1 = sharedStore;
var sharedKey$2 = sharedKey$3;
var hiddenKeys$3 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$5 = global$o.TypeError;
var WeakMap = global$o.WeakMap;
var set$3, get$1, has;

var enforce = function (it) {
  return has(it) ? get$1(it) : set$3(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$b(it) || (state = get$1(it)).type !== TYPE) {
      throw TypeError$5('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared$1.state) {
  var store = shared$1.state || (shared$1.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set$3 = function (it, metadata) {
    if (store.has(it)) throw TypeError$5(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get$1 = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey$2('state');
  hiddenKeys$3[STATE] = true;
  set$3 = function (it, metadata) {
    if (hasOwn$d(it, STATE)) throw TypeError$5(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$8(it, STATE, metadata);
    return metadata;
  };
  get$1 = function (it) {
    return hasOwn$d(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$d(it, STATE);
  };
}

var internalState = {
  set: set$3,
  get: get$1,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var uncurryThis$x = functionUncurryThis;
var fails$t = fails$A;
var isCallable$i = isCallable$q;
var hasOwn$c = hasOwnProperty_1;
var DESCRIPTORS$b = descriptors;
var CONFIGURABLE_FUNCTION_NAME$2 = functionName.CONFIGURABLE;
var inspectSource$2 = inspectSource$3;
var InternalStateModule$9 = internalState;

var enforceInternalState$3 = InternalStateModule$9.enforce;
var getInternalState$6 = InternalStateModule$9.get;
var $String$3 = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$6 = Object.defineProperty;
var stringSlice$a = uncurryThis$x(''.slice);
var replace$8 = uncurryThis$x(''.replace);
var join$3 = uncurryThis$x([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS$b && !fails$t(function () {
  return defineProperty$6(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$2 = makeBuiltIn$3.exports = function (value, name, options) {
  if (stringSlice$a($String$3(name), 0, 7) === 'Symbol(') {
    name = '[' + replace$8($String$3(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$c(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$2 && value.name !== name)) {
    if (DESCRIPTORS$b) defineProperty$6(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$c(options, 'arity') && value.length !== options.arity) {
    defineProperty$6(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$c(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$b) defineProperty$6(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState$3(value);
  if (!hasOwn$c(state, 'source')) {
    state.source = join$3(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$2(function toString() {
  return isCallable$i(this) && getInternalState$6(this).source || inspectSource$2(this);
}, 'toString');

var isCallable$h = isCallable$q;
var definePropertyModule$4 = objectDefineProperty;
var makeBuiltIn$1 = makeBuiltIn$3.exports;
var defineGlobalProperty$1 = defineGlobalProperty$3;

var defineBuiltIn$d = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$h(value)) makeBuiltIn$1(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule$4.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor$7 = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor$7 : ceil)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$a = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$9 = toIntegerOrInfinity$a;

var max$2 = Math.max;
var min$3 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$4 = function (index, length) {
  var integer = toIntegerOrInfinity$9(index);
  return integer < 0 ? max$2(integer + length, 0) : min$3(integer, length);
};

var toIntegerOrInfinity$8 = toIntegerOrInfinity$a;

var min$2 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$9 = function (argument) {
  return argument > 0 ? min$2(toIntegerOrInfinity$8(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength$8 = toLength$9;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$d = function (obj) {
  return toLength$8(obj.length);
};

var toIndexedObject$4 = toIndexedObject$6;
var toAbsoluteIndex$3 = toAbsoluteIndex$4;
var lengthOfArrayLike$c = lengthOfArrayLike$d;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$4 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$4($this);
    var length = lengthOfArrayLike$c(O);
    var index = toAbsoluteIndex$3(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$4(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$4(false)
};

var uncurryThis$w = functionUncurryThis;
var hasOwn$b = hasOwnProperty_1;
var toIndexedObject$3 = toIndexedObject$6;
var indexOf$1 = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;

var push$6 = uncurryThis$w([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$3(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$b(hiddenKeys$2, key) && hasOwn$b(O, key) && push$6(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$b(O, key = names[i++])) {
    ~indexOf$1(result, key) || push$6(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$5 = getBuiltIn$7;
var uncurryThis$v = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$i = anObject$k;

var concat$2 = uncurryThis$v([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$5('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$i(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$2(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$a = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule$1 = objectGetOwnPropertyDescriptor;
var definePropertyModule$3 = objectDefineProperty;

var copyConstructorProperties$2 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$3.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule$1.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$a(target, key) && !(exceptions && hasOwn$a(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$s = fails$A;
var isCallable$g = isCallable$q;

var replacement = /#|\.prototype\./;

var isForced$3 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable$g(detection) ? fails$s(detection)
    : !!detection;
};

var normalize = isForced$3.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$3.data = {};
var NATIVE = isForced$3.NATIVE = 'N';
var POLYFILL = isForced$3.POLYFILL = 'P';

var isForced_1 = isForced$3;

var global$n = global$w;
var getOwnPropertyDescriptor$3 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$7 = createNonEnumerableProperty$9;
var defineBuiltIn$c = defineBuiltIn$d;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties$1 = copyConstructorProperties$2;
var isForced$2 = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$n;
  } else if (STATIC) {
    target = global$n[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global$n[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor$3(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced$2(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties$1(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$7(sourceProperty, 'sham', true);
    }
    defineBuiltIn$c(target, key, sourceProperty, options);
  }
};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS$a = descriptors;
var uncurryThis$u = functionUncurryThis;
var call$m = functionCall;
var fails$r = fails$A;
var objectKeys$1 = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$a = toObject$c;
var IndexedObject$2 = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty$5 = Object.defineProperty;
var concat$1 = uncurryThis$u([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$r(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$a && $assign({ b: 1 }, $assign(defineProperty$5({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$5(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys$1($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$a(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject$2(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat$1(objectKeys$1(S), getOwnPropertySymbols(S)) : objectKeys$1(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$a || call$m(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$r = _export;
var assign$1 = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$r({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign$1 }, {
  assign: assign$1
});

var classof$d = classofRaw$2;

var engineIsNode = typeof process != 'undefined' && classof$d(process) == 'process';

var uncurryThis$t = functionUncurryThis;
var aCallable$a = aCallable$c;

var functionUncurryThisAccessor = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis$t(aCallable$a(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};

var isCallable$f = isCallable$q;

var $String$2 = String;
var $TypeError$d = TypeError;

var aPossiblePrototype$1 = function (argument) {
  if (typeof argument == 'object' || isCallable$f(argument)) return argument;
  throw $TypeError$d("Can't set " + $String$2(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */

var uncurryThisAccessor = functionUncurryThisAccessor;
var anObject$h = anObject$k;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject$h(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var defineProperty$4 = objectDefineProperty.f;
var hasOwn$9 = hasOwnProperty_1;
var wellKnownSymbol$m = wellKnownSymbol$o;

var TO_STRING_TAG$4 = wellKnownSymbol$m('toStringTag');

var setToStringTag$6 = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn$9(target, TO_STRING_TAG$4)) {
    defineProperty$4(target, TO_STRING_TAG$4, { configurable: true, value: TAG });
  }
};

var makeBuiltIn = makeBuiltIn$3.exports;
var defineProperty$3 = objectDefineProperty;

var defineBuiltInAccessor$6 = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty$3.f(target, name, descriptor);
};

var getBuiltIn$4 = getBuiltIn$7;
var defineBuiltInAccessor$5 = defineBuiltInAccessor$6;
var wellKnownSymbol$l = wellKnownSymbol$o;
var DESCRIPTORS$9 = descriptors;

var SPECIES$4 = wellKnownSymbol$l('species');

var setSpecies$3 = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn$4(CONSTRUCTOR_NAME);

  if (DESCRIPTORS$9 && Constructor && !Constructor[SPECIES$4]) {
    defineBuiltInAccessor$5(Constructor, SPECIES$4, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var isPrototypeOf$6 = objectIsPrototypeOf;

var $TypeError$c = TypeError;

var anInstance$5 = function (it, Prototype) {
  if (isPrototypeOf$6(Prototype, it)) return it;
  throw $TypeError$c('Incorrect invocation');
};

var wellKnownSymbol$k = wellKnownSymbol$o;

var TO_STRING_TAG$3 = wellKnownSymbol$k('toStringTag');
var test$2 = {};

test$2[TO_STRING_TAG$3] = 'z';

var toStringTagSupport = String(test$2) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$e = isCallable$q;
var classofRaw$1 = classofRaw$2;
var wellKnownSymbol$j = wellKnownSymbol$o;

var TO_STRING_TAG$2 = wellKnownSymbol$j('toStringTag');
var $Object$1 = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw$1(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$c = TO_STRING_TAG_SUPPORT ? classofRaw$1 : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object$1(it), TO_STRING_TAG$2)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw$1(O)
    // ES3 arguments fallback
    : (result = classofRaw$1(O)) == 'Object' && isCallable$e(O.callee) ? 'Arguments' : result;
};

var uncurryThis$s = functionUncurryThis;
var fails$q = fails$A;
var isCallable$d = isCallable$q;
var classof$b = classof$c;
var getBuiltIn$3 = getBuiltIn$7;
var inspectSource$1 = inspectSource$3;

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn$3('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec$5 = uncurryThis$s(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable$d(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable$d(argument)) return false;
  switch (classof$b(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec$5(constructorRegExp, inspectSource$1(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor$3 = !construct || fails$q(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var isConstructor$2 = isConstructor$3;
var tryToString$4 = tryToString$6;

var $TypeError$b = TypeError;

// `Assert: IsConstructor(argument) is true`
var aConstructor$2 = function (argument) {
  if (isConstructor$2(argument)) return argument;
  throw $TypeError$b(tryToString$4(argument) + ' is not a constructor');
};

var anObject$g = anObject$k;
var aConstructor$1 = aConstructor$2;
var isNullOrUndefined$5 = isNullOrUndefined$8;
var wellKnownSymbol$i = wellKnownSymbol$o;

var SPECIES$3 = wellKnownSymbol$i('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor$3 = function (O, defaultConstructor) {
  var C = anObject$g(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined$5(S = anObject$g(C)[SPECIES$3]) ? defaultConstructor : aConstructor$1(S);
};

var NATIVE_BIND$1 = functionBindNative;

var FunctionPrototype = Function.prototype;
var apply$3 = FunctionPrototype.apply;
var call$l = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND$1 ? call$l.bind(apply$3) : function () {
  return call$l.apply(apply$3, arguments);
});

var classofRaw = classofRaw$2;
var uncurryThis$r = functionUncurryThis;

var functionUncurryThisClause = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis$r(fn);
};

var uncurryThis$q = functionUncurryThisClause;
var aCallable$9 = aCallable$c;
var NATIVE_BIND = functionBindNative;

var bind$a = uncurryThis$q(uncurryThis$q.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable$9(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind$a(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var getBuiltIn$2 = getBuiltIn$7;

var html$2 = getBuiltIn$2('document', 'documentElement');

var uncurryThis$p = functionUncurryThis;

var arraySlice$5 = uncurryThis$p([].slice);

var $TypeError$a = TypeError;

var validateArgumentsLength$3 = function (passed, required) {
  if (passed < required) throw $TypeError$a('Not enough arguments');
  return passed;
};

var userAgent$4 = engineUserAgent;

// eslint-disable-next-line redos/no-vulnerable -- safe
var engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent$4);

var global$m = global$w;
var apply$2 = functionApply;
var bind$9 = functionBindContext;
var isCallable$c = isCallable$q;
var hasOwn$8 = hasOwnProperty_1;
var fails$p = fails$A;
var html$1 = html$2;
var arraySlice$4 = arraySlice$5;
var createElement = documentCreateElement$2;
var validateArgumentsLength$2 = validateArgumentsLength$3;
var IS_IOS$1 = engineIsIos;
var IS_NODE$4 = engineIsNode;

var set$2 = global$m.setImmediate;
var clear = global$m.clearImmediate;
var process$3 = global$m.process;
var Dispatch = global$m.Dispatch;
var Function$1 = global$m.Function;
var MessageChannel = global$m.MessageChannel;
var String$1 = global$m.String;
var counter = 0;
var queue$2 = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var $location, defer, channel, port;

fails$p(function () {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location = global$m.location;
});

var run = function (id) {
  if (hasOwn$8(queue$2, id)) {
    var fn = queue$2[id];
    delete queue$2[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var eventListener = function (event) {
  run(event.data);
};

var globalPostMessageDefer = function (id) {
  // old engines have not location.origin
  global$m.postMessage(String$1(id), $location.protocol + '//' + $location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set$2 || !clear) {
  set$2 = function setImmediate(handler) {
    validateArgumentsLength$2(arguments.length, 1);
    var fn = isCallable$c(handler) ? handler : Function$1(handler);
    var args = arraySlice$4(arguments, 1);
    queue$2[++counter] = function () {
      apply$2(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue$2[id];
  };
  // Node.js 0.8-
  if (IS_NODE$4) {
    defer = function (id) {
      process$3.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS$1) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = eventListener;
    defer = bind$9(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global$m.addEventListener &&
    isCallable$c(global$m.postMessage) &&
    !global$m.importScripts &&
    $location && $location.protocol !== 'file:' &&
    !fails$p(globalPostMessageDefer)
  ) {
    defer = globalPostMessageDefer;
    global$m.addEventListener('message', eventListener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html$1.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html$1.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task$1 = {
  set: set$2,
  clear: clear
};

var Queue$2 = function () {
  this.head = null;
  this.tail = null;
};

Queue$2.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    var tail = this.tail;
    if (tail) tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      var next = this.head = entry.next;
      if (next === null) this.tail = null;
      return entry.item;
    }
  }
};

var queue$1 = Queue$2;

var userAgent$3 = engineUserAgent;

var engineIsIosPebble = /ipad|iphone|ipod/i.test(userAgent$3) && typeof Pebble != 'undefined';

var userAgent$2 = engineUserAgent;

var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(userAgent$2);

var global$l = global$w;
var bind$8 = functionBindContext;
var getOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f;
var macrotask = task$1.set;
var Queue$1 = queue$1;
var IS_IOS = engineIsIos;
var IS_IOS_PEBBLE = engineIsIosPebble;
var IS_WEBOS_WEBKIT = engineIsWebosWebkit;
var IS_NODE$3 = engineIsNode;

var MutationObserver = global$l.MutationObserver || global$l.WebKitMutationObserver;
var document$2 = global$l.document;
var process$2 = global$l.process;
var Promise$1 = global$l.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor$2(global$l, 'queueMicrotask');
var microtask$1 = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;
var notify$1, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!microtask$1) {
  var queue = new Queue$1();

  var flush = function () {
    var parent, fn;
    if (IS_NODE$3 && (parent = process$2.domain)) parent.exit();
    while (fn = queue.get()) try {
      fn();
    } catch (error) {
      if (queue.head) notify$1();
      throw error;
    }
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE$3 && !IS_WEBOS_WEBKIT && MutationObserver && document$2) {
    toggle = true;
    node = document$2.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify$1 = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$1.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise$1;
    then = bind$8(promise.then, promise);
    notify$1 = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE$3) {
    notify$1 = function () {
      process$2.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // `webpack` dev server bug on IE global methods - use bind(fn, global)
    macrotask = bind$8(macrotask, global$l);
    notify$1 = function () {
      macrotask(flush);
    };
  }

  microtask$1 = function (fn) {
    if (!queue.head) notify$1();
    queue.add(fn);
  };
}

var microtask_1 = microtask$1;

var hostReportErrors$1 = function (a, b) {
  try {
    // eslint-disable-next-line no-console -- safe
    arguments.length == 1 ? console.error(a) : console.error(a, b);
  } catch (error) { /* empty */ }
};

var perform$3 = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var global$k = global$w;

var promiseNativeConstructor = global$k.Promise;

/* global Deno -- Deno case */

var engineIsDeno = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';

var IS_DENO$1 = engineIsDeno;
var IS_NODE$2 = engineIsNode;

var engineIsBrowser = !IS_DENO$1 && !IS_NODE$2
  && typeof window == 'object'
  && typeof document == 'object';

var global$j = global$w;
var NativePromiseConstructor$3 = promiseNativeConstructor;
var isCallable$b = isCallable$q;
var isForced$1 = isForced_1;
var inspectSource = inspectSource$3;
var wellKnownSymbol$h = wellKnownSymbol$o;
var IS_BROWSER = engineIsBrowser;
var IS_DENO = engineIsDeno;
var V8_VERSION = engineV8Version;

NativePromiseConstructor$3 && NativePromiseConstructor$3.prototype;
var SPECIES$2 = wellKnownSymbol$h('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT$1 = isCallable$b(global$j.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR$5 = isForced$1('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor$3);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor$3);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new NativePromiseConstructor$3(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES$2] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (IS_BROWSER || IS_DENO) && !NATIVE_PROMISE_REJECTION_EVENT$1;
});

var promiseConstructorDetection = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR$5,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT$1,
  SUBCLASSING: SUBCLASSING
};

var newPromiseCapability$2 = {};

var aCallable$8 = aCallable$c;

var $TypeError$9 = TypeError;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw $TypeError$9('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable$8(resolve);
  this.reject = aCallable$8(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
newPromiseCapability$2.f = function (C) {
  return new PromiseCapability(C);
};

var $$q = _export;
var IS_NODE$1 = engineIsNode;
var global$i = global$w;
var call$k = functionCall;
var defineBuiltIn$b = defineBuiltIn$d;
var setPrototypeOf$5 = objectSetPrototypeOf;
var setToStringTag$5 = setToStringTag$6;
var setSpecies$2 = setSpecies$3;
var aCallable$7 = aCallable$c;
var isCallable$a = isCallable$q;
var isObject$a = isObject$g;
var anInstance$4 = anInstance$5;
var speciesConstructor$2 = speciesConstructor$3;
var task = task$1.set;
var microtask = microtask_1;
var hostReportErrors = hostReportErrors$1;
var perform$2 = perform$3;
var Queue = queue$1;
var InternalStateModule$8 = internalState;
var NativePromiseConstructor$2 = promiseNativeConstructor;
var PromiseConstructorDetection = promiseConstructorDetection;
var newPromiseCapabilityModule$3 = newPromiseCapability$2;

var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR$4 = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule$8.getterFor(PROMISE);
var setInternalState$7 = InternalStateModule$8.set;
var NativePromisePrototype$1 = NativePromiseConstructor$2 && NativePromiseConstructor$2.prototype;
var PromiseConstructor = NativePromiseConstructor$2;
var PromisePrototype = NativePromisePrototype$1;
var TypeError$4 = global$i.TypeError;
var document$1 = global$i.document;
var process$1 = global$i.process;
var newPromiseCapability$1 = newPromiseCapabilityModule$3.f;
var newGenericPromiseCapability = newPromiseCapability$1;

var DISPATCH_EVENT = !!(document$1 && document$1.createEvent && global$i.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject$a(it) && isCallable$a(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state == FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(TypeError$4('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call$k(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$1.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global$i.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global$i['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call$k(task, global$i, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform$2(function () {
        if (IS_NODE$1) {
          process$1.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE$1 || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call$k(task, global$i, function () {
    var promise = state.facade;
    if (IS_NODE$1) {
      process$1.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind$7 = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError$4("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call$k(then, value,
            bind$7(internalResolve, wrapper, state),
            bind$7(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR$4) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance$4(this, PromisePrototype);
    aCallable$7(executor);
    call$k(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind$7(internalResolve, state), bind$7(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState$7(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn$b(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability$1(speciesConstructor$2(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable$a(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable$a(onRejected) && onRejected;
    reaction.domain = IS_NODE$1 ? process$1.domain : undefined;
    if (state.state == PENDING) state.reactions.add(reaction);
    else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind$7(internalResolve, state);
    this.reject = bind$7(internalReject, state);
  };

  newPromiseCapabilityModule$3.f = newPromiseCapability$1 = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (isCallable$a(NativePromiseConstructor$2) && NativePromisePrototype$1 !== Object.prototype) {
    nativeThen = NativePromisePrototype$1.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn$b(NativePromisePrototype$1, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call$k(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype$1.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf$5) {
      setPrototypeOf$5(NativePromisePrototype$1, PromisePrototype);
    }
  }
}

$$q({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR$4 }, {
  Promise: PromiseConstructor
});

setToStringTag$5(PromiseConstructor, PROMISE, false);
setSpecies$2(PROMISE);

var iterators = {};

var wellKnownSymbol$g = wellKnownSymbol$o;
var Iterators$4 = iterators;

var ITERATOR$9 = wellKnownSymbol$g('iterator');
var ArrayPrototype$1 = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod$3 = function (it) {
  return it !== undefined && (Iterators$4.Array === it || ArrayPrototype$1[ITERATOR$9] === it);
};

var classof$a = classof$c;
var getMethod$5 = getMethod$7;
var isNullOrUndefined$4 = isNullOrUndefined$8;
var Iterators$3 = iterators;
var wellKnownSymbol$f = wellKnownSymbol$o;

var ITERATOR$8 = wellKnownSymbol$f('iterator');

var getIteratorMethod$5 = function (it) {
  if (!isNullOrUndefined$4(it)) return getMethod$5(it, ITERATOR$8)
    || getMethod$5(it, '@@iterator')
    || Iterators$3[classof$a(it)];
};

var call$j = functionCall;
var aCallable$6 = aCallable$c;
var anObject$f = anObject$k;
var tryToString$3 = tryToString$6;
var getIteratorMethod$4 = getIteratorMethod$5;

var $TypeError$8 = TypeError;

var getIterator$4 = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod$4(argument) : usingIterator;
  if (aCallable$6(iteratorMethod)) return anObject$f(call$j(iteratorMethod, argument));
  throw $TypeError$8(tryToString$3(argument) + ' is not iterable');
};

var call$i = functionCall;
var anObject$e = anObject$k;
var getMethod$4 = getMethod$7;

var iteratorClose$2 = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject$e(iterator);
  try {
    innerResult = getMethod$4(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call$i(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject$e(innerResult);
  return value;
};

var bind$6 = functionBindContext;
var call$h = functionCall;
var anObject$d = anObject$k;
var tryToString$2 = tryToString$6;
var isArrayIteratorMethod$2 = isArrayIteratorMethod$3;
var lengthOfArrayLike$b = lengthOfArrayLike$d;
var isPrototypeOf$5 = objectIsPrototypeOf;
var getIterator$3 = getIterator$4;
var getIteratorMethod$3 = getIteratorMethod$5;
var iteratorClose$1 = iteratorClose$2;

var $TypeError$7 = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

var iterate$3 = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind$6(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose$1(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject$d(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod$3(iterable);
    if (!iterFn) throw $TypeError$7(tryToString$2(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod$2(iterFn)) {
      for (index = 0, length = lengthOfArrayLike$b(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf$5(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator$3(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call$h(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose$1(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf$5(ResultPrototype, result)) return result;
  } return new Result(false);
};

var wellKnownSymbol$e = wellKnownSymbol$o;

var ITERATOR$7 = wellKnownSymbol$e('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR$7] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration$2 = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$7] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var NativePromiseConstructor$1 = promiseNativeConstructor;
var checkCorrectnessOfIteration$1 = checkCorrectnessOfIteration$2;
var FORCED_PROMISE_CONSTRUCTOR$3 = promiseConstructorDetection.CONSTRUCTOR;

var promiseStaticsIncorrectIteration = FORCED_PROMISE_CONSTRUCTOR$3 || !checkCorrectnessOfIteration$1(function (iterable) {
  NativePromiseConstructor$1.all(iterable).then(undefined, function () { /* empty */ });
});

var $$p = _export;
var call$g = functionCall;
var aCallable$5 = aCallable$c;
var newPromiseCapabilityModule$2 = newPromiseCapability$2;
var perform$1 = perform$3;
var iterate$2 = iterate$3;
var PROMISE_STATICS_INCORRECT_ITERATION$1 = promiseStaticsIncorrectIteration;

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$$p({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION$1 }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$2.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform$1(function () {
      var $promiseResolve = aCallable$5(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate$2(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call$g($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$o = _export;
var FORCED_PROMISE_CONSTRUCTOR$2 = promiseConstructorDetection.CONSTRUCTOR;
var NativePromiseConstructor = promiseNativeConstructor;
var getBuiltIn$1 = getBuiltIn$7;
var isCallable$9 = isCallable$q;
var defineBuiltIn$a = defineBuiltIn$d;

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$$o({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR$2, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (isCallable$9(NativePromiseConstructor)) {
  var method = getBuiltIn$1('Promise').prototype['catch'];
  if (NativePromisePrototype['catch'] !== method) {
    defineBuiltIn$a(NativePromisePrototype, 'catch', method, { unsafe: true });
  }
}

var $$n = _export;
var call$f = functionCall;
var aCallable$4 = aCallable$c;
var newPromiseCapabilityModule$1 = newPromiseCapability$2;
var perform = perform$3;
var iterate$1 = iterate$3;
var PROMISE_STATICS_INCORRECT_ITERATION = promiseStaticsIncorrectIteration;

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$$n({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$1.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable$4(C.resolve);
      iterate$1(iterable, function (promise) {
        call$f($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$m = _export;
var call$e = functionCall;
var newPromiseCapabilityModule = newPromiseCapability$2;
var FORCED_PROMISE_CONSTRUCTOR$1 = promiseConstructorDetection.CONSTRUCTOR;

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$$m({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR$1 }, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule.f(this);
    call$e(capability.reject, undefined, r);
    return capability.promise;
  }
});

var anObject$c = anObject$k;
var isObject$9 = isObject$g;
var newPromiseCapability = newPromiseCapability$2;

var promiseResolve$1 = function (C, x) {
  anObject$c(C);
  if (isObject$9(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var $$l = _export;
var getBuiltIn = getBuiltIn$7;
var FORCED_PROMISE_CONSTRUCTOR = promiseConstructorDetection.CONSTRUCTOR;
var promiseResolve = promiseResolve$1;

getBuiltIn('Promise');

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$$l({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve(this, x);
  }
});

var objectDefineProperties = {};

var DESCRIPTORS$8 = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule$2 = objectDefineProperty;
var anObject$b = anObject$k;
var toIndexedObject$2 = toIndexedObject$6;
var objectKeys = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$8 && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$b(O);
  var props = toIndexedObject$2(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule$2.f(O, key = keys[index++], props[key]);
  return O;
};

/* global ActiveXObject -- old IE, WSH */

var anObject$a = anObject$k;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html = html$2;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$1 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE$1 = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$1('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE$1][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE$1] = anObject$a(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE$1] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var wellKnownSymbol$d = wellKnownSymbol$o;
var create$8 = objectCreate;
var defineProperty$2 = objectDefineProperty.f;

var UNSCOPABLES = wellKnownSymbol$d('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  defineProperty$2(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create$8(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$4 = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var fails$o = fails$A;

var correctPrototypeGetter = !fails$o(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var hasOwn$7 = hasOwnProperty_1;
var isCallable$8 = isCallable$q;
var toObject$9 = toObject$c;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype$2 = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject$9(O);
  if (hasOwn$7(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$8(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype$2 : null;
};

var fails$n = fails$A;
var isCallable$7 = isCallable$q;
var isObject$8 = isObject$g;
var getPrototypeOf$3 = objectGetPrototypeOf;
var defineBuiltIn$9 = defineBuiltIn$d;
var wellKnownSymbol$c = wellKnownSymbol$o;

var ITERATOR$6 = wellKnownSymbol$c('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$3(getPrototypeOf$3(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject$8(IteratorPrototype$2) || fails$n(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$6].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$7(IteratorPrototype$2[ITERATOR$6])) {
  defineBuiltIn$9(IteratorPrototype$2, ITERATOR$6, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create$7 = objectCreate;
var createPropertyDescriptor$3 = createPropertyDescriptor$6;
var setToStringTag$4 = setToStringTag$6;
var Iterators$2 = iterators;

var returnThis$1 = function () { return this; };

var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create$7(IteratorPrototype$1, { next: createPropertyDescriptor$3(+!ENUMERABLE_NEXT, next) });
  setToStringTag$4(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$2[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var $$k = _export;
var call$d = functionCall;
var FunctionName$1 = functionName;
var isCallable$6 = isCallable$q;
var createIteratorConstructor$2 = iteratorCreateConstructor;
var getPrototypeOf$2 = objectGetPrototypeOf;
var setPrototypeOf$4 = objectSetPrototypeOf;
var setToStringTag$3 = setToStringTag$6;
var createNonEnumerableProperty$6 = createNonEnumerableProperty$9;
var defineBuiltIn$8 = defineBuiltIn$d;
var wellKnownSymbol$b = wellKnownSymbol$o;
var Iterators$1 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME$3 = FunctionName$1.PROPER;
var CONFIGURABLE_FUNCTION_NAME$1 = FunctionName$1.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$5 = wellKnownSymbol$b('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor$2(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$5]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf$2(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf$2(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf$4) {
          setPrototypeOf$4(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable$6(CurrentIteratorPrototype[ITERATOR$5])) {
          defineBuiltIn$8(CurrentIteratorPrototype, ITERATOR$5, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag$3(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME$3 && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME$1) {
      createNonEnumerableProperty$6(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call$d(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn$8(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$k({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$5] !== defaultIterator) {
    defineBuiltIn$8(IterablePrototype, ITERATOR$5, defaultIterator, { name: DEFAULT });
  }
  Iterators$1[NAME] = defaultIterator;

  return methods;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject$3 = function (value, done) {
  return { value: value, done: done };
};

var toIndexedObject$1 = toIndexedObject$6;
var addToUnscopables$3 = addToUnscopables$4;
var Iterators = iterators;
var InternalStateModule$7 = internalState;
var defineProperty$1 = objectDefineProperty.f;
var defineIterator$1 = iteratorDefine;
var createIterResultObject$2 = createIterResultObject$3;
var DESCRIPTORS$7 = descriptors;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$6 = InternalStateModule$7.set;
var getInternalState$5 = InternalStateModule$7.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator$1(Array, 'Array', function (iterated, kind) {
  setInternalState$6(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject$1(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$5(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject$2(undefined, true);
  }
  if (kind == 'keys') return createIterResultObject$2(index, false);
  if (kind == 'values') return createIterResultObject$2(target[index], false);
  return createIterResultObject$2([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values$4 = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$3('keys');
addToUnscopables$3('values');
addToUnscopables$3('entries');

// V8 ~ Chrome 45- bug
if (DESCRIPTORS$7 && values$4.name !== 'values') try {
  defineProperty$1(values$4, 'name', { value: 'values' });
} catch (error) { /* empty */ }

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var global$h = global$w;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty$5 = createNonEnumerableProperty$9;
var wellKnownSymbol$a = wellKnownSymbol$o;

var ITERATOR$4 = wellKnownSymbol$a('iterator');
var TO_STRING_TAG$1 = wellKnownSymbol$a('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$4] !== ArrayValues) try {
      createNonEnumerableProperty$5(CollectionPrototype, ITERATOR$4, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$4] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG$1]) {
      createNonEnumerableProperty$5(CollectionPrototype, TO_STRING_TAG$1, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty$5(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global$h[COLLECTION_NAME] && global$h[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

const sxBackdropStyles = {
  zIndex: theme => {
    var _theme$zIndex$modal, _theme$zIndex;
    return ((_theme$zIndex$modal = (_theme$zIndex = theme.zIndex) == null ? void 0 : _theme$zIndex.modal) != null ? _theme$zIndex$modal : 0) + 1;
  },
  color: "#fff",
  display: "flex",
  flexDirection: "column"
};
function Loading({
  loading,
  delay = 500
}) {
  const [showLoadingIndicator, setLoadingIndicatorVisibility] = useState(false);
  useEffect(() => {
    if (!loading) return;
    const timer = setTimeout(() => setLoadingIndicatorVisibility(true), delay);
    // This will clear Timeout when component unmont like in
    // willComponentUnmount.
    return () => {
      clearTimeout(timer);
      setLoadingIndicatorVisibility(false);
    };
  }, [loading, delay]);
  return loading && showLoadingIndicator ? jsx(Backdrop, {
    sx: sxBackdropStyles,
    open: loading,
    "data-cy": "CircularProgress",
    children: jsx(CircularProgress, {
      color: "inherit",
      size: 200
    })
  }) : null;
}

var classof$9 = classof$c;

var $String$1 = String;

var toString$g = function (argument) {
  if (classof$9(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String$1(argument);
};

var anObject$9 = anObject$k;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags$1 = function () {
  var that = anObject$9(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

var fails$m = fails$A;
var global$g = global$w;

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp$2 = global$g.RegExp;

var UNSUPPORTED_Y$2 = fails$m(function () {
  var re = $RegExp$2('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY$1 = UNSUPPORTED_Y$2 || fails$m(function () {
  return !$RegExp$2('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y$2 || fails$m(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp$2('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

var regexpStickyHelpers = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY$1,
  UNSUPPORTED_Y: UNSUPPORTED_Y$2
};

var fails$l = fails$A;
var global$f = global$w;

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp$1 = global$f.RegExp;

var regexpUnsupportedDotAll = fails$l(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});

var fails$k = fails$A;
var global$e = global$w;

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global$e.RegExp;

var regexpUnsupportedNcg = fails$k(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call$c = functionCall;
var uncurryThis$o = functionUncurryThis;
var toString$f = toString$g;
var regexpFlags = regexpFlags$1;
var stickyHelpers$1 = regexpStickyHelpers;
var shared = shared$4.exports;
var create$6 = objectCreate;
var getInternalState$4 = internalState.get;
var UNSUPPORTED_DOT_ALL$1 = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG$1 = regexpUnsupportedNcg;

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt$8 = uncurryThis$o(''.charAt);
var indexOf = uncurryThis$o(''.indexOf);
var replace$7 = uncurryThis$o(''.replace);
var stringSlice$9 = uncurryThis$o(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call$c(nativeExec, re1, 'a');
  call$c(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y$1 = stickyHelpers$1.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y$1 || UNSUPPORTED_DOT_ALL$1 || UNSUPPORTED_NCG$1;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState$4(re);
    var str = toString$f(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call$c(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y$1 && re.sticky;
    var flags = call$c(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace$7(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice$9(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt$8(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call$c(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice$9(match.input, charsAdded);
        match[0] = stringSlice$9(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      call$c(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create$6(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec$2 = patchedExec;

var $$j = _export;
var exec$4 = regexpExec$2;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$$j({ target: 'RegExp', proto: true, forced: /./.exec !== exec$4 }, {
  exec: exec$4
});

// TODO: Remove from `core-js@4` since it's moved to entry points

var uncurryThis$n = functionUncurryThisClause;
var defineBuiltIn$7 = defineBuiltIn$d;
var regexpExec$1 = regexpExec$2;
var fails$j = fails$A;
var wellKnownSymbol$9 = wellKnownSymbol$o;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$9;

var SPECIES$1 = wellKnownSymbol$9('species');
var RegExpPrototype$4 = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol$9(KEY);

  var DELEGATES_TO_SYMBOL = !fails$j(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$j(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES$1] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var uncurriedNativeRegExpMethod = uncurryThis$n(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = uncurryThis$n(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec$1 || $exec === RegExpPrototype$4.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
        }
        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn$7(String.prototype, KEY, methods[0]);
    defineBuiltIn$7(RegExpPrototype$4, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty$4(RegExpPrototype$4[SYMBOL], 'sham', true);
};

// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe
var sameValue$1 = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

var call$b = functionCall;
var anObject$8 = anObject$k;
var isCallable$5 = isCallable$q;
var classof$8 = classofRaw$2;
var regexpExec = regexpExec$2;

var $TypeError$6 = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (isCallable$5(exec)) {
    var result = call$b(exec, R, S);
    if (result !== null) anObject$8(result);
    return result;
  }
  if (classof$8(R) === 'RegExp') return call$b(regexpExec, R, S);
  throw $TypeError$6('RegExp#exec called on incompatible receiver');
};

var call$a = functionCall;
var fixRegExpWellKnownSymbolLogic$2 = fixRegexpWellKnownSymbolLogic;
var anObject$7 = anObject$k;
var isNullOrUndefined$3 = isNullOrUndefined$8;
var requireObjectCoercible$8 = requireObjectCoercible$b;
var sameValue = sameValue$1;
var toString$e = toString$g;
var getMethod$3 = getMethod$7;
var regExpExec$3 = regexpExecAbstract;

// @@search logic
fixRegExpWellKnownSymbolLogic$2('search', function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible$8(this);
      var searcher = isNullOrUndefined$3(regexp) ? undefined : getMethod$3(regexp, SEARCH);
      return searcher ? call$a(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString$e(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function (string) {
      var rx = anObject$7(this);
      var S = toString$e(string);
      var res = maybeCallNative(nativeSearch, rx, S);

      if (res.done) return res.value;

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec$3(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});

var fails$i = fails$A;
var wellKnownSymbol$8 = wellKnownSymbol$o;
var IS_PURE$1 = isPure;

var ITERATOR$3 = wellKnownSymbol$8('iterator');

var urlConstructorDetection = !fails$i(function () {
  // eslint-disable-next-line unicorn/relative-url-style -- required for testing
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var searchParams = url.searchParams;
  var result = '';
  url.pathname = 'c%20d';
  searchParams.forEach(function (value, key) {
    searchParams['delete']('b');
    result += key + value;
  });
  return (IS_PURE$1 && !url.toJSON)
    || !searchParams.sort
    || url.href !== 'http://a/c%20d?a=1&c=3'
    || searchParams.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !searchParams[ITERATOR$3]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('http://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('http://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('http://x', undefined).host !== 'x';
});

var defineBuiltIn$6 = defineBuiltIn$d;

var defineBuiltIns$2 = function (target, src, options) {
  for (var key in src) defineBuiltIn$6(target, key, src[key], options);
  return target;
};

var toPropertyKey$1 = toPropertyKey$4;
var definePropertyModule$1 = objectDefineProperty;
var createPropertyDescriptor$2 = createPropertyDescriptor$6;

var createProperty$3 = function (object, key, value) {
  var propertyKey = toPropertyKey$1(key);
  if (propertyKey in object) definePropertyModule$1.f(object, propertyKey, createPropertyDescriptor$2(0, value));
  else object[propertyKey] = value;
};

var toAbsoluteIndex$2 = toAbsoluteIndex$4;
var lengthOfArrayLike$a = lengthOfArrayLike$d;
var createProperty$2 = createProperty$3;

var $Array$3 = Array;
var max$1 = Math.max;

var arraySliceSimple = function (O, start, end) {
  var length = lengthOfArrayLike$a(O);
  var k = toAbsoluteIndex$2(start, length);
  var fin = toAbsoluteIndex$2(end === undefined ? length : end, length);
  var result = $Array$3(max$1(fin - k, 0));
  for (var n = 0; k < fin; k++, n++) createProperty$2(result, n, O[k]);
  result.length = n;
  return result;
};

var arraySlice$3 = arraySliceSimple;

var floor$6 = Math.floor;

var mergeSort = function (array, comparefn) {
  var length = array.length;
  var middle = floor$6(length / 2);
  return length < 8 ? insertionSort(array, comparefn) : merge(
    array,
    mergeSort(arraySlice$3(array, 0, middle), comparefn),
    mergeSort(arraySlice$3(array, middle), comparefn),
    comparefn
  );
};

var insertionSort = function (array, comparefn) {
  var length = array.length;
  var i = 1;
  var element, j;

  while (i < length) {
    j = i;
    element = array[i];
    while (j && comparefn(array[j - 1], element) > 0) {
      array[j] = array[--j];
    }
    if (j !== i++) array[j] = element;
  } return array;
};

var merge = function (array, left, right, comparefn) {
  var llength = left.length;
  var rlength = right.length;
  var lindex = 0;
  var rindex = 0;

  while (lindex < llength || rindex < rlength) {
    array[lindex + rindex] = (lindex < llength && rindex < rlength)
      ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
      : lindex < llength ? left[lindex++] : right[rindex++];
  } return array;
};

var arraySort$1 = mergeSort;

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`

var $$i = _export;
var global$d = global$w;
var call$9 = functionCall;
var uncurryThis$m = functionUncurryThis;
var DESCRIPTORS$6 = descriptors;
var USE_NATIVE_URL$1 = urlConstructorDetection;
var defineBuiltIn$5 = defineBuiltIn$d;
var defineBuiltIns$1 = defineBuiltIns$2;
var setToStringTag$2 = setToStringTag$6;
var createIteratorConstructor$1 = iteratorCreateConstructor;
var InternalStateModule$6 = internalState;
var anInstance$3 = anInstance$5;
var isCallable$4 = isCallable$q;
var hasOwn$6 = hasOwnProperty_1;
var bind$5 = functionBindContext;
var classof$7 = classof$c;
var anObject$6 = anObject$k;
var isObject$7 = isObject$g;
var $toString$2 = toString$g;
var create$5 = objectCreate;
var createPropertyDescriptor$1 = createPropertyDescriptor$6;
var getIterator$2 = getIterator$4;
var getIteratorMethod$2 = getIteratorMethod$5;
var validateArgumentsLength$1 = validateArgumentsLength$3;
var wellKnownSymbol$7 = wellKnownSymbol$o;
var arraySort = arraySort$1;

var ITERATOR$2 = wellKnownSymbol$7('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState$5 = InternalStateModule$6.set;
var getInternalParamsState = InternalStateModule$6.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule$6.getterFor(URL_SEARCH_PARAMS_ITERATOR);
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Avoid NodeJS experimental warning
var safeGetBuiltIn = function (name) {
  if (!DESCRIPTORS$6) return global$d[name];
  var descriptor = getOwnPropertyDescriptor$1(global$d, name);
  return descriptor && descriptor.value;
};

var nativeFetch = safeGetBuiltIn('fetch');
var NativeRequest = safeGetBuiltIn('Request');
var Headers = safeGetBuiltIn('Headers');
var RequestPrototype = NativeRequest && NativeRequest.prototype;
var HeadersPrototype = Headers && Headers.prototype;
var RegExp$1 = global$d.RegExp;
var TypeError$3 = global$d.TypeError;
var decodeURIComponent = global$d.decodeURIComponent;
var encodeURIComponent$1 = global$d.encodeURIComponent;
var charAt$7 = uncurryThis$m(''.charAt);
var join$2 = uncurryThis$m([].join);
var push$5 = uncurryThis$m([].push);
var replace$6 = uncurryThis$m(''.replace);
var shift$1 = uncurryThis$m([].shift);
var splice = uncurryThis$m([].splice);
var split$2 = uncurryThis$m(''.split);
var stringSlice$8 = uncurryThis$m(''.slice);

var plus = /\+/g;
var sequences = Array(4);

var percentSequence = function (bytes) {
  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp$1('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode = function (sequence) {
  try {
    return decodeURIComponent(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize = function (it) {
  var result = replace$6(it, plus, ' ');
  var bytes = 4;
  try {
    return decodeURIComponent(result);
  } catch (error) {
    while (bytes) {
      result = replace$6(result, percentSequence(bytes--), percentDecode);
    }
    return result;
  }
};

var find = /[!'()~]|%20/g;

var replacements = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replacements[match];
};

var serialize = function (it) {
  return replace$6(encodeURIComponent$1(it), find, replacer);
};

var URLSearchParamsIterator = createIteratorConstructor$1(function Iterator(params, kind) {
  setInternalState$5(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    iterator: getIterator$2(getInternalParamsState(params).entries),
    kind: kind
  });
}, 'Iterator', function next() {
  var state = getInternalIteratorState(this);
  var kind = state.kind;
  var step = state.iterator.next();
  var entry = step.value;
  if (!step.done) {
    step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [entry.key, entry.value];
  } return step;
}, true);

var URLSearchParamsState = function (init) {
  this.entries = [];
  this.url = null;

  if (init !== undefined) {
    if (isObject$7(init)) this.parseObject(init);
    else this.parseQuery(typeof init == 'string' ? charAt$7(init, 0) === '?' ? stringSlice$8(init, 1) : init : $toString$2(init));
  }
};

URLSearchParamsState.prototype = {
  type: URL_SEARCH_PARAMS,
  bindURL: function (url) {
    this.url = url;
    this.update();
  },
  parseObject: function (object) {
    var iteratorMethod = getIteratorMethod$2(object);
    var iterator, next, step, entryIterator, entryNext, first, second;

    if (iteratorMethod) {
      iterator = getIterator$2(object, iteratorMethod);
      next = iterator.next;
      while (!(step = call$9(next, iterator)).done) {
        entryIterator = getIterator$2(anObject$6(step.value));
        entryNext = entryIterator.next;
        if (
          (first = call$9(entryNext, entryIterator)).done ||
          (second = call$9(entryNext, entryIterator)).done ||
          !call$9(entryNext, entryIterator).done
        ) throw TypeError$3('Expected sequence with length 2');
        push$5(this.entries, { key: $toString$2(first.value), value: $toString$2(second.value) });
      }
    } else for (var key in object) if (hasOwn$6(object, key)) {
      push$5(this.entries, { key: key, value: $toString$2(object[key]) });
    }
  },
  parseQuery: function (query) {
    if (query) {
      var attributes = split$2(query, '&');
      var index = 0;
      var attribute, entry;
      while (index < attributes.length) {
        attribute = attributes[index++];
        if (attribute.length) {
          entry = split$2(attribute, '=');
          push$5(this.entries, {
            key: deserialize(shift$1(entry)),
            value: deserialize(join$2(entry, '='))
          });
        }
      }
    }
  },
  serialize: function () {
    var entries = this.entries;
    var result = [];
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      push$5(result, serialize(entry.key) + '=' + serialize(entry.value));
    } return join$2(result, '&');
  },
  update: function () {
    this.entries.length = 0;
    this.parseQuery(this.url.query);
  },
  updateURL: function () {
    if (this.url) this.url.update();
  }
};

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance$3(this, URLSearchParamsPrototype);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  setInternalState$5(this, new URLSearchParamsState(init));
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

defineBuiltIns$1(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    validateArgumentsLength$1(arguments.length, 2);
    var state = getInternalParamsState(this);
    push$5(state.entries, { key: $toString$2(name), value: $toString$2(value) });
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name) {
    validateArgumentsLength$1(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var key = $toString$2(name);
    var index = 0;
    while (index < entries.length) {
      if (entries[index].key === key) splice(entries, index, 1);
      else index++;
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    validateArgumentsLength$1(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString$2(name);
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    validateArgumentsLength$1(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString$2(name);
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) push$5(result, entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name) {
    validateArgumentsLength$1(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString$2(name);
    var index = 0;
    while (index < entries.length) {
      if (entries[index++].key === key) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    validateArgumentsLength$1(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var found = false;
    var key = $toString$2(name);
    var val = $toString$2(value);
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) splice(entries, index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) push$5(entries, { key: key, value: val });
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    arraySort(state.entries, function (a, b) {
      return a.key > b.key ? 1 : -1;
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = bind$5(callback, arguments.length > 1 ? arguments[1] : undefined);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
defineBuiltIn$5(URLSearchParamsPrototype, ITERATOR$2, URLSearchParamsPrototype.entries, { name: 'entries' });

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
defineBuiltIn$5(URLSearchParamsPrototype, 'toString', function toString() {
  return getInternalParamsState(this).serialize();
}, { enumerable: true });

setToStringTag$2(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

$$i({ global: true, constructor: true, forced: !USE_NATIVE_URL$1 }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!USE_NATIVE_URL$1 && isCallable$4(Headers)) {
  var headersHas = uncurryThis$m(HeadersPrototype.has);
  var headersSet = uncurryThis$m(HeadersPrototype.set);

  var wrapRequestOptions = function (init) {
    if (isObject$7(init)) {
      var body = init.body;
      var headers;
      if (classof$7(body) === URL_SEARCH_PARAMS) {
        headers = init.headers ? new Headers(init.headers) : new Headers();
        if (!headersHas(headers, 'content-type')) {
          headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
        return create$5(init, {
          body: createPropertyDescriptor$1(0, $toString$2(body)),
          headers: createPropertyDescriptor$1(0, headers)
        });
      }
    } return init;
  };

  if (isCallable$4(nativeFetch)) {
    $$i({ global: true, enumerable: true, dontCallGetSet: true, forced: true }, {
      fetch: function fetch(input /* , init */) {
        return nativeFetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
      }
    });
  }

  if (isCallable$4(NativeRequest)) {
    var RequestConstructor = function Request(input /* , init */) {
      anInstance$3(this, RequestPrototype);
      return new NativeRequest(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
    };

    RequestPrototype.constructor = RequestConstructor;
    RequestConstructor.prototype = RequestPrototype;

    $$i({ global: true, constructor: true, dontCallGetSet: true, forced: true }, {
      Request: RequestConstructor
    });
  }
}

var web_urlSearchParams_constructor = {
  URLSearchParams: URLSearchParamsConstructor,
  getState: getInternalParamsState
};

var $$h = _export;
var $includes = arrayIncludes.includes;
var fails$h = fails$A;
var addToUnscopables$2 = addToUnscopables$4;

// FF99+ bug
var BROKEN_ON_SPARSE = fails$h(function () {
  // eslint-disable-next-line es/no-array-prototype-includes -- detection
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$$h({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$2('includes');

var isObject$6 = isObject$g;
var classof$6 = classofRaw$2;
var wellKnownSymbol$6 = wellKnownSymbol$o;

var MATCH$2 = wellKnownSymbol$6('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject$6(it) && ((isRegExp = it[MATCH$2]) !== undefined ? !!isRegExp : classof$6(it) == 'RegExp');
};

var isRegExp$2 = isRegexp;

var $TypeError$5 = TypeError;

var notARegexp = function (it) {
  if (isRegExp$2(it)) {
    throw $TypeError$5("The method doesn't accept regular expressions");
  } return it;
};

var wellKnownSymbol$5 = wellKnownSymbol$o;

var MATCH$1 = wellKnownSymbol$5('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH$1] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

var $$g = _export;
var uncurryThis$l = functionUncurryThis;
var notARegExp$1 = notARegexp;
var requireObjectCoercible$7 = requireObjectCoercible$b;
var toString$d = toString$g;
var correctIsRegExpLogic$1 = correctIsRegexpLogic;

var stringIndexOf$3 = uncurryThis$l(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$$g({ target: 'String', proto: true, forced: !correctIsRegExpLogic$1('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf$3(
      toString$d(requireObjectCoercible$7(this)),
      toString$d(notARegExp$1(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});

var uncurryThis$k = functionUncurryThis;
var toIntegerOrInfinity$7 = toIntegerOrInfinity$a;
var toString$c = toString$g;
var requireObjectCoercible$6 = requireObjectCoercible$b;

var charAt$6 = uncurryThis$k(''.charAt);
var charCodeAt$1 = uncurryThis$k(''.charCodeAt);
var stringSlice$7 = uncurryThis$k(''.slice);

var createMethod$3 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString$c(requireObjectCoercible$6($this));
    var position = toIntegerOrInfinity$7(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt$1(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt$1(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt$6(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice$7(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$3(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$3(true)
};

var charAt$5 = stringMultibyte.charAt;
var toString$b = toString$g;
var InternalStateModule$5 = internalState;
var defineIterator = iteratorDefine;
var createIterResultObject$1 = createIterResultObject$3;

var STRING_ITERATOR = 'String Iterator';
var setInternalState$4 = InternalStateModule$5.set;
var getInternalState$3 = InternalStateModule$5.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState$4(this, {
    type: STRING_ITERATOR,
    string: toString$b(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState$3(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return createIterResultObject$1(undefined, true);
  point = charAt$5(string, index);
  state.index += point.length;
  return createIterResultObject$1(point, false);
});

var anObject$5 = anObject$k;
var iteratorClose = iteratorClose$2;

// call something on iterator step with safe closing on error
var callWithSafeIterationClosing$1 = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject$5(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};

var bind$4 = functionBindContext;
var call$8 = functionCall;
var toObject$8 = toObject$c;
var callWithSafeIterationClosing = callWithSafeIterationClosing$1;
var isArrayIteratorMethod$1 = isArrayIteratorMethod$3;
var isConstructor$1 = isConstructor$3;
var lengthOfArrayLike$9 = lengthOfArrayLike$d;
var createProperty$1 = createProperty$3;
var getIterator$1 = getIterator$4;
var getIteratorMethod$1 = getIteratorMethod$5;

var $Array$2 = Array;

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
var arrayFrom$1 = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject$8(arrayLike);
  var IS_CONSTRUCTOR = isConstructor$1(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  if (mapping) mapfn = bind$4(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
  var iteratorMethod = getIteratorMethod$1(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod && !(this === $Array$2 && isArrayIteratorMethod$1(iteratorMethod))) {
    iterator = getIterator$1(O, iteratorMethod);
    next = iterator.next;
    result = IS_CONSTRUCTOR ? new this() : [];
    for (;!(step = call$8(next, iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty$1(result, index, value);
    }
  } else {
    length = lengthOfArrayLike$9(O);
    result = IS_CONSTRUCTOR ? new this(length) : $Array$2(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty$1(result, index, value);
    }
  }
  result.length = index;
  return result;
};

// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js
var uncurryThis$j = functionUncurryThis;

var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = '-'; // '\x2D'
var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
var baseMinusTMin = base - tMin;

var $RangeError$5 = RangeError;
var exec$3 = uncurryThis$j(regexSeparators.exec);
var floor$5 = Math.floor;
var fromCharCode = String.fromCharCode;
var charCodeAt = uncurryThis$j(''.charCodeAt);
var join$1 = uncurryThis$j([].join);
var push$4 = uncurryThis$j([].push);
var replace$5 = uncurryThis$j(''.replace);
var split$1 = uncurryThis$j(''.split);
var toLowerCase$1 = uncurryThis$j(''.toLowerCase);

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */
var ucs2decode = function (string) {
  var output = [];
  var counter = 0;
  var length = string.length;
  while (counter < length) {
    var value = charCodeAt(string, counter++);
    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // It's a high surrogate, and there is a next character.
      var extra = charCodeAt(string, counter++);
      if ((extra & 0xFC00) == 0xDC00) { // Low surrogate.
        push$4(output, ((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // It's an unmatched surrogate; only append this code unit, in case the
        // next code unit is the high surrogate of a surrogate pair.
        push$4(output, value);
        counter--;
      }
    } else {
      push$4(output, value);
    }
  }
  return output;
};

/**
 * Converts a digit/integer into a basic code point.
 */
var digitToBasic = function (digit) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */
var adapt = function (delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor$5(delta / damp) : delta >> 1;
  delta += floor$5(delta / numPoints);
  while (delta > baseMinusTMin * tMax >> 1) {
    delta = floor$5(delta / baseMinusTMin);
    k += base;
  }
  return floor$5(k + (baseMinusTMin + 1) * delta / (delta + skew));
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */
var encode = function (input) {
  var output = [];

  // Convert the input in UCS-2 to an array of Unicode code points.
  input = ucs2decode(input);

  // Cache the length.
  var inputLength = input.length;

  // Initialize the state.
  var n = initialN;
  var delta = 0;
  var bias = initialBias;
  var i, currentValue;

  // Handle the basic code points.
  for (i = 0; i < input.length; i++) {
    currentValue = input[i];
    if (currentValue < 0x80) {
      push$4(output, fromCharCode(currentValue));
    }
  }

  var basicLength = output.length; // number of basic code points.
  var handledCPCount = basicLength; // number of code points that have been handled;

  // Finish the basic string with a delimiter unless it's empty.
  if (basicLength) {
    push$4(output, delimiter);
  }

  // Main encoding loop:
  while (handledCPCount < inputLength) {
    // All non-basic code points < n have been handled already. Find the next larger one:
    var m = maxInt;
    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    }

    // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
    var handledCPCountPlusOne = handledCPCount + 1;
    if (m - n > floor$5((maxInt - delta) / handledCPCountPlusOne)) {
      throw $RangeError$5(OVERFLOW_ERROR);
    }

    delta += (m - n) * handledCPCountPlusOne;
    n = m;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue < n && ++delta > maxInt) {
        throw $RangeError$5(OVERFLOW_ERROR);
      }
      if (currentValue == n) {
        // Represent delta as a generalized variable-length integer.
        var q = delta;
        var k = base;
        while (true) {
          var t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
          if (q < t) break;
          var qMinusT = q - t;
          var baseMinusT = base - t;
          push$4(output, fromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
          q = floor$5(qMinusT / baseMinusT);
          k += base;
        }

        push$4(output, fromCharCode(digitToBasic(q)));
        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
        delta = 0;
        handledCPCount++;
      }
    }

    delta++;
    n++;
  }
  return join$1(output, '');
};

var stringPunycodeToAscii = function (input) {
  var encoded = [];
  var labels = split$1(replace$5(toLowerCase$1(input), regexSeparators, '\u002E'), '.');
  var i, label;
  for (i = 0; i < labels.length; i++) {
    label = labels[i];
    push$4(encoded, exec$3(regexNonASCII, label) ? 'xn--' + encode(label) : label);
  }
  return join$1(encoded, '.');
};

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`

var $$f = _export;
var DESCRIPTORS$5 = descriptors;
var USE_NATIVE_URL = urlConstructorDetection;
var global$c = global$w;
var bind$3 = functionBindContext;
var uncurryThis$i = functionUncurryThis;
var defineBuiltIn$4 = defineBuiltIn$d;
var defineBuiltInAccessor$4 = defineBuiltInAccessor$6;
var anInstance$2 = anInstance$5;
var hasOwn$5 = hasOwnProperty_1;
var assign = objectAssign;
var arrayFrom = arrayFrom$1;
var arraySlice$2 = arraySliceSimple;
var codeAt = stringMultibyte.codeAt;
var toASCII = stringPunycodeToAscii;
var $toString$1 = toString$g;
var setToStringTag$1 = setToStringTag$6;
var validateArgumentsLength = validateArgumentsLength$3;
var URLSearchParamsModule = web_urlSearchParams_constructor;
var InternalStateModule$4 = internalState;

var setInternalState$3 = InternalStateModule$4.set;
var getInternalURLState = InternalStateModule$4.getterFor('URL');
var URLSearchParams$1 = URLSearchParamsModule.URLSearchParams;
var getInternalSearchParamsState = URLSearchParamsModule.getState;

var NativeURL = global$c.URL;
var TypeError$2 = global$c.TypeError;
var parseInt$1 = global$c.parseInt;
var floor$4 = Math.floor;
var pow$2 = Math.pow;
var charAt$4 = uncurryThis$i(''.charAt);
var exec$2 = uncurryThis$i(/./.exec);
var join = uncurryThis$i([].join);
var numberToString = uncurryThis$i(1.0.toString);
var pop = uncurryThis$i([].pop);
var push$3 = uncurryThis$i([].push);
var replace$4 = uncurryThis$i(''.replace);
var shift = uncurryThis$i([].shift);
var split = uncurryThis$i(''.split);
var stringSlice$6 = uncurryThis$i(''.slice);
var toLowerCase = uncurryThis$i(''.toLowerCase);
var unshift = uncurryThis$i([].unshift);

var INVALID_AUTHORITY = 'Invalid authority';
var INVALID_SCHEME = 'Invalid scheme';
var INVALID_HOST = 'Invalid host';
var INVALID_PORT = 'Invalid port';

var ALPHA = /[a-z]/i;
// eslint-disable-next-line regexp/no-obscure-range -- safe
var ALPHANUMERIC = /[\d+-.a-z]/i;
var DIGIT = /\d/;
var HEX_START = /^0x/i;
var OCT = /^[0-7]+$/;
var DEC = /^\d+$/;
var HEX = /^[\da-f]+$/i;
/* eslint-disable regexp/no-control-character -- safe */
var FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
var LEADING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+/;
var TRAILING_C0_CONTROL_OR_SPACE = /(^|[^\u0000-\u0020])[\u0000-\u0020]+$/;
var TAB_AND_NEW_LINE = /[\t\n\r]/g;
/* eslint-enable regexp/no-control-character -- safe */
var EOF;

// https://url.spec.whatwg.org/#ipv4-number-parser
var parseIPv4 = function (input) {
  var parts = split(input, '.');
  var partsLength, numbers, index, part, radix, number, ipv4;
  if (parts.length && parts[parts.length - 1] == '') {
    parts.length--;
  }
  partsLength = parts.length;
  if (partsLength > 4) return input;
  numbers = [];
  for (index = 0; index < partsLength; index++) {
    part = parts[index];
    if (part == '') return input;
    radix = 10;
    if (part.length > 1 && charAt$4(part, 0) == '0') {
      radix = exec$2(HEX_START, part) ? 16 : 8;
      part = stringSlice$6(part, radix == 8 ? 1 : 2);
    }
    if (part === '') {
      number = 0;
    } else {
      if (!exec$2(radix == 10 ? DEC : radix == 8 ? OCT : HEX, part)) return input;
      number = parseInt$1(part, radix);
    }
    push$3(numbers, number);
  }
  for (index = 0; index < partsLength; index++) {
    number = numbers[index];
    if (index == partsLength - 1) {
      if (number >= pow$2(256, 5 - partsLength)) return null;
    } else if (number > 255) return null;
  }
  ipv4 = pop(numbers);
  for (index = 0; index < numbers.length; index++) {
    ipv4 += numbers[index] * pow$2(256, 3 - index);
  }
  return ipv4;
};

// https://url.spec.whatwg.org/#concept-ipv6-parser
// eslint-disable-next-line max-statements -- TODO
var parseIPv6 = function (input) {
  var address = [0, 0, 0, 0, 0, 0, 0, 0];
  var pieceIndex = 0;
  var compress = null;
  var pointer = 0;
  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;

  var chr = function () {
    return charAt$4(input, pointer);
  };

  if (chr() == ':') {
    if (charAt$4(input, 1) != ':') return;
    pointer += 2;
    pieceIndex++;
    compress = pieceIndex;
  }
  while (chr()) {
    if (pieceIndex == 8) return;
    if (chr() == ':') {
      if (compress !== null) return;
      pointer++;
      pieceIndex++;
      compress = pieceIndex;
      continue;
    }
    value = length = 0;
    while (length < 4 && exec$2(HEX, chr())) {
      value = value * 16 + parseInt$1(chr(), 16);
      pointer++;
      length++;
    }
    if (chr() == '.') {
      if (length == 0) return;
      pointer -= length;
      if (pieceIndex > 6) return;
      numbersSeen = 0;
      while (chr()) {
        ipv4Piece = null;
        if (numbersSeen > 0) {
          if (chr() == '.' && numbersSeen < 4) pointer++;
          else return;
        }
        if (!exec$2(DIGIT, chr())) return;
        while (exec$2(DIGIT, chr())) {
          number = parseInt$1(chr(), 10);
          if (ipv4Piece === null) ipv4Piece = number;
          else if (ipv4Piece == 0) return;
          else ipv4Piece = ipv4Piece * 10 + number;
          if (ipv4Piece > 255) return;
          pointer++;
        }
        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
        numbersSeen++;
        if (numbersSeen == 2 || numbersSeen == 4) pieceIndex++;
      }
      if (numbersSeen != 4) return;
      break;
    } else if (chr() == ':') {
      pointer++;
      if (!chr()) return;
    } else if (chr()) return;
    address[pieceIndex++] = value;
  }
  if (compress !== null) {
    swaps = pieceIndex - compress;
    pieceIndex = 7;
    while (pieceIndex != 0 && swaps > 0) {
      swap = address[pieceIndex];
      address[pieceIndex--] = address[compress + swaps - 1];
      address[compress + --swaps] = swap;
    }
  } else if (pieceIndex != 8) return;
  return address;
};

var findLongestZeroSequence = function (ipv6) {
  var maxIndex = null;
  var maxLength = 1;
  var currStart = null;
  var currLength = 0;
  var index = 0;
  for (; index < 8; index++) {
    if (ipv6[index] !== 0) {
      if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
      }
      currStart = null;
      currLength = 0;
    } else {
      if (currStart === null) currStart = index;
      ++currLength;
    }
  }
  if (currLength > maxLength) {
    maxIndex = currStart;
    maxLength = currLength;
  }
  return maxIndex;
};

// https://url.spec.whatwg.org/#host-serializing
var serializeHost = function (host) {
  var result, index, compress, ignore0;
  // ipv4
  if (typeof host == 'number') {
    result = [];
    for (index = 0; index < 4; index++) {
      unshift(result, host % 256);
      host = floor$4(host / 256);
    } return join(result, '.');
  // ipv6
  } else if (typeof host == 'object') {
    result = '';
    compress = findLongestZeroSequence(host);
    for (index = 0; index < 8; index++) {
      if (ignore0 && host[index] === 0) continue;
      if (ignore0) ignore0 = false;
      if (compress === index) {
        result += index ? ':' : '::';
        ignore0 = true;
      } else {
        result += numberToString(host[index], 16);
        if (index < 7) result += ':';
      }
    }
    return '[' + result + ']';
  } return host;
};

var C0ControlPercentEncodeSet = {};
var fragmentPercentEncodeSet = assign({}, C0ControlPercentEncodeSet, {
  ' ': 1, '"': 1, '<': 1, '>': 1, '`': 1
});
var pathPercentEncodeSet = assign({}, fragmentPercentEncodeSet, {
  '#': 1, '?': 1, '{': 1, '}': 1
});
var userinfoPercentEncodeSet = assign({}, pathPercentEncodeSet, {
  '/': 1, ':': 1, ';': 1, '=': 1, '@': 1, '[': 1, '\\': 1, ']': 1, '^': 1, '|': 1
});

var percentEncode = function (chr, set) {
  var code = codeAt(chr, 0);
  return code > 0x20 && code < 0x7F && !hasOwn$5(set, chr) ? chr : encodeURIComponent(chr);
};

// https://url.spec.whatwg.org/#special-scheme
var specialSchemes = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
};

// https://url.spec.whatwg.org/#windows-drive-letter
var isWindowsDriveLetter = function (string, normalized) {
  var second;
  return string.length == 2 && exec$2(ALPHA, charAt$4(string, 0))
    && ((second = charAt$4(string, 1)) == ':' || (!normalized && second == '|'));
};

// https://url.spec.whatwg.org/#start-with-a-windows-drive-letter
var startsWithWindowsDriveLetter = function (string) {
  var third;
  return string.length > 1 && isWindowsDriveLetter(stringSlice$6(string, 0, 2)) && (
    string.length == 2 ||
    ((third = charAt$4(string, 2)) === '/' || third === '\\' || third === '?' || third === '#')
  );
};

// https://url.spec.whatwg.org/#single-dot-path-segment
var isSingleDot = function (segment) {
  return segment === '.' || toLowerCase(segment) === '%2e';
};

// https://url.spec.whatwg.org/#double-dot-path-segment
var isDoubleDot = function (segment) {
  segment = toLowerCase(segment);
  return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
};

// States:
var SCHEME_START = {};
var SCHEME = {};
var NO_SCHEME = {};
var SPECIAL_RELATIVE_OR_AUTHORITY = {};
var PATH_OR_AUTHORITY = {};
var RELATIVE = {};
var RELATIVE_SLASH = {};
var SPECIAL_AUTHORITY_SLASHES = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var AUTHORITY = {};
var HOST = {};
var HOSTNAME = {};
var PORT = {};
var FILE = {};
var FILE_SLASH = {};
var FILE_HOST = {};
var PATH_START = {};
var PATH = {};
var CANNOT_BE_A_BASE_URL_PATH = {};
var QUERY = {};
var FRAGMENT = {};

var URLState = function (url, isBase, base) {
  var urlString = $toString$1(url);
  var baseState, failure, searchParams;
  if (isBase) {
    failure = this.parse(urlString);
    if (failure) throw TypeError$2(failure);
    this.searchParams = null;
  } else {
    if (base !== undefined) baseState = new URLState(base, true);
    failure = this.parse(urlString, null, baseState);
    if (failure) throw TypeError$2(failure);
    searchParams = getInternalSearchParamsState(new URLSearchParams$1());
    searchParams.bindURL(this);
    this.searchParams = searchParams;
  }
};

URLState.prototype = {
  type: 'URL',
  // https://url.spec.whatwg.org/#url-parsing
  // eslint-disable-next-line max-statements -- TODO
  parse: function (input, stateOverride, base) {
    var url = this;
    var state = stateOverride || SCHEME_START;
    var pointer = 0;
    var buffer = '';
    var seenAt = false;
    var seenBracket = false;
    var seenPasswordToken = false;
    var codePoints, chr, bufferCodePoints, failure;

    input = $toString$1(input);

    if (!stateOverride) {
      url.scheme = '';
      url.username = '';
      url.password = '';
      url.host = null;
      url.port = null;
      url.path = [];
      url.query = null;
      url.fragment = null;
      url.cannotBeABaseURL = false;
      input = replace$4(input, LEADING_C0_CONTROL_OR_SPACE, '');
      input = replace$4(input, TRAILING_C0_CONTROL_OR_SPACE, '$1');
    }

    input = replace$4(input, TAB_AND_NEW_LINE, '');

    codePoints = arrayFrom(input);

    while (pointer <= codePoints.length) {
      chr = codePoints[pointer];
      switch (state) {
        case SCHEME_START:
          if (chr && exec$2(ALPHA, chr)) {
            buffer += toLowerCase(chr);
            state = SCHEME;
          } else if (!stateOverride) {
            state = NO_SCHEME;
            continue;
          } else return INVALID_SCHEME;
          break;

        case SCHEME:
          if (chr && (exec$2(ALPHANUMERIC, chr) || chr == '+' || chr == '-' || chr == '.')) {
            buffer += toLowerCase(chr);
          } else if (chr == ':') {
            if (stateOverride && (
              (url.isSpecial() != hasOwn$5(specialSchemes, buffer)) ||
              (buffer == 'file' && (url.includesCredentials() || url.port !== null)) ||
              (url.scheme == 'file' && !url.host)
            )) return;
            url.scheme = buffer;
            if (stateOverride) {
              if (url.isSpecial() && specialSchemes[url.scheme] == url.port) url.port = null;
              return;
            }
            buffer = '';
            if (url.scheme == 'file') {
              state = FILE;
            } else if (url.isSpecial() && base && base.scheme == url.scheme) {
              state = SPECIAL_RELATIVE_OR_AUTHORITY;
            } else if (url.isSpecial()) {
              state = SPECIAL_AUTHORITY_SLASHES;
            } else if (codePoints[pointer + 1] == '/') {
              state = PATH_OR_AUTHORITY;
              pointer++;
            } else {
              url.cannotBeABaseURL = true;
              push$3(url.path, '');
              state = CANNOT_BE_A_BASE_URL_PATH;
            }
          } else if (!stateOverride) {
            buffer = '';
            state = NO_SCHEME;
            pointer = 0;
            continue;
          } else return INVALID_SCHEME;
          break;

        case NO_SCHEME:
          if (!base || (base.cannotBeABaseURL && chr != '#')) return INVALID_SCHEME;
          if (base.cannotBeABaseURL && chr == '#') {
            url.scheme = base.scheme;
            url.path = arraySlice$2(base.path);
            url.query = base.query;
            url.fragment = '';
            url.cannotBeABaseURL = true;
            state = FRAGMENT;
            break;
          }
          state = base.scheme == 'file' ? FILE : RELATIVE;
          continue;

        case SPECIAL_RELATIVE_OR_AUTHORITY:
          if (chr == '/' && codePoints[pointer + 1] == '/') {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
            pointer++;
          } else {
            state = RELATIVE;
            continue;
          } break;

        case PATH_OR_AUTHORITY:
          if (chr == '/') {
            state = AUTHORITY;
            break;
          } else {
            state = PATH;
            continue;
          }

        case RELATIVE:
          url.scheme = base.scheme;
          if (chr == EOF) {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice$2(base.path);
            url.query = base.query;
          } else if (chr == '/' || (chr == '\\' && url.isSpecial())) {
            state = RELATIVE_SLASH;
          } else if (chr == '?') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice$2(base.path);
            url.query = '';
            state = QUERY;
          } else if (chr == '#') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice$2(base.path);
            url.query = base.query;
            url.fragment = '';
            state = FRAGMENT;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice$2(base.path);
            url.path.length--;
            state = PATH;
            continue;
          } break;

        case RELATIVE_SLASH:
          if (url.isSpecial() && (chr == '/' || chr == '\\')) {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          } else if (chr == '/') {
            state = AUTHORITY;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            state = PATH;
            continue;
          } break;

        case SPECIAL_AUTHORITY_SLASHES:
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          if (chr != '/' || charAt$4(buffer, pointer + 1) != '/') continue;
          pointer++;
          break;

        case SPECIAL_AUTHORITY_IGNORE_SLASHES:
          if (chr != '/' && chr != '\\') {
            state = AUTHORITY;
            continue;
          } break;

        case AUTHORITY:
          if (chr == '@') {
            if (seenAt) buffer = '%40' + buffer;
            seenAt = true;
            bufferCodePoints = arrayFrom(buffer);
            for (var i = 0; i < bufferCodePoints.length; i++) {
              var codePoint = bufferCodePoints[i];
              if (codePoint == ':' && !seenPasswordToken) {
                seenPasswordToken = true;
                continue;
              }
              var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
              if (seenPasswordToken) url.password += encodedCodePoints;
              else url.username += encodedCodePoints;
            }
            buffer = '';
          } else if (
            chr == EOF || chr == '/' || chr == '?' || chr == '#' ||
            (chr == '\\' && url.isSpecial())
          ) {
            if (seenAt && buffer == '') return INVALID_AUTHORITY;
            pointer -= arrayFrom(buffer).length + 1;
            buffer = '';
            state = HOST;
          } else buffer += chr;
          break;

        case HOST:
        case HOSTNAME:
          if (stateOverride && url.scheme == 'file') {
            state = FILE_HOST;
            continue;
          } else if (chr == ':' && !seenBracket) {
            if (buffer == '') return INVALID_HOST;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PORT;
            if (stateOverride == HOSTNAME) return;
          } else if (
            chr == EOF || chr == '/' || chr == '?' || chr == '#' ||
            (chr == '\\' && url.isSpecial())
          ) {
            if (url.isSpecial() && buffer == '') return INVALID_HOST;
            if (stateOverride && buffer == '' && (url.includesCredentials() || url.port !== null)) return;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PATH_START;
            if (stateOverride) return;
            continue;
          } else {
            if (chr == '[') seenBracket = true;
            else if (chr == ']') seenBracket = false;
            buffer += chr;
          } break;

        case PORT:
          if (exec$2(DIGIT, chr)) {
            buffer += chr;
          } else if (
            chr == EOF || chr == '/' || chr == '?' || chr == '#' ||
            (chr == '\\' && url.isSpecial()) ||
            stateOverride
          ) {
            if (buffer != '') {
              var port = parseInt$1(buffer, 10);
              if (port > 0xFFFF) return INVALID_PORT;
              url.port = (url.isSpecial() && port === specialSchemes[url.scheme]) ? null : port;
              buffer = '';
            }
            if (stateOverride) return;
            state = PATH_START;
            continue;
          } else return INVALID_PORT;
          break;

        case FILE:
          url.scheme = 'file';
          if (chr == '/' || chr == '\\') state = FILE_SLASH;
          else if (base && base.scheme == 'file') {
            if (chr == EOF) {
              url.host = base.host;
              url.path = arraySlice$2(base.path);
              url.query = base.query;
            } else if (chr == '?') {
              url.host = base.host;
              url.path = arraySlice$2(base.path);
              url.query = '';
              state = QUERY;
            } else if (chr == '#') {
              url.host = base.host;
              url.path = arraySlice$2(base.path);
              url.query = base.query;
              url.fragment = '';
              state = FRAGMENT;
            } else {
              if (!startsWithWindowsDriveLetter(join(arraySlice$2(codePoints, pointer), ''))) {
                url.host = base.host;
                url.path = arraySlice$2(base.path);
                url.shortenPath();
              }
              state = PATH;
              continue;
            }
          } else {
            state = PATH;
            continue;
          } break;

        case FILE_SLASH:
          if (chr == '/' || chr == '\\') {
            state = FILE_HOST;
            break;
          }
          if (base && base.scheme == 'file' && !startsWithWindowsDriveLetter(join(arraySlice$2(codePoints, pointer), ''))) {
            if (isWindowsDriveLetter(base.path[0], true)) push$3(url.path, base.path[0]);
            else url.host = base.host;
          }
          state = PATH;
          continue;

        case FILE_HOST:
          if (chr == EOF || chr == '/' || chr == '\\' || chr == '?' || chr == '#') {
            if (!stateOverride && isWindowsDriveLetter(buffer)) {
              state = PATH;
            } else if (buffer == '') {
              url.host = '';
              if (stateOverride) return;
              state = PATH_START;
            } else {
              failure = url.parseHost(buffer);
              if (failure) return failure;
              if (url.host == 'localhost') url.host = '';
              if (stateOverride) return;
              buffer = '';
              state = PATH_START;
            } continue;
          } else buffer += chr;
          break;

        case PATH_START:
          if (url.isSpecial()) {
            state = PATH;
            if (chr != '/' && chr != '\\') continue;
          } else if (!stateOverride && chr == '?') {
            url.query = '';
            state = QUERY;
          } else if (!stateOverride && chr == '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr != EOF) {
            state = PATH;
            if (chr != '/') continue;
          } break;

        case PATH:
          if (
            chr == EOF || chr == '/' ||
            (chr == '\\' && url.isSpecial()) ||
            (!stateOverride && (chr == '?' || chr == '#'))
          ) {
            if (isDoubleDot(buffer)) {
              url.shortenPath();
              if (chr != '/' && !(chr == '\\' && url.isSpecial())) {
                push$3(url.path, '');
              }
            } else if (isSingleDot(buffer)) {
              if (chr != '/' && !(chr == '\\' && url.isSpecial())) {
                push$3(url.path, '');
              }
            } else {
              if (url.scheme == 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
                if (url.host) url.host = '';
                buffer = charAt$4(buffer, 0) + ':'; // normalize windows drive letter
              }
              push$3(url.path, buffer);
            }
            buffer = '';
            if (url.scheme == 'file' && (chr == EOF || chr == '?' || chr == '#')) {
              while (url.path.length > 1 && url.path[0] === '') {
                shift(url.path);
              }
            }
            if (chr == '?') {
              url.query = '';
              state = QUERY;
            } else if (chr == '#') {
              url.fragment = '';
              state = FRAGMENT;
            }
          } else {
            buffer += percentEncode(chr, pathPercentEncodeSet);
          } break;

        case CANNOT_BE_A_BASE_URL_PATH:
          if (chr == '?') {
            url.query = '';
            state = QUERY;
          } else if (chr == '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr != EOF) {
            url.path[0] += percentEncode(chr, C0ControlPercentEncodeSet);
          } break;

        case QUERY:
          if (!stateOverride && chr == '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr != EOF) {
            if (chr == "'" && url.isSpecial()) url.query += '%27';
            else if (chr == '#') url.query += '%23';
            else url.query += percentEncode(chr, C0ControlPercentEncodeSet);
          } break;

        case FRAGMENT:
          if (chr != EOF) url.fragment += percentEncode(chr, fragmentPercentEncodeSet);
          break;
      }

      pointer++;
    }
  },
  // https://url.spec.whatwg.org/#host-parsing
  parseHost: function (input) {
    var result, codePoints, index;
    if (charAt$4(input, 0) == '[') {
      if (charAt$4(input, input.length - 1) != ']') return INVALID_HOST;
      result = parseIPv6(stringSlice$6(input, 1, -1));
      if (!result) return INVALID_HOST;
      this.host = result;
    // opaque host
    } else if (!this.isSpecial()) {
      if (exec$2(FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT, input)) return INVALID_HOST;
      result = '';
      codePoints = arrayFrom(input);
      for (index = 0; index < codePoints.length; index++) {
        result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
      }
      this.host = result;
    } else {
      input = toASCII(input);
      if (exec$2(FORBIDDEN_HOST_CODE_POINT, input)) return INVALID_HOST;
      result = parseIPv4(input);
      if (result === null) return INVALID_HOST;
      this.host = result;
    }
  },
  // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
  cannotHaveUsernamePasswordPort: function () {
    return !this.host || this.cannotBeABaseURL || this.scheme == 'file';
  },
  // https://url.spec.whatwg.org/#include-credentials
  includesCredentials: function () {
    return this.username != '' || this.password != '';
  },
  // https://url.spec.whatwg.org/#is-special
  isSpecial: function () {
    return hasOwn$5(specialSchemes, this.scheme);
  },
  // https://url.spec.whatwg.org/#shorten-a-urls-path
  shortenPath: function () {
    var path = this.path;
    var pathSize = path.length;
    if (pathSize && (this.scheme != 'file' || pathSize != 1 || !isWindowsDriveLetter(path[0], true))) {
      path.length--;
    }
  },
  // https://url.spec.whatwg.org/#concept-url-serializer
  serialize: function () {
    var url = this;
    var scheme = url.scheme;
    var username = url.username;
    var password = url.password;
    var host = url.host;
    var port = url.port;
    var path = url.path;
    var query = url.query;
    var fragment = url.fragment;
    var output = scheme + ':';
    if (host !== null) {
      output += '//';
      if (url.includesCredentials()) {
        output += username + (password ? ':' + password : '') + '@';
      }
      output += serializeHost(host);
      if (port !== null) output += ':' + port;
    } else if (scheme == 'file') output += '//';
    output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
    if (query !== null) output += '?' + query;
    if (fragment !== null) output += '#' + fragment;
    return output;
  },
  // https://url.spec.whatwg.org/#dom-url-href
  setHref: function (href) {
    var failure = this.parse(href);
    if (failure) throw TypeError$2(failure);
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-origin
  getOrigin: function () {
    var scheme = this.scheme;
    var port = this.port;
    if (scheme == 'blob') try {
      return new URLConstructor(scheme.path[0]).origin;
    } catch (error) {
      return 'null';
    }
    if (scheme == 'file' || !this.isSpecial()) return 'null';
    return scheme + '://' + serializeHost(this.host) + (port !== null ? ':' + port : '');
  },
  // https://url.spec.whatwg.org/#dom-url-protocol
  getProtocol: function () {
    return this.scheme + ':';
  },
  setProtocol: function (protocol) {
    this.parse($toString$1(protocol) + ':', SCHEME_START);
  },
  // https://url.spec.whatwg.org/#dom-url-username
  getUsername: function () {
    return this.username;
  },
  setUsername: function (username) {
    var codePoints = arrayFrom($toString$1(username));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.username = '';
    for (var i = 0; i < codePoints.length; i++) {
      this.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-password
  getPassword: function () {
    return this.password;
  },
  setPassword: function (password) {
    var codePoints = arrayFrom($toString$1(password));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.password = '';
    for (var i = 0; i < codePoints.length; i++) {
      this.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-host
  getHost: function () {
    var host = this.host;
    var port = this.port;
    return host === null ? ''
      : port === null ? serializeHost(host)
      : serializeHost(host) + ':' + port;
  },
  setHost: function (host) {
    if (this.cannotBeABaseURL) return;
    this.parse(host, HOST);
  },
  // https://url.spec.whatwg.org/#dom-url-hostname
  getHostname: function () {
    var host = this.host;
    return host === null ? '' : serializeHost(host);
  },
  setHostname: function (hostname) {
    if (this.cannotBeABaseURL) return;
    this.parse(hostname, HOSTNAME);
  },
  // https://url.spec.whatwg.org/#dom-url-port
  getPort: function () {
    var port = this.port;
    return port === null ? '' : $toString$1(port);
  },
  setPort: function (port) {
    if (this.cannotHaveUsernamePasswordPort()) return;
    port = $toString$1(port);
    if (port == '') this.port = null;
    else this.parse(port, PORT);
  },
  // https://url.spec.whatwg.org/#dom-url-pathname
  getPathname: function () {
    var path = this.path;
    return this.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
  },
  setPathname: function (pathname) {
    if (this.cannotBeABaseURL) return;
    this.path = [];
    this.parse(pathname, PATH_START);
  },
  // https://url.spec.whatwg.org/#dom-url-search
  getSearch: function () {
    var query = this.query;
    return query ? '?' + query : '';
  },
  setSearch: function (search) {
    search = $toString$1(search);
    if (search == '') {
      this.query = null;
    } else {
      if ('?' == charAt$4(search, 0)) search = stringSlice$6(search, 1);
      this.query = '';
      this.parse(search, QUERY);
    }
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-searchparams
  getSearchParams: function () {
    return this.searchParams.facade;
  },
  // https://url.spec.whatwg.org/#dom-url-hash
  getHash: function () {
    var fragment = this.fragment;
    return fragment ? '#' + fragment : '';
  },
  setHash: function (hash) {
    hash = $toString$1(hash);
    if (hash == '') {
      this.fragment = null;
      return;
    }
    if ('#' == charAt$4(hash, 0)) hash = stringSlice$6(hash, 1);
    this.fragment = '';
    this.parse(hash, FRAGMENT);
  },
  update: function () {
    this.query = this.searchParams.serialize() || null;
  }
};

// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var URLConstructor = function URL(url /* , base */) {
  var that = anInstance$2(this, URLPrototype);
  var base = validateArgumentsLength(arguments.length, 1) > 1 ? arguments[1] : undefined;
  var state = setInternalState$3(that, new URLState(url, false, base));
  if (!DESCRIPTORS$5) {
    that.href = state.serialize();
    that.origin = state.getOrigin();
    that.protocol = state.getProtocol();
    that.username = state.getUsername();
    that.password = state.getPassword();
    that.host = state.getHost();
    that.hostname = state.getHostname();
    that.port = state.getPort();
    that.pathname = state.getPathname();
    that.search = state.getSearch();
    that.searchParams = state.getSearchParams();
    that.hash = state.getHash();
  }
};

var URLPrototype = URLConstructor.prototype;

var accessorDescriptor = function (getter, setter) {
  return {
    get: function () {
      return getInternalURLState(this)[getter]();
    },
    set: setter && function (value) {
      return getInternalURLState(this)[setter](value);
    },
    configurable: true,
    enumerable: true
  };
};

if (DESCRIPTORS$5) {
  // `URL.prototype.href` accessors pair
  // https://url.spec.whatwg.org/#dom-url-href
  defineBuiltInAccessor$4(URLPrototype, 'href', accessorDescriptor('serialize', 'setHref'));
  // `URL.prototype.origin` getter
  // https://url.spec.whatwg.org/#dom-url-origin
  defineBuiltInAccessor$4(URLPrototype, 'origin', accessorDescriptor('getOrigin'));
  // `URL.prototype.protocol` accessors pair
  // https://url.spec.whatwg.org/#dom-url-protocol
  defineBuiltInAccessor$4(URLPrototype, 'protocol', accessorDescriptor('getProtocol', 'setProtocol'));
  // `URL.prototype.username` accessors pair
  // https://url.spec.whatwg.org/#dom-url-username
  defineBuiltInAccessor$4(URLPrototype, 'username', accessorDescriptor('getUsername', 'setUsername'));
  // `URL.prototype.password` accessors pair
  // https://url.spec.whatwg.org/#dom-url-password
  defineBuiltInAccessor$4(URLPrototype, 'password', accessorDescriptor('getPassword', 'setPassword'));
  // `URL.prototype.host` accessors pair
  // https://url.spec.whatwg.org/#dom-url-host
  defineBuiltInAccessor$4(URLPrototype, 'host', accessorDescriptor('getHost', 'setHost'));
  // `URL.prototype.hostname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hostname
  defineBuiltInAccessor$4(URLPrototype, 'hostname', accessorDescriptor('getHostname', 'setHostname'));
  // `URL.prototype.port` accessors pair
  // https://url.spec.whatwg.org/#dom-url-port
  defineBuiltInAccessor$4(URLPrototype, 'port', accessorDescriptor('getPort', 'setPort'));
  // `URL.prototype.pathname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-pathname
  defineBuiltInAccessor$4(URLPrototype, 'pathname', accessorDescriptor('getPathname', 'setPathname'));
  // `URL.prototype.search` accessors pair
  // https://url.spec.whatwg.org/#dom-url-search
  defineBuiltInAccessor$4(URLPrototype, 'search', accessorDescriptor('getSearch', 'setSearch'));
  // `URL.prototype.searchParams` getter
  // https://url.spec.whatwg.org/#dom-url-searchparams
  defineBuiltInAccessor$4(URLPrototype, 'searchParams', accessorDescriptor('getSearchParams'));
  // `URL.prototype.hash` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hash
  defineBuiltInAccessor$4(URLPrototype, 'hash', accessorDescriptor('getHash', 'setHash'));
}

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
defineBuiltIn$4(URLPrototype, 'toJSON', function toJSON() {
  return getInternalURLState(this).serialize();
}, { enumerable: true });

// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
defineBuiltIn$4(URLPrototype, 'toString', function toString() {
  return getInternalURLState(this).serialize();
}, { enumerable: true });

if (NativeURL) {
  var nativeCreateObjectURL = NativeURL.createObjectURL;
  var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
  // `URL.createObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
  if (nativeCreateObjectURL) defineBuiltIn$4(URLConstructor, 'createObjectURL', bind$3(nativeCreateObjectURL, NativeURL));
  // `URL.revokeObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
  if (nativeRevokeObjectURL) defineBuiltIn$4(URLConstructor, 'revokeObjectURL', bind$3(nativeRevokeObjectURL, NativeURL));
}

setToStringTag$1(URLConstructor, 'URL');

$$f({ global: true, constructor: true, forced: !USE_NATIVE_URL, sham: !DESCRIPTORS$5 }, {
  URL: URLConstructor
});

var call$7 = functionCall;
var hasOwn$4 = hasOwnProperty_1;
var isPrototypeOf$4 = objectIsPrototypeOf;
var regExpFlags = regexpFlags$1;

var RegExpPrototype$3 = RegExp.prototype;

var regexpGetFlags = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype$3) && !hasOwn$4(R, 'flags') && isPrototypeOf$4(RegExpPrototype$3, R)
    ? call$7(regExpFlags, R) : flags;
};

var PROPER_FUNCTION_NAME$2 = functionName.PROPER;
var defineBuiltIn$3 = defineBuiltIn$d;
var anObject$4 = anObject$k;
var $toString = toString$g;
var fails$g = fails$A;
var getRegExpFlags$2 = regexpGetFlags;

var TO_STRING = 'toString';
var RegExpPrototype$2 = RegExp.prototype;
var nativeToString = RegExpPrototype$2[TO_STRING];

var NOT_GENERIC = fails$g(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME$2 && nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn$3(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject$4(this);
    var pattern = $toString(R.source);
    var flags = $toString(getRegExpFlags$2(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}

const isObject$5 = value => value !== null && typeof value === "object";
const isRecord = value => isObject$5(value) && !isArray$4(value);
const isArray$4 = value => value !== null && Array.isArray(value);
const isString = value => typeof value === "string";

const isHiddenByAction = (ruleEngineInput, variableId, instanceId, map = "hiddenVariablesMap") => {
  const mapForVariable = ruleEngineInput == null ? void 0 : ruleEngineInput[map][variableId];
  const isGloballyHidden = mapForVariable === true;
  const isLocallyHidden = isRecord(mapForVariable) && mapForVariable[instanceId];
  return isGloballyHidden || isLocallyHidden;
};

var charAt$3 = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex$3 = function (S, index, unicode) {
  return index + (unicode ? charAt$3(S, index).length : 1);
};

var uncurryThis$h = functionUncurryThis;
var toObject$7 = toObject$c;

var floor$3 = Math.floor;
var charAt$2 = uncurryThis$h(''.charAt);
var replace$3 = uncurryThis$h(''.replace);
var stringSlice$5 = uncurryThis$h(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
var getSubstitution$1 = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject$7(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace$3(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt$2(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice$5(str, 0, position);
      case "'": return stringSlice$5(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice$5(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor$3(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt$2(ch, 1) : captures[f - 1] + charAt$2(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};

var apply$1 = functionApply;
var call$6 = functionCall;
var uncurryThis$g = functionUncurryThis;
var fixRegExpWellKnownSymbolLogic$1 = fixRegexpWellKnownSymbolLogic;
var fails$f = fails$A;
var anObject$3 = anObject$k;
var isCallable$3 = isCallable$q;
var isNullOrUndefined$2 = isNullOrUndefined$8;
var toIntegerOrInfinity$6 = toIntegerOrInfinity$a;
var toLength$7 = toLength$9;
var toString$a = toString$g;
var requireObjectCoercible$5 = requireObjectCoercible$b;
var advanceStringIndex$2 = advanceStringIndex$3;
var getMethod$2 = getMethod$7;
var getSubstitution = getSubstitution$1;
var regExpExec$2 = regexpExecAbstract;
var wellKnownSymbol$4 = wellKnownSymbol$o;

var REPLACE = wellKnownSymbol$4('replace');
var max = Math.max;
var min$1 = Math.min;
var concat = uncurryThis$g([].concat);
var push$2 = uncurryThis$g([].push);
var stringIndexOf$2 = uncurryThis$g(''.indexOf);
var stringSlice$4 = uncurryThis$g(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails$f(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic$1('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible$5(this);
      var replacer = isNullOrUndefined$2(searchValue) ? undefined : getMethod$2(searchValue, REPLACE);
      return replacer
        ? call$6(replacer, searchValue, O, replaceValue)
        : call$6(nativeReplace, toString$a(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject$3(this);
      var S = toString$a(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf$2(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf$2(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable$3(replaceValue);
      if (!functionalReplace) replaceValue = toString$a(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec$2(rx, S);
        if (result === null) break;

        push$2(results, result);
        if (!global) break;

        var matchStr = toString$a(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex$2(S, toLength$7(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString$a(result[0]);
        var position = max(min$1(toIntegerOrInfinity$6(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push$2(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push$2(replacerArgs, namedCaptures);
          var replacement = toString$a(apply$1(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice$4(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + stringSlice$4(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

const isInterval = thing => isRecord(thing) && "left" in thing;
const isDiscreteInterval = thing => isInterval(thing) && thing.left === thing.right;
const discreteInterval = n => ({
  left: n,
  leftInclude: true,
  right: n,
  rightInclude: true
});
const excludingInterval = (left, right) => ({
  left,
  right,
  leftInclude: false,
  rightInclude: false
});
const intervalToString = interval => {
  if (interval.left === interval.right) return interval.left.toString();
  return `${interval.leftInclude ? "" : "("}${interval.left}-${interval.right}${interval.rightInclude ? "" : ")"}`;
};
const mergeConnectedIntervals = intervals => {
  const last = intervals[intervals.length - 1];
  return Object.assign({}, intervals[0], {
    right: last.right,
    rightInclude: last.rightInclude
  });
};
const sanitizeInterval = ({
  left,
  leftInclude,
  right,
  rightInclude
}) => {
  return {
    left: left != null ? left : -Infinity,
    right: right != null ? right : Infinity,
    leftInclude,
    rightInclude
  };
};

const splitString = str => {
  const noWhite = str.replace(/\s/g, "");
  if (noWhite.includes(";")) return noWhite.split(";");
  if (noWhite.includes("-")) return noWhite.split("-");
  return [];
};
const stringAndInclude = (s, pos) => {
  if (pos === "left") {
    if (["]", "("].includes(s[0])) return [s.slice(1), false];
    return [s.slice(s[0] === "[" ? 1 : 0), true];
  } else {
    const lastIndex = s.length - 1;
    const last = s[lastIndex];
    if (["[", ")"].includes(last)) return [s.slice(0, lastIndex), false];
    return [s.slice(0, last === "]" ? lastIndex : lastIndex + 1), true];
  }
};
const numberAndInclude = (s, pos) => {
  const [no, include] = stringAndInclude(s, pos);
  if (no === "") return [pos === "left" ? -Infinity : Infinity, false];
  const n = Number(no);
  if (isNaN(n)) {
    throw new Error(`Unable to parse ${s} to number`);
  }
  return [n, include];
};
const parseInterval = str => {
  const n = Number(str);
  if (n || n === 0) return {
    left: n,
    leftInclude: true,
    right: n,
    rightInclude: true
  };
  const split = splitString(str);
  if (split.length !== 2) throw new Error(`Unable to parse interval ${str}`);
  const [left, leftInclude] = numberAndInclude(split[0], "left");
  const [right, rightInclude] = numberAndInclude(split[1], "right");
  return {
    left,
    leftInclude,
    right,
    rightInclude
  };
};
const isDiscreteIntervalValue = value => isDiscreteInterval(value.data);

const noSelectionKey = "$noSelection";

var aCallable$3 = aCallable$c;
var toObject$6 = toObject$c;
var IndexedObject$1 = indexedObject;
var lengthOfArrayLike$8 = lengthOfArrayLike$d;

var $TypeError$4 = TypeError;

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod$2 = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aCallable$3(callbackfn);
    var O = toObject$6(that);
    var self = IndexedObject$1(O);
    var length = lengthOfArrayLike$8(O);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw $TypeError$4('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod$2(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod$2(true)
};

var fails$e = fails$A;

var arrayMethodIsStrict$2 = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails$e(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};

var $$e = _export;
var $reduce = arrayReduce.left;
var arrayMethodIsStrict$1 = arrayMethodIsStrict$2;
var CHROME_VERSION = engineV8Version;
var IS_NODE = engineIsNode;

// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;
var FORCED$5 = CHROME_BUG || !arrayMethodIsStrict$1('reduce');

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$$e({ target: 'Array', proto: true, forced: FORCED$5 }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var length = arguments.length;
    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
  }
});

// a string of all valid unicode whitespaces
var whitespaces$4 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var uncurryThis$f = functionUncurryThis;
var requireObjectCoercible$4 = requireObjectCoercible$b;
var toString$9 = toString$g;
var whitespaces$3 = whitespaces$4;

var replace$2 = uncurryThis$f(''.replace);
var ltrim = RegExp('^[' + whitespaces$3 + ']+');
var rtrim = RegExp('(^|[^' + whitespaces$3 + '])[' + whitespaces$3 + ']+$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod$1 = function (TYPE) {
  return function ($this) {
    var string = toString$9(requireObjectCoercible$4($this));
    if (TYPE & 1) string = replace$2(string, ltrim, '');
    if (TYPE & 2) string = replace$2(string, rtrim, '$1');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod$1(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod$1(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod$1(3)
};

var global$b = global$w;
var fails$d = fails$A;
var uncurryThis$e = functionUncurryThis;
var toString$8 = toString$g;
var trim$1 = stringTrim.trim;
var whitespaces$2 = whitespaces$4;

var charAt$1 = uncurryThis$e(''.charAt);
var $parseFloat$1 = global$b.parseFloat;
var Symbol$2 = global$b.Symbol;
var ITERATOR$1 = Symbol$2 && Symbol$2.iterator;
var FORCED$4 = 1 / $parseFloat$1(whitespaces$2 + '-0') !== -Infinity
  // MS Edge 18- broken with boxed symbols
  || (ITERATOR$1 && !fails$d(function () { $parseFloat$1(Object(ITERATOR$1)); }));

// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
var numberParseFloat = FORCED$4 ? function parseFloat(string) {
  var trimmedString = trim$1(toString$8(string));
  var result = $parseFloat$1(trimmedString);
  return result === 0 && charAt$1(trimmedString, 0) == '-' ? -0 : result;
} : $parseFloat$1;

var $$d = _export;
var $parseFloat = numberParseFloat;

// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
$$d({ global: true, forced: parseFloat != $parseFloat }, {
  parseFloat: $parseFloat
});

var global$a = global$w;
var fails$c = fails$A;
var uncurryThis$d = functionUncurryThis;
var toString$7 = toString$g;
var trim = stringTrim.trim;
var whitespaces$1 = whitespaces$4;

var $parseInt$1 = global$a.parseInt;
var Symbol$1 = global$a.Symbol;
var ITERATOR = Symbol$1 && Symbol$1.iterator;
var hex = /^[+-]?0x/i;
var exec$1 = uncurryThis$d(hex.exec);
var FORCED$3 = $parseInt$1(whitespaces$1 + '08') !== 8 || $parseInt$1(whitespaces$1 + '0x16') !== 22
  // MS Edge 18- broken with boxed symbols
  || (ITERATOR && !fails$c(function () { $parseInt$1(Object(ITERATOR)); }));

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
var numberParseInt = FORCED$3 ? function parseInt(string, radix) {
  var S = trim(toString$7(string));
  return $parseInt$1(S, (radix >>> 0) || (exec$1(hex, S) ? 16 : 10));
} : $parseInt$1;

var $$c = _export;
var $parseInt = numberParseInt;

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$$c({ global: true, forced: parseInt != $parseInt }, {
  parseInt: $parseInt
});

function isWithId(value) {
  return isObject$h(value) && has$1("id", value);
}
const indexById = items => keyBy(items, "id");
const mapValuesExtra = mapValues.convert({
  cap: false
});
const mapExtra = map.convert({
  cap: false
});
const reduceExtra = reduce.convert({
  cap: false
});
const pickByExtra = pickBy.convert({
  cap: false
});
const forEachExtra = forEach$1.convert({
  cap: false
});
const when = curry((checkValue, func, value) => checkValue ? func(value) : value);
curry((checkFn, func, value) => checkFn(value) ? func(value) : value);
const transform = updated => old => mergeWith((oldValue, updatedValue) => {
  if (updatedValue === undefined) {
    return oldValue;
  }
  if (isFunction(updatedValue)) {
    return updatedValue(oldValue);
  } else if (isArray$5(oldValue)) {
    if (isFunction(updatedValue)) {
      return map(updatedValue, oldValue);
    }
    if (flow(first, has$1("id"))(oldValue)) {
      const srcIndexedById = indexById(updatedValue);
      return map(v => srcIndexedById[v.id] ? assign$2(v, srcIndexedById[v.id]) : v, oldValue);
    }
    return updatedValue;
  }
}, old, updated);
function set$1(updated, toUpdate) {
  return mergeWith((objValue, srcValue) => {
    if (isArray$5(objValue)) {
      return srcValue;
    }
  }, toUpdate, updated);
}
const maybeParseInt = id => {
  if (isString$1(id)) {
    if (id.includes("Infinity")) {
      return parseFloat(id);
    }
    return parseInt(id);
  }
  return id;
};
const moveItem = (sourceIndex, destinationIndex) => reduceExtra((acc, val, index, array) => {
  if (index === sourceIndex) {
    return acc;
  } else if (index === destinationIndex) {
    return sourceIndex < destinationIndex ? [...acc, val, array[sourceIndex]] : [...acc, array[sourceIndex], val];
  } else {
    return [...acc, val];
  }
}, []);
const modulo = (modulus, number) => (number % modulus + modulus) % modulus;

const VariableType = {
  List: "list",
  Color: "color",
  Number: "number",
  Text: "text",
  MultiSelect: "multiSelect",
  Boolean: "boolean",
  Image: "image",
  Components: "components"
};
const variableTypeValues = values$5(VariableType);
const VariableTemplateType = {
  Checkbox: "checkbox",
  Hidden: "hidden",
  RadioCard: "radioCard",
  Radio: "radio",
  Select: "select",
  Text: "text",
  Textarea: "textarea",
  Number: "number",
  Switch: "switch",
  SwitchCard: "switchCard",
  ColorSelect: "colorSelect",
  ColorDropdown: "colorDropdown",
  ColorRadio: "colorRadio",
  RALColorSelect: "ralColorSelect",
  ImageUpload: "imageUpload",
  ComponentList: "componentList",
  ComponentListPopup: "componentListPopup"
};
const showSelection$4 = ["always", "never", "auto"];
var ImageFormat;
(function (ImageFormat) {
  ImageFormat["PNG"] = "PNG";
  ImageFormat["JPG"] = "JPG";
})(ImageFormat || (ImageFormat = {}));
function isVariable(variable) {
  const cast = variable;
  const hasId = (cast == null ? void 0 : cast.id) !== undefined;
  const hasVariableType = variableTypeValues.includes(cast == null ? void 0 : cast.type);
  return hasId && hasVariableType;
}
function isNewVariable(variable) {
  const cast = variable;
  const hasNoId = (cast == null ? void 0 : cast.id) === undefined;
  const hasVariableType = variableTypeValues.includes(cast == null ? void 0 : cast.type);
  return hasNoId && hasVariableType;
}
const isColorVariable = variable => variable.type === VariableType.Color;
const isImageVariable = variable => variable.type === VariableType.Image;
/** Is a variable a number variable? */
const isNumberVariable = variable => (variable == null ? void 0 : variable.type) === VariableType.Number;
const isBooleanVariable = variable => variable.type === VariableType.Boolean;

const getTemplate = variable => variable == null ? void 0 : variable.settings.template;
const getTemplateOptions = variable => variable == null ? void 0 : variable.settings.templateOptions;
/** Gets the smallest delta to the next allowed number */
const getMinimumDeviation = variable => {
  const {
    step,
    roundToStep,
    digits
  } = getTemplateOptions(variable);
  const numberStep = Number(step || 0);
  if (numberStep && roundToStep) return numberStep;
  if (digits) return 1 / 10 ** digits;
  return 1;
};
/** Gets the min/max values of a number variable. */
const getMinMaxTemplateOptions = variable => {
  var _getTemplateOptions, _getTemplateOptions2;
  return {
    min: ((_getTemplateOptions = getTemplateOptions(variable)) == null ? void 0 : _getTemplateOptions.min) || -Infinity,
    max: ((_getTemplateOptions2 = getTemplateOptions(variable)) == null ? void 0 : _getTemplateOptions2.max) || Infinity
  };
};
const getAttributeDefinitions = variable => (variable == null ? void 0 : variable.attrs) || [];
const getAttributeDefinitionByKey = (attributeKey, variable) =>
// @ts-ignore
getAttributeDefinitions(variable).find(attributeDefinition => attributeDefinition.key === attributeKey);
const isRALTemplate = flow(getTemplate, equals(VariableTemplateType.RALColorSelect));
const isHidden$1 = variable => {
  var _getTemplateOptions3;
  return ((_getTemplateOptions3 = getTemplateOptions(variable)) == null ? void 0 : _getTemplateOptions3.hideAlways) || getTemplate(variable) === VariableTemplateType.Hidden;
};
const isVisible = variable => !isHidden$1(variable);
const isTextArea = variable => getTemplate(variable) === "textarea";
curry((label, variable) => transform({
  label
})(variable));
curry((description, variable) => transform({
  description
})(variable));
const setVariableTemplate = curry((template, variable) => transform({
  settings: {
    template
  }
})(variable));
const setVariableTemplateOptions = curry((templateOptions, variable) => transform({
  settings: {
    templateOptions
  }
})(variable));
const setVariableType = curry((type, variable) => transform({
  type
})(variable));

var HiddenReason;
(function (HiddenReason) {
  HiddenReason[HiddenReason["HideAction"] = 0] = "HideAction";
  HiddenReason[HiddenReason["ConcealAction"] = 1] = "ConcealAction";
  HiddenReason[HiddenReason["OneValidValue"] = 2] = "OneValidValue";
  HiddenReason[HiddenReason["NoValidValue"] = 3] = "NoValidValue";
  HiddenReason[HiddenReason["AlwaysHidden"] = 4] = "AlwaysHidden";
})(HiddenReason || (HiddenReason = {}));
const isHiddenBecause = (variable, input, state, instanceId) => {
  var _input$values, _input$values$byVarId, _state$all, _state$all$validOptio;
  const templateOptions = getTemplateOptions(variable);
  if (templateOptions.hideAlways) {
    return {
      reason: HiddenReason.AlwaysHidden,
      text: "Dieses Merkmal ist versteckt."
    };
  }
  if (isHiddenByAction(input, variable.id, instanceId, "concealedVariablesMap")) {
    return {
      reason: HiddenReason.ConcealAction,
      text: "Dieses Merkmal ist nur im Admin-Panel sichtbar, da es per Regel versteckt wurde."
    };
  }
  if (!(input != null && (_input$values = input.values) != null && (_input$values$byVarId = _input$values.byVarId) != null && _input$values$byVarId.all[variable.id]) || isHiddenByAction(input, variable.id, instanceId)) {
    return {
      reason: HiddenReason.HideAction,
      text: "Dieses Merkmal ist nur im Admin-Panel sichtbar. Das kann mehrere Ursachen haben: \n 1. Es wurde per Regel entfernt. \n 2. Die zugehörige Gruppe wurde entfernt. \n 3. Das Merkmal besitzt keine Auswahloptionen."
    };
  }
  const validOptions = state == null ? void 0 : (_state$all = state.all) == null ? void 0 : (_state$all$validOptio = _state$all.validOptions[instanceId]) == null ? void 0 : _state$all$validOptio[variable.id];
  if (templateOptions != null && templateOptions.hideIfNoOptions && (validOptions == null ? void 0 : validOptions.length) === 0) {
    return {
      reason: HiddenReason.NoValidValue,
      text: "Dieses Merkmal ist nicht mehr sichtbar, weil es keine valide Auswahl hat!"
    };
  }
  if (templateOptions != null && templateOptions.hideIfSingleOption && (validOptions == null ? void 0 : validOptions.length) === 1) {
    if (isNumberVariable(variable)) {
      var _validOptions$;
      const value = (_validOptions$ = validOptions[0]) == null ? void 0 : _validOptions$.value;
      if (!isDiscreteIntervalValue(value)) {
        return null;
      }
    }
    return {
      reason: HiddenReason.OneValidValue,
      text: "Dieses Merkmal ist nicht mehr sichtbar, weil es nur eine valide Auswahl hat!"
    };
  }
  return null;
};
/** Returns whether a selection should be displayed in summaries like PDF or the overview page.
 * Has nothing to do with displaying it in the UI. IsHiddenBecause handles this.
 */
const shouldSelectionBeDisplayedInSummaries = (variable, input, state, selection) => {
  const {
    showSelection,
    hideIfNoSelection
  } = getTemplateOptions(variable);
  if (hideIfNoSelection) {
    var _state$all$selections;
    const valueId = (_state$all$selections = state.all.selections.find(s => s.variableId === variable.id)) == null ? void 0 : _state$all$selections.valueId;
    const isOptionalDefaultSelected = getIsOptionalDefaultSelected(variable, state, selection, valueId);
    if (isOptionalDefaultSelected) {
      return false;
    }
    const isASwitch = variable.type === VariableType.Boolean;
    const isImageUpload = variable.type === VariableType.Image;
    if (isASwitch || isImageUpload) {
      return getIsVariableOn(variable, input, valueId);
    }
    return true;
  }
  switch (showSelection) {
    case "always":
      return true;
    case "never":
      return false;
    case "auto":
    default:
      return !isHiddenBecause(variable, input, state, selection.instance.id);
  }
};
const getIsOptionalDefaultSelected = (variable, state, selection, valueId) => {
  var _state$all$validOptio2, _state$all$validOptio3;
  return ((_state$all$validOptio2 = state.all.validOptions[selection.instance.id][variable.id]) == null ? void 0 : (_state$all$validOptio3 = _state$all$validOptio2.find(o => o.value.id === valueId)) == null ? void 0 : _state$all$validOptio3.value.key) === noSelectionKey;
};
const getIsVariableOn = (variable, input, selectionId) => {
  var _input$values$byVarId2;
  return ((_input$values$byVarId2 = input.values.byVarId.all[variable.id].find(v => v.id === selectionId)) == null ? void 0 : _input$values$byVarId2.value) === "1";
};

var classof$5 = classofRaw$2;

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray$3 = Array.isArray || function isArray(argument) {
  return classof$5(argument) == 'Array';
};

var $TypeError$3 = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

var doesNotExceedSafeInteger$1 = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError$3('Maximum allowed index exceeded');
  return it;
};

var isArray$2 = isArray$3;
var lengthOfArrayLike$7 = lengthOfArrayLike$d;
var doesNotExceedSafeInteger = doesNotExceedSafeInteger$1;
var bind$2 = functionBindContext;

// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var flattenIntoArray$2 = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? bind$2(mapper, thisArg) : false;
  var element, elementLen;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      if (depth > 0 && isArray$2(element)) {
        elementLen = lengthOfArrayLike$7(element);
        targetIndex = flattenIntoArray$2(target, original, element, elementLen, targetIndex, depth - 1) - 1;
      } else {
        doesNotExceedSafeInteger(targetIndex + 1);
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
};

var flattenIntoArray_1 = flattenIntoArray$2;

var isArray$1 = isArray$3;
var isConstructor = isConstructor$3;
var isObject$4 = isObject$g;
var wellKnownSymbol$3 = wellKnownSymbol$o;

var SPECIES = wellKnownSymbol$3('species');
var $Array$1 = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesConstructor$1 = function (originalArray) {
  var C;
  if (isArray$1(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === $Array$1 || isArray$1(C.prototype))) C = undefined;
    else if (isObject$4(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array$1 : C;
};

var arraySpeciesConstructor = arraySpeciesConstructor$1;

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate$3 = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};

var $$b = _export;
var flattenIntoArray$1 = flattenIntoArray_1;
var toObject$5 = toObject$c;
var lengthOfArrayLike$6 = lengthOfArrayLike$d;
var toIntegerOrInfinity$5 = toIntegerOrInfinity$a;
var arraySpeciesCreate$2 = arraySpeciesCreate$3;

// `Array.prototype.flat` method
// https://tc39.es/ecma262/#sec-array.prototype.flat
$$b({ target: 'Array', proto: true }, {
  flat: function flat(/* depthArg = 1 */) {
    var depthArg = arguments.length ? arguments[0] : undefined;
    var O = toObject$5(this);
    var sourceLen = lengthOfArrayLike$6(O);
    var A = arraySpeciesCreate$2(O, 0);
    A.length = flattenIntoArray$1(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toIntegerOrInfinity$5(depthArg));
    return A;
  }
});

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables$1 = addToUnscopables$4;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$1('flat');

var tryToString$1 = tryToString$6;

var $TypeError$2 = TypeError;

var deletePropertyOrThrow$1 = function (O, P) {
  if (!delete O[P]) throw $TypeError$2('Cannot delete property ' + tryToString$1(P) + ' of ' + tryToString$1(O));
};

var userAgent$1 = engineUserAgent;

var firefox = userAgent$1.match(/firefox\/(\d+)/i);

var engineFfVersion = !!firefox && +firefox[1];

var UA = engineUserAgent;

var engineIsIeOrEdge = /MSIE|Trident/.test(UA);

var userAgent = engineUserAgent;

var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);

var engineWebkitVersion = !!webkit && +webkit[1];

var $$a = _export;
var uncurryThis$c = functionUncurryThis;
var aCallable$2 = aCallable$c;
var toObject$4 = toObject$c;
var lengthOfArrayLike$5 = lengthOfArrayLike$d;
var deletePropertyOrThrow = deletePropertyOrThrow$1;
var toString$6 = toString$g;
var fails$b = fails$A;
var internalSort$1 = arraySort$1;
var arrayMethodIsStrict = arrayMethodIsStrict$2;
var FF$1 = engineFfVersion;
var IE_OR_EDGE$1 = engineIsIeOrEdge;
var V8$1 = engineV8Version;
var WEBKIT$1 = engineWebkitVersion;

var test$1 = [];
var nativeSort$1 = uncurryThis$c(test$1.sort);
var push$1 = uncurryThis$c(test$1.push);

// IE8-
var FAILS_ON_UNDEFINED = fails$b(function () {
  test$1.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails$b(function () {
  test$1.sort(null);
});
// Old WebKit
var STRICT_METHOD = arrayMethodIsStrict('sort');

var STABLE_SORT$1 = !fails$b(function () {
  // feature detection can be too slow, so check engines versions
  if (V8$1) return V8$1 < 70;
  if (FF$1 && FF$1 > 3) return;
  if (IE_OR_EDGE$1) return true;
  if (WEBKIT$1) return WEBKIT$1 < 603;

  var result = '';
  var code, chr, value, index;

  // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);

    switch (code) {
      case 66: case 69: case 70: case 72: value = 3; break;
      case 68: case 71: value = 4; break;
      default: value = 2;
    }

    for (index = 0; index < 47; index++) {
      test$1.push({ k: chr + index, v: value });
    }
  }

  test$1.sort(function (a, b) { return b.v - a.v; });

  for (index = 0; index < test$1.length; index++) {
    chr = test$1[index].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr) result += chr;
  }

  return result !== 'DGBEFHACIJK';
});

var FORCED$2 = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT$1;

var getSortCompare$1 = function (comparefn) {
  return function (x, y) {
    if (y === undefined) return -1;
    if (x === undefined) return 1;
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    return toString$6(x) > toString$6(y) ? 1 : -1;
  };
};

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$$a({ target: 'Array', proto: true, forced: FORCED$2 }, {
  sort: function sort(comparefn) {
    if (comparefn !== undefined) aCallable$2(comparefn);

    var array = toObject$4(this);

    if (STABLE_SORT$1) return comparefn === undefined ? nativeSort$1(array) : nativeSort$1(array, comparefn);

    var items = [];
    var arrayLength = lengthOfArrayLike$5(array);
    var itemsLength, index;

    for (index = 0; index < arrayLength; index++) {
      if (index in array) push$1(items, array[index]);
    }

    internalSort$1(items, getSortCompare$1(comparefn));

    itemsLength = lengthOfArrayLike$5(items);
    index = 0;

    while (index < itemsLength) array[index] = items[index++];
    while (index < arrayLength) deletePropertyOrThrow(array, index++);

    return array;
  }
});

var $$9 = _export;
var flattenIntoArray = flattenIntoArray_1;
var aCallable$1 = aCallable$c;
var toObject$3 = toObject$c;
var lengthOfArrayLike$4 = lengthOfArrayLike$d;
var arraySpeciesCreate$1 = arraySpeciesCreate$3;

// `Array.prototype.flatMap` method
// https://tc39.es/ecma262/#sec-array.prototype.flatmap
$$9({ target: 'Array', proto: true }, {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject$3(this);
    var sourceLen = lengthOfArrayLike$4(O);
    var A;
    aCallable$1(callbackfn);
    A = arraySpeciesCreate$1(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    return A;
  }
});

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = addToUnscopables$4;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('flatMap');

const isSimpleSelection = selection => selection.instance.isInstanceLauncher === false && selection.id !== selection.instance.id;
const isInstanceSelection = selection => selection.instance.isInstanceLauncher === true && selection.id === selection.instance.id;
const isChildSelectionOfParent = parent => child => {
  if (isSimpleSelection(child)) {
    return parent.id === child.instance.id;
  } else if (isInstanceSelection(child)) {
    return parent.id === child.instance.belongsToInstanceId;
  } else {
    return false;
  }
};
const getParentSelectionId = child => {
  if (isSimpleSelection(child)) {
    return child.instance.id;
  } else if (isInstanceSelection(child)) {
    return child.instance.belongsToInstanceId;
  } else {
    return undefined;
  }
};
const getParentSelection = (selections, selection) => {
  if (isSimpleSelection(selection)) {
    return selections.find(s => s.id === selection.instance.id);
  } else if (isInstanceSelection(selection)) {
    return selections.find(s => s.id === selection.instance.belongsToInstanceId);
  } else {
    return undefined;
  }
};
const rootSelection = {
  id: "",
  instance: {
    id: "",
    isInstanceLauncher: true,
    belongsToInstanceId: "",
    belongsToVariableId: null,
    hierarchyLevel: 0
  },
  variableId: null,
  valueId: 0
};
/** Calculates all instances based on selections */
const calcInstances = selections => [rootSelection, ...findAllChildrenInstances(selections)];
/** Finds the parent instances, and their parent instance and so on...
 * Including the root selection, if not passed as selection.
 * Always excluding selection itself */
const findAllParentInstances = (selections, selection) => {
  const parents = [];
  let thisSelection = selection;
  while (thisSelection) {
    thisSelection = selections.find(
    // eslint-disable-next-line no-loop-func
    s => {
      var _thisSelection, _thisSelection2;
      return s.instance.isInstanceLauncher && s.instance.id === ((_thisSelection = thisSelection) == null ? void 0 : _thisSelection.instance.belongsToInstanceId) && s.id !== ((_thisSelection2 = thisSelection) == null ? void 0 : _thisSelection2.id);
    });
    if (thisSelection) parents.push(thisSelection);
  }
  if (selection.id) parents.push(rootSelection);
  return parents;
};
/** Finds all children instances, and their children instances and so on...
 * Always excluding selection itself */
const findAllChildrenInstances = (selections, selection) => {
  let children = selections.filter(s => s.instance.isInstanceLauncher && s.instance.belongsToInstanceId === ((selection == null ? void 0 : selection.instance.id) || rootSelection.id) && s.id !== (selection == null ? void 0 : selection.id));
  for (const child of children) {
    children = [...children, ...findAllChildrenInstances(selections, child)];
  }
  return children;
};
/** Finds all instances in a line, if you imagine them as a tree.
 * Meaning parents, itself and all children.
 */
const findAllInstancesInLine = (selections, selection) => {
  const nextInstance = (selection.instance.isInstanceLauncher ? selection : selections.find(s => s.instance.isInstanceLauncher && s.instance.id === selection.instance.id)) || rootSelection;
  const children = findAllChildrenInstances(selections, nextInstance);
  const parents = findAllParentInstances(selections, nextInstance);
  return [...parents, nextInstance, ...children];
};
const findSelectionWithHighestHierarchyLevel = selections => selections.reduce((acc, selection) => selection.instance.hierarchyLevel > acc.instance.hierarchyLevel ? selection : acc, rootSelection);

/** Creates a new selection */
const createSelection = (variable, value, parentInstance, isInstance, additionalData, sort) => {
  const id = nanoid();
  const varId = typeof variable === "number" ? variable : variable.id;
  return {
    id: id,
    variableId: varId,
    valueId: (value == null ? void 0 : value.id) || 0,
    instance: isInstance ? {
      id: id,
      belongsToInstanceId: parentInstance.id,
      belongsToVariableId: varId,
      isInstanceLauncher: true,
      hierarchyLevel: parentInstance.hierarchyLevel + 1
    } : Object.assign({}, parentInstance, {
      isInstanceLauncher: false,
      hierarchyLevel: parentInstance.hierarchyLevel + 1
    }),
    debuggingValue: (value == null ? void 0 : value.label) || `Empty selection for variable ${typeof variable === "number" ? variable : variable.label}`,
    data: additionalData,
    interval: value == null ? void 0 : value.data,
    sort
  };
};

var uncurryThis$b = functionUncurryThis;

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
var thisNumberValue$1 = uncurryThis$b(1.0.valueOf);

var toIntegerOrInfinity$4 = toIntegerOrInfinity$a;
var toString$5 = toString$g;
var requireObjectCoercible$3 = requireObjectCoercible$b;

var $RangeError$4 = RangeError;

// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
var stringRepeat = function repeat(count) {
  var str = toString$5(requireObjectCoercible$3(this));
  var result = '';
  var n = toIntegerOrInfinity$4(count);
  if (n < 0 || n == Infinity) throw $RangeError$4('Wrong number of repetitions');
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
  return result;
};

var $$8 = _export;
var uncurryThis$a = functionUncurryThis;
var toIntegerOrInfinity$3 = toIntegerOrInfinity$a;
var thisNumberValue = thisNumberValue$1;
var $repeat = stringRepeat;
var fails$a = fails$A;

var $RangeError$3 = RangeError;
var $String = String;
var floor$2 = Math.floor;
var repeat = uncurryThis$a($repeat);
var stringSlice$3 = uncurryThis$a(''.slice);
var nativeToFixed = uncurryThis$a(1.0.toFixed);

var pow$1 = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow$1(x, n - 1, acc * x) : pow$1(x * x, n / 2, acc);
};

var log$1 = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

var multiply = function (data, n, c) {
  var index = -1;
  var c2 = c;
  while (++index < 6) {
    c2 += n * data[index];
    data[index] = c2 % 1e7;
    c2 = floor$2(c2 / 1e7);
  }
};

var divide = function (data, n) {
  var index = 6;
  var c = 0;
  while (--index >= 0) {
    c += data[index];
    data[index] = floor$2(c / n);
    c = (c % n) * 1e7;
  }
};

var dataToString = function (data) {
  var index = 6;
  var s = '';
  while (--index >= 0) {
    if (s !== '' || index === 0 || data[index] !== 0) {
      var t = $String(data[index]);
      s = s === '' ? t : s + repeat('0', 7 - t.length) + t;
    }
  } return s;
};

var FORCED$1 = fails$a(function () {
  return nativeToFixed(0.00008, 3) !== '0.000' ||
    nativeToFixed(0.9, 0) !== '1' ||
    nativeToFixed(1.255, 2) !== '1.25' ||
    nativeToFixed(1000000000000000128.0, 0) !== '1000000000000000128';
}) || !fails$a(function () {
  // V8 ~ Android 4.3-
  nativeToFixed({});
});

// `Number.prototype.toFixed` method
// https://tc39.es/ecma262/#sec-number.prototype.tofixed
$$8({ target: 'Number', proto: true, forced: FORCED$1 }, {
  toFixed: function toFixed(fractionDigits) {
    var number = thisNumberValue(this);
    var fractDigits = toIntegerOrInfinity$3(fractionDigits);
    var data = [0, 0, 0, 0, 0, 0];
    var sign = '';
    var result = '0';
    var e, z, j, k;

    // TODO: ES2018 increased the maximum number of fraction digits to 100, need to improve the implementation
    if (fractDigits < 0 || fractDigits > 20) throw $RangeError$3('Incorrect fraction digits');
    // eslint-disable-next-line no-self-compare -- NaN check
    if (number != number) return 'NaN';
    if (number <= -1e21 || number >= 1e21) return $String(number);
    if (number < 0) {
      sign = '-';
      number = -number;
    }
    if (number > 1e-21) {
      e = log$1(number * pow$1(2, 69, 1)) - 69;
      z = e < 0 ? number * pow$1(2, -e, 1) : number / pow$1(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(data, 0, z);
        j = fractDigits;
        while (j >= 7) {
          multiply(data, 1e7, 0);
          j -= 7;
        }
        multiply(data, pow$1(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(data, 1 << 23);
          j -= 23;
        }
        divide(data, 1 << j);
        multiply(data, 1, 1);
        divide(data, 2);
        result = dataToString(data);
      } else {
        multiply(data, 0, z);
        multiply(data, 1 << -e, 0);
        result = dataToString(data) + repeat('0', fractDigits);
      }
    }
    if (fractDigits > 0) {
      k = result.length;
      result = sign + (k <= fractDigits
        ? '0.' + repeat('0', fractDigits - k) + result
        : stringSlice$3(result, 0, k - fractDigits) + '.' + stringSlice$3(result, k - fractDigits));
    } else {
      result = sign + result;
    } return result;
  }
});

const isMultiVariable = v => (v == null ? void 0 : v.type) === "components";
const selectionsEqual = (a, b) => a.valueId === b.valueId && selectionHasSamePosition(a, b);
/** Selections belong to the same instance and variable. However, their value
 * might be different */
const selectionHasSamePosition = (a, b) => a.variableId === b.variableId && a.instance.id === b.instance.id && a.instance.belongsToInstanceId === b.instance.belongsToInstanceId;
const matchingSelectionForVariable = (variableId, openInstance) => s => s.variableId === variableId && s.instance.id === openInstance.id;
const moveOptionsToStart = (arr, toStart) => [...toStart, ...arr.filter(a => !toStart.some(s => (s == null ? void 0 : s.value.id) === a.value.id))];
const translateInstanceOfSelection = (i, state, selection) => {
  if (!selection.instance.belongsToInstanceId) return null;
  const iSel = state.locked.selections.find(s => s.id === selection.instance.belongsToInstanceId);
  if (!iSel) return null;
  const possibleMatches = state.locked.selections.filter(s => s.variableId === iSel.variableId && s.valueId === iSel.valueId);
  const index = possibleMatches.findIndex(m => m.id === iSel.id);
  const value = i.values.byVarId.locked[iSel.variableId].find(v => v.id === iSel.valueId);
  const variable = i.variables.byVarId.locked[iSel.variableId];
  return {
    variable: variable.label,
    value: (value == null ? void 0 : value.label) || "",
    index: index
  };
};
const isNumberSelection = selection => selection.interval;
const translateSelection = (i, s, selection) => {
  var _selection$data$input, _selection$data, _i$values$byVarId$all, _i$values$byVarId$all2;
  const variable = i.variables.byVarId.all[selection.variableId];
  const to = getTemplateOptions(variable);
  const value = isNumberSelection(selection) ? `${((_selection$data$input = (_selection$data = selection.data) == null ? void 0 : _selection$data.inputValue) != null ? _selection$data$input : 0).toFixed(to.digits)} ${to.unit ? to.unit : ""}` : (_i$values$byVarId$all = (_i$values$byVarId$all2 = i.values.byVarId.all[selection.variableId].find(v => v.id === selection.valueId)) == null ? void 0 : _i$values$byVarId$all2.label) != null ? _i$values$byVarId$all : "";
  const instance = translateInstanceOfSelection(i, s, selection);
  return {
    value,
    variable: variable.label,
    instance: instance
  };
};
function isUUID(input) {
  return /\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b/.test(input);
}
const isVariableId = maybeId => Number.isInteger(parseInt(maybeId)) && !isUUID(maybeId);
const splitSelections = (i, selections) => {
  const [locked, free] = partition(selections, s => i.variables.byVarId.locked[s.variableId]);
  return {
    locked,
    free
  };
};
const sortSelectionsByVariableOrder = (i, selections) => selections.map(s => ({
  selection: s,
  variable: i.variables.byVarId.all[s.variableId]
})).sort((a, b) => a.variable.sort - b.variable.sort || (a.selection.sort || 0) - (b.selection.sort || 0)).map(s => s.selection);
const isSiblingInstance = curry((variableId, parentInstanceId, selection) => selection.variableId === variableId && selection.instance.belongsToInstanceId === parentInstanceId);
const getMaxInstanceSort = (variableId, parentInstanceId, selections) => Math.max(0, ...selections.filter(isSiblingInstance(variableId, parentInstanceId)).map(s => s.sort || 0));
function traverseVariableTree(variables, func) {
  const rootVariables = variables.filter(v => v.parentId === rootSelection.variableId);
  const variablesByParentId = groupBy(variables, v => v.parentId);
  let stack = [...rootVariables];
  while (stack.length > 0) {
    const currentVariable = stack.pop();
    const childVariables = variablesByParentId[currentVariable.id] || [];
    stack = func(currentVariable, childVariables, stack);
  }
}
const createVariableHierachyLevelMap = variables => {
  const map = {};
  const topLevel = rootSelection.instance.hierarchyLevel + 1;
  traverseVariableTree(variables, (variable, childVariables, stack) => {
    map[variable.id] = variable.parentId ? map[variable.parentId] + 1 : topLevel;
    return [...stack, ...childVariables];
  });
  return map;
};
const sortByHierachyLevel = (a, b) => a.instance.hierarchyLevel - b.instance.hierarchyLevel;
const filterAllSelectionsInHierarchy = (selections, selection) => {
  const instancesInLine = findAllInstancesInLine(selections, selection);
  const selectionsInHierarchy = selections.filter(s => instancesInLine.some(i => i.instance.id === s.instance.id));
  return selectionsInHierarchy;
};
const sortBySort = (a, b) => {
  var _a$sort, _b$sort;
  return ((_a$sort = a.sort) != null ? _a$sort : 0) - ((_b$sort = b.sort) != null ? _b$sort : 0);
};

const isAPartOfB = (a, b) => {
  if (!a || !b) return false;
  return (a.left > b.left || a.left === b.left && (b.leftInclude || !a.leftInclude)) && (a.right < b.right || a.right === b.right && (b.rightInclude || !a.rightInclude));
};

const K3ReduxContext = /*#__PURE__*/createContext({});
/** Dispatch hook bound to our redux store */
const useTypedDispatch = createDispatchHook(K3ReduxContext);
/** Selector hook bound to our redux store */
const useTypedSelector = createSelectorHook(K3ReduxContext);

const getInputValue$1 = selection => {
  var _selection$data;
  return toNumber((selection == null ? void 0 : (_selection$data = selection.data) == null ? void 0 : _selection$data.inputValue) || 0);
};
const findValue = (i, values) => values.find(v => isAPartOfB(discreteInterval(i), v.data));
const findClosestValue = (i, values, minimumDeviation) => {
  const value = findValue(i, values);
  return value ? {
    value,
    input: i
  } : closestValue(i, values, minimumDeviation);
};
const getNext = (i, step, direction) => i[`${direction}Include`] ? i[direction] : i[direction] + step * (direction === "left" ? 1 : -1);
const closestValue = (i, values, minimumDeviation) => {
  if (values.length === 0) return undefined;
  const firstGreaterIndex = values.findIndex(v => v.data.left >= i);
  if (firstGreaterIndex < 0) {
    const v = values[values.length - 1];
    return {
      value: v,
      input: getNext(v.data, minimumDeviation, "right")
    };
  } else if (firstGreaterIndex === 0) {
    const v = values[0];
    return {
      value: v,
      input: getNext(v.data, minimumDeviation, "left")
    };
  } else {
    const greater = values[firstGreaterIndex];
    const smaller = values[firstGreaterIndex - 1];
    const greaterInput = getNext(greater.data, minimumDeviation, "left");
    const smallerInput = getNext(greater.data, minimumDeviation, "right");
    if (Math.abs(i - greaterInput) < Math.abs(i - smallerInput)) {
      return {
        value: greater,
        input: greaterInput
      };
    } else {
      return {
        value: smaller,
        input: smallerInput
      };
    }
  }
};
const noReset = {
  resetNumber: undefined,
  isInRange: true
};
const useNumberVariableChangeHandler = (onChange, selection, variable, values) => {
  var _variable$settings2, _variable$settings2$t;
  const conflict = useTypedSelector(selectRuleEngineConflict);
  const round = n => {
    var _variable$settings, _variable$settings$te;
    const digits = Math.max((variable == null ? void 0 : (_variable$settings = variable.settings) == null ? void 0 : (_variable$settings$te = _variable$settings.templateOptions) == null ? void 0 : _variable$settings$te.digits) || 0, 0);
    return Number(Number(n).toFixed(clamp(digits, 0, 20)));
  };
  const [pureNumber, setPureNumber] = useState((variable == null ? void 0 : (_variable$settings2 = variable.settings) == null ? void 0 : (_variable$settings2$t = _variable$settings2.templateOptions) == null ? void 0 : _variable$settings2$t.min) || 0);
  const [resetData, setResetData] = useState(noReset);
  useEffect(() => {
    setPureNumber(round(getInputValue$1(selection)));
  }, [selection]);
  // This sets the pure number back to the current selection if we reject the conflict.
  // This is necessary, because normally, on a conflict rejection, we do not change the
  // current state at all. Which is why selection does not update and pureNumber
  // does not reset.
  useEffect(() => {
    if (!conflict) setPureNumber(round(getInputValue$1(selection)));
  }, [conflict, selection]);
  useEffect(() => {
    let timeout;
    if (!resetData.isInRange) {
      timeout = setTimeout(() => setResetData(noReset), 5000);
    }
    return () => {
      if (timeout) clearTimeout(timeout);
    };
  }, [resetData]);
  const handleImmediateChange = useCallback(
  // WHAT THE FUCK JS.
  // when used as onBlur function n is a number. onConfirm n is a string.
  n => {
    const number = +n;
    const match = findClosestValue(number, values, getMinimumDeviation(variable));
    if (!match) return;
    onChange(match.value.id, {
      inputValue: round(match.input)
    });
    if (+number !== +match.input) setResetData({
      isInRange: false,
      resetNumber: match.input
    });
  }, [onChange, values, variable]);
  return {
    onNumberChange: setPureNumber,
    onInputBlur: handleImmediateChange,
    onImmediateChange: handleImmediateChange,
    isInRange: resetData.isInRange,
    resetNumber: resetData.resetNumber,
    pureNumber
  };
};

/** Creates a new selection based on oldSelection,
 * changing only the value and debuggingValue */
const fillSelection = (i, value, oldSelection) => {
  return Object.assign({}, oldSelection, {
    valueId: value.id,
    debuggingValue: value.label,
    data: getNumericalData(i, value, oldSelection) || oldSelection.data,
    interval: value.data
  });
};
const getNumericalData = (i, value, oldSelection) => {
  var _oldSelection$data;
  if (!isInterval(value.data)) return oldSelection.data;
  const variable = i.variables.byVarId.all[oldSelection.variableId];
  const clamped = findClosestValue(((_oldSelection$data = oldSelection.data) == null ? void 0 : _oldSelection$data.inputValue) || 0, [value], getMinimumDeviation(variable));
  return {
    inputValue: clamped.input
  };
};
/** Calcs all selections that have to be filled for a specific instance */
const calcEmptySelectionsForInstance = (input, selectionMap, instances, currentInstance, scope) => {
  const freeSelections = [];
  // find all variables belonging to this instance
  const instanceVariables = input.variables.flat[scope].filter(v => {
    const isHidden = isHiddenByAction(input, v.id, currentInstance.id);
    const doesBelongToInstance = v.parentId === currentInstance.variableId || v.id === currentInstance.variableId;
    return !isHidden && doesBelongToInstance;
  });
  instanceVariables.forEach(v => {
    // can this variable launch other instances?
    const isMulti = isMultiVariable(v);
    const isItself = v.id === currentInstance.variableId;
    if (isMulti && !isItself) {
      // were there already any instances created by this variable?
      const instancesCreatedByThisVarAndInstance = instances.filter(i => i.variableId === v.id && i.instance.belongsToInstanceId === currentInstance.instance.id);
      // If so, calc if they are missing anything
      freeSelections.push(...instancesCreatedByThisVarAndInstance.flatMap(instance => calcEmptySelectionsForInstance(input, selectionMap, instances, instance, scope)));
    } else {
      var _selectionMap;
      // if not a multi we require a selection
      // is there already one?
      const selection = (_selectionMap = selectionMap[currentInstance.id || ""]) == null ? void 0 : _selectionMap.some(s => s.variableId === v.id);
      if (!selection && input.values.byVarId.all[v.id].length) {
        // if not, create it, linked to our instance
        const freeSelection = isItself ? currentInstance : createSelection(v, null, currentInstance.instance, false);
        freeSelections.push(freeSelection);
      }
    }
  });
  return freeSelections;
};
/** Calculates all empty selections */
const calcAllEmptySelections = (input, selections, instances, scope) => {
  const selectionsByInstance = selections.length ? groupBy(selections, s => {
    var _s$instance;
    return ((_s$instance = s.instance) == null ? void 0 : _s$instance.id) || "";
  }) : {
    "": []
  };
  // start calcing selections for the parent instance.
  // this automatically calcs for all other instances recursively
  return calcEmptySelectionsForInstance(input, selectionsByInstance, instances, rootSelection, scope);
};
const realDirectParent = selection => selection.instance.isInstanceLauncher ? selection.instance.belongsToInstanceId : selection.instance.id;

const isValueId = thing => {
  if (isArray$5(thing)) return false;
  const test = Number(thing);
  return !isNaN(test);
};
const isValueIdArray = thing => Array.isArray(thing);
const isIntervalRuleItemValue = thing => isRecord(thing) && "interval" in thing && "originalString" in thing;
const isNumberRuleValue = thing => (thing == null ? void 0 : thing.id) !== undefined;
const ActionIds = {
  SetArticle: "setArticle",
  SetInstance: "setInstance",
  SetColor: "setColorByVariable",
  SetImage2D: "setImage2D",
  SetLabel: "setLabel",
  SetMaterial: "setMaterial",
  SetMaterialTexture: "setMaterialTexture",
  SetModel: "setModel",
  SetConcealVariable: "setConcealVariable",
  SetConcealGroup: "setConcealGroup",
  SetHideVariable: "setHideVariable",
  SetHideGroup: "setHideGroup",
  SetHideValues: "setHideValues"
};
const isModelActionRuleValue = thing => (thing == null ? void 0 : thing.id) == ActionIds.SetModel && (thing == null ? void 0 : thing.modelId) !== undefined;
const isLabelActionRuleValue = thing => (thing == null ? void 0 : thing.id) == ActionIds.SetLabel && (thing == null ? void 0 : thing.label) !== undefined;
const isConcealGroupRuleValue = thing => (thing == null ? void 0 : thing.id) == ActionIds.SetConcealGroup;
const isConcealVariableRuleValue = thing => (thing == null ? void 0 : thing.id) == ActionIds.SetConcealVariable;
const isHideVariableRuleValue = thing => (thing == null ? void 0 : thing.id) == ActionIds.SetHideVariable;
const isHideGroupRuleValue = thing => (thing == null ? void 0 : thing.id) == ActionIds.SetHideGroup;
const isHideValuesRuleValue = thing => isRecord(thing) && thing.id === ActionIds.SetHideValues;
const isArticleActionRuleValue = thing => (thing == null ? void 0 : thing.id) === ActionIds.SetArticle && (thing == null ? void 0 : thing.articleId) !== undefined;
const isInstanceActionRuleValue = thing => (thing == null ? void 0 : thing.id) === ActionIds.SetInstance && (thing == null ? void 0 : thing.valueId) !== undefined;
const isColorActionRuleValue = thing => (thing == null ? void 0 : thing.id) === ActionIds.SetColor && (thing == null ? void 0 : thing.variableId) !== undefined;
const isMaterialActionRuleValue = thing => (thing == null ? void 0 : thing.id) === ActionIds.SetMaterial && (thing == null ? void 0 : thing.materialId) !== undefined;
const isImage2DActionRuleValue = thing => (thing == null ? void 0 : thing.id) === ActionIds.SetImage2D && (thing == null ? void 0 : thing.path) !== undefined;
const isImageActionRuleValue = thing => (thing == null ? void 0 : thing.id) === ActionIds.SetMaterialTexture && (thing == null ? void 0 : thing.variableId) !== undefined;
const isActionRuleItemValue = thing => isRecord(thing) && "id" in thing;
const isVariableIdRuleItemValue = thing => typeof thing === "number";
const isVariableIdsRuleItemValue = thing => isArray$5(thing);
const isValueReferencingRuleItemValue = thing => anyPass([isVariableIdRuleItemValue, isVariableIdsRuleItemValue])(thing);

const isSelectionValidForRuleItem = (ruleItem, selection) => {
  const keys = Object.keys(ruleItem.values);
  for (let i = 0; i < keys.length; i++) {
    const varId = keys[i];
    const value = ruleItem.values[varId];
    const result = ruleItemValueMatchesSelection(selection, varId, value);
    if (result) return true;
  }
  return false;
};
/** Calculates whether a new selection beeing added to already valid selections
 * is still a valid state or not. Very cheap due to these assumptions.
 * Returns the reasons why it might be invalid.
 * @param input
 * @param selectionsWithoutChange: Selections that a guaranteed to be correct
 * @param newSelection: The selection that might be wrong.
 * @param earlyAbort: Lets the function return early if not valid. Might not return all reasons
 */
const calcAreSelectionsStillValid = (input, selectionsWithoutChange, newSelection, earlyAbort) => {
  if (!selectionsWithoutChange.length) return [true, []];
  selectionsWithoutChange.sort(sortByHierachyLevel);
  // rules without any items are omitted
  const relevantRules = input.rules.filter(r => {
    var _input$ruleItems$byRu;
    return r.columns.some(c => c.targetId === newSelection.variableId) && ((_input$ruleItems$byRu = input.ruleItems.byRuleId[r.id]) == null ? void 0 : _input$ruleItems$byRu.length);
  });
  const withItems = relevantRules.map(r => ({
    rule: r,
    items: (input.ruleItems.byRuleId[r.id] || []).filter(ri => isSelectionValidForRuleItem(ri, newSelection))
  }));
  const otherVariables = uniq(withItems.flatMap(r => r.rule.columns.filter(c => c.type === "variable" && c.targetId !== newSelection.variableId).map(c => Number(c.targetId))));
  const instancesInLine = findAllInstancesInLine(selectionsWithoutChange, newSelection);
  const selectionsToCheck = selectionsWithoutChange.filter(s => otherVariables.includes(s.variableId) && instancesInLine.some(i => i.instance.id === s.instance.id));
  // checks if a rule items that fullfills the constraint exist.
  // This is necessary for rules with more then two columns when the
  // conflict is caused by a combination of variables
  const restrictedBy = [];
  for (const ruleWithItems of withItems) {
    const ruleItems = ruleWithItems.items;
    // If a rule has no matching items the newSelection is considered invalid
    const exists = ruleItems.some(ruleItemIsActive(otherVariables, selectionsToCheck));
    if (!exists) {
      // currently we mark the whole combination as invalid.
      // It would also be possible to only mark the most Restricting
      // selection as impossible:
      // Determine the most plausible reason for failure.
      // const [mostRestricting] = selectionsToCheck.reduce(
      //   (p, c) => {
      //     const count = relevantRuleItems.filter((ri) =>
      //       Object.values(ri.values).some((v) => v === c.valueId)
      //     ).length;
      //     return count < p[1] ? [c, count] : p;
      //   },
      //   [undefined, Infinity]
      // ) as [SelectionT, number];
      // restrictedBy.push(mostRestricting);
      const possiblyFaultySelections = selectionsToCheck.filter(s => ruleWithItems.rule.columns.some(c => c.targetId == s.variableId));
      restrictedBy.push(...possiblyFaultySelections);
      if (earlyAbort) break;
    }
  }
  return [!restrictedBy.length, uniqBy(restrictedBy, s => s.id).map(s => [newSelection, s])];
};
/** This is similar to ruleItemIsActive. However, ruleItemIsActive is more
 * performant and thus kept as it is. */
const ruleItemValueMatchesSelection = (selection, varId, val) => {
  if (selection.variableId != varId) return false;
  if (val === true) return true;
  if (isIntervalRuleItemValue(val) && isNumberSelection(selection)) return isAPartOfB(selection.interval, val.interval);
  try {
    return val.includes(selection.valueId);
  } catch (e) {
    console.error("Failed to compare selection & value", e, selection, val);
    return false;
  }
};
/** A rule items is active if for every value:
 * Its variable should not be considered OR
 * There is no relevant selection that matches the variable OR
 * There is a relevant selection that matches the valueId.
 */
const ruleItemIsActive = (otherVariables, selectionsToCheck) => ri => Object.keys(ri.values).every(key => {
  const v = +key;
  const val = ri.values[v];
  // Variable is always valid (*/Alle Werte)
  if (val === true) return true;
  // Variable should not be considered
  if (!otherVariables.includes(v)) return true;
  const relevantSelections = selectionsToCheck.filter(s => s.variableId === v);
  // There is no selection, where the variableId matches
  if (!relevantSelections.length) return true;
  if (isIntervalRuleItemValue(val)) {
    // for numbers check if there is a selection in interval
    return relevantSelections.some(s => isAPartOfB(s.interval, val.interval));
  } else {
    // for normal vars check if there is a selection with the correc valueId
    return relevantSelections.some(s => val.some(v => s.valueId === v));
  }
});
/** Calculates if selections are valid
 * @param input
 * @param guaranteedCorrectSelections: Selections that are guaranteed correct and will not be checked.
 * @param possibleFaultySelections: Selections that should be checked for conflicts.
 */
const calcAreSelectionsValid = (input, guaranteedCorrectSelections, possibleFaultySelections) => {
  guaranteedCorrectSelections.sort(sortByHierachyLevel);
  possibleFaultySelections.sort(sortByHierachyLevel);
  for (let s = 0; s < possibleFaultySelections.length; s++) {
    const check = s === 0 ? [] : possibleFaultySelections.slice(0, s);
    const [valid, reasons] = calcAreSelectionsStillValid(input, [...guaranteedCorrectSelections, ...check], possibleFaultySelections[s], false);
    if (!valid) return [valid, reasons];
  }
  return [true, []];
};
/** Calculates any conflict for the instance.
 * When we call this, we already know it is invalid, we just need some kind of conflict
 * to show to the user.
 * */
const calcFirstConflictForInstance = (input, guaranteedCorrectSelections, instance) => {
  // try to add the instance itself first, check if there are any conflicts
  const instanceResponse = calcAreSelectionsStillValid(input, guaranteedCorrectSelections, instance, false);
  if (!instanceResponse[0]) return instanceResponse;
  const selections = [instance, ...guaranteedCorrectSelections];
  const instances = calcInstances(selections);
  const empty = calcAllEmptySelections(input, selections, instances, "locked");
  const filled = empty.map(s =>
  // [0] is totally fine, because we know there is no valid combination.
  // We just need to find a reason for it, which we will get if we stupidly
  // take the first one.
  fillSelection(input, input.values.byVarId.locked[s.variableId][0], s));
  return calcAreSelectionsValid(input, selections, filled);
};
/** READ CAREFUL: Used to determine the invalid Icon
 *
 * Determines whether there is a conflict between the invalid option and
 * every of the relevant touched selections **on its own**. If this is the case
 * we will return only the direct conflicts.
 *
 * If not, we consider the touched as a group and search for a conflict there.
 * If we find one, we return it.
 *
 * If not, and this is important to understand: We do not display a warning icon.
 *
 * **However**, it is still possible that there is a hidden, touched conflict,
 * which pops open on click. This will be due to implicit connections
 * (rule: engine-> model and model-> velocity instead of engine->model->velocity)
 *
 * Because figuring them out is really expensive, we avoid this here and risk
 * not showing an invalid icon
 */
const getTouchedConflicts = (invalidOption, touched, input, value, instance) => {
  const selection = createSelection(value.variableId, value, instance.instance, false);
  const touchedConflicts = touched.filter(t => {
    return !calcAreSelectionsValid(input, [selection], [t])[0];
  });
  if (touchedConflicts.length) {
    return {
      value: invalidOption.value,
      conflicts: touchedConflicts
    };
  }
  return !calcAreSelectionsValid(input, [selection], touched)[0] ? {
    value: invalidOption.value,
    conflicts: touched
  } : undefined;
};

const emptySelections = [];
const emptyTranslatedVariables = [];
const emptyOptions = {};
const emptyTouched$1 = {};
const selectRuleEngineInput = state => state.ruleEngine.ruleEngineInput;
const selectRuleEngineState = state => state.ruleEngine.ruleEngineState;
const selectRuleEngineConflict = state => state.ruleEngine.ruleEngineConflict;
const selectAllSelections = state => {
  var _selectRuleEngineStat, _selectRuleEngineStat2, _selectRuleEngineStat3, _selectRuleEngineStat4;
  return (_selectRuleEngineStat = (_selectRuleEngineStat2 = selectRuleEngineState(state)) == null ? void 0 : (_selectRuleEngineStat3 = _selectRuleEngineStat2.state) == null ? void 0 : (_selectRuleEngineStat4 = _selectRuleEngineStat3.all) == null ? void 0 : _selectRuleEngineStat4.selections) != null ? _selectRuleEngineStat : emptySelections;
};
const selectOpenInstance = state => state.ruleEngine.openInstance;
const selectRuleEngineInfo = state => ({
  ruleEngineInput: selectRuleEngineInput(state),
  ruleEngineState: selectRuleEngineState(state),
  openInstance: selectOpenInstance(state)
});
const selectSelectionById = selectionId => state => selectAllSelections(state).find(s => s.id === selectionId);
const selectValidOptions = state => {
  var _selectRuleEngineStat5, _selectRuleEngineStat6, _selectRuleEngineStat7, _selectRuleEngineStat8;
  return (_selectRuleEngineStat5 = (_selectRuleEngineStat6 = selectRuleEngineState(state)) == null ? void 0 : (_selectRuleEngineStat7 = _selectRuleEngineStat6.state) == null ? void 0 : (_selectRuleEngineStat8 = _selectRuleEngineStat7.all) == null ? void 0 : _selectRuleEngineStat8.validOptions) != null ? _selectRuleEngineStat5 : emptyOptions;
};
const selectInvalidOptions = state => {
  var _selectRuleEngineStat9, _selectRuleEngineStat10, _selectRuleEngineStat11, _selectRuleEngineStat12;
  return (_selectRuleEngineStat9 = (_selectRuleEngineStat10 = selectRuleEngineState(state)) == null ? void 0 : (_selectRuleEngineStat11 = _selectRuleEngineStat10.state) == null ? void 0 : (_selectRuleEngineStat12 = _selectRuleEngineStat11.all) == null ? void 0 : _selectRuleEngineStat12.invalidOptions) != null ? _selectRuleEngineStat9 : emptyOptions;
};
const selectTouchedByUser = state => {
  var _selectRuleEngineStat13, _selectRuleEngineStat14, _selectRuleEngineStat15, _selectRuleEngineStat16;
  return (_selectRuleEngineStat13 = (_selectRuleEngineStat14 = selectRuleEngineState(state)) == null ? void 0 : (_selectRuleEngineStat15 = _selectRuleEngineStat14.state) == null ? void 0 : (_selectRuleEngineStat16 = _selectRuleEngineStat15.all) == null ? void 0 : _selectRuleEngineStat16.touched) != null ? _selectRuleEngineStat13 : emptyTouched$1;
};
const selectHasUserTouchedVariable = variableId => state => {
  var _selectTouchedByUser$;
  return (_selectTouchedByUser$ = selectTouchedByUser(state)[selectOpenInstance(state).id]) == null ? void 0 : _selectTouchedByUser$.includes(variableId);
};
const selectValidValuesByVarIdOfInstance = variableId => state => {
  var _selectValidOptions$s, _selectValidOptions$s2;
  return ((_selectValidOptions$s = selectValidOptions(state)[selectOpenInstance(state).id]) == null ? void 0 : (_selectValidOptions$s2 = _selectValidOptions$s[variableId]) == null ? void 0 : _selectValidOptions$s2.map(v => v.value)) || [];
};
const selectInvalidValueForInstance = value => state => {
  var _selectInvalidOptions, _selectInvalidOptions2;
  return (_selectInvalidOptions = selectInvalidOptions(state)[selectOpenInstance(state).id]) == null ? void 0 : (_selectInvalidOptions2 = _selectInvalidOptions[value.variableId]) == null ? void 0 : _selectInvalidOptions2.find(v => v.value.id === value.id);
};
const selectReValueById = valueId => state => {
  var _selectRuleEngineInpu, _selectRuleEngineInpu2, _selectRuleEngineInpu3, _selectRuleEngineInpu4;
  return ((_selectRuleEngineInpu = (_selectRuleEngineInpu2 = selectRuleEngineInput(state)) == null ? void 0 : (_selectRuleEngineInpu3 = _selectRuleEngineInpu2.values) == null ? void 0 : (_selectRuleEngineInpu4 = _selectRuleEngineInpu3.flat) == null ? void 0 : _selectRuleEngineInpu4.all) != null ? _selectRuleEngineInpu : []).find(v => v.id === valueId);
};
const selectTouchedInvalidSelection = valueId => state => {
  const value = selectReValueById(valueId)(state);
  if (!value) return;
  const invalidOption = selectInvalidValueForInstance(value)(state);
  if (!invalidOption) return invalidOption;
  const touched = invalidOption.conflicts.filter(conflict => selectHasUserTouchedVariable(conflict.variableId)(state));
  const ruleEngineInput = selectRuleEngineInput(state);
  if (!ruleEngineInput) {
    return undefined;
  }
  const instance = selectOpenInstance(state);
  return getTouchedConflicts(invalidOption, touched, ruleEngineInput, value, instance);
};
const selectTranslatedSelections = selections => state => {
  const ruleEngineInput = selectRuleEngineInput(state);
  const ruleEngineState = selectRuleEngineState(state);
  if (!ruleEngineInput || !ruleEngineState) {
    return emptyTranslatedVariables;
  }
  return selections.map(sel => translateSelection(ruleEngineInput, ruleEngineState.state, sel));
};
const selectRuleEngineError = state => state.ruleEngine.ruleEngineError;

const selectVariables = state => state.metadata.variables;
const selectVariablesByIdMap = createSelector(selectVariables, variables => indexById(variables));
const selectVariableById = variableId => state => selectVariables(state).find(v => v.id == variableId);
const selectVariableByKey = variableKey => state => selectVariables(state).find(v => v.key === variableKey);
const selectVariablesByIds = variableIds => state => {
  const variablesById = indexById(selectVariables(state));
  return compact(variableIds == null ? void 0 : variableIds.map(id => variablesById[id]));
};
const selectVariablesByType = variableType => state => {
  return selectVariables(state).filter(v => v.type === variableType);
};
const selectVariablesByAppId = appId => state => selectVariables(state).filter(variable => variable.appId == appId);
const selectComponentVariables = state => {
  const variables = selectVariables(state);
  return variables.filter(variable => variable.type === "components");
};
const hasComponentVariables = state => {
  return selectComponentVariables(state).length > 0;
};
const selectIsVariableHiddenBecause = variable => state => {
  var _selectRuleEngineStat, _selectOpenInstance;
  const ruleEngineInput = selectRuleEngineInput(state);
  const scopedRuleEngineState = (_selectRuleEngineStat = selectRuleEngineState(state)) == null ? void 0 : _selectRuleEngineStat.state;
  if (!ruleEngineInput || !scopedRuleEngineState) {
    console.warn("Rule engine not initialized!");
    return null;
  }
  return isHiddenBecause(variable, ruleEngineInput, scopedRuleEngineState, (_selectOpenInstance = selectOpenInstance(state)) == null ? void 0 : _selectOpenInstance.id);
};
const selectIsSelectionDisplayedInSummaries = (variable, selection) => state => {
  var _selectRuleEngineStat2;
  const ruleEngineInput = selectRuleEngineInput(state);
  const scopedRuleEngineState = (_selectRuleEngineStat2 = selectRuleEngineState(state)) == null ? void 0 : _selectRuleEngineStat2.state;
  if (!ruleEngineInput || !scopedRuleEngineState) {
    console.warn("Rule engine not initialized!");
    return null;
  }
  return shouldSelectionBeDisplayedInSummaries(variable, ruleEngineInput, scopedRuleEngineState, selection);
};
const selectVariableByAttribute = attribute => state => selectVariables(state).find(v => {
  var _v$attrs;
  return (_v$attrs = v.attrs) == null ? void 0 : _v$attrs.some(attr => attr.id === attribute.id);
});

const getAppCodeFromQuery = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get("app");
};
const getDealerCodeFromQuery = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get("dealer");
};
const isCustomDomain = () => {
  const origin = window.location.origin;
  const originalUrl = env.originalDomain;
  return !(origin.includes("localhost") || originalUrl && origin.includes(originalUrl));
};
const getAppCode = () => {
  if (isCustomDomain()) return window.location.host;
  return getAppCodeFromQuery();
};
const getCfgCode = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get("code");
};
const getStartInstanceKey = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get("part");
};
const useStartInstance = () => {
  const startInstance = getStartInstanceKey();
  const rootVariable = useTypedSelector(selectVariableByKey(startInstance));
  return startInstance && (rootVariable == null ? void 0 : rootVariable.type) === "components" ? rootVariable : undefined;
};
const LANGUAGEDEFAULT = "de";
const getPreferredContentLanguage = configuration => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const queryParamLang = urlParams.get("lang");
  if (queryParamLang) return queryParamLang;
  if (configuration != null && configuration.lang) return configuration.lang;
  let shortLang = window.navigator.languages && window.navigator.language.length ? window.navigator.languages[0] : window.navigator.language;
  if (shortLang.includes("-")) shortLang = shortLang.split("-")[0];
  if (shortLang.includes("_")) shortLang = shortLang.split("_")[0];
  return shortLang || LANGUAGEDEFAULT;
};
const setConfigurationCode = code => {
  const url = new URL(window.location.href);
  url.searchParams.set("code", code);
  window.history.pushState({}, "", url.toString());
};
const getAutostartAR = () => {
  const url = new URL(window.location.href);
  return url.searchParams.get("autostartAR");
};
const removeAutostartAR = () => {
  const url = new URL(window.location.href);
  url.searchParams.delete("autostartAR");
  window.history.pushState({}, "", url.toString());
};

const safeGetLocalStorage = key => {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    return null;
  }
};

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var id = 0;
function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}
function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}

var _result = /*#__PURE__*/_classPrivateFieldLooseKey("result");
class ApiError extends Error {
  constructor(msg, result) {
    super(msg);
    Object.defineProperty(this, _result, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldLooseBase(this, _result)[_result] = result;
  }
  get result() {
    return _classPrivateFieldLooseBase(this, _result)[_result];
  }
}

function isEntity(value) {
  return overEvery([has$1("id")])(value);
}

function isUser(value) {
  return overEvery([isEntity, has$1("email"), has$1("name"), has$1("role")])(value);
}

function _tokenKey() {
  return env.apiUrl + "$token";
}
function getUserToken() {
  return safeGetLocalStorage(_tokenKey());
}
function setUserToken(token) {
  localStorage.setItem(_tokenKey(), token);
}
function removeUserToken() {
  localStorage.removeItem(_tokenKey());
}
function hasRememberedToken() {
  return getUserToken() != null;
}
async function api_configuredFetch(method, url, headers = {}, body = null) {
  const config = {
    method,
    mode: "cors",
    cache: "no-cache",
    credentials: "same-origin",
    headers,
    redirect: "follow",
    referrerPolicy: "no-referrer"
  };
  if (body) config.body = body;
  return await fetch(url, config);
}
async function api_fetchRaw(method, url, body = null, headers = {}) {
  const apiUrl = env.apiUrl + "/api/v1.0" + url;
  const token = getUserToken();
  // If there is no token it typically means that we are in the frontend.
  // The only request made here is the save configuration request which does not
  // need a token. We just omit it here.
  if (token) headers["Authorization"] = "Bearer " + token;
  return await api_configuredFetch(method, apiUrl, headers, body);
}
// FIXME: response.json() is type any... error handling?
async function api_fetch(method, url, body = null, headers = {}) {
  const response = await api_fetchRaw(method, url, body, headers);
  const json = await response.json();
  if (!response.ok) {
    throw new ApiError(`Response-Error: Status ${response.status}. Message: ${JSON.stringify(json)}`, json);
  }
  return json;
}
async function api_request(method, url, body = null, {
  lang = ""
} = {}) {
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json"
  };
  if (lang) headers["X-language"] = lang;
  if (body) body = JSON.stringify(body);
  return api_fetch(method, url, body, headers);
}
async function api_login({
  email,
  password
}) {
  const maybeUser = await api_request("POST", "/login", {
    email,
    password
  });
  if (!isUser(maybeUser)) {
    throw maybeUser;
  }
  const user = maybeUser;
  setUserToken(user.token);
  return user;
}
async function api_logout() {
  await api_request("GET", "/logout");
  removeUserToken();
}
async function api_getDocs(url) {
  const headers = {
    Accept: "application/json"
  };
  const response = await api_configuredFetch("GET", env.docUrl + url, headers);
  return await response.json();
}

var Mandant$3 = "Mandant";
var Produkt$3 = "Produkt";
var Bezahlzustand$3 = "Bezahlzustand";
var Addon$3 = "Addon";
var apps$3 = "Konfiguratoren";
var support$3 = "Support";
var dealers$3 = "Händler";
var users$3 = "Benutzer";
var trash$3 = "Papierkorb";
var others$3 = "Andere";
var links$3 = "Links";
var help$3 = "Hilfe";
var consultation$3 = "Beratung";
var status$3 = "Status";
var subscription$3 = "Abonnement";
var profile$3 = "Profil";
var logout$3 = "Logout";
var Template$3 = "Template";
var Aufrufen$3 = "Aufrufen";
var PDF$3 = "PDF";
var Code$3 = "Code";
var Preis$3 = "Preis";
var Inspiration$3 = "Inspiration";
var Anzeige$3 = "Anzeige";
var Bild$3 = "Bild";
var Sortierung$3 = "Sortierung";
var Kunde$3 = "Kunde";
var Inhalt$3 = "Inhalt";
var Konfiguratorversion$3 = "Konfiguratorversion";
var Abbrechen$3 = "Abbrechen";
var Speichern$3 = "Speichern";
var Schliessen$3 = "Schliessen";
var Adresse$3 = "Adresse";
var Datenschutz$3 = "Datenschutz";
var Name$3 = "Name";
var Email$3 = "Email";
var Telefon$3 = "Telefon";
var Bemerkung$3 = "Bemerkung";
var Firma$3 = "Firma";
var Akzeptiert$3 = "Akzeptiert";
var Stadt$3 = "Stadt";
var PLZ$3 = "PLZ";
var Datum$3 = "Datum";
var dealer$3 = "Händler";
var json$3 = "json";
var Price$4 = "Price";
var options$3 = "Optionen";
var Bestellaktion$3 = "Bestellaktion";
var Typ$3 = "Typ";
var Konfiguration$3 = "Konfiguration";
var AR$3 = "AR";
var Geteilt$3 = "Geteilt";
var anzeigen$3 = "anzeigen";
var Artikelnummer$3 = "Artikelnummer";
var Beschreibung$3 = "Beschreibung";
var Kategorie$3 = "Kategorie";
var Preise$3 = "Preise";
var Importieren$3 = "Importieren";
var Upload$3 = "Upload";
var Keine$3 = "Keine";
var Alle$3 = "Alle";
var Bilder$3 = "Bilder";
var Seite$3 = "Seite";
var Vorderseite$3 = "Vorderseite";
var Hinterseite$3 = "Hinterseite";
var Beidseitig$3 = "Beidseitig";
var Optionen$3 = "Optionen";
var Bezeichnung$3 = "Bezeichnung";
var Pbr$3 = "Pbr";
var Physikalisch$3 = "Physikalisch";
var Key$3 = "Key";
var Model$3 = "Model";
var Erweitert$3 = "Erweitert";
var Editieren$3 = "Editieren";
var Kopieren$3 = "Kopieren";
var Allgemein$3 = "Allgemein";
var Sprachen$3 = "Sprachen";
var Produktdarstellung$3 = "Produktdarstellung";
var Upgrade$3 = "Upgrade";
var Hauptmodell$3 = "Hauptmodell";
var Vorlage$3 = "Vorlage";
var Tutorial$3 = "Tutorial";
var Export$3 = "Export";
var discount$3 = "Abschlag";
var surcharge$3 = "Aufschlag";
var Einbetten$3 = "Einbetten";
var Referenzsprache$3 = "Referenzsprache";
var Artikel$3 = "Artikel";
var Schriftart$3 = "Schriftart";
var Helvetica$3 = "Helvetica";
var Courier$3 = "Courier";
var Interstate$3 = "Interstate";
var Montserrat$3 = "Montserrat";
var Links$3 = "Links";
var Rechts$3 = "Rechts";
var Oben$3 = "Oben";
var Unten$3 = "Unten";
var Kopfzeile$3 = "Kopfzeile";
var Mail$3 = "Mail";
var Shop$3 = "Shop";
var Senden$3 = "Senden";
var orders$3 = "Bestellungen";
var Tage$3 = "Tage";
var date$3 = "Datum";
var number$3 = "Zahl";
var articlename$3 = "Artikel Name";
var articles$3 = "Artikel";
var Bezahlt$3 = "Bezahlt";
var Wechseln$3 = "Wechseln";
var Anlegen$3 = "Anlegen";
var Neu$3 = "Neu";
var Konfiguratoren$4 = "Konfiguratoren";
var Benutzer$7 = "Benutzer";
var Rolle$3 = "Rolle";
var name$3 = "Name";
var email$3 = "E-Mail";
var Nutzerkonto$3 = "Nutzerkonto";
var Nutzername$3 = "Nutzername";
var create$4 = "Anlegen";
var save$3 = "Speichern";
var Password$3 = "Kennwort";
var Login$3 = "Anmelden";
var Registrierung$3 = "Registrierung";
var Datenschutzbestimmungen$3 = "Datenschutzbestimmungen";
var AGB$3 = "AGB";
var Passwort$3 = "Passwort";
var Mandantentabelle$3 = "Mandantentabelle";
var Startdatum$3 = "Startdatum";
var Enddatum$3 = "Enddatum";
var Konfigurator$3 = "Konfigurator";
var Merkmal$3 = "Merkmal";
var Regel$3 = "Regel";
var Nummer$3 = "Nummer";
var Erstellt$3 = "Erstellt";
var Kennwort$3 = "Kennwort";
var Sprache$3 = "Sprache";
var Download$3 = "Download";
var Hintergrundmodell$3 = "Hintergrundmodell";
var Preiseinstellungen$3 = "Preiseinstellungen";
var Standard$3 = "Standard";
var Hauptaktion$3 = "Hauptaktion";
var Kontaktformular$3 = "Kontaktformular";
var Pflichtfeld$3 = "Pflichtfeld";
var Aktionsname$3 = "Aktionsname";
var Anzahl$3 = "Anzahl";
var Zahl$3 = "Zahl";
var Einheit$3 = "Einheit";
var Aktionen$3 = "Aktionen";
var Kameras$3 = "Kameras";
var Kamera$3 = "Kamera";
var Reiter$3 = "Reiter";
var Kameraansicht$3 = "Kameraansicht";
var Ok$3 = "Ok";
var Fertig$3 = "Fertig";
var Auswahlen$3 = "Auswahlen";
var Positionspreis$3 = "Positionspreis";
var Gesamtpreis$3 = "Gesamtpreis";
var Kostenfrei$3 = "Kostenfrei";
var Downgrade$3 = "Downgrade";
var Home$3 = "Home";
var Hilfe$7 = "Hilfe";
var cancel$3 = "Abbrechen";
var Icon$3 = "Icon";
var Gruppen$3 = "Gruppen";
var Logo$4 = "Logo";
var Farben$3 = "Farben";
var CSS$3 = "CSS";
var Variablen$3 = "Variablen";
var Einstellungen$3 = "Einstellungen";
var Vorschau$3 = "Vorschau";
var Editor$3 = "Editor";
var Regeln$3 = "Regeln";
var Articles$3 = "Artikel";
var Modelle$3 = "Modelle";
var Materialien$3 = "Materialien";
var Bestellungen$3 = "Bestellungen";
var Fatal_Error_Text$3 = "Leider ist ein unbekannter Fehler aufgetreten. Falls sich das Problem mit einem Neuladen der Seite nicht beheben lässt, kontaktieren Sie uns bitte.";
var Fatal_Error$3 = "Unbekannter Fehler";
var Error_Message$3 = "Fehlernachricht:";
var Abschnitt$3 = "Abschnitt";
var Bestelloptionen$3 = "Bestelloptionen";
var hiddenGroup$3 = "Diese Gruppe ist aktuell nur im Admin-Panel sichtbar, da sie keine Merkmale mit wählbaren Optionen enthält.";
var Bearbeiten$3 = "Bearbeiten";
var Leer$3 = "Leer";
var Basiseinstellungen$3 = "Basiseinstellungen";
var Deckkraft$3 = "Deckkraft";
var Anwenden$3 = "Anwenden";
var Auswahl$3 = "Auswahl";
var Duplizieren$3 = "Duplizieren";
var Ersetzen$3 = "Ersetzen";
var Statistics$3 = "Statistics";
var Konfigurationen$3 = "Konfigurationen";
var articleNo$3 = "Artikelnummer";
var articleName$3 = "Name";
var price$3 = "Preis";
var currency$3 = "Währung";
var Cancel$3 = "Cancel";
var Save$3 = "Save";
var Startanzahl$3 = "Startanzahl";
var Endanzahl$3 = "Endanzahl";
var Suchen$3 = "Suchen";
var Ctrl$3 = "STRG";
var Hervorhebung$3 = "Hervorhebung";
var Expression$3 = "Expression";
var Ergebnis$3 = "Ergebnis";
var Mindestwert$3 = "Mindestwert";
var Maximalwert$3 = "Maximalwert";
var Nachkommastellen$3 = "Nachkommastellen";
var Schrittweite$3 = "Schrittweite";
var Berechnet$3 = "Berechnet";
var Wert$3 = "Wert";
var Farbauswahl$3 = "Farbauswahl";
var Komponente$3 = "Komponente";
var Komponentenliste$3 = "Komponentenliste";
var Bildauswahl$3 = "Bildauswahl";
var Zahleneingabe$3 = "Zahleneingabe";
var Dropdown$3 = "Dropdown";
var Schalter$3 = "Schalter";
var Texteingabe$3 = "Texteingabe";
var Beispieltext$3 = "Beispieltext";
var Optional$3 = "Optional";
var Versteckt$3 = "Versteckt";
var Position$3 = "Position";
var Scale$3 = "Scale";
var Modell$3 = "Modell";
var Material$3 = "Material";
var Komponenten$3 = "Komponenten";
var Druck$3 = "Druck";
var Farbe$3 = "Farbe";
var Regelname$3 = "Regelname";
var Produktstruktur$3 = "Produktstruktur";
var Materialnamen$3 = "Materialnamen";
var Merkmalskombinationen$3 = "Merkmalskombinationen";
var Merkmale$3 = "Merkmale";
var Erstellen$3 = "Erstellen";
var Komponentenmerkmale$3 = "Komponentenmerkmale";
var Herunterladen$3 = "Herunterladen";
var Verbinden$3 = "Verbinden";
var Templatname$3 = "Templatname";
var Farbwert$3 = "Farbwert";
var Ansicht$3 = "Ansicht";
var URL$4 = "URL";
var Auswahlwerte$3 = "Auswahlwerte";
var Abmessungen$3 = "Abmessungen";
var Breite$3 = "Breite";
var Tiefe$3 = "Tiefe";
var Startpunkt$3 = "Startpunkt";
var Endpunkt$3 = "Endpunkt";
var Text$4 = "Text";
var Offsets$3 = "Offsets";
var Edit$3 = "Edit";
var deTranslation = {
	"Sie zahlen nicht online. Bitte wenden Sie sich an den Mitarbeiter in Ihrem Unternehmen, der den Vertrag mit ObjectCode geschlossen hat.": "Sie zahlen nicht online. Bitte wenden Sie sich an den Mitarbeiter in Ihrem Unternehmen, der den Vertrag mit ObjectCode geschlossen hat.",
	Mandant: Mandant$3,
	Produkt: Produkt$3,
	Bezahlzustand: Bezahlzustand$3,
	"Gültig von": "Gültig von",
	"Nicht angegeben": "Nicht angegeben",
	"Gültig bis": "Gültig bis",
	Addon: Addon$3,
	apps: apps$3,
	support: support$3,
	"dealer-profile": "Händlerprofil",
	dealers: dealers$3,
	users: users$3,
	trash: trash$3,
	others: others$3,
	links: links$3,
	help: help$3,
	consultation: consultation$3,
	status: status$3,
	subscription: subscription$3,
	profile: profile$3,
	logout: logout$3,
	"Neuer Konfigurator": "Neuer Konfigurator",
	Template: Template$3,
	"Zurück": "Zurück",
	Aufrufen: Aufrufen$3,
	PDF: PDF$3,
	Code: Code$3,
	Preis: Preis$3,
	Inspiration: Inspiration$3,
	Anzeige: Anzeige$3,
	Bild: Bild$3,
	Sortierung: Sortierung$3,
	"Sie möchten die Daten dieses Kunden einsehen?": "Sie möchten die Daten dieses Kunden einsehen?",
	Kunde: Kunde$3,
	Inhalt: Inhalt$3,
	"Shop-API": "Shop-API",
	"Gespeichert am": "Gespeichert am",
	Konfiguratorversion: Konfiguratorversion$3,
	Abbrechen: Abbrechen$3,
	Speichern: Speichern$3,
	"Ergebnis der Shop API": "Ergebnis der Shop API",
	Schliessen: Schliessen$3,
	Adresse: Adresse$3,
	Datenschutz: Datenschutz$3,
	Name: Name$3,
	Email: Email$3,
	Telefon: Telefon$3,
	Bemerkung: Bemerkung$3,
	Firma: Firma$3,
	"Steuer-ID": "Steuer-ID",
	Akzeptiert: Akzeptiert$3,
	Stadt: Stadt$3,
	PLZ: PLZ$3,
	Datum: Datum$3,
	"exit-action": "Bestellaktion",
	dealer: dealer$3,
	"order-status": "Status",
	json: json$3,
	Price: Price$4,
	options: options$3,
	Bestellaktion: Bestellaktion$3,
	Typ: Typ$3,
	Konfiguration: Konfiguration$3,
	AR: AR$3,
	Geteilt: Geteilt$3,
	"Sie möchten die Daten Ihrer Kunden einsehen?": "Sie möchten die Daten Ihrer Kunden einsehen?",
	"Preise anlegen": "Preise anlegen",
	anzeigen: anzeigen$3,
	Artikelnummer: Artikelnummer$3,
	"Artikelnummer eingeben": "Artikelnummer eingeben",
	"Namen eingeben": "Namen eingeben",
	Beschreibung: Beschreibung$3,
	"Beschreibung eingeben": "Beschreibung eingeben",
	Kategorie: Kategorie$3,
	"Kategorien eingeben": "Kategorien eingeben",
	Preise: Preise$3,
	"Sie möchten Preise anzeigen?": "Sie möchten Preise anzeigen?",
	Importieren: Importieren$3,
	"Artikel und Preise veröffentlichen": "Artikel und Preise veröffentlichen",
	"Neuer Artikel": "Neuer Artikel",
	Upload: Upload$3,
	"Laden Sie ein oder mehrere Bilder in den angegeben Ordner hoch. Die können den Schrägstrich (/) verwenden, um tiefere Ordner zu erzeugen.": "Laden Sie ein oder mehrere Bilder in den angegeben Ordner hoch. Die können den Schrägstrich (/) verwenden, um tiefere Ordner zu erzeugen.",
	"Alternativ können Sie ein ZIP-Archiv mit einer Ordnerstruktur hochladen.": "Alternativ können Sie ein ZIP-Archiv mit einer Ordnerstruktur hochladen.",
	"Ordner *": "Ordner *",
	"Beachten Sie: Alle Bilder in einem Ordner werden als Galerie gruppiert, nach Name sortiert. Verwenden Sie also Dateinamen wie \"Bild_001\".": "Beachten Sie: Alle Bilder in einem Ordner werden als Galerie gruppiert, nach Name sortiert. Verwenden Sie also Dateinamen wie \"Bild_001\".",
	Keine: Keine$3,
	Alle: Alle$3,
	"Löschen": "Löschen",
	Bilder: Bilder$3,
	Seite: Seite$3,
	Vorderseite: Vorderseite$3,
	Hinterseite: Hinterseite$3,
	Beidseitig: Beidseitig$3,
	"new-material": "Neues Material",
	Optionen: Optionen$3,
	Bezeichnung: Bezeichnung$3,
	Pbr: Pbr$3,
	Physikalisch: Physikalisch$3,
	Key: Key$3,
	"AR Fallback Material": "AR Fallback Material",
	"Nicht ausgewählt": "Nicht ausgewählt",
	Model: Model$3,
	Erweitert: Erweitert$3,
	"Nur in Regeln verwendete Materialien anzeigen": "Nur in Regeln verwendete Materialien anzeigen",
	"extract-materials": "Materialien aus Modell extrahieren",
	Editieren: Editieren$3,
	Kopieren: Kopieren$3,
	"Neues Modell": "Neues Modell",
	"Dynamisches Modell": "Dynamisches Modell",
	"Gültigkeit": "Gültigkeit",
	"Neue Regel": "Neue Regel",
	"Neue Regel Erstellen": "Neue Regel Erstellen",
	"Regel erstellen": "Regel erstellen",
	Allgemein: Allgemein$3,
	Sprachen: Sprachen$3,
	"Die erste Sprache gilt als Standard.": "Die erste Sprache gilt als Standard.",
	"Die Beschreibung dieses Konfigurators": "Die Beschreibung dieses Konfigurators",
	"Link zum Konfigurator": "Link zum Konfigurator",
	"Falls Sie eine Erweiertung nutzen, tragen Sie hier ein, wo Ihr Entwickler sie zur Verfügung stellt.": "Falls Sie eine Erweiertung nutzen, tragen Sie hier ein, wo Ihr Entwickler sie zur Verfügung stellt.",
	Produktdarstellung: Produktdarstellung$3,
	"3D-Modell": "3D-Modell",
	"Bilder-Konfigurator": "Bilder-Konfigurator",
	"Google Analytics 4 Property ID": "Google Analytics 4 Property ID",
	"Sie müssen für den Google Cookie die Einverständnis des Nutzers einholen. Das passiert nicht innerhalb des K3!": "Sie müssen für den Google Cookie die Einverständnis des Nutzers einholen. Das passiert nicht innerhalb des K3!",
	"Sie möchten Ihr Analytics-Konto verbinden?": "Sie möchten Ihr Analytics-Konto verbinden?",
	Upgrade: Upgrade$3,
	Hauptmodell: Hauptmodell$3,
	"Hauptmodell entfernen": "Hauptmodell entfernen",
	Vorlage: Vorlage$3,
	"Dieser Konfigurator dient als Vorlage": "Dieser Konfigurator dient als Vorlage",
	Tutorial: Tutorial$3,
	"Standard übernehmen": "Standard übernehmen",
	"screenshot-quality": "Screenshot Qualität",
	Export: Export$3,
	"app-code-duplicate": "App Code wird schon benutzt",
	"Ihre Händler sollen Ihren Konfigurator nutzen können?": "Ihre Händler sollen Ihren Konfigurator nutzen können?",
	"Keine Händler vorhanden": "Keine Händler vorhanden",
	"Legen Sie zuerst einen Händler an - dann geben Sie ihm hier Zugriff auf die App.": "Legen Sie zuerst einen Händler an - dann geben Sie ihm hier Zugriff auf die App.",
	"Jetzt Händler anlegen": "Jetzt Händler anlegen",
	"to dealer app": "to dealer app",
	"dealer query": "Voreinstellungen",
	discount: discount$3,
	surcharge: surcharge$3,
	Einbetten: Einbetten$3,
	"Als Link": "Als Link",
	"Als IFrame": "Als IFrame",
	"Referenzsprache. Die Einträge müssen mit der Referenzspalte in der importierten Datei übereinstimmen, um berücksichtigt zu werden.": "Referenzsprache. Die Einträge müssen mit der Referenzspalte in der importierten Datei übereinstimmen, um berücksichtigt zu werden.",
	"Wrong file format, be sure to use the format of the exported file for the currently selected reference language.": "Wrong file format, be sure to use the format of the exported file for the currently selected reference language.",
	"Importiere XLSX": "Importiere XLSX",
	"Exportiere XLSX": "Exportiere XLSX",
	Referenzsprache: Referenzsprache$3,
	"Werden berücksichtigt:": "Werden berücksichtigt:",
	Artikel: Artikel$3,
	"Versteckte Variablen": "Versteckte Variablen",
	"Unbenutzte Sprachen": "Unbenutzte Sprachen",
	"Sie möchten Ihren Kunden und/oder sich selbst Anfragen per E-Mail senden?": "Sie möchten Ihren Kunden und/oder sich selbst Anfragen per E-Mail senden?",
	"Mail Texte": "Mail Texte",
	"Hier können Sie den Inhalt der versendeten Mails anpassen. Lesen Sie vorab den Abschnitt in der Dokumentation.": "Hier können Sie den Inhalt der versendeten Mails anpassen. Lesen Sie vorab den Abschnitt in der Dokumentation.",
	"Bitte beachten Sie: Sie müssen immer den Konfigurator veröffentlichen, bevor die geänderten Texte verwendet werden.": "Bitte beachten Sie: Sie müssen immer den Konfigurator veröffentlichen, bevor die geänderten Texte verwendet werden.",
	"Sie möchten Bestätigungen oder Angebote als PDF senden?": "Sie möchten Bestätigungen oder Angebote als PDF senden?",
	"Sie möchten den Konfigurator veröffentlichen?": "Sie möchten den Konfigurator veröffentlichen?",
	"PDF Einstellungen": "PDF Einstellungen",
	Schriftart: Schriftart$3,
	Helvetica: Helvetica$3,
	"Times Roman": "Times Roman",
	Courier: Courier$3,
	Interstate: Interstate$3,
	Montserrat: Montserrat$3,
	"Nunito Sans": "Nunito Sans",
	"Poppins Bold": "Poppins Bold",
	"Schriftgröße": "Schriftgröße",
	"Seitenränder": "Seitenränder",
	Links: Links$3,
	Rechts: Rechts$3,
	Oben: Oben$3,
	Unten: Unten$3,
	Kopfzeile: Kopfzeile$3,
	"Fußzeile": "Fußzeile",
	"Neue PDF Vorlage auswählen": "Neue PDF Vorlage auswählen",
	"Vorhandene PDF Vorlage löschen": "Vorhandene PDF Vorlage löschen",
	"Voransicht mit dieser Konfiguration:": "Voransicht mit dieser Konfiguration:",
	"und diesem Template:": "und diesem Template:",
	"Speichern und drucken": "Speichern und drucken",
	"Für eine Voransicht speichern Sie eine Konfiguration ab.": "Für eine Voransicht speichern Sie eine Konfiguration ab.",
	"Dann können Sie sie hier drucken.": "Dann können Sie sie hier drucken.",
	Mail: Mail$3,
	Shop: Shop$3,
	"Social Sharing": "Social Sharing",
	"Wir helfen gern!": "Wir helfen gern!",
	"Ihre Telefonnummer": "Ihre Telefonnummer",
	"Ihre Nachricht": "Ihre Nachricht",
	Senden: Senden$3,
	orders: orders$3,
	"Preise wurden in den Einstellungen deaktiviert": "Preise wurden in den Einstellungen deaktiviert",
	"Keine Einnahmen vorliegend": "Keine Einnahmen vorliegend",
	"total-earnings": "Gesamteinnahmen",
	Tage: Tage$3,
	date: date$3,
	number: number$3,
	articlename: articlename$3,
	articles: articles$3,
	"Sie können einen Konfigurator unter \"Einstellungen\" exportieren. Die entstandene Datei können Sie hier wieder importieren.": "Sie können einen Konfigurator unter \"Einstellungen\" exportieren. Die entstandene Datei können Sie hier wieder importieren.",
	"JSON Export Datei": "JSON Export Datei",
	"Leerer Konfigurator": "Leerer Konfigurator",
	"Starten Sie mit einem leeren Konfigurator und richten Sie ihn nach Ihren Wünschen ein.": "Starten Sie mit einem leeren Konfigurator und richten Sie ihn nach Ihren Wünschen ein.",
	"Konfigurator importieren": "Konfigurator importieren",
	"Importieren sie einen Konfigurator anhand einer exportierten Datei.": "Importieren sie einen Konfigurator anhand einer exportierten Datei.",
	Bezahlt: Bezahlt$3,
	"Gebucht ab": "Gebucht ab",
	"Gebucht bis": "Gebucht bis",
	"Mandant erfolgreich geändert": "Mandant erfolgreich geändert",
	"Mandant erfolgreich angelegt": "Mandant erfolgreich angelegt",
	"E-Mail": "E-Mail",
	"Einstiegs-Produkt": "Einstiegs-Produkt",
	"Stripe ID": "Stripe ID",
	"Angelegt am": "Angelegt am",
	"Wird gelöscht am": "Wird gelöscht am",
	"Zu diesem Datum wird der Mandant rückstandlos gelöscht!": "Zu diesem Datum wird der Mandant rückstandlos gelöscht!",
	"Der vollständige Mandant wird exportiert - inklusive aller Assets. Sind Sie sicher?": "Der vollständige Mandant wird exportiert - inklusive aller Assets. Sind Sie sicher?",
	Wechseln: Wechseln$3,
	Anlegen: Anlegen$3,
	Neu: Neu$3,
	Konfiguratoren: Konfiguratoren$4,
	Benutzer: Benutzer$7,
	Rolle: Rolle$3,
	"Vielen Dank für Ihre Bestätigung...": "Vielen Dank für Ihre Bestätigung...",
	"E-Mail Bestätigung": "E-Mail Bestätigung",
	"Zur Anmeldung": "Zur Anmeldung",
	name: name$3,
	email: email$3,
	"E-Mail ist ungültig!": "E-Mail ist ungültig!",
	Nutzerkonto: Nutzerkonto$3,
	Nutzername: Nutzername$3,
	"Mail ist schon vergeben": "Mail ist schon vergeben",
	"code-duplicate": "Dieser Code ist schon vergeben",
	"dealer code helper text": "Zum Aufrufen des Händler-Konfigurators.",
	"default discount": "default discount",
	"default surcharge": "default surcharge",
	"Pro Abo": "Pro Abo",
	"is pro dealer": "Darf den Konfigurator auf seiner eigenen Webseite einsetzen und das Design anpassen",
	"Bitte überprüfen Sie die von Ihnen gemachten Angaben: ": "Bitte überprüfen Sie die von Ihnen gemachten Angaben: ",
	create: create$4,
	save: save$3,
	"Fehlendes Produkt": "Fehlendes Produkt",
	"Ihre Händler sollen einen Ihrer Konfiguratoren nutzen können?": "Ihre Händler sollen einen Ihrer Konfiguratoren nutzen können?",
	"Bitte buchen Sie dort zunächst ein anderes Produkt.": "Bitte buchen Sie dort zunächst ein anderes Produkt.",
	"new dealer": "Neuer Händler",
	"Login screen": "Anmeldung",
	Password: Password$3,
	Login: Login$3,
	"Passwort vergessen?": "Passwort vergessen?",
	"Noch kein Konto?": "Noch kein Konto?",
	"Ein Login war leider nicht möglich. Die Kombination aus E-Mail und Passwort ist ungültig.": "Ein Login war leider nicht möglich. Die Kombination aus E-Mail und Passwort ist ungültig.",
	"Falls die Mail in den nächsten Minuten nicht ankommt, schauen Sie bitte auch in Ihrem SPAM-Ordner nach und kontrollieren Sie Ihre Adresse.": "Falls die Mail in den nächsten Minuten nicht ankommt, schauen Sie bitte auch in Ihrem SPAM-Ordner nach und kontrollieren Sie Ihre Adresse.",
	"Wir senden Ihnen eine Mail mit Hinweisen zum Setzen eines neuen Kennwortes.": "Wir senden Ihnen eine Mail mit Hinweisen zum Setzen eines neuen Kennwortes.",
	"Mail senden": "Mail senden",
	Registrierung: Registrierung$3,
	"Bitte bestätigen Sie unsere ": "Bitte bestätigen Sie unsere ",
	Datenschutzbestimmungen: Datenschutzbestimmungen$3,
	" und unsere ": " und unsere ",
	AGB: AGB$3,
	"Jetzt registrieren": "Jetzt registrieren",
	"Bereits angemeldet?": "Bereits angemeldet?",
	"Herzlich willkommen!": "Herzlich willkommen!",
	"Wir haben Ihnen eine E-Mail gesendet - schauen Sie auch in Ihren Spam-Ordner.": "Wir haben Ihnen eine E-Mail gesendet - schauen Sie auch in Ihren Spam-Ordner.",
	"Sie können sich aber auch jetzt gleich mit Ihren Daten anmelden:": "Sie können sich aber auch jetzt gleich mit Ihren Daten anmelden:",
	"Die Registrierung war leider nicht möglich.": "Die Registrierung war leider nicht möglich.",
	"Wir haben Ihr Kennwort neu gesetzt.": "Wir haben Ihr Kennwort neu gesetzt.",
	"Passwort setzen": "Passwort setzen",
	Passwort: Passwort$3,
	"Mindestens 8 Zeichen, Groß-, Kleinbuchstaben und Zahlen": "Mindestens 8 Zeichen, Groß-, Kleinbuchstaben und Zahlen",
	"Bestätigung": "Bestätigung",
	"Bestätigung stimmt nicht überein": "Bestätigung stimmt nicht überein",
	"Kennwort setzen": "Kennwort setzen",
	Mandantentabelle: Mandantentabelle$3,
	"Händleraktivierungen": "Händleraktivierungen",
	Startdatum: Startdatum$3,
	Enddatum: Enddatum$3,
	"Mandanten wechseln": "Mandanten wechseln",
	"Mandanten editieren": "Mandanten editieren",
	"Neuer Mandant": "Neuer Mandant",
	Konfigurator: Konfigurator$3,
	Merkmal: Merkmal$3,
	Regel: Regel$3,
	Nummer: Nummer$3,
	Erstellt: Erstellt$3,
	"Gelöscht": "Gelöscht",
	"Zurücklegen": "Zurücklegen",
	"Mindestlänge": "Mindestlänge {{chars}} Zeichen",
	"Email Adresse ist ungültig": "Email Adresse ist ungültig",
	Kennwort: Kennwort$3,
	"Test stimmt nicht überein": "Test stimmt nicht überein",
	"Telefonnummer ist ungültig": "Telefonnummer ist ungültig",
	Sprache: Sprache$3,
	"Entwickler Modus": "Entwickler Modus",
	"Gibt Entwicklern Zugriff auf erweiterte Möglichkeiten.": "Gibt Entwicklern Zugriff auf erweiterte Möglichkeiten.",
	"API Token": "API Token",
	"Wenn Sie ein neues API Token erzeugen, werden alle bisherigen gelöscht.": "Wenn Sie ein neues API Token erzeugen, werden alle bisherigen gelöscht.",
	"Damit verlieren auch alle von Ihnen verbundenen Shops Zugriff auf den Konfigurator.": "Damit verlieren auch alle von Ihnen verbundenen Shops Zugriff auf den Konfigurator.",
	"Sie können das Token im Shop-Plugin eintragen.": "Sie können das Token im Shop-Plugin eintragen.",
	"Notieren Sie sich das neue Token, es wird hier nur einmalig angezeigt.": "Notieren Sie sich das neue Token, es wird hier nur einmalig angezeigt.",
	"Mit dem ApiToken erhält ein Shop oder Ihre individuelle Entwicklung Zugriff auf die Daten Ihrer Konfiguratoren.": "Mit dem ApiToken erhält ein Shop oder Ihre individuelle Entwicklung Zugriff auf die Daten Ihrer Konfiguratoren.",
	"new user": "Neuer Benutzer",
	"Neuen Nutzer anlegen": "Neuen Nutzer anlegen",
	"E-Mail nicht valide!": "E-Mail nicht valide!",
	"Wir senden dem neuen Nutzer eine E-Mail mit einem Link. Dort kann er sein Kennwort setzen und erhält dann Zugang zu Ihrem Konfigurator.": "Wir senden dem neuen Nutzer eine E-Mail mit einem Link. Dort kann er sein Kennwort setzen und erhält dann Zugang zu Ihrem Konfigurator.",
	"Bitte überprüfen Sie die von Ihnen gemachten Angaben:": "Bitte überprüfen Sie die von Ihnen gemachten Angaben:",
	"Sie möchten dynamische Modelle nutzen und damit z.B. Produkte auf Maß verkaufen?": "Sie möchten dynamische Modelle nutzen und damit z.B. Produkte auf Maß verkaufen?",
	"Hinzufügen": "Hinzufügen",
	"Das Modell überschreitet mit {{curr}} die empfohlene Anzahl von {{max}} Dreiecken. Eventuell kann es zu Problemen im AR Modus kommen.": "Das Modell überschreitet mit {{curr}} die empfohlene Anzahl von {{max}} Dreiecken. Eventuell kann es zu Problemen im AR Modus kommen.",
	"Das Modell überschreitet mit {{curr}}MB die empfohlene Dateigröße von {{max}}MB.": "Das Modell überschreitet mit {{curr}}MB die empfohlene Dateigröße von {{max}}MB.",
	"3D-Modell auswählen": "3D-Modell auswählen",
	Download: Download$3,
	Hintergrundmodell: Hintergrundmodell$3,
	"material-upload": "material-upload",
	"main-model": "Hauptmodell",
	"Wirft Schatten": "Wirft Schatten",
	"Wird schattiert": "Wird schattiert",
	"Bilder Galerie": "Bilder Galerie",
	"Neue Aktion": "Neue Aktion",
	Preiseinstellungen: Preiseinstellungen$3,
	"Preise im Konfigurator ausblenden?": "Preise im Konfigurator ausblenden?",
	Standard: Standard$3,
	Hauptaktion: Hauptaktion$3,
	Kontaktformular: Kontaktformular$3,
	"Sie können diese Kundendaten zwar erfassen, aber nicht einsehen.": "Sie können diese Kundendaten zwar erfassen, aber nicht einsehen.",
	Pflichtfeld: Pflichtfeld$3,
	"Sie können Links zu Ihren eigenen Dokumenten mit <a href=\"https://ihre-domain.de/ihre-datenschutzbestimmungen.html\" target=\"_blank\">Datenschutzhinweise</a> einbauen.": "Sie können Links zu Ihren eigenen Dokumenten mit <a href=\"https://ihre-domain.de/ihre-datenschutzbestimmungen.html\" target=\"_blank\">Datenschutzhinweise</a> einbauen.",
	Aktionsname: Aktionsname$3,
	"Shop verbinden": "Shop verbinden",
	"Überschrift Bestätigung": "Überschrift Bestätigung",
	"Text Bestätigung": "Text Bestätigung",
	"Link zur Konfiguration zeigen?": "Link zur Konfiguration zeigen?",
	"Thumbnail des Konfigurators": "Thumbnail des Konfigurators",
	"Desktop Gerät erkannt": "Desktop Gerät erkannt",
	"Augmented-Reality ist aktuell nur auf aktuellen iOS- oder androidOS-Smartphones verfügbar. Scannen Sie daher einfach diesen QR-Code mit der Kamera-App Ihres Smartphones:": "Augmented-Reality ist aktuell nur auf aktuellen iOS- oder androidOS-Smartphones verfügbar. Scannen Sie daher einfach diesen QR-Code mit der Kamera-App Ihres Smartphones:",
	"Export des 3D-Objekts": "Export des 3D-Objekts",
	"Bereitstellen der AR-Datei": "Bereitstellen der AR-Datei",
	"Kein Artikel ausgewählt!": "Kein Artikel ausgewählt!",
	"Artikel auswählen": "Artikel auswählen",
	Anzahl: Anzahl$3,
	"Wert eingeben": "Wert eingeben",
	"Neue Spalte": "Neue Spalte",
	"Wert-Eigenschaft": "Wert-Eigenschaft",
	"Sie können den Werten dieses Merkmals Eigenschaften geben, z.B.             Gewicht oder Güteklasse oder Leistung. Diese Eigenschaften können             Sie für jeden Wert getrennt erfassen und dann dem Benutzer ausgeben. Sie             können mit diesen Eigenschaften aber auch Regeln und Berechnungen             deutlich einfacher machen.": "Sie können den Werten dieses Merkmals Eigenschaften geben, z.B.             Gewicht oder Güteklasse oder Leistung. Diese Eigenschaften können             Sie für jeden Wert getrennt erfassen und dann dem Benutzer ausgeben. Sie             können mit diesen Eigenschaften aber auch Regeln und Berechnungen             deutlich einfacher machen.",
	"Eigenschaft wird dem Nutzer angezeigt": "Eigenschaft wird dem Nutzer angezeigt",
	"mehrsprachiger Text": "mehrsprachiger Text",
	"nicht übersetzter Text": "nicht übersetzter Text",
	Zahl: Zahl$3,
	Einheit: Einheit$3,
	"Fokus auf Modelle": "Fokus auf Modelle",
	"Alle Modelle": "Alle Modelle",
	"Fokus über Objektnamen": "Fokus über Objektnamen",
	"Aktuelle Ansicht übernehmen und Speichern": "Aktuelle Ansicht übernehmen und Speichern",
	Aktionen: Aktionen$3,
	"Kamera bearbeiten": "Kamera bearbeiten",
	"Noch keine Kamera gespeichert": "Noch keine Kamera gespeichert",
	"Kameras gespeichert: ": "Kameras gespeichert: ",
	Kameras: Kameras$3,
	Kamera: Kamera$3,
	Reiter: Reiter$3,
	Kameraansicht: Kameraansicht$3,
	"Kamera speichern": "Kamera speichern",
	"Bitte auswählen": "Bitte auswählen",
	"Ausgewählt": "Ausgewählt",
	"Merkmal setzen: ": "Merkmal setzen: ",
	"Keine Farbe ausgewählt!": "Keine Farbe ausgewählt!",
	"Farbe auswählen": "Farbe auswählen",
	"Farbmerkmal auswählen:": "Farbmerkmal auswählen:",
	"Keine Auswahl": "Keine Auswahl",
	"Sind Sie sicher?": "Sind Sie sicher?",
	Ok: Ok$3,
	"Ergebnis: ": "Ergebnis: ",
	"Ihre Konfiguration wurde gespeichert": "Ihre Konfiguration wurde gespeichert",
	"Mit diesem Link können Sie Ihre Konfiguration wieder aufrufen: ": "Mit diesem Link können Sie Ihre Konfiguration wieder aufrufen: ",
	"Sie sollten zum Shop weitergeleitet worden sein. Wenn Sie nicht weitergeleitet wurden klicken Sie bitte hier, um Ihre Bestellung abzuschließen: ": "Sie sollten zum Shop weitergeleitet worden sein. Wenn Sie nicht weitergeleitet wurden klicken Sie bitte hier, um Ihre Bestellung abzuschließen: ",
	"Zum Shop": "Zum Shop",
	"Ihre Konfiguration konnte nicht gespeichert werden.": "Ihre Konfiguration konnte nicht gespeichert werden.",
	"Bitte entschuldigen Sie. Wir haben die Konfiguration in diesem Browser gesichert. Bitte kommen Sie später noch einmal wieder.": "Bitte entschuldigen Sie. Wir haben die Konfiguration in diesem Browser gesichert. Bitte kommen Sie später noch einmal wieder.",
	"technische Information:": "technische Information:",
	Fertig: Fertig$3,
	"Neues Produkt auswählen": "Neues Produkt auswählen",
	"Neues Produkt hinzufügen": "Neues Produkt hinzufügen",
	Auswahlen: Auswahlen$3,
	"Pos.": "Pos.",
	Positionspreis: Positionspreis$3,
	Gesamtpreis: Gesamtpreis$3,
	"Preis: ": "Preis: ",
	"Kameras für Bestellungsbilder": "Kameras für Bestellungsbilder",
	"Anfrage erhalten": "Anfrage erhalten",
	"Buchung erfolgreich": "Buchung erfolgreich",
	"Für das neue Produkt melden wir uns bei Ihnen.": "Für das neue Produkt melden wir uns bei Ihnen.",
	"Ihre Subskription wurde angepasst.": "Ihre Subskription wurde angepasst.",
	"Ihre Subskription wurde beendet.": "Ihre Subskription wurde beendet.",
	"Das Produkt wurde gebucht.": "Das Produkt wurde gebucht.",
	"Meine Rechnungen": "Meine Rechnungen",
	"Auf Anfrage": "Auf Anfrage",
	Kostenfrei: Kostenfrei$3,
	"{{fee}},- EUR pro Monat": "{{fee}},- EUR pro Monat",
	"Derzeit gebucht.": "Derzeit gebucht.",
	"Sie buchen nun ein neues Produkt.": "Sie buchen nun ein neues Produkt.",
	Downgrade: Downgrade$3,
	"Ihre K3 Buchung": "Ihre K3 Buchung",
	"In neuem Tab öffnen": "In neuem Tab öffnen",
	"Konfigurator anpassen": "Konfigurator anpassen",
	"main drawer": "Sie sehen eine Vorschau Ihres Konfigurators, die Sie wie üblich bedienen können. Klicken Sie auf ein Stift-Symbol, um etwas zu ändern oder:",
	"Ändern Sie die Bestelloptionen": "Ändern Sie die Bestelloptionen",
	"Ändern Sie das Design": "Ändern Sie das Design",
	"Passen sie die 3D Szene an": "Passen sie die 3D Szene an",
	"Speichern Sie die aktuelle Kamera für Bestellungsbilder": "Speichern Sie die aktuelle Kamera für Bestellungsbilder",
	"Nutzen Sie die Hilfe": "Nutzen Sie die Hilfe",
	"Gruppen und Merkmale anpassen:": "Gruppen und Merkmale anpassen:",
	"Gruppen verwalten": "Gruppen verwalten",
	"Merkmale verwalten": "Merkmale verwalten",
	"So richten Sie Ihren Konfigurator ein:": "So richten Sie Ihren Konfigurator ein:",
	Home: Home$3,
	Hilfe: Hilfe$7,
	"Ihr K3": "Ihr K3",
	"dealer sidebar": "Hier können sie ihren Händler Konfigurator einstellen",
	"change design": "Ändern Sie das Design",
	"change logo": "Ändern Sie das Logo",
	"change price": "Ändern Sie den Preis",
	"change pdf": "Ändern Sie die PDF Vorlage",
	"PDF Gestaltung": "PDF Gestaltung",
	"Laden Sie ein PDF als Vorlage für den Druck hoch.": "Laden Sie ein PDF als Vorlage für den Druck hoch.",
	cancel: cancel$3,
	"app surcharge": "Aufschlag festlegen",
	"you can change your surcharge here": "Hier können Sie Ihren Aufpreis ändern",
	"Neue Gruppe": "Neue Gruppe",
	"Neuer Reiter": "Neuer Reiter",
	Icon: Icon$3,
	"Icon Bilddatei": "Icon Bilddatei",
	"Icon position": "Icon position",
	"Icon Größe": "Icon Größe",
	"Ersetze Weiter mit Aktionsauswahl": "Ersetze Weiter mit Aktionsauswahl",
	"Aktionsnamen überschreiben": "Aktionsnamen überschreiben",
	"Individuelles Gruppen-Design": "Individuelles Gruppen-Design",
	Gruppen: Gruppen$3,
	"Gruppen editieren": "Gruppen editieren",
	"Desktop Layout": "Desktop Layout",
	"Reiter schrittweise einblenden": "Reiter schrittweise einblenden",
	"Besuchte Reiter abhaken": "Besuchte Reiter abhaken",
	"Desktop Layout wählen": "Desktop Layout wählen",
	"Schließen": "Schließen",
	"Mobile Layout": "Mobile Layout",
	"Mobile Layout wählen": "Mobile Layout wählen",
	Logo: Logo$4,
	"Konfigurator-Abschluss": "Konfigurator-Abschluss",
	"3D Szene": "3D Szene",
	"Manuelle Einstellung erstellen": "Manuelle Einstellung erstellen",
	"Design & Theme": "Design & Theme",
	Farben: Farben$3,
	"Farbanpassungen zurücksetzten": "Farbanpassungen zurücksetzten",
	CSS: CSS$3,
	"Sie können das Aussehen Ihres Konfigurators auch mittels CSS individuell anpassen:": "Sie können das Aussehen Ihres Konfigurators auch mittels CSS individuell anpassen:",
	"Link zur CSS-Datei": "Link zur CSS-Datei",
	"Oder laden Sie eine CSS Datei hoch:": "Oder laden Sie eine CSS Datei hoch:",
	"Neues Merkmal": "Neues Merkmal",
	Variablen: Variablen$3,
	"Variablen editieren": "Variablen editieren",
	Einstellungen: Einstellungen$3,
	"Dynamische Texte": "Dynamische Texte",
	Vorschau: Vorschau$3,
	Editor: Editor$3,
	Regeln: Regeln$3,
	Articles: Articles$3,
	Modelle: Modelle$3,
	Materialien: Materialien$3,
	Bestellungen: Bestellungen$3,
	"Inhalte: ": "Inhalte: ",
	"Bevor der Konfigurator genutzt werden kann, müssen sie den Knopf \"Veröffentlichen\" betätigen. Wenn Sie danach Änderungen vornehmen, werden diese auch erst nach der nächsten Veröffentlichung wirksam.": "Bevor der Konfigurator genutzt werden kann, müssen sie den Knopf \"Veröffentlichen\" betätigen. Wenn Sie danach Änderungen vornehmen, werden diese auch erst nach der nächsten Veröffentlichung wirksam.",
	"Live Version": "Live Version",
	"Veröffentlichen": "Veröffentlichen",
	"Erstelle Option: ": "Erstelle Option: ",
	Fatal_Error_Text: Fatal_Error_Text$3,
	Fatal_Error: Fatal_Error$3,
	"Fehlermeldung:": "Fehlermeldung:",
	"Zur Startseite": "Zur Startseite",
	"Neu Laden": "Neu Laden",
	"Cleanup und Neu Laden": "Cleanup und Neu Laden",
	Error_Message: Error_Message$3,
	"Die folgenden Gründe sprechen gegen eine Löschung:": "Die folgenden Gründe sprechen gegen eine Löschung:",
	"einer Erweiterung. Bitten Sie den Entwickler die Nutzung zu entfernen und löschen Sie dann den Key.": "einer Erweiterung. Bitten Sie den Entwickler die Nutzung zu entfernen und löschen Sie dann den Key.",
	"der Definition der Regel": "der Definition der Regel",
	"einem Eintrag in Regel": "einem Eintrag in Regel",
	"einer berechneten Eigenschaft des Modells": "einer berechneten Eigenschaft des Modells",
	"der Formel von": "der Formel von",
	"der Kamera": "der Kamera",
	"des Merkmals": "des Merkmals",
	"der Gruppe": "der Gruppe",
	"der globalen Kamera": "der globalen Kamera",
	"Löschen Sie bitte zunächst die anderen Referenzen.": "Löschen Sie bitte zunächst die anderen Referenzen.",
	Abschnitt: Abschnitt$3,
	"Bitte legen Sie einen Reiter an!": "Bitte legen Sie einen Reiter an!",
	"Gruppe editieren": "Gruppe editieren",
	Bestelloptionen: Bestelloptionen$3,
	"Merkmal editieren": "Merkmal editieren",
	hiddenGroup: hiddenGroup$3,
	"Label eingeben": "Label eingeben",
	Bearbeiten: Bearbeiten$3,
	"Bilder auswählen": "Bilder auswählen",
	"Ordner auswählen:": "Ordner auswählen:",
	"Bildmerkmal: ": "Bildmerkmal: ",
	"Kein Bild ausgewählt": "Kein Bild ausgewählt",
	"Bild auswählen": "Bild auswählen",
	"Bildmerkmal auswählen:": "Bildmerkmal auswählen:",
	"Befüllt": "Befüllt",
	Leer: Leer$3,
	"Zustand auswählen": "Zustand auswählen",
	"Kein Komponente ausgewählt!": "Kein Komponente ausgewählt!",
	"Komponente auswählen": "Komponente auswählen",
	"Intervall eingeben": "Intervall eingeben",
	"Zum Dashboard": "Zum Dashboard",
	Basiseinstellungen: Basiseinstellungen$3,
	"Helles Theme": "Helles Theme",
	"Erweiterte Einstellungen": "Erweiterte Einstellungen",
	"Label hinzufügen: ": "Label hinzufügen: ",
	"Kein Label ausgewählt!": "Kein Label ausgewählt!",
	"Was soll angezeigt werden?": "Was soll angezeigt werden?",
	"Maximalgröße": "Maximalgröße",
	Deckkraft: Deckkraft$3,
	"Kein Material ausgewählt!": "Kein Material ausgewählt!",
	"Material auswählen": "Material auswählen",
	"Material auswählen:": "Material auswählen:",
	"Beschränkung der Auswirkungen auf bestimmte Modelle": "Beschränkung der Auswirkungen auf bestimmte Modelle",
	"Welches Teil soll hinzugefügt werden?": "Welches Teil soll hinzugefügt werden?",
	"Mobile Theme wählen": "Mobile Theme wählen",
	"Layout auswählen": "Layout auswählen",
	"Layout erstellen": "Layout erstellen",
	"Gewähltes Layout kopieren": "Gewähltes Layout kopieren",
	Anwenden: Anwenden$3,
	"Kein Modell ausgewählt!": "Kein Modell ausgewählt!",
	"Modell auswählen": "Modell auswählen",
	"Modell hinzufügen:": "Modell hinzufügen:",
	"Globale Änderung": "Globale Änderung",
	"Oberflächen": "Oberflächen",
	"Ausgewählte Oberflächen": "Ausgewählte Oberflächen",
	"Eintrag darf nicht leer sein.": "Eintrag darf nicht leer sein.",
	"Alle Werte": "Alle Werte",
	"Werte auswählen": "Werte auswählen",
	Auswahl: Auswahl$3,
	"Hoch schieben": "Hoch schieben",
	"Runter schieben": "Runter schieben",
	Duplizieren: Duplizieren$3,
	"Sortierung anwenden": "Sortierung anwenden",
	"Das Dateiformat ist nicht erlaubt! Keine Datei gewählt.": "Das Dateiformat ist nicht erlaubt! Keine Datei gewählt.",
	"Erlaube Formate:": "Erlaube Formate:",
	"Keine Datei gewählt.": "Keine Datei gewählt.",
	"Das Dateiformat ist nicht erlaubt!": "Das Dateiformat ist nicht erlaubt!",
	Ersetzen: Ersetzen$3,
	"Bild hochladen": "Bild hochladen",
	"Diese Variable ist nicht erlaubt.": "Diese Variable ist nicht erlaubt.",
	"Merkmal-Info editieren": "Merkmal-Info editieren",
	"Vorlage wählen": "Vorlage wählen",
	"Konfigurator erstellen": "Konfigurator erstellen",
	"Willkommen in Ihrem neuen K3 Konto!": "Willkommen in Ihrem neuen K3 Konto!",
	"Richten Sie gleich Ihren ersten Konfigurator ein:": "Richten Sie gleich Ihren ersten Konfigurator ein:",
	"Sie können alle Daten natürlich später noch ändern.": "Sie können alle Daten natürlich später noch ändern.",
	"Nicht veröffentlicht": "Nicht veröffentlicht",
	Statistics: Statistics$3,
	Konfigurationen: Konfigurationen$3,
	"Konfigurator wurde aktualisiert": "Konfigurator wurde aktualisiert",
	"Seit Sie diese Konfiguration gespeichert haben, wurde der Konfigurator weiterentwickelt. Wollen Sie die aktuelle Version verwenden und weiterarbeiten oder die alte Version nur zur Ansicht öffnen?": "Seit Sie diese Konfiguration gespeichert haben, wurde der Konfigurator weiterentwickelt. Wollen Sie die aktuelle Version verwenden und weiterarbeiten oder die alte Version nur zur Ansicht öffnen?",
	"Alte Version": "Alte Version",
	"Aktuelle Version": "Aktuelle Version",
	"Ladevorgang fehlgeschlagen": "Ladevorgang fehlgeschlagen",
	"Die Konfiguration konnte nicht geladen werden! Bitte versuchen Sie es später erneut!": "Die Konfiguration konnte nicht geladen werden! Bitte versuchen Sie es später erneut!",
	"Keine Optionen": "Keine Optionen",
	articleNo: articleNo$3,
	articleName: articleName$3,
	price: price$3,
	currency: currency$3,
	Cancel: Cancel$3,
	Save: Save$3,
	"edit-positions": "Positionen ändern",
	"Klicken um abzubrechen.": "Klicken um abzubrechen.",
	"Preis eingeben": "Preis eingeben",
	"Währung": "Währung",
	"Währung eingeben": "Währung eingeben",
	"Einheit eingeben": "Einheit eingeben",
	"Startdatum eingeben": "Startdatum eingeben",
	"Enddatum eingeben": "Enddatum eingeben",
	Startanzahl: Startanzahl$3,
	"Startanzahl eingeben": "Startanzahl eingeben",
	Endanzahl: Endanzahl$3,
	"Endanzahl eingeben": "Endanzahl eingeben",
	"Priorität": "Priorität",
	"Priorität eingeben": "Priorität eingeben",
	"Aufschlag?": "Aufschlag?",
	"Preistyp eingeben": "Preistyp eingeben",
	"Neuer Preis": "Neuer Preis",
	Suchen: Suchen$3,
	Ctrl: Ctrl$3,
	"Auswählen": "Auswählen",
	"Wählen Sie eine Vorlage aus:": "Wählen Sie eine Vorlage aus:",
	"Sollen wir Ihren Konfigurator jetzt anlegen?": "Sollen wir Ihren Konfigurator jetzt anlegen?",
	"Wir bringen Sie danach direkt in den Editor.": "Wir bringen Sie danach direkt in den Editor.",
	"Anlegen & zum Konfigurator": "Anlegen & zum Konfigurator",
	"Farbenanzahl im Fenster": "Farbenanzahl im Fenster",
	"Farbkachel Rundung": "Farbkachel Rundung",
	"Opazität": "Opazität",
	Hervorhebung: Hervorhebung$3,
	"Groupieren nach": "Groupieren nach",
	Expression: Expression$3,
	"Formel Editor": "Formel Editor",
	"Geben Sie Formeln von Variablen ein.": "Geben Sie Formeln von Variablen ein.",
	" Schreiben Sie z.B. Länge * Breite.": " Schreiben Sie z.B. Länge * Breite.",
	"Für ein Attribut nutzen Sie beispielsweise Motor.Leistung, wenn Motor ihr Merkmal und Leistung das entsprechende Attribut ist.": "Für ein Attribut nutzen Sie beispielsweise Motor.Leistung, wenn Motor ihr Merkmal und Leistung das entsprechende Attribut ist.",
	Ergebnis: Ergebnis$3,
	"Keine Formel eingegeben": "Keine Formel eingegeben",
	"Formel: ": "Formel: ",
	"Noch gibt es nicht genug Auswahlen um eine Vorschau anzuzeigen.": "Noch gibt es nicht genug Auswahlen um eine Vorschau anzuzeigen.",
	"Ausblenden der originalen Textur, wenn bedruckt wird?": "Ausblenden der originalen Textur, wenn bedruckt wird?",
	"Erlaube Bildformate": "Erlaube Bildformate",
	Mindestwert: Mindestwert$3,
	Maximalwert: Maximalwert$3,
	Nachkommastellen: Nachkommastellen$3,
	Schrittweite: Schrittweite$3,
	"Zeige Knöpfe an": "Zeige Knöpfe an",
	"Benutze Vielfaches der Schrittweite": "Benutze Vielfaches der Schrittweite",
	Berechnet: Berechnet$3,
	"Zyklus Erkennung deaktivieren": "Zyklus Erkennung deaktivieren",
	"Ändern": "Ändern",
	Wert: Wert$3,
	"Beispielhafte Beschreibung eines Wertes.": "Beispielhafte Beschreibung eines Wertes.",
	"Dies ist nur eine Info": "Dies ist nur eine Info",
	"Color Dropdown": "Farbauswahl Dropdown",
	"Color Radio": "Farbauswahl Radio",
	Farbauswahl: Farbauswahl$3,
	Komponente: Komponente$3,
	Komponentenliste: Komponentenliste$3,
	"Komponentenliste mit Popup": "Komponentenliste mit Popup",
	Bildauswahl: Bildauswahl$3,
	Zahleneingabe: Zahleneingabe$3,
	"Radio Buttons": "Radio Buttons",
	"Radio Cards": "Radio Cards",
	"RAL-Farbauswahl": "RAL-Farbauswahl",
	Dropdown: Dropdown$3,
	Schalter: Schalter$3,
	"Schalter Card": "Schalter Card",
	Texteingabe: Texteingabe$3,
	Beispieltext: Beispieltext$3,
	Optional: Optional$3,
	"Unter \"Werte\" finden Sie dann den speziellen Eintrag \"keine Angabe\". Hier können Sie noch anpassen, was dem Nutzer angezeigt werden soll, wenn er nichts ausgewählt hat.": "Unter \"Werte\" finden Sie dann den speziellen Eintrag \"keine Angabe\". Hier können Sie noch anpassen, was dem Nutzer angezeigt werden soll, wenn er nichts ausgewählt hat.",
	Versteckt: Versteckt$3,
	"Dieses Merkmal wird nicht angezeigt. Der Wert kann aber in Regeln und Berechnungen genutzt werden.": "Dieses Merkmal wird nicht angezeigt. Der Wert kann aber in Regeln und Berechnungen genutzt werden.",
	"Auswahl nur anzeigen, wenn ausgewählt": "Auswahl nur anzeigen, wenn ausgewählt",
	"Die Auswahl wird nicht in der Bestätigung, PDF oder im Shop angezeigt, wenn nichts ausgewählt wurde.": "Die Auswahl wird nicht in der Bestätigung, PDF oder im Shop angezeigt, wenn nichts ausgewählt wurde.",
	"showSelection.label": "showSelection.label",
	"Aus Gruppe verstecken": "Aus Gruppe verstecken",
	"Diese Option ergibt nur Sinn, wenn die Variable über ein custom Layout an einer anderen Stelle ein- oder ausgeblendet wird. Auch wenn sie hierrüber aus der Gruppe versteckt wird, wird sie trotzdem weiterhin in Zusammenfassungen dieser zugeordnet.": "Diese Option ergibt nur Sinn, wenn die Variable über ein custom Layout an einer anderen Stelle ein- oder ausgeblendet wird. Auch wenn sie hierrüber aus der Gruppe versteckt wird, wird sie trotzdem weiterhin in Zusammenfassungen dieser zugeordnet.",
	"Folgende Änderungen werden veröffentlicht:": "Folgende Änderungen werden veröffentlicht:",
	"Konfigurator veröffentlichen": "Konfigurator veröffentlichen",
	"Wertebereich angeben": "Wertebereich angeben",
	"Merkmale: ": "Merkmale: ",
	"Aktionen: ": "Aktionen: ",
	"Diese Regel ist aktuell deaktiviert.": "Diese Regel ist aktuell deaktiviert.",
	"Modell Eigenschaften anpassen": "Modell Eigenschaften anpassen",
	"Bitte fügen Sie neue Regelzeilen hinzu.": "Bitte fügen Sie neue Regelzeilen hinzu.",
	"Andernfalls wird diese Regel bei der Auswertung nicht beachtet.": "Andernfalls wird diese Regel bei der Auswertung nicht beachtet.",
	"Keine Warnungen": "Keine Warnungen",
	"Selektions-Bearbeitung": "Selektions-Bearbeitung",
	"Alle Regeln ansehen": "Alle Regeln ansehen",
	Position: Position$3,
	"Rotation (in radiant)": "Rotation (in radiant)",
	Scale: Scale$3,
	"Regel Bearbeitung": "Regel Bearbeitung",
	"Kein Label angegeben!": "Kein Label angegeben!",
	"Regel Validierung": "Regel Validierung",
	"Fehlende Werte": "Fehlende Werte",
	Modell: Modell$3,
	Material: Material$3,
	Komponenten: Komponenten$3,
	Druck: Druck$3,
	Farbe: Farbe$3,
	"Kein Modell": "Kein Modell",
	Regelname: Regelname$3,
	"Wird angewendet": "Wird angewendet",
	Produktstruktur: Produktstruktur$3,
	"Reiter ausblenden": "Reiter ausblenden",
	"Variablen ausblenden": "Variablen ausblenden",
	"Werte ausblenden": "Werte ausblenden",
	"Variablen entfernen": "Variablen entfernen (veraltet)",
	"Reiter entfernen": "Reiter entfernen (veraltet)",
	"Anzeige von 3D-Modellen": "Anzeige von 3D-Modellen",
	"Anzeige von Informationen": "Anzeige von Informationen",
	"Austauschen von Oberflächen": "Austauschen von Oberflächen",
	"Bilder auf Oberflächen drucken": "Bilder auf Oberflächen drucken",
	Materialnamen: Materialnamen$3,
	"Wählen Sie ein Materialnamen aus.": "Wählen Sie ein Materialnamen aus.",
	"Ändern der Farbe": "Ändern der Farbe",
	"Anzeige von Bildern": "Anzeige von Bildern",
	"Preise & Artikel": "Preise & Artikel",
	"Gültigkeitsregeln": "Gültigkeitsregeln",
	"Gültigkeit prüfen?": "Gültigkeit prüfen?",
	Merkmalskombinationen: Merkmalskombinationen$3,
	Merkmale: Merkmale$3,
	Erstellen: Erstellen$3,
	"Artikel zur Stückliste hinzufügen": "Artikel zur Stückliste hinzufügen",
	"Zugeordnete Variablen": "Zugeordnete Variablen",
	"Wählen Sie die Variablen aus, denen die Artikel zugeordnet werden sollen": "Wählen Sie die Variablen aus, denen die Artikel zugeordnet werden sollen",
	"Befüllen von Komponentenmerkmalen": "Befüllen von Komponentenmerkmalen",
	Komponentenmerkmale: Komponentenmerkmale$3,
	"Wählen Sie Komponentenmerkmale aus.": "Wählen Sie Komponentenmerkmale aus.",
	"Oberflächenaktion hinzufügen": "Oberflächenaktion hinzufügen",
	"Alle auswählen": "Alle auswählen",
	"Alle abwählen": "Alle abwählen",
	"Auswahl umkehren": "Auswahl umkehren",
	"Dieser Konfigurator wurde erfolgreich mit Ihrem Shop verbunden: ": "Dieser Konfigurator wurde erfolgreich mit Ihrem Shop verbunden: ",
	"Falls Sie die Anbindung aufheben möchten, löschen Sie zunächst das Secret im K3 Plugin in Ihrem Shop.": "Falls Sie die Anbindung aufheben möchten, löschen Sie zunächst das Secret im K3 Plugin in Ihrem Shop.",
	"Secret ist gelöscht": "Secret ist gelöscht",
	"Shop-Anbindung aufheben": "Shop-Anbindung aufheben",
	Herunterladen: Herunterladen$3,
	"Ist installiert": "Ist installiert",
	"Verbinde Shop": "Verbinde Shop",
	" und importiere Artikel": " und importiere Artikel",
	"Fehler beim Verbinden:": "Fehler beim Verbinden:",
	"Shop erfolgreich verbunden.": "Shop erfolgreich verbunden.",
	"Fehler beim Verbinden: ": "Fehler beim Verbinden: ",
	"Shop-Anbindung": "Shop-Anbindung",
	"Web-Adresse des Shops": "Web-Adresse des Shops",
	"Shopify Admin API Key": "Shopify Admin API Key",
	"Sollen die Artikel aus dem Shop importiert werden?": "Sollen die Artikel aus dem Shop importiert werden?",
	"Filter für Artikel": "Filter für Artikel",
	"Sollen die Artikel bei der Bestellung zusammengefasst werden?": "Sollen die Artikel bei der Bestellung zusammengefasst werden?",
	"Basis-Name für kombinierte Artikel": "Basis-Name für kombinierte Artikel",
	Verbinden: Verbinden$3,
	"Laden Sie zunächst eines unserer Plugins herunter und installieren Sie es in Ihrem Shop:": "Laden Sie zunächst eines unserer Plugins herunter und installieren Sie es in Ihrem Shop:",
	"Sie können uns den Vorfall hier melden!": "Sie können uns den Vorfall hier melden!",
	"Konnte das Templat nicht laden.": "Konnte das Templat nicht laden.",
	Templatname: Templatname$3,
	"Standard laden": "Standard laden",
	"Neuen Templatenamen eingeben": "Neuen Templatenamen eingeben",
	"Templat hinzufügen": "Templat hinzufügen",
	"Desktop Theme wählen": "Desktop Theme wählen",
	"Ansicht auswählen": "Ansicht auswählen",
	"Datei hochladen": "Datei hochladen",
	"You may need to reload the page": "Neu laden der Seite könnte notwendig sein",
	"Bitte buchen Sie zunächst ein anderes Produkt:": "Bitte buchen Sie zunächst ein anderes Produkt:",
	"Bitte wählen": "Bitte wählen",
	"Diese Aktion verbindet mehrere Merkmale und kann daher hier nicht geändert werden. Ändern Sie dafür direkt die folgende(n) Regel(n):": "Diese Aktion verbindet mehrere Merkmale und kann daher hier nicht geändert werden. Ändern Sie dafür direkt die folgende(n) Regel(n):",
	"Automatisch angelegt": "Automatisch angelegt",
	"Aktionen verknüpfen": "Aktionen verknüpfen",
	"Werte von diesem Merkmal sollen folgende Aktionen auslösen:": "Werte von diesem Merkmal sollen folgende Aktionen auslösen:",
	"Dieses Merkmal kann nicht verwendet werden, um weitere Vorgänge zu steuern. Nutzen Sie dafür bitte direkt die Regeln.": "Dieses Merkmal kann nicht verwendet werden, um weitere Vorgänge zu steuern. Nutzen Sie dafür bitte direkt die Regeln.",
	"Zu den Regeln": "Zu den Regeln",
	"Artikel bestellen": "Artikel bestellen",
	"Abhängig von der Auswahl werden verschiedene Artikel zur Stückliste hinzugefügt.": "Abhängig von der Auswahl werden verschiedene Artikel zur Stückliste hinzugefügt.",
	"Oberfläche ändern": "Oberfläche ändern",
	"Welche Oberflächen sollen geändert werden? ": "Welche Oberflächen sollen geändert werden? ",
	"3D-Modell anzeigen": "3D-Modell anzeigen",
	"Abhängig von der Auswahl werden verschiedene 3D-Modelle angezeigt.": "Abhängig von der Auswahl werden verschiedene 3D-Modelle angezeigt.",
	"Bild anzeigen": "Bild anzeigen",
	"Abhängig von der Auswahl werden verschiedene Bilder angezeigt.": "Abhängig von der Auswahl werden verschiedene Bilder angezeigt.",
	"Farbe ändern": "Farbe ändern",
	"Welche Oberflächen sollen eingefärbt werden? ": "Welche Oberflächen sollen eingefärbt werden? ",
	"Bild aufdrucken": "Bild aufdrucken",
	"Auf welchen Oberflächen soll das hochgeladene Bild aufgedruckt werden? ": "Auf welchen Oberflächen soll das hochgeladene Bild aufgedruckt werden? ",
	"Der Wert wird noch in Regeln verwendet:": "Der Wert wird noch in Regeln verwendet:",
	"Löschen Sie bitte zunächst dort die entsprechende(n) Zeile(n).": "Löschen Sie bitte zunächst dort die entsprechende(n) Zeile(n).",
	"Hier können Sie einstellen, was angezeigt werden soll, wenn noch kein Wert gewählt wurde": "Hier können Sie einstellen, was angezeigt werden soll, wenn noch kein Wert gewählt wurde",
	"Dieser Wert ist nicht erlaubt.": "Dieser Wert ist nicht erlaubt.",
	"Maximale Anzahl an Werten ist erreicht.": "Maximale Anzahl an Werten ist erreicht.",
	Farbwert: Farbwert$3,
	Ansicht: Ansicht$3,
	"Key eingeben": "Key eingeben",
	URL: URL$4,
	"Info-Text": "Info-Text",
	"Zahlenvariablen haben keine Werte.": "Zahlenvariablen haben keine Werte.",
	Auswahlwerte: Auswahlwerte$3,
	"Typ des Merkmals": "Typ des Merkmals",
	"es gibt keine Variable mit {{identificator}}": "es gibt keine Variable mit {{identificator}}",
	"es gibt kein Attribut mit {{identificator}}": "es gibt kein Attribut mit {{identificator}}",
	"es gibt keine Selection mit {{identificator}}": "es gibt keine Selection mit {{identificator}}",
	"es gibt mehr als eine Selection mit {{identificator}}": "es gibt mehr als eine Selection mit {{identificator}}",
	"Es gibt einen Zyklus in den berechneten Variablen: {{cycleText}}": "Es gibt einen Zyklus in den berechneten Variablen: {{cycleText}}",
	"das Ergebnis der Formel muss ein Zahlenwert sein, statt dessen ist es {{type}}": "das Ergebnis der Formel muss ein Zahlenwert sein, statt dessen ist es {{type}}",
	"Wert {{paramName}} der Funktion {{functionName}} ist null": "Wert {{paramName}} der Funktion {{functionName}} ist null",
	"Die Variable {{variableLabel}} ist eine Komponentenliste. Sie müssen mit einem Index wie {{variableLabel2}}[0] für das 1. Element oder mit einer Array-Funktionen wie z.B. map(), find(), reduce() oder first() darauf zugreifen": "Die Variable {{variableLabel}} ist eine Komponentenliste. Sie müssen mit einem Index wie {{variableLabel2}}[0] für das 1. Element oder mit einer Array-Funktionen wie z.B. map(), find(), reduce() oder first() darauf zugreifen",
	"Zeige Namen": "Zeige Namen",
	"Zeige Beschreibung": "Zeige Beschreibung",
	"Zeige Thumbnail": "Zeige Thumbnail",
	"Zeige Preis": "Zeige Preis",
	"Zeige URL": "Zeige URL",
	"Zeige Info-Button für Werte": "Zeige Info-Button für Werte",
	"Kamerafahrt beim scrollen": "Kamerafahrt beim scrollen",
	"Ungültige, aktiv geänderte, Werte ausblenden": "Ungültige, aktiv geänderte, Werte ausblenden",
	"Alle ungültige Werte ausblenden": "Alle ungültige Werte ausblenden",
	"Ausblenden wenn nur eine Auswahl möglich ist": "Ausblenden wenn nur eine Auswahl möglich ist",
	"Deaktivieren wenn nur eine Auswahl möglich ist": "Deaktivieren wenn nur eine Auswahl möglich ist",
	"Komponente hervorheben": "Komponente hervorheben",
	"Dieses Material existiert bereits": "Dieses Material existiert bereits",
	"Material hinzufügen": "Material hinzufügen",
	"Materialname eingeben": "Materialname eingeben",
	Abmessungen: Abmessungen$3,
	Breite: Breite$3,
	"Höhe": "Höhe",
	Tiefe: Tiefe$3,
	Startpunkt: Startpunkt$3,
	Endpunkt: Endpunkt$3,
	"Linienstärke": "Linienstärke",
	Text: Text$4,
	"Automatisches Maß überschreiben": "Automatisches Maß überschreiben",
	"Neues Maß": "Neues Maß",
	"Textgröße als Faktor. 1 ist Standard.": "Textgröße als Faktor. 1 ist Standard.",
	Offsets: Offsets$3,
	"Hier können Abweichungen von Position und Rotation, die sich normalerweise aus Start und Endpunkt ergeben, definiert werden. Dazu kann das 3D Positionierungswerkzeug benutzt werden.": "Hier können Abweichungen von Position und Rotation, die sich normalerweise aus Start und Endpunkt ergeben, definiert werden. Dazu kann das 3D Positionierungswerkzeug benutzt werden.",
	Edit: Edit$3,
	"Script Modell Editor": "Script Modell Editor",
	"Schreiben Sie das Modell als JSX Komponente.": "Schreiben Sie das Modell als JSX Komponente.",
	"Nicht Befüllt": "Nicht Befüllt",
	"Keine Angabe": "Keine Angabe",
	"Maximale Anzahl an Iterationen erreicht! Die Regelkonflikte können nicht aufgelöst werden.": "Maximale Anzahl an Iterationen erreicht! Die Regelkonflikte können nicht aufgelöst werden."
};

var list$2 = "Liste";
var color$2 = "Farben";
var text$2 = "Text";
var boolean$2 = "Ja/ Nein";
var image$2 = "Bild";
var components$2 = "Komponenten";
var presentation$3 = "Darstellung";
var usage$3 = "Aktionen";
var values$3 = "Werte";
var rules$3 = "Regeln";
var settings$3 = "Optionen";
var images$3 = "Bilder";
var configurators$3 = "Konfiguratoren";
var street$2 = "Straße";
var zip$2 = "PLZ";
var city$2 = "Stadt";
var country$2 = "Land";
var extract$2 = "Extrahieren";
var phone$2 = "Telefon";
var username$2 = "Nutzername";
var Schritt$3 = "Schritt";
var MATERIAL$3 = "MATERIAL";
var Import$3 = "Import";
var Manuell$3 = "Manuell";
var Rotation$3 = "Rotation";
var Allgemeines$3 = "Allgemeines";
var Beschaffenheit$3 = "Beschaffenheit";
var Roughness$3 = "Roughness";
var Metallness$3 = "Metallness";
var Bilderstapel$3 = "Bilderstapel";
var Hilfe$6 = "Hilfe";
var Szeneneinstellungen$3 = "Szeneneinstellungen";
var Themes$3 = "Themes";
var Anpassung$3 = "Anpassung";
var Weiter$3 = "Weiter";
var Wertebereich$3 = "Wertebereich";
var Darstellung$3 = "Darstellung";
var Werte$3 = "Werte";
var Anfragen$3 = "Anfragen";
var Zeitpunkt$3 = "Zeitpunkt";
var Benutzer$6 = "Benutzer";
var Anfrage$3 = "Anfrage";
var URI$3 = "URI";
var Parameter$3 = "Parameter";
var Dauer$3 = "Dauer";
var Server$3 = "Server";
var amount$2 = "Anzahl";
var article$3 = "Artikel";
var Fullscreen$3 = "Vollbildmodus";
var showSelection$3 = {
	always: "Immer",
	never: "Nie",
	auto: "Wie im Konfigurator",
	label: "Anzeige in Bestätigung, PDF und Shop"
};
var Aktivieren$3 = "Aktivieren";
var Deaktivieren$3 = "Deaktivieren";
var variablesAndArticles$3 = "Merkmale und Artikel";
var variablesOnly$3 = "Nur Merkmale";
var articlesOnly$3 = "Nur Artikel";
var noOverview$3 = "Keine Übersicht";
var Auswahlpreise$3 = "Auswahlpreise";
var Variable$3 = "Variable";
var breadcrumb_app$3 = "Allgemein";
var breadcrumb_pdf$3 = "PDF";
var breadcrumb_mail$3 = "Mail";
var breadcrumb_embed$3 = "Einbetten";
var breadcrumb_shop$3 = "Shop";
var breadcrumb_articles$3 = "Artikel";
var breadcrumb_preview$3 = "Vorschau";
var breadcrumb_edit$3 = "Editor";
var breadcrumb_images$3 = "Bilder";
var breadcrumb_materials$3 = "Materialien";
var breadcrumb_models$3 = "Modelle";
var breadcrumb_rules$3 = "Regeln";
var breadcrumb_settings$3 = "Optionen";
var breadcrumb_admin$3 = "Admin";
var breadcrumb_extract$3 = "extract";
var breadcrumb_apps$3 = "Konfiguratoren";
var breadcrumb_create$3 = "Erstellen";
var breadcrumb_import$3 = "Importieren";
var breadcrumb_users$3 = "Benutzer";
var breadcrumb_support$3 = "Support";
var breadcrumb_logs$3 = "Logs";
var breadcrumb_systemStatus$3 = "Systemstatus";
var breadcrumb_trash$3 = "Papierkorb";
var breadcrumb_abonnement$3 = "Abonnement";
var breadcrumb_expired$3 = "Ausgelaufen";
var breadcrumb_profile$3 = "Profil";
var breadcrumb_configurator$3 = "Editor";
var breadcrumb_configurations$3 = "Konfigurationen";
var breadcrumb_groups$3 = "Reiter";
var breadcrumb_variables$3 = "Merkmale";
var breadcrumb_design$3 = "Design";
var breadcrumb_scene$3 = "Szene";
var breadcrumb_presentation$3 = "Darstellung";
var breadcrumb_options$3 = "Optionen";
var breadcrumb_usage$3 = "Aktionen";
var breadcrumb_values$3 = "Werte";
var deTranslationExtra = {
	list: list$2,
	color: color$2,
	text: text$2,
	boolean: boolean$2,
	image: image$2,
	components: components$2,
	presentation: presentation$3,
	usage: usage$3,
	values: values$3,
	rules: rules$3,
	settings: settings$3,
	images: images$3,
	configurators: configurators$3,
	street: street$2,
	zip: zip$2,
	city: city$2,
	country: country$2,
	extract: extract$2,
	phone: phone$2,
	username: username$2,
	"Maßkette": "Maßkette",
	"duplicate-entry": "Es existieren bereits Konten mit diesen Daten",
	"create new dealer": "Neuen Händler anlegen",
	"die Variable {{variableLabel}} ist eine KomponentenListe. Sie müssen mit einem Index wie {{variableLabel}}[0] für das 1. Element oder mit einer Array-Funktionen wie z.B. map(), find(), reduce() oder first() darauf zugreifen": "die Variable {{variableLabel}} ist eine KomponentenListe. Sie müssen mit einem Index wie {{variableLabel}}[0] für das 1. Element oder mit einer Array-Funktionen wie z.B. map(), find(), reduce() oder first() darauf zugreifen",
	"Dieser Wert ist nicht kombinierbar mit folgenden Auswahlen:": "Dieser Wert ist nicht kombinierbar mit folgenden Auswahlen:",
	"Bei Auswahl wird eine Alternative berechnet!": "Bei Auswahl wird eine Alternative berechnet!",
	"Artikel Anzahl": "Artikel Anzahl",
	"Farb auswählen": "Farb auswählen",
	"< Zurück": "< Zurück",
	"Preis Information": "Preis Information",
	Schritt: Schritt$3,
	"Ihre Eingabe war leider nicht möglich und wurde auf den nächstmöglichen Wert zurückgesetzt: ": "Ihre Eingabe war leider nicht möglich und wurde auf den nächstmöglichen Wert zurückgesetzt: ",
	"Merkmal auswählen": "Merkmal auswählen",
	MATERIAL: MATERIAL$3,
	Import: Import$3,
	"Materialien für den Import auswählen:": "Materialien für den Import auswählen:",
	"Wie möchten Sie ein Material erstellen?": "Wie möchten Sie ein Material erstellen?",
	"Import einer .glb und export der enthaltenen Materialien": "Import einer .glb und export der enthaltenen Materialien",
	Manuell: Manuell$3,
	"Eigenständiges Anlegen eines PBR-Materials": "Eigenständiges Anlegen eines PBR-Materials",
	"Die Variable wird von einer Erweiterung benötigt und kann daher nicht gelöscht werden!": "Die Variable wird von einer Erweiterung benötigt und kann daher nicht gelöscht werden!",
	"Bitten Sie den Entwickler, die Variable aus der Erweiterung zu entfernen und zu löschen.": "Bitten Sie den Entwickler, die Variable aus der Erweiterung zu entfernen und zu löschen.",
	"Die Variable wird noch in Regeln verwendet:": "Die Variable wird noch in Regeln verwendet:",
	"Löschen Sie bitte zunächst dort die entsprechende Spalte.": "Löschen Sie bitte zunächst dort die entsprechende Spalte.",
	"Anpassung nötig": "Anpassung",
	"\"Die Auswahl \"{{value}}\" ({{variable}}) passt nicht zu der Auswahl \"{{conflictValue0}}\" ({{conflictVariable0}}).\"": "\"Die Auswahl \"{{value}}\" ({{variable}}) passt nicht zu der Auswahl \"{{conflictValue0}}\" ({{conflictVariable0}}).\"",
	"Die Auswahl \"{{value}}\" ({{variable}}) passt nicht zu der Auswahl \"{{conflictValue0}}\" ({{conflictVariable0}}) und der Auswahl \"{{conflictValue1}}\" ({{conflictVariable1}}).": "Die Auswahl \"{{value}}\" ({{variable}}) passt nicht zu der Auswahl \"{{conflictValue0}}\" ({{conflictVariable0}}) und der Auswahl \"{{conflictValue1}}\" ({{conflictVariable1}}).",
	"Die Auswahl \"{{value}}\" ({{variable}}) passt nicht zu der Auswahl \"{{conflictValue0}}\" ({{conflictVariable0}}), der Auswahl \"{{conflictValue1}}\" ({{conflictVariable1}}) und der Auswahl \"{{conflictValue2}}\" ({{conflictVariable2}}).": "Die Auswahl \"{{value}}\" ({{variable}}) passt nicht zu der Auswahl \"{{conflictValue0}}\" ({{conflictVariable0}}), der Auswahl \"{{conflictValue1}}\" ({{conflictVariable1}}) und der Auswahl \"{{conflictValue2}}\" ({{conflictVariable2}}).",
	"Die Auswahl \"{{value}}\" ({{variable}}) passt nicht zu anderen Auswahlen.": "Die Auswahl \"{{value}}\" ({{variable}}) passt nicht zu anderen Auswahlen.",
	"wird zu": "wird zu",
	"Stattdessen werden folgende Auswahlen angepasst:": "Stattdessen werden folgende Auswahlen angepasst:",
	"Design & Layout": "Design & Layout",
	"Nur sichtbar im Vorschaumodus oder veröffentlichtem Konfigurator!": "Nur sichtbar im Vorschaumodus oder veröffentlichtem Konfigurator!",
	"Theme wählen": "Theme wählen",
	"Komponente löschen": "Komponente löschen",
	"Mehrfach Regelzeilen Bearbeitung": "Mehrfach Regelzeilen Bearbeitung",
	"Anzahl ausgewählte Regel-Zeilen:": "Anzahl ausgewählte Regel-Zeilen:",
	"Modelaktions-Positionierung": "Modelaktions-Positionierung",
	Rotation: Rotation$3,
	"Keine Aktionen für die Mehrfachbearbeitung vorhanden.": "Keine Aktionen für die Mehrfachbearbeitung vorhanden.",
	Allgemeines: Allgemeines$3,
	"Farben und Lichtinteraktion": "Farben und Lichtinteraktion",
	"Color-Map Upload": "Color-Map Upload",
	"Material interagiert mit Licht in der Szene": "Material interagiert mit Licht in der Szene",
	Beschaffenheit: Beschaffenheit$3,
	"Roughness-Map Upload": "Roughness-Map Upload",
	Roughness: Roughness$3,
	"Metallness-Map Upload": "Metallness-Map Upload",
	Metallness: Metallness$3,
	"Normalen-Map Upload": "Normalen-Map Upload",
	"Normalen-Skalierung": "Normalen-Skalierung",
	"Anwendung auf 3D-Modell": "Anwendung auf 3D-Modell",
	"Displacement-Map Upload": "Displacement-Map Upload",
	"Displacement-Skalierung": "Displacement-Skalierung",
	"Repeat-Faktor der Textur in X- und Y-Richtung": "Repeat-Faktor der Textur in X- und Y-Richtung",
	"Alpha-Werte": "Alpha-Werte",
	"Alpha-Map Upload": "Alpha-Map Upload",
	"Ambient Occlusion": "Ambient Occlusion",
	"Ambient-Occlusion-Map Upload": "Ambient-Occlusion-Map Upload",
	"Info editieren": "Info editieren",
	"Zeige Info-Button": "Zeige Info-Button",
	"Abhängigkeitsschleifen": "Abhängigkeitsschleifen",
	Bilderstapel: Bilderstapel$3,
	"Google Analytics Property ID": "Google Analytics Property ID",
	"Sans Serif": "Sans Serif",
	"Das flexibles Shopsystem für Ihr E-Commerce-Projekt.": "Das flexibles Shopsystem für Ihr E-Commerce-Projekt.",
	"Die eine europäische Open-Source-E-Commerce-Plattform. ": "Die eine europäische Open-Source-E-Commerce-Plattform. ",
	"Jetzt Adobe Commerce: E-Commerce leicht gemacht.": "Jetzt Adobe Commerce: E-Commerce leicht gemacht.",
	"Erstklassig im digitalen Vertrieb mit dem Oxid esales Shop.": "Erstklassig im digitalen Vertrieb mit dem Oxid esales Shop.",
	"Individuelle Entwicklung": "Individuelle Entwicklung",
	Hilfe: Hilfe$6,
	"Shop mit einer individuellen Entwicklung anbinden.": "Shop mit einer individuellen Entwicklung anbinden.",
	Szeneneinstellungen: Szeneneinstellungen$3,
	Themes: Themes$3,
	Anpassung: Anpassung$3,
	"Gewähltes Theme übernehmen": "Gewähltes Theme übernehmen",
	"Legen Sie einen neuen Konfigurationsschritt an.": "Legen Sie einen neuen Konfigurationsschritt an.",
	"Eine Konfiguration erfolgt in mehreren Schritten. In jedem Schritt können ggf. mehrere Produkt-Eigenschaften angegeben werden. Hier legen Sie den ersten Schritt an.": "Eine Konfiguration erfolgt in mehreren Schritten. In jedem Schritt können ggf. mehrere Produkt-Eigenschaften angegeben werden. Hier legen Sie den ersten Schritt an.",
	"Konfigurationsschritt erstellen": "Konfigurationsschritt erstellen",
	"Bitte klicken Sie zunächst hier, um einen neuen Konfigurator zu erstellen.": "Bitte klicken Sie zunächst hier, um einen neuen Konfigurator zu erstellen.",
	"Neuer Konfigurator wählen": "Neuer Konfigurator wählen",
	"Bitte geben Sie einen Namen ein.": "Bitte geben Sie einen Namen ein.",
	"Bitte geben Sie eine Beschreibung ein.": "Bitte geben Sie eine Beschreibung ein.",
	"Bestätigen": "Bestätigen",
	"Bitte klicken Sie hier.": "Bitte klicken Sie hier.",
	"Konfigurator Dialog aufrufen": "Konfigurator Dialog aufrufen",
	"Konfigurationsschritt benennen": "Konfigurationsschritt benennen",
	"Hier können Sie neue Werte hinzufügen.": "Hier können Sie neue Werte hinzufügen.",
	"Merkmale, die eine Liste (oder Farbe, Material, Modell) sind, zeigen mehrere Werte zur Auwahl an. Diese Werte können Sie hier eingeben.": "Merkmale, die eine Liste (oder Farbe, Material, Modell) sind, zeigen mehrere Werte zur Auwahl an. Diese Werte können Sie hier eingeben.",
	"Klicken Sie hier um einen neuen Wert zu erstellen.": "Klicken Sie hier um einen neuen Wert zu erstellen.",
	"Wenn Sie fertig sind klicken Sie hier.": "Wenn Sie fertig sind klicken Sie hier.",
	"Werte erstellen": "Werte erstellen",
	"Bitte geben Sie einen Namen für das neue Merkmal ein.": "Bitte geben Sie einen Namen für das neue Merkmal ein.",
	"Bitte wählen Sie eine Darstellung, die den Möglichkeiten des Merkmals entspricht.": "Bitte wählen Sie eine Darstellung, die den Möglichkeiten des Merkmals entspricht.",
	"Präsentation definieren": "Präsentation definieren",
	"In einem Schritt kann Ihr Kunde mehrere Merkmale seines Produktes anpassen. Fügen Sie hier das erste Merkmal ein.": "In einem Schritt kann Ihr Kunde mehrere Merkmale seines Produktes anpassen. Fügen Sie hier das erste Merkmal ein.",
	"Produktmerkmal erstellen": "Produktmerkmal erstellen",
	"Was für ein Merkmal wollen Sie anlegen?": "Was für ein Merkmal wollen Sie anlegen?",
	"Ein Merkmal kann eine Auswahl sein (z.B. die Größen S, M, L und XL), ein Text oder eine Zahl (z.B. für eine Breite oder Höhe) oder auch eine Farbe oder Material Ihres Produktes oder ein 3D-Modell, dass einen Teil Ihres Produktes darstellt.": "Ein Merkmal kann eine Auswahl sein (z.B. die Größen S, M, L und XL), ein Text oder eine Zahl (z.B. für eine Breite oder Höhe) oder auch eine Farbe oder Material Ihres Produktes oder ein 3D-Modell, dass einen Teil Ihres Produktes darstellt.",
	"Produktmerkmaltyp auswählen": "Produktmerkmaltyp auswählen",
	"Wählen sie den eben erstellten Konfigurator.": "Wählen sie den eben erstellten Konfigurator.",
	"Steuerung des Konfigurators durch das neue Merkmal.": "Steuerung des Konfigurators durch das neue Merkmal.",
	"Merkmale können z.B. dafür sorgen, dass 3D-Modelle oder Bilder angezeigt werden oder das Oberflächen geändert oder eingefärbt werden. Sie können auch eine Stückliste von Artikel erzeugen, die dann den Preis bestimmt und in den Warenkorb Ihres Shops gelegt werden kann.": "Merkmale können z.B. dafür sorgen, dass 3D-Modelle oder Bilder angezeigt werden oder das Oberflächen geändert oder eingefärbt werden. Sie können auch eine Stückliste von Artikel erzeugen, die dann den Preis bestimmt und in den Warenkorb Ihres Shops gelegt werden kann.",
	"Merkmal verwenden": "Merkmal verwenden",
	"Oberfläche ��ndern": "Oberfläche ändern",
	Weiter: Weiter$3,
	Wertebereich: Wertebereich$3,
	Darstellung: Darstellung$3,
	Werte: Werte$3,
	Anfragen: Anfragen$3,
	Zeitpunkt: Zeitpunkt$3,
	Benutzer: Benutzer$6,
	Anfrage: Anfrage$3,
	URI: URI$3,
	Parameter: Parameter$3,
	Dauer: Dauer$3,
	Server: Server$3,
	"Modell bearbeiten": "Modell bearbeiten",
	"Korrekte Mail-Adresse": "Korrekte Mail-Adresse",
	"Statistik (30 Tage)": "Statistik (30 Tage)",
	amount: amount$2,
	article: article$3,
	"Datum eingeben": "Datum eingeben",
	"Nach hause ": "Nach hause ",
	"Mandant anlegen": "Mandant anlegen",
	"Nutzer hinzufügen": "Nutzer hinzufügen",
	"Übersicht": "Übersicht",
	"Persönliche Daten": "Persönliche Daten",
	"In AR ansehen": "In AR ansehen",
	Fullscreen: Fullscreen$3,
	showSelection: showSelection$3,
	"Kamera überschreiben": "Kamera überschreiben",
	Aktivieren: Aktivieren$3,
	Deaktivieren: Deaktivieren$3,
	"Übersichtsseite": "Übersichtsseite",
	variablesAndArticles: variablesAndArticles$3,
	variablesOnly: variablesOnly$3,
	articlesOnly: articlesOnly$3,
	noOverview: noOverview$3,
	Auswahlpreise: Auswahlpreise$3,
	Variable: Variable$3,
	breadcrumb_app: breadcrumb_app$3,
	breadcrumb_pdf: breadcrumb_pdf$3,
	breadcrumb_mail: breadcrumb_mail$3,
	breadcrumb_embed: breadcrumb_embed$3,
	breadcrumb_shop: breadcrumb_shop$3,
	breadcrumb_articles: breadcrumb_articles$3,
	breadcrumb_preview: breadcrumb_preview$3,
	breadcrumb_edit: breadcrumb_edit$3,
	breadcrumb_images: breadcrumb_images$3,
	breadcrumb_materials: breadcrumb_materials$3,
	breadcrumb_models: breadcrumb_models$3,
	breadcrumb_rules: breadcrumb_rules$3,
	breadcrumb_settings: breadcrumb_settings$3,
	breadcrumb_admin: breadcrumb_admin$3,
	breadcrumb_extract: breadcrumb_extract$3,
	breadcrumb_apps: breadcrumb_apps$3,
	breadcrumb_create: breadcrumb_create$3,
	breadcrumb_import: breadcrumb_import$3,
	breadcrumb_users: breadcrumb_users$3,
	breadcrumb_support: breadcrumb_support$3,
	breadcrumb_logs: breadcrumb_logs$3,
	breadcrumb_systemStatus: breadcrumb_systemStatus$3,
	breadcrumb_trash: breadcrumb_trash$3,
	breadcrumb_abonnement: breadcrumb_abonnement$3,
	breadcrumb_expired: breadcrumb_expired$3,
	breadcrumb_profile: breadcrumb_profile$3,
	breadcrumb_configurator: breadcrumb_configurator$3,
	breadcrumb_configurations: breadcrumb_configurations$3,
	breadcrumb_groups: breadcrumb_groups$3,
	breadcrumb_variables: breadcrumb_variables$3,
	breadcrumb_design: breadcrumb_design$3,
	breadcrumb_scene: breadcrumb_scene$3,
	breadcrumb_presentation: breadcrumb_presentation$3,
	breadcrumb_options: breadcrumb_options$3,
	breadcrumb_usage: breadcrumb_usage$3,
	breadcrumb_values: breadcrumb_values$3,
	"Letzte Gruppe kann nicht gelöscht werden.": "Letzte Gruppe kann nicht gelöscht werden."
};

const de = Object.assign({}, deTranslation, deTranslationExtra);

var Mandant$2 = "Client";
var Produkt$2 = "Product";
var Bezahlzustand$2 = "Payment status";
var Addon$2 = "Addon";
var apps$2 = "Configurators";
var support$2 = "Support";
var dealers$2 = "Dealers";
var users$2 = "Users";
var trash$2 = "Trash";
var others$2 = "Others";
var links$2 = "Links";
var help$2 = "Help";
var consultation$2 = "Consultation";
var status$2 = "Status";
var subscription$2 = "Subscription";
var profile$2 = "Profile";
var logout$2 = "Log out";
var Template$2 = "Template";
var Aufrufen$2 = "Invoke";
var PDF$2 = "PDF";
var Code$2 = "Code";
var Preis$2 = "Price";
var Inspiration$2 = "Inspiration";
var Anzeige$2 = "Label";
var Bild$2 = "Image";
var Sortierung$2 = "Sort";
var Kunde$2 = "Customer";
var Inhalt$2 = "Content";
var Konfiguratorversion$2 = "Configurator version";
var Abbrechen$2 = "Cancel";
var Speichern$2 = "Save";
var Schliessen$2 = "Close";
var Adresse$2 = "Address";
var Datenschutz$2 = "Privacy policy";
var Name$2 = "Name";
var Email$2 = "Email";
var Telefon$2 = "Phone";
var Bemerkung$2 = "Remark";
var Firma$2 = "Company";
var Akzeptiert$2 = "Accepted";
var Stadt$2 = "City";
var PLZ$2 = "ZIP CODE";
var Datum$2 = "Date";
var dealer$2 = "Dealer";
var json$2 = "json";
var Price$3 = "Price";
var options$2 = "Options";
var Bestellaktion$2 = "Order Action";
var Typ$2 = "Type";
var Konfiguration$2 = "Configuration";
var AR$2 = "AR";
var Geteilt$2 = "Shared";
var anzeigen$2 = "Display";
var Artikelnummer$2 = "Article number";
var Beschreibung$2 = "Description";
var Kategorie$2 = "Category";
var Preise$2 = "Prices";
var Importieren$2 = "Import";
var Upload$2 = "Upload";
var Keine$2 = "None";
var Alle$2 = "All";
var Bilder$2 = "Images";
var Seite$2 = "Surface";
var Vorderseite$2 = "Front";
var Hinterseite$2 = "Back";
var Beidseitig$2 = "Both sides";
var Optionen$2 = "Options";
var Bezeichnung$2 = "Designation";
var Pbr$2 = "Pbr";
var Physikalisch$2 = "Physical";
var Key$2 = "Key";
var Model$2 = "Model";
var Erweitert$2 = "Advanced";
var Editieren$2 = "Edit";
var Kopieren$2 = "Copy";
var Allgemein$2 = "General";
var Sprachen$2 = "Languages";
var Produktdarstellung$2 = "Product visualization";
var Upgrade$2 = "Upgrade";
var Hauptmodell$2 = "Main Model";
var Vorlage$2 = "Template";
var Tutorial$2 = "Tutorial";
var Export$2 = "Export";
var discount$2 = "Discount";
var surcharge$2 = "Surcharge";
var Einbetten$2 = "Embed";
var Referenzsprache$2 = "Reference language";
var Artikel$2 = "Article";
var Schriftart$2 = "Font";
var Helvetica$2 = "Helvetica";
var Courier$2 = "Courier";
var Interstate$2 = "Interstate";
var Montserrat$2 = "Montserrat";
var Links$2 = "Left";
var Rechts$2 = "Right";
var Oben$2 = "Top";
var Unten$2 = "Bottom";
var Kopfzeile$2 = "Header";
var Mail$2 = "Mail";
var Shop$2 = "Shop";
var Senden$2 = "Send";
var orders$2 = "Orders";
var Tage$2 = "Days";
var date$2 = "Date";
var number$2 = "Number";
var articlename$2 = "Article Name";
var articles$2 = "Articles";
var Bezahlt$2 = "Paid";
var Wechseln$2 = "Switch";
var Anlegen$2 = "Create";
var Neu$2 = "New";
var Konfiguratoren$3 = "Konfiguratoren";
var Benutzer$5 = "Benutzer";
var Rolle$2 = "Role";
var name$2 = "name";
var email$2 = "email";
var Nutzerkonto$2 = "User account";
var Nutzername$2 = "Userame";
var create$3 = "create";
var save$2 = "save";
var Password$2 = "Password";
var Login$2 = "Login";
var Registrierung$2 = "Registration";
var Datenschutzbestimmungen$2 = "Datenschutzbestimmungen";
var AGB$2 = "TERMS AND CONDITIONS";
var Passwort$2 = "Password";
var Mandantentabelle$2 = "Table of Clients";
var Startdatum$2 = "Start date";
var Enddatum$2 = "End date";
var Konfigurator$2 = "Configurator";
var Merkmal$2 = "Variable";
var Regel$2 = "Rule";
var Nummer$2 = "Number";
var Erstellt$2 = "Created";
var Kennwort$2 = "Kennwort";
var Sprache$2 = "Language";
var Download$2 = "Download";
var Hintergrundmodell$2 = "Background model";
var Preiseinstellungen$2 = "Pricing settings";
var Standard$2 = "Standard";
var Hauptaktion$2 = "Main action";
var Kontaktformular$2 = "Contact form";
var Pflichtfeld$2 = "Mandatory field";
var Aktionsname$2 = "Action name";
var Anzahl$2 = "Count";
var Zahl$2 = "Number";
var Einheit$2 = "Unit";
var Aktionen$2 = "Actions";
var Kameras$2 = "Cameras";
var Kamera$2 = "Camera";
var Reiter$2 = "Tab";
var Kameraansicht$2 = "Camera view";
var Ok$2 = "Ok";
var Fertig$2 = "Ready";
var Auswahlen$2 = "Selections";
var Positionspreis$2 = "Item Price";
var Gesamtpreis$2 = "Total price";
var Kostenfrei$2 = "free";
var Downgrade$2 = "Downgrade";
var Home$2 = "Home";
var Hilfe$5 = "Help";
var cancel$2 = "cancel";
var Icon$2 = "Icon";
var Gruppen$2 = "Groups";
var Logo$3 = "Logo";
var Farben$2 = "Colors";
var CSS$2 = "CSS";
var Variablen$2 = "Variables";
var Einstellungen$2 = "Settings";
var Vorschau$2 = "Preview";
var Editor$2 = "Editor";
var Regeln$2 = "Rules";
var Articles$2 = "Articles";
var Modelle$2 = "Models";
var Materialien$2 = "Materials";
var Bestellungen$2 = "Orders";
var Fatal_Error_Text$2 = "";
var Fatal_Error$2 = "";
var Error_Message$2 = "";
var Abschnitt$2 = "Section";
var Bestelloptionen$2 = "Order options";
var hiddenGroup$2 = "This group is currently only visible here (in admin-panel), because it contains only variables with no selectable options";
var Bearbeiten$2 = "Edit";
var Leer$2 = "Blank";
var Basiseinstellungen$2 = "Basic settings";
var Deckkraft$2 = "Opacity";
var Anwenden$2 = "Apply";
var Auswahl$2 = "Selection";
var Duplizieren$2 = "Duplicate";
var Ersetzen$2 = "Replace";
var Statistics$2 = "Statistics";
var Konfigurationen$2 = "Configurations";
var articleNo$2 = "ArticleNo";
var articleName$2 = "ArticleName";
var price$2 = "Price";
var currency$2 = "Currency";
var Cancel$2 = "Cancel";
var Save$2 = "Save";
var Startanzahl$2 = "Start number";
var Endanzahl$2 = "End count";
var Suchen$2 = "Search";
var Ctrl$2 = "Ctrl";
var Hervorhebung$2 = "Highlight";
var Expression$2 = "Expression";
var Ergebnis$2 = "Result";
var Mindestwert$2 = "Minimum value";
var Maximalwert$2 = "Maximum value";
var Nachkommastellen$2 = "Decimal places";
var Schrittweite$2 = "Step size";
var Berechnet$2 = "Calculate";
var Wert$2 = "Value";
var Farbauswahl$2 = "Color Selection";
var Komponente$2 = "Component";
var Komponentenliste$2 = "Component List";
var Bildauswahl$2 = "Image Selection";
var Zahleneingabe$2 = "Number input";
var Dropdown$2 = "Dropdown";
var Schalter$2 = "Switch";
var Texteingabe$2 = "Text input";
var Beispieltext$2 = "Sample text";
var Optional$2 = "Optional";
var Versteckt$2 = "Hidden";
var Position$2 = "Position";
var Scale$2 = "Scale";
var Modell$2 = "Model";
var Material$2 = "Material";
var Komponenten$2 = "Components";
var Druck$2 = "Print";
var Farbe$2 = "Color";
var Regelname$2 = "Rule name";
var Produktstruktur$2 = "Product structure";
var Materialnamen$2 = "Material names";
var Merkmalskombinationen$2 = "Characteristic combinations";
var Merkmale$2 = "Characteristics";
var Erstellen$2 = "Create";
var Komponentenmerkmale$2 = "Component proper";
var Herunterladen$2 = "Download";
var Verbinden$2 = "Connect";
var Templatname$2 = "Template name";
var Farbwert$2 = "Color value";
var Ansicht$2 = "View";
var URL$3 = "URL";
var Auswahlwerte$2 = "Values";
var Abmessungen$2 = "Dimensions";
var Breite$2 = "Width";
var Tiefe$2 = "Depth";
var Startpunkt$2 = "Start point";
var Endpunkt$2 = "End point";
var Text$3 = "Text";
var Offsets$2 = "Offsets";
var Edit$2 = "Edit";
var enTranslation = {
	"Sie zahlen nicht online. Bitte wenden Sie sich an den Mitarbeiter in Ihrem Unternehmen, der den Vertrag mit ObjectCode geschlossen hat.": "You do not pay online. Please contact the employee in your company who has signed the contract with ObjectCode..",
	Mandant: Mandant$2,
	Produkt: Produkt$2,
	Bezahlzustand: Bezahlzustand$2,
	"Gültig von": "Valid from",
	"Nicht angegeben": "Not specified",
	"Gültig bis": "Valid until",
	Addon: Addon$2,
	apps: apps$2,
	support: support$2,
	"dealer-profile": "dealer-profile",
	dealers: dealers$2,
	users: users$2,
	trash: trash$2,
	others: others$2,
	links: links$2,
	help: help$2,
	consultation: consultation$2,
	status: status$2,
	subscription: subscription$2,
	profile: profile$2,
	logout: logout$2,
	"Neuer Konfigurator": "New configurator",
	Template: Template$2,
	"Zurück": "Back",
	Aufrufen: Aufrufen$2,
	PDF: PDF$2,
	Code: Code$2,
	Preis: Preis$2,
	Inspiration: Inspiration$2,
	Anzeige: Anzeige$2,
	Bild: Bild$2,
	Sortierung: Sortierung$2,
	"Sie möchten die Daten dieses Kunden einsehen?": "Would you like to view this customer's data?",
	Kunde: Kunde$2,
	Inhalt: Inhalt$2,
	"Shop-API": "Store API",
	"Gespeichert am": "Saved on",
	Konfiguratorversion: Konfiguratorversion$2,
	Abbrechen: Abbrechen$2,
	Speichern: Speichern$2,
	"Ergebnis der Shop API": "Store API result",
	Schliessen: Schliessen$2,
	Adresse: Adresse$2,
	Datenschutz: Datenschutz$2,
	Name: Name$2,
	Email: Email$2,
	Telefon: Telefon$2,
	Bemerkung: Bemerkung$2,
	Firma: Firma$2,
	"Steuer-ID": "Tax ID",
	Akzeptiert: Akzeptiert$2,
	Stadt: Stadt$2,
	PLZ: PLZ$2,
	Datum: Datum$2,
	"exit-action": "Exit action",
	dealer: dealer$2,
	"order-status": "Order status",
	json: json$2,
	Price: Price$3,
	options: options$2,
	Bestellaktion: Bestellaktion$2,
	Typ: Typ$2,
	Konfiguration: Konfiguration$2,
	AR: AR$2,
	Geteilt: Geteilt$2,
	"Sie möchten die Daten Ihrer Kunden einsehen?": "Would you like to view your customers' data and requests?",
	"Preise anlegen": "Create prices",
	anzeigen: anzeigen$2,
	Artikelnummer: Artikelnummer$2,
	"Artikelnummer eingeben": "Enter article number",
	"Namen eingeben": "Enter names",
	Beschreibung: Beschreibung$2,
	"Beschreibung eingeben": "Enter description",
	Kategorie: Kategorie$2,
	"Kategorien eingeben": "Enter categories",
	Preise: Preise$2,
	"Sie möchten Preise anzeigen?": "Would you like to display prices?",
	Importieren: Importieren$2,
	"Artikel und Preise veröffentlichen": "Publish articles and prices",
	"Neuer Artikel": "New article",
	Upload: Upload$2,
	"Laden Sie ein oder mehrere Bilder in den angegeben Ordner hoch. Die können den Schrägstrich (/) verwenden, um tiefere Ordner zu erzeugen.": "Upload one or more images to the specified folder. They can use the slash (/) to create deeper folders...",
	"Alternativ können Sie ein ZIP-Archiv mit einer Ordnerstruktur hochladen.": "Alternatively, you can upload a ZIP archive with a folder structure..",
	"Ordner *": "folder *",
	"Beachten Sie: Alle Bilder in einem Ordner werden als Galerie gruppiert, nach Name sortiert. Verwenden Sie also Dateinamen wie \"Bild_001\".": "Note: All images in a folder are grouped, sorted by name. So use file names like \"image_001\".",
	Keine: Keine$2,
	Alle: Alle$2,
	"Löschen": "Delete",
	Bilder: Bilder$2,
	Seite: Seite$2,
	Vorderseite: Vorderseite$2,
	Hinterseite: Hinterseite$2,
	Beidseitig: Beidseitig$2,
	"new-material": "New Material",
	Optionen: Optionen$2,
	Bezeichnung: Bezeichnung$2,
	Pbr: Pbr$2,
	Physikalisch: Physikalisch$2,
	Key: Key$2,
	"AR Fallback Material": "AR Fallback Material",
	"Nicht ausgewählt": "Not Selected",
	Model: Model$2,
	Erweitert: Erweitert$2,
	"Nur in Regeln verwendete Materialien anzeigen": "Show only materials used in rules",
	"extract-materials": "extract-materials",
	Editieren: Editieren$2,
	Kopieren: Kopieren$2,
	"Neues Modell": "New model",
	"Dynamisches Modell": "Dynamic model",
	"Gültigkeit": "Validity",
	"Neue Regel": "New Rule",
	"Neue Regel Erstellen": "Create new rule",
	"Regel erstellen": "Create Rule",
	Allgemein: Allgemein$2,
	Sprachen: Sprachen$2,
	"Die erste Sprache gilt als Standard.": "The first language is the default.",
	"Die Beschreibung dieses Konfigurators": "The description of this configurator",
	"Link zum Konfigurator": "Link to the configurator",
	"Falls Sie eine Erweiertung nutzen, tragen Sie hier ein, wo Ihr Entwickler sie zur Verfügung stellt.": "If you use an extension, enter here where your developer provides it...",
	Produktdarstellung: Produktdarstellung$2,
	"3D-Modell": "3D-Model",
	"Bilder-Konfigurator": "Image configurator",
	"Google Analytics 4 Property ID": "Google Analytics 4 Property ID",
	"Sie müssen für den Google Cookie die Einverständnis des Nutzers einholen. Das passiert nicht innerhalb des K3!": "You must obtain the user's consent for the Google cookie. This does not happen within the K3!",
	"Sie möchten Ihr Analytics-Konto verbinden?": "Would you like to connect your Analytics-account?",
	Upgrade: Upgrade$2,
	Hauptmodell: Hauptmodell$2,
	"Hauptmodell entfernen": "Remove Main Model",
	Vorlage: Vorlage$2,
	"Dieser Konfigurator dient als Vorlage": "This configurator is a template",
	Tutorial: Tutorial$2,
	"Standard übernehmen": "Apply default",
	"screenshot-quality": "Screenshot quality",
	Export: Export$2,
	"app-code-duplicate": "App code already in use",
	"Ihre Händler sollen Ihren Konfigurator nutzen können?": "Would you like your deals to use your configurator?",
	"Keine Händler vorhanden": "No existing dealers",
	"Legen Sie zuerst einen Händler an - dann geben Sie ihm hier Zugriff auf die App.": "First create a dealer - then authorize them to the app here.",
	"Jetzt Händler anlegen": "Create dealer now",
	"to dealer app": "to dealer app",
	"dealer query": "Input presets",
	discount: discount$2,
	surcharge: surcharge$2,
	Einbetten: Einbetten$2,
	"Als Link": "As Link",
	"Als IFrame": "As IFrame",
	"Referenzsprache. Die Einträge müssen mit der Referenzspalte in der importierten Datei übereinstimmen, um berücksichtigt zu werden.": "Reference language. The entries must match the reference column in the imported file in order to be taken into account.",
	"Wrong file format, be sure to use the format of the exported file for the currently selected reference language.": "Wrong file format, be sure to use the format of the exported file for the currently selected reference language.",
	"Importiere XLSX": "Import XLSX",
	"Exportiere XLSX": "Export XLSX",
	Referenzsprache: Referenzsprache$2,
	"Werden berücksichtigt:": "Are taken into account:",
	Artikel: Artikel$2,
	"Versteckte Variablen": "Hidden variables",
	"Unbenutzte Sprachen": "Unused languages",
	"Sie möchten Ihren Kunden und/oder sich selbst Anfragen per E-Mail senden?": "Would you like to forward requests to the customer or yourself?",
	"Mail Texte": "Mail texts",
	"Hier können Sie den Inhalt der versendeten Mails anpassen. Lesen Sie vorab den Abschnitt in der Dokumentation.": "Here you can customize the content of the sent mails. Read the section in the documentation beforehand...",
	"Bitte beachten Sie: Sie müssen immer den Konfigurator veröffentlichen, bevor die geänderten Texte verwendet werden.": "Please note: you must always publish the configurator before using the modified texts.",
	"Sie möchten Bestätigungen oder Angebote als PDF senden?": "Would you like to send a PDF of confirmations or offers?",
	"Sie möchten den Konfigurator veröffentlichen?": "Would you like to publish the configurator?",
	"PDF Einstellungen": "PDF Settings",
	Schriftart: Schriftart$2,
	Helvetica: Helvetica$2,
	"Times Roman": "Times Roman",
	Courier: Courier$2,
	Interstate: Interstate$2,
	Montserrat: Montserrat$2,
	"Nunito Sans": "Nunito Sans",
	"Poppins Bold": "Poppins Bold",
	"Schriftgröße": "font size",
	"Seitenränder": "Margins",
	Links: Links$2,
	Rechts: Rechts$2,
	Oben: Oben$2,
	Unten: Unten$2,
	Kopfzeile: Kopfzeile$2,
	"Fußzeile": "Footer",
	"Neue PDF Vorlage auswählen": "Select new PDF template",
	"Vorhandene PDF Vorlage löschen": "Delete existing PDF template",
	"Voransicht mit dieser Konfiguration:": "Preview with this configuration:",
	"und diesem Template:": "and the template:",
	"Speichern und drucken": "Save and print",
	"Für eine Voransicht speichern Sie eine Konfiguration ab.": "For preview, save a configuration",
	"Dann können Sie sie hier drucken.": "Then you can print it here",
	Mail: Mail$2,
	Shop: Shop$2,
	"Social Sharing": "Social Sharing",
	"Wir helfen gern!": "We're here for you!",
	"Ihre Telefonnummer": "Your phone number",
	"Ihre Nachricht": "Your message",
	Senden: Senden$2,
	orders: orders$2,
	"Preise wurden in den Einstellungen deaktiviert": "Prices have been disabled in the settings",
	"Keine Einnahmen vorliegend": "No revenue present",
	"total-earnings": "Total earnings",
	Tage: Tage$2,
	date: date$2,
	number: number$2,
	articlename: articlename$2,
	articles: articles$2,
	"Sie können einen Konfigurator unter \"Einstellungen\" exportieren. Die entstandene Datei können Sie hier wieder importieren.": "You can export a configurator under \"Settings\". You can import the resulting file back here.",
	"JSON Export Datei": "JSON export file",
	"Leerer Konfigurator": "Empty configurator",
	"Starten Sie mit einem leeren Konfigurator und richten Sie ihn nach Ihren Wünschen ein.": "Start with an empty configurator and set it up according to your wishes.",
	"Konfigurator importieren": "Import configurator",
	"Importieren sie einen Konfigurator anhand einer exportierten Datei.": "Import a configurator based on an exported file.",
	Bezahlt: Bezahlt$2,
	"Gebucht ab": "Booked from",
	"Gebucht bis": "Booked until",
	"Mandant erfolgreich geändert": "Client successfully changed",
	"Mandant erfolgreich angelegt": "Client successfully created",
	"E-Mail": "E-mail",
	"Einstiegs-Produkt": "Initial product",
	"Stripe ID": "Stripe ID",
	"Angelegt am": "Created on",
	"Wird gelöscht am": "To be deleted at",
	"Zu diesem Datum wird der Mandant rückstandlos gelöscht!": "On this date, the client will be deleted completely!",
	"Der vollständige Mandant wird exportiert - inklusive aller Assets. Sind Sie sicher?": "The client will be fully exported - all assets included. Are you sure?",
	Wechseln: Wechseln$2,
	Anlegen: Anlegen$2,
	Neu: Neu$2,
	Konfiguratoren: Konfiguratoren$3,
	Benutzer: Benutzer$5,
	Rolle: Rolle$2,
	"Vielen Dank für Ihre Bestätigung...": "Thank you for your confirmation..",
	"E-Mail Bestätigung": "Email confirmation",
	"Zur Anmeldung": "To login",
	name: name$2,
	email: email$2,
	"E-Mail ist ungültig!": "Email is invalid!",
	Nutzerkonto: Nutzerkonto$2,
	Nutzername: Nutzername$2,
	"Mail ist schon vergeben": "Email is already taken",
	"code-duplicate": "code-duplicate",
	"dealer code helper text": "To open the dealer configurator.",
	"default discount": "default discount",
	"default surcharge": "default surcharge",
	"Pro Abo": "Per Abo",
	"is pro dealer": "is pro dealer",
	"Bitte überprüfen Sie die von Ihnen gemachten Angaben: ": "Please check the information you have provided:",
	create: create$3,
	save: save$2,
	"Fehlendes Produkt": "Missing product",
	"Ihre Händler sollen einen Ihrer Konfiguratoren nutzen können?": "Do you want your dealers to use one of your configurators?",
	"Bitte buchen Sie dort zunächst ein anderes Produkt.": "Bitte buchen Sie dort zunächst ein anderes Produkt.",
	"new dealer": "New Dealer",
	"Login screen": "Login",
	Password: Password$2,
	Login: Login$2,
	"Passwort vergessen?": "Forgot password?",
	"Noch kein Konto?": "Noch kein Konto?",
	"Ein Login war leider nicht möglich. Die Kombination aus E-Mail und Passwort ist ungültig.": "We were not able to log you on. Email and/or password are invalid",
	"Falls die Mail in den nächsten Minuten nicht ankommt, schauen Sie bitte auch in Ihrem SPAM-Ordner nach und kontrollieren Sie Ihre Adresse.": "If the mail does not arrive in the next few minutes, please also check your SPAM folder and check your address...",
	"Wir senden Ihnen eine Mail mit Hinweisen zum Setzen eines neuen Kennwortes.": "We will send you a mail with instructions on how to set a new password.,",
	"Mail senden": "Send mail",
	Registrierung: Registrierung$2,
	"Bitte bestätigen Sie unsere ": "Please confirm our ",
	Datenschutzbestimmungen: Datenschutzbestimmungen$2,
	" und unsere ": " und unsere ",
	AGB: AGB$2,
	"Jetzt registrieren": "Jetzt registrieren",
	"Bereits angemeldet?": "Bereits angemeldet?",
	"Herzlich willkommen!": "Welcome!",
	"Wir haben Ihnen eine E-Mail gesendet - schauen Sie auch in Ihren Spam-Ordner.": "We have sent you an e-mail - please also check your spam folder..",
	"Sie können sich aber auch jetzt gleich mit Ihren Daten anmelden:": "You can also register right now with your data:",
	"Die Registrierung war leider nicht möglich.": "Sorry, registration was not possible",
	"Wir haben Ihr Kennwort neu gesetzt.": "We have reset your password",
	"Passwort setzen": "Set password",
	Passwort: Passwort$2,
	"Mindestens 8 Zeichen, Groß-, Kleinbuchstaben und Zahlen": "At least 8 characters, upper, lower case letters and numbers",
	"Bestätigung": "Confirmation",
	"Bestätigung stimmt nicht überein": "Confirmation does not match",
	"Kennwort setzen": "Set password",
	Mandantentabelle: Mandantentabelle$2,
	"Händleraktivierungen": "Dealer activations",
	Startdatum: Startdatum$2,
	Enddatum: Enddatum$2,
	"Mandanten wechseln": "Change client",
	"Mandanten editieren": "Edit client",
	"Neuer Mandant": "New client",
	Konfigurator: Konfigurator$2,
	Merkmal: Merkmal$2,
	Regel: Regel$2,
	Nummer: Nummer$2,
	Erstellt: Erstellt$2,
	"Gelöscht": "Deleted",
	"Zurücklegen": "Put back",
	"Mindestlänge": "Min {{chars}} chars required",
	"Email Adresse ist ungültig": "Email address is invalid",
	Kennwort: Kennwort$2,
	"Test stimmt nicht überein": "Test does not match",
	"Telefonnummer ist ungültig": "Phone number is invalid",
	Sprache: Sprache$2,
	"Entwickler Modus": "Developer Mode",
	"Gibt Entwicklern Zugriff auf erweiterte Möglichkeiten.": "Gives developers access to advanced capabilities",
	"API Token": "API Token",
	"Wenn Sie ein neues API Token erzeugen, werden alle bisherigen gelöscht.": "On creation of a new token, all others are deleted.",
	"Damit verlieren auch alle von Ihnen verbundenen Shops Zugriff auf den Konfigurator.": "Thus all shops get disconnected.",
	"Sie können das Token im Shop-Plugin eintragen.": "Put the token into the shop plugin.",
	"Notieren Sie sich das neue Token, es wird hier nur einmalig angezeigt.": "Please take a note of the token, it is only displayed once.",
	"Mit dem ApiToken erhält ein Shop oder Ihre individuelle Entwicklung Zugriff auf die Daten Ihrer Konfiguratoren.": "The ApiToken gives a store or your custom development access to your configurators data...",
	"new user": "New User",
	"Neuen Nutzer anlegen": "Create new user",
	"E-Mail nicht valide!": "Email not valid!",
	"Wir senden dem neuen Nutzer eine E-Mail mit einem Link. Dort kann er sein Kennwort setzen und erhält dann Zugang zu Ihrem Konfigurator.": "We will send the new user an e-mail with a link. There he can set his password and then he will get access to your configurator..",
	"Bitte überprüfen Sie die von Ihnen gemachten Angaben:": "Please check the information you have provided:",
	"Sie möchten dynamische Modelle nutzen und damit z.B. Produkte auf Maß verkaufen?": "Do you want to use dynamic models to sell customised products?",
	"Hinzufügen": "Add",
	"Das Modell überschreitet mit {{curr}} die empfohlene Anzahl von {{max}} Dreiecken. Eventuell kann es zu Problemen im AR Modus kommen.": "The model with {{curr}} triangles is exceeding the recommended amount of {{max}} triangles. This may lead to problems in AR mode.",
	"Das Modell überschreitet mit {{curr}}MB die empfohlene Dateigröße von {{max}}MB.": "The model's file size of {{curr}}MB is exceeding the recommended file size of {{max}}MB.",
	"3D-Modell auswählen": "Choose 3D-Model",
	Download: Download$2,
	Hintergrundmodell: Hintergrundmodell$2,
	"material-upload": "material-upload",
	"main-model": "main-model",
	"Wirft Schatten": "Casts shadows",
	"Wird schattiert": "Receives shadows",
	"Bilder Galerie": "Image Gallery",
	"Neue Aktion": "New Action",
	Preiseinstellungen: Preiseinstellungen$2,
	"Preise im Konfigurator ausblenden?": "Hide prices?",
	Standard: Standard$2,
	Hauptaktion: Hauptaktion$2,
	Kontaktformular: Kontaktformular$2,
	"Sie können diese Kundendaten zwar erfassen, aber nicht einsehen.": "You may receive notifications about but not actually view customer orders",
	Pflichtfeld: Pflichtfeld$2,
	"Sie können Links zu Ihren eigenen Dokumenten mit <a href=\"https://ihre-domain.de/ihre-datenschutzbestimmungen.html\" target=\"_blank\">Datenschutzhinweise</a> einbauen.": "You may include links as <a href=\"https://your-domain.com/privacy.html\" target=\"_blank\">Privacy</a>.",
	Aktionsname: Aktionsname$2,
	"Shop verbinden": "Shop verbinden",
	"Überschrift Bestätigung": "Confirmation title",
	"Text Bestätigung": "Confirmation text",
	"Link zur Konfiguration zeigen?": "Show link to configuration?",
	"Thumbnail des Konfigurators": "Configurator Thumbnail",
	"Desktop Gerät erkannt": "Desktop device detected",
	"Augmented-Reality ist aktuell nur auf aktuellen iOS- oder androidOS-Smartphones verfügbar. Scannen Sie daher einfach diesen QR-Code mit der Kamera-App Ihres Smartphones:": "Augmented reality is currently only available on current iOS or androidOS smartphones. Therefore, simply scan this QR code with the camera app of your smartphone:",
	"Export des 3D-Objekts": "Export the 3D object",
	"Bereitstellen der AR-Datei": "Deploy the AR file",
	"Kein Artikel ausgewählt!": "No item selected!",
	"Artikel auswählen": "Select article",
	Anzahl: Anzahl$2,
	"Wert eingeben": "Enter value",
	"Neue Spalte": "New column",
	"Wert-Eigenschaft": "Value property",
	"Sie können den Werten dieses Merkmals Eigenschaften geben, z.B.             Gewicht oder Güteklasse oder Leistung. Diese Eigenschaften können             Sie für jeden Wert getrennt erfassen und dann dem Benutzer ausgeben. Sie             können mit diesen Eigenschaften aber auch Regeln und Berechnungen             deutlich einfacher machen.": "You can give properties to the values of this characteristic, for example, weight or grade or power. You can enter these properties separately for each value and then output them to the user. But you can also use these properties to make rules and calculations much simpler..",
	"Eigenschaft wird dem Nutzer angezeigt": "property is displayed to the user",
	"mehrsprachiger Text": "multilingual text",
	"nicht übersetzter Text": "untranslated text",
	Zahl: Zahl$2,
	Einheit: Einheit$2,
	"Fokus auf Modelle": "Focus on models",
	"Alle Modelle": "All models",
	"Fokus über Objektnamen": "Focus on object names",
	"Aktuelle Ansicht übernehmen und Speichern": "Accept current view and save",
	Aktionen: Aktionen$2,
	"Kamera bearbeiten": "Edit camera",
	"Noch keine Kamera gespeichert": "No camera saved yet",
	"Kameras gespeichert: ": "Cameras saved: ",
	Kameras: Kameras$2,
	Kamera: Kamera$2,
	Reiter: Reiter$2,
	Kameraansicht: Kameraansicht$2,
	"Kamera speichern": "Save Camera",
	"Bitte auswählen": "Please select",
	"Ausgewählt": "Selected",
	"Merkmal setzen: ": "Set characteristic: ",
	"Keine Farbe ausgewählt!": "No color selected!",
	"Farbe auswählen": "Select colour",
	"Farbmerkmal auswählen:": "Select color feature:",
	"Keine Auswahl": "No selection",
	"Sind Sie sicher?": "Are you sure?",
	Ok: Ok$2,
	"Ergebnis: ": "Result:",
	"Ihre Konfiguration wurde gespeichert": "Your configuration has been saved",
	"Mit diesem Link können Sie Ihre Konfiguration wieder aufrufen: ": "You can use this link to recall your configuration: ",
	"Sie sollten zum Shop weitergeleitet worden sein. Wenn Sie nicht weitergeleitet wurden klicken Sie bitte hier, um Ihre Bestellung abzuschließen: ": "You should have been redirected to the shop. If you have not been redirected, please click here to finalise your order:",
	"Zum Shop": "To the shop",
	"Ihre Konfiguration konnte nicht gespeichert werden.": "Your configuration could not be saved.",
	"Bitte entschuldigen Sie. Wir haben die Konfiguration in diesem Browser gesichert. Bitte kommen Sie später noch einmal wieder.": "Please excuse. We have saved the configuration in this browser. Please come back later.",
	"technische Information:": "technical information:",
	Fertig: Fertig$2,
	"Neues Produkt auswählen": "Select new product",
	"Neues Produkt hinzufügen": "Add new product",
	Auswahlen: Auswahlen$2,
	"Pos.": "item",
	Positionspreis: Positionspreis$2,
	Gesamtpreis: Gesamtpreis$2,
	"Preis: ": "Price: ",
	"Kameras für Bestellungsbilder": "Cameras for order images",
	"Anfrage erhalten": "Request received",
	"Buchung erfolgreich": "Booking successful",
	"Für das neue Produkt melden wir uns bei Ihnen.": "We will contact you regarding the new product.",
	"Ihre Subskription wurde angepasst.": "Your subscription has been updated.",
	"Ihre Subskription wurde beendet.": "Your subscription was cancelled.",
	"Das Produkt wurde gebucht.": "The product has been booked.",
	"Meine Rechnungen": "My invoices",
	"Auf Anfrage": "On request",
	Kostenfrei: Kostenfrei$2,
	"{{fee}},- EUR pro Monat": "{{fee}},- EUR per month",
	"Derzeit gebucht.": "Now booked.",
	"Sie buchen nun ein neues Produkt.": "You are booking a new product.",
	Downgrade: Downgrade$2,
	"Ihre K3 Buchung": "Ihre K3 Buchung",
	"In neuem Tab öffnen": "Open in new tab",
	"Konfigurator anpassen": "Customize Configurator",
	"main drawer": "This is a preview of your configurator. Click on an edit icon to change something, or:",
	"Ändern Sie die Bestelloptionen": "Change the order options",
	"Ändern Sie das Design": "Change the design",
	"Passen sie die 3D Szene an": "Customize the 3D scene",
	"Speichern Sie die aktuelle Kamera für Bestellungsbilder": "Save the current camera for order images",
	"Nutzen Sie die Hilfe": "Use the help",
	"Gruppen und Merkmale anpassen:": "Adapt Steps and Characteristics:",
	"Gruppen verwalten": "Manage groups",
	"Merkmale verwalten": "Manage features",
	"So richten Sie Ihren Konfigurator ein:": "This is how you set up the configurator:",
	Home: Home$2,
	Hilfe: Hilfe$5,
	"Ihr K3": "Your K3",
	"dealer sidebar": "Dealer sidebar",
	"change design": "Change design",
	"change logo": "Change logo",
	"change price": "Change price",
	"change pdf": "Change PDF template",
	"PDF Gestaltung": "PDF Design",
	"Laden Sie ein PDF als Vorlage für den Druck hoch.": "Upload a PDF as a template for printing.",
	cancel: cancel$2,
	"app surcharge": "Set price surcharge",
	"you can change your surcharge here": "you can change your surcharge here",
	"Neue Gruppe": "New group",
	"Neuer Reiter": "New step",
	Icon: Icon$2,
	"Icon Bilddatei": "Icon image file",
	"Icon position": "Icon position",
	"Icon Größe": "Icon size",
	"Ersetze Weiter mit Aktionsauswahl": "Replace Next with Action Selection",
	"Aktionsnamen überschreiben": "Override action name",
	"Individuelles Gruppen-Design": "Custom group design",
	Gruppen: Gruppen$2,
	"Gruppen editieren": "Edit groups",
	"Desktop Layout": "Desktop Layout",
	"Reiter schrittweise einblenden": "Show tabs step by step",
	"Besuchte Reiter abhaken": "Check off visited tabs",
	"Desktop Layout wählen": "Choose desktop layout",
	"Schließen": "Close",
	"Mobile Layout": "Mobile Layout",
	"Mobile Layout wählen": "Select mobile layout",
	Logo: Logo$3,
	"Konfigurator-Abschluss": "Configurator Finalisation",
	"3D Szene": "3D Szene",
	"Manuelle Einstellung erstellen": "Create manual setting",
	"Design & Theme": "Design & Theme",
	Farben: Farben$2,
	"Farbanpassungen zurücksetzten": "Reset color adjustments",
	CSS: CSS$2,
	"Sie können das Aussehen Ihres Konfigurators auch mittels CSS individuell anpassen:": "You can also customize the look of your configurator using CSS:",
	"Link zur CSS-Datei": "Link to CSS file",
	"Oder laden Sie eine CSS Datei hoch:": "Or upload a CSS file:",
	"Neues Merkmal": "New Feature",
	Variablen: Variablen$2,
	"Variablen editieren": "Edit variables",
	Einstellungen: Einstellungen$2,
	"Dynamische Texte": "Dynamic texts",
	Vorschau: Vorschau$2,
	Editor: Editor$2,
	Regeln: Regeln$2,
	Articles: Articles$2,
	Modelle: Modelle$2,
	Materialien: Materialien$2,
	Bestellungen: Bestellungen$2,
	"Inhalte: ": "Contents: ",
	"Bevor der Konfigurator genutzt werden kann, müssen sie den Knopf \"Veröffentlichen\" betätigen. Wenn Sie danach Änderungen vornehmen, werden diese auch erst nach der nächsten Veröffentlichung wirksam.": "Before the configurator can be used, they must press the button \"Publish\". If you make changes after that, they will also take effect after the next publication.",
	"Live Version": "Live Version",
	"Veröffentlichen": "Publish",
	"Erstelle Option: ": "Create option: ",
	Fatal_Error_Text: Fatal_Error_Text$2,
	Fatal_Error: Fatal_Error$2,
	"Fehlermeldung:": "Error message:",
	"Zur Startseite": "To the home page",
	"Neu Laden": "Reload",
	"Cleanup und Neu Laden": "Cleanup and Reload",
	Error_Message: Error_Message$2,
	"Die folgenden Gründe sprechen gegen eine Löschung:": "The following reasons speak against deletion:",
	"einer Erweiterung. Bitten Sie den Entwickler die Nutzung zu entfernen und löschen Sie dann den Key.": "of an extension. Ask the developer to remove the usage and then delete the key.",
	"der Definition der Regel": "the definition of the rule",
	"einem Eintrag in Regel": "an entry in rule",
	"einer berechneten Eigenschaft des Modells": "a calculated property of the model",
	"der Formel von": "the formula of",
	"der Kamera": "the camera",
	"des Merkmals": "the feature",
	"der Gruppe": "the group",
	"der globalen Kamera": "the global camera",
	"Löschen Sie bitte zunächst die anderen Referenzen.": "Please delete the other references first.",
	Abschnitt: Abschnitt$2,
	"Bitte legen Sie einen Reiter an!": "Please create a tab!",
	"Gruppe editieren": "Edit tab",
	Bestelloptionen: Bestelloptionen$2,
	"Merkmal editieren": "Edit feature",
	hiddenGroup: hiddenGroup$2,
	"Label eingeben": "Enter label",
	Bearbeiten: Bearbeiten$2,
	"Bilder auswählen": "Select images",
	"Ordner auswählen:": "Select folder:",
	"Bildmerkmal: ": "Image Feature: ",
	"Kein Bild ausgewählt": "No image selected",
	"Bild auswählen": "Select image",
	"Bildmerkmal auswählen:": "Select image feature:",
	"Befüllt": "Filled",
	Leer: Leer$2,
	"Zustand auswählen": "Select State",
	"Kein Komponente ausgewählt!": "No component selected!",
	"Komponente auswählen": "Select component",
	"Intervall eingeben": "Enter Interval",
	"Zum Dashboard": "Go to dashboard",
	Basiseinstellungen: Basiseinstellungen$2,
	"Helles Theme": "Bright Theme",
	"Erweiterte Einstellungen": "Advanced Settings",
	"Label hinzufügen: ": "Add Label: ",
	"Kein Label ausgewählt!": "No label selected!",
	"Was soll angezeigt werden?": "What should be displayed?",
	"Maximalgröße": "Max size",
	Deckkraft: Deckkraft$2,
	"Kein Material ausgewählt!": "No material selected!",
	"Material auswählen": "Select material",
	"Material auswählen:": "Select material:",
	"Beschränkung der Auswirkungen auf bestimmte Modelle": "Restricting the effects to specific models",
	"Welches Teil soll hinzugefügt werden?": "Which part should be added?",
	"Mobile Theme wählen": "Select mobile theme",
	"Layout auswählen": "Choose layout",
	"Layout erstellen": "Create layout",
	"Gewähltes Layout kopieren": "Copy selected layout",
	Anwenden: Anwenden$2,
	"Kein Modell ausgewählt!": "No model selected!",
	"Modell auswählen": "Select model",
	"Modell hinzufügen:": "Add Model:",
	"Globale Änderung": "Global Change",
	"Oberflächen": "Surfaces",
	"Ausgewählte Oberflächen": "Selected surfaces",
	"Eintrag darf nicht leer sein.": "Entry must not be empty.",
	"Alle Werte": "All values",
	"Werte auswählen": "Select values",
	Auswahl: Auswahl$2,
	"Hoch schieben": "Move up",
	"Runter schieben": "Move down",
	Duplizieren: Duplizieren$2,
	"Sortierung anwenden": "Apply sorting",
	"Das Dateiformat ist nicht erlaubt! Keine Datei gewählt.": "The file format is not allowed! No file selected.",
	"Erlaube Formate:": "Allow formats:",
	"Keine Datei gewählt.": "No file selected.",
	"Das Dateiformat ist nicht erlaubt!": "The file format is not allowed!",
	Ersetzen: Ersetzen$2,
	"Bild hochladen": "Upload image",
	"Diese Variable ist nicht erlaubt.": "This Variable is not permitted.",
	"Merkmal-Info editieren": "Edit Feature Info",
	"Vorlage wählen": "Choose template",
	"Konfigurator erstellen": "Create configurator",
	"Willkommen in Ihrem neuen K3 Konto!": "Welcome to your new K3 account!",
	"Richten Sie gleich Ihren ersten Konfigurator ein:": "Set up your first configurator right away:",
	"Sie können alle Daten natürlich später noch ändern.": "You may change all data later again if necessary.",
	"Nicht veröffentlicht": "Not published",
	Statistics: Statistics$2,
	Konfigurationen: Konfigurationen$2,
	"Konfigurator wurde aktualisiert": "Configurator has been updated",
	"Seit Sie diese Konfiguration gespeichert haben, wurde der Konfigurator weiterentwickelt. Wollen Sie die aktuelle Version verwenden und weiterarbeiten oder die alte Version nur zur Ansicht öffnen?": "Since you saved this configuration, the configurator has been upgraded. Do you want to use the current version and continue working or open the old version for viewing only?.",
	"Alte Version": "Old version",
	"Aktuelle Version": "Current version",
	"Ladevorgang fehlgeschlagen": "Charging process failed",
	"Die Konfiguration konnte nicht geladen werden! Bitte versuchen Sie es später erneut!": "The configuration could not be loaded! Please try again later!",
	"Keine Optionen": "No options",
	articleNo: articleNo$2,
	articleName: articleName$2,
	price: price$2,
	currency: currency$2,
	Cancel: Cancel$2,
	Save: Save$2,
	"edit-positions": "edit-positions",
	"Klicken um abzubrechen.": "Click to cancel.",
	"Preis eingeben": "Enter price",
	"Währung": "Currency",
	"Währung eingeben": "Enter currency",
	"Einheit eingeben": "Enter unit",
	"Startdatum eingeben": "Enter start date",
	"Enddatum eingeben": "Enter end date",
	Startanzahl: Startanzahl$2,
	"Startanzahl eingeben": "Enter start count",
	Endanzahl: Endanzahl$2,
	"Endanzahl eingeben": "Enter end number",
	"Priorität": "Priority",
	"Priorität eingeben": "Enter priority",
	"Aufschlag?": "Markup?",
	"Preistyp eingeben": "Enter price type",
	"Neuer Preis": "New price",
	Suchen: Suchen$2,
	Ctrl: Ctrl$2,
	"Auswählen": "Auswählen",
	"Wählen Sie eine Vorlage aus:": "Choose a template:",
	"Sollen wir Ihren Konfigurator jetzt anlegen?": "Do you want to create your configurator now?",
	"Wir bringen Sie danach direkt in den Editor.": "We will redirect you to the editor afterwards.",
	"Anlegen & zum Konfigurator": "Create & open Configurator",
	"Farbenanzahl im Fenster": "Visible Colors",
	"Farbkachel Rundung": "Color tile rounding",
	"Opazität": "Opacity",
	Hervorhebung: Hervorhebung$2,
	"Groupieren nach": "Group by",
	Expression: Expression$2,
	"Formel Editor": "Formula Editor",
	"Geben Sie Formeln von Variablen ein.": "Enter formulas of variables",
	" Schreiben Sie z.B. Länge * Breite.": "Write, for example, length * width..",
	"Für ein Attribut nutzen Sie beispielsweise Motor.Leistung, wenn Motor ihr Merkmal und Leistung das entsprechende Attribut ist.": "For an attribute, use for example Motor.Power, if Motor is its attribute and Power is the corresponding attribute...",
	Ergebnis: Ergebnis$2,
	"Keine Formel eingegeben": "No formula entered",
	"Formel: ": "Formula: ",
	"Noch gibt es nicht genug Auswahlen um eine Vorschau anzuzeigen.": "There are not yet enough selections to display a preview.",
	"Ausblenden der originalen Textur, wenn bedruckt wird?": "Hide original texture when printed?",
	"Erlaube Bildformate": "Allow image formats",
	Mindestwert: Mindestwert$2,
	Maximalwert: Maximalwert$2,
	Nachkommastellen: Nachkommastellen$2,
	Schrittweite: Schrittweite$2,
	"Zeige Knöpfe an": "Show buttons",
	"Benutze Vielfaches der Schrittweite": "Use multiples of the step size",
	Berechnet: Berechnet$2,
	"Zyklus Erkennung deaktivieren": "Deactivate cycle detection",
	"Ändern": "Change",
	Wert: Wert$2,
	"Beispielhafte Beschreibung eines Wertes.": "Exemplary description of a value",
	"Dies ist nur eine Info": "This is just an info",
	"Color Dropdown": "Color Dropdown",
	"Color Radio": "Color Radio",
	Farbauswahl: Farbauswahl$2,
	Komponente: Komponente$2,
	Komponentenliste: Komponentenliste$2,
	"Komponentenliste mit Popup": "Component list with popup",
	Bildauswahl: Bildauswahl$2,
	Zahleneingabe: Zahleneingabe$2,
	"Radio Buttons": "Radio Buttons",
	"Radio Cards": "Radio Cards",
	"RAL-Farbauswahl": "RAL color selection",
	Dropdown: Dropdown$2,
	Schalter: Schalter$2,
	"Schalter Card": "Switch Card",
	Texteingabe: Texteingabe$2,
	Beispieltext: Beispieltext$2,
	Optional: Optional$2,
	"Unter \"Werte\" finden Sie dann den speziellen Eintrag \"keine Angabe\". Hier können Sie noch anpassen, was dem Nutzer angezeigt werden soll, wenn er nichts ausgewählt hat.": "Under \"Values\" you will then find the special entry \"no specification\". Here you can still customize what should be displayed to the user if they have not selected anything.",
	Versteckt: Versteckt$2,
	"Dieses Merkmal wird nicht angezeigt. Der Wert kann aber in Regeln und Berechnungen genutzt werden.": "This variable is not displayed. However, its value can be used in rules and calculations.",
	"Auswahl nur anzeigen, wenn ausgewählt": "Show selection only if selected",
	"Die Auswahl wird nicht in der Bestätigung, PDF oder im Shop angezeigt, wenn nichts ausgewählt wurde.": "The selection will not be displayed in the confirmation, PDF or in the shop if not selected.",
	"showSelection.label": "showSelection.label",
	"Aus Gruppe verstecken": "Hide from group",
	"Diese Option ergibt nur Sinn, wenn die Variable über ein custom Layout an einer anderen Stelle ein- oder ausgeblendet wird. Auch wenn sie hierrüber aus der Gruppe versteckt wird, wird sie trotzdem weiterhin in Zusammenfassungen dieser zugeordnet.": "This option only makes sense if the variable is shown or hidden at a different position via a custom layout. Even if it is hidden from the group in this way, it will still be assigned to it in summaries.",
	"Folgende Änderungen werden veröffentlicht:": "The following changes will be published:",
	"Konfigurator veröffentlichen": "Publish configurator",
	"Wertebereich angeben": "Specify value range",
	"Merkmale: ": "Features: ",
	"Aktionen: ": "Actions: ",
	"Diese Regel ist aktuell deaktiviert.": "This rule is currently deactivated.",
	"Modell Eigenschaften anpassen": "Customise model properties",
	"Bitte fügen Sie neue Regelzeilen hinzu.": "Please add new rule lines.",
	"Andernfalls wird diese Regel bei der Auswertung nicht beachtet.": "Otherwise this rule will not be considered in the evaluation...",
	"Keine Warnungen": "No warnings",
	"Selektions-Bearbeitung": "Selection editing",
	"Alle Regeln ansehen": "View all rules",
	Position: Position$2,
	"Rotation (in radiant)": "Rotation (in radian)",
	Scale: Scale$2,
	"Regel Bearbeitung": "Rule editing",
	"Kein Label angegeben!": "No label given!",
	"Regel Validierung": "Rule Validation",
	"Fehlende Werte": "Missing values",
	Modell: Modell$2,
	Material: Material$2,
	Komponenten: Komponenten$2,
	Druck: Druck$2,
	Farbe: Farbe$2,
	"Kein Modell": "No model",
	Regelname: Regelname$2,
	"Wird angewendet": "Is applied",
	Produktstruktur: Produktstruktur$2,
	"Reiter ausblenden": "Hide tabs",
	"Variablen ausblenden": "Hide variables",
	"Werte ausblenden": "Hide values",
	"Variablen entfernen": "Remove variables (deprecated)",
	"Reiter entfernen": "Remove tabs (deprecated)",
	"Anzeige von 3D-Modellen": "Display 3D models",
	"Anzeige von Informationen": "display of information",
	"Austauschen von Oberflächen": "Replacing surfaces",
	"Bilder auf Oberflächen drucken": "Print images on surfaces",
	Materialnamen: Materialnamen$2,
	"Wählen Sie ein Materialnamen aus.": "Select a material name",
	"Ändern der Farbe": "Change the color",
	"Anzeige von Bildern": "Display images",
	"Preise & Artikel": "Prices & Articles",
	"Gültigkeitsregeln": "Validity rules",
	"Gültigkeit prüfen?": "Check Validity?",
	Merkmalskombinationen: Merkmalskombinationen$2,
	Merkmale: Merkmale$2,
	Erstellen: Erstellen$2,
	"Artikel zur Stückliste hinzufügen": "Add items to the bill of materials",
	"Zugeordnete Variablen": "Assigned variables",
	"Wählen Sie die Variablen aus, denen die Artikel zugeordnet werden sollen": "Select the variables to which the articles are to be assigned",
	"Befüllen von Komponentenmerkmalen": "Fill Component Variables",
	Komponentenmerkmale: Komponentenmerkmale$2,
	"Wählen Sie Komponentenmerkmale aus.": "Select component features.",
	"Oberflächenaktion hinzufügen": "Add surface action",
	"Alle auswählen": "Select all",
	"Alle abwählen": "Select none",
	"Auswahl umkehren": "Reverse selection",
	"Dieser Konfigurator wurde erfolgreich mit Ihrem Shop verbunden: ": "This configurator has been successfully connected to your store: ",
	"Falls Sie die Anbindung aufheben möchten, löschen Sie zunächst das Secret im K3 Plugin in Ihrem Shop.": "If you want to remove the connection, first delete the Secret in the K3 plugin in your store...",
	"Secret ist gelöscht": "Secret is deleted",
	"Shop-Anbindung aufheben": "Unlink the store",
	Herunterladen: Herunterladen$2,
	"Ist installiert": "Is installed",
	"Verbinde Shop": "Connect Shop",
	" und importiere Artikel": "and import articles",
	"Fehler beim Verbinden:": "Error connecting:",
	"Shop erfolgreich verbunden.": "Store successfully connected.",
	"Fehler beim Verbinden: ": "Error connecting: ",
	"Shop-Anbindung": "Shop connection",
	"Web-Adresse des Shops": "Web address of the store",
	"Shopify Admin API Key": "Shopify Admin API Key",
	"Sollen die Artikel aus dem Shop importiert werden?": "Should the items be imported from the store?",
	"Filter für Artikel": "Filter for articles",
	"Sollen die Artikel bei der Bestellung zusammengefasst werden?": "Should the items be grouped together when ordering?",
	"Basis-Name für kombinierte Artikel": "Base name for combined articles",
	Verbinden: Verbinden$2,
	"Laden Sie zunächst eines unserer Plugins herunter und installieren Sie es in Ihrem Shop:": "First download one of our plugins and install it in your store:",
	"Sie können uns den Vorfall hier melden!": "You can report the incident here!",
	"Konnte das Templat nicht laden.": "Couldn't load the template",
	Templatname: Templatname$2,
	"Standard laden": "Load default",
	"Neuen Templatenamen eingeben": "Enter new template name",
	"Templat hinzufügen": "Add template",
	"Desktop Theme wählen": "Choose desktop theme",
	"Ansicht auswählen": "Select view",
	"Datei hochladen": "Upload file",
	"You may need to reload the page": "You may need to reload the page",
	"Bitte buchen Sie zunächst ein anderes Produkt:": "Please book another product first:",
	"Bitte wählen": "Please select",
	"Diese Aktion verbindet mehrere Merkmale und kann daher hier nicht geändert werden. Ändern Sie dafür direkt die folgende(n) Regel(n):": "This action combines several features and therefore cannot be changed here. Change the following rule(s) directly for this:",
	"Automatisch angelegt": "Automatically created",
	"Aktionen verknüpfen": "Link actions",
	"Werte von diesem Merkmal sollen folgende Aktionen auslösen:": "Values from this characteristic should trigger the following actions:",
	"Dieses Merkmal kann nicht verwendet werden, um weitere Vorgänge zu steuern. Nutzen Sie dafür bitte direkt die Regeln.": "This characteristic cannot be used to control other operations. Please use the rules directly for this",
	"Zu den Regeln": "To the rules",
	"Artikel bestellen": "Order articles",
	"Abhängig von der Auswahl werden verschiedene Artikel zur Stückliste hinzugefügt.": "Depending on the selection, different articles will be added to the parts list.,",
	"Oberfläche ändern": "Change surface",
	"Welche Oberflächen sollen geändert werden? ": "Which surfaces should be changed? ",
	"3D-Modell anzeigen": "Show 3D model",
	"Abhängig von der Auswahl werden verschiedene 3D-Modelle angezeigt.": "Depending on the selection, different 3D models will be displayed...",
	"Bild anzeigen": "Show image",
	"Abhängig von der Auswahl werden verschiedene Bilder angezeigt.": "Depending on the selection different images are displayed",
	"Farbe ändern": "Change color",
	"Welche Oberflächen sollen eingefärbt werden? ": "Which surfaces should be colored? ",
	"Bild aufdrucken": "Print image",
	"Auf welchen Oberflächen soll das hochgeladene Bild aufgedruckt werden? ": "On which surfaces should the uploaded image be printed? ",
	"Der Wert wird noch in Regeln verwendet:": "The value is still used in rules:",
	"Löschen Sie bitte zunächst dort die entsprechende(n) Zeile(n).": "First, please delete the corresponding line(s) there...",
	"Hier können Sie einstellen, was angezeigt werden soll, wenn noch kein Wert gewählt wurde": "Here you can set what should be displayed if no value has been selected yet",
	"Dieser Wert ist nicht erlaubt.": "This value is invalid.",
	"Maximale Anzahl an Werten ist erreicht.": "Maximum number of values reached.",
	Farbwert: Farbwert$2,
	Ansicht: Ansicht$2,
	"Key eingeben": "Enter Key",
	URL: URL$3,
	"Info-Text": "Info Text",
	"Zahlenvariablen haben keine Werte.": "Number variables have no values.",
	Auswahlwerte: Auswahlwerte$2,
	"Typ des Merkmals": "Type of variable",
	"es gibt keine Variable mit {{identificator}}": "No variable {{identificator}}",
	"es gibt kein Attribut mit {{identificator}}": "No attribute {{identificator}}",
	"es gibt keine Selection mit {{identificator}}": "No selection {{identificator}}",
	"es gibt mehr als eine Selection mit {{identificator}}": "there is more than one selection with {{identificator}}",
	"Es gibt einen Zyklus in den berechneten Variablen: {{cycleText}}": "There is a cycle in the calculated variables: {{cycleText}}",
	"das Ergebnis der Formel muss ein Zahlenwert sein, statt dessen ist es {{type}}": "the result of the formula must be a numerical value, instead it is {{type}}",
	"Wert {{paramName}} der Funktion {{functionName}} ist null": "value {{paramName}} of the function {{functionName}} is zero",
	"Die Variable {{variableLabel}} ist eine Komponentenliste. Sie müssen mit einem Index wie {{variableLabel2}}[0] für das 1. Element oder mit einer Array-Funktionen wie z.B. map(), find(), reduce() oder first() darauf zugreifen": "The variable {{variableLabel}} is a component list. You must access it with an index such as {{variableLabel2}}[0] for the 1st element or with an array function such as map(), find(), reduce() or first()",
	"Zeige Namen": "Show Name",
	"Zeige Beschreibung": "Show Description",
	"Zeige Thumbnail": "Show Thumbnail",
	"Zeige Preis": "Show Price",
	"Zeige URL": "Show URL",
	"Zeige Info-Button für Werte": "Show Info Button for Values",
	"Kamerafahrt beim scrollen": "Camera change when scrolling",
	"Ungültige, aktiv geänderte, Werte ausblenden": "Hide invalid, actively changed, values",
	"Alle ungültige Werte ausblenden": "Hide all invalid values",
	"Ausblenden wenn nur eine Auswahl möglich ist": "Hide if only one selection is possible",
	"Deaktivieren wenn nur eine Auswahl möglich ist": "Disable if only one selection is possible",
	"Komponente hervorheben": "Emphasise component",
	"Dieses Material existiert bereits": "This material already exists",
	"Material hinzufügen": "Add material",
	"Materialname eingeben": "Enter material name",
	Abmessungen: Abmessungen$2,
	Breite: Breite$2,
	"Höhe": "Height",
	Tiefe: Tiefe$2,
	Startpunkt: Startpunkt$2,
	Endpunkt: Endpunkt$2,
	"Linienstärke": "Line thickness",
	Text: Text$3,
	"Automatisches Maß überschreiben": "Override automatic dimension",
	"Neues Maß": "New dimension",
	"Textgröße als Faktor. 1 ist Standard.": "Text size as a factor. 1 is standard.",
	Offsets: Offsets$2,
	"Hier können Abweichungen von Position und Rotation, die sich normalerweise aus Start und Endpunkt ergeben, definiert werden. Dazu kann das 3D Positionierungswerkzeug benutzt werden.": "Here, deviations from position and rotation, which normally result from start and end point, can be defined. For this purpose, the 3D positioning tool can be used.",
	Edit: Edit$2,
	"Script Modell Editor": "Script Model Editor",
	"Schreiben Sie das Modell als JSX Komponente.": "Write the model as JSX component.",
	"Nicht Befüllt": "Not assigned",
	"Keine Angabe": "No information",
	"Maximale Anzahl an Iterationen erreicht! Die Regelkonflikte können nicht aufgelöst werden.": "Maximum number of iterations reached! The rule conflicts cannot be resolved."
};

var presentation$2 = "Presentation";
var usage$2 = "Actions";
var values$2 = "Values";
var rules$2 = "Rules";
var settings$2 = "Options";
var images$2 = "Images";
var configurators$2 = "Configurators";
var article$2 = "Article";
var Vorne = "Front";
var Uhrzeiger = "Clockwise";
var Schritt$2 = "Step";
var Schritte = "Steps";
var MATERIAL$2 = "MATERIAL";
var Import$2 = "Import";
var Manuell$2 = "Manual";
var Akzeptieren = "Accept";
var Rotation$2 = "Rotation";
var Allgemeines$2 = "General";
var Beschaffenheit$2 = "Texture";
var Roughness$2 = "Roughness";
var Metallness$2 = "Metallness";
var Bilderstapel$2 = "Image stack";
var Hilfe$4 = "Help";
var Szeneneinstellungen$2 = "Scene settings";
var Themes$2 = "Themes";
var Anpassung$2 = "Customization";
var Weiter$2 = "Next";
var Wertebereich$2 = "Value range";
var Darstellung$2 = "Presentation";
var Werte$2 = "Values";
var Anfragen$2 = "Requests";
var Zeitpunkt$2 = "Time";
var Benutzer$4 = "User";
var Anfrage$2 = "Request";
var URI$2 = "URI";
var Parameter$2 = "Parameters";
var Dauer$2 = "Duration";
var Server$2 = "Server";
var Konfiguratoren$2 = "Configurators";
var Benutzerkonten = "Users";
var Support = "Support";
var Systemstatus = "System Status";
var Andere = "Others";
var Dokumentation = "Help";
var Beratung = "Consulting";
var Abonnement = "Subscription";
var Profil = "Profile";
var Papierkorb = "Trash";
var Logout = "Log Out";
var Fullscreen$2 = "Fullscreen";
var showSelection$2 = {
	always: "Always",
	never: "Never",
	auto: "Like in the configurator",
	label: "Display in confirmation, pdf and shop"
};
var Aktivieren$2 = "Activate";
var Deaktivieren$2 = "Deactivate";
var variablesAndArticles$2 = "Variables and Articles";
var variablesOnly$2 = "Variables only";
var articlesOnly$2 = "Articles only";
var noOverview$2 = "No Overview";
var Auswahlpreise$2 = "Selection prices";
var Variable$2 = "Variable";
var Regelzeilen = "Rule Entries";
var breadcrumb_app$2 = "General";
var breadcrumb_pdf$2 = "PDF";
var breadcrumb_mail$2 = "Mail";
var breadcrumb_embed$2 = "Embed";
var breadcrumb_shop$2 = "Shop";
var breadcrumb_articles$2 = "Articles";
var breadcrumb_preview$2 = "Preview";
var breadcrumb_edit$2 = "Editor";
var breadcrumb_images$2 = "Images";
var breadcrumb_materials$2 = "Materials";
var breadcrumb_models$2 = "Models";
var breadcrumb_rules$2 = "Rules";
var breadcrumb_settings$2 = "Options";
var breadcrumb_admin$2 = "Admin";
var breadcrumb_extract$2 = "Extract";
var breadcrumb_apps$2 = "Configurators";
var breadcrumb_create$2 = "Create";
var breadcrumb_import$2 = "Import";
var breadcrumb_users$2 = "Users";
var breadcrumb_support$2 = "Support";
var breadcrumb_logs$2 = "Logs";
var breadcrumb_systemStatus$2 = "System Status";
var breadcrumb_trash$2 = "Trash";
var breadcrumb_abonnement$2 = "Subscription";
var breadcrumb_expired$2 = "Expired";
var breadcrumb_profile$2 = "Profile";
var breadcrumb_configurator$2 = "Editor";
var breadcrumb_configurations$2 = "Configurations";
var breadcrumb_groups$2 = "Tabs";
var breadcrumb_variables$2 = "Features";
var breadcrumb_design$2 = "Design";
var breadcrumb_scene$2 = "Scene";
var breadcrumb_presentation$2 = "Presentation";
var breadcrumb_options$2 = "Options";
var breadcrumb_usage$2 = "Actions";
var breadcrumb_values$2 = "Values";
var enTranslationExtra = {
	presentation: presentation$2,
	usage: usage$2,
	values: values$2,
	rules: rules$2,
	settings: settings$2,
	images: images$2,
	configurators: configurators$2,
	article: article$2,
	"create new dealer": "Create New Dealer",
	"die Variable {{variableLabel}} ist eine KomponentenListe. Sie müssen mit einem Index wie {{variableLabel}}[0] für das 1. Element oder mit einer Array-Funktionen wie z.B. map(), find(), reduce() oder first() darauf zugreifen": "the variable {{variableLabel}} is a component list. You must access it with an index like {{variableLabel}}[0] for the 1st element or with an array function like map(), find(), reduce() or first()",
	Vorne: Vorne,
	Uhrzeiger: Uhrzeiger,
	"Dieser Wert ist nicht kombinierbar mit folgenden Auswahlen:": "This value cannot be combined with the following selections:",
	"Bei Auswahl wird eine Alternative berechnet!": "If selected, an alternative will be calculated!",
	"Artikel Anzahl": "Article Quantity",
	"Farb auswählen": "Select color",
	"< Zurück": "< Back",
	"Preis Information": "price information",
	"Reiter - Rechts": "Tabs - Right",
	"Reiter - Links": "Tabs - Left",
	"Flyaway Reiter - Links": "Flyaway Tabs - Left",
	"Einfach - Links": "Simple - Left",
	"Akkordeons - Rechts": "Accordions - Right",
	"Fullscreen Formular": "Fullscreen Form",
	Schritt: Schritt$2,
	Schritte: Schritte,
	"Maßkette": "Ruler",
	"Ihre Eingabe war leider nicht möglich und wurde auf den nächstmöglichen Wert zurückgesetzt: ": "Unfortunately, your input was not possible and was reset to the next possible value: ",
	"Merkmal auswählen": "Choose feature",
	MATERIAL: MATERIAL$2,
	Import: Import$2,
	"Materialien für den Import auswählen:": "Choose materials to import:",
	"Wie möchten Sie ein Material erstellen?": "How do you like to create a material?",
	"Import einer .glb und export der enthaltenen Materialien": "Import of a .glb und export of contained materials",
	Manuell: Manuell$2,
	"Eigenständiges Anlegen eines PBR-Materials": "Manually create a PBR-Material",
	"Die Variable wird von einer Erweiterung benötigt und kann daher nicht gelöscht werden!": "The variable is required by an extension and therefore cannot be deleted!",
	"Bitten Sie den Entwickler, die Variable aus der Erweiterung zu entfernen und zu löschen.": "Ask the developer to remove the variable from the extension and delete it.,",
	"Die Variable wird noch in Regeln verwendet:": "The variable is still used in rules:",
	"Löschen Sie bitte zunächst dort die entsprechende Spalte.": "Please delete the corresponding column there first",
	"Anpassung nötig": "Adjustment",
	"\"Die Auswahl \"{{value}}\" ({{variable}}) passt nicht zu der Auswahl \"{{conflictValue0}}\" ({{conflictVariable0}}).\"": "\"The selection \"{{value}}\" ({{variable}}) does not match the selection \"{{conflictValue0}}\" ({{conflictVariable0}}).\"",
	"Die Auswahl \"{{value}}\" ({{variable}}) passt nicht zu der Auswahl \"{{conflictValue0}}\" ({{conflictVariable0}}) und der Auswahl \"{{conflictValue1}}\" ({{conflictVariable1}}).": "The selection \"{{value}}\" ({{variable}}) does not match the selection \"{{conflictValue0}}\" ({{conflictVariable0}}) and the selection \"{{conflictValue1}}\" ({{conflictVariable1}}).",
	"Die Auswahl \"{{value}}\" ({{variable}}) passt nicht zu der Auswahl \"{{conflictValue0}}\" ({{conflictVariable0}}), der Auswahl \"{{conflictValue1}}\" ({{conflictVariable1}}) und der Auswahl \"{{conflictValue2}}\" ({{conflictVariable2}}).": "The selection \"{{value}}\" ({{variable}}) does not match the selection \"{{conflictValue0}}\" ({{conflictVariable0}}), the selection \"{{conflictValue1}}\" ({{conflictVariable1}}) and the selection \"{{conflictValue2}}\" ({{conflictVariable2}}).",
	"Die Auswahl \"{{value}}\" ({{variable}}) passt nicht zu anderen Auswahlen.": "The selection \"{{value}}\" ({{variable}}) does not match other selections.",
	"wird zu": "is becoming",
	"Stattdessen werden folgende Auswahlen angepasst:": "Instead the following selections will be adapted:",
	Akzeptieren: Akzeptieren,
	"Design & Layout": "Design & Layout",
	"Nur sichtbar im Vorschaumodus oder veröffentlichtem Konfigurator!": "Only visible in preview mode or published configurator!",
	"Theme wählen": "Choose Theme",
	"Komponente löschen": "Delete component",
	"Mehrfach Regelzeilen Bearbeitung": "Multiple rule lines editing",
	"Anzahl ausgewählte Regel-Zeilen:": "Number of selected rule lines:",
	"Modelaktions-Positionierung": "Model action positioning",
	Rotation: Rotation$2,
	"Keine Aktionen für die Mehrfachbearbeitung vorhanden.": "No actions available for multiple editing",
	Allgemeines: Allgemeines$2,
	"Farben und Lichtinteraktion": "Colors and light interaction",
	"Color-Map Upload": "Color map upload",
	"Material interagiert mit Licht in der Szene": "Material interacts with light in the scene",
	Beschaffenheit: Beschaffenheit$2,
	"Roughness-Map Upload": "Roughness map upload",
	Roughness: Roughness$2,
	"Metallness-Map Upload": "Metallness Map Upload",
	Metallness: Metallness$2,
	"Normalen-Map Upload": "Normality Map Upload",
	"Normalen-Skalierung": "Normality Scaling",
	"Anwendung auf 3D-Modell": "Application to 3D model",
	"Displacement-Map Upload": "Displacement Map Upload",
	"Displacement-Skalierung": "Displacement Scaling",
	"Repeat-Faktor der Textur in X- und Y-Richtung": "Repeat factor of texture in X and Y direction",
	"Alpha-Werte": "Alpha values",
	"Alpha-Map Upload": "Alpha map upload",
	"Ambient Occlusion": "Ambient Occlusion",
	"Ambient-Occlusion-Map Upload": "Ambient Occlusion Map Upload",
	"Info editieren": "Edit Info",
	"Zeige Info-Button": "Show Info Button",
	"An Shop senden": "Send to shop",
	"Javascript Event senden": "Send javascript event",
	"PDF herunterladen oder versenden": "Save or send PDF",
	"PDF Dokument (optional)": "PDF document (optional)",
	"Interne E-Mail-Adresse": "Internal email address",
	"Interne E-Mail senden": "Send internal email",
	"PDF an interne E-Mail anhängen": "Attach PDF to internal email",
	"PDF Dokument für interne E-Mail (optional)": "PDF document for internal email (optional)",
	"Kunden-Email senden": "Send Customer Email",
	"PDF an Kunden-Email anhängen": "Attach PDF to customer Email",
	"PDF Dokument für Kunden-Email (optional)": "PDF document for customer email (optional)",
	"UST-ID": "UST-ID",
	"Datenschutz-Hinweis": "Privacy",
	"E-mail": "Email",
	"Abhängigkeitsschleifen": "Dependency Loops",
	Bilderstapel: Bilderstapel$2,
	"Google Analytics Property ID": "Google Analytics Property ID",
	"Sans Serif": "Sans Serif",
	"Das flexibles Shopsystem für Ihr E-Commerce-Projekt.": "The flexible store system for your e-commerce project...",
	"Die eine europäische Open-Source-E-Commerce-Plattform. ": "The one European open source e-commerce platform. ",
	"Jetzt Adobe Commerce: E-Commerce leicht gemacht.": "Now Adobe Commerce: E-commerce made easy",
	"Erstklassig im digitalen Vertrieb mit dem Oxid esales Shop.": "First class in digital sales with the Oxid esales store.,",
	"Individuelle Entwicklung": "Custom development",
	Hilfe: Hilfe$4,
	"Shop mit einer individuellen Entwicklung anbinden.": "Connect shop with custom development...",
	Szeneneinstellungen: Szeneneinstellungen$2,
	Themes: Themes$2,
	Anpassung: Anpassung$2,
	"Gewähltes Theme übernehmen": "Apply selected theme",
	"Legen Sie einen neuen Konfigurationsschritt an.": "Create a new configuration step.",
	"Eine Konfiguration erfolgt in mehreren Schritten. In jedem Schritt können ggf. mehrere Produkt-Eigenschaften angegeben werden. Hier legen Sie den ersten Schritt an.": "A configuration is done in several steps. In each step, several product properties can be specified if necessary. Here you create the first step",
	"Konfigurationsschritt erstellen": "Create configuration step",
	"Bitte klicken Sie zunächst hier, um einen neuen Konfigurator zu erstellen.": "Please click here first, to create a new configurator",
	"Neuer Konfigurator wählen": "Select new configurator",
	"Bitte geben Sie einen Namen ein.": "Please enter a name",
	"Bitte geben Sie eine Beschreibung ein.": "Please enter a description",
	"Bestätigen": "Confirm",
	"Bitte klicken Sie hier.": "Please click here",
	"Konfigurator Dialog aufrufen": "Call configurator dialog",
	"Konfigurationsschritt benennen": "Name configuration step",
	"Hier können Sie neue Werte hinzufügen.": "Here you can add new values",
	"Merkmale, die eine Liste (oder Farbe, Material, Modell) sind, zeigen mehrere Werte zur Auwahl an. Diese Werte können Sie hier eingeben.": "Characteristics that are a list (or color, material, model) show several values for selection. You can enter these values here",
	"Klicken Sie hier um einen neuen Wert zu erstellen.": "Click here to create a new value",
	"Wenn Sie fertig sind klicken Sie hier.": "When you are done click here",
	"Werte erstellen": "Create values",
	"Bitte geben Sie einen Namen für das neue Merkmal ein.": "Please enter a name for the new feature",
	"Bitte wählen Sie eine Darstellung, die den Möglichkeiten des Merkmals entspricht.": "Please select a presentation that matches the feature's capabilities.,",
	"Präsentation definieren": "Define presentation",
	"In einem Schritt kann Ihr Kunde mehrere Merkmale seines Produktes anpassen. Fügen Sie hier das erste Merkmal ein.": "In one step your customer can customize several features of his product. Insert the first feature here...",
	"Produktmerkmal erstellen": "Create product feature",
	"Was für ein Merkmal wollen Sie anlegen?": "What kind of feature do you want to create?",
	"Ein Merkmal kann eine Auswahl sein (z.B. die Größen S, M, L und XL), ein Text oder eine Zahl (z.B. für eine Breite oder Höhe) oder auch eine Farbe oder Material Ihres Produktes oder ein 3D-Modell, dass einen Teil Ihres Produktes darstellt.": "A feature can be a selection (e.g. sizes S, M, L and XL), a text or a number (e.g. for a width or height) or even a color or material of your product or a 3D model representing a part of your product",
	"Produktmerkmaltyp auswählen": "Select product feature type",
	"Wählen sie den eben erstellten Konfigurator.": "Select the configurator you just created.",
	"Steuerung des Konfigurators durch das neue Merkmal.": "Control the configurator by the new feature.",
	"Merkmale können z.B. dafür sorgen, dass 3D-Modelle oder Bilder angezeigt werden oder das Oberflächen geändert oder eingefärbt werden. Sie können auch eine Stückliste von Artikel erzeugen, die dann den Preis bestimmt und in den Warenkorb Ihres Shops gelegt werden kann.": "Features can e.g. cause 3D models or images to be displayed or surfaces to be changed or colored. You can also create a parts list of items, which then determines the price and can be placed in the shopping cart of your store..",
	"Merkmal verwenden": "Use feature",
	Weiter: Weiter$2,
	Wertebereich: Wertebereich$2,
	Darstellung: Darstellung$2,
	Werte: Werte$2,
	Anfragen: Anfragen$2,
	Zeitpunkt: Zeitpunkt$2,
	Benutzer: Benutzer$4,
	Anfrage: Anfrage$2,
	URI: URI$2,
	Parameter: Parameter$2,
	Dauer: Dauer$2,
	Server: Server$2,
	"Modell bearbeiten": "Update model",
	"Korrekte Mail-Adresse": "Correct mail address",
	"Statistik (30 Tage)": "Statistics (30 days)",
	"Datum eingeben": "Enter date",
	"Nach hause ": "Home ",
	"Mandant anlegen": "Create client",
	"Nutzer hinzufügen": "Add user",
	Konfiguratoren: Konfiguratoren$2,
	Benutzerkonten: Benutzerkonten,
	Support: Support,
	Systemstatus: Systemstatus,
	Andere: Andere,
	Dokumentation: Dokumentation,
	Beratung: Beratung,
	Abonnement: Abonnement,
	"Jetzt K3 buchen": "Book K3 now",
	Profil: Profil,
	Papierkorb: Papierkorb,
	Logout: Logout,
	"Übersicht": "Overview",
	"Persönliche Daten": "Personal Data",
	"In AR ansehen": "Watch in AR",
	"Die globale Commerce-Plattform": "The global ecommerce platform",
	Fullscreen: Fullscreen$2,
	showSelection: showSelection$2,
	"Kamera überschreiben": "Override camera",
	Aktivieren: Aktivieren$2,
	Deaktivieren: Deaktivieren$2,
	"Übersichtsseite": "Overview Page",
	variablesAndArticles: variablesAndArticles$2,
	variablesOnly: variablesOnly$2,
	articlesOnly: articlesOnly$2,
	noOverview: noOverview$2,
	Auswahlpreise: Auswahlpreise$2,
	Variable: Variable$2,
	Regelzeilen: Regelzeilen,
	"Händler: Bestellung weiterleiten": "Dealer: Forward order",
	"Wird nicht im Konfigurator angezeigt": "not shown in frontend",
	"Dateiname des Pdfs (optional)": "Filename of the pdf (optional)",
	"Die Datenschutzhinweise habe ich zur Kenntnis genommen und akzeptiere sie.": "I have read and accept the privacy policy.",
	"Die Mail-Adresse muss zum Senden freigeschaltet werden - bitte melden Sie sich bei uns.": "The email address must be activated for sending - please contact us.",
	breadcrumb_app: breadcrumb_app$2,
	breadcrumb_pdf: breadcrumb_pdf$2,
	breadcrumb_mail: breadcrumb_mail$2,
	breadcrumb_embed: breadcrumb_embed$2,
	breadcrumb_shop: breadcrumb_shop$2,
	breadcrumb_articles: breadcrumb_articles$2,
	breadcrumb_preview: breadcrumb_preview$2,
	breadcrumb_edit: breadcrumb_edit$2,
	breadcrumb_images: breadcrumb_images$2,
	breadcrumb_materials: breadcrumb_materials$2,
	breadcrumb_models: breadcrumb_models$2,
	breadcrumb_rules: breadcrumb_rules$2,
	breadcrumb_settings: breadcrumb_settings$2,
	breadcrumb_admin: breadcrumb_admin$2,
	breadcrumb_extract: breadcrumb_extract$2,
	breadcrumb_apps: breadcrumb_apps$2,
	breadcrumb_create: breadcrumb_create$2,
	breadcrumb_import: breadcrumb_import$2,
	breadcrumb_users: breadcrumb_users$2,
	breadcrumb_support: breadcrumb_support$2,
	breadcrumb_logs: breadcrumb_logs$2,
	breadcrumb_systemStatus: breadcrumb_systemStatus$2,
	breadcrumb_trash: breadcrumb_trash$2,
	breadcrumb_abonnement: breadcrumb_abonnement$2,
	breadcrumb_expired: breadcrumb_expired$2,
	breadcrumb_profile: breadcrumb_profile$2,
	breadcrumb_configurator: breadcrumb_configurator$2,
	breadcrumb_configurations: breadcrumb_configurations$2,
	breadcrumb_groups: breadcrumb_groups$2,
	breadcrumb_variables: breadcrumb_variables$2,
	breadcrumb_design: breadcrumb_design$2,
	breadcrumb_scene: breadcrumb_scene$2,
	breadcrumb_presentation: breadcrumb_presentation$2,
	breadcrumb_options: breadcrumb_options$2,
	breadcrumb_usage: breadcrumb_usage$2,
	breadcrumb_values: breadcrumb_values$2,
	"Letzte Gruppe kann nicht gelöscht werden.": "Last group cannot be deleted.",
	"Dieses Merkmal ist versteckt.": "This feature is hidden.",
	"Dieses Merkmal ist nur im Admin-Panel sichtbar. Das kann mehrere Ursachen haben: \n 1. Es wurde per Regel ausgeblendet. \n 2. Die zugehörige Gruppe wurde entfernt. \n 3. Das Merkmal besitzt keine Auswahloptionen.": "This feature is only visible in the admin panel. This can have several causes: \n 1. It was removed by rule. \n 2. The associated group was removed. \n 3. The feature has no selection options.",
	"Dieses Merkmal ist nicht mehr sichtbar, weil es keine valide Auswahl hat!": "This feature is no longer visible because it has no valid selection!",
	"Dieses Merkmal ist nicht mehr sichtbar, weil es nur eine valide Auswahl hat!": "This feature is no longer visible because it has only one valid selection!"
};

const en = Object.assign({}, enTranslation, enTranslationExtra);

var Mandant$1 = "Client";
var Produkt$1 = "Produit";
var Bezahlzustand$1 = "Condition de paiement";
var Addon$1 = "Addon";
var apps$1 = "Configurateurs";
var support$1 = "Support";
var dealers$1 = "Revendeur";
var users$1 = "Utilisateur";
var trash$1 = "Corbeille à papier";
var others$1 = "Autres";
var links$1 = "Liens";
var help$1 = "Aide";
var consultation$1 = "Conseil";
var status$1 = "Statut";
var subscription$1 = "Abonnement";
var profile$1 = "Profil";
var logout$1 = "Déconnexion";
var Template$1 = "Modèle";
var Aufrufen$1 = "Appeler";
var PDF$1 = "PDF";
var Code$1 = "Code";
var Preis$1 = "Prix";
var Inspiration$1 = "Inspiration";
var Anzeige$1 = "Annonce";
var Bild$1 = "Image";
var Sortierung$1 = "Triage";
var Kunde$1 = "Client";
var Inhalt$1 = "Contenu";
var Konfiguratorversion$1 = "Version du configurateur";
var Abbrechen$1 = "Annuler";
var Speichern$1 = "Enregistrer";
var Schliessen$1 = "Fermer";
var Adresse$1 = "Adresse";
var Datenschutz$1 = "Protection des données";
var Name$1 = "Nom";
var Email$1 = "Email";
var Telefon$1 = "Téléphone";
var Bemerkung$1 = "Remarque";
var Firma$1 = "Société";
var Akzeptiert$1 = "Accepte";
var Stadt$1 = "Ville";
var PLZ$1 = "CODE POSTAL";
var Datum$1 = "Date";
var dealer$1 = "Revendeur";
var json$1 = "json";
var Price$2 = "Prix";
var options$1 = "Options";
var Bestellaktion$1 = "Action de commande";
var Typ$1 = "Type";
var Konfiguration$1 = "Configuration";
var AR$1 = "AR";
var Geteilt$1 = "Partagé";
var anzeigen$1 = "afficheur";
var Artikelnummer$1 = "Numéro d'article";
var Beschreibung$1 = "Description";
var Kategorie$1 = "Catégorie";
var Preise$1 = "Prix";
var Importieren$1 = "Importer";
var Upload$1 = "Téléchargement";
var Keine$1 = "Pas de";
var Alle$1 = "Tous les";
var Bilder$1 = "Images";
var Seite$1 = "Page";
var Vorderseite$1 = "Page d\\'accueil";
var Hinterseite$1 = "Face arrière";
var Beidseitig$1 = "Les deux côtés";
var Optionen$1 = "Options";
var Bezeichnung$1 = "Désignation";
var Pbr$1 = "Pbr";
var Physikalisch$1 = "Physique";
var Key$1 = "Clé";
var Model$1 = "Modèle";
var Erweitert$1 = "Élargi";
var Editieren$1 = "Éditer";
var Kopieren$1 = "Copier";
var Allgemein$1 = "Généralités";
var Sprachen$1 = "Langues";
var Produktdarstellung$1 = "Présentation du produit";
var Upgrade$1 = "Mise à niveau";
var Hauptmodell$1 = "Modèle principal";
var Vorlage$1 = "Modèle";
var Tutorial$1 = "Tutoriel";
var Export$1 = "Exportation";
var discount$1 = "Réduction";
var surcharge$1 = "Service";
var Einbetten$1 = "Intégrer";
var Referenzsprache$1 = "Langue de référence";
var Artikel$1 = "Article";
var Schriftart$1 = "Police de caractères";
var Helvetica$1 = "Helvetica";
var Courier$1 = "Courrier";
var Interstate$1 = "Interstate";
var Montserrat$1 = "Montserrat";
var Links$1 = "Liens";
var Rechts$1 = "A droite";
var Oben$1 = "En haut";
var Unten$1 = "En bas";
var Kopfzeile$1 = "En-tête";
var Mail$1 = "Mail";
var Shop$1 = "Boutique";
var Senden$1 = "Envoyer";
var orders$1 = "Commandes";
var Tage$1 = "Jours";
var date$1 = "Date";
var number$1 = "Nombre";
var articlename$1 = "Nom de l'article";
var articles$1 = "Article";
var Bezahlt$1 = "Paye";
var Wechseln$1 = "Changer";
var Anlegen$1 = "Créer";
var Neu$1 = "Nouveau";
var Konfiguratoren$1 = "Configurateurs";
var Benutzer$3 = "Utilisateur";
var Rolle$1 = "Rôle";
var name$1 = "Nom";
var email$1 = "E-mail";
var Nutzerkonto$1 = "Compte d'utilisateur";
var Nutzername$1 = "Nom d'utilisateur";
var create$2 = "Créer";
var save$1 = "Enregistrer";
var Password$1 = "Mot de passe";
var Login$1 = "S'inscrire";
var Registrierung$1 = "Enregistrement";
var Datenschutzbestimmungen$1 = "Politique de confidentialité";
var AGB$1 = "CGV";
var Passwort$1 = "Mot de passe";
var Mandantentabelle$1 = "Tableau des mandants";
var Startdatum$1 = "Date de début";
var Enddatum$1 = "Date de fin";
var Konfigurator$1 = "Configurateur";
var Merkmal$1 = "Caractéristique";
var Regel$1 = "Règle";
var Nummer$1 = "Numéro";
var Erstellt$1 = "Créé";
var Kennwort$1 = "Mot de passe";
var Sprache$1 = "Langue";
var Download$1 = "Télécharger";
var Hintergrundmodell$1 = "Modèle de fond";
var Preiseinstellungen$1 = "Paramètres de prix";
var Standard$1 = "Standard";
var Hauptaktion$1 = "Action principale";
var Kontaktformular$1 = "Formulaire de contact";
var Pflichtfeld$1 = "Champ obligatoire";
var Aktionsname$1 = "Nom de l'action";
var Anzahl$1 = "Nombre";
var Zahl$1 = "Nombre";
var Einheit$1 = "Unité";
var Aktionen$1 = "Actions";
var Kameras$1 = "Caméras";
var Kamera$1 = "Caméra";
var Reiter$1 = "Cavalier";
var Kameraansicht$1 = "Vue de la caméra";
var Ok$1 = "Ok";
var Fertig$1 = "Prêt";
var Auswahlen$1 = "Sélections";
var Positionspreis$1 = "Prix par poste";
var Gesamtpreis$1 = "Prix total";
var Kostenfrei$1 = "Gratuit";
var Downgrade$1 = "Mise à niveau vers le bas";
var Home$1 = "Accueil";
var Hilfe$3 = "Aide";
var cancel$1 = "Annuler";
var Icon$1 = "Icône";
var Gruppen$1 = "Groupes";
var Logo$2 = "Logo";
var Farben$1 = "Couleurs";
var CSS$1 = "CSS";
var Variablen$1 = "Variable";
var Einstellungen$1 = "Paramètres";
var Vorschau$1 = "Aperçu";
var Editor$1 = "Éditeur";
var Regeln$1 = "Règles";
var Articles$1 = "Article";
var Modelle$1 = "Modèles";
var Materialien$1 = "Matériaux";
var Bestellungen$1 = "Commandes";
var Fatal_Error_Text$1 = "Malheureusement, une erreur inconnue s'est produite. Si un nouveau chargement de la page ne permet pas de résoudre le problème, contacte-nous.";
var Fatal_Error$1 = "Erreur inconnue";
var Error_Message$1 = "Message d'erreur :";
var Abschnitt$1 = "Section";
var Bestelloptionen$1 = "Options de commande";
var hiddenGroup$1 = "Ce groupe n\\'est actuellement visible que dans le panneau d'administration, car il ne contient pas de caractéristiques avec des options sélectionnables.";
var Bearbeiten$1 = "Éditer";
var Leer$1 = "Vide";
var Basiseinstellungen$1 = "Paramètres de base";
var Deckkraft$1 = "Opacité";
var Anwenden$1 = "Appliquer";
var Auswahl$1 = "Sélection";
var Duplizieren$1 = "Dupliquer";
var Ersetzen$1 = "Remplacer";
var Statistics$1 = "Statistiques";
var Konfigurationen$1 = "Configurations";
var articleNo$1 = "Numéro d'article";
var articleName$1 = "Nom";
var price$1 = "Prix";
var currency$1 = "Monnaie";
var Cancel$1 = "Annuler";
var Save$1 = "Sauvegarder";
var Startanzahl$1 = "Nombre de départs";
var Endanzahl$1 = "Nombre final";
var Suchen$1 = "Chercheur";
var Ctrl$1 = "Ctrl";
var Hervorhebung$1 = "Mise en évidence";
var Expression$1 = "Expression";
var Ergebnis$1 = "Résultat";
var Mindestwert$1 = "Valeur minimale";
var Maximalwert$1 = "Valeur maximale";
var Nachkommastellen$1 = "Chiffres après la virgule";
var Schrittweite$1 = "Pas à pas";
var Berechnet$1 = "Calcule";
var Wert$1 = "Valeur";
var Farbauswahl$1 = "Choix de la couleur";
var Komponente$1 = "Composant";
var Komponentenliste$1 = "Liste des composants";
var Bildauswahl$1 = "Sélection d'images";
var Zahleneingabe$1 = "Saisie de chiffres";
var Dropdown$1 = "Liste déroulante";
var Schalter$1 = "Interrupteur";
var Texteingabe$1 = "Saisie de texte";
var Beispieltext$1 = "Exemple de texte";
var Optional$1 = "En option";
var Versteckt$1 = "Caché";
var Position$1 = "Position";
var Scale$1 = "Échelle";
var Modell$1 = "Modèle";
var Material$1 = "Matériel";
var Komponenten$1 = "Composants";
var Druck$1 = "Impression";
var Farbe$1 = "Couleur";
var Regelname$1 = "Nom de la règle";
var Produktstruktur$1 = "Structure du produit";
var Materialnamen$1 = "Noms des matériaux";
var Merkmalskombinationen$1 = "Combinaisons de caractéristiques";
var Merkmale$1 = "Caractéristiques";
var Erstellen$1 = "Créer";
var Komponentenmerkmale$1 = "Caractéristiques des composants";
var Herunterladen$1 = "Télécharger";
var Verbinden$1 = "Connecter";
var Templatname$1 = "Nom du modèle";
var Farbwert$1 = "Valeur de la couleur";
var Ansicht$1 = "Vue";
var URL$2 = "URL";
var Auswahlwerte$1 = "Valeurs de sélection";
var Abmessungen$1 = "Dimensions";
var Breite$1 = "Large";
var Tiefe$1 = "Profondeur";
var Startpunkt$1 = "Point de départ";
var Endpunkt$1 = "Point final";
var Text$2 = "Textes";
var Offsets$1 = "Décalages";
var Edit$1 = "Editer";
var frTranslation = {
	"Sie zahlen nicht online. Bitte wenden Sie sich an den Mitarbeiter in Ihrem Unternehmen, der den Vertrag mit ObjectCode geschlossen hat.": "Tu ne paies pas en ligne. Contacte la personne de ton entreprise qui a conclu le contrat avec ObjectCode.",
	Mandant: Mandant$1,
	Produkt: Produkt$1,
	Bezahlzustand: Bezahlzustand$1,
	"Gültig von": "Valable à partir de",
	"Nicht angegeben": "Non spécifié",
	"Gültig bis": "Valable jusqu'au",
	Addon: Addon$1,
	apps: apps$1,
	support: support$1,
	"dealer-profile": "Profil du revendeur",
	dealers: dealers$1,
	users: users$1,
	trash: trash$1,
	others: others$1,
	links: links$1,
	help: help$1,
	consultation: consultation$1,
	status: status$1,
	subscription: subscription$1,
	profile: profile$1,
	logout: logout$1,
	"Neuer Konfigurator": "Nouveau configurateur",
	Template: Template$1,
	"Zurück": "Retour",
	Aufrufen: Aufrufen$1,
	PDF: PDF$1,
	Code: Code$1,
	Preis: Preis$1,
	Inspiration: Inspiration$1,
	Anzeige: Anzeige$1,
	Bild: Bild$1,
	Sortierung: Sortierung$1,
	"Sie möchten die Daten dieses Kunden einsehen?": "Tu souhaites consulter les données de ce client ?",
	Kunde: Kunde$1,
	Inhalt: Inhalt$1,
	"Shop-API": "API de la boutique",
	"Gespeichert am": "Sauvé le",
	Konfiguratorversion: Konfiguratorversion$1,
	Abbrechen: Abbrechen$1,
	Speichern: Speichern$1,
	"Ergebnis der Shop API": "Résultat de l'API de la boutique",
	Schliessen: Schliessen$1,
	Adresse: Adresse$1,
	Datenschutz: Datenschutz$1,
	Name: Name$1,
	Email: Email$1,
	Telefon: Telefon$1,
	Bemerkung: Bemerkung$1,
	Firma: Firma$1,
	"Steuer-ID": "Numéro d'identification fiscale",
	Akzeptiert: Akzeptiert$1,
	Stadt: Stadt$1,
	PLZ: PLZ$1,
	Datum: Datum$1,
	"exit-action": "Action de commande",
	dealer: dealer$1,
	"order-status": "Statut",
	json: json$1,
	Price: Price$2,
	options: options$1,
	Bestellaktion: Bestellaktion$1,
	Typ: Typ$1,
	Konfiguration: Konfiguration$1,
	AR: AR$1,
	Geteilt: Geteilt$1,
	"Sie möchten die Daten Ihrer Kunden einsehen?": "Tu souhaites consulter les données de tes clients ?",
	"Preise anlegen": "Créer des prix",
	anzeigen: anzeigen$1,
	Artikelnummer: Artikelnummer$1,
	"Artikelnummer eingeben": "Saisir le numéro de l'article",
	"Namen eingeben": "Saisir le nom",
	Beschreibung: Beschreibung$1,
	"Beschreibung eingeben": "Entrer la description",
	Kategorie: Kategorie$1,
	"Kategorien eingeben": "Saisir les catégories",
	Preise: Preise$1,
	"Sie möchten Preise anzeigen?": "Tu veux afficher les prix ?",
	Importieren: Importieren$1,
	"Artikel und Preise veröffentlichen": "Publier des articles et des prix",
	"Neuer Artikel": "Nouvel article",
	Upload: Upload$1,
	"Laden Sie ein oder mehrere Bilder in den angegeben Ordner hoch. Die können den Schrägstrich (/) verwenden, um tiefere Ordner zu erzeugen.": "Télécharge une ou plusieurs images dans le dossier indiqué. Tu peux utiliser la barre oblique (/) pour créer des dossiers plus profonds.",
	"Alternativ können Sie ein ZIP-Archiv mit einer Ordnerstruktur hochladen.": "Sinon, tu peux télécharger une archive ZIP avec une structure de dossier.",
	"Ordner *": "Dossier *",
	"Beachten Sie: Alle Bilder in einem Ordner werden als Galerie gruppiert, nach Name sortiert. Verwenden Sie also Dateinamen wie \"Bild_001\".": "N\\'oublie pas : toutes les images dans un dossier sont regroupées en tant que galerie, triées par nom. Utilise donc des noms de fichiers comme %r@\\N%r@\\N \"image_001%r@\\N%r@\\N\".",
	Keine: Keine$1,
	Alle: Alle$1,
	"Löschen": "Supprimer",
	Bilder: Bilder$1,
	Seite: Seite$1,
	Vorderseite: Vorderseite$1,
	Hinterseite: Hinterseite$1,
	Beidseitig: Beidseitig$1,
	"new-material": "Nouveau matériel",
	Optionen: Optionen$1,
	Bezeichnung: Bezeichnung$1,
	Pbr: Pbr$1,
	Physikalisch: Physikalisch$1,
	Key: Key$1,
	"AR Fallback Material": "Matériel de retombée AR",
	"Nicht ausgewählt": "Non sélectionné",
	Model: Model$1,
	Erweitert: Erweitert$1,
	"Nur in Regeln verwendete Materialien anzeigen": "Afficher uniquement les matériaux utilisés dans les règles",
	"extract-materials": "Extraire les matériaux du modèle",
	Editieren: Editieren$1,
	Kopieren: Kopieren$1,
	"Neues Modell": "Nouveau modèle",
	"Dynamisches Modell": "Modèle dynamique",
	"Gültigkeit": "Validité",
	"Neue Regel": "Nouvelle règle",
	"Neue Regel Erstellen": "Créer une nouvelle règle",
	"Regel erstellen": "Créer une règle",
	Allgemein: Allgemein$1,
	Sprachen: Sprachen$1,
	"Die erste Sprache gilt als Standard.": "La première langue est considérée comme standard.",
	"Die Beschreibung dieses Konfigurators": "La description de ce configurateur",
	"Link zum Konfigurator": "Lien vers le configurateur",
	"Falls Sie eine Erweiertung nutzen, tragen Sie hier ein, wo Ihr Entwickler sie zur Verfügung stellt.": "Si tu utilises une extension, indique ici où ton développeur la met à disposition.",
	Produktdarstellung: Produktdarstellung$1,
	"3D-Modell": "Modèle 3D",
	"Bilder-Konfigurator": "Configurateur d'images",
	"Google Analytics 4 Property ID": "Google Analytics 4 ID de propriété",
	"Sie müssen für den Google Cookie die Einverständnis des Nutzers einholen. Das passiert nicht innerhalb des K3!": "Tu dois obtenir l'accord de l'utilisateur pour le cookie Google. Cela ne se passe pas à l'intérieur de K3 !",
	"Sie möchten Ihr Analytics-Konto verbinden?": "Tu veux connecter ton compte Analytics ?",
	Upgrade: Upgrade$1,
	Hauptmodell: Hauptmodell$1,
	"Hauptmodell entfernen": "Supprimer le modèle principal",
	Vorlage: Vorlage$1,
	"Dieser Konfigurator dient als Vorlage": "Ce configurateur sert de modèle",
	Tutorial: Tutorial$1,
	"Standard übernehmen": "Adopter le standard",
	"screenshot-quality": "Capture d'écran Qualité",
	Export: Export$1,
	"app-code-duplicate": "Le code de l'application est déjà utilisé",
	"Ihre Händler sollen Ihren Konfigurator nutzen können?": "Tu veux que tes distributeurs puissent utiliser ton configurateur ?",
	"Keine Händler vorhanden": "Aucun revendeur disponible",
	"Legen Sie zuerst einen Händler an - dann geben Sie ihm hier Zugriff auf die App.": "Crée d'abord un revendeur - puis donne-lui accès à l'application ici.",
	"Jetzt Händler anlegen": "Créer des commerçants maintenant",
	"to dealer app": "vers l'application du concessionnaire",
	"dealer query": "Préférences",
	discount: discount$1,
	surcharge: surcharge$1,
	Einbetten: Einbetten$1,
	"Als Link": "En tant que lien",
	"Als IFrame": "Comme IFrame",
	"Referenzsprache. Die Einträge müssen mit der Referenzspalte in der importierten Datei übereinstimmen, um berücksichtigt zu werden.": "Langue de référence. Les éléments doivent être intégrés à la liste de référence dans la base de données imprimée, afin d'être pris en compte.",
	"Wrong file format, be sure to use the format of the exported file for the currently selected reference language.": "Mauvais format de fichier, assure-toi d'utiliser le format du fichier exporté pour la langue de référence actuellement sélectionnée.",
	"Importiere XLSX": "Importer XLSX",
	"Exportiere XLSX": "Exporter XLSX",
	Referenzsprache: Referenzsprache$1,
	"Werden berücksichtigt:": "Seront pris en compte",
	Artikel: Artikel$1,
	"Versteckte Variablen": "Variables cachées",
	"Unbenutzte Sprachen": "Langues inutilisées",
	"Sie möchten Ihren Kunden und/oder sich selbst Anfragen per E-Mail senden?": "Tu souhaites envoyer des demandes par e-mail à tes clients et/ou à toi-même ?",
	"Mail Texte": "Textes de mail",
	"Hier können Sie den Inhalt der versendeten Mails anpassen. Lesen Sie vorab den Abschnitt in der Dokumentation.": "Ici, tu peux adapter le contenu des mails envoyés. Lis au préalable la section dans la documentation.",
	"Bitte beachten Sie: Sie müssen immer den Konfigurator veröffentlichen, bevor die geänderten Texte verwendet werden.": "Attention : tu dois toujours publier le configurateur avant d'utiliser les textes modifiés.",
	"Sie möchten Bestätigungen oder Angebote als PDF senden?": "Tu souhaites envoyer des confirmations ou des offres au format PDF ?",
	"Sie möchten den Konfigurator veröffentlichen?": "Vous souhaitez publier le configurateur?",
	"PDF Einstellungen": "Paramètres PDF",
	Schriftart: Schriftart$1,
	Helvetica: Helvetica$1,
	"Times Roman": "Times Roman",
	Courier: Courier$1,
	Interstate: Interstate$1,
	Montserrat: Montserrat$1,
	"Nunito Sans": "Nunito Sans",
	"Poppins Bold": "Poppins Bold",
	"Schriftgröße": "Taille de la police",
	"Seitenränder": "Marges",
	Links: Links$1,
	Rechts: Rechts$1,
	Oben: Oben$1,
	Unten: Unten$1,
	Kopfzeile: Kopfzeile$1,
	"Fußzeile": "Pied de page",
	"Neue PDF Vorlage auswählen": "Choisir un nouveau modèle PDF",
	"Vorhandene PDF Vorlage löschen": "Supprimer un modèle PDF",
	"Voransicht mit dieser Konfiguration:": "Prévisualisation avec cette configuration :",
	"und diesem Template:": "et ce modèle :",
	"Speichern und drucken": "Enregistrer et imprimer",
	"Für eine Voransicht speichern Sie eine Konfiguration ab.": "Pour un aperçu, enregistre une configuration.",
	"Dann können Sie sie hier drucken.": "Alors tu peux les imprimer ici.",
	Mail: Mail$1,
	Shop: Shop$1,
	"Social Sharing": "Partage social",
	"Wir helfen gern!": "Nous sommes heureux de t'aider !",
	"Ihre Telefonnummer": "Ton numéro de téléphone",
	"Ihre Nachricht": "Ton message",
	Senden: Senden$1,
	orders: orders$1,
	"Preise wurden in den Einstellungen deaktiviert": "Les prix ont été désactivés dans les paramètres",
	"Keine Einnahmen vorliegend": "Pas de recettes en jeu",
	"total-earnings": "Recettes totales",
	Tage: Tage$1,
	date: date$1,
	number: number$1,
	articlename: articlename$1,
	articles: articles$1,
	"Sie können einen Konfigurator unter \"Einstellungen\" exportieren. Die entstandene Datei können Sie hier wieder importieren.": "Tu peux exporter un configurateur %r@\\N \"Paramètres%r@\\%r@\\N\". Tu peux réimporter le fichier obtenu ici.",
	"JSON Export Datei": "Fichier d'exportation JSON",
	"Leerer Konfigurator": "Configurateur vide",
	"Starten Sie mit einem leeren Konfigurator und richten Sie ihn nach Ihren Wünschen ein.": "Commence avec un configurateur vide et configure-le comme tu le souhaites.",
	"Konfigurator importieren": "Importer le configurateur",
	"Importieren sie einen Konfigurator anhand einer exportierten Datei.": "Importe un configurateur à partir d'un fichier exporté.",
	Bezahlt: Bezahlt$1,
	"Gebucht ab": "Réservé à partir de",
	"Gebucht bis": "Réservé jusqu'au",
	"Mandant erfolgreich geändert": "Client modifié avec succès",
	"Mandant erfolgreich angelegt": "Client créé avec succès",
	"E-Mail": "Courrier électronique",
	"Einstiegs-Produkt": "Produit d'entrée de gamme",
	"Stripe ID": "ID de bande",
	"Angelegt am": "Créé le",
	"Wird gelöscht am": "Sera supprimé le",
	"Zu diesem Datum wird der Mandant rückstandlos gelöscht!": "A cette date, le client sera supprimé sans réserve !",
	"Der vollständige Mandant wird exportiert - inklusive aller Assets. Sind Sie sicher?": "Le mandant complet est exporté - y compris tous les actifs. Tu es sûr ?",
	Wechseln: Wechseln$1,
	Anlegen: Anlegen$1,
	Neu: Neu$1,
	Konfiguratoren: Konfiguratoren$1,
	Benutzer: Benutzer$3,
	Rolle: Rolle$1,
	"Vielen Dank für Ihre Bestätigung...": "Merci beaucoup pour ta confirmation...",
	"E-Mail Bestätigung": "Confirmation par e-mail",
	"Zur Anmeldung": "Vers l'inscription",
	name: name$1,
	email: email$1,
	"E-Mail ist ungültig!": "L'e-mail n'est pas valide !",
	Nutzerkonto: Nutzerkonto$1,
	Nutzername: Nutzername$1,
	"Mail ist schon vergeben": "Mail est déjà pris",
	"code-duplicate": "Ce code est déjà pris",
	"dealer code helper text": "A consulter, configurateur de revendeur.",
	"default discount": "Remise par défaut",
	"default surcharge": "surcharge par défaut",
	"Pro Abo": "Par abonnement",
	"is pro dealer": "Peut utiliser le configurateur sur son propre site web et adapter le design",
	"Bitte überprüfen Sie die von Ihnen gemachten Angaben: ": "Merci de vérifier les informations que tu as fournies : ",
	create: create$2,
	save: save$1,
	"Fehlendes Produkt": "Produit manquant",
	"Ihre Händler sollen einen Ihrer Konfiguratoren nutzen können?": "Tu veux que tes distributeurs puissent utiliser un de tes configurateurs ?",
	"Bitte buchen Sie dort zunächst ein anderes Produkt.": "Réserve d'abord un autre produit.",
	"new dealer": "Nouveau distributeur",
	"Login screen": "Inscription",
	Password: Password$1,
	Login: Login$1,
	"Passwort vergessen?": "Mot de passe oublié ?",
	"Noch kein Konto?": "Pas encore de compte ?",
	"Ein Login war leider nicht möglich. Die Kombination aus E-Mail und Passwort ist ungültig.": "Une connexion n\\'a malheureusement pas été possible. La combinaison de l'e-mail et du mot de passe n'est pas valide.",
	"Falls die Mail in den nächsten Minuten nicht ankommt, schauen Sie bitte auch in Ihrem SPAM-Ordner nach und kontrollieren Sie Ihre Adresse.": "Si le mail n'arrive pas dans les minutes qui suivent, regarde aussi dans ton dossier SPAM et vérifie ton adresse.",
	"Wir senden Ihnen eine Mail mit Hinweisen zum Setzen eines neuen Kennwortes.": "Nous t\\N enverrons un e-mail avec les instructions pour mettre en place un nouveau mot de passe.",
	"Mail senden": "Envoyer un mail",
	Registrierung: Registrierung$1,
	"Bitte bestätigen Sie unsere ": "Merci de confirmer notre ",
	Datenschutzbestimmungen: Datenschutzbestimmungen$1,
	" und unsere ": " et nos ",
	AGB: AGB$1,
	"Jetzt registrieren": "S'inscrire maintenant",
	"Bereits angemeldet?": "Déjà inscrit ?",
	"Herzlich willkommen!": "Bienvenue à toi !",
	"Wir haben Ihnen eine E-Mail gesendet - schauen Sie auch in Ihren Spam-Ordner.": "Nous t'avons envoyé un e-mail - regarde aussi dans ton dossier spam.",
	"Sie können sich aber auch jetzt gleich mit Ihren Daten anmelden:": "Mais tu peux aussi t'inscrire dès maintenant avec tes données :",
	"Die Registrierung war leider nicht möglich.": "Malheureusement, l'inscription n'a pas été possible.",
	"Wir haben Ihr Kennwort neu gesetzt.": "Nous avons réinitialisé ton mot de passe.",
	"Passwort setzen": "Définir un mot de passe",
	Passwort: Passwort$1,
	"Mindestens 8 Zeichen, Groß-, Kleinbuchstaben und Zahlen": "Au moins 8 caractères, majuscules, minuscules et chiffres",
	"Bestätigung": "Confirmation",
	"Bestätigung stimmt nicht überein": "La confirmation ne correspond pas",
	"Kennwort setzen": "Définir un mot de passe",
	Mandantentabelle: Mandantentabelle$1,
	"Händleraktivierungen": "Activations des commerçants",
	Startdatum: Startdatum$1,
	Enddatum: Enddatum$1,
	"Mandanten wechseln": "Changer de client",
	"Mandanten editieren": "Éditer des mandants",
	"Neuer Mandant": "Nouveau client",
	Konfigurator: Konfigurator$1,
	Merkmal: Merkmal$1,
	Regel: Regel$1,
	Nummer: Nummer$1,
	Erstellt: Erstellt$1,
	"Gelöscht": "Supprimé",
	"Zurücklegen": "Remettre",
	"Mindestlänge": "Longueur minimale {{chars}} Caractères",
	"Email Adresse ist ungültig": "L'adresse e-mail n'est pas valide",
	Kennwort: Kennwort$1,
	"Test stimmt nicht überein": "Le test ne correspond pas",
	"Telefonnummer ist ungültig": "Le numéro de téléphone n'est pas valide",
	Sprache: Sprache$1,
	"Entwickler Modus": "Mode développeur",
	"Gibt Entwicklern Zugriff auf erweiterte Möglichkeiten.": "Donne aux développeurs l'accès à des possibilités avancées.",
	"API Token": "Jeton API",
	"Wenn Sie ein neues API Token erzeugen, werden alle bisherigen gelöscht.": "Si tu crées un nouveau jeton API, tous les précédents seront supprimés.",
	"Damit verlieren auch alle von Ihnen verbundenen Shops Zugriff auf den Konfigurator.": "Ainsi, toutes les boutiques que tu as connectées perdent également l'accès au configurateur.",
	"Sie können das Token im Shop-Plugin eintragen.": "Tu peux inscrire le jeton dans le plugin de la boutique.",
	"Notieren Sie sich das neue Token, es wird hier nur einmalig angezeigt.": "Note le nouveau jeton, il ne sera affiché ici qu'une seule fois.",
	"Mit dem ApiToken erhält ein Shop oder Ihre individuelle Entwicklung Zugriff auf die Daten Ihrer Konfiguratoren.": "Grâce à l\\'ApiToken, une boutique ou ton développement individuel a accès aux données de tes configurateurs.",
	"new user": "Nouvel utilisateur",
	"Neuen Nutzer anlegen": "Créer un utilisateur",
	"E-Mail nicht valide!": "E-mail non valide !",
	"Wir senden dem neuen Nutzer eine E-Mail mit einem Link. Dort kann er sein Kennwort setzen und erhält dann Zugang zu Ihrem Konfigurator.": "Nous enverrons un e-mail au nouvel utilisateur avec un lien. Il pourra y définir son mot de passe et aura alors accès à ton configurateur.",
	"Bitte überprüfen Sie die von Ihnen gemachten Angaben:": "Merci de vérifier les informations que tu as fournies :",
	"Sie möchten dynamische Modelle nutzen und damit z.B. Produkte auf Maß verkaufen?": "Tu souhaites utiliser des modèles dynamiques et les utiliser pour vendre des produits sur mesure, par exemple ?",
	"Hinzufügen": "Ajouter",
	"Das Modell überschreitet mit {{curr}} die empfohlene Anzahl von {{max}} Dreiecken. Eventuell kann es zu Problemen im AR Modus kommen.": "Le modèle dépasse {{curr}} le nombre recommandé de {{max}} Triangles. Il se peut que tu aies des problèmes en mode AR.",
	"Das Modell überschreitet mit {{curr}}MB die empfohlene Dateigröße von {{max}}MB.": "Le modèle dépasse {{curr}}MB la taille de fichier recommandée de {{max}}MB",
	"3D-Modell auswählen": "Sélectionner un modèle 3D",
	Download: Download$1,
	Hintergrundmodell: Hintergrundmodell$1,
	"material-upload": "material-upload",
	"main-model": "Modèle principal",
	"Wirft Schatten": "Jette des ombres",
	"Wird schattiert": "Est ombragé",
	"Bilder Galerie": "Galerie d\\'images",
	"Neue Aktion": "Nouvelle action",
	Preiseinstellungen: Preiseinstellungen$1,
	"Preise im Konfigurator ausblenden?": "Masquer les prix dans le configurateur ?",
	Standard: Standard$1,
	Hauptaktion: Hauptaktion$1,
	Kontaktformular: Kontaktformular$1,
	"Sie können diese Kundendaten zwar erfassen, aber nicht einsehen.": "Tu peux certes saisir ces données clients, mais tu ne peux pas les consulter.",
	Pflichtfeld: Pflichtfeld$1,
	"Sie können Links zu Ihren eigenen Dokumenten mit <a href=\"https://ihre-domain.de/ihre-datenschutzbestimmungen.html\" target=\"_blank\">Datenschutzhinweise</a> einbauen.": "Tu peux inclure des liens vers tes propres documents avec <a href=%r@\\N https://ihre-domain.de/ihre-datenschutzbestimmungen.html%r@\\N%r@\\\" target=%r@\\N%r@\\\"_blank%r@\\N%r@\\\">Informations sur la protection des données</a>.",
	Aktionsname: Aktionsname$1,
	"Shop verbinden": "Connecter la boutique",
	"Überschrift Bestätigung": "Titre confirmation",
	"Text Bestätigung": "Textes confirmation",
	"Link zur Konfiguration zeigen?": "Montrer le lien vers la configuration ?",
	"Thumbnail des Konfigurators": "Vignette du configurateur",
	"Desktop Gerät erkannt": "Appareil de bureau détecté",
	"Augmented-Reality ist aktuell nur auf aktuellen iOS- oder androidOS-Smartphones verfügbar. Scannen Sie daher einfach diesen QR-Code mit der Kamera-App Ihres Smartphones:": "La réalité augmentée n'est pas disponible actuellement sur les smartphones iOS ou androidOS actuels. Il te suffit donc de scanner ce code QR avec l'application caméra de ton smartphone :",
	"Export des 3D-Objekts": "Exportation de l'objet 3D",
	"Bereitstellen der AR-Datei": "Mise à disposition du fichier AR",
	"Kein Artikel ausgewählt!": "Pas d'article sélectionné !",
	"Artikel auswählen": "Choisir un article",
	Anzahl: Anzahl$1,
	"Wert eingeben": "Entrer la valeur",
	"Neue Spalte": "Nouvelle colonne",
	"Wert-Eigenschaft": "Propriété de la valeur",
	"Sie können den Werten dieses Merkmals Eigenschaften geben, z.B.             Gewicht oder Güteklasse oder Leistung. Diese Eigenschaften können             Sie für jeden Wert getrennt erfassen und dann dem Benutzer ausgeben. Sie             können mit diesen Eigenschaften aber auch Regeln und Berechnungen             deutlich einfacher machen.": "Tu peux donner des propriétés aux valeurs de cette caractéristique, par exemple le poids ou la classe de qualité ou la performance. Tu peux saisir ces propriétés séparément pour chaque valeur et les afficher ensuite à l'utilisateur. Mais tu peux aussi utiliser ces propriétés pour rendre les règles et les calculs beaucoup plus simples.",
	"Eigenschaft wird dem Nutzer angezeigt": "La propriété est affichée à l'utilisateur",
	"mehrsprachiger Text": "Textes multilingues",
	"nicht übersetzter Text": "Texte non traduit",
	Zahl: Zahl$1,
	Einheit: Einheit$1,
	"Fokus auf Modelle": "Focus sur les modèles",
	"Alle Modelle": "Tous les modèles",
	"Fokus über Objektnamen": "Focus sur les noms d'objets",
	"Aktuelle Ansicht übernehmen und Speichern": "Reprendre la vue actuelle et enregistrer",
	Aktionen: Aktionen$1,
	"Kamera bearbeiten": "Modifier la caméra",
	"Noch keine Kamera gespeichert": "Pas encore de caméra enregistrée",
	"Kameras gespeichert: ": "Caméras enregistrées : ",
	Kameras: Kameras$1,
	Kamera: Kamera$1,
	Reiter: Reiter$1,
	Kameraansicht: Kameraansicht$1,
	"Kamera speichern": "Enregistrer la caméra",
	"Bitte auswählen": "Choisir s'il te plaît",
	"Ausgewählt": "Choisi",
	"Merkmal setzen: ": "Mettre une caractéristique : ",
	"Keine Farbe ausgewählt!": "Pas de couleur choisie !",
	"Farbe auswählen": "Choisir la couleur",
	"Farbmerkmal auswählen:": "Sélectionner une caractéristique de couleur :",
	"Keine Auswahl": "Pas de sélection",
	"Sind Sie sicher?": "Tu es sûr ?",
	Ok: Ok$1,
	"Ergebnis: ": "Résultat : ",
	"Ihre Konfiguration wurde gespeichert": "Ta configuration a été enregistrée",
	"Mit diesem Link können Sie Ihre Konfiguration wieder aufrufen: ": "Ce lien te permet de retrouver ta configuration : ",
	"Sie sollten zum Shop weitergeleitet worden sein. Wenn Sie nicht weitergeleitet wurden klicken Sie bitte hier, um Ihre Bestellung abzuschließen: ": "Tu devrais avoir été redirigé vers la boutique. Si tu n'as pas été redirigé, clique ici pour terminer ta commande : ",
	"Zum Shop": "Vers la boutique",
	"Ihre Konfiguration konnte nicht gespeichert werden.": "Ta configuration n'a pas pu être enregistrée.",
	"Bitte entschuldigen Sie. Wir haben die Konfiguration in diesem Browser gesichert. Bitte kommen Sie später noch einmal wieder.": "Veuillez nous excuser. Nous avons sauvegardé la configuration dans ce navigateur. Merci de revenir plus tard.",
	"technische Information:": "information technique :",
	Fertig: Fertig$1,
	"Neues Produkt auswählen": "Choisir un nouveau produit",
	"Neues Produkt hinzufügen": "Ajouter un nouveau produit",
	Auswahlen: Auswahlen$1,
	"Pos.": "Pos.",
	Positionspreis: Positionspreis$1,
	Gesamtpreis: Gesamtpreis$1,
	"Preis: ": "Le prix : ",
	"Kameras für Bestellungsbilder": "Caméras pour les photos de commande",
	"Anfrage erhalten": "Recevoir une demande",
	"Buchung erfolgreich": "Réservation réussie",
	"Für das neue Produkt melden wir uns bei Ihnen.": "Pour le nouveau produit, nous te contacterons.",
	"Ihre Subskription wurde angepasst.": "Ta souscription a été adaptée.",
	"Ihre Subskription wurde beendet.": "Ta souscription est terminée.",
	"Das Produkt wurde gebucht.": "Le produit a été réservé.",
	"Meine Rechnungen": "Mes factures",
	"Auf Anfrage": "Sur demande",
	Kostenfrei: Kostenfrei$1,
	"{{fee}},- EUR pro Monat": "{{fee}},- EUR par mois",
	"Derzeit gebucht.": "Actuellement réservé.",
	"Sie buchen nun ein neues Produkt.": "Tu vas maintenant réserver un nouveau produit.",
	Downgrade: Downgrade$1,
	"Ihre K3 Buchung": "Ta réservation K3",
	"In neuem Tab öffnen": "Ouvrir dans un nouvel onglet",
	"Konfigurator anpassen": "Personnaliser le configurateur",
	"main drawer": "Tu vois un aperçu de ton configurateur que tu peux utiliser comme d'habitude. Clique sur une icône de crayon pour modifier quelque chose ou :",
	"Ändern Sie die Bestelloptionen": "Modifie les options de commande",
	"Ändern Sie das Design": "Modifie le design",
	"Passen sie die 3D Szene an": "Ajuste la scène 3D",
	"Speichern Sie die aktuelle Kamera für Bestellungsbilder": "Enregistre la caméra actuelle pour les images de commande",
	"Nutzen Sie die Hilfe": "Utilise ton aide",
	"Gruppen und Merkmale anpassen:": "Adapter les groupes et les caractéristiques :",
	"Gruppen verwalten": "Gérer les groupes",
	"Merkmale verwalten": "Gérer les caractéristiques",
	"So richten Sie Ihren Konfigurator ein:": "Voici comment configurer ton configurateur :",
	Home: Home$1,
	Hilfe: Hilfe$3,
	"Ihr K3": "Ton K3",
	"dealer sidebar": "Ici, ils peuvent configurer leur concessionnaire",
	"change design": "Modifie le design",
	"change logo": "Change le logo",
	"change price": "Change le prix",
	"change pdf": "Modifier le modèle PDF",
	"PDF Gestaltung": "PDF Mise en forme",
	"Laden Sie ein PDF als Vorlage für den Druck hoch.": "Chargez un PDF en tant qu'outil d'impression.",
	cancel: cancel$1,
	"app surcharge": "Définir la majoration",
	"you can change your surcharge here": "tu peux changer ta surcharge ici",
	"Neue Gruppe": "Nouveau groupe",
	"Neuer Reiter": "Nouvel onglet",
	Icon: Icon$1,
	"Icon Bilddatei": "Icône fichier image",
	"Icon position": "Position de l'icône",
	"Icon Größe": "Taille de l'icône",
	"Ersetze Weiter mit Aktionsauswahl": "Remplace Continue par Sélection d'action",
	"Aktionsnamen überschreiben": "Remplacer le nom de l'action",
	"Individuelles Gruppen-Design": "Design de groupe individuel",
	Gruppen: Gruppen$1,
	"Gruppen editieren": "Éditer des groupes",
	"Desktop Layout": "Mise en page du bureau",
	"Reiter schrittweise einblenden": "Afficher les onglets pas à pas",
	"Besuchte Reiter abhaken": "Cocher les cavaliers visités",
	"Desktop Layout wählen": "Choisir la mise en page du bureau",
	"Schließen": "Fermer",
	"Mobile Layout": "Mise en page mobile",
	"Mobile Layout wählen": "Choisir la mise en page mobile",
	Logo: Logo$2,
	"Konfigurator-Abschluss": "Finalisation du configurateur",
	"3D Szene": "Scène 3D",
	"Manuelle Einstellung erstellen": "Créer un réglage manuel",
	"Design & Theme": "Design & thème",
	Farben: Farben$1,
	"Farbanpassungen zurücksetzten": "Réinitialiser les ajustements de couleurs",
	CSS: CSS$1,
	"Sie können das Aussehen Ihres Konfigurators auch mittels CSS individuell anpassen:": "Tu peux aussi personnaliser l'apparence de ton configurateur à l'aide de CSS :",
	"Link zur CSS-Datei": "Lien vers le fichier CSS",
	"Oder laden Sie eine CSS Datei hoch:": "Ou télécharge un fichier CSS :",
	"Neues Merkmal": "Nouvelle caractéristique",
	Variablen: Variablen$1,
	"Variablen editieren": "Éditer les variables",
	Einstellungen: Einstellungen$1,
	"Dynamische Texte": "Textes dynamiques",
	Vorschau: Vorschau$1,
	Editor: Editor$1,
	Regeln: Regeln$1,
	Articles: Articles$1,
	Modelle: Modelle$1,
	Materialien: Materialien$1,
	Bestellungen: Bestellungen$1,
	"Inhalte: ": "Contenu : ",
	"Bevor der Konfigurator genutzt werden kann, müssen sie den Knopf \"Veröffentlichen\" betätigen. Wenn Sie danach Änderungen vornehmen, werden diese auch erst nach der nächsten Veröffentlichung wirksam.": "Avant de pouvoir utiliser le configurateur, tu dois cliquer sur le bouton %r@\\N \"Publier%r@\\N\". Si tu fais des modifications après cela, elles ne prendront effet qu'après la prochaine publication.",
	"Live Version": "Version en direct",
	"Veröffentlichen": "Publier",
	"Erstelle Option: ": "Créer une option : ",
	Fatal_Error_Text: Fatal_Error_Text$1,
	Fatal_Error: Fatal_Error$1,
	"Fehlermeldung:": "Message d'erreur :",
	"Zur Startseite": "Vers la page d'accueil",
	"Neu Laden": "Nouveau magasin",
	"Cleanup und Neu Laden": "Nettoyer et recharger",
	Error_Message: Error_Message$1,
	"Die folgenden Gründe sprechen gegen eine Löschung:": "Les raisons suivantes s'opposent à la suppression :",
	"einer Erweiterung. Bitten Sie den Entwickler die Nutzung zu entfernen und löschen Sie dann den Key.": "d'une extension. Demande au développeur de supprimer l'utilisation et supprime ensuite la clé.",
	"der Definition der Regel": "la définition de la règle",
	"einem Eintrag in Regel": "une entrée dans Règle",
	"einer berechneten Eigenschaft des Modells": "une propriété calculée du modèle",
	"der Formel von": "de la formule de",
	"der Kamera": "La caméra",
	"des Merkmals": "de la caractéristique",
	"der Gruppe": "du groupe",
	"der globalen Kamera": "La caméra globale",
	"Löschen Sie bitte zunächst die anderen Referenzen.": "Supprime d'abord les autres références, s'il te plaît.",
	Abschnitt: Abschnitt$1,
	"Bitte legen Sie einen Reiter an!": "Crée un onglet, s'il te plaît !",
	"Gruppe editieren": "Éditer le groupe",
	Bestelloptionen: Bestelloptionen$1,
	"Merkmal editieren": "Éditer la caractéristique",
	hiddenGroup: hiddenGroup$1,
	"Label eingeben": "Entrer l'étiquette",
	Bearbeiten: Bearbeiten$1,
	"Bilder auswählen": "Choisir des images",
	"Ordner auswählen:": "Sélectionner un dossier :",
	"Bildmerkmal: ": "Caractéristique de l'image : ",
	"Kein Bild ausgewählt": "Pas d'image sélectionnée",
	"Bild auswählen": "Choisir une image",
	"Bildmerkmal auswählen:": "Sélectionner une caractéristique de l'image :",
	"Befüllt": "Rempli",
	Leer: Leer$1,
	"Zustand auswählen": "Sélectionner l'état",
	"Kein Komponente ausgewählt!": "Aucun composant sélectionné !",
	"Komponente auswählen": "Sélectionner un composant",
	"Intervall eingeben": "Entrer l'intervalle de temps",
	"Zum Dashboard": "Vers le tableau de bord",
	Basiseinstellungen: Basiseinstellungen$1,
	"Helles Theme": "Thème clair",
	"Erweiterte Einstellungen": "Paramètres avancés",
	"Label hinzufügen: ": "Ajouter une étiquette : ",
	"Kein Label ausgewählt!": "Pas de label sélectionné !",
	"Was soll angezeigt werden?": "Qu\\'est-ce qui doit être affiché ?",
	"Maximalgröße": "Taille maximale",
	Deckkraft: Deckkraft$1,
	"Kein Material ausgewählt!": "Pas de matériel sélectionné !",
	"Material auswählen": "Choisir le matériel",
	"Material auswählen:": "Choisir le matériel",
	"Beschränkung der Auswirkungen auf bestimmte Modelle": "Limiter l'impact de ta parole sur certains modèles",
	"Welches Teil soll hinzugefügt werden?": "Quelle partie ajouter ?",
	"Mobile Theme wählen": "Choisir un thème pour mobile",
	"Layout auswählen": "Choisir une mise en page",
	"Layout erstellen": "Créer une mise en page",
	"Gewähltes Layout kopieren": "Copier la mise en page sélectionnée",
	Anwenden: Anwenden$1,
	"Kein Modell ausgewählt!": "Pas de modèle sélectionné !",
	"Modell auswählen": "Choisir un modèle",
	"Modell hinzufügen:": "Ajouter un modèle :",
	"Globale Änderung": "Changement global",
	"Oberflächen": "Surfaces",
	"Ausgewählte Oberflächen": "Finitions sélectionnées",
	"Eintrag darf nicht leer sein.": "L'entrée ne doit pas être vide.",
	"Alle Werte": "Toutes les valeurs",
	"Werte auswählen": "Sélectionner les valeurs",
	Auswahl: Auswahl$1,
	"Hoch schieben": "Pousser vers le haut",
	"Runter schieben": "Pousser vers le bas",
	Duplizieren: Duplizieren$1,
	"Sortierung anwenden": "Appliquer le tri",
	"Das Dateiformat ist nicht erlaubt! Keine Datei gewählt.": "Le format de fichier n\\'est pas autorisé ! Aucun fichier sélectionné.",
	"Erlaube Formate:": "Autorise les formats :",
	"Keine Datei gewählt.": "Aucun fichier sélectionné.",
	"Das Dateiformat ist nicht erlaubt!": "Le format de fichier n\\'est pas autorisé !",
	Ersetzen: Ersetzen$1,
	"Bild hochladen": "Télécharger l\\'image",
	"Diese Variable ist nicht erlaubt.": "Cette variable n'est pas autorisée.",
	"Merkmal-Info editieren": "Éditer les infos sur les caractéristiques",
	"Vorlage wählen": "Choisir un modèle",
	"Konfigurator erstellen": "Créer un configurateur",
	"Willkommen in Ihrem neuen K3 Konto!": "Bienvenue dans ton nouveau compte K3 !",
	"Richten Sie gleich Ihren ersten Konfigurator ein:": "Configure tout de suite ton premier configurateur :",
	"Sie können alle Daten natürlich später noch ändern.": "Tu peux bien sûr modifier toutes les données plus tard.",
	"Nicht veröffentlicht": "Non publié",
	Statistics: Statistics$1,
	Konfigurationen: Konfigurationen$1,
	"Konfigurator wurde aktualisiert": "Le configurateur a été mis à jour",
	"Seit Sie diese Konfiguration gespeichert haben, wurde der Konfigurator weiterentwickelt. Wollen Sie die aktuelle Version verwenden und weiterarbeiten oder die alte Version nur zur Ansicht öffnen?": "Depuis que tu as enregistré cette configuration, le configurateur a été développé. Tu veux utiliser la version actuelle et continuer à travailler ou ouvrir l'ancienne version uniquement pour la consulter ?",
	"Alte Version": "Ancienne version",
	"Aktuelle Version": "Version actuelle",
	"Ladevorgang fehlgeschlagen": "Échec du chargement",
	"Die Konfiguration konnte nicht geladen werden! Bitte versuchen Sie es später erneut!": "La configuration n'a pas pu être chargée ! Merci de réessayer plus tard !",
	"Keine Optionen": "Pas d'options",
	articleNo: articleNo$1,
	articleName: articleName$1,
	price: price$1,
	currency: currency$1,
	Cancel: Cancel$1,
	Save: Save$1,
	"edit-positions": "Changer les positions",
	"Klicken um abzubrechen.": "Cliquer pour annuler.",
	"Preis eingeben": "Saisir le prix",
	"Währung": "Monnaie",
	"Währung eingeben": "Saisir la monnaie",
	"Einheit eingeben": "Entrer l'unité",
	"Startdatum eingeben": "Entrer la date de début",
	"Enddatum eingeben": "Entrer la date de fin",
	Startanzahl: Startanzahl$1,
	"Startanzahl eingeben": "Saisir le nombre de départs",
	Endanzahl: Endanzahl$1,
	"Endanzahl eingeben": "Entrer le nombre final",
	"Priorität": "Priorité",
	"Priorität eingeben": "Entrer la priorité",
	"Aufschlag?": "Le service ?",
	"Preistyp eingeben": "Saisir le type de prix",
	"Neuer Preis": "Nouveau prix",
	Suchen: Suchen$1,
	Ctrl: Ctrl$1,
	"Auswählen": "Sélectionner",
	"Wählen Sie eine Vorlage aus:": "Choisis un modèle :",
	"Sollen wir Ihren Konfigurator jetzt anlegen?": "Devons-nous créer ton configurateur maintenant ?",
	"Wir bringen Sie danach direkt in den Editor.": "Nous t'emmènerons ensuite directement dans l'éditeur.",
	"Anlegen & zum Konfigurator": "Créer & vers le configurateur",
	"Farbenanzahl im Fenster": "Nombre de couleurs dans la fenêtre",
	"Farbkachel Rundung": "Carreau de couleur arrondi",
	"Opazität": "Opacité",
	Hervorhebung: Hervorhebung$1,
	"Groupieren nach": "Regrouper par",
	Expression: Expression$1,
	"Formel Editor": "Éditeur de la formule",
	"Geben Sie Formeln von Variablen ein.": "Saisis des formules de variables.",
	" Schreiben Sie z.B. Länge * Breite.": " Écris par exemple longueur * largeur.",
	"Für ein Attribut nutzen Sie beispielsweise Motor.Leistung, wenn Motor ihr Merkmal und Leistung das entsprechende Attribut ist.": "Par exemple, pour un attribut, utilise Moteur.Puissance si Moteur est sa caractéristique et Puissance l'attribut correspondant.",
	Ergebnis: Ergebnis$1,
	"Keine Formel eingegeben": "Aucune formule saisie",
	"Formel: ": "Formule : ",
	"Noch gibt es nicht genug Auswahlen um eine Vorschau anzuzeigen.": "Il n'y a pas encore assez de sélections pour afficher un aperçu.",
	"Ausblenden der originalen Textur, wenn bedruckt wird?": "Masquer la texture originale lors de l'impression ?",
	"Erlaube Bildformate": "Autoriser les formats d'image",
	Mindestwert: Mindestwert$1,
	Maximalwert: Maximalwert$1,
	Nachkommastellen: Nachkommastellen$1,
	Schrittweite: Schrittweite$1,
	"Zeige Knöpfe an": "Affiche les boutons",
	"Benutze Vielfaches der Schrittweite": "Utilise les multiples de pas",
	Berechnet: Berechnet$1,
	"Zyklus Erkennung deaktivieren": "Désactiver la détection de cycle",
	"Ändern": "Changer",
	Wert: Wert$1,
	"Beispielhafte Beschreibung eines Wertes.": "Exemple de description d'une valeur.",
	"Dies ist nur eine Info": "Ceci n\\'est qu'une information",
	"Color Dropdown": "Sélection de couleur Dropdown",
	"Color Radio": "Choix de la couleur radio",
	Farbauswahl: Farbauswahl$1,
	Komponente: Komponente$1,
	Komponentenliste: Komponentenliste$1,
	"Komponentenliste mit Popup": "Liste de composants avec popup",
	Bildauswahl: Bildauswahl$1,
	Zahleneingabe: Zahleneingabe$1,
	"Radio Buttons": "Boutons radio",
	"Radio Cards": "Cartes radio",
	"RAL-Farbauswahl": "Choix de la couleur RAL",
	Dropdown: Dropdown$1,
	Schalter: Schalter$1,
	"Schalter Card": "Carte d'interruption",
	Texteingabe: Texteingabe$1,
	Beispieltext: Beispieltext$1,
	Optional: Optional$1,
	"Unter \"Werte\" finden Sie dann den speziellen Eintrag \"keine Angabe\". Hier können Sie noch anpassen, was dem Nutzer angezeigt werden soll, wenn er nichts ausgewählt hat.": "Sous \"%r@\\Nvaleurs%r@\\\", tu trouveras l'entrée spéciale %r@\\Npas d'indication%r@\\%r@\\\". Ici, tu peux encore adapter ce que l'utilisateur doit voir s'il n'a rien sélectionné.",
	Versteckt: Versteckt$1,
	"Dieses Merkmal wird nicht angezeigt. Der Wert kann aber in Regeln und Berechnungen genutzt werden.": "Cette caractéristique n'est pas affichée. Mais la valeur peut être utilisée dans les règles et les calculs.",
	"Auswahl nur anzeigen, wenn ausgewählt": "Afficher la sélection uniquement sélectionnée",
	"Die Auswahl wird nicht in der Bestätigung, PDF oder im Shop angezeigt, wenn nichts ausgewählt wurde.": "La sélection ne sera pas affichée dans la confirmation, le PDF ou la boutique si rien n'a été sélectionné.",
	"showSelection.label": "showSelection.label",
	"Aus Gruppe verstecken": "Se cacher du groupe",
	"Diese Option ergibt nur Sinn, wenn die Variable über ein custom Layout an einer anderen Stelle ein- oder ausgeblendet wird. Auch wenn sie hierrüber aus der Gruppe versteckt wird, wird sie trotzdem weiterhin in Zusammenfassungen dieser zugeordnet.": "Cette option n'a de sens que si la variable est affichée ou masquée à un autre endroit via une mise en page personnalisée. Même si elle est cachée du groupe, elle sera toujours associée au groupe dans les résumés.",
	"Folgende Änderungen werden veröffentlicht:": "Les changements suivants sont publiés :",
	"Konfigurator veröffentlichen": "Publier le configurateur",
	"Wertebereich angeben": "Indiquer la plage de valeurs",
	"Merkmale: ": "Caractéristiques : ",
	"Aktionen: ": "Actions : ",
	"Diese Regel ist aktuell deaktiviert.": "Cette règle est actuellement désactivée.",
	"Modell Eigenschaften anpassen": "Adapter les caractéristiques du modèle",
	"Bitte fügen Sie neue Regelzeilen hinzu.": "S\\'il te plaît, ajoute de nouvelles lignes de règles.",
	"Andernfalls wird diese Regel bei der Auswertung nicht beachtet.": "Dans le cas contraire, cette règle ne sera pas prise en compte lors de l'évaluation.",
	"Keine Warnungen": "Pas d'avertissements",
	"Selektions-Bearbeitung": "Édition de la sélection",
	"Alle Regeln ansehen": "Voir toutes les règles",
	Position: Position$1,
	"Rotation (in radiant)": "Rotation (en radian)",
	Scale: Scale$1,
	"Regel Bearbeitung": "Édition de la règle",
	"Kein Label angegeben!": "Pas de label indiqué !",
	"Regel Validierung": "Règle Validation",
	"Fehlende Werte": "Valeurs manquantes",
	Modell: Modell$1,
	Material: Material$1,
	Komponenten: Komponenten$1,
	Druck: Druck$1,
	Farbe: Farbe$1,
	"Kein Modell": "Pas de modèle",
	Regelname: Regelname$1,
	"Wird angewendet": "S\\'applique",
	Produktstruktur: Produktstruktur$1,
	"Reiter ausblenden": "Masquer les onglets",
	"Variablen ausblenden": "Masquer les variables",
	"Werte ausblenden": "Masquer les valeurs",
	"Variablen entfernen": "Supprimer les variables (obsolète)",
	"Reiter entfernen": "Supprimer les onglets (obsolète)",
	"Anzeige von 3D-Modellen": "Affichage de modèles 3D",
	"Anzeige von Informationen": "Affichage d'informations",
	"Austauschen von Oberflächen": "Remplacer les surfaces",
	"Bilder auf Oberflächen drucken": "Imprimer des images sur des surfaces",
	Materialnamen: Materialnamen$1,
	"Wählen Sie ein Materialnamen aus.": "Choisis un nom de matériau.",
	"Ändern der Farbe": "Changer la couleur",
	"Anzeige von Bildern": "Affichage d'images",
	"Preise & Artikel": "Prix et articles",
	"Gültigkeitsregeln": "Règles de validité",
	"Gültigkeit prüfen?": "Vérifier la validité ?",
	Merkmalskombinationen: Merkmalskombinationen$1,
	Merkmale: Merkmale$1,
	Erstellen: Erstellen$1,
	"Artikel zur Stückliste hinzufügen": "Ajouter un article à la liste de pièces",
	"Zugeordnete Variablen": "Variables associées",
	"Wählen Sie die Variablen aus, denen die Artikel zugeordnet werden sollen": "Sélectionne les variables auxquelles les articles doivent être attribués",
	"Befüllen von Komponentenmerkmalen": "Remplir les caractéristiques des composants",
	Komponentenmerkmale: Komponentenmerkmale$1,
	"Wählen Sie Komponentenmerkmale aus.": "Sélectionne les caractéristiques du composant.",
	"Oberflächenaktion hinzufügen": "Ajouter une action de surface",
	"Alle auswählen": "Sélectionner tout",
	"Alle abwählen": "Tout désélectionner",
	"Auswahl umkehren": "Inverser la sélection",
	"Dieser Konfigurator wurde erfolgreich mit Ihrem Shop verbunden: ": "Ce configurateur a été connecté avec succès à ta boutique : ",
	"Falls Sie die Anbindung aufheben möchten, löschen Sie zunächst das Secret im K3 Plugin in Ihrem Shop.": "Si tu souhaites supprimer la connexion, supprime d'abord le secret dans le plugin K3 de ta boutique.",
	"Secret ist gelöscht": "Secret est effacé",
	"Shop-Anbindung aufheben": "Supprimer le lien avec la boutique",
	Herunterladen: Herunterladen$1,
	"Ist installiert": "Est installé",
	"Verbinde Shop": "Relie la boutique",
	" und importiere Artikel": " et importer des articles",
	"Fehler beim Verbinden:": "Erreur de connexion :",
	"Shop erfolgreich verbunden.": "Boutique connectée avec succès.",
	"Fehler beim Verbinden: ": "Erreur de connexion : ",
	"Shop-Anbindung": "Connexion à la boutique",
	"Web-Adresse des Shops": "Adresse web de la boutique",
	"Shopify Admin API Key": "Shopify Admin API Key",
	"Sollen die Artikel aus dem Shop importiert werden?": "Les articles doivent-ils être importés de la boutique ?",
	"Filter für Artikel": "Filtre pour les articles",
	"Sollen die Artikel bei der Bestellung zusammengefasst werden?": "Les articles doivent-ils être regroupés lors de la commande ?",
	"Basis-Name für kombinierte Artikel": "Nom de base pour les articles combinés",
	Verbinden: Verbinden$1,
	"Laden Sie zunächst eines unserer Plugins herunter und installieren Sie es in Ihrem Shop:": "Télécharge d\\'abord l\\'un de nos plugins et installe-le dans ta boutique :",
	"Sie können uns den Vorfall hier melden!": "Tu peux nous signaler l'incident ici !",
	"Konnte das Templat nicht laden.": "N'a pas pu charger le modèle.",
	Templatname: Templatname$1,
	"Standard laden": "Chargement standard",
	"Neuen Templatenamen eingeben": "Saisir un nouveau nom de template",
	"Templat hinzufügen": "Ajouter un template",
	"Desktop Theme wählen": "Choisir un thème de bureau",
	"Ansicht auswählen": "Sélectionner une vue",
	"Datei hochladen": "Télécharger le fichier",
	"You may need to reload the page": "Recharger la page peut être nécessaire",
	"Bitte buchen Sie zunächst ein anderes Produkt:": "Réserve d'abord un autre produit, s'il te plaît :",
	"Bitte wählen": "Choisir s'il te plaît",
	"Diese Aktion verbindet mehrere Merkmale und kann daher hier nicht geändert werden. Ändern Sie dafür direkt die folgende(n) Regel(n):": "Cette action combine plusieurs caractéristiques et ne peut donc pas être modifiée ici. Pour cela, modifie directement la ou les règles suivantes :",
	"Automatisch angelegt": "Créé automatiquement",
	"Aktionen verknüpfen": "Lier les actions",
	"Werte von diesem Merkmal sollen folgende Aktionen auslösen:": "Les valeurs de cette caractéristique doivent déclencher les actions suivantes :",
	"Dieses Merkmal kann nicht verwendet werden, um weitere Vorgänge zu steuern. Nutzen Sie dafür bitte direkt die Regeln.": "Cette caractéristique ne peut pas être utilisée pour contrôler d'autres processus. Pour cela, utilise directement les règles.",
	"Zu den Regeln": "Vers les règles",
	"Artikel bestellen": "Commandant l\\'article",
	"Abhängig von der Auswahl werden verschiedene Artikel zur Stückliste hinzugefügt.": "En fonction de la sélection, différents articles seront ajoutés à la liste de pièces.",
	"Oberfläche ändern": "Modifier la surface",
	"Welche Oberflächen sollen geändert werden? ": "Quelles sont les surfaces qui doivent être modifiées ? ",
	"3D-Modell anzeigen": "Afficher le modèle 3D",
	"Abhängig von der Auswahl werden verschiedene 3D-Modelle angezeigt.": "En fonction de la sélection, différents modèles 3D s'affichent.",
	"Bild anzeigen": "Afficher l'image",
	"Abhängig von der Auswahl werden verschiedene Bilder angezeigt.": "En fonction de la sélection, différentes images s'affichent.",
	"Farbe ändern": "Changer de couleur",
	"Welche Oberflächen sollen eingefärbt werden? ": "Quelles surfaces doivent être colorées ? ",
	"Bild aufdrucken": "Imprimer l'image",
	"Auf welchen Oberflächen soll das hochgeladene Bild aufgedruckt werden? ": "Sur quelles surfaces l'image téléchargée doit-elle être imprimée ? ",
	"Der Wert wird noch in Regeln verwendet:": "Cette valeur est encore utilisée dans les règles :",
	"Löschen Sie bitte zunächst dort die entsprechende(n) Zeile(n).": "Commence par supprimer la ou les lignes correspondantes.",
	"Hier können Sie einstellen, was angezeigt werden soll, wenn noch kein Wert gewählt wurde": "Ici, tu peux définir ce qui doit être affiché quand aucune valeur n'a encore été sélectionnée.",
	"Dieser Wert ist nicht erlaubt.": "Cette valeur n'est pas autorisée.",
	"Maximale Anzahl an Werten ist erreicht.": "Le nombre maximal de valeurs est atteint",
	Farbwert: Farbwert$1,
	Ansicht: Ansicht$1,
	"Key eingeben": "Saisir la clé",
	URL: URL$2,
	"Info-Text": "Texte d'information",
	"Zahlenvariablen haben keine Werte.": "Les variables numériques n'ont pas de valeurs.",
	Auswahlwerte: Auswahlwerte$1,
	"Typ des Merkmals": "Type de caractéristique",
	"es gibt keine Variable mit {{identificator}}": "il n\\'y a pas de variable avec {{identificator}}",
	"es gibt kein Attribut mit {{identificator}}": "il n'y a pas d'attribut d'attribution avec {{identificator}}",
	"es gibt keine Selection mit {{identificator}}": "il n\\'y a pas de sélection avec {{identificator}}",
	"es gibt mehr als eine Selection mit {{identificator}}": "il y a plus d'une sélection avec {{identificator}}",
	"Es gibt einen Zyklus in den berechneten Variablen: {{cycleText}}": "Il y a un cycle dans les variables calculées : {{cycleText}}",
	"das Ergebnis der Formel muss ein Zahlenwert sein, statt dessen ist es {{type}}": "le résultat de la formule doit être une valeur numérique, au lieu de cela, c'est\\'est {{type}}",
	"Wert {{paramName}} der Funktion {{functionName}} ist null": "Valeur {{paramName}} de la fonction {{functionName}} est égal à zéro",
	"Die Variable {{variableLabel}} ist eine Komponentenliste. Sie müssen mit einem Index wie {{variableLabel2}}[0] für das 1. Element oder mit einer Array-Funktionen wie z.B. map(), find(), reduce() oder first() darauf zugreifen": "La variable {{variableLabel}} est une liste de composants. Tu dois utiliser un index comme {{variableLabel2}}[0] pour le 1er élément ou avec une fonction de tableau comme map(), find(), reduce() ou first() pour y accéder.",
	"Zeige Namen": "Afficher les noms",
	"Zeige Beschreibung": "Afficher la description",
	"Zeige Thumbnail": "Afficher la vignette",
	"Zeige Preis": "Afficher le prix",
	"Zeige URL": "Afficher l\\'URL",
	"Zeige Info-Button für Werte": "Afficher le bouton d'information pour les valeurs",
	"Kamerafahrt beim scrollen": "Déplacement de la caméra pendant l'enlèvement",
	"Ungültige, aktiv geänderte, Werte ausblenden": "Masquer les valeurs non valides, modifiées activement",
	"Alle ungültige Werte ausblenden": "Masquer toutes les valeurs non valides",
	"Ausblenden wenn nur eine Auswahl möglich ist": "Masquer si seulement une sélection est possible",
	"Deaktivieren wenn nur eine Auswahl möglich ist": "Désactiver si une seule sélection est possible",
	"Komponente hervorheben": "Mettre en valeur le composant",
	"Dieses Material existiert bereits": "Ce matériel existe déjà",
	"Material hinzufügen": "Ajouter du matériel",
	"Materialname eingeben": "Saisir le nom du matériau",
	Abmessungen: Abmessungen$1,
	Breite: Breite$1,
	"Höhe": "Hauteur",
	Tiefe: Tiefe$1,
	Startpunkt: Startpunkt$1,
	Endpunkt: Endpunkt$1,
	"Linienstärke": "Épaisseur de la ligne",
	Text: Text$2,
	"Automatisches Maß überschreiben": "Casser la mesure automatique",
	"Neues Maß": "Nouvelle mesure",
	"Textgröße als Faktor. 1 ist Standard.": "Taille du texte comme facteur. 1 est la valeur par défaut.",
	Offsets: Offsets$1,
	"Hier können Abweichungen von Position und Rotation, die sich normalerweise aus Start und Endpunkt ergeben, definiert werden. Dazu kann das 3D Positionierungswerkzeug benutzt werden.": "Ici, il est possible de définir les écarts de position et de rotation qui résultent normalement du point de départ et du point final. Pour cela, tu peux utiliser l'outil de positionnement 3D.",
	Edit: Edit$1,
	"Script Modell Editor": "Éditeur de modèle de script",
	"Schreiben Sie das Modell als JSX Komponente.": "Ecris le modèle en tant que composant JSX.",
	"Nicht Befüllt": "Non rempli",
	"Keine Angabe": "Aucune indication",
	"Maximale Anzahl an Iterationen erreicht! Die Regelkonflikte können nicht aufgelöst werden.": "Le nombre maximal d'itérations est atteint ! Les fonctions de régulation ne peuvent pas être supprimées."
};

var list$1 = "Liste";
var color$1 = "Couleurs";
var text$1 = "Texte";
var boolean$1 = "Oui/ Non";
var image$1 = "Image";
var components$1 = "Composants";
var presentation$1 = "Présentation";
var usage$1 = "Actions";
var values$1 = "Valeurs";
var rules$1 = "Règles";
var settings$1 = "Options";
var images$1 = "Images";
var configurators$1 = "Configurateurs";
var street$1 = "Rue";
var zip$1 = "CODE POSTAL";
var city$1 = "Ville";
var country$1 = "Pays";
var extract$1 = "Extraire";
var phone$1 = "Téléphone";
var username$1 = "Nom d'utilisateur";
var Schritt$1 = "Étape";
var MATERIAL$1 = "MATÉRIEL";
var Import$1 = "Importation";
var Manuell$1 = "Manuel";
var Rotation$1 = "Rotation";
var Allgemeines$1 = "Généralités";
var Beschaffenheit$1 = "Caractéristiques";
var Roughness$1 = "Roughness";
var Metallness$1 = "Métallicité";
var Bilderstapel$1 = "Pile d'images";
var Hilfe$2 = "Aide";
var Szeneneinstellungen$1 = "Paramètres de scène";
var Themes$1 = "Thèmes";
var Anpassung$1 = "Adaptation";
var Weiter$1 = "Continue";
var Wertebereich$1 = "Plage de valeurs";
var Darstellung$1 = "Présentation";
var Werte$1 = "Valeurs";
var Anfragen$1 = "Demandes";
var Zeitpunkt$1 = "Moment";
var Benutzer$2 = "Utilisateur";
var Anfrage$1 = "Demande";
var URI$1 = "URI";
var Parameter$1 = "Paramètres";
var Dauer$1 = "Durée";
var Server$1 = "Serveur";
var amount$1 = "Nombre";
var article$1 = "Article";
var Fullscreen$1 = "Mode plein écran";
var showSelection$1 = {
	always: "Toujours",
	never: "Jamais",
	auto: "Comme dans le configurateur",
	label: "Affichage dans la confirmation, le PDF et la boutique"
};
var Aktivieren$1 = "Activer";
var Deaktivieren$1 = "Désactiver";
var variablesAndArticles$1 = "Caractéristiques et articles";
var variablesOnly$1 = "Seulement des caractéristiques";
var articlesOnly$1 = "Seulement des articles";
var noOverview$1 = "Pas d'aperçu";
var Auswahlpreise$1 = "Prix de sélection";
var Variable$1 = "Variable";
var breadcrumb_app$1 = "Généralités";
var breadcrumb_pdf$1 = "PDF";
var breadcrumb_mail$1 = "Mail";
var breadcrumb_embed$1 = "Intégrer";
var breadcrumb_shop$1 = "Boutique";
var breadcrumb_articles$1 = "Article";
var breadcrumb_preview$1 = "Aperçu";
var breadcrumb_edit$1 = "Éditeur";
var breadcrumb_images$1 = "Images";
var breadcrumb_materials$1 = "Matériaux";
var breadcrumb_models$1 = "Modèles";
var breadcrumb_rules$1 = "Règles";
var breadcrumb_settings$1 = "Options";
var breadcrumb_admin$1 = "Admin";
var breadcrumb_extract$1 = "extract";
var breadcrumb_apps$1 = "Configurateurs";
var breadcrumb_create$1 = "Créer";
var breadcrumb_import$1 = "Importer";
var breadcrumb_users$1 = "Utilisateur";
var breadcrumb_support$1 = "Support";
var breadcrumb_logs$1 = "Logs";
var breadcrumb_systemStatus$1 = "État du système";
var breadcrumb_trash$1 = "Corbeille à papier";
var breadcrumb_abonnement$1 = "Abonnement";
var breadcrumb_expired$1 = "Expiré";
var breadcrumb_profile$1 = "Profil";
var breadcrumb_configurator$1 = "Éditeur";
var breadcrumb_configurations$1 = "Configurations";
var breadcrumb_groups$1 = "Cavalier";
var breadcrumb_variables$1 = "Caractéristiques";
var breadcrumb_design$1 = "Design";
var breadcrumb_scene$1 = "Scène";
var breadcrumb_presentation$1 = "Présentation";
var breadcrumb_options$1 = "Options";
var breadcrumb_usage$1 = "Actions";
var breadcrumb_values$1 = "Valeurs";
var frTranslationExtra = {
	list: list$1,
	color: color$1,
	text: text$1,
	boolean: boolean$1,
	image: image$1,
	components: components$1,
	presentation: presentation$1,
	usage: usage$1,
	values: values$1,
	rules: rules$1,
	settings: settings$1,
	images: images$1,
	configurators: configurators$1,
	street: street$1,
	zip: zip$1,
	city: city$1,
	country: country$1,
	extract: extract$1,
	phone: phone$1,
	username: username$1,
	"Maßkette": "Chaîne de mesure",
	"duplicate-entry": "Il existe déjà des comptes avec ces données",
	"create new dealer": "Créer un nouveau commerçant",
	"die Variable {{variableLabel}} ist eine KomponentenListe. Sie müssen mit einem Index wie {{variableLabel}}[0] für das 1. Element oder mit einer Array-Funktionen wie z.B. map(), find(), reduce() oder first() darauf zugreifen": "la variable {{variableLabel}} est une liste de composants. Tu dois utiliser un index comme {{variableLabel}}[0] pour le premier élément ou avec une fonction de tableau comme map(), find(), reduce() ou first().",
	"Dieser Wert ist nicht kombinierbar mit folgenden Auswahlen:": "Cette valeur ne peut pas être combinée avec les sélections suivantes :",
	"Bei Auswahl wird eine Alternative berechnet!": "En cas de sélection, une alternative sera facturée !",
	"Artikel Anzahl": "Article Nombre",
	"Farb auswählen": "Choisir une couleur",
	"< Zurück": "< Retour",
	"Preis Information": "Information sur le prix",
	Schritt: Schritt$1,
	"Ihre Eingabe war leider nicht möglich und wurde auf den nächstmöglichen Wert zurückgesetzt: ": "Ta saisie n'a malheureusement pas été possible et a été réinitialisée à la valeur la plus proche possible : ",
	"Merkmal auswählen": "Sélectionner une caractéristique",
	MATERIAL: MATERIAL$1,
	Import: Import$1,
	"Materialien für den Import auswählen:": "Sélectionner les matériaux pour l'importation :",
	"Wie möchten Sie ein Material erstellen?": "Comment souhaites-tu créer un matériel ?",
	"Import einer .glb und export der enthaltenen Materialien": "Importer un .glb et exporter les matériaux qu'il contient",
	Manuell: Manuell$1,
	"Eigenständiges Anlegen eines PBR-Materials": "Création autonome d'un matériau PBR",
	"Die Variable wird von einer Erweiterung benötigt und kann daher nicht gelöscht werden!": "La variable est requise par une extension et ne peut donc pas être supprimée !",
	"Bitten Sie den Entwickler, die Variable aus der Erweiterung zu entfernen und zu löschen.": "Demande au développeur de retirer la variable de l'extension et de la supprimer.",
	"Die Variable wird noch in Regeln verwendet:": "La variable est encore utilisée dans les règles :",
	"Löschen Sie bitte zunächst dort die entsprechende Spalte.": "Commence par supprimer la colonne correspondante.",
	"Anpassung nötig": "Adaptation",
	"\"Die Auswahl \"{{value}}\" ({{variable}}) passt nicht zu der Auswahl \"{{conflictValue0}}\" ({{conflictVariable0}}).\"": "%r@\\\"La sélection %r@\\\".{{value}}%r@\\\" ({{variable}}) ne correspond pas à la sélection %r@\\\".{{conflictValue0}}%r@\\\" ({{conflictVariable0}}).%r@\\\"",
	"Die Auswahl \"{{value}}\" ({{variable}}) passt nicht zu der Auswahl \"{{conflictValue0}}\" ({{conflictVariable0}}) und der Auswahl \"{{conflictValue1}}\" ({{conflictVariable1}}).": "La sélection %r@\\\"{{value}}%r@\\\" ({{variable}}) ne correspond pas à la sélection \"%r@\\\".{{conflictValue0}}%r@\\\" ({{conflictVariable0}}) et la sélection %r@\\N\"{{conflictValue1}}%r@\\\" ({{conflictVariable1}}).",
	"Die Auswahl \"{{value}}\" ({{variable}}) passt nicht zu der Auswahl \"{{conflictValue0}}\" ({{conflictVariable0}}), der Auswahl \"{{conflictValue1}}\" ({{conflictVariable1}}) und der Auswahl \"{{conflictValue2}}\" ({{conflictVariable2}}).": "La sélection %r@\\\"{{value}}%r@\\\" ({{variable}}) ne correspond pas à la sélection \"%r@\\\".{{conflictValue0}}%r@\\\" ({{conflictVariable0}}), la sélection %r@\\N\"{{conflictValue1}}%r@\\\" ({{conflictVariable1}}) et la sélection %r@\\N\".{{conflictValue2}}%r@\\\" ({{conflictVariable2}}).",
	"Die Auswahl \"{{value}}\" ({{variable}}) passt nicht zu anderen Auswahlen.": "La sélection %r@\\\"{{value}}%r@\\\" ({{variable}}) ne correspond pas à d'autres sélections.",
	"wird zu": "devient",
	"Stattdessen werden folgende Auswahlen angepasst:": "Au lieu de cela, les sélections suivantes sont adaptées :",
	"Design & Layout": "Design & mise en page",
	"Nur sichtbar im Vorschaumodus oder veröffentlichtem Konfigurator!": "Visible uniquement en mode prévisualisation ou configurateur publié !",
	"Theme wählen": "Choisir un thème",
	"Komponente löschen": "Supprimer un composant",
	"Mehrfach Regelzeilen Bearbeitung": "Edition de lignes de règles multiples",
	"Anzahl ausgewählte Regel-Zeilen:": "Nombre de lignes de règles sélectionnées :",
	"Modelaktions-Positionierung": "Positionnement de la modélisation",
	Rotation: Rotation$1,
	"Keine Aktionen für die Mehrfachbearbeitung vorhanden.": "Aucune action disponible pour le traitement multiple",
	Allgemeines: Allgemeines$1,
	"Farben und Lichtinteraktion": "Couleurs et interaction avec la lumière",
	"Color-Map Upload": "Téléchargement de la carte des couleurs",
	"Material interagiert mit Licht in der Szene": "La matière interagit avec la lumière dans la scène",
	Beschaffenheit: Beschaffenheit$1,
	"Roughness-Map Upload": "Télécharger la carte de la rugosité",
	Roughness: Roughness$1,
	"Metallness-Map Upload": "Télécharger la carte de Metallness",
	Metallness: Metallness$1,
	"Normalen-Map Upload": "Téléchargement de la carte normale",
	"Normalen-Skalierung": "Échelle normale",
	"Anwendung auf 3D-Modell": "Application sur modèle 3D",
	"Displacement-Map Upload": "Téléchargement de la carte de déplacement",
	"Displacement-Skalierung": "Échelle de déplacement",
	"Repeat-Faktor der Textur in X- und Y-Richtung": "Facteur de répétition de la texture dans les directions X et Y",
	"Alpha-Werte": "Valeurs alpha",
	"Alpha-Map Upload": "Téléchargement de la carte alpha",
	"Ambient Occlusion": "Occlusion d'ambiance",
	"Ambient-Occlusion-Map Upload": "Téléchargement de la carte d'occlusion d'ambiance",
	"Info editieren": "Éditer l'info",
	"Zeige Info-Button": "Afficher le bouton d'information",
	"Abhängigkeitsschleifen": "Boucles de dépendance",
	Bilderstapel: Bilderstapel$1,
	"Google Analytics Property ID": "ID de propriété Google Analytics",
	"Sans Serif": "Sans Serif",
	"Das flexibles Shopsystem für Ihr E-Commerce-Projekt.": "Le système de boutique flexible pour ton projet de commerce électronique.",
	"Die eine europäische Open-Source-E-Commerce-Plattform. ": "L'une des plateformes européennes de commerce électronique open source. ",
	"Jetzt Adobe Commerce: E-Commerce leicht gemacht.": "Maintenant Adobe Commerce : le e-commerce en toute simplicité.",
	"Erstklassig im digitalen Vertrieb mit dem Oxid esales Shop.": "Première classe dans la vente numérique avec la boutique Oxid esales.",
	"Individuelle Entwicklung": "Développement individuel",
	Hilfe: Hilfe$2,
	"Shop mit einer individuellen Entwicklung anbinden.": "Connecter la boutique avec un développement personnalisé.",
	Szeneneinstellungen: Szeneneinstellungen$1,
	Themes: Themes$1,
	Anpassung: Anpassung$1,
	"Gewähltes Theme übernehmen": "Reprendre le thème choisi",
	"Legen Sie einen neuen Konfigurationsschritt an.": "Crée une nouvelle étape de configuration.",
	"Eine Konfiguration erfolgt in mehreren Schritten. In jedem Schritt können ggf. mehrere Produkt-Eigenschaften angegeben werden. Hier legen Sie den ersten Schritt an.": "Une configuration se fait en plusieurs étapes. Dans chaque étape, il est possible d'indiquer plusieurs propriétés du produit, le cas échéant. Ici, tu crées la première étape.",
	"Konfigurationsschritt erstellen": "Créer une étape de configuration",
	"Bitte klicken Sie zunächst hier, um einen neuen Konfigurator zu erstellen.": "Commence par cliquer ici pour créer un nouveau configurateur.",
	"Neuer Konfigurator wählen": "Choisir le nouveau configurateur",
	"Bitte geben Sie einen Namen ein.": "Saisis un nom, s'il te plaît.",
	"Bitte geben Sie eine Beschreibung ein.": "Saisis une description.",
	"Bestätigen": "Confirmer",
	"Bitte klicken Sie hier.": "Clique ici s'il te plaît.",
	"Konfigurator Dialog aufrufen": "Ouvrir la boîte de dialogue du configurateur",
	"Konfigurationsschritt benennen": "Nommer l'étape de configuration",
	"Hier können Sie neue Werte hinzufügen.": "Ici, tu peux ajouter de nouvelles valeurs.",
	"Merkmale, die eine Liste (oder Farbe, Material, Modell) sind, zeigen mehrere Werte zur Auwahl an. Diese Werte können Sie hier eingeben.": "Les caractéristiques qui sont une liste (ou couleur, matériau, modèle) affichent plusieurs valeurs à choisir. Tu peux saisir ces valeurs ici.",
	"Klicken Sie hier um einen neuen Wert zu erstellen.": "Clique ici pour créer une nouvelle valeur.",
	"Wenn Sie fertig sind klicken Sie hier.": "Quand tu as terminé, clique ici.",
	"Werte erstellen": "Créer des valeurs",
	"Bitte geben Sie einen Namen für das neue Merkmal ein.": "Saisis un nom pour la nouvelle caractéristique.",
	"Bitte wählen Sie eine Darstellung, die den Möglichkeiten des Merkmals entspricht.": "Choisis une présentation qui correspond aux possibilités de la caractéristique.",
	"Präsentation definieren": "Définir la présentation",
	"In einem Schritt kann Ihr Kunde mehrere Merkmale seines Produktes anpassen. Fügen Sie hier das erste Merkmal ein.": "En une seule étape, ton client peut personnaliser plusieurs caractéristiques de son produit. Insère ici la première caractéristique.",
	"Produktmerkmal erstellen": "Créer une caractéristique de produit",
	"Was für ein Merkmal wollen Sie anlegen?": "Quel type de caractéristique veux-tu créer ?",
	"Ein Merkmal kann eine Auswahl sein (z.B. die Größen S, M, L und XL), ein Text oder eine Zahl (z.B. für eine Breite oder Höhe) oder auch eine Farbe oder Material Ihres Produktes oder ein 3D-Modell, dass einen Teil Ihres Produktes darstellt.": "Une caractéristique peut être une sélection (par exemple les tailles S, M, L et XL), un texte ou un chiffre (par exemple pour une largeur ou une hauteur) ou encore une couleur ou une matière de ton produit ou un modèle 3D qui représente une partie de ton produit.",
	"Produktmerkmaltyp auswählen": "Sélectionner le type de caractéristique du produit",
	"Wählen sie den eben erstellten Konfigurator.": "Choisis le configurateur que tu viens de créer.",
	"Steuerung des Konfigurators durch das neue Merkmal.": "Contrôle du configurateur par la nouvelle caractéristique.",
	"Merkmale können z.B. dafür sorgen, dass 3D-Modelle oder Bilder angezeigt werden oder das Oberflächen geändert oder eingefärbt werden. Sie können auch eine Stückliste von Artikel erzeugen, die dann den Preis bestimmt und in den Warenkorb Ihres Shops gelegt werden kann.": "Les caractéristiques peuvent, par exemple, faire en sorte que les modèles 3D ou les images soient affichés ou que les surfaces soient modifiées ou colorées. Tu peux aussi créer une nomenclature d'articles qui détermine ensuite le prix et qui peut être placée dans le panier de ta boutique.",
	"Merkmal verwenden": "Utiliser la caractéristique",
	"Oberfläche ��ndern": "Modifier la surface",
	Weiter: Weiter$1,
	Wertebereich: Wertebereich$1,
	Darstellung: Darstellung$1,
	Werte: Werte$1,
	Anfragen: Anfragen$1,
	Zeitpunkt: Zeitpunkt$1,
	Benutzer: Benutzer$2,
	Anfrage: Anfrage$1,
	URI: URI$1,
	Parameter: Parameter$1,
	Dauer: Dauer$1,
	Server: Server$1,
	"Modell bearbeiten": "Modifier le modèle",
	"Korrekte Mail-Adresse": "Adresse e-mail correcte",
	"Statistik (30 Tage)": "Statistiques (30 jours)",
	amount: amount$1,
	article: article$1,
	"Datum eingeben": "Entrer la date",
	"Nach hause ": "A la maison ",
	"Mandant anlegen": "Créer un client",
	"Nutzer hinzufügen": "Ajouter des utilisateurs",
	"Übersicht": "Aperçu",
	"Persönliche Daten": "Données personnelles",
	"In AR ansehen": "Voir en AR",
	Fullscreen: Fullscreen$1,
	showSelection: showSelection$1,
	"Kamera überschreiben": "Écraser la caméra",
	Aktivieren: Aktivieren$1,
	Deaktivieren: Deaktivieren$1,
	"Übersichtsseite": "Page d'accueil",
	variablesAndArticles: variablesAndArticles$1,
	variablesOnly: variablesOnly$1,
	articlesOnly: articlesOnly$1,
	noOverview: noOverview$1,
	Auswahlpreise: Auswahlpreise$1,
	Variable: Variable$1,
	breadcrumb_app: breadcrumb_app$1,
	breadcrumb_pdf: breadcrumb_pdf$1,
	breadcrumb_mail: breadcrumb_mail$1,
	breadcrumb_embed: breadcrumb_embed$1,
	breadcrumb_shop: breadcrumb_shop$1,
	breadcrumb_articles: breadcrumb_articles$1,
	breadcrumb_preview: breadcrumb_preview$1,
	breadcrumb_edit: breadcrumb_edit$1,
	breadcrumb_images: breadcrumb_images$1,
	breadcrumb_materials: breadcrumb_materials$1,
	breadcrumb_models: breadcrumb_models$1,
	breadcrumb_rules: breadcrumb_rules$1,
	breadcrumb_settings: breadcrumb_settings$1,
	breadcrumb_admin: breadcrumb_admin$1,
	breadcrumb_extract: breadcrumb_extract$1,
	breadcrumb_apps: breadcrumb_apps$1,
	breadcrumb_create: breadcrumb_create$1,
	breadcrumb_import: breadcrumb_import$1,
	breadcrumb_users: breadcrumb_users$1,
	breadcrumb_support: breadcrumb_support$1,
	breadcrumb_logs: breadcrumb_logs$1,
	breadcrumb_systemStatus: breadcrumb_systemStatus$1,
	breadcrumb_trash: breadcrumb_trash$1,
	breadcrumb_abonnement: breadcrumb_abonnement$1,
	breadcrumb_expired: breadcrumb_expired$1,
	breadcrumb_profile: breadcrumb_profile$1,
	breadcrumb_configurator: breadcrumb_configurator$1,
	breadcrumb_configurations: breadcrumb_configurations$1,
	breadcrumb_groups: breadcrumb_groups$1,
	breadcrumb_variables: breadcrumb_variables$1,
	breadcrumb_design: breadcrumb_design$1,
	breadcrumb_scene: breadcrumb_scene$1,
	breadcrumb_presentation: breadcrumb_presentation$1,
	breadcrumb_options: breadcrumb_options$1,
	breadcrumb_usage: breadcrumb_usage$1,
	breadcrumb_values: breadcrumb_values$1,
	"Letzte Gruppe kann nicht gelöscht werden.": "Le dernier groupe ne peut pas être supprimé."
};

const fr = Object.assign({}, frTranslation, frTranslationExtra);

var Mandant = "Klant";
var Produkt = "Product";
var Bezahlzustand = "Betalingsvoorwaarden";
var Addon = "Toevoeging";
var apps = "Configurateurs";
var support = "Ondersteuning";
var dealers = "Revendeur";
var users = "Gebruiker";
var trash = "Papier";
var others = "Andere";
var links = "Onderpand";
var help = "Aide";
var consultation = "Raad";
var status = "Statuut";
var subscription = "Abonnement";
var profile = "Profiel";
var logout = "Aansluiting";
var Template = "Model";
var Aufrufen = "Appeler";
var PDF = "PDF";
var Code = "Code";
var Preis = "Prix";
var Inspiration = "Inspiratie";
var Anzeige = "Advertentie";
var Bild = "Afbeelding";
var Sortierung = "Triage";
var Kunde = "Klant";
var Inhalt = "Inhoud";
var Konfiguratorversion = "Versie van configurator";
var Abbrechen = "Annuler";
var Speichern = "registreren";
var Schliessen = "Fermer";
var Adresse = "Adres";
var Datenschutz = "Bescherming van gegevens";
var Name = "Nom";
var Email = "e-mail";
var Telefon = "Telefoon";
var Bemerkung = "Remarque";
var Firma = "Société";
var Akzeptiert = "Accepteer";
var Stadt = "Ville";
var PLZ = "POSTCODE";
var Datum = "Datum";
var dealer = "Revendeur";
var json = "json";
var Price$1 = "Prix";
var options = "Opties";
var Bestellaktion = "Beveligingsactie";
var Typ = "Type";
var Konfiguration = "Configuratie";
var AR = "AR";
var Geteilt = "Partagé";
var anzeigen = "afficher";
var Artikelnummer = "Artikelnummer";
var Beschreibung = "Beschrijving";
var Kategorie = "Catégorie";
var Preise = "Prix";
var Importieren = "Importeur";
var Upload = "Download";
var Keine = "Pas de";
var Alle = "Alle";
var Bilder = "Afbeeldingen";
var Seite = "Pagina";
var Vorderseite = "Pagina";
var Hinterseite = "Gezicht naar voren";
var Beidseitig = "De twee kanten";
var Optionen = "Opties";
var Bezeichnung = "Benaming";
var Pbr = "Pbr";
var Physikalisch = "Lichaamsbouw";
var Key = "Clé";
var Model = "Model";
var Erweitert = "Élargi";
var Editieren = "Uitgever";
var Kopieren = "Kopieerapparaat";
var Allgemein = "Algemeen";
var Sprachen = "Langues";
var Produktdarstellung = "Présentation du produit";
var Upgrade = "Upgrade";
var Hauptmodell = "Belangrijkste model";
var Vorlage = "Model";
var Tutorial = "Les";
var Export = "Export";
var discount = "Reductie";
var surcharge = "Service";
var Einbetten = "Integreer";
var Referenzsprache = "Referentietaal";
var Artikel = "Artikel";
var Schriftart = "Politie de caractères";
var Helvetica = "Helvetica";
var Courier = "Koerier";
var Interstate = "Interstate";
var Montserrat = "Montserrat";
var Links = "Onderpand";
var Rechts = "Rechts";
var Oben = "En hoog";
var Unten = "En bas";
var Kopfzeile = "En-tête";
var Mail = "Mail";
var Shop = "Boetiek";
var Senden = "Stuur";
var orders = "Commando's";
var Tage = "Jours";
var date = "Datum";
var number = "Nombre";
var articlename = "Naam van het artikel";
var articles = "Artikel";
var Bezahlt = "Paye";
var Wechseln = "Wisselaar";
var Anlegen = "maken";
var Neu = "Nouveau";
var Konfiguratoren = "Configurators";
var Benutzer$1 = "Gebruikers";
var Rolle = "Rol";
var name = "Nom";
var email = "E-mail";
var Nutzerkonto = "Compte d'utilisateur";
var Nutzername = "Gebruikersnaam";
var create$1 = "maken";
var save = "registreren";
var Password = "Pasmotief";
var Login = "Inschrijven";
var Registrierung = "Aanmelden";
var Datenschutzbestimmungen = "Regelgeving gegevensbescherming";
var AGB = "CGV";
var Passwort = "Pasmotief";
var Mandantentabelle = "Mandantentabel";
var Startdatum = "Datum van begin";
var Enddatum = "Einddatum";
var Konfigurator = "Configurateur";
var Merkmal = "Kenmerken";
var Regel = "Règle";
var Nummer = "Numéro";
var Erstellt = "Créé";
var Kennwort = "Pasmotief";
var Sprache = "Langue";
var Download = "Télécharger";
var Hintergrundmodell = "Model van fond";
var Preiseinstellungen = "Prijzen";
var Standard = "Standaard";
var Hauptaktion = "Actie principale";
var Kontaktformular = "Contactformulier";
var Pflichtfeld = "Verplichte Champ";
var Aktionsname = "Actienaam";
var Anzahl = "Nombre";
var Zahl = "Nombre";
var Einheit = "Eenheid";
var Aktionen = "Acties";
var Kameras = "Caméras";
var Kamera = "Caméra";
var Reiter = "Cavalier";
var Kameraansicht = "Uitzicht op de camera";
var Ok = "Ok";
var Fertig = "Prêt";
var Auswahlen = "Verkiezingen";
var Positionspreis = "Prijs per post";
var Gesamtpreis = "Prijs totaal";
var Kostenfrei = "Gratis";
var Downgrade = "Downgrade";
var Home = "Home";
var Hilfe$1 = "Help";
var cancel = "Annuler";
var Icon = "Icône";
var Gruppen = "Groepen";
var Logo$1 = "Logo";
var Farben = "Kleuren";
var CSS = "CSS";
var Variablen = "Variabelen";
var Einstellungen = "Parameters";
var Vorschau = "Aperçu";
var Editor = "Uitgever";
var Regeln = "Regels";
var Articles = "Artikel";
var Modelle = "Modellen";
var Materialien = "Materiaal";
var Bestellungen = "Commando's";
var Fatal_Error_Text = "Helaas is er een onherkende fout opgetreden. Als je het probleem niet kunt oplossen door de pagina opnieuw op te laden, neem dan contact met ons op.";
var Fatal_Error = "Onopzettelijke fout";
var Error_Message = "Foutmelding :";
var Abschnitt = "Sectie";
var Bestelloptionen = "Opties";
var hiddenGroup = "Deze groep is momenteel alleen zichtbaar in het beheerpaneel, omdat hij geen kenmerken met selecteerbare opties bevat.";
var Bearbeiten = "Uitgever";
var Leer = "Video";
var Basiseinstellungen = "Basisparameters";
var Deckkraft = "Opaciteit";
var Anwenden = "Appliquer";
var Auswahl = "Sélection";
var Duplizieren = "Dupliquer";
var Ersetzen = "Remplacer";
var Statistics = "Statistieken";
var Konfigurationen = "Configuraties";
var articleNo = "Artikelnummer";
var articleName = "Nom";
var price = "Prix";
var currency = "Munt";
var Cancel = "Annuler";
var Save = "Sauvegarder";
var Startanzahl = "Aantal onderdelen";
var Endanzahl = "Definitieve naam";
var Suchen = "Onderzoeker";
var Ctrl = "Ctrl";
var Hervorhebung = "Overtuigend";
var Expression = "Expressie";
var Ergebnis = "Resultaat";
var Mindestwert = "Minimale vochtigheid";
var Maximalwert = "Maximale waarde";
var Nachkommastellen = "De cijfers na de maagdelijkheid";
var Schrittweite = "Pas à pas";
var Berechnet = "Calcule";
var Wert = "Valeur";
var Farbauswahl = "Kleur kiezen";
var Komponente = "Samenstelling";
var Komponentenliste = "Lijst van samenstellingen";
var Bildauswahl = "Selectie van afbeeldingen";
var Zahleneingabe = "Tarieven";
var Dropdown = "Lijst déroulante";
var Schalter = "Onderbreker";
var Texteingabe = "Tekstveredeling";
var Beispieltext = "Voorbeeld van tekst";
var Optional = "En optie";
var Versteckt = "Caché";
var Position = "Positie";
var Scale = "Échelle";
var Modell = "Model";
var Material = "Materiaal";
var Komponenten = "Samenstelling";
var Druck = "Indruk";
var Farbe = "Kleur";
var Regelname = "Naam van de regel";
var Produktstruktur = "Structuur van het product";
var Materialnamen = "Namen van materialen";
var Merkmalskombinationen = "Combinaties van eigenschappen";
var Merkmale = "Kenmerken";
var Erstellen = "maken";
var Komponentenmerkmale = "Eigenschappen van de componenten";
var Herunterladen = "Télécharger";
var Verbinden = "Connecter";
var Templatname = "Naam sjabloon";
var Farbwert = "Kleurwaarde";
var Ansicht = "Vue";
var URL$1 = "URL";
var Auswahlwerte = "Keuzemogelijkheden";
var Abmessungen = "Afmetingen";
var Breite = "Groot";
var Tiefe = "Profondeur";
var Startpunkt = "Punt van vertrek";
var Endpunkt = "Punt definitief";
var Text$1 = "Teksten";
var Offsets = "Afwijkingen";
var Edit = "Redactie";
var nlTranslation = {
	"Sie zahlen nicht online. Bitte wenden Sie sich an den Mitarbeiter in Ihrem Unternehmen, der den Vertrag mit ObjectCode geschlossen hat.": "Je betaalt niet online. Neem contact op met de persoon van uw onderneming die het contract met ObjectCode heeft afgesloten.",
	Mandant: Mandant,
	Produkt: Produkt,
	Bezahlzustand: Bezahlzustand,
	"Gültig von": "Waardevol vanaf",
	"Nicht angegeben": "Niet gespecificeerd",
	"Gültig bis": "Geldig tot",
	Addon: Addon,
	apps: apps,
	support: support,
	"dealer-profile": "Profiel van de koper",
	dealers: dealers,
	users: users,
	trash: trash,
	others: others,
	links: links,
	help: help,
	consultation: consultation,
	status: status,
	subscription: subscription,
	profile: profile,
	logout: logout,
	"Neuer Konfigurator": "Nieuwe configurator",
	Template: Template,
	"Zurück": "Stuur  terug.",
	Aufrufen: Aufrufen,
	PDF: PDF,
	Code: Code,
	Preis: Preis,
	Inspiration: Inspiration,
	Anzeige: Anzeige,
	Bild: Bild,
	Sortierung: Sortierung,
	"Sie möchten die Daten dieses Kunden einsehen?": "Wil je de gegevens van deze klant bekijken?",
	Kunde: Kunde,
	Inhalt: Inhalt,
	"Shop-API": "API de la boetiek",
	"Gespeichert am": "Le Sauvé",
	Konfiguratorversion: Konfiguratorversion,
	Abbrechen: Abbrechen,
	Speichern: Speichern,
	"Ergebnis der Shop API": "Resultaat van de API van de winkel",
	Schliessen: Schliessen,
	Adresse: Adresse,
	Datenschutz: Datenschutz,
	Name: Name,
	Email: Email,
	Telefon: Telefon,
	Bemerkung: Bemerkung,
	Firma: Firma,
	"Steuer-ID": "Fiscaal identificatienummer",
	Akzeptiert: Akzeptiert,
	Stadt: Stadt,
	PLZ: PLZ,
	Datum: Datum,
	"exit-action": "Beveligingsactie",
	dealer: dealer,
	"order-status": "Statuut",
	json: json,
	Price: Price$1,
	options: options,
	Bestellaktion: Bestellaktion,
	Typ: Typ,
	Konfiguration: Konfiguration,
	AR: AR,
	Geteilt: Geteilt,
	"Sie möchten die Daten Ihrer Kunden einsehen?": "Wil je de gegevens van je klanten bekijken?",
	"Preise anlegen": "Creëer prijzen",
	anzeigen: anzeigen,
	Artikelnummer: Artikelnummer,
	"Artikelnummer eingeben": "Het nummer van het artikel opzoeken",
	"Namen eingeben": "Onthoud je naam",
	Beschreibung: Beschreibung,
	"Beschreibung eingeben": "Voer de beschrijving in",
	Kategorie: Kategorie,
	"Kategorien eingeben": "Kies de categorieën",
	Preise: Preise,
	"Sie möchten Preise anzeigen?": "Wil je prijzen weergeven?",
	Importieren: Importieren,
	"Artikel und Preise veröffentlichen": "Artikelen en prijzen publiceren",
	"Neuer Artikel": "Nieuw artikel",
	Upload: Upload,
	"Laden Sie ein oder mehrere Bilder in den angegeben Ordner hoch. Die können den Schrägstrich (/) verwenden, um tiefere Ordner zu erzeugen.": "Télécharge une ou plusieurs images dans le dossier indiqué. Je kunt de schuine balk (/) gebruiken om meer gedetailleerde dossiers te maken.",
	"Alternativ können Sie ein ZIP-Archiv mit einer Ordnerstruktur hochladen.": "Sineon, tu peux télécharger une archive ZIP avec une structure de dossier.",
	"Ordner *": "Dossier *",
	"Beachten Sie: Alle Bilder in einem Ordner werden als Galerie gruppiert, nach Name sortiert. Verwenden Sie also Dateinamen wie \"Bild_001\".": "Niet vergeten: alle afbeeldingen in een dossier worden gegroepeerd als galerie, met een naam. Gebruik daarom de bestandsnamen %r@\\N \"image_001%r@\\N%r@\\\".",
	Keine: Keine,
	Alle: Alle,
	"Löschen": "Supprimer",
	Bilder: Bilder,
	Seite: Seite,
	Vorderseite: Vorderseite,
	Hinterseite: Hinterseite,
	Beidseitig: Beidseitig,
	"new-material": "Nieuwe materialen",
	Optionen: Optionen,
	Bezeichnung: Bezeichnung,
	Pbr: Pbr,
	Physikalisch: Physikalisch,
	Key: Key,
	"AR Fallback Material": "Retombeermateriaal AR",
	"Nicht ausgewählt": "Niet geselecteerd",
	Model: Model,
	Erweitert: Erweitert,
	"Nur in Regeln verwendete Materialien anzeigen": "Bevestig alleen de materialen die worden gebruikt in de regels",
	"extract-materials": "Extraire les matériaux du modèle",
	Editieren: Editieren,
	Kopieren: Kopieren,
	"Neues Modell": "Nieuw model",
	"Dynamisches Modell": "Dynamisch model",
	"Gültigkeit": "Geldig",
	"Neue Regel": "Nieuwe regels",
	"Neue Regel Erstellen": "Een nieuwe regel maken",
	"Regel erstellen": "Een regel maken",
	Allgemein: Allgemein,
	Sprachen: Sprachen,
	"Die erste Sprache gilt als Standard.": "La première langue est considérée comme standard.",
	"Die Beschreibung dieses Konfigurators": "De beschrijving van deze configurateur",
	"Link zum Konfigurator": "Verbinding met de configurator",
	"Falls Sie eine Erweiertung nutzen, tragen Sie hier ein, wo Ihr Entwickler sie zur Verfügung stellt.": "Als je een extensie gebruikt, geef dan hier aan waar je ontwikkelaar deze beschikbaar heeft.",
	Produktdarstellung: Produktdarstellung,
	"3D-Modell": "3D model",
	"Bilder-Konfigurator": "Configurateur van afbeeldingen",
	"Google Analytics 4 Property ID": "Google Analytics 4 ID van eigendom",
	"Sie müssen für den Google Cookie die Einverständnis des Nutzers einholen. Das passiert nicht innerhalb des K3!": "Je moet toestemming hebben van de gebruiker voor de cookie van Google. Cela ne se passe pas à l'intérieur de K3!",
	"Sie möchten Ihr Analytics-Konto verbinden?": "Wil je je Analytics-account koppelen?",
	Upgrade: Upgrade,
	Hauptmodell: Hauptmodell,
	"Hauptmodell entfernen": "Het hoofdmodel vervangen",
	Vorlage: Vorlage,
	"Dieser Konfigurator dient als Vorlage": "Deze configurator is een model",
	Tutorial: Tutorial,
	"Standard übernehmen": "Standaard aannemen",
	"screenshot-quality": "Kwaliteit beeldweergave",
	Export: Export,
	"app-code-duplicate": "De code de l'application is al in gebruik",
	"Ihre Händler sollen Ihren Konfigurator nutzen können?": "Wil je dat je dealers je configurator kunnen gebruiken?",
	"Keine Händler vorhanden": "Geen dealers beschikbaar",
	"Legen Sie zuerst einen Händler an - dann geben Sie ihm hier Zugriff auf die App.": "Maak eerst een winkelier aan en geef deze hier toegang tot de app.",
	"Jetzt Händler anlegen": "Nu dealer aanmaken",
	"to dealer app": "vers l'application du concessionnaire",
	"dealer query": "Favorieten",
	discount: discount,
	surcharge: surcharge,
	Einbetten: Einbetten,
	"Als Link": "En tant que lien",
	"Als IFrame": "Comme IFrame",
	"Referenzsprache. Die Einträge müssen mit der Referenzspalte in der importierten Datei übereinstimmen, um berücksichtigt zu werden.": "Referentielijst. De elementen moeten zijn opgenomen in de lijst met referenties in de gedrukte databank om in aanmerking te worden genomen.",
	"Wrong file format, be sure to use the format of the exported file for the currently selected reference language.": "Bad format de fichier, assure-toi d\\'utiliser le format du fichier exporté pour la langue de référence actuellement sélectionnée.",
	"Importiere XLSX": "Importeur XLSX",
	"Exportiere XLSX": "Uitvoerder XLSX",
	Referenzsprache: Referenzsprache,
	"Werden berücksichtigt:": "Worden in aanmerking genomen",
	Artikel: Artikel,
	"Versteckte Variablen": "Variabelen in de cache",
	"Unbenutzte Sprachen": "Ongebruikte talen",
	"Sie möchten Ihren Kunden und/oder sich selbst Anfragen per E-Mail senden?": "Wil je je klanten en/of jezelf vragen sturen per e-mail?",
	"Mail Texte": "Teksten per e-mail",
	"Hier können Sie den Inhalt der versendeten Mails anpassen. Lesen Sie vorab den Abschnitt in der Dokumentation.": "Ici, tu peux adapter le contenu des mails envoyés. Lees de sectie in de documentatie van tevoren.",
	"Bitte beachten Sie: Sie müssen immer den Konfigurator veröffentlichen, bevor die geänderten Texte verwendet werden.": "Let op: je moet de configurator altijd publiceren voordat je de gewijzigde teksten kunt gebruiken.",
	"Sie möchten Bestätigungen oder Angebote als PDF senden?": "Wil je bevestigingen of aanbiedingen als PDF versturen?",
	"Sie möchten den Konfigurator veröffentlichen?": "Wilt u de configurator publiceren?",
	"PDF Einstellungen": "PDF-gegevens",
	Schriftart: Schriftart,
	Helvetica: Helvetica,
	"Times Roman": "Times Roman",
	Courier: Courier,
	Interstate: Interstate,
	Montserrat: Montserrat,
	"Nunito Sans": "Nunito Sans",
	"Poppins Bold": "Poppins Vet",
	"Schriftgröße": "Taille de la police",
	"Seitenränder": "Marges",
	Links: Links,
	Rechts: Rechts,
	Oben: Oben,
	Unten: Unten,
	Kopfzeile: Kopfzeile,
	"Fußzeile": "Pagina",
	"Neue PDF Vorlage auswählen": "Kies een nieuw model PDF",
	"Vorhandene PDF Vorlage löschen": "Bestaande PDF-modellen verwijderen",
	"Voransicht mit dieser Konfiguration:": "Visualisatie met deze configuratie :",
	"und diesem Template:": "et ce modèle :",
	"Speichern und drucken": "Registreren en afdrukken",
	"Für eine Voransicht speichern Sie eine Konfiguration ab.": "Voor een overzicht, registreer een configuratie.",
	"Dann können Sie sie hier drucken.": "U kunt ze hier afdrukken.",
	Mail: Mail,
	Shop: Shop,
	"Social Sharing": "Sociaal partnerschap",
	"Wir helfen gern!": "We helpen je graag!",
	"Ihre Telefonnummer": "Je telefoonnummer",
	"Ihre Nachricht": "Jouw bericht",
	Senden: Senden,
	orders: orders,
	"Preise wurden in den Einstellungen deaktiviert": "De prijzen zijn gedeactiveerd in de parameters",
	"Keine Einnahmen vorliegend": "Pas de recepten en jeu",
	"total-earnings": "Totaalopnames",
	Tage: Tage,
	date: date,
	number: number,
	articlename: articlename,
	articles: articles,
	"Sie können einen Konfigurator unter \"Einstellungen\" exportieren. Die entstandene Datei können Sie hier wieder importieren.": "Je kunt een configurator exporteren onder %r@\\\"Parameters%r@\\%r@\\\". Je kunt het hier verkregen bestand opnieuw importeren.",
	"JSON Export Datei": "Exportbestand JSON",
	"Leerer Konfigurator": "Videoconfigurator",
	"Starten Sie mit einem leeren Konfigurator und richten Sie ihn nach Ihren Wünschen ein.": "Begin met een configurateur vide et configure-le comme tu le souhaites.",
	"Konfigurator importieren": "De configurator importeren",
	"Importieren sie einen Konfigurator anhand einer exportierten Datei.": "Importeer een configurateur op basis van een geëxporteerd bestand.",
	Bezahlt: Bezahlt,
	"Gebucht ab": "Geboekt vanaf",
	"Gebucht bis": "Gereserveerd tot",
	"Mandant erfolgreich geändert": "Klant met succes gewijzigd",
	"Mandant erfolgreich angelegt": "Succesvolle klant",
	"E-Mail": "Elektronische koerier",
	"Einstiegs-Produkt": "Instapproduct",
	"Stripe ID": "Band ID",
	"Angelegt am": "Gemaakt",
	"Wird gelöscht am": "Sera supprimé le",
	"Zu diesem Datum wird der Mandant rückstandlos gelöscht!": "Op deze datum wordt de klant zonder voorbehoud vervangen!",
	"Der vollständige Mandant wird exportiert - inklusive aller Assets. Sind Sie sicher?": "Le mandant complet est exporté - y compris tous les actifs. Weet je het zeker?",
	Wechseln: Wechseln,
	Anlegen: Anlegen,
	Neu: Neu,
	Konfiguratoren: Konfiguratoren,
	Benutzer: Benutzer$1,
	Rolle: Rolle,
	"Vielen Dank für Ihre Bestätigung...": "Merci beaucoup pour ta confirmation...",
	"E-Mail Bestätigung": "Bevestiging per e-mail",
	"Zur Anmeldung": "Vers l'inscription",
	name: name,
	email: email,
	"E-Mail ist ungültig!": "E-mail is niet geldig!",
	Nutzerkonto: Nutzerkonto,
	Nutzername: Nutzername,
	"Mail ist schon vergeben": "Mail is déjà pris",
	"code-duplicate": "Deze code is al aangenomen",
	"dealer code helper text": "Raadpleeg, configurateur de revendeur.",
	"default discount": "Remise par défaut",
	"default surcharge": "toeslag bij défaut",
	"Pro Abo": "Par abonnement",
	"is pro dealer": "Je kunt de configurator op je eigen website gebruiken en het ontwerp aanpassen",
	"Bitte überprüfen Sie die von Ihnen gemachten Angaben: ": "Merci de vérifier les informations que tu as fournies : ",
	create: create$1,
	save: save,
	"Fehlendes Produkt": "Ontbrekend product",
	"Ihre Händler sollen einen Ihrer Konfiguratoren nutzen können?": "Wil je dat je dealers een van je configurators kunnen gebruiken?",
	"Bitte buchen Sie dort zunächst ein anderes Produkt.": "Boek daar eerst een ander product.",
	"new dealer": "Nieuwe distributeur",
	"Login screen": "Opschrift",
	Password: Password,
	Login: Login,
	"Passwort vergessen?": "Paswoord vergeten?",
	"Noch kein Konto?": "Nog geen account?",
	"Ein Login war leider nicht möglich. Die Kombination aus E-Mail und Passwort ist ungültig.": "Helaas was een verbinding niet mogelijk. De combinatie van e-mail en paswoord is niet geldig.",
	"Falls die Mail in den nächsten Minuten nicht ankommt, schauen Sie bitte auch in Ihrem SPAM-Ordner nach und kontrollieren Sie Ihre Adresse.": "Als de mail niet binnen een paar minuten aankomt, controleer dan ook je SPAM-bestand en controleer je adres.",
	"Wir senden Ihnen eine Mail mit Hinweisen zum Setzen eines neuen Kennwortes.": "We sturen je een e-mail met instructies om een nieuw wachtwoord in te voeren.",
	"Mail senden": "Een e-mail verzenden",
	Registrierung: Registrierung,
	"Bitte bestätigen Sie unsere ": "Merci de confirmer notre ",
	Datenschutzbestimmungen: Datenschutzbestimmungen,
	" und unsere ": " en onze ",
	AGB: AGB,
	"Jetzt registrieren": "Nu registreren",
	"Bereits angemeldet?": "Al geregistreerd?",
	"Herzlich willkommen!": "Tot ziens!",
	"Wir haben Ihnen eine E-Mail gesendet - schauen Sie auch in Ihren Spam-Ordner.": "We hebben je een e-mail gestuurd - lees deze ook in je spamdossier.",
	"Sie können sich aber auch jetzt gleich mit Ihren Daten anmelden:": "Maar je kunt je ook meteen inschrijven met je gegevens:",
	"Die Registrierung war leider nicht möglich.": "Helaas was de inschrijving niet mogelijk.",
	"Wir haben Ihr Kennwort neu gesetzt.": "Nous avons réinitialisé ton mot de passe.",
	"Passwort setzen": "Een paswoord definiëren",
	Passwort: Passwort,
	"Mindestens 8 Zeichen, Groß-, Kleinbuchstaben und Zahlen": "Minimaal 8 caractères, majuscules, minuscules en chiffres",
	"Bestätigung": "Bevestiging",
	"Bestätigung stimmt nicht überein": "De bevestiging komt niet overeen",
	"Kennwort setzen": "Een paswoord definiëren",
	Mandantentabelle: Mandantentabelle,
	"Händleraktivierungen": "Activeringen voor winkeliers",
	Startdatum: Startdatum,
	Enddatum: Enddatum,
	"Mandanten wechseln": "Klant wijzigen",
	"Mandanten editieren": "Mandaten bewerken",
	"Neuer Mandant": "Nieuwe klant",
	Konfigurator: Konfigurator,
	Merkmal: Merkmal,
	Regel: Regel,
	Nummer: Nummer,
	Erstellt: Erstellt,
	"Gelöscht": "Supprimé",
	"Zurücklegen": "Remettre",
	"Mindestlänge": "Minimale lengte {{chars}} Kenmerken",
	"Email Adresse ist ungültig": "E-mailadres is niet geldig",
	Kennwort: Kennwort,
	"Test stimmt nicht überein": "De test komt niet overeen met",
	"Telefonnummer ist ungültig": "Het telefoonnummer is niet geldig",
	Sprache: Sprache,
	"Entwickler Modus": "Mode développeur",
	"Gibt Entwicklern Zugriff auf erweiterte Möglichkeiten.": "Geeft ontwikkelaars toegang tot geavanceerde mogelijkheden.",
	"API Token": "Jeton API",
	"Wenn Sie ein neues API Token erzeugen, werden alle bisherigen gelöscht.": "Als je een nieuw API token aanmaakt, worden alle vorige token verwijderd.",
	"Damit verlieren auch alle von Ihnen verbundenen Shops Zugriff auf den Konfigurator.": "Dit betekent dat al je aangesloten winkels ook geen toegang meer hebben tot de configurator.",
	"Sie können das Token im Shop-Plugin eintragen.": "Je kunt het token invoeren in de winkelplugin.",
	"Notieren Sie sich das neue Token, es wird hier nur einmalig angezeigt.": "Noteer het nieuwe token, het wordt hier maar één keer weergegeven.",
	"Mit dem ApiToken erhält ein Shop oder Ihre individuelle Entwicklung Zugriff auf die Daten Ihrer Konfiguratoren.": "Dankzij de ApiToken heeft een boetiek of je individuele ontwikkeling toegang tot de gegevens van je configurators.",
	"new user": "Nieuwe gebruiker",
	"Neuen Nutzer anlegen": "Maak een nieuwe gebruiker",
	"E-Mail nicht valide!": "E-mail ongeldig !",
	"Wir senden dem neuen Nutzer eine E-Mail mit einem Link. Dort kann er sein Kennwort setzen und erhält dann Zugang zu Ihrem Konfigurator.": "We sturen de nieuwe gebruiker een e-mail met een link. Hij kan dan zijn wachtwoord instellen en krijgt toegang tot zijn configurator.",
	"Bitte überprüfen Sie die von Ihnen gemachten Angaben:": "Merci de vérifier les informations que tu as fournies :",
	"Sie möchten dynamische Modelle nutzen und damit z.B. Produkte auf Maß verkaufen?": "Wil je dynamische modellen gebruiken om bijvoorbeeld producten op maat te verkopen?",
	"Hinzufügen": "Aanmelden",
	"Das Modell überschreitet mit {{curr}} die empfohlene Anzahl von {{max}} Dreiecken. Eventuell kann es zu Problemen im AR Modus kommen.": "Het model overtreft met {{curr}} de aanbevolen {{max}} driehoeken. Het kan zijn dat je problemen hebt met de AR-modus.",
	"Das Modell überschreitet mit {{curr}}MB die empfohlene Dateigröße von {{max}}MB.": "Het model werkt niet met {{curr}}MB het aanbevolen bestand van {{max}}MB",
	"3D-Modell auswählen": "Een 3D-model selecteren",
	Download: Download,
	Hintergrundmodell: Hintergrundmodell,
	"material-upload": "materiaal-upload",
	"main-model": "Belangrijkste model",
	"Wirft Schatten": "Jette des ombres",
	"Wird schattiert": "Est ombragé",
	"Bilder Galerie": "Beeldengalerij",
	"Neue Aktion": "Nieuwe actie",
	Preiseinstellungen: Preiseinstellungen,
	"Preise im Konfigurator ausblenden?": "Prijzen verbergen in de configurator?",
	Standard: Standard,
	Hauptaktion: Hauptaktion,
	Kontaktformular: Kontaktformular,
	"Sie können diese Kundendaten zwar erfassen, aber nicht einsehen.": "Je kunt deze klantgegevens wel vastleggen, maar niet bekijken.",
	Pflichtfeld: Pflichtfeld,
	"Sie können Links zu Ihren eigenen Dokumenten mit <a href=\"https://ihre-domain.de/ihre-datenschutzbestimmungen.html\" target=\"_blank\">Datenschutzhinweise</a> einbauen.": "Je kunt links opnemen naar je eigen documenten met <a href=%r@ https://ihre-domain.de/ihre-datenschutzbestimmungen.html%r@\" target=%r@\"_blank%r@\">informatie over gegevensbescherming</a>.",
	Aktionsname: Aktionsname,
	"Shop verbinden": "Winkel aansluiten",
	"Überschrift Bestätigung": "Titels bevestigen",
	"Text Bestätigung": "Teksten bevestiging",
	"Link zur Konfiguration zeigen?": "Montrer le lien vers la configuration?",
	"Thumbnail des Konfigurators": "Vignet van de configurator",
	"Desktop Gerät erkannt": "Bureau-apparaat gedeactiveerd",
	"Augmented-Reality ist aktuell nur auf aktuellen iOS- oder androidOS-Smartphones verfügbar. Scannen Sie daher einfach diesen QR-Code mit der Kamera-App Ihres Smartphones:": "De verbeterde versie is momenteel alleen beschikbaar op de huidige iOS en AndroidOS smartphones. Het is daarom voldoende om deze QR-code te scannen met de camera-applicatie op je smartphone:",
	"Export des 3D-Objekts": "Export van 3D-objecten",
	"Bereitstellen der AR-Datei": "Beschikbaar stellen van fichier AR",
	"Kein Artikel ausgewählt!": "Pas d'article sélectionné!",
	"Artikel auswählen": "Kies een artikel",
	Anzahl: Anzahl,
	"Wert eingeben": "Waarde invoeren",
	"Neue Spalte": "Nieuwe kolonne",
	"Wert-Eigenschaft": "Propriété de la valeur",
	"Sie können den Werten dieses Merkmals Eigenschaften geben, z.B.             Gewicht oder Güteklasse oder Leistung. Diese Eigenschaften können             Sie für jeden Wert getrennt erfassen und dann dem Benutzer ausgeben. Sie             können mit diesen Eigenschaften aber auch Regeln und Berechnungen             deutlich einfacher machen.": "Je kunt eigenschappen toekennen aan de waarden van dit kenmerk, zoals gewicht, kwaliteitsklasse of prestatie. Je kunt deze eigenschappen voor elke waarde apart controleren en vervolgens aan de gebruiker tonen. Maar je kunt deze eigenschappen ook gebruiken om de regels en berekeningen veel eenvoudiger te maken.",
	"Eigenschaft wird dem Nutzer angezeigt": "La propriété est affichée à l'utilisateur",
	"mehrsprachiger Text": "Teksten meertalig",
	"nicht übersetzter Text": "Niet vertaalde teksten",
	Zahl: Zahl,
	Einheit: Einheit,
	"Fokus auf Modelle": "Focus op de modellen",
	"Alle Modelle": "Alle modellen",
	"Fokus über Objektnamen": "Focus op de namen van objecten",
	"Aktuelle Ansicht übernehmen und Speichern": "De huidige weergave opnieuw bekijken en registreren",
	Aktionen: Aktionen,
	"Kamera bearbeiten": "De caméra wijzigen",
	"Noch keine Kamera gespeichert": "Nog geen caméra geregistreerd",
	"Kameras gespeichert: ": "Geregistreerde caméras : ",
	Kameras: Kameras,
	Kamera: Kamera,
	Reiter: Reiter,
	Kameraansicht: Kameraansicht,
	"Kamera speichern": "De caméra registreren",
	"Bitte auswählen": "Kies wat u wilt",
	"Ausgewählt": "Choisi",
	"Merkmal setzen: ": "Een kenmerk toevoegen : ",
	"Keine Farbe ausgewählt!": "Pas de couleur choisie!",
	"Farbe auswählen": "Kleur kiezen",
	"Farbmerkmal auswählen:": "Selecteer een couleur caractéristique :",
	"Keine Auswahl": "Pas de selectie",
	"Sind Sie sicher?": "Tu es sûr ?",
	Ok: Ok,
	"Ergebnis: ": "Resultaat : ",
	"Ihre Konfiguration wurde gespeichert": "Uw configuratie is geregistreerd",
	"Mit diesem Link können Sie Ihre Konfiguration wieder aufrufen: ": "Met deze link kun je je configuratie terugvinden: ",
	"Sie sollten zum Shop weitergeleitet worden sein. Wenn Sie nicht weitergeleitet wurden klicken Sie bitte hier, um Ihre Bestellung abzuschließen: ": "Je moet zijn doorverwezen naar de boetiek. Als je nog niet bent doorgestuurd, klik dan hier om je opdracht te beëindigen: ",
	"Zum Shop": "Vers la boetiek",
	"Ihre Konfiguration konnte nicht gespeichert werden.": "De configuratie is nog niet geregistreerd.",
	"Bitte entschuldigen Sie. Wir haben die Konfiguration in diesem Browser gesichert. Bitte kommen Sie später noch einmal wieder.": "Neem het ons niet kwalijk. We hebben de configuratie van deze navigator verbeterd. Merci de revenir plus tard.",
	"technische Information:": "informatietechniek :",
	Fertig: Fertig,
	"Neues Produkt auswählen": "Een nieuw product kiezen",
	"Neues Produkt hinzufügen": "Een nieuw product toevoegen",
	Auswahlen: Auswahlen,
	"Pos.": "Pos.",
	Positionspreis: Positionspreis,
	Gesamtpreis: Gesamtpreis,
	"Preis: ": "Prijs : ",
	"Kameras für Bestellungsbilder": "Caméras voor opdrachtfoto's",
	"Anfrage erhalten": "Verzoek ontvangen",
	"Buchung erfolgreich": "Succesvol boeken",
	"Für das neue Produkt melden wir uns bei Ihnen.": "We nemen contact met je op voor het nieuwe product.",
	"Ihre Subskription wurde angepasst.": "Je abonnement is aangepast.",
	"Ihre Subskription wurde beendet.": "Je abonnement is geannuleerd.",
	"Das Produkt wurde gebucht.": "Het product is geboekt.",
	"Meine Rechnungen": "Mijn facturen",
	"Auf Anfrage": "Op aanvraag",
	Kostenfrei: Kostenfrei,
	"{{fee}},- EUR pro Monat": "{{fee}}EUR per maand",
	"Derzeit gebucht.": "Momenteel geboekt.",
	"Sie buchen nun ein neues Produkt.": "Je bent nu een nieuw product aan het boeken.",
	Downgrade: Downgrade,
	"Ihre K3 Buchung": "Je K3 boeking",
	"In neuem Tab öffnen": "In nieuw tabblad openen",
	"Konfigurator anpassen": "De configurator personaliseren",
	"main drawer": "Je ziet een overzicht van de configurator die je zoals gewoonlijk kunt gebruiken. Klik op een krijtpictogram om iets aan te passen of :",
	"Ändern Sie die Bestelloptionen": "Wijzig de besturingsopties",
	"Ändern Sie das Design": "Ontwerp aanpassen",
	"Passen sie die 3D Szene an": "De 3D-weergave aanpassen",
	"Speichern Sie die aktuelle Kamera für Bestellungsbilder": "Registreer de huidige caméra voor de opdrachtbeelden",
	"Nutzen Sie die Hilfe": "Gebruik l'aide",
	"Gruppen und Merkmale anpassen:": "Groepen en kenmerken aanpassen :",
	"Gruppen verwalten": "Groepen maken",
	"Merkmale verwalten": "Bekijk de kenmerken",
	"So richten Sie Ihren Konfigurator ein:": "Hoe je je configurator instelt:",
	Home: Home,
	Hilfe: Hilfe$1,
	"Ihr K3": "Jouw K3",
	"dealer sidebar": "Ici, ils peuvent configurer leur concessionnaire",
	"change design": "Ontwerp aanpassen",
	"change logo": "Verander je logo",
	"change price": "Verander de prijs",
	"change pdf": "PDF wijzigen",
	"PDF Gestaltung": "PDF Mise en forme",
	"Laden Sie ein PDF als Vorlage für den Druck hoch.": "Laad een PDF als afdrukhulpmiddel.",
	cancel: cancel,
	"app surcharge": "Définir la majoration",
	"you can change your surcharge here": "u kunt de toeslag hier veranderen",
	"Neue Gruppe": "Nieuwe groep",
	"Neuer Reiter": "Nouvel onglet",
	Icon: Icon,
	"Icon Bilddatei": "Icône fichier image",
	"Icon position": "Positie",
	"Icon Größe": "Afmetingen",
	"Ersetze Weiter mit Aktionsauswahl": "Doorgaan met selectie van actie vervangen",
	"Aktionsnamen überschreiben": "Verplaats de naam van de actie",
	"Individuelles Gruppen-Design": "Individueel groepsontwerp",
	Gruppen: Gruppen,
	"Gruppen editieren": "Groepen bewerken",
	"Desktop Layout": "Pagina van het bureau",
	"Reiter schrittweise einblenden": "Pas à pas onglets afficheren",
	"Besuchte Reiter abhaken": "Bezoek cavaliers",
	"Desktop Layout wählen": "Kies de lay-out van het bureau",
	"Schließen": "Fermer",
	"Mobile Layout": "Mobiele pagina",
	"Mobile Layout wählen": "Kies een mobiele pagina",
	Logo: Logo$1,
	"Konfigurator-Abschluss": "Afwerking van de configurator",
	"3D Szene": "Scène 3D",
	"Manuelle Einstellung erstellen": "Handmatige instellingen maken",
	"Design & Theme": "Ontwerp & thema",
	Farben: Farben,
	"Farbanpassungen zurücksetzten": "Kleurinstellingen opnieuw initialiseren",
	CSS: CSS,
	"Sie können das Aussehen Ihres Konfigurators auch mittels CSS individuell anpassen:": "Je kunt ook het uiterlijk van je configurateur aanpassen met behulp van CSS:",
	"Link zur CSS-Datei": "Link naar CSS-bestand",
	"Oder laden Sie eine CSS Datei hoch:": "Of télécharge un fichier CSS :",
	"Neues Merkmal": "Nieuwe karaktereigenschappen",
	Variablen: Variablen,
	"Variablen editieren": "Variabelen bewerken",
	Einstellungen: Einstellungen,
	"Dynamische Texte": "Dynamische teksten",
	Vorschau: Vorschau,
	Editor: Editor,
	Regeln: Regeln,
	Articles: Articles,
	Modelle: Modelle,
	Materialien: Materialien,
	Bestellungen: Bestellungen,
	"Inhalte: ": "Inhoud : ",
	"Bevor der Konfigurator genutzt werden kann, müssen sie den Knopf \"Veröffentlichen\" betätigen. Wenn Sie danach Änderungen vornehmen, werden diese auch erst nach der nächsten Veröffentlichung wirksam.": "Voordat je de configurator kunt gebruiken, moet je op de knop %r@\\\"Publiceren%r@\\\" klikken. Als je hierna wijzigingen aanbrengt, worden deze pas na de volgende publicatie van kracht.",
	"Live Version": "Versie live",
	"Veröffentlichen": "Uitgeverij",
	"Erstelle Option: ": "Maak een optie: ",
	Fatal_Error_Text: Fatal_Error_Text,
	Fatal_Error: Fatal_Error,
	"Fehlermeldung:": "Foutmelding :",
	"Zur Startseite": "Vers la page d'accueil",
	"Neu Laden": "Nieuwe magazijn",
	"Cleanup und Neu Laden": "Nettoyer en oplader",
	Error_Message: Error_Message,
	"Die folgenden Gründe sprechen gegen eine Löschung:": "De volgende redenen zijn tegen de afschaffing:",
	"einer Erweiterung. Bitten Sie den Entwickler die Nutzung zu entfernen und löschen Sie dann den Key.": "een uitbreiding. Vraag de ontwikkelaar om het gebruik te verminderen en verlaag dan de clé.",
	"der Definition der Regel": "definitie van de regel",
	"einem Eintrag in Regel": "een ingang in Règle",
	"einer berechneten Eigenschaft des Modells": "een berekende eigenschap van het model",
	"der Formel von": "de la formule de",
	"der Kamera": "De caméra",
	"des Merkmals": "de la caractéristique",
	"der Gruppe": "in groepsverband",
	"der globalen Kamera": "Wereldwijde camouflage",
	"Löschen Sie bitte zunächst die anderen Referenzen.": "Ondersteun ook de andere referenties, als het mag.",
	Abschnitt: Abschnitt,
	"Bitte legen Sie einen Reiter an!": "Maak een onglet, s'il te plaît!",
	"Gruppe editieren": "Groep bewerken",
	Bestelloptionen: Bestelloptionen,
	"Merkmal editieren": "Karakteristiek bewerken",
	hiddenGroup: hiddenGroup,
	"Label eingeben": "Etiquette invoeren",
	Bearbeiten: Bearbeiten,
	"Bilder auswählen": "Afbeeldingen kiezen",
	"Ordner auswählen:": "Selecteer een dossier:",
	"Bildmerkmal: ": "Karakteristiek van de afbeelding : ",
	"Kein Bild ausgewählt": "Pas d'image sélectionnée",
	"Bild auswählen": "Kies een afbeelding",
	"Bildmerkmal auswählen:": "Selecteer een afbeelding:",
	"Befüllt": "Rempli",
	Leer: Leer,
	"Zustand auswählen": "Kies een staat",
	"Kein Komponente ausgewählt!": "Aucun composant sélectionné!",
	"Komponente auswählen": "Selecteer een composant",
	"Intervall eingeben": "Voer het interval in",
	"Zum Dashboard": "Vers le tableau de bord",
	Basiseinstellungen: Basiseinstellungen,
	"Helles Theme": "Thema helder",
	"Erweiterte Einstellungen": "Geavanceerde parameters",
	"Label hinzufügen: ": "Een afbeelding toevoegen : ",
	"Kein Label ausgewählt!": "Pas de label sélectionné!",
	"Was soll angezeigt werden?": "Wat moet er worden aangebracht?",
	"Maximalgröße": "Maximale taille",
	Deckkraft: Deckkraft,
	"Kein Material ausgewählt!": "Pas de matériel sélectionné!",
	"Material auswählen": "Materiaal kiezen",
	"Material auswählen:": "Materiaal kiezen",
	"Beschränkung der Auswirkungen auf bestimmte Modelle": "Beperk de impact tot bepaalde modellen",
	"Welches Teil soll hinzugefügt werden?": "Welk deel moet ik toevoegen?",
	"Mobile Theme wählen": "Kies een mobiel thema",
	"Layout auswählen": "Kies een mise en page",
	"Layout erstellen": "Een pagina maken",
	"Gewähltes Layout kopieren": "Kopieer de geselecteerde pagina",
	Anwenden: Anwenden,
	"Kein Modell ausgewählt!": "Pas de modèle sélectionné!",
	"Modell auswählen": "Kies een model",
	"Modell hinzufügen:": "Model toevoegen :",
	"Globale Änderung": "Wereldwijde verandering",
	"Oberflächen": "Oppervlakken",
	"Ausgewählte Oberflächen": "Geselecteerde afwerkingen",
	"Eintrag darf nicht leer sein.": "De ingang mag niet op video staan.",
	"Alle Werte": "Alle waarden",
	"Werte auswählen": "Waarde selecteren",
	Auswahl: Auswahl,
	"Hoch schieben": "Pousser vers le haut",
	"Runter schieben": "Pousser vers le bas",
	Duplizieren: Duplizieren,
	"Sortierung anwenden": "De tri toepassen",
	"Das Dateiformat ist nicht erlaubt! Keine Datei gewählt.": "Het formaat van het bestand is niet toegestaan! Aucun fichier sélectionné.",
	"Erlaube Formate:": "De formaten autoriseren :",
	"Keine Datei gewählt.": "Aucun fichier sélectionné.",
	"Das Dateiformat ist nicht erlaubt!": "Het formaat van het bestand is niet geautoriseerd!",
	Ersetzen: Ersetzen,
	"Bild hochladen": "Beeld downloaden",
	"Diese Variable ist nicht erlaubt.": "Deze variabele is niet toegestaan.",
	"Merkmal-Info editieren": "Meer informatie over de kenmerken",
	"Vorlage wählen": "Selecteer sjabloon",
	"Konfigurator erstellen": "Een configurator maken",
	"Willkommen in Ihrem neuen K3 Konto!": "Welkom op je nieuwe K3 account!",
	"Richten Sie gleich Ihren ersten Konfigurator ein:": "Stel meteen je eerste configurator in:",
	"Sie können alle Daten natürlich später noch ändern.": "Je kunt natuurlijk alle gegevens later wijzigen.",
	"Nicht veröffentlicht": "Niet gepubliceerd",
	Statistics: Statistics,
	Konfigurationen: Konfigurationen,
	"Konfigurator wurde aktualisiert": "De configurator is bijgewerkt",
	"Seit Sie diese Konfiguration gespeichert haben, wurde der Konfigurator weiterentwickelt. Wollen Sie die aktuelle Version verwenden und weiterarbeiten oder die alte Version nur zur Ansicht öffnen?": "Sinds je deze configuratie hebt geregistreerd, is de configurator ontwikkeld. Wil je de huidige versie gebruiken en verder werken of de oude versie openen om deze te raadplegen?",
	"Alte Version": "Oude versie",
	"Aktuelle Version": "Huidige versie",
	"Ladevorgang fehlgeschlagen": "Opladen",
	"Die Konfiguration konnte nicht geladen werden! Bitte versuchen Sie es später erneut!": "De configuratie is niet opgeladen! Bedankt voor de snelle reactie!",
	"Keine Optionen": "Geen opties",
	articleNo: articleNo,
	articleName: articleName,
	price: price,
	currency: currency,
	Cancel: Cancel,
	Save: Save,
	"edit-positions": "Posities veranderen",
	"Klicken um abzubrechen.": "Cliquer pour annuler.",
	"Preis eingeben": "Bepaal de prijs",
	"Währung": "Munt",
	"Währung eingeben": "De monnaie redden",
	"Einheit eingeben": "De eenheid binnengaan",
	"Startdatum eingeben": "Datum invoeren",
	"Enddatum eingeben": "Datum invoeren",
	Startanzahl: Startanzahl,
	"Startanzahl eingeben": "Bepaal het aantal onderdelen",
	Endanzahl: Endanzahl,
	"Endanzahl eingeben": "Voer de uiteindelijke naam in",
	"Priorität": "Prioriteit",
	"Priorität eingeben": "Prioriteit invoeren",
	"Aufschlag?": "De service?",
	"Preistyp eingeben": "Bepaal de prijs",
	"Neuer Preis": "Nieuwe prijs",
	Suchen: Suchen,
	Ctrl: Ctrl,
	"Auswählen": "Selecteer",
	"Wählen Sie eine Vorlage aus:": "Selecteer een sjabloon:",
	"Sollen wir Ihren Konfigurator jetzt anlegen?": "Moeten we nu je configurator maken?",
	"Wir bringen Sie danach direkt in den Editor.": "We brengen je dan rechtstreeks naar de redacteur.",
	"Anlegen & zum Konfigurator": "Maken & naar de configurator",
	"Farbenanzahl im Fenster": "Aantal kleuren in het scherm",
	"Farbkachel Rundung": "Carreau de couleur arrondi",
	"Opazität": "Opaciteit",
	Hervorhebung: Hervorhebung,
	"Groupieren nach": "Opnieuw par",
	Expression: Expression,
	"Formel Editor": "Uitgever van de formule",
	"Geben Sie Formeln von Variablen ein.": "Saisis des formules de variables.",
	" Schreiben Sie z.B. Länge * Breite.": " Écris par exemple longueur * largeur.",
	"Für ein Attribut nutzen Sie beispielsweise Motor.Leistung, wenn Motor ihr Merkmal und Leistung das entsprechende Attribut ist.": "Gebruik bijvoorbeeld voor een attribuut Moteur.Puissance als Moteur het kenmerk is en Puissance l'attribut overeenkomt.",
	Ergebnis: Ergebnis,
	"Keine Formel eingegeben": "Aucune formule saisie",
	"Formel: ": "Formule : ",
	"Noch gibt es nicht genug Auswahlen um eine Vorschau anzuzeigen.": "Er zijn niet genoeg verkiezingen om een overzicht te geven.",
	"Ausblenden der originalen Textur, wenn bedruckt wird?": "De originele textuur verbergen tijdens de impressie?",
	"Erlaube Bildformate": "Afbeeldingsformaten autoriseren",
	Mindestwert: Mindestwert,
	Maximalwert: Maximalwert,
	Nachkommastellen: Nachkommastellen,
	Schrittweite: Schrittweite,
	"Zeige Knöpfe an": "Druk op de knoppen",
	"Benutze Vielfaches der Schrittweite": "Gebruik de meervoudige pas",
	Berechnet: Berechnet,
	"Zyklus Erkennung deaktivieren": "De cyclus verwijderen",
	"Ändern": "Wisselaar",
	Wert: Wert,
	"Beispielhafte Beschreibung eines Wertes.": "Voorbeeld van een beschrijving van een waarde.",
	"Dies ist nur eine Info": "Ceci n'est qu'une information",
	"Color Dropdown": "Kleur selecteren Dropdown",
	"Color Radio": "Kies de radiokleur",
	Farbauswahl: Farbauswahl,
	Komponente: Komponente,
	Komponentenliste: Komponentenliste,
	"Komponentenliste mit Popup": "Lijst met componenten met pop-up",
	Bildauswahl: Bildauswahl,
	Zahleneingabe: Zahleneingabe,
	"Radio Buttons": "Radio",
	"Radio Cards": "Cartes radio",
	"RAL-Farbauswahl": "Kies de RAL-kleur",
	Dropdown: Dropdown,
	Schalter: Schalter,
	"Schalter Card": "Interrupteur Kaart",
	Texteingabe: Texteingabe,
	Beispieltext: Beispieltext,
	Optional: Optional,
	"Unter \"Werte\" finden Sie dann den speziellen Eintrag \"keine Angabe\". Hier können Sie noch anpassen, was dem Nutzer angezeigt werden soll, wenn er nichts ausgewählt hat.": "Onder \"%r@\\Nvaleurs%r@\\\" vind je een speciaal item %r@\\Npas d\\'indication%r@\\\". Hier kun je nog meer aanpassen wat de gebruiker wil zien als hij niets geselecteerd heeft.",
	Versteckt: Versteckt,
	"Dieses Merkmal wird nicht angezeigt. Der Wert kann aber in Regeln und Berechnungen genutzt werden.": "Deze eigenschap wordt niet weergegeven. De waarde kan echter wel worden gebruikt in de regels en berekeningen.",
	"Auswahl nur anzeigen, wenn ausgewählt": "Alleen selecteren als geselecteerd",
	"Die Auswahl wird nicht in der Bestätigung, PDF oder im Shop angezeigt, wenn nichts ausgewählt wurde.": "La sélection ne sera pas affichée dans la confirmation, le PDF ou la boutique si rien n'a été sélectionné.",
	"showSelection.label": "showSelectie.label",
	"Aus Gruppe verstecken": "De groep leiden",
	"Diese Option ergibt nur Sinn, wenn die Variable über ein custom Layout an einer anderen Stelle ein- oder ausgeblendet wird. Auch wenn sie hierrüber aus der Gruppe versteckt wird, wird sie trotzdem weiterhin in Zusammenfassungen dieser zugeordnet.": "Deze optie heeft geen betekenis als de variabele op een andere plaats wordt weergegeven of gemaskeerd via een gepersonaliseerde mise en page. Zelfs als deze door de groep in de cache is opgeslagen, zal deze altijd met de groep worden geassocieerd in de cv's.",
	"Folgende Änderungen werden veröffentlicht:": "De volgende wijzigingen zijn gepubliceerd:",
	"Konfigurator veröffentlichen": "Configurator publiceren",
	"Wertebereich angeben": "Indiquer la plage de valeurs",
	"Merkmale: ": "Kenmerken : ",
	"Aktionen: ": "Acties : ",
	"Diese Regel ist aktuell deaktiviert.": "Deze regel is momenteel gedeactiveerd.",
	"Modell Eigenschaften anpassen": "De kenmerken van het model aanpassen",
	"Bitte fügen Sie neue Regelzeilen hinzu.": "Als het mag, voeg dan nieuwe regels toe.",
	"Andernfalls wird diese Regel bei der Auswertung nicht beachtet.": "In het tegenovergestelde geval wordt deze regel niet meegenomen in de evaluatie.",
	"Keine Warnungen": "Pas d'avertissements",
	"Selektions-Bearbeitung": "Uitgave van de selectie",
	"Alle Regeln ansehen": "Bekijk alle regels",
	Position: Position,
	"Rotation (in radiant)": "Rotatie (en radiaal)",
	Scale: Scale,
	"Regel Bearbeitung": "Uitgave van de wet",
	"Kein Label angegeben!": "Pas de label indiqué!",
	"Regel Validierung": "Valideren",
	"Fehlende Werte": "Manifestaties",
	Modell: Modell,
	Material: Material,
	Komponenten: Komponenten,
	Druck: Druck,
	Farbe: Farbe,
	"Kein Modell": "Pas de modèle",
	Regelname: Regelname,
	"Wird angewendet": "Applique",
	Produktstruktur: Produktstruktur,
	"Reiter ausblenden": "Masquer les onglets",
	"Variablen ausblenden": "Verberg de variabelen",
	"Werte ausblenden": "Masquer les valeurs",
	"Variablen entfernen": "Supprimer les variables (obsolète)",
	"Reiter entfernen": "Supprimer les onglets (obsolète)",
	"Anzeige von 3D-Modellen": "3D-modellen weergeven",
	"Anzeige von Informationen": "Informatie Affichage",
	"Austauschen von Oberflächen": "Oppervlakken vervangen",
	"Bilder auf Oberflächen drucken": "Afbeeldingen op oppervlakken afdrukken",
	Materialnamen: Materialnamen,
	"Wählen Sie ein Materialnamen aus.": "Kies een materiaalnaam.",
	"Ändern der Farbe": "De kleur veranderen",
	"Anzeige von Bildern": "Afbeeldingen Afficheren",
	"Preise & Artikel": "Prijzen en artikelen",
	"Gültigkeitsregeln": "Geldigheidsregels",
	"Gültigkeit prüfen?": "De geldigheid controleren?",
	Merkmalskombinationen: Merkmalskombinationen,
	Merkmale: Merkmale,
	Erstellen: Erstellen,
	"Artikel zur Stückliste hinzufügen": "Een artikel toevoegen aan de lijst met artikelen",
	"Zugeordnete Variablen": "Variabelen",
	"Wählen Sie die Variablen aus, denen die Artikel zugeordnet werden sollen": "Kies de variabelen waaraan de artikelen moeten worden toegewezen",
	"Befüllen von Komponentenmerkmalen": "De eigenschappen van samenstellingen vervangen",
	Komponentenmerkmale: Komponentenmerkmale,
	"Wählen Sie Komponentenmerkmale aus.": "Selecteer de eigenschappen van het onderdeel.",
	"Oberflächenaktion hinzufügen": "Een actie op het oppervlak toevoegen",
	"Alle auswählen": "Alles selecteren",
	"Alle abwählen": "Alles kiezen",
	"Auswahl umkehren": "Selectie omkeren",
	"Dieser Konfigurator wurde erfolgreich mit Ihrem Shop verbunden: ": "Deze configurator is succesvol verbonden met de boutique: ",
	"Falls Sie die Anbindung aufheben möchten, löschen Sie zunächst das Secret im K3 Plugin in Ihrem Shop.": "Als je de verbinding wilt onderdrukken, onderdruk dan eerst het geheim in de K3 plugin in je boetiek.",
	"Secret ist gelöscht": "Geheim verdwijnt",
	"Shop-Anbindung aufheben": "De band met de boetiek verstevigen",
	Herunterladen: Herunterladen,
	"Ist installiert": "Wordt geïnstalleerd",
	"Verbinde Shop": "Winkel opnieuw openen",
	" und importiere Artikel": " en artikelen importeren",
	"Fehler beim Verbinden:": "Erreur de connexion :",
	"Shop erfolgreich verbunden.": "Een succesvolle winkel.",
	"Fehler beim Verbinden: ": "Erreur de connexion : ",
	"Shop-Anbindung": "Verbinding met de winkel",
	"Web-Adresse des Shops": "Webadres van de boetiek",
	"Shopify Admin API Key": "Shopify Admin API sleutel",
	"Sollen die Artikel aus dem Shop importiert werden?": "Moeten de artikelen worden geïmporteerd uit de winkel?",
	"Filter für Artikel": "Filters voor artikelen",
	"Sollen die Artikel bei der Bestellung zusammengefasst werden?": "Moeten de artikelen gegroepeerd worden tijdens de opdracht?",
	"Basis-Name für kombinierte Artikel": "Basisbenaming voor gecombineerde artikelen",
	Verbinden: Verbinden,
	"Laden Sie zunächst eines unserer Plugins herunter und installieren Sie es in Ihrem Shop:": "Télécharge d'abord l'un de nos plugins et installe-le dans ta boutique :",
	"Sie können uns den Vorfall hier melden!": "Je kunt ons hier een signaal geven!",
	"Konnte das Templat nicht laden.": "Ik heb het model nog niet kunnen opladen.",
	Templatname: Templatname,
	"Standard laden": "Standaard opladen",
	"Neuen Templatenamen eingeben": "Een nieuwe sjabloonnaam opgeven",
	"Templat hinzufügen": "Sjabloon toevoegen",
	"Desktop Theme wählen": "Kies een thema voor je bureau",
	"Ansicht auswählen": "Een uitzicht selecteren",
	"Datei hochladen": "Download het bestand",
	"You may need to reload the page": "Het kan nodig zijn om de pagina opnieuw op te laden",
	"Bitte buchen Sie zunächst ein anderes Produkt:": "Reserveer eerst een ander product:",
	"Bitte wählen": "Kies wat u wilt",
	"Diese Aktion verbindet mehrere Merkmale und kann daher hier nicht geändert werden. Ändern Sie dafür direkt die folgende(n) Regel(n):": "Deze actie combineert verschillende kenmerken en kan daarom hier niet worden aangepast. Wijzig hiervoor direct een of meer van de volgende regels:",
	"Automatisch angelegt": "Automatisch gecreëerd",
	"Aktionen verknüpfen": "Lieren van acties",
	"Werte von diesem Merkmal sollen folgende Aktionen auslösen:": "De waarden van deze eigenschap moeten de volgende acties aangeven:",
	"Dieses Merkmal kann nicht verwendet werden, um weitere Vorgänge zu steuern. Nutzen Sie dafür bitte direkt die Regeln.": "Dit kenmerk kan niet worden gebruikt om andere processen te besturen. Gebruik hiervoor rechtstreeks de regels.",
	"Zu den Regeln": "Vers les règles",
	"Artikel bestellen": "Commandant artikel",
	"Abhängig von der Auswahl werden verschiedene Artikel zur Stückliste hinzugefügt.": "Afhankelijk van de selectie worden verschillende artikelen toegevoegd aan de lijst met items.",
	"Oberfläche ändern": "Verander het oppervlak",
	"Welche Oberflächen sollen geändert werden? ": "Wat zijn de oppervlakken die moeten worden aangepast? ",
	"3D-Modell anzeigen": "Het 3D-model weergeven",
	"Abhängig von der Auswahl werden verschiedene 3D-Modelle angezeigt.": "Afhankelijk van de selectie worden verschillende 3D-modellen weergegeven.",
	"Bild anzeigen": "Afficher l'image",
	"Abhängig von der Auswahl werden verschiedene Bilder angezeigt.": "Afhankelijk van de selectie worden verschillende afbeeldingen weergegeven.",
	"Farbe ändern": "Kleur veranderen",
	"Welche Oberflächen sollen eingefärbt werden? ": "Welke oppervlakken moeten worden ingekleurd? ",
	"Bild aufdrucken": "Imprimer l'image",
	"Auf welchen Oberflächen soll das hochgeladene Bild aufgedruckt werden? ": "Op welke oppervlakken moet de afbeelding worden afgedrukt? ",
	"Der Wert wird noch in Regeln verwendet:": "Deze waarde wordt nog steeds gebruikt in de regels:",
	"Löschen Sie bitte zunächst dort die entsprechende(n) Zeile(n).": "Begin met supprimer la ou les lignes correspondantes.",
	"Hier können Sie einstellen, was angezeigt werden soll, wenn noch kein Wert gewählt wurde": "Ici, tu peux définir ce qui doit être affiché lorsqu'aucune valeur n'a encore étélectionnée.",
	"Dieser Wert ist nicht erlaubt.": "Deze waarde is niet toegestaan.",
	"Maximale Anzahl an Werten ist erreicht.": "Het maximum aantal waarden is bereikt.",
	Farbwert: Farbwert,
	Ansicht: Ansicht,
	"Key eingeben": "De clé vinden",
	URL: URL$1,
	"Info-Text": "Teksten d'informatie",
	"Zahlenvariablen haben keine Werte.": "De numerieke variabelen hebben geen waarde.",
	Auswahlwerte: Auswahlwerte,
	"Typ des Merkmals": "Type kenmerk",
	"es gibt keine Variable mit {{identificator}}": "il n'y a pas de variable avec {{identificator}}",
	"es gibt kein Attribut mit {{identificator}}": "er is geen attribuut met {{identificator}}",
	"es gibt keine Selection mit {{identificator}}": "er is geen keuze met {{identificator}}",
	"es gibt mehr als eine Selection mit {{identificator}}": "il y a plus d'une sélection avec {{identificator}}",
	"Es gibt einen Zyklus in den berechneten Variablen: {{cycleText}}": "Er is een cyclus in de berekende variabelen: {{cycleText}}",
	"das Ergebnis der Formel muss ein Zahlenwert sein, statt dessen ist es {{type}}": "het resultaat van de formule moet een numerieke waarde zijn, in plaats daarvan is het {{type}}",
	"Wert {{paramName}} der Funktion {{functionName}} ist null": "Valeur {{paramName}} van de functie {{functionName}} is gelijk aan nul",
	"Die Variable {{variableLabel}} ist eine Komponentenliste. Sie müssen mit einem Index wie {{variableLabel2}}[0] für das 1. Element oder mit einer Array-Funktionen wie z.B. map(), find(), reduce() oder first() darauf zugreifen": "La variabele {{variableLabel}} is een lijst van componenten. Je moet een index gebruiken zoals {{variableLabel2}}[0] voor het eerste element of met een functie voor tabellen zoals map(), find(), reduce() of first() om toegang te krijgen.",
	"Zeige Namen": "Namen bevestigen",
	"Zeige Beschreibung": "Beschrijving",
	"Zeige Thumbnail": "Maak het vignet zichtbaar",
	"Zeige Preis": "Bevestig de prijs",
	"Zeige URL": "URL openen",
	"Zeige Info-Button für Werte": "Informatie selecteren voor de waarden",
	"Kamerafahrt beim scrollen": "Verplaatsing van de caméra tijdens de storing",
	"Ungültige, aktiv geänderte, Werte ausblenden": "Masquer les valeurs non valides, modifiées activement",
	"Alle ungültige Werte ausblenden": "Verwijder alle niet-valide waarden",
	"Ausblenden wenn nur eine Auswahl möglich ist": "Masker als slechts één selectie mogelijk is",
	"Deaktivieren wenn nur eine Auswahl möglich ist": "Désactiver si une seule sélection est possible",
	"Komponente hervorheben": "Beoordeel de samenstelling",
	"Dieses Material existiert bereits": "Dit materiaal bestaat al",
	"Material hinzufügen": "Materiaal toevoegen",
	"Materialname eingeben": "De naam van het materiaal opzoeken",
	Abmessungen: Abmessungen,
	Breite: Breite,
	"Höhe": "Hoogheid",
	Tiefe: Tiefe,
	Startpunkt: Startpunkt,
	Endpunkt: Endpunkt,
	"Linienstärke": "Lijndikte",
	Text: Text$1,
	"Automatisches Maß überschreiben": "Automatisch meten",
	"Neues Maß": "Nieuwe metingen",
	"Textgröße als Faktor. 1 ist Standard.": "Taille du texte comme facteur. 1 est la valeur par défaut.",
	Offsets: Offsets,
	"Hier können Abweichungen von Position und Rotation, die sich normalerweise aus Start und Endpunkt ergeben, definiert werden. Dazu kann das 3D Positionierungswerkzeug benutzt werden.": "Hier is het mogelijk om de positie- en rotatiegrenzen te definiëren die normaal gesproken voortvloeien uit de begin- en eindpunten. Hiervoor kun je het positioneringshulpmiddel 3D gebruiken.",
	Edit: Edit,
	"Script Modell Editor": "Uitgever van scriptmodellen",
	"Schreiben Sie das Modell als JSX Komponente.": "Ecriseer het model als composant JSX.",
	"Nicht Befüllt": "Niet rempli",
	"Keine Angabe": "Geen indicatie",
	"Maximale Anzahl an Iterationen erreicht! Die Regelkonflikte können nicht aufgelöst werden.": "Het maximale aantal iteraties is bereikt! De regelfuncties kunnen niet worden onderdrukt."
};

var list = "Lijst";
var color = "Kleuren";
var text = "Tekst";
var boolean = "Ja/ Nee";
var image = "Afbeelding";
var components = "Onderdelen";
var presentation = "Vertegenwoordiging";
var usage = "Acties";
var values = "Waarden";
var rules = "Regels";
var settings = "Opties";
var images = "Foto's";
var configurators = "Configurators";
var street = "Straat";
var zip = "POSTCODE";
var city = "Stad";
var country = "Land";
var extract = "Uittreksel";
var phone = "Telefoon";
var username = "Gebruikersnaam";
var Schritt = "Stap";
var MATERIAL = "MATERIAAL";
var Import = "Importeren";
var Manuell = "Handmatig";
var Rotation = "Rotatie";
var Allgemeines = "Algemene informatie";
var Beschaffenheit = "Kenmerken";
var Roughness = "Ruwheid";
var Metallness = "Metallness";
var Bilderstapel = "Stapel foto's";
var Hilfe = "Help";
var Szeneneinstellungen = "Scène-instellingen";
var Themes = "Thema's";
var Anpassung = "Aanpassing";
var Weiter = "Verder";
var Wertebereich = "Waardebereik";
var Darstellung = "Vertegenwoordiging";
var Werte = "Waarden";
var Anfragen = "Vragen";
var Zeitpunkt = "Timing";
var Benutzer = "Gebruikers";
var Anfrage = "Aanvraag";
var URI = "URI";
var Parameter = "Parameters";
var Dauer = "Duur";
var Server = "Server";
var amount = "Hoeveelheid";
var article = "Artikel";
var Fullscreen = "Modus Volledig scherm";
var showSelection = {
	always: "Altijd",
	never: "Nooit",
	auto: "Zoals in de configurator",
	label: "Weergave in bevestiging, PDF en winkel"
};
var Aktivieren = "Activeer";
var Deaktivieren = "Deactiveer";
var variablesAndArticles = "Artikelen";
var variablesOnly = "Alleen functies";
var articlesOnly = "Alleen artikel";
var noOverview = "Geen overzicht";
var Auswahlpreise = "Selectie prijzen";
var Variable = "Variabele";
var breadcrumb_app = "Algemeen";
var breadcrumb_pdf = "PDF";
var breadcrumb_mail = "Mail";
var breadcrumb_embed = "inbedden";
var breadcrumb_shop = "Winkel op";
var breadcrumb_articles = "Artikel";
var breadcrumb_preview = "Voorbeeld";
var breadcrumb_edit = "Redacteur";
var breadcrumb_images = "Foto's";
var breadcrumb_materials = "Materialen";
var breadcrumb_models = "Modellen";
var breadcrumb_rules = "Regels";
var breadcrumb_settings = "Opties";
var breadcrumb_admin = "Admin";
var breadcrumb_extract = "extract";
var breadcrumb_apps = "Configurators";
var breadcrumb_create = "Maak";
var breadcrumb_import = "Importeren";
var breadcrumb_users = "Gebruikers";
var breadcrumb_support = "Ondersteuning";
var breadcrumb_logs = "Logboeken";
var breadcrumb_systemStatus = "Systeemstatus";
var breadcrumb_trash = "Prullenmand";
var breadcrumb_abonnement = "Abonnement";
var breadcrumb_expired = "Verlopen";
var breadcrumb_profile = "Profiel";
var breadcrumb_configurator = "Redacteur";
var breadcrumb_configurations = "Configuraties";
var breadcrumb_groups = "Ruiter";
var breadcrumb_variables = "Kenmerken";
var breadcrumb_design = "Ontwerp";
var breadcrumb_scene = "Scène";
var breadcrumb_presentation = "Vertegenwoordiging";
var breadcrumb_options = "Opties";
var breadcrumb_usage = "Acties";
var breadcrumb_values = "Waarden";
var nlTranslationExtra = {
	list: list,
	color: color,
	text: text,
	boolean: boolean,
	image: image,
	components: components,
	presentation: presentation,
	usage: usage,
	values: values,
	rules: rules,
	settings: settings,
	images: images,
	configurators: configurators,
	street: street,
	zip: zip,
	city: city,
	country: country,
	extract: extract,
	phone: phone,
	username: username,
	"Maßkette": "Maatketen",
	"duplicate-entry": "Accounts met deze gegevens bestaan al",
	"create new dealer": "Nieuwe verkoper maken",
	"die Variable {{variableLabel}} ist eine KomponentenListe. Sie müssen mit einem Index wie {{variableLabel}}[0] für das 1. Element oder mit einer Array-Funktionen wie z.B. map(), find(), reduce() oder first() darauf zugreifen": "De variabele {{variableLabel}} is een componentenlijst. Je moet het benaderen met een index zoals {{variableLabel}}[0] voor het 1e element of met een arrayfunctie zoals map(), find(), reduce() of first()",
	"Dieser Wert ist nicht kombinierbar mit folgenden Auswahlen:": "Deze waarde kan niet worden gecombineerd met de volgende selecties:",
	"Bei Auswahl wird eine Alternative berechnet!": "Indien geselecteerd, wordt een alternatief berekend!",
	"Artikel Anzahl": "Artikel Aantal",
	"Farb auswählen": "Selecteer kleur",
	"< Zurück": "< Terug",
	"Preis Information": "Prijsinformatie",
	Schritt: Schritt,
	"Ihre Eingabe war leider nicht möglich und wurde auf den nächstmöglichen Wert zurückgesetzt: ": "Helaas was je invoer niet mogelijk en is deze teruggezet naar de eerstvolgende mogelijke waarde: ",
	"Merkmal auswählen": "Functie selecteren",
	MATERIAL: MATERIAL,
	Import: Import,
	"Materialien für den Import auswählen:": "Selecteer materialen om te importeren:",
	"Wie möchten Sie ein Material erstellen?": "Hoe wil je materiaal maken?",
	"Import einer .glb und export der enthaltenen Materialien": "Een .glb importeren en de materialen exporteren",
	Manuell: Manuell,
	"Eigenständiges Anlegen eines PBR-Materials": "Onafhankelijk aanmaken van een PBR-materiaal",
	"Die Variable wird von einer Erweiterung benötigt und kann daher nicht gelöscht werden!": "De variabele is vereist door een extensie en kan daarom niet worden verwijderd!",
	"Bitten Sie den Entwickler, die Variable aus der Erweiterung zu entfernen und zu löschen.": "Vraag de ontwikkelaar om de variabele uit de extensie te halen en te verwijderen.",
	"Die Variable wird noch in Regeln verwendet:": "De variabele wordt nog steeds gebruikt in regels:",
	"Löschen Sie bitte zunächst dort die entsprechende Spalte.": "Verwijder daar eerst de bijbehorende kolom.",
	"Anpassung nötig": "Aanpassing",
	"\"Die Auswahl \"{{value}}\" ({{variable}}) passt nicht zu der Auswahl \"{{conflictValue0}}\" ({{conflictVariable0}}).\"": "De selectie %r@@\"{{value}}%r@\\\" ({{variable}}) komt niet overeen met de selectie %r@\\\"{{conflictValue0}}%r@\\\" ({{conflictVariable0}}).%r@\\\"",
	"Die Auswahl \"{{value}}\" ({{variable}}) passt nicht zu der Auswahl \"{{conflictValue0}}\" ({{conflictVariable0}}) und der Auswahl \"{{conflictValue1}}\" ({{conflictVariable1}}).": "De selectie %r@\\\"{{value}}%r@\\\" ({{variable}}) komt niet overeen met de selectie %r@\\\"{{conflictValue0}}%r@\\\" ({{conflictVariable0}}) en de selectie %r@\\\"{{conflictValue1}}%r@\\\" ({{conflictVariable1}}).",
	"Die Auswahl \"{{value}}\" ({{variable}}) passt nicht zu der Auswahl \"{{conflictValue0}}\" ({{conflictVariable0}}), der Auswahl \"{{conflictValue1}}\" ({{conflictVariable1}}) und der Auswahl \"{{conflictValue2}}\" ({{conflictVariable2}}).": "De selectie %r@\\\"{{value}}%r@\\\" ({{variable}}) komt niet overeen met de selectie %r@\\\"{{conflictValue0}}%r@\\\" ({{conflictVariable0}}), de selectie %r@\\\"{{conflictValue1}}%r@\\\" ({{conflictVariable1}}) en de selectie %r@\\\"{{conflictValue2}}%r@\\\" ({{conflictVariable2}}).",
	"Die Auswahl \"{{value}}\" ({{variable}}) passt nicht zu anderen Auswahlen.": "De selectie %r@\\\"{{value}}%r@\\\" ({{variable}}) komt niet overeen met andere selecties.",
	"wird zu": "wordt",
	"Stattdessen werden folgende Auswahlen angepasst:": "In plaats daarvan worden de volgende selecties aangepast:",
	"Design & Layout": "Ontwerp en lay-out",
	"Nur sichtbar im Vorschaumodus oder veröffentlichtem Konfigurator!": "Alleen zichtbaar in voorbeeldmodus of gepubliceerde configurator!",
	"Theme wählen": "Selecteer thema",
	"Komponente löschen": "Component verwijderen",
	"Mehrfach Regelzeilen Bearbeitung": "Meerdere regels bewerken",
	"Anzahl ausgewählte Regel-Zeilen:": "Aantal geselecteerde regels:",
	"Modelaktions-Positionierung": "Actie positioneren modelleren",
	Rotation: Rotation,
	"Keine Aktionen für die Mehrfachbearbeitung vorhanden.": "Geen acties beschikbaar voor meervoudige verwerking.",
	Allgemeines: Allgemeines,
	"Farben und Lichtinteraktion": "Kleuren en lichtinteractie",
	"Color-Map Upload": "Kleurkaart uploaden",
	"Material interagiert mit Licht in der Szene": "Materiaal interageert met licht in de scène",
	Beschaffenheit: Beschaffenheit,
	"Roughness-Map Upload": "Ruwheidskaart uploaden",
	Roughness: Roughness,
	"Metallness-Map Upload": "Metallness-kaart uploaden",
	Metallness: Metallness,
	"Normalen-Map Upload": "Normale kaart uploaden",
	"Normalen-Skalierung": "Normaal schalen",
	"Anwendung auf 3D-Modell": "Toepassing op 3D-model",
	"Displacement-Map Upload": "Verplaatsingskaart uploaden",
	"Displacement-Skalierung": "Verplaatsingsschaal",
	"Repeat-Faktor der Textur in X- und Y-Richtung": "Herhalingsfactor van de textuur in X- en Y-richting",
	"Alpha-Werte": "Alfa-waarden",
	"Alpha-Map Upload": "Alpha-kaart uploaden",
	"Ambient Occlusion": "Omgevingsverloop",
	"Ambient-Occlusion-Map Upload": "Omgeving-Occlusie-Kaart uploaden",
	"Info editieren": "Info bewerken",
	"Zeige Info-Button": "Toon info knop",
	"Abhängigkeitsschleifen": "Lussen van afhankelijkheid",
	Bilderstapel: Bilderstapel,
	"Google Analytics Property ID": "Google Analytics-eigendom-ID",
	"Sans Serif": "schreefloos",
	"Das flexibles Shopsystem für Ihr E-Commerce-Projekt.": "Het flexibele shopsysteem voor je e-commerce project.",
	"Die eine europäische Open-Source-E-Commerce-Plattform. ": "Het enige Europese open source e-commerce platform. ",
	"Jetzt Adobe Commerce: E-Commerce leicht gemacht.": "Nu Adobe Commerce: E-commerce gemakkelijk gemaakt.",
	"Erstklassig im digitalen Vertrieb mit dem Oxid esales Shop.": "Eersteklas digitale verkoop met de Oxid esales shop.",
	"Individuelle Entwicklung": "Individuele ontwikkeling",
	Hilfe: Hilfe,
	"Shop mit einer individuellen Entwicklung anbinden.": "Winkel met ontwikkeling op maat.",
	Szeneneinstellungen: Szeneneinstellungen,
	Themes: Themes,
	Anpassung: Anpassung,
	"Gewähltes Theme übernehmen": "Kies een thema",
	"Legen Sie einen neuen Konfigurationsschritt an.": "Maak een nieuwe configuratiestap.",
	"Eine Konfiguration erfolgt in mehreren Schritten. In jedem Schritt können ggf. mehrere Produkt-Eigenschaften angegeben werden. Hier legen Sie den ersten Schritt an.": "Configuratie vindt plaats in verschillende stappen. In elke stap kunnen verschillende producteigenschappen worden opgegeven. Maak hier de eerste stap.",
	"Konfigurationsschritt erstellen": "Configuratiestap maken",
	"Bitte klicken Sie zunächst hier, um einen neuen Konfigurator zu erstellen.": "Klik eerst hier om een nieuwe configurator te maken.",
	"Neuer Konfigurator wählen": "Selecteer nieuwe configurator",
	"Bitte geben Sie einen Namen ein.": "Voer een naam in.",
	"Bitte geben Sie eine Beschreibung ein.": "Voer een beschrijving in.",
	"Bestätigen": "Bevestig",
	"Bitte klicken Sie hier.": "Klik hier.",
	"Konfigurator Dialog aufrufen": "Dialoog configurator oproepen",
	"Konfigurationsschritt benennen": "Naam configuratiestap",
	"Hier können Sie neue Werte hinzufügen.": "Je kunt hier nieuwe waarden toevoegen.",
	"Merkmale, die eine Liste (oder Farbe, Material, Modell) sind, zeigen mehrere Werte zur Auwahl an. Diese Werte können Sie hier eingeben.": "Kenmerken die een lijst zijn (of kleur, materiaal, model) geven verschillende waarden weer voor selectie. Je kunt deze waarden hier invoeren.",
	"Klicken Sie hier um einen neuen Wert zu erstellen.": "Klik hier om een nieuwe waarde te creëren.",
	"Wenn Sie fertig sind klicken Sie hier.": "Klik hier als je klaar bent.",
	"Werte erstellen": "Waarden creëren",
	"Bitte geben Sie einen Namen für das neue Merkmal ein.": "Voer een naam in voor de nieuwe functie.",
	"Bitte wählen Sie eine Darstellung, die den Möglichkeiten des Merkmals entspricht.": "Selecteer een weergave die overeenkomt met de mogelijkheden van de functie.",
	"Präsentation definieren": "Presentatie definiëren",
	"In einem Schritt kann Ihr Kunde mehrere Merkmale seines Produktes anpassen. Fügen Sie hier das erste Merkmal ein.": "Je klant kan in één stap verschillende functies van zijn product aanpassen. Voer hier de eerste functie in.",
	"Produktmerkmal erstellen": "Productkenmerk maken",
	"Was für ein Merkmal wollen Sie anlegen?": "Welk kenmerk wil je creëren?",
	"Ein Merkmal kann eine Auswahl sein (z.B. die Größen S, M, L und XL), ein Text oder eine Zahl (z.B. für eine Breite oder Höhe) oder auch eine Farbe oder Material Ihres Produktes oder ein 3D-Modell, dass einen Teil Ihres Produktes darstellt.": "Een kenmerk kan een selectie zijn (bijvoorbeeld de maten S, M, L en XL), een tekst of een getal (bijvoorbeeld voor een breedte of hoogte) of zelfs een kleur of materiaal van je product of een 3D-model dat een onderdeel van je product voorstelt.",
	"Produktmerkmaltyp auswählen": "Selecteer type productkenmerk",
	"Wählen sie den eben erstellten Konfigurator.": "Selecteer de configurator die je zojuist hebt gemaakt.",
	"Steuerung des Konfigurators durch das neue Merkmal.": "Bediening van de configurator met de nieuwe functie.",
	"Merkmale können z.B. dafür sorgen, dass 3D-Modelle oder Bilder angezeigt werden oder das Oberflächen geändert oder eingefärbt werden. Sie können auch eine Stückliste von Artikel erzeugen, die dann den Preis bestimmt und in den Warenkorb Ihres Shops gelegt werden kann.": "Functies kunnen er bijvoorbeeld voor zorgen dat 3D-modellen of afbeeldingen worden weergegeven of dat oppervlakken worden veranderd of gekleurd. Je kunt ook een onderdelenlijst van artikelen maken, die vervolgens de prijs bepaalt en in het winkelmandje van je winkel geplaatst kan worden.",
	"Merkmal verwenden": "Functie gebruiken",
	"Oberfläche ändern": "Verander oppervlak",
	Weiter: Weiter,
	Wertebereich: Wertebereich,
	Darstellung: Darstellung,
	Werte: Werte,
	Anfragen: Anfragen,
	Zeitpunkt: Zeitpunkt,
	Benutzer: Benutzer,
	Anfrage: Anfrage,
	URI: URI,
	Parameter: Parameter,
	Dauer: Dauer,
	Server: Server,
	"Modell bearbeiten": "Model bewerken",
	"Korrekte Mail-Adresse": "Juist e-mailadres",
	"Statistik (30 Tage)": "Statistieken (30 dagen)",
	amount: amount,
	article: article,
	"Datum eingeben": "Datum invoeren",
	"Nach hause ": "Home ",
	"Mandant anlegen": "Klant maken",
	"Nutzer hinzufügen": "Gebruiker toevoegen",
	"Übersicht": "Overzicht",
	"Persönliche Daten": "Persoonlijke gegevens",
	"In AR ansehen": "Bekijk in AR",
	Fullscreen: Fullscreen,
	showSelection: showSelection,
	"Kamera überschreiben": "Camera overschrijven",
	Aktivieren: Aktivieren,
	Deaktivieren: Deaktivieren,
	"Übersichtsseite": "Overzichtspagina",
	variablesAndArticles: variablesAndArticles,
	variablesOnly: variablesOnly,
	articlesOnly: articlesOnly,
	noOverview: noOverview,
	Auswahlpreise: Auswahlpreise,
	Variable: Variable,
	breadcrumb_app: breadcrumb_app,
	breadcrumb_pdf: breadcrumb_pdf,
	breadcrumb_mail: breadcrumb_mail,
	breadcrumb_embed: breadcrumb_embed,
	breadcrumb_shop: breadcrumb_shop,
	breadcrumb_articles: breadcrumb_articles,
	breadcrumb_preview: breadcrumb_preview,
	breadcrumb_edit: breadcrumb_edit,
	breadcrumb_images: breadcrumb_images,
	breadcrumb_materials: breadcrumb_materials,
	breadcrumb_models: breadcrumb_models,
	breadcrumb_rules: breadcrumb_rules,
	breadcrumb_settings: breadcrumb_settings,
	breadcrumb_admin: breadcrumb_admin,
	breadcrumb_extract: breadcrumb_extract,
	breadcrumb_apps: breadcrumb_apps,
	breadcrumb_create: breadcrumb_create,
	breadcrumb_import: breadcrumb_import,
	breadcrumb_users: breadcrumb_users,
	breadcrumb_support: breadcrumb_support,
	breadcrumb_logs: breadcrumb_logs,
	breadcrumb_systemStatus: breadcrumb_systemStatus,
	breadcrumb_trash: breadcrumb_trash,
	breadcrumb_abonnement: breadcrumb_abonnement,
	breadcrumb_expired: breadcrumb_expired,
	breadcrumb_profile: breadcrumb_profile,
	breadcrumb_configurator: breadcrumb_configurator,
	breadcrumb_configurations: breadcrumb_configurations,
	breadcrumb_groups: breadcrumb_groups,
	breadcrumb_variables: breadcrumb_variables,
	breadcrumb_design: breadcrumb_design,
	breadcrumb_scene: breadcrumb_scene,
	breadcrumb_presentation: breadcrumb_presentation,
	breadcrumb_options: breadcrumb_options,
	breadcrumb_usage: breadcrumb_usage,
	breadcrumb_values: breadcrumb_values,
	"Letzte Gruppe kann nicht gelöscht werden.": "Laatste groep kan niet worden verwijderd."
};

const nl = Object.assign({}, nlTranslation, nlTranslationExtra);

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  de: {
    translation: de
  },
  en: {
    translation: en
  },
  nl: {
    translation: nl
  },
  fr: {
    translation: fr
  }
};
i18n.use(initReactI18next) // passes i18n down to react-i18next
.init({
  resources,
  lng: "de",
  // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
  // if you're using a language detector, do not define the lng option
  interpolation: {
    escapeValue: false // react already safes from xss
  }
});

const initialState$8 = {
  language: "de",
  contentLanguage: null,
  dark: null,
  callIds: [],
  appLoadCounter: 0,
  selectedVariableId: undefined,
  focusGroupId: undefined,
  fullScreen3DView: false,
  focusGroupHistory: [],
  dealerData: {
    discount: 0,
    surcharge: 0,
    apps: []
  }
};
const commonSlice = createSlice({
  name: "common",
  initialState: initialState$8,
  reducers: {
    setLanguage: (state, action) => {
      i18n.changeLanguage(action.payload, () => state.language = action.payload);
    },
    setContentLanguage: (state, action) => {
      state.contentLanguage = action.payload;
    },
    setDarkMode: (state, action) => {
      state.dark = action.payload;
    },
    setDealerData: (state, {
      payload
    }) => {
      state.dealerData = Object.assign({}, payload, {
        discount: payload != null && payload.discount ? payload.discount : 0,
        surcharge: payload != null && payload.surcharge ? payload.surcharge : 0
      });
    },
    overwriteDealerApp: (state, {
      payload
    }) => {
      var _state$dealerData$app;
      const apps = [...((_state$dealerData$app = state.dealerData.apps) != null ? _state$dealerData$app : []).filter(da => da.id !== payload.id), payload];
      state.dealerData = transform({
        apps
      })(state.dealerData);
    },
    incAppLoadCounter: state => {
      state.appLoadCounter++;
    },
    setSelectedVariableId: (state, action) => {
      state.selectedVariableId = action.payload;
    },
    setFocusGroupId: (state, action) => {
      if (state.focusGroupId === action.payload) return;
      state.focusGroupId = action.payload;
      if (action.payload) {
        state.focusGroupHistory = [action.payload, ...state.focusGroupHistory];
      }
    },
    setPseudoRootSelection: (state, action) => {
      state.pseudoRootSelection = action.payload;
    },
    startLoading: (state, action) => {
      state.callIds.push(action.payload);
    },
    finishLoading: (state, action) => {
      state.callIds = state.callIds.filter(id => id !== action.payload);
    },
    createGroupCommon: (state, action) => {
      // Hier wird verhindert das automatisch bei Erstellung einer
      // Komponentenvariable in die dazugehörige Subgruppe gesprungen wird.
      state.focusGroupId = action.payload.id;
    },
    toggleFullScreen3DView: state => {
      state.fullScreen3DView = !state.fullScreen3DView;
    }
  }
});
const {
  createGroupCommon,
  finishLoading,
  incAppLoadCounter,
  setDealerData,
  overwriteDealerApp,
  setDarkMode,
  setFocusGroupId,
  setLanguage,
  setContentLanguage,
  setSelectedVariableId,
  startLoading,
  toggleFullScreen3DView,
  setPseudoRootSelection
} = commonSlice.actions;
const commonReducer = commonSlice.reducer;

const SidebarPositionType = {
  Right: "right",
  Left: "left"
};
const defaultContentLangs = ["de", "en", "nl", "fr"];
const getLanguages = app => {
  var _app$settings$langs;
  return (_app$settings$langs = app.settings.langs) != null && _app$settings$langs.length ? app.settings.langs : defaultContentLangs;
};
const DesignType = {
  topmenu: "topmenu",
  accordion: "accordion",
  onlysidebar: "onlysidebar",
  backgroungGroup: "backgroungGroup",
  individuell: "individuell"
};
const SidebarType = {
  Configurator: "configurator",
  ArticleList: "articleList"
};
const StageType = {
  NONE: "NONE",
  STACK: "STACK",
  GALLERY: "TURNTABLE",
  _3D: "3D",
  PLANER: "PLANER"
};
const SupportedLocale = {
  DE: "de",
  EN: "en",
  NL: "nl",
  FR: "fr"
};
const allLocales = Object.values(SupportedLocale);
const langMap = {
  ab: "Abkhazian",
  aa: "Afar",
  af: "Afrikaans",
  ak: "Akan",
  sq: "Albanian",
  am: "Amharic",
  ar: "Arabic",
  an: "Aragonese",
  hy: "Armenian",
  as: "Assamese",
  av: "Avaric",
  ae: "Avestan",
  ay: "Aymara",
  az: "Azerbaijani",
  bm: "Bambara",
  ba: "Bashkir",
  eu: "Basque",
  be: "Belarusian",
  bn: "Bengali",
  bi: "Bislama",
  bs: "Bosnian",
  br: "Breton",
  bg: "Bulgarian",
  my: "Burmese",
  ca: "Catalan, Valencian",
  ch: "Chamorro",
  ce: "Chechen",
  ny: "Chichewa, Chewa, Nyanja",
  zh: "Chinese",
  cu: "Church Slavonic, Old Slavonic, Old Church Slavonic",
  cv: "Chuvash",
  kw: "Cornish",
  co: "Corsican",
  cr: "Cree",
  hr: "Croatian",
  cs: "Czech",
  da: "Danish",
  dv: "Divehi, Dhivehi, Maldivian",
  nl: "Dutch, Flemish",
  dz: "Dzongkha",
  en: "English",
  eo: "Esperanto",
  et: "Estonian",
  ee: "Ewe",
  fo: "Faroese",
  fj: "Fijian",
  fi: "Finnish",
  fr: "French",
  fy: "Western Frisian",
  ff: "Fulah",
  gd: "Gaelic, Scottish Gaelic",
  gl: "Galician",
  lg: "Ganda",
  ka: "Georgian",
  de: "German",
  el: "Greek, Modern (1453–)",
  kl: "Kalaallisut, Greenlandic",
  gn: "Guarani",
  gu: "Gujarati",
  ht: "Haitian, Haitian Creole",
  ha: "Hausa",
  he: "Hebrew",
  hz: "Herero",
  hi: "Hindi",
  ho: "Hiri Motu",
  hu: "Hungarian",
  is: "Icelandic",
  io: "Ido",
  ig: "Igbo",
  id: "Indonesian",
  ia: "Interlingua (International Auxiliary Language Association)",
  ie: "Interlingue, Occidental",
  iu: "Inuktitut",
  ik: "Inupiaq",
  ga: "Irish",
  it: "Italian",
  ja: "Japanese",
  jv: "Javanese",
  kn: "Kannada",
  kr: "Kanuri",
  ks: "Kashmiri",
  kk: "Kazakh",
  km: "Central Khmer",
  ki: "Kikuyu, Gikuyu",
  rw: "Kinyarwanda",
  ky: "Kirghiz, Kyrgyz",
  kv: "Komi",
  kg: "Kongo",
  ko: "Korean",
  kj: "Kuanyama, Kwanyama",
  ku: "Kurdish",
  lo: "Lao",
  la: "Latin",
  lv: "Latvian",
  li: "Limburgan, Limburger, Limburgish",
  ln: "Lingala",
  lt: "Lithuanian",
  lu: "Luba-Katanga",
  lb: "Luxembourgish, Letzeburgesch",
  mk: "Macedonian",
  mg: "Malagasy",
  ms: "Malay",
  ml: "Malayalam",
  mt: "Maltese",
  gv: "Manx",
  mi: "Maori",
  mr: "Marathi",
  mh: "Marshallese",
  mn: "Mongolian",
  na: "Nauru",
  nv: "Navajo, Navaho",
  nd: "North Ndebele",
  nr: "South Ndebele",
  ng: "Ndonga",
  ne: "Nepali",
  no: "Norwegian",
  nb: "Norwegian Bokmål",
  nn: "Norwegian Nynorsk",
  ii: "Sichuan Yi, Nuosu",
  oc: "Occitan",
  oj: "Ojibwa",
  or: "Oriya",
  om: "Oromo",
  os: "Ossetian, Ossetic",
  pi: "Pali",
  ps: "Pashto, Pushto",
  fa: "Persian",
  pl: "Polish",
  pt: "Portuguese",
  pa: "Punjabi, Panjabi",
  qu: "Quechua",
  ro: "Romanian, Moldavian, Moldovan",
  rm: "Romansh",
  rn: "Rundi",
  ru: "Russian",
  se: "Northern Sami",
  sm: "Samoan",
  sg: "Sango",
  sa: "Sanskrit",
  sc: "Sardinian",
  sr: "Serbian",
  sn: "Shona",
  sd: "Sindhi",
  si: "Sinhala, Sinhalese",
  sk: "Slovak",
  sl: "Slovenian",
  so: "Somali",
  st: "Southern Sotho",
  es: "Spanish, Castilian",
  su: "Sundanese",
  sw: "Swahili",
  ss: "Swati",
  sv: "Swedish",
  tl: "Tagalog",
  ty: "Tahitian",
  tg: "Tajik",
  ta: "Tamil",
  tt: "Tatar",
  te: "Telugu",
  th: "Thai",
  bo: "Tibetan",
  ti: "Tigrinya",
  to: "Tonga (Tonga Islands)",
  ts: "Tsonga",
  tn: "Tswana",
  tr: "Turkish",
  tk: "Turkmen",
  tw: "Twi",
  ug: "Uighur, Uyghur",
  uk: "Ukrainian",
  ur: "Urdu",
  uz: "Uzbek",
  ve: "Venda",
  vi: "Vietnamese",
  vo: "Volapük",
  wa: "Walloon",
  cy: "Welsh",
  wo: "Wolof",
  xh: "Xhosa",
  yi: "Yiddish",
  yo: "Yoruba",
  za: "Zhuang, Chuang",
  zu: "Zulu"
};
const overviewType = ["variablesAndArticles", "variablesOnly", "articlesOnly", "noOverview"];
const isValidAppSettingsAction = action => !action || !("type" in action);

async function api_connectShop(id, connectRequest, lang) {
  return await api_request("POST", `/app/${id}/shop`, connectRequest, {
    lang
  });
}
async function api_getFullApp(lang, code) {
  return await api_request("GET", `/app/${encodeURIComponent(code)}/full`, null, {
    lang
  });
}
async function api_getFullAppFromJsonWithLangDefault(lang, code, version, dispatch) {
  // available languages laden
  try {
    const fullApp = await api_getFullAppFromJson(lang, code, version);
    dispatch == null ? void 0 : dispatch(setContentLanguage(lang));
    return fullApp;
  } catch (e) {
    console.error(`No App for ${lang} found, using Default`);
  }
  try {
    const fullApp = await api_getFullAppFromJson(null, code, version);
    const langs = getLanguages(fullApp.app)[0];
    dispatch == null ? void 0 : dispatch(setContentLanguage(langs));
    return fullApp;
  } catch (e) {
    console.error(`Fallback to default language did not work, because JSON is not published yet.`);
  }
  try {
    const fullApp = await api_getFullAppFromJson(LANGUAGEDEFAULT, code, version);
    dispatch == null ? void 0 : dispatch(setContentLanguage(LANGUAGEDEFAULT));
    return fullApp;
  } catch (e) {
    throw new Error("Could not load any JSON");
  }
}
async function api_getFullAppFromJson(lang, code, version) {
  const langPart = lang ? `.${lang}` : "";
  const versionString = version === "current" ? "current" : "versions";
  const response = await api_getDocs(`/data/${versionString}/${encodeURIComponent(code)}${langPart}.json`);
  return response;
}
async function api_getArticlesAndPricesFromJson(lang, appCode, versionId) {
  try {
    const langPart = lang ? `.${lang}` : "";
    const versionString = versionId || "current";
    return await api_getDocs(`/data/articles/${encodeURIComponent(appCode)}/${versionString}${langPart}.json`);
  } catch (_unused) {
    return undefined;
  }
}
async function api_importArticles(id, lang) {
  return await api_request("GET", `/app/${id}/import/articles`, null, {
    lang
  });
}
async function api_publish(id, lang) {
  return await api_request("GET", `/app/${id}/publish`, null, {
    lang
  });
}
async function api_publish_articles(id, lang) {
  return await api_request("GET", `/app/${id}/publish/articles`, null, {
    lang
  });
}
async function api_copyApp(id, data, lang) {
  return await api_request("POST", `/app/${id}/copy`, data, {
    lang
  });
}
async function api_exportApp(id) {
  return await api_request("GET", `/app/${id}/export`, null, {});
}
async function api_importApp(json) {
  return await api_request("POST", `/app/import`, json);
}
async function api_book(id, product) {
  return await api_request("POST", `/app/${id}/book/${product}`);
}
async function api_products(id) {
  return await api_request("GET", `/app/${id}/products`, null, {});
}

const ConfigurationState = {
  Draft: "draft",
  Basket: "basket",
  Quoted: "quoted",
  Ordered: "ordered"
};

async function api_saveConfiguration(configuration, code, action, lang, filesAndInformation, isPreview = false, dealerId) {
  if (!code) {
    throw new Error("Missing App Code for uploadContent!");
  }
  const formData = new FormData();
  dealerId && formData.append("dealerId", String(dealerId));
  dealerId ? formData.append("state", ConfigurationState.Draft) : formData.append("state", ConfigurationState.Ordered);
  formData.append("price", JSON.stringify(configuration.price));
  formData.append("preview", String(isPreview));
  formData.append("json", JSON.stringify(configuration.json));
  formData.append("customer", JSON.stringify(configuration.customer));
  formData.append("files", JSON.stringify(configuration.files));
  filesAndInformation.forEach(i => {
    formData.append(i.key, i.file);
  });
  const result = await api_fetch("POST", `/app/${code}/cfg/${action.id}`, formData, {
    "X-language": lang,
    Accept: "application/json"
  });
  return result;
}
async function api_getConfigurationFromJson(code) {
  return await api_getDocs(`/data/cfgs/${encodeURIComponent(code)}.json`);
}
async function api_getConfiguration(code) {
  return await api_request("GET", `/app/cfg/${encodeURIComponent(code)}`, null);
}
async function api_getConfigurationPdf(code, lang, template) {
  return await api_request("GET", `/cfg/${code}/pdf${template ? "/" + template : ""}`, null, {
    lang
  });
}
async function api_getConfigurationShop(code, lang) {
  return await api_request("GET", `/cfg/${code}/shop`, null, {
    lang
  });
}

const RuleColumnType = {
  ArticleAction: "articleAction",
  ColorAction: "colorAction",
  Image2DAction: "image2DAction",
  ImageAction: "imageAction",
  LabelAction: "labelAction",
  MaterialAction: "materialAction",
  InstanceAction: "instanceAction",
  ModelAction: "modelAction",
  Variable: "variable",
  ConcealVariableAction: "concealVariableAction",
  ConcealGroupAction: "concealGroupAction",
  HideVariableAction: "hideVariableAction",
  HideGroupAction: "hideGroupAction",
  HideValuesAction: "hideValuesAction"
};
const isMaterialActionModelTarget = thing => (thing == null ? void 0 : thing.targetModelId) !== undefined && (thing == null ? void 0 : thing.targetMaterialName) !== undefined;
const isMaterialActionGlobalTarget = thing => (thing == null ? void 0 : thing.isGlobalChange) === true && (thing == null ? void 0 : thing.targetMaterialName) !== undefined;
const isActionColumn = column => includes(column.type, [RuleColumnType.ArticleAction, RuleColumnType.InstanceAction, RuleColumnType.ColorAction, RuleColumnType.Image2DAction, RuleColumnType.ImageAction, RuleColumnType.LabelAction, RuleColumnType.MaterialAction, RuleColumnType.ModelAction, RuleColumnType.ConcealVariableAction, RuleColumnType.ConcealGroupAction, RuleColumnType.HideVariableAction, RuleColumnType.HideGroupAction, RuleColumnType.HideValuesAction]);
const isVariableColumn = column => column.type === RuleColumnType.Variable;
const isModelActionColumn = column => column.type === RuleColumnType.ModelAction;
const isColorActionColumn = column => column.type === RuleColumnType.ColorAction;
const isMaterialActionColumn = column => column.type === RuleColumnType.MaterialAction;
const isInstanceActionColumn = column => column.type === RuleColumnType.InstanceAction;
const isLabelActionColumn = column => column.type === RuleColumnType.LabelAction;
const isConcealVariableActionColumn = column => column.type === RuleColumnType.ConcealVariableAction;
const isConcealGroupActionColumn = column => column.type === RuleColumnType.ConcealGroupAction;
const isHideVariableActionColumn = column => column.type === RuleColumnType.HideVariableAction;
const isHideGroupActionColumn = column => column.type === RuleColumnType.HideGroupAction;
const isHideValuesActionColumn = column => column.type === RuleColumnType.HideValuesAction;
const isImage2DActionColumn = column => column.type === RuleColumnType.Image2DAction;
const isImageActionColumn = column => column.type === RuleColumnType.ImageAction;
const isArticleActionColumn = column => column.type === RuleColumnType.ArticleAction;

const preprocessAllRuleItems = (rules, ruleItems, values, variables, removeActions = true) => {
  const ruleItemsByRuleId = _$1.groupBy(ruleItems, ruleItem => ruleItem.ruleId);
  const nested = rules.map(rule => preprocessRuleItemsForRule(rule, ruleItemsByRuleId[rule.id] || [], values, variables, removeActions));
  return {
    nested,
    flat: {
      rules: nested.map(n => n.rule),
      ruleItems: nested.flatMap(n => n.items)
    }
  };
};
function preprocessRuleItemsForRule(rule, ruleItems, values, variables, removeActions = true) {
  const [validColumns, invalidColumns] = partition(rule.columns, col => !isVariableColumn(col) || variables.find(variable => variable.id == col.targetId));
  invalidColumns.length && console.info("Rejecting orphaned columns", invalidColumns, "of", rule);
  const variableColumnsOnly = validColumns.filter(col => isVariableColumn(col));
  const items = ruleItems.map(ruleItem => {
    const newValues = {};
    variableColumnsOnly.forEach(col => {
      const id = col.targetId;
      newValues[id] = ruleItem.values[id] || true;
    });
    if (!removeActions) {
      Object.keys(ruleItem.values).forEach(k => {
        if (isUUID(k)) newValues[k] = ruleItem.values[k];
      });
    }
    return Object.assign({}, ruleItem, {
      values: newValues
    });
  });
  return {
    rule: Object.assign({}, rule, {
      columns: removeActions ? variableColumnsOnly : validColumns
    }),
    items
  };
}
const filterVisibleSelections = ruleEngineInput => (selections = []) => selections.filter(s => !isHiddenByAction(ruleEngineInput, s.variableId, s.instance.id));

const appHasShowPrice = app => {
  var _app$settings$priceOp;
  return !((_app$settings$priceOp = app.settings.priceOptions) != null && _app$settings$priceOp.hidePrice);
};

const callbacks = {};
/** Registers new callback functions. This works additively. */
function addCallbacks(newCallbacks) {
  // @ts-ignore
  forEach$2(newCallbacks, (value, key) => callbacks[key] = value);
}
function hasCallback(callbackKey) {
  return !!callbacks[callbackKey];
}
const removeCallbacks = callbacks =>
// @ts-ignore
callbacks.forEach(c => callbacks[c] = undefined);
const applyCallback = (callbackKey, data) => {
  const callback = callbacks[callbackKey];
  return callback ? callback(data) : data;
};
const curriedApplyCallback = curry(applyCallback);

const selectActionEngineInput = state => state.actionEngine.actionEngineInput;
const selectActionEngineState = state => state.actionEngine.actionEngineState;
const selectArticleActions = state => {
  var _state$actionEngine$a, _state$actionEngine$a2;
  return (_state$actionEngine$a = (_state$actionEngine$a2 = state.actionEngine.actionEngineState) == null ? void 0 : _state$actionEngine$a2.articles) != null ? _state$actionEngine$a : [];
};
const selectColorActions = state => {
  var _state$actionEngine$a5, _state$actionEngine$a6;
  return (_state$actionEngine$a5 = (_state$actionEngine$a6 = state.actionEngine.actionEngineState) == null ? void 0 : _state$actionEngine$a6.colors) != null ? _state$actionEngine$a5 : [];
};
const selectModelActions = state => {
  var _state$actionEngine$a7, _state$actionEngine$a8;
  return (_state$actionEngine$a7 = (_state$actionEngine$a8 = state.actionEngine.actionEngineState) == null ? void 0 : _state$actionEngine$a8.models) != null ? _state$actionEngine$a7 : [];
};
createSelector(selectModelActions, modelActions => modelActions.map(modelAction => modelAction.modelId));
const selectPrintActions = state => {
  var _state$actionEngine$a9, _state$actionEngine$a10;
  return (_state$actionEngine$a9 = (_state$actionEngine$a10 = state.actionEngine.actionEngineState) == null ? void 0 : _state$actionEngine$a10.prints) != null ? _state$actionEngine$a9 : [];
};
const selectImageActions = state => {
  var _state$actionEngine$a11, _state$actionEngine$a12;
  return (_state$actionEngine$a11 = (_state$actionEngine$a12 = state.actionEngine.actionEngineState) == null ? void 0 : _state$actionEngine$a12.images) != null ? _state$actionEngine$a11 : [];
};
const selectLabelActions = state => {
  var _state$actionEngine$a13, _state$actionEngine$a14;
  return (_state$actionEngine$a13 = (_state$actionEngine$a14 = state.actionEngine.actionEngineState) == null ? void 0 : _state$actionEngine$a14.labels) != null ? _state$actionEngine$a13 : [];
};
const selectMaterialActions = state => {
  var _state$actionEngine$a15, _state$actionEngine$a16;
  return (_state$actionEngine$a15 = (_state$actionEngine$a16 = state.actionEngine.actionEngineState) == null ? void 0 : _state$actionEngine$a16.materials) != null ? _state$actionEngine$a15 : [];
};
const selectActionsByTypeId = typeId => state => {
  var _state$actionEngine$a19, _state$actionEngine$a20;
  return (_state$actionEngine$a19 = (_state$actionEngine$a20 = state.actionEngine.actionEngineState) == null ? void 0 : _state$actionEngine$a20[typeId]) != null ? _state$actionEngine$a19 : [];
};

const selectSelectionByVariableIdAndInstanceId = (variableId, instanceId) => state => {
  const variable = selectVariableById(variableId)(state);
  const selections = selectSelections(state);
  const selection = selections.find(s => s.variableId === (variable == null ? void 0 : variable.id) && s.instance.id === instanceId);
  return selection;
};
const selectInstanceSelectionsAndVariables = state => {
  const selections = selectSelections(state);
  const instanceSelections = selections.filter(s => s.instance.isInstanceLauncher);
  return instanceSelections.map(selection => ({
    selection,
    variable: selectVariableById(selection.variableId)(state)
  }));
};
const selectPseudoRootSelection = state => state.common.pseudoRootSelection;
const selectSelections = state => {
  var _selectRuleEngineStat, _selectRuleEngineStat2, _selectRuleEngineStat3;
  return ((_selectRuleEngineStat = selectRuleEngineState(state)) == null ? void 0 : (_selectRuleEngineStat2 = _selectRuleEngineStat.state) == null ? void 0 : (_selectRuleEngineStat3 = _selectRuleEngineStat2.all) == null ? void 0 : _selectRuleEngineStat3.selections) || [];
};
const selectVisibleSelections = state => {
  const inputState = selectRuleEngineInput(state);
  const selections = selectSelections(state);
  if (!inputState) {
    return emptySelections;
  }
  return filterVisibleSelections(inputState)(selections);
};
const selectSelectionsForVariableId = id => state => flow(selectSelections, filter(s => s.variableId == id))(state);
const selectValidValuesAndSelectionsForVariableId = id => state => {
  const selectionsForVariableId = selectSelectionsForVariableId(id)(state);
  return selectionsForVariableId.map(selection => {
    return {
      value: state.metadata.values.find(value => value.id == +selection.valueId),
      selection: selection
    };
  });
};
const selectSelectionByVariableId = variableId => state => selectSelections(state).find(s => s.variableId == variableId);
const selectParentSelections = (selection, considerSelf) => state => {
  if (!selection) return [];
  const selections = selectSelections(state);
  let currentSelection = selection;
  const parentSelections = [];
  if (considerSelf && selection.instance.isInstanceLauncher) parentSelections.push(selection);
  while (currentSelection) {
    const parentSelection = selections.find(s => s.id == getParentSelectionId(currentSelection));
    if (parentSelection) {
      parentSelections.push(parentSelection);
      currentSelection = parentSelection;
    } else {
      currentSelection = undefined;
    }
  }
  return parentSelections;
};
const selectOnlyValidOptions = templateOptions => state => value => {
  if (templateOptions.hideInvalidUntouchedOptions) {
    return !selectInvalidValueForInstance(value)(state);
  } else if (templateOptions.hideInvalidOptions) {
    return !selectTouchedInvalidSelection(value.id)(state);
  } else {
    return true;
  }
};
const selectFrontendAppShowPrice = state => {
  var _state$frontend, _state$configurator;
  return appHasShowPrice((state == null ? void 0 : (_state$frontend = state.frontend) == null ? void 0 : _state$frontend.app) || (state == null ? void 0 : (_state$configurator = state.configurator) == null ? void 0 : _state$configurator.app) || undefined);
};
const selectFrontendApp = state => {
  var _state$frontend2, _state$configurator2;
  return (state == null ? void 0 : (_state$frontend2 = state.frontend) == null ? void 0 : _state$frontend2.app) || (state == null ? void 0 : (_state$configurator2 = state.configurator) == null ? void 0 : _state$configurator2.app) || undefined;
};
const selectProductDetails = state => {
  var _selectFrontendApp;
  return (_selectFrontendApp = selectFrontendApp(state)) == null ? void 0 : _selectFrontendApp.productDetails;
};
const selectShowBranding = state => {
  var _selectProductDetails, _selectProductDetails2;
  return (_selectProductDetails = (_selectProductDetails2 = selectProductDetails(state)) == null ? void 0 : _selectProductDetails2.branding) != null ? _selectProductDetails : true;
};
const selectIsApp3D = app => state => {
  const a = app || selectFrontendApp(state);
  return (a == null ? void 0 : a.stage) == StageType._3D;
};
const selectIsApp2D = app => state => {
  const a = app || selectFrontendApp(state);
  return (a == null ? void 0 : a.stage) == StageType.GALLERY || (a == null ? void 0 : a.stage) == StageType.STACK;
};
const selectInfoDialog = state => {
  var _state$frontend3;
  return state == null ? void 0 : (_state$frontend3 = state.frontend) == null ? void 0 : _state$frontend3.infoDialog;
};
const selectVariableInfoDialog = state => {
  var _state$frontend4;
  return state == null ? void 0 : (_state$frontend4 = state.frontend) == null ? void 0 : _state$frontend4.variableInfoDialog;
};
const selectAppInfo = state => {
  var _state$frontend5;
  return state == null ? void 0 : (_state$frontend5 = state.frontend) == null ? void 0 : _state$frontend5.appInfo;
};
const selectDynamicSettings = state => {
  var _selectFrontendApp2, _selectFrontendApp2$s;
  return ((_selectFrontendApp2 = selectFrontendApp(state)) == null ? void 0 : (_selectFrontendApp2$s = _selectFrontendApp2.settings) == null ? void 0 : _selectFrontendApp2$s.dynamicSettings) || {};
};
const selectDynamicTranslationKeys = state => {
  var _selectFrontendApp3, _selectFrontendApp3$s;
  return ((_selectFrontendApp3 = selectFrontendApp(state)) == null ? void 0 : (_selectFrontendApp3$s = _selectFrontendApp3.settings) == null ? void 0 : _selectFrontendApp3$s.dynamicTranslationKeys) || [];
};
const selectCameras = state => {
  var _selectFrontendApp4;
  return applyCallback("setCameraList", ((_selectFrontendApp4 = selectFrontendApp(state)) == null ? void 0 : _selectFrontendApp4.settings.cameras) || []);
};
const selectCamerasByScope = scope => state => camerasForScope(scope, selectCameras(state));
const selectModifiedGeneralCameras = state => flow(selectCamerasByScope({
  type: "general"
}), curriedApplyCallback("setScreenshotCameras"))(state);
const camerasForScope = (scope, cameras) => cameras.filter(c => {
  var _c$scope, _c$scope2;
  return scope.type === "general" && (!c.scope || c.scope.type === "general") || scope.type === ((_c$scope = c.scope) == null ? void 0 : _c$scope.type) && scope.id === ((_c$scope2 = c.scope) == null ? void 0 : _c$scope2.id);
});
const selectConfigurationInitialization = state => state.frontend.configurationInitialization;
const selectConfiguration = state => state.frontend.configuration;
const selectAnchoringSelectionsOfRuleItem = (ruleItemId, ruleColumnId) => state => {
  let anchoringSelections = [rootSelection];
  const actions = selectModelActions(state);
  if (ruleItemId) {
    // Since the anchoringSelection is the same for all actions of this ruleItem
    // we can just take the first one no matter if it fits the same rule column
    // or not.
    const modelActions = actions.filter(ma => {
      var _ma$ruleItem, _ma$ruleColumn;
      return (ma == null ? void 0 : (_ma$ruleItem = ma.ruleItem) == null ? void 0 : _ma$ruleItem.id) === ruleItemId && ((_ma$ruleColumn = ma.ruleColumn) == null ? void 0 : _ma$ruleColumn.id) === ruleColumnId;
    });
    if (modelActions) {
      anchoringSelections = modelActions.map(ma => ma.anchoringSelection);
    }
  }
  return anchoringSelections;
};
const selectArDialog = state => state.frontend.arDialog;
const selectCurrentAppSettingAction = state => isValidAppSettingsAction(state.frontend.currentAction) ? state.frontend.currentAction : null;
const selectCurrentAction = state => state.frontend.currentAction;

/**
 * This is Google Analytics tracking.
 * It may operate in two modes.
 * If initialized with an app and admin=false, this is frontend tracking of user interaction
 * into customers analytics property
 * If initialized without an app and admin=true, this is tracking of the funnel into the admin-panel
 * (registration, booking, etc) into our analytics property
 * We cannot have both at the same time, obviously.
 */
const initializeGoogleAnalytics = (app, admin = false) => {
  const code = admin ? env.adminAnalytics : app.settings.gaTrackingId;
  if (code) {
    ReactGA.initialize(code /*, { debug: true }*/);
    ReactGA.set({
      anonymizeIp: true
    });
  }
};
const analyticsTrack = (action, label, app) => {
  if (!app) return;
  const event = {
    category: app.label,
    action,
    label
  };
  if (app.settings.gaTrackingId) {
    ReactGA.event(event);
  }
};
const analyticsTrackChangeThunk = (variableId, value) => (_dispatch, getState) => {
  var _selectRuleEngineInpu;
  const state = getState();
  const variable = (_selectRuleEngineInpu = selectRuleEngineInput(state)) == null ? void 0 : _selectRuleEngineInpu.variables.byVarId.all[variableId];
  if (!variable) {
    console.warn("Rule engine not initialized!");
    return;
  }
  const action = variable.key || variable.label;
  const label = value.key || value.label;
  analyticsTrack(action, label, selectFrontendApp(state));
};
const analyticsFunnel = (state, label) => {
  const event = {
    category: "k3",
    action: state,
    label
  };
  if (env.adminAnalytics) {
    ReactGA.event(event);
  }
};

const isHidden = (group, invisibleGroups) => !!invisibleGroups.find(invisibleGroup => invisibleGroup.id === group.id);

const initialState$7 = {
  isLoading: true,
  loadedModelIds: undefined,
  screenshotting: null,
  isScreenshottingPossible: false,
  nextCameraPosition: null,
  forceNextCameraPosition: undefined,
  modelRuleData: {},
  editMode: false,
  loadingStatus: {},
  sceneContext: {}
};
const k3dSlice = createSlice({
  name: "k3d",
  initialState: initialState$7,
  reducers: {
    setModelRuleData: (state, action) => {
      state.modelRuleData[action.payload.ruleItemId] = action.payload;
    },
    clearModelRuleData: state => {
      state.modelRuleData = {};
    },
    setEditMode: (state, {
      payload
    }) => {
      state.editMode = payload;
    },
    setSceneContext: (state, action) => {
      state.sceneContext = action.payload;
    },
    setIsRenderingScreenshot: (state, action) => {
      state.sceneContext = Object.assign({}, state.sceneContext, {
        isRenderingScreenshot: action.payload
      });
    },
    setIsAR: (state, action) => {
      state.sceneContext = Object.assign({}, state.sceneContext, {
        isAR: action.payload
      });
    },
    setIsVR: (state, action) => {
      state.sceneContext = Object.assign({}, state.sceneContext, {
        isVR: action.payload
      });
    },
    setScreenshotting: (state, action) => {
      if (action.payload === "creating") state.sceneContext.isRenderingScreenshot = true;
      state.screenshotting = action.payload;
    },
    setIsScreenshottingPossible: (state, action) => {
      state.isScreenshottingPossible = action.payload;
    },
    resetScreenshotting: state => {
      const {
        screenshotting
      } = state;
      if (isArray$6(screenshotting)) {
        screenshotting.forEach(screen => URL.revokeObjectURL(screen.file));
      }
      state.screenshotting = null;
      state.sceneContext.isRenderingScreenshot = false;
    },
    setNextCameraPosition: (state, action) => {
      state.nextCameraPosition = action.payload;
    },
    forceNextCameraPosition: state => {
      state.forceNextCameraPosition = uniqueId("forceNextCameraPosition_");
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setLoadedModelIds: (state, action) => {
      state.loadedModelIds = action.payload;
    }
  }
});
const {
  setModelRuleData,
  clearModelRuleData,
  setEditMode,
  setScreenshotting,
  setIsScreenshottingPossible,
  resetScreenshotting,
  setNextCameraPosition,
  forceNextCameraPosition,
  setSceneContext,
  setIsRenderingScreenshot,
  setIsAR,
  setIsVR,
  setIsLoading,
  setLoadedModelIds
} = k3dSlice.actions;
const k3dReducer = k3dSlice.reducer;

const driveToCam = scope => (dispatch, getState) => {
  const state = getState();
  const cameras = selectCameras(state);
  const camera = camerasForScope(scope, cameras)[0];
  if (camera) dispatch(setNextCameraPosition(camera));else dispatch(setNextCameraPosition(null));
};

const emptyActionEngineState = {
  articles: [],
  colors: [],
  hideGroups: [],
  hideValues: [],
  hideVariables: [],
  concealVariables: [],
  concealGroups: [],
  images: [],
  instances: [],
  labels: [],
  materials: [],
  models: [],
  prints: []
};
const initialState$6 = {
  actionEngineInput: null,
  actionEngineState: emptyActionEngineState
};
const actionEngineSlice = createSlice({
  name: "common",
  initialState: initialState$6,
  reducers: {
    setActionEngineInput: (state, action) => {
      state.actionEngineInput = action.payload;
    },
    setActionEngineState: (state, action) => {
      state.actionEngineState = action.payload;
    }
  }
});
const {
  setActionEngineInput,
  setActionEngineState
} = actionEngineSlice.actions;
const actionEngineReducer = actionEngineSlice.reducer;

const initialState$5 = {
  app: undefined,
  infoDialog: null,
  appInfo: null,
  arDialog: false,
  currentAction: null,
  configurationInitialization: null,
  configuration: null
};
const frontendSlice = createSlice({
  name: "frontend",
  initialState: initialState$5,
  reducers: {
    setFrontendApp: (state, action) => {
      state.app = action.payload;
    },
    setInfoDialog: (state, action) => {
      state.infoDialog = action.payload;
    },
    setVariableInfoDialog: (state, action) => {
      state.variableInfoDialog = action.payload;
    },
    setAppInfo: (state, action) => {
      state.appInfo = action.payload;
    },
    setConfigurationInitialization: (state, action) => {
      state.configurationInitialization = action.payload;
    },
    setConfiguration: (state, action) => {
      state.configuration = action.payload;
    },
    setArDialog: (state, action) => {
      state.arDialog = action.payload;
    },
    setCurrentAction: (state, action) => {
      state.currentAction = action.payload;
    }
  }
});
const {
  setFrontendApp,
  setInfoDialog,
  setVariableInfoDialog,
  setAppInfo,
  setConfigurationInitialization,
  setConfiguration,
  setArDialog,
  setCurrentAction
} = frontendSlice.actions;
const frontendReducer = frontendSlice.reducer;

const articlesSlice = createSlice({
  name: "articles",
  initialState: [],
  reducers: {
    createArticle: (state, action) => [...state, action.payload],
    deleteArticle: (state, action) => state.filter(entity => entity.id !== action.payload),
    setArticles: (_state, action) => action.payload,
    updateArticle: (state, action) => state.map(entity => entity.id == action.payload.id ? action.payload : entity)
  }
});
const {
  createArticle,
  deleteArticle,
  setArticles,
  updateArticle
} = articlesSlice.actions;
const articlesReducer = articlesSlice.reducer;

const initialState$4 = {
  client: null
};
const clientSlice = createSlice({
  name: "client",
  initialState: initialState$4,
  reducers: {
    setClient: (state, action) => {
      state.client = action.payload;
    }
  }
});
const {
  setClient
} = clientSlice.actions;
const clientReducer = clientSlice.reducer;

const groupsSlice = createSlice({
  name: "groups",
  initialState: [],
  reducers: {
    setGroups: (_state, action) => action.payload || [],
    createGroup: (state, action) => [...state, action.payload],
    deleteGroup: (state, action) => state.filter(group => group.id !== action.payload.id),
    updateGroup: (state, action) => state.map(group => group.id == action.payload.id ? action.payload : group),
    updateGroups: (state, action) => {
      const updatedGroupsById = indexById(action.payload);
      return state.map(group => updatedGroupsById[group.id] || group);
    }
  }
});
const {
  createGroup,
  deleteGroup,
  updateGroup,
  updateGroups,
  setGroups
} = groupsSlice.actions;
const groupsReducer = groupsSlice.reducer;

const imagesSlice = createSlice({
  name: "images",
  initialState: [],
  reducers: {
    createImage: (state, action) => [...state, action.payload],
    deleteImage: (state, action) => state.filter(entity => entity.id !== action.payload),
    setImages: (_state, action) => action.payload,
    updateImage: (state, action) => state.map(entity => entity.id == action.payload.id ? action.payload : entity)
  }
});
const {
  createImage,
  deleteImage,
  setImages,
  updateImage
} = imagesSlice.actions;
const imagesReducer = imagesSlice.reducer;

const materialsSlice = createSlice({
  name: "materials",
  initialState: [],
  reducers: {
    createMaterial: (state, action) => [...state, action.payload],
    deleteMaterial: (state, action) => state.filter(entity => entity.id !== action.payload),
    setMaterials: (_state, action) => action.payload,
    updateMaterial: (state, action) => state.map(entity => entity.id == action.payload.id ? action.payload : entity)
  }
});
const {
  createMaterial,
  deleteMaterial,
  setMaterials,
  updateMaterial
} = materialsSlice.actions;
const materialsReducer = materialsSlice.reducer;

const modelsSlice = createSlice({
  name: "models",
  initialState: [],
  reducers: {
    createModel: (state, action) => [...state, action.payload],
    deleteModel: (state, action) => state.filter(entity => entity.id !== action.payload),
    setModels: (_state, action) => action.payload,
    updateModel: (state, action) => state.map(entity => entity.id == action.payload.id ? action.payload : entity)
  }
});
const {
  createModel,
  deleteModel,
  setModels,
  updateModel
} = modelsSlice.actions;
const modelsReducer = modelsSlice.reducer;

const pricesSlice = createSlice({
  name: "prices",
  initialState: [],
  reducers: {
    createPrice: (state, action) => [...state, action.payload],
    deletePrice: (state, action) => state.filter(entity => entity.id !== action.payload),
    setPrices: (_state, action) => action.payload,
    updatePrice: (state, action) => state.map(entity => entity.id == action.payload.id ? action.payload : entity)
  }
});
const {
  createPrice,
  deletePrice,
  setPrices,
  updatePrice
} = pricesSlice.actions;
const pricesReducer = pricesSlice.reducer;

const ruleItemSlice = createSlice({
  name: "ruleItems",
  initialState: [],
  reducers: {
    setRuleItems: (_state, action) => action.payload,
    createRuleItem: (state, action) => [...state, action.payload],
    deleteRuleItem: (state, action) => state.filter(rule => rule.id !== action.payload),
    updateRuleItem: (state, action) => state.map(rule => rule.id == action.payload.id ? action.payload : rule),
    updateRuleItems: (state, action) => {
      const updatedRulesByKey = indexById(action.payload);
      return state.map(rule => updatedRulesByKey[rule.id] || rule);
    }
  }
});
const {
  createRuleItem,
  deleteRuleItem,
  updateRuleItem,
  updateRuleItems,
  setRuleItems
} = ruleItemSlice.actions;
const ruleItemsReducer = ruleItemSlice.reducer;

const rulesSlice = createSlice({
  name: "rules",
  initialState: [],
  reducers: {
    setRules: (_state, action) => action.payload,
    createRule: (state, action) => [...state, action.payload],
    deleteRule: (state, action) => state.filter(rule => rule.id !== action.payload),
    updateRule: (state, action) => state.map(rule => rule.id == action.payload.id ? action.payload : rule),
    updateRules: (state, action) => {
      const updatedRulesByKey = indexById(action.payload);
      return state.map(rule => updatedRulesByKey[rule.id] || rule);
    }
  }
});
const {
  createRule,
  updateRule,
  deleteRule,
  setRules
} = rulesSlice.actions;
const rulesReducer = rulesSlice.reducer;

var $$7 = _export;
var DESCRIPTORS$4 = descriptors;
var global$9 = global$w;
var uncurryThis$9 = functionUncurryThis;
var hasOwn$3 = hasOwnProperty_1;
var isCallable$2 = isCallable$q;
var isPrototypeOf$3 = objectIsPrototypeOf;
var toString$4 = toString$g;
var defineBuiltInAccessor$3 = defineBuiltInAccessor$6;
var copyConstructorProperties = copyConstructorProperties$2;

var NativeSymbol = global$9.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS$4 && isCallable$2(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString$4(arguments[0]);
    var result = isPrototypeOf$3(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('test')) == 'Symbol(test)';
  var thisSymbolValue = uncurryThis$9(SymbolPrototype.valueOf);
  var symbolDescriptiveString = uncurryThis$9(SymbolPrototype.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace$1 = uncurryThis$9(''.replace);
  var stringSlice$2 = uncurryThis$9(''.slice);

  defineBuiltInAccessor$3(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwn$3(EmptyStringDescriptionStore, symbol)) return '';
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL ? stringSlice$2(string, 7, -1) : replace$1(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $$7({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}

const createBasicValue = ({
  appId,
  attrs: _attrs = null,
  description: _description = null,
  disabled: _disabled = false,
  isDefault: _isDefault = false,
  key: _key = null,
  label,
  price: _price = 0,
  sort,
  thumbnail: _thumbnail = null,
  url: _url = null,
  info: _info = null,
  value,
  variableId
}) => ({
  appId,
  attrs: _attrs,
  description: _description,
  disabled: _disabled,
  isDefault: _isDefault,
  key: _key,
  label,
  price: _price,
  sort,
  thumbnail: _thumbnail,
  url: _url,
  value,
  info: _info,
  variableId
});

const fetchError = e => {
  console.error("FETCH-ERROR", e);
  // TODO
  // wkfg3API.handleError(e);
};

async function api_createResource(type, entity, params = {}) {
  try {
    return await api_request("POST", `/${type}`, entity, {
      lang: params == null ? void 0 : params.lang
    });
  } catch (e) {
    fetchError(e);
    throw e;
  }
}
async function api_bulkCreateResource(type, entities, params = {}) {
  try {
    return await api_request("POST", `/${type}/bulk`, entities, {
      lang: params == null ? void 0 : params.lang
    });
  } catch (e) {
    fetchError(e);
    throw e;
  }
}
async function api_getResourceById(type, id, params = {}) {
  try {
    return await api_request("GET", `/${type}/${id}`, null, {
      lang: params == null ? void 0 : params.lang
    });
  } catch (e) {
    fetchError(e);
    throw e;
  }
}
// Querys only the Table of T
async function api_queryResources(type, query, params = {}) {
  try {
    const qs = new URLSearchParams(query);
    return await api_request("GET", `/${type}?${qs}`, null, {
      lang: params == null ? void 0 : params.lang
    });
  } catch (e) {
    fetchError(e);
    throw e;
  }
}
async function api_updateResource(type, entity, params = {}) {
  try {
    const id = entity.id;
    const updateEntity = omit(entity, "id");
    return await api_request("PUT", `/${type}/${id}`, updateEntity, {
      lang: params == null ? void 0 : params.lang
    });
  } catch (e) {
    fetchError(e);
    throw e;
  }
}
async function api_bulkUpdateResource(type, entities, params = {}) {
  try {
    return await api_request("PUT", `/${type}`, entities, {
      lang: params == null ? void 0 : params.lang
    });
  } catch (e) {
    fetchError(e);
    throw e;
  }
}
async function api_deleteResource(type, id) {
  try {
    await api_request("DELETE", `/${type}/${id}`);
  } catch (e) {
    fetchError(e);
    throw e;
  }
}
async function api_uploadResourceContent(type, files, path, params = {}) {
  try {
    if (!params.appCode) {
      throw new Error("Missing App Code for uploadContent!");
    }
    const formData = new FormData();
    formData.append("app", params.appCode);
    if (type) formData.append("path", type + path);
    (Array.isArray(files) ? files : [files]).forEach(entry => {
      if (entry instanceof File) {
        formData.append("file[]", entry, entry.name);
      } else {
        formData.append("file[]", entry.blob, entry.fileName);
      }
    });
    return await api_fetch("POST", "/doc", formData);
  } catch (e) {
    fetchError(e);
    throw e;
  }
}
async function api_uploadResourceTmpContent(type, files, path, params = {}) {
  try {
    if (!params.appCode) {
      throw new Error("Missing App Code for uploadTmpContent!");
    }
    const formData = new FormData();
    formData.append("app", params.appCode);
    if (type) formData.append("path", type + path);
    (Array.isArray(files) ? files : [files]).forEach(entry => {
      if (entry instanceof File) {
        formData.append("file[]", entry, entry.name);
      } else {
        formData.append("file[]", entry.blob, entry.fileName);
      }
    });
    return await api_fetch("POST", "/doc/tmp", formData);
  } catch (e) {
    alert(e);
    fetchError(e);
    throw e;
  }
}
// Querys deleted records
async function api_queryResourceTrash(type, query, params = {}) {
  try {
    const qs = new URLSearchParams(query);
    return await api_request("GET", `/${type}/trash?${qs}`, null, {
      lang: params == null ? void 0 : params.lang
    });
  } catch (e) {
    fetchError(e);
    throw e;
  }
}
async function api_undeleteResource(type, id, params = {}) {
  try {
    return await api_request("GET", `/${type}/${id}/undelete`, null, {
      lang: params == null ? void 0 : params.lang
    });
  } catch (e) {
    fetchError(e);
    throw e;
  }
}

function move(entityArray, entity, direction) {
  const newArr = [...entityArray];
  const item = newArr.find(v => v.id == entity.id);
  const index = newArr.indexOf(item);
  if (index + direction < 0 || index + direction > newArr.length) return entityArray;
  newArr.splice(index, 1);
  newArr.splice(index + direction, 0, item);
  const result = newArr.map((item, i) => Object.assign({}, item, {
    sort: i
  }));
  return result;
}
const directionForBAfterA = (a, b) => a.sort - b.sort + 1;
const byOrder = (a, b) => (a.sort || 0) - (b.sort || 0);
const byOrderAndCreation = (a, b) => a.sort - b.sort || a.id - b.id;

const internalSelectGroups = state => state.metadata.groups;
const selectGroups = createSelector(internalSelectGroups, groups => groups.slice().sort(byOrder));
const selectGroupsByIdMap = createSelector(selectGroups, groups => indexById(groups));
// FIXME: causes infinite rerenders
const selectGroupsByAppId = appId => state => selectGroups(state).filter(group => +group.appId == appId);
const selectGroupById = groupId => state => selectGroups(state).find(group => group.id == groupId);
const selectGroupByKey = groupKey => state => selectGroups(state).find(group => group.key == groupKey);
const selectGroupByParentId = parentId => state => selectGroups(state).find(group => group.parentId == parentId);
const selectGroupsByParentId = parentId => state => selectGroups(state).filter(group => group.parentId === parentId);

const selectAdminLanguage = state => state.common.language;
/**
 * @deprecated: this is deprecated and marks places where content language might be incorrect */
const selectLanguage = state => state.common.language;
const selectContentLanguage = state => state.common.contentLanguage;
const selectDealerData = state => state.common.dealerData;
const selectSelectedVariableId = state => state.common.selectedVariableId;
const selectFocusGroupId = state => state.common.focusGroupId;
const selectFocusGroup = state => {
  const groups = selectGroups(state);
  const currentGroup = groups.find(g => g.id === state.common.focusGroupId);
  return currentGroup;
};
const selectLoadingCallIds = state => state.common.callIds;
const selectIsLoading = state => selectLoadingCallIds(state).length > 0;
const isFullscreen3DView = state => state.common.fullScreen3DView;

const selectValues = state => state.metadata.values;
const selectValuesByIdMap = createSelector(selectValues, values => indexById(values));
const selectValuesByVariableId = curry((variableId, state) => variableId ? selectValues(state).filter(value => value.variableId == variableId)
// We need to sort here, because state.metadata.values is not sorted,
// only ruleEngineInput values is.
// But because this is used for the UI Tables in the Admin Panel we
// don't want autogenerated values and thus want to continue to use
// metadata.values.
.slice().sort(byOrderAndCreation) : []);
const selectValueById = valueId => state => selectValues(state).find(value => value.id == valueId);
const selectValueByKey = valueKey => state => selectValues(state).find(value => value.key == valueKey);
const selectValuesByAppId = appId => state => selectValues(state).filter(value => value.appId == appId);

const valuesSlice = createSlice({
  name: "values",
  initialState: [],
  reducers: {
    setValues: (_state, action) => action.payload,
    createValue: (state, action) => [...state, action.payload],
    deleteValue: (state, action) => state.filter(value => value.id !== action.payload),
    updateValue: (state, action) => state.map(value => value.id == action.payload.id ? action.payload : value),
    updateValues: (state, action) => {
      const newValues = action.payload;
      return state.map(value => newValues.find(v => v.id == value.id) || value);
    }
  }
});
const {
  createValue,
  deleteValue,
  updateValue,
  updateValues,
  setValues
} = valuesSlice.actions;
const valuesReducer = valuesSlice.reducer;

const createValueThunk = (value, variable) => async (dispatch, getState) => {
  const state = getState();
  const language = selectContentLanguage(state);
  const variableValues = selectValuesByVariableId(variable.id)(state);
  const newValue = createBasicValue(Object.assign({}, value, {
    sort: (value == null ? void 0 : value.sort) === undefined ? 1 + Math.max(...variableValues.map(v => v.sort), 0) : value.sort,
    appId: variable.appId,
    variableId: variable.id
  }));
  const result = await api_createResource("value", newValue, {
    lang: language
  });
  dispatch(createValue(result));
  return result;
};

const deleteValueThunk = valueId => async dispatch => {
  dispatch(deleteValue(valueId));
  await api_deleteResource("value", valueId);
};

const variablesSlice = createSlice({
  name: "variables",
  initialState: [],
  reducers: {
    setVariables: (_state, action) => action.payload,
    createVariable: (state, action) => [...state, action.payload],
    deleteVariable: (state, action) => state.filter(variable => variable.id !== action.payload),
    updateVariable: (state, action) => state.map(variable => variable.id == action.payload.id ? action.payload : variable),
    updateVariables: (state, action) => {
      const updatedVariablesById = indexById(action.payload);
      return state.map(variable => updatedVariablesById[variable.id] || variable);
    }
  }
});
const {
  createVariable,
  deleteVariable,
  updateVariable,
  setVariables
} = variablesSlice.actions;
const variablesReducer = variablesSlice.reducer;

/** Clear touched */
const emptyTouched = state => {
  return {
    free: state.free,
    locked: Object.assign({}, state.locked, {
      touched: {}
    }),
    all: Object.assign({}, state.all, {
      touched: {}
    })
  };
};
/** Adds touches to state */
const addTouched = (i, state, touch, touchHidden = false) => {
  const newTouched = cloneDeep(state.all.touched);
  touch.forEach(t => {
    const v = i.variables.byVarId.all[t.variableId];
    if (!v) return;
    if (!touchHidden) {
      const hidden = isHiddenBecause(v, i, state, t.instanceId);
      if (hidden) return;
    }
    if (!newTouched[t.instanceId]) newTouched[t.instanceId] = [];
    if (!newTouched[t.instanceId].includes(t.variableId)) newTouched[t.instanceId].push(t.variableId);
  });
  return {
    free: state.free,
    locked: Object.assign({}, state.locked, {
      touched: newTouched
    }),
    all: Object.assign({}, state.all, {
      touched: newTouched
    })
  };
};
/** Marks all instance launchers as touched */
const markInstanceLaunchersAsTouched = (input, state) => {
  const touching = state.state.locked.selections.filter(s => s.instance.isInstanceLauncher).map(s => ({
    instanceId: s.instance.id,
    variableId: s.variableId
  }));
  return Object.assign({}, state, {
    state: addTouched(input, state.state, touching)
  });
};

const initialState$3 = {
  openInstance: rootSelection,
  ruleEngineInput: null,
  ruleEngineState: null,
  ruleEngineConflict: null,
  ruleEngineError: undefined
};
const ruleEngineSlice = createSlice({
  name: "common",
  initialState: initialState$3,
  reducers: {
    setRuleEngineInput: (state, action) => {
      state.ruleEngineInput = action.payload;
    },
    setRuleEngineState: (state, action) => {
      state.ruleEngineState = action.payload;
    },
    setRuleEngineConflict: (state, action) => {
      state.ruleEngineConflict = action.payload;
    },
    setOpenInstance: (state, action) => {
      state.openInstance = action.payload;
    },
    resetTouched: state => {
      // @ts-ignore
      state.ruleEngineState = Object.assign({}, state.ruleEngineState, {
        state: emptyTouched(state.ruleEngineState.state)
      });
    },
    setRuleEngineError: (state, action) => {
      state.ruleEngineError = action.payload;
    }
  }
});
const {
  setRuleEngineInput,
  setRuleEngineState,
  setRuleEngineConflict,
  setOpenInstance,
  resetTouched,
  setRuleEngineError
} = ruleEngineSlice.actions;
const ruleEngineReducer = ruleEngineSlice.reducer;

var call$5 = functionCall;
var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
var anObject$2 = anObject$k;
var isNullOrUndefined$1 = isNullOrUndefined$8;
var toLength$6 = toLength$9;
var toString$3 = toString$g;
var requireObjectCoercible$2 = requireObjectCoercible$b;
var getMethod$1 = getMethod$7;
var advanceStringIndex$1 = advanceStringIndex$3;
var regExpExec$1 = regexpExecAbstract;

// @@match logic
fixRegExpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible$2(this);
      var matcher = isNullOrUndefined$1(regexp) ? undefined : getMethod$1(regexp, MATCH);
      return matcher ? call$5(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString$3(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var rx = anObject$2(this);
      var S = toString$3(string);
      var res = maybeCallNative(nativeMatch, rx, S);

      if (res.done) return res.value;

      if (!rx.global) return regExpExec$1(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec$1(rx, S)) !== null) {
        var matchStr = toString$3(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex$1(S, toLength$6(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});

var isCallable$1 = isCallable$q;
var isObject$3 = isObject$g;
var setPrototypeOf$3 = objectSetPrototypeOf;

// makes subclassing work correct for wrapped built-ins
var inheritIfRequired$2 = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf$3 &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable$1(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject$3(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf$3($this, NewTargetPrototype);
  return $this;
};

var defineProperty = objectDefineProperty.f;

var proxyAccessor$1 = function (Target, Source, key) {
  key in Target || defineProperty(Target, key, {
    configurable: true,
    get: function () { return Source[key]; },
    set: function (it) { Source[key] = it; }
  });
};

var DESCRIPTORS$3 = descriptors;
var global$8 = global$w;
var uncurryThis$8 = functionUncurryThis;
var isForced = isForced_1;
var inheritIfRequired$1 = inheritIfRequired$2;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$9;
var getOwnPropertyNames$2 = objectGetOwnPropertyNames.f;
var isPrototypeOf$2 = objectIsPrototypeOf;
var isRegExp$1 = isRegexp;
var toString$2 = toString$g;
var getRegExpFlags$1 = regexpGetFlags;
var stickyHelpers = regexpStickyHelpers;
var proxyAccessor = proxyAccessor$1;
var defineBuiltIn$2 = defineBuiltIn$d;
var fails$9 = fails$A;
var hasOwn$2 = hasOwnProperty_1;
var enforceInternalState$2 = internalState.enforce;
var setSpecies$1 = setSpecies$3;
var wellKnownSymbol$2 = wellKnownSymbol$o;
var UNSUPPORTED_DOT_ALL = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG = regexpUnsupportedNcg;

var MATCH = wellKnownSymbol$2('match');
var NativeRegExp = global$8.RegExp;
var RegExpPrototype$1 = NativeRegExp.prototype;
var SyntaxError = global$8.SyntaxError;
var exec = uncurryThis$8(RegExpPrototype$1.exec);
var charAt = uncurryThis$8(''.charAt);
var replace = uncurryThis$8(''.replace);
var stringIndexOf$1 = uncurryThis$8(''.indexOf);
var stringSlice$1 = uncurryThis$8(''.slice);
// TODO: Use only proper RegExpIdentifierName
var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var MISSED_STICKY = stickyHelpers.MISSED_STICKY;
var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;

var BASE_FORCED = DESCRIPTORS$3 &&
  (!CORRECT_NEW || MISSED_STICKY || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG || fails$9(function () {
    re2[MATCH] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    return NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || NativeRegExp(re1, 'i') != '/a/i';
  }));

var handleDotAll = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var brackets = false;
  var chr;
  for (; index <= length; index++) {
    chr = charAt(string, index);
    if (chr === '\\') {
      result += chr + charAt(string, ++index);
      continue;
    }
    if (!brackets && chr === '.') {
      result += '[\\s\\S]';
    } else {
      if (chr === '[') {
        brackets = true;
      } else if (chr === ']') {
        brackets = false;
      } result += chr;
    }
  } return result;
};

var handleNCG = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var named = [];
  var names = {};
  var brackets = false;
  var ncg = false;
  var groupid = 0;
  var groupname = '';
  var chr;
  for (; index <= length; index++) {
    chr = charAt(string, index);
    if (chr === '\\') {
      chr = chr + charAt(string, ++index);
    } else if (chr === ']') {
      brackets = false;
    } else if (!brackets) switch (true) {
      case chr === '[':
        brackets = true;
        break;
      case chr === '(':
        if (exec(IS_NCG, stringSlice$1(string, index + 1))) {
          index += 2;
          ncg = true;
        }
        result += chr;
        groupid++;
        continue;
      case chr === '>' && ncg:
        if (groupname === '' || hasOwn$2(names, groupname)) {
          throw new SyntaxError('Invalid capture group name');
        }
        names[groupname] = true;
        named[named.length] = [groupname, groupid];
        ncg = false;
        groupname = '';
        continue;
    }
    if (ncg) groupname += chr;
    else result += chr;
  } return [result, named];
};

// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if (isForced('RegExp', BASE_FORCED)) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = isPrototypeOf$2(RegExpPrototype$1, this);
    var patternIsRegExp = isRegExp$1(pattern);
    var flagsAreUndefined = flags === undefined;
    var groups = [];
    var rawPattern = pattern;
    var rawFlags, dotAll, sticky, handled, result, state;

    if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) {
      return pattern;
    }

    if (patternIsRegExp || isPrototypeOf$2(RegExpPrototype$1, pattern)) {
      pattern = pattern.source;
      if (flagsAreUndefined) flags = getRegExpFlags$1(rawPattern);
    }

    pattern = pattern === undefined ? '' : toString$2(pattern);
    flags = flags === undefined ? '' : toString$2(flags);
    rawPattern = pattern;

    if (UNSUPPORTED_DOT_ALL && 'dotAll' in re1) {
      dotAll = !!flags && stringIndexOf$1(flags, 's') > -1;
      if (dotAll) flags = replace(flags, /s/g, '');
    }

    rawFlags = flags;

    if (MISSED_STICKY && 'sticky' in re1) {
      sticky = !!flags && stringIndexOf$1(flags, 'y') > -1;
      if (sticky && UNSUPPORTED_Y) flags = replace(flags, /y/g, '');
    }

    if (UNSUPPORTED_NCG) {
      handled = handleNCG(pattern);
      pattern = handled[0];
      groups = handled[1];
    }

    result = inheritIfRequired$1(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype$1, RegExpWrapper);

    if (dotAll || sticky || groups.length) {
      state = enforceInternalState$2(result);
      if (dotAll) {
        state.dotAll = true;
        state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
      }
      if (sticky) state.sticky = true;
      if (groups.length) state.groups = groups;
    }

    if (pattern !== rawPattern) try {
      // fails in old engines, but we have no alternatives for unsupported regex syntax
      createNonEnumerableProperty$3(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
    } catch (error) { /* empty */ }

    return result;
  };

  for (var keys$1 = getOwnPropertyNames$2(NativeRegExp), index = 0; keys$1.length > index;) {
    proxyAccessor(RegExpWrapper, NativeRegExp, keys$1[index++]);
  }

  RegExpPrototype$1.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype$1;
  defineBuiltIn$2(global$8, 'RegExp', RegExpWrapper, { constructor: true });
}

// https://tc39.es/ecma262/#sec-get-regexp-@@species
setSpecies$1('RegExp');

/* eslint-disable es/no-string-prototype-matchall -- safe */
var $$6 = _export;
var call$4 = functionCall;
var uncurryThis$7 = functionUncurryThisClause;
var createIteratorConstructor = iteratorCreateConstructor;
var createIterResultObject = createIterResultObject$3;
var requireObjectCoercible$1 = requireObjectCoercible$b;
var toLength$5 = toLength$9;
var toString$1 = toString$g;
var anObject$1 = anObject$k;
var isNullOrUndefined = isNullOrUndefined$8;
var classof$4 = classofRaw$2;
var isRegExp = isRegexp;
var getRegExpFlags = regexpGetFlags;
var getMethod = getMethod$7;
var defineBuiltIn$1 = defineBuiltIn$d;
var fails$8 = fails$A;
var wellKnownSymbol$1 = wellKnownSymbol$o;
var speciesConstructor$1 = speciesConstructor$3;
var advanceStringIndex = advanceStringIndex$3;
var regExpExec = regexpExecAbstract;
var InternalStateModule$3 = internalState;
var IS_PURE = isPure;

var MATCH_ALL = wellKnownSymbol$1('matchAll');
var REGEXP_STRING = 'RegExp String';
var REGEXP_STRING_ITERATOR = REGEXP_STRING + ' Iterator';
var setInternalState$2 = InternalStateModule$3.set;
var getInternalState$2 = InternalStateModule$3.getterFor(REGEXP_STRING_ITERATOR);
var RegExpPrototype = RegExp.prototype;
var $TypeError$1 = TypeError;
var stringIndexOf = uncurryThis$7(''.indexOf);
var nativeMatchAll = uncurryThis$7(''.matchAll);

var WORKS_WITH_NON_GLOBAL_REGEX = !!nativeMatchAll && !fails$8(function () {
  nativeMatchAll('a', /./);
});

var $RegExpStringIterator = createIteratorConstructor(function RegExpStringIterator(regexp, string, $global, fullUnicode) {
  setInternalState$2(this, {
    type: REGEXP_STRING_ITERATOR,
    regexp: regexp,
    string: string,
    global: $global,
    unicode: fullUnicode,
    done: false
  });
}, REGEXP_STRING, function next() {
  var state = getInternalState$2(this);
  if (state.done) return createIterResultObject(undefined, true);
  var R = state.regexp;
  var S = state.string;
  var match = regExpExec(R, S);
  if (match === null) {
    state.done = true;
    return createIterResultObject(undefined, true);
  }
  if (state.global) {
    if (toString$1(match[0]) === '') R.lastIndex = advanceStringIndex(S, toLength$5(R.lastIndex), state.unicode);
    return createIterResultObject(match, false);
  }
  state.done = true;
  return createIterResultObject(match, false);
});

var $matchAll = function (string) {
  var R = anObject$1(this);
  var S = toString$1(string);
  var C = speciesConstructor$1(R, RegExp);
  var flags = toString$1(getRegExpFlags(R));
  var matcher, $global, fullUnicode;
  matcher = new C(C === RegExp ? R.source : R, flags);
  $global = !!~stringIndexOf(flags, 'g');
  fullUnicode = !!~stringIndexOf(flags, 'u');
  matcher.lastIndex = toLength$5(R.lastIndex);
  return new $RegExpStringIterator(matcher, S, $global, fullUnicode);
};

// `String.prototype.matchAll` method
// https://tc39.es/ecma262/#sec-string.prototype.matchall
$$6({ target: 'String', proto: true, forced: WORKS_WITH_NON_GLOBAL_REGEX }, {
  matchAll: function matchAll(regexp) {
    var O = requireObjectCoercible$1(this);
    var flags, S, matcher, rx;
    if (!isNullOrUndefined(regexp)) {
      if (isRegExp(regexp)) {
        flags = toString$1(requireObjectCoercible$1(getRegExpFlags(regexp)));
        if (!~stringIndexOf(flags, 'g')) throw $TypeError$1('`.matchAll` does not allow non-global regexes');
      }
      if (WORKS_WITH_NON_GLOBAL_REGEX) return nativeMatchAll(O, regexp);
      matcher = getMethod(regexp, MATCH_ALL);
      if (matcher === undefined && IS_PURE && classof$4(regexp) == 'RegExp') matcher = $matchAll;
      if (matcher) return call$4(matcher, regexp, O);
    } else if (WORKS_WITH_NON_GLOBAL_REGEX) return nativeMatchAll(O, regexp);
    S = toString$1(O);
    rx = new RegExp(regexp, 'g');
    return rx[MATCH_ALL](S);
  }
});

MATCH_ALL in RegExpPrototype || defineBuiltIn$1(RegExpPrototype, MATCH_ALL, $matchAll);

const noVariableError = identificator => new Error(i18n.t("es gibt keine Variable mit {{identificator}}", {
  identificator
}));
const noAttributeError = identificator => new Error(i18n.t("es gibt kein Attribut mit {{identificator}}", {
  identificator
}));
const noSelectionError = identificator => new Error(i18n.t("es gibt keine Selection mit {{identificator}}", {
  identificator
}));
const moreThanOneSelectionError = identificator => new Error(i18n.t("es gibt mehr als eine Selection mit {{identificator}}", {
  identificator
}));
const cycleError = cycleText => new Error(i18n.t("Es gibt einen Zyklus in den berechneten Variablen: {{cycleText}}", {
  cycleText
}));
const assertNumberOrNull = value => {
  const type = typeof value;
  if (!(value == null || type === "number")) {
    throw new Error(i18n.t("das Ergebnis der Formel muss ein Zahlenwert sein, statt dessen ist es {{type}}", {
      type
    }));
  }
  return value;
};
const assertNotNull = (value, functionName, paramName) => {
  if (value == null) {
    throw new Error(i18n.t("Wert {{paramName}} der Funktion {{functionName}} ist null", {
      functionName,
      paramName
    }));
  }
  return value;
};
const arrayAccessNeededError = variableLabel => new Error(i18n.t("Die Variable {{variableLabel}} ist eine Komponentenliste. Sie müssen mit einem Index wie {{variableLabel2}}[0] für das 1. Element oder mit einer Array-Funktionen wie z.B. map(), find(), reduce() oder first() darauf zugreifen", {
  variableLabel,
  variableLabel2: variableLabel
}));

// jsExpression.ohm als base64 encoded String
const jsExpression = atob("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");

// hier finden sich alle Funktionen, welche in der ExpressionEngine verfügbar sind
// zusätzlich wird noch eine Funktion variable(label) sowie id(id) im Proxy erzeugt, welche eine Variable zurückgibt
const extraFunctions = _.toPairs({
  count: a => a.length,
  product: a => a.reduce((p, x) => p * x, 1)
});
const lodashFunctions = ["capitalize", "clamp", "compact", "first", "last", "lowerFirst", "max", "min", "mean", "pad", "range", "snakeCase", "orderBy", "startCase", "sum", "tail", "take", "takeLast", "toLower", "toUpper", "union", "uniq", "upperFirst", "without"].map(name => [name, _[name]]);
const numberStatics = ["EPSILON", "MAX_SAFE_INTEGER", "MAX_VALUE", "MIN_SAFE_INTEGER", "MIN_VALUE", "NaN", "NEGATIVE_INFINITY", "POSITIVE_INFINITY", "isFinite", "isInteger", "isNaN", "isSafeInteger", "parseFloat", "parseInt"].map(name => [name, Number[name]]);
const mathStatics = ["E", "PI", "abs", "acos", "acosh", "asin", "asinh", "atan", "atan2", "atanh", "ceil", "cos", "cosh", "exp", "floor", "fround", "hypot", "imul", "log", "log10", "log1p", "log2", "pow", "round", "sign", "sin", "sinh", "sqrt", "tan", "tanh", "trunc" // this seems to be necessary here
].map(name => [name, Math[name]]);
const numberMethods = ["toExponential", "toFixed", "toPrecision", "toLocaleString"];
const numberMethodFunctions = numberMethods.map(name => [name,
// (x, ...args) => (isNumber(x) ? x[name](...args) : null),
(x, ...args) => isNumber(x) ? x[name](...args) : throwFunTypeError(name, "number", x)]);
const stringMethods = ["endsWith", "includes", "indexOf", "lastIndexOf", "localeCompare", "match", "matchAll", "normalize", "padEnd", "padStart", "repeat", "replace", "replaceAll", "search", "slice", "split", "startsWith", "substring", "toLocaleLowerCase", "toLocaleUpperCase", "toLowerCase", "toSource", "toString", "toUpperCase", "trim", "trimEnd", "trimStart"];
const stringMethodFunctions = stringMethods.map(name => [name, (x, ...args) => isString$1(x) ?
// @ts-ignore
x[name](...args) : throwFunTypeError(name, "string", x)]);
const regexMethods = ["test"];
const regexMethodFunctions = regexMethods.map(name => [name,
// (x, ...args) => (isRegExp(x) ? x[name](...args) : null),
(x, ...args) => isRegExp$3(x) ?
// @ts-ignore Should it be that way?
x[name](...args) : throwFunTypeError(name, "RegExp", x)]);
const arrayMethods = ["at", "concat", "every", "filter", "find", "findIndex", "flat", "flatMap", "includes", "indexOf", "join", "lastIndexOf", "map", "reduce", "reduceRight", "slice", "some"];
const arrayMethodFunctions = arrayMethods.map(name => [name, (x, ...args) =>
// @ts-ignore Needed here because we access the array
isArray$6(x) ? x[name](...args) : throwFunTypeError(name, "Array", x)]);
const standardMethodsAsFunctions = [...numberMethodFunctions, ...stringMethodFunctions, ...regexMethodFunctions, ...arrayMethodFunctions];
function throwFunTypeError(funName, type, x) {
  throw new Error(`function ${funName}(...) is only defined for type ${type} but got type ${typeof x}`);
}
const staticContext = _.fromPairs([].concat(standardMethodsAsFunctions, numberStatics, mathStatics, lodashFunctions, extraFunctions));
var types;
(function (types) {
  types[types["Boolean"] = 0] = "Boolean";
  types[types["Number"] = 1] = "Number";
  types[types["Array"] = 2] = "Array";
  types[types["ElementCallback"] = 3] = "ElementCallback";
  types[types["ArrayElement"] = 4] = "ArrayElement";
  types[types["CallbackReturn"] = 5] = "CallbackReturn";
  types[types["Any"] = 6] = "Any";
})(types || (types = {}));
const arrayFunctionWithCallback = [{
  name: "first",
  arguments: [types.Array],
  type: types.ArrayElement
}, {
  name: "last",
  arguments: [types.Array],
  type: types.ArrayElement
}, {
  name: "every",
  arguments: [types.Array, types.ElementCallback],
  type: types.Boolean
}, {
  name: "filter",
  arguments: [types.Array, types.ElementCallback],
  type: types.ArrayElement
}, {
  name: "find",
  arguments: [types.Array, types.ElementCallback],
  type: types.ArrayElement
}, {
  name: "findIndex",
  arguments: [types.Array, types.ElementCallback],
  type: types.Number
}, {
  name: "includes",
  arguments: [types.Array, types.ArrayElement],
  type: types.ArrayElement
}, {
  name: "indexOf",
  arguments: [types.Array, types.ArrayElement],
  type: types.Number
}, {
  name: "lastIndexOf",
  arguments: [types.Array, types.ArrayElement],
  type: types.Number
}, {
  name: "map",
  arguments: [types.Array, types.ElementCallback],
  type: types.CallbackReturn
}, {
  name: "reduce",
  arguments: [types.Array, types.ElementCallback, types.Any],
  type: types.CallbackReturn
}, {
  name: "reduceRight",
  arguments: [types.Array, types.ElementCallback, types.Any],
  type: types.CallbackReturn
}, {
  name: "some",
  arguments: [types.Array, types.ElementCallback],
  type: types.Boolean
}, {
  name: "orderBy",
  arguments: [types.Array, types.ElementCallback],
  type: types.Array
}];

/**
 * Sortiert einen azyklischen gerichteten Graphen, d.h. gibt eine Liste zurück,
 * in der Abhängigkeiten der Reihenfolge nach aufgelöst sind.
 * Im Falle eines Cycle wird der Cycle als Array mit Elementen als Error gethrowed
 *
 * Beispiel: wenn man ein Array von Aufgaben hat, und Aufgaben können voneinander abhängen,
 * dann kriegt man eine Reihenfolge zurück, in der die Aufgaben hinter einander abgearbeitet werden können.
 * Edges muss in diesem Beispiel zu einer Aufgabe A alle Aufgaben zurück geben,
 * die als Vorbedingung erledigt werden müssen (es reichen die direkten Vorgänger-Aufgaben).
 *
 * @see https://www.tutorialspoint.com/Topological-sorting-using-Javascript-DFS
 * @param {Array} array von beliebigen Element-Objekten
 * @param {function} edges ein Callback das zu jedem Element aus array die referenzierten Elemente zurückgibt
 * @param {boolean} throwError Entscheidet ob eine exception geworfen wird, wenn die Variable bereits besucht wurde.
 * @returns {Array}
 */
function topologicalSort(array, edges = element => [], throwError) {
  const sorted = [];
  const permanent = new Set();
  const temporary = new Set();
  const visit = element => {
    if (permanent.has(element)) {
      return;
    }
    if (temporary.has(element)) {
      temporary.add(element);
      if (throwError(element)) {
        throw temporary;
      } else {
        return;
      }
    }
    temporary.add(element);
    edges(element).forEach(visit);
    temporary.delete(element);
    permanent.add(element);
    sorted.push(element);
  };
  array.forEach(visit);
  return sorted;
}
const calculated = variable => {
  var _variable$settings$te, _variable$settings, _variable$settings$te2;
  return (_variable$settings$te = variable == null ? void 0 : (_variable$settings = variable.settings) == null ? void 0 : (_variable$settings$te2 = _variable$settings.templateOptions) == null ? void 0 : _variable$settings$te2.calculated) != null ? _variable$settings$te : false;
};
const expression = variable => {
  var _variable$settings$te3, _variable$settings2, _variable$settings2$t;
  return (_variable$settings$te3 = variable == null ? void 0 : (_variable$settings2 = variable.settings) == null ? void 0 : (_variable$settings2$t = _variable$settings2.templateOptions) == null ? void 0 : _variable$settings2$t.expression) != null ? _variable$settings$te3 : "";
};
const isExpression = thing => isRecord(thing) && "expression" in thing && isString$1(thing.expression);
const isNonPrimitiveExpression = exp => {
  const expStr = isExpression(exp) ? exp.expression : exp;
  try {
    const r = +expStr;
    return !r && r !== 0;
  } catch (_unused) {
    return true;
  }
};

const resolve = (that, node, localContext, globalContext) => node.resolve(that.args.resolver, that.args.nodeToRefMap, localContext != null ? localContext : that.args.localContext, globalContext != null ? globalContext : that.args.globalContext);
const jsExpressionGrammar = ohm.grammar(jsExpression);
const nodeToRefMap = node => node.args.nodeToRefMap;
const mapper = node => node.args.mapper;
const resolver = node => node.args.resolver;
const setNodeMap = (node, value) => {
  if (value) {
    node.args.nodeToRefMap.set(node._node, value);
  }
  return [value];
};
const jsExpressionSemantics = jsExpressionGrammar.createSemantics()
// ######################################################################################
// ersetzt alle Nodes, die in der nodeToRefMap stehen, durch einen umformatierten String,
// lässt für alle anderen Nodes den Source-Strings unverändert
.addOperation("replace(replacer,resolver,nodeToRefMap,mapper)", {
  _nonterminal(...children) {
    const ref = nodeToRefMap(this).get(this._node);
    if (ref && !ref.binding) {
      const replacement = mapper(this)(ref);
      if (replacement != null) {
        const replacer = this.args.replacer;
        replacer.replace(this, replacement);
        return;
      }
    }
    return children.map(c => c.replace(this.args.replacer, this.args.resolver, this.args.nodeToRefMap, this.args.mapper)).flat();
  },
  _iter(...children) {
    return children.map(c => c.replace(this.args.replacer, this.args.resolver, this.args.nodeToRefMap, this.args.mapper)).flat();
  },
  _terminal() {
    return [];
  }
})
// ######################################################################################
// ermittelt für alle Nodes, ob es sich um eine Variable oder ein Attribut handelt,
// und ermittelt den jeweiligen Context, in dem ein Teil der Expression sich befindet
.addOperation("resolve(resolver,nodeToRefMap,localContext,globalContext)", {
  CallExpression_alt1(a, b) {
    // MemberExpression<guardYield> Arguments<guardYield> -- alt1
    const functionName = a.plain[0];
    const functionMeta = arrayFunctionWithCallback.find(({
      name
    }) => name === functionName);
    if (functionMeta) {
      const arrayArgumentIndex = functionMeta.arguments.findIndex(t => t === types.Array);
      const variableNode = b.arguments[arrayArgumentIndex];
      const variable = resolve(this, variableNode)[0];
      let lastValue = undefined;
      b.arguments.forEach((node, index) => {
        const type = functionMeta.arguments[index];
        if (type === types.ElementCallback) {
          const {
            parameter,
            body
          } = node.arrowFunction[0];
          const parameterIdentifier = parameter.plain[0];
          const newContext = resolver(this).subContextWithBinding(this.args.globalContext, parameterIdentifier, variable);
          lastValue = resolve(this, body, newContext, newContext)[0];
        } else {
          resolve(this, node);
        }
      });
      if (functionMeta.type === types.ArrayElement) {
        return [variable];
      }
      return [lastValue];
    }
    return resolve(this, b.arguments[0])[0];
  },
  CallExpression_alt5(a, b, c) {
    var _resolve, _resolver$subContextF, _resolver;
    // CallExpression<guardYield> "." Identifier -- alt5
    const ref = (_resolve = resolve(this, a)) == null ? void 0 : _resolve[0];
    const newContext = (_resolver$subContextF = (_resolver = resolver(this)).subContextFromRef) == null ? void 0 : _resolver$subContextF.call(_resolver, this.args.localContext, ref);
    return resolve(this, c, newContext);
  },
  CallExpression_alt4(a, b, c, d) {
    var _resolve2, _resolver$subContextF2, _resolver2;
    // CallExpression<guardYield> "[" Expression<withIn, guardYield> "]" -- alt4
    const ref = (_resolve2 = resolve(this, a)) == null ? void 0 : _resolve2[0];
    const newContext = (_resolver$subContextF2 = (_resolver2 = resolver(this)).subContextFromRef) == null ? void 0 : _resolver$subContextF2.call(_resolver2, this.args.localContext, ref);
    resolve(this, c, newContext);
    return ref;
  },
  LeftHandSideExpression(_) {
    return resolve(this, _, this.args.globalContext);
  },
  MemberExpression_alt3(a, b, c) {
    var _resolve3, _resolver$subContextF3, _resolver3;
    // MemberExpression<guardYield> "." Identifier -- alt3
    const ref = (_resolve3 = resolve(this, a)) == null ? void 0 : _resolve3[0];
    const newContext = (_resolver$subContextF3 = (_resolver3 = resolver(this)).subContextFromRef) == null ? void 0 : _resolver$subContextF3.call(_resolver3, this.args.localContext, ref);
    return resolve(this, c, newContext);
  },
  MemberExpression_alt2(a, b, c, d) {
    var _resolve4, _resolver$subContextF4, _resolver4;
    // MemberExpression<guardYield> "[" Expression<withIn, guardYield> "]" -- alt2
    const ref = (_resolve4 = resolve(this, a)) == null ? void 0 : _resolve4[0];
    const newContext = (_resolver$subContextF4 = (_resolver4 = resolver(this)).subContextFromRef) == null ? void 0 : _resolver$subContextF4.call(_resolver4, this.args.localContext, ref);
    resolve(this, c, newContext);
    return ref;
  },
  ConditionalExpression_alt2(a, b, c, d, e) {
    var _resolve5;
    // LogicalORExpression<guardIn, guardYield> "?" AssignmentExpression<withIn, guardYield> ":" AssignmentExpression<guardIn, guardYield> -- alt2
    resolve(this, a);
    const ref = (_resolve5 = resolve(this, c)) == null ? void 0 : _resolve5[0];
    resolve(this, e);
    return ref;
  },
  // TODO: here contextRef will be undefined for instance nodes!
  Identifier_alt1(_) {
    var _ref, _r$binding;
    const label = this.plain[0];
    const r = resolver(this);
    if (label === "instances") {
      const context = this.args.localContext;
      const result = r.instances(context);
      return [result];
    }
    const contextRef = (_ref = (_r$binding = r.binding(this.args.localContext, label)) != null ? _r$binding : r.attribute(this.args.localContext, label)) != null ? _ref : r.variable(this.args.localContext, label);
    return setNodeMap(this, contextRef);
  },
  Identifier_variable(a, b, c, d) {
    const label = c.plain[0];
    const contextRef = resolver(this).variable(this.args.localContext, label);
    return setNodeMap(this, contextRef);
  },
  Identifier_attribute(a, b, c, d) {
    const label = c.plain[0];
    const contextRef = resolver(this).attribute(this.args.localContext, label);
    return setNodeMap(this, contextRef);
  },
  Identifier_varId(a, b, c, d) {
    const id = c.plain[0];
    const contextRef = resolver(this).varId(this.args.localContext, id);
    return setNodeMap(this, contextRef);
  },
  Identifier_attrId(a, b, c, d) {
    const id = c.plain[0];
    const contextRef = resolver(this).attrId(this.args.localContext, id);
    return setNodeMap(this, contextRef);
  },
  _iter(...children) {
    return children.map(c => resolve(this, c)).flat();
  },
  _nonterminal(...children) {
    return children.map(c => resolve(this, c)).flat();
  },
  _terminal() {
    return [];
  }
})
// ######################################################################################
// gibt den Inhalt des Nodes als String oder Zahl zurück
.addAttribute("plain", {
  stringLiteral(_) {
    return [this.sourceString.substring(1, this.sourceString.length - 1)];
  },
  decimalIntegerLiteral(_) {
    return [parseInt(this.sourceString, 10)];
  },
  Identifier_alt1(_) {
    return [this.sourceString];
  },
  _iter(...children) {
    return children.map(c => c.plain).flat();
  },
  _nonterminal(...children) {
    return children.map(c => c.plain).flat();
  },
  _terminal() {
    return [];
  }
})
// ######################################################################################
// gibt bei einer Argumentliste das Array der Argument-Nodes zurück
.addAttribute("arguments", {
  CallExpression(_) {
    return [];
  },
  _iter(...children) {
    return children.map(c => c.arguments).flat();
  },
  _nonterminal(...children) {
    if (/ArgumentList_.*/.test(this._node.ruleName)) {
      return children.filter(n => n._node.ruleName !== undefined);
    }
    return children.map(c => c.arguments).flat();
  },
  _terminal() {
    return [];
  }
})
// ######################################################################################
// gibt [{body,parameters}] zu einer Arrow-Funktion zurück
.addAttribute("arrowFunction", {
  ArrowFunction_alt1(parameter, arrow, body) {
    return [{
      parameter,
      body
    }];
  },
  BindingIdentifier_alt1(_) {
    return _.plain;
  },
  _iter(...children) {
    return children.map(c => c.arrowFunction).flat();
  },
  _nonterminal(...children) {
    return children.map(c => c.arrowFunction).flat();
  },
  _terminal() {
    return [];
  }
});
function validate(expressionString) {
  const match = jsExpressionGrammar.match(expressionString);
  if (match.failed()) {
    throw new Error(match.message);
  }
}
/**
 * Erzeugt einen Replacer, der einzelne Nodes einer Expression ersetzen kann,
 * das Besondere: Whitespaces bleiben erhalten, daher so und nicht per gejointen
 * Semantic-Rückgabewerten, was eher ein Pretty-Printer wäre
 */
function createReplacer(expressionString) {
  let lastIndex = 0;
  let newExpression = "";
  const consume = index => {
    newExpression += expressionString.substring(lastIndex, index);
    lastIndex = index;
  };
  const consumeAll = () => consume(expressionString.length);
  const append = string => newExpression += string;
  const skip = index => lastIndex = index;
  const replace = (node, replacement) => {
    consume(node.source.startIdx);
    append(replacement);
    skip(node.source.endIdx);
  };
  const end = () => {
    consumeAll();
    return newExpression;
  };
  return {
    replace,
    end
  };
}
var ContextRefType;
(function (ContextRefType) {
  ContextRefType[ContextRefType["Variable"] = 0] = "Variable";
  ContextRefType[ContextRefType["Attribute"] = 1] = "Attribute";
})(ContextRefType || (ContextRefType = {}));
function createGlobalContext(variables) {
  return {
    bindings: {},
    localVariables: variables.filter(v => v.parentId == null),
    contextVariable: null,
    allVariables: variables
  };
}
const contextResolver = {
  // TODO: Searching by label might become a problem real fast if we have
  // multiple variables with the same label...
  variable(context, label) {
    return resolveVariable(context, v => v.label === label);
  },
  // TODO: Same as above
  attribute(context, label) {
    return resolveAttribute(context, a => a.label[i18n.language] === label);
  },
  instances(context) {
    return resolveInstances(context);
  },
  varId(context, id) {
    return resolveVariable(context, v => v.id == id);
  },
  attrId(context, id) {
    return resolveAttribute(context, a => a.id == id);
  },
  binding(context, identifier) {
    return context.bindings[identifier];
  },
  subContextWithBinding(context, name, ref) {
    return Object.assign({}, context, {
      bindings: Object.assign({}, context.bindings, {
        [name]: Object.assign({}, ref, {
          binding: true
        })
      })
    });
  },
  subContextFromRef(context, ref) {
    if ((ref == null ? void 0 : ref.type) === ContextRefType.Variable) {
      return Object.assign({}, context, {
        contextVariable: ref.variable,
        localVariables: context == null ? void 0 : context.allVariables.filter(v => v.parentId == ref.variable.id)
      });
    }
    if ((ref == null ? void 0 : ref.type) === ContextRefType.Attribute) {
      return Object.assign({}, context, {
        contextVariable: null,
        localVariables: []
      });
    }
    return undefined;
  }
};
/**
 * Ersetzt in einer Expression alle Variablen und Attribute mittels einer mapper-Funktion
 */
function replaceVariablesAndAttributes(expressionString, resolver, mapper, globalContext) {
  const match = jsExpressionGrammar.match(expressionString);
  if (match.failed()) {
    return expressionString;
  }
  const nodeToRefMap = new Map();
  const semantics = jsExpressionSemantics(match);
  semantics.resolve(resolver, nodeToRefMap, globalContext, globalContext);
  const replacer = createReplacer(expressionString);
  semantics.replace(replacer, resolver, nodeToRefMap, mapper);
  return replacer.end();
}
/**
 * formattiert ein Label entweder als variable('label') oder einfach nur als label, je nachdem, ob label ein
 * zulässiger identifier ist
 * @param accessor
 * @param label
 */
function formatLabel(accessor, label) {
  return (label == null ? void 0 : label.indexOf(" ")) === -1 && !forbiddenIdentifiers.has(label) ? label : `${accessor}('${label}')`;
}
const formatAsId = contextRef => {
  var _contextRef$attr;
  switch (contextRef == null ? void 0 : contextRef.type) {
    case ContextRefType.Variable:
      return `varId(${contextRef.variable.id})`;
    case ContextRefType.Attribute:
      return `attrId('${contextRef == null ? void 0 : (_contextRef$attr = contextRef.attr) == null ? void 0 : _contextRef$attr.id}')`;
  }
};
const formatAsLabel = contextRef => {
  var _contextRef$attr$labe, _contextRef$attr2;
  switch (contextRef == null ? void 0 : contextRef.type) {
    case ContextRefType.Variable:
      return formatLabel("variable", contextRef.variable.label);
    case ContextRefType.Attribute:
      return formatLabel("attribute", (_contextRef$attr$labe = contextRef == null ? void 0 : (_contextRef$attr2 = contextRef.attr) == null ? void 0 : _contextRef$attr2.label[i18n.language]) != null ? _contextRef$attr$labe : "");
  }
};
function resolveVariable(context, predicate) {
  const filteredVariables = context.contextVariable ? context.localVariables.filter(v => {
    var _context$contextVaria;
    return v.parentId == (context == null ? void 0 : (_context$contextVaria = context.contextVariable) == null ? void 0 : _context$contextVaria.id);
  }) : context.localVariables;
  const variable = filteredVariables.find(predicate);
  return variable == null ? undefined : {
    binding: false,
    type: ContextRefType.Variable,
    variable
  };
}
function resolveAttribute(context, predicate) {
  var _variable$attrs;
  const variable = context.contextVariable;
  if (variable == null) {
    return undefined;
  }
  const attr = variable == null ? void 0 : (_variable$attrs = variable.attrs) == null ? void 0 : _variable$attrs.find(predicate);
  return attr == null ? undefined : {
    binding: false,
    type: ContextRefType.Attribute,
    variable,
    attr
  };
}
function resolveInstances(context) {
  const variable = context.contextVariable;
  const result = variable == null ? undefined : {
    binding: false,
    type: ContextRefType.Variable,
    variable
  };
  return result;
}
/**
 * Ersetzt in einer Expression alle Labels durch Ids, d.h. anzeigbare zu persistierbare und ausführbare Expression
 */
function labelsToId(expression = "", variables) {
  return replaceVariablesAndAttributes(expression, contextResolver, formatAsId, createGlobalContext(variables));
}
/**
 * Ersetzt in einer Expression alle Ids durch Labels, d.h. persistierbare zu anzeigbare Expression
 */
function idsToLabels(expression = "", variables) {
  return replaceVariablesAndAttributes(expression, contextResolver, formatAsLabel, createGlobalContext(variables));
}
/**
 * sortiert die Variablen nach ihren Abhängigkeiten (der expressions).
 * Die Variablen können fehlerfrei in der zurückgegebenen Reihenfolge evaluiert werden.
 * Wirft einen Error, falls es einen Zyklus gibt.
 */
function topologicalSortVariables(variables) {
  const dependenciesMap = new Map();
  const idToNode = new Map();
  variables.forEach(v => idToNode.set(v.id, v));
  const getDependencies = v => getReferencedVariableIds(expression(v)).map(id => idToNode.get(id)).filter(v => v != null);
  variables.forEach(v => dependenciesMap.set(v, getDependencies(v)));
  try {
    return topologicalSort(variables, v => dependenciesMap.get(v), v => !getTemplateOptions(v).suppressCycleDetection);
  } catch (e) {
    if (e instanceof Set) {
      const cycle = Array.from(e);
      const label = variable => variable == null ? void 0 : variable.label;
      const cycleText = cycle.concat(first$1(cycle)).map(label).join(" -> ");
      throw cycleError(cycleText);
    }
  }
}
function getReferencedVariableIds(expression) {
  const idPattern = /\bvarId\s*\((\s*[0-9]+\s*)\)/g;
  return [...expression.matchAll(idPattern)].map(match => parseInt(match[1], 0));
}
const forbiddenIdentifiers = new Set(["attribute", "attrId", "variable", "async", "await", "break", "case", "catch", "class", "console", "const", "continue", "debugger", "default", "delete", "do", "document", "else", "enum", "export", "extends", "finally", "for", "function", "if", "implements", "import", "in", "interface", "let", "new", "package", "private", "protected", "public", "return", "self", "super", "switch", "this", "throw", "try", "var", "varId", "void", "while", "window", "with", "yield"]);
// diente zum Verstehen der Semantiks
// export function rebuildOriginalString(expressionString) {
//   const semantics = jsExpressionGrammar.createSemantics().addAttribute('same', {
//     stringLiteral(_) {
//       return [this.sourceString.substring(1, this.sourceString.length - 1)];
//     },
//     decimalIntegerLiteral(_) {
//       return [parseInt(this.sourceString, 10)];
//     },
//     Identifier(_) {
//       return [this.sourceString];
//     },
//     _iter(...children) {
//       return children.map((c) => c.same).flat();
//     },
//     _nonterminal(...children) {
//       return children.map((c) => c.same).flat();
//     },
//     _terminal() {
//       return [this.sourceString];
//     },
//   });
//   const match = jsExpressionGrammar.match(expressionString);
//   return semantics(match).same.join('');
// }

function createEvalContext(variables, values, selections) {
  const mutatedSelections = cloneCalculatedSelectionsAndCopyRest(variables, selections);
  return {
    variables,
    values,
    selections: mutatedSelections,
    variable: null,
    selectionsOfVariable: [],
    allSelections: mutatedSelections,
    anchoringSelection: rootSelection
  };
}
function createAvailableFunctionsAndConstants(context) {
  return Object.assign({
    varId(id) {
      return createAProxyToHandle_VarId(context, id);
    },
    id(id) {
      return createAProxyToHandle_VarId(context, id);
    },
    attrId(id) {
      return evalContextResolver.attrId(context, id);
    }
  }, staticContext);
}
const evalContextResolver = {
  varId(context, variableId) {
    {
      assertNotNull(context, "varId", "context");
      assertNotNull(variableId, "varId", "id");
    }
    const selectionsOfVariable = context.selections.filter(isSelectionOfVariable(context, variableId)).sort(sortBySort);
    const variable = context.variables.find(s => s.id == variableId);
    if (variable == null) {
      throw noVariableError("variableId " + variableId);
    }
    if ((selectionsOfVariable == null || selectionsOfVariable.length === 0) && variable.type !== VariableType.Components) {
      throw noSelectionError("variable " + variable.label);
    }
    return Object.assign({}, context, {
      variable,
      selectionsOfVariable
    });
  },
  attrId(context, id) {
    var _value$attrs;
    {
      assertNotNull(context, "attrId", "context");
      assertNotNull(id, "attrId", "id");
      if (context.selectionsOfVariable == null || context.selectionsOfVariable.length === 0) {
        var _context$variable;
        throw noSelectionError("variable " + ((_context$variable = context.variable) == null ? void 0 : _context$variable.label));
      }
      if (context.selectionsOfVariable.length > 1) {
        var _context$variable2;
        // Is selectionsOfVariable even meant to be more than one? Only in the case
        // of component variables?
        throw moreThanOneSelectionError("variable " + ((_context$variable2 = context.variable) == null ? void 0 : _context$variable2.label));
      }
    }
    // TODO I guess we should take care that the first contextSelection is the
    // right one...?
    const selection = context.selectionsOfVariable[0];
    assertNotNull(selection, "attrId", "context.selectionsOfVariable[0]");
    const valueId = selection.valueId;
    if (valueId == null) {
      var _context$variable3;
      throw noAttributeError("variable " + ((_context$variable3 = context.variable) == null ? void 0 : _context$variable3.label) + " attributeId " + id);
    }
    const value = context.values.find(v => v.id == valueId);
    assertNotNull(valueId, "attrId", "value is null for context.selectionsOfVariable[0].valueId");
    const attributeValue = value == null ? void 0 : (_value$attrs = value.attrs) == null ? void 0 : _value$attrs.find(a => a.attrId == id);
    if (attributeValue == null) {
      var _context$variable4;
      throw noAttributeError("variable " + ((_context$variable4 = context.variable) == null ? void 0 : _context$variable4.label) + " attributeId " + id);
    }
    const primitiveValue = attributeValue == null ? void 0 : attributeValue.value;
    if (primitiveValue == null) {
      return null;
    }
    const contextVariable = context.variables.find(s => s.id == selection.variableId);
    assertNotNull(context, "attrId", "contextVariable");
    const attributeDefintion = contextVariable.attrs.find(a => a.id == id);
    assertNotNull(context, "attrId", "attr");
    if (attributeDefintion.type === "symbol") {
      throw new Error("type symbol is not implemented yet in expression engine for attribute " + attributeDefintion.label[i18n.language]);
    }
    if (typeof primitiveValue !== attributeDefintion.type) {
      throw new Error("internal type mismatch: attribute definition for " + attributeDefintion.label[i18n.language] + " is of type " + attributeDefintion.type + " but primitive value is of type " + typeof primitiveValue);
    }
    return primitiveValue;
  },
  instances(context) {
    const variable = context.variable;
    const variableSelections = context.selectionsOfVariable;
    if (variable == null) {
      throw new Error("Variable is null");
    }
    if (variableSelections.length === 0) {
      throw new Error(`No selections for variable ${variable == null ? void 0 : variable.label}`);
    }
    if (!isVariableAParentOfTheAnchoringSelection(context, variable.id)) {
      throw new Error(`Variable ${variable == null ? void 0 : variable.label} is not a parent of the anchoring selection.`);
    }
    const instanceSelection = variableSelections[0];
    const siblings = context.allSelections.filter(s => s.variableId === (instanceSelection == null ? void 0 : instanceSelection.variableId) && s.instance.belongsToInstanceId === (instanceSelection == null ? void 0 : instanceSelection.instance.belongsToInstanceId)).sort(sortBySort);
    return createComponentArrayProxy(Object.assign({}, context, {
      selections: context.allSelections,
      selectionsOfVariable: siblings
    }));
  },
  instanceIndex(context) {
    const variable = context.variable;
    const variableSelections = context.selectionsOfVariable;
    if (variable == null) {
      throw new Error("Variable is null");
    }
    if (variableSelections.length === 0) {
      throw new Error(`No selections for variable ${variable == null ? void 0 : variable.label}`);
    }
    if (variableSelections.length > 1) {
      throw new Error(`More than one selection for variable ${variable == null ? void 0 : variable.label}, cant determine instance index.`);
    }
    const currentSelection = variableSelections[0];
    let instanceSelection;
    if (isSimpleSelection(currentSelection)) {
      if (currentSelection.instance.id === rootSelection.id) {
        return 0;
      }
      instanceSelection = getParentSelection(context.selections, currentSelection);
    } else {
      instanceSelection = currentSelection;
    }
    const siblings = context.allSelections.filter(s => {
      var _instanceSelection, _instanceSelection2;
      return s.variableId === ((_instanceSelection = instanceSelection) == null ? void 0 : _instanceSelection.variableId) && s.instance.belongsToInstanceId === ((_instanceSelection2 = instanceSelection) == null ? void 0 : _instanceSelection2.instance.belongsToInstanceId);
    }).sort(sortBySort);
    const index = siblings.findIndex(s => s.id === currentSelection.instance.id);
    return index;
  },
  getInputValue(context) {
    var _context$selectionsOf, _context$selectionsOf2;
    assertNotNull(context, "value", "context");
    return context.selectionsOfVariable == null || context.selectionsOfVariable.length === 0 ? null : (_context$selectionsOf = context.selectionsOfVariable[0]) == null ? void 0 : (_context$selectionsOf2 = _context$selectionsOf.data) == null ? void 0 : _context$selectionsOf2.inputValue;
  },
  isContextVariableAComponentVariable(context) {
    var _context$variable5;
    return ((_context$variable5 = context.variable) == null ? void 0 : _context$variable5.type) === VariableType.Components;
  },
  splitContextIntoMultipleSubContexts(context) {
    const result = context.selectionsOfVariable.map(selection => Object.assign({}, context, {
      selections: filterAllSelectionsInHierarchy(context.selections, selection),
      selectionsOfVariable: [selection],
      anchoringSelection: selection
    }));
    return result;
  }
};
function isSelectionOfVariable(context, variableId) {
  // In which cases do we have multiple selections of a variable?
  // 1. In the case of a component variable, where we have multiple instances
  //   of the component.
  // 2. In the case of a variable that is part of a component variable, where we
  // have multiple instances of the component and therefore multiple selections
  // of the variable.
  if (context.selectionsOfVariable.length > 0) {
    const selectionIds = new Set(context.selectionsOfVariable.map(s => s.id));
    return s => s.variableId == variableId && selectionIds.has(getParentSelectionId(s));
  }
  return s => s.variableId == variableId;
}
function createProxy(target) {
  return new Proxy(target, proxyHandler);
}
const proxyHandler = {
  get(target, prop) {
    if (prop === Symbol.toPrimitive || prop === "valueOf") {
      return type => evalContextResolver.getInputValue(target);
    }
    if (prop === "varId") {
      return variableId => createAProxyToHandle_VarId(target, variableId);
    }
    if (prop === "attrId") {
      return attributeId => evalContextResolver.attrId(target, attributeId);
    }
    if (prop === "instances") {
      return evalContextResolver.instances(target);
    }
    if (prop === "instanceIndex") {
      return evalContextResolver.instanceIndex(target);
    }
    if (prop === Symbol.toStringTag) {
      return Object.prototype.toString.call(evalContextResolver.getInputValue(target));
    }
    if (typeof prop === "symbol") {
      throw new Error(`unknown property of type symbol`);
    }
    throw new Error(`unknown property ${prop} context: ${target}`);
  }
};
const createComponentArrayProxy = context => {
  const componentProxies = evalContextResolver.splitContextIntoMultipleSubContexts(context).map(c => createProxy(c));
  const hintThatArrayAccessorIsMissing = () => {
    var _context$variable6;
    throw arrayAccessNeededError((_context$variable6 = context.variable) == null ? void 0 : _context$variable6.label);
  };
  return new Proxy(componentProxies, {
    get(target, prop, receiver) {
      if (typeof prop === "string") {
        if (/^(varId|attrId)$/g.test(prop)) {
          return hintThatArrayAccessorIsMissing;
        }
        if (prop === "instanceIndex") {
          return hintThatArrayAccessorIsMissing();
        }
        const index = parseInt(prop, 10);
        if (index < 0 || index >= componentProxies.length) {
          var _context$variable7;
          throw noSelectionError("variable " + ((_context$variable7 = context.variable) == null ? void 0 : _context$variable7.label) + ", index=" + index);
        }
      }
      return Reflect.get(target, prop, receiver);
    }
  });
};
function createAProxyToHandle_VarId(context, variableId) {
  const newContext = evalContextResolver.varId(context, variableId);
  if (evalContextResolver.isContextVariableAComponentVariable(newContext)) {
    if (newContext.selectionsOfVariable.length === 1) {
      // If we have a single selection of a component variable and the variable
      // is a parent of the anchoring selection, we treat it as a normal
      // variable. Since there is no possibility that we have multiple
      // selections to deal with in the hierarchy at his point.
      if (isVariableAParentOfTheAnchoringSelection(newContext, variableId)) {
        return createProxy(newContext);
      }
    }
    // Otherwise we return an array of proxies for each selection of the
    // variable. And the user has to define an index to get the value of the
    // respective selection.
    return createComponentArrayProxy(newContext);
  } else {
    return createProxy(newContext);
  }
}
const functionKeywords = [
// TODO this might be deprecated but I am not sure - CL
"id", ...Object.keys(evalContextResolver), ...Object.keys(staticContext)];
const compileExpression = memoize(expression => {
  validate(expression);
  const expressionSafe = isEmpty(expression) ? "undefined" : expression;
  const fnBody = `
      const { ${functionKeywords.filter(funcKey => expression.match(new RegExp(`\\b${funcKey}\\b`))).join(", ")} } = availableFunctions;
      const result = ${expressionSafe};
      return result?.valueOf();
  `;
  // eslint-disable-next-line no-new-func
  const compiledExpression = new Function("availableFunctions", fnBody);
  return availableFunctions => assertNumberOrNull(compiledExpression(availableFunctions));
});
const findParentVariableIds = (variables, variableId) => {
  const variablesById = indexById(variables);
  const parentVariablesIds = [];
  let currentVariable = variablesById[variableId];
  while (currentVariable && currentVariable.parentId != null) {
    const parentVariable = variablesById[currentVariable.parentId];
    if (parentVariable) {
      parentVariablesIds.push(parentVariable.id);
    }
    currentVariable = parentVariable;
  }
  parentVariablesIds.push(rootSelection.variableId);
  return parentVariablesIds;
};
function isVariableAParentOfTheAnchoringSelection(newContext, variableId) {
  const parentVariablesIds = findParentVariableIds(newContext.variables, newContext == null ? void 0 : newContext.anchoringSelection.variableId);
  if (newContext != null && newContext.anchoringSelection.instance.isInstanceLauncher) parentVariablesIds.push(newContext == null ? void 0 : newContext.anchoringSelection.variableId);
  const isVariableAParent = parentVariablesIds.find(parentId => parentId === variableId);
  return isVariableAParent;
}
/**
 * Wertet eine einzige Variable aus und gibt den Zahlenwert zurück.
 * Die Compilierung erfolgt dabei memoized und lazy intern.
 * Ist nach außen eine fast pure Funktion, denn es können Exceptions auftreten, falls die Compilierung
 * oder Evaluation fehlschlägt.
 * @param variables
 * @param values
 * @param selections
 * @param variable
 */
function evaluateSingleVariable(variables, values, selections, variable) {
  const variablesInContext = variables.filter(v => v.id !== variable.id).concat([variable]);
  try {
    var _selection$data$input, _selection$data, _selection$data2;
    const newSelections = evaluateCalculatedVariables(variablesInContext, values, selections);
    const selection = newSelections.find(s => s.variableId == variable.id);
    return {
      result: (_selection$data$input = selection == null ? void 0 : (_selection$data = selection.data) == null ? void 0 : _selection$data.inputValue) != null ? _selection$data$input : 0,
      errorMessage: selection == null ? void 0 : (_selection$data2 = selection.data) == null ? void 0 : _selection$data2.errorMessage
    };
  } catch (e) {
    return {
      result: 0,
      errorMessage: e.message
    };
  }
}
/**
 * Wertet alle calculated Variables aus und gibt das Ergebnis als Teil der Gesamtmenge aller Selections zurück.
 * Die Compilierung erfolgt dabei memoized und lazy intern.
 * Ist nach außen eine fast pure Funktion, denn es können Exceptions auftreten, falls die Compilierung
 * oder Evaluation fehlschlägt.
 * @param variables
 * @param values
 * @param selections
 */
function evaluateCalculatedVariables(variables, values, selections) {
  var _topologicalSortVaria;
  const globalEvalContext = createEvalContext(variables, values, selections);
  (_topologicalSortVaria = topologicalSortVariables(variables.filter(calculated))) == null ? void 0 : _topologicalSortVaria.forEach(calculatedVariable => evaluateCalculatedVariable(globalEvalContext, values, calculatedVariable));
  return globalEvalContext.selections;
}
function evaluateCalculatedVariable(globalEvalContext, values, calculatedVariable) {
  const expressionString = expression(calculatedVariable);
  const selectionsOfVariable = globalEvalContext.selections.filter(s => s.variableId == calculatedVariable.id);
  if (selectionsOfVariable.length == 0) {
    return;
  }
  const validValues = values.filter(value => value.variableId == calculatedVariable.id);
  selectionsOfVariable.forEach(selection => {
    var _selection$data3;
    selection.data = (_selection$data3 = selection.data) != null ? _selection$data3 : {};
    const availableFunctions = createAvailableFunctionsAndConstants(Object.assign({}, globalEvalContext, {
      selections: filterAllSelectionsInHierarchy(globalEvalContext.selections, selection),
      anchoringSelection: selection
    }));
    try {
      const evalExpression = compileExpression(expressionString);
      const inputValue = evalExpression(availableFunctions);
      selection.data.inputValue = inputValue != null ? inputValue : 0;
      const match = findClosestValue(inputValue, validValues, getMinimumDeviation(calculatedVariable));
      if (match) {
        selection.valueId = match.value.id;
        selection.data.inputValue = match.input;
        selection.interval = match.value.data;
      }
    } catch (e) {
      if (e instanceof Error) selection.data.errorMessage = e.message;
    }
  });
}
/**
 * ACHTUNG: Verlässt sich darauf das alle Variablen bereits durch
 * evaluateCalculatedVariables ausgewertet wurden.
 * Wertet eine Expression aus und gibt den Zahlenwert zurück.
 * Die Compilierung erfolgt dabei memoized und lazy intern.
 * Ist nach außen eine fast pure Funktion, denn es können Exceptions auftreten,
 * falls die Compilierung oder Evaluation fehlschlägt.
 * @param variables
 * @param values
 * @param selections
 * @param expression
 */
function evaluateExpression(variables, values, selections, expression, anchoringSelection = rootSelection) {
  const evalContext = createEvalContext(variables, values, selections);
  const context = Object.assign({}, evalContext, {
    selections: filterAllSelectionsInHierarchy(evalContext.selections, anchoringSelection),
    anchoringSelection: anchoringSelection
  });
  const availableFunctions = createAvailableFunctionsAndConstants(context);
  try {
    const evalExpression = compileExpression(expression);
    return {
      result: evalExpression(availableFunctions)
    };
  } catch (e) {
    return {
      result: 0,
      errorMessage: e.message
    };
  }
}
function cloneCalculatedSelectionsAndCopyRest(variables, selections) {
  // clone alle selections, die potenziell mutable sind, weil sie zu einer
  // berechneten Variable gehören
  const calculatedVariableIds = new Set(variables.filter(calculated).map(v => v.id));
  return selections.map(s => calculatedVariableIds.has(s.variableId) ? Object.assign({}, s, {
    data: Object.assign({}, s.data)
  }) : s);
}

const getSidebarPosition = app => {
  var _app$layout;
  return app == null ? void 0 : (_app$layout = app.layout) == null ? void 0 : _app$layout.sidebarPosition;
};

const selectArticles = state => {
  var _state$metadata$artic;
  return (_state$metadata$artic = state.metadata.articles) != null ? _state$metadata$artic : [];
};
const selectArticlesByIdMap = createSelector(selectArticles, articles => indexById(articles));
const selectArticleById = id => state => selectArticlesByIdMap(state)[id];
const selectArticlesByAppId = curry((appId, state) => flow(selectArticles, filter(article => article.appId == appId))(state));

const selectMaterials = state => get$2(state, ["metadata", lowerCase("materials")]);
const selectMaterialById = id => state => selectMaterials(state).find(e => e.id == id);
const selectMaterialsByAppId = curry((appId, state) => flow(selectMaterials, filter(material => material.appId == appId))(state));

const isLocalBlobOrDataUrl = url => {
  const newUrl = new URL(url);
  if (newUrl.protocol === "data:" && newUrl.origin === "null") {
    return true;
  }
  // eslint-disable-next-line no-restricted-globals
  if (newUrl.protocol === "blob:" && newUrl.origin === location.origin) {
    return true;
  }
  return false;
};
/**
 * This is needed to fight this S3 vs chrome interaction:
 * https://serverfault.com/questions/856904/chrome-s3-cloudfront-no-access-control-allow-origin-header-on-initial-xhr-req/856948#856948
 */
const corsHack = url =>
// If the url is a local blob url or a data url, we cant add a query
// parameter otherwise the url is invalid.
isLocalBlobOrDataUrl(url) ? url : url + "?x-request=html";

function getNodeByName(nodeName, layer) {
  return layer.findOne(node => node.attrs.name === nodeName);
}
const md = new MobileDetect(window.navigator.userAgent);
const createKonvaStage = (imageWidth, imageHeight, container) => {
  const isMobile = md.mobile();
  let width = imageWidth != null ? imageWidth : isMobile ? 256 : 1024;
  let height = imageHeight != null ? imageHeight : isMobile ? 256 : 1024;
  /** Scale up to low resolutions. We want to have at least 200px */
  const min = Math.min(width, height);
  if (min < 200) {
    // use only natural numbers. This will result in a factor of 2 for 199 pixels,
    // and an end resolution of 398. Maybe to aggressive? But I want to avoid rounding when possible.
    const fac = Math.ceil(200 / min);
    width *= fac;
    height *= fac;
  }
  /** Scale down if too big, max 2048, to reduce performance hits */
  const maximumPixels = 2048;
  const max = Math.max(width, height);
  if (max > maximumPixels) {
    const fac = max / maximumPixels;
    width /= fac;
    height /= fac;
  }
  try {
    const stage = new Konva.Stage({
      container: container,
      width: width,
      height: height,
      scale: {
        x: 1,
        y: 1
      }
    });
    stage.listening(false);
    return stage;
  } catch (e) {
    throw new Error("Print-Designer Error: Out-of-memory in Safari?");
  }
};
const printLayerName = "print-layer";
const printImageName = "print-image";
const originalImageName = "original-image";
const backgroundName = "background";
function setupLayer(stage) {
  var _stage$getLayers;
  let layer = stage == null ? void 0 : (_stage$getLayers = stage.getLayers()) == null ? void 0 : _stage$getLayers.find(l => l.attrs.name === printLayerName);
  if (!layer) {
    layer = new Konva.Layer({
      name: printLayerName,
      imageSmoothingEnabled: true
    });
    const isMobile = md.mobile();
    if (isMobile) {
      const canvas = layer.getCanvas();
      // Reduce pixel ratio to reduce memory usage. We dont need a high quality
      // texture on mobile since we are showing the texture in a 3d scene, which
      // means it is not showing at the full resolution most of the time anyway.
      const pixelRatio = Math.min(1.5, canvas.getPixelRatio());
      canvas.setPixelRatio(pixelRatio);
    }
    stage.add(layer);
  }
  // Since we dont use drag and drop or anything with a mouse, we can disable
  // listening to events.
  layer.listening(false);
  return layer;
}
function getDimensions(imageWidth, imageHeight, stage, printAction) {
  const stageWidth = stage.width();
  const stageHeight = stage.height();
  const widthRatio = stageWidth / imageWidth;
  const heightRatio = stageHeight / imageHeight;
  const bestRatio = Math.min(widthRatio, heightRatio);
  const newImageWidth = Math.round(imageWidth * bestRatio * (printAction.scale || 1.0) / 100);
  const newImageHeight = Math.round(newImageWidth * imageHeight / imageWidth);
  const x = Math.round((stageWidth - newImageWidth) * (printAction.leftright || 1.0) / 100);
  const y = Math.round((stageHeight - newImageHeight) * (printAction.topbottom || 1.0) / 100);
  return {
    stageWidth,
    stageHeight,
    x,
    y,
    newImageWidth,
    newImageHeight
  };
}
function setupBackgroundColor(layer, originalMaterial, stageWidth, stageHeight) {
  if (originalMaterial != null && originalMaterial.color) {
    const backgroundNode = getNodeByName(backgroundName, layer);
    if (backgroundNode) {
      backgroundNode.fill("#" + originalMaterial.color.getHexString());
    } else {
      const background = new Konva.Rect({
        name: backgroundName,
        x: 0,
        y: 0,
        width: stageWidth,
        height: stageHeight,
        fill: "#" + originalMaterial.color.getHexString(),
        listening: false
      });
      layer.add(background);
    }
  }
}
function setupOriginalMapAsBackground(layer, originalMaterial, stageWidth, stageHeight) {
  if (!originalMaterial.map) return;
  const backgroundNode = getNodeByName(originalImageName, layer);
  if (backgroundNode) {
    if (backgroundNode.attrs.uuid !== originalMaterial.map.image.uuid) {
      backgroundNode.image(originalMaterial.map.image);
    }
    backgroundNode.width(stageWidth);
    backgroundNode.height(stageHeight);
  } else {
    const konvaImage = new Konva.Image({
      name: originalImageName,
      image: originalMaterial.map.image,
      uuid: originalMaterial.map.image.uuid,
      x: 0,
      y: 0,
      width: stageWidth,
      height: stageHeight
    });
    layer.add(konvaImage);
  }
}
function setupImage(layer, printAction, newImageWidth, newImageHeight, x, y, image) {
  const printImageNode = getNodeByName(printImageName, layer);
  const scaleX = newImageWidth / image.width;
  const scaleY = newImageHeight / image.height;
  if (printImageNode && printImageNode.attrs.url === printAction.materialUrl) {
    printImageNode.scaleX(scaleX);
    printImageNode.scaleY(scaleY);
    printImageNode.x(x);
    printImageNode.y(y);
  } else {
    if (printImageNode) {
      printImageNode.destroy();
    }
    const printImage = new Konva.Image({
      name: printImageName,
      url: printAction.materialUrl,
      image,
      x,
      y,
      width: image.width,
      height: image.height,
      scaleX,
      scaleY,
      draggable: false,
      perfectDrawEnabled: false
    });
    layer.add(printImage);
  }
}
const drawImage = (stage, image, printAction, originalMaterial) => {
  var _originalMaterial$map;
  const layer = setupLayer(stage);
  const {
    stageWidth,
    stageHeight,
    x,
    y,
    newImageWidth,
    newImageHeight
  } = getDimensions(image.width, image.height, stage, printAction);
  setupBackgroundColor(layer, originalMaterial, stageWidth, stageHeight);
  if (originalMaterial != null && (_originalMaterial$map = originalMaterial.map) != null && _originalMaterial$map.image && !printAction.hideOriginalMapWhenPrinting) {
    setupOriginalMapAsBackground(layer, originalMaterial, stageWidth, stageHeight);
  }
  setupImage(layer, printAction, newImageWidth, newImageHeight, x, y, image);
  layer.draw();
  stage.draw();
};

function useApplyImageActionsToMaterials(setUpdatedMaterials, defaultMaterials, materials, printActions, modelAction, modelId) {
  useEffect(() => {
    const asyncCreateCanvasMaterials = async () => {
      const updatedMaterials = !modelId ? materials : await calcDruckdesignerMaterials(defaultMaterials, materials, printActions, modelAction);
      setUpdatedMaterials(updatedMaterials);
    };
    asyncCreateCanvasMaterials();
  }, [defaultMaterials, materials, modelAction, modelId, printActions, setUpdatedMaterials]);
}
async function calcDruckdesignerMaterials(defaultMaterials, materials, printActions, modelAction) {
  if (!modelAction) {
    return Promise.resolve(materials);
  }
  const activePrintActions = getActivePrintActions(printActions, modelAction);
  const allMaterials = Object.values(materials);
  const result = await Promise.all(activePrintActions.map(async printAction => {
    const material = allMaterials.find(m => m.name === printAction.targetMaterial);
    if (!material) {
      return Promise.resolve(undefined);
    }
    const result = await applyPrintActionToMaterial(modelAction, defaultMaterials[printAction.targetMaterial], material, printAction);
    return result;
  }, [])).then(materials => {
    var _materials$reduce;
    return (_materials$reduce = materials.reduce((acc, m) => Object.assign({}, acc, m != null ? m : {}), {})) != null ? _materials$reduce : {};
  });
  return result;
}
function isModelTargetOfPrintAction(modelAction, printAction) {
  var _modelAction$selectio;
  return ((_modelAction$selectio = modelAction.selections) != null ? _modelAction$selectio : []).every(selection => {
    var _printAction$selectio;
    return ((_printAction$selectio = printAction.selectionScope[selection.variableId]) != null ? _printAction$selectio : []).find(s => s.id === selection.id);
  });
}
function getActivePrintActions(printActions, modelAction) {
  let activePrintActions = printActions.filter(p => isModelTargetOfPrintAction(modelAction, p));
  const groupedActivePrintActions = groupBy(activePrintActions, "targetMaterial");
  const hasMultipleActionsForSameMaterial = Object.values(groupedActivePrintActions).some(printActions => printActions.length > 1);
  if (hasMultipleActionsForSameMaterial) {
    activePrintActions = Object.values(groupedActivePrintActions).map(printActions => {
      if (printActions.length === 1) {
        return printActions[0];
      }
      return getPrintActionMatchingModelSelections(printActions, modelAction);
    });
  }
  return activePrintActions;
}
function getPrintActionMatchingModelSelections(printActions, modelAction) {
  const bestMatch = printActions.reduce((acc, printAction) => {
    const intersectionCount = intersection(modelAction.selections, printAction.selections).length;
    return intersectionCount > acc.maxIntersectionCount ? {
      maxIntersectionCount: intersectionCount,
      printAction
    } : acc;
  }, {
    maxIntersectionCount: -1,
    printAction: printActions[0]
  });
  return bestMatch.printAction;
}
const konvaStageMap = new Map();
const konvaRootDivId = "konvaRoot";
const getPrintCanvases = () => {
  const konvaRoot = document.getElementById(konvaRootDivId);
  return konvaRoot == null ? void 0 : konvaRoot.childNodes;
};
async function applyPrintActionToMaterial(modelAction, defaultMaterial, material, printAction) {
  const oldMaterial = material;
  if (printAction && printAction.materialUrl && oldMaterial) {
    var _konvaDiv$firstElemen, _material$map;
    const image = new Image();
    image.crossOrigin = "anonymous";
    image.src = corsHack(printAction.materialUrl);
    await image.decode();
    const key = `imageAction:${modelAction.unique}-${material.name}`;
    let konvaRoot = document.getElementById(konvaRootDivId);
    if (!konvaRoot) {
      konvaRoot = document.createElement("div");
      konvaRoot.id = konvaRootDivId;
      document.body.appendChild(konvaRoot);
    }
    let konvaDiv = document.getElementById(key);
    if (!konvaDiv) {
      konvaDiv = document.createElement("div");
      konvaDiv.id = key;
      konvaDiv.style.display = "none";
      konvaDiv.dataset.materialName = material.name;
      konvaDiv.dataset.modelId = modelAction.modelId.toString();
      konvaRoot.appendChild(konvaDiv);
      const oldStage = konvaStageMap.get(key);
      if (oldStage) {
        konvaStageMap.delete(key);
        oldStage.destroy();
      }
    }
    let stage = konvaStageMap.get(key);
    if (!stage) {
      var _defaultMaterial$map$, _defaultMaterial$map, _defaultMaterial$map$2, _defaultMaterial$map2;
      stage = createKonvaStage((_defaultMaterial$map$ = (_defaultMaterial$map = defaultMaterial.map) == null ? void 0 : _defaultMaterial$map.image.width) != null ? _defaultMaterial$map$ : image.width, (_defaultMaterial$map$2 = (_defaultMaterial$map2 = defaultMaterial.map) == null ? void 0 : _defaultMaterial$map2.image.height) != null ? _defaultMaterial$map$2 : image.height, konvaDiv);
      konvaStageMap.set(key, stage);
    }
    drawImage(stage, image, printAction, oldMaterial);
    const newMaterial = new THREE.MeshStandardMaterial({}).copy(material);
    const canvas = (_konvaDiv$firstElemen = konvaDiv.firstElementChild) == null ? void 0 : _konvaDiv$firstElemen.firstElementChild;
    const newTexture = new THREE.CanvasTexture(canvas, THREE.UVMapping);
    newTexture.flipY = false;
    newTexture.colorSpace = (_material$map = material.map) != null && _material$map.colorSpace ? material.map.colorSpace : "srgb";
    newMaterial.color = new THREE.Color(1, 1, 1);
    newMaterial.map = newTexture;
    newTexture.needsUpdate = true;
    newMaterial.needsUpdate = true;
    const newMaterialMap = {
      [material.name]: newMaterial
    };
    return newMaterialMap;
  }
}

function calcColorManipulatedMaterials(OriginalMaterials, colorActions) {
  let colorManipulatedMaterials = {};
  if (colorActions) {
    Object.values(OriginalMaterials).forEach(material => {
      const colorAction = colorActions.find(colorManipulation => colorManipulation.targetMaterial === material.name);
      if (colorAction) {
        const newColor = new THREE.Color(colorAction.hex);
        const newMaterial = material.clone();
        newMaterial.color = newColor;
        newMaterial.needsUpdate = true;
        colorManipulatedMaterials = Object.assign({}, colorManipulatedMaterials, {
          [material.name]: newMaterial
        });
      }
    });
  }
  return colorManipulatedMaterials;
}
function useMaterialsWithAppliedColorActions(originalWithReplaced, colorActions) {
  return useMemo(() => calcColorManipulatedMaterials(originalWithReplaced, colorActions), [colorActions, originalWithReplaced]);
}

const isGlobalMaterialAction = thing => (thing == null ? void 0 : thing.isGlobalChange) === true && (thing == null ? void 0 : thing.replacementMaterialId) !== undefined && (thing == null ? void 0 : thing.targetMaterialName) !== undefined;
const isModelMaterialAction = thing => (thing == null ? void 0 : thing.targetModelId) !== undefined && (thing == null ? void 0 : thing.replacementMaterialId) !== undefined && (thing == null ? void 0 : thing.targetMaterialName) !== undefined;

function getTextureAndImage(material, uuid) {
  var _material$props$textu, _material$props$image;
  const texture = (_material$props$textu = material.props.textures) == null ? void 0 : _material$props$textu.find(texture => texture.uuid === uuid);
  const image = (_material$props$image = material.props.images) == null ? void 0 : _material$props$image.find(image => image.uuid === texture.image);
  // @ts-ignore
  return {
    texture,
    image
  };
}
async function loadMaterialWithTextures(material) {
  const loader = new THREE.MaterialLoader();
  const textureLoader = new THREE.TextureLoader();
  const objLoader = new THREE.ObjectLoader();
  const potentialTextureSlots = _$1.pick(material.props, ["alphaMap", "aoMap", "bumpMap", "clearcoatMap", "clearcoatNormalMap", "clearcoatRoughnessMap", "sheenRoughnessMap", "sheenColorMap", "displacementMap", "emissiveMap", "envMap", "lightMap", "map", "metalnessMap", "normalMap", "specularIntensityMap", "specularColorMap", "roughnessMap", "thicknessMap", "transmissionMap"]);
  const props = _$1.omit(material.props, Object.keys(potentialTextureSlots));
  props.userData = Object.assign({}, props.userData, {
    arFallbackId: material.arFallbackId
  });
  const meshMaterial = loader.parse(props);
  if (!_$1.isEmpty(potentialTextureSlots)) {
    await Promise.all(_$1.map(potentialTextureSlots, async (mapUuid, mapKey) => {
      const {
        texture,
        image
      } = getTextureAndImage(material, mapUuid);
      if (image.url) {
        return textureLoader.loadAsync(corsHack(image.url)).then(loadedTexture => {
          // Das Laden der Textur ist wirklich komisch. Aber ImageLoader und
          // ImageBitmapLoader sind für Images in Textures nicht zu
          // gebrauchen. Daher lade ich die eigentlichen Texturdaten mit dem richtigen
          // Image und verwende dann nur das Image (hinter .source).  - CL
          // @ts-ignore
          meshMaterial[mapKey] = objLoader.parseTextures([texture], {
            [texture.image]: loadedTexture.source
            // @ts-ignore
          })[texture.uuid];
          return;
        }).catch(() => {
          console.warn(`Could not load texture: ${mapKey} for material ${material.name} with id ${material.id}!`);
        });
      } else {
        return Promise.resolve();
      }
    }));
  }
  return meshMaterial;
}

function calcRelevantMaterialActions(modelId, materials, materialActions, OriginalMaterials) {
  const materialsById = indexById(Object.values(materials));
  const MaterialsByName = indexBy(m => m.name, Object.values(OriginalMaterials));
  const relevantMaterialActions = materialActions.reduce((acc, materialAction) => {
    const targetMeshMaterial = materialAction.targetMaterialName && MaterialsByName[materialAction.targetMaterialName];
    if (!targetMeshMaterial || !materialAction.replacementMaterialId) {
      return acc;
    }
    let updateAcc = false;
    if (isModelMaterialAction(materialAction) && materialAction.targetModelId === modelId) {
      var _acc$targetMeshMateri;
      const existingAction = (_acc$targetMeshMateri = acc[targetMeshMaterial.name]) == null ? void 0 : _acc$targetMeshMateri.materialAction;
      // Wenn schon eine isModelMaterialAction vorhanden ist dann wird die
      // aktuelle ignoriert. GlobalMaterialActions werden aber überschrieben
      // da ModelMaterialActions spezifischer sind.
      if (!isModelMaterialAction(existingAction)) {
        updateAcc = true;
      }
    }
    if (isGlobalMaterialAction(materialAction)) {
      var _acc$targetMeshMateri2;
      const existingAction = (_acc$targetMeshMateri2 = acc[targetMeshMaterial.name]) == null ? void 0 : _acc$targetMeshMateri2.materialAction;
      // Falls schon irgendeine Action angegeben ist für das Material dann
      // wird keine Änderung gemacht.
      if (!existingAction) {
        updateAcc = true;
      }
    }
    const replacementMaterial = materialsById[materialAction.replacementMaterialId];
    if (!replacementMaterial) {
      console.warn(`Replacement material with id ${materialAction.replacementMaterialId} not found!`);
      return acc;
    }
    return updateAcc ? Object.assign({}, acc, {
      [targetMeshMaterial.name]: {
        materialAction,
        targetMeshMaterial,
        replacementMaterial
      }
    }) : acc;
  }, {});
  return Object.values(relevantMaterialActions);
}
async function calcReplacedMaterials(modelId, OriginalMaterials = {}, materials, materialActions = []) {
  const relevantMaterialActions = calcRelevantMaterialActions(modelId, materials, materialActions, OriginalMaterials);
  const replacementMaterials = await Promise.all(relevantMaterialActions.map(async materialAction => {
    const targetMeshMaterial = materialAction.targetMeshMaterial;
    const replacementMaterial = transform({
      props: {
        name: targetMeshMaterial.name
      }
    })(materialAction.replacementMaterial);
    const replacementMeshMaterial = await loadMaterialWithTextures(replacementMaterial);
    return {
      [targetMeshMaterial.name]: replacementMeshMaterial
    };
  }));
  return replacementMaterials.reduce((acc, targetMaterialMap) => Object.assign({}, acc, targetMaterialMap), {});
}
function useMaterialsWithAppliedMaterialActions(modelId, defaultMaterialsRecord, materials, materialActions, setReplacedMaterials) {
  useEffect(() => {
    (async () => {
      const rm = !modelId ? defaultMaterialsRecord : await calcReplacedMaterials(modelId, defaultMaterialsRecord, materials, materialActions);
      setReplacedMaterials(Object.assign({}, defaultMaterialsRecord, rm));
    })();
  }, [modelId, defaultMaterialsRecord, materialActions, materials, setReplacedMaterials]);
}

function useMaterialsWithAppliedActions(defaultMaterials, modelId, modelAction) {
  const defaultMaterialsRecord = useMemo(() => defaultMaterials.reduce((acc, item) => {
    acc[item.name] = item;
    return acc;
  }, {}), [defaultMaterials]);
  const materials = useTypedSelector(selectMaterials);
  const materialActions = useTypedSelector(selectMaterialActions);
  const colorActions = useTypedSelector(selectColorActions);
  const printActions = useTypedSelector(selectPrintActions);
  const [replacedMaterials, setReplacedMaterials] = useState({});
  const [druckdesignerManipulatedMaterials, setDruckdesignerManipulatedMaterials] = useState({});
  const [printAreas, setPrintAreas] = useState([]);
  useMaterialsWithAppliedMaterialActions(modelId, defaultMaterialsRecord, materials, materialActions, setReplacedMaterials);
  const originalWithReplaced = useMemo(() => Object.assign({}, defaultMaterialsRecord, replacedMaterials), [defaultMaterialsRecord, replacedMaterials]);
  const colorManipulatedMaterials = useMaterialsWithAppliedColorActions(originalWithReplaced, colorActions);
  const updatedK3Materials = useMemo(() => Object.assign({}, defaultMaterialsRecord, replacedMaterials, colorManipulatedMaterials), [defaultMaterialsRecord, replacedMaterials, colorManipulatedMaterials]);
  useApplyImageActionsToMaterials(setDruckdesignerManipulatedMaterials, defaultMaterialsRecord, updatedK3Materials, printActions, modelAction, modelId);
  const newMaterials = Object.assign({}, defaultMaterialsRecord, replacedMaterials, colorManipulatedMaterials, druckdesignerManipulatedMaterials);
  return {
    materials: newMaterials,
    printAreas
  };
}

function useModelWithAppliedActions(modelId, defaultMaterials,
// @deprecated You dont need to pass printAreas anymore as they are created
// and registered automatically
_printAreas, modelAction) {
  const {
    materials,
    printAreas
  } = useMaterialsWithAppliedActions(defaultMaterials, modelId, modelAction);
  Object.values(materials).forEach(material => {
    material.needsUpdate = true;
  });
  return materials;
}

const significantChanges = (v1, v2, tolerance) => {
  const diff = v1.clone().sub(v2);
  const axis = [];
  if (Math.abs(diff.x) > tolerance) axis.push("x");
  if (Math.abs(diff.y) > tolerance) axis.push("y");
  if (Math.abs(diff.z) > tolerance) axis.push("z");
  return axis;
};
const checkVectorForDeviation = mode => (oldCalculatedProps, oldExpressionProps) => (key, newVec, tolerance) => {
  const totalTolerance = tolerance || (key === "rotation" ? 0.05 : 0.0001);
  const diff = significantChanges(new Vector3(...(oldCalculatedProps[key] || [0, 0, 0])), new Vector3(...newVec), totalTolerance);
  if (!diff.length) return mode === "expression" ? oldExpressionProps[key] : oldCalculatedProps[key];
  const defaultArray = mode === "expression" ? [{
    expression: "0"
  }, {
    expression: "0"
  }, {
    expression: "0"
  }] : [0, 0, 0];
  const newProps = mode === "expression" ? [...(oldExpressionProps[key] || defaultArray)] : [...(oldCalculatedProps[key] || defaultArray)];
  "xyz".split("").forEach((str, i) => {
    if (diff.includes(str)) newProps[i] = mode === "expression" ? {
      expression: newVec[i].toString()
    } : newVec[i];
  });
  return newProps;
};
const defaultRepositionApplicator = mode => (oldCalculatedProps, oldExpressionProps) => (newPosition, newRotation) => {
  const checkVector = checkVectorForDeviation(mode)(oldCalculatedProps, oldExpressionProps);
  const restProps = mode === "number" ? oldCalculatedProps : oldExpressionProps;
  const test = Object.assign({}, restProps, {
    position: checkVector("position", newPosition),
    rotation: checkVector("rotation", newRotation)
  });
  return test;
};

const _excluded$q = ["children"];
const SecondaryTitle = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$q);
  return jsx(Typography, Object.assign({}, props, {
    color: "text.secondary",
    sx: {
      mb: 0
    },
    children: children
  }));
};

const ClickInsideOutside = props => {
  useEffect(() => {
    const element = props.targetRef.current;
    const touchAway = e => {
      const bounds = element.getBoundingClientRect();
      if (e.touches[0].clientX < bounds.left || e.touches[0].clientX > bounds.right || e.touches[0].clientY < bounds.top || e.touches[0].clientY > bounds.bottom) {
        props.onClickAway(e);
      }
    };
    const clickAway = e => {
      const bounds = element.getBoundingClientRect();
      if (e.clientX < bounds.left || e.clientX > bounds.right || e.clientY < bounds.top || e.clientY > bounds.bottom) {
        props.onClickAway(e);
      }
    };
    const clickInside = e => {
      const bounds = element.getBoundingClientRect();
      if (e.clientX > bounds.left && e.clientX < bounds.right && e.clientY > bounds.top && e.clientY < bounds.bottom) {
        props.onClickInside(e);
      }
    };
    const touchInside = e => {
      const bounds = element.getBoundingClientRect();
      if (e.touches[0].clientX > bounds.left && e.touches[0].clientX < bounds.right && e.touches[0].clientY > bounds.top && e.touches[0].clientY < bounds.bottom) {
        props.onClickInside(e);
      }
    };
    if (element) {
      props.onClickAway && window.addEventListener("click", clickAway);
      props.onClickAway && window.addEventListener("touchstart", touchAway);
      props.onClickInside && element.addEventListener("click", clickInside);
      props.onClickInside && element.addEventListener("touchstart", touchInside);
    }
    return () => {
      window.removeEventListener("click", clickAway);
      window.removeEventListener("touchstart", touchAway);
      element.removeEventListener("click", clickInside);
      element.removeEventListener("touchstart", touchInside);
    };
  }, [props.onClickAway, props.onClickInside, props.targetRef]);
  return jsx(Fragment, {
    children: props.children
  });
};

const UnfoldableContent = props => {
  return jsxs(Fragment, {
    children: [props.children, jsx(Collapse, {
      in: props.showUnfoldContent,
      children: jsxs(Fragment, {
        children: [props.divider && jsx(Divider, {}), props.unfoldContent]
      })
    })]
  });
};
const Unfoldable = props => {
  const ref = useRef(null);
  return jsxs(Fragment, {
    children: [(props.showUnfoldContent || props.alwaysShowContour) && jsx(ClickInsideOutside, {
      targetRef: ref,
      onClickAway: props.onClickAway,
      onClickInside: props.onClickInside,
      children: jsx(Stack, {
        sx: {
          ml: -2
        },
        children: jsx(Paper, {
          "data-cy": "variableContainer_",
          elevation: props.showUnfoldContent || props.alwaysShowContour ? 4 : 0,
          sx: {
            pt: 0,
            pb: 2,
            pl: 2,
            pr: 2,
            transition: "all 0.3s"
          },
          ref: ref,
          children: jsx(UnfoldableContent, Object.assign({}, props))
        })
      })
    }), !props.showUnfoldContent && !props.alwaysShowContour && props.children]
  });
};

const UnfoldableTextField = props => {
  var _props$InputProps;
  const [advancedSettings, setAdvancedSettings] = useState(false);
  useEffect(() => {
    if (props.hideAdvancedSettings) setAdvancedSettings(false);
  }, [props.hideAdvancedSettings]);
  return jsx(Unfoldable, {
    unfoldContent: props.advancedSettings,
    onClickAway: () => setAdvancedSettings(false),
    showUnfoldContent: !props.hideAdvancedSettings && advancedSettings,
    children: jsx(TextField, Object.assign({}, props, {
      InputProps: Object.assign({}, props.InputProps, !props.hideAdvancedSettings && {
        endAdornment: jsxs(Fragment, {
          children: [(_props$InputProps = props.InputProps) == null ? void 0 : _props$InputProps.endAdornment, jsx(InputAdornment, {
            position: "end",
            children: jsx(IconButton, {
              "data-cy": "advanceedSettingsButton",
              size: "small",
              onClick: () => {
                setAdvancedSettings(!advancedSettings);
              },
              children: jsx(SettingsIcon, {})
            })
          })]
        })
      })
    }))
  });
};

const useDebouncedChange = (debounced, value, onChange, onBlur, debounceTimeMs = 500) => {
  const [debouncedData, setDebouncedValue] = useState({
    value,
    preDebounceValue: value
  });
  useEffect(() => {
    if (debounced && debouncedData.preDebounceValue !== value) {
      setDebouncedValue({
        value,
        preDebounceValue: value
      });
    }
  }, [debounced, value, debouncedData.preDebounceValue]);
  const debouncedOnChange = useCallback(debounce(value => {
    setDebouncedValue(prev => Object.assign({}, prev, {
      value
    }));
    if (onChange) {
      onChange(value);
    }
  }, debounceTimeMs), [onChange]);
  const handleDebouncedChange = useCallback(value => {
    setDebouncedValue(prev => Object.assign({}, prev, {
      value
    }));
    debouncedOnChange(value);
  }, [debouncedOnChange]);
  const handleDebouncedBlur = event => {
    if (debounced) {
      debouncedOnChange.flush();
    }
    if (onBlur) {
      onBlur(event);
    }
  };
  return {
    debouncedValue: debouncedData.value,
    handleDebouncedChange,
    handleDebouncedBlur
  };
};

const _excluded$p = ["defaultValue", "error", "helperText", "inputProps", "onChange", "onBlur"],
  _excluded2$2 = ["TextFieldProps"];
/**
 * Ein Textinput-Feld, mit folgenden Besonderheiten:
 *  - kein floating, sondern ein statisches Label
 *  - Validierung auf required
 */
const OCTextInput = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      TextFieldProps: {
        defaultValue,
        error,
        helperText,
        inputProps,
        onChange,
        onBlur
      } = {}
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref.TextFieldProps, _excluded$p),
    props = _objectWithoutPropertiesLoose(_ref, _excluded2$2);
  const {
    t
  } = useTranslation();
  // FIXME: two different ways to pass onChange handlers in one Component is confusing
  const handleChange = event => {
    const value = event.target.value;
    if (onChange) onChange(event);
    if (props.onChange) props.onChange(value);
  };
  // KEYDOWN
  const handleConfirm = event => {
    event.stopPropagation();
    const isEnter = event.key === "Enter";
    const {
      value
    } = event.target;
    if (props.onConfirm && isEnter) {
      props.onConfirm(value);
    }
  };
  const handleBlur = event => {
    onBlur == null ? void 0 : onBlur(event);
    props.onBlur == null ? void 0 : props.onBlur(event);
  };
  const {
    debouncedValue,
    handleDebouncedChange,
    handleDebouncedBlur
  } = useDebouncedChange(props.debounced, props.value, props.onChange, handleBlur, props.debounceTimeMs);
  const handleDebounced = useCallback(e => handleDebouncedChange(e.target.value), [handleDebouncedChange]);
  const TextFieldComponent = useMemo(() => {
    if (!props.advancedSettings) {
      return TextField$1;
    }
    return UnfoldableTextField;
  }, [props.advancedSettings]);
  return jsxs(FormControl, {
    fullWidth: props.fullWidth,
    children: [jsx(Typography$1, {
      component: "div",
      color: "textSecondary",
      children: isString(props.label) ? t(props.label) : props.label
    }), jsx(TextFieldComponent, Object.assign({
      value: props.debounced ? debouncedValue : props.value,
      variant: "outlined",
      onChange: props.debounced ? handleDebounced : handleChange,
      onBlur: props.debounced ? handleDebouncedBlur : handleBlur,
      onKeyDown: handleConfirm,
      InputLabelProps: {
        shrink: !props.label
      },
      defaultValue: defaultValue,
      inputRef: ref,
      error: error,
      helperText: helperText ? jsx(Fragment, {
        children: t(helperText)
      }) : undefined,
      inputProps: merge$1({}, inputProps, {
        "data-cy": props["data-cy"]
      }),
      // FIXME: these are just TextFieldProps, no need for prop drilling...
      minRows: props.minRows,
      name: props.name,
      type: props.type,
      autoComplete: props.autoComplete,
      disabled: props.disabled,
      required: props.required,
      multiline: props.multiline,
      placeholder: t(props.placeholder),
      autoFocus: props.autoFocus
    }, rest, {
      advancedSettings: props.advancedSettings
    }))]
  });
});

const EntityListItem = ({
  label,
  onDelete,
  Icon
}) => {
  return jsxs(ListItem, {
    secondaryAction: onDelete && jsx(IconButton, {
      "data-cy": "deleteListItem",
      edge: "end",
      onClick: onDelete,
      children: jsx(DeleteIcon, {})
    }),
    children: [jsx(ListItemAvatar, {
      children: jsx(Avatar, {
        children: Icon ? Icon : jsx(Folder, {})
      })
    }), jsx(ListItemText, {
      primary: label
    })]
  });
};
const AddDeleteEntityList = ({
  entities,
  name,
  editable: _editable = true,
  onChange,
  onCreate,
  onDelete,
  getLabel,
  buttonLabel,
  placeholder,
  errors,
  Icon
}) => {
  return jsxs(Stack, {
    direction: "column",
    spacing: 1,
    children: [_editable && jsxs(Stack, {
      direction: "row",
      spacing: 2,
      sx: {
        width: 1.0,
        justifyContent: "space-between"
      },
      children: [jsx(OCTextInput, {
        "data-cy": "addListItem",
        fullWidth: true,
        value: name,
        onChange: onChange,
        placeholder: placeholder,
        TextFieldProps: {
          error: errors !== undefined && errors.length > 0,
          helperText: errors == null ? void 0 : errors.join(", ")
        }
      }), jsx(Button, {
        "data-cy": "addListItemButton",
        sx: {
          maxHeight: "56px"
        },
        onClick: () => onCreate(),
        disabled: name === "" || errors !== undefined,
        variant: "contained",
        children: buttonLabel
      })]
    }), jsx(List, {
      children: entities.map(entity => {
        const label = getLabel(entity);
        const handleDelete = () => onDelete(entity);
        return jsx(EntityListItem, {
          label: label,
          onDelete: _editable ? handleDelete : undefined,
          Icon: Icon
        }, label);
      })
    })]
  });
};

const updateModelThunk = entity => async (dispatch, getState) => {
  dispatch(updateModel(entity));
  return api_updateResource("model", entity, {
    lang: selectContentLanguage(getState())
  });
};

const AddDeleteMaterials = ({
  model,
  editable: _editable = true
}) => {
  var _model$materials4;
  const {
    t
  } = useTranslation();
  const dispatch = useTypedDispatch();
  const [name, setName] = useState("");
  const [errors, setErrors] = useState(undefined);
  const handleNameChange = useCallback(name => {
    var _model$materials;
    setName(name);
    if (model != null && (_model$materials = model.materials) != null && _model$materials.find(m => m.toLowerCase() === name.toLowerCase())) {
      setErrors([t("Dieses Material existiert bereits")]);
    } else {
      setErrors(undefined);
    }
  }, [model, t]);
  const handleMaterialCreate = useCallback(() => {
    if (model) {
      var _model$materials2;
      dispatch(updateModelThunk(Object.assign({}, model, {
        materials: [...((_model$materials2 = model.materials) != null ? _model$materials2 : []), name]
      })));
    }
    setName("");
  }, [name, model, dispatch]);
  const handleMaterialDelete = useCallback(materialName => {
    if (model) {
      var _model$materials3;
      dispatch(updateModelThunk(Object.assign({}, model, {
        materials: ((_model$materials3 = model.materials) != null ? _model$materials3 : []).filter(m => m !== materialName)
      })));
    }
  }, [model, dispatch]);
  return jsxs(Stack, {
    direction: "column",
    spacing: 2,
    children: [jsx(SecondaryTitle, {
      children: t("Materialien")
    }), jsx(AddDeleteEntityList, {
      name: name,
      editable: _editable,
      entities: (_model$materials4 = model == null ? void 0 : model.materials) != null ? _model$materials4 : [],
      onChange: handleNameChange,
      onCreate: handleMaterialCreate,
      onDelete: handleMaterialDelete,
      getLabel: identity,
      buttonLabel: t("Material hinzufügen"),
      placeholder: t("Materialname eingeben"),
      errors: errors,
      Icon: jsx(AspectRatioOutlined, {})
    })]
  });
};

/* eslint-disable */
function createExpressionK3LanguageDefinition(languages, keywords) {
  const configuration = {
    wordPattern: /(-?\d*\.\d\w*)|([^\`\~\!\@\#\%\^\&\*\(\)\-\=\+\[\{\]\}\\\|\;\:\'\"\,\.\<\>\/\?\s]+)/g,
    comments: {
      lineComment: "//",
      blockComment: ["/*", "*/"]
    },
    brackets: [["{", "}"], ["[", "]"], ["(", ")"]],
    onEnterRules: [{
      // e.g. /** | */
      beforeText: /^\s*\/\*\*(?!\/)([^\*]|\*(?!\/))*$/,
      afterText: /^\s*\*\/$/,
      action: {
        indentAction: languages.IndentAction.IndentOutdent,
        appendText: " * "
      }
    }, {
      // e.g. /** ...|
      beforeText: /^\s*\/\*\*(?!\/)([^\*]|\*(?!\/))*$/,
      action: {
        indentAction: languages.IndentAction.None,
        appendText: " * "
      }
    }, {
      // e.g.  * ...|
      beforeText: /^(\t|(\ \ ))*\ \*(\ ([^\*]|\*(?!\/))*)?$/,
      action: {
        indentAction: languages.IndentAction.None,
        appendText: "* "
      }
    }, {
      // e.g.  */|
      beforeText: /^(\t|(\ \ ))*\ \*\/\s*$/,
      action: {
        indentAction: languages.IndentAction.None,
        removeText: 1
      }
    }],
    autoClosingPairs: [{
      open: "{",
      close: "}"
    }, {
      open: "[",
      close: "]"
    }, {
      open: "(",
      close: ")"
    }, {
      open: '"',
      close: '"',
      notIn: ["string"]
    }, {
      open: "'",
      close: "'",
      notIn: ["string", "comment"]
    }, {
      open: "`",
      close: "`",
      notIn: ["string", "comment"]
    }, {
      open: "/**",
      close: " */",
      notIn: ["string"]
    }],
    folding: {
      markers: {
        start: new RegExp("^\\s*//\\s*#?region\\b"),
        end: new RegExp("^\\s*//\\s*#?endregion\\b")
      }
    }
  };
  const language = {
    // Set defaultToken to invalid to see what you do not tokenize yet
    defaultToken: "invalid",
    tokenPostfix: ".ts",
    keywords,
    operators: ["<=", ">=", "==", "!=", "===", "!==", "=>", "+", "-", "**", "*", "/", "%", "<<", "</", ">>", ">>>", "&", "|", "^", "!", "~", "&&", "||", "??", "?", ":", "="],
    // we include these common regular expressions
    symbols: /[=><!~?:&|+\-*\/\^%]+/,
    escapes: /\\(?:[abfnrtv\\"']|x[0-9A-Fa-f]{1,4}|u[0-9A-Fa-f]{4}|U[0-9A-Fa-f]{8})/,
    digits: /\d+(_+\d+)*/,
    octaldigits: /[0-7]+(_+[0-7]+)*/,
    binarydigits: /[0-1]+(_+[0-1]+)*/,
    hexdigits: /[[0-9a-fA-F]+(_+[0-9a-fA-F]+)*/,
    regexpctl: /[(){}\[\]\$\^|\-*+?\.]/,
    regexpesc: /\\(?:[bBdDfnrstvwWn0\\\/]|@regexpctl|c[A-Z]|x[0-9a-fA-F]{2}|u[0-9a-fA-F]{4})/,
    // The main tokenizer for our languages
    tokenizer: {
      root: [[/[{}]/, "delimiter.bracket"], {
        include: "common"
      }],
      common: [
      // identifiers and keywords
      [/[a-z_$][\w$]*/, {
        cases: {
          "@keywords": "keyword",
          "@default": "identifier"
        }
      }], [/[A-Z][\w\$]*/, "type.identifier"],
      // [/[A-Z][\w\$]*/, 'identifier'],
      // whitespace
      {
        include: "@whitespace"
      },
      // regular expression: ensure it is terminated before beginning (otherwise it is an opeator)
      [/\/(?=([^\\\/]|\\.)+\/([dgimsuy]*)(\s*)(\.|;|,|\)|\]|\}|$))/, {
        token: "regexp",
        bracket: "@open",
        next: "@regexp"
      }],
      // delimiters and operators
      [/[()\[\]]/, "@brackets"], [/[<>](?!@symbols)/, "@brackets"], [/!(?=([^=]|$))/, "delimiter"], [/@symbols/, {
        cases: {
          "@operators": "delimiter",
          "@default": ""
        }
      }],
      // numbers
      [/(@digits)[eE]([\-+]?(@digits))?/, "number.float"], [/(@digits)\.(@digits)([eE][\-+]?(@digits))?/, "number.float"], [/0[xX](@hexdigits)n?/, "number.hex"], [/0[oO]?(@octaldigits)n?/, "number.octal"], [/0[bB](@binarydigits)n?/, "number.binary"], [/(@digits)n?/, "number"],
      // delimiter: after number because of .\d floats
      [/[;,.]/, "delimiter"],
      // strings
      [/"([^"\\]|\\.)*$/, "string.invalid"], [/'([^'\\]|\\.)*$/, "string.invalid"], [/"/, "string", "@string_double"], [/'/, "string", "@string_single"], [/`/, "string", "@string_backtick"]],
      whitespace: [[/[ \t\r\n]+/, ""], [/\/\*\*(?!\/)/, "comment.doc", "@jsdoc"], [/\/\*/, "comment", "@comment"], [/\/\/.*$/, "comment"]],
      comment: [[/[^\/*]+/, "comment"], [/\*\//, "comment", "@pop"], [/[\/*]/, "comment"]],
      jsdoc: [[/[^\/*]+/, "comment.doc"], [/\*\//, "comment.doc", "@pop"], [/[\/*]/, "comment.doc"]],
      // We match regular expression quite precisely
      regexp: [[/(\{)(\d+(?:,\d*)?)(\})/, ["regexp.escape.control", "regexp.escape.control", "regexp.escape.control"]], [/(\[)(\^?)(?=(?:[^\]\\\/]|\\.)+)/, ["regexp.escape.control", {
        token: "regexp.escape.control",
        next: "@regexrange"
      }]], [/(\()(\?:|\?=|\?!)/, ["regexp.escape.control", "regexp.escape.control"]], [/[()]/, "regexp.escape.control"], [/@regexpctl/, "regexp.escape.control"], [/[^\\\/]/, "regexp"], [/@regexpesc/, "regexp.escape"], [/\\\./, "regexp.invalid"], [/(\/)([dgimsuy]*)/, [{
        token: "regexp",
        bracket: "@close",
        next: "@pop"
      }, "keyword.other"]]],
      regexrange: [[/-/, "regexp.escape.control"], [/\^/, "regexp.invalid"], [/@regexpesc/, "regexp.escape"], [/[^\]]/, "regexp"], [/\]/, {
        token: "regexp.escape.control",
        next: "@pop",
        bracket: "@close"
      }]],
      string_double: [[/[^\\"]+/, "string"], [/@escapes/, "string.escape"], [/\\./, "string.escape.invalid"], [/"/, "string", "@pop"]],
      string_single: [[/[^\\']+/, "string"], [/@escapes/, "string.escape"], [/\\./, "string.escape.invalid"], [/'/, "string", "@pop"]],
      string_backtick: [[/\$\{/, {
        token: "delimiter.bracket",
        next: "@bracketCounting"
      }], [/[^\\`$]+/, "string"], [/@escapes/, "string.escape"], [/\\./, "string.escape.invalid"], [/`/, "string", "@pop"]],
      bracketCounting: [[/\{/, "delimiter.bracket", "@bracketCounting"], [/\}/, "delimiter.bracket", "@pop"], {
        include: "common"
      }]
    }
  };
  return {
    configuration,
    language
  };
}

const monacoOptions = {
  codeLens: false,
  lineNumbers: "off",
  glyphMargin: false,
  folding: false,
  lineDecorationsWidth: 0,
  lineNumbersMinChars: 0,
  overviewRulerLanes: 0,
  hideCursorInOverviewRuler: true,
  overviewRulerBorder: false,
  renderLineHighlight: "none",
  minimap: {
    enabled: false
  }
};

const expressionK3 = "expressionK3";
function ExpressionEditor(props) {
  var _props$expression, _props$height;
  const {
    t
  } = useTranslation();
  const variables = useTypedSelector(selectVariables);
  const onChange = expression => {
    const expressionAsId = labelsToId(expression, variables);
    props.onChange(expressionAsId);
  };
  const expressionAsLabels = idsToLabels((_props$expression = props.expression) != null ? _props$expression : "", variables);
  const onMountEditor = (editor, monaco) => {
    maybeRegisterExpressionLanguageK3(monaco, variables);
    if (props.inline) {
      var _editor$getAction;
      (_editor$getAction = editor.getAction("editor.action.toggleTabFocusMode")) == null ? void 0 : _editor$getAction.run();
    } else {
      editor.focus();
    }
  };
  const options = useMemo(() => merge$1({}, monacoOptions, props.inline ? {
    scrollbar: {
      vertical: "hidden",
      horizontal: "hidden",
      handleMouseWheel: false
    }
  } : {}, props.options), [props.inline, props.options]);
  return jsx(Editor$4, {
    height: (_props$height = props.height) != null ? _props$height : "10em",
    theme: "light",
    defaultLanguage: expressionK3,
    onChange: onChange,
    value: expressionAsLabels,
    onMount: onMountEditor,
    options: options,
    loading: jsxs(FormControl$1, {
      variant: "standard",
      children: [jsx(InputLabel, {
        htmlFor: "input-component",
        children: t("Expression")
      }), jsx(Input, {
        id: "input-component",
        onChange: event => onChange(event.target.value),
        value: expressionAsLabels,
        multiline: true,
        fullWidth: true
      })]
    })
  });
}
let completionProvider = null;
function maybeRegisterExpressionLanguageK3(monaco, variables) {
  const languages = monaco.languages;
  if (languages.getEncodedLanguageId(expressionK3) == 0) {
    languages.register({
      id: expressionK3
    });
  }
  const keywords = variables.map(({
    label
  }) => label).concat(Object.keys(staticContext));
  const {
    configuration,
    language
  } = createExpressionK3LanguageDefinition(languages, keywords);
  languages.setLanguageConfiguration(expressionK3, configuration);
  languages.setMonarchTokensProvider(expressionK3, language);
  if (completionProvider !== null) {
    var _completionProvider;
    // Dispose previous completion provider to avoid showing duplicate
    // suggestions.
    (_completionProvider = completionProvider) == null ? void 0 : _completionProvider.dispose();
  }
  completionProvider = languages.registerCompletionItemProvider(expressionK3, createCompletionItemProvider(languages, variables));
}
function createCompletionItemProvider(languages, variables) {
  return {
    provideCompletionItems: (model, position) => {
      // find out if we are completing a property in the 'dependencies' object.
      model.getValueInRange({
        startLineNumber: 1,
        startColumn: 1,
        endLineNumber: position.lineNumber,
        endColumn: position.column
      });
      const word = model.getWordUntilPosition(position);
      const range = {
        startLineNumber: position.lineNumber,
        endLineNumber: position.lineNumber,
        startColumn: word.startColumn,
        endColumn: word.endColumn
      };
      return {
        suggestions: createDependencyProposals(languages, variables, range)
      };
    }
  };
}
function createDependencyProposals(languages, variables, range) {
  const {
    Function,
    Variable,
    Constant,
    Property
  } = languages.CompletionItemKind;
  // dynamische Variable / Attributzuweisung verbieten:
  // (Breite > 1 ? Teile : AndereTeile)[0].Höhe
  // (x=>x.Höhe)((Breite > 1 ? Teile : AndereTeile)[0)
  // was aber ok ist:
  // map(Teile,x=>x.Höhe)
  // (x=>x.Höhe)(Teile)
  // => es mus statisch erkennbar sein, welche Variable und welches Attribut gemeint ist
  // todo um hier das Attribut zu ermitteln, muss man eigentlich wissen, auf welcher Variablen man steht..
  // das ist nicht ganz einfach, schon gar nicht bei closures in agregat function etc..
  // die expression engine muss das aber eigentlich sowieso können, um die ID des Attributes zu ermitteln..
  // also den Job auf jeden Fall an die expression engine auslagern!
  // betrifft nur diese dynamischen Teil. Relevant ist nur eine Liste von Variablen und Attribute,
  // welche dann hier gemappt werden
  return variables.map(v => v.label).map(label => ({
    label: `${label}`,
    kind: Variable,
    // documentation klappt nicht.. keine Ahnung warum
    documentation: "reference to Variable " + label,
    insertText: formatLabel("variable", label),
    range: range
  })).concat(variables.flatMap(v => {
    var _v$attrs$map$map, _v$attrs;
    return (_v$attrs$map$map = (_v$attrs = v.attrs) == null ? void 0 : _v$attrs.map(a => a.label[i18n.language]).map(label => ({
      label: `${label}`,
      kind: Property,
      // documentation klappt nicht.. keine Ahnung warum
      documentation: "reference to attribut " + label,
      insertText: formatLabel("attribut", label),
      range: range
    }))) != null ? _v$attrs$map$map : [];
  }), [{
    label: "instanceIndex",
    kind: Property,
    documentation: "instance index",
    insertText: "instanceIndex",
    range: range
  }])
  // der rest ist statisch - entfällt aber, wenn wir in Punktnotation-Folge stehen
  .concat(map$1(staticContext, (value, key) => typeof value == "function" ? {
    label: `${key}`,
    kind: Function,
    // documentation klappt nicht.. keine Ahnung warum
    documentation: "the function " + key,
    insertText: `${key}()`,
    range: range
  } : {
    label: `${key}`,
    kind: Constant,
    // documentation klappt nicht.. keine Ahnung warum
    documentation: "the constant " + key,
    insertText: key,
    range: range
  }));
}

const variableWithExpression = (variable, expression) => {
  const n = cloneDeep(variable);
  n.settings.templateOptions.expression = expression;
  return n;
};
function useExpression(props) {
  const selections = useTypedSelector(selectSelections);
  const variables = useTypedSelector(selectVariables);
  const values = useTypedSelector(selectValues);
  if (!props.variable) return evaluateExpression(variables, values, selections, props.expression, props.anchoringSelection);
  const newVars = [...variables];
  const i = newVars.findIndex(v => {
    var _props$variable;
    return v.id == ((_props$variable = props.variable) == null ? void 0 : _props$variable.id);
  });
  if (i >= 0) {
    newVars[i] = variableWithExpression(variables[i], props.expression);
  }
  const variable = variableWithExpression(props.variable, props.expression);
  return evaluateSingleVariable(newVars, values, selections, variable);
}
function SingleExpressionPreview(props) {
  var _props$showError;
  const {
    t
  } = useTranslation();
  const {
    result,
    errorMessage
  } = useExpression(props);
  if (props.onError) props.onError(errorMessage);
  const parentSelections = useTypedSelector(selectParentSelections(props.anchoringSelection));
  const valuesById = useTypedSelector(selectValuesByIdMap);
  return jsxs(Fragment, {
    children: [jsxs(FormHelperText, {
      "data-cy": "expressionEngineResult",
      children: [t("Ergebnis"), " " + parentSelections.map(p => {
        var _valuesById$p$valueId;
        return p.valueId ? (_valuesById$p$valueId = valuesById[p == null ? void 0 : p.valueId]) == null ? void 0 : _valuesById$p$valueId.label : "";
      }).join(" > "), ": ", " " + result]
    }), ((_props$showError = props.showError) != null ? _props$showError : true) && errorMessage && jsx(FormHelperText, {
      "data-cy": "expressionEngineError",
      sx: {
        color: "red"
      },
      children: "" + errorMessage
    })]
  });
}
function ExpressionEditorPreview({
  expression,
  anchoringSelections,
  showExpression,
  onError,
  gutterBottom
}) {
  const {
    t
  } = useTranslation();
  const variables = useTypedSelector(selectVariables);
  const formula = useMemo(() => {
    return idsToLabels(expression, variables);
  }, [expression, variables]);
  return jsxs(Box, {
    component: "div",
    "data-cy": "expressionEditorPreview",
    sx: {
      display: "grid",
      gridTemplateColumns: "auto",
      gridAutoFlow: "row",
      gap: 2
    },
    children: [showExpression ? isEmpty(expression) ? jsx(FormHelperText, {
      "data-cy": "noExpresionMessage",
      children: t("Keine Formel eingegeben")
    }) : jsx(Box, {
      "data-cy": "expression",
      component: "div",
      sx: {
        wordBreak: "break-word"
      },
      children: jsx(Typography, {
        children: t("Formel: ") + formula
      })
    }) : null, jsx(Box, {
      component: "div",
      sx: {
        display: "grid",
        gridTemplateColumns: "auto",
        gridAutoFlow: "row",
        gap: 1,
        marginBottom: gutterBottom ? 2 : 0,
        overflowY: "scroll",
        maxHeight: "200px"
      },
      children: anchoringSelections.map((anchoringSelection, index, array) => jsx(SingleExpressionPreview, {
        expression: expression,
        anchoringSelection: anchoringSelection,
        showError: index === array.length - 1,
        onError: onError
      }, anchoringSelection.id))
    }), !anchoringSelections || (anchoringSelections == null ? void 0 : anchoringSelections.length) === 0 && jsx(FormHelperText, {
      "data-cy": "notEnoughSelectionsToEvaluateExpressionMessage",
      children: t("Noch gibt es nicht genug Auswahlen um eine Vorschau anzuzeigen.")
    })]
  });
}

function ExpressionEditorDialog(props) {
  const {
    t
  } = useTranslation();
  const [currentExpression, setCurrentExpression] = useState("");
  useEffect(() => {
    setCurrentExpression(props.expression);
  }, [props.expression]);
  const [errorMessage, setErrorMessage] = useState();
  const handleClose = () => {
    if (!errorMessage) props.onChange(currentExpression);
    props.onClose();
  };
  return jsxs(Dialog, {
    open: props.open,
    onClose: props.onClose,
    fullWidth: true,
    maxWidth: "xl",
    children: [jsx(DialogTitle, {
      children: t("Formel Editor")
    }), jsxs(DialogContent, {
      children: [jsxs(DialogContentText, {
        children: [jsx(Typography, {
          children: t("Geben Sie Formeln von Variablen ein.")
        }), jsx(Typography, {
          children: t(" Schreiben Sie z.B. Länge * Breite.")
        }), jsx(Typography, {
          children: t("Für ein Attribut nutzen Sie beispielsweise Motor.Leistung, wenn Motor ihr Merkmal und Leistung das entsprechende Attribut ist.")
        })]
      }), jsx("br", {}), jsx(Box, {
        component: "div",
        sx: {
          padding: "1em",
          border: "1px solid #c4c4c4",
          borderRadius: 1
        },
        children: jsx(ExpressionEditor, {
          onChange: setCurrentExpression,
          expression: currentExpression
        })
      }), jsx(ExpressionEditorPreview, {
        expression: currentExpression,
        anchoringSelections: props.anchoringSelections,
        onError: setErrorMessage,
        gutterBottom: false
      })]
    }), jsx(DialogActions, {
      children: jsx(Button, {
        disabled: !!errorMessage,
        "data-cy": `save`,
        onClick: handleClose,
        children: t("Speichern")
      })
    })]
  });
}

const useHasFocus = ref => {
  const [hasFocus, setHasFocus] = useState(false);
  useEffect(() => {
    //check if the focus is inside the expression input
    const onFocus = e => {
      var _ref$current;
      if ((_ref$current = ref.current) != null && _ref$current.contains(e.target)) {
        setHasFocus(true);
      }
    };
    const onFocusOut = e => {
      var _ref$current2;
      if ((_ref$current2 = ref.current) != null && _ref$current2.contains(e.target)) {
        setHasFocus(false);
      }
    };
    document.addEventListener("focusin", onFocus);
    document.addEventListener("focusout", onFocusOut);
    return () => {
      document.removeEventListener("focusin", onFocus);
      document.removeEventListener("focusout", onFocusOut);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return hasFocus;
};

const ExpressionInput = ({
  value,
  onChange,
  sx,
  label,
  anchoringSelections: _anchoringSelections = [rootSelection]
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [error, setError] = useState(undefined);
  const ref = useRef(null);
  const hasFocus = useHasFocus(ref);
  useEffect(() => {
    if (!hasFocus) setError(undefined);
  }, [hasFocus]);
  return jsxs(Box, {
    component: "fieldset",
    sx: Object.assign({
      borderColor: "rgba(0, 0, 0, 0.23)",
      borderWidth: 1,
      borderRadius: 1,
      margin: 0
    }, sx),
    ref: ref,
    "data-cy": `expressionInput-${label}`,
    children: [jsx(Popover, {
      open: hasFocus,
      anchorEl: ref.current,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "left"
      },
      sx: {
        display: error ? "block" : "none",
        pointerEvents: "none"
      },
      children: jsx(Box, {
        sx: {
          p: 2
        },
        component: "div",
        children: jsx(ExpressionEditorPreview, {
          expression: value,
          showExpression: false,
          anchoringSelections: _anchoringSelections,
          onError: setError
        })
      })
    }), jsx(Typography, {
      component: "legend",
      color: "textSecondary",
      sx: {
        fontSize: 12
      },
      children: label
    }), jsxs(Box, {
      component: "div",
      sx: {
        display: "flex",
        alignItems: "center"
      },
      children: [jsx(IconButton, {
        onClick: () => setIsOpen(true),
        "data-cy": "",
        size: "small",
        sx: {
          ml: -1.5
        },
        tabIndex: -1,
        children: jsx(Calculate, {})
      }), jsx(ExpressionEditor, {
        expression: value,
        inline: true,
        onChange: onChange,
        height: "1.1rem"
      })]
    }), jsx(ExpressionEditorDialog, {
      open: isOpen,
      onClose: () => setIsOpen(false),
      expression: value,
      onChange: onChange,
      anchoringSelections: _anchoringSelections
    })]
  });
};

const sxStyles$s = {
  input: {
    width: "33%"
  },
  x: {
    borderTopRightRadius: "0px",
    borderBottomRightRadius: "0px"
  },
  y: {
    borderRadius: 0
  },
  z: {
    borderTopLeftRadius: "0px",
    borderBottomLeftRadius: "0px"
  }
};
const getExpressionString = value => {
  if (isRecord(value) && "expression" in value) return value.expression;
  return String(value);
};
function OCVector3Input({
  label,
  inputLabels = ["X", "Y", "Z"],
  placeholders = ["X", "Y", "Z"],
  defaultValues,
  onChange,
  sx,
  debounced = false,
  expression = false,
  anchoringSelections = [rootSelection]
}) {
  const [vector, setVector] = useState([defaultValues ? defaultValues[0] : "0", defaultValues ? defaultValues[1] : "0", defaultValues ? defaultValues[2] : "0"]);
  const handleChange = useCallback((...newVector) => {
    setVector(prev => {
      const updatedVector = prev.map((v, i) => newVector[i] || v || "0");
      if (onChange) {
        onChange(updatedVector);
      }
      return updatedVector;
    });
  }, [onChange]);
  const changeX = value => handleChange({
    expression: value
  }, vector[1], vector[2]);
  const changeY = value => handleChange(vector[0], {
    expression: value
  }, vector[2]);
  const changeZ = value => handleChange(vector[0], vector[1], {
    expression: value
  });
  return jsxs(Box, {
    component: "div",
    sx: sx,
    children: [jsx(Typography, {
      color: "text.secondary",
      sx: {
        mb: 0
      },
      children: label
    }), jsx(Box, {
      component: "div",
      display: "flex",
      children: expression ? jsxs(Fragment, {
        children: [jsx(ExpressionInput, {
          label: "X",
          sx: Object.assign({}, sxStyles$s.input, sxStyles$s.x),
          value: getExpressionString(vector[0]),
          onChange: changeX,
          anchoringSelections: anchoringSelections
        }), jsx(ExpressionInput, {
          label: "Y",
          sx: Object.assign({}, sxStyles$s.input, sxStyles$s.y),
          value: getExpressionString(vector[1]),
          onChange: changeY,
          anchoringSelections: anchoringSelections
        }), jsx(ExpressionInput, {
          label: "Z",
          sx: Object.assign({}, sxStyles$s.input, sxStyles$s.z),
          value: getExpressionString(vector[2]),
          onChange: changeZ,
          anchoringSelections: anchoringSelections
        })]
      }) : jsxs(Fragment, {
        children: [jsx(Box, {
          component: "div",
          sx: sxStyles$s.input,
          children: jsx(OCTextInput, {
            "data-cy": `vectorX`,
            debounced: debounced,
            value: getExpressionString(vector[0]),
            onChange: changeX,
            TextFieldProps: {
              type: "number",
              label: inputLabels[0],
              placeholder: placeholders[0],
              InputProps: {
                sx: sxStyles$s.x
              },
              inputProps: {
                step: "0.1"
              }
            }
          })
        }), jsx(Box, {
          component: "div",
          sx: sxStyles$s.input,
          children: jsx(OCTextInput, {
            "data-cy": `vectorY`,
            debounced: debounced,
            value: getExpressionString(vector[1]),
            onChange: changeY,
            TextFieldProps: {
              type: "number",
              label: inputLabels[1],
              placeholder: placeholders[1],
              InputProps: {
                sx: sxStyles$s.y
              },
              inputProps: {
                step: "0.1"
              }
            }
          })
        }), jsx(Box, {
          component: "div",
          sx: sxStyles$s.input,
          children: jsx(OCTextInput, {
            "data-cy": `vectorZ`,
            debounced: debounced,
            value: getExpressionString(vector[2]),
            onChange: changeZ,
            TextFieldProps: {
              type: "number",
              label: inputLabels[2],
              placeholder: placeholders[2],
              InputProps: {
                sx: sxStyles$s.z
              },
              inputProps: {
                step: "0.1"
              }
            }
          })
        })]
      })
    })]
  });
}

const PositionRotationScale = ({
  modelActionRuleItemValue,
  model,
  onChange,
  ruleItem,
  ruleColumnId
}) => {
  const {
    t
  } = useTranslation();
  const getDefault = (key, defaultValue) => {
    var _modelActionRuleItemV, _modelActionRuleItemV2, _model$props;
    if (modelActionRuleItemValue != null && (_modelActionRuleItemV = modelActionRuleItemValue.props) != null && _modelActionRuleItemV[key]) return (_modelActionRuleItemV2 = modelActionRuleItemValue.props) == null ? void 0 : _modelActionRuleItemV2[key];
    if (model && "props" in model && (_model$props = model.props) != null && _model$props[key]) return model.props[key];
    return defaultValue || [0, 0, 0];
  };
  const defaultPosition = getDefault("position");
  const defaultRotation = getDefault("rotation");
  const defaultScale = getDefault("scale", [1, 1, 1]);
  const anchoringSelections = useTypedSelector(selectAnchoringSelectionsOfRuleItem(ruleItem == null ? void 0 : ruleItem.id, ruleColumnId));
  return jsxs(Stack, {
    direction: "column",
    spacing: 2,
    children: [jsx(OCVector3Input, {
      debounced: true,
      defaultValues: defaultPosition,
      label: t("Position"),
      onChange: onChange("position"),
      expression: true,
      anchoringSelections: anchoringSelections
    }), jsx(OCVector3Input, {
      debounced: true,
      defaultValues: defaultRotation,
      label: t("Rotation (in radiant)"),
      onChange: onChange("rotation"),
      expression: true,
      anchoringSelections: anchoringSelections
    }), jsx(OCVector3Input, {
      debounced: true,
      defaultValues: defaultScale,
      label: t("Scale"),
      onChange: onChange("scale"),
      expression: true,
      anchoringSelections: anchoringSelections
    })]
  });
};

const Dimensions = ({
  widthExpression,
  heightExpression,
  depthExpression,
  expressionChange,
  ruleItem,
  ruleColumnId
}) => {
  const {
    t
  } = useTranslation();
  const anchoringSelections = useTypedSelector(selectAnchoringSelectionsOfRuleItem(ruleItem == null ? void 0 : ruleItem.id, ruleColumnId));
  return jsxs(Stack, {
    direction: "column",
    spacing: 2,
    children: [jsx(SecondaryTitle, {
      children: t("Abmessungen")
    }), jsx(ExpressionInput, {
      value: widthExpression.expression,
      onChange: expressionChange("width"),
      label: t("Breite"),
      anchoringSelections: anchoringSelections
    }), jsx(ExpressionInput, {
      value: heightExpression.expression,
      onChange: expressionChange("height"),
      label: t("Höhe"),
      anchoringSelections: anchoringSelections
    }), jsx(ExpressionInput, {
      value: depthExpression.expression,
      onChange: expressionChange("depth"),
      label: t("Tiefe"),
      anchoringSelections: anchoringSelections
    })]
  });
};

const TransformationAndDimensions = ({
  modelActionRuleItemValue,
  model,
  onChange,
  widthExpression,
  heightExpression,
  depthExpression,
  expressionChange,
  ruleItem,
  ruleColumnId
}) => {
  return jsxs(Stack, {
    direction: "column",
    spacing: 4,
    children: [jsx(PositionRotationScale, {
      modelActionRuleItemValue: modelActionRuleItemValue,
      model: model,
      onChange: onChange,
      ruleItem: ruleItem,
      ruleColumnId: ruleColumnId
    }), jsx(Dimensions, {
      widthExpression: widthExpression,
      heightExpression: heightExpression,
      depthExpression: depthExpression,
      expressionChange: expressionChange,
      ruleItem: ruleItem,
      ruleColumnId: ruleColumnId
    })]
  });
};

const BasicDynamicModelEditor = ({
  dynamicModelProps,
  expressionChange,
  model,
  modelActionRuleItemValue,
  onChange,
  ruleItem,
  ruleColumnId,
  materialsAreEditable: _materialsAreEditable = false
}) => {
  return jsxs(Stack, {
    direction: "column",
    spacing: 4,
    children: [jsx(TransformationAndDimensions, {
      modelActionRuleItemValue: modelActionRuleItemValue,
      model: model,
      onChange: onChange,
      widthExpression: dynamicModelProps.width,
      heightExpression: dynamicModelProps.height,
      depthExpression: dynamicModelProps.depth,
      expressionChange: expressionChange,
      ruleItem: ruleItem,
      ruleColumnId: ruleColumnId
    }), jsx(AddDeleteMaterials, {
      model: model,
      editable: _materialsAreEditable
    })]
  });
};

var Screenshot$3 = "data:image/png;base64,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";

const PropsDialog$3 = props => {
  return jsx(BasicDynamicModelEditor, Object.assign({}, props, {
    materialsAreEditable: false
  }));
};
const BoxWithReplaceableMaterial = props => {
  const defaultMaterials = useMemo(() => [new MeshStandardMaterial({
    name: "surface",
    color: "grey"
  })], []);
  const modelId = props.id;
  const updatedMaterials = useModelWithAppliedActions(modelId, defaultMaterials, [], props.modelAction);
  return jsx(Box$1, {
    args: [props.width, props.height, props.depth],
    rotation: props.rotation,
    scale: props.scale,
    position: props.position,
    name: props.name,
    matrixWorldAutoUpdate: undefined,
    getObjectsByProperty: undefined,
    getVertexPosition: undefined,
    userData: {
      modelId
    },
    material: updatedMaterials["surface"]
  });
};
const dynamicBox = {
  type: "box",
  label: "Box",
  disabledForAR: false,
  component: BoxWithReplaceableMaterial,
  propsDialog: PropsDialog$3,
  defaultProps: {
    width: {
      expression: "1"
    },
    height: {
      expression: "1"
    },
    depth: {
      expression: "1"
    }
  },
  materials: ["surface"],
  repositionApplicator: defaultRepositionApplicator,
  screenshot: Screenshot$3
};

function setupExtensionsInternal(extensions) {
  const NoExtension = comp => comp;
  const defaultExtensions = {
    extendAdditionalGroups: NoExtension,
    extendAdditionalVars: NoExtension,
    extendGroupLabel: NoExtension,
    extendGroupPanel: NoExtension,
    extendHeader: NoExtension,
    extendVariableLabel: NoExtension,
    components: {
      select: Wrapped => props => {
        return jsx(Wrapped, Object.assign({}, props));
      }
    }
  };
  return Object.assign({}, defaultExtensions, extensions);
}
const setupExtensions = memoize(setupExtensionsInternal);

const _excluded$o = ["extensions"];
const flattenObject = (obj, prefix = "") => Object.keys(obj).reduce((acc, k) => {
  const pre = prefix.length ? `${prefix}.` : "";
  if (typeof obj[k] === "object" && obj[k] !== null && Object.keys(obj[k]).length > 0) Object.assign(acc, flattenObject(obj[k], pre + k));
  // @ts-ignore
  else acc[pre + k] = obj[k];
  return acc;
}, {});
const ExtensionContext = /*#__PURE__*/React__default.createContext({});
const withExtensionContext = Wrapped => _ref => {
  let {
      extensions
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$o);
  const ctx = setupExtensions(extensions);
  return jsx(ExtensionContext.Provider, {
    value: ctx,
    children: jsx(Wrapped, Object.assign({}, props, {
      extensions: extensions
    }))
  });
};
const mergeComponentHOCs = (context, componentHOCs) => flow(flattenObject, reduceExtra((acc, value, key) => {
  const componentKey = flow(split$4("."), last)(key);
  return set$4(["components", componentKey], value, acc);
}, {}), merge$2(context))(componentHOCs);
const withExtensions = extensionPointFlags => {
  const contextPaths = flow(flattenObject, keys$3)(extensionPointFlags);
  const rootHOCPaths = filter(endsWith("root"), contextPaths);
  if (rootHOCPaths.length > 1) {
    throw new Error("There should only be one root HOC!");
  }
  const rootHOCPath = first(rootHOCPaths);
  const componentHOCPaths = reject(endsWith("root"), contextPaths);
  return withInnerExtensions(rootHOCPath, componentHOCPaths);
};
const withComponentExtension = extensionComponentKey => withInnerExtensions(`components.${extensionComponentKey}`, []);
const withInnerExtensions = (rootHOCPath, componentHOCPaths) => {
  return Wrapped => /*#__PURE__*/React__default.forwardRef((props, ref) => {
    const context = useContext(ExtensionContext);
    const withRootHOC = get$3(rootHOCPath, context);
    const NewWrapped = useMemo(() => withRootHOC ? withRootHOC(Wrapped) : Wrapped, [withRootHOC]);
    const componentHOCs = useMemo(() => pick(componentHOCPaths, context), [context]);
    const Component = useMemo(() => {
      let newContext;
      if (!isEmpty$1(componentHOCs)) {
        newContext = mergeComponentHOCs(context, componentHOCs);
        return /*#__PURE__*/React__default.forwardRef((props, ref) => jsx(ExtensionContext.Provider, {
          value: newContext,
          children: jsx(NewWrapped, Object.assign({}, props, {
            ref: ref
          }))
        }));
      }
      return /*#__PURE__*/React__default.forwardRef((props, ref) => jsx(NewWrapped, Object.assign({}, props, {
        ref: ref
      })));
    }, [NewWrapped, componentHOCs, context]);
    return jsx(Component, Object.assign({}, props, {
      ref: ref
    }));
  });
};
const withDynamicModelExtension = extensionComponentKey => Wrapped => props => {
  const context = useContext(ExtensionContext);
  const NewWrapped = useMemo(() => {
    var _context$dynamicModel;
    const hoc = context == null ? void 0 : (_context$dynamicModel = context.dynamicModels) == null ? void 0 : _context$dynamicModel[extensionComponentKey];
    // @ts-ignore
    return hoc ? hoc(Wrapped) : Wrapped;
  }, [context]);
  return jsx(NewWrapped, Object.assign({}, props));
};

var Screenshot$2 = "40794b23ce392098.png";

const PropsDialog$2 = props => {
  return jsx(BasicDynamicModelEditor, Object.assign({}, props, {
    materialsAreEditable: true
  }));
};
const DummyInternal = props => {
  const modelId = props.id;
  const wireframeMaterial = useMemo(() => new MeshStandardMaterial({
    name: "surface",
    color: "blue",
    wireframe: true
  }), []);
  return jsx(Box$1, {
    args: [props.width, props.height, props.depth],
    rotation: props.rotation,
    scale: props.scale,
    position: props.position,
    userData: {
      modelId
    },
    material: wireframeMaterial,
    name: props.name
  });
};
const DummyKey = "dummy";
const Dummy = withDynamicModelExtension(DummyKey)(DummyInternal);
const dynamicDummy = {
  type: DummyKey,
  label: "Dummy",
  disabledForAR: false,
  component: Dummy,
  propsDialog: PropsDialog$2,
  defaultProps: {
    width: {
      expression: "1"
    },
    height: {
      expression: "1"
    },
    depth: {
      expression: "1"
    }
  },
  materials: ["surface"],
  repositionApplicator: defaultRepositionApplicator,
  screenshot: Screenshot$2
};

var PROPER_FUNCTION_NAME$1 = functionName.PROPER;
var fails$7 = fails$A;
var whitespaces = whitespaces$4;

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
var stringTrimForced = function (METHOD_NAME) {
  return fails$7(function () {
    return !!whitespaces[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME$1 && whitespaces[METHOD_NAME].name !== METHOD_NAME);
  });
};

var $$5 = _export;
var $trim = stringTrim.trim;
var forcedStringTrimMethod = stringTrimForced;

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$$5({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});

var $$4 = _export;
var uncurryThis$6 = functionUncurryThisClause;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var toLength$4 = toLength$9;
var toString = toString$g;
var notARegExp = notARegexp;
var requireObjectCoercible = requireObjectCoercible$b;
var correctIsRegExpLogic = correctIsRegexpLogic;

// eslint-disable-next-line es/no-string-prototype-startswith -- safe
var nativeStartsWith = uncurryThis$6(''.startsWith);
var stringSlice = uncurryThis$6(''.slice);
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$$4({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = toString(requireObjectCoercible(this));
    notARegExp(searchString);
    var index = toLength$4(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = toString(searchString);
    return nativeStartsWith
      ? nativeStartsWith(that, search, index)
      : stringSlice(that, index, index + search.length) === search;
  }
});

const addLabels = (componentName, classes) => mapValues$1(classes, (value, key) => Object.assign({}, value, {
  label: componentName + "-" + key
}));

const cleanupHexColor = hexString => (hexString || "").replace("#", "").trim();
const sxStyles$r = addLabels("OCColorPicker", {
  rgbContainer: {
    display: "grid",
    gridTemplateColumns: "auto auto auto",
    gridGap: theme => theme.spacing(1)
  },
  rgbInput: {
    width: "100%"
  },
  container: {
    display: "grid",
    gridGap: theme => theme.spacing(1),
    gridTemplateRows: "auto auto auto",
    justifyItems: "center",
    margin: 1,
    marginBottom: 2,
    width: 200
  }
});
const OCColorPicker = ({
  onChange,
  value,
  mode: _mode = "hex"
}) => {
  const rgbaString = useMemo(() => {
    if (!value) {
      return "rgba(0,0,0,1)";
    } else if (value.startsWith("rgba")) {
      return value;
    }
    return colord(value).toRgbString();
  }, [value]);
  const [hexColor, setHexColor] = useState(cleanupHexColor(colord(value).toHex()));
  const [rgbColor, setRGBColor] = useState(colord(value).toRgb());
  const handleChange = (value, updateText = true) => {
    if (colord(value).isValid()) {
      const convertedValue = _mode === "hex" ? colord(value).toHex() : value;
      updateText && setHexColor(cleanupHexColor(colord(value).toHex()));
      setRGBColor(colord(value).toRgb());
      onChange(convertedValue);
    }
  };
  const handleHexChange = event => {
    const hexColor = cleanupHexColor(event.target.value);
    if (event.nativeEvent.inputType === "insertFromPaste") {
      setHexColor(hexColor);
    } else if (hexColor.length <= 6) {
      setHexColor(event.target.value);
    }
    handleChange("#" + hexColor, false);
  };
  const handleRGBChange = rgbKey => event => {
    const newRGB = Object.assign({}, rgbColor, {
      [rgbKey]: event.target.value
    });
    if (colord(newRGB).isValid()) {
      handleChange(newRGB);
    } else {
      setRGBColor(newRGB);
    }
  };
  const handleRChange = handleRGBChange("r");
  const handleGChange = handleRGBChange("g");
  const handleBChange = handleRGBChange("b");
  return jsxs(Box, {
    component: "div",
    sx: sxStyles$r["container"],
    "data-cy": "colorPickerContainer",
    children: [jsx(RgbStringColorPicker, {
      "data-cy": "colorPickerColorGradient",
      onChange: handleChange,
      color: rgbaString
    }), jsx(TextField, {
      variant: "standard",
      label: "HEX",
      onChange: handleHexChange,
      value: hexColor,
      error: !colord("#" + hexColor).isValid(),
      InputProps: {
        startAdornment: jsx(InputAdornment, {
          position: "start",
          children: "#"
        })
      },
      inputProps: {
        "data-cy": "hex"
      }
    }), jsxs(Box, {
      component: "div",
      sx: sxStyles$r["rgbContainer"],
      children: [jsx(TextField, {
        sx: sxStyles$r["rgbInput"],
        type: "number",
        variant: "standard",
        label: "R",
        onChange: handleRChange,
        value: rgbColor.r,
        inputProps: {
          "data-cy": "colorR"
        }
      }), jsx(TextField, {
        sx: sxStyles$r["rgbInput"],
        type: "number",
        variant: "standard",
        label: "G",
        onChange: handleGChange,
        value: rgbColor.g,
        inputProps: {
          "data-cy": "colorG"
        }
      }), jsx(TextField, {
        sx: sxStyles$r["rgbInput"],
        type: "number",
        variant: "standard",
        label: "B",
        onChange: handleBChange,
        value: rgbColor.b,
        inputProps: {
          "data-cy": "colorB"
        }
      })]
    })]
  });
};

const _excluded$n = ["checked", "onChange"];
const sxStyles$q = {
  formControlLabel: {
    width: 1.0,
    margin: 0,
    "& .MuiTypography-root": {
      width: 1.0
    }
  }
};
function OCSwitch(props) {
  const _ref = props.SwitchProps || {},
    {
      checked,
      onChange
    } = _ref,
    switchProps = _objectWithoutPropertiesLoose(_ref, _excluded$n);
  const switchChecked = checked === undefined ? props.checked : checked;
  const switchOnChange = event => {
    if (onChange) onChange(event, !!event.target);
    if (props.onChange) props.onChange(event.target.checked);
  };
  return jsxs(FormControl$1, {
    fullWidth: true,
    variant: "outlined",
    children: [jsx(Typography, {
      color: "textSecondary",
      children: props.label
    }), jsx(FormControlLabel, {
      sx: sxStyles$q.formControlLabel,
      componentsProps: {
        typography: {
          color: "text.primary"
        }
      },
      control: jsx(Switch$1, Object.assign({
        "data-cy": props["data-cy"],
        checked: switchChecked || false,
        onChange: switchOnChange
      }, switchProps)),
      label: props.description || ""
    })]
  });
}

const selectScreenshotting = state => {
  return state.k3d.screenshotting;
};
const selectIsScreenshottingPossible = state => {
  return state.k3d.isScreenshottingPossible;
};
const selectModelRuleData = state => {
  return state.k3d.modelRuleData;
};
const selectEditMode = state => {
  return state.k3d.editMode;
};
const selectNextCameraPosition = state => {
  return state.k3d.nextCameraPosition;
};
/**
 * this returns a unique id that changes when forceNextCameraPosition is called.
 */
const selectForceNextCameraPosition = state => {
  return state.k3d.forceNextCameraPosition;
};
const selectIsLoadingScene = state => {
  return state.k3d.isLoading;
};
const emptyModelIdArray = [];
const selectLoadedModelIds = state => {
  return state.k3d.loadedModelIds || emptyModelIdArray;
};

const getOrthogonalDirection = (center, direction, origin) => {
  const originDir = center.clone().sub(origin).normalize();
  // If the direction is parallel to the origin direction, we need to shift the
  // origin direction a bit
  let result = direction.clone().cross(originDir).normalize();
  if (result.lengthSq() === 0) {
    const shiftedOriginDir = originDir.clone();
    shiftedOriginDir.x += 0.0001;
    shiftedOriginDir.y += 0.0001;
    shiftedOriginDir.z += 0.0001;
    result = direction.clone().cross(shiftedOriginDir).normalize();
  }
  return result;
};
const RulerHeadLine = props => {
  var _props$parameters$len, _props$parameters, _props$parameters$off, _props$parameters2, _props$parameters3, _props$parameters$dir, _props$parameters4;
  const {
    scene
  } = useThree();
  const endLength = (_props$parameters$len = (_props$parameters = props.parameters) == null ? void 0 : _props$parameters.length) != null ? _props$parameters$len : 0.05;
  const endStart = ((_props$parameters$off = (_props$parameters2 = props.parameters) == null ? void 0 : _props$parameters2.offset) != null ? _props$parameters$off : 0.5) * -endLength;
  const endEnd = endStart + endLength;
  let headLineDirection = (_props$parameters3 = props.parameters) != null && _props$parameters3.direction ? new Vector3(...((_props$parameters$dir = (_props$parameters4 = props.parameters) == null ? void 0 : _props$parameters4.direction) != null ? _props$parameters$dir : [])).normalize() : undefined;
  if (!headLineDirection) {
    const k3dScene = scene == null ? void 0 : scene.getObjectByName("k3d");
    let currentOrigin = new Vector3();
    try {
      var _Box3$setFromObject$g;
      currentOrigin = (_Box3$setFromObject$g = new Box3().setFromObject(k3dScene).getCenter(new Vector3())) != null ? _Box3$setFromObject$g : new Vector3();
    } catch (e) {
      currentOrigin = new Vector3();
    }
    const orthogonalDir = getOrthogonalDirection(props.center, props.direction, currentOrigin);
    headLineDirection = props.direction.clone().cross(getMostEqualAxis(orthogonalDir, axes).clone()).normalize();
  }
  const headLinePoints = [new Vector3(...props.endpoint).add(new Vector3().copy(headLineDirection).multiplyScalar(endStart)).toArray(), new Vector3(...props.endpoint).add(new Vector3().copy(headLineDirection).multiplyScalar(endEnd)).toArray()];
  return jsx(Line
  // @ts-ignore
  , {
    // @ts-ignore
    color: props.color,
    lineWidth: props.lineWidth,
    points: headLinePoints
  });
};
const upAxis = new Vector3(0, 1, 0);
const axes = [new Vector3(1, 0, 0), upAxis, new Vector3(0, 0, 1)];
function getMostEqualAxis(originDir, axes) {
  let mostEqualAxis = axes[0];
  let mostEqualAxisDot = Math.abs(originDir.clone().dot(axes[0]));
  for (let i = 1; i < axes.length; i++) {
    const dot = Math.abs(originDir.clone().dot(axes[i]));
    if (dot > mostEqualAxisDot) {
      mostEqualAxis = axes[i];
      mostEqualAxisDot = dot;
    }
  }
  return mostEqualAxis;
}
const areFloatsDifferent = (a, b) => {
  return Math.abs(a - b) / a > 0.0025;
};
const areQuaternionsDifferent = (q1, q2) => {
  const q2A = q2.toArray();
  return q1.toArray().some((n, i) => areFloatsDifferent(n, q2A[i]));
};
function Rulertext(props) {
  var _props$rotation, _props$size;
  const ref = useRef(null);
  const textRotation = new Quaternion().setFromEuler(new Euler(...((_props$rotation = props.rotation) != null ? _props$rotation : [0, 0, 0])));
  const [rot, setRot] = useState(textRotation);
  const [textDistance, setTextDistance] = useState(0);
  const [textLength, setTextLength] = useState(0);
  useFrame(a => {
    const newRot = textRotation.rotateTowards(a.camera.quaternion, 99999);
    if (areQuaternionsDifferent(rot, newRot)) setRot(newRot);
    const newTextDistance = a.camera.position.distanceTo(props.textWorldPosition);
    if (areFloatsDifferent(textDistance, newTextDistance)) setTextDistance(newTextDistance);
    if (ref.current && props.sprite) {
      ref.current.quaternion.copy(a.camera.quaternion);
    }
  });
  const fontSize = ((_props$size = props.size) != null ? _props$size : 1) * textDistance / 100;
  const boxMargin = fontSize;
  useEffect(() => {
    if (props.onMaxTextDimensionChange) {
      const mostEqualAxis = getMostEqualAxis(props.direction, axes);
      if (mostEqualAxis.equals(upAxis)) {
        props.onMaxTextDimensionChange(fontSize + boxMargin);
      } else {
        props.onMaxTextDimensionChange(textLength + boxMargin);
      }
    }
  }, [props, textLength, fontSize, boxMargin, props.onMaxTextDimensionChange]);
  return jsx("group", {
    position: props.position,
    quaternion: rot,
    castShadow: false,
    receiveShadow: false,
    children: jsxs(Text$5, {
      anchorX: "center",
      anchorY: "middle",
      ref: ref,
      fontSize: fontSize,
      lineHeight: 1,
      color: props.color,
      outlineWidth: 0.1,
      outlineColor: "white",
      clipRect: [-(textLength + boxMargin) / 2, -(fontSize + boxMargin) / 2.5, (textLength + boxMargin) / 2, (fontSize + boxMargin) / 2],
      onSync: mesh => {
        const newLength = mesh.geometry.boundingBox.max.x - mesh.geometry.boundingBox.min.x;
        if (areFloatsDifferent(newLength, textLength)) {
          setTextLength(newLength);
        }
      },
      children: [props.text, " ", props.unit || "", jsx(MeshFlatMaterial, {})]
    })
  });
}
const Ruler = props => {
  var _props$formatter, _props$length, _props$color, _props$thickness, _props$lineClamp, _props$textColor, _props$textSize, _props$textSprite, _props$textStatic;
  const ref = useRef(null);
  const editMode = useTypedSelector(selectEditMode);
  const getText = (_props$formatter = props.formatter) != null ? _props$formatter : length => {
    var _props$digits;
    return length.toFixed((_props$digits = props.digits) != null ? _props$digits : 2);
  };
  const [textWorldPosition, setTextWorldPosition] = useState(new Vector3());
  const vCon = new Vector3(...props.startPoint).sub(new Vector3(...props.endPoint));
  const [center, setCenter] = useState(new Vector3());
  const length = (_props$length = props.length) != null ? _props$length : vCon.length();
  const textPosition = (props.textPosition ? new Vector3(...props.textPosition) : new Vector3(...props.startPoint).add(new Vector3().copy(vCon).multiplyScalar(-0.5))).toArray();
  const lineColor = (_props$color = props.color) != null ? _props$color : "black";
  const lineThickness = (_props$thickness = props.thickness) != null ? _props$thickness : 1;
  const [maxTextDimension, setMaxTextDimension] = useState(0);
  const handleMaxTextDimensionChange = useCallback(newMaxTextDimension => {
    if (newMaxTextDimension !== maxTextDimension) {
      setMaxTextDimension(newMaxTextDimension);
    }
  }, [maxTextDimension]);
  const lengthFactor = (_props$lineClamp = props.lineClamp) != null ? _props$lineClamp : Math.max(0.0, 0.5 - maxTextDimension / 1.5 / length);
  const startTo = new Vector3(...props.startPoint).add(new Vector3().copy(vCon).multiplyScalar(-lengthFactor)).toArray();
  const endTo = new Vector3(...props.endPoint).add(new Vector3().copy(vCon).multiplyScalar(lengthFactor)).toArray();
  const direction = new Vector3(...props.endPoint).sub(new Vector3(...props.startPoint)).normalize();
  const handleTextWorldPositionUpdate = useCallback(groupObject => {
    const newTextWorldPosition = (groupObject == null ? void 0 : groupObject.localToWorld(new Vector3(...textPosition))) || new Vector3();
    if (textWorldPosition.equals(newTextWorldPosition)) return;
    setTextWorldPosition(newTextWorldPosition);
  }, [textPosition, textWorldPosition]);
  const handleCenterUpdate = useCallback(groupObject => {
    let newCenter = new Vector3(...props.startPoint).add(new Vector3(...props.endPoint).sub(new Vector3(...props.startPoint)).multiplyScalar(0.5));
    newCenter = groupObject.localToWorld(newCenter);
    if (center.equals(newCenter)) return;
    setCenter(newCenter);
  }, [props.startPoint, props.endPoint, center]);
  const handleGroupUpdate = useCallback(groupObject => {
    handleTextWorldPositionUpdate(groupObject);
    handleCenterUpdate(groupObject);
  }, [handleTextWorldPositionUpdate, handleCenterUpdate]);
  return jsxs("group", {
    ref: ref,
    position: props.position,
    userData: {
      modelId: props.id
    },
    onUpdate: handleGroupUpdate,
    name: props.name,
    children: [!editMode && jsx(Rulertext, {
      color: (_props$textColor = props.textColor) != null ? _props$textColor : "black",
      size: (_props$textSize = props.textSize) != null ? _props$textSize : 1,
      sprite: (_props$textSprite = props.textSprite) != null ? _props$textSprite : false,
      position: textPosition,
      text: getText((_props$textStatic = props.textStatic) != null ? _props$textStatic : length),
      rotation: props.textRotation,
      textWorldPosition: textWorldPosition,
      unit: props.unit,
      direction: direction,
      onMaxTextDimensionChange: handleMaxTextDimensionChange
    }), jsxs("group", {
      rotation: props.rotation,
      children: [jsx(RulerHeadLine, {
        center: center,
        direction: direction,
        color: lineColor,
        lineWidth: lineThickness,
        parameters: props.endLines,
        endpoint: props.startPoint
      }), jsx(RulerHeadLine, {
        center: center,
        direction: direction,
        color: lineColor,
        lineWidth: lineThickness,
        parameters: props.endLines,
        endpoint: props.endPoint
      }), jsx(Line
      // @ts-ignore
      , {
        // @ts-ignore
        color: lineColor,
        lineWidth: lineThickness,
        points: [props.startPoint, startTo]
      }), jsx(Line
      // @ts-ignore
      , {
        // @ts-ignore
        color: lineColor,
        lineWidth: lineThickness,
        points: [props.endPoint, endTo]
      })]
    })]
  });
};
const MeshFlatMaterial = props => {
  return jsx("meshBasicMaterial", {
    attach: "material",
    color: props.color,
    toneMapped: false,
    reflectivity: 0,
    fog: false,
    map: props.map
  });
};

var Screenshot$1 = "data:image/png;base64,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";

const defaultExpression = {
  expression: "0"
};
const defaultProps = {
  color: "#000",
  startPoint: [defaultExpression, defaultExpression, defaultExpression],
  endPoint: [defaultExpression, {
    expression: "1"
  }, defaultExpression],
  thickness: {
    expression: "1"
  },
  digits: {
    expression: "2"
  }
};
const optionalPropsSent = {
  textStatic: defaultExpression
};
const PropsDialog$1 = ({
  dynamicModelProps,
  expressionChange,
  toggleVisibility: toggleVisibilityProp,
  isVisible,
  onChange,
  ruleItem,
  ruleColumnId,
  model,
  modelActionRuleItemValue: modelAction
}) => {
  var _dynamicModelProps$th, _dynamicModelProps$te, _dynamicModelProps$te2, _dynamicModelProps$te3, _dynamicModelProps$di;
  const {
    t
  } = useTranslation();
  const toggleVisibility = toggleVisibilityProp(optionalPropsSent);
  const anchoringSelections = useTypedSelector(selectAnchoringSelectionsOfRuleItem(ruleItem == null ? void 0 : ruleItem.id, ruleColumnId));
  return jsxs(Stack, {
    maxWidth: 800,
    children: [jsx(Typography, {
      variant: "h5",
      children: t("Allgemein")
    }), jsxs(Stack, {
      mt: 3,
      children: [jsx(Typography, {
        children: t("Farbe")
      }), jsx(OCColorPicker, {
        value: dynamicModelProps.color,
        onChange: onChange("color")
      })]
    }), jsx(Stack, {
      mt: 3,
      children: jsx(OCVector3Input, {
        debounced: true,
        defaultValues: dynamicModelProps.startPoint,
        sx: {
          maxWidth: "400px"
        },
        label: t("Startpunkt"),
        onChange: onChange("startPoint"),
        expression: true,
        anchoringSelections: anchoringSelections
      })
    }), jsx(Stack, {
      mt: 3,
      children: jsx(OCVector3Input, {
        debounced: true,
        defaultValues: dynamicModelProps.endPoint,
        sx: {
          maxWidth: "400px"
        },
        label: t("Endpunkt"),
        onChange: onChange("endPoint"),
        expression: true,
        anchoringSelections: anchoringSelections
      })
    }), jsx(Stack, {
      mt: 3,
      children: jsx(ExpressionInput, {
        value: (_dynamicModelProps$th = dynamicModelProps.thickness) == null ? void 0 : _dynamicModelProps$th.expression,
        onChange: expressionChange("thickness"),
        label: t("Linienstärke"),
        sx: {
          maxWidth: 300
        },
        anchoringSelections: anchoringSelections
      })
    }), jsx(Typography, {
      variant: "h5",
      sx: {
        mt: 5
      },
      children: t("Text")
    }), jsxs(Stack, {
      mt: 3,
      children: [jsx(OCSwitch, {
        "data-cy": "overrideStandardText",
        checked: isVisible("textStatic"),
        onChange: toggleVisibility("textStatic"),
        label: t("Automatisches Maß überschreiben")
      }), isVisible("textStatic") && dynamicModelProps.textStatic && jsx(ExpressionInput, {
        value: (_dynamicModelProps$te = dynamicModelProps.textStatic) == null ? void 0 : _dynamicModelProps$te.expression,
        onChange: expressionChange("textStatic"),
        label: t("Neues Maß"),
        sx: {
          maxWidth: 300
        },
        anchoringSelections: anchoringSelections
      }), jsx(ExpressionInput, {
        value: (_dynamicModelProps$te2 = (_dynamicModelProps$te3 = dynamicModelProps.textSize) == null ? void 0 : _dynamicModelProps$te3.expression) != null ? _dynamicModelProps$te2 : "1",
        onChange: expressionChange("textSize"),
        label: t("Textgröße als Faktor. 1 ist Standard."),
        sx: {
          maxWidth: 300
        },
        anchoringSelections: anchoringSelections
      }), jsx(ExpressionInput, {
        value: (_dynamicModelProps$di = dynamicModelProps.digits) == null ? void 0 : _dynamicModelProps$di.expression,
        onChange: expressionChange("digits"),
        label: t("Nachkommastellen"),
        sx: {
          maxWidth: 300
        },
        anchoringSelections: anchoringSelections
      }), jsx(OCTextInput, {
        "data-cy": "unit",
        label: t("Einheit"),
        value: dynamicModelProps.unit,
        onChange: onChange("unit")
      })]
    }), jsx(Stack, {
      mt: 3,
      children: jsxs(Accordion, {
        children: [jsx(AccordionSummary, {
          expandIcon: jsx(ExpandMore, {}),
          children: jsx(Typography, {
            variant: "h5",
            children: t("Offsets")
          })
        }), jsxs(AccordionDetails, {
          children: [jsx(Typography, {
            variant: "body1",
            children: t("Hier können Abweichungen von Position und Rotation, die sich normalerweise aus Start und Endpunkt ergeben, definiert werden. Dazu kann das 3D Positionierungswerkzeug benutzt werden.")
          }), jsx(PositionRotationScale, {
            modelActionRuleItemValue: modelAction,
            model: model,
            ruleItem: ruleItem,
            onChange: onChange
          })]
        })]
      })
    }), jsx(Stack, {
      mt: 3
    })]
  });
};
const dynamicRuler = {
  type: "ruler",
  label: "Maßkette",
  disabledForAR: true,
  component: Ruler,
  defaultProps,
  propsDialog: PropsDialog$1,
  repositionApplicator: defaultRepositionApplicator,
  materials: [],
  screenshot: Screenshot$1
};

var $$3 = _export;
var uncurryThis$5 = functionUncurryThis;
var isArray = isArray$3;

var nativeReverse = uncurryThis$5([].reverse);
var test = [1, 2];

// `Array.prototype.reverse` method
// https://tc39.es/ecma262/#sec-array.prototype.reverse
// fix for Safari 12.0 bug
// https://bugs.webkit.org/show_bug.cgi?id=188794
$$3({ target: 'Array', proto: true, forced: String(test) === String(test.reverse()) }, {
  reverse: function reverse() {
    // eslint-disable-next-line no-self-assign -- dirty hack
    if (isArray(this)) this.length = this.length;
    return nativeReverse(this);
  }
});

const getVariablesByGroupId = (state, group_id) => selectVariables(state).filter(variable => variable.groupId == group_id).sort(byOrder);

const getAttributes = value => (value == null ? void 0 : value.attrs) || [];
const getAttributeValueById = (attributeDefinitionId, value) =>
// @ts-ignore
getAttributes(value).find(attribute => attribute.attrId == attributeDefinitionId);

const useAsyncError = () => {
  const [_, setError] = React__default.useState();
  return React__default.useCallback(e => {
    setError(() => {
      throw e;
    });
  }, [setError]);
};

/** Just makes a dispatch, to hide redux from extension developers */
const useActionCreator = actionCreator => {
  const dispatch = useTypedDispatch();
  return useCallback((...args) =>
  // @ts-ignore
  dispatch(actionCreator(...args)), [dispatch, actionCreator]);
};

const setTouchedByUserFromFocusGroupChangeThunk = id => (dispatch, getState) => {
  const state = getState();
  const input = selectRuleEngineInput(state);
  if (!input) {
    console.warn("Rule engine not initialized!");
    return;
  }
  const variablesForGroups = input.variables.flat.all.filter(variable => variable.groupId == +id);
  const variableAndInstances = variablesForGroups.map(variable => ({
    instanceId: "",
    variableId: variable.id
  }));
  const oldState = selectRuleEngineState(state);
  if (!oldState) {
    console.warn("Rule engine not initialized!");
    return;
  }
  const newR2State = addTouched(input, oldState.state, variableAndInstances);
  dispatch(setRuleEngineState(Object.assign({}, oldState, {
    state: newR2State
  })));
};

const changeGroupThunk = (groupId, resetToToplevel) => (dispatch, getState) => {
  const state = getState();
  const focusGroupId = selectFocusGroupId(state);
  if (!focusGroupId) return;
  dispatch(setTouchedByUserFromFocusGroupChangeThunk(focusGroupId));
  if (resetToToplevel) {
    dispatch(setOpenInstance(rootSelection));
    dispatch(setSelectedVariableId(undefined));
  }
  dispatch(setGroup(groupId));
};
const changeGroupByKeyThunk = (groupKey, resetToToplevel) => (dispatch, getState) => {
  const state = getState();
  const group = selectGroupByKey(groupKey)(state);
  if (!group) return;
  dispatch(changeGroupThunk(group.id, resetToToplevel));
};

const selectImages = state => get$2(state, ["metadata", lowerCase("images")]);
curry((appId, state) => flow(selectImages, filter(image => image.appId == appId))(state));
const selectCurrentImageFolders = state => {
  const images = selectImages(state);
  return _$1.uniq(images.map(i => i.path)).sort();
};
const selectCurrentImages = state => {
  const images = selectImages(state);
  const actionEngine = selectImageActions(state);
  return images.filter(image => actionEngine.some(a => a.path === image.path));
};

const selectPrices = state => get$2(state, ["metadata", lowerCase("prices")]);
const selectPricesByAppId = curry((appId, state) => flow(selectPrices, filter(price => price.appId == appId))(state));
const selectPricesByArticleId = curry((articleId, state) => flow(selectPrices, filter(price => price.articleId == articleId))(state));

const selectRules = state => state.metadata.rules;
const selectRulesByIdMap = createSelector(selectRules, rules => indexById(rules));
const selectRuleById = ruleId => state => selectRules(state).find(t => t.id == ruleId);
const selectRulesByAppId = appId => state => selectRules(state).filter(t => t.appId == appId);
const selectRulesByVariableId = variableId => state => {
  if (!variableId) return [];
  return selectRules(state).filter(rule => includes$1(map(c => c.targetId, rule.columns), variableId));
};
const selectRuleColumnById = (ruleId, columnId) => state => {
  var _selectRuleById, _selectRuleById$colum;
  return (//@ts-ignore
    (_selectRuleById = selectRuleById(ruleId)(state)) == null ? void 0 : (_selectRuleById$colum = _selectRuleById.columns) == null ? void 0 : _selectRuleById$colum.find(c => c.id == columnId)
  );
};

const selectRuleItems = state => state.metadata.ruleItems;
const selectRuleItemsByRuleId = ruleId => state => selectRuleItems(state).filter(r => r.ruleId == ruleId).sort(byOrder);
const selectRuleItemsByValueId = valueId => state => selectRuleItems(state).filter(ruleItem => some(ruleItem.values, v => {
  if (isValueId(v)) {
    return v === valueId;
  } else if (isValueIdArray(v)) {
    return v.includes(valueId);
  } else if (isModelActionRuleValue(v)) {
    return v.modelId == valueId;
  } else if (isNumberRuleValue(v)) {
    return false;
  } else {
    return false;
  }
}));
const selectRuleItemsWithImageActions = createSelector(selectRuleItems, ruleItems => {
  return ruleItems.filter(ruleItem => Object.values(ruleItem.values).find(isImageActionRuleValue));
});
createSelector(selectRuleItemsWithImageActions, selectRulesByIdMap, (ruleItems, rulesByIdMap) => {
  return ruleItems.map(ruleItem => {
    const rule = rulesByIdMap[ruleItem.ruleId];
    return rule.columns.filter(column => isImageActionColumn(column)).map(t => t.targetId);
  }).flat();
});
const selectBefuelltImageTargetByValueId = valueId => state => {
  return selectRuleItemsByValueId(valueId)(state).flatMap(ruleItem => {
    const foundImageAction = Object.values(ruleItem.values).find(isImageActionRuleValue);
    if (foundImageAction) {
      const rule = selectRuleById(ruleItem.ruleId)(state);
      const targetIds = rule.columns.filter(isImageActionColumn).map(t => t.targetId);
      return targetIds;
    } else {
      return undefined;
    }
  }).filter(Boolean);
};
const selectInstanceActionRuleItemValues = createSelector(selectRuleItems, ruleItems => ruleItems.flatMap(ruleItem => Object.values(ruleItem.values).filter(isInstanceActionRuleValue)));

/** Trys to find a valid selection for every empty selection.
 * Backtracking exactly like you know it.
 *
 * You can optimize run time by modifying the order of empty selections and valid
 * options for each instance and variableId.
 * This also helps to implicitly try to hold previous selections.
 */
const fillEmptySelections = (ruleEngineInput, selections, emptySelections, validOptionsByInstanceAndVariable, depth) => {
  var _validOptionsByInstan;
  emptySelections == null ? void 0 : emptySelections.sort(sortByHierachyLevel);
  const emptyNextSelection = emptySelections[0];
  if (!emptyNextSelection) return selections;
  selections.sort(sortByHierachyLevel);
  const instance = emptyNextSelection.instance.id;
  const options = ((_validOptionsByInstan = validOptionsByInstanceAndVariable[instance]) == null ? void 0 : _validOptionsByInstan[emptyNextSelection.variableId]) || ruleEngineInput.values.byVarId.locked[emptyNextSelection.variableId].map(v => ({
    value: v,
    conflicts: []
  }));
  for (const option of options) {
    const nextSelection = fillSelection(ruleEngineInput, option.value, emptyNextSelection);
    const [valid] = calcAreSelectionsStillValid(ruleEngineInput, selections, nextSelection, true);
    if (valid) {
      const nextSelections = [...selections, nextSelection];
      const fill = fillEmptySelections(ruleEngineInput, nextSelections, emptySelections.slice(1), validOptionsByInstanceAndVariable);
      if (fill) {
        return fill;
      }
    }
  }
  return false;
};
/** Detects all still missing selections for a set of selections and fills them.
 * The input selections are not changed under any circumstances.
 */
const findAndFillEmptySelections = (input, selections, validOptions, empty) => {
  const e = empty || calcAllEmptySelections(input, selections, calcInstances(selections), "locked");
  return fillEmptySelections(input, selections, e, validOptions);
};

/** Calculates the options for an instance.
 * ALL options are treated as valid!
 * */
const calcInitialOptionsForInstance = (i, instance) => {
  const byVarId = {};
  const variables = i.variables.flat.locked.filter(v => v.parentId === instance.variableId || v.id === instance.variableId);
  variables.forEach(variable => {
    byVarId[variable.id.toString()] = i.values.byVarId.locked[variable.id].map(v => ({
      value: v,
      conflicts: []
    }));
  });
  return {
    [instance.id]: byVarId
  };
};

/** MUTATION of options!
 * We enter options and it adds us append for the instance and variable specified.
 */
const mutateOptions = (options, instanceId, variableId, append) => {
  if (!options[instanceId]) options[instanceId] = {};
  if (!options[instanceId][variableId]) options[instanceId][variableId] = [];
  options[instanceId][variableId].push(...append);
};
/** Merges two options, returns a third object. */
const mergeOptions = (optionsA, optionsB) => {
  const options = cloneDeep(optionsA);
  Object.keys(optionsB).forEach(instanceId => Object.keys(optionsB[instanceId]).forEach(varId => mutateOptions(options, instanceId, varId, optionsB[instanceId][varId])));
  return options;
};

/** Attempts to launch all instances for a variable.
 * Returns either a valid or an invalid Option for each value */
const attemptToLaunchInstances = (input, launchingVar, instance, selections, staticValidOptions) => {
  const vals = input.values.byVarId.locked[launchingVar.id];
  return vals.map(value => {
    const newSelection = createSelection(launchingVar, value, instance.instance, true);
    // lets attempt to find a valid set of selections for the children of this new instance
    const options = mergeOptions(staticValidOptions, calcInitialOptionsForInstance(input, newSelection));
    const res = findAndFillEmptySelections(input, [...selections, newSelection], options);
    if (res) {
      // if there is some, great
      return {
        value: value,
        conflicts: []
      };
    } else {
      // If not, we just need to find any conflict.
      const valid = calcFirstConflictForInstance(input, selections, newSelection);
      valid[0] && console.warn("Ooops? Fill did find no solution but calcFirstConflict found no conflict. This is strange. ", input, selections, newSelection, staticValidOptions);
      return {
        value: value,
        conflicts: valid[1].map(r => r[1])
      };
    }
  });
};

/** Merges the locked and free state */
const mergeLockedAndFreeState = (lockedState, freeState) => ({
  locked: lockedState,
  free: freeState,
  all: {
    selections: [...freeState.selections, ...lockedState.selections],
    validOptions: mergeOptions(freeState.validOptions, lockedState.validOptions),
    invalidOptions: lockedState.invalidOptions,
    touched: lockedState.touched
  }
});

/** MUTATION of newValidOptions and newInvalidOptions
 *
 * Checks if instance can launch any instances itself and fills the options accordingly */
const checkForPossibleLaunchedInstances = (i, selections, instance, staticValidOptions, newValidOptions, newInvalidOptions) => {
  const launchingVars = i.variables.flat.locked.filter(v => isMultiVariable(v) && v.parentId === instance.variableId);
  launchingVars.forEach(launchingVar => {
    const options = attemptToLaunchInstances(i, launchingVar, instance, selections, staticValidOptions);
    const [validOptions, invalidOptions] = partition(options, o => !o.conflicts.length);
    mutateOptions(newValidOptions, instance.id, launchingVar.id, validOptions);
    mutateOptions(newInvalidOptions, instance.id, launchingVar.id, invalidOptions);
  });
};
/** Calculates all valid and invalid options for a given set of selections */
const calcValidAndInvalidOptions = (input, selections) => {
  const validOptions = {};
  const invalidOptions = {};
  selections.forEach(selection => {
    var _input$values$byVarId;
    const vals = (_input$values$byVarId = input.values.byVarId.locked[selection.variableId]) != null ? _input$values$byVarId : [];
    const selectionsWithoutSelection = selections.filter(s => s.id !== selection.id);
    const options = calcOptionOrder(vals.map(val => {
      return {
        value: val,
        conflicts: calcAreSelectionsStillValid(input, selectionsWithoutSelection, createSelection(selection.variableId, val, selection.instance, selection.instance.isInstanceLauncher), false)[1].map(r => r[1])
      };
    }), selection);
    const [valid, invalid] = partition(options, v => !v.conflicts.length);
    const iId = selection.instance.id;
    mutateOptions(validOptions, iId, selection.variableId, valid);
    mutateOptions(invalidOptions, iId, selection.variableId, invalid);
  });
  const freezedValidOptions = cloneDeep(validOptions);
  [rootSelection, ...selections.filter(s => s.instance.isInstanceLauncher)].forEach(instance => checkForPossibleLaunchedInstances(input, selections, instance, freezedValidOptions, validOptions, invalidOptions));
  return {
    valid: validOptions,
    invalid: invalidOptions
  };
};
/** Calcs the initial options without any selections and thus instances.
 * ALL options are treated as valid!
 * */
const calcInitialOptions = i => calcInitialOptionsForInstance(i, rootSelection);
/** Calcs the initial options for all instances.
 * ALL options are treated as valid!
 */
const calcInitialOptionsForInstances = (i, instances) => Object.assign({}, ...instances.map(instance => calcInitialOptionsForInstance(i, instance)));
/** Calculates all possible options for free variables (there are no invalid ones).
 * Sets the previously in oldFreeState set selection or picks the first possible one.
 * In the end you have a complete R2State.
 * */
const calcAndFillAllFreeOptions = (i, newLockedState, oldFreeState) => {
  const instances = calcInstances(newLockedState.selections);
  const allFree = calcAllEmptySelections(i, newLockedState.selections, instances, "all");
  const options = {};
  const freeSelections = allFree.map(free => {
    const values = i.values.byVarId.free[free.variableId].map(v => ({
      value: v,
      conflicts: []
    }));
    mutateOptions(options, free.instance.id, free.variableId, values);
    return oldFreeState.selections.find(s => selectionHasSamePosition(s, free)) || fillSelection(i, values[0].value, free);
  });
  return mergeLockedAndFreeState(newLockedState, {
    selections: freeSelections,
    validOptions: options
  });
};
/** Calculates options from scratch, but moves them to the start if they were selected
 * in the previous state.
 */
const calcOptionsForInvalidSelections = (i, selections, instances) => {
  const options = calcInitialOptionsForInstances(i, instances);
  Object.keys(options).forEach(instanceId => Object.keys(options[instanceId]).forEach(varId => {
    const matchingSelection = selections.find(s => s.variableId == Number(varId) && s.instance.id === instanceId);
    if (!matchingSelection) return;
    options[instanceId][varId] = calcOptionOrder(options[instanceId][varId], matchingSelection);
  }));
  return options;
};
const calcOptionOrder = (options, activeSelection) => {
  if (isNumberSelection(activeSelection)) {
    return sortNumberOptions(options, activeSelection);
  } else {
    const option = options.find(o => o.value.id === activeSelection.valueId);
    if (!option) return options;
    return moveOptionsToStart(options, [option]);
  }
};
const sortNumberOptions = (options, matchingSelection) => {
  var _matchingSelection$da, _matchingSelection$da2;
  // we utilize that values were created in order and thus are already
  // sorted from smallest to largest by their ids
  const sorted = options.slice().sort((a, b) => b.value.id - a.value.id);
  const index = sorted.findIndex(o => o.value.id === matchingSelection.valueId);
  const iV = (_matchingSelection$da = (_matchingSelection$da2 = matchingSelection.data) == null ? void 0 : _matchingSelection$da2.inputValue) != null ? _matchingSelection$da : 0;
  const res = [sorted[index]];
  let upper = index + 1,
    lower = index - 1;
  // we are starting "in the middle" and either go up or down, depending what is closer
  while (res.length !== sorted.length) {
    const up = sorted[upper];
    const low = sorted[lower];
    const upVal = up ? up.value.data.left - iV : Infinity;
    const lowVal = low ? iV - low.value.data.right : Infinity;
    if (!low || (
    // including interval is (if contested) always closer or equal to any other interval
    upVal === lowVal ? up.value.data.leftInclude : upVal < lowVal)) {
      upper++;
      res.push(up);
    } else {
      lower--;
      res.push(low);
    }
  }
  return res;
};

/** Fills the empty selections and afterwards calculates new valid Options */
const fillAndCalcNewLockedState = (i, oldLockedState, empty) => {
  const res = findAndFillEmptySelections(i, oldLockedState.selections, oldLockedState.validOptions, empty);
  if (res) {
    const v = calcValidAndInvalidOptions(i, res);
    return {
      selections: res,
      validOptions: v.valid,
      invalidOptions: v.invalid,
      touched: oldLockedState.touched
    };
  } else {
    return false;
  }
};
/** Calculates a new valid locked state and afterwards recalculates the free selections as well.
 * This should only be necessary after adding or removing an instance.
 * Otherwise, free options can simply be kept
 * */
const fillAndCalcNewState = (i, oldState, empty) => {
  const res = oldState ? fillAndCalcNewLockedState(i, oldState.locked, empty) : fillAndCalcNewLockedState(i, {
    selections: [],
    validOptions: calcInitialOptions(i),
    touched: {},
    invalidOptions: {}
  });
  if (!res) return false;
  return calcAndFillAllFreeOptions(i, res, (oldState == null ? void 0 : oldState.free) || {
    selections: [],
    validOptions: {}
  });
};

/** Sets selections in old state and recalculate valid options if necessary. */
const setSelectionsInOldState = (i, oldState, selections, newOptions) => Object.assign({}, oldState, {
  locked: Object.assign({}, oldState.locked, {
    selections: selections,
    validOptions: newOptions ? calcInitialOptions(i) : oldState.locked.validOptions
  })
});
/** appends the selections to the oldState. */
const appendSelectionsInOldState = (oldState, selections) => Object.assign({}, oldState, {
  locked: Object.assign({}, oldState.locked, {
    selections: [...selections, ...oldState.locked.selections]
  })
});

/** Creates a valid state completely from scratch */
const fillInitial = input => {
  const initial = fillAndCalcNewState(input);
  if (!initial) return false;
  return {
    state: initial,
    changes: [],
    touchedChanges: [],
    onlyUntouched: true
  };
};

/** Builds a new state based on invalid selections.
 * Respect instances and trys to keep as much of the state as possible */
const buildNewStateForInvalidSelection = (input, oldState, invalidSelection, invalidInfo) => {
  // we want to keep our instances, so we calculate them manually (needed for empty)
  const instances = calcInstances(oldState.locked.selections);
  if (invalidSelection.instance.isInstanceLauncher) instances.push(invalidSelection);
  const empty = calcAllEmptySelections(input, [invalidSelection], instances, "locked");
  // We order our empty selections for the optimal runtime
  const [conflict, noConflict] = partition(empty, s => invalidInfo.conflicts.some(c => selectionsEqual(s, c)));
  const emptySelectionsInOrder = moveTouchedSelectionsToStart(input, [...noConflict, ...conflict], oldState.locked.touched);
  const options = calcOptionsForInvalidSelections(input, oldState.locked.selections, instances);
  const newLockedState = {
    selections: [invalidSelection],
    invalidOptions: {},
    validOptions: options,
    touched: oldState.locked.touched
  };
  return fillAndCalcNewState(input, Object.assign({}, oldState, {
    locked: newLockedState
  }), emptySelectionsInOrder);
};
/** Builds a new state based on valid selections. */
const calcStateFromCorrectSelections = (input, selections, touched) => {
  const {
    locked,
    free
  } = splitSelections(input, selections);
  const {
    valid,
    invalid
  } = calcValidAndInvalidOptions(input, locked);
  // create eventually missing selections
  const newLocked = fillAndCalcNewLockedState(input, {
    selections: locked,
    validOptions: valid,
    invalidOptions: invalid,
    touched
  });
  if (!newLocked) throw new Error("Unable to calc state");
  const filled = calcAndFillAllFreeOptions(input, newLocked, {
    selections: free,
    validOptions: {}
  });
  return {
    state: filled,
    changes: [],
    touchedChanges: [],
    onlyUntouched: true
  };
};
/** Builds a new state based on invalid selections. Trys to keep as much as possible */
const calcStateFromIncorrectSelections = (input, selections) => {
  const {
    locked,
    free
  } = splitSelections(input, selections);
  const instances = calcInstances(locked);
  const empty = calcAllEmptySelections(input, [], instances, "locked");
  const options = calcOptionsForInvalidSelections(input, locked, instances);
  const lockedState = {
    selections: [],
    invalidOptions: {},
    validOptions: options,
    touched: {}
  };
  const freeState = {
    selections: free,
    validOptions: {}
  };
  const filled = fillAndCalcNewState(input, mergeLockedAndFreeState(lockedState, freeState), empty);
  if (filled) {
    return {
      state: filled,
      changes: [],
      touchedChanges: [],
      onlyUntouched: true
    };
  } else {
    console.error("Unable to calc initial state based on invalid selections", input, selections);
    const initial = fillInitial(input);
    if (!initial) console.error("Unable to even calculate initial state. This is really bad.");
    return initial;
  }
};
const calcDiff = (oldState, newState, changed) => {
  if (oldState === false) return false;
  if (!oldState) return {
    state: newState,
    changes: [],
    touchedChanges: [],
    onlyUntouched: true,
    lastManualChange: changed
  };
  const changes = oldState.locked.selections.map(o => {
    // It's not reported as a change if we did this by purpose.
    if (changed && selectionHasSamePosition(o, changed)) return undefined;
    const inNewState = newState.locked.selections.find(n => selectionHasSamePosition(o, n));
    // we don't want to detect a change on a removed instance, as this can never happen by accident
    if (!inNewState) return undefined;
    // It's not a change if they still have the same value
    if (o.valueId === inNewState.valueId) return undefined;
    return [o, inNewState];
  }).filter(Boolean);
  const touched = changes.filter(c => {
    var _oldState$locked$touc;
    const old = c[0];
    return (_oldState$locked$touc = oldState.locked.touched[old.instance.id]) == null ? void 0 : _oldState$locked$touc.includes(old.variableId);
  });
  return {
    state: newState,
    // @ts-ignore
    changes,
    // @ts-ignore
    touchedChanges: touched,
    onlyUntouched: !touched.length,
    lastManualChange: changed
  };
};
/** Trys to create a new state based on previous selections only and respect it
 * as much as possible.
 */
const calcStateFromSelections = (input, oldSelections, checkSelections, touched) => {
  const selections = oldSelections.filter(s => {
    var _input$values$byVarId;
    return (_input$values$byVarId = input.values.byVarId.all[s.variableId]) == null ? void 0 : _input$values$byVarId.some(v => v.id === s.valueId);
  });
  selections.sort(sortByHierachyLevel);
  try {
    if (checkSelections) {
      const [isValid] = calcAreSelectionsValid(input, [], selections);
      if (isValid) {
        return calcStateFromCorrectSelections(input, selections, touched);
      } else {
        return calcStateFromIncorrectSelections(input, selections);
      }
    } else {
      return calcStateFromCorrectSelections(input, selections, touched);
    }
  } catch (e) {
    console.error(e);
    return calcStateFromIncorrectSelections(input, selections);
  }
};
const moveTouchedToStart = (input, state) => {
  const selections = moveTouchedSelectionsToStart(input, state.state.locked.selections, state.state.locked.touched);
  return Object.assign({}, state, {
    state: Object.assign({}, state.state, {
      locked: Object.assign({}, state.state.locked, {
        selections
      }),
      all: Object.assign({}, state.state.all, {
        selections: [...state.state.free.selections, ...selections]
      })
    })
  });
};
const moveTouchedSelectionsToStart = (input, selections, touched) => {
  const [touchedSelections, untouchedSelections] = partition(selections, selection => {
    var _touched$selection$in;
    return (_touched$selection$in = touched[selection.instance.id]) == null ? void 0 : _touched$selection$in.some(variableId => selection.variableId === variableId);
  });
  const [untouchedNonHidden, untouchedHidden] = partition(untouchedSelections, selection => {
    const variable = input.variables.byVarId.all[selection.variableId];
    if (!variable) return true;
    return !getTemplateOptions(variable).hideAlways;
  });
  const [launcher, noLauncher] = partition(touchedSelections, selection => selection.instance.isInstanceLauncher);
  return [...launcher, ...noLauncher, ...untouchedNonHidden, ...untouchedHidden];
};
const fixNumberInputData = (input, newState, prevState, manualChange) => {
  if (!prevState) return newState;
  const newSelections = newState.state.locked.selections.map(currentSelection => {
    if (isNumberSelection(currentSelection)) {
      var _oldSelection$data$in, _oldSelection$data, _currentSelection$dat, _currentSelection$dat2;
      /** In case we are restoring selections after a manual change, we want to
       * keep the input value of the manual change and NOT the outdated
       * inputValue in prevState, which is the go-to for all other number
       * variables.
       *
       * E.g.
       * - depth starts at 100
       * - manually changed to 400
       * - first iteration goes through
       * - restoring selections
       * - prevState is still at 100 (because we want to restore all variables
       *  to the input as close as possible to their start value)
       *  - next selection is still the interval (380-400. Input value of 100
       *  does not match the interval so we go for left border. Left border is
       *  380 but NON inclusive. So we increment by step and arrive at 390.
       * - manualChange is at 400
       * - use manualChange
       * - ?
       * - Profit
       */
      // TODO: This does not correctly account for number variables in multiplicity.
      // But this is kind of hard to do, because selectionIds might change during
      // restoration. This might be another problem.
      if (manualChange && (currentSelection == null ? void 0 : currentSelection.valueId) === (manualChange == null ? void 0 : manualChange.valueId)) {
        var _manualChange$data;
        return transform({
          data: {
            inputValue: (_manualChange$data = manualChange.data) == null ? void 0 : _manualChange$data.inputValue
          }
        })(currentSelection);
      }
      const oldSelection = prevState.state.locked.selections.find(os => selectionHasSamePosition(os, currentSelection));
      if (!oldSelection) return currentSelection;
      const variable = input.variables.byVarId.locked[currentSelection.variableId];
      const minimumDeviation = getMinimumDeviation(variable);
      const currentValue = input.values.byVarId.locked[currentSelection.variableId].find(v => v.id === currentSelection.valueId);
      const oldInputValue = (_oldSelection$data$in = (_oldSelection$data = oldSelection.data) == null ? void 0 : _oldSelection$data.inputValue) != null ? _oldSelection$data$in : 0,
        currentInputValue = (_currentSelection$dat = (_currentSelection$dat2 = currentSelection.data) == null ? void 0 : _currentSelection$dat2.inputValue) != null ? _currentSelection$dat : 0;
      let newInputValue;
      if (isAPartOfB(discreteInterval(oldInputValue), currentValue.data)) {
        newInputValue = oldInputValue;
      } else {
        var _currentSelection$dat3;
        if (oldInputValue < currentInputValue) {
          newInputValue = currentValue.data.left + (currentValue.data.leftInclude ? 0 : minimumDeviation);
        } else {
          newInputValue = currentValue.data.right - (currentValue.data.rightInclude ? 0 : minimumDeviation);
        }
        // it is possible that we overstepped if we only had a interval smaller
        // than the step size.
        if (!isAPartOfB(discreteInterval(newInputValue), currentValue.data)) newInputValue = (_currentSelection$dat3 = currentSelection.data) == null ? void 0 : _currentSelection$dat3.inputValue;
      }
      return transform({
        data: {
          inputValue: newInputValue
        }
      })(currentSelection);
    } else {
      return currentSelection;
    }
  });
  return Object.assign({}, newState, {
    state: mergeLockedAndFreeState(Object.assign({}, newState.state.locked, {
      selections: newSelections
    }), newState.state.free)
  });
};

const measureAndLogCriticalPerformance = (scope, critical) => {
  try {
    if (!performance.measure) return;
    performance.mark(`${scope}-end`);
    const perf = performance.measure(`${scope}-total`, `${scope}-start`, `${scope}-end`);
    if (!perf) return;
    if (perf.duration > (critical || 250)) {
      const entries = performance.getEntries();
      entries.forEach(entry => {
        if (entry.entryType === "mark") {
          console.warn(`Critical ${scope} Performance:`, entry.name, performance.measure(`${entry.name}-measure`, `${scope}-start`, entry.name).duration);
        }
      });
    }
    performance.clearMarks();
    performance.clearMeasures();
  } catch (e) {
    console.warn("No performance measured because of", e);
  }
};

/** Adds a new instance */
const addInstance = (input, state, parentInstance, value, sort, additionalData) => {
  var _state$locked$invalid, _state$locked$invalid2;
  if (!sort) {
    sort = getMaxInstanceSort(value.variableId, parentInstance.id, state.locked.selections) + 1;
  }
  const isInvalid = ((_state$locked$invalid = (_state$locked$invalid2 = state.locked.invalidOptions[parentInstance.id]) == null ? void 0 : _state$locked$invalid2[value.variableId]) != null ? _state$locked$invalid : []).find(o => o.value.id === value.id);
  const newInstance = createSelection(value.variableId, value, parentInstance.instance, true, additionalData, sort);
  let res;
  if (isInvalid) {
    res = buildNewStateForInvalidSelection(input, state, newInstance, isInvalid);
  } else {
    res = fillAndCalcNewState(input, appendSelectionsInOldState(state, [newInstance]));
  }
  if (!res) return false;
  res = addTouched(input, res, [{
    instanceId: newInstance.instance.id,
    variableId: newInstance.variableId
  }]);
  return calcDiff(state, res, newInstance);
};
/** Removes an instance */
const removeInstance = (input, state, instance) => {
  const thisAndChildren = [instance, ...findAllChildrenInstances(state.locked.selections, instance)];
  // removes this instance and all their children (and their children...)
  const newSelections = state.locked.selections.filter(s => !thisAndChildren.some(c => c.instance.id === s.instance.id));
  const res = fillAndCalcNewState(input, setSelectionsInOldState(input, state, newSelections, false));
  if (!res) return false;
  return {
    state: res,
    changes: [],
    onlyUntouched: true,
    touchedChanges: [],
    lastManualChange: undefined
  };
};
/** Changes a variable */
const changeVariable = (input, state, parentInstance, value, additionalData, touchHidden = false) => {
  var _state$locked$invalid3, _state$locked$invalid4;
  performance.mark("change-var-start");
  const isInvalid = (_state$locked$invalid3 = state.locked.invalidOptions[parentInstance.id]) == null ? void 0 : (_state$locked$invalid4 = _state$locked$invalid3[value.variableId]) == null ? void 0 : _state$locked$invalid4.find(o => o.value.id === value.id);
  const newSelection = createSelection(value.variableId, value, parentInstance.instance, false, additionalData);
  let res;
  const scope = input.variables.byVarId.free[newSelection.variableId] ? "free" : "locked";
  if (isInvalid) {
    res = buildNewStateForInvalidSelection(input, state, newSelection, isInvalid);
    performance.mark("change-var-invalid");
  } else {
    const withoutOld = state[scope].selections.filter(s => !selectionHasSamePosition(s, newSelection));
    const withNew = [newSelection, ...withoutOld];
    if (scope === "free") {
      res = mergeLockedAndFreeState(state.locked, Object.assign({}, state.free, {
        selections: withNew
      }));
    } else {
      const {
        valid,
        invalid
      } = calcValidAndInvalidOptions(input, withNew);
      res = mergeLockedAndFreeState({
        selections: withNew,
        validOptions: valid,
        invalidOptions: invalid,
        touched: state.locked.touched
      }, state.free);
    }
    performance.mark("change-var-valid");
  }
  if (!res) return false;
  res = addTouched(input, res, [{
    instanceId: newSelection.instance.id,
    variableId: newSelection.variableId
  }], touchHidden);
  const diffState = calcDiff(state, res, newSelection);
  measureAndLogCriticalPerformance("change-var");
  return diffState;
};
/** Trys to create a new state based on previous selections only and respect it
 * as much as possible.
 */
const restoreSelections = (input, selections, checkSelections, touched) => {
  const res = calcStateFromSelections(input, selections, checkSelections, touched);
  return Object.assign({}, res, {
    state: res.state
  });
};
/** Trys to change all variables in order. If something fails we just skip it */
const bulkChangeVariables = (input, initialState) => variableSet => {
  let newState = initialState;
  Object.entries(variableSet).forEach(([variableKey, valueKey]) => {
    const variable = input.variables.flat.all.find(v => v.key === variableKey);
    if (!variable) return;
    const isNumberVariable = variable.type === "number";
    const isTextVariable = variable.type === "text";
    const value = input.values.byVarId.all[variable.id].find(v => isNumberVariable ? isAPartOfB(discreteInterval(+valueKey), v.data) : isTextVariable ? true : v.key === valueKey);
    if (!value) return;
    // we have no way to know which instance it could belong to, so we take the first one
    const currentSelection = newState.state.all.selections.find(s => s.variableId === variable.id);
    if (!currentSelection) return;
    const parentInstance = newState.state.all.selections.find(s => s.id === currentSelection.instance.id) || rootSelection;
    const res = changeVariable(input, newState.state, parentInstance, value, isNumberVariable ? {
      inputValue: +valueKey
    } : isTextVariable ? {
      inputText: valueKey.toString()
    } : undefined, true);
    if (!res) return;
    newState = res;
  });
  return newState;
};

function isComponentVariable(variable) {
  return (variable == null ? void 0 : variable.type) === "components";
}

const getRuleItemsWithValidSelections = (rules, ruleItemsByRuleId, selections) => {
  const rulesById = indexById(rules);
  const selectionGroupedByVariableId = groupBy(selections, s => s.variableId);
  return Object.entries(ruleItemsByRuleId).flatMap(([ruleId, ruleItems]) => {
    const rule = rulesById[parseInt(ruleId)];
    const variableColumns = rule.columns.filter(isVariableColumn);
    return ruleItems.reduce((acc, ruleItem) => {
      const ruleItemsWithEnoughSelections = {
        selectionsByVariableId: {},
        rule,
        ruleItem
      };
      for (let i = 0; i < variableColumns.length; i++) {
        const column = variableColumns[i];
        const selectionsForVariable = selectionGroupedByVariableId[column.targetId];
        if (!selectionsForVariable || selectionsForVariable.length === 0) {
          return acc;
        }
        const validSelections = selectionsForVariable.filter(s => isSelectionValidForRuleItem(ruleItem, s));
        if (validSelections.length === 0) {
          return acc;
        }
        ruleItemsWithEnoughSelections.selectionsByVariableId[column.targetId] = validSelections;
      }
      if (variableColumns.length === 0) {
        ruleItemsWithEnoughSelections.selectionsByVariableId = {
          [rootSelection.variableId]: [rootSelection]
        };
      }
      acc.push(ruleItemsWithEnoughSelections);
      return acc;
    }, []);
  });
};
const transformToActiveRuleItemsInfo = ruleItemInfo => {
  return ruleItemInfo.reduce((acc, ruleItemInfo) => {
    acc.activeRuleItems.push(ruleItemInfo.ruleItem);
    acc.validSelectionCombinations[ruleItemInfo.ruleItem.id] = ruleItemInfo.validSelectionCombinations;
    if (ruleItemInfo.scopes) {
      acc.selectionScopes[ruleItemInfo.ruleItem.id] = ruleItemInfo.scopes;
    }
    return acc;
  }, {
    activeRuleItems: [],
    validSelectionCombinations: {},
    selectionScopes: {}
  });
};
const getActiveRuleItems = (actionEngineInput, ruleEngineInput, ruleEngineState) => {
  if (!ruleEngineState || !actionEngineInput) {
    return {
      activeRuleItems: [],
      validSelectionCombinations: {},
      selectionScopes: {}
    };
  }
  const ruleItems = actionEngineInput.ruleItems;
  const selections = filterVisibleSelections(ruleEngineInput)(ruleEngineState.state.all.selections);
  const ruleItemsWithEnoughSelections = getRuleItemsWithValidSelections(actionEngineInput.rules, ruleItems.byRuleId, selections);
  const ruleItemInfoWithScopes = addScopes(actionEngineInput.variables, selections, ruleItemsWithEnoughSelections);
  const result = transformToActiveRuleItemsInfo(createValidSelectionCombinations(ruleItemInfoWithScopes));
  return result;
};
const backTrackValidSelectionCombinations = ruleItemInfo => {
  let variableIds = ruleItemInfo.rule.columns.filter(isVariableColumn).map(c => c.targetId);
  // enable action only rules
  if (variableIds.length === 0) {
    variableIds = [rootSelection.variableId];
  }
  const isValidCombination = (selection, ruleItemInfo, path) => {
    return path.every(pathSelection => {
      var _scope$selection$vari;
      const scope = ruleItemInfo.scopes[pathSelection.id];
      return has$2(scope, selection.variableId) ? // If the variable is in the scope, check if the selection fits to the
      // previous scopes
      (_scope$selection$vari = scope[selection.variableId]) == null ? void 0 : _scope$selection$vari.find(s => s.id === selection.id) :
      // If the variable is not in the scope, it means that previous
      // selections have not excLuded it yet. So continue.
      true;
    });
  };
  const combinations = [];
  const maxLength = variableIds.length;
  const backtrackToCollectValidCombinations = function backtrackToCollectValidCombinations(startI, selectionPath) {
    if (selectionPath.length === maxLength) {
      combinations.push([...selectionPath]);
    } else {
      for (let i = startI; i < variableIds.length; i++) {
        const selections = ruleItemInfo.selectionsByVariableId[variableIds[i]];
        for (let j = 0; j < selections.length; j++) {
          if (!isValidCombination(selections[j], ruleItemInfo, selectionPath)) continue;
          selectionPath.push(selections[j]);
          backtrackToCollectValidCombinations(i + 1, selectionPath);
          selectionPath.pop();
        }
      }
    }
  };
  backtrackToCollectValidCombinations(0, []);
  return combinations;
};
const createValidSelectionCombinations = ruleItemInfoWithScopes => {
  const result = ruleItemInfoWithScopes.map(ruleItemInfo => {
    const validSelectionCombinations = backTrackValidSelectionCombinations(ruleItemInfo);
    return Object.assign({}, ruleItemInfo, {
      validSelectionCombinations
    });
  }).filter(r => r.validSelectionCombinations.length > 0);
  return result;
};
const ruleItemsToActions = (activeRuleItems, validSelectionCombinations, selectionScopes, actionEngineInput, ruleEngineInput, ruleEngineState, app, metadata) => {
  const result = {
    articles: [],
    colors: [],
    hideGroups: [],
    hideValues: [],
    hideVariables: [],
    concealVariables: [],
    concealGroups: [],
    images: [],
    instances: [],
    labels: [],
    models: [],
    materials: [],
    prints: []
  };
  const visibleSelections = filterVisibleSelections(ruleEngineInput)(ruleEngineState.state.all.selections);
  activeRuleItems.forEach(ruleItem => {
    const ruleForRuleItem = actionEngineInput.rules.find(rule => {
      return rule.id === ruleItem.ruleId;
    });
    const actionColumns = ruleForRuleItem.columns.filter(isActionColumn);
    Object.keys(ruleItem.values).filter(isUUID).forEach(key => {
      const actionEntry = ruleItem.values[key];
      const resultKey = actionObjectResultKeyMapper(actionEntry);
      if (resultKey && result[resultKey]) {
        const actionColumn = actionColumns.find(col => col.id === key);
        const actions = createActions(actionEntry, {
          column: actionColumn,
          ruleItem,
          rule: ruleForRuleItem,
          actionEngineInput,
          selections: visibleSelections,
          validSelectionCombinations,
          selectionScopes,
          ruleEngineInput,
          metadata
        });
        // In case of instances one entry can generate multiple actions on runtime
        if (isArray$6(actions)) {
          // @ts-ignore
          result[resultKey].push(...(actions != null ? actions : []));
        } else if (actions) {
          result[resultKey].push(actions);
        } else {
          console.warn("Action defined for non accesable variable: Might be hidden?");
        }
      } else {
        console.error(`Unknown actionEntry: ${resultKey} ${JSON.stringify(actionEntry)}`);
      }
    });
  });
  // Add global Model!
  if (app != null && app.modelId) {
    const model = metadata.models.find(m => m.id === app.modelId);
    if (model) {
      const [props, expressionProps] = evaluateModelExpressions(ruleEngineInput, visibleSelections, model);
      result.models.push({
        id: ActionIds.SetModel,
        modelId: app.modelId,
        model,
        props,
        expressionProps,
        anchoringSelection: rootSelection,
        ruleItem: null,
        ruleColumn: null
      });
    }
  }
  return result;
};
// Array mapper for objects in actionEngineState
const actionObjectResultKeyMapper = actionEntry => {
  switch (true) {
    case isLabelActionRuleValue(actionEntry):
      return "labels";
    case isModelActionRuleValue(actionEntry):
      return "models";
    case isColorActionRuleValue(actionEntry):
      return "colors";
    case isArticleActionRuleValue(actionEntry):
      return "articles";
    case isInstanceActionRuleValue(actionEntry):
      return "instances";
    case isImage2DActionRuleValue(actionEntry):
      return "images";
    case isHideVariableRuleValue(actionEntry):
      return "hideVariables";
    case isConcealVariableRuleValue(actionEntry):
      return "concealVariables";
    case isImageActionRuleValue(actionEntry):
      return "prints";
    case isHideGroupRuleValue(actionEntry):
      return "hideGroups";
    case isConcealGroupRuleValue(actionEntry):
      return "concealGroups";
    case isMaterialActionRuleValue(actionEntry):
      return "materials";
    case isHideValuesRuleValue(actionEntry):
      return "hideValues";
    default:
      return null;
  }
};
const createActions = (actionEntry, actionData) => {
  var _actionData$validSele;
  if (isColorActionRuleValue(actionEntry)) {
    return createColorActions(actionEntry, actionData);
  }
  if (isModelActionRuleValue(actionEntry)) {
    return createModelActions(actionEntry, actionData);
  }
  if (isImageActionRuleValue(actionEntry)) {
    return createPrintActions(actionEntry, actionData);
  }
  if (isArticleActionRuleValue(actionEntry)) {
    return createArticleActions(actionEntry, actionData);
  }
  if (isMaterialActionRuleValue(actionEntry)) {
    return createMaterialActions(actionEntry, actionData);
  }
  if (isConcealVariableRuleValue(actionEntry)) {
    return createVariableAction()(actionEntry, actionData);
  }
  if (isHideVariableRuleValue(actionEntry)) {
    return createVariableAction()(actionEntry, actionData);
  }
  if (isHideValuesRuleValue(actionEntry)) {
    return createHideValuesActions(actionEntry, actionData);
  }
  if (isInstanceActionRuleValue(actionEntry)) {
    return createInstanceActions(actionEntry, actionData);
  }
  return ((_actionData$validSele = actionData == null ? void 0 : actionData.validSelectionCombinations[actionData == null ? void 0 : actionData.ruleItem.id]) != null ? _actionData$validSele : []).map(selectionCombination => Object.assign({}, actionEntry, {
    ruleItem: actionData.ruleItem,
    ruleColumn: actionData.column,
    anchoringSelection: findSelectionWithHighestHierarchyLevel(selectionCombination)
  }));
};
function createScope(selection, selections, variablesByParentId, selectionsByVariableId) {
  const instances = findAllInstancesInLine(selections, selection);
  const variableSelectionMap = {};
  instances.forEach(instance => {
    var _variableSelectionMap;
    const childVariables = variablesByParentId[instance.variableId];
    if (!variableSelectionMap[instance.variableId]) variableSelectionMap[instance.variableId] = [];
    ((_variableSelectionMap = variableSelectionMap[instance.variableId]) != null ? _variableSelectionMap : []).push(instance);
    const result = (childVariables != null ? childVariables : []).forEach(childVariable => {
      var _selectionsByVariable;
      const childResult = ((_selectionsByVariable = selectionsByVariableId[childVariable.id]) == null ? void 0 : _selectionsByVariable.filter(selection => {
        const isChildSelection = isChildSelectionOfParent(instance)(selection);
        if (!isChildSelection) return false;
        const isNotSiblingOfInstance = !instances.some(inner => inner.variableId === selection.variableId);
        return isChildSelection && isNotSiblingOfInstance;
      })) || null;
      if (childResult === null) {
        variableSelectionMap[childVariable.id] = null;
      } else {
        var _variableSelectionMap2;
        variableSelectionMap[childVariable.id] = ((_variableSelectionMap2 = variableSelectionMap[childVariable.id]) != null ? _variableSelectionMap2 : []).concat(childResult);
      }
    }, {});
    return result;
  });
  return variableSelectionMap;
}
function addScopes(variables, selections, ruleItemsWithEnoughSelections) {
  const variablesById = indexById(variables);
  const variablesByParentId = groupBy(variables, v => v.parentId);
  const selectionsByVariableId = groupBy(selections, s => s.variableId);
  const globalScope = createScope(rootSelection, selections, variablesByParentId, selectionsByVariableId);
  return ruleItemsWithEnoughSelections.map(selectionInfo => {
    const scopes = selectionInfo.rule.columns.filter(isVariableColumn).reduce((outerAcc, column) => {
      const selectionsForVariable = selectionInfo.selectionsByVariableId[column.targetId];
      const variable = variablesById[column.targetId];
      // We dont need to compute the scope for non component variables on
      // root level since they all have the global scope.
      if (variable.parentId === rootSelection.variableId && !isComponentVariable(variable)) {
        return Object.assign({}, outerAcc, selectionsForVariable.reduce((acc, selection) => Object.assign({}, acc, {
          [selection.id]: globalScope
        }), {}));
      }
      return Object.assign({}, outerAcc, selectionsForVariable.reduce((acc, selection) => {
        const scope = createScope(selection, selections, variablesByParentId, selectionsByVariableId);
        return Object.assign({}, acc, {
          [selection.id]: scope
        });
      }, {}));
    }, {
      // If the rule has just action columns and no variable columns we need
      // to provide the global scope as the default.
      [rootSelection.id]: globalScope
    });
    return Object.assign({}, selectionInfo, {
      scopes
    });
  });
}
const createHideAndConcealActions = (variableIds, variablesById, ruleItem, selectionScopes, validCombinations, createAction) => validCombinations.flatMap(selections => {
  const selectionScope = createScopeFromSelections(selections, selectionScopes[ruleItem.id]);
  const hideActions = variableIds.reduce((newActions, variableId) => {
    const variable = variablesById[variableId];
    const parentId = variable != null && variable.parentId ? variable.parentId : rootSelection.variableId;
    const parentSelections = selectionScope[parentId];
    if (!parentSelections) {
      return newActions;
    }
    newActions.push(createAction(variableId, parentSelections.map(selection => selection.id).sort(), selections));
    return newActions;
  }, []);
  return hideActions;
}, []);
const createVariableAction = () => (actionEntry, {
  column,
  ruleItem,
  ruleEngineInput,
  selectionScopes,
  validSelectionCombinations
}) => {
  var _validSelectionCombin;
  const variableIds = actionEntry.variables;
  const variablesById = ruleEngineInput.variables.byVarId.all;
  const validCombinations = (_validSelectionCombin = validSelectionCombinations == null ? void 0 : validSelectionCombinations[ruleItem.id]) != null ? _validSelectionCombin : [];
  return createHideAndConcealActions(variableIds, variablesById, ruleItem, selectionScopes, validCombinations, (variableId, instanceIds) => ({
    variableId,
    instanceIds,
    ruleItem,
    ruleColumn: column
  }));
};
const createHideValuesActions = (actionEntry, {
  column,
  ruleItem,
  ruleEngineInput,
  selectionScopes,
  validSelectionCombinations
}) => {
  var _validSelectionCombin2;
  const valuesById = indexById(ruleEngineInput.values.flat.all);
  const variableIds = uniq(actionEntry.values.map(valueId => {
    var _valuesById$valueId;
    return (_valuesById$valueId = valuesById[valueId]) == null ? void 0 : _valuesById$valueId.variableId;
  }).filter(Boolean));
  const variablesById = ruleEngineInput.variables.byVarId.all;
  const validCombinations = (_validSelectionCombin2 = validSelectionCombinations == null ? void 0 : validSelectionCombinations[ruleItem.id]) != null ? _validSelectionCombin2 : [];
  const hideValuesActions = createHideAndConcealActions(variableIds, variablesById, ruleItem, selectionScopes, validCombinations, (variableId, instanceIds) => {
    return {
      variableId,
      valueIds: actionEntry.values.filter(valueId => valuesById[valueId].variableId === variableId),
      instanceIds,
      ruleItem,
      ruleColumn: column
    };
  });
  return hideValuesActions;
};
// We need to merge the target for the coloring into the actionEntry-Object
const createColorActions = (actionEntry, {
  ruleItem,
  column,
  selections,
  actionEngineInput
}) => {
  var _actionEngineInput$va;
  const activeSelectionForColorVariable = selections.find(selection => selection.variableId === actionEntry.variableId);
  // Variables might be hidden, even if referenced in Actions!
  if (!activeSelectionForColorVariable) return [];
  const targetId = column == null ? void 0 : column.targetId;
  const value = (_actionEngineInput$va = actionEngineInput.values.flat.find(value => {
    return value.id == activeSelectionForColorVariable.valueId;
  })) == null ? void 0 : _actionEngineInput$va.value;
  return [{
    targetMaterial: targetId,
    hex: value,
    ruleItem,
    ruleColumn: column
  }];
};
// We need to merge the target for the coloring into the actionEntry-Object
const createModelActions = (actionEntry, {
  validSelectionCombinations,
  ruleItem,
  column,
  rule,
  selections: allSelections,
  ruleEngineInput,
  metadata
}) => {
  const validCombinations = validSelectionCombinations[ruleItem.id];
  const modelActions = (validCombinations != null ? validCombinations : []).map(selections => {
    const model = metadata.models.find(m => m.id === actionEntry.modelId);
    if (!model) return null;
    const anchoringSelection = findSelectionWithHighestHierarchyLevel(selections);
    const [props, expressionProps] = evaluateModelExpressions(ruleEngineInput, allSelections, model, actionEntry, anchoringSelection);
    return Object.assign({}, actionEntry, {
      expressionProps,
      unique: `ruleItem_${ruleItem.id}_ruleId_${rule == null ? void 0 : rule.id}_modelId_${actionEntry.modelId}_anchoringSelectionId_${anchoringSelection.instance.id}`,
      ruleItem,
      ruleColumn: column,
      selections,
      props,
      model,
      anchoringSelection
    });
  }).filter(Boolean);
  return modelActions;
};
const evaluateModelProps = (ruleEngineInput, selections, anchoringSelection) => reduceExtra((acc, origValue, key) => {
  const valueIsArray = isArray$6(origValue);
  const valueArray = valueIsArray ? origValue : [origValue];
  const result = valueArray.map(value => {
    let res = 0;
    if (isExpression(value)) {
      const expRes = evaluateExpression(ruleEngineInput.variables.flat.all, ruleEngineInput.values.flat.all, selections, value.expression, anchoringSelection);
      if (expRes.errorMessage) console.error(expRes.errorMessage);
      if (expRes.result) res = expRes.result;
    } else {
      try {
        const valueAsNumber = +value;
        if (valueAsNumber || valueAsNumber === 0) {
          res = valueAsNumber;
        } else {
          res = value;
        }
      } catch (e) {
        console.error(e);
      }
    }
    return res;
  });
  return Object.assign({}, acc, {
    [key]: valueIsArray ? result : result[0]
  });
}, {});
const evaluateModelExpressions = (ruleEngineInput, selections, model, actionEntry, anchoringSelection = rootSelection) => {
  const dynamicModel = getDynamicModels().find(m => m.type === (model == null ? void 0 : model.dynamicModelKey));
  const props = Object.assign({}, dynamicModel == null ? void 0 : dynamicModel.defaultProps, model == null ? void 0 : model.props, actionEntry == null ? void 0 : actionEntry.props);
  const res = evaluateModelProps(ruleEngineInput, selections, anchoringSelection)(props);
  return [res, props];
};
function intersectArrays(objValue, srcValue) {
  if (isArray$6(objValue)) {
    return intersectionBy(objValue, srcValue, "id");
  }
}
const createScopeFromSelections = (selections, selectionScopes) => {
  return selections.reduce((acc, selection) => {
    const variableSelectionMap = selectionScopes[selection.id];
    return assignWith(acc, variableSelectionMap, intersectArrays);
  }, {});
};
const createPrintActions = (actionEntry, {
  column,
  selections,
  actionEngineInput,
  validSelectionCombinations,
  ruleItem,
  selectionScopes
}) => {
  const targetId = column == null ? void 0 : column.targetId;
  const variable = actionEngineInput.variables.find(variable => {
    return variable.id === actionEntry.variableId;
  });
  const variablesByParentId = groupBy(actionEngineInput.variables, variable => variable.parentId);
  const selectionsByVariableId = groupBy(selections, selection => selection.variableId);
  const allSelections = selections;
  const validCombinations = validSelectionCombinations[ruleItem.id];
  const printActions = (validCombinations != null ? validCombinations : []).reduce((acc, selections) => {
    var _selectionScope$actio;
    const selectionScope = createScopeFromSelections(selections, selectionScopes[ruleItem.id]);
    const possibleSelections = (_selectionScope$actio = selectionScope[actionEntry.variableId]) != null ? _selectionScope$actio : [];
    return [...acc, ...possibleSelections.map(activeSelectionForActionEntry => {
      var _activeSelectionForAc, _activeSelectionForAc2, _activeSelectionForAc3, _activeSelectionForAc4, _activeSelectionForAc5, _activeSelectionForAc6, _activeSelectionForAc7, _activeSelectionForAc8, _variable$settings$te;
      const activeSelectionScope = createScope(activeSelectionForActionEntry, allSelections, variablesByParentId, selectionsByVariableId);
      const restrictedScope = assignWith({}, selectionScope, activeSelectionScope, intersectArrays);
      return {
        targetMaterial: targetId,
        materialUrl: (_activeSelectionForAc = activeSelectionForActionEntry == null ? void 0 : (_activeSelectionForAc2 = activeSelectionForActionEntry.data) == null ? void 0 : _activeSelectionForAc2.url) != null ? _activeSelectionForAc : "",
        scale: (_activeSelectionForAc3 = activeSelectionForActionEntry == null ? void 0 : (_activeSelectionForAc4 = activeSelectionForActionEntry.data) == null ? void 0 : _activeSelectionForAc4.scale) != null ? _activeSelectionForAc3 : 1,
        topbottom: (_activeSelectionForAc5 = activeSelectionForActionEntry == null ? void 0 : (_activeSelectionForAc6 = activeSelectionForActionEntry.data) == null ? void 0 : _activeSelectionForAc6.topbottom) != null ? _activeSelectionForAc5 : 1,
        leftright: (_activeSelectionForAc7 = activeSelectionForActionEntry == null ? void 0 : (_activeSelectionForAc8 = activeSelectionForActionEntry.data) == null ? void 0 : _activeSelectionForAc8.leftright) != null ? _activeSelectionForAc7 : 1,
        hideOriginalMapWhenPrinting: variable == null ? void 0 : (_variable$settings$te = variable.settings.templateOptions) == null ? void 0 : _variable$settings$te.hideOriginalMapWhenPrinting,
        selections,
        selectionScope: restrictedScope,
        ruleItem,
        ruleColumn: column
      };
    })];
  }, []);
  return printActions;
};
const createArticleActions = (actionEntry, {
  column,
  validSelectionCombinations,
  ruleItem,
  rule
}) => {
  const validCombinations = validSelectionCombinations[ruleItem.id];
  return (validCombinations || []).map(selections => {
    var _rule$columns$find, _selections$find;
    const variableId = Number((column == null ? void 0 : column.targetId) || (rule == null ? void 0 : (_rule$columns$find = rule.columns.find(isVariableColumn)) == null ? void 0 : _rule$columns$find.targetId)) || undefined;
    return Object.assign({}, actionEntry, {
      variableId,
      selectionId: selections == null ? void 0 : (_selections$find = selections.find(s => s.variableId === variableId)) == null ? void 0 : _selections$find.id,
      anchoringSelection: findSelectionWithHighestHierarchyLevel(selections),
      ruleItem,
      ruleColumn: column
    });
  });
};
const createMaterialActions = (actionEntry, {
  column,
  ruleItem
}) => {
  const targets = column.targets;
  const materialActions = (targets == null ? void 0 : targets.map(target => {
    return Object.assign({}, target, {
      replacementMaterialId: actionEntry.materialId,
      ruleItem,
      ruleColumn: column
    });
  })) || [];
  return materialActions;
};
const createInstanceActions = (actionEntry, {
  column,
  ruleItem,
  validSelectionCombinations,
  selectionScopes,
  ruleEngineInput
}) => {
  const validCombinations = validSelectionCombinations[ruleItem.id];
  const variablesById = ruleEngineInput.variables.byVarId.all;
  const values = ruleEngineInput.values.flat.all;
  const valuesById = indexById(values);
  const instanceActions = (validCombinations != null ? validCombinations : []).reduce((acc, selections) => {
    const selectionScope = createScopeFromSelections(selections, selectionScopes[ruleItem.id]);
    const value = valuesById[actionEntry.valueId];
    if (!value) {
      // eslint-disable-next-line no-console
      console.warn(`Could not find value with id ${actionEntry.valueId} for actionEntry ${JSON.stringify(actionEntry, null, 2)} of ruleItem ${JSON.stringify(ruleItem, null, 2)}!`);
      return acc;
    }
    const variable = variablesById[value.variableId];
    if (!variable) {
      // eslint-disable-next-line no-console
      console.warn(`Could not find variable with id ${value.variableId} for value ${JSON.stringify(value, null, 2)}!`);
      return acc;
    }
    const parentId = variable.parentId ? variable.parentId : rootSelection.variableId;
    const parentSelections = selectionScope[parentId];
    if (!parentSelections) {
      return acc;
    }
    parentSelections.forEach(parentSelection => {
      acc.push(Object.assign({}, actionEntry, {
        selectionScope,
        parentSelection,
        anchoringSelection: findSelectionWithHighestHierarchyLevel(selections),
        ruleItem,
        ruleColumn: column
      }));
    });
    return acc;
  }, []);
  return instanceActions;
};

const getActiveActions = (actionEngineInput, ruleEngineInput, ruleEngineState, app, metadata) => {
  const {
    activeRuleItems,
    validSelectionCombinations,
    selectionScopes
  } = getActiveRuleItems(actionEngineInput, ruleEngineInput, ruleEngineState);
  return ruleItemsToActions(activeRuleItems, validSelectionCombinations, selectionScopes, actionEngineInput, ruleEngineInput, ruleEngineState, app, metadata);
};

/** Applies the expressionEngine onto a state */
const applyExpressionEngine = (ruleEngineInput, state) => {
  const sortedSelections = state.all.selections.slice().sort(sortBySort);
  const callbackSelections = applyCallback("setExpressionEngineSelections", sortedSelections);
  const evaluated = evaluateCalculatedVariables(ruleEngineInput.variables.flat.all, ruleEngineInput.values.flat.all, callbackSelections);
  const {
    free,
    locked
  } = splitSelections(ruleEngineInput, evaluated);
  const [calculatedSelections, uncalculatedSelections] = partition(locked, s => calculated(ruleEngineInput.variables.byVarId.locked[s.variableId]));
  const [valid] = calcAreSelectionsValid(ruleEngineInput, uncalculatedSelections, calculatedSelections);
  return {
    valid,
    state: mergeLockedAndFreeState(Object.assign({}, state.locked, {
      selections: locked
    }), {
      selections: free,
      validOptions: state.free.validOptions
    })
  };
};

var $$2 = _export;
var iterate = iterate$3;
var createProperty = createProperty$3;

// `Object.fromEntries` method
// https://github.com/tc39/proposal-object-from-entries
$$2({ target: 'Object', stat: true }, {
  fromEntries: function fromEntries(iterable) {
    var obj = {};
    iterate(iterable, function (k, v) {
      createProperty(obj, k, v);
    }, { AS_ENTRIES: true });
    return obj;
  }
});

const splitIntervals = (intervals, min, max) => {
  const bot = min ? Number(min) : -Infinity;
  const top = max ? Number(max) : Infinity;
  // combine all numbers  in array, including top and bot
  let numbers = [...intervals.flatMap(i => [i.left, i.right]), top, bot];
  // make sure they are unique
  // somehow I seem to need the sort callback explicitly when using -Infinity/Infinity
  numbers = uniq(numbers).sort((a, b) => a - b);
  // remove numbers out of min/max
  numbers = numbers.filter(n => n <= top && n >= bot);
  // create final intervals
  const orderedIntervals = numbers.slice(0, numbers.length - 1).flatMap((left, ind) => {
    const right = numbers[ind + 1];
    if (left === -Infinity) return [excludingInterval(left, right)];
    return [discreteInterval(left), excludingInterval(left, right)];
  });
  if (top !== Infinity) orderedIntervals.push(discreteInterval(top));
  return orderedIntervals;
};

const enginePreprocessor = (variables, removeActions) => data => {
  checkForDuplicateKeys(variables);
  let {
    values: newValues,
    ruleItems: newRuleItems,
    rules: newRules
  } = data;
  // make sure only active items are considered
  newRules = newRules.filter(rule => rule.isActive);
  newRuleItems = newRuleItems.filter(item => item.isActive);
  // kick all rule items out that have empty arrays.
  newRuleItems = newRuleItems.filter(item => !Object.values(item.values).some(val => isArray$6(val) && !val.length));
  // migrate old rule items to new ones, holding arrays of valueIds instead
  // of numbers
  // also sanitizing intervals
  newRuleItems = newRuleItems.map(item => Object.assign({}, item, {
    values: Object.fromEntries(Object.entries(item.values).map(([key, val]) => [key, isNumber(val) ? [val] : isIntervalRuleItemValue(val) ? Object.assign({}, val, {
      interval: sanitizeInterval(val.interval)
    }) : val]))
  }));
  newValues = newValues.slice().sort(byOrderAndCreation);
  // sort values. This makes sure the order in the table is applied to the rule
  // engine. It allows defining defaults and priorities of values by moving
  // them up in the table.
  // 1. and 2.
  const numberValues = generateMockValues(newValues, variables, newRuleItems);
  newValues = numberValues.newValues;
  // having the valid ids as an object is a quite impactfull
  // performance optimization for the filter in e.g. faber
  const validIds = indexById(newValues);
  // remove rule items mentioning a non existing value (because it was
  // removed via the action)
  // Otherwise all selections for that value are considered always valid which
  // causes hickups and performance issues
  newRuleItems = newRuleItems.filter(ri => Object.values(ri.values).every(val => {
    // valueIds
    if (isArray$6(val)) return val.some(v => validIds[v]);
    // actions, numbers etc.
    return true;
  }));
  if (removeActions) {
    newRules = newRules.filter(r => r.checkValidity);
  } else {
    newRules = newRules.filter(r => r.columns.some(col => !isVariableColumn(col)));
  }
  newRuleItems = newRuleItems.filter(ri => newRules.some(r => ri.ruleId === r.id));
  // 3. and 4.
  const preProc = preprocessAllRuleItems(newRules, newRuleItems, newValues, variables, removeActions);
  newRules = preProc.flat.rules;
  newRuleItems = preProc.flat.ruleItems;
  return {
    newRules,
    newRuleItems,
    newValues
  };
};
const generateMockValues = (values, variables, ruleItems) => {
  const createMockValue = mockValueFactory();
  // 4.
  // filter out old number values
  const newValues = values.filter(val => {
    var _variables$find;
    return ((_variables$find = variables.find(v => v.id === val.variableId)) == null ? void 0 : _variables$find.type) !== "number";
  });
  const n = generateNumberRuleItemsAndValues(ruleItems, newValues, variables, createMockValue);
  newValues.push(...n.additionalValues);
  // add mock Values for texts
  const generatedValues = variables.filter(v => v.type === "text").map(v => createMockValue(v));
  newValues.push(...generatedValues);
  return {
    newValues
  };
};
/** Creates mock Values, starting with index of -1. */
const mockValueFactory = () => {
  let i = -1;
  return (variable, data) => ({
    id: i--,
    appId: 0,
    variableId: variable.id,
    value: isInterval(data) ? intervalToString(data) : "",
    sort: 0,
    label: isInterval(data) ? intervalToString(data) : "",
    data
  });
};
/** Generates a map of values */
const generateValueMap = (variables, values) => {
  const vm = {};
  variables.forEach(v => {
    // @ts-ignore
    vm[v.id.toString()] = values.filter(val => val.variableId === v.id);
  });
  return vm;
};
/** Generates interval number rule items */
const generateNumberRuleItemsAndValues = (ruleItems, values, variables, createMockValue) => {
  const withInterval = filter$1(ruleItems, ri => Object.values(ri.values).some(v => isIntervalRuleItemValue(v)));
  // generate interval values for each variable
  const additionalValues = variables.filter(v => v.type === "number").flatMap(variable => {
    const {
      min,
      max
    } = getMinMaxTemplateOptions(variable);
    const itemsForVariable = withInterval.filter(ri => !!ri.values[variable.id]);
    let intervals = itemsForVariable.flatMap(ri => Object.keys(ri.values).map(k => {
      if (Number(k) !== variable.id) return false;
      const v = ri.values[k];
      return isIntervalRuleItemValue(v) ? v.interval : false;
    })).filter(Boolean);
    intervals = splitIntervals(intervals, min, max);
    intervals = mergeValueIntervals(variable, intervals, itemsForVariable);
    intervals = removeUnnecessaryIntervals(variable, intervals);
    return intervals.map(i => createMockValue(variable, i));
  });
  return {
    additionalValues
  };
};
/** The idea is: If two values are used in exactly the same rule items,
 * they can be merged together.
 * This creates fewer values and thus saves on iteration depth. */
const mergeValueIntervals = (variable, intervals, ruleItemsForVariable) => {
  if (!ruleItemsForVariable.length) return intervals;
  const intervalsWithItemIds = intervals.map(interval => ({
    interval,
    items: ruleItemsForVariable.filter(i => isAPartOfB(interval, i.values[variable.id].interval)).map(i => i.id)
  }));
  let identicalUsedIntervals = [];
  const mergedIntervals = [];
  for (const valWithItems of intervalsWithItemIds) {
    if (!identicalUsedIntervals.length) {
      identicalUsedIntervals.push(valWithItems);
    } else if (isEqual(identicalUsedIntervals[0].items, valWithItems.items)) {
      identicalUsedIntervals.push(valWithItems);
    } else {
      // this value is different, meaning all values before were equal.
      // Let's combine them
      mergedIntervals.push(mergeConnectedIntervals(identicalUsedIntervals.map(v => v.interval)));
      identicalUsedIntervals = [valWithItems];
    }
  }
  // we need to do it one more time for the remaining values
  mergedIntervals.push(mergeConnectedIntervals(identicalUsedIntervals.map(v => v.interval)));
  return mergedIntervals;
};
/** We remove unnecessary open interval values if the step size is explicitly
 * set to a natural number */
const removeUnnecessaryIntervals = (variable, intervals) => {
  const minimumDeviation = getMinimumDeviation(variable);
  if (minimumDeviation && !(minimumDeviation % 1)) {
    return intervals.filter(i => !(!i.leftInclude && !i.rightInclude && i.right === i.left + 1));
  }
  return intervals;
};
const checkForDuplicateKeys = variables => variables.forEach(variable => {
  if (!variable.key) return;
  const conflict = variables.find(v => v.key === variable.key && v.id !== variable.id);
  if (conflict) {
    console.error(`${variable.label} and ${conflict.label} have the same key.`, variable, conflict);
  }
});

const createHiddenValuesMap = actionEngineState => {
  if (!actionEngineState) {
    return {};
  }
  const hideValueActions = actionEngineState.hideValues;
  return hideValueActions.reduce((acc, action) => {
    var _action$instanceIds;
    return merge$1(acc, ((_action$instanceIds = action.instanceIds) != null ? _action$instanceIds : []).reduce((innerAcc, instanceId) => {
      innerAcc[instanceId] = action.valueIds.reduce((a, valueId) => {
        a[valueId] = true;
        return a;
      }, {});
      return innerAcc;
    }, {}));
  }, {});
};
const createHiddenOrConcealedVariablesMap = hideActions => {
  return hideActions.reduce((acc, action) => {
    var _action$instanceIds2;
    const current = acc[action.variableId];
    if (current === true) {
      return acc;
    }
    return merge$1(acc, {
      [action.variableId]: ((_action$instanceIds2 = action.instanceIds) == null ? void 0 : _action$instanceIds2.reduce((a, instanceId) => Object.assign({}, a, {
        [instanceId]: true
      }), {})) || true
    });
  }, {});
};
const createConcealedVariablesMap = (variables, actionEngineState) => {
  if (!actionEngineState) {
    return {};
  }
  const concealVariableActions = [...actionEngineState.concealVariables, ...actionEngineState.concealGroups.flatMap(concealGroupAction => variables.filter(variable => concealGroupAction.groups.some(groupId => groupId === variable.groupId)).map(variable => ({
    variableId: variable.id,
    ruleItem: concealGroupAction.ruleItem,
    ruleColumn: concealGroupAction.ruleColumn
  })))];
  return createHiddenOrConcealedVariablesMap(concealVariableActions);
};
const createHiddenVariablesMap = (variables, actionEngineState) => {
  if (!actionEngineState) {
    return {};
  }
  const hideVariableActions = [...actionEngineState.hideVariables, ...actionEngineState.hideGroups.flatMap(hideGroupAction => variables.filter(variable => hideGroupAction.groups.some(groupId => groupId === variable.groupId)).map(variable => ({
    variableId: variable.id,
    ruleItem: hideGroupAction.ruleItem,
    ruleColumn: hideGroupAction.ruleColumn
  })))];
  return createHiddenOrConcealedVariablesMap(hideVariableActions);
};
/** Preprocess rules, ruleItems, values and variables to the RuleEngineInput.
 * It does a couple of things:
 * 1. Create Intervals for numbers (we do it that early because we need the values
 *    to be distinct for the action engine. Otherwise the rule Engine would show
 *    0-10, while the action engine needs to know whether it is 0-5 or 5-10
 * 2. Creates mock values for variables that need one, e.g. text or number variables
 *    without any already present values. Used to store their input as additionalData.
 * 3. Remove actions from ruleItems and rules
 * 4. Create every necessary ruleItem for "Alle Werte"/*. This might actually
 *    not be necessary anymore.
 * 5. Determine rules that only have a single column anymore.
 *    Most likely previous action rules.
 *    Remove them and their rule items.
 *    If they didn't list every possible value, remove the not listed values as well.
 * 6. Split variables in locked and free variables. Locked variables are all
 *    variables that need to be considered in the core rule engine algorithms.
 *    They either take presence in the rules/ruleItems that are left or launch instances.
 *    Free variables are the rest aka "irrelevant" variables.
 * 7. Calculate locked/free values (a locked value belongs to a locked variable)
 *    and create Records (with variableId as key) for faster access of them
 */
const ruleEnginePreprocessor = (rules, ruleItems, allValues, variables, lastActionEngineState, lastInput) => {
  if (lastInput) {
    return Object.assign({}, lastInput, {
      hiddenValuesMap: createHiddenValuesMap(lastActionEngineState),
      concealedVariablesMap: createConcealedVariablesMap(variables, lastActionEngineState),
      hiddenVariablesMap: createHiddenVariablesMap(variables, lastActionEngineState)
    });
  }
  const {
    newRules,
    newRuleItems,
    newItemsById,
    newValues,
    newVariables
  } = flow(enginePreprocessor(variables, true), determineRemovals(variables))({
    rules,
    ruleItems,
    values: allValues
  });
  // 6.
  // all variables that don't belong to any rule are "free".
  const [lockedVariables, freeVariables] = partition(newVariables, v => isMultiVariable(v) || newRules.some(r => r.columns.some(c => c.targetId === v.id)));
  const isLocked = val => lockedVariables.some(v => v.id === val.variableId);
  // all values that belong to locked variables are locked.
  const [lockedValues, freeValues] = partition(newValues, isLocked);
  const lockedValueMap = generateValueMap(lockedVariables, lockedValues),
    freeValueMap = generateValueMap(freeVariables, freeValues),
    allValueMap = generateValueMap(newVariables, newValues);
  /** This sorts the variables with the most values to the end.
   * This means they will be changed first in backtracking.
   */
  const sortedFreeVars = sortVars(freeVariables, newRules),
    sortedLockedVars = sortVars(lockedVariables, newRules),
    sortedVars = sortVars(newVariables, newRules);
  return {
    rules: newRules,
    ruleItems: {
      flat: newRuleItems,
      byRuleId: newItemsById
    },
    variables: {
      flat: {
        free: sortedFreeVars,
        locked: sortedLockedVars,
        all: sortedVars
      },
      byVarId: {
        free: indexById(sortedFreeVars),
        locked: indexById(sortedLockedVars),
        all: indexById(sortedVars)
      }
    },
    values: {
      byVarId: {
        free: freeValueMap,
        locked: lockedValueMap,
        all: allValueMap
      },
      flat: {
        free: freeValues,
        locked: lockedValues,
        all: newValues
      }
    },
    hiddenVariablesMap: createHiddenVariablesMap(variables, lastActionEngineState),
    hiddenValuesMap: createHiddenValuesMap(lastActionEngineState),
    concealedVariablesMap: createHiddenValuesMap(lastActionEngineState)
  };
};
/** This puts the most often in rules used variables at the beginning.
 *
 * This makes sense because of the assumption, that they fail quickly and thus
 * should be checked first.
 */
const sortVars = (variables, rules) => {
  const withCounts = variables.map(variable => ({
    variable,
    count: rules.filter(r => r.columns.some(c => c.targetId === variable.id)).length
  }));
  withCounts.sort((a, b) => b.count - a.count);
  return withCounts.map(w => w.variable);
};
const findValuesForNumberRuleItem = valsByVarId => (v, varId) => uniq(valsByVarId[+varId].filter(val =>
// Both is possible. A value spans a larger interval then the rule item,
// because it was merged or the rule items spans a larger interval because it was split further by other rule items
isAPartOfB(val.data, v.interval) || isAPartOfB(v.interval, val.data)).map(val => val.id));
/** Determines unnecessary rules/ruleItems (step 3. of preprocessor) */
const determineRemovals = variables => data => {
  const {
    newRules: rules,
    newValues: values,
    newRuleItems: ruleItems
  } = data;
  const valsByVarId = groupBy(values, v => v.variableId);
  const findNumberValues = findValuesForNumberRuleItem(valsByVarId);
  const byId = groupBy(ruleItems, ri => ri.ruleId);
  const confirmedValueIds = {};
  rules.forEach(rule => {
    const variableIds = rule.columns.map(c => c.targetId);
    const items = byId[rule.id];
    variableIds.forEach(varId => {
      // we will deal with empty rules later
      if (!items) return;
      const valueIds = items.flatMap(i => {
        const v = i.values[varId];
        return isIntervalRuleItemValue(v) ? findNumberValues(v, varId) : v;
      });
      if (!valueIds.includes(true)) {
        confirmedValueIds[varId] = confirmedValueIds[varId] ? intersection(valueIds, confirmedValueIds[varId]) : valueIds;
      }
    });
  });
  const [newValues, removedValues] = partition(values, v => {
    const confirmedVals = confirmedValueIds[v.variableId];
    if (!confirmedVals) return true;
    return confirmedVals.some(vid => vid === v.id);
  });
  const newValuesByVariable = groupBy(newValues, v => v.variableId);
  const [newVariables, removedVariables] = partition(variables, v => newValues.some(val => val.variableId === v.id));
  // these are values that are not empty but have no valid values left
  const invalidNonEmptyValues = removedVariables.filter(v => removedValues.some(val => val.variableId === v.id));
  if ((invalidNonEmptyValues == null ? void 0 : invalidNonEmptyValues.length) > 0) {
    // When a variable has no valid values left, to free work from the ruleEngine we fail early here
    throw new Error("Folgende Merkmale haben keine gültigen Werte mehr: " + invalidNonEmptyValues.map(v => v.label).join(", "));
  }
  const newItemsById = {};
  const newRules = [];
  rules.forEach(rule => {
    const newCols = rule.columns.filter(col => !removedVariables.some(v => v.id === col.targetId));
    if (newCols.length <= 1) return;
    const items = (byId[rule.id] || []).map(i => {
      if (newCols.length === rule.columns.length) {
        return i;
      } else {
        const newValues = {};
        const originalValueEntries = Object.entries(i.values);
        originalValueEntries.forEach(([key, itemValues]) => {
          if (isArray$6(itemValues)) {
            const forVar = newValuesByVariable[key] || [];
            const remaining = itemValues.filter(vId => forVar.some(val => val.id === vId));
            if (remaining.length) newValues[key] = remaining;
          } else {
            newValues[key] = itemValues;
          }
        });
        // we deleted out a column. This invalidates the entire rule item
        if (Object.entries(newValues).length !== originalValueEntries.length) return false;
        return Object.assign({}, i, {
          values: newValues
        });
      }
    }).filter(Boolean);
    if (!items.length) return;
    newRules.push(Object.assign({}, rule, {
      columns: newCols
    }));
    newItemsById[rule.id] = items;
  });
  const newRuleItems = Object.values(newItemsById).flat();
  return {
    newValues,
    newRules,
    newItemsById,
    newRuleItems,
    newVariables
  };
};

function sumUpInstanceCounts(instanceActions, variables, values, selections) {
  const instanceActionsByValueId = groupBy(instanceActions || [], i => i.valueId);
  return map$1(instanceActionsByValueId, instanceActions => {
    const count = instanceActions.reduce((acc, instanceAction) => {
      if (instanceAction.expression) {
        const {
          result
        } = evaluateExpression(variables, values, selections, instanceAction.expression, instanceAction.anchoringSelection);
        return acc + result;
      } else {
        var _instanceAction$count;
        acc += (_instanceAction$count = instanceAction.count) != null ? _instanceAction$count : 0;
      }
      return acc;
    }, 0);
    return {
      valueId: instanceActions[0].valueId,
      // it is possible that expressions add a negative amount.
      // This prevents everything from crashing.
      count: Math.max(count, 0)
    };
  });
}
const addOrRemoveInstances = (parentInstance, instanceCounts, ruleEngineInput, valuesById, ruleEngineState) => {
  return instanceCounts.reduce((newRuleEngineState, instanceCount) => {
    const currentSelections = ruleEngineState.state.all.selections;
    const instances = currentSelections.filter(s => s.valueId === instanceCount.valueId && s.instance.belongsToInstanceId === parentInstance.instance.id);
    const diff = instanceCount.count - instances.length;
    if (diff > 0) {
      let creationState = newRuleEngineState;
      for (let i = 0; i < diff; i++) {
        const result = addInstance(ruleEngineInput, creationState.state, parentInstance, valuesById[instanceCount.valueId]);
        if (result) {
          creationState = result;
        } else {
          console.error(`Could not create instance for value.id: ${instanceCount.valueId}`);
        }
      }
      return creationState;
    } else if (diff < 0) {
      let deletionState = newRuleEngineState;
      const deleteCount = diff * -1;
      for (let i = 0; i < deleteCount; i++) {
        const result = removeInstance(ruleEngineInput, deletionState.state, instances[i]);
        if (result) {
          deletionState = result;
        } else {
          throw new Error(`Could not delete instance for value.id: ${instanceCount.valueId}`);
        }
      }
      return deletionState;
    }
    return newRuleEngineState;
  }, ruleEngineState);
};
function applyInstanceActions(actionEngineState, ruleEngineInput, ruleEngineState) {
  const selections = ruleEngineState.state.all.selections;
  const selectionsById = indexById(selections);
  const variables = ruleEngineInput.variables.flat.all;
  const values = ruleEngineInput.values.flat.all;
  const valuesById = indexById(values);
  const instanceActionsBySelectionId = groupBy(actionEngineState.instances, i => i.parentSelection.id);
  const newRuleEngineState = reduce$1(instanceActionsBySelectionId, (accRuleEngineState, instanceActions, selectionId) => {
    var _selectionsById$selec;
    const parentSelection = (_selectionsById$selec = selectionsById[selectionId]) != null ? _selectionsById$selec : rootSelection;
    const instanceCounts = !isEmpty(instanceActions) ? sumUpInstanceCounts(instanceActions, variables, values, selections) : [];
    accRuleEngineState = addOrRemoveInstances(parentSelection, instanceCounts, ruleEngineInput, valuesById, accRuleEngineState);
    return accRuleEngineState;
  }, ruleEngineState);
  return newRuleEngineState;
}
function removeOrphanedInstances(ruleEngineInput, ruleEngineState) {
  const selections = ruleEngineState.state.all.selections;
  const selectionsById = indexById(selections);
  const selectionTree = findAllInstancesInLine(selections, rootSelection);
  const selectionTreeById = indexById(selectionTree);
  return selections.reduce((newState, selection) => {
    if (isInstanceSelection(selection) &&
    // If the selection is not part of the tree starting at the root
    // selection and
    !selectionTreeById[selection.instance.id] &&
    // if the parent selection does not exist anymore
    !selectionsById[selection.instance.belongsToInstanceId]) {
      const innerState = removeInstance(ruleEngineInput, newState.state, selection);
      if (innerState) {
        return innerState;
      } else {
        throw new Error(`Could not delete orphaned instance: ${selection}`);
      }
    }
    return newState;
  }, ruleEngineState);
}
function executeInstanceActions(ruleEngineInput, ruleEngineState, actionEngineState) {
  let newRuleEngineState = applyInstanceActions(actionEngineState, ruleEngineInput, ruleEngineState);
  newRuleEngineState = removeOrphanedInstances(ruleEngineInput, newRuleEngineState);
  return newRuleEngineState;
}

const RuleEngineIterationLimit = 16;
const areHideActionsEqual = (previousActionEngineState, nextActionEngineState) => {
  const previousHideVariableActions = previousActionEngineState.hideVariables;
  const nextHideVariableActions = nextActionEngineState.hideVariables;
  const isTheHideVariableActionCountEqual = previousHideVariableActions.length === nextHideVariableActions.length;
  if (!isTheHideVariableActionCountEqual) {
    return false;
  }
  const previousHideGroupActions = previousActionEngineState.hideGroups;
  const nextHideGroupActions = nextActionEngineState.hideGroups;
  const isTheHideGroupActionCountEqual = previousHideGroupActions.length === nextHideGroupActions.length;
  if (!isTheHideGroupActionCountEqual) {
    return false;
  }
  const areHideVariableActionsEqual = equals(sortBy(previousHideVariableActions, ["variableId", "instanceIds"]), sortBy(nextHideVariableActions, ["variableId", "instanceIds"]));
  if (!areHideVariableActionsEqual) {
    return false;
  }
  const areHideGroupActionsEqual = equals(sortBy(previousHideGroupActions, ["groups"]), sortBy(nextHideGroupActions, ["groups"]));
  if (!areHideGroupActionsEqual) {
    return false;
  }
  return true;
};
const areInstancesEqual = (previousRuleEngineState, nextRuleEngineState) => {
  const previousInstances = findAllChildrenInstances(previousRuleEngineState.state.all.selections, rootSelection);
  const nextInstances = findAllChildrenInstances(nextRuleEngineState.state.all.selections, rootSelection);
  return isEqual(previousInstances, nextInstances);
};
/** This sets a new rule engine state. It works like this:
 *
 * - Changes to a variable request an update to the engines via
 * "provisionalRuleEngineState".
 * - In a loop: We recalculate the new action engine input and state and check,
 * if we need to recalculate the rule engine input and thus state as well
 * (because of removed values/variables). This is currently limited to 5
 * iterations to prevent an infinte loop.
 * In case of a touched conflict we submit the whole engine state to the user,
 * who can then decide whether they want to accept this or deny it
 * via the ruleEngineConflict state.
 * After we found a new stable state (and the user accepted it), we settle it.
 * Only then the UI is rerendered. This is a MASSIVE performance boost as
 * otherwise we would have rerendered the entire UI every iteration which is
 * terrible.
 *
 */
const setStableEngineState = (newRuleEngineState, newRuleEngineInput, newActionEngineInput) => (dispatch, getState) => {
  performance.mark("engine-start");
  const state = getState();
  const frontendApp = selectFrontendApp(state);
  const metadata = state.metadata;
  const rules = selectRules(state);
  const variables = selectVariables(state);
  const values = selectValues(state);
  const ruleItems = selectRuleItems(state);
  const ruleEngineInput = newRuleEngineInput || selectRuleEngineInput(state);
  const nextActionEngineInput = newActionEngineInput || selectActionEngineInput(state);
  const ruleEngineState = selectRuleEngineState(state);
  let nextActionEngineState = selectActionEngineState(state) || emptyActionEngineState;
  let nextRuleEngineInput = ruleEngineInput;
  let nextRuleEngineState = newRuleEngineState;
  performance.mark("engine-selectors");
  let i = 0;
  while (i < RuleEngineIterationLimit) {
    nextRuleEngineState = moveTouchedToStart(nextRuleEngineInput, nextRuleEngineState);
    nextRuleEngineState = fixNumberInputData(nextRuleEngineInput, nextRuleEngineState, ruleEngineState != null ? ruleEngineState : undefined, newRuleEngineState == null ? void 0 : newRuleEngineState.lastManualChange);
    performance.mark(`engine-fixing-numbers-${i}`);
    const {
      valid,
      state: _state
    } = applyExpressionEngine(ruleEngineInput, nextRuleEngineState.state);
    nextRuleEngineState = Object.assign({}, nextRuleEngineState, {
      state: _state
    });
    const previousRuleEngineState = nextRuleEngineState;
    performance.mark(`engine-expression-${i}`);
    // If the expression engine state is invalid we can skip all of this
    // and continue calculating a valid rule and expression engine state,
    // before the action engine kicks in as well
    if (valid) {
      const previousActionEngineState = nextActionEngineState;
      // calc new action engine state
      nextActionEngineState = getActiveActions(nextActionEngineInput, nextRuleEngineInput, nextRuleEngineState, frontendApp, metadata);
      performance.mark(`engine-action-state-${i}`);
      // add instances if necessary
      nextRuleEngineState = executeInstanceActions(nextRuleEngineInput, nextRuleEngineState, nextActionEngineState);
      moveTouchedToStart(nextRuleEngineInput, nextRuleEngineState);
      performance.mark(`engine-instance-actions-${i}`);
      performance.mark(`engine-calc-hidden-${i}`);
      // recalculate the rule engine input
      nextRuleEngineInput = ruleEnginePreprocessor(rules, ruleItems, values, variables, nextActionEngineState, nextRuleEngineInput);
      // we break the loop if we did not have any changes to the rule input.
      if (areHideActionsEqual(previousActionEngineState, nextActionEngineState) && areInstancesEqual(previousRuleEngineState, nextRuleEngineState)) {
        // recalculate state one more time to respect valid Options after expression run.
        nextRuleEngineState = restoreSelections(nextRuleEngineInput, nextRuleEngineState.state.all.selections, false, nextRuleEngineState.state.all.touched);
        moveTouchedToStart(nextRuleEngineInput, nextRuleEngineState);
        performance.mark(`engine-rule-state-${i}`);
        break;
      }
      performance.mark(`engine-rule-input-${i}`);
    }
    // and recalculate the state
    nextRuleEngineState = restoreSelections(nextRuleEngineInput, nextRuleEngineState.state.all.selections, true, nextRuleEngineState.state.all.touched);
    moveTouchedToStart(nextRuleEngineInput, nextRuleEngineState);
    performance.mark(`engine-rule-state-${i}`);
    i++;
    // now we continue recalculating the action engine input...
  }
  // This is bad. But hopefully should never happen.
  if (i === RuleEngineIterationLimit) {
    throw new Error(t("Maximale Anzahl an Iterationen erreicht! Die Regelkonflikte können nicht aufgelöst werden."));
  }
  nextRuleEngineState = markInstanceLaunchersAsTouched(nextRuleEngineInput, nextRuleEngineState);
  // calc what changed between the initial and the settled state
  const newStateWithDiff = calcDiff(ruleEngineState == null ? void 0 : ruleEngineState.state, nextRuleEngineState.state, newRuleEngineState == null ? void 0 : newRuleEngineState.lastManualChange);
  measureAndLogCriticalPerformance("engine");
  if (!newStateWithDiff) return {
    status: "error"
  };
  const engineState = {
    ruleEngineInput: nextRuleEngineInput,
    ruleEngineState: newStateWithDiff,
    actionEngineInput: nextActionEngineInput,
    actionEngineState: nextActionEngineState
  };
  // directly commit it or ask the user to do it.
  if (newStateWithDiff.onlyUntouched) {
    dispatch(setEngineState(engineState));
    return {
      status: "no-conflict",
      newState: engineState
    };
  } else {
    dispatch(setRuleEngineConflict(engineState));
    return {
      status: "conflict",
      newState: engineState
    };
  }
};

const errorStatus = {
  status: "error"
};
const removeInstanceThunk = instance => (dispatch, getState) => {
  const {
    ruleEngineInput,
    ruleEngineState
  } = selectRuleEngineInfo(getState());
  if (!ruleEngineInput || !ruleEngineState) {
    console.warn("Rule engine not initialized!");
    return errorStatus;
  }
  const res = removeInstance(ruleEngineInput, ruleEngineState.state, instance);
  return dispatch(applyRuleEngineStateThunk(res));
};
const addInstanceThunk = (value, parentInstance) => (dispatch, getState) => {
  const {
    ruleEngineInput,
    ruleEngineState,
    openInstance
  } = selectRuleEngineInfo(getState());
  if (!ruleEngineInput || !ruleEngineState) {
    console.warn("Rule engine not initialized!");
    return errorStatus;
  }
  const res = addInstance(ruleEngineInput, ruleEngineState.state, parentInstance || openInstance, value);
  return dispatch(applyRuleEngineStateThunk(res));
};
const changeVariableThunk = (value, variableId, additionalData, parentInstance) => (dispatch, getState) => {
  const {
    ruleEngineInput,
    ruleEngineState,
    openInstance
  } = selectRuleEngineInfo(getState());
  if (!ruleEngineInput || !ruleEngineState) {
    console.warn("Rule engine not initialized!");
    return;
  }
  const valueFromId = ruleEngineInput.values.flat.all.find(v => v.id === value);
  const properValue = valueFromId || ruleEngineInput.values.byVarId.all[variableId][0];
  const res = changeVariable(ruleEngineInput, ruleEngineState.state, parentInstance || openInstance, properValue, additionalData);
  const engineResult = dispatch(applyRuleEngineStateThunk(res));
  dispatch(analyticsTrackChangeThunk(variableId, properValue));
  return engineResult;
};
const applyRuleEngineStateThunk = res => dispatch => {
  if (res) {
    return dispatch(setStableEngineState(res));
  } else {
    console.error("Rule engine failed");
    return errorStatus;
  }
};

// eslint-disable-next-line es/no-typed-arrays -- safe
var arrayBufferBasicDetection = typeof ArrayBuffer != 'undefined' && typeof DataView != 'undefined';

var toIntegerOrInfinity$2 = toIntegerOrInfinity$a;
var toLength$3 = toLength$9;

var $RangeError$2 = RangeError;

// `ToIndex` abstract operation
// https://tc39.es/ecma262/#sec-toindex
var toIndex$2 = function (it) {
  if (it === undefined) return 0;
  var number = toIntegerOrInfinity$2(it);
  var length = toLength$3(number);
  if (number !== length) throw $RangeError$2('Wrong length or index');
  return length;
};

// IEEE754 conversions based on https://github.com/feross/ieee754
var $Array = Array;
var abs = Math.abs;
var pow = Math.pow;
var floor$1 = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;

var pack = function (number, mantissaLength, bytes) {
  var buffer = $Array(bytes);
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var rt = mantissaLength === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var sign = number < 0 || number === 0 && 1 / number < 0 ? 1 : 0;
  var index = 0;
  var exponent, mantissa, c;
  number = abs(number);
  // eslint-disable-next-line no-self-compare -- NaN check
  if (number != number || number === Infinity) {
    // eslint-disable-next-line no-self-compare -- NaN check
    mantissa = number != number ? 1 : 0;
    exponent = eMax;
  } else {
    exponent = floor$1(log(number) / LN2);
    c = pow(2, -exponent);
    if (number * c < 1) {
      exponent--;
      c *= 2;
    }
    if (exponent + eBias >= 1) {
      number += rt / c;
    } else {
      number += rt * pow(2, 1 - eBias);
    }
    if (number * c >= 2) {
      exponent++;
      c /= 2;
    }
    if (exponent + eBias >= eMax) {
      mantissa = 0;
      exponent = eMax;
    } else if (exponent + eBias >= 1) {
      mantissa = (number * c - 1) * pow(2, mantissaLength);
      exponent = exponent + eBias;
    } else {
      mantissa = number * pow(2, eBias - 1) * pow(2, mantissaLength);
      exponent = 0;
    }
  }
  while (mantissaLength >= 8) {
    buffer[index++] = mantissa & 255;
    mantissa /= 256;
    mantissaLength -= 8;
  }
  exponent = exponent << mantissaLength | mantissa;
  exponentLength += mantissaLength;
  while (exponentLength > 0) {
    buffer[index++] = exponent & 255;
    exponent /= 256;
    exponentLength -= 8;
  }
  buffer[--index] |= sign * 128;
  return buffer;
};

var unpack = function (buffer, mantissaLength) {
  var bytes = buffer.length;
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var nBits = exponentLength - 7;
  var index = bytes - 1;
  var sign = buffer[index--];
  var exponent = sign & 127;
  var mantissa;
  sign >>= 7;
  while (nBits > 0) {
    exponent = exponent * 256 + buffer[index--];
    nBits -= 8;
  }
  mantissa = exponent & (1 << -nBits) - 1;
  exponent >>= -nBits;
  nBits += mantissaLength;
  while (nBits > 0) {
    mantissa = mantissa * 256 + buffer[index--];
    nBits -= 8;
  }
  if (exponent === 0) {
    exponent = 1 - eBias;
  } else if (exponent === eMax) {
    return mantissa ? NaN : sign ? -Infinity : Infinity;
  } else {
    mantissa = mantissa + pow(2, mantissaLength);
    exponent = exponent - eBias;
  } return (sign ? -1 : 1) * mantissa * pow(2, exponent - mantissaLength);
};

var ieee754 = {
  pack: pack,
  unpack: unpack
};

var toObject$2 = toObject$c;
var toAbsoluteIndex$1 = toAbsoluteIndex$4;
var lengthOfArrayLike$3 = lengthOfArrayLike$d;

// `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill
var arrayFill$1 = function fill(value /* , start = 0, end = @length */) {
  var O = toObject$2(this);
  var length = lengthOfArrayLike$3(O);
  var argumentsLength = arguments.length;
  var index = toAbsoluteIndex$1(argumentsLength > 1 ? arguments[1] : undefined, length);
  var end = argumentsLength > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex$1(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};

var global$7 = global$w;
var uncurryThis$4 = functionUncurryThis;
var DESCRIPTORS$2 = descriptors;
var NATIVE_ARRAY_BUFFER$1 = arrayBufferBasicDetection;
var FunctionName = functionName;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$9;
var defineBuiltInAccessor$2 = defineBuiltInAccessor$6;
var defineBuiltIns = defineBuiltIns$2;
var fails$6 = fails$A;
var anInstance$1 = anInstance$5;
var toIntegerOrInfinity$1 = toIntegerOrInfinity$a;
var toLength$2 = toLength$9;
var toIndex$1 = toIndex$2;
var IEEE754 = ieee754;
var getPrototypeOf$1 = objectGetPrototypeOf;
var setPrototypeOf$2 = objectSetPrototypeOf;
var getOwnPropertyNames$1 = objectGetOwnPropertyNames.f;
var arrayFill = arrayFill$1;
var arraySlice$1 = arraySliceSimple;
var setToStringTag = setToStringTag$6;
var InternalStateModule$2 = internalState;

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH$1 = 'Wrong length';
var WRONG_INDEX = 'Wrong index';
var getInternalArrayBufferState = InternalStateModule$2.getterFor(ARRAY_BUFFER);
var getInternalDataViewState = InternalStateModule$2.getterFor(DATA_VIEW);
var setInternalState$1 = InternalStateModule$2.set;
var NativeArrayBuffer = global$7[ARRAY_BUFFER];
var $ArrayBuffer = NativeArrayBuffer;
var ArrayBufferPrototype$1 = $ArrayBuffer && $ArrayBuffer[PROTOTYPE];
var $DataView = global$7[DATA_VIEW];
var DataViewPrototype$1 = $DataView && $DataView[PROTOTYPE];
var ObjectPrototype$1 = Object.prototype;
var Array$1 = global$7.Array;
var RangeError$3 = global$7.RangeError;
var fill = uncurryThis$4(arrayFill);
var reverse = uncurryThis$4([].reverse);

var packIEEE754 = IEEE754.pack;
var unpackIEEE754 = IEEE754.unpack;

var packInt8 = function (number) {
  return [number & 0xFF];
};

var packInt16 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF];
};

var packInt32 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF, number >> 16 & 0xFF, number >> 24 & 0xFF];
};

var unpackInt32 = function (buffer) {
  return buffer[3] << 24 | buffer[2] << 16 | buffer[1] << 8 | buffer[0];
};

var packFloat32 = function (number) {
  return packIEEE754(number, 23, 4);
};

var packFloat64 = function (number) {
  return packIEEE754(number, 52, 8);
};

var addGetter$1 = function (Constructor, key, getInternalState) {
  defineBuiltInAccessor$2(Constructor[PROTOTYPE], key, {
    configurable: true,
    get: function () {
      return getInternalState(this)[key];
    }
  });
};

var get = function (view, count, index, isLittleEndian) {
  var intIndex = toIndex$1(index);
  var store = getInternalDataViewState(view);
  if (intIndex + count > store.byteLength) throw RangeError$3(WRONG_INDEX);
  var bytes = store.bytes;
  var start = intIndex + store.byteOffset;
  var pack = arraySlice$1(bytes, start, start + count);
  return isLittleEndian ? pack : reverse(pack);
};

var set = function (view, count, index, conversion, value, isLittleEndian) {
  var intIndex = toIndex$1(index);
  var store = getInternalDataViewState(view);
  if (intIndex + count > store.byteLength) throw RangeError$3(WRONG_INDEX);
  var bytes = store.bytes;
  var start = intIndex + store.byteOffset;
  var pack = conversion(+value);
  for (var i = 0; i < count; i++) bytes[start + i] = pack[isLittleEndian ? i : count - i - 1];
};

if (!NATIVE_ARRAY_BUFFER$1) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance$1(this, ArrayBufferPrototype$1);
    var byteLength = toIndex$1(length);
    setInternalState$1(this, {
      type: ARRAY_BUFFER,
      bytes: fill(Array$1(byteLength), 0),
      byteLength: byteLength
    });
    if (!DESCRIPTORS$2) {
      this.byteLength = byteLength;
      this.detached = false;
    }
  };

  ArrayBufferPrototype$1 = $ArrayBuffer[PROTOTYPE];

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance$1(this, DataViewPrototype$1);
    anInstance$1(buffer, ArrayBufferPrototype$1);
    var bufferState = getInternalArrayBufferState(buffer);
    var bufferLength = bufferState.byteLength;
    var offset = toIntegerOrInfinity$1(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError$3('Wrong offset');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength$2(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError$3(WRONG_LENGTH$1);
    setInternalState$1(this, {
      type: DATA_VIEW,
      buffer: buffer,
      byteLength: byteLength,
      byteOffset: offset,
      bytes: bufferState.bytes
    });
    if (!DESCRIPTORS$2) {
      this.buffer = buffer;
      this.byteLength = byteLength;
      this.byteOffset = offset;
    }
  };

  DataViewPrototype$1 = $DataView[PROTOTYPE];

  if (DESCRIPTORS$2) {
    addGetter$1($ArrayBuffer, 'byteLength', getInternalArrayBufferState);
    addGetter$1($DataView, 'buffer', getInternalDataViewState);
    addGetter$1($DataView, 'byteLength', getInternalDataViewState);
    addGetter$1($DataView, 'byteOffset', getInternalDataViewState);
  }

  defineBuiltIns(DataViewPrototype$1, {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined)) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 23);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 52);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packInt8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packInt8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packFloat32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packFloat64, value, arguments.length > 2 ? arguments[2] : undefined);
    }
  });
} else {
  var INCORRECT_ARRAY_BUFFER_NAME = PROPER_FUNCTION_NAME && NativeArrayBuffer.name !== ARRAY_BUFFER;
  /* eslint-disable no-new -- required for testing */
  if (!fails$6(function () {
    NativeArrayBuffer(1);
  }) || !fails$6(function () {
    new NativeArrayBuffer(-1);
  }) || fails$6(function () {
    new NativeArrayBuffer();
    new NativeArrayBuffer(1.5);
    new NativeArrayBuffer(NaN);
    return NativeArrayBuffer.length != 1 || INCORRECT_ARRAY_BUFFER_NAME && !CONFIGURABLE_FUNCTION_NAME;
  })) {
    /* eslint-enable no-new -- required for testing */
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance$1(this, ArrayBufferPrototype$1);
      return new NativeArrayBuffer(toIndex$1(length));
    };

    $ArrayBuffer[PROTOTYPE] = ArrayBufferPrototype$1;

    for (var keys = getOwnPropertyNames$1(NativeArrayBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) {
        createNonEnumerableProperty$2($ArrayBuffer, key, NativeArrayBuffer[key]);
      }
    }

    ArrayBufferPrototype$1.constructor = $ArrayBuffer;
  } else if (INCORRECT_ARRAY_BUFFER_NAME && CONFIGURABLE_FUNCTION_NAME) {
    createNonEnumerableProperty$2(NativeArrayBuffer, 'name', ARRAY_BUFFER);
  }

  // WebKit bug - the same parent prototype for typed arrays and data view
  if (setPrototypeOf$2 && getPrototypeOf$1(DataViewPrototype$1) !== ObjectPrototype$1) {
    setPrototypeOf$2(DataViewPrototype$1, ObjectPrototype$1);
  }

  // iOS Safari 7.x bug
  var testView = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = uncurryThis$4(DataViewPrototype$1.setInt8);
  testView.setInt8(0, 2147483648);
  testView.setInt8(1, 2147483649);
  if (testView.getInt8(0) || !testView.getInt8(1)) defineBuiltIns(DataViewPrototype$1, {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8(this, byteOffset, value << 24 >> 24);
    }
  }, { unsafe: true });
}

setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);

var arrayBuffer = {
  ArrayBuffer: $ArrayBuffer,
  DataView: $DataView
};

var $$1 = _export;
var uncurryThis$3 = functionUncurryThisClause;
var fails$5 = fails$A;
var ArrayBufferModule$1 = arrayBuffer;
var anObject = anObject$k;
var toAbsoluteIndex = toAbsoluteIndex$4;
var toLength$1 = toLength$9;
var speciesConstructor = speciesConstructor$3;

var ArrayBuffer$3 = ArrayBufferModule$1.ArrayBuffer;
var DataView$2 = ArrayBufferModule$1.DataView;
var DataViewPrototype = DataView$2.prototype;
var nativeArrayBufferSlice = uncurryThis$3(ArrayBuffer$3.prototype.slice);
var getUint8 = uncurryThis$3(DataViewPrototype.getUint8);
var setUint8 = uncurryThis$3(DataViewPrototype.setUint8);

var INCORRECT_SLICE = fails$5(function () {
  return !new ArrayBuffer$3(2).slice(1, undefined).byteLength;
});

// `ArrayBuffer.prototype.slice` method
// https://tc39.es/ecma262/#sec-arraybuffer.prototype.slice
$$1({ target: 'ArrayBuffer', proto: true, unsafe: true, forced: INCORRECT_SLICE }, {
  slice: function slice(start, end) {
    if (nativeArrayBufferSlice && end === undefined) {
      return nativeArrayBufferSlice(anObject(this), start); // FF fix
    }
    var length = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    var result = new (speciesConstructor(this, ArrayBuffer$3))(toLength$1(fin - first));
    var viewSource = new DataView$2(this);
    var viewTarget = new DataView$2(result);
    var index = 0;
    while (first < fin) {
      setUint8(viewTarget, index++, getUint8(viewSource, first++));
    } return result;
  }
});

var typedArrayConstructor = {exports: {}};

var NATIVE_ARRAY_BUFFER = arrayBufferBasicDetection;
var DESCRIPTORS$1 = descriptors;
var global$6 = global$w;
var isCallable = isCallable$q;
var isObject$2 = isObject$g;
var hasOwn$1 = hasOwnProperty_1;
var classof$3 = classof$c;
var tryToString = tryToString$6;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$9;
var defineBuiltIn = defineBuiltIn$d;
var defineBuiltInAccessor$1 = defineBuiltInAccessor$6;
var isPrototypeOf$1 = objectIsPrototypeOf;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf$1 = objectSetPrototypeOf;
var wellKnownSymbol = wellKnownSymbol$o;
var uid = uid$3;
var InternalStateModule$1 = internalState;

var enforceInternalState$1 = InternalStateModule$1.enforce;
var getInternalState$1 = InternalStateModule$1.get;
var Int8Array$4 = global$6.Int8Array;
var Int8ArrayPrototype$1 = Int8Array$4 && Int8Array$4.prototype;
var Uint8ClampedArray$1 = global$6.Uint8ClampedArray;
var Uint8ClampedArrayPrototype = Uint8ClampedArray$1 && Uint8ClampedArray$1.prototype;
var TypedArray$1 = Int8Array$4 && getPrototypeOf(Int8Array$4);
var TypedArrayPrototype$1 = Int8ArrayPrototype$1 && getPrototypeOf(Int8ArrayPrototype$1);
var ObjectPrototype = Object.prototype;
var TypeError$1 = global$6.TypeError;

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var TYPED_ARRAY_TAG$1 = uid('TYPED_ARRAY_TAG');
var TYPED_ARRAY_CONSTRUCTOR = 'TypedArrayConstructor';
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var NATIVE_ARRAY_BUFFER_VIEWS$2 = NATIVE_ARRAY_BUFFER && !!setPrototypeOf$1 && classof$3(global$6.opera) !== 'Opera';
var TYPED_ARRAY_TAG_REQUIRED = false;
var NAME, Constructor, Prototype;

var TypedArrayConstructorsList = {
  Int8Array: 1,
  Uint8Array: 1,
  Uint8ClampedArray: 1,
  Int16Array: 2,
  Uint16Array: 2,
  Int32Array: 4,
  Uint32Array: 4,
  Float32Array: 4,
  Float64Array: 8
};

var BigIntArrayConstructorsList = {
  BigInt64Array: 8,
  BigUint64Array: 8
};

var isView = function isView(it) {
  if (!isObject$2(it)) return false;
  var klass = classof$3(it);
  return klass === 'DataView'
    || hasOwn$1(TypedArrayConstructorsList, klass)
    || hasOwn$1(BigIntArrayConstructorsList, klass);
};

var getTypedArrayConstructor = function (it) {
  var proto = getPrototypeOf(it);
  if (!isObject$2(proto)) return;
  var state = getInternalState$1(proto);
  return (state && hasOwn$1(state, TYPED_ARRAY_CONSTRUCTOR)) ? state[TYPED_ARRAY_CONSTRUCTOR] : getTypedArrayConstructor(proto);
};

var isTypedArray$1 = function (it) {
  if (!isObject$2(it)) return false;
  var klass = classof$3(it);
  return hasOwn$1(TypedArrayConstructorsList, klass)
    || hasOwn$1(BigIntArrayConstructorsList, klass);
};

var aTypedArray$4 = function (it) {
  if (isTypedArray$1(it)) return it;
  throw TypeError$1('Target is not a typed array');
};

var aTypedArrayConstructor$2 = function (C) {
  if (isCallable(C) && (!setPrototypeOf$1 || isPrototypeOf$1(TypedArray$1, C))) return C;
  throw TypeError$1(tryToString(C) + ' is not a typed array constructor');
};

var exportTypedArrayMethod$4 = function (KEY, property, forced, options) {
  if (!DESCRIPTORS$1) return;
  if (forced) for (var ARRAY in TypedArrayConstructorsList) {
    var TypedArrayConstructor = global$6[ARRAY];
    if (TypedArrayConstructor && hasOwn$1(TypedArrayConstructor.prototype, KEY)) try {
      delete TypedArrayConstructor.prototype[KEY];
    } catch (error) {
      // old WebKit bug - some methods are non-configurable
      try {
        TypedArrayConstructor.prototype[KEY] = property;
      } catch (error2) { /* empty */ }
    }
  }
  if (!TypedArrayPrototype$1[KEY] || forced) {
    defineBuiltIn(TypedArrayPrototype$1, KEY, forced ? property
      : NATIVE_ARRAY_BUFFER_VIEWS$2 && Int8ArrayPrototype$1[KEY] || property, options);
  }
};

var exportTypedArrayStaticMethod = function (KEY, property, forced) {
  var ARRAY, TypedArrayConstructor;
  if (!DESCRIPTORS$1) return;
  if (setPrototypeOf$1) {
    if (forced) for (ARRAY in TypedArrayConstructorsList) {
      TypedArrayConstructor = global$6[ARRAY];
      if (TypedArrayConstructor && hasOwn$1(TypedArrayConstructor, KEY)) try {
        delete TypedArrayConstructor[KEY];
      } catch (error) { /* empty */ }
    }
    if (!TypedArray$1[KEY] || forced) {
      // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
      try {
        return defineBuiltIn(TypedArray$1, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS$2 && TypedArray$1[KEY] || property);
      } catch (error) { /* empty */ }
    } else return;
  }
  for (ARRAY in TypedArrayConstructorsList) {
    TypedArrayConstructor = global$6[ARRAY];
    if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) {
      defineBuiltIn(TypedArrayConstructor, KEY, property);
    }
  }
};

for (NAME in TypedArrayConstructorsList) {
  Constructor = global$6[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) enforceInternalState$1(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
  else NATIVE_ARRAY_BUFFER_VIEWS$2 = false;
}

for (NAME in BigIntArrayConstructorsList) {
  Constructor = global$6[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) enforceInternalState$1(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
}

// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!NATIVE_ARRAY_BUFFER_VIEWS$2 || !isCallable(TypedArray$1) || TypedArray$1 === Function.prototype) {
  // eslint-disable-next-line no-shadow -- safe
  TypedArray$1 = function TypedArray() {
    throw TypeError$1('Incorrect invocation');
  };
  if (NATIVE_ARRAY_BUFFER_VIEWS$2) for (NAME in TypedArrayConstructorsList) {
    if (global$6[NAME]) setPrototypeOf$1(global$6[NAME], TypedArray$1);
  }
}

if (!NATIVE_ARRAY_BUFFER_VIEWS$2 || !TypedArrayPrototype$1 || TypedArrayPrototype$1 === ObjectPrototype) {
  TypedArrayPrototype$1 = TypedArray$1.prototype;
  if (NATIVE_ARRAY_BUFFER_VIEWS$2) for (NAME in TypedArrayConstructorsList) {
    if (global$6[NAME]) setPrototypeOf$1(global$6[NAME].prototype, TypedArrayPrototype$1);
  }
}

// WebKit bug - one more object in Uint8ClampedArray prototype chain
if (NATIVE_ARRAY_BUFFER_VIEWS$2 && getPrototypeOf(Uint8ClampedArrayPrototype) !== TypedArrayPrototype$1) {
  setPrototypeOf$1(Uint8ClampedArrayPrototype, TypedArrayPrototype$1);
}

if (DESCRIPTORS$1 && !hasOwn$1(TypedArrayPrototype$1, TO_STRING_TAG)) {
  TYPED_ARRAY_TAG_REQUIRED = true;
  defineBuiltInAccessor$1(TypedArrayPrototype$1, TO_STRING_TAG, {
    configurable: true,
    get: function () {
      return isObject$2(this) ? this[TYPED_ARRAY_TAG$1] : undefined;
    }
  });
  for (NAME in TypedArrayConstructorsList) if (global$6[NAME]) {
    createNonEnumerableProperty$1(global$6[NAME], TYPED_ARRAY_TAG$1, NAME);
  }
}

var arrayBufferViewCore = {
  NATIVE_ARRAY_BUFFER_VIEWS: NATIVE_ARRAY_BUFFER_VIEWS$2,
  TYPED_ARRAY_TAG: TYPED_ARRAY_TAG_REQUIRED && TYPED_ARRAY_TAG$1,
  aTypedArray: aTypedArray$4,
  aTypedArrayConstructor: aTypedArrayConstructor$2,
  exportTypedArrayMethod: exportTypedArrayMethod$4,
  exportTypedArrayStaticMethod: exportTypedArrayStaticMethod,
  getTypedArrayConstructor: getTypedArrayConstructor,
  isView: isView,
  isTypedArray: isTypedArray$1,
  TypedArray: TypedArray$1,
  TypedArrayPrototype: TypedArrayPrototype$1
};

/* eslint-disable no-new -- required for testing */

var global$5 = global$w;
var fails$4 = fails$A;
var checkCorrectnessOfIteration = checkCorrectnessOfIteration$2;
var NATIVE_ARRAY_BUFFER_VIEWS$1 = arrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;

var ArrayBuffer$2 = global$5.ArrayBuffer;
var Int8Array$3 = global$5.Int8Array;

var typedArrayConstructorsRequireWrappers = !NATIVE_ARRAY_BUFFER_VIEWS$1 || !fails$4(function () {
  Int8Array$3(1);
}) || !fails$4(function () {
  new Int8Array$3(-1);
}) || !checkCorrectnessOfIteration(function (iterable) {
  new Int8Array$3();
  new Int8Array$3(null);
  new Int8Array$3(1.5);
  new Int8Array$3(iterable);
}, true) || fails$4(function () {
  // Safari (11+) bug - a reason why even Safari 13 should load a typed array polyfill
  return new Int8Array$3(new ArrayBuffer$2(2), 1, undefined).length !== 1;
});

var isObject$1 = isObject$g;

var floor = Math.floor;

// `IsIntegralNumber` abstract operation
// https://tc39.es/ecma262/#sec-isintegralnumber
// eslint-disable-next-line es/no-number-isinteger -- safe
var isIntegralNumber$1 = Number.isInteger || function isInteger(it) {
  return !isObject$1(it) && isFinite(it) && floor(it) === it;
};

var toIntegerOrInfinity = toIntegerOrInfinity$a;

var $RangeError$1 = RangeError;

var toPositiveInteger$1 = function (it) {
  var result = toIntegerOrInfinity(it);
  if (result < 0) throw $RangeError$1("The argument can't be less than 0");
  return result;
};

var toPositiveInteger = toPositiveInteger$1;

var $RangeError = RangeError;

var toOffset$2 = function (it, BYTES) {
  var offset = toPositiveInteger(it);
  if (offset % BYTES) throw $RangeError('Wrong offset');
  return offset;
};

var classof$2 = classof$c;

var isBigIntArray$1 = function (it) {
  var klass = classof$2(it);
  return klass == 'BigInt64Array' || klass == 'BigUint64Array';
};

var toPrimitive = toPrimitive$2;

var $TypeError = TypeError;

// `ToBigInt` abstract operation
// https://tc39.es/ecma262/#sec-tobigint
var toBigInt$2 = function (argument) {
  var prim = toPrimitive(argument, 'number');
  if (typeof prim == 'number') throw $TypeError("Can't convert number to bigint");
  // eslint-disable-next-line es/no-bigint -- safe
  return BigInt(prim);
};

var bind$1 = functionBindContext;
var call$3 = functionCall;
var aConstructor = aConstructor$2;
var toObject$1 = toObject$c;
var lengthOfArrayLike$2 = lengthOfArrayLike$d;
var getIterator = getIterator$4;
var getIteratorMethod = getIteratorMethod$5;
var isArrayIteratorMethod = isArrayIteratorMethod$3;
var isBigIntArray = isBigIntArray$1;
var aTypedArrayConstructor$1 = arrayBufferViewCore.aTypedArrayConstructor;
var toBigInt$1 = toBigInt$2;

var typedArrayFrom$1 = function from(source /* , mapfn, thisArg */) {
  var C = aConstructor(this);
  var O = toObject$1(source);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod(O);
  var i, length, result, thisIsBigIntArray, value, step, iterator, next;
  if (iteratorMethod && !isArrayIteratorMethod(iteratorMethod)) {
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    O = [];
    while (!(step = call$3(next, iterator)).done) {
      O.push(step.value);
    }
  }
  if (mapping && argumentsLength > 2) {
    mapfn = bind$1(mapfn, arguments[2]);
  }
  length = lengthOfArrayLike$2(O);
  result = new (aTypedArrayConstructor$1(C))(length);
  thisIsBigIntArray = isBigIntArray(result);
  for (i = 0; length > i; i++) {
    value = mapping ? mapfn(O[i], i) : O[i];
    // FF30- typed arrays doesn't properly convert objects to typed array values
    result[i] = thisIsBigIntArray ? toBigInt$1(value) : +value;
  }
  return result;
};

var bind = functionBindContext;
var uncurryThis$2 = functionUncurryThis;
var IndexedObject = indexedObject;
var toObject = toObject$c;
var lengthOfArrayLike$1 = lengthOfArrayLike$d;
var arraySpeciesCreate = arraySpeciesCreate$3;

var push = uncurryThis$2([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that);
    var length = lengthOfArrayLike$1(self);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

var arrayIteration = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};

var $ = _export;
var global$4 = global$w;
var call$2 = functionCall;
var DESCRIPTORS = descriptors;
var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = typedArrayConstructorsRequireWrappers;
var ArrayBufferViewCore$4 = arrayBufferViewCore;
var ArrayBufferModule = arrayBuffer;
var anInstance = anInstance$5;
var createPropertyDescriptor = createPropertyDescriptor$6;
var createNonEnumerableProperty = createNonEnumerableProperty$9;
var isIntegralNumber = isIntegralNumber$1;
var toLength = toLength$9;
var toIndex = toIndex$2;
var toOffset$1 = toOffset$2;
var toPropertyKey = toPropertyKey$4;
var hasOwn = hasOwnProperty_1;
var classof$1 = classof$c;
var isObject = isObject$g;
var isSymbol = isSymbol$3;
var create = objectCreate;
var isPrototypeOf = objectIsPrototypeOf;
var setPrototypeOf = objectSetPrototypeOf;
var getOwnPropertyNames = objectGetOwnPropertyNames.f;
var typedArrayFrom = typedArrayFrom$1;
var forEach = arrayIteration.forEach;
var setSpecies = setSpecies$3;
var defineBuiltInAccessor = defineBuiltInAccessor$6;
var definePropertyModule = objectDefineProperty;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var InternalStateModule = internalState;
var inheritIfRequired = inheritIfRequired$2;

var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var enforceInternalState = InternalStateModule.enforce;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var round = Math.round;
var RangeError$2 = global$4.RangeError;
var ArrayBuffer$1 = ArrayBufferModule.ArrayBuffer;
var ArrayBufferPrototype = ArrayBuffer$1.prototype;
var DataView$1 = ArrayBufferModule.DataView;
var NATIVE_ARRAY_BUFFER_VIEWS = ArrayBufferViewCore$4.NATIVE_ARRAY_BUFFER_VIEWS;
var TYPED_ARRAY_TAG = ArrayBufferViewCore$4.TYPED_ARRAY_TAG;
var TypedArray = ArrayBufferViewCore$4.TypedArray;
var TypedArrayPrototype = ArrayBufferViewCore$4.TypedArrayPrototype;
var aTypedArrayConstructor = ArrayBufferViewCore$4.aTypedArrayConstructor;
var isTypedArray = ArrayBufferViewCore$4.isTypedArray;
var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
var WRONG_LENGTH = 'Wrong length';

var fromList = function (C, list) {
  aTypedArrayConstructor(C);
  var index = 0;
  var length = list.length;
  var result = new C(length);
  while (length > index) result[index] = list[index++];
  return result;
};

var addGetter = function (it, key) {
  defineBuiltInAccessor(it, key, {
    configurable: true,
    get: function () {
      return getInternalState(this)[key];
    }
  });
};

var isArrayBuffer = function (it) {
  var klass;
  return isPrototypeOf(ArrayBufferPrototype, it) || (klass = classof$1(it)) == 'ArrayBuffer' || klass == 'SharedArrayBuffer';
};

var isTypedArrayIndex = function (target, key) {
  return isTypedArray(target)
    && !isSymbol(key)
    && key in target
    && isIntegralNumber(+key)
    && key >= 0;
};

var wrappedGetOwnPropertyDescriptor = function getOwnPropertyDescriptor(target, key) {
  key = toPropertyKey(key);
  return isTypedArrayIndex(target, key)
    ? createPropertyDescriptor(2, target[key])
    : nativeGetOwnPropertyDescriptor(target, key);
};

var wrappedDefineProperty = function defineProperty(target, key, descriptor) {
  key = toPropertyKey(key);
  if (isTypedArrayIndex(target, key)
    && isObject(descriptor)
    && hasOwn(descriptor, 'value')
    && !hasOwn(descriptor, 'get')
    && !hasOwn(descriptor, 'set')
    // TODO: add validation descriptor w/o calling accessors
    && !descriptor.configurable
    && (!hasOwn(descriptor, 'writable') || descriptor.writable)
    && (!hasOwn(descriptor, 'enumerable') || descriptor.enumerable)
  ) {
    target[key] = descriptor.value;
    return target;
  } return nativeDefineProperty(target, key, descriptor);
};

if (DESCRIPTORS) {
  if (!NATIVE_ARRAY_BUFFER_VIEWS) {
    getOwnPropertyDescriptorModule.f = wrappedGetOwnPropertyDescriptor;
    definePropertyModule.f = wrappedDefineProperty;
    addGetter(TypedArrayPrototype, 'buffer');
    addGetter(TypedArrayPrototype, 'byteOffset');
    addGetter(TypedArrayPrototype, 'byteLength');
    addGetter(TypedArrayPrototype, 'length');
  }

  $({ target: 'Object', stat: true, forced: !NATIVE_ARRAY_BUFFER_VIEWS }, {
    getOwnPropertyDescriptor: wrappedGetOwnPropertyDescriptor,
    defineProperty: wrappedDefineProperty
  });

  typedArrayConstructor.exports = function (TYPE, wrapper, CLAMPED) {
    var BYTES = TYPE.match(/\d+/)[0] / 8;
    var CONSTRUCTOR_NAME = TYPE + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + TYPE;
    var SETTER = 'set' + TYPE;
    var NativeTypedArrayConstructor = global$4[CONSTRUCTOR_NAME];
    var TypedArrayConstructor = NativeTypedArrayConstructor;
    var TypedArrayConstructorPrototype = TypedArrayConstructor && TypedArrayConstructor.prototype;
    var exported = {};

    var getter = function (that, index) {
      var data = getInternalState(that);
      return data.view[GETTER](index * BYTES + data.byteOffset, true);
    };

    var setter = function (that, index, value) {
      var data = getInternalState(that);
      if (CLAMPED) value = (value = round(value)) < 0 ? 0 : value > 0xFF ? 0xFF : value & 0xFF;
      data.view[SETTER](index * BYTES + data.byteOffset, value, true);
    };

    var addElement = function (that, index) {
      nativeDefineProperty(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };

    if (!NATIVE_ARRAY_BUFFER_VIEWS) {
      TypedArrayConstructor = wrapper(function (that, data, offset, $length) {
        anInstance(that, TypedArrayConstructorPrototype);
        var index = 0;
        var byteOffset = 0;
        var buffer, byteLength, length;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new ArrayBuffer$1(byteLength);
        } else if (isArrayBuffer(data)) {
          buffer = data;
          byteOffset = toOffset$1(offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError$2(WRONG_LENGTH);
            byteLength = $len - byteOffset;
            if (byteLength < 0) throw RangeError$2(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + byteOffset > $len) throw RangeError$2(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (isTypedArray(data)) {
          return fromList(TypedArrayConstructor, data);
        } else {
          return call$2(typedArrayFrom, TypedArrayConstructor, data);
        }
        setInternalState(that, {
          buffer: buffer,
          byteOffset: byteOffset,
          byteLength: byteLength,
          length: length,
          view: new DataView$1(buffer)
        });
        while (index < length) addElement(that, index++);
      });

      if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
      TypedArrayConstructorPrototype = TypedArrayConstructor.prototype = create(TypedArrayPrototype);
    } else if (TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS) {
      TypedArrayConstructor = wrapper(function (dummy, data, typedArrayOffset, $length) {
        anInstance(dummy, TypedArrayConstructorPrototype);
        return inheritIfRequired(function () {
          if (!isObject(data)) return new NativeTypedArrayConstructor(toIndex(data));
          if (isArrayBuffer(data)) return $length !== undefined
            ? new NativeTypedArrayConstructor(data, toOffset$1(typedArrayOffset, BYTES), $length)
            : typedArrayOffset !== undefined
              ? new NativeTypedArrayConstructor(data, toOffset$1(typedArrayOffset, BYTES))
              : new NativeTypedArrayConstructor(data);
          if (isTypedArray(data)) return fromList(TypedArrayConstructor, data);
          return call$2(typedArrayFrom, TypedArrayConstructor, data);
        }(), dummy, TypedArrayConstructor);
      });

      if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
      forEach(getOwnPropertyNames(NativeTypedArrayConstructor), function (key) {
        if (!(key in TypedArrayConstructor)) {
          createNonEnumerableProperty(TypedArrayConstructor, key, NativeTypedArrayConstructor[key]);
        }
      });
      TypedArrayConstructor.prototype = TypedArrayConstructorPrototype;
    }

    if (TypedArrayConstructorPrototype.constructor !== TypedArrayConstructor) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, 'constructor', TypedArrayConstructor);
    }

    enforceInternalState(TypedArrayConstructorPrototype).TypedArrayConstructor = TypedArrayConstructor;

    if (TYPED_ARRAY_TAG) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, TYPED_ARRAY_TAG, CONSTRUCTOR_NAME);
    }

    var FORCED = TypedArrayConstructor != NativeTypedArrayConstructor;

    exported[CONSTRUCTOR_NAME] = TypedArrayConstructor;

    $({ global: true, constructor: true, forced: FORCED, sham: !NATIVE_ARRAY_BUFFER_VIEWS }, exported);

    if (!(BYTES_PER_ELEMENT in TypedArrayConstructor)) {
      createNonEnumerableProperty(TypedArrayConstructor, BYTES_PER_ELEMENT, BYTES);
    }

    if (!(BYTES_PER_ELEMENT in TypedArrayConstructorPrototype)) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, BYTES_PER_ELEMENT, BYTES);
    }

    setSpecies(CONSTRUCTOR_NAME);
  };
} else typedArrayConstructor.exports = function () { /* empty */ };

var createTypedArrayConstructor = typedArrayConstructor.exports;

// `Uint8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Uint8', function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

var ArrayBufferViewCore$3 = arrayBufferViewCore;
var $fill = arrayFill$1;
var toBigInt = toBigInt$2;
var classof = classof$c;
var call$1 = functionCall;
var uncurryThis$1 = functionUncurryThis;
var fails$3 = fails$A;

var aTypedArray$3 = ArrayBufferViewCore$3.aTypedArray;
var exportTypedArrayMethod$3 = ArrayBufferViewCore$3.exportTypedArrayMethod;
var slice = uncurryThis$1(''.slice);

// V8 ~ Chrome < 59, Safari < 14.1, FF < 55, Edge <=18
var CONVERSION_BUG = fails$3(function () {
  var count = 0;
  // eslint-disable-next-line es/no-typed-arrays -- safe
  new Int8Array(2).fill({ valueOf: function () { return count++; } });
  return count !== 1;
});

// `%TypedArray%.prototype.fill` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.fill
exportTypedArrayMethod$3('fill', function fill(value /* , start, end */) {
  var length = arguments.length;
  aTypedArray$3(this);
  var actualValue = slice(classof(this), 0, 3) === 'Big' ? toBigInt(value) : +value;
  return call$1($fill, this, actualValue, length > 1 ? arguments[1] : undefined, length > 2 ? arguments[2] : undefined);
}, CONVERSION_BUG);

var global$3 = global$w;
var call = functionCall;
var ArrayBufferViewCore$2 = arrayBufferViewCore;
var lengthOfArrayLike = lengthOfArrayLike$d;
var toOffset = toOffset$2;
var toIndexedObject = toObject$c;
var fails$2 = fails$A;

var RangeError$1 = global$3.RangeError;
var Int8Array$2 = global$3.Int8Array;
var Int8ArrayPrototype = Int8Array$2 && Int8Array$2.prototype;
var $set = Int8ArrayPrototype && Int8ArrayPrototype.set;
var aTypedArray$2 = ArrayBufferViewCore$2.aTypedArray;
var exportTypedArrayMethod$2 = ArrayBufferViewCore$2.exportTypedArrayMethod;

var WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS = !fails$2(function () {
  // eslint-disable-next-line es/no-typed-arrays -- required for testing
  var array = new Uint8ClampedArray(2);
  call($set, array, { length: 1, 0: 3 }, 1);
  return array[1] !== 3;
});

// https://bugs.chromium.org/p/v8/issues/detail?id=11294 and other
var TO_OBJECT_BUG = WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS && ArrayBufferViewCore$2.NATIVE_ARRAY_BUFFER_VIEWS && fails$2(function () {
  var array = new Int8Array$2(2);
  array.set(1);
  array.set('2', 1);
  return array[0] !== 0 || array[1] !== 2;
});

// `%TypedArray%.prototype.set` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
exportTypedArrayMethod$2('set', function set(arrayLike /* , offset */) {
  aTypedArray$2(this);
  var offset = toOffset(arguments.length > 1 ? arguments[1] : undefined, 1);
  var src = toIndexedObject(arrayLike);
  if (WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS) return call($set, this, src, offset);
  var length = this.length;
  var len = lengthOfArrayLike(src);
  var index = 0;
  if (len + offset > length) throw RangeError$1('Wrong length');
  while (index < len) this[offset + index] = src[index++];
}, !WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS || TO_OBJECT_BUG);

var global$2 = global$w;
var uncurryThis = functionUncurryThisClause;
var fails$1 = fails$A;
var aCallable = aCallable$c;
var internalSort = arraySort$1;
var ArrayBufferViewCore$1 = arrayBufferViewCore;
var FF = engineFfVersion;
var IE_OR_EDGE = engineIsIeOrEdge;
var V8 = engineV8Version;
var WEBKIT = engineWebkitVersion;

var aTypedArray$1 = ArrayBufferViewCore$1.aTypedArray;
var exportTypedArrayMethod$1 = ArrayBufferViewCore$1.exportTypedArrayMethod;
var Uint16Array = global$2.Uint16Array;
var nativeSort = Uint16Array && uncurryThis(Uint16Array.prototype.sort);

// WebKit
var ACCEPT_INCORRECT_ARGUMENTS = !!nativeSort && !(fails$1(function () {
  nativeSort(new Uint16Array(2), null);
}) && fails$1(function () {
  nativeSort(new Uint16Array(2), {});
}));

var STABLE_SORT = !!nativeSort && !fails$1(function () {
  // feature detection can be too slow, so check engines versions
  if (V8) return V8 < 74;
  if (FF) return FF < 67;
  if (IE_OR_EDGE) return true;
  if (WEBKIT) return WEBKIT < 602;

  var array = new Uint16Array(516);
  var expected = Array(516);
  var index, mod;

  for (index = 0; index < 516; index++) {
    mod = index % 4;
    array[index] = 515 - index;
    expected[index] = index - 2 * mod + 3;
  }

  nativeSort(array, function (a, b) {
    return (a / 4 | 0) - (b / 4 | 0);
  });

  for (index = 0; index < 516; index++) {
    if (array[index] !== expected[index]) return true;
  }
});

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    // eslint-disable-next-line no-self-compare -- NaN check
    if (y !== y) return -1;
    // eslint-disable-next-line no-self-compare -- NaN check
    if (x !== x) return 1;
    if (x === 0 && y === 0) return 1 / x > 0 && 1 / y < 0 ? 1 : -1;
    return x > y;
  };
};

// `%TypedArray%.prototype.sort` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.sort
exportTypedArrayMethod$1('sort', function sort(comparefn) {
  if (comparefn !== undefined) aCallable(comparefn);
  if (STABLE_SORT) return nativeSort(this, comparefn);

  return internalSort(aTypedArray$1(this), getSortCompare(comparefn));
}, !STABLE_SORT || ACCEPT_INCORRECT_ARGUMENTS);

var global$1 = global$w;
var apply = functionApply;
var ArrayBufferViewCore = arrayBufferViewCore;
var fails = fails$A;
var arraySlice = arraySlice$5;

var Int8Array$1 = global$1.Int8Array;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var $toLocaleString = [].toLocaleString;

// iOS Safari 6.x fails here
var TO_LOCALE_STRING_BUG = !!Int8Array$1 && fails(function () {
  $toLocaleString.call(new Int8Array$1(1));
});

var FORCED = fails(function () {
  return [1, 2].toLocaleString() != new Int8Array$1([1, 2]).toLocaleString();
}) || !fails(function () {
  Int8Array$1.prototype.toLocaleString.call([1, 2]);
});

// `%TypedArray%.prototype.toLocaleString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tolocalestring
exportTypedArrayMethod('toLocaleString', function toLocaleString() {
  return apply(
    $toLocaleString,
    TO_LOCALE_STRING_BUG ? arraySlice(aTypedArray(this)) : aTypedArray(this),
    arraySlice(arguments)
  );
}, FORCED);

const sliceSize = 512;
const pdfContentType = "application/pdf";
const pdfToBlob = pdfData => {
  const byteCharacters = pdfData;
  const byteArrays = [];
  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  return new Blob(byteArrays, {
    type: pdfContentType
  });
};
const pdfToDataUrl = pdfData => URL.createObjectURL(pdfToBlob(pdfData));
const downloadPdf = (pdfData, filename = "Konfiguration.pdf") => {
  downloadFileByUrl(pdfToDataUrl(pdfData), filename);
};
const downloadFileByUrl = (url, fileName) => {
  const a = document.createElement("a");
  a.download = fileName;
  a.href = url;
  a.click();
};

const requestLoadingThunk = callId => dispatch => {
  if (!callId) {
    callId = uuidv4();
  }
  dispatch(startLoading(callId));
  return callId;
};

const triggerSaveThunk = () => (dispatch, getState) => {
  const state = getState();
  const screenshottingPossible = selectIsScreenshottingPossible(state);
  dispatch(setScreenshotting(screenshottingPossible ? "creating" : []));
};
const saveConfigurationThunk = (configuration, action, files, isPreview) => async (dispatch, getState) => {
  var _selectDealerData;
  const loadingId = dispatch(requestLoadingThunk());
  const state = getState();
  const language = selectContentLanguage(state);
  const dealerId = (_selectDealerData = selectDealerData(state)) == null ? void 0 : _selectDealerData.id;
  const updatedConfiguration = applyCallback("saveConfiguration", configuration);
  try {
    const result = await api_saveConfiguration(updatedConfiguration, updatedConfiguration.appCode, action, language, files, isPreview, dealerId);
    window.onbeforeunload = null;
    if (action.sendJavascriptEvent) {
      var _window$top;
      (_window$top = window.top) == null ? void 0 : _window$top.postMessage({
        type: "K3ConfigurationSaved",
        actionKey: action.actionKey,
        code: result.code
      }, "*");
    }
    if (!selectIsAdminPanel(state)) setConfigurationCode(result.code);
    dispatch(resetTouched);
    if (result.pdf) {
      if (hasCallback("openPdf")) {
        applyCallback("openPdf", result);
      } else {
        downloadPdf(result.pdf, result.pdfName);
      }
    }
    if (action.sendToShop) {
      const app = selectFrontendApp(state);
      const link = result.shopLink || generateShopLink(app, result);
      if (link) (window.top || window).location = link;
    }
    return result;
  } catch (e) {
    // FIXME: on error local konfiguration speichern sollte anders gehandelt werden
    // saveConfigurationLocal(
    //   { ...updatedConfiguration, failedSaveAction: action },
    //   files
    // );
    if (e instanceof Error) return {
      error: true,
      message: e.message
    };
  } finally {
    dispatch(finishLoading(loadingId));
  }
};
const generateShopLink = (app, result) => {
  const shopURLstring = app.settings.shopURL;
  if (shopURLstring) {
    const shopURL = new URL(shopURLstring);
    shopURL.searchParams.append("cfg", result.code);
    return shopURL.toString();
  } else {
    return null;
  }
};

/** Returns all groups */
const useGroups = () => useTypedSelector(selectGroups);
/** Returns the currently focused groupId */
const useFocusedGroupId = () => useTypedSelector(selectFocusGroupId);
/** Returns a function to set the focused Group */
const useSetFocusedGroup = () => useActionCreator(setFocusGroupId);
/** Returns a group by id. Probably you want to use `useGroupByKey` instead. */
const useGroupById = groupId => useTypedSelector(selectGroupById(groupId));
/** Returns a group by key */
const useGroupByKey = groupKey => useTypedSelector(selectGroupByKey(groupKey));
/** Returns all variables */
const useVariables = () => useTypedSelector(selectVariables);
/** Returns a variable by key */
const useVariableByKey = variableKey => useTypedSelector(selectVariableByKey(variableKey));
/** Returns all variables by group id */
const useVariablesByGroupId = groupId => useTypedSelector(state => getVariablesByGroupId(state, groupId));
/** Returns a variable by Id */
const useVariableById = variableId => useTypedSelector(selectVariableById(variableId));
/**
 * Returns all raw values.
 * To get the rule engines values, use `useRuleEngineInput`.
 * You should not need this.
 */
const useValues = () => useTypedSelector(selectValues);
/** Returns a value by key */
const useValueByKey = valueKey => useTypedSelector(selectValueByKey(valueKey));
/** Returns a value by id. */
const useValueById = valueId => useTypedSelector(selectValueById(valueId));
/**
 * Returns all raw values for a certain variable.
 * To get the rule engines values, use `useRuleEngineInput().values.byVarId[id]`.
 */
const useValuesByVariableId = variableId => useTypedSelector(selectValuesByVariableId(variableId));
/**
 * Returns all raw rules.
 * You should not need this.
 */
const useRules = () => useTypedSelector(selectRules);
/**
 * Returns all raw rule items.
 * You should not need this.
 */
const useRuleItems = () => useTypedSelector(selectRuleItems);
/** Returns all articles. */
const useArticles = () => useTypedSelector(selectArticles);
/** Returns all articles and prices */
const useAllArticlesAndPrices = () => useTypedSelector(selectAllArticlesAndPrices);
/** Returns the current Intl price formatter */
const usePriceFormatter = () => useTypedSelector(selectPriceFormatter);
/**
 * Returns all prices.
 * You should not need this.
 */
const usePrices = () => useTypedSelector(selectPrices);
/** Returns whether the price should be shown in the frontend */
const useShouldDisplayPrice = () => useTypedSelector(selectFrontendAppShowPrice);
/** Returns all 3D Models. */
const useModels = () => useTypedSelector(selectModels);
/** Returns all materials */
const useMaterials = () => useTypedSelector(selectMaterials);
/** Returns all gallery images */
const useImages = () => useTypedSelector(selectImages);
/** Returns all active actions. */
const useActions = () => useTypedSelector(selectActionEngineState);
/** Returns the currently opened instance */
const useOpenInstance = () => useTypedSelector(selectOpenInstance);
const useIsOpenInstanceFirstOfSiblings = () => {
  const currentInstance = useOpenInstance();
  const siblingInstances = useTypedSelector(selectSiblingInstances);
  if (siblingInstances.indexOf(currentInstance) === 0) {
    return true;
  }
  return false;
};
/** Returns all selections */
const useSelections = () => useTypedSelector(selectSelections);
/** Returns the selection for a variable */
const useSelectionByVariableId = variableId => useTypedSelector(selectSelectionByVariableId(variableId));
/** Returns the currently selected value for this variableKey or undefined */
const useSelectedValueByVariableKey = variableKey => {
  const selection = useSelectionByVariableKey(variableKey);
  return useValueById(selection == null ? void 0 : selection.valueId);
};
/**
 * Returns the currently selected number for this variableKey or undefined. Only usable for
 * number variables (calculated or not calculated)
 */
const useSelectedNumberByVariableKey = variableKey => {
  var _selection$data;
  const selection = useSelectionByVariableKey(variableKey);
  return selection == null ? void 0 : (_selection$data = selection.data) == null ? void 0 : _selection$data.inputValue;
};
/** Returns the selection for a variableKey */
const useSelectionByVariableKey = variableKey => {
  const variable = useVariableByKey(variableKey);
  return useSelectionByVariableId(variable == null ? void 0 : variable.id);
};
/**
 * Returns a map of all multiplicity selections with a value key and their children.
 *
 * Keys are the selectionIds, values are objects themselves with variableKeys
 * as keys and values or in case of number variables numbers as value.
 */
const useInstanceSelectionsByValueKey = valueKey => {
  const value = useValueByKey(valueKey);
  const selections = useSelections();
  const valueSelections = selections.filter(selection => selection.valueId === (value == null ? void 0 : value.id));
  const rootSelections = valueSelections.filter(selection => selection.valueId === (value == null ? void 0 : value.id));
  const valuesById = useTypedSelector(selectValuesByIdMap);
  const variablesById = useTypedSelector(selectVariablesByIdMap);
  const stack = [...rootSelections];
  const selectionsMap = {};
  let rootSelectionId = null;
  while (stack.length > 0) {
    var _variablesById$select;
    const selection = stack.pop();
    if (selection.valueId === (value == null ? void 0 : value.id)) {
      rootSelectionId = selection.id;
    }
    const childrenSelections = selections.filter(s => (s.instance.belongsToInstanceId === (selection == null ? void 0 : selection.instance.id) || s.instance.id === (selection == null ? void 0 : selection.instance.id)) && s.id !== (selection == null ? void 0 : selection.id));
    selectionsMap[rootSelectionId] = Object.assign({}, selectionsMap[rootSelectionId] || {
      // @ts-ignore
      [(_variablesById$select = variablesById[selection == null ? void 0 : selection.variableId]) == null ? void 0 : _variablesById$select.key]:
      // @ts-ignore
      valuesById[selection == null ? void 0 : selection.valueId]
    }, childrenSelections.reduce((acc, s) => {
      // @ts-ignore
      const variable = variablesById[s == null ? void 0 : s.variableId];
      let value = valuesById[s.valueId];
      if (isNumberVariable(variable)) {
        var _s$data$inputValue, _s$data;
        // @ts-ignore
        value = (_s$data$inputValue = (_s$data = s.data) == null ? void 0 : _s$data.inputValue) != null ? _s$data$inputValue : 0;
      }
      if (!variable) return acc;
      return Object.assign({}, acc, {
        // @ts-ignore
        [variable == null ? void 0 : variable.key]: acc[variable == null ? void 0 : variable.key] ?
        // @ts-ignore
        [...acc[variable == null ? void 0 : variable.key], value] : value
      });
    }, {}));
    stack.push(...childrenSelections.filter(s => s.instance.isInstanceLauncher));
  }
  return selectionsMap;
};
/** Returns the currently selected value for this variable and attributeKey */
const useSelectedValueAttributeByKey = (variableKey, attributeKey) => useSelectedValueAttributesByKeys(variableKey, [attributeKey])[0];
const useSelectedValueAttributesByKeys = (variableKey, attributeKeys) => {
  const variable = useVariableByKey(variableKey);
  const value = useSelectedValueByVariableKey(variableKey);
  const result = Array.from(attributeKeys).map(() => undefined);
  if (value && variable) {
    for (let i = 0; i < attributeKeys.length; i++) {
      const attributeDefinition = getAttributeDefinitionByKey(attributeKeys[i], variable);
      if (attributeDefinition) {
        result[i] = getAttributeValueById(attributeDefinition == null ? void 0 : attributeDefinition.id, value);
      }
    }
  }
  return result;
};
/** Returns a function to drive towards a camera */
const useSetNextCamera = () => useActionCreator(setNextCameraPosition);
/** Returns the values, variables, rules and ruleItems as used by the ruleEngine. */
const useRuleEngineInput = () => useTypedSelector(selectRuleEngineInput);
/** Returns the current, stable state of the configurator */
const useRuleEngineState = () => useTypedSelector(selectRuleEngineState);
/** Returns all values used by the ruleEngine as an array */
const useRuleEngineValues = () => {
  var _useRuleEngineInput, _useRuleEngineInput$v, _useRuleEngineInput$v2;
  return ((_useRuleEngineInput = useRuleEngineInput()) == null ? void 0 : (_useRuleEngineInput$v = _useRuleEngineInput.values) == null ? void 0 : (_useRuleEngineInput$v2 = _useRuleEngineInput$v.flat) == null ? void 0 : _useRuleEngineInput$v2.all) || [];
};
/** Returns the current state of the action engine. */
const useActionEngineState = () => useTypedSelector(selectActionEngineState);
/** Returns all values for a variableId used by the ruleEngine as an array */
const useRuleEngineValueByVarId = variableId => {
  var _useRuleEngineInput2, _useRuleEngineInput2$, _useRuleEngineInput2$2;
  return ((_useRuleEngineInput2 = useRuleEngineInput()) == null ? void 0 : (_useRuleEngineInput2$ = _useRuleEngineInput2.values) == null ? void 0 : (_useRuleEngineInput2$2 = _useRuleEngineInput2$.byVarId) == null ? void 0 : _useRuleEngineInput2$2.all[variableId]) || [];
};
/** Change a variable programmatically.
 * Passing the parentInstance is optional. If none is passed it takes the one currently open */
const useChangeVariable = () => useActionCreator(changeVariableThunk);
/** Adds an instance programmatically.
 * Passing the parentInstance is optional. If none is passed it takes the one currently open */
const useAddInstance = () => useActionCreator(addInstanceThunk);
/** Removes an instance programmatically */
const useRemoveInstance = () => useActionCreator(removeInstanceThunk);
/** Returns the new, conflicting engine state or null if there is no conflict */
const useRuleEngineConflict = () => useTypedSelector(selectRuleEngineConflict);
/** accepts the conflict as new state */
const useAcceptAlternative = () => useActionCreator(acceptAlternativeThunk);
/** rejects the conflict as new state */
const useRejectAlternative = () => useActionCreator(rejectAlternativeThunk);
/**
 * Returns the admin language
 */
const useAdminLanguage = () => useTypedSelector(selectAdminLanguage);
/**
 * Returns the content language for the app. defaults to "de"
 */
const useContentLanguage = () => useTypedSelector(selectContentLanguage);
/** Returns the current app including all settings */
const useApp = () => useTypedSelector(selectFrontendApp);
/** Returns the current price */
const usePrice = () => useTypedSelector(selectOverallPrice);
/** Returns a function to start the AR Mode */
const useStartAr = () => useActionCreator(() => setArDialog(true));
/** Opens the dialog for the passed action */
const useTriggerAction = () => useActionCreator(setCurrentAction);
/** Triggers the save. For the save to work either the normal Dialog must be opened or the useExecuteSave must be included somewhere in your app */
const useTriggerSave = () => useActionCreator(triggerSaveThunk);
const useChangeGroup = () => useActionCreator(changeGroupByKeyThunk);
/** Returns whether we are currently within the AdminPanel */
const useIsAdminPanel = () => useTypedSelector(selectIsAdminPanel);
/** Returns whether we are currently within editor mode */
const useIsEditor = () => useTypedSelector(selectShowEditorUi);
/** Use this for adding a new Value to a variable of type component */
const useAddInstanceToVariable = variable => {
  const dispatch = useTypedDispatch();
  const currentInstance = useTypedSelector(selectSelectionByVariableId(variable == null ? void 0 : variable.id));
  const parentSelections = useTypedSelector(selectParentSelections(currentInstance)).reverse();
  return value => {
    const parentSelection = parentSelections.length > 0 ? parentSelections[0] : rootSelection;
    const result = dispatch(addInstanceThunk(value, parentSelection));
    if (!result) {
      return;
    }
    if ("newState" in result) {
      const newInstance = result.newState.ruleEngineState.lastManualChange.instance;
      const newSelection = {
        id: newInstance.id,
        instance: newInstance,
        variableId: newInstance.belongsToVariableId,
        valueId: currentInstance == null ? void 0 : currentInstance.valueId,
        sort: ((currentInstance == null ? void 0 : currentInstance.sort) || 0) + 1,
        debuggingValue: value.label
      };
      dispatch(setCurrentAction(null));
      dispatch(setOpenInstance(newSelection));
      dispatch(setInitialFocusGroupKey());
    }
  };
};
/**  Use this for deleting an instance. In case it is the current selection, it returns to its parent or to the root. */
const useSafeDeleteInstance = () => {
  const pseudoRootSelection = useTypedSelector(selectPseudoRootSelection);
  const currentSelection = useTypedSelector(selectOpenInstance);
  const siblingInstances = useTypedSelector(selectSiblingInstances).filter(s => s.id !== (currentSelection == null ? void 0 : currentSelection.id));
  const dispatch = useTypedDispatch();
  const parentSelections = useTypedSelector(selectParentSelections(currentSelection)).reverse();
  return selection => {
    if ((pseudoRootSelection == null ? void 0 : pseudoRootSelection.id) === selection.id) {
      dispatch(setPseudoRootSelection(siblingInstances[0]));
    }
    if (selection.id === (currentSelection == null ? void 0 : currentSelection.id)) {
      const parentSelection = parentSelections.length > 0 ? parentSelections[0] : pseudoRootSelection || rootSelection;
      if (siblingInstances.length > 0) {
        dispatch(setOpenInstance(siblingInstances[0]));
      } else dispatch(setOpenInstance(parentSelection));
    }
    dispatch(removeInstanceThunk(selection));
  };
};
const useAnchoringSelections = (ruleItemId, ruleColumnId) => useTypedSelector(selectAnchoringSelectionsOfRuleItem(ruleItemId, ruleColumnId));
const useConfiguration = () => useTypedSelector(selectConfiguration);

// Since instanceof Mesh does not always work, we use this type guard.
// more details here:
// https://discourse.threejs.org/t/gltf-scene-traverse-property-ismesh-does-not-exist-on-type-object3d/27212/2
const isMesh = object => {
  const maybeMesh = object;
  return maybeMesh == null ? void 0 : maybeMesh.isMesh;
};
/**
 * Loads the preset of the drei Environment from our asset server instead.
 *
 * This avoids third party CDNs. Relevant for GDPR and stability.
 *
 * Usage: instead of `<Environment preset="city" />` use
 * `<Environment files={getDreiPresetUrl("city")} />`
 *
 * Currently uploaded: city, night, apartment, forest, sunset.
 *
 * Others can be uploaded on short notice
 */
const getDreiPresetUrl = presetName => `${env.libsUrl}3d/environments/${presetName}.hdr`;
const getBasicSceneInformation = e => {
  const {
    scene
  } = e;
  let objects = 0,
    vertices = 0,
    triangles = 0;
  for (let i = 0, l = scene.children.length; i < l; i++) {
    const object = scene.children[i];
    object.traverseVisible(function (object) {
      objects++;
      if ("isMesh" in object && object.isMesh) {
        const geometry = object.geometry;
        vertices += geometry.attributes.position.count;
        if (geometry.index !== null) {
          triangles += geometry.index.count / 3;
        } else {
          triangles += geometry.attributes.position.count / 3;
        }
      }
    });
  }
  return {
    objects,
    vertices,
    triangles
  };
};

function useGLTF_GDPRCompliant(path, useMeshOpt) {
  const gltf = useGLTF(path, env.libsUrl, useMeshOpt);
  return gltf;
}
function useK3GLTF(url, k3ModelProps) {
  var _k3ModelProps$model2;
  const gltf = useGLTF_GDPRCompliant(url, true);
  gltf.scene.traverse(object => {
    if (isMesh(object)) {
      var _k3ModelProps$model, _k3ModelProps$meshPro, _k3ModelProps$meshPro2;
      object.userData.modelId = k3ModelProps == null ? void 0 : (_k3ModelProps$model = k3ModelProps.model) == null ? void 0 : _k3ModelProps$model.id;
      object.receiveShadow = !!((_k3ModelProps$meshPro = k3ModelProps.meshProps) != null && _k3ModelProps$meshPro.receiveShadow);
      object.castShadow = !!((_k3ModelProps$meshPro2 = k3ModelProps.meshProps) != null && _k3ModelProps$meshPro2.castShadow);
    }
  });
  const onMaterialsLoaded = k3ModelProps.onMaterialsLoaded;
  useEffect(() => {
    if (onMaterialsLoaded) {
      onMaterialsLoaded(gltf.materials);
    }
  }, [gltf.materials, onMaterialsLoaded]);
  if (gltf && k3ModelProps.onUpdate) {
    k3ModelProps.onUpdate(gltf);
  }
  if ((_k3ModelProps$model2 = k3ModelProps.model) != null && _k3ModelProps$model2.key) {
    var _k3ModelProps$model3;
    gltf.scene.name = (_k3ModelProps$model3 = k3ModelProps.model) == null ? void 0 : _k3ModelProps$model3.key;
  }
  return gltf;
}

const zeroVector3Tuple = [0, 0, 0];
const oneVector3Tuple = [1, 1, 1];
function applyTransformationOfModelAction(k3ModelProps, copiedScene) {
  var _k3ModelProps$meshPro;
  const {
    rotation = zeroVector3Tuple,
    position = zeroVector3Tuple,
    scale = oneVector3Tuple
  } = (_k3ModelProps$meshPro = k3ModelProps.meshProps) != null ? _k3ModelProps$meshPro : {};
  copiedScene.rotation.set(rotation[0], rotation[1], rotation[2]);
  copiedScene.position.set(position[0], position[1], position[2]);
  copiedScene.scale.set(scale[0], scale[1], scale[2]);
  // If we dont call updateWorldMatrix, the bounding box will ignore the
  // transformations of the parent elements thus breaking the camera focus
  // position later on.
  copiedScene.updateWorldMatrix(true, true);
}
/**
 * Load a gltf, but apply actions to it. This includes material and color swaps
 * as well as the print designer.
 */
function useGLTFWithAppliedActions(k3ModelProps) {
  var _k3ModelProps$model;
  const k3Gltf = useK3GLTF(k3ModelProps.fileURL || "", k3ModelProps);
  const materials = useMemo(() => Object.values(k3Gltf.materials), [k3Gltf.materials]);
  const {
    materials: newMaterials,
    printAreas
  } = useMaterialsWithAppliedActions(materials, (_k3ModelProps$model = k3ModelProps.model) == null ? void 0 : _k3ModelProps$model.id, k3ModelProps.modelAction);
  const copiedScene = useMemo(() => {
    return k3Gltf.scene.clone();
  }, [k3Gltf.scene]);
  // Apply the materials.
  if (!isEmpty(newMaterials)) {
    copiedScene.traverse(children => {
      if (children.material && newMaterials[children.material.name]) {
        children.material = newMaterials[children.material.name];
        children.material.needsUpdate = true;
      }
    });
  }
  applyTransformationOfModelAction(k3ModelProps, copiedScene);
  k3Gltf.scene = copiedScene;
  return k3Gltf;
}
/**
 * Load a gltf, but apply actions to it. This includes material and color swaps
 * as well as the print designer.
 * @deprecated use useGLTFWithAppliedActions instead
 */
const useMaterialReplacedGLTF = useGLTFWithAppliedActions;

var Screenshot = "53cfec614df69c93.png";

var ScriptedEditorDialog = (props => {
  const {
    t
  } = useTranslation();
  const [value, setValue] = useState(props.value);
  const onCancel = () => {
    setValue(props.value);
    props.onSave(props.value); // In order to remove possible previous compiler errors
  };

  return jsxs(Dialog, {
    open: props.open,
    onClose: onCancel,
    fullWidth: true,
    maxWidth: "xl",
    children: [jsx(DialogTitle, {
      children: t("Script Modell Editor")
    }), jsxs(DialogContent, {
      children: [jsx(DialogContentText, {
        children: jsx(Typography, {
          children: t("Schreiben Sie das Modell als JSX Komponente.")
        })
      }), jsx(Box, {
        component: "div",
        sx: {
          padding: "1em",
          border: "1px solid #c4c4c4",
          borderRadius: 1
        },
        children: jsx(Editor$4, {
          height: "500px",
          theme: "light",
          defaultLanguage: "javascript",
          onChange: setValue,
          options: monacoOptions,
          value: value
        })
      }), props.error != null && jsx(Alert, {
        severity: "warning",
        children: props.error
      })]
    }), jsxs(DialogActions, {
      children: [jsx(Button, {
        variant: "outlined",
        "data-cy": `cancel`,
        onClick: onCancel,
        children: t("Abbrechen")
      }), jsx(Button, {
        variant: "contained",
        disabled: !value,
        "data-cy": `save`,
        onClick: () => props.onSave(value),
        children: t("Speichern")
      })]
    })]
  });
});

const PropsDialog = props => {
  const {
    t
  } = useTranslation();
  useState(props.dynamicModelProps.script);
  const [error, setError] = useState(null);
  const [open, setOpen] = useState(false);
  const onChange = script => {
    setError(null);
    try {
      // Checking component validity
      const Component = getComponent$1(script || "", null, true);
      Component({});
      setOpen(false);
      props.onChange("script")(script);
    } catch (e) {
      console.log("ERR", e);
      setError(e.toString());
    }
  };
  return jsxs(Stack, {
    maxWidth: 800,
    children: [jsx(ScriptedEditorDialog, {
      open: open,
      value: props.dynamicModelProps.script,
      error: error,
      onSave: onChange
    }), jsx(Button, {
      variant: "contained",
      onClick: () => setOpen(true),
      "data-cy": "scripted-edit",
      children: t("Edit")
    }), error != null && jsx(Alert, {
      severity: "warning",
      children: error
    }), jsx(AddDeleteMaterials, {
      model: props.model,
      editable: true
    })]
  });
};
const standardMaterial = name => new THREE.MeshStandardMaterial({
  name: name,
  color: "red"
});
const ModelComponent = props => {
  const model = useTypedSelector(selectModels).find(m => m.key == props.model);
  if (!model) return;
  if ((model == null ? void 0 : model.type) == "dynamic") {
    const dynamicModel = getDynamicModels().find(dm => dm.type == model.dynamicModelKey);
    const Component = dynamicModel == null ? void 0 : dynamicModel.component;
    if (!Component) return null;
    if (dynamicModel.type == "scripted") {
      return jsx(Component, Object.assign({}, props, model.props, {
        id: model.id
      }));
    } else {
      // model.props in this case leads to a render loop...
      return jsx(Component, Object.assign({}, props));
    }
  } else {
    const k3GltfWithMaterials = useGLTFWithAppliedActions({
      model,
      fileURL: model.path,
      meshProps: Object.assign({}, props)
    });
    return jsx("mesh", {
      children: jsx("primitive", {
        object: k3GltfWithMaterials.scene
      })
    });
  }
};
const getMaterial = modelId => name => {
  // Stolen from Box.tsx
  const defaultMaterials = useMemo(() => [standardMaterial(name)], [name]);
  if (!modelId) return defaultMaterials[0];
  const printAreas = useMemo(() => defaultMaterials.map(m => {
    return {
      modelId: modelId,
      materialName: m.name
    };
  }), [defaultMaterials, modelId]);
  const updatedMaterials = useModelWithAppliedActions(modelId, defaultMaterials, printAreas, undefined);
  return updatedMaterials[name] || defaultMaterials[0];
};
const getComponent$1 = (body, modelId, forTest = false) => {
  const compiler = new Compiler();
  const ctx = {
    React: React__default,
    Drei,
    THREE,
    getNumber: variableKey => {
      var _selection$data;
      const selection = useSelectionByVariableKey(variableKey);
      return selection == null ? void 0 : (_selection$data = selection.data) == null ? void 0 : _selection$data.inputValue;
    },
    Model: ModelComponent,
    getMaterial: getMaterial(modelId),
    useMemo,
    useState
  };
  if (forTest) {
    // In the test call, the component is called directly and React is not available.
    ctx.getNumber = () => 1;
    ctx.Model = () => null;
    ctx.getMaterial = () => standardMaterial("std");
    // Nevertheless, we want to check whether the useMemo function works
    ctx.useMemo = f => f();
    ctx.useState = () => [null, () => null];
  }
  if (!body || body.trim() == "") return props => null;
  return compiler.compileToComponent(ctx, body);
};
const ScriptedModel = props => {
  const Component = useMemo(() => {
    if (props.script == null) return null;
    return getComponent$1(props.script, props.id, false);
  }, [props.script, props.id]);
  if (Component == null) return null;
  return jsx(Component, Object.assign({}, props));
};
const dynamicScripted = {
  type: "scripted",
  label: "Scripted",
  disabledForAR: false,
  component: ScriptedModel,
  propsDialog: PropsDialog,
  defaultProps: {
    script: "",
    js: ""
  },
  materials: ["surface"],
  repositionApplicator: defaultRepositionApplicator,
  screenshot: Screenshot
};

const getDynamicModels = () => {
  const coreDynamicModels = [dynamicBox, dynamicRuler, dynamicDummy, dynamicScripted];
  const allDynamicModels = applyCallback("getDynamicModels", coreDynamicModels);
  return allDynamicModels;
};
const getDynamicModelComponent = (model, modelAction) => {
  const dynamicModel = getDynamicModels().find(m => m.type === model.dynamicModelKey);
  let component = undefined;
  if (dynamicModel) {
    component = dynamicModel.component;
  } else {
    // eslint-disable-next-line no-console
    console.error("Dynamic model not found", modelAction.modelId);
  }
  return component;
};

const selectModels = state => state.metadata.models || [];
const selectModelById = id => state => selectModels(state).find(e => e.id == id);
const selectModelsByAppId = curry((appId, state) => flow(selectModels, filter(model => model.appId == appId))(state));
const selectDynamicModels = state => selectModels(state).filter(m => m.type === "dynamic");
const selectDynamicModelsDisabledForAR = state => selectDynamicModels(state).filter(model => getDynamicModels().find(dynamicModel => dynamicModel.type === model.dynamicModelKey && dynamicModel.disabledForAR));

const selectConfiguratorApp = state => {
  var _state$configurator;
  return (_state$configurator = state.configurator) == null ? void 0 : _state$configurator.app;
};
const selectSearch = state => state.configurator.searchString;
const selectConfiguratorAppId = state => {
  var _selectConfiguratorAp;
  return (_selectConfiguratorAp = selectConfiguratorApp(state)) == null ? void 0 : _selectConfiguratorAp.id;
};
const selectShowEditorUi = state => {
  var _state$configurator2;
  return (_state$configurator2 = state.configurator) == null ? void 0 : _state$configurator2.showEditorUi;
};
const selectShowThemeDialog = state => {
  var _state$configurator3;
  return (_state$configurator3 = state.configurator) == null ? void 0 : _state$configurator3.showThemeDialog;
};
const selectShowMobileThemeDialog = state => {
  var _state$configurator4;
  return (_state$configurator4 = state.configurator) == null ? void 0 : _state$configurator4.showMobileThemeDialog;
};
const selectPreviewDevice = state => state.configurator.device;
const selectDevmode = state => {
  var _state$configurator5;
  return (_state$configurator5 = state.configurator) == null ? void 0 : _state$configurator5.devmode;
};
const selectHelpTopic = state => {
  var _state$configurator6;
  return (_state$configurator6 = state.configurator) == null ? void 0 : _state$configurator6.helpTopic;
};
const selectCurrentGroup = state => {
  const currentGroupId = selectFocusGroupId(state);
  const groups = selectGroups(state);
  return groups.find(g => g.id === currentGroupId);
};
const selectFirstGroupWithDesign = device => state => {
  let current = selectCurrentGroup(state);
  // basically a recursive loop. But eslint hates me for this, so I am using a
  // for loop. Maybe it saves an infinite loop for corrupt data.
  for (let i = 0; i < 20; i++) {
    var _current$settings, _current$settings$the, _current$settings$the2;
    if (!current) return null;
    if (((_current$settings = current.settings) == null ? void 0 : (_current$settings$the = _current$settings.theme) == null ? void 0 : (_current$settings$the2 = _current$settings$the[device]) == null ? void 0 : _current$settings$the2.selected) === "custom") return current;
    if (!current.parentId) return null;
    current = selectGroupByParentId(current.parentId)(state);
  }
  return null;
};
const selectCurrentGroups = state => {
  const app = selectConfiguratorApp(state);
  return selectGroupsByAppId(app == null ? void 0 : app.id)(state);
};
const selectCurrentVariables = state => {
  const app = selectConfiguratorApp(state);
  return selectVariablesByAppId(app == null ? void 0 : app.id)(state);
};
const selectCurrentModels = state => {
  const app = selectConfiguratorApp(state);
  return selectModelsByAppId(app == null ? void 0 : app.id, state);
};
const selectCurrentMaterials = state => {
  const app = selectConfiguratorApp(state);
  return selectMaterialsByAppId(app == null ? void 0 : app.id, state);
};
const selectCurrentArticles = state => {
  const app = selectConfiguratorApp(state);
  return selectArticlesByAppId(app == null ? void 0 : app.id, state);
};
const selectCurrentRules = state => {
  const app = selectConfiguratorApp(state);
  return selectRulesByAppId(app == null ? void 0 : app.id)(state);
};
const selectCurrentArticleCatories = state => {
  const app = selectConfiguratorApp(state);
  const articles = selectArticlesByAppId(app == null ? void 0 : app.id, state);
  return flow(map(article => article.category), compact$1, uniq$1)(articles);
};
const selectCurrentPrices = state => {
  const app = selectConfiguratorApp(state);
  return selectPricesByAppId(app == null ? void 0 : app.id, state);
};

const selectVisibleVariablesOfGroup = groupId => state => getVariablesByGroupId(state, groupId).filter(isVisible).filter(v => selectIsVariableHiddenBecause(v)(state) === null);
const selectVariablesOfGroup = groupId => state => getVariablesByGroupId(state, groupId);

const CurrencyType = {
  USD: "USD",
  CAD: "CAD",
  AUD: "AUD",
  EUR: "EUR",
  GBP: "GBP",
  JPY: "JPY",
  NZD: "NZD",
  HKD: "HKD",
  SGD: "SGD",
  DKK: "DKK"
};
const PriceType = {
  fixed: "fixed",
  surcharge: "surcharge",
  surchargeHidden: "surchargeHidden"
};

const selectSelectedValue = variableId => state => {
  const openInstance = selectOpenInstance(state);
  const selection = flow(selectSelections, find$1(matchingSelectionForVariable(variableId, openInstance)))(state);
  if (!selection) {
    // @ts-ignore
    return undefined;
  }
  return flow(selectValues, find$1(value =>
  // JVI 27.5.: Bei Dropdowns ist nun Value.value==null. Bei Zahlenvariablen ohne Intervalle ist selection.valueId null.
  // Dann wird hier ein Dropdown-Wert für eine Zahlenvariable geliefert, wenn nicht auf value.value!=null geprüft wird.
  value.id == (selection == null ? void 0 : selection.valueId)
  // ||
  // (value.value != null && value.value == selection?.valueId)
  ))(state);
};
// FIXME: Die Währung und locale sollte aus dem store kommen. - CL
const selectPriceFormatter = _state => {
  const formatter = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR"
  });
  return formatter;
};
const selectArticlePrice = (articleId, qty) => state => {
  var _dealerData$apps;
  const now = new Date();
  const app = selectFrontendApp(state);
  const dealerData = state.common.dealerData;
  const dealerApp = (_dealerData$apps = dealerData.apps) == null ? void 0 : _dealerData$apps.find(da => da.appId == (app == null ? void 0 : app.id));
  const dealerDiscount = (dealerData == null ? void 0 : dealerData.discount) || 0;
  const dealerSurcharge = (dealerData == null ? void 0 : dealerData.surcharge) || 0;
  const appDiscount = (dealerApp == null ? void 0 : dealerApp.discount) != 0 ? dealerApp == null ? void 0 : dealerApp.discount : null;
  const appSurcharge = (dealerApp == null ? void 0 : dealerApp.surcharge) != 0 ? dealerApp == null ? void 0 : dealerApp.surcharge : null;
  const discount = appDiscount != null ? appDiscount : dealerDiscount;
  const surcharge = appSurcharge != null ? appSurcharge : dealerSurcharge;
  const prices = selectPricesByArticleId(articleId)(state).filter(price => !price.displayOnly && (price.fromDate == null || new Date(price.fromDate) <= now) && (price.toDate == null || new Date(price.toDate) >= now) && (price.fromQty == null || price.fromQty == 0 || price.fromQty <= qty) && (price.toQty == null || price.toQty == 0 || price.toQty >= qty)).sort((a, b) => a.sort - b.sort).map(p => Object.assign({}, p, {
    price: p.price * (1 - discount / 100) * (1 + surcharge / 100)
  }));
  if (prices.length == 0) {
    const fallbackPrice = {
      price: 0,
      type: PriceType.fixed
    };
    return fallbackPrice;
  }
  return prices[0];
};
const selectOverallPrice = state => {
  let overallPrice = selectAllArticlesAndPrices(state).priceTotal;
  overallPrice = applyCallback("setPrice", overallPrice);
  return overallPrice;
};
const sumUp = (list, attr) => reduce$1(list, (result, item) => result + attr(item), 0);
const selectBOMEntry = (state, articleAction) => {
  let qty = articleAction.count || 1;
  if (articleAction.expression) {
    const selections = selectSelections(state);
    const variables = selectVariables(state);
    const values = selectValues(state);
    const {
      result,
      errorMessage
    } = evaluateExpression(variables, values, selections, articleAction.expression, articleAction.anchoringSelection);
    qty = result;
    if (errorMessage != null) {
      console.warn(errorMessage);
    }
  }
  const article = selectArticleById(articleAction.articleId)(state);
  if (!article) {
    console.warn(`Article not found: ${articleAction.articleId} for article action: ${JSON.stringify(articleAction, null, 2)}`);
    return undefined;
  }
  return {
    articleAction,
    qty,
    article,
    price: selectArticlePrice(articleAction.articleId, qty)(state),
    main: articleAction.main
  };
};
const selectBOM = state => selectArticleActions(state).reduce((acc, action) => {
  const re = selectBOMEntry(state, action);
  if (re && re.qty > 0) acc.push(re);
  return acc;
}, []);
const selectSelectionsAndArticles = state => {
  const groups = selectGroups(state).slice().sort(byOrder);
  const variables = selectVariables(state);
  const selections = selectVisibleSelections(state);
  const allArticleActions = selectArticleActions(state);
  const allArticlesAndPrices = selectAllArticlesAndPrices(state);
  function getVariablePrice(group, index, variable, selection) {
    const articleActions = allArticleActions.filter(action => action.variableId === variable.id && action.selectionId === (selection == null ? void 0 : selection.id));
    const articleLines = [];
    const surchargeLines = [];
    function addAction(action, source, target) {
      const line = source.find(l => {
        var _l$article;
        return action.articleId == (l == null ? void 0 : (_l$article = l.article) == null ? void 0 : _l$article.id);
      });
      if (line) target.push(line);
    }
    articleActions.forEach(action => {
      addAction(action, allArticlesAndPrices.articleLines, articleLines);
      addAction(action, allArticlesAndPrices.surchargeLines, surchargeLines);
    });
    const priceTotal = sumUp(articleLines, a => a.priceTotal) + sumUp(surchargeLines, a => a.priceTotal);
    const subVariables = isMultiVariable(variable) ? getRows(variable.id, selection.id) : null;
    return {
      group,
      index,
      variable,
      selectionLabel: String(selectLabelOfSelection(selection)(state)),
      selection,
      bom: {
        articleLines,
        surchargeLines,
        priceTotal
      },
      subVariables: subVariables
    };
  }
  function getRows(variableId, instanceId) {
    const rows = groups.filter(group => group.parentId == variableId).flatMap(group => {
      return variables.filter(v => v.groupId == group.id).sort(byOrder).flatMap(v => selections.filter(s => v.id == s.variableId && (s.instance.id == instanceId || s.instance.id == s.id)).map(s => ({
        v,
        s
      }))).filter(({
        v,
        s
      }) => s != null).map(({
        v,
        s
      }, index) => getVariablePrice(group, index, v, s));
    });
    return rows;
  }
  return getRows(null, "");
};
function selectVisibleRows(state) {
  const rows = selectSelectionsAndArticles(state);
  return rows.filter(row => selectIsSelectionDisplayedInSummaries(row.variable, row.selection)(state));
}
const selectAllArticlesAndPrices = state => {
  const bom = selectBOM(state);
  const articles = bom.filter(pos => pos.price.type == PriceType.fixed);
  const surcharges = bom.filter(pos => pos.price.type == PriceType.surcharge);
  const surchargesHidden = bom.filter(pos => pos.price.type == PriceType.surchargeHidden);
  const articlesTotal = sumUp(articles, a => a.price.price * a.qty);
  const surchargesHiddenTotal = sumUp(surchargesHidden, a => a.price.price) / 100.0;
  const articleLines = articles.map(a => Object.assign({}, a, {
    priceUnit: a.price.price * (1 + surchargesHiddenTotal),
    priceTotal: a.price.price * (1 + surchargesHiddenTotal) * a.qty
  }));
  const surchargeLines = surcharges.map(a => Object.assign({}, a, {
    priceUnit: a.price.price / 100 * articlesTotal,
    priceTotal: a.price.price / 100 * articlesTotal * a.qty
  }));
  const priceTotal = sumUp(articleLines, a => a.priceTotal) + sumUp(surchargeLines, a => a.priceTotal);
  return {
    articleLines,
    surchargeLines,
    priceTotal
  };
};
const selectOverallFormattedPrice = state => {
  const formatter = selectPriceFormatter();
  const overallPrice = selectOverallPrice(state);
  return formatter.format(overallPrice);
};
const selectLabelOfSelection = selection => state => {
  if (!selection) return null;
  if (isNumberSelection(selection)) {
    var _selection$data;
    const variable = selectVariableById(selection.variableId)(state);
    return Number((_selection$data = selection.data) == null ? void 0 : _selection$data.inputValue).toFixed(getTemplateOptions(variable).digits || 0);
  } else {
    const values = selectValues(state);
    const value = values.find(value => value.id == selection.valueId);
    return (value == null ? void 0 : value.label) || selection.data;
  }
};
const selectNoSelectionValue = variableId => flow(selectValuesByVariableId(variableId), find$1(value => value.key === noSelectionKey));
const selectGroupsForOpenInstance = state => {
  const openInstance = selectOpenInstance(state);
  return selectGroupsForInstance(openInstance)(state);
};
const selectGroupsForInstance = instance => state => {
  const groups = selectGroups(state);
  const parentId = instance.instance.belongsToVariableId;
  return groups.filter(group => group.parentId == parentId);
};
// Invisible groups are fully invisible in the frontend
// In admin-panel they will get a custom-marker and can still be selected
const selectInvisibleGroups = state => {
  const visibleGroups = selectGroupsForOpenInstance(state);
  // Returns only groups with variables that have no variables with selections on them
  return visibleGroups.filter(group => {
    const variables = selectVariablesOfGroup(group.id)(state);
    return variables.every(variable => selectIsVariableHiddenBecause(variable)(state));
  });
};
const selectVisibleGroups = state => {
  const visibleGroups = selectGroupsForOpenInstance(state);
  // Returns only groups that have at least one visible variable
  return visibleGroups.filter(group => {
    const variables = selectVariablesOfGroup(group.id)(state);
    return variables.some(variable => selectIsVariableHiddenBecause(variable)(state) === null);
  });
};
const selectVisibleGroupsTouchedByUser = state => {
  const parentId = selectOpenInstance(state).instance.belongsToVariableId;
  const touchedVariableIds = selectTouchedByUser(state);
  const variables = selectVariablesByIds(touchedVariableIds[parentId === null ? "" : parentId])(state);
  const visibleGroups = selectVisibleGroups(state);
  // @ts-ignore
  const touchedGroups = variables.reduce((acc, v) => {
    const group = visibleGroups.find(g => g.id === v.groupId);
    return group ? [...acc, group] : acc;
  }, []);
  return touchedGroups;
};
const selectIsGroupRevealed = group => state => {
  const revealGroups = selectRevealGroups(state);
  const isInEditorMode = selectShowEditorUi(state);
  if (!revealGroups || isInEditorMode) {
    return true;
  }
  const groups = selectVisibleGroups(state);
  const groupsTouchedByUser = selectVisibleGroupsTouchedByUser(state);
  const maxSortedGroup = maxBy(groupsTouchedByUser, g => g.sort);
  const maxTouchedIndex = maxSortedGroup ? groups.findIndex(g => g.id === maxSortedGroup.id) : 0;
  const focusGroupId = selectFocusGroupId(state);
  const focusIndex = Math.max(groups.findIndex(g => g.id === focusGroupId), 0);
  const indexLastVisible = clamp(Math.max(maxTouchedIndex, focusIndex) + 1, 0, groups.length);
  const groupIndex = groups.findIndex(g => g.id === group.id);
  return groupIndex <= indexLastVisible;
};
const selectParentVariablePath = parentId => state => {
  if (!parentId) return [];
  const variables = selectVariables(state);
  const variablesById = indexById(variables);
  let path = [];
  while (parentId) {
    const parentVariable = variablesById[parentId];
    path = [parentVariable, ...path];
    parentId = parentVariable == null ? void 0 : parentVariable.parentId;
  }
  return path;
};
const selectSidebarPosition = state => {
  const app = selectFrontendApp(state);
  return getSidebarPosition(app);
};
const selectRevealGroups = state => {
  var _app$settings, _app$settings$design;
  const app = selectFrontendApp(state);
  return (app == null ? void 0 : (_app$settings = app.settings) == null ? void 0 : (_app$settings$design = _app$settings.design) == null ? void 0 : _app$settings$design.revealGroups) || false;
};
const selectAddCheckMarkToVisitedTabs = state => {
  var _app$settings2, _app$settings2$design;
  const app = selectFrontendApp(state);
  return (app == null ? void 0 : (_app$settings2 = app.settings) == null ? void 0 : (_app$settings2$design = _app$settings2.design) == null ? void 0 : _app$settings2$design.addCheckMarkToVisitedTabs) || false;
};
// FIXME: We need a better method for determining app context
const selectIsAdminPanel = state => {
  var _state$configurator;
  return Boolean(state == null ? void 0 : (_state$configurator = state.configurator) == null ? void 0 : _state$configurator.app);
};
const isControlledByInstanceActions = variableId => state => {
  const values = selectValuesByVariableId(variableId)(state);
  const valuesById = indexById(values);
  const instanceActionRuleValues = selectInstanceActionRuleItemValues(state);
  return instanceActionRuleValues.some(v => valuesById[v.valueId]);
};
const selectGroupByVariableId = variableId => state => {
  const variable = selectVariableById(variableId)(state);
  if (!variable) {
    return undefined;
  }
  const group = selectGroupById(variable.groupId)(state);
  return group;
};
const selectSiblingInstances = state => {
  const selection = selectOpenInstance(state);
  const selections = selectSelections(state);
  const result = selections.filter(s => s.variableId === selection.variableId);
  const hasInstanceActions = isControlledByInstanceActions(selection.variableId)(state);
  if (hasInstanceActions) {
    const values = selectValuesByVariableId(selection.variableId)(state);
    const valuesById = indexById(values);
    result.sort((a, b) => {
      var _a$sort2, _b$sort2;
      if (a.valueId && b.valueId) {
        var _valueA$sort, _valueB$sort, _a$sort, _b$sort;
        const valueA = valuesById[a.valueId];
        const valueB = valuesById[b.valueId];
        return ((_valueA$sort = valueA == null ? void 0 : valueA.sort) != null ? _valueA$sort : 0) - ((_valueB$sort = valueB == null ? void 0 : valueB.sort) != null ? _valueB$sort : 0) || ((_a$sort = a.sort) != null ? _a$sort : 0) - ((_b$sort = b.sort) != null ? _b$sort : 0);
      }
      return ((_a$sort2 = a.sort) != null ? _a$sort2 : 0) - ((_b$sort2 = b.sort) != null ? _b$sort2 : 0);
    });
  } else {
    result.sort((a, b) => {
      var _a$sort3, _b$sort3;
      return ((_a$sort3 = a.sort) != null ? _a$sort3 : 0) - ((_b$sort3 = b.sort) != null ? _b$sort3 : 0);
    });
  }
  return result;
};

const setInitialFocusGroupKey = () => (dispatch, getState) => {
  var _groups$filter$find;
  const state = getState();
  const invisible = selectInvisibleGroups(state);
  const groups = selectGroupsForOpenInstance(state);
  const selection = selectOpenInstance(state);
  const firstGroup = (_groups$filter$find = groups.filter(group => group.parentId === (selection == null ? void 0 : selection.variableId)).find(group => !isHidden(group, invisible))) != null ? _groups$filter$find : groups[0];
  dispatch(setGroup(firstGroup == null ? void 0 : firstGroup.id));
};
const setEngineState = newState => dispatch => {
  dispatch(setActionEngineInput((newState == null ? void 0 : newState.actionEngineInput) || null));
  dispatch(setActionEngineState((newState == null ? void 0 : newState.actionEngineState) || null));
  dispatch(setRuleEngineInput((newState == null ? void 0 : newState.ruleEngineInput) || null));
  dispatch(setRuleEngineState((newState == null ? void 0 : newState.ruleEngineState) || null));
};
const acceptAlternativeThunk = () => (dispatch, getState) => {
  const state = getState();
  const conflict = selectRuleEngineConflict(state);
  dispatch(setEngineState(conflict));
  dispatch(setRuleEngineConflict(null));
};
const rejectAlternativeThunk = () => dispatch => {
  dispatch(setRuleEngineConflict(null));
};
const goBackToInstance = (nextInstance, variableId) => (dispatch, getState) => {
  var _history$find;
  const state = getState();
  const history = state.common.focusGroupHistory;
  const groupsInInstance = selectGroupsForInstance(nextInstance)(state);
  const nextGroup = (_history$find = history.find(groupId => groupsInInstance.some(group => group.id === groupId))) != null ? _history$find : groupsInInstance[0].id;
  dispatch(setOpenInstance(nextInstance));
  dispatch(setGroup(nextGroup));
  dispatch(setSelectedVariableId(variableId != null ? variableId : nextInstance.variableId));
};
const setGroup = groupId => dispatch => {
  dispatch(driveToCam({
    type: "group",
    id: groupId
  }));
  dispatch(setFocusGroupId(groupId));
};
const openParentInstance = () => (dispatch, getState) => {
  const state = getState();
  const selection = selectOpenInstance(state);
  const group = selectGroupByVariableId(selection == null ? void 0 : selection.variableId)(state);
  const parentSelectionId = getParentSelectionId(selection) || rootSelection.id;
  dispatch(openInstanceById(parentSelectionId, group == null ? void 0 : group.id));
};
const handleLoadedApp = async (dispatch, fullApp) => {
  var _fullApp, _fullApp2, _fullApp3, _fullApp4, _fullApp5, _fullApp6, _fullApp7, _fullApp8, _fullApp9, _fullApp10, _fullApp11;
  if (hasCallback("preprocessFullApp")) {
    fullApp = applyCallback("preprocessFullApp", fullApp);
  }
  dispatch(setClient((_fullApp = fullApp) == null ? void 0 : _fullApp.client));
  dispatch(setGroups((_fullApp2 = fullApp) == null ? void 0 : _fullApp2.groups));
  dispatch(setVariables((_fullApp3 = fullApp) == null ? void 0 : _fullApp3.variables));
  dispatch(setValues((_fullApp4 = fullApp) == null ? void 0 : _fullApp4.values));
  dispatch(setArticles((_fullApp5 = fullApp) == null ? void 0 : _fullApp5.articles));
  dispatch(setPrices((_fullApp6 = fullApp) == null ? void 0 : _fullApp6.prices));
  dispatch(setMaterials((_fullApp7 = fullApp) == null ? void 0 : _fullApp7.materials));
  dispatch(setModels((_fullApp8 = fullApp) == null ? void 0 : _fullApp8.models));
  dispatch(setImages(((_fullApp9 = fullApp) == null ? void 0 : _fullApp9.images) || []));
  dispatch(setRules((_fullApp10 = fullApp) == null ? void 0 : _fullApp10.rules));
  dispatch(setRuleItems((_fullApp11 = fullApp) == null ? void 0 : _fullApp11.ruleItems));
  initializeGoogleAnalytics(fullApp.app);
  analyticsTrack("cfg", "loaded", fullApp.app);
};
const setMetadataForAppThunk = fullApp => async dispatch => {
  await handleLoadedApp(dispatch, fullApp);
  return fullApp;
};
const loadFullAppByCode = (appCode, language) => async dispatch => {
  const fullApp = await api_getFullApp(language, appCode);
  await handleLoadedApp(dispatch, fullApp);
  return fullApp;
};
const resetMetadata = async dispatch => {
  dispatch(setGroups([]));
  dispatch(setVariables([]));
  dispatch(setValues([]));
  dispatch(setArticles([]));
  dispatch(setPrices([]));
  dispatch(setMaterials([]));
  dispatch(setModels([]));
  dispatch(setImages([]));
  dispatch(setRules([]));
  dispatch(setRuleItems([]));
};
const mergeFullAndArticles = (fullApp, articlesAndPrices) => {
  var _articlesAndPrices$pr, _articlesAndPrices$ar;
  const base = {
    articles: [],
    prices: []
  };
  const mergedApp = articlesAndPrices != null && (_articlesAndPrices$pr = articlesAndPrices.prices) != null && _articlesAndPrices$pr.length || articlesAndPrices != null && (_articlesAndPrices$ar = articlesAndPrices.articles) != null && _articlesAndPrices$ar.length ? Object.assign({}, fullApp, articlesAndPrices) : fullApp;
  return Object.assign({}, base, mergedApp);
};
const initialiseApp = (fullApp, articlesAndPrices, configuration, checkSelections = false) => async dispatch => {
  if (configuration) {
    dispatch(setConfigurationInitialization({
      checkSelections,
      configuration
    }));
    dispatch(setConfiguration(configuration));
  }
  await dispatch(setMetadataForAppThunk(mergeFullAndArticles(fullApp, articlesAndPrices)));
  dispatch(setFrontendApp(fullApp.app));
};
const createImageVariableDefaultValues = imageVariable => async dispatch => {
  await dispatch(createValueThunk({
    appId: imageVariable.appId,
    label: t("Nicht Befüllt"),
    sort: 0,
    value: false,
    variableId: imageVariable.id
  }, imageVariable));
  await dispatch(createValueThunk({
    appId: imageVariable.appId,
    label: t("Befüllt"),
    sort: 1,
    value: true,
    variableId: imageVariable.id
  }, imageVariable));
};
const createBooleanVariableDefaultValues = booleanVariable => async dispatch => {
  await dispatch(createValueThunk({
    appId: booleanVariable.appId,
    label: t("Ausgewählt"),
    sort: 0,
    value: true,
    variableId: booleanVariable.id
  }, booleanVariable));
  await dispatch(createValueThunk({
    appId: booleanVariable.appId,
    label: t("Nicht ausgewählt"),
    sort: 1,
    value: false,
    variableId: booleanVariable.id
  }, booleanVariable));
};
const createNoSelectionValueForVariable = variable => (dispatch, getState) => {
  const state = getState();
  const optionalValue = selectNoSelectionValue(variable.id)(state);
  if (!optionalValue) {
    const newOptionalValue = {
      label: t("Keine Angabe"),
      key: noSelectionKey,
      appId: variable.appId,
      variableId: variable.id,
      sort: 0,
      value: null
    };
    dispatch(createValueThunk(newOptionalValue, variable));
  }
};
const deleteNoSelectionValueForVariable = variable => (dispatch, getState) => {
  const state = getState();
  const optionalValue = selectNoSelectionValue(variable.id)(state);
  if (optionalValue) {
    dispatch(deleteValueThunk(optionalValue.id));
  }
};
const openInstanceById = (selectionId, focusGroupId) => (dispatch, getState) => {
  const state = getState();
  const selection = !selectionId ? rootSelection : selectSelectionById(selectionId)(state);
  if (selection) {
    dispatch(setOpenInstance(selection));
    if (focusGroupId) {
      dispatch(setGroup(focusGroupId));
    } else {
      dispatch(setInitialFocusGroupKey());
    }
  }
};

var SITUATION;
(function (SITUATION) {
  SITUATION[SITUATION["initial"] = 0] = "initial";
  SITUATION[SITUATION["localSavedWithSavedAction"] = 1] = "localSavedWithSavedAction";
  SITUATION[SITUATION["localSavedWithoutSavedAction"] = 2] = "localSavedWithoutSavedAction";
  SITUATION[SITUATION["versionMissmatch"] = 3] = "versionMissmatch";
  SITUATION[SITUATION["noAppAndCfgCode"] = 4] = "noAppAndCfgCode";
  SITUATION[SITUATION["errorWhileLoading"] = 5] = "errorWhileLoading";
})(SITUATION || (SITUATION = {}));
function useLoadingSituation(decision) {
  const dispatch = useTypedDispatch();
  const [situation, setSituation] = useState(SITUATION.initial);
  const [versionMissmatchedApp, setVersionMissmatchedApp] = useState(undefined);
  const [versionMissmatchedConfiguration, setVersioMissmatchedConfiguration] = useState(undefined);
  useEffect(() => {
    const decideForSituation = async () => {
      const appCode = getAppCode();
      const cfgCode = getCfgCode();
      const queryDealerCode = getDealerCodeFromQuery();
      async function tryToSetDealerApp(dealerCode, fullApp) {
        var _dealerJSON, _dealerJSON$apps;
        let dealerJSON = undefined;
        try {
          if (dealerCode) {
            dealerJSON = await api_getDocs(`/data/dealer/${dealerCode}.json`);
          }
        } catch (error) {
          setSituation(SITUATION.noAppAndCfgCode);
        }
        if (!dealerJSON) return;
        const dealerApp = (_dealerJSON = dealerJSON) == null ? void 0 : (_dealerJSON$apps = _dealerJSON.apps) == null ? void 0 : _dealerJSON$apps.find(da => da.appId == fullApp.app.id);
        if (dealerApp) {
          dispatch(setDealerData(dealerJSON));
        } else {
          throw new Error("no dealer app access");
        }
      }
      async function tryToFetchArticles(fullApp, cfg) {
        return api_getArticlesAndPricesFromJson(getLanguages(fullApp.app)[0], fullApp.app.code, cfg == null ? void 0 : cfg.articleVersionId);
      }
      // loading a configuration by code
      if (cfgCode) {
        var _loadedCfg$dealerCode;
        let loadedCfg = undefined;
        try {
          loadedCfg = await api_getConfigurationFromJson(cfgCode);
        } catch (e) {
          console.error("No Inspiration for this configuration found. Instead asking Backend. No Problem :-)");
          try {
            loadedCfg = await api_getConfiguration(cfgCode);
            if (!loadedCfg.versionId) throw new Error("Konfiguration nicht gefunden. Ist der Konfigurator veröffentlicht?");
          } catch (error) {
            setSituation(SITUATION.noAppAndCfgCode);
          }
        }
        if (!loadedCfg) return;
        const fullApp = await api_getFullAppFromJsonWithLangDefault(getPreferredContentLanguage(loadedCfg), loadedCfg.appCode, "current", dispatch);
        await tryToSetDealerApp( // queryDealerCode is required for inspirations
        (_loadedCfg$dealerCode = loadedCfg.dealerCode) != null ? _loadedCfg$dealerCode : queryDealerCode, fullApp);
        if (loadedCfg.inspiration) {
          const articlesAndPrices = await tryToFetchArticles(fullApp, loadedCfg);
          await dispatch(initialiseApp(fullApp, articlesAndPrices, loadedCfg, true));
        } else if (loadedCfg.versionId !== fullApp.app.versionId) {
          setSituation(SITUATION.versionMissmatch);
          setVersionMissmatchedApp(fullApp);
          setVersioMissmatchedConfiguration(loadedCfg);
        } else {
          const articlesAndPrices = await tryToFetchArticles(fullApp, loadedCfg);
          dispatch(initialiseApp(fullApp, articlesAndPrices, loadedCfg));
        }
      }
      // loading an app by code
      else if (appCode) {
        try {
          const fullApp = await api_getFullAppFromJsonWithLangDefault(getPreferredContentLanguage(), appCode, "current", dispatch);
          await tryToSetDealerApp(queryDealerCode, fullApp);
          const articlesAndPrices = await tryToFetchArticles(fullApp);
          dispatch(initialiseApp(fullApp, articlesAndPrices));
        } catch (error) {
          setSituation(SITUATION.noAppAndCfgCode);
        }
      } else {
        setSituation(SITUATION.noAppAndCfgCode);
      }
    };
    decideForSituation();
  }, [decision]);
  return {
    situation: situation,
    versionMissmatchedApp: versionMissmatchedApp,
    versionMissmatchedConfiguration: versionMissmatchedConfiguration
  };
}

var LOADINGDECISION;
(function (LOADINGDECISION) {
  LOADINGDECISION[LOADINGDECISION["none"] = 0] = "none";
  LOADINGDECISION[LOADINGDECISION["handleRestartAfterRescue"] = 1] = "handleRestartAfterRescue";
  LOADINGDECISION[LOADINGDECISION["handleContinueAfterRescue"] = 2] = "handleContinueAfterRescue";
})(LOADINGDECISION || (LOADINGDECISION = {}));
const AppLoader = () => {
  const {
    t
  } = useTranslation();
  const dispatch = useTypedDispatch();
  const {
    situation,
    versionMissmatchedApp,
    versionMissmatchedConfiguration
  } = useLoadingSituation(LOADINGDECISION.none);
  const navigate = useNavigate();
  const handleCurrentForVersionMissmatch = async () => {
    const articlesAndPrices = await api_getArticlesAndPricesFromJson(getLanguages(versionMissmatchedApp.app)[0], versionMissmatchedApp.app.code, versionMissmatchedConfiguration == null ? void 0 : versionMissmatchedConfiguration.articleVersionId);
    dispatch(initialiseApp(versionMissmatchedApp, articlesAndPrices, versionMissmatchedConfiguration));
  };
  const handleOriginalForVersionMissmatch = async () => {
    const loadingId = dispatch(requestLoadingThunk);
    if (!versionMissmatchedConfiguration) return;
    const fullApp = await api_getFullAppFromJsonWithLangDefault(getPreferredContentLanguage(versionMissmatchedConfiguration), versionMissmatchedConfiguration.versionId, "old", null);
    const articlesAndPrices = await api_getArticlesAndPricesFromJson(getLanguages(fullApp.app)[0], fullApp.app.code, versionMissmatchedConfiguration == null ? void 0 : versionMissmatchedConfiguration.articleVersionId);
    await dispatch(initialiseApp(fullApp, articlesAndPrices, versionMissmatchedConfiguration));
    dispatch(finishLoading(loadingId));
  };
  switch (situation) {
    case SITUATION.initial:
      return jsx(Loading, {
        loading: true
      });
    case SITUATION.versionMissmatch:
      return jsxs(Dialog, {
        open: true,
        children: [jsx(DialogTitle, {
          children: t("Konfigurator wurde aktualisiert")
        }), jsxs(DialogContent, {
          children: [jsx(DialogContentText, {
            children: t("Seit Sie diese Konfiguration gespeichert haben, wurde der Konfigurator weiterentwickelt." + " Wollen Sie die aktuelle Version verwenden und weiterarbeiten" + " oder die alte Version nur zur Ansicht öffnen?")
          }), jsxs(DialogActions, {
            children: [jsx(Button, {
              onClick: handleOriginalForVersionMissmatch,
              "data-cy": `oldVersion`,
              children: t("Alte Version")
            }), jsx(Button, {
              "data-cy": `newVersion`,
              variant: "contained",
              onClick: handleCurrentForVersionMissmatch,
              children: t("Aktuelle Version")
            })]
          })]
        })]
      });
    case SITUATION.noAppAndCfgCode:
      return jsxs(Dialog, {
        open: true,
        children: [jsx(DialogTitle, {
          children: t("Ladevorgang fehlgeschlagen")
        }), jsxs(DialogContent, {
          children: [jsx(DialogContentText, {
            children: t("Die Konfiguration konnte nicht geladen werden! Bitte versuchen Sie es später erneut!")
          }), jsxs(DialogActions, {
            children: [jsx(Button, {
              "data-cy": `goHome`,
              onClick: () => {
                navigate("/admin");
                navigate(0);
              },
              children: t("Zur Startseite")
            }), jsx(Button, {
              onClick: () => window.location.reload(),
              "data-cy": `reload`,
              children: t("Neu Laden")
            }), jsx(Button, {
              "data-cy": `restart`,
              onClick: () => {
                window.localStorage.clear();
                window.location.reload();
              },
              children: t("Cleanup und Neu Laden")
            })]
          })]
        })]
      });
    default:
      return jsx(Fragment, {});
  }
};

const AppInformation = () => {
  const appInfo = useTypedSelector(selectAppInfo);
  const dispatch = useTypedDispatch();
  const {
    t
  } = useTranslation();
  const handleClose = () => {
    dispatch(setAppInfo(null));
  };
  // Wir übersetzen die Nachricht hier, weil aus Untiefen kommen kann, in denen useTranslation nicht zure Verfügung steht.
  return jsx(Snackbar, {
    open: appInfo != null,
    autoHideDuration: (appInfo == null ? void 0 : appInfo.autoHide) || 6000,
    onClose: handleClose,
    children: jsx(Alert, {
      onClose: handleClose,
      severity: "error",
      sx: {
        width: "100%"
      },
      children: t(appInfo == null ? void 0 : appInfo.message)
    })
  });
};

const LocalizedText = ({
  value
}) => {
  const language = useTypedSelector(selectContentLanguage);
  return jsx(Fragment, {
    children: getLocalizedText(value, language)
  });
};
const getLocalizedText = (value, language) => {
  var _ref, _value$language;
  return (_ref = (_value$language = value == null ? void 0 : value[language]) != null ? _value$language : `[${value == null ? void 0 : value["de"]}]`) != null ? _ref : "";
};

const AttributeDisplay = props => {
  const language = useTypedSelector(selectContentLanguage);
  // TODO: No idea what is correct here
  const displayValue = (attr, value) => {
    const attrValue = (value.attrs || []).find(a => a.attrId == attr.id);
    if (!attrValue) return null;
    switch (attr.type) {
      case "string":
        // eslint-disable-next-line no-case-declarations
        const _value = (attrValue == null ? void 0 : attrValue.value) || {};
        return getLocalizedText(_value, language);
      case "number":
        return (attrValue == null ? void 0 : attrValue.value) + " " + (attr.unit || "");
      case "symbol":
      default:
        return JSON.stringify(attrValue == null ? void 0 : attrValue.value);
    }
  };
  return jsx(Table, {
    size: "small",
    sx: {
      [`& .${tableCellClasses.root}`]: {
        borderBottom: "none"
      }
    },
    children: jsx(TableBody, {
      children: props.attrs.map(attr => jsxs(TableRow, {
        children: [jsx(TableCell, {
          component: "th",
          scope: "row",
          children: jsx(LocalizedText, {
            value: attr.label
          })
        }), jsx(TableCell, {
          children: displayValue(attr, props.value)
        })]
      }, attr.id))
    })
  });
};

const HTMLStringToReact = ({
  htmlString: _htmlString = ""
}) => {
  const content = useMemo(() => jsx("div", {
    dangerouslySetInnerHTML: {
      __html: _htmlString
    }
  }), [_htmlString]);
  return content;
};

const InfoSelectionDialog = () => {
  var _data$variable, _data$value, _data$value2;
  const {
    t
  } = useTranslation();
  const data = useTypedSelector(selectInfoDialog);
  const dispatch = useTypedDispatch();
  const handleClose = () => {
    dispatch(setInfoDialog(null));
  };
  const displayedAttrs = ((data == null ? void 0 : (_data$variable = data.variable) == null ? void 0 : _data$variable.attrs) || []).filter(attr => attr.displayed);
  return jsxs(Dialog, {
    className: "infoSelectionDialog",
    open: data != null,
    maxWidth: "sm",
    onClose: handleClose,
    fullWidth: true,
    children: [jsx(DialogTitle, {
      className: "infoSelectionDialogTitle",
      children: data == null ? void 0 : data.value.label
    }), jsxs(DialogContent, {
      className: "infoSelectionDialogContent",
      dividers: true,
      children: [(data == null ? void 0 : (_data$value = data.value) == null ? void 0 : _data$value.info) && jsx(Typography, {
        children: jsx(HTMLStringToReact, {
          htmlString: data == null ? void 0 : (_data$value2 = data.value) == null ? void 0 : _data$value2.info
        })
      }), displayedAttrs.length > 0 && jsx(AttributeDisplay, {
        attrs: displayedAttrs,
        value: data == null ? void 0 : data.value
      })]
    }), jsx(DialogActions, {
      className: "infoSelectionDialogActions",
      children: jsx(Button, {
        onClick: handleClose,
        "data-cy": `close`,
        children: t("Schliessen")
      })
    })]
  });
};

/** The extension provider Context.
 * You should not need this.
 */
const providedExtensionsContext = /*#__PURE__*/React__default.createContext({
  extensions: {},
  contexts: []
});
/**
 * Uses the provided extensions context.
 * You should not need this.
 */
const useProvidedExtensions = () => useContext(providedExtensionsContext);
/** @deprecated Use K3Main directly to insert extensions etc. */
const ProvidedExtensionsProvider = props => jsx(providedExtensionsContext.Provider, {
  value: {
    extensions: props.extensions,
    additionalDynamicSettings: props.additionalDynamicSettings,
    contexts: props.contexts || []
  },
  children: props.children
});

/** All the different value types that can be represented by a dynamic setting */
var DynamicSettingValueType;
(function (DynamicSettingValueType) {
  DynamicSettingValueType["STRING"] = "string";
  DynamicSettingValueType["NUMBER"] = "number";
  DynamicSettingValueType["TRANSLATION"] = "translation";
  DynamicSettingValueType["BOOLEAN"] = "boolean";
  DynamicSettingValueType["IMAGE"] = "image";
  DynamicSettingValueType["ARRAY"] = "array";
})(DynamicSettingValueType || (DynamicSettingValueType = {}));
/** Default settings keys */
var DynamicSettingsKeys;
(function (DynamicSettingsKeys) {
  DynamicSettingsKeys["ORDER_DIALOG_OVERVIEW"] = "translation_orderDialogOverview";
  DynamicSettingsKeys["ORDER_DIALOG_OVERVIEW_SELECTIONPRICE"] = "translation_selectionPrice";
  DynamicSettingsKeys["ORDER_DIALOG_OVERVIEW_STEP"] = "translation_step";
  DynamicSettingsKeys["ORDER_DIALOG_OVERVIEW_VARIABLE"] = "translation_variable";
  DynamicSettingsKeys["ORDER_DIALOG_OVERVIEW_SELECTION"] = "translation_selection";
  DynamicSettingsKeys["ORDER_DIALOG_OVERVIEW_TOTALPRICE"] = "translation_totalPrice";
  DynamicSettingsKeys["ORDER_DIALOG_OVERVIEW_PRICE"] = "translation_price";
  DynamicSettingsKeys["ORDER_DIALOG_OVERVIEW_PRICEINFO"] = "translation_priceInformation";
  DynamicSettingsKeys["ORDER_DIALOG_DATA"] = "translation_orderDialogData";
  DynamicSettingsKeys["ORDER_DIALOG_CONFIRMATION"] = "translation_orderDialogConfirmation";
  DynamicSettingsKeys["NAVBAR_BACK"] = "translation_navbarBack";
  DynamicSettingsKeys["NAVBAR_NEXT"] = "translation_navbarNext";
  DynamicSettingsKeys["AR_BUTTON"] = "translation_ar_button";
  DynamicSettingsKeys["FULLSCREEN_BUTTON"] = "translation_fullscreen_button";
  DynamicSettingsKeys["CANCEL"] = "translation_cancel";
  DynamicSettingsKeys["OK"] = "translation_ok";
})(DynamicSettingsKeys || (DynamicSettingsKeys = {}));
/** The default settings */
const dynamicSettings = [{
  key: DynamicSettingsKeys.ORDER_DIALOG_OVERVIEW,
  valueType: DynamicSettingValueType.TRANSLATION,
  defaultValue: "Übersicht"
}, {
  key: DynamicSettingsKeys.ORDER_DIALOG_OVERVIEW_SELECTIONPRICE,
  valueType: DynamicSettingValueType.TRANSLATION,
  defaultValue: "Auswahlpreise"
}, {
  key: DynamicSettingsKeys.ORDER_DIALOG_OVERVIEW_STEP,
  valueType: DynamicSettingValueType.TRANSLATION,
  defaultValue: "Schritt"
}, {
  key: DynamicSettingsKeys.ORDER_DIALOG_OVERVIEW_VARIABLE,
  valueType: DynamicSettingValueType.TRANSLATION,
  defaultValue: "Variable"
}, {
  key: DynamicSettingsKeys.ORDER_DIALOG_OVERVIEW_SELECTION,
  valueType: DynamicSettingValueType.TRANSLATION,
  defaultValue: "Auswahl"
}, {
  key: DynamicSettingsKeys.ORDER_DIALOG_OVERVIEW_TOTALPRICE,
  valueType: DynamicSettingValueType.TRANSLATION,
  defaultValue: "Gesamtpreis"
}, {
  key: DynamicSettingsKeys.ORDER_DIALOG_OVERVIEW_PRICE,
  valueType: DynamicSettingValueType.TRANSLATION,
  defaultValue: "Preis"
}, {
  key: DynamicSettingsKeys.ORDER_DIALOG_OVERVIEW_PRICEINFO,
  valueType: DynamicSettingValueType.TRANSLATION,
  defaultValue: "Preis Information"
}, {
  key: DynamicSettingsKeys.ORDER_DIALOG_DATA,
  valueType: DynamicSettingValueType.TRANSLATION,
  defaultValue: "Persönliche Daten"
}, {
  key: DynamicSettingsKeys.ORDER_DIALOG_CONFIRMATION,
  valueType: DynamicSettingValueType.TRANSLATION,
  defaultValue: "Bestätigung"
}, {
  key: DynamicSettingsKeys.NAVBAR_BACK,
  valueType: DynamicSettingValueType.TRANSLATION,
  defaultValue: "Zurück"
}, {
  key: DynamicSettingsKeys.NAVBAR_NEXT,
  valueType: DynamicSettingValueType.TRANSLATION,
  defaultValue: "Weiter"
}, {
  key: DynamicSettingsKeys.AR_BUTTON,
  valueType: DynamicSettingValueType.TRANSLATION,
  defaultValue: "In AR ansehen"
}, {
  key: DynamicSettingsKeys.FULLSCREEN_BUTTON,
  valueType: DynamicSettingValueType.TRANSLATION,
  defaultValue: "Fullscreen"
}, {
  key: DynamicSettingsKeys.CANCEL,
  valueType: DynamicSettingValueType.TRANSLATION,
  defaultValue: "Abbrechen"
}, {
  key: DynamicSettingsKeys.OK,
  valueType: DynamicSettingValueType.TRANSLATION,
  defaultValue: "OK"
},
// MP Popup texts
{
  key: "translation_mp_popup_add",
  valueType: DynamicSettingValueType.TRANSLATION,
  defaultValue: "Hinzufügen",
  label: "Hinzufügen"
}, {
  key: "translation_mp_popup_search",
  valueType: DynamicSettingValueType.TRANSLATION,
  defaultValue: "Komponenten suchen",
  label: "Suche"
}, {
  key: "translation_mp_popup_not_grouped",
  valueType: DynamicSettingValueType.TRANSLATION,
  defaultValue: "Nicht Gruppiert",
  label: "Nicht gruppiert"
}, {
  key: "translation_mp_popup_description",
  valueType: DynamicSettingValueType.TRANSLATION,
  defaultValue: "Komponenten",
  label: "Beschreibung"
}, {
  key: "translation_mp_popup_title",
  valueType: DynamicSettingValueType.TRANSLATION,
  defaultValue: "Komponenten hinzufügen",
  label: "Titel"
},
// warning texts
{
  key: "translation_warning_number",
  valueType: DynamicSettingValueType.TRANSLATION,
  defaultValue: "Ihre Eingabe war leider nicht möglich und wurde auf den nächstmöglichen Wert zurückgesetzt: "
}, {
  key: "translation_warning_invalid_selection",
  valueType: DynamicSettingValueType.TRANSLATION,
  defaultValue: "Dieser Wert ist nicht kombinierbar mit folgenden Auswahlen:"
}, {
  key: "translation_warning_invalid_selection_alternative",
  valueType: DynamicSettingValueType.TRANSLATION,
  defaultValue: "Bei Auswahl wird eine Alternative berechnet!"
},
// Group Actions
{
  key: "translation_group_multiple_actions",
  valueType: DynamicSettingValueType.TRANSLATION,
  defaultValue: "Bestätigen"
}, {
  key: "translation_group_actions_add_item",
  valueType: DynamicSettingValueType.TRANSLATION,
  defaultValue: "Produkt hinzufügen"
}, {
  key: "translation_group_actions_continue",
  valueType: DynamicSettingValueType.TRANSLATION,
  defaultValue: "Weiter"
}, {
  key: "translation_group_actions_dialog_title",
  valueType: DynamicSettingValueType.TRANSLATION,
  defaultValue: "Produkt erfolgreich konfiguriert"
}, {
  key: "translation_group_actions_dialog_description",
  valueType: DynamicSettingValueType.TRANSLATION,
  defaultValue: "Die Konfiguration ist abgeschlossen. Welches Produkt möchten Sie als Nächstes in den Warenkorb legen?"
}, {
  key: "translation_group_actions_dialog_pick_item",
  valueType: DynamicSettingValueType.TRANSLATION,
  defaultValue: "Neues Produkt auswählen"
}, {
  key: "translation_group_actions_dialog_more",
  valueType: DynamicSettingValueType.TRANSLATION,
  defaultValue: "Weitere Möglichkeiten"
}, {
  key: "translation_group_actions_dialog_add_item",
  valueType: DynamicSettingValueType.TRANSLATION,
  defaultValue: "Neues Produkt hinzufügen"
},
//invalid rule modal
{
  key: "translation_invalid_rule_modal_1_conflict",
  valueType: DynamicSettingValueType.TRANSLATION,
  defaultValue: 'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}).',
  label: 'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}).'
}, {
  key: "translation_invalid_rule_modal_2_conflict",
  valueType: DynamicSettingValueType.TRANSLATION,
  defaultValue: 'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}) und der Auswahl "{{conflictValue1}}" ({{conflictVariable1}}).',
  label: 'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}) und der Auswahl "{{conflictValue1}}" ({{conflictVariable1}}).'
}, {
  key: "translation_invalid_rule_modal_3_conflict",
  valueType: DynamicSettingValueType.TRANSLATION,
  defaultValue: 'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}), der Auswahl "{{conflictValue1}}" ({{conflictVariable1}}) und der Auswahl "{{conflictValue2}}" ({{conflictVariable2}}).',
  label: 'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}), der Auswahl "{{conflictValue1}}" ({{conflictVariable1}}) und der Auswahl "{{conflictValue2}}" ({{conflictVariable2}}).'
}, {
  key: "translation_invalid_rule_modal_other_conflict",
  valueType: DynamicSettingValueType.TRANSLATION,
  defaultValue: 'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu anderen Auswahlen.',
  label: 'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu anderen Auswahlen.'
}, {
  key: "translation_invalid_rule_modal_changes_needed",
  valueType: DynamicSettingValueType.TRANSLATION,
  defaultValue: "Anpassung nötig"
}, {
  key: "translation_invalid_rule_modal_changes_will_be_made",
  valueType: DynamicSettingValueType.TRANSLATION,
  defaultValue: "Stattdessen werden folgende Auswahlen angepasst:"
}, {
  key: "translation_invalid_rule_modal_changes_will_become",
  valueType: DynamicSettingValueType.TRANSLATION,
  defaultValue: "wird zu"
}];
/** Returns all registered settings */
const useDynamicSettings = () => {
  const dynamicTranslations = useTypedSelector(selectDynamicTranslationKeys);
  const extensions = useProvidedExtensions().additionalDynamicSettings;
  return useMemo(() => [...(extensions || []), ...dynamicSettings, ...dynamicTranslations.map(t => ({
    key: t.key,
    valueType: DynamicSettingValueType.TRANSLATION,
    defaultValue: t.defaultValue
  }))], [dynamicTranslations, extensions]);
};
/** Validates if a string can be parsed into a vector of a certain length */
const vectorValidator = len => value => {
  if (typeof value !== "string") return [false, "Please make sure the type is set to array."];
  const split = value.split(", ");
  if (split.length !== len || !split.every(i => i && isFinite(Number(i)))) {
    const err = `Not a vector of length ${len}. Please enter your vector like this: ${new Array(len).fill(0).map((_, i) => i + 1).join(", ")}`;
    return [false, err];
  } else {
    return [true, ""];
  }
};
/** Validates if a string can be parsed into an array */
const arrayValidator = v => {
  if (typeof v !== "string") return [false, "Not a string"];
  const split = v.split(", ");
  const valid = split.every(e => e !== "");
  const err = `Please enter your vector like this: 1, 2, true, test`;
  return [valid, valid ? "" : err];
};

const useContentTranslation = () => {
  const language = useTypedSelector(selectContentLanguage);
  const {
    t
  } = useTranslation();
  return key => t(key, {
    lng: language,
    fallback: false,
    defaultValue: null
  });
};

/**
 * Get a dynamic setting by key and don't apply the default value.
 * You should not need this.
 */
const useGetDynamicSettingNoDefault = () => {
  const dynamicSettings = useTypedSelector(selectDynamicSettings);
  return useCallback(key => dynamicSettings[key], [dynamicSettings]);
};
/**
 * Get a translated string in the current language. You can specify a default,
 * otherwise the default of the setting will be used.
 */
const useDynamicTranslation = () => {
  const get = useGetDynamicSettingNoDefault();
  const dynamicSettings = useDynamicSettings();
  const language = useTypedSelector(selectContentLanguage);
  const {
    t
  } = useTranslation();
  const contentTranslation = useContentTranslation();
  return useCallback((key, defaultString, data) => {
    var _dynamicSettings$find, _get;
    const dynamicValue = (_dynamicSettings$find = dynamicSettings.find(s => s.key === key)) == null ? void 0 : _dynamicSettings$find.defaultValue;
    return (((_get = get(key)) == null ? void 0 : _get[language]) || t(defaultString) || contentTranslation(dynamicValue) || `[${dynamicValue}]` || "").replace(/\{\{(\w+)\}\}/g, (_, key) => (data == null ? void 0 : data[key]) || "{{" + key + "}}");
  }, [dynamicSettings, get, language, t, contentTranslation]);
};
/** Get a dynamic setting and apply an explicit default value or the
 * default value of the setting .
 */
const useDynamicSetting = () => {
  const get = useGetDynamicSettingNoDefault();
  const dynamicSettings = useDynamicSettings();
  return useCallback((key, defaultValue) => {
    var _dynamicSettings$find2;
    return get(key) || defaultValue || ((_dynamicSettings$find2 = dynamicSettings.find(s => s.key === key)) == null ? void 0 : _dynamicSettings$find2.defaultValue);
  }, [get, dynamicSettings]);
};
const standardParser = s => s.split(", ").map(s => {
  try {
    return JSON.parse(s);
  } catch (_unused) {
    return s;
  }
});
/** Get a dynamic settings array.
 *
 * By default, this is a string representation of the array,  with ", " as separators.
 * E.g.: blue, red, green
 *
 * But you can provide another parser directly or via the setting declaration.
 * */
const useDynamicSettingArray = () => {
  const get = useGetDynamicSettingNoDefault();
  const dynamicSettings = useDynamicSettings();
  return useCallback((key, parser, defaultValue) => {
    const t = get(key);
    const s = dynamicSettings.find(s => s.key === key);
    const p = parser || s.parser || standardParser;
    if (t) return p(t);
    return defaultValue || (s == null ? void 0 : s.defaultValue) || [];
  }, [get, dynamicSettings]);
};

async function api_uploadDocument(app, path, files) {
  const formData = new FormData();
  formData.append("app", app.code);
  formData.append("path", path);
  files.forEach(file => {
    formData.append("file[]", file);
  });
  return api_fetch("POST", "/doc", formData);
}
async function api_getDocumentTmpl(path) {
  return api_fetch("GET", `/tmpl/${path}`);
}

const _excluded$m = ["acceptedImageFormats"];
const imageFormatsToContentType = formats => formats ? formats.map(f => f.toLowerCase() === "jpg" ? "jpeg" : f).map(f => f.toLowerCase() === "svg" ? "svg+xml" : f).map(f => `image/${f}`).join(",") : "image/*";
const ImageUploadError = ({
  acceptedImageFormats
}) => {
  const {
    t
  } = useTranslation();
  return jsxs(Fragment, {
    children: [jsx(Typography, {
      component: "b",
      variant: "body1",
      children: t("Das Dateiformat ist nicht erlaubt!")
    }), jsx(Typography, {
      component: "small",
      variant: "caption",
      children: `${t("Erlaube Formate:")} ${acceptedImageFormats.join(", ")}`
    })]
  });
};
function OCImageUpload(_ref) {
  let {
      acceptedImageFormats = ["png", "jpg"]
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$m);
  const {
    t
  } = useTranslation();
  const inputFile = useRef(null);
  const [filetypeError, setFiletypeError] = useState(false);
  const [file, setFile] = useState(null);
  const [url, setUrl] = useState(undefined);
  useEffect(() => {
    setUrl(props.url);
  }, [props.url]);
  const validateFileName = useCallback(filename => {
    let fileExtension = filename == null ? void 0 : filename.split(".").pop().toLowerCase();
    fileExtension = fileExtension === "jpeg" ? "jpg" : fileExtension;
    return acceptedImageFormats == null ? void 0 : acceptedImageFormats.includes(fileExtension);
  }, [acceptedImageFormats]);
  const openFileExplorer = event => {
    var _inputFile$current;
    event.stopPropagation();
    (_inputFile$current = inputFile.current) == null ? void 0 : _inputFile$current.click();
  };
  const readNewFile = useCallback(file => {
    const uploadFile = async file => {
      let url;
      if (!props.storeLocally) {
        const urls = await api_uploadDocument(props.app, "image", [file]);
        url = urls[file.name];
      } else {
        url = window.URL.createObjectURL(file);
      }
      setFile(file);
      setUrl(url);
      if (props.onUrlChange) props.onUrlChange(url);
    };
    if (acceptedImageFormats) {
      if (file == null || validateFileName(file.name)) {
        setFiletypeError(false);
        uploadFile(file);
      } else {
        setFiletypeError(true);
      }
    } else {
      uploadFile(file);
    }
  }, [props, validateFileName, acceptedImageFormats]);
  const handleDelete = event => {
    event == null ? void 0 : event.stopPropagation();
    setFiletypeError(false);
    setUrl(undefined);
    setFile(null);
    props.onDelete();
  };
  return jsx(Box, {
    component: "div",
    sx: {
      width: 1.0,
      height: 1.0
    },
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    "data-cy": props["data-cy"],
    children: jsx(Tooltip, {
      disableHoverListener: props.disabled,
      disableFocusListener: props.disabled,
      leaveDelay: 500,
      title: jsxs(Box, {
        component: "div",
        display: "flex",
        flexDirection: "column",
        children: [filetypeError && jsx(ImageUploadError, {
          acceptedImageFormats: acceptedImageFormats
        }), !filetypeError && !file && !url && acceptedImageFormats && jsx(Typography, {
          component: "small",
          variant: "caption",
          children: `${t("Erlaube Formate:")} ${acceptedImageFormats.join(", ")}`
        }), url && jsxs(Box, {
          component: "div",
          sx: {
            display: "grid",
            gap: 1,
            gridAutoFlow: "column"
          },
          children: [jsx(Button, {
            "data-cy": `replace`,
            variant: "outlined",
            size: "small",
            color: "inherit",
            onClick: openFileExplorer,
            startIcon: jsx(CloudUpload, {
              color: "inherit"
            }),
            children: t("Ersetzen")
          }), jsx(Button, {
            "data-cy": `delete`,
            variant: "outlined",
            size: "small",
            color: "inherit",
            onClick: handleDelete,
            startIcon: jsx(Clear, {
              color: "inherit"
            }),
            children: t("Löschen")
          })]
        })]
      }),
      children: jsx(Box, {
        component: "div",
        sx: {
          width: "100%",
          height: "100%",
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          alignItems: "center"
        },
        children: jsxs(ButtonBase, {
          "data-cy": `imageUpload`,
          disabled: props.disabled,
          sx: {
            width: "100%",
            height: "100%",
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
          },
          onClick: openFileExplorer,
          children: [filetypeError && jsx(ImageUploadError, {
            acceptedImageFormats: acceptedImageFormats
          }), jsx("input", {
            "data-cy": `imageInput`,
            ref: inputFile,
            onChange: event => {
              var _event$target, _event$target$files;
              if (event != null && (_event$target = event.target) != null && (_event$target$files = _event$target.files) != null && _event$target$files[0]) {
                const file = event.target.files[0];
                readNewFile(file);
                //https://stackoverflow.com/questions/19643265/second-use-of-input-file-doesnt-trigger-onchange-anymore/56258902
                event.target.value = "";
              }
            },
            type: "file",
            accept: imageFormatsToContentType(acceptedImageFormats),
            hidden: true
          }), !url ? jsxs(Fragment, {
            children: [jsx(CloudUpload, {
              color: "action",
              sx: {
                color: "text.icon"
              }
            }), jsx(Typography, {
              variant: "caption",
              color: "text.primary",
              children: props.buttonLabel || t("Bild hochladen")
            })]
          }) : jsx("img", {
            style: {
              height: "auto",
              width: "auto",
              maxWidth: "315px",
              maxHeight: "100%",
              boxSizing: "border-box",
              objectFit: "contain",
              padding: 1
            },
            alt: "",
            src: url
          })]
        })
      })
    })
  });
}

const precise = digits => isNumber(digits) ? x => x.toFixed(digits) : identity$1;
const roundValueToStep = step => value => Math.round(value / step) * step;
const OCNumberInput = ({
  TextFieldProps: _TextFieldProps = {},
  min: passedMin = -Infinity,
  max: passedMax = Infinity,
  digits,
  step: _step = 1,
  unit,
  onChange,
  onConfirm,
  debounced,
  debounceTimeMs,
  onChangeByStep,
  onBlur,
  onClear,
  value,
  roundToStep: _roundToStep = false,
  buttons: _buttons = false,
  calculated: _calculated = false,
  label,
  useRaw,
  forceLimit,
  fullWidth,
  disabled,
  "data-cy": dataCy
}) => {
  const min = passedMin != null ? passedMin : -Infinity;
  const max = passedMax != null ? passedMax : Infinity;
  const ref = useRef();
  const limitValue = useCallback(value => when(!!value, flow(parseFloat, when(_roundToStep, roundValueToStep(_step)), clamp$1(min, max), precise(digits)))(value), [digits, max, min, _roundToStep, _step]);
  const handleBlur = useCallback(event => {
    const value = event.target.value;
    if (useRaw) {
      const val = forceLimit ? limitValue(value) : value;
      onChange(val);
    } else if (!onBlur) {
      if (!value) {
        onChange(toString$j(min));
      } else {
        onChange(toString$j(limitValue(value)));
      }
    } else {
      onBlur(limitValue(value));
    }
  }, [onChange, limitValue, min, onBlur, useRaw]);
  const handleStep = useCallback(up => {
    var _ref;
    const newValue = Number(value) + _step * (up ? 1 : -1);
    (_ref = onChangeByStep || onChange) == null ? void 0 : _ref(newValue);
  }, [onChange, onChangeByStep, _step, value]);
  const handleStepUp = useCallback(() => handleStep(true), [handleStep]);
  const handleStepDown = useCallback(() => handleStep(false), [handleStep]);
  const mergedTextFieldProps = useMemo(() => merge$2(_TextFieldProps, {
    type: "number",
    "data-cy": dataCy,
    InputProps: Object.assign({
      sx: {
        "input::-webkit-outer-spin-button, input::-webkit-inner-spin-button": {
          WebkitAppearance: "none",
          margin: 0
        },
        "input[type=number]": {
          MozAppearance: "textfield"
        }
      },
      inputProps: {
        readOnly: _calculated,
        step: _step,
        style: {
          textAlign: "right"
        }
      }
    }, _buttons ? {
      startAdornment: jsxs(InputAdornment, {
        position: "start",
        children: [jsx(IconButton, {
          "data-cy": `plus`,
          sx: {
            p: 0.5
          },
          onClick: handleStepUp,
          tabIndex: -1,
          disabled: disabled,
          children: jsx(Add, {})
        }, "add-button"), jsx(IconButton, {
          "data-cy": `minus`,
          sx: {
            p: 0.5
          },
          onClick: handleStepDown,
          tabIndex: -1,
          disabled: disabled,
          children: jsx(Remove, {})
        }, "remove-button")]
      })
    } : {}, unit || onClear ? {
      endAdornment: jsxs(InputAdornment, {
        position: "end",
        children: [unit, onClear && jsx(IconButton, {
          "data-cy": `clear`,
          size: "small",
          onMouseDown: event => {
            event.preventDefault();
            event.stopPropagation();
            onClear();
          },
          tabIndex: -1,
          children: jsx(Clear, {})
        }, "clear")]
      })
    } : {}, _calculated ? {
      startAdornment: jsx(InputAdornment, {
        position: "start",
        children: "="
      })
    } : {})
  }), [_TextFieldProps, _buttons, _calculated, handleStepDown, handleStepUp, onClear, _step, unit]);
  return jsx(OCTextInput, {
    "data-cy": dataCy,
    ref: ref,
    value: value,
    onChange: onChange,
    onBlur: handleBlur,
    TextFieldProps: mergedTextFieldProps,
    label: label,
    fullWidth: fullWidth,
    debounced: debounced,
    onConfirm: onConfirm,
    debounceTimeMs: debounceTimeMs,
    disabled: disabled
  });
};

const DynamicSettingsField = props => {
  const [err, setErr] = useState("");
  const setValue = v => {
    const validator = props.setting.isValid || props.setting.valueType === DynamicSettingValueType.ARRAY ? arrayValidator : undefined;
    if (validator) {
      const [isValid, error] = validator(v);
      setErr(error);
      if (isValid) {
        props.setValue(v);
      }
    } else {
      props.setValue(v);
    }
  };
  return jsxs(Box, {
    component: "div",
    children: [jsx(DynamicSettingsInput, {
      setting: props.setting,
      value: props.value,
      setValue: setValue
    }), err && jsx(Typography, {
      pt: 1,
      color: "error",
      children: err
    })]
  });
};
const DynamicSettingsInput = ({
  setting,
  value,
  setValue
}) => {
  const {
    t
  } = useTranslation();
  const label = t(setting.label || (typeof setting.defaultValue === "string" ? setting.defaultValue : setting.key));
  const language = useTypedSelector(selectContentLanguage);
  const app = useTypedSelector(selectConfiguratorApp);
  if ([DynamicSettingValueType.STRING, DynamicSettingValueType.ARRAY].includes(setting.valueType)) {
    return jsx(OCTextInput, {
      "data-cy": `dynamic-${value}`,
      value: value,
      onChange: setValue,
      label: label,
      fullWidth: true
    });
  }
  if (setting.valueType === DynamicSettingValueType.NUMBER) {
    return jsx(OCNumberInput, {
      onChange: setValue,
      value: value,
      label: label,
      fullWidth: true,
      "data-cy": "dynamicNumberInput"
    });
  }
  if (setting.valueType === DynamicSettingValueType.TRANSLATION) {
    const val = value;
    return jsx(OCTextInput, {
      "data-cy": `dynamicTranslation`,
      value: val == null ? void 0 : val[language],
      onChange: v => setValue(Object.assign({}, val, {
        [language]: v
      })),
      label: label,
      fullWidth: true
    });
  }
  if (setting.valueType === DynamicSettingValueType.BOOLEAN) {
    return jsx(OCSwitch, {
      checked: value,
      onChange: setValue,
      label: label,
      "data-cy": `dynamicBoolean`
    });
  }
  if (setting.valueType === DynamicSettingValueType.IMAGE) {
    return jsx(OCImageUpload, {
      url: value,
      app: app,
      onDelete: () => setValue(undefined),
      onUrlChange: setValue,
      "data-cy": "imageUpload"
    });
  }
  return jsx(Typography, {
    children: "This type of setting is not implemented yet."
  });
};

const DynamicSettingsForm = ({
  values,
  setValues
}) => {
  const dynamicSettings = useDynamicSettings();
  const settingValues = useTypedSelector(selectDynamicSettings);
  const {
    keys,
    settings
  } = useTypedSelector(state => state.configurator.dynamicSettingsEditing) || {};
  if (!keys && !settings) throw new Error("dynamicSettings were of the wrong type!");
  const setValue = key => v => setValues(Object.assign({}, values, {
    [key]: v
  }));
  const newSettings = useMemo(() => {
    if (settings) return settings;
    return keys.map(k => {
      const r = dynamicSettings.find(s => s.key === k);
      if (!r) throw new Error(`Settings for key ${k} do not exist.`);
      return r;
    }).filter(Boolean);
  }, [settings, keys, dynamicSettings]);
  return jsx(Box, {
    component: "div",
    children: newSettings.map(s => {
      var _values$s$key;
      return jsx(Box, {
        component: "div",
        mb: 2,
        children: jsx(DynamicSettingsField, {
          setting: s,
          value: (_values$s$key = values[s.key]) != null ? _values$s$key : settingValues[s.key],
          setValue: setValue(s.key)
        })
      }, s.key);
    })
  });
};

function useCreateResourceMutation(type) {
  const queryClient = useQueryClient();
  const lang = useTypedSelector(selectContentLanguage);
  return useMutation(variables => api_createResource(type, variables, {
    lang
  }), {
    onSuccess: () => {
      queryClient.invalidateQueries([type]);
      queryClient.invalidateQueries(["metadata"]);
    }
  });
}
function useUpdateResourceMutation(type, config) {
  const queryClient = useQueryClient();
  const lang = useTypedSelector(selectContentLanguage);
  return useMutation(variables => api_updateResource(type, variables, {
    lang
  }), {
    onSuccess: () => {
      queryClient.invalidateQueries([type]);
      if (!(config != null && config.keepMetadata)) queryClient.invalidateQueries(["metadata"]);
    }
  });
}
function useDeleteResourceMutation(type) {
  const queryClient = useQueryClient();
  return useMutation(({
    id
  }) => api_deleteResource(type, id), {
    onSuccess: () => queryClient.invalidateQueries([type])
  });
}

const VariableEditorStep = {
  Presentation: "presentation",
  Options: "options",
  Usage: "usage",
  Values: "values",
  Rules: "rules"
};

const initialState$2 = {
  app: undefined,
  group: undefined,
  variable: undefined,
  variableStep: VariableEditorStep.Options,
  showEditorUi: false,
  devmode: 0,
  helpTopic: undefined,
  device: "desktop",
  showThemeDialog: false,
  showMobileThemeDialog: false,
  searchString: "",
  dynamicSettingsEditing: undefined
};
const configuratorSlice = createSlice({
  name: "configurator",
  initialState: initialState$2,
  reducers: {
    setConfiguratorApp: (state, action) => {
      state.app = action.payload;
    },
    setDynamicSettings: (state, action) => {
      state.dynamicSettingsEditing = action.payload;
    },
    setConfiguratorGroup: (state, action) => {
      state.group = action.payload;
    },
    setConfiguratorVariable: (state, action) => {
      state.variable = action.payload;
    },
    setPreviewDevice: (state, action) => {
      state.device = action.payload;
    },
    setShowEditorUi: (state, action) => {
      state.showEditorUi = action.payload;
    },
    setSearchString: (state, action) => {
      state.searchString = action.payload;
    },
    setShowThemeDialog: (state, action) => {
      state.showThemeDialog = action.payload;
    },
    setShowMobileThemeDialog: (state, action) => {
      state.showMobileThemeDialog = action.payload;
    },
    setDevmode: (state, action) => {
      state.devmode = action.payload;
    },
    setHelpTopic: (state, action) => {
      state.helpTopic = action.payload;
    }
  }
});
const {
  setConfiguratorApp,
  setConfiguratorGroup,
  setConfiguratorVariable,
  setShowEditorUi,
  setSearchString,
  setDynamicSettings,
  setDevmode,
  setHelpTopic,
  setPreviewDevice,
  setShowThemeDialog,
  setShowMobileThemeDialog
} = configuratorSlice.actions;
const configuratorReducer = configuratorSlice.reducer;

/**
 * Sets a new dynamic settings object.
 * You should not need this, use `useSetDynamicSetting` instead.
 */
const useSetDynamicTranslations = () => {
  const app = useTypedSelector(selectFrontendApp);
  const dispatch = useTypedDispatch();
  const {
    mutateAsync: updateApp
  } = useUpdateResourceMutation("app", {
    keepMetadata: true
  });
  return useCallback(async settings => {
    var _app$settings;
    const newApp = Object.assign({}, app, {
      settings: Object.assign({}, app.settings, {
        dynamicTranslationKeys: [...(((_app$settings = app.settings) == null ? void 0 : _app$settings.dynamicTranslationKeys) || []), ...settings]
      })
    });
    await updateApp(newApp, {
      onSuccess: () => {
        dispatch(setConfiguratorApp(newApp));
      }
    });
  }, [updateApp, app, dispatch]);
};
/**
 * Sets a new dynamic settings object.
 * You should not need this, use `useSetDynamicSetting` instead.
 */
const useSetDynamicSettings = () => {
  const app = useTypedSelector(selectFrontendApp);
  const dispatch = useTypedDispatch();
  const {
    mutateAsync: updateApp
  } = useUpdateResourceMutation("app", {
    keepMetadata: true
  });
  return useCallback(async settings => {
    const newApp = Object.assign({}, app, {
      settings: Object.assign({}, app.settings, {
        dynamicSettings: Object.assign({}, app.settings.dynamicSettings, settings)
      })
    });
    await updateApp(newApp, {
      onSuccess: () => {
        dispatch(setConfiguratorApp(newApp));
      }
    });
  }, [updateApp, app, dispatch]);
};
/**
 * Sets only one dynamic setting programmatically.
 *
 * It is recommended that you use our ui with `EditDynamicSettings` or
 * `DynamicSettingsLaunch` if possible.
 */
const useSetDynamicSetting = () => {
  const setSettings = useSetDynamicSettings();
  return useCallback(async (key, value) => await setSettings({
    [key]: value
  }), [setSettings]);
};

const DynamicSettingsDialog = ({
  setOpen,
  open
}) => {
  const {
    t
  } = useTranslation();
  const [values, setValues] = useState({});
  const commitToApp = useSetDynamicSettings();
  const close = async () => {
    await commitToApp(values);
    setOpen(false);
  };
  return jsxs(Dialog, {
    open: open,
    onClose: close,
    children: [jsx(DialogTitle, {
      children: t("Einstellungen")
    }), jsx(DialogContent, {
      children: jsx(DynamicSettingsForm, {
        values: values,
        setValues: setValues
      })
    }), jsx(DialogActions, {
      children: jsx(Button, {
        variant: "contained",
        onClick: close,
        "data-cy": `close`,
        children: t("Schließen")
      })
    })]
  });
};

const _excluded$l = ["component", "display"];
/** Entry-Point to launch a dynamic settings configuration window */
const DynamicSettingsLaunch = props => {
  const {
      display
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded$l);
  const dispatch = useTypedDispatch();
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  // For some reason showEditorUi is true in frontend, so i can't just use this.
  const showEditorUi = useTypedSelector(selectShowEditorUi);
  const admin = useTypedSelector(selectIsAdminPanel);
  if (!showEditorUi || !admin) return null;
  const openDialogOrSidebar = e => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(setDynamicSettings(rest));
    if (display === "dialog") {
      setOpen(true);
    } else {
      nav("dynamic");
    }
  };
  return jsxs(Fragment, {
    children: [jsx(props.component, {
      "data-cy": `edit`,
      onClick: openDialogOrSidebar
    }), jsx(DynamicSettingsDialog, Object.assign({
      setOpen: setOpen,
      open: open
    }, rest))]
  });
};

function EditButton({
  "data-cy": cyKey,
  onClick,
  tooltip
}) {
  return jsx(Tooltip, {
    title: tooltip,
    children: jsx(IconButton, {
      color: "editor",
      "data-cy": cyKey,
      onClick: onClick,
      children: jsx(Edit$4, {})
    })
  });
}

const _excluded$k = ["boxProps"];
/** Launch the dynamic settings with a normal editButton */
const EditDynamicSettings = _ref => {
  let {
      boxProps
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$k);
  const showEditorUi = useTypedSelector(selectShowEditorUi);
  const admin = useTypedSelector(selectIsAdminPanel);
  if (!showEditorUi || !admin) return null;
  return jsx(Box, {
    component: "div",
    sx: Object.assign({
      display: "flex",
      pointerEvents: "all",
      justifyContent: "center",
      alignItems: "center"
    }, boxProps),
    children: jsx(DynamicSettingsLaunch, Object.assign({}, rest, {
      component: EditButton
    }))
  });
};

const InvalidRuleModalWrapper = () => {
  const dispatch = useTypedDispatch();
  const conflict = useTypedSelector(selectRuleEngineConflict);
  if (conflict) {
    const causingConflict = conflict.ruleEngineState.lastManualChange;
    if (!causingConflict) {
      console.error("No change detected, but a conflict. This should not happen.", conflict);
      return null;
    }
    const translated = translateSelection(conflict.ruleEngineInput, conflict.ruleEngineState.state, causingConflict);
    const translatedConflicts = conflict.ruleEngineState.touchedChanges.map(c => c.map(s => translateSelection(conflict.ruleEngineInput, conflict.ruleEngineState.state, s)));
    const acceptAlternative = () => {
      dispatch(acceptAlternativeThunk());
    };
    const rejectAlternative = () => {
      dispatch(rejectAlternativeThunk());
    };
    return jsx(InvalidRuleModal, {
      variableCausingConflict: translated,
      conflicts: translatedConflicts,
      rejectAlternative: rejectAlternative,
      acceptAlternative: acceptAlternative
    });
  } else {
    return null;
  }
};
const getVariableString = v => {
  var _v$instance;
  return (_v$instance = v.instance) != null && _v$instance.value ? `${v.variable}, ${v.instance.index + 1}. ${v.instance.value}` : v.variable;
};
const IInvalidRuleModal = props => {
  const getTranslation = useDynamicTranslation();
  const text = useMemo(() => {
    const data1Conflicts = {
      value: props.variableCausingConflict.value,
      variable: getVariableString(props.variableCausingConflict),
      conflictValue0: props.conflicts[0][0].value,
      conflictVariable0: getVariableString(props.conflicts[0][0])
    };
    if (props.conflicts.length === 1) return getTranslation("translation_invalid_rule_modal_1_conflict", 'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}).', data1Conflicts);
    const data2Conflicts = Object.assign({}, data1Conflicts, {
      conflictValue1: props.conflicts[1][0].value,
      conflictVariable1: getVariableString(props.conflicts[1][0])
    });
    if (props.conflicts.length === 2) return getTranslation("translation_invalid_rule_modal_2_conflict", 'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}) und der Auswahl "{{conflictValue1}}" ({{conflictVariable1}}).', data2Conflicts);
    const data3Conflicts = Object.assign({}, data2Conflicts, {
      conflictValue2: props.conflicts[2][0].value,
      conflictVariable2: getVariableString(props.conflicts[2][0])
    });
    if (props.conflicts.length === 3) return getTranslation("translation_invalid_rule_modal_3_conflict", 'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}), der Auswahl "{{conflictValue1}}" ({{conflictVariable1}}) und der Auswahl "{{conflictValue2}}" ({{conflictVariable2}}).', data3Conflicts);
    return getTranslation("translation_invalid_rule_modal_other_conflict", 'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu anderen Auswahlen.', data1Conflicts);
  }, [props, getTranslation]);
  return jsxs(Dialog, {
    fullWidth: true,
    open: true,
    onClose: props.rejectAlternative,
    className: "invalidRuleModal",
    "data-cy": "invalidRuleModal",
    children: [jsxs(DialogTitle, {
      className: "invalidRuleModalTitle",
      children: [getTranslation("translation_invalid_rule_modal_changes_needed"), jsx(Box, {
        component: "div",
        sx: {
          position: "absolute",
          top: 0,
          right: 0
        },
        children: jsx(EditDynamicSettings, {
          keys: ["translation_invalid_rule_modal_changes_needed", "translation_invalid_rule_modal_changes_will_be_made", "translation_invalid_rule_modal_changes_will_become", "translation_invalid_rule_modal_1_conflict", "translation_invalid_rule_modal_2_conflict", "translation_invalid_rule_modal_3_conflict", "translation_invalid_rule_modal_other_conflict", DynamicSettingsKeys.CANCEL, DynamicSettingsKeys.OK],
          display: "dialog"
        })
      })]
    }), jsxs(DialogContent, {
      className: "invalidRuleModalContent",
      children: [jsx(DialogContentText, {
        id: "alert-dialog-slide-description",
        className: "invalidRuleModalHeading1",
        children: text
      }), jsx("br", {}), jsx(DialogContentText, {
        className: "invalidRuleModalHeading2",
        children: getTranslation("translation_invalid_rule_modal_changes_will_be_made")
      }), jsx(Box, {
        component: "div",
        className: "invalidRuleModalAlternatives",
        children: props.conflicts.map((c, i) => {
          const [o, n] = c;
          // Sorry: What this means: Farbe, Schraube 3: Rot wird zu Blau
          return jsxs(Typography, {
            children: [getVariableString(o), ": ", jsx("b", {
              children: o.value
            }), " ", getTranslation("translation_invalid_rule_modal_changes_will_become"), " ", jsx("b", {
              children: n.value
            })]
          }, i);
        })
      })]
    }), jsxs(DialogActions, {
      className: "invalidRuleModalActions",
      children: [jsx(Button, {
        "data-cy": `deny`,
        className: "invalidRuleModalDecline",
        onClick: props.rejectAlternative,
        color: "error",
        children: getTranslation(DynamicSettingsKeys.CANCEL)
      }), jsx(Button, {
        "data-cy": `ok`,
        className: "invalidRuleModalAccept",
        onClick: props.acceptAlternative,
        children: getTranslation(DynamicSettingsKeys.OK)
      })]
    })]
  });
};
const InvalidRuleModal = withExtensions({
  app: {
    invalidRuleModal: {
      root: true
    }
  }
})(IInvalidRuleModal);

function K3Loading() {
  const loading = useTypedSelector(selectIsLoading);
  return jsx(Loading, {
    loading: loading
  });
}

const IMountedWhenLoaded = () => {
  return null;
};
const MountedWhenLoaded = withExtensions({
  app: {
    mountedWhenLoaded: {
      root: true
    }
  }
})(IMountedWhenLoaded);

const VariableInfoDialogContent = ({
  variable
}) => {
  var _variable$info;
  if (!variable) {
    return null;
  }
  return jsx(Typography, {
    children: jsx(HTMLStringToReact, {
      htmlString: (_variable$info = variable == null ? void 0 : variable.info) != null ? _variable$info : undefined
    })
  });
};
const VariableInfoDialog = () => {
  const {
    t
  } = useTranslation();
  const infoDialogData = useTypedSelector(selectVariableInfoDialog);
  const variable = useTypedSelector(selectVariableById(infoDialogData == null ? void 0 : infoDialogData.variableId));
  const dispatch = useTypedDispatch();
  const handleClose = () => {
    dispatch(setVariableInfoDialog(undefined));
  };
  return jsxs(Dialog, {
    className: "variableInfoDialog",
    open: !!infoDialogData,
    maxWidth: "sm",
    onClose: handleClose,
    fullWidth: true,
    children: [jsx(DialogTitle, {
      className: "variableInfoDialogTitle",
      children: variable == null ? void 0 : variable.label
    }), jsx(DialogContent, {
      className: "variableInfoDialogContent",
      dividers: true,
      children: jsx(VariableInfoDialogContent, {
        variable: variable
      })
    }), jsx(DialogActions, {
      className: "variableInfoDialogActions",
      children: jsx(Button, {
        onClick: handleClose,
        "data-cy": `close`,
        children: t("Schliessen")
      })
    })]
  });
};

/** Pre-Styled Tooltip */
const SecondaryButton = styled(Button)(({
  theme
}) => ({
  color: theme.palette.secondary.contrastText,
  borderColor: theme.palette.secondary.main,
  backgroundColor: theme.palette.secondary.main,
  "&:hover": {
    backgroundColor: theme.palette.secondary.dark
  }
}));

var DIALOGSTATE;
(function (DIALOGSTATE) {
  DIALOGSTATE[DIALOGSTATE["NONE"] = 0] = "NONE";
  DIALOGSTATE[DIALOGSTATE["DESKTOP"] = 1] = "DESKTOP";
  DIALOGSTATE[DIALOGSTATE["IOS"] = 2] = "IOS";
  DIALOGSTATE[DIALOGSTATE["ANDROID"] = 3] = "ANDROID";
})(DIALOGSTATE || (DIALOGSTATE = {}));
const ARButton = () => {
  var _app$productDetails;
  const translation = useDynamicTranslation();
  const startAr = useStartAr();
  const app = useTypedSelector(selectFrontendApp);
  return jsx(SecondaryButton, {
    "data-cy": `dynAR`,
    onClick: startAr,
    className: clsx("ar-button"),
    variant: "contained",
    fullWidth: true,
    startIcon: jsx(ViewInArIcon, {}),
    disabled: !((_app$productDetails = app.productDetails) != null && _app$productDetails.ar),
    children: translation(DynamicSettingsKeys.AR_BUTTON)
  });
};

const FillLater = "fillLater";
const backendToFrontendSelections = (ruleEngineInput, configuration) => {
  const withoutRemovedVariables = configuration.json.variables.filter(backendSelection => ruleEngineInput.variables.byVarId.all[backendSelection.variableId]);
  const variableHierarchyLevelById = createVariableHierachyLevelMap(ruleEngineInput.variables.flat.all);
  let reconstructedSelections = withoutRemovedVariables.map(backendSelection => {
    var _backendSelection$par, _backendSelection$par2, _backendSelection$par3, _backendSelection$par4, _result$data;
    const variable = ruleEngineInput.variables.byVarId.all[backendSelection.variableId];
    const isInstance = ruleEngineInput.variables.flat.all.some(v => v.parentId === backendSelection.variableId);
    const id = backendSelection.id || nanoid();
    const instance = isInstance ? {
      id,
      isInstanceLauncher: true,
      belongsToVariableId: backendSelection.variableId,
      belongsToInstanceId: ((_backendSelection$par = backendSelection.parent) == null ? void 0 : _backendSelection$par.selectionId) || "",
      hierarchyLevel: variableHierarchyLevelById[backendSelection.variableId]
    } : {
      id: ((_backendSelection$par2 = backendSelection.parent) == null ? void 0 : _backendSelection$par2.selectionId) || "",
      isInstanceLauncher: false,
      belongsToVariableId: ((_backendSelection$par3 = backendSelection.parent) == null ? void 0 : _backendSelection$par3.variableId) || null,
      belongsToInstanceId: (_backendSelection$par4 = backendSelection.parent) != null && _backendSelection$par4.selectionId ? FillLater : "",
      hierarchyLevel: variableHierarchyLevelById[backendSelection.variableId]
    };
    let valueId = backendSelection.value;
    const data = Object.assign({}, backendSelection.additionalData);
    const additionalSelectionData = {};
    if (isNumberVariable(variable)) {
      var _backendSelection$add, _backendSelection$add2;
      const iV = Number((_backendSelection$add = (_backendSelection$add2 = backendSelection.additionalData) == null ? void 0 : _backendSelection$add2.inputValue) != null ? _backendSelection$add : 0);
      const value = ruleEngineInput.values.byVarId.all[variable.id].find(v => isAPartOfB(discreteInterval(iV), v.data));
      data.inputValue = iV;
      if (!value) return null;
      valueId = value.id;
      additionalSelectionData.interval = value.data;
    } else if (variable.type === VariableType.Text) {
      var _ruleEngineInput$valu;
      const value = (_ruleEngineInput$valu = ruleEngineInput.values.byVarId.all[variable.id]) == null ? void 0 : _ruleEngineInput$valu[0];
      if (value) valueId = value.id;
    }
    const result = Object.assign({
      id,
      sort: backendSelection.sort,
      variableId: backendSelection.variableId,
      valueId,
      data,
      instance,
      debuggingValue: backendSelection.debuggingValue
    }, additionalSelectionData);
    if (result != null && (_result$data = result.data) != null && _result$data.url) {
      // Unsere API replaced Leerzeichen in solchen key mit einem Underscore!
      const dataUrlKey = result.data.url.replace(/ /g, "_");
      result.data.url = _$1.first(Object.values(configuration.files[dataUrlKey]));
    }
    return result;
  }).filter(Boolean);
  // find parents of parents
  let abort = 0;
  while (reconstructedSelections.some(s => s.instance.belongsToInstanceId === FillLater) && abort < 20) {
    reconstructedSelections = reconstructedSelections.map((s, i, sel) => {
      if (s.instance.belongsToInstanceId !== FillLater) return s;
      const instance = sel.find(ps => ps.id === s.instance.id);
      const belongsToInstanceId = instance == null ? void 0 : instance.instance.belongsToInstanceId;
      if (instance && belongsToInstanceId !== FillLater) {
        return transform({
          instance: {
            belongsToInstanceId
          }
        })(s);
      } else {
        return s;
      }
    });
    abort++;
  }
  if (abort === 20) console.error("Too many iterations needed to resolve selection tree", reconstructedSelections, configuration);
  return reconstructedSelections;
};
const frontendToBackendSelections = (i, selections, state) => sortSelectionsByVariableOrder(i, selections).reduce((prev, selection) => {
  if (!selection.valueId) {
    return prev;
  }
  const variable = i.variables.byVarId.all[selection.variableId];
  const parent = selections.find(s => s.id === realDirectParent(selection)) || rootSelection;
  const hidden = !shouldSelectionBeDisplayedInSummaries(variable, i, state.state, selection);
  const newBackendSelection = {
    sort: selection.sort,
    hidden,
    variableId: selection.variableId,
    value: selection.valueId,
    additionalData: selection.data,
    debuggingValue: selection.debuggingValue,
    parent: {
      selectionId: parent.id,
      variableId: parent.variableId,
      valueId: (parent == null ? void 0 : parent.valueId) || null
    },
    id: selection.id
  };
  return [...prev, newBackendSelection];
}, []);

// FIXME: api requests here?!
const urlToBlob = async url => {
  const result = await fetch(url);
  return await result.blob();
};
const getScreenshotFiles = async state => {
  const screenshotting = selectScreenshotting(state);
  return Array.isArray(screenshotting) ? await Promise.all(screenshotting.map(async screen => Object.assign({}, screen, {
    file: await urlToBlob(screen.file)
  }))) : [];
};
const fetchSelectionsAndImageFiles = async state => {
  const selectionsAndImageFiles = await Promise.all(selectSelections(state).map(async selection => {
    var _selection$data;
    if ((_selection$data = selection.data) != null && _selection$data.url) {
      const savedUnderKey = selection.id;
      return {
        selection: Object.assign({}, selection, {
          data: Object.assign({}, selection.data, {
            url: savedUnderKey
          })
        }),
        uploadFileInformation: {
          key: savedUnderKey,
          file: await urlToBlob(selection.data.url)
        }
      };
    } else {
      return {
        selection: selection,
        uploadFileInformation: undefined
      };
    }
  }));
  const updatedSelections = selectionsAndImageFiles.map(s => s.selection);
  const files = await getScreenshotFiles(state);
  const filesAndInformation = [...selectionsAndImageFiles.map(s => s.uploadFileInformation).filter(Boolean), ...files];
  return {
    updatedSelections,
    filesAndInformation
  };
};

const getGalleryFiles = async state => {
  const galleryImages = selectCurrentImages(state);
  return galleryImages.reduce((prev, curr, i) => Object.assign({}, prev, {
    ["camera_" + i]: {
      [curr.label]: corsHack(curr.url)
    }
  }), {});
};
const fetchConfigurationAndExports = async (state, label, customer) => {
  const app = selectFrontendApp(state);
  const lang = selectContentLanguage(state);
  const ruleEngineInput = selectRuleEngineInput(state);
  const ruleEngineState = selectRuleEngineState(state);
  if (!ruleEngineInput || !ruleEngineState) {
    console.warn("Rule engine not initialized!");
    return;
  }
  // TODO: Wenn die Versionierung implementiert ist dann muss darauf geachtet
  // werden die aktuellste App zu nehmen.
  // const app = selectAppByCode(appCode)(state);
  // const appId = app.id;
  // const configurations = selectConfigurationsByAppId(appId)(state);
  if (app) {
    const price = selectOverallPrice(state);
    const {
      updatedSelections,
      filesAndInformation
    } = await fetchSelectionsAndImageFiles(state);
    const selectionsForBackend = frontendToBackendSelections(ruleEngineInput, updatedSelections, ruleEngineState);
    const mapLine = line => ({
      articleNo: line.article.no,
      articleName: line.article.name,
      priceUnit: line.priceUnit,
      qty: line.qty,
      priceTotal: line.priceTotal
    });
    const mapRowsForApi = rows => rows.map(row => ({
      group: row.group.label,
      groupId: row.group.id,
      index: row.index,
      variableLabel: row.variable.label,
      variableId: row.variable.id,
      selectionLabel: row.selectionLabel,
      selectionId: row.selection.id,
      selectionValueId: isNumberVariable(row.variable) ? null : row.selection.valueId,
      bom: {
        articleLines: row.bom.articleLines.map(mapLine),
        surchargeLines: row.bom.surchargeLines.map(mapLine),
        priceTotal: row.bom.priceTotal
      },
      subVariables: row.subVariables ? mapRowsForApi(row.subVariables) : null
    }));
    const bom = selectBOM(state).map(pos => ({
      articleId: pos.article.id,
      count: 1,
      qty: pos.qty,
      main: pos.main
    }));
    const newConfiguration = {
      state: ConfigurationState.Ordered,
      // TODO
      thumbnail: null,
      files: await getGalleryFiles(state),
      appId: app.id,
      appCode: app.code,
      versionId: app.versionId,
      // TODO
      userId: null,
      price,
      inspiration: false,
      //sort: (maxBy((g) => g.sort, configurations)?.sort || -1) + 1,
      json: {
        variables: selectionsForBackend,
        bom: bom,
        summary: mapRowsForApi(selectSelectionsAndArticles(state)),
        touched: ruleEngineState.state.all.touched
      },
      customer: customer,
      lang,
      label: label
    };
    return {
      newConfiguration,
      filesAndInformation
    };
  } else {
    return {};
  }
};

const saveCurrentConfigurationThunk = (label, action, customer) => async (dispatch, getState) => {
  const state = getState();
  const app = selectFrontendApp(state);
  const isPreview = selectIsAdminPanel(state);
  // Eine Funktion die mir vom aktuellen State die keys für ImageUpload URLs zurückliefert.
  //
  const {
    newConfiguration,
    filesAndInformation
  } = (await fetchConfigurationAndExports(state, label, customer)) || {};
  // configuration.customer = customer;
  // configuration.code = uuidv4();
  // configuration.label = label;
  analyticsTrack("cfg", "saved", app);
  return await dispatch(saveConfigurationThunk(newConfiguration, action, filesAndInformation, isPreview));
};

const DesktopDialog = props => {
  const {
    t
  } = useTranslation();
  const [URL, setURL] = useState("");
  const dispatch = useTypedDispatch();
  const throwError = useAsyncError();
  // const URL = new window.URL(window.location.href);
  // URL.searchParams.append('autostartAR', 'true');
  useEffect(() => {
    // TODO: Should we generate and save screenshots here as well? Why are we doing it? Shouldn't we only do it on order?
    const main = async () => {
      try {
        // TODO: id hier durch JVI und Backend vorgegeben.
        await dispatch(saveCurrentConfigurationThunk("Configuration", {
          id: "ar",
          label: {}
        }, {}));
        const NEWURL = new window.URL(window.location.href);
        NEWURL.searchParams.append("autostartAR", "true");
        setURL(NEWURL.toString());
      } catch (e) {
        throwError(e);
      }
    };
    main();
  }, []);
  return jsxs(Fragment, {
    children: [jsx(DialogTitle, {
      children: t("Desktop Gerät erkannt")
    }), jsxs(DialogContent, {
      children: [jsx(DialogContentText, {
        children: t("Augmented-Reality ist aktuell nur auf aktuellen iOS- oder androidOS-Smartphones verfügbar. Scannen Sie daher einfach diesen QR-Code mit der Kamera-App Ihres Smartphones:")
      }), jsx(Box, {
        component: "div",
        sx: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          margin: 3
        },
        children: URL ? jsx(QRCode, {
          value: URL.toString()
        }) : jsx(CircularProgress$1, {
          size: 30
        })
      })]
    }), jsx(DialogActions, {
      children: jsx(Button, {
        onClick: props.closeDialog,
        "data-cy": `cancel`,
        children: t("Abbrechen")
      })
    })]
  });
};

const callAr = (device, intent) => {
  device === "iOS" ? iosAr(intent) : androidAr(intent);
};
const androidAr = intent => {
  const anchor = document.createElement("a");
  anchor.setAttribute("href", intent);
  anchor.click();
};
const iosAr = intent => {
  const anchor = document.createElement("a");
  anchor.setAttribute("rel", "ar");
  anchor.appendChild(document.createElement("img"));
  anchor.setAttribute("href", intent);
  anchor.click();
};

const androidIntentVersion = "1.1";
const deinstantiateMaterials = scene => {
  const meshes = [];
  const materialCount = {};
  scene.traverseVisible(child => {
    const mesh = child;
    if (mesh.isMesh) {
      meshes.push(mesh);
      if (mesh.material instanceof Array) {
        mesh.material.forEach(material => {
          var _materialCount$materi;
          materialCount[material.uuid] = ((_materialCount$materi = materialCount[material.uuid]) != null ? _materialCount$materi : 0) + 1;
        });
      } else {
        var _materialCount$mesh$m;
        materialCount[mesh.material.uuid] = ((_materialCount$mesh$m = materialCount[mesh.material.uuid]) != null ? _materialCount$mesh$m : 0) + 1;
      }
    }
  });
  meshes.forEach(mesh => {
    if (mesh.material instanceof Array) {
      mesh.material = mesh.material.map(material => materialCount[material.uuid] > 1 ? material.clone() : material);
    } else {
      if (materialCount[mesh.material.uuid] > 1) {
        mesh.material = mesh.material.clone();
      }
    }
  });
};
const useUploadARFile = device => {
  const usdzExporter = new USDZExporter();
  const gltfExporter = new GLTFExporter();
  const printActions = useTypedSelector(selectPrintActions);
  const [exported, setExported] = useState();
  const [uploadedUrl, setUploadedUrl] = useState();
  const [intent, setIntent] = useState();
  const [tried, setTried] = useState(0);
  const app = useTypedSelector(selectFrontendApp);
  const materials = useTypedSelector(selectMaterials);
  const dynamicModelsDisabledForAR = useTypedSelector(selectDynamicModelsDisabledForAR);
  const progress = useProgress();
  useEffect(() => {
    if (tried === 0) {
      setTimeout(() => setTried(tried + 1), printActions.length ? 3000 : 0);
    }
  }, []);
  useEffect(() => {
    const exportObject = async () => {
      var _three$scene;
      if (!tried) return;
      let k3dScene;
      const three = window.oc3;
      three == null ? void 0 : (_three$scene = three.scene) == null ? void 0 : _three$scene.traverse(child => {
        if (child.name === "k3d") k3dScene = child;
      });
      if (three && k3dScene && progress.progress >= 100) {
        let blob;
        const clonedScene = k3dScene.clone(true);
        setDisabledDynamicModelsToBeInvisible(dynamicModelsDisabledForAR, clonedScene);
        if (hasCallback("setARExport")) {
          blob = await applyCallback("setARExport", {
            platform: device,
            scene: clonedScene
          });
        } else {
          await swapARMaterials(clonedScene, materials);
          if (device === "iOS") {
            deinstantiateMaterials(clonedScene);
          }
          const arraybuffer = device === "iOS" ? await usdzExporter.parse(clonedScene) : await gltfExporter.parseAsync(clonedScene, {
            binary: true
          });
          blob = new Blob([arraybuffer], {
            type: "application/octet-stream"
          });
        }
        setExported(blob);
      } else {
        setTimeout(() => setTried(tried + 1), progress.progress < 100 ? 200 : 1500);
      }
    };
    if (window.oc3) {
      exportObject();
    }
  }, [tried, progress.progress]);
  useEffect(() => {
    const uploadContent = async () => {
      const urls = await api_uploadResourceTmpContent("app", [new File([exported], `${app.code}_ar_${device}.${device === "iOS" ? "usdz" : "glb"}`)], device, {
        appCode: app.code
      });
      setUploadedUrl(_$1.first(Object.values(urls)));
    };
    if (exported) {
      uploadContent();
    }
  }, [exported]);
  useEffect(() => {
    if (uploadedUrl) {
      if (device === "iOS") {
        setIntent(uploadedUrl);
      } else {
        const location = window.location.toString();
        const locationUrl = new URL(location);
        const noArViewerSigil = "#model-viewer-no-ar-fallback";
        locationUrl.hash = noArViewerSigil;
        const intentParams = `?file=${uploadedUrl}&mode=ar_preferred`;
        const intent = `intent://arvr.google.com/scene-viewer/${androidIntentVersion}${intentParams}#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;end;`;
        setIntent(intent);
      }
    }
  }, [uploadedUrl]);
  return [exported, uploadedUrl, intent];
};
function setDisabledDynamicModelsToBeInvisible(dynamicModelsDisabledForAR, scene) {
  const disabledModelIds = new Set(dynamicModelsDisabledForAR.map(m => m.id));
  if (disabledModelIds.size > 0) {
    scene.traverse(o => {
      if (disabledModelIds.has(o.userData.modelId)) {
        o.visible = false;
      }
    });
  }
  return disabledModelIds;
}
async function swapARMaterials(scene, materials) {
  const allMaterials = new Map(materials.map(m => [m.id, m]));
  const change = [];
  scene.traverseVisible(o => {
    if (isMesh(o)) {
      const mats = Array.isArray(o.material) ? o.material : [o.material];
      if (mats.some(m => m.userData.arFallbackId && allMaterials.has(m.userData.arFallbackId))) {
        change.push(o);
      }
    }
  });
  const mats = await Promise.all(change.map(async o => {
    if (Array.isArray(o.material)) {
      const mats = await Promise.all(o.material.map(async aMat => {
        if (aMat.userData.arFallbackId && allMaterials.has(aMat.userData.arFallbackId)) {
          return loadMaterialWithTextures(allMaterials.get(aMat.userData.arFallbackId));
        } else {
          return aMat;
        }
      }));
      return mats;
    } else {
      return await loadMaterialWithTextures(allMaterials.get(o.material.userData.arFallbackId));
    }
  }));
  const backup = [];
  for (let i = 0; i < change.length; i++) {
    backup.push([change[i], change[i].material]);
    change[i].material = mats[i];
  }
  return backup;
}

const MobileDialog = props => {
  const {
    t
  } = useTranslation();
  const [exported, uploaded, intent] = useUploadARFile(props.device);
  useEffect(() => {
    if (intent) {
      callAr(props.device, intent);
      setTimeout(props.closeDialog, 500);
    }
  }, [intent]);
  return jsxs(Fragment, {
    children: [jsx(DialogTitle, {
      children: t(`Mobiles ${props.device}-Gerät erkannt`)
    }), jsxs(DialogContent, {
      children: [jsx(DialogContentText, {
        children: jsxs(Box, {
          component: "div",
          sx: {
            display: "flex",
            alignItems: "center",
            marginTop: 3
          },
          children: [jsx(Box, {
            component: "div",
            sx: {
              marginRight: 1,
              display: "flex",
              alignItems: "center"
            },
            children: !exported ? jsx(CircularProgress$1, {
              size: 20
            }) : jsx(DoneIcon, {})
          }), t("Export des 3D-Objekts")]
        })
      }), jsx(DialogContentText, {
        children: jsxs(Box, {
          component: "div",
          sx: {
            display: "flex",
            alignItems: "center",
            marginTop: 3
          },
          children: [jsx(Box, {
            component: "div",
            sx: {
              marginRight: 1,
              display: "flex",
              alignItems: "center"
            },
            children: !uploaded ? jsx(CircularProgress$1, {
              size: 20
            }) : jsx(DoneIcon, {})
          }), t("Bereitstellen der AR-Datei")]
        })
      }), jsx(DialogContentText, {
        children: jsxs(Box, {
          component: "div",
          sx: {
            display: "flex",
            alignItems: "center",
            marginTop: 3
          },
          children: [jsx(Box, {
            component: "div",
            sx: {
              marginRight: 1,
              display: "flex",
              alignItems: "center"
            },
            children: !intent ? jsx(CircularProgress$1, {
              size: 20
            }) : jsx(DoneIcon, {})
          }), t(`Aufruf an ${props.device}-System`)]
        })
      })]
    })]
  });
};

const ArDialog = () => {
  const arDialog = useTypedSelector(selectArDialog);
  const dispatch = useTypedDispatch();
  const progress = useProgress();
  useEffect(() => {
    const autostartAR = getAutostartAR();
    if (autostartAR && progress.progress >= 100) {
      removeAutostartAR();
      dispatch(setArDialog(true));
    }
  }, [progress.progress]);
  if (!arDialog) return null;
  return jsx(IArDialog, {});
};
const IArDialog = () => {
  const dispatch = useTypedDispatch();
  const [dialog, setDialog] = useState(DIALOGSTATE.NONE);
  const app = useTypedSelector(selectFrontendApp);
  const md = useMemo(() => new MobileDetect(window.navigator.userAgent), []);
  useEffect(() => {
    const isMobile = md.mobile();
    const isIOS = md.os() == "iOS" || md.os() == "iPadOS";
    const isAndroid = md.os() == "AndroidOS";
    const getDialogType = () => {
      if (!isMobile) return DIALOGSTATE.DESKTOP;
      if (isIOS) return DIALOGSTATE.IOS;
      if (isAndroid) return DIALOGSTATE.ANDROID;
      return DIALOGSTATE.DESKTOP;
    };
    setDialog(getDialogType());
    analyticsTrack("ar", isMobile, app);
  }, []);
  const handleClose = () => {
    dispatch(setArDialog(false));
  };
  return jsx(Dialog, {
    onClose: () => setDialog(DIALOGSTATE.NONE),
    open: dialog !== DIALOGSTATE.NONE,
    children: {
      // TODO: Handle this or can this even happen?
      [DIALOGSTATE.NONE]: jsx("div", {}),
      [DIALOGSTATE.ANDROID]: jsx(MobileDialog, {
        closeDialog: handleClose,
        device: "AndroidOS"
      }),
      [DIALOGSTATE.IOS]: jsx(MobileDialog, {
        closeDialog: handleClose,
        device: "iOS"
      }),
      [DIALOGSTATE.DESKTOP]: jsx(DesktopDialog, {
        closeDialog: handleClose
      })
    }[dialog]
  });
};

const IInvalidToolTipContent = ({
  invalidOption
}) => {
  const getTranslation = useDynamicTranslation();
  const translatedInvalidSelections = useTypedSelector(selectTranslatedSelections(invalidOption.conflicts));
  return jsxs(Fragment, {
    children: [jsx(Typography, {
      children: getTranslation("translation_warning_invalid_selection")
    }), jsx(Box, {
      component: "div",
      sx: {
        margin: 2
      },
      children: translatedInvalidSelections.map(invalidSelection => {
        return jsxs(Typography, {
          children: [jsxs("b", {
            children: [invalidSelection.variable, ":"]
          }), " ", invalidSelection.value]
        }, invalidSelection.variable);
      })
    }), jsx(Typography, {
      children: getTranslation("translation_warning_invalid_selection_alternative")
    }), jsx(EditDynamicSettings, {
      keys: ["translation_warning_invalid_selection", "translation_warning_invalid_selection_alternative"],
      display: "dialog"
    })]
  });
};
const InvalidToolTipContent = withExtensions({
  app: {
    sidebar: {
      invalidSelectionWarning: {
        tooltipContent: {
          root: true
        }
      }
    }
  }
})(IInvalidToolTipContent);
const IInvalidSelectionWarningIcon = ({
  iconSx
}) => jsx(ErrorOutlineIcon, {
  className: "invalidSelectionIcon",
  sx: iconSx,
  color: "error"
});
const InvalidSelectionWarningIcon = withExtensions({
  app: {
    sidebar: {
      invalidSelectionWarning: {
        icon: {
          root: true
        }
      }
    }
  }
})(IInvalidSelectionWarningIcon);
const IInvalidSelectionWarning = ({
  valueId,
  alwaysDisplay,
  iconSx,
  invalidOption
}) => {
  const touchedInvalidOption = useTypedSelector(state => invalidOption != null ? invalidOption : selectTouchedInvalidSelection(valueId)(state));
  //TODO: Das hier sieht falsch aus!
  if (!touchedInvalidOption) {
    return jsx(Fragment, {
      children: alwaysDisplay
    });
  }
  return jsx(Tooltip, {
    className: "invalidSelectionIconTooltip",
    title: jsx(InvalidToolTipContent, {
      invalidOption: touchedInvalidOption
    }),
    children: jsx("div", {
      children: jsx(InvalidSelectionWarningIcon, {
        iconSx: iconSx
      })
    })
  });
};
const ExtendedIInvalidSelectionWarning = withExtensions({
  app: {
    sidebar: {
      invalidSelectionWarning: {
        root: true
      }
    }
  }
})(IInvalidSelectionWarning);
const InvalidSelectionWarning = props => {
  const touchedInvalidOption = useTypedSelector(selectTouchedInvalidSelection(props.valueId));
  return jsx(ExtendedIInvalidSelectionWarning, Object.assign({}, props, {
    invalidOption: touchedInvalidOption
  }));
};

const _excluded$j = ["value", "onChange"];
function OCSelect(props) {
  var _props$FormControllPr;
  const _ref = props.SelectProps || {},
    {
      value,
      onChange
    } = _ref,
    selectProps = _objectWithoutPropertiesLoose(_ref, _excluded$j);
  const formControllProps = merge$1({
    fullWidth: true,
    variant: "outlined"
  }, (_props$FormControllPr = props.FormControllProps) != null ? _props$FormControllPr : {});
  const selectValue = value || props.value;
  const selectOnChange = event => {
    if (onChange) onChange(event, event.target);
    if (props.onChange) props.onChange(event.target.value);
  };
  return jsxs(FormControl$1, Object.assign({}, formControllProps, {
    children: [props.label && jsx(Typography, {
      component: "label",
      htmlFor: selectProps.id,
      color: "textSecondary",
      children: props.label
    }), jsx(Select$1, Object.assign({
      value: selectValue,
      onChange: selectOnChange,
      "data-cy": props["data-cy"]
    }, selectProps, {
      disabled: props.disabled,
      multiple: props.multiple,
      MenuProps: {
        MenuListProps: {
          sx: {
            maxHeight: "35vh"
          }
        }
      },
      children: props.children
    }))]
  }));
}

function PlaceHolderImage(props) {
  return jsx(Box, {
    component: "img",
    sx: props.sx,
    width: props.width,
    src: "data:image/png;base64,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"
  });
}

const sxStyles$p = {
  image: {
    height: "100%",
    width: "100%",
    maxWidth: "100%",
    maxHeight: "100%",
    boxSizing: "border-box",
    objectFit: "contain"
  }
};
const Thumbnail = ({
  url
}) => {
  if (url) return jsx(Box, {
    component: "img",
    sx: sxStyles$p.image,
    alt: "",
    src: url
  });
  return jsx(PlaceHolderImage, {
    sx: sxStyles$p.image
  });
};

const sxStyles$o = {
  root: {},
  rootDense: {
    p: 0
  },
  layout: {
    minHeight: "40px",
    maxHeight: "150px",
    maxWidth: "300px",
    height: "100%",
    width: "100%",
    display: "grid",
    gridTemplateColumns: "minmax(0, max-content) minmax(0, 1fr) minmax(0, max-content)",
    gridTemplateRows: "minmax(0, 1fr) minmax(0, min-content)",
    gridColumnGap: "8px",
    gridTemplateAreas: `
          "Thumbnail Label Info"
          "Thumbnail Description Description"
          "Thumbnail Url Price"
    `
  },
  gridAreaThumbnail: (size = "100px") => ({
    gridArea: "Thumbnail",
    width: size,
    height: size,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    placeSelf: "center"
  }),
  gridAreaLabel: {
    gridArea: "Label",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    height: "100%"
  },
  gridAreaDescription: {
    gridArea: "Description",
    whiteSpace: "break-spaces",
    display: "-webkit-box",
    WebkitLineClamp: "3",
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    wordWrap: "break-word"
  },
  gridAreaUrl: {
    gridArea: "Url",
    display: "flex",
    justifyContent: "start"
  },
  gridAreaPrice: {
    gridArea: "Price",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "end"
  },
  gridAreaInfo: {
    gridArea: "Info",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "end"
  }
};
const ValueDetails = ({
  templateOptions,
  variableValue,
  variable,
  infoIconButtons
}) => {
  var _variable$settings;
  const formatter = useTypedSelector(selectPriceFormatter);
  const isColorSelect = ["colorDropdown", "colorRadio", "colorSelect"].includes(variable == null ? void 0 : (_variable$settings = variable.settings) == null ? void 0 : _variable$settings.template);
  const thumbNailSize = !(templateOptions != null && templateOptions.showDescription) ? "50px" : "100px";
  return (
    // @ts-ignore
    jsxs(Box, {
      component: "div",
      sx: sxStyles$o.layout,
      children: [isColorSelect && variableValue != null && variableValue.value ? jsx(Box, {
        component: "div",
        sx: Object.assign({}, sxStyles$o.gridAreaThumbnail(thumbNailSize), {
          bgcolor: variableValue == null ? void 0 : variableValue.value
        })
      }) : (templateOptions == null ? void 0 : templateOptions.showThumbnail) && jsx(Box, {
        component: "div",
        sx: Object.assign({}, sxStyles$o.gridAreaThumbnail(), {
          bgcolor: variableValue == null ? void 0 : variableValue.value
        }),
        children: !isColorSelect && jsx(Thumbnail, {
          url: variableValue.thumbnail
        })
      }), (templateOptions == null ? void 0 : templateOptions.showLabel) && jsx(Box, {
        component: "div",
        sx: sxStyles$o.gridAreaLabel,
        "data-cy": "valueDetail-" + variableValue.label,
        children: jsx(Typography, {
          variant: "body1",
          noWrap: true,
          children: variableValue.label
        })
      }), (templateOptions == null ? void 0 : templateOptions.showDescription) && jsx(Box, {
        component: "div",
        sx: sxStyles$o.gridAreaDescription,
        children: jsx(Typography, {
          variant: "body2",
          children: variableValue.description
        })
      }), (templateOptions == null ? void 0 : templateOptions.showUrl) && jsx(Box, {
        component: "div",
        sx: sxStyles$o.gridAreaUrl,
        children: jsx(Link, {
          "data-cy": `valueDetails-${variableValue == null ? void 0 : variableValue.url}`,
          align: "left",
          variant: "caption",
          href: variableValue.url,
          target: "_blank",
          children: variableValue.url
        })
      }), (templateOptions == null ? void 0 : templateOptions.showPrice) && jsx(Box, {
        component: "div",
        sx: !(templateOptions != null && templateOptions.showInfo && infoIconButtons) ? sxStyles$o.gridAreaInfo : sxStyles$o.gridAreaPrice,
        children: jsx(Typography, {
          variant: "body2",
          children: formatter.format(variableValue.price)
        })
      }), infoIconButtons && jsx(Box, {
        component: "div",
        sx: sxStyles$o.gridAreaInfo,
        children: infoIconButtons
      })]
    })
  );
};

const _excluded$i = ["templateOptions", "variable", "variableValue", "dense", "infoIconButtons", "key", "selected", "value"];
const sxStyles$n = {
  root: {},
  rootDense: {
    p: 0
  }
};
const SelectMenuItem = _ref => {
  let {
      templateOptions,
      variable,
      variableValue,
      dense = false,
      infoIconButtons,
      key,
      selected,
      value
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$i);
  return jsxs(MenuItem, Object.assign({
    sx: dense ? sxStyles$n.rootDense : sxStyles$n.root,
    value: value,
    selected: selected
  }, props, {
    children: [props.children, jsx(ValueDetails, {
      variable: variable,
      variableValue: variableValue,
      templateOptions: templateOptions,
      infoIconButtons: infoIconButtons
    })]
  }), key);
};

const AddItemsDropdown = ({
  onSelected,
  variable,
  label,
  value
}) => {
  const {
    t
  } = useTranslation();
  const values = useTypedSelector(selectValuesByVariableId(variable.id));
  const unselectedValue = {
    id: 0,
    label: label ? label : t("Hinzufügen"),
    appId: variable.appId,
    variableId: variable.id,
    value: "0",
    sort: 0
  };
  return jsxs(OCSelect, {
    "data-cy": `componentList`,
    label: "",
    // label={<VariableLabel variable={variable} />}
    value: (value == null ? void 0 : value.id.toString()) || "0",
    onChange: valueId => {
      const value = values.find(v => v.id == +valueId);
      value && (onSelected == null ? void 0 : onSelected(value));
    },
    SelectProps: {
      inputProps: {
        sx: {
          p: 1
        }
      },
      renderValue: valueId => {
        const variableValue = valueId == 0 ? unselectedValue : values.find(value => value.id == valueId);
        if (!variableValue) {
          return null;
        }
        return jsx(SelectMenuItem, {
          dense: true,
          value: valueId,
          variableValue: variableValue,
          templateOptions: {
            showLabel: true
          }
        });
      }
    },
    children: [jsx(SelectMenuItem, {
      value: "0",
      variableValue: unselectedValue,
      templateOptions: {
        showLabel: true
      }
    }), values.map(validValue => {
      return jsx(SelectMenuItem, {
        value: validValue.id,
        variableValue: validValue,
        templateOptions: {
          showLabel: true
        },
        children: jsx(ListItemIcon, {
          children: jsx(InvalidSelectionWarning, {
            valueId: validValue == null ? void 0 : validValue.id
          })
        })
      }, validValue.id);
    })]
  });
};

const sxStyles$m = {
  branding: {
    position: "absolute",
    bottom: 0,
    width: "100%",
    textAlign: "center"
  }
};
const Branding = function Branding() {
  const showBranding = useTypedSelector(selectShowBranding);
  if (showBranding) {
    return (
      // @ts-ignore
      jsx(Box, {
        component: "div",
        sx: sxStyles$m.branding,
        children: jsx(Link, {
          "data-cy": `brand`,
          href: "https://www.objectcode.de",
          target: "_blank",
          children: jsxs(Typography, {
            variant: "caption",
            display: "block",
            children: ["Powered by ObjectCode K3\u00AE ", K3_EXTERNAL_VERSION]
          })
        })
      })
    );
  } else {
    return null;
  }
};

const GroupTemplateType = {
  SelectionTemplate: "Auswahlen",
  OverviewTemplate: "Stückliste"
};
const continueAction = {
  dynamicTranslatedLabelKey: "translation_group_actions_continue",
  id: "continueAction",
  label: "Weiter",
  type: "group"
};
const addItemAction = {
  dynamicTranslatedLabelKey: "translation_group_actions_add_item",
  label: "Produkt hinzufügen",
  id: "addItemAction",
  type: "group"
};
const selectableGroupActions = [continueAction, addItemAction];
const multipleActionsAction = {
  dynamicTranslatedLabelKey: "translation_group_multiple_actions",
  label: "Bestätigen",
  id: "multipleActions",
  type: "group"
};
function isGroup(group) {
  return group.id !== undefined;
}
function isNewGroup(group) {
  return !has$2(group, "id");
}

const defaultHandleDisabled = (direction, groups, focusGroupId, currentGroup) => {
  if (currentGroup != null && currentGroup.parentId) {
    // If we are in a child instance we can always go up or to a sibling
    // instance. So we don't need to disable the button.
    return false;
  }
  const order = groups.map(element => element.id);
  if (direction === "backward") order.reverse();
  const currentGroupIndex = order.indexOf(focusGroupId);
  return groups.length - 1 === currentGroupIndex;
};
const defaultSelectNextGroup = async (direction, groups, focusGroupId, currentInstance, siblingInstances, dispatch) => {
  const order = groups.map(element => element.id);
  if (direction === "backward") order.reverse();
  let currentGroupIndex = order.indexOf(focusGroupId);
  const nextGroup = order[++currentGroupIndex];
  if (nextGroup) {
    dispatch(changeGroupThunk(+nextGroup, false));
  } else {
    // If we are in a child instance we want to navigate the siblings or go up
    // to the parent.
    const currentGroup = groups.find(g => g.id === focusGroupId);
    if (currentGroup != null && currentGroup.parentId) {
      const currentSiblingIndex = siblingInstances.findIndex(s => s.id === (currentInstance == null ? void 0 : currentInstance.id));
      const nextSelection = siblingInstances[currentSiblingIndex + (direction === "forward" ? 1 : -1)];
      dispatch(setTouchedByUserFromFocusGroupChangeThunk(focusGroupId));
      if (nextSelection) {
        // If we are in a child instance and we go to the next sibling.
        dispatch(openInstanceById(nextSelection.id));
      } else {
        // If we are in the last sibling instance we want to go up to the
        // parent.
        dispatch(openParentInstance());
      }
    }
  }
};
const NavigationButtonsWithData = props => {
  var _groups, _currentGroup$setting, _currentGroup$setting2, _app$settings, _currentGroup$setting6;
  const dispatch = useTypedDispatch();
  const groups = useTypedSelector(selectVisibleGroups);
  const focusGroupId = useTypedSelector(selectFocusGroupId);
  const currentGroup = groups.find(g => g.id === focusGroupId);
  const app = useTypedSelector(selectFrontendApp);
  const currentInstance = useTypedSelector(selectOpenInstance);
  const siblingInstances = useTypedSelector(selectSiblingInstances);
  const startInstance = useStartInstance();
  const isOpenInstanceFirstOfSiblings = useIsOpenInstanceFirstOfSiblings();
  const handleDisabled = direction => {
    if (direction === "backward" && startInstance && isOpenInstanceFirstOfSiblings) {
      return true;
    }
    return defaultHandleDisabled(direction, groups, focusGroupId, currentGroup);
  };
  const selectNextGroup = async direction => defaultSelectNextGroup(direction, groups, focusGroupId, currentInstance, siblingInstances, dispatch);
  const isLastGroup = focusGroupId == ((_groups = groups[groups.length - 1]) == null ? void 0 : _groups.id) && !(currentGroup != null && currentGroup.parentId);
  const showActionButton = !!(currentGroup != null && (_currentGroup$setting = currentGroup.settings) != null && _currentGroup$setting.actionIds) && (currentGroup == null ? void 0 : (_currentGroup$setting2 = currentGroup.settings) == null ? void 0 : _currentGroup$setting2.actionIds.length) > 0 || !!(app != null && (_app$settings = app.settings) != null && _app$settings.defaultAction) && isLastGroup;
  const showBranding = useTypedSelector(selectShowBranding);
  const currentAction = useMemo(() => {
    var _currentGroup$setting3;
    const defaultAction = app.settings.actions.find(a => {
      var _app$settings2;
      return a.id === (app == null ? void 0 : (_app$settings2 = app.settings) == null ? void 0 : _app$settings2.defaultAction);
    });
    if (!(currentGroup != null && (_currentGroup$setting3 = currentGroup.settings) != null && _currentGroup$setting3.actionIds)) {
      return defaultAction;
    } else if (currentGroup.settings.actionIds.length === 1) {
      return app.settings.actions.find(a => {
        var _currentGroup$setting4, _currentGroup$setting5;
        return a.id === ((_currentGroup$setting4 = currentGroup.settings) == null ? void 0 : (_currentGroup$setting5 = _currentGroup$setting4.actionIds) == null ? void 0 : _currentGroup$setting5[0]);
      });
    } else if (currentGroup.settings.actionIds.length > 1) {
      return multipleActionsAction;
    }
    return defaultAction;
  }, [app, currentGroup]);
  return jsxs(Fragment, {
    children: [jsx(NavigationButtons, {
      handleDisabled: handleDisabled,
      selectNextGroup: selectNextGroup,
      showActionButton: showActionButton,
      customActionLabel: currentGroup == null ? void 0 : (_currentGroup$setting6 = currentGroup.settings) == null ? void 0 : _currentGroup$setting6.actionLabel,
      defaultAction: currentAction || continueAction
    }), showBranding && jsx(Branding, {})]
  });
};
const INavigationButtons = props => {
  const {
    handleDisabled,
    selectNextGroup,
    customActionLabel,
    showActionButton,
    defaultAction,
    onlyShow
  } = props;
  const translation = useDynamicTranslation();
  return jsxs(Box, {
    component: "div",
    sx: {
      display: "grid",
      gridAutoFlow: "column",
      gap: 2
    },
    children: [(!onlyShow || onlyShow === "backward") && jsx(Button, {
      "data-cy": `dynBack`,
      variant: "outlined",
      disabled: handleDisabled("backward"),
      onClick: () => selectNextGroup("backward"),
      children: translation(DynamicSettingsKeys.NAVBAR_BACK)
    }), jsx(EditDynamicSettings, {
      keys: [DynamicSettingsKeys.NAVBAR_BACK, DynamicSettingsKeys.NAVBAR_NEXT]
    }), (!onlyShow || onlyShow === "forward") && jsx(ForwardButton, {
      handleDisabled: handleDisabled,
      selectNextGroup: selectNextGroup,
      customActionLabel: customActionLabel,
      defaultAction: defaultAction,
      showActionButton: showActionButton
    })]
  });
};
const ForwardButton = props => {
  const {
    handleDisabled,
    selectNextGroup,
    customActionLabel,
    defaultAction,
    showActionButton,
    variant
  } = props;
  const translation = useDynamicTranslation();
  const dispatch = useTypedDispatch();
  return !!showActionButton && defaultAction.id !== "continueAction" ? jsx(Button, {
    "data-cy": `dynLabel`,
    variant: variant || "contained",
    onClick: () => dispatch(setCurrentAction(defaultAction)),
    children: customActionLabel ? customActionLabel : "dynamicTranslatedLabelKey" in defaultAction ? translation(defaultAction.dynamicTranslatedLabelKey) : jsx(LocalizedText, {
      value: defaultAction.label
    })
  }) : jsx(Button, {
    "data-cy": `dynNext`,
    variant: "contained",
    disabled: handleDisabled("forward"),
    // sx={{ minWidth: 116 }}
    onClick: () => {
      selectNextGroup("forward");
      dispatch(setCurrentAction(null));
    },
    children: customActionLabel ? customActionLabel : translation(DynamicSettingsKeys.NAVBAR_NEXT)
  });
};
const NavigationButtons = withExtensions({
  app: {
    navigationButtons: {
      root: true
    }
  }
})(INavigationButtons);

const getSettings = app => app == null ? void 0 : app.settings;

const getSettingsActions = app => {
  var _getSettings;
  return (_getSettings = getSettings(app)) == null ? void 0 : _getSettings.actions;
};
const getAllActions = app => [...getSettingsActions(app), ...selectableGroupActions];

const MultipleActionsDialogWithData = () => {
  const action = useTypedSelector(selectCurrentAction);
  if (!action || !(action.id === multipleActionsAction.id || action.id === addItemAction.id)) return null;
  return jsx(MultipleActionsDialog, {
    action: action
  });
};
const MultipleActionsDialog = ({
  action
}) => {
  var _currentInstance$vari;
  const dispatch = useTypedDispatch();
  const handleClose = () => {
    dispatch(setCurrentAction(null));
  };
  const getTranslation = useDynamicTranslation();
  const app = useTypedSelector(selectFrontendApp);
  const groups = useTypedSelector(selectVisibleGroups);
  const focusGroupId = useTypedSelector(selectFocusGroupId);
  const currentGroup = useTypedSelector(selectCurrentGroup);
  const actions = getAllActions(app).filter(a => {
    var _currentGroup$setting, _currentGroup$setting2;
    return currentGroup == null ? void 0 : (_currentGroup$setting = currentGroup.settings) == null ? void 0 : (_currentGroup$setting2 = _currentGroup$setting.actionIds) == null ? void 0 : _currentGroup$setting2.includes(a.id);
  });
  const currentInstance = useTypedSelector(selectOpenInstance);
  const siblingInstances = useTypedSelector(selectSiblingInstances);
  const variable = useTypedSelector(selectVariableById((_currentInstance$vari = currentInstance == null ? void 0 : currentInstance.variableId) != null ? _currentInstance$vari : ""));
  const startInstance = useStartInstance();
  const isOpenInstanceFirstOfSiblings = useIsOpenInstanceFirstOfSiblings();
  const handleDisabled = direction => {
    if (startInstance && isOpenInstanceFirstOfSiblings) {
      return true;
    }
    return defaultHandleDisabled(direction, groups, focusGroupId, currentGroup);
  };
  const selectNextGroup = async direction => defaultSelectNextGroup(direction, groups, focusGroupId, currentInstance, siblingInstances, dispatch);
  useTypedSelector(selectParentSelections(currentInstance)).reverse();
  const addItemInParentComponent = useAddInstanceToVariable(variable);
  const addItem = actions.find(a => a.id === addItemAction.id);
  const customActions = actions.filter(a => a.id !== addItemAction.id);
  const [newItem, setNewItem] = useState(undefined);
  return jsxs(Dialog, {
    open: true,
    fullWidth: true,
    maxWidth: "md",
    onClose: handleClose,
    "data-cy": "multipleActionsDialog",
    children: [jsxs(DialogTitle, {
      children: [getTranslation("translation_group_actions_dialog_title"), jsx(Box, {
        component: "div",
        sx: {
          position: "absolute",
          top: 0,
          right: 0
        },
        children: jsx(EditDynamicSettings, {
          keys: ["translation_group_multiple_actions", "translation_group_actions_add_item", "translation_group_actions_continue", "translation_group_actions_dialog_title", "translation_group_actions_dialog_description", "translation_group_actions_dialog_pick_item", "translation_group_actions_dialog_more", "translation_group_actions_dialog_add_item"],
          display: "dialog"
        })
      })]
    }), jsx(DialogContent, {
      children: jsx(Stack, {
        sx: {
          gap: 2
        },
        children: !!addItem && variable && jsxs(Fragment, {
          children: [jsxs(Box, {
            component: "div",
            children: [jsx(Typography, {
              variant: "body1",
              children: getTranslation("translation_group_actions_dialog_description")
            }), jsx(AddItemsDropdown, {
              label: getTranslation("translation_group_actions_dialog_pick_item"),
              variable: variable,
              onSelected: setNewItem,
              value: newItem
            })]
          }), customActions.length > 0 && jsxs(Box, {
            component: "div",
            children: [jsx(Typography, {
              variant: "body2",
              children: getTranslation("translation_group_actions_dialog_more")
            }), customActions.map(action => jsx(ForwardButton, {
              handleDisabled: handleDisabled,
              selectNextGroup: selectNextGroup,
              defaultAction: actions.find(a => a.id === action.id),
              showActionButton: true
            }, action.id))]
          })]
        })
      })
    }), jsxs(DialogActions
    // sx={{ justifyContent: "left" }}
    , {
      children: [jsx(Button, {
        "data-cy": `cancel`,
        variant: "outlined",
        onClick: () => {
          dispatch(setCurrentAction(null));
        },
        children: getTranslation(DynamicSettingsKeys.NAVBAR_BACK)
      }), addItem ? jsx(Button, {
        "data-cy": `close`,
        variant: "contained",
        disabled: !newItem,
        onClick: () => {
          addItemInParentComponent(newItem);
        },
        children: getTranslation("translation_group_actions_dialog_add_item")
      }) : jsx(Fragment, {
        children: customActions.map(action => jsx(ForwardButton, {
          handleDisabled: handleDisabled,
          selectNextGroup: selectNextGroup,
          defaultAction: actions.find(a => a.id === action.id),
          showActionButton: true
        }, action.id))
      })]
    })]
  });
};

/** The name of the defaultApp, k3.objectcode.de/app.
 *  To use a root mounted app k3.objectcode.de just use '' */
const defaultApp = "app";

const getLocationInfo = () => {
  const withoutProtocol = window.location.href.split("://")[1];
  const slashSplit = withoutProtocol.split("/");
  const test = slashSplit[1] === "test" || slashSplit[1] === "demo";
  const host = slashSplit.slice(0, test ? 2 : 1).join("/");
  const rest = slashSplit.slice(test ? 2 : 1);
  const currentApp = rest[0] && rest[0] !== "#" && !rest[0].includes("?") ? rest[0] : "";
  const pathWithHash = rest.slice(currentApp ? 1 : 0);
  const path = pathWithHash.slice(pathWithHash[0] === "#" ? 1 : 0).join("/");
  return {
    /** The base host, including /test if we are on test */
    host: host,
    /** The current type of the app/bundle loaded. E.g. veranda or defaultApp.
     * This hook also already supports root mounted default app. Just set defaultApp to ''.
     * */
    currentAppType: currentApp || defaultApp,
    /** The internal path we are currently on */
    path: path,
    /** Are we on test? */
    test: test
  };
};

const getAppUrl = (app, code) => {
  var _app$settings;
  const location = getLocationInfo();
  const url = (app == null ? void 0 : (_app$settings = app.settings) == null ? void 0 : _app$settings.url) || `${window.location.protocol}//${location.host}/${(app == null ? void 0 : app.type) || defaultApp}/`;
  if (code) return `${url}?code=${code}`;
  return `${url}?app=${app == null ? void 0 : app.code}`;
};

const IOrderConfirmationSuccess = props => {
  const {
    t
  } = useTranslation();
  return jsxs(Fragment, {
    children: [jsx(Typography, {
      gutterBottom: true,
      variant: "h5",
      component: "h2",
      children: props.action.confirmationHeader ? jsx(LocalizedText, {
        value: props.action.confirmationHeader
      }) : t("Ihre Konfiguration wurde gespeichert")
    }), jsx(Typography, {
      gutterBottom: true,
      whiteSpace: "pre-line",
      children: props.action.confirmationText ? jsx(LocalizedText, {
        value: props.action.confirmationText
      }) : t("Mit diesem Link können Sie Ihre Konfiguration wieder aufrufen: ")
    }), !props.action.confirmationHideLink && jsx(Typography, {
      gutterBottom: true,
      children: jsx(Link, {
        target: "_parent",
        href: props.savedConfigurationUrl,
        "data-cy": `cfgUrl`,
        children: props.savedConfigurationUrl
      })
    }), jsx(ShopRedirectSafeguard, Object.assign({}, props))]
  });
};
/** Makes sure the user can proceed to the shop even if popups are suppressed */
const ShopRedirectSafeguard = props => {
  const {
    t
  } = useTranslation();
  const app = useTypedSelector(selectFrontendApp);
  const link = props.result.shopLink || generateShopLink(app, props.result);
  if (!props.action.sendToShop || !link) return null;
  return jsxs(Box, {
    component: "div",
    sx: {
      mt: 4
    },
    children: [jsx(Typography, {
      gutterBottom: true,
      children: t("Sie sollten zum Shop weitergeleitet worden sein. Wenn Sie nicht weitergeleitet wurden klicken Sie bitte hier, um Ihre Bestellung abzuschließen: ")
    }), jsx(Button, {
      href: link,
      target: "_blank",
      "data-cy": `shopUrl`,
      children: t("Zum Shop")
    })]
  });
};
const OrderConfirmationSuccess = withExtensions({
  app: {
    orderDialog: {
      confirmation: {
        success: {
          root: true
        }
      }
    }
  }
})(IOrderConfirmationSuccess);
const IOrderConfirmationError = props => {
  var _props$result;
  const {
    t
  } = useTranslation();
  return jsxs(Fragment, {
    children: [jsx(Typography, {
      gutterBottom: true,
      variant: "h5",
      component: "h2",
      children: t("Ihre Konfiguration konnte nicht gespeichert werden.")
    }), jsx(Typography, {
      children: t("Bitte entschuldigen Sie." + " Wir haben die Konfiguration in diesem Browser gesichert." + " Bitte kommen Sie später noch einmal wieder.")
    }), jsxs(Typography, {
      children: [t("technische Information:"), " ", (_props$result = props.result) == null ? void 0 : _props$result.message]
    })]
  });
};
const OrderConfirmationError = withExtensions({
  app: {
    orderDialog: {
      confirmation: {
        error: {
          root: true
        }
      }
    }
  }
})(IOrderConfirmationError);
const OrderConfirmation = props => {
  var _props$result2, _props$result3;
  const app = useTypedSelector(selectFrontendApp);
  const url = getAppUrl(app, (_props$result2 = props.result) == null ? void 0 : _props$result2.code);
  return jsx(Box, {
    component: "div",
    children: (_props$result3 = props.result) != null && _props$result3.error ? jsx(OrderConfirmationError, {
      action: props.action,
      result: props.result
    }) : jsx(OrderConfirmationSuccess, {
      savedConfigurationUrl: url,
      action: props.action,
      result: props.result
    })
  });
};

const PriceTableContainer = ({
  children
}) => {
  return jsx(Box$2, {
    component: "div",
    my: 2,
    children: children
  });
};

const ArticleRow = ({
  no,
  pos
}) => {
  const {
    t,
    i18n
  } = useTranslation();
  const priceFormatter = useTypedSelector(selectPriceFormatter);
  const showPrice = useTypedSelector(selectFrontendAppShowPrice);
  const qtyFormatter = new Intl.NumberFormat(i18n.language, {
    maximumFractionDigits: 3
  });
  return jsxs(TableRow$1, {
    sx: {
      "&:last-child td, &:last-child th": {
        border: 0
      }
    },
    children: [jsx(TableCell$1, {
      component: "th",
      scope: "row",
      children: no + 1
    }), jsx(TableCell$1, {
      component: "th",
      scope: "row",
      children: pos.article.no
    }), jsx(TableCell$1, {
      scope: "row",
      children: pos.article.name
    }), showPrice && jsx(TableCell$1, {
      children: priceFormatter.format(pos.priceUnit)
    }), jsx(TableCell$1, {
      children: qtyFormatter.format(pos.qty)
    }), showPrice && jsx(TableCell$1, {
      align: "right",
      children: pos.priceTotal ? priceFormatter.format(pos.priceTotal) : ""
    })]
  });
};
const PriceTableArticleInner = ({
  dense,
  bom,
  showPrice,
  sortCompareFn
}) => {
  const {
    t
  } = useTranslation();
  const priceFormatter = useTypedSelector(selectPriceFormatter);
  const sortedArticleLines = useMemo(() => {
    var _bom$articleLines;
    if (!sortCompareFn) return bom.articleLines;
    return ((_bom$articleLines = bom.articleLines) != null ? _bom$articleLines : []).sort(sortCompareFn);
  }, [sortCompareFn, bom.articleLines]);
  const sortedSurchargeLines = useMemo(() => {
    var _bom$surchargeLines;
    if (!sortCompareFn) return bom.surchargeLines;
    return ((_bom$surchargeLines = bom.surchargeLines) != null ? _bom$surchargeLines : []).sort(sortCompareFn);
  }, [sortCompareFn, bom.surchargeLines]);
  if (!sortedArticleLines || sortedArticleLines.length == 0) {
    return null;
  }
  return jsx(PriceTableContainer, {
    children: jsx(TableContainer, {
      component: Paper$1,
      children: jsxs(Table$1, {
        sx: dense ? {
          width: 1
        } : {
          minWidth: 400
        },
        size: dense ? "small" : "medium",
        children: [jsx(TableHead, {
          children: jsxs(TableRow$1, {
            children: [jsx(TableCell$1, {
              align: "left",
              children: t("Pos.")
            }), jsx(TableCell$1, {
              align: "left",
              children: t("Nummer")
            }), jsx(TableCell$1, {
              align: "left",
              children: t("Artikel")
            }), showPrice && jsx(TableCell$1, {
              align: "left",
              children: t("Preis")
            }), jsx(TableCell$1, {
              align: "left",
              children: t("Anzahl")
            }), showPrice && jsx(TableCell$1, {
              align: "right",
              children: t("Positionspreis")
            })]
          })
        }), jsxs(TableBody$1, {
          children: [sortedArticleLines.map((pos, no) => {
            return jsx(ArticleRow, {
              no: no,
              pos: pos
            }, no);
          }), sortedSurchargeLines.map((pos, no) => {
            return jsx(ArticleRow, {
              no: no,
              pos: pos
            }, no);
          }), showPrice && jsxs(TableRow$1, {
            children: [jsx(TableCell$1, {}), jsx(TableCell$1, {
              align: "left",
              colSpan: 4,
              children: t("Gesamtpreis")
            }), jsx(TableCell$1, {
              align: "right",
              children: bom.priceTotal > 0 ? priceFormatter.format(bom.priceTotal) : ""
            })]
          })]
        })]
      })
    })
  });
};
const PriceTableArticle = withExtensions({
  app: {
    orderDialog: {
      priceTable: {
        articleList: {
          root: true
        }
      }
    }
  }
})(PriceTableArticleInner);

const PriceInfoDialog = ({
  bom,
  showPrice,
  onClose
}) => {
  const {
    t
  } = useTranslation();
  const dynamicTranslation = useDynamicTranslation();
  return jsxs(Dialog, {
    className: "priceInfoDialog",
    open: bom != null,
    maxWidth: "md",
    onClose: onClose,
    fullWidth: true,
    children: [jsx(DialogTitle, {
      className: "priceInfoDialogTitle",
      children: dynamicTranslation(DynamicSettingsKeys.ORDER_DIALOG_OVERVIEW_PRICEINFO)
    }), jsx(DialogContent, {
      className: "priceInfoDialogContent",
      dividers: true,
      children: bom && jsx(PriceTableArticle, {
        dense: true,
        bom: bom,
        showPrice: showPrice
      })
    }), jsx(DialogActions, {
      className: "priceInfoDialogActions",
      children: jsx(Button, {
        onClick: onClose,
        "data-cy": `close`,
        children: t("Schliessen")
      })
    })]
  });
};

/** Pre-Styled Tooltip */
const LightTooltip = styled(Tooltip$1)(({
  theme
}) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 16,
    border: "solid 1px rgba(0, 0, 0, 0.87)"
  },
  arrow: {
    "&:before": {
      boxSizing: "border-box",
      border: "solid 1px rgba(0, 0, 0, 0.87)"
    },
    color: theme.palette.common.white
  }
}));

const _excluded$h = ["isInRange", "resetNumber", "children", "placement", "variable"],
  _excluded2$1 = ["resetNumber"];
const NumberWarningTooltip = _ref => {
  let {
      isInRange,
      resetNumber,
      children,
      placement = "left-end",
      variable
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$h);
  return jsx(LightTooltip, Object.assign({}, rest, {
    arrow: true,
    placement: placement,
    open: !isInRange,
    title: !isInRange && jsx(NumberWarningTooltipContent, Object.assign({
      isInRange: isInRange,
      resetNumber: resetNumber,
      placement: placement,
      variable: variable,
      children: jsx(Fragment, {})
    }, rest)),
    children: jsx(Box, {
      component: "div",
      children: children
    })
  }));
};
const INumberWarningTooltip = _ref2 => {
  let {
      resetNumber
    } = _ref2;
    _objectWithoutPropertiesLoose(_ref2, _excluded2$1);
  const getTranslation = useDynamicTranslation();
  return jsxs(Box, {
    component: "div",
    sx: {
      display: "grid",
      gridTemplateColumns: "min-content auto",
      gap: 1,
      alignItems: "center"
    },
    children: [jsx(ErrorOutline, {
      color: "error"
    }), getTranslation("translation_warning_number") + resetNumber, jsx(EditDynamicSettings, {
      keys: ["translation_warning_number"],
      display: "dialog"
    })]
  });
};
const NumberWarningTooltipContent = withExtensions({
  app: {
    sidebar: {
      numberWarningTooltipContent: {
        root: true
      }
    }
  }
})(INumberWarningTooltip);

const sxStyles$l = {
  hiddenContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    borderRadius: 1,
    opacity: 0.5,
    filter: "grayscale(1)",
    border: "2px black solid",
    boxSizing: "border-box",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    pointerEvents: "none"
  },
  hiddenBackground: {
    background: theme => {
      return `repeating-linear-gradient(
45deg,
${theme.palette.warning.main},
${theme.palette.warning.main} 10px,
${theme.palette.warning.dark} 10px,
${theme.palette.warning.dark} 20px
)`;
    }
  }
};
const withEditorHideDisableTemplateOptions = Wrapped => props => {
  const {
    t
  } = useTranslation();
  const hiddenBecause = useTypedSelector(selectIsVariableHiddenBecause(props.variable));
  if (hiddenBecause !== null) {
    return jsxs(Box, {
      component: "div",
      sx: Object.assign({
        position: "relative"
      }, hiddenBecause.reason === HiddenReason.NoValidValue ? {
        height: 100
      } : {}, {
        minHeight: 50,
        whiteSpace: "pre-line"
      }),
      children: [jsx(Wrapped, Object.assign({}, props, {
        disabled: true,
        dontHide: true
      })), jsx(Tooltip, {
        title: jsx(Box, {
          component: "div",
          style: {
            whiteSpace: "pre-line"
          },
          children: t(hiddenBecause.text)
        }),
        children: jsx(Box, {
          component: "div",
          sx: [sxStyles$l.hiddenBackground, sxStyles$l.hiddenContainer],
          children: jsx(VisibilityOff, {})
        })
      })]
    });
  }
  return jsx(Wrapped, Object.assign({}, props));
};

const _excluded$g = ["fullWidth", "data-cy", "label", "onChange"];
const sxStyles$k = {
  fullWidth: {
    width: 1.0,
    marginLeft: 0,
    "& .MuiFormControlLabel-label": {
      width: 1.0
    }
  }
};
const OCCheckbox = props => {
  const {
      fullWidth,
      "data-cy": cyKey,
      label,
      onChange
    } = props,
    checkboxProps = _objectWithoutPropertiesLoose(props, _excluded$g);
  const handleChange = event => {
    onChange(event.target.checked);
  };
  return jsx(FormControlLabel, {
    "data-cy": cyKey + "label",
    sx: fullWidth ? sxStyles$k.fullWidth : {},
    control: jsx(Checkbox$1, Object.assign({
      "data-cy": cyKey + "check",
      // @ts-ignore
      inputProps: {
        "data-cy": cyKey + "checkInput"
      }
    }, checkboxProps, {
      onChange: handleChange
    })),
    label: label
  });
};

const VariableInfoIcon = ({
  variable,
  sx
}) => {
  const dispatch = useTypedDispatch();
  const handleClick = useCallback(() => {
    dispatch(setVariableInfoDialog({
      variableId: variable == null ? void 0 : variable.id
    }));
  }, [dispatch, variable]);
  return jsx(IconButton, {
    onClick: handleClick,
    "data-cy": `varInfo-${variable == null ? void 0 : variable.id}`,
    sx: sx,
    children: jsx(InfoOutlined, {
      color: "info"
    })
  });
};

const SimpleVariableLabel = ({
  variable,
  fullWidth: _fullWidth = false,
  showLabel
}) => jsxs(Box, {
  component: "div",
  sx: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  "data-cy": "simpleVariableLabelBox",
  children: [showLabel && jsx(Typography, {
    component: "span",
    variant: "body1",
    color: "textSecondary",
    sx: Object.assign({
      whiteSpace: "wrap"
    }, _fullWidth ? {
      width: 1.0
    } : {}),
    "data-cy": "simpleVariableLabel",
    children: variable == null ? void 0 : variable.label
  }), isVariable(variable) && (variable == null ? void 0 : variable.info) && jsx(VariableInfoIcon, {
    variable: variable
  })]
});
/** Default label of a variable */
const VariableLabel = ({
  variable,
  fullWidth,
  showLabel: _showLabel = true,
  children
}) => {
  const ctx = useContext(ExtensionContext);
  const Label = useMemo(() => {
    const extension = ctx.extendVariableLabel || identity;
    return extension(props => jsxs(Stack, {
      direction: "row",
      "data-cy": "variableLabelStack",
      children: [jsx(SimpleVariableLabel, {
        variable: props.variable,
        fullWidth: fullWidth,
        showLabel: _showLabel
      }), props.children]
    }));
  }, [ctx.extendVariableLabel, fullWidth, _showLabel]);
  return jsxs(Box, {
    component: "span",
    children: [Label && jsx(Label, {
      variable: variable,
      children: children
    }), (variable == null ? void 0 : variable.description) && jsx(Typography, {
      component: "span",
      variant: "body2",
      gutterBottom: true,
      children: variable.description
    })]
  });
};

// Das Backend liefert anstatt true oder false für booleans "0" oder "1"
// zurück.
const parseBackendBool = value => {
  switch (value == null ? void 0 : value.value) {
    case "0":
      return false;
    case "1":
      return true;
    default:
      // directly after creation value.value is true/false
      return !!(value != null && value.value);
  }
};
const useBooleanChangeHandler = (onChange, value, variable, values) => {
  const handleChange = useCallback(checked => {
    flow(find$1(value => parseBackendBool(value) === checked), value => value == null ? void 0 : value.id, onChange)(values);
  }, [onChange, values]);
  return {
    onBooleanChange: handleChange,
    checked: parseBackendBool(value)
  };
};

const CheckboxTmp = ({
  variable,
  value,
  onChange,
  values
}) => {
  const {
    checked,
    onBooleanChange
  } = useBooleanChangeHandler(onChange, value, variable, values);
  return jsx(OCCheckbox, {
    "data-cy": `varCheck-${variable.id}`,
    fullWidth: true,
    label: jsx(VariableLabel, {
      fullWidth: true,
      variable: variable
    }),
    value: checked,
    onChange: onBooleanChange
  });
};
const Checkbox = withComponentExtension("checkbox")(CheckboxTmp);

const ColorButton = /*#__PURE__*/React__default.forwardRef(({
  disabled: _disabled = false,
  height: _height = 20,
  hexColor,
  isActive: _isActive = false,
  onClick: _onClick = noop$1,
  width: _width = 20,
  children: _children = null,
  borderRadius: _borderRadius = 1
}, ref) => jsx(Box, {
  component: "div",
  sx: {
    width: _width,
    height: _height,
    boxSizing: "border-box",
    position: "relative"
  },
  className: _isActive ? "MuiChecked" : "",
  children: jsxs(ButtonBase, {
    "data-cy": `colorButton`,
    ref: ref,
    disabled: _disabled,
    onClick: _onClick,
    sx: {
      width: _width - 6,
      height: _height - 6,
      background: hexColor,
      borderRadius: _borderRadius,
      position: "absolute",
      top: 1,
      left: 1,
      bottom: 1,
      right: 1
    },
    children: [_isActive && jsx(CheckOutlined, {
      fontSize: "large",
      sx: {
        color: colord(hexColor).isLight() ? "black" : "white"
      }
    }), _children]
  })
}));

const InfoSelectionIcon = props => {
  var _props$variable, _props$variable$setti, _props$variable$setti2, _props$value, _props$value2, _props$variable2;
  const infoDisplayed = ((_props$variable = props.variable) == null ? void 0 : (_props$variable$setti = _props$variable.settings) == null ? void 0 : (_props$variable$setti2 = _props$variable$setti.templateOptions) == null ? void 0 : _props$variable$setti2.showInfo) && ((_props$value = props.value) == null ? void 0 : _props$value.info) && ((_props$value2 = props.value) == null ? void 0 : _props$value2.info) != "";
  const attrsDisplayed = (((_props$variable2 = props.variable) == null ? void 0 : _props$variable2.attrs) || []).some(attr => attr.displayed);
  const dispatch = useTypedDispatch();
  if (!infoDisplayed && !attrsDisplayed) return null;
  const handleClick = event => {
    /**
     * Hä? Warum ist das denn jetzt über Redux gemacht, obwohl Jörg das war?
     * Weil, wenn der Dialog direkt hier gerendert wird, verschwindet er, sobald das Icon verschwindet -
     * also z.B. sobald ein Select sich schliesst.
     * Also Variable und Value, für die Info gezeigt werden soll, in den State und den Dialog zeigen, sobald nicht null steht.
     * Vgl. ./InfoSelectionDialog
     */
    dispatch(setInfoDialog({
      variable: props.variable,
      value: props.value
    }));
    // Klick auf das Info-Icon soll den Wert nicht auswählen
    event.stopPropagation();
  };
  return jsx(InfoOutlined, {
    fontSize: "inherit",
    color: "action",
    sx: props.sx,
    onClick: handleClick
  });
};

extend([harmonies]);
const gridGap = 4;
const OCColorSelect = ({
  variable,
  columnCount: _columnCount = 4,
  borderRadius: _borderRadius = 1,
  disabled: _disabled = false,
  label,
  onChange,
  rowCount: _rowCount = 2,
  value,
  values
}) => {
  const containerRef = useRef(null);
  const [width, setWidth] = useState(0);
  useLayoutEffect(() => {
    var _containerRef$current;
    setWidth((containerRef == null ? void 0 : (_containerRef$current = containerRef.current) == null ? void 0 : _containerRef$current.clientWidth) || 0);
  }, [values, _rowCount, _columnCount]);
  const cellWidth = width / _columnCount;
  const maxHeight = Math.min(Math.ceil(values.length / _columnCount), _rowCount);
  return jsxs(Box, {
    component: "div",
    sx: {
      width: 1.0
    },
    children: [jsx(Typography, {
      component: "span",
      color: "textSecondary",
      children: label
    }), jsx(Box, {
      component: "div",
      ref: containerRef,
      sx: {
        display: "grid",
        justifyContent: "start",
        gridTemplateColumns: `repeat(${_columnCount}, auto)`,
        gridGap,
        width: 1.0,
        height: maxHeight * cellWidth,
        overflowY: "auto"
      },
      children: map(currentValue => {
        const invalidColor = colord(currentValue.value).isLight() ? "black" : "white";
        return jsxs(ColorButton, {
          disabled: _disabled,
          onClick: () => onChange(currentValue.id),
          width: cellWidth - gridGap,
          height: cellWidth - gridGap,
          isActive: (value == null ? void 0 : value.id) == currentValue.id,
          hexColor: currentValue.value,
          borderRadius: _borderRadius,
          children: [jsx(InvalidSelectionWarning, {
            iconSx: {
              position: "absolute",
              bottom: 5,
              right: 5,
              color: invalidColor
            },
            valueId: currentValue.id
          }), jsx(InfoSelectionIcon, {
            variable: variable,
            // TODO: Das ist hier nicht wirklich eine Value...
            value: currentValue,
            sx: {
              position: "absolute",
              bottom: 5,
              left: 5,
              color: invalidColor
            }
          })]
        }, currentValue.id);
      }, values)
    })]
  });
};

const WithHideDisableTemplateOptions = Wrapped => props => {
  var _props$validOptions3;
  const templateOptions = getTemplateOptions(props.variable);
  if (!props.dontHide) {
    var _props$validOptions, _props$validOptions2;
    if (templateOptions != null && templateOptions.hideAlways) {
      return null;
    }
    if (templateOptions != null && templateOptions.hideIfNoOptions && (((_props$validOptions = props.validOptions) == null ? void 0 : _props$validOptions.length) || 0) === 0) {
      return null;
    }
    if (templateOptions != null && templateOptions.hideIfSingleOption && (((_props$validOptions2 = props.validOptions) == null ? void 0 : _props$validOptions2.length) || 0) <= 1) {
      if (isNumberVariable(props.variable)) {
        var _props$validOptions$;
        const value = (_props$validOptions$ = props.validOptions[0]) == null ? void 0 : _props$validOptions$.value;
        if (isDiscreteIntervalValue(value)) {
          return null;
        }
      } else {
        return null;
      }
    }
  }
  const disabled = props.disabled || (templateOptions == null ? void 0 : templateOptions.disableIfSingleOption) && (((_props$validOptions3 = props.validOptions) == null ? void 0 : _props$validOptions3.length) || 0) <= 1;
  return jsx(Wrapped, Object.assign({}, props, {
    disabled: disabled
  }));
};

const ColorSelectTmp = ({
  variable,
  value,
  values,
  onChange,
  disabled
}) => {
  const templateOptions = getTemplateOptions(variable);
  const borderRadius = isNumber$1(templateOptions == null ? void 0 : templateOptions.borderRadius) ? templateOptions == null ? void 0 : templateOptions.borderRadius : 1;
  return jsx(OCColorSelect, {
    variable: variable,
    disabled: disabled,
    label: jsx(VariableLabel, {
      variable: variable
    }),
    values: values,
    value: value,
    onChange: onChange,
    columnCount: templateOptions == null ? void 0 : templateOptions.numberOfColorsShown,
    borderRadius: borderRadius
  });
};
const ColorSelect = flow(WithHideDisableTemplateOptions, withComponentExtension("colorSelect"))(ColorSelectTmp);

const useRapidStore = create$9()(set => ({
  hoveredSelections: [],
  setHoveredSelection: selectionId => {
    set(state => ({
      hoveredSelections: [...state.hoveredSelections, selectionId]
    }));
  },
  removeHoveredSelection: selectionId => {
    set(state => ({
      hoveredSelections: state.hoveredSelections.filter(s => s !== selectionId)
    }));
  }
}));

const sxStyles$j = {
  wrapper: {
    display: "flex",
    flexDirection: "column",
    mt: 2,
    overflowY: "auto"
  },
  button: {
    display: "grid",
    gridTemplateColumns: "min-content 1fr min-content",
    gridTemplateAreas: `
          "Thumbnail Title Icons"
          "Thumbnail Extra Extra"`,
    width: "100%"
  },
  buttonThumbnail: {
    gridArea: "Thumbnail",
    justifySelf: "start"
  },
  buttonTitle: {
    gridArea: "Title"
  },
  buttonIcons: {
    gridArea: "Icons",
    justifySelf: "end"
  },
  buttonExtra: {
    gridArea: "Extra"
  }
};
const emptySelectionMap = [];
const useSelectionMap = (variable, sort = false) => {
  var _ruleEngineState$stat4, _ruleEngineState$stat5;
  const {
    ruleEngineInput,
    ruleEngineState,
    openInstance
  } = useTypedSelector(selectRuleEngineInfo);
  return useMemo(() => {
    var _ruleEngineState$stat, _ruleEngineState$stat2, _ruleEngineState$stat3;
    if (!variable) {
      return [];
    }
    const result = ruleEngineState == null ? void 0 : (_ruleEngineState$stat = ruleEngineState.state) == null ? void 0 : (_ruleEngineState$stat2 = _ruleEngineState$stat.all) == null ? void 0 : (_ruleEngineState$stat3 = _ruleEngineState$stat2.selections) == null ? void 0 : _ruleEngineState$stat3.filter(s => s.variableId === variable.id && s.instance.belongsToInstanceId === openInstance.id).sort((a, b) => a.sort - b.sort).map(s => ({
      selection: s,
      value: ruleEngineInput == null ? void 0 : ruleEngineInput.values.byVarId.locked[variable.id].find(v => v.id === s.valueId)
    }));
    if (sort) {
      var _result$slice$sort;
      return (_result$slice$sort = result == null ? void 0 : result.slice().sort((a, b) =>
      // @ts-ignore
      a.value.sort - b.value.sort || a.selection.sort - b.selection.sort)) != null ? _result$slice$sort : emptySelectionMap;
    }
    return result != null ? result : emptySelectionMap;
  }, [variable, ruleEngineState == null ? void 0 : (_ruleEngineState$stat4 = ruleEngineState.state) == null ? void 0 : (_ruleEngineState$stat5 = _ruleEngineState$stat4.all) == null ? void 0 : _ruleEngineState$stat5.selections, sort, openInstance.id, ruleEngineInput == null ? void 0 : ruleEngineInput.values.byVarId.locked]);
};
const ComponentButtonsTmp = ({
  variable,
  onRenderThumbnail,
  onRenderExtra,
  hideSelection,
  tailingContent
}) => {
  var _useSelectionMap$filt, _useSelectionMap;
  const selectionMap = (_useSelectionMap$filt = (_useSelectionMap = useSelectionMap(variable, true)) == null ? void 0 : _useSelectionMap.filter(s => hideSelection ? hideSelection(s.selection, s.value) : true)) != null ? _useSelectionMap$filt : [];
  const dispatch = useTypedDispatch();
  const handleChange = (_e, selectionId) => {
    dispatch(openInstanceById(selectionId));
  };
  const setHoveredSelection = useRapidStore(state => state.setHoveredSelection);
  const removeHoveredSelection = useRapidStore(state => state.removeHoveredSelection);
  return jsxs(Fragment, {
    children: [jsx(Typography, {
      color: "textSecondary",
      children: jsx(VariableLabel, {
        variable: variable
      })
    }), jsx(ToggleButtonGroup, {
      sx: sxStyles$j.wrapper,
      orientation: "vertical",
      exclusive: true,
      onChange: handleChange,
      children: selectionMap.map(selection => jsx(ToggleButton, {
        onMouseEnter: () => setHoveredSelection(selection.selection.id),
        onMouseLeave: () => removeHoveredSelection(selection.selection.id),
        onMouseDown: () => removeHoveredSelection(selection.selection.id),
        "data-cy": `selection-${selection == null ? void 0 : selection.value}`,
        fullWidth: true,
        value: selection.selection.id,
        sx: {
          textAlign: "left"
        },
        children: jsxs(Box, {
          component: "div",
          sx: sxStyles$j.button,
          children: [jsx(Box, {
            component: "div",
            sx: sxStyles$j.buttonThumbnail,
            children: onRenderThumbnail ? onRenderThumbnail(selection.selection, selection.value) : null
          }), jsx(Typography, {
            sx: sxStyles$j.buttonTitle,
            variant: "body1",
            color: "textPrimary",
            children: selection.value.label
          }), tailingContent ? tailingContent(selection.selection, selection.value) : jsx(Box, {
            component: "div",
            sx: sxStyles$j.buttonIcons,
            children: jsx(EditIcon, {
              fontSize: "small",
              color: "action"
            })
          }), jsx(Box, {
            component: "div",
            sx: sxStyles$j.buttonExtra,
            children: onRenderExtra ? onRenderExtra(selection.selection, selection.value) : null
          })]
        })
      }, selection.selection.id))
    })]
  });
};
const ComponentButtons = flow(WithHideDisableTemplateOptions, withComponentExtension("componentButtons"))(ComponentButtonsTmp);

/**
 * Urgs.
 * Hier stylen wir die border selbst - das ist Mist.
 */
const sxStyles$i = {
  list: {
    border: "solid 1px rgba(0, 0, 0, 0.38)",
    borderRadius: 1,
    padding: 1,
    overflowY: "auto"
  }
};
function OCSelectList(props) {
  const onListItemClick = value => {
    props.onChange(value);
  };
  return jsxs(FormControl$1, {
    fullWidth: true,
    variant: "outlined",
    children: [!!props.label && jsx(Typography, {
      color: "textSecondary",
      children: props.label
    }), jsxs(List, {
      component: "nav",
      style: {
        maxHeight: props.maxHeight,
        height: props.height
      },
      sx: props.listStyles || sxStyles$i.list,
      "data-cy": props["data-cy"],
      children: [React__default.Children.map(props.children || null, child => {
        return (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
          jsx("div", {
            onClick: () => onListItemClick(child.props.value),
            children: child
          })
        );
      }), !!props.footerContent && jsx(Box, {
        component: "div",
        sx: {
          //sticky footer
          position: "sticky",
          width: "100%",
          bottom: "-8px",
          background: "white"
        },
        children: props.footerContent
      })]
    })]
  });
}

const OCSelectListItem = ({
  checked,
  disabled,
  hideCheckbox,
  label,
  value,
  chip,
  onDelete,
  instanceId,
  variable
}) => {
  const setHoveredSelection = useRapidStore(state => state.setHoveredSelection);
  const removeHoveredSelection = useRapidStore(state => state.removeHoveredSelection);
  const selectionId = value.toString();
  return jsx(ListItem, {
    disabled: disabled,
    value: value,
    disablePadding: true,
    dense: true,
    onMouseEnter: () => setHoveredSelection(selectionId),
    onMouseLeave: () => removeHoveredSelection(selectionId),
    onMouseDown: () => removeHoveredSelection(selectionId),
    secondaryAction: jsxs(Fragment, {
      children: [jsx(IconButton, {
        edge: "end",
        "data-cy": `edit`,
        children: jsx(Edit$4, {
          fontSize: "small"
        })
      }), jsx(IconButton, {
        onClick: onDelete,
        sx: {
          ml: 2
        },
        edge: "end",
        "data-cy": `del`,
        children: jsx(Delete, {
          fontSize: "small"
        })
      })]
    }),
    children: jsxs(ListItemButton, {
      children: [!hideCheckbox && jsx(ListItemIcon, {
        children: jsx(Checkbox$1, {
          checked: checked,
          "data-cy": `ls`
        })
      }), !!instanceId && jsx(InstanceCountInput, {
        instanceId: instanceId,
        variable: variable
      }), jsx(ListItemText, {
        children: jsx(Box, {
          component: "div",
          "data-cy": "listItemBox_" + label,
          sx: {
            display: "flex",
            flexDirection: "row"
            // justifyContent: 'center',
          },
          children: jsxs(Typography, {
            children: [chip !== undefined && `${chip}. `, label]
          })
        })
      })]
    })
  });
};

/** This function creates a new styledObject and is a pure TS Wrapper. Main advantages:
 * - Autocomplete for css and sx syntax
 * - theme automatically gets assigned the appropriate type, no need for (theme: Theme) => anymore.
 */
const createStyleObject = styles => styles;
/** Merge multiple sx styles to one, first has the lowest priority. */
const mergeStyles = (...styles) => Object.assign(styles);
/** Styles creating a baseline for all projects using the K3. It is recommended to be used in all projects using the K3. */
const k3GlobalStylePreset = {
  "html, body, #root": {
    margin: 0,
    height: "100%"
  }
};

const _excluded$f = ["variable", "values"];
const styles$1 = createStyleObject({
  wrapper: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    mt: 2
  },
  select: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "row",
    marginBottom: theme => theme.spacing(1)
  }
});
const ComponentListTmp = _ref => {
  let {
      variable,
      values
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$f);
  useTranslation();
  const dispatch = useTypedDispatch();
  getTemplateOptions(variable);
  const isCountVariable = useVariableIsInstanceCount();
  const selectionMap = useSelectionMap(variable);
  const hasInstanceActions = useTypedSelector(isControlledByInstanceActions(variable.id));
  if (hasInstanceActions) {
    return jsx(ComponentButtons, Object.assign({}, rest, {
      variable: variable,
      values: values
    }));
  }
  const addComponent = itemId => {
    const value = values.find(value => value.id == itemId);
    if (value) {
      dispatch(addInstanceThunk(value));
    }
  };
  const onHandleDelete = (event, selection) => {
    event.stopPropagation();
    dispatch(removeInstanceThunk(selection));
  };
  const handleChange = selectionId => dispatch(openInstanceById(selectionId));
  return jsxs(Fragment, {
    children: [jsx(Typography, {
      color: "textSecondary",
      children: jsx(VariableLabel, {
        variable: variable
      })
    }), jsxs(Box, {
      component: "div",
      sx: styles$1.wrapper,
      children: [jsx(Box, {
        component: "div",
        sx: styles$1.select,
        children: jsx(AddItemsDropdown, {
          onSelected: value => addComponent(value.id),
          variable: variable
        })
      }), jsx(OCSelectList, {
        "data-cy": `ocSelectList`,
        defaultValue: -1,
        onChange: handleChange,
        height: "150px",
        listStyles: {
          padding: 1,
          overflowY: "auto",
          border: "solid 1px rgba(0, 0, 0, 0.38)",
          borderRadius: 1
        },
        children: selectionMap.map(currentValue => {
          return jsx(OCSelectListItem, {
            // checked={(value as Value)?.id == currentValue.value?.id}
            hideCheckbox: true,
            label: currentValue.value.label,
            value: currentValue.selection.id,
            onDelete: event => onHandleDelete(event, currentValue.selection),
            chip: currentValue.selection.sort,
            instanceId: isCountVariable(currentValue.selection.variableId) ? currentValue.selection.id : undefined,
            variable: variable
          }, currentValue.selection.id);
        })
      })]
    })]
  });
};
const ComponentList = flow(WithHideDisableTemplateOptions, withComponentExtension("componentList"))(ComponentListTmp);

function SearchField({
  justifySelf,
  currentValue,
  onChange,
  placeholder
}) {
  const {
    t
  } = useTranslation();
  return jsxs(Paper, {
    sx: {
      display: "flex",
      width: 300,
      justifySelf: justifySelf != null ? justifySelf : "unset",
      justifyContent: "space-between",
      alignItems: "center"
    },
    "data-cy": `searchField`,
    children: [jsx(IconButton, {
      type: "button",
      "aria-label": "search",
      disabled: true,
      "data-cy": `search`,
      children: jsx(Search, {})
    }), jsx(InputBase, {
      value: currentValue,
      id: "search-field",
      sx: {
        width: 170
      },
      onChange: event => onChange(event.target.value),
      onKeyDown: e => {
        if (e.key === "Escape") {
          onChange("");
          e.currentTarget.blur();
        }
      },
      placeholder: placeholder ? placeholder : t("Suchen")
    }), currentValue ? jsx(IconButton, {
      "data-cy": `clear`,
      type: "button",
      "aria-label": "search",
      onClick: () => onChange(""),
      sx: {
        ml: "auto"
      },
      children: jsx(Clear, {})
    }) : jsx(Stack, {
      pr: 2,
      sx: {
        color: "action.active"
      },
      children: jsxs("kbd", {
        children: [t("Ctrl"), " + K"]
      })
    })]
  });
}

const _excluded$e = ["variable", "values"];
const styles = createStyleObject({
  wrapper: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    mt: 2
  },
  select: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "row",
    marginBottom: theme => theme.spacing(1)
  }
});
const ComponentListPopupTmp = _ref => {
  let {
      variable,
      values
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$e);
  // const { t } = useTranslation();
  const getTranslation = useDynamicTranslation();
  const dispatch = useTypedDispatch();
  const templateOptions = getTemplateOptions(variable);
  const language = useTypedSelector(selectContentLanguage);
  const selectionMap = useSelectionMap(variable);
  const hasInstanceActions = useTypedSelector(isControlledByInstanceActions(variable.id));
  const [showOptions, setShowOptions] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const isCountVariable = useVariableIsInstanceCount();
  const getGroupName = useMemo(() => group => {
    if (group) {
      const name = typeof group == "object" ? getLocalizedText(group, language) : group.toString();
      if (name) {
        return name;
      }
    }
    return getTranslation("translation_mp_popup_not_grouped");
  }, [getTranslation, language]);
  const differentGroups = useMemo(() => {
    const groups = values.reduce((acc, value) => {
      var _value$attrs;
      const group = (_value$attrs = value.attrs) == null ? void 0 : _value$attrs.find(attr => attr.attrId == templateOptions.groupBy);
      const groupHeader = getGroupName(group == null ? void 0 : group.value);
      if (!acc.includes(groupHeader)) {
        acc.push(groupHeader);
      }
      return acc;
    }, []);
    return groups;
  }, [getGroupName, templateOptions.groupBy, values]);
  if (hasInstanceActions) {
    return jsx(ComponentButtons, Object.assign({}, rest, {
      variable: variable,
      values: values
    }));
  }
  const addComponent = itemId => {
    const value = values.find(value => value.id == itemId);
    if (value) {
      dispatch(addInstanceThunk(value));
    }
  };
  const onHandleDelete = (event, selection) => {
    event.stopPropagation();
    dispatch(removeInstanceThunk(selection));
  };
  const handleChange = selectionId => dispatch(openInstanceById(selectionId));
  return jsxs(Fragment, {
    children: [jsx(Typography, {
      color: "textSecondary",
      children: jsx(VariableLabel, {
        variable: variable
      })
    }), jsx(Box, {
      component: "div",
      sx: styles.wrapper,
      children: jsx(OCSelectList, {
        "data-cy": `ocSelectList`,
        defaultValue: -1,
        onChange: handleChange,
        height: "150px",
        listStyles: {
          padding: 1,
          overflowY: "auto",
          border: "solid 1px rgba(0, 0, 0, 0.38)",
          borderRadius: 1
        },
        footerContent: jsxs(Fragment, {
          children: [jsx(Divider, {
            "data-cy": "footerDivider"
          }), jsx("div", {
            style: {
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: "1rem"
            },
            "data-cy": "footerContent",
            children: jsx(AddComponentButton, {
              onClick: () => {
                if (values.length <= 1) {
                  if (values.length == 1) {
                    //add the only value
                    dispatch(addInstanceThunk(values[0]));
                  }
                } else {
                  setShowOptions(true);
                }
              },
              disabled: values.length == 0
            })
          })]
        }),
        children: selectionMap.map(currentValue => {
          return jsx(OCSelectListItem, {
            // checked={(value as Value)?.id == currentValue.value?.id}
            hideCheckbox: true,
            label: currentValue.value.label,
            value: currentValue.selection.id,
            onDelete: event => onHandleDelete(event, currentValue.selection),
            chip: currentValue.selection.sort,
            instanceId: isCountVariable(currentValue.selection.variableId) ? currentValue.selection.id : undefined,
            variable: variable
          }, currentValue.selection.id);
        })
      })
    }), jsxs(Dialog, {
      open: showOptions,
      onClose: () => setShowOptions(false),
      "data-cy": "componentListPopup",
      fullWidth: true,
      maxWidth: "xl",
      children: [jsxs(DialogTitle, {
        children: [jsx(Typography, {
          variant: "h6",
          children: getTranslation("translation_mp_popup_title")
        }), jsx(Box, {
          component: "div",
          sx: {
            position: "absolute",
            top: 0,
            right: 0
          },
          children: jsx(EditDynamicSettings, {
            keys: ["translation_mp_popup_add", "translation_mp_popup_search", "translation_mp_popup_description", "translation_mp_popup_title", "translation_mp_popup_not_grouped"],
            display: "dialog"
          })
        })]
      }), jsxs(DialogContent, {
        children: [jsxs(Box, {
          sx: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            flexWrap: "wrap",
            alignItems: "center",
            gap: "1rem"
          },
          component: "div",
          children: [jsx(Typography, {
            variant: "subtitle1",
            children: getTranslation("translation_mp_popup_description")
          }), jsx(SearchField, {
            currentValue: searchValue,
            onChange: value => {
              setSearchValue(value);
            },
            placeholder: getTranslation("translation_mp_popup_search")
          })]
        }), templateOptions.groupBy && differentGroups.length > 1 ? jsx(Box, {
          component: "div",
          "data-cy": "groupsWrapper",
          children: differentGroups.map(group => {
            const groupedValues = values.filter(v => {
              var _v$attrs;
              //filter by group
              const groupAttr = (_v$attrs = v.attrs) == null ? void 0 : _v$attrs.find(attr => attr.attrId == templateOptions.groupBy);
              const groupHeader = getGroupName(groupAttr == null ? void 0 : groupAttr.value);
              return groupHeader == group;
            }).filter(v => {
              return v.label.toLowerCase().indexOf(searchValue.toLowerCase()) > -1;
            });
            if (groupedValues.length == 0) {
              return null;
            }
            return jsxs(Accordion, {
              "data-cy": "group-" + group,
              children: [jsx(AccordionSummary, {
                expandIcon: jsx(ExpandMoreIcon, {}),
                "aria-controls": "panel1bh-content",
                id: "panel1bh-header",
                children: jsx(Typography, {
                  variant: "subtitle1",
                  children: group
                })
              }), jsx(AccordionDetails, {
                children: jsx(EntriesWrapper, {
                  children: groupedValues.map((currentValue, index) => {
                    return jsx(EntryButton, {
                      currentValue: currentValue,
                      index: index,
                      setShowOptions: setShowOptions,
                      addComponent: addComponent,
                      showThumbnail: variable.settings.templateOptions.showThumbnail
                    });
                  })
                })
              })]
            }, group);
          })
        }) : jsx(EntriesWrapper, {
          children: values.filter(v => {
            return v.label.toLowerCase().indexOf(searchValue.toLowerCase()) > -1;
          }).map((currentValue, index) => {
            return jsx(EntryButton, {
              currentValue: currentValue,
              index: index,
              setShowOptions: setShowOptions,
              addComponent: addComponent,
              showThumbnail: variable.settings.templateOptions.showThumbnail
            });
          })
        })]
      }), jsx(DialogActions, {})]
    })]
  });
};
const EntriesWrapper = ({
  children
}) => {
  return jsx(Box, {
    "data-cy": "entriesWrapper",
    sx: {
      display: "grid",
      //fit content in width best with 4 columns maximum
      gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 300px), 1fr))",
      gap: "1rem",
      paddingY: "1rem"
    },
    component: "div",
    children: children
  });
};
const EntryButton = ({
  currentValue,
  index,
  setShowOptions,
  addComponent,
  showThumbnail
}) => {
  return jsx(Button, {
    "data-cy": "addComponentButton-" + index,
    onClick: () => {
      setShowOptions(false);
      addComponent(currentValue.id);
    },
    sx: {
      width: "100%",
      height: "100%",
      alignSelf: "center"
    },
    children: jsxs(Box, {
      component: "div",
      sx: {
        padding: "1rem",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
      },
      children: [showThumbnail && currentValue.thumbnail && jsx("img", {
        "data-cy": "componentThumbnail",
        src: currentValue.thumbnail,
        alt: currentValue.label,
        style: {
          maxWidth: "300px",
          height: "auto",
          maxHeight: "400px",
          objectFit: "contain",
          marginBottom: "1rem"
        }
      }), jsx(Typography, {
        variant: "body1",
        "data-cy": "componentLabel",
        sx: {
          width: "100%",
          whiteSpace: "wrap"
        },
        children: currentValue.label
      })]
    })
  }, currentValue.id);
};
const AddComponentButtonTmp = ({
  onClick,
  disabled
}) => {
  const getTranslation = useDynamicTranslation();
  return jsxs(Button, {
    "data-cy": "addComponentButton",
    variant: "text",
    color: "inherit",
    onClick: onClick,
    disabled: disabled,
    children: [jsx(Typography, {
      variant: "body1",
      "data-cy": "addComponentButtonText",
      children: getTranslation("translation_mp_popup_add")
    }), jsx(AddIcon, {})]
  });
};
const AddComponentButton = withExtensions({
  app: {
    sidebar: {
      componentListPopup: {
        addComponentButton: {
          root: true
        }
      }
    }
  }
})(AddComponentButtonTmp);
const ComponentListPopup = flow$1(WithHideDisableTemplateOptions, withExtensions({
  app: {
    sidebar: {
      componentListPopup: {
        root: true
      }
    }
  }
}))(ComponentListPopupTmp);

const useTextChangeHandler = variableComponentProps => {
  var _selection$data;
  const {
    selection,
    onChange,
    value
  } = variableComponentProps;
  return {
    text: selection == null ? void 0 : (_selection$data = selection.data) == null ? void 0 : _selection$data.inputText,
    onChange: text => onChange(value.id, {
      inputText: text
    })
  };
};

const HiddenTmp = variableComponentProps => {
  const {
    onChange
  } = useTextChangeHandler(variableComponentProps);
  return jsx(OCTextInput, {
    "data-cy": `hidden`,
    label: jsx(VariableLabel, {
      variable: variableComponentProps.variable
    }),
    disabled: true,
    fullWidth: true,
    value: "Versteckt",
    onChange: onChange
  });
};
const Hidden = withComponentExtension("hidden")(HiddenTmp);

const OCSlider = /*#__PURE__*/React__default.forwardRef(({
  debounced,
  throttle: throttle$1,
  label,
  onChange,
  value,
  sliderProps,
  sx,
  "data-cy": dataCy
}, ref) => {
  const delayed = useMemo(() => !!debounced || !!throttle$1, [debounced, throttle$1]);
  const [delayedValue, setDelayedValue] = useState(value);
  const onChangeDebounced = useCallback(debounce(value => onChange(value), 16), [onChange]);
  const onChangeThrottled = useCallback(throttle(value => onChange(value), throttle$1), [onChange, throttle$1]);
  const handleChangeDelayed = useCallback((_event, value) => {
    setDelayedValue(value);
    if (throttle$1) {
      onChangeThrottled(value);
    } else if (debounced) {
      onChangeDebounced(value);
    }
  }, [onChangeThrottled, onChangeDebounced, throttle$1, debounced]);
  const handleChange = useCallback((_event, value) => onChange(value), [onChange]);
  useEffect(() => {
    if (delayed) setDelayedValue(value);
  }, [value, delayed]);
  return jsxs(Box, {
    component: "div",
    ref: ref,
    sx: sx,
    "data-cy": dataCy,
    children: [jsx(Typography, {
      color: "text.secondary",
      children: label
    }), jsx(Box, {
      component: "div",
      sx: {
        height: 56,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
      },
      children: jsx(Slider, Object.assign({}, sliderProps, {
        value: delayed ? delayedValue : value,
        onChange: delayed ? handleChangeDelayed : handleChange,
        "data-cy": "slider"
      }))
    })]
  });
});

const SLIDERDEFAULTS = {
  topbottom: 50,
  leftright: 50,
  scale: 75
};
const ImageUploadTmp = ({
  variable,
  value,
  selection,
  values,
  onChange
}) => {
  var _selection$data2, _variable$settings$te, _selection$data3, _selection$data4, _selection$data5, _selection$data6;
  const befuelltValue = values.find(value => value.value == "1");
  const app = useTypedSelector(selectConfiguratorApp);
  const befuelltAndActiveImageTargets = useTypedSelector(selectBefuelltImageTargetByValueId(befuelltValue == null ? void 0 : befuelltValue.id));
  const printActions = useTypedSelector(selectActionsByTypeId("prints"));
  const printAreasAffectedByThisVariable = printActions.filter(pA => {
    return befuelltAndActiveImageTargets.some(bAAIT => bAAIT == pA.targetMaterial);
  });
  const handleImageChange = useCallback(newValue => {
    const realValue = values.find(value => value.variableId == variable.id && value.value == (newValue != null && newValue.length ? "1" : "0"));
    onChange(realValue.id, {
      url: newValue,
      leftright: SLIDERDEFAULTS.leftright,
      topbottom: SLIDERDEFAULTS.topbottom,
      scale: SLIDERDEFAULTS.scale
    });
  }, [onChange, values, variable.id]);
  const handleSliderChange = useCallback((valueName, newValue) => {
    var _selection$data;
    if (((_selection$data = selection.data) == null ? void 0 : _selection$data[valueName]) !== newValue) {
      onChange(value.id, Object.assign({}, selection.data, {
        [valueName]: newValue
      }));
    }
  }, [onChange, selection, value]);
  const handleReset = useCallback(() => {
    onChange(value.id, Object.assign({}, selection.data, SLIDERDEFAULTS));
  }, [onChange, selection, value]);
  return (
    // @ts-ignore
    jsxs(Box, {
      component: "div",
      children: [jsx(VariableLabel, {
        fullWidth: true,
        variable: variable
      }), jsx(OCImageUpload, {
        storeLocally: true,
        url: (selection == null ? void 0 : (_selection$data2 = selection.data) == null ? void 0 : _selection$data2.url) || "",
        app: app,
        onDelete: () => handleImageChange(""),
        onUrlChange: handleImageChange,
        acceptedImageFormats: (_variable$settings$te = variable.settings.templateOptions.fileFormat) == null ? void 0 : _variable$settings$te.split(",").map(format => format.toLowerCase()),
        "data-cy": "imageUpload"
      }), printAreasAffectedByThisVariable.length > 0 && (selection == null ? void 0 : (_selection$data3 = selection.data) == null ? void 0 : _selection$data3.url) && jsxs(Box, {
        component: "div",
        sx: {
          mb: "30px"
        },
        "data-cy": "imageUploadSliders",
        children: [jsxs(Box, {
          component: "div",
          sx: {
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          },
          children: [jsx(SwapVert, {
            sx: {
              height: "20px",
              marginRight: "16px",
              transform: "rotate(90deg)"
            }
          }), jsx(OCSlider, {
            sx: {
              width: "100%"
            },
            sliderProps: {
              size: "small",
              valueLabelDisplay: "auto"
            },
            throttle: 33,
            value: (_selection$data4 = selection.data) == null ? void 0 : _selection$data4.leftright,
            "data-cy": "leftRight",
            onChange: value => handleSliderChange("leftright", value)
          })]
        }), jsxs(Box, {
          component: "div",
          sx: {
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          },
          children: [jsx(SwapVert, {
            sx: {
              height: "20px",
              marginRight: "16px"
            }
          }), jsx(OCSlider, {
            sx: {
              width: "100%"
            },
            sliderProps: {
              size: "small",
              valueLabelDisplay: "auto"
            },
            throttle: 33,
            "data-cy": "topBottom",
            value: (_selection$data5 = selection.data) == null ? void 0 : _selection$data5.topbottom,
            onChange: value => handleSliderChange("topbottom", value)
          })]
        }), jsxs(Box, {
          component: "div",
          sx: {
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          },
          children: [jsx(SearchIcon, {
            sx: {
              height: "20px",
              marginRight: "16px"
            }
          }), jsx(OCSlider, {
            throttle: 33,
            sx: {
              width: "100%"
            },
            sliderProps: {
              size: "small",
              valueLabelDisplay: "auto"
            },
            value: (_selection$data6 = selection.data) == null ? void 0 : _selection$data6.scale,
            "data-cy": "scale",
            onChange: value => handleSliderChange("scale", value)
          }), jsx(IconButton, {
            sx: {
              marginLeft: "16px"
            },
            "aria-label": "upload picture",
            component: "span",
            onClick: handleReset,
            "data-cy": "resetScale",
            children: jsx(AspectRatioIcon, {})
          })]
        })]
      })]
    })
  );
};
const ImageUpload = withComponentExtension("imageUpload")(ImageUploadTmp);

const NumberTmp = ({
  variable,
  onChange,
  selection,
  values,
  disabled
}) => {
  const sidebarPosition = useTypedSelector(selectSidebarPosition);
  const {
    onNumberChange,
    onInputBlur,
    isInRange,
    resetNumber,
    pureNumber
  } = useNumberVariableChangeHandler(onChange, selection, variable, values);
  return jsx(NumberWarningTooltip, {
    placement: sidebarPosition === SidebarPositionType.Left ? "left-end" : "right-end",
    variable: variable,
    isInRange: isInRange,
    resetNumber: resetNumber,
    children: jsx(OCNumberInput, Object.assign({
      label: jsx(VariableLabel, {
        variable: variable
      }),
      fullWidth: true,
      disabled: disabled,
      value: pureNumber,
      onChange: onNumberChange,
      onChangeByStep: onInputBlur,
      onBlur: onInputBlur,
      onConfirm: onInputBlur,
      TextFieldProps: {
        error: !isInRange
      }
    }, flow(getTemplateOptions, omit$1(["min", "max"]))(variable), {
      "data-cy": "numberInput"
    }))
  });
};
const Number$1 = flow(WithHideDisableTemplateOptions, withComponentExtension("number"))(NumberTmp);

extend([harmonies]);
const height = 85;
const padding = 16;
const colorButtonDimension = height - padding;
const RALColorItem = ({
  index,
  style,
  data
}) => {
  const color = data.colors[index];
  const language = data.language;
  if (!color) {
    return null;
  }
  const invalidColor = colord(color.hex).harmonies("complementary")[1].toHex();
  return jsx("div", {
    style: style,
    children: jsxs(ListItemButton, {
      disabled: data.disabled || !color.hex,
      onClick: () => data.onClick(color),
      sx: {
        px: 1,
        display: "grid",
        gridTemplateColumns: "max-content 1fr",
        gridGap: theme => theme.spacing(1),
        alignItems: "center",
        boxSizing: "border-box"
      },
      className: data.selectedHex === color.hex ? "MuiChecked" : "",
      children: [jsx(ColorButton, {
        disabled: data.disabled,
        isActive: data.selectedHex === color.hex,
        hexColor: color.hex,
        width: colorButtonDimension,
        height: colorButtonDimension,
        borderRadius: data.borderRadius,
        children: jsx(InvalidSelectionWarning, {
          iconSx: {
            position: "absolute",
            bottom: 5,
            right: 5,
            color: invalidColor
          },
          valueId: color.valueId
        })
      }), jsx(Box, {
        component: "div",
        sx: {
          display: "flex",
          flexDirection: "column"
        },
        children: !color.hex ? jsx(Typography, {
          color: "error",
          children: `Invalid RAL value`
        }) : jsxs(Fragment, {
          children: [jsx(Typography, {
            color: "text.primary",
            children: color != null && color.dontAddPrefix ? color.code : `RAL ${color.code}`
          }), color[language] && jsx(Typography, {
            color: "text.primary",
            children: color[language]
          }), jsxs(Typography, {
            variant: "subtitle2",
            color: "text.secondary",
            children: [color.scope, " "]
          })]
        })
      })]
    })
  });
};
const OCRALColorSelect = ({
  autoFocus: _autoFocus = false,
  disabled: _disabled = false,
  label,
  language: _language = SupportedLocale.DE,
  onChange,
  ralColors,
  value,
  visibleColorCount: _visibleColorCount = 4,
  borderRadius: _borderRadius = 1
}) => {
  const [searchString, setSearchString] = useState("");
  const [focusedHexColor, setFocusedHexColor] = useState();
  const listRef = /*#__PURE__*/React__default.createRef();
  useEffect(() => {
    if (!focusedHexColor) {
      const index = findIndex(color => color.hex === value, ralColors);
      if (index >= 0) {
        const scrollList = listRef.current;
        scrollList.scrollToItem(index, "center");
        setFocusedHexColor(ralColors[index].hex);
      }
    }
  }, [listRef, focusedHexColor, ralColors, value]);
  const filteredColors = useMemo(() => {
    if (!searchString) return ralColors;
    const regex = new RegExp(replace$9(/\s+/g, ".*", searchString), "i");
    const ralRegex = new RegExp(replace$9(/\s+/g, "\\s*", searchString), "i");
    return filter(color => regex.test(color[_language] || "") || ralRegex.test(`RAL${replace$9(/\s+/g, "", color.code)}`), ralColors);
  }, [searchString, ralColors, _language]);
  const handleClick = useCallback(color => {
    setFocusedHexColor(color.hex);
    onChange(color.hex, color[_language] || "");
  }, [onChange, _language]);
  const itemData = useMemo(() => ({
    colors: filteredColors,
    onClick: handleClick,
    selectedHex: focusedHexColor,
    language: _language,
    disabled: _disabled,
    borderRadius: _borderRadius
  }), [filteredColors, handleClick, focusedHexColor, _language, _disabled, _borderRadius]);
  return jsxs(Box, {
    component: "div",
    sx: {
      display: "grid",
      gridTemplateRows: "max-content max-content max-content",
      gridGap: theme => theme.spacing(1)
    },
    children: [jsx(Typography, {
      color: "textSecondary",
      children: label
    }), jsx(OCTextInput, {
      "data-cy": `ralText`,
      disabled: _disabled,
      onChange: setSearchString,
      fullWidth: true,
      debounced: true,
      TextFieldProps: {
        autoFocus: _autoFocus,
        InputProps: {
          endAdornment: jsx(InputAdornment$1, {
            position: "end",
            children: jsx(Search, {})
          })
        }
      }
    }), jsx(FixedSizeList, {
      ref: listRef,
      itemData: itemData,
      height: Math.min(_visibleColorCount, ralColors.length || 1) * height,
      itemCount: filteredColors.length,
      itemSize: height,
      width: "100%",
      children: RALColorItem
    })]
  });
};

// prettier-ignore
// eslint-disable-next-line
// @ts-ignore
const ralColorsComplete=[{"hex":"#CDBA88","code":"1000","scope":"Classic","de":"Grünbeige","en":"Green beige","nl":"Groen-beige","fr":"Beige vert"},{"hex":"#D0B084","code":"1001","scope":"Classic","de":"Beige","en":"Beige","nl":"Beige","fr":"Beige"},{"hex":"#D2AA6D","code":"1002","scope":"Classic","de":"Sandgelb","en":"Sand yellow","nl":"Zandgeel","fr":"Jaune sable"},{"hex":"#F9A900","code":"1003","scope":"Classic","de":"Signalgelb","en":"Signal yellow","nl":"Signaal geel","fr":"Jaune de signalisation"},{"hex":"#E49E00","code":"1004","scope":"Classic","de":"Goldgelb","en":"Golden yellow","nl":"Goudgeel","fr":"Jaune d'or"},{"hex":"#CB8F00","code":"1005","scope":"Classic","de":"Honiggelb","en":"Honey yellow","nl":"Honinggeel","fr":"Jaune miel"},{"hex":"#E19000","code":"1006","scope":"Classic","de":"Maisgelb","en":"Maize yellow","nl":"Maïs geel","fr":"Jaune maïs"},{"hex":"#E88C00","code":"1007","scope":"Classic","de":"Narzissengelb","en":"Daffodil yellow","nl":"Narcisgeel","fr":"Jaune jonquille"},{"hex":"#AF8050","code":"1011","scope":"Classic","de":"Braunbeige","en":"Brown beige","nl":"Bruin-beige","fr":"Beige marron"},{"hex":"#DDAF28","code":"1012","scope":"Classic","de":"Zitronengelb","en":"Lemon yellow","nl":"Citroengeel","fr":"Jaune citron"},{"hex":"#E3D9C7","code":"1013","scope":"Classic","de":"Perlweiß","en":"Oyster white","nl":"Parelwit","fr":"Blanc perle"},{"hex":"#DDC49B","code":"1014","scope":"Classic","de":"Elfenbein","en":"Ivory","nl":"Ivoor","fr":"Ivoire"},{"hex":"#E6D2B5","code":"1015","scope":"Classic","de":"Hellelfenbein","en":"Light ivory","nl":"Licht ivoor","fr":"Ivoire clair"},{"hex":"#F1DD39","code":"1016","scope":"Classic","de":"Schwefelgelb","en":"Sulfur yellow","nl":"Zwavelgeel","fr":"Jaune soufre"},{"hex":"#F6A951","code":"1017","scope":"Classic","de":"Safrangelb","en":"Saffron yellow","nl":"Saffraangeel","fr":"Jaune safran"},{"hex":"#FACA31","code":"1018","scope":"Classic","de":"Zinkgelb","en":"Zinc yellow","nl":"Zinkgeel","fr":"Jaune de zinc"},{"hex":"#A48F7A","code":"1019","scope":"Classic","de":"Graubeige","en":"Grey beige","nl":"Grijs-beige","fr":"Beige gris"},{"hex":"#A08F65","code":"1020","scope":"Classic","de":"Olivgelb","en":"Olive yellow","nl":"Olijfgeel","fr":"Jaune olive"},{"hex":"#F6B600","code":"1021","scope":"Classic","de":"Rapsgelb","en":"Colza yellow","nl":"Koolzaad geel","fr":"Jaune colza"},{"hex":"#F7B500","code":"1023","scope":"Classic","de":"Verkehrsgelb","en":"Traffic yellow","nl":"Verkeer geel","fr":"Jaune trafic"},{"hex":"#BA8F4C","code":"1024","scope":"Classic","de":"Ockergelb","en":"Ochre yellow","nl":"Okergeel","fr":"Jaune ocre"},{"hex":"#FFFF00","code":"1026","scope":"Classic","de":"Leuchtgelb","en":"Luminous yellow","nl":"Fluorescerend geel","fr":"Jaune vif"},{"hex":"#A77F0F","code":"1027","scope":"Classic","de":"Currygelb","en":"Curry","nl":"Kerrie geel","fr":"Jaune curry"},{"hex":"#FF9C00","code":"1028","scope":"Classic","de":"Melonengelb","en":"Melon yellow","nl":"Meloengeel","fr":"Jaune melon"},{"hex":"#E2A300","code":"1032","scope":"Classic","de":"Ginstergelb","en":"Broom yellow","nl":"Bezem geel","fr":"Jaune genêt"},{"hex":"#F99A1D","code":"1033","scope":"Classic","de":"Dahliengelb","en":"Dahlia yellow","nl":"Dahlia geel","fr":"Jaune dahlia"},{"hex":"#EB9C52","code":"1034","scope":"Classic","de":"Pastellgelb","en":"Pastel yellow","nl":"Pastelgeel","fr":"Jaune pastel"},{"hex":"#8F8370","code":"1035","scope":"Classic","de":"Perlbeige","en":"Pearl beige","nl":"Parel beige","fr":"Beige perle"},{"hex":"#806440","code":"1036","scope":"Classic","de":"Perlgold","en":"Pearl gold","nl":"Parel goud","fr":"Or perlé"},{"hex":"#F09200","code":"1037","scope":"Classic","de":"Sonnengelb","en":"Sun yellow","nl":"Zonnegeel","fr":"Jaune soleil"},{"hex":"#DA6E00","code":"2000","scope":"Classic","de":"Gelborange","en":"Yellow orange","nl":"Geeloranje","fr":"Jaune-orange"},{"hex":"#BA481C","code":"2001","scope":"Classic","de":"Rotorange","en":"Red orange","nl":"Rood oranje","fr":"Orange rouge"},{"hex":"#BF3922","code":"2002","scope":"Classic","de":"Blutorange","en":"Vermilion","nl":"Bloedsinaasappel","fr":"Orange sanguine"},{"hex":"#F67829","code":"2003","scope":"Classic","de":"Pastellorange","en":"Pastel orange","nl":"Pastel oranje","fr":"Orange pastel"},{"hex":"#E25304","code":"2004","scope":"Classic","de":"Reinorange","en":"Pure orange","nl":"Puur oranje","fr":"Orange pure"},{"hex":"#FF4D08","code":"2005","scope":"Classic","de":"Leuchtorange","en":"Luminous orange","nl":"Fluorescerend oranje","fr":"Orange vif"},{"hex":"#FFB200","code":"2007","scope":"Classic","de":"Leuchthellorange","en":"Luminous bright orange","nl":"Fluorescerend licht oranje","fr":"Orange clair lumineux"},{"hex":"#EC6B22","code":"2008","scope":"Classic","de":"Hellrotorange","en":"Bright red orange","nl":"Licht rood-oranje","fr":"Orange clair"},{"hex":"#DE5308","code":"2009","scope":"Classic","de":"Verkehrsorange","en":"Traffic orange","nl":"Verkeer oranje","fr":"Orange trafic"},{"hex":"#D05D29","code":"2010","scope":"Classic","de":"Signalorange","en":"Signal orange","nl":"Signaal oranje","fr":"Orange de signalisation"},{"hex":"#E26E0F","code":"2011","scope":"Classic","de":"Tieforange","en":"Deep orange","nl":"Diep oranje","fr":"Orange profond"},{"hex":"#D5654E","code":"2012","scope":"Classic","de":"Lachsorange","en":"Salmon orange","nl":"Zalm oranje","fr":"Orange saumon"},{"hex":"#923E25","code":"2013","scope":"Classic","de":"Perlorange","en":"Pearl orange","nl":"Parel oranje","fr":"Orange perle"},{"hex":"#FC5500","code":"2017","scope":"Classic","de":"RAL Orange","en":"RAL orange","nl":"RAL Oranje","fr":"RAL orange"},{"hex":"#A72920","code":"3000","scope":"Classic","de":"Feuerrot","en":"Flame red","nl":"Vuurrood","fr":"Rouge feu"},{"hex":"#9B2423","code":"3001","scope":"Classic","de":"Signalrot","en":"Signal red","nl":"Signaal rood","fr":"Rouge de signalisation"},{"hex":"#9B2321","code":"3002","scope":"Classic","de":"Karminrot","en":"Carmine red","nl":"Karmijnrood","fr":"Rouge carmin"},{"hex":"#861A22","code":"3003","scope":"Classic","de":"Rubinrot","en":"Ruby red","nl":"Robijnrood","fr":"Rouge rubis"},{"hex":"#6B1C23","code":"3004","scope":"Classic","de":"Purpurrot","en":"Purple red","nl":"Paars rood","fr":"Rouge pourpre"},{"hex":"#59191F","code":"3005","scope":"Classic","de":"Weinrot","en":"Wine red","nl":"Wijn rood","fr":"Rouge vin"},{"hex":"#3E2022","code":"3007","scope":"Classic","de":"Schwarzrot","en":"Black red","nl":"Zwart rood","fr":"Rouge noir"},{"hex":"#6D342D","code":"3009","scope":"Classic","de":"Oxidrot","en":"Oxide red","nl":"Oxydrood","fr":"Rouge oxyde"},{"hex":"#782423","code":"3011","scope":"Classic","de":"Braunrot","en":"Brown red","nl":"Bruin rood","fr":"Marron rouge"},{"hex":"#C5856D","code":"3012","scope":"Classic","de":"Beigerot","en":"Beige red","nl":"Beige rood","fr":"Beigerot"},{"hex":"#972E25","code":"3013","scope":"Classic","de":"Tomatenrot","en":"Tomato red","nl":"Tomaat rood","fr":"Rouge tomate"},{"hex":"#CB7375","code":"3014","scope":"Classic","de":"Altrosa","en":"Antique pink","nl":"Donkerroze","fr":"Vieux rose"},{"hex":"#D8A0A6","code":"3015","scope":"Classic","de":"Hellrosa","en":"Light pink","nl":"Lichtroze","fr":"Rose clair"},{"hex":"#A63D30","code":"3016","scope":"Classic","de":"Korallenrot","en":"Coral red","nl":"Koraalrood","fr":"Rouge corail"},{"hex":"#CA555D","code":"3017","scope":"Classic","de":"Rosé","en":"Rose","nl":"Rosé","fr":"Rosé"},{"hex":"#C63F4A","code":"3018","scope":"Classic","de":"Erdbeerrot","en":"Strawberry red","nl":"Aardbeirood","fr":"Rouge fraise"},{"hex":"#BB1F11","code":"3020","scope":"Classic","de":"Verkehrsrot","en":"Traffic red","nl":"Verkeer rood","fr":"Rouge trafic"},{"hex":"#CF6955","code":"3022","scope":"Classic","de":"Lachsrot","en":"Salmon pink","nl":"Zalmrood","fr":"Rouge saumon"},{"hex":"#FF2D21","code":"3024","scope":"Classic","de":"Leuchtrot","en":"Luminous red","nl":"Fluorescerend rood","fr":"Rouge vif"},{"hex":"#FF2A1C","code":"3026","scope":"Classic","de":"Leuchthellrot","en":"Luminous bright red","nl":"Helder rood","fr":"Rouge clair lumineux"},{"hex":"#AB273C","code":"3027","scope":"Classic","de":"Himbeerrot","en":"Raspberry red","nl":"Framboos rood","fr":"Rouge framboise"},{"hex":"#CC2C24","code":"3028","scope":"Classic","de":"Reinrot","en":"Pure red","nl":"Puur rood","fr":"Rouge pur"},{"hex":"#A63437","code":"3031","scope":"Classic","de":"Orientrot","en":"Orient red","nl":"Oriënt rood","fr":"Rouge d'Orient"},{"hex":"#701D24","code":"3032","scope":"Classic","de":"Perlrubinrot","en":"Pearl ruby red","nl":"Parel robijnrood","fr":"Rouge rubis perle"},{"hex":"#A53A2E","code":"3033","scope":"Classic","de":"Perlrosa","en":"Pearl pink","nl":"Parelmoer roze","fr":"Rose perle"},{"hex":"#816183","code":"4001","scope":"Classic","de":"Rotlila","en":"Red lilac","nl":"Roodpaars","fr":"Violet rouge"},{"hex":"#8D3C4B","code":"4002","scope":"Classic","de":"Rotviolett","en":"Red violet","nl":"Roodviolet","fr":"Rouge-violet"},{"hex":"#C4618C","code":"4003","scope":"Classic","de":"Erikaviolett","en":"Heather violet","nl":"Erika violet","fr":"Violet d'Erika"},{"hex":"#651E38","code":"4004","scope":"Classic","de":"Bordeauxviolett","en":"Claret violet","nl":"Bordeaux viooltje","fr":"Violet bordeaux"},{"hex":"#76689A","code":"4005","scope":"Classic","de":"Blaulila","en":"Blue lilac","nl":"Blauwpaars","fr":"Blaulila"},{"hex":"#903373","code":"4006","scope":"Classic","de":"Verkehrspurpur","en":"Traffic purple","nl":"Rijbaan","fr":"Voie de circulation"},{"hex":"#47243C","code":"4007","scope":"Classic","de":"Purpurviolett","en":"Purple violet","nl":"Paars viooltje","fr":"Violet pourpre"},{"hex":"#844C82","code":"4008","scope":"Classic","de":"Signalviolett","en":"Signal violet","nl":"Signaal violet","fr":"Violet de signalisation"},{"hex":"#9D8692","code":"4009","scope":"Classic","de":"Pastellviolett","en":"Pastel violet","nl":"Pastelviolet","fr":"Violet pastel"},{"hex":"#BB4077","code":"4010","scope":"Classic","de":"Telemagenta","en":"Telemagenta","nl":"Telemagenta","fr":"Telemagenta"},{"hex":"#6E6387","code":"4011","scope":"Classic","de":"Perlviolett","en":"Pearl violet","nl":"Parelviolet","fr":"Violet perlé"},{"hex":"#6A6B7F","code":"4012","scope":"Classic","de":"Perlbrombeer","en":"Pearl blackberry","nl":"Parel braam","fr":"Mûre perlée"},{"hex":"#304F6E","code":"5000","scope":"Classic","de":"Violettblau","en":"Violet blue","nl":"Violetblauw","fr":"Bleu violet"},{"hex":"#0E4C64","code":"5001","scope":"Classic","de":"Grünblau","en":"Green blue","nl":"Groenblauw","fr":"Bleu vert"},{"hex":"#00387A","code":"5002","scope":"Classic","de":"Ultramarinblau","en":"Ultramarine blue","nl":"Ultramarijnblauw","fr":"Bleu outremer"},{"hex":"#1F3855","code":"5003","scope":"Classic","de":"Saphirblau","en":"Sapphire blue","nl":"Saffierblauw","fr":"Bleu saphir"},{"hex":"#191E28","code":"5004","scope":"Classic","de":"Schwarzblau","en":"Black blue","nl":"Zwartblauw","fr":"Bleu noir"},{"hex":"#005387","code":"5005","scope":"Classic","de":"Signalblau","en":"Signal blue","nl":"Signaal blauw","fr":"Bleu signal"},{"hex":"#376B8C","code":"5007","scope":"Classic","de":"Brillantblau","en":"Brillant blue","nl":"Schitterend blauw","fr":"Bleu brillant"},{"hex":"#2B3A44","code":"5008","scope":"Classic","de":"Graublau","en":"Grey blue","nl":"Grijsblauw","fr":"Bleu gris"},{"hex":"#215F78","code":"5009","scope":"Classic","de":"Azurblau","en":"Azure blue","nl":"Azuurblauw","fr":"Bleu azur"},{"hex":"#004F7C","code":"5010","scope":"Classic","de":"Enzianblau","en":"Gentian blue","nl":"Gentiaanblauw","fr":"Bleu gentiane"},{"hex":"#1A2B3C","code":"5011","scope":"Classic","de":"Stahlblau","en":"Steel blue","nl":"Staalblauw","fr":"Bleu acier"},{"hex":"#0089B6","code":"5012","scope":"Classic","de":"Lichtblau","en":"Light blue","nl":"Lichtblauw","fr":"Bleu clair"},{"hex":"#193153","code":"5013","scope":"Classic","de":"Kobaltblau","en":"Cobalt blue","nl":"Kobaltblauw","fr":"Bleu cobalt"},{"hex":"#637D96","code":"5014","scope":"Classic","de":"Taubenblau","en":"Pigeon blue","nl":"Duif blauw","fr":"Bleu pigeon"},{"hex":"#007CAF","code":"5015","scope":"Classic","de":"Himmelblau","en":"Sky blue","nl":"Hemelsblauw","fr":"Bleu ciel"},{"hex":"#005B8C","code":"5017","scope":"Classic","de":"Verkehrsblau","en":"Traffic blue","nl":"Verkeersblauw","fr":"Bleu trafic"},{"hex":"#048B8C","code":"5018","scope":"Classic","de":"Türkisblau","en":"Turquoise blue","nl":"Turquoise blauw","fr":"Bleu turquoise"},{"hex":"#005E83","code":"5019","scope":"Classic","de":"Capriblau","en":"Capri blue","nl":"Capri blauw","fr":"Bleu capri"},{"hex":"#00414B","code":"5020","scope":"Classic","de":"Ozeanblau","en":"Ocean blue","nl":"Oceaanblauw","fr":"Bleu océan"},{"hex":"#007577","code":"5021","scope":"Classic","de":"Wasserblau","en":"Water blue","nl":"Waterblauw","fr":"Bleu d'eau"},{"hex":"#222D5A","code":"5022","scope":"Classic","de":"Nachtblau","en":"Night blue","nl":"Nachtblauw","fr":"Bleu nuit"},{"hex":"#41698C","code":"5023","scope":"Classic","de":"Fernblau","en":"Distant blue","nl":"Ver blauw","fr":"Bleu lointain"},{"hex":"#6093AC","code":"5024","scope":"Classic","de":"Pastellblau","en":"Pastel blue","nl":"Pastelblauw","fr":"Bleu pastel"},{"hex":"#20697C","code":"5025","scope":"Classic","de":"Perlenzian","en":"Pearl gentian blue","nl":"Parelgentiaan","fr":"Gentiane perlée"},{"hex":"#0F3052","code":"5026","scope":"Classic","de":"Perlnachtblau","en":"Pearl night blue","nl":"Parel nachtblauw","fr":"Bleu nuit perle"},{"hex":"#3C7460","code":"6000","scope":"Classic","de":"Patinagrün","en":"Patina green","nl":"Patinagroen","fr":"Vert patine"},{"hex":"#366735","code":"6001","scope":"Classic","de":"Smaragdgrün","en":"Emerald green","nl":"Smaragdgroen","fr":"Vert émeraude"},{"hex":"#325928","code":"6002","scope":"Classic","de":"Laubgrün","en":"Leaf green","nl":"Bladgroen","fr":"Vert feuillage"},{"hex":"#50533C","code":"6003","scope":"Classic","de":"Olivgrün","en":"Olive green","nl":"Olijfgroen","fr":"Vert olive"},{"hex":"#024442","code":"6004","scope":"Classic","de":"Blaugrün","en":"Blue green","nl":"Blauwgroen","fr":"Bleu-vert"},{"hex":"#114232","code":"6005","scope":"Classic","de":"Moosgrün","en":"Moss green","nl":"Mosgroen","fr":"Vert mousse"},{"hex":"#3C392E","code":"6006","scope":"Classic","de":"Grauoliv","en":"Grey olive","nl":"Grijze olijf","fr":"Gris olive"},{"hex":"#2C3222","code":"6007","scope":"Classic","de":"Flaschengrün","en":"Bottle green","nl":"Fles groen","fr":"Vert bouteille"},{"hex":"#36342A","code":"6008","scope":"Classic","de":"Braungrün","en":"Brown green","nl":"Bruin-groen","fr":"Vert marron"},{"hex":"#27352A","code":"6009","scope":"Classic","de":"Tannengrün","en":"Fir green","nl":"Dennengroen","fr":"Vert sapin"},{"hex":"#4D6F39","code":"6010","scope":"Classic","de":"Grasgrün","en":"Grass green","nl":"Grasgroen","fr":"Vert herbe"},{"hex":"#6B7C59","code":"6011","scope":"Classic","de":"Resedagrün","en":"Reseda green","nl":"Reseda groen","fr":"Vert réséda"},{"hex":"#2F3D3A","code":"6012","scope":"Classic","de":"Schwarzgrün","en":"Black green","nl":"Zwartgroen","fr":"Vert noir"},{"hex":"#7C765A","code":"6013","scope":"Classic","de":"Schilfgrün","en":"Reed green","nl":"Rietgroen","fr":"Le vert des roseaux"},{"hex":"#474135","code":"6014","scope":"Classic","de":"Gelboliv","en":"Yellow olive","nl":"Gele olijf","fr":"Jaune bolivien"},{"hex":"#3D3D36","code":"6015","scope":"Classic","de":"Schwarzoliv","en":"Black olive","nl":"Zwarte olijf","fr":"olive noir"},{"hex":"#00694C","code":"6016","scope":"Classic","de":"Türkisgrün","en":"Turquoise green","nl":"Turquoise groen","fr":"Vert turquoise"},{"hex":"#587F40","code":"6017","scope":"Classic","de":"Maigrün","en":"May green","nl":"Mei groen","fr":"Vert mai"},{"hex":"#60993B","code":"6018","scope":"Classic","de":"Gelbgrün","en":"Yellow green","nl":"Geelgroen","fr":"Vert jaune"},{"hex":"#B9CEAC","code":"6019","scope":"Classic","de":"Weißgrün","en":"Pastel green","nl":"Witgroen","fr":"Vert blanc"},{"hex":"#37422F","code":"6020","scope":"Classic","de":"Chromoxidgrün","en":"Chrome green","nl":"Chroomoxidegroen","fr":"Vert oxyde de chrome"},{"hex":"#8A9977","code":"6021","scope":"Classic","de":"Blaßgrün","en":"Pale green","nl":"Lichtgroen","fr":"Vert pâle"},{"hex":"#3A3327","code":"6022","scope":"Classic","de":"Braunoliv","en":"Olive drab","nl":"Bruine olijf","fr":"Marron olive"},{"hex":"#008351","code":"6024","scope":"Classic","de":"Verkehrsgrün","en":"Traffic green","nl":"Verkeer groen","fr":"Espaces verts de circulation"},{"hex":"#5E6E3B","code":"6025","scope":"Classic","de":"Farngrün","en":"Fern green","nl":"Varen groen","fr":"Vert fougère"},{"hex":"#005F4E","code":"6026","scope":"Classic","de":"Opalgrün","en":"Opal green","nl":"Opaalgroen","fr":"Vert opale"},{"hex":"#7EBAB5","code":"6027","scope":"Classic","de":"Lichtgrün","en":"Light green","nl":"Lichtgroen","fr":"Vert clair"},{"hex":"#315442","code":"6028","scope":"Classic","de":"Kieferngrün","en":"Pine green","nl":"Dennengroen","fr":"Vert pin"},{"hex":"#006F3D","code":"6029","scope":"Classic","de":"Minzgrün","en":"Mint green","nl":"Mintgroen","fr":"Vert menthe"},{"hex":"#237F52","code":"6032","scope":"Classic","de":"Signalgrün","en":"Signal green","nl":"Signaal groen","fr":"Vert signal"},{"hex":"#45877F","code":"6033","scope":"Classic","de":"Minttürkis","en":"Mint turquoise","nl":"Mint turkoois","fr":"Turquoise menthe"},{"hex":"#7AADAC","code":"6034","scope":"Classic","de":"Pastelltürkis","en":"Pastel turquoise","nl":"Pastelturquoise","fr":"Turquoise pastel"},{"hex":"#194D25","code":"6035","scope":"Classic","de":"Perlgrün","en":"Pearl green","nl":"Parelgroen","fr":"Vert perle"},{"hex":"#04574B","code":"6036","scope":"Classic","de":"Perlopalgrün","en":"Pearl opal green","nl":"Parel opaalgroen","fr":"Vert perlopal"},{"hex":"#008B29","code":"6037","scope":"Classic","de":"Reingrün","en":"Pure green","nl":"Puur groen","fr":"Vert pur"},{"hex":"#00B51B","code":"6038","scope":"Classic","de":"Leuchtgrün","en":"Luminous green ","nl":"Fluorescerend groen","fr":"Vert fluo"},{"hex":"#B3C43E","code":"6039","scope":"Classic","de":"Fasergrün","en":"Fibrous green","nl":"Vezel groen","fr":"Fibre verte"},{"hex":"#7A888E","code":"7000","scope":"Classic","de":"Fehgrau","en":"Squirrel grey","nl":"Feh grijs","fr":"Fehgrau"},{"hex":"#8C979C","code":"7001","scope":"Classic","de":"Silbergrau","en":"Silver grey","nl":"Zilvergrijs","fr":"Gris argenté"},{"hex":"#817863","code":"7002","scope":"Classic","de":"Olivgrau","en":"Olive grey","nl":"Olijfgrijs","fr":"Gris olive"},{"hex":"#797669","code":"7003","scope":"Classic","de":"Moosgrau","en":"Moss grey","nl":"Mosgrijs","fr":"Gris mousse"},{"hex":"#9A9B9B","code":"7004","scope":"Classic","de":"Signalgrau","en":"Signal grey","nl":"Signaal grijs","fr":"Gris signal"},{"hex":"#6B6E6B","code":"7005","scope":"Classic","de":"Mausgrau","en":"Mouse grey","nl":"Muis grijs","fr":"Gris souris"},{"hex":"#766A5E","code":"7006","scope":"Classic","de":"Beigegrau","en":"Beige grey","nl":"Beige grijs","fr":"Gris beige"},{"hex":"#745F3D","code":"7008","scope":"Classic","de":"Khakigrau","en":"Khaki grey","nl":"Kaki grijs","fr":"Gris kaki"},{"hex":"#5D6058","code":"7009","scope":"Classic","de":"Grüngrau","en":"Green grey","nl":"Groen-grijs","fr":"Gris vert"},{"hex":"#585C56","code":"7010","scope":"Classic","de":"Zeltgrau","en":"Tarpaulin grey","nl":"Tent grijs","fr":"Gris tente"},{"hex":"#52595D","code":"7011","scope":"Classic","de":"Eisengrau","en":"Iron grey","nl":"IJzergrijs","fr":"Gris fer"},{"hex":"#575D5E","code":"7012","scope":"Classic","de":"Basaltgrau","en":"Basalt grey","nl":"Basalt grijs","fr":"Gris basalte"},{"hex":"#575044","code":"7013","scope":"Classic","de":"Braungrau","en":"Brown grey","nl":"Bruin-grijs","fr":"Gris marron"},{"hex":"#4F5358","code":"7015","scope":"Classic","de":"Schiefergrau","en":"Slate grey","nl":"Leigrijs","fr":"Gris ardoise"},{"hex":"#383E42","code":"7016","scope":"Classic","de":"Anthrazitgrau","en":"Anthracite grey","nl":"Antraciet grijs","fr":"Gris anthracite"},{"hex":"#2F3234","code":"7021","scope":"Classic","de":"Schwarzgrau","en":"Black grey","nl":"Zwart grijs","fr":"Gris noir"},{"hex":"#4C4A44","code":"7022","scope":"Classic","de":"Umbragrau","en":"Umbra grey","nl":"Umbra grijs","fr":"Gris terre d'ombre"},{"hex":"#808076","code":"7023","scope":"Classic","de":"Betongrau","en":"Concrete grey","nl":"Beton grijs","fr":"Gris béton"},{"hex":"#45494E","code":"7024","scope":"Classic","de":"Graphitgrau","en":"Graphite grey","nl":"Grafietgrijs","fr":"Gris graphite"},{"hex":"#374345","code":"7026","scope":"Classic","de":"Granitgrau","en":"Granite grey","nl":"Granietgrijs","fr":"Gris granit"},{"hex":"#928E85","code":"7030","scope":"Classic","de":"Steingrau","en":"Stone grey","nl":"Steengrijs","fr":"Gris pierre"},{"hex":"#5B686D","code":"7031","scope":"Classic","de":"Blaugrau","en":"Blue grey","nl":"Blauwgrijs","fr":"Bleu-gris"},{"hex":"#B5B0A1","code":"7032","scope":"Classic","de":"Kieselgrau","en":"Pebble grey","nl":"Kiezelgrijs","fr":"Gris silex"},{"hex":"#7F8274","code":"7033","scope":"Classic","de":"Zementgrau","en":"Cement grey","nl":"Cementgrijs","fr":"Gris ciment"},{"hex":"#92886F","code":"7034","scope":"Classic","de":"Gelbgrau","en":"Yellow grey","nl":"Geelgrijs","fr":"Gris jaune"},{"hex":"#C5C7C4","code":"7035","scope":"Classic","de":"Lichtgrau","en":"Light grey","nl":"Lichtgrijs","fr":"Gris clair"},{"hex":"#979392","code":"7036","scope":"Classic","de":"Platingrau","en":"Platinum grey","nl":"Platina grijs","fr":"Gris platine"},{"hex":"#7A7B7A","code":"7037","scope":"Classic","de":"Staubgrau","en":"Dusty grey","nl":"Stof grijs","fr":"Gris poussière"},{"hex":"#B0B0A9","code":"7038","scope":"Classic","de":"Achatgrau","en":"Agate grey","nl":"Agaat grijs","fr":"Gris agate"},{"hex":"#6B665E","code":"7039","scope":"Classic","de":"Quarzgrau","en":"Quartz grey","nl":"Kwartsgrijs","fr":"Gris quartz"},{"hex":"#989EA1","code":"7040","scope":"Classic","de":"Fenstergrau","en":"Window grey","nl":"Raam grijs","fr":"Gris fenêtre"},{"hex":"#8E9291","code":"7042","scope":"Classic","de":"Verkehrsgrau A","en":"Traffic grey A","nl":"Verkeer grijs A","fr":"Gris trafic A"},{"hex":"#4F5250","code":"7043","scope":"Classic","de":"Verkehrsgrau B","en":"Traffic grey B","nl":"Verkeer grijs B","fr":"Gris trafic B"},{"hex":"#B7B3A8","code":"7044","scope":"Classic","de":"Seidengrau","en":"Silk grey","nl":"Zijde grijs","fr":"Gris soie"},{"hex":"#8D9295","code":"7045","scope":"Classic","de":"Telegrau 1","en":"Telegrey 1","nl":"Telegrafeer 1","fr":"Telegrau 1"},{"hex":"#7E868A","code":"7046","scope":"Classic","de":"Telegrau 2","en":"Telegrey 2","nl":"Telegrey 2","fr":"Telegrau 2"},{"hex":"#C8C8C7","code":"7047","scope":"Classic","de":"Telegrau 4","en":"Telegrey 4","nl":"Telegrey 4","fr":"Telegrau 4"},{"hex":"#817B73","code":"7048","scope":"Classic","de":"Perlmausgrau","en":"Pearl mouse grey","nl":"Parel muisgrijs","fr":"Gris perle"},{"hex":"#89693F","code":"8000","scope":"Classic","de":"Grünbraun","en":"Green brown","nl":"Groen-bruin","fr":"Marron vert"},{"hex":"#9D622B","code":"8001","scope":"Classic","de":"Ockerbraun","en":"Ochre brown","nl":"Okerbruin","fr":"Marron ocre"},{"hex":"#794D3E","code":"8002","scope":"Classic","de":"Signalbraun","en":"Signal brown","nl":"Signaal bruin","fr":"Marron de signalisation"},{"hex":"#7E4B27","code":"8003","scope":"Classic","de":"Lehmbraun","en":"Clay brown","nl":"Klei bruin","fr":"Marron argile"},{"hex":"#8D4931","code":"8004","scope":"Classic","de":"Kupferbraun","en":"Copper brown","nl":"Koperbruin","fr":"Marron cuivré"},{"hex":"#70462B","code":"8007","scope":"Classic","de":"Rehbraun","en":"Fawn brown","nl":"Fawn","fr":"Marron chevreuil"},{"hex":"#724A25","code":"8008","scope":"Classic","de":"Olivbraun","en":"Olive brown","nl":"Olijfbruin","fr":"Marron olive"},{"hex":"#5A3827","code":"8011","scope":"Classic","de":"Nußbraun","en":"Nut brown","nl":"Notenbruin","fr":"Marron noisette"},{"hex":"#66332B","code":"8012","scope":"Classic","de":"Rotbraun","en":"Red brown","nl":"Roodbruin","fr":"Marron rouge"},{"hex":"#4A3526","code":"8014","scope":"Classic","de":"Sepiabraun","en":"Sepia brown","nl":"Sepia bruin","fr":"Brun sépia"},{"hex":"#5E2F26","code":"8015","scope":"Classic","de":"Kastanienbraun","en":"Chestnut brown","nl":"Kastanjebruin","fr":"Châtaigne"},{"hex":"#4C2B20","code":"8016","scope":"Classic","de":"Mahagonibraun","en":"Mahogany brown","nl":"Mahoniebruin","fr":"Brun acajou"},{"hex":"#442F29","code":"8017","scope":"Classic","de":"Schokoladenbraun","en":"Chocolate brown","nl":"Chocoladebruin","fr":"Marron chocolat"},{"hex":"#3D3635","code":"8019","scope":"Classic","de":"Graubraun","en":"Grey brown","nl":"Grijsbruin","fr":"Marron gris"},{"hex":"#1A1719","code":"8022","scope":"Classic","de":"Schwarzbraun","en":"Black brown","nl":"Zwartbruin","fr":"Marron noir"},{"hex":"#A45729","code":"8023","scope":"Classic","de":"Orangebraun","en":"Orange brown","nl":"Oranjebruin","fr":"Marron orange"},{"hex":"#795038","code":"8024","scope":"Classic","de":"Beigebraun","en":"Beige brown","nl":"Beige bruin","fr":"Beige-brun"},{"hex":"#755847","code":"8025","scope":"Classic","de":"Blaßbraun","en":"Pale brown","nl":"Lichtbruin","fr":"Marron pâle"},{"hex":"#513A2A","code":"8028","scope":"Classic","de":"Terrabraun","en":"Terra brown","nl":"Terra bruin","fr":"Brun terra"},{"hex":"#7F4031","code":"8029","scope":"Classic","de":"Perlkupfer","en":"Pearl copper","nl":"Parel koper","fr":"Cuivre nacré"},{"hex":"#E9E0D2","code":"9001","scope":"Classic","de":"Cremeweiß","en":"Cream","nl":"Crème wit","fr":"Blanc crème"},{"hex":"#D6D5CB","code":"9002","scope":"Classic","de":"Grauweiß","en":"Grey white","nl":"Grijs wit","fr":"Blanc gris"},{"hex":"#ECECE7","code":"9003","scope":"Classic","de":"Signalweiß","en":"Signal white","nl":"Signaal wit","fr":"Blanc de signalisation"},{"hex":"#2B2B2C","code":"9004","scope":"Classic","de":"Signalschwarz","en":"Signal black","nl":"Signaal zwart","fr":"Noir de signalisation"},{"hex":"#0E0E10","code":"9005","scope":"Classic","de":"Tiefschwarz","en":"Jet black","nl":"Diepzwart","fr":"Noir profond"},{"hex":"#A1A1A0","code":"9006","scope":"Classic","de":"Weißaluminium","en":"White aluminium","nl":"Wit aluminium","fr":"Aluminium blanc"},{"hex":"#868581","code":"9007","scope":"Classic","de":"Graualuminium","en":"Grey aluminium","nl":"Grijs aluminium","fr":"Aluminium gris"},{"hex":"#F1EDE1","code":"9010","scope":"Classic","de":"Reinweiß","en":"Pure white","nl":"Puur wit","fr":"Blanc pur"},{"hex":"#27292B","code":"9011","scope":"Classic","de":"Graphitschwarz","en":"Graphite black","nl":"Grafiet zwart","fr":"Noir graphite"},{"hex":"#F8F2E1","code":"9012","scope":"Classic","de":"Reinraumweiß","en":"Cleanroom White","nl":"Cleanroom wit","fr":"Blanc salle blanche"},{"hex":"#F1F1EA","code":"9016","scope":"Classic","de":"Verkehrsweiß","en":"Traffic white","nl":"Verkeerswit","fr":"Blanc trafic"},{"hex":"#29292A","code":"9017","scope":"Classic","de":"Verkehrsschwarz","en":"Traffic black","nl":"Verkeer zwart","fr":"Noir trafic"},{"hex":"#C8CBC4","code":"9018","scope":"Classic","de":"Papyrusweiß","en":"Papyrus white","nl":"Papyrus wit","fr":"Blanc papyrus"},{"hex":"#858583","code":"9022","scope":"Classic","de":"Perlhellgrau","en":"Pearl light grey","nl":"Parel lichtgrijs","fr":"Gris clair perle"},{"hex":"#787B7A","code":"9023","scope":"Classic","de":"Perldunkelgrau","en":"Pearl dark grey","nl":"Parel donkergrijs","fr":"Gris perle foncé"},{"hex":"#414141","code":"000 15 00","scope":"Design System Plus","de":"Tintenschwarz","en":"Ink black","nl":"Inkt zwart","fr":"Noir d'encre"},{"hex":"#474646","code":"000 20 00","scope":"Design System Plus","de":"Schieferschwarz","en":"Slate black","nl":"Leisteen zwart","fr":"Noir ardoise"},{"hex":"#504f4f","code":"000 25 00","scope":"Design System Plus","de":"Onyxschwarz","en":"Onyx black","nl":"Onyx zwart","fr":"Noir onyx"},{"hex":"#565656","code":"000 30 00","scope":"Design System Plus","de":"Mittelschwarz","en":"Medium black","nl":"Medium zwart","fr":"Noir moyen"},{"hex":"#5f5f5f","code":"000 35 00","scope":"Design System Plus","de":"Brikettgrau","en":"Briquette grey","nl":"Briket grijs","fr":"Gris briquette"},{"hex":"#696968","code":"000 40 00","scope":"Design System Plus","de":"Dunkelgrau","en":"Dark grey","nl":"Donkergrijs","fr":"Gris foncé"},{"hex":"#757473","code":"000 45 00","scope":"Design System Plus","de":"Architekturgrau","en":"Architecture grey","nl":"Architectonisch grijs","fr":"Gris architecture"},{"hex":"#7e7f7e","code":"000 50 00","scope":"Design System Plus","de":"Stahlgrau","en":"Steel grey","nl":"Staalgrijs","fr":"Gris acier"},{"hex":"#898989","code":"000 55 00","scope":"Design System Plus","de":"Mittelgrau","en":"Medium grey","nl":"Medium grijs","fr":"Gris moyen"},{"hex":"#959595","code":"000 60 00","scope":"Design System Plus","de":"Aschgrau","en":"Ash grey","nl":"Asgrijs","fr":"Gris cendré"},{"hex":"#a3a3a3","code":"000 65 00","scope":"Design System Plus","de":"Mörtelgrau","en":"Mortar grey","nl":"Mortel grijs","fr":"Gris mortier"},{"hex":"#b0b0b0","code":"000 70 00","scope":"Design System Plus","de":"Leichtgrau","en":"Light grey","nl":"Lichtgrijs","fr":"Gris léger"},{"hex":"#bdbdbd","code":"000 75 00","scope":"Design System Plus","de":"Marmorgrau","en":"Marble grey","nl":"Marmer grijs","fr":"Gris marbre"},{"hex":"#cacac9","code":"000 80 00","scope":"Design System Plus","de":"Nebelgrau","en":"Foggy grey","nl":"Mist grijs","fr":"Gris brume"},{"hex":"#d7d7d5","code":"000 85 00","scope":"Design System Plus","de":"Schattenweiß","en":"Shadow white","nl":"Schaduw wit","fr":"Blanc d'ombre"},{"hex":"#e2e3e1","code":"000 90 00","scope":"Design System Plus","de":"Winterweiß","en":"Winter white","nl":"Winterwit","fr":"Blanc d'hiver"},{"hex":"#524446","code":"010 20 10","scope":"Design System Plus","de":"Wengeschwarz","en":"Wenge black","nl":"Wengeschwarz","fr":"Noir de wengé"},{"hex":"#564144","code":"010 20 15","scope":"Design System Plus","de":"Kirschenschwarz","en":"Cherry black","nl":"Kersen zwart","fr":"Noir cerise"},{"hex":"#5b3f43","code":"010 20 20","scope":"Design System Plus","de":"Dunkelmahagoni","en":"Dark mahogany","nl":"Donker mahonie","fr":"Acajou foncé"},{"hex":"#5e3e43","code":"010 20 25","scope":"Design System Plus","de":"Rostrot","en":"Rusty red","nl":"Roest rood","fr":"Rouge rouille"},{"hex":"#665255","code":"010 30 10","scope":"Design System Plus","de":"Holzschwarzrot","en":"Laurel nut rusty brown","nl":"Hout zwart rood","fr":"Rouge bois noir"},{"hex":"#6a5054","code":"010 30 15","scope":"Design System Plus","de":"Nachtmauve","en":"Night mauve","nl":"Nacht mauve","fr":"Mauve nuit"},{"hex":"#714e53","code":"010 30 20","scope":"Design System Plus","de":"Rosigbraun","en":"Pinkish brown","nl":"Rozig bruin","fr":"Marron rose"},{"hex":"#774a52","code":"010 30 25","scope":"Design System Plus","de":"Kastanienrot","en":"Chestnut red","nl":"Kastanje rood","fr":"Rouge châtaigne"},{"hex":"#7c4851","code":"010 30 30","scope":"Design System Plus","de":"Lederrot","en":"Leather red","nl":"Leder rood","fr":"Rouge cuir"},{"hex":"#7e454f","code":"010 30 35","scope":"Design System Plus","de":"Anthrazitrot","en":"Anthracite red","nl":"Antraciet rood","fr":"Rouge anthracite"},{"hex":"#86404f","code":"010 30 40","scope":"Design System Plus","de":"Braunmagenta","en":"Brown magenta","nl":"Bruin magenta","fr":"Magenta brun"},{"hex":"#8b3d4f","code":"010 30 44","scope":"Design System Plus","de":"Atlasrot","en":"Atlas red","nl":"Atlas rood","fr":"Rouge atlas"},{"hex":"#796567","code":"010 40 10","scope":"Design System Plus","de":"Caputmortuumgraurot","en":"Caput mortuum grey red","nl":"Caputmortuum grijs rood","fr":"Caputmortuumgraurot"},{"hex":"#806165","code":"010 40 15","scope":"Design System Plus","de":"Rostbraun","en":"Rust brown","nl":"Roestbruin","fr":"Marron rouille"},{"hex":"#875f64","code":"010 40 20","scope":"Design System Plus","de":"Abendrot","en":"Sunset red","nl":"Zonsondergang","fr":"Coucher de soleil"},{"hex":"#8d5c65","code":"010 40 25","scope":"Design System Plus","de":"Mineralrot","en":"Mineral red","nl":"Mineraal rood","fr":"Rouge minéral"},{"hex":"#945963","code":"010 40 30","scope":"Design System Plus","de":"Trübmagenta","en":"Dull magenta","nl":"Bewolkt magenta","fr":"Magenta trouble"},{"hex":"#975460","code":"010 40 35","scope":"Design System Plus","de":"Samtrot","en":"Velvet red","nl":"Fluweelrood","fr":"Rouge velours"},{"hex":"#9f5161","code":"010 40 40","scope":"Design System Plus","de":"Algenrot","en":"Algae red","nl":"Algen rood","fr":"Rouge algue"},{"hex":"#a54d61","code":"010 40 45","scope":"Design System Plus","de":"Himbeereisrot","en":"Raspberry ice cream red","nl":"Framboos ijs rood","fr":"Rouge framboise"},{"hex":"#ab4960","code":"010 40 50","scope":"Design System Plus","de":"Fuchsiarot","en":"Fuchsia red","nl":"Fuchsiarood","fr":"Rouge fuchsia"},{"hex":"#ae465e","code":"010 40 53","scope":"Design System Plus","de":"Urrot","en":"Primal red","nl":"Oerrood","fr":"Urrot"},{"hex":"#8f797d","code":"010 50 10","scope":"Design System Plus","de":"Altmahagoni","en":"Old mahogany","nl":"Oud mahonie","fr":"Acajou ancien"},{"hex":"#96757a","code":"010 50 15","scope":"Design System Plus","de":"Trübaltrosa","en":"Dull dusky pink","nl":"Bewolkt roze","fr":"Rose pâle trouble"},{"hex":"#9d737a","code":"010 50 20","scope":"Design System Plus","de":"Backsteinrot","en":"Brickwork red","nl":"Baksteen rood","fr":"Rouge brique"},{"hex":"#a67079","code":"010 50 25","scope":"Design System Plus","de":"Mattkarmin","en":"Matte carmine","nl":"Mat karmijn","fr":"Carmin mat"},{"hex":"#ae6c78","code":"010 50 30","scope":"Design System Plus","de":"Marmorrot","en":"Marble red","nl":"Marmerrood","fr":"Rouge marbré"},{"hex":"#b36876","code":"010 50 35","scope":"Design System Plus","de":"Geranienrot","en":"Geranium red","nl":"Geranium rood","fr":"Rouge géranium"},{"hex":"#b86576","code":"010 50 40","scope":"Design System Plus","de":"Schieferrosa","en":"Slate pink","nl":"Leisteen roze","fr":"Rose ardoise"},{"hex":"#bd5f74","code":"010 50 45","scope":"Design System Plus","de":"Tulipanrot","en":"Tulip red","nl":"Tulpenrood","fr":"Rouge tulipe"},{"hex":"#c65c74","code":"010 50 50","scope":"Design System Plus","de":"Lichtrot","en":"Vibrant red","nl":"Licht rood","fr":"Rouge lumière"},{"hex":"#a89093","code":"010 60 10","scope":"Design System Plus","de":"Fliedergrau","en":"Lilac grey","nl":"Lila grijs","fr":"Gris lilas"},{"hex":"#b18e93","code":"010 60 15","scope":"Design System Plus","de":"Eisorchideenrot","en":"Ice orchid red","nl":"Ijsorchidee rood","fr":"Rouge orchidée glacée"},{"hex":"#ba8b92","code":"010 60 20","scope":"Design System Plus","de":"Kalkrosa","en":"Lime pink","nl":"Limoenroze","fr":"Rose calcaire"},{"hex":"#c08690","code":"010 60 25","scope":"Design System Plus","de":"Lippenstiftrosa","en":"Lipstick pink","nl":"Lippenstift roze","fr":"Rose à lèvres"},{"hex":"#c7828f","code":"010 60 30","scope":"Design System Plus","de":"Japankoralle","en":"Japanese coral","nl":"Japans koraal","fr":"Corail du Japon"},{"hex":"#d07f8d","code":"010 60 35","scope":"Design System Plus","de":"Rosenrot","en":"Rose red","nl":"Rozerood","fr":"Rose rouge"},{"hex":"#d67b8c","code":"010 60 40","scope":"Design System Plus","de":"Erdbeershakerot","en":"Strawberry milkshake red","nl":"Aardbeienshaker rood","fr":"Shakerot à la fraise"},{"hex":"#df768b","code":"010 60 45","scope":"Design System Plus","de":"Leuchtendrosa","en":"Luminous pink","nl":"Helder roze","fr":"Rose vif"},{"hex":"#c3aaae","code":"010 70 10","scope":"Design System Plus","de":"Blassmauve","en":"Pale mauve","nl":"Licht mauve","fr":"Mauve pâle"},{"hex":"#caa7ab","code":"010 70 15","scope":"Design System Plus","de":"Puderrosé","en":"Powder rose","nl":"Poederroze","fr":"Rose poudré"},{"hex":"#d4a3ab","code":"010 70 20","scope":"Design System Plus","de":"Silberrosé","en":"Silver rose","nl":"Zilveren roos","fr":"Rose argenté"},{"hex":"#dc9fa9","code":"010 70 25","scope":"Design System Plus","de":"Flamingorosa","en":"Flamingo pink","nl":"Flamingo roze","fr":"Flamingorosa"},{"hex":"#e39ca8","code":"010 70 30","scope":"Design System Plus","de":"Kirschblütenrosa","en":"Cherry blossom pink","nl":"Kersenbloesem roze","fr":"Rose cerise"},{"hex":"#eb96a5","code":"010 70 35","scope":"Design System Plus","de":"Babyrosa","en":"Baby pink","nl":"Baby roze","fr":"Rose bébé"},{"hex":"#dec3c5","code":"010 80 10","scope":"Design System Plus","de":"Schlammpink","en":"Mud pink","nl":"Modderroze","fr":"Rose boue"},{"hex":"#e5c0c4","code":"010 80 15","scope":"Design System Plus","de":"Eispink","en":"Ice hot pink","nl":"IJsroze","fr":"Rose glacé"},{"hex":"#efbcc3","code":"010 80 20","scope":"Design System Plus","de":"Pastellrosa","en":"Pastel pink","nl":"Pastelroze","fr":"Rose pastel"},{"hex":"#ded1d3","code":"010 85 05","scope":"Design System Plus","de":"Perlrosé","en":"Pearl rose","nl":"Parel rosé","fr":"Perlrosé"},{"hex":"#e4cdd1","code":"010 85 10","scope":"Design System Plus","de":"Lachsrosé","en":"Salmon rose","nl":"Zalmroze","fr":"Rose saumon"},{"hex":"#efccd2","code":"010 85 15","scope":"Design System Plus","de":"Milchshakerosa","en":"Milkshake pink","nl":"Melkshakerosa","fr":"Shakerosa de lait"},{"hex":"#f8cbd2","code":"010 85 20","scope":"Design System Plus","de":"Inkarnatrosé","en":"Carnation pink","nl":"Menselijke roos","fr":"Rose incarnat"},{"hex":"#efe0df","code":"010 90 05","scope":"Design System Plus","de":"Rosécreme","en":"Rose cream","nl":"Rosé crème","fr":"Crème rose"},{"hex":"#f2dbd8","code":"010 90 10","scope":"Design System Plus","de":"Hellapricot","en":"Light apricot","nl":"Hellapricot","fr":"Hellapricot"},{"hex":"#f1e6e8","code":"010 93 05","scope":"Design System Plus","de":"Weißrötlich","en":"White-red","nl":"Wit-roodachtig","fr":"Blanc rougeâtre"},{"hex":"#4c4545","code":"020 20 05","scope":"Design System Plus","de":"Tiefbraun","en":"Deep brown","nl":"Diep bruin","fr":"Marron profond"},{"hex":"#524343","code":"020 20 10","scope":"Design System Plus","de":"Nachtröte","en":"Night red","nl":"Nachtzanger","fr":"Nocturne"},{"hex":"#5b4041","code":"020 20 20","scope":"Design System Plus","de":"Dunkelrotbraun","en":"Dark red brown","nl":"Donker roodbruin","fr":"Marron rouge foncé"},{"hex":"#633c40","code":"020 20 29","scope":"Design System Plus","de":"Burgunderrot","en":"Burgundy","nl":"Bourgondisch rood","fr":"Rouge bordeaux"},{"hex":"#5d5454","code":"020 30 05","scope":"Design System Plus","de":"Rhodonitbraun","en":"Rhodonite brown","nl":"Rhodoniet bruin","fr":"Brun rhodonite"},{"hex":"#645151","code":"020 30 10","scope":"Design System Plus","de":"Budapesterbraun","en":"Budapest brown","nl":"Boedapest bruin","fr":"Marron budapest"},{"hex":"#6f4b4c","code":"020 30 20","scope":"Design System Plus","de":"Kremlrot","en":"Kremlin red","nl":"Kremlin rood","fr":"Rouge du Kremlin"},{"hex":"#78464a","code":"020 30 30","scope":"Design System Plus","de":"Kristalldunkelrot","en":"Crystal dark red","nl":"Kristal donkerrood","fr":"Rouge foncé cristal"},{"hex":"#844048","code":"020 30 40","scope":"Design System Plus","de":"Amaranthblüte","en":"Amaranth blossom","nl":"Amarant bloesem","fr":"Fleur d'amarante"},{"hex":"#8c3c46","code":"020 30 48","scope":"Design System Plus","de":"Vogelkirschenrot","en":"Sweet cherry red","nl":"Vogel kersenrood","fr":"Rouge cerise d'oiseau"},{"hex":"#726868","code":"020 40 05","scope":"Design System Plus","de":"Graubräunlich","en":"Greyish brown","nl":"Grijsbruin","fr":"Gris-brunâtre"},{"hex":"#786464","code":"020 40 10","scope":"Design System Plus","de":"Nussbaumbraun","en":"Nut brown","nl":"Walnootbruin","fr":"Marron noyer"},{"hex":"#855e60","code":"020 40 20","scope":"Design System Plus","de":"Antikrot","en":"Antique red","nl":"Antiek rood","fr":"Rouge antique"},{"hex":"#92585c","code":"020 40 30","scope":"Design System Plus","de":"Hermosarosa","en":"Hermosa pink","nl":"Hermosarosa","fr":"Hermosarosa"},{"hex":"#9b5157","code":"020 40 40","scope":"Design System Plus","de":"Oktoberrot","en":"October red","nl":"Oktober rood","fr":"Rouge octobre"},{"hex":"#a74751","code":"020 40 50","scope":"Design System Plus","de":"Knallrot","en":"Bright red","nl":"Helder rood","fr":"Rouge vif"},{"hex":"#897d7c","code":"020 50 05","scope":"Design System Plus","de":"Zirkongrau","en":"Zircon grey","nl":"Zirkoon grijs","fr":"Gris zircon"},{"hex":"#907879","code":"020 50 10","scope":"Design System Plus","de":"Sandsteinrotgrau","en":"Sandstone red grey","nl":"Zandsteen rood-grijs","fr":"Gris grès rouge"},{"hex":"#9f7274","code":"020 50 20","scope":"Design System Plus","de":"Rotgrau","en":"Red grey","nl":"Roodgrijs","fr":"Gris rouge"},{"hex":"#ac6c70","code":"020 50 30","scope":"Design System Plus","de":"Venezianerrot","en":"Venetian red","nl":"Venetiaans rood","fr":"Rouge vénitien"},{"hex":"#b6646b","code":"020 50 40","scope":"Design System Plus","de":"Schwedenkleerot","en":"Alsike clover red","nl":"Zweeds klavertje rood","fr":"Rouge de trèfle suédois"},{"hex":"#c25c67","code":"020 50 50","scope":"Design System Plus","de":"Flammenrot","en":"Flame red","nl":"Vuurrood","fr":"Rouge flamme"},{"hex":"#d25766","code":"020 50 58","scope":"Design System Plus","de":"Preiselbeerenrot","en":"Lingonberry red","nl":"Veenbessenrood","fr":"Rouge canneberge"},{"hex":"#9f9493","code":"020 60 05","scope":"Design System Plus","de":"Kugeldistelgraurosé","en":"Globe thistle grey rose","nl":"Bal distel grijs rosé","fr":"Chardon sphérique grisâtre"},{"hex":"#a78e8f","code":"020 60 10","scope":"Design System Plus","de":"Blechrosa","en":"Tin pink","nl":"Tin roze","fr":"Rose de tôle"},{"hex":"#b88a8c","code":"020 60 20","scope":"Design System Plus","de":"Retrorosa","en":"Retro pink","nl":"Retrorosa","fr":"Retrorosa"},{"hex":"#c68186","code":"020 60 30","scope":"Design System Plus","de":"Begonienrostrosé","en":"Begonia rusty rose","nl":"Begonia roestroze","fr":"Rose bégonia"},{"hex":"#d37a82","code":"020 60 40","scope":"Design System Plus","de":"Lotusrot","en":"Lotus red","nl":"Lotusrood","fr":"Rouge lotus"},{"hex":"#b9adac","code":"020 70 05","scope":"Design System Plus","de":"Fashionmauve","en":"Fashion mauve","nl":"Mode mauve","fr":"Fashionmauve"},{"hex":"#c0a7a8","code":"020 70 10","scope":"Design System Plus","de":"Turmalinmauve","en":"Tourmaline mauve","nl":"Toermalijn mauve","fr":"Mauve tourmaline"},{"hex":"#d4a2a5","code":"020 70 20","scope":"Design System Plus","de":"Rosenholzapricot","en":"Rosewood apricot","nl":"Rozenhout abrikoos","fr":"Abricot bois de rose"},{"hex":"#e49ba0","code":"020 70 30","scope":"Design System Plus","de":"Markerrosa","en":"Marker pink","nl":"Marker roze","fr":"Rose marqueur"},{"hex":"#d5c7c6","code":"020 80 05","scope":"Design System Plus","de":"Auroragrau","en":"Aurora grey","nl":"Aurora grijs","fr":"Gris aurore"},{"hex":"#dcc1c2","code":"020 80 10","scope":"Design System Plus","de":"Quarzrosé","en":"Quartz rose","nl":"Kwarts rosé","fr":"Rose quartz"},{"hex":"#eebcbe","code":"020 80 20","scope":"Design System Plus","de":"Marzipanrosa","en":"Marzipan pink","nl":"Marsepein roze","fr":"Rose massepain"},{"hex":"#dfd1d1","code":"020 85 05","scope":"Design System Plus","de":"Mandelblütenrosa","en":"Almond blossom pink","nl":"Amandelbloesem roze","fr":"Rose fleur d'amandier"},{"hex":"#e7cece","code":"020 85 10","scope":"Design System Plus","de":"Lachscreme","en":"Salmon cream","nl":"Zalmcrème","fr":"Crème de saumon"},{"hex":"#fbc9ca","code":"020 85 20","scope":"Design System Plus","de":"Elegantlichtrosé","en":"Elegant light rose","nl":"Elegant lichtroze","fr":"Elégant trosé"},{"hex":"#f0e2de","code":"020 90 05","scope":"Design System Plus","de":"Muschelweiß","en":"Mussel white","nl":"Schelp wit","fr":"Blanc de coquillage"},{"hex":"#f3ddd9","code":"020 90 10","scope":"Design System Plus","de":"Pfirsichcreme","en":"Peach cream","nl":"Perzikcrème","fr":"Crème de pêche"},{"hex":"#f6e6e3","code":"020 93 05","scope":"Design System Plus","de":"Blütenweiß","en":"Blossom white","nl":"Bloesem wit","fr":"Blanc de fleur"},{"hex":"#635351","code":"030 30 10","scope":"Design System Plus","de":"Laurelnussrostbraun","en":"Laurel nut rusty brown","nl":"Lauriernoot roestbruin","fr":"Brun rouille de noix de laurier"},{"hex":"#6e4d4b","code":"030 30 20","scope":"Design System Plus","de":"Herbstlaubrot","en":"Autumn leaf red","nl":"Herfstblad rood","fr":"Rouge feuille d'automne"},{"hex":"#784845","code":"030 30 30","scope":"Design System Plus","de":"Macorefurnierrot","en":"Macore veneer red","nl":"Maco fineer rood","fr":"Rouge plaqué macore"},{"hex":"#854343","code":"030 30 40","scope":"Design System Plus","de":"Karmesinrot","en":"Crimson red","nl":"Crimson rood","fr":"Rouge cramoisi"},{"hex":"#863e3f","code":"030 30 45","scope":"Design System Plus","de":"Blutrot","en":"Blood red","nl":"Bloedrood","fr":"Rouge sang"},{"hex":"#766361","code":"030 40 10","scope":"Design System Plus","de":"Torfrotbraun","en":"Peat red brown","nl":"Veen roodbruin","fr":"Marron tourbe"},{"hex":"#86605c","code":"030 40 20","scope":"Design System Plus","de":"Moosbeerenrot","en":"Cranberry red","nl":"Veenbessenrood","fr":"Rouge canneberge"},{"hex":"#925955","code":"030 40 30","scope":"Design System Plus","de":"Backsteinbraun","en":"Brick brown","nl":"Baksteen bruin","fr":"Marron brique"},{"hex":"#9d5351","code":"030 40 40","scope":"Design System Plus","de":"Scharfrot","en":"Spicy red","nl":"Scherp rood","fr":"Rouge vif"},{"hex":"#a84c4c","code":"030 40 50","scope":"Design System Plus","de":"Hibiskusrot","en":"Hibiscus red","nl":"Hibiscus rood","fr":"Rouge hibiscus"},{"hex":"#b14548","code":"030 40 60","scope":"Design System Plus","de":"Kaiserkirschenrot","en":"Emperor cherry red","nl":"Keizer kersenrood","fr":"Rouge cerise impériale"},{"hex":"#8f7875","code":"030 50 10","scope":"Design System Plus","de":"Erdrot","en":"Earth red","nl":"Aarde rood","fr":"Rouge terre"},{"hex":"#9d736f","code":"030 50 20","scope":"Design System Plus","de":"Terracottarotbraun","en":"Terracotta red brown","nl":"Terracotta roodbruin","fr":"Brun rouge terracotta"},{"hex":"#ab6d68","code":"030 50 30","scope":"Design System Plus","de":"Lehmrot","en":"Clay red","nl":"Klei rood","fr":"Rouge argile"},{"hex":"#b86762","code":"030 50 40","scope":"Design System Plus","de":"Zinnoberrot","en":"Vermilion red","nl":"Vermiljoen","fr":"Rouge vermillon"},{"hex":"#c25f5c","code":"030 50 50","scope":"Design System Plus","de":"Ahornrot","en":"Maple red","nl":"Esdoorn rood","fr":"Rouge érable"},{"hex":"#cf5654","code":"030 50 60","scope":"Design System Plus","de":"Hollandrot","en":"Holland red","nl":"Nederland rood","fr":"Rouge hollandais"},{"hex":"#a6908e","code":"030 60 10","scope":"Design System Plus","de":"Sturmröte","en":"Storm red","nl":"Stormrood","fr":"Rouge de la tempête"},{"hex":"#b78a86","code":"030 60 20","scope":"Design System Plus","de":"Wüstenrot","en":"Desert red","nl":"Wüstenrot","fr":"Wüstenrot"},{"hex":"#c5827c","code":"030 60 30","scope":"Design System Plus","de":"Antikrosa","en":"Antique pink","nl":"Antiek roze","fr":"Rose antique"},{"hex":"#d37d77","code":"030 60 40","scope":"Design System Plus","de":"Helltomate","en":"Light tomato","nl":"Lichtgekleurde tomaat","fr":"Tomate claire"},{"hex":"#e0746e","code":"030 60 50","scope":"Design System Plus","de":"Kalypsorot","en":"Calypso red","nl":"Calypsorot","fr":"Calypsorote"},{"hex":"#c0a8a6","code":"030 70 10","scope":"Design System Plus","de":"Floridagrau","en":"Florida grey","nl":"Grijs Florida","fr":"Gris florida"},{"hex":"#d2a19c","code":"030 70 20","scope":"Design System Plus","de":"Trübapricot","en":"Dull apricot","nl":"Bewolkt abrikoos","fr":"Pricot de turbidité"},{"hex":"#e29a94","code":"030 70 30","scope":"Design System Plus","de":"Lachsrosarot","en":"Salmon pink red","nl":"Zalmroze","fr":"Rouge saumon"},{"hex":"#f0938c","code":"030 70 40","scope":"Design System Plus","de":"Flamingorot","en":"Flamingo red","nl":"Flamingo rood","fr":"Rouge flamant"},{"hex":"#dbc2bf","code":"030 80 10","scope":"Design System Plus","de":"Salzrosa","en":"Salt pink","nl":"Roze zout","fr":"Rose salé"},{"hex":"#ecbbb6","code":"030 80 20","scope":"Design System Plus","de":"Magnolienrosa","en":"Magnolia pink","nl":"Magnolia roze","fr":"Rose magnolia"},{"hex":"#dfd0cb","code":"030 85 05","scope":"Design System Plus","de":"Mandelcreme","en":"Almond cream","nl":"Amandelcrème","fr":"Crème d'amande"},{"hex":"#e5cec9","code":"030 85 10","scope":"Design System Plus","de":"Softeisrosé","en":"Soft ice rose","nl":"Zacht ijs rosé","fr":"Rose soft glacé"},{"hex":"#f6cbc3","code":"030 85 20","scope":"Design System Plus","de":"Pfirsichrot","en":"Peach red","nl":"Perzikrood","fr":"Rouge pêche"},{"hex":"#efe1dc","code":"030 90 05","scope":"Design System Plus","de":"Antikweiß","en":"Antique white","nl":"Antiek wit","fr":"Blanc antique"},{"hex":"#f5dfd9","code":"030 90 10","scope":"Design System Plus","de":"Hochzeitsrosa","en":"Wedding pink","nl":"Roze bruiloft","fr":"Rose de mariage"},{"hex":"#f7e7e3","code":"030 93 05","scope":"Design System Plus","de":"Pergamentweiß","en":"Parchment white","nl":"Perkament wit","fr":"Blanc parchemin"},{"hex":"#5a433f","code":"040 20 19","scope":"Design System Plus","de":"Wildbraun","en":"Wild brown","nl":"Wildbruin","fr":"Marron sauvage"},{"hex":"#5d5552","code":"040 30 05","scope":"Design System Plus","de":"Basaltschwarz","en":"Basalt black","nl":"Basalt zwart","fr":"Noir basalte"},{"hex":"#62524e","code":"040 30 10","scope":"Design System Plus","de":"Kaviarschwarz","en":"Caviar black","nl":"Kaviaar zwart","fr":"Noir caviar"},{"hex":"#6d4e47","code":"040 30 20","scope":"Design System Plus","de":"Kaffeebraun","en":"Coffee brown","nl":"Koffiebruin","fr":"Marron café"},{"hex":"#774b43","code":"040 30 30","scope":"Design System Plus","de":"Wurzelbraun","en":"Root brown","nl":"Wortel bruin","fr":"Marron racine"},{"hex":"#80463e","code":"040 30 40","scope":"Design System Plus","de":"Korrosionsrot","en":"Corrosion red","nl":"Corrosie rood","fr":"Rouge de corrosion"},{"hex":"#726865","code":"040 40 05","scope":"Design System Plus","de":"Aschbraun","en":"Ash brown","nl":"Asbruin","fr":"Marron cendré"},{"hex":"#776560","code":"040 40 10","scope":"Design System Plus","de":"Somalibraun","en":"Somali brown","nl":"Somalisch bruin","fr":"Marron somali"},{"hex":"#84625a","code":"040 40 20","scope":"Design System Plus","de":"Vandyckbraun","en":"Vandyck brown","nl":"Vandyck bruin","fr":"Marron vandyck"},{"hex":"#8d5a4e","code":"040 40 30","scope":"Design System Plus","de":"Maronenbraun","en":"Chestnut brown","nl":"Kastanjebruin","fr":"Brun marron"},{"hex":"#985447","code":"040 40 40","scope":"Design System Plus","de":"Ziegelrot","en":"Brick red","nl":"Baksteen rood","fr":"Rouge brique"},{"hex":"#a35041","code":"040 40 50","scope":"Design System Plus","de":"Hennarot","en":"Henna red","nl":"Henna rood","fr":"Rouge henné"},{"hex":"#aa473b","code":"040 40 60","scope":"Design System Plus","de":"Kupferrot","en":"Copper red","nl":"Koperrood","fr":"Rouge cuivré"},{"hex":"#b24539","code":"040 40 67","scope":"Design System Plus","de":"Chinarot","en":"China red","nl":"Chinees rood","fr":"Chinarot"},{"hex":"#877c79","code":"040 50 05","scope":"Design System Plus","de":"Nomadengrau","en":"Nomad grey","nl":"Nomad grijs","fr":"Gris nomade"},{"hex":"#8e7a74","code":"040 50 10","scope":"Design System Plus","de":"Umbrasand","en":"Umbra sand","nl":"Umbra zand","fr":"Sable d'Ombrage"},{"hex":"#9c746a","code":"040 50 20","scope":"Design System Plus","de":"Achatbraun","en":"Agate brown","nl":"Agaat bruin","fr":"Marron agate"},{"hex":"#aa6f61","code":"040 50 30","scope":"Design System Plus","de":"Rostfarben","en":"Rust coloured","nl":"Roestkleuren","fr":"Couleur rouille"},{"hex":"#b36857","code":"040 50 40","scope":"Design System Plus","de":"Ameisenrot","en":"Ant red","nl":"Mier rood","fr":"Rouge fourmi"},{"hex":"#c0624f","code":"040 50 50","scope":"Design System Plus","de":"Englischrot","en":"English red","nl":"Engels rood","fr":"Rouge anglais"},{"hex":"#ce5e4a","code":"040 50 60","scope":"Design System Plus","de":"Fuchsrot","en":"Fox red","nl":"Vos rood","fr":"Rouge renard"},{"hex":"#d55845","code":"040 50 70","scope":"Design System Plus","de":"Pompejirot","en":"Pompeii red","nl":"Pompeii rood","fr":"Pompejirot"},{"hex":"#9f9491","code":"040 60 05","scope":"Design System Plus","de":"Warmgrau","en":"Warm grey","nl":"Warm grijs","fr":"Gris chaud"},{"hex":"#a8918b","code":"040 60 10","scope":"Design System Plus","de":"Hellkaramell","en":"Light caramel","nl":"Lichte karamel","fr":"Caramel clair"},{"hex":"#b4897e","code":"040 60 20","scope":"Design System Plus","de":"Sienagelblich","en":"Sienna yellow","nl":"Sienna geel","fr":"Siennois"},{"hex":"#c48677","code":"040 60 30","scope":"Design System Plus","de":"Zedernrot","en":"Cedar red","nl":"Cederrood","fr":"Rouge cèdre"},{"hex":"#cf806e","code":"040 60 40","scope":"Design System Plus","de":"Terraorange","en":"Terra orange","nl":"Terra oranje","fr":"Terraorange"},{"hex":"#dc7b64","code":"040 60 50","scope":"Design System Plus","de":"Mandarinorange","en":"Mandarin orange","nl":"Mandarijn","fr":"Orange mandarine"},{"hex":"#e67359","code":"040 60 60","scope":"Design System Plus","de":"Korallenorange","en":"Coral orange","nl":"Koraaloranje","fr":"Orange corail"},{"hex":"#b7aca9","code":"040 70 05","scope":"Design System Plus","de":"Passepartoutgrau","en":"Passepartout grey","nl":"Passepartout grijs","fr":"Gris passe-partout"},{"hex":"#c2a9a3","code":"040 70 10","scope":"Design System Plus","de":"Mohairmauve","en":"Mohair mauve","nl":"Mohair mauve","fr":"Mauve mohair"},{"hex":"#d2a499","code":"040 70 20","scope":"Design System Plus","de":"Sanftsiena","en":"Soft sienna","nl":"Sanftsiena","fr":"Sanftsiena"},{"hex":"#e09d8d","code":"040 70 30","scope":"Design System Plus","de":"Industrierosé","en":"Industrial rose","nl":"Industriële rosé","fr":"Rosé industriel"},{"hex":"#e99885","code":"040 70 40","scope":"Design System Plus","de":"Aprikosenrot","en":"Apricot red","nl":"Abrikoosrood","fr":"Rouge abricot"},{"hex":"#fa9079","code":"040 70 50","scope":"Design System Plus","de":"Fruchtrot","en":"Fruit red","nl":"Vrucht rood","fr":"Rouge fruit"},{"hex":"#d4c7c3","code":"040 80 05","scope":"Design System Plus","de":"Naturseidegrau","en":"Natural silk grey","nl":"Natuurlijke zijde grijs","fr":"Gris soie naturelle"},{"hex":"#dec4bc","code":"040 80 10","scope":"Design System Plus","de":"Thulitrosé","en":"Thulite rose","nl":"Thulitrosé","fr":"Thulitrosé"},{"hex":"#f1c1b4","code":"040 80 20","scope":"Design System Plus","de":"Krapporange","en":"Madder orange","nl":"Meekrap oranje","fr":"Orange crapaud"},{"hex":"#febaa9","code":"040 80 30","scope":"Design System Plus","de":"Naturapricot","en":"Nature apricot","nl":"Natuurlijk abrikoos","fr":"Apricot naturel"},{"hex":"#e1d2ce","code":"040 85 05","scope":"Design System Plus","de":"Pandoragrau","en":"Pandora grey","nl":"Pandora grijs","fr":"Gris pandora"},{"hex":"#ead2ca","code":"040 85 10","scope":"Design System Plus","de":"Feinalabaster","en":"Fine alabaster","nl":"Fijn albast","fr":"Albâtre fin"},{"hex":"#faccbd","code":"040 85 20","scope":"Design System Plus","de":"Zartsüßapricot","en":"Delicate sweet apricot","nl":"Verfijnd zoete abrikoos","fr":"Aricot doux"},{"hex":"#f1e2dc","code":"040 90 05","scope":"Design System Plus","de":"Saharalichtrot","en":"Sahara light red","nl":"Sahara lichtrood","fr":"Rouge lumière saharienne"},{"hex":"#f7e0d7","code":"040 90 10","scope":"Design System Plus","de":"Zartrosé","en":"Delicate rose","nl":"Lichtroze","fr":"Rose tendre"},{"hex":"#f9eae4","code":"040 93 05","scope":"Design System Plus","de":"Naturweiß","en":"Natural white","nl":"Natuurlijk wit","fr":"Blanc naturel"},{"hex":"#504541","code":"050 20 10","scope":"Design System Plus","de":"Granitbraun","en":"Granite brown","nl":"Granietbruin","fr":"Brun granite"},{"hex":"#56443e","code":"050 20 16","scope":"Design System Plus","de":"Nachtbraun","en":"Night brown","nl":"Nacht bruin","fr":"Marron nuit"},{"hex":"#5f504a","code":"050 30 10","scope":"Design System Plus","de":"Obsidianbraun","en":"Obsidian brown","nl":"Obsidiaanbruin","fr":"Marron obsidienne"},{"hex":"#6a4f44","code":"050 30 20","scope":"Design System Plus","de":"Tropenholzbraun","en":"Tropical wood brown","nl":"Tropisch hout bruin","fr":"Marron bois tropical"},{"hex":"#744c3e","code":"050 30 30","scope":"Design System Plus","de":"Tabakbraun","en":"Tobacco brown","nl":"Tabakbruin","fr":"Marron tabac"},{"hex":"#7a4b3c","code":"050 30 36","scope":"Design System Plus","de":"Palisanderbraun","en":"Rosewood brown","nl":"Rozenhout bruin","fr":"Marron palissandre"},{"hex":"#76645d","code":"050 40 10","scope":"Design System Plus","de":"Mokkaschwarz","en":"Mocha black","nl":"Mokka zwart","fr":"Noir moka"},{"hex":"#806153","code":"050 40 20","scope":"Design System Plus","de":"Florentinerbraun","en":"Florentine brown","nl":"Florentijns bruin","fr":"Marron florentin"},{"hex":"#895e4d","code":"050 40 30","scope":"Design System Plus","de":"Currybraun","en":"Curry brown","nl":"Kerrie bruin","fr":"Marron curry"},{"hex":"#945943","code":"050 40 40","scope":"Design System Plus","de":"Madeirabraun","en":"Madeira brown","nl":"Madeira bruin","fr":"Marron de Madère"},{"hex":"#9d5640","code":"050 40 50","scope":"Design System Plus","de":"Herbstrot","en":"Autumn red","nl":"Herfstrood","fr":"Rouge d'automne"},{"hex":"#8d7b73","code":"050 50 10","scope":"Design System Plus","de":"Teakholzbraun","en":"Teakwood brown","nl":"Teak bruin","fr":"Marron teck"},{"hex":"#997767","code":"050 50 20","scope":"Design System Plus","de":"Milchkaffeebraun","en":"Milk coffee brown","nl":"Melk koffie bruin","fr":"Marron café au lait"},{"hex":"#a5725c","code":"050 50 30","scope":"Design System Plus","de":"Goldbraun","en":"Golden brown","nl":"Goudbruin","fr":"Marron doré"},{"hex":"#ae6c50","code":"050 50 40","scope":"Design System Plus","de":"Kupfermetallrot","en":"Copper-metal red","nl":"Koperen metaal rood","fr":"Rouge cuivre métallique"},{"hex":"#b96746","code":"050 50 50","scope":"Design System Plus","de":"Goldlackbraun","en":"Gold varnish brown","nl":"Goudlak bruin","fr":"Marron laqué or"},{"hex":"#bd623d","code":"050 50 60","scope":"Design System Plus","de":"Tizianrot","en":"Titian red","nl":"Titiaan rood","fr":"Rouge tiziane"},{"hex":"#cc5c36","code":"050 50 70","scope":"Design System Plus","de":"Mohnrot","en":"Poppy red","nl":"Klaproos rood","fr":"Rouge coquelicot"},{"hex":"#d16032","code":"050 50 78","scope":"Design System Plus","de":"Persischorange","en":"Persian orange","nl":"Perzische sinaasappel","fr":"Orange persane"},{"hex":"#a59188","code":"050 60 10","scope":"Design System Plus","de":"Ecruocker","en":"Ecru ochre","nl":"Ecruocker","fr":"Ecruocker"},{"hex":"#b18c7b","code":"050 60 20","scope":"Design System Plus","de":"Karamellbraun","en":"Caramel brown","nl":"Karamelbruin","fr":"Marron caramel"},{"hex":"#c28971","code":"050 60 30","scope":"Design System Plus","de":"Mittelbraun","en":"Medium brown","nl":"Medium bruin","fr":"Marron moyen"},{"hex":"#c98365","code":"050 60 40","scope":"Design System Plus","de":"Apricotbraun","en":"Apricot brown","nl":"Abrikoosbruin","fr":"Marron abricot"},{"hex":"#d67f59","code":"050 60 50","scope":"Design System Plus","de":"Orangegelb","en":"Orange yellow","nl":"Oranje geel","fr":"Jaune orangé"},{"hex":"#e17b4e","code":"050 60 60","scope":"Design System Plus","de":"Kamelrot","en":"Camel red","nl":"Kameelrood","fr":"Rouge chameau"},{"hex":"#e67045","code":"050 60 70","scope":"Design System Plus","de":"Karottenorange","en":"Carrot orange","nl":"Wortel oranje","fr":"Orange carotte"},{"hex":"#f26d3f","code":"050 60 80","scope":"Design System Plus","de":"Gerberarot","en":"Gerbera red","nl":"Tanner rood","fr":"Rouge de Gerber"},{"hex":"#c0aca2","code":"050 70 10","scope":"Design System Plus","de":"Bambusbeige","en":"Bamboo beige","nl":"Bamboe beige","fr":"Beige bambou"},{"hex":"#cea796","code":"050 70 20","scope":"Design System Plus","de":"Bernsteingrau","en":"Amber grey","nl":"Ambergrijs","fr":"Gris ambré"},{"hex":"#dba188","code":"050 70 30","scope":"Design System Plus","de":"Sienaocker","en":"Sienna ochre","nl":"Siena oker","fr":"Tabouret de Sienne"},{"hex":"#e99b7b","code":"050 70 40","scope":"Design System Plus","de":"Amberhellorange","en":"Light amber orange","nl":"Amber lichtoranje","fr":"Orange clair ambré"},{"hex":"#f39670","code":"050 70 50","scope":"Design System Plus","de":"Melonenrot","en":"Melon red","nl":"Meloenrood","fr":"Rouge melon"},{"hex":"#fe9063","code":"050 70 60","scope":"Design System Plus","de":"Mangoorange","en":"Mango orange","nl":"Mangosinaasappel","fr":"Orange mangue"},{"hex":"#dbc5bb","code":"050 80 10","scope":"Design System Plus","de":"Blasssiena","en":"Pale sienna","nl":"Bleke sienna","fr":"Blasssiena"},{"hex":"#e9bfac","code":"050 80 20","scope":"Design System Plus","de":"Sanftorange","en":"Soft orange","nl":"Zacht oranje","fr":"Orange douce"},{"hex":"#f6b99f","code":"050 80 30","scope":"Design System Plus","de":"Fahlorange","en":"Pallid orange","nl":"Lichtoranje","fr":"Orange pâle"},{"hex":"#e2d3cc","code":"050 85 05","scope":"Design System Plus","de":"Meersand","en":"Ocean sand","nl":"Zeezand","fr":"Sable de mer"},{"hex":"#e6cfc3","code":"050 85 10","scope":"Design System Plus","de":"Reinbeige","en":"Pure beige","nl":"Puur beige","fr":"Beige pur"},{"hex":"#f6cbb7","code":"050 85 20","scope":"Design System Plus","de":"Biscuitcreme","en":"Biscuit cream","nl":"Koekjescrème","fr":"Crème de biscuit"},{"hex":"#ede0d8","code":"050 90 05","scope":"Design System Plus","de":"Eierschalenweiß","en":"Eggshell white","nl":"Eischaal wit","fr":"Blanc coquille d'œuf"},{"hex":"#fbe2d6","code":"050 90 10","scope":"Design System Plus","de":"Hellpfirsichrosé","en":"Light peach rose","nl":"Lichte perzikrosé","fr":"Rose pêche clair"},{"hex":"#f9ebe4","code":"050 93 05","scope":"Design System Plus","de":"Tüllweiß","en":"Tulle white","nl":"Tule wit","fr":"Tulle blanc"},{"hex":"#4a4643","code":"060 20 05","scope":"Design System Plus","de":"Industrieschwarz","en":"Industrial black","nl":"Industrieel zwart","fr":"Noir industriel"},{"hex":"#5c5551","code":"060 30 05","scope":"Design System Plus","de":"Karosseriegrau","en":"Vehicle body grey","nl":"Lichaam grijs","fr":"Gris carrosserie"},{"hex":"#60534b","code":"060 30 10","scope":"Design System Plus","de":"Nutriafellbraun","en":"Nutria fur brown","nl":"Nutria bont bruin","fr":"Marron nutraceutique"},{"hex":"#665042","code":"060 30 20","scope":"Design System Plus","de":"Torfbraun","en":"Peat brown","nl":"Turfbruin","fr":"Marron tourbe"},{"hex":"#6f5141","code":"060 30 27","scope":"Design System Plus","de":"Zinnsteinbraun","en":"Cassiterite brown","nl":"Tinnen bruin","fr":"Brun ambré"},{"hex":"#716863","code":"060 40 05","scope":"Design System Plus","de":"Zinkgrau","en":"Zinc grey","nl":"Zinkgrijs","fr":"Gris zinc"},{"hex":"#75655c","code":"060 40 10","scope":"Design System Plus","de":"Mooreichengrau","en":"Moor oak grey","nl":"Eiken moeras grijs","fr":"Gris chêne des marais"},{"hex":"#7f6351","code":"060 40 20","scope":"Design System Plus","de":"Kaffeebohnenbraun","en":"Coffee bean brown","nl":"Koffieboon bruin","fr":"Marron grain de café"},{"hex":"#876048","code":"060 40 30","scope":"Design System Plus","de":"Brasilbraun","en":"Brazilian brown","nl":"Braziliaans bruin","fr":"Marron brésilien"},{"hex":"#915f41","code":"060 40 40","scope":"Design System Plus","de":"Platanenbraun","en":"Plane brown","nl":"Plataan bruin","fr":"Marron platane"},{"hex":"#877d77","code":"060 50 05","scope":"Design System Plus","de":"Chinchillagrau","en":"Chinchilla grey","nl":"Chinchilla grijs","fr":"Gris chinchilla"},{"hex":"#8c7c71","code":"060 50 10","scope":"Design System Plus","de":"Sandsteingrau","en":"Sandstone grey","nl":"Zandsteengrijs","fr":"Gris grès"},{"hex":"#967965","code":"060 50 20","scope":"Design System Plus","de":"Champignonbraun","en":"Mushroom brown","nl":"Paddenstoel bruin","fr":"Marron champignon"},{"hex":"#a2775a","code":"060 50 30","scope":"Design System Plus","de":"Senfbraun","en":"Mustard brown","nl":"Mosterdbruin","fr":"Marron moutarde"},{"hex":"#aa714d","code":"060 50 40","scope":"Design System Plus","de":"Kamelbraun","en":"Camel brown","nl":"Camelbruin","fr":"Brun chameau"},{"hex":"#b37045","code":"060 50 50","scope":"Design System Plus","de":"Dattelfruchtbraun","en":"Date fruit brown","nl":"Dadelvrucht bruin","fr":"Marron fruit de la datte"},{"hex":"#b66838","code":"060 50 60","scope":"Design System Plus","de":"Rüsterbraunrot","en":"Elm brown red","nl":"Iep bruin rood","fr":"Rouge brun d'orme"},{"hex":"#c16933","code":"060 50 70","scope":"Design System Plus","de":"Trockenlehm","en":"Dry clay","nl":"Droge klei","fr":"Argile sèche"},{"hex":"#a09790","code":"060 60 05","scope":"Design System Plus","de":"Estrichgrau","en":"Screed grey","nl":"Screed grijs","fr":"Gris chape"},{"hex":"#a59387","code":"060 60 10","scope":"Design System Plus","de":"Eichenbraun","en":"Oak brown","nl":"Eiken bruin","fr":"Chêne brun"},{"hex":"#b4907b","code":"060 60 20","scope":"Design System Plus","de":"Topashellocker","en":"Light topaz ochre","nl":"Topashellocker","fr":"Topashellocker"},{"hex":"#bc8d6d","code":"060 60 30","scope":"Design System Plus","de":"Cognacbraun","en":"Cognac brown","nl":"Cognacbruin","fr":"Marron cognac"},{"hex":"#cb8c5e","code":"060 60 40","scope":"Design System Plus","de":"Ahornsirupbraun","en":"Maple syrup brown","nl":"Ahornsiroop bruin","fr":"Brun sirop d'érable"},{"hex":"#cc814e","code":"060 60 50","scope":"Design System Plus","de":"Kurkumarot","en":"Turmeric red","nl":"Kurkuma rood","fr":"Rouge de curcuma"},{"hex":"#d77f43","code":"060 60 60","scope":"Design System Plus","de":"Bitterorange","en":"Bitter orange","nl":"Bittere sinaasappel","fr":"Orange amère"},{"hex":"#dc7c37","code":"060 60 70","scope":"Design System Plus","de":"Goldorange","en":"Gold orange","nl":"Goudoranje","fr":"Orange doré"},{"hex":"#e6752a","code":"060 60 80","scope":"Design System Plus","de":"Akzentorange","en":"Accent orange","nl":"Accent oranje","fr":"Orange d'accent"},{"hex":"#b9afa9","code":"060 70 05","scope":"Design System Plus","de":"Zementgreige","en":"Cement greige","nl":"Cementdeeg","fr":"Pâte à ciment"},{"hex":"#c0ada1","code":"060 70 10","scope":"Design System Plus","de":"Kittgrau","en":"Putty grey","nl":"Putty grijs","fr":"Gris mastic"},{"hex":"#cba891","code":"060 70 20","scope":"Design System Plus","de":"Erdnusscreme","en":"Peanut butter","nl":"Pindacrème","fr":"Crème de cacahuètes"},{"hex":"#d3a281","code":"060 70 30","scope":"Design System Plus","de":"Pfirsichgelb","en":"Peach yellow","nl":"Perzikgeel","fr":"Jaune pêche"},{"hex":"#e1a074","code":"060 70 40","scope":"Design System Plus","de":"Kerzengelb","en":"Candle yellow","nl":"Kaars geel","fr":"Jaune bougie"},{"hex":"#eb9c67","code":"060 70 50","scope":"Design System Plus","de":"Topasgelb","en":"Topaz yellow","nl":"Topaas geel","fr":"Jaune topaze"},{"hex":"#f19758","code":"060 70 60","scope":"Design System Plus","de":"Melonenorange","en":"Melon orange","nl":"Meloen oranje","fr":"Orange melon"},{"hex":"#fc9348","code":"060 70 70","scope":"Design System Plus","de":"Indischgelb","en":"Indian yellow","nl":"Indiaas geel","fr":"Jaune indien"},{"hex":"#d3c9c1","code":"060 80 05","scope":"Design System Plus","de":"Chamoishellbeige","en":"Light chamois beige","nl":"Zeem licht beige","fr":"Beige clair chamois"},{"hex":"#d8c6b9","code":"060 80 10","scope":"Design System Plus","de":"Sanftgreige","en":"Soft greige","nl":"Zacht grijs","fr":"Grains doux"},{"hex":"#e7c2aa","code":"060 80 20","scope":"Design System Plus","de":"Keksbeige","en":"Biscuit beige","nl":"Koekjesbeige","fr":"Beige biscuit"},{"hex":"#f4be9a","code":"060 80 30","scope":"Design System Plus","de":"Mildorange","en":"Mild orange","nl":"Mild oranje","fr":"Orange douce"},{"hex":"#fdb889","code":"060 80 40","scope":"Design System Plus","de":"Apricotorange","en":"Apricot orange","nl":"Abrikoos sinaasappel","fr":"Orange abricot"},{"hex":"#e0d4cc","code":"060 85 05","scope":"Design System Plus","de":"Champagnerrosé","en":"Champagne rose","nl":"Champagne rosé","fr":"Rose champagne"},{"hex":"#e8d3c5","code":"060 85 10","scope":"Design System Plus","de":"Maismehlbeige","en":"Cornmeal beige","nl":"Korenbloem beige","fr":"Beige de farine de maïs"},{"hex":"#f3cfb6","code":"060 85 20","scope":"Design System Plus","de":"Teiggelb","en":"Dough yellow","nl":"Deeg geel","fr":"Jaune de pâte"},{"hex":"#ffcca5","code":"060 85 30","scope":"Design System Plus","de":"Safranhellorange","en":"Light saffron orange","nl":"Saffraan licht oranje","fr":"Orange safran clair"},{"hex":"#efe3d9","code":"060 90 05","scope":"Design System Plus","de":"Kornweiß","en":"Grain white","nl":"Korrel wit","fr":"Blanc grain"},{"hex":"#f7e0d2","code":"060 90 10","scope":"Design System Plus","de":"Vanillecreme","en":"Vanilla cream","nl":"Vanillecrème","fr":"Crème à la vanille"},{"hex":"#fcdcc9","code":"060 90 15","scope":"Design System Plus","de":"Aprikosencreme","en":"Apricot cream","nl":"Abrikozencrème","fr":"Crème à l'abricot"},{"hex":"#f7ebe2","code":"060 93 05","scope":"Design System Plus","de":"Wollweiß","en":"Wool white","nl":"Wol wit","fr":"Blanc laine"},{"hex":"#5c5148","code":"070 30 10","scope":"Design System Plus","de":"Mineralbraun","en":"Mineral brown","nl":"Mineraal bruin","fr":"Marron minéral"},{"hex":"#655444","code":"070 30 20","scope":"Design System Plus","de":"Buchenbraun","en":"Beech brown","nl":"Beukenbruin","fr":"Brun hêtre"},{"hex":"#71655a","code":"070 40 10","scope":"Design System Plus","de":"Nerzfellbraun","en":"Mink brown","nl":"Nertsbont bruin","fr":"Brun en peau de vison"},{"hex":"#7a634e","code":"070 40 20","scope":"Design System Plus","de":"Elsbeerenbraun","en":"Huckleberry brown","nl":"Wilde dienstboom bruin","fr":"Brun d'alisier"},{"hex":"#826448","code":"070 40 30","scope":"Design System Plus","de":"Ackerbraun","en":"Arable brown","nl":"Veld bruin","fr":"Marron des champs"},{"hex":"#88613d","code":"070 40 40","scope":"Design System Plus","de":"Herbstgold","en":"Autumn gold","nl":"Herfst goud","fr":"Or d'automne"},{"hex":"#887b6e","code":"070 50 10","scope":"Design System Plus","de":"Sarukgrau","en":"Saruk grey","nl":"Saruk grijs","fr":"Gris sarouk"},{"hex":"#927961","code":"070 50 20","scope":"Design System Plus","de":"Aschgold","en":"Ash gold","nl":"Asgoud","fr":"Or cendré"},{"hex":"#997552","code":"070 50 30","scope":"Design System Plus","de":"Löwenmähnenblond","en":"Lion's mane blonde","nl":"Leeuwenmanen blond","fr":"Blond crinière de lion"},{"hex":"#a17344","code":"070 50 40","scope":"Design System Plus","de":"Altgold","en":"Antique gold","nl":"Oud goud","fr":"Vieil or"},{"hex":"#a2723d","code":"070 50 50","scope":"Design System Plus","de":"Bühnengold","en":"Stage gold","nl":"Podium goud","fr":"Or de scène"},{"hex":"#aa7034","code":"070 50 55","scope":"Design System Plus","de":"Theatergold","en":"Theatre gold","nl":"Theater goud","fr":"L'or du théâtre"},{"hex":"#a19285","code":"070 60 10","scope":"Design System Plus","de":"Hellmahagoni","en":"Light mahogany","nl":"Licht mahonie","fr":"Acajou clair"},{"hex":"#ab9178","code":"070 60 20","scope":"Design System Plus","de":"Dunkelblond","en":"Dark blond","nl":"Donkerblond","fr":"Blond foncé"},{"hex":"#b38c67","code":"070 60 30","scope":"Design System Plus","de":"Eichenhellbraun","en":"Light oak brown","nl":"Licht eikenbruin","fr":"Chêne brun clair"},{"hex":"#bb8b58","code":"070 60 40","scope":"Design System Plus","de":"Kornbraun","en":"Grain brown","nl":"Korrel bruin","fr":"Marron grain"},{"hex":"#c48949","code":"070 60 50","scope":"Design System Plus","de":"Schlammgelb","en":"Mud yellow","nl":"Moddergeel","fr":"Jaune boue"},{"hex":"#cc863b","code":"070 60 60","scope":"Design System Plus","de":"Senfgelb","en":"Mustard yellow","nl":"Mosterdgeel","fr":"Jaune moutarde"},{"hex":"#cf8432","code":"070 60 70","scope":"Design System Plus","de":"Sanddorngelbbraun","en":"Sea buckthorn yellow brown","nl":"Duindoorn geelbruin","fr":"Brun jaune d'argousier"},{"hex":"#d1812a","code":"070 60 75","scope":"Design System Plus","de":"Herbstlauborange","en":"Autumn leaf orange","nl":"Herfstblad oranje","fr":"Orange feuille d'automne"},{"hex":"#baac9d","code":"070 70 10","scope":"Design System Plus","de":"Ingwergraugelb","en":"Ginger grey yellow","nl":"Gembergrijs geel","fr":"Jaune gingembre"},{"hex":"#c5a98d","code":"070 70 20","scope":"Design System Plus","de":"Eschehellbraun","en":"Light ash brown","nl":"As lichtbruin","fr":"Frêne brun clair"},{"hex":"#d0a77e","code":"070 70 30","scope":"Design System Plus","de":"Goldbeige","en":"Golden beige","nl":"Goudbeige","fr":"Beige doré"},{"hex":"#d19f6a","code":"070 70 40","scope":"Design System Plus","de":"Dechantsbirnengelb","en":"Dechant pear yellow","nl":"Dean's peer geel","fr":"Jaune poire de Dechants"},{"hex":"#dfa15f","code":"070 70 50","scope":"Design System Plus","de":"Honigwabengelb","en":"Honeycomb yellow","nl":"Honingraat geel","fr":"Jaune nid d'abeille"},{"hex":"#e9a04f","code":"070 70 60","scope":"Design System Plus","de":"Ginstergelborange","en":"Gorse yellow orange","nl":"Bezem geel oranje","fr":"Jaune genêt orange"},{"hex":"#eb9a3f","code":"070 70 70","scope":"Design System Plus","de":"Neapelgelb","en":"Naples yellow","nl":"Napels geel","fr":"Jaune de Naples"},{"hex":"#f09630","code":"070 70 80","scope":"Design System Plus","de":"Safrangold","en":"Saffron gold","nl":"Saffraan goud","fr":"Or safrané"},{"hex":"#d5c5b6","code":"070 80 10","scope":"Design System Plus","de":"Flachsbeige","en":"Flax beige","nl":"Vlassig beige","fr":"Beige plat"},{"hex":"#e4c5a8","code":"070 80 20","scope":"Design System Plus","de":"Butterblumengelb","en":"Buttercup yellow","nl":"Boterbloem geel","fr":"Jaune bouton d'or"},{"hex":"#ecc196","code":"070 80 30","scope":"Design System Plus","de":"Goldhaferfarben","en":"Golden oat coloured","nl":"Goudkleurige haver","fr":"Couleur avoine dorée"},{"hex":"#f6c088","code":"070 80 40","scope":"Design System Plus","de":"Aprikosengelb","en":"Apricot yellow","nl":"Abrikoosgeel","fr":"Jaune abricot"},{"hex":"#febc75","code":"070 80 50","scope":"Design System Plus","de":"Warmapricot","en":"Warm apricot","nl":"Warmeprik","fr":"Warmapricot"},{"hex":"#ffba65","code":"070 80 60","scope":"Design System Plus","de":"Goldregengelb","en":"Golden rain yellow","nl":"Gouden regen geel","fr":"Jaune pluie d'or"},{"hex":"#ded4ca","code":"070 85 05","scope":"Design System Plus","de":"Mandelkernbeige","en":"Almond beige","nl":"Amandelkern beige","fr":"Beige cœur d'amande"},{"hex":"#e5d3c5","code":"070 85 10","scope":"Design System Plus","de":"Silberdistelbeige","en":"Silver thistle beige","nl":"Zilveren distel beige","fr":"Beige chardon argenté"},{"hex":"#efd0b2","code":"070 85 20","scope":"Design System Plus","de":"Sandelholzbeige","en":"Sandalwood beige","nl":"Sandelhout beige","fr":"Beige santal"},{"hex":"#facfa2","code":"070 85 30","scope":"Design System Plus","de":"Haarblond","en":"Hair blonde","nl":"Haar blond","fr":"Blond des cheveux"},{"hex":"#ede3da","code":"070 90 05","scope":"Design System Plus","de":"Offwhite","en":"Off white","nl":"Offwhite","fr":"Blanc cassé"},{"hex":"#f3e2d2","code":"070 90 10","scope":"Design System Plus","de":"Hellmais","en":"Light corn","nl":"Hellmais","fr":"Hellmais"},{"hex":"#fedec0","code":"070 90 20","scope":"Design System Plus","de":"Kreidegelb","en":"Chalk yellow","nl":"Krijt geel","fr":"Jaune craie"},{"hex":"#f7ece2","code":"070 93 05","scope":"Design System Plus","de":"Anemonenweiß","en":"Anemone white","nl":"Anemoon wit","fr":"Blanc anémone"},{"hex":"#71685d","code":"075 40 10","scope":"Design System Plus","de":"Baumrindenbraun","en":"Tree bark brown","nl":"Boomschors bruin","fr":"Brun écorce d'arbre"},{"hex":"#786551","code":"075 40 20","scope":"Design System Plus","de":"Kümmelfruchtbraun","en":"Caraway brown","nl":"Karwijvruchten bruin","fr":"Marron fruit de carvi"},{"hex":"#7d6346","code":"075 40 30","scope":"Design System Plus","de":"Borkenbraun","en":"Bark brown","nl":"Schors bruin","fr":"Marron bordeaux"},{"hex":"#81633e","code":"075 40 38","scope":"Design System Plus","de":"Eidechsenbraun","en":"Lizard brown","nl":"Hagedis bruin","fr":"Marron lézard"},{"hex":"#887d71","code":"075 50 10","scope":"Design System Plus","de":"Roggenteigbraun","en":"Rye dough brown","nl":"Rogge deeg bruin","fr":"Marron pâte de seigle"},{"hex":"#907a62","code":"075 50 20","scope":"Design System Plus","de":"Chinazimt","en":"China cinnamon","nl":"Chinese kaneel","fr":"Cannelle de Chine"},{"hex":"#987954","code":"075 50 30","scope":"Design System Plus","de":"Chamottegelb","en":"Grog yellow","nl":"Chamotte geel","fr":"Jaune chamotte"},{"hex":"#9e7749","code":"075 50 40","scope":"Design System Plus","de":"Bernsteinbraun","en":"Amber brown","nl":"Amberbruin","fr":"Marron ambré"},{"hex":"#a3753c","code":"075 50 50","scope":"Design System Plus","de":"Zimtbraun","en":"Cinnamon brown","nl":"Kaneelbruin","fr":"Marron cannelle"},{"hex":"#a47232","code":"075 50 58","scope":"Design System Plus","de":"Kreuzkümmelocker","en":"Cumin ochre","nl":"Komijn oker","fr":"Gingembre au cumin"},{"hex":"#a29487","code":"075 60 10","scope":"Design System Plus","de":"Kittgelb","en":"Putty yellow","nl":"Putty geel","fr":"Jaune mastic"},{"hex":"#aa9278","code":"075 60 20","scope":"Design System Plus","de":"Walnussschalenbraun","en":"Walnut shell brown","nl":"Walnoot schelp bruin","fr":"Brun écorce de noix"},{"hex":"#b29069","code":"075 60 30","scope":"Design System Plus","de":"Lehmocker","en":"Clay ochre","nl":"Kleikrukje","fr":"Lehmocker"},{"hex":"#b98e5a","code":"075 60 40","scope":"Design System Plus","de":"Funchalgelb","en":"Funchal yellow","nl":"Funchal geel","fr":"Jaune Funchal"},{"hex":"#be8c49","code":"075 60 50","scope":"Design System Plus","de":"Mangobraun","en":"Mango brown","nl":"Mangobruin","fr":"Marron mangue"},{"hex":"#c3893a","code":"075 60 60","scope":"Design System Plus","de":"Kurkumabraun","en":"Turmeric brown","nl":"Kurkuma bruin","fr":"Marron curcuma"},{"hex":"#ca872a","code":"075 60 70","scope":"Design System Plus","de":"Bambusbraun","en":"Bamboo brown","nl":"Bamboe bruin","fr":"Marron bambou"},{"hex":"#baad9f","code":"075 70 10","scope":"Design System Plus","de":"Flachsfasergrau","en":"Flax fibre grey","nl":"Vlasvezel grijs","fr":"Gris fibre de lin"},{"hex":"#c4aa8c","code":"075 70 20","scope":"Design System Plus","de":"Kürbishellbraun","en":"Light pumpkin brown","nl":"Pompoen lichtbruin","fr":"Marron clair citrouille"},{"hex":"#cca87e","code":"075 70 30","scope":"Design System Plus","de":"Golddistelgelb","en":"Golden thistle yellow","nl":"Gouden distel geel","fr":"Jaune chardon doré"},{"hex":"#d3a56c","code":"075 70 40","scope":"Design System Plus","de":"Backsteingelb","en":"Brick yellow","nl":"Baksteen geel","fr":"Jaune brique"},{"hex":"#daa45e","code":"075 70 50","scope":"Design System Plus","de":"Bambustiefgelb","en":"Deep bamboo yellow","nl":"Bamboe diepgeel","fr":"Jaune profond de bambou"},{"hex":"#e2a14b","code":"075 70 60","scope":"Design System Plus","de":"Intensivgelb","en":"Intense yellow","nl":"Intens geel","fr":"Jaune intense"},{"hex":"#eaa139","code":"075 70 70","scope":"Design System Plus","de":"Kürbisgelb","en":"Pumpkin yellow","nl":"Pompoen geel","fr":"Jaune citrouille"},{"hex":"#eb9f2b","code":"075 70 80","scope":"Design System Plus","de":"Herbstgelb","en":"Autumn yellow","nl":"Herfstgeel","fr":"Jaune d'automne"},{"hex":"#d7c8b8","code":"075 80 10","scope":"Design System Plus","de":"Kalkbeige","en":"Chalk beige","nl":"Kalkbeige","fr":"Beige calcaire"},{"hex":"#e1c6a7","code":"075 80 20","scope":"Design System Plus","de":"Hellweizengelb","en":"Light corn yellow","nl":"Licht tarwegeel","fr":"Jaune blé clair"},{"hex":"#e8c295","code":"075 80 30","scope":"Design System Plus","de":"Dunkelgelb","en":"Dark yellow","nl":"Donkergeel","fr":"Jaune foncé"},{"hex":"#f0c186","code":"075 80 40","scope":"Design System Plus","de":"Eschengelb","en":"Ash yellow","nl":"Asgeel","fr":"Jaune frêne"},{"hex":"#f6bd73","code":"075 80 50","scope":"Design System Plus","de":"Orientgelb","en":"Orient yellow","nl":"Oosters geel","fr":"Jaune d'Orient"},{"hex":"#ffbb63","code":"075 80 60","scope":"Design System Plus","de":"Kutschengelb","en":"Carriage yellow","nl":"Rijtuig geel","fr":"Jaune calèche"},{"hex":"#e4d4c3","code":"075 85 10","scope":"Design System Plus","de":"Seerosenweiß","en":"Water lily white","nl":"Waterlelie wit","fr":"Blanc nénuphar"},{"hex":"#eed2b2","code":"075 85 20","scope":"Design System Plus","de":"Bananeneiscreme","en":"Banana ice cream","nl":"Bananenijs","fr":"Crème glacée à la banane"},{"hex":"#f7d0a2","code":"075 85 30","scope":"Design System Plus","de":"Ahornbeige","en":"Maple beige","nl":"Esdoorn beige","fr":"Beige érable"},{"hex":"#fecd90","code":"075 85 40","scope":"Design System Plus","de":"Goldrutengelb","en":"Goldenrod yellow","nl":"Guldenroede geel","fr":"Jaune verge d'or"},{"hex":"#f5e5d2","code":"075 90 10","scope":"Design System Plus","de":"Süßspeisecreme","en":"Dessert cream","nl":"Dessertcrème","fr":"Crème dessert"},{"hex":"#fce0c0","code":"075 90 20","scope":"Design System Plus","de":"Butterweiß","en":"Butter white","nl":"Boter wit","fr":"Blanc beurre"},{"hex":"#f4ece3","code":"075 93 05","scope":"Design System Plus","de":"Vanilleweiß","en":"Vanilla white","nl":"Vanille wit","fr":"Blanc vanille"},{"hex":"#4a4743","code":"080 20 05","scope":"Design System Plus","de":"Nachtbraunschwarz","en":"Night brown black","nl":"Nacht bruin zwart","fr":"Noir brun nuit"},{"hex":"#4d4740","code":"080 20 10","scope":"Design System Plus","de":"Vanilleschotenbraun","en":"Vanilla bean brown","nl":"Vanilleboon bruin","fr":"Gousse de vanille brune"},{"hex":"#5a5550","code":"080 30 05","scope":"Design System Plus","de":"Erdschwarz","en":"Earth black","nl":"Aarde zwart","fr":"Noir de terre"},{"hex":"#5c544a","code":"080 30 10","scope":"Design System Plus","de":"Olivschwarz","en":"Olive black","nl":"Olijf zwart","fr":"Noir olive"},{"hex":"#615341","code":"080 30 20","scope":"Design System Plus","de":"Nelkengelbbraun","en":"Clove yellow brown","nl":"Anjer geelbruin","fr":"Marron jaune œillet"},{"hex":"#64533c","code":"080 30 26","scope":"Design System Plus","de":"Raucheichenbraun","en":"Smoked oak brown","nl":"Rokerig eikenbruin","fr":"Marron chêne fumé"},{"hex":"#6e6962","code":"080 40 05","scope":"Design System Plus","de":"Bürograu","en":"Office grey","nl":"Kantoor grijs","fr":"Gris bureau"},{"hex":"#71685b","code":"080 40 10","scope":"Design System Plus","de":"Steinbraun","en":"Stone brown","nl":"Steenbruin","fr":"Marron pierre"},{"hex":"#76654d","code":"080 40 20","scope":"Design System Plus","de":"Pimentkornbraun","en":"Pimento grain brown","nl":"Pimentkorrel bruin","fr":"Brun grain de piment"},{"hex":"#7b6442","code":"080 40 30","scope":"Design System Plus","de":"Ockergrün","en":"Ochre green","nl":"Okergroen","fr":"Vert ocre"},{"hex":"#82653a","code":"080 40 40","scope":"Design System Plus","de":"Herbstlaubbraun","en":"Autumn leaf brown","nl":"Herfstblad bruin","fr":"Marron feuilles d'automne"},{"hex":"#837e76","code":"080 50 05","scope":"Design System Plus","de":"Dämmergrau","en":"Dusk grey","nl":"Schemer grijs","fr":"Gris crépuscule"},{"hex":"#877c6f","code":"080 50 10","scope":"Design System Plus","de":"Roggenbraun","en":"Rye brown","nl":"Roggebruin","fr":"Marron seigle"},{"hex":"#8e7b60","code":"080 50 20","scope":"Design System Plus","de":"Graugelb","en":"Greyish yellow","nl":"Grijsgeel","fr":"Jaune gris"},{"hex":"#937a53","code":"080 50 30","scope":"Design System Plus","de":"Chiligrün","en":"Chili green","nl":"Chilipeper groen","fr":"Vert piment"},{"hex":"#977845","code":"080 50 40","scope":"Design System Plus","de":"Schmutzgelb","en":"Dirt yellow","nl":"Vies geel","fr":"Jaune sale"},{"hex":"#9c7839","code":"080 50 50","scope":"Design System Plus","de":"Gamsgelb","en":"Chamois yellow","nl":"Gemsgeel","fr":"Jaune chamois"},{"hex":"#9b958e","code":"080 60 05","scope":"Design System Plus","de":"Flanellgrau","en":"Flannel grey","nl":"Flanel grijs","fr":"Gris flanelle"},{"hex":"#9e9384","code":"080 60 10","scope":"Design System Plus","de":"Hellkhaki","en":"Light khaki","nl":"Licht kaki","fr":"Kaki clair"},{"hex":"#a79375","code":"080 60 20","scope":"Design System Plus","de":"Dinkelkornbraun","en":"Spelt grain brown","nl":"Speltkorrel bruin","fr":"Brun grain d'épeautre"},{"hex":"#ad9165","code":"080 60 30","scope":"Design System Plus","de":"Goldquarzocker","en":"Golden quartz ochre","nl":"Goudkwarts gokker","fr":"Le quartz d'or"},{"hex":"#b18e58","code":"080 60 40","scope":"Design System Plus","de":"Bambusgelb","en":"Bamboo yellow","nl":"Bamboe geel","fr":"Jaune bambou"},{"hex":"#b78e49","code":"080 60 50","scope":"Design System Plus","de":"Messinggelb","en":"Brass yellow","nl":"Messing geel","fr":"jaune laiton"},{"hex":"#bd8e39","code":"080 60 60","scope":"Design System Plus","de":"Feigensenfgelb","en":"Fig mustard yellow","nl":"Vijgenmosterd geel","fr":"Jaune figue de barbarie"},{"hex":"#c08d2d","code":"080 60 70","scope":"Design System Plus","de":"Gelbgold","en":"Yellow gold","nl":"Geel goud","fr":"Or jaune"},{"hex":"#b3aea6","code":"080 70 05","scope":"Design System Plus","de":"Knoblauchbeige","en":"Garlic beige","nl":"Knoflook beige","fr":"Beige à l'ail"},{"hex":"#b8ac9c","code":"080 70 10","scope":"Design System Plus","de":"Feingreige","en":"Fine greige","nl":"Feingreige","fr":"Feingreige"},{"hex":"#c1ab8b","code":"080 70 20","scope":"Design System Plus","de":"Gelbbraun","en":"Yellow brown","nl":"Geelbruin","fr":"Marron jaune"},{"hex":"#c7a97b","code":"080 70 30","scope":"Design System Plus","de":"Senfkornbeige","en":"Mustard seed beige","nl":"Mosterdkorrel beige","fr":"Beige moutarde"},{"hex":"#cfa86a","code":"080 70 40","scope":"Design System Plus","de":"Diamantgelb","en":"Diamond yellow","nl":"Diamantgeel","fr":"Jaune diamant"},{"hex":"#d4a75a","code":"080 70 50","scope":"Design System Plus","de":"Antikmessing","en":"Antique brass","nl":"Antiek messing","fr":"Laiton antique"},{"hex":"#dba74b","code":"080 70 60","scope":"Design System Plus","de":"Zucchinigelb","en":"Courgette yellow","nl":"Courgette dooier","fr":"Jaune de courgette"},{"hex":"#dfa639","code":"080 70 70","scope":"Design System Plus","de":"Grapefruitgelb","en":"Grapefruit yellow","nl":"Grapefruit geel","fr":"Jaune pamplemousse"},{"hex":"#e0a226","code":"080 70 80","scope":"Design System Plus","de":"Sonnenblumengelb","en":"Sunflower yellow","nl":"Zonnebloem geel","fr":"Jaune tournesol"},{"hex":"#e5a10e","code":"080 70 88","scope":"Design System Plus","de":"Arnikagelb","en":"Arnica yellow","nl":"Arnica geel","fr":"Jaune d'arnica"},{"hex":"#cfc9c0","code":"080 80 05","scope":"Design System Plus","de":"Glimmerhellgrau","en":"Micaceous light grey","nl":"Mica lichtgrijs","fr":"Gris clair micacé"},{"hex":"#d6c8b7","code":"080 80 10","scope":"Design System Plus","de":"Pastellsand","en":"Pastel sand","nl":"Pastelzand","fr":"Sable pastel"},{"hex":"#ddc5a4","code":"080 80 20","scope":"Design System Plus","de":"Naturreisbeige","en":"Natural rice beige","nl":"Natuurlijk rijstbeige","fr":"Beige riz naturel"},{"hex":"#e3c393","code":"080 80 30","scope":"Design System Plus","de":"Gelbbeige","en":"Yellow beige","nl":"Geel beige","fr":"Beige jaune"},{"hex":"#ebc281","code":"080 80 40","scope":"Design System Plus","de":"Strohgelb","en":"Straw yellow","nl":"Strogeel","fr":"Jaune paille"},{"hex":"#f2c172","code":"080 80 50","scope":"Design System Plus","de":"Mirabellengelb","en":"Mirabelle yellow","nl":"Mirabelle geel","fr":"Jaune mirabelle"},{"hex":"#f8c05f","code":"080 80 60","scope":"Design System Plus","de":"Vollgelb","en":"Full yellow","nl":"Stevig geel","fr":"Jaune plein"},{"hex":"#fbbd4e","code":"080 80 70","scope":"Design System Plus","de":"Birnengelb","en":"Pear yellow","nl":"Peer geel","fr":"Jaune poire"},{"hex":"#ffba36","code":"080 80 80","scope":"Design System Plus","de":"Brandgelb","en":"Fire yellow","nl":"Brandgeel","fr":"Jaune vif"},{"hex":"#ffba1f","code":"080 80 90","scope":"Design System Plus","de":"Sommergelb","en":"Summer yellow","nl":"Zomer geel","fr":"Jaune d'été"},{"hex":"#dbd4ca","code":"080 85 05","scope":"Design System Plus","de":"Weizenmehlweiß","en":"Wheat flour white","nl":"Tarwebloem wit","fr":"Blanc de farine de blé"},{"hex":"#e0d4c2","code":"080 85 10","scope":"Design System Plus","de":"Zwiebelweiß","en":"Onion white","nl":"Ui wit","fr":"Blanc d'oignon"},{"hex":"#ead3b2","code":"080 85 20","scope":"Design System Plus","de":"Nashibirnenbeige","en":"Nashi pear beige","nl":"Nashi peer beige","fr":"Beige poire à rhinocéros"},{"hex":"#f1d0a0","code":"080 85 30","scope":"Design System Plus","de":"Vespagelb","en":"Vespa yellow","nl":"Vespagelb","fr":"Vespagelb"},{"hex":"#f9cf8d","code":"080 85 40","scope":"Design System Plus","de":"Blätterteiggelb","en":"Puff pastry yellow","nl":"Bladerdeeg geel","fr":"Pâte feuilletée jaune"},{"hex":"#ede5da","code":"080 90 05","scope":"Design System Plus","de":"Japanweiß","en":"Japanese white","nl":"Japan wit","fr":"Blanc Japon"},{"hex":"#efe1cf","code":"080 90 10","scope":"Design System Plus","de":"Champignonweiß","en":"Mushroom white","nl":"Champignon wit","fr":"Blanc de champignon"},{"hex":"#ecd6b6","code":"080 90 20","scope":"Design System Plus","de":"Macadamiabeige","en":"Macadamia beige","nl":"Macadamia beige","fr":"Beige macadamia"},{"hex":"#ffdfae","code":"080 90 30","scope":"Design System Plus","de":"Meerrettichgelb","en":"Horseradish yellow","nl":"Mierikswortel geel","fr":"Jaune raifort"},{"hex":"#f3eae1","code":"080 93 05","scope":"Design System Plus","de":"Milchsternweiß","en":"Milk star white","nl":"Melkster wit","fr":"Blanc étoile de lait"},{"hex":"#716a5e","code":"085 40 10","scope":"Design System Plus","de":"Mineralgrün","en":"Mineral green","nl":"Mineraalgroen","fr":"Vert minéral"},{"hex":"#74674f","code":"085 40 20","scope":"Design System Plus","de":"Khakigrün","en":"Khaki green","nl":"Kaki groen","fr":"Vert kaki"},{"hex":"#7a6847","code":"085 40 30","scope":"Design System Plus","de":"Moosbraun","en":"Moss brown","nl":"Mosbruin","fr":"Marron mousse"},{"hex":"#867e6f","code":"085 50 10","scope":"Design System Plus","de":"Korianderocker","en":"Coriander ochre","nl":"Koriander oker","fr":"Tabouret de coriandre"},{"hex":"#8c7d61","code":"085 50 20","scope":"Design System Plus","de":"Pyritschiefergrün","en":"Pyrite slate green","nl":"Pyriet leigroen","fr":"Vert ardoise pyrite"},{"hex":"#927d54","code":"085 50 30","scope":"Design System Plus","de":"Sepiagelb","en":"Sepia yellow","nl":"Sepia geel","fr":"Jaune sépia"},{"hex":"#947b48","code":"085 50 40","scope":"Design System Plus","de":"Sumpfgrün","en":"Marshy green","nl":"Moerasgroen","fr":"Vert marais"},{"hex":"#987b3d","code":"085 50 50","scope":"Design System Plus","de":"Honiggelbgrün","en":"Honey yellow green","nl":"Honing geel groen","fr":"Vert jaune miel"},{"hex":"#9e9587","code":"085 60 10","scope":"Design System Plus","de":"Mattoliv","en":"Matte olive","nl":"Mattolive","fr":"Mattoliv"},{"hex":"#a59476","code":"085 60 20","scope":"Design System Plus","de":"Teichgrün","en":"Pond green","nl":"Vijver groen","fr":"Vert de l'étang"},{"hex":"#ab9367","code":"085 60 30","scope":"Design System Plus","de":"Holzgrün","en":"Wood green","nl":"Houtgroen","fr":"Vert bois"},{"hex":"#af9358","code":"085 60 40","scope":"Design System Plus","de":"Flechtengrün","en":"Lichen green","nl":"Groen korstmos","fr":"Vert lichen"},{"hex":"#b4934a","code":"085 60 50","scope":"Design System Plus","de":"Mineralumbra","en":"Mineral umber","nl":"Mineralumbra","fr":"Mineralumbra"},{"hex":"#b9923b","code":"085 60 60","scope":"Design System Plus","de":"Lodengelb","en":"Loden yellow","nl":"Loden geel","fr":"Jaune loden"},{"hex":"#b6ad9c","code":"085 70 10","scope":"Design System Plus","de":"Naturbastgreige","en":"Raffia greige","nl":"Natuurlijk bastgrauw","fr":"Pâte à modeler naturelle"},{"hex":"#bfac8c","code":"085 70 20","scope":"Design System Plus","de":"Feldspatgrau","en":"Feldspar grey","nl":"Veldspaat grijs","fr":"Gris feldspath"},{"hex":"#c5ac7a","code":"085 70 30","scope":"Design System Plus","de":"Heugelb","en":"Hay yellow","nl":"Hooi geel","fr":"Jaune foin"},{"hex":"#c9aa6b","code":"085 70 40","scope":"Design System Plus","de":"Winterbirnenbeige","en":"Winter pear beige","nl":"Winterpeer beige","fr":"Beige poire d'hiver"},{"hex":"#cea95a","code":"085 70 50","scope":"Design System Plus","de":"Herbstapfelgelb","en":"Autumn apple yellow","nl":"Herfst appel geel","fr":"Jaune pomme d'automne"},{"hex":"#d0a848","code":"085 70 60","scope":"Design System Plus","de":"Pitmastonbirnengelb","en":"Pitmaston pear yellow","nl":"Pitmaston peer geel","fr":"Jaune pitmaston poire"},{"hex":"#d4a738","code":"085 70 70","scope":"Design System Plus","de":"Strohblumengelb","en":"Immortelle yellow","nl":"Strobloem geel","fr":"Jaune fleur de paille"},{"hex":"#daa92d","code":"085 70 75","scope":"Design System Plus","de":"Goldberyllgelb","en":"Golden beryl yellow","nl":"Gouden beryl geel","fr":"Jaune béryl doré"},{"hex":"#d1c7b5","code":"085 80 10","scope":"Design System Plus","de":"Samtbeige","en":"Velvet beige","nl":"Fluweelbeige","fr":"Beige velouté"},{"hex":"#d8c6a4","code":"085 80 20","scope":"Design System Plus","de":"Mineralbeige","en":"Mineral beige","nl":"Mineraal beige","fr":"Beige minéral"},{"hex":"#e1c692","code":"085 80 30","scope":"Design System Plus","de":"Mondscheingelb","en":"Moonlight yellow","nl":"Maanlicht geel","fr":"Jaune clair de lune"},{"hex":"#e6c582","code":"085 80 40","scope":"Design System Plus","de":"Tafelbirnengelb","en":"Table pear yellow","nl":"Tafelpeer geel","fr":"Jaune poire de table"},{"hex":"#e9c370","code":"085 80 50","scope":"Design System Plus","de":"Fruchtgelb","en":"Fruit yellow","nl":"Vrucht geel","fr":"Jaune fruit"},{"hex":"#eec25d","code":"085 80 60","scope":"Design System Plus","de":"Adonisröschengelb","en":"Adonis rose yellow","nl":"Adonis bloesem geel","fr":"Jaune adonis"},{"hex":"#f2c14b","code":"085 80 70","scope":"Design System Plus","de":"Berberitzengelb","en":"Barberry yellow","nl":"Bosbes geel","fr":"Jaune berbère"},{"hex":"#f4bf36","code":"085 80 80","scope":"Design System Plus","de":"Löwenzahngelb","en":"Dandelion yellow","nl":"Paardenbloem geel","fr":"Jaune pissenlit"},{"hex":"#f5bf2c","code":"085 80 85","scope":"Design System Plus","de":"Dekorgelb","en":"Decor yellow","nl":"Decoratief geel","fr":"Jaune décoratif"},{"hex":"#ddd2bf","code":"085 85 10","scope":"Design System Plus","de":"Alabasterweiß","en":"Alabaster white","nl":"Albast wit","fr":"Blanc albâtre"},{"hex":"#e5d2b0","code":"085 85 20","scope":"Design System Plus","de":"Hellblond","en":"Light blond","nl":"Licht blond","fr":"Blond clair"},{"hex":"#edd19e","code":"085 85 30","scope":"Design System Plus","de":"Weidenblütengelb","en":"Willow-flower yellow","nl":"Wilgenbloesem geel","fr":"Jaune fleur de saule"},{"hex":"#f4d28e","code":"085 85 40","scope":"Design System Plus","de":"Ingwerhellgelb","en":"Light ginger yellow","nl":"Gember lichtgeel","fr":"Jaune gingembre clair"},{"hex":"#f0e5d3","code":"085 90 10","scope":"Design System Plus","de":"Tulpenweiß","en":"Tulip white","nl":"Tulp wit","fr":"Blanc tulipe"},{"hex":"#f6e1be","code":"085 90 20","scope":"Design System Plus","de":"Alpenbeerengelb","en":"Alpine berry yellow","nl":"Alpine bessengeel","fr":"Jaune baie des Alpes"},{"hex":"#fbdeab","code":"085 90 30","scope":"Design System Plus","de":"Porzellanerdengelb","en":"China clay yellow","nl":"Porseleinklei geel","fr":"Jaune terre de porcelaine"},{"hex":"#f2ece3","code":"085 93 05","scope":"Design System Plus","de":"Altweiß","en":"Vintage white","nl":"Oud wit","fr":"Blanc cassé"},{"hex":"#5b554a","code":"090 30 10","scope":"Design System Plus","de":"Limonitbraun","en":"Limonite brown","nl":"Limoniet bruin","fr":"Marron limonite"},{"hex":"#5f5641","code":"090 30 20","scope":"Design System Plus","de":"Borkengrün","en":"Bark green","nl":"Schors groen","fr":"Vert bordeaux"},{"hex":"#706a5d","code":"090 40 10","scope":"Design System Plus","de":"Wackersteinbraun","en":"Boulder brown","nl":"Bruin Wackerstein","fr":"Marron pierre de taille"},{"hex":"#73684d","code":"090 40 20","scope":"Design System Plus","de":"Pflaumengrün","en":"Plum green","nl":"Pruimgroen","fr":"Vert prune"},{"hex":"#766843","code":"090 40 30","scope":"Design System Plus","de":"Weinblättergrün","en":"Vine leaf green","nl":"Wijnblad groen","fr":"Vert feuille de vigne"},{"hex":"#847e70","code":"090 50 10","scope":"Design System Plus","de":"Graphitgraugrün","en":"Graphite grey green","nl":"Grafiet grijsgroen","fr":"Vert gris graphite"},{"hex":"#887d61","code":"090 50 20","scope":"Design System Plus","de":"Pestogrün","en":"Pesto green","nl":"Pesto groen","fr":"Vert pesto"},{"hex":"#8e7e51","code":"090 50 30","scope":"Design System Plus","de":"Riesenkaktusgrün","en":"Giant cactus green","nl":"Reuzencactus groen","fr":"Vert cactus géant"},{"hex":"#917e45","code":"090 50 40","scope":"Design System Plus","de":"Auberginengrün","en":"Aubergine green","nl":"Aubergine groen","fr":"Vert d'aubergine"},{"hex":"#9b9485","code":"090 60 10","scope":"Design System Plus","de":"Austerngrau","en":"Oyster grey","nl":"Oestergrijs","fr":"Gris huître"},{"hex":"#a29474","code":"090 60 20","scope":"Design System Plus","de":"Manzanillaoliv","en":"Manzanilla olive","nl":"Manzanilla olijf","fr":"Manzanillaoliv"},{"hex":"#a59467","code":"090 60 30","scope":"Design System Plus","de":"Tarnoliv","en":"Camouflage olive","nl":"Tarnoliv","fr":"Tarnoliv"},{"hex":"#a89356","code":"090 60 40","scope":"Design System Plus","de":"Lorbeergrün","en":"Laurel green","nl":"Lauriergroen","fr":"Vert de laurier"},{"hex":"#a89043","code":"090 60 50","scope":"Design System Plus","de":"Fahlgrün","en":"Faint green","nl":"Lichtgroen","fr":"Vert pâle"},{"hex":"#af9538","code":"090 60 60","scope":"Design System Plus","de":"Titanitgelb","en":"Titanite yellow","nl":"Titaniet geel","fr":"Jaune titanite"},{"hex":"#b5ae9d","code":"090 70 10","scope":"Design System Plus","de":"Staubgelb","en":"Dusty yellow","nl":"Stof geel","fr":"Jaune poussière"},{"hex":"#bbad8a","code":"090 70 20","scope":"Design System Plus","de":"Barbadosbeige","en":"Barbados beige","nl":"Barbados beige","fr":"Barbadosbeige"},{"hex":"#beab7b","code":"090 70 30","scope":"Design System Plus","de":"Rhabarberblattgrün","en":"Rhubarb leaf green","nl":"Rabarberblad groen","fr":"Vert feuille de rhubarbe"},{"hex":"#c5ae6a","code":"090 70 40","scope":"Design System Plus","de":"Igelkaktusgelbgrün","en":"Hedgehog cactus yellow green","nl":"Egelcactus geelgroen","fr":"Vert hérisson-cactus"},{"hex":"#c8ad5a","code":"090 70 50","scope":"Design System Plus","de":"Stachelbeergelb","en":"Gooseberry yellow","nl":"Kruisbes geel","fr":"Jaune groseille"},{"hex":"#caac47","code":"090 70 60","scope":"Design System Plus","de":"Knospengrün","en":"Bud green","nl":"Groen","fr":"Vert bourgeon"},{"hex":"#cdac33","code":"090 70 70","scope":"Design System Plus","de":"Birkenkätzchengelb","en":"Catkin yellow","nl":"Berkenkatoen geel","fr":"Jaune poussin bouleau"},{"hex":"#cfab22","code":"090 70 80","scope":"Design System Plus","de":"Prehnitgelb","en":"Prehnite yellow","nl":"Prehniet geel","fr":"Jaune prehnite"},{"hex":"#d0c7b3","code":"090 80 10","scope":"Design System Plus","de":"Hellbeige","en":"Light beige","nl":"Licht beige","fr":"Beige clair"},{"hex":"#d5c6a3","code":"090 80 20","scope":"Design System Plus","de":"Champagnerbeige","en":"Champagne beige","nl":"Champagne-beige","fr":"Beige champagne"},{"hex":"#dcc894","code":"090 80 30","scope":"Design System Plus","de":"Zitronensorbetgelb","en":"Lemon sorbet yellow","nl":"Citroensorbet geel","fr":"Jaune sorbet citron"},{"hex":"#e0c984","code":"090 80 40","scope":"Design System Plus","de":"Blütengelb","en":"Blossom yellow","nl":"Bloem geel","fr":"Jaune fleur"},{"hex":"#e5c76d","code":"090 80 50","scope":"Design System Plus","de":"Tasmanhoniggelb","en":"Tasman honey yellow","nl":"Tasmaanse honing geel","fr":"Jaune miel de Tasmanie"},{"hex":"#e7c558","code":"090 80 60","scope":"Design System Plus","de":"Neugelb","en":"New yellow","nl":"Nieuw geel","fr":"Jaune neuf"},{"hex":"#ebc648","code":"090 80 70","scope":"Design System Plus","de":"Fashiongelb","en":"Fashion yellow","nl":"Mode geel","fr":"Jaune fashion"},{"hex":"#eac42c","code":"090 80 80","scope":"Design System Plus","de":"Plakatgelb","en":"Poster yellow","nl":"Poster geel","fr":"Jaune d'affiche"},{"hex":"#f0c503","code":"090 80 90","scope":"Design System Plus","de":"Kontrastgelb","en":"Contrasting yellow","nl":"Contrast geel","fr":"Jaune de contraste"},{"hex":"#dad4ca","code":"090 85 05","scope":"Design System Plus","de":"Pfefferweiß","en":"Pepper white","nl":"Peper wit","fr":"Blanc poivré"},{"hex":"#dfd5c2","code":"090 85 10","scope":"Design System Plus","de":"Paellanaturweiß","en":"Paella natural white","nl":"Paella wit","fr":"Blanc naturel Paellan"},{"hex":"#e4d5b0","code":"090 85 20","scope":"Design System Plus","de":"Cidregelb","en":"Cider yellow","nl":"Cidregelb","fr":"Cidregelb"},{"hex":"#ead59f","code":"090 85 30","scope":"Design System Plus","de":"Palmzuckergelb","en":"Palm sugar yellow","nl":"Palmsuiker geel","fr":"Jaune sucre de palme"},{"hex":"#edd38c","code":"090 85 40","scope":"Design System Plus","de":"Märzgelb","en":"March yellow","nl":"Maart geel","fr":"Jaune de mars"},{"hex":"#f2d479","code":"090 85 50","scope":"Design System Plus","de":"Pirolgelb","en":"Oriole yellow","nl":"Oriole geel","fr":"Jaune loriot"},{"hex":"#eae4d9","code":"090 90 05","scope":"Design System Plus","de":"Marzipanweiß","en":"Marzipan white","nl":"Marsepein wit","fr":"Blanc massepain"},{"hex":"#ebe4d1","code":"090 90 10","scope":"Design System Plus","de":"Primelweiß","en":"Primrose white","nl":"Primula wit","fr":"Blanc primevère"},{"hex":"#f2e3bd","code":"090 90 20","scope":"Design System Plus","de":"Cremegelb","en":"Cream yellow","nl":"Crème geel","fr":"Jaune crème"},{"hex":"#f6e2ac","code":"090 90 30","scope":"Design System Plus","de":"Wachsgelb","en":"Wax yellow","nl":"Was geel","fr":"Jaune cire"},{"hex":"#fce299","code":"090 90 40","scope":"Design System Plus","de":"Zitronencreme","en":"Lemon cream","nl":"Citroencrème","fr":"Crème au citron"},{"hex":"#fdde82","code":"090 90 50","scope":"Design System Plus","de":"Tigergelb","en":"Tiger yellow","nl":"Tijger geel","fr":"Jaune tigre"},{"hex":"#fedc70","code":"090 90 60","scope":"Design System Plus","de":"Sonnenröschengelb","en":"Sunrose yellow","nl":"Zonnebloem geel","fr":"Jaune tournesol"},{"hex":"#f0ebe0","code":"090 93 05","scope":"Design System Plus","de":"Sahneweiß","en":"Cream white","nl":"Romig wit","fr":"Blanc crème"},{"hex":"#6e6a5d","code":"095 40 10","scope":"Design System Plus","de":"Schattengrün","en":"Shady green","nl":"Schaduwgroen","fr":"Vert ombre"},{"hex":"#71684e","code":"095 40 20","scope":"Design System Plus","de":"Waldgrün","en":"Forest green","nl":"Bosgroen","fr":"Vert forêt"},{"hex":"#726843","code":"095 40 30","scope":"Design System Plus","de":"Bohnengrün","en":"Bean green","nl":"Bonengroen","fr":"Vert de haricot"},{"hex":"#837e70","code":"095 50 10","scope":"Design System Plus","de":"Stumpfoliv","en":"Dull olive","nl":"Stompfolie","fr":"olive à moignon"},{"hex":"#877e62","code":"095 50 20","scope":"Design System Plus","de":"Kohlgrün","en":"Cabbage green","nl":"Kool groen","fr":"Vert choux"},{"hex":"#8b7f54","code":"095 50 30","scope":"Design System Plus","de":"Kaperngrün","en":"Caper green","nl":"Kappertjesgroen","fr":"Vert câpre"},{"hex":"#8d7e45","code":"095 50 40","scope":"Design System Plus","de":"Gartensalatgrün","en":"Garden lettuce green","nl":"Tuin sla","fr":"Vert de salade de jardin"},{"hex":"#8f813c","code":"095 50 50","scope":"Design System Plus","de":"Artischockengrün","en":"Artichoke green","nl":"Artisjok groen","fr":"Vert artichaut"},{"hex":"#9c9686","code":"095 60 10","scope":"Design System Plus","de":"Bleichgrüngrau","en":"Pale green grey","nl":"Lichtgroen-grijs","fr":"Gris vert pâle"},{"hex":"#9f9676","code":"095 60 20","scope":"Design System Plus","de":"Blassgrün","en":"Pale green","nl":"Lichtgroen","fr":"Vert pâle"},{"hex":"#a39565","code":"095 60 30","scope":"Design System Plus","de":"Zypressengrün","en":"Cypress green","nl":"Cypresgroen","fr":"Vert cyprès"},{"hex":"#a59556","code":"095 60 40","scope":"Design System Plus","de":"Traubengrün","en":"Grape green","nl":"Druifgroen","fr":"Vert raisin"},{"hex":"#a69746","code":"095 60 50","scope":"Design System Plus","de":"Stachelbeergrün","en":"Gooseberry green","nl":"Kruisbessengroen","fr":"Vert groseille"},{"hex":"#a59439","code":"095 60 60","scope":"Design System Plus","de":"Guavenfruchtgrün","en":"Guava green","nl":"Guave groen","fr":"Vert goyave"},{"hex":"#a7962a","code":"095 60 70","scope":"Design System Plus","de":"Romanescogrün","en":"Romaine green","nl":"Romanesco groen","fr":"Vert romanesco"},{"hex":"#b6b09e","code":"095 70 10","scope":"Design System Plus","de":"Sandgrau","en":"Sand grey","nl":"Zandgrijs","fr":"Gris sable"},{"hex":"#bab08f","code":"095 70 20","scope":"Design System Plus","de":"Krokodilgrün","en":"Crocodile green","nl":"Krokodil groen","fr":"Vert crocodile"},{"hex":"#beb07e","code":"095 70 30","scope":"Design System Plus","de":"Chicoréegrün","en":"Chicory green","nl":"Witlof","fr":"Vert de chicorée"},{"hex":"#c0af6a","code":"095 70 40","scope":"Design System Plus","de":"Bananengrün","en":"Banana green","nl":"Bananengroen","fr":"Vert banane"},{"hex":"#c0af5c","code":"095 70 50","scope":"Design System Plus","de":"Sternfruchtgelbgrün","en":"Star fruit yellow green","nl":"Sterfruit geelgroen","fr":"Vert fruit de l'étoile"},{"hex":"#c0ae4c","code":"095 70 60","scope":"Design System Plus","de":"Papayagelbgrün","en":"Papaya yellow green","nl":"Papaja geelgroen","fr":"Vert papaye"},{"hex":"#c5b037","code":"095 70 70","scope":"Design System Plus","de":"Bronzegrün","en":"Bronze green","nl":"Bronsgroen","fr":"Vert bronze"},{"hex":"#cfc9b8","code":"095 80 10","scope":"Design System Plus","de":"Saphirlichtgelb","en":"Sapphire light yellow","nl":"Saffier lichtgeel","fr":"Jaune saphir clair"},{"hex":"#d5caa7","code":"095 80 20","scope":"Design System Plus","de":"Blassoliv","en":"Pale olive","nl":"Blassoliv","fr":"Blassoliv"},{"hex":"#dbcc96","code":"095 80 30","scope":"Design System Plus","de":"Spargelgelb","en":"Asparagus yellow","nl":"Asperge geel","fr":"Jaune asperge"},{"hex":"#decb83","code":"095 80 40","scope":"Design System Plus","de":"Erbsengrün","en":"Pea green","nl":"Erwtgroen","fr":"Vert pois"},{"hex":"#deca72","code":"095 80 50","scope":"Design System Plus","de":"Williamsbirnengelb","en":"Williams pear yellow","nl":"Williams peergeel","fr":"Jaune poire williams"},{"hex":"#dcc75f","code":"095 80 60","scope":"Design System Plus","de":"Grünlichgelb","en":"Greenish yellow","nl":"Groenachtig geel","fr":"Jaune verdâtre"},{"hex":"#dfc94b","code":"095 80 70","scope":"Design System Plus","de":"Mimosengelb","en":"Mimosa yellow","nl":"Mimosa geel","fr":"Jaune mimosa"},{"hex":"#dac438","code":"095 80 80","scope":"Design System Plus","de":"Sorbetgelb","en":"Sorbet yellow","nl":"Sorbetgeel","fr":"Jaune sorbet"},{"hex":"#dcd6c4","code":"095 85 10","scope":"Design System Plus","de":"Schwarzwurzelweiß","en":"Salsify white","nl":"Schorseneren wit","fr":"Blanc de scorsonère"},{"hex":"#e2d7b4","code":"095 85 20","scope":"Design System Plus","de":"Trübhellgelb","en":"Dull light yellow","nl":"Lichtgeel bewolkt","fr":"Jaune pâle trouble"},{"hex":"#e6d6a0","code":"095 85 30","scope":"Design System Plus","de":"Blattgelb","en":"Leaf yellow","nl":"Blad geel","fr":"Jaune feuille"},{"hex":"#ebd78d","code":"095 85 40","scope":"Design System Plus","de":"Naturgelb","en":"Natural yellow","nl":"Natuurlijk geel","fr":"Jaune naturel"},{"hex":"#ecd67c","code":"095 85 50","scope":"Design System Plus","de":"Sportgelb","en":"Sport yellow","nl":"Sport geel","fr":"Jaune sport"},{"hex":"#ece5d0","code":"095 90 10","scope":"Design System Plus","de":"Atlasweiß","en":"Atlas white","nl":"Atlas wit","fr":"Blanc atlas"},{"hex":"#f1e4c0","code":"095 90 20","scope":"Design System Plus","de":"Perlgelb","en":"Pearl yellow","nl":"Parel geel","fr":"Jaune perle"},{"hex":"#f6e3ac","code":"095 90 30","scope":"Design System Plus","de":"Zitroneneisgelb","en":"Lemon ice cream yellow","nl":"Citroen ijsgeel","fr":"Jaune citron glacé"},{"hex":"#f7e297","code":"095 90 40","scope":"Design System Plus","de":"Frischgelb","en":"Fresh yellow","nl":"Fris geel","fr":"Jaune frais"},{"hex":"#fde588","code":"095 90 50","scope":"Design System Plus","de":"Leuchtendgelb","en":"Luminescent yellow","nl":"Lichtgevend geel","fr":"Jaune vif"},{"hex":"#ffe479","code":"095 90 59","scope":"Design System Plus","de":"Dynamischgelb","en":"Dynamic yellow","nl":"Dynamisch geel","fr":"Jaune dynamique"},{"hex":"#eeebe2","code":"095 93 05","scope":"Design System Plus","de":"Kreppseidenweiß","en":"Crepe silk white","nl":"Crepe zijde wit","fr":"Blanc crêpe de soie"},{"hex":"#4a4945","code":"100 20 05","scope":"Design System Plus","de":"Nachtgrün","en":"Night green","nl":"Nachtgroen","fr":"Vert nuit"},{"hex":"#56554f","code":"100 30 05","scope":"Design System Plus","de":"Vulkansteingrün","en":"Volcanic stone green","nl":"Vulkaansteen groen","fr":"Vert pierre volcanique"},{"hex":"#585449","code":"100 30 10","scope":"Design System Plus","de":"Zinnobergrün","en":"Vermilion green","nl":"Vermiljoen groen","fr":"Vert vermillon"},{"hex":"#5a5741","code":"100 30 20","scope":"Design System Plus","de":"Uniformgrün","en":"Uniform green","nl":"Uniform groen","fr":"Vert uniforme"},{"hex":"#6a6962","code":"100 40 05","scope":"Design System Plus","de":"Taubengrau","en":"Doves grey","nl":"Duifgrijs","fr":"Gris pigeon"},{"hex":"#6c695b","code":"100 40 10","scope":"Design System Plus","de":"Schlickgrün","en":"Slick green","nl":"Slibgroen","fr":"Vert barbotine"},{"hex":"#6d694f","code":"100 40 20","scope":"Design System Plus","de":"Brokkoligrün","en":"Broccoli green","nl":"Broccoli groen","fr":"Vert de brocoli"},{"hex":"#706a43","code":"100 40 30","scope":"Design System Plus","de":"Hochwaldgrün","en":"High forest green","nl":"Hoog bosgroen","fr":"Vert forêt"},{"hex":"#716b3b","code":"100 40 40","scope":"Design System Plus","de":"Rosenkohlgrün","en":"Brussels sprout green","nl":"Spruitjes","fr":"Choux de Bruxelles verts"},{"hex":"#817f77","code":"100 50 05","scope":"Design System Plus","de":"Waldbodenkhaki","en":"Forest floor khaki","nl":"Bosbodem kaki","fr":"Kaki des sols forestiers"},{"hex":"#827e6e","code":"100 50 10","scope":"Design System Plus","de":"Kiebitzgraugrün","en":"Lapwing grey green","nl":"Kievit grijsgroen","fr":"Vert gris vanneau"},{"hex":"#848060","code":"100 50 20","scope":"Design System Plus","de":"Grünspechtoliv","en":"Green woodpecker olive","nl":"Groene specht olijf","fr":"Olive du pic vert"},{"hex":"#847e52","code":"100 50 30","scope":"Design System Plus","de":"Steppengrün","en":"Steppe green","nl":"Gewatteerd groen","fr":"Vert steppe"},{"hex":"#888045","code":"100 50 40","scope":"Design System Plus","de":"Faiencegrün","en":"Faience green","nl":"Faience groen","fr":"Vert faïence"},{"hex":"#868039","code":"100 50 50","scope":"Design System Plus","de":"Werkzeuggrün","en":"Tool green","nl":"Gereedschap groen","fr":"Vert outil"},{"hex":"#99978e","code":"100 60 05","scope":"Design System Plus","de":"Rauchgraugrün","en":"Smoky grey green","nl":"Rokerig grijsgroen","fr":"Vert fumé"},{"hex":"#979483","code":"100 60 10","scope":"Design System Plus","de":"Olivingrau","en":"Olivine grey","nl":"Olijfgrijs","fr":"Gris olivine"},{"hex":"#9d9776","code":"100 60 20","scope":"Design System Plus","de":"Grauspechtgrün","en":"Grey-headed woodpecker green","nl":"Grijs espengroen","fr":"Vert pitch gris"},{"hex":"#9d9664","code":"100 60 30","scope":"Design System Plus","de":"Kardamomgrün","en":"Cardamom green","nl":"Kardemom groen","fr":"Vert cardamome"},{"hex":"#9f9857","code":"100 60 40","scope":"Design System Plus","de":"Salatgrün","en":"Lettuce green","nl":"Saladegroenten","fr":"Vert de laitue"},{"hex":"#9f9946","code":"100 60 50","scope":"Design System Plus","de":"Artnouveaugrün","en":"Art Nouveau green","nl":"Artnouveau groen","fr":"Artnouveauvert"},{"hex":"#9b9532","code":"100 60 60","scope":"Design System Plus","de":"Smoothiegrün","en":"Smoothie green","nl":"Smoothie groen","fr":"Vert smoothie"},{"hex":"#b3b1a8","code":"100 70 05","scope":"Design System Plus","de":"Rauchweiß","en":"Smoky white","nl":"Rookwit","fr":"Blanc fumé"},{"hex":"#b4b09e","code":"100 70 10","scope":"Design System Plus","de":"Anisgraugelb","en":"Anise grey yellow","nl":"Anijs grijs geel","fr":"Jaune anis"},{"hex":"#b6b08d","code":"100 70 20","scope":"Design System Plus","de":"Sandbraun","en":"Sand brown","nl":"Zandbruin","fr":"Marron sable"},{"hex":"#b6b07b","code":"100 70 30","scope":"Design System Plus","de":"Hippiegrün","en":"Hippie green","nl":"Hippie groen","fr":"Vert hippie"},{"hex":"#bab26c","code":"100 70 40","scope":"Design System Plus","de":"Lindgrün","en":"Linden green","nl":"Limoengroen","fr":"Vert tilleul"},{"hex":"#b8af57","code":"100 70 50","scope":"Design System Plus","de":"Dillgrün","en":"Dill green","nl":"Dille groen","fr":"Vert aneth"},{"hex":"#b6af44","code":"100 70 60","scope":"Design System Plus","de":"Neugrün","en":"New green","nl":"Nieuw groen","fr":"Vert nouveau"},{"hex":"#cac9bf","code":"100 80 05","scope":"Design System Plus","de":"Naturgrau","en":"Natural grey","nl":"Natuurlijk grijs","fr":"Gris naturel"},{"hex":"#cecab5","code":"100 80 10","scope":"Design System Plus","de":"Blassbeige","en":"Pale beige","nl":"Licht beige","fr":"Beige pâle"},{"hex":"#d4cca7","code":"100 80 20","scope":"Design System Plus","de":"Weichgrün","en":"Soft green","nl":"Zacht groen","fr":"Vert tendre"},{"hex":"#d3ca93","code":"100 80 30","scope":"Design System Plus","de":"Silbergrün","en":"Silver green","nl":"Zilvergroen","fr":"Vert argenté"},{"hex":"#d4cb81","code":"100 80 40","scope":"Design System Plus","de":"Märztulpengrün","en":"March tulip green","nl":"Maart tulp groen","fr":"Vert tulipe de mars"},{"hex":"#d4cb6e","code":"100 80 50","scope":"Design System Plus","de":"Leichtoliv","en":"Light olive","nl":"Licht olijf","fr":"Olive légère"},{"hex":"#d9cd5b","code":"100 80 60","scope":"Design System Plus","de":"Reklamegrün","en":"Advertisement green","nl":"Groen adverteren","fr":"Vert de la publicité"},{"hex":"#d8cd48","code":"100 80 70","scope":"Design System Plus","de":"LEDgrün","en":"LED green","nl":"LED groen","fr":"LED verte"},{"hex":"#d5ce33","code":"100 80 80","scope":"Design System Plus","de":"Märzgrün","en":"March green","nl":"Maart groen","fr":"Vert mars"},{"hex":"#d9d7cd","code":"100 85 05","scope":"Design System Plus","de":"Sellerieweiß","en":"Celery white","nl":"Selderij wit","fr":"Blanc de céleri"},{"hex":"#dbd6c2","code":"100 85 10","scope":"Design System Plus","de":"Palmherzencreme","en":"Palm heart cream","nl":"Palmhartcrème","fr":"Crème de cœur de palmier"},{"hex":"#ddd6b0","code":"100 85 20","scope":"Design System Plus","de":"Beigegrün","en":"Beige green","nl":"Beige groen","fr":"Vert beige"},{"hex":"#e1d7a0","code":"100 85 30","scope":"Design System Plus","de":"Kristallgelb","en":"Crystal yellow","nl":"Kristalgeel","fr":"Jaune cristal"},{"hex":"#e8e5d9","code":"100 90 05","scope":"Design System Plus","de":"Brillantgelb","en":"Brilliant yellow","nl":"Briljant geel","fr":"Jaune brillant"},{"hex":"#eae5d1","code":"100 90 10","scope":"Design System Plus","de":"Holunderweiß","en":"Elderberry white","nl":"Vlierbes wit","fr":"Blanc sureau"},{"hex":"#eee5bf","code":"100 90 20","scope":"Design System Plus","de":"Designercremegelb","en":"Designer cream yellow","nl":"Designer crème geel","fr":"Jaune crème de designer"},{"hex":"#eee4aa","code":"100 90 30","scope":"Design System Plus","de":"Buchsbaumgelb","en":"Boxwood yellow","nl":"Buxus geel","fr":"Jaune buis"},{"hex":"#f3e699","code":"100 90 40","scope":"Design System Plus","de":"Primelgelb","en":"Primrose yellow","nl":"Primula geel","fr":"Jaune primevère"},{"hex":"#f1e586","code":"100 90 50","scope":"Design System Plus","de":"Frühlingsgelb","en":"Spring yellow","nl":"Lente geel","fr":"Jaune printemps"},{"hex":"#efede3","code":"100 93 05","scope":"Design System Plus","de":"Nebelweiß","en":"Fog white","nl":"Mistig wit","fr":"Blanc de brume"},{"hex":"#484840","code":"110 20 10","scope":"Design System Plus","de":"Metallbaugrün","en":"Metal construction green","nl":"Metalen constructie groen","fr":"Vert construction métallique"},{"hex":"#57574c","code":"110 30 10","scope":"Design System Plus","de":"Dunkelolivgrün","en":"Dark olive green","nl":"Donker olijfgroen","fr":"Vert olive foncé"},{"hex":"#585945","code":"110 30 20","scope":"Design System Plus","de":"Norialgenschwarzgrün","en":"Nori seaweed green","nl":"Norialgen zwart groen","fr":"Vert norialgen noir"},{"hex":"#6a6b5d","code":"110 40 10","scope":"Design System Plus","de":"Stumpfgrün","en":"Stump green","nl":"Stomp groen","fr":"Vert terne"},{"hex":"#67694d","code":"110 40 20","scope":"Design System Plus","de":"Antikgrün","en":"Antique green","nl":"Antiek groen","fr":"Vert antique"},{"hex":"#696c46","code":"110 40 30","scope":"Design System Plus","de":"Gärtnergrün","en":"Gardener green","nl":"Groen van de tuinman","fr":"Vert jardinier"},{"hex":"#686e3c","code":"110 40 40","scope":"Design System Plus","de":"Kirchnergrün","en":"Kirchner green","nl":"Kersengroen","fr":"Vert cerise"},{"hex":"#7f7f70","code":"110 50 10","scope":"Design System Plus","de":"Novembergrün","en":"November green","nl":"November groen","fr":"Vert novembre"},{"hex":"#7e8061","code":"110 50 20","scope":"Design System Plus","de":"Alexandritgrün","en":"Alexandrite green","nl":"Alexandriet groen","fr":"Vert alexandrite"},{"hex":"#7d8153","code":"110 50 30","scope":"Design System Plus","de":"Pflanzengrün","en":"Plant green","nl":"Plant groen","fr":"Vert végétal"},{"hex":"#7b8244","code":"110 50 40","scope":"Design System Plus","de":"Reifegrün","en":"Ripe green","nl":"Rijp groen","fr":"Vert mûr"},{"hex":"#79833a","code":"110 50 50","scope":"Design System Plus","de":"Portugalgrün","en":"Portuguese green","nl":"Portugal groen","fr":"Vert Portugal"},{"hex":"#798533","code":"110 50 55","scope":"Design System Plus","de":"Flaggengrün","en":"Flag green","nl":"Vlag groen","fr":"Vert drapeau"},{"hex":"#959685","code":"110 60 10","scope":"Design System Plus","de":"Graugrün","en":"Grey green","nl":"Grijsgroen","fr":"Vert gris"},{"hex":"#939777","code":"110 60 20","scope":"Design System Plus","de":"Erbsenschotengrün","en":"Peapod green","nl":"Erwtenpeul groen","fr":"Vert des cosses de pois"},{"hex":"#969a69","code":"110 60 30","scope":"Design System Plus","de":"Indischgrün","en":"Indian green","nl":"Indiaas groen","fr":"Vert indien"},{"hex":"#929a58","code":"110 60 40","scope":"Design System Plus","de":"Blatterbsengrün","en":"Winterpea green","nl":"Blad erwtgroen","fr":"Vert pois de senteur"},{"hex":"#909c49","code":"110 60 50","scope":"Design System Plus","de":"Airlinegrün","en":"Airline green","nl":"Groene luchtvaartmaatschappij","fr":"Vert Airline"},{"hex":"#909f3b","code":"110 60 60","scope":"Design System Plus","de":"Waldmeistergrün","en":"Woodruff green","nl":"Bosgroen","fr":"Vert sylvestre"},{"hex":"#91a033","code":"110 60 65","scope":"Design System Plus","de":"Ampelgrün","en":"Traffic light green","nl":"Verkeerslicht groen","fr":"Vert feu de signalisation"},{"hex":"#b0b19e","code":"110 70 10","scope":"Design System Plus","de":"Chinateegrün","en":"Chinese tea green","nl":"China groen","fr":"Vert chinois"},{"hex":"#afb28e","code":"110 70 20","scope":"Design System Plus","de":"Wandgrün","en":"Wall green","nl":"Muur groen","fr":"Vert mural"},{"hex":"#acb17d","code":"110 70 30","scope":"Design System Plus","de":"Wasabigrün","en":"Wasabi green","nl":"Wasabi groen","fr":"Vert wasabi"},{"hex":"#acb46e","code":"110 70 40","scope":"Design System Plus","de":"Aprilgrün","en":"April green","nl":"April groen","fr":"Vert d'avril"},{"hex":"#acb65d","code":"110 70 50","scope":"Design System Plus","de":"Delaunaygrün","en":"Delaunay green","nl":"Delaunay groen","fr":"Vert Delaunay"},{"hex":"#a8b64c","code":"110 70 60","scope":"Design System Plus","de":"Limettengrün","en":"Lime green","nl":"Limoengroen","fr":"Vert citron"},{"hex":"#a1b62b","code":"110 70 70","scope":"Design System Plus","de":"Chlorophyllgrün","en":"Chlorophyll green","nl":"Groen chlorofyl","fr":"Vert chlorophylle"},{"hex":"#a0b42d","code":"110 70 77","scope":"Design System Plus","de":"Markergrün","en":"Marker green","nl":"Markeerstift groen","fr":"Vert marqueur"},{"hex":"#c7c9b7","code":"110 80 10","scope":"Design System Plus","de":"Frühlingsgrau","en":"Spring grey","nl":"Lente grijs","fr":"Gris printemps"},{"hex":"#cbcca7","code":"110 80 20","scope":"Design System Plus","de":"Minzeisgrün","en":"Mint ice green","nl":"Mint ijsgroen","fr":"Vert menthe à l'eau"},{"hex":"#c9ce95","code":"110 80 30","scope":"Design System Plus","de":"Lenzgrün","en":"Springtide green","nl":"Lenzgrün","fr":"Vert Lenz"},{"hex":"#c7cf84","code":"110 80 40","scope":"Design System Plus","de":"Limettensorbetgrün","en":"Lime sorbet green","nl":"Linde sorbetgroen","fr":"Vert sorbet citron vert"},{"hex":"#c8d172","code":"110 80 50","scope":"Design System Plus","de":"Ostergrün","en":"Easter green","nl":"Paasgroen","fr":"Vert de Pâques"},{"hex":"#c4d160","code":"110 80 60","scope":"Design System Plus","de":"Clowngrün","en":"Clown green","nl":"Clown groen","fr":"Vert clown"},{"hex":"#c2d24c","code":"110 80 70","scope":"Design System Plus","de":"Saftgrün","en":"Juice green","nl":"Sap groen","fr":"Vert jus"},{"hex":"#d5d6c3","code":"110 85 10","scope":"Design System Plus","de":"Veltlinerweiß","en":"Veltliner white","nl":"Veltliner wit","fr":"Blanc de veltliner"},{"hex":"#d5d7b1","code":"110 85 20","scope":"Design System Plus","de":"Kohlrabigrün","en":"Kohlrabi green","nl":"Koolrabi groen","fr":"Vert chou-rave"},{"hex":"#d7daa1","code":"110 85 30","scope":"Design System Plus","de":"Burgundergrau","en":"Burgundy grey","nl":"Bourgondisch grijs","fr":"Gris bourgogne"},{"hex":"#d5da8e","code":"110 85 40","scope":"Design System Plus","de":"Wachsgrün","en":"Wax green","nl":"Was groen","fr":"Vert cire"},{"hex":"#d2da7a","code":"110 85 50","scope":"Design System Plus","de":"Sprossengrün","en":"Sprout green","nl":"Kiemgroen","fr":"Vert pousses"},{"hex":"#e4e2d7","code":"110 90 05","scope":"Design System Plus","de":"Baumwollweiß","en":"Cotton white","nl":"Katoen wit","fr":"Blanc coton"},{"hex":"#e6e6d2","code":"110 90 10","scope":"Design System Plus","de":"Farnhellgrün","en":"Light fern green","nl":"Varen lichtgroen","fr":"Vert fougère clair"},{"hex":"#e6e7bf","code":"110 90 20","scope":"Design System Plus","de":"Lilienduftgrün","en":"Lily scent green","nl":"Leliegeurend groen","fr":"Vert parfum de lys"},{"hex":"#e5e7ac","code":"110 90 30","scope":"Design System Plus","de":"Kiwieisgrün","en":"Kiwi ice cream green","nl":"Kiwi ijsgroen","fr":"Vert kiwi"},{"hex":"#e4e99b","code":"110 90 40","scope":"Design System Plus","de":"Limettensaftgrün","en":"Lime juice green","nl":"Limoensap groen","fr":"Vert jus de citron vert"},{"hex":"#ebebe1","code":"110 93 05","scope":"Design System Plus","de":"Bastweiß","en":"Raffia white","nl":"Bast wit","fr":"Blanc bâtard"},{"hex":"#f4f3ef","code":"110 96 02","scope":"Design System Plus","de":"Waschweiß","en":"Laundry white","nl":"Wit wassen","fr":"Blanc de lavage"},{"hex":"#545650","code":"120 30 05","scope":"Design System Plus","de":"Racinggrün","en":"Racing green","nl":"Racegroen","fr":"Vert Racing"},{"hex":"#53574b","code":"120 30 10","scope":"Design System Plus","de":"Landhausgrün","en":"Country house green","nl":"Landhuis groen","fr":"Vert campagne"},{"hex":"#515842","code":"120 30 20","scope":"Design System Plus","de":"Avocadodunkelgrün","en":"Avocado dark green","nl":"Avocado donkergroen","fr":"Vert foncé d'avocat"},{"hex":"#686962","code":"120 40 05","scope":"Design System Plus","de":"Englischgrün","en":"English green","nl":"Engels groen","fr":"Vert anglais"},{"hex":"#66695b","code":"120 40 10","scope":"Design System Plus","de":"Mandelgrün","en":"Almond green","nl":"Amandelgroen","fr":"Vert amande"},{"hex":"#636b51","code":"120 40 20","scope":"Design System Plus","de":"Kaktusgrün","en":"Cactus green","nl":"Cactusgroen","fr":"Vert cactus"},{"hex":"#626e48","code":"120 40 30","scope":"Design System Plus","de":"Basilikumgrün","en":"Basil green","nl":"Basilicumgroen","fr":"Vert basilic"},{"hex":"#5c703b","code":"120 40 40","scope":"Design System Plus","de":"Paprikagrün","en":"Pepper green","nl":"Paprikagroen","fr":"Vert de paprika"},{"hex":"#7e7f77","code":"120 50 05","scope":"Design System Plus","de":"Rauchgrün","en":"Smoke green","nl":"Rookgroen","fr":"Vert fumée"},{"hex":"#7b8071","code":"120 50 10","scope":"Design System Plus","de":"Samtgrüngrau","en":"Velvet green grey","nl":"Fluweelgroen grijs","fr":"Gris vert velours"},{"hex":"#788262","code":"120 50 20","scope":"Design System Plus","de":"Papageiengrün","en":"Parrot green","nl":"Papegaaiengroen","fr":"Vert perroquet"},{"hex":"#758254","code":"120 50 30","scope":"Design System Plus","de":"Quarzgrün","en":"Quartz green","nl":"Kwartsgroen","fr":"Vert quartz"},{"hex":"#72864c","code":"120 50 40","scope":"Design System Plus","de":"Heckengrün","en":"Hedge green","nl":"Heggengroen","fr":"Feuillage des haies"},{"hex":"#6c863e","code":"120 50 50","scope":"Design System Plus","de":"Birkenblattgrün","en":"Birch leaf green","nl":"Berkenblad groen","fr":"Vert feuille de bouleau"},{"hex":"#979a90","code":"120 60 05","scope":"Design System Plus","de":"Bläulichgrau","en":"Bluish grey","nl":"Blauwachtig grijs","fr":"Gris bleuté"},{"hex":"#929787","code":"120 60 10","scope":"Design System Plus","de":"Lavendelblattgrün","en":"Lavender leaf green","nl":"Lavendelblad groen","fr":"Vert feuille de lavande"},{"hex":"#909978","code":"120 60 20","scope":"Design System Plus","de":"Mostbirnengrün","en":"Cider pear green","nl":"Cider peer groen","fr":"Vert poire à cidre"},{"hex":"#8c9d6b","code":"120 60 30","scope":"Design System Plus","de":"Vesuviangrün","en":"Vesuvian green","nl":"Vesuviaans groen","fr":"Vert vesuviane"},{"hex":"#899f5d","code":"120 60 40","scope":"Design System Plus","de":"Bambusgrasgrün","en":"Bamboo grass green","nl":"Bamboegras groen","fr":"Vert herbe de bambou"},{"hex":"#83a04d","code":"120 60 50","scope":"Design System Plus","de":"Aloeveragrün","en":"Aloe vera green","nl":"Aloë vera groen","fr":"Vert aloès"},{"hex":"#7da03e","code":"120 60 60","scope":"Design System Plus","de":"Mambagrün","en":"Mamba green","nl":"Mambagroen","fr":"Vert Mamba"},{"hex":"#7ca23d","code":"120 60 63","scope":"Design System Plus","de":"Leuchtendgrün","en":"Luminescent green","nl":"Lichtgevend groen","fr":"Vert vif"},{"hex":"#afb1a7","code":"120 70 05","scope":"Design System Plus","de":"Lorbeergrau","en":"Laurel grey","nl":"Laurier grijs","fr":"Gris laurier"},{"hex":"#acb19e","code":"120 70 10","scope":"Design System Plus","de":"Nilgrün","en":"Nile green","nl":"Nijlgroen","fr":"Vert Nil"},{"hex":"#a8b38f","code":"120 70 20","scope":"Design System Plus","de":"Filigrangrün","en":"Filigree green","nl":"Filigraan groen","fr":"Vert filigrane"},{"hex":"#a6b682","code":"120 70 30","scope":"Design System Plus","de":"Serpentingrün","en":"Serpentine green","nl":"Serpentijn groen","fr":"Vert serpentin"},{"hex":"#a1b872","code":"120 70 40","scope":"Design System Plus","de":"Birkenhellgrün","en":"Light birch green","nl":"Berk lichtgroen","fr":"Bouleau vert clair"},{"hex":"#9cb960","code":"120 70 50","scope":"Design System Plus","de":"Waldrebengrün","en":"Clematis green","nl":"Clematissen groen","fr":"Vert saule des bois"},{"hex":"#95b751","code":"120 70 60","scope":"Design System Plus","de":"Turmalingrün","en":"Tourmaline green","nl":"Toermalijn groen","fr":"Vert tourmaline"},{"hex":"#92bc42","code":"120 70 70","scope":"Design System Plus","de":"Cocktailgrün","en":"Cocktail green","nl":"Cocktail groen","fr":"Vert cocktail"},{"hex":"#8db836","code":"120 70 75","scope":"Design System Plus","de":"Brillantgrün","en":"Brilliant green","nl":"Briljant groen","fr":"Vert brillant"},{"hex":"#c8cbc1","code":"120 80 05","scope":"Design System Plus","de":"Staubgrün","en":"Dust green","nl":"Stof groen","fr":"Vert poussière"},{"hex":"#c5cab6","code":"120 80 10","scope":"Design System Plus","de":"Jugendstilgrün","en":"Modern Style green","nl":"Art Nouveau groen","fr":"Vert art nouveau"},{"hex":"#c4cea9","code":"120 80 20","scope":"Design System Plus","de":"Avocadocreme","en":"Avocado cream","nl":"Avocadocrème","fr":"Crème d'avocat"},{"hex":"#becf97","code":"120 80 30","scope":"Design System Plus","de":"Naturgrün","en":"Natural green","nl":"Natuurlijk groen","fr":"Vert naturel"},{"hex":"#bbd289","code":"120 80 40","scope":"Design System Plus","de":"Sommergrün","en":"Summer green","nl":"Zomergroen","fr":"Vert d'été"},{"hex":"#b6d478","code":"120 80 50","scope":"Design System Plus","de":"Modegrün","en":"Fashion green","nl":"Groene mode","fr":"Vert mode"},{"hex":"#b1d669","code":"120 80 60","scope":"Design System Plus","de":"Neongrün","en":"Neon green","nl":"Neongroen","fr":"Vert fluo"},{"hex":"#d4d6cc","code":"120 85 05","scope":"Design System Plus","de":"Kreidegrün","en":"Chalk green","nl":"Krijtgroen","fr":"Vert craie"},{"hex":"#d1d7c4","code":"120 85 10","scope":"Design System Plus","de":"Federleichtgrün","en":"Light feather green","nl":"Vederlicht groen","fr":"Vert plume"},{"hex":"#d0dab4","code":"120 85 20","scope":"Design System Plus","de":"Seegrün","en":"Lake green","nl":"Zeegroen","fr":"Vert de mer"},{"hex":"#ccdba2","code":"120 85 30","scope":"Design System Plus","de":"Aquagrün","en":"Aqua green","nl":"Aqua groen","fr":"Vert aqua"},{"hex":"#e2e4d9","code":"120 90 05","scope":"Design System Plus","de":"Maiglöckchenweiß","en":"Lily of the valley white","nl":"Lelietje-van-dalen wit","fr":"Blanc muguet"},{"hex":"#e4e7d3","code":"120 90 10","scope":"Design System Plus","de":"Hellpistazie","en":"Pale pistachio","nl":"Lichte pistache","fr":"Pistache claire"},{"hex":"#dee8c2","code":"120 90 20","scope":"Design System Plus","de":"Kiwisorbetgrün","en":"Kiwi sorbet green","nl":"Kiwisorbet groen","fr":"Vert kiwi"},{"hex":"#daebb1","code":"120 90 30","scope":"Design System Plus","de":"Eiskaltgrün","en":"Ice-cold green","nl":"IJskoud groen","fr":"Vert glacé"},{"hex":"#e9ece1","code":"120 93 05","scope":"Design System Plus","de":"Hauchweißgrün","en":"Touch of white green","nl":"Gebroken wit groen","fr":"Vert pâle blanc"},{"hex":"#53584d","code":"130 30 10","scope":"Design System Plus","de":"Aramealgengrün","en":"Arame seaweed green","nl":"Arameal groen","fr":"Vert algue araméenne"},{"hex":"#4e5945","code":"130 30 20","scope":"Design System Plus","de":"Seetanggrün","en":"Kelp green","nl":"Zeewier groen","fr":"Vert algue"},{"hex":"#666c5f","code":"130 40 10","scope":"Design System Plus","de":"Sanftoliv","en":"Soft olive","nl":"Zachte olijf","fr":"Sanftoliv"},{"hex":"#5d6c53","code":"130 40 20","scope":"Design System Plus","de":"Alpenseegrün","en":"Alpine lake green","nl":"Alpenmeer groen","fr":"Vert des Alpes"},{"hex":"#5a6f4b","code":"130 40 30","scope":"Design System Plus","de":"Edelsteingrün","en":"Gemstone green","nl":"Edelsteen groen","fr":"Vert pierre précieuse"},{"hex":"#788072","code":"130 50 10","scope":"Design System Plus","de":"Dubuffetgrün","en":"Dubuffet green","nl":"Dubuffet groen","fr":"Vert Dubuffet"},{"hex":"#758468","code":"130 50 20","scope":"Design System Plus","de":"Spanischgrün","en":"Spanish green","nl":"Spaans groen","fr":"Vert espagnol"},{"hex":"#6c855b","code":"130 50 30","scope":"Design System Plus","de":"Algengrün","en":"Algae green","nl":"Algen groen","fr":"Vert algue"},{"hex":"#65884f","code":"130 50 40","scope":"Design System Plus","de":"Peperonigrün","en":"Hot pepper green","nl":"Pepperoni groen","fr":"Vert poivron"},{"hex":"#5d8947","code":"130 50 50","scope":"Design System Plus","de":"Smaragdklargrün","en":"Emerald clear green","nl":"Smaragd helder groen","fr":"Vert émeraude clair"},{"hex":"#909989","code":"130 60 10","scope":"Design System Plus","de":"Salbeimattgrün","en":"Matte sage green","nl":"Saliegroen","fr":"Vert imitation sauge"},{"hex":"#8a9b7d","code":"130 60 20","scope":"Design System Plus","de":"Altgrün","en":"Old green","nl":"Oud groen","fr":"Vieux vert"},{"hex":"#839d71","code":"130 60 30","scope":"Design System Plus","de":"Erbsauberginengrün","en":"Pea aubergine green","nl":"Erwt aubergine groen","fr":"Vert aubergine de pois"},{"hex":"#7c9f64","code":"130 60 40","scope":"Design System Plus","de":"Grashüpfergrün","en":"Grasshopper green","nl":"Sprinkhaan groen","fr":"Vert sauterelle"},{"hex":"#74a256","code":"130 60 50","scope":"Design System Plus","de":"Parisergrün","en":"Parisian green","nl":"Parijs groen","fr":"Vert parisien"},{"hex":"#69a449","code":"130 60 60","scope":"Design System Plus","de":"Urgrün","en":"Primal green","nl":"Oergroen","fr":"Vert primitif"},{"hex":"#a9b3a3","code":"130 70 10","scope":"Design System Plus","de":"Kalkgrün","en":"Limestone green","nl":"Limoengroen","fr":"Vert chaux"},{"hex":"#a4b695","code":"130 70 20","scope":"Design System Plus","de":"Seifengrün","en":"Soap green","nl":"Zeep groen","fr":"Vert sapin"},{"hex":"#9bb787","code":"130 70 30","scope":"Design System Plus","de":"Aquarellgrün","en":"Watercolour green","nl":"Aquarel groen","fr":"Vert aquarelle"},{"hex":"#94b979","code":"130 70 40","scope":"Design System Plus","de":"Vangoghgrün","en":"Vangogh green","nl":"Vangogh groen","fr":"Vert vangogh"},{"hex":"#8dbc6e","code":"130 70 50","scope":"Design System Plus","de":"Apfelgrün","en":"Apple green","nl":"Appelgroen","fr":"Vert pomme"},{"hex":"#84be5f","code":"130 70 60","scope":"Design System Plus","de":"Ultragrün","en":"Ultra green","nl":"Ultragroen","fr":"Ultra vert"},{"hex":"#c3ccbb","code":"130 80 10","scope":"Design System Plus","de":"Jadehellgrün","en":"Jade light green","nl":"Jade lichtgroen","fr":"Vert jade clair"},{"hex":"#bdcead","code":"130 80 20","scope":"Design System Plus","de":"Emaillegrün","en":"Enamel green","nl":"Groen email","fr":"Vert émail"},{"hex":"#b6d1a0","code":"130 80 30","scope":"Design System Plus","de":"Pastellgrün","en":"Pastel green","nl":"Pastelgroen","fr":"Vert pastel"},{"hex":"#afd592","code":"130 80 40","scope":"Design System Plus","de":"Jasmingrün","en":"Jasmine green","nl":"Jasmijngroen","fr":"Vert jasmin"},{"hex":"#a7d683","code":"130 80 50","scope":"Design System Plus","de":"Kristallgrün","en":"Crystal green","nl":"Kristalgroen","fr":"Vert cristal"},{"hex":"#d1d7cd","code":"130 85 05","scope":"Design System Plus","de":"Traubenölgrün","en":"Grape oil green","nl":"Druivenolie groen","fr":"Vert huile de raisin"},{"hex":"#cfd9c6","code":"130 85 10","scope":"Design System Plus","de":"Duchamplichtgrün","en":"Duchamp light green","nl":"Duchamp lichtgroen","fr":"Vert lumière de Duchamp"},{"hex":"#c9dbb8","code":"130 85 20","scope":"Design System Plus","de":"Bleichhellgrün","en":"Pallid light green","nl":"Lichtgroen","fr":"Vert pâle clair"},{"hex":"#c5deac","code":"130 85 30","scope":"Design System Plus","de":"Viridingrün","en":"Viridine green","nl":"Viridian groen","fr":"Vert viridine"},{"hex":"#e0e4da","code":"130 90 05","scope":"Design System Plus","de":"Silberpappelweiß","en":"Silver poplar white","nl":"Zilverpopulier wit","fr":"Blanc peuplier argenté"},{"hex":"#e0e3d9","code":"130 90 10","scope":"Design System Plus","de":"Mediterrangrün","en":"Mediterranean green","nl":"Mediterraan groen","fr":"Vert Méditerranée"},{"hex":"#d8e9c6","code":"130 90 20","scope":"Design System Plus","de":"Frühlingsgrün","en":"Spring green","nl":"Lentegroen","fr":"Vert printemps"},{"hex":"#e8ece3","code":"130 93 05","scope":"Design System Plus","de":"Bohnenweiß","en":"Bean white","nl":"Bonen wit","fr":"Blanc de haricot"},{"hex":"#454845","code":"140 20 05","scope":"Design System Plus","de":"Melanitschwarzgrün","en":"Melanite black green","nl":"Melaniet zwart-groen","fr":"Vert mélanite noir"},{"hex":"#424941","code":"140 20 10","scope":"Design System Plus","de":"Gebirgsgrün","en":"Mountain range green","nl":"Berggroen","fr":"Vert montagne"},{"hex":"#414b3e","code":"140 20 20","scope":"Design System Plus","de":"Bayrischgrün","en":"Bavarian green","nl":"Beiers groen","fr":"Vert de Bavière"},{"hex":"#555954","code":"140 30 05","scope":"Design System Plus","de":"Schwarzwaldgrün","en":"Black Forest green","nl":"Zwarte Woud groen","fr":"Vert Forêt Noire"},{"hex":"#51594f","code":"140 30 10","scope":"Design System Plus","de":"Kupferkiesgrün","en":"Copper pyrite green","nl":"Chalcopyriet groen","fr":"Vert cuivré"},{"hex":"#4b5c48","code":"140 30 20","scope":"Design System Plus","de":"Brennnesselgrün","en":"Nettle green","nl":"Brandnetel groen","fr":"Vert d'ortie"},{"hex":"#425e3f","code":"140 30 30","scope":"Design System Plus","de":"Edelkastaniengrün","en":"Chestnut green","nl":"Tamme kastanje groen","fr":"Vert châtaigne"},{"hex":"#395e3c","code":"140 30 40","scope":"Design System Plus","de":"Förstergrün","en":"Ranger green","nl":"Förstergrün","fr":"Förstergrün"},{"hex":"#676c66","code":"140 40 05","scope":"Design System Plus","de":"Steingrün","en":"Stone green","nl":"Steengroen","fr":"Vert pierre"},{"hex":"#626c60","code":"140 40 10","scope":"Design System Plus","de":"Lodengrün","en":"Loden green","nl":"Loden groen","fr":"Vert loden"},{"hex":"#586d55","code":"140 40 20","scope":"Design System Plus","de":"Akaziengrün","en":"Acacia green","nl":"Acaciagroen","fr":"Vert acacia"},{"hex":"#51704c","code":"140 40 30","scope":"Design System Plus","de":"Pfaugrün","en":"Peacock green","nl":"Pauwgroen","fr":"Vert paon"},{"hex":"#487547","code":"140 40 40","scope":"Design System Plus","de":"Radikalgrün","en":"Radical green","nl":"Radicaal groen","fr":"Vert radical"},{"hex":"#407740","code":"140 40 50","scope":"Design System Plus","de":"Brasilgrün","en":"Brazilian green","nl":"Brazilië groen","fr":"Vert brésil"},{"hex":"#7a8079","code":"140 50 05","scope":"Design System Plus","de":"Silberahorngrün","en":"Silver maple green","nl":"Groene zilveresdoorn","fr":"Vert érable argenté"},{"hex":"#768174","code":"140 50 10","scope":"Design System Plus","de":"Edeltannengrün","en":"Fir spruce green","nl":"Zilverspar groen","fr":"Vert sapin noble"},{"hex":"#6e8368","code":"140 50 20","scope":"Design System Plus","de":"Silberweidengrün","en":"Silver willow green","nl":"Zilver wilgengroen","fr":"Vert saule argenté"},{"hex":"#65875f","code":"140 50 30","scope":"Design System Plus","de":"Wandergrün","en":"Rambling green","nl":"Groen wandelen","fr":"Vert de marche"},{"hex":"#588853","code":"140 50 40","scope":"Design System Plus","de":"Guineagrün","en":"Guinean green","nl":"Guinea groen","fr":"Vert guinée"},{"hex":"#4f8c4c","code":"140 50 50","scope":"Design System Plus","de":"Bergwiesengrün","en":"Mountain meadow green","nl":"Bergweide groen","fr":"Vert prairie de montagne"},{"hex":"#408e42","code":"140 50 60","scope":"Design System Plus","de":"Temperamentgrün","en":"Temperamental green","nl":"Temperament groen","fr":"Vert de tempérament"},{"hex":"#919791","code":"140 60 05","scope":"Design System Plus","de":"Camouflagegrün","en":"Camouflage green","nl":"Camouflagegroen","fr":"Vert camouflage"},{"hex":"#8b9889","code":"140 60 10","scope":"Design System Plus","de":"Silberlindengrau","en":"Silver linden grey","nl":"Zilver limoengrijs","fr":"Gris tilleul argenté"},{"hex":"#859e80","code":"140 60 20","scope":"Design System Plus","de":"Spinatgrün","en":"Spinach green","nl":"Spinazie groen","fr":"Vert des épinards"},{"hex":"#7ba174","code":"140 60 30","scope":"Design System Plus","de":"Schwarzdorngrün","en":"Blackthorn green","nl":"Sleedoorn groen","fr":"Vert épine noire"},{"hex":"#72a369","code":"140 60 40","scope":"Design System Plus","de":"Frischgrün","en":"Fresh green","nl":"Frisgroen","fr":"Vert frais"},{"hex":"#64a45e","code":"140 60 50","scope":"Design System Plus","de":"Petersiliengrün","en":"Parsley green","nl":"Peterselie groen","fr":"Vert persil"},{"hex":"#59a754","code":"140 60 60","scope":"Design System Plus","de":"Oreganogrün","en":"Oregano green","nl":"Oregano groen","fr":"Vert origan"},{"hex":"#4aa74b","code":"140 60 70","scope":"Design System Plus","de":"Ballongrün","en":"Balloon green","nl":"Ballon groen","fr":"Vert ballon"},{"hex":"#aab0a9","code":"140 70 05","scope":"Design System Plus","de":"Ginkgogrün","en":"Ginkgo green","nl":"Ginkgo groen","fr":"Vert ginkgo"},{"hex":"#a3b1a3","code":"140 70 10","scope":"Design System Plus","de":"Wermutgrün","en":"Wormwood green","nl":"Alsem groen","fr":"Vert absinthe"},{"hex":"#9cb697","code":"140 70 20","scope":"Design System Plus","de":"Taugrün","en":"Dew green","nl":"Dauwgroen","fr":"Vert de rosée"},{"hex":"#91b98c","code":"140 70 30","scope":"Design System Plus","de":"Anisblattgrün","en":"Aniseed leaf green","nl":"Anijsblad groen","fr":"Vert feuille d'anis"},{"hex":"#89bd80","code":"140 70 40","scope":"Design System Plus","de":"Sauergrün","en":"Sour green","nl":"Zuur groen","fr":"Vert acide"},{"hex":"#7cbf74","code":"140 70 50","scope":"Design System Plus","de":"Acidgrün","en":"Acid green","nl":"Zuurgroen","fr":"Vert acide"},{"hex":"#71c067","code":"140 70 60","scope":"Design System Plus","de":"Dropsgrün","en":"Drop green","nl":"Groen laten vallen","fr":"Dropsgrün"},{"hex":"#c5ccc2","code":"140 80 05","scope":"Design System Plus","de":"Weidengrün","en":"Willow green","nl":"Wilgengroen","fr":"Vert saule"},{"hex":"#bfccbc","code":"140 80 10","scope":"Design System Plus","de":"Pastellgraugrün","en":"Pastel grey green","nl":"Pastel grijsgroen","fr":"Vert gris pastel"},{"hex":"#b6d0b0","code":"140 80 20","scope":"Design System Plus","de":"Giopontigrün","en":"Gio Ponti green","nl":"Gioponti groen","fr":"Vert Gioponti"},{"hex":"#abd3a4","code":"140 80 30","scope":"Design System Plus","de":"Entspannungsgrün","en":"Relaxation green","nl":"Ontspannend groen","fr":"Vert de détente"},{"hex":"#9dd697","code":"140 80 40","scope":"Design System Plus","de":"Dentistgrün","en":"Dentist green","nl":"Tandarts groen","fr":"Vert Dentist"},{"hex":"#d0d8cf","code":"140 85 05","scope":"Design System Plus","de":"Taubnesselweiß","en":"Deadnettle white","nl":"Dode brandnetel wit","fr":"Blanc d'ortie"},{"hex":"#ccdaca","code":"140 85 10","scope":"Design System Plus","de":"Lauchweiß","en":"Leek white","nl":"Prei wit","fr":"Blanc poireau"},{"hex":"#c3debd","code":"140 85 20","scope":"Design System Plus","de":"Kalkschiefer","en":"Limestone slate","nl":"Kalkhoudende schalie","fr":"Schiste calcaire"},{"hex":"#b6dfb0","code":"140 85 30","scope":"Design System Plus","de":"Minzcocktailgrün","en":"Mint cocktail green","nl":"Munt cocktail groen","fr":"Vert cocktail à la menthe"},{"hex":"#e0e6db","code":"140 90 05","scope":"Design System Plus","de":"Rosmarinweiß","en":"Rosemary white","nl":"Rozemarijn wit","fr":"Blanc romarin"},{"hex":"#dce8d6","code":"140 90 10","scope":"Design System Plus","de":"Hauchgrün","en":"Touch of green","nl":"Lichtgroen","fr":"Vert pâle"},{"hex":"#e8eee4","code":"140 93 05","scope":"Design System Plus","de":"Kastanienweiß","en":"Chestnut white","nl":"Kastanje wit","fr":"Blanc châtaigne"},{"hex":"#515c53","code":"150 30 10","scope":"Design System Plus","de":"Thymiangrün","en":"Thyme green","nl":"Tijm groen","fr":"Vert thym"},{"hex":"#475e4e","code":"150 30 20","scope":"Design System Plus","de":"Moselgrün","en":"Moselle green","nl":"Moezel groen","fr":"Vert Moselle"},{"hex":"#3d5e46","code":"150 30 30","scope":"Design System Plus","de":"Berggrün","en":"Mountain green","nl":"Berggroen","fr":"Vert montagne"},{"hex":"#616d63","code":"150 40 10","scope":"Design System Plus","de":"Filzgrün","en":"Felt green","nl":"Vilt groen","fr":"Vert feutre"},{"hex":"#58715c","code":"150 40 20","scope":"Design System Plus","de":"Prallgrün","en":"Firm green","nl":"Invloed groen","fr":"Vert perle"},{"hex":"#4a7254","code":"150 40 30","scope":"Design System Plus","de":"Genevergrün","en":"Genever green","nl":"Jenever groen","fr":"Vert genièvre"},{"hex":"#3c744c","code":"150 40 40","scope":"Design System Plus","de":"Tintengrün","en":"Ink green","nl":"Inkt groen","fr":"Vert d'encre"},{"hex":"#307649","code":"150 40 50","scope":"Design System Plus","de":"Irlandgrün","en":"Ireland green","nl":"Ierland groen","fr":"Vert Irlande"},{"hex":"#738176","code":"150 50 10","scope":"Design System Plus","de":"Salbeigrüngrau","en":"Sage green grey","nl":"Saliegroen grijs","fr":"Gris vert sauge"},{"hex":"#69866e","code":"150 50 20","scope":"Design System Plus","de":"Koreaminze","en":"Korean mint","nl":"Koreaanse munt","fr":"Menthe coréenne"},{"hex":"#608866","code":"150 50 30","scope":"Design System Plus","de":"Feldgrün","en":"Field green","nl":"Veld groen","fr":"Vert champ"},{"hex":"#518d63","code":"150 50 40","scope":"Design System Plus","de":"Selleriegrün","en":"Celery green","nl":"Selderij groen","fr":"Vert céleri"},{"hex":"#3e8f58","code":"150 50 50","scope":"Design System Plus","de":"Sattgrün","en":"Rich green","nl":"Weelderig groen","fr":"Vert saturé"},{"hex":"#239151","code":"150 50 60","scope":"Design System Plus","de":"Kaltgrün","en":"Cold green","nl":"Koud groen","fr":"Vert froid"},{"hex":"#8c9b8e","code":"150 60 10","scope":"Design System Plus","de":"Spitzkohlgrün","en":"Pointed cabbage green","nl":"Spitskool groen","fr":"Chou pointu vert"},{"hex":"#7f9e86","code":"150 60 20","scope":"Design System Plus","de":"Orientgrün","en":"Orient green","nl":"Oosters groen","fr":"Vert d'Orient"},{"hex":"#73a07d","code":"150 60 30","scope":"Design System Plus","de":"Rosmaringrün","en":"Rosemary green","nl":"Rozemarijn groen","fr":"Vert romarin"},{"hex":"#65a474","code":"150 60 40","scope":"Design System Plus","de":"Mosaikgrün","en":"Mosaic green","nl":"Mozaïek groen","fr":"Vert mosaïque"},{"hex":"#58a96f","code":"150 60 50","scope":"Design System Plus","de":"Flummigrün","en":"Bouncy ball green","nl":"Flodderig groen","fr":"Vert fluo"},{"hex":"#3aa861","code":"150 60 60","scope":"Design System Plus","de":"Energiegrün","en":"Energy green","nl":"Groene energie","fr":"Vert d'énergie"},{"hex":"#a3b3a6","code":"150 70 10","scope":"Design System Plus","de":"Teegrün","en":"Tea green","nl":"Groene thee","fr":"Vert thé"},{"hex":"#98b89f","code":"150 70 20","scope":"Design System Plus","de":"Liebermanngrün","en":"Liebermann green","nl":"Liebermann groen","fr":"Vert Liebermann"},{"hex":"#8abd95","code":"150 70 30","scope":"Design System Plus","de":"Wachstuchgrün","en":"Oilcloth green","nl":"Tafelzeil groen","fr":"Toile cirée verte"},{"hex":"#7cbe8c","code":"150 70 40","scope":"Design System Plus","de":"Jadesteingrün","en":"Jade stone green","nl":"Jade steen groen","fr":"Vert jade"},{"hex":"#6cc181","code":"150 70 50","scope":"Design System Plus","de":"Grünspanfarben","en":"Verdigris coloured","nl":"verdigris kleuren","fr":"Couleurs vert-de-gris"},{"hex":"#bdcec0","code":"150 80 10","scope":"Design System Plus","de":"Organzagrün","en":"Organza green","nl":"Organza groen","fr":"Vert organza"},{"hex":"#b1d2b7","code":"150 80 20","scope":"Design System Plus","de":"Pastellminzgrün","en":"Pastel mint green","nl":"Pastel mintgroen","fr":"Vert menthe pastel"},{"hex":"#a3d6af","code":"150 80 30","scope":"Design System Plus","de":"Knallgrün","en":"Bright green","nl":"Heldergroen","fr":"Vert vif"},{"hex":"#95daa5","code":"150 80 40","scope":"Design System Plus","de":"Perlmuttgrün","en":"Mother-of-pearl green","nl":"Parelmoer groen","fr":"Vert nacré"},{"hex":"#ccd7ce","code":"150 85 05","scope":"Design System Plus","de":"Spargelweiß","en":"Asparagus white","nl":"Asperges wit","fr":"Blanc asperge"},{"hex":"#c9daca","code":"150 85 10","scope":"Design System Plus","de":"Transparentweiß","en":"Transparent white","nl":"Transparant wit","fr":"Blanc transparent"},{"hex":"#bfdec1","code":"150 85 20","scope":"Design System Plus","de":"Bleichgrün","en":"Pallid green","nl":"Lichtgroen","fr":"Vert pâle"},{"hex":"#dce5da","code":"150 90 05","scope":"Design System Plus","de":"Mineralweiß","en":"Mineral white","nl":"Mineraal wit","fr":"Blanc minéral"},{"hex":"#d9e9d8","code":"150 90 10","scope":"Design System Plus","de":"Alabastergrün","en":"Alabaster green","nl":"Albastgroen","fr":"Vert albâtre"},{"hex":"#e4ede4","code":"150 93 05","scope":"Design System Plus","de":"Quarkweiß","en":"Quark white","nl":"Kwark wit","fr":"Blancheur de fromage blanc"},{"hex":"#464a48","code":"160 20 05","scope":"Design System Plus","de":"Beryllschwarzgrün","en":"Beryl black green","nl":"Beryl zwartgroen","fr":"Vert béryl noir"},{"hex":"#404b45","code":"160 20 10","scope":"Design System Plus","de":"Schalmuschelgrün","en":"Mussel green","nl":"Jacobsschelp groen","fr":"Vert coquille"},{"hex":"#394a43","code":"160 20 15","scope":"Design System Plus","de":"Kürbisgrünschwarz","en":"Pumpkin green black","nl":"Pompoen groen-zwart","fr":"Vert citrouille noir"},{"hex":"#394942","code":"160 20 20","scope":"Design System Plus","de":"Opulentgrün","en":"Opulent green","nl":"Weelderig groen","fr":"Vert opulent"},{"hex":"#535955","code":"160 30 05","scope":"Design System Plus","de":"Sattoliv","en":"Rich olive","nl":"Sattoliv","fr":"Sattoliv"},{"hex":"#4e5a53","code":"160 30 10","scope":"Design System Plus","de":"Exklusivgrün","en":"Exclusive green","nl":"Exclusief groen","fr":"Vert exclusif"},{"hex":"#485a4f","code":"160 30 15","scope":"Design System Plus","de":"Blattgrün","en":"Leaf green","nl":"Bladgroen","fr":"Vert feuille"},{"hex":"#415a4d","code":"160 30 20","scope":"Design System Plus","de":"Bergminze","en":"Mountain mint","nl":"Bergmunt","fr":"Menthe des montagnes"},{"hex":"#3b5c4a","code":"160 30 25","scope":"Design System Plus","de":"Ordnungsgrün","en":"Order green","nl":"Groen bestellen","fr":"Vert d'ordre"},{"hex":"#345e48","code":"160 30 30","scope":"Design System Plus","de":"Trollgrün","en":"Troll green","nl":"Trollengroen","fr":"Vert troll"},{"hex":"#2c5e45","code":"160 30 35","scope":"Design System Plus","de":"Spieltischgrün","en":"Card table green","nl":"Speltafel groen","fr":"Vert table de jeu"},{"hex":"#235f44","code":"160 30 40","scope":"Design System Plus","de":"Zitronenmelissengrün","en":"Lemon balm green","nl":"Citroenmelisse groen","fr":"Vert mélisse citronnée"},{"hex":"#656c68","code":"160 40 05","scope":"Design System Plus","de":"Jaspisgrün","en":"Jasper green","nl":"Jaspis groen","fr":"Vert jaspe"},{"hex":"#5d6d65","code":"160 40 10","scope":"Design System Plus","de":"Sibirischgrün","en":"Siberian green","nl":"Siberisch groen","fr":"Vert sibérien"},{"hex":"#576e62","code":"160 40 15","scope":"Design System Plus","de":"Gurkengrün","en":"Cucumber green","nl":"Komkommer groen","fr":"Vert concombre"},{"hex":"#506f5f","code":"160 40 20","scope":"Design System Plus","de":"Serbischgrün","en":"Serbian green","nl":"Servisch groen","fr":"Vert serbe"},{"hex":"#49705b","code":"160 40 25","scope":"Design System Plus","de":"Schwarzkiefergrün","en":"Black pine green","nl":"Zwarte dennengroen","fr":"Vert pin noir"},{"hex":"#427259","code":"160 40 30","scope":"Design System Plus","de":"Kürbisgrün","en":"Pumpkin green","nl":"Pompoen groen","fr":"Vert citrouille"},{"hex":"#3a7457","code":"160 40 35","scope":"Design System Plus","de":"Jademuschelgrün","en":"Jade mussel green","nl":"Jade schelp groen","fr":"Vert coquille de jade"},{"hex":"#317656","code":"160 40 40","scope":"Design System Plus","de":"Kleegrün","en":"Clover green","nl":"Klaver groen","fr":"Vert de trèfle"},{"hex":"#287451","code":"160 40 45","scope":"Design System Plus","de":"Froschgrün","en":"Frog green","nl":"Kikkergroen","fr":"Vert grenouille"},{"hex":"#16754e","code":"160 40 50","scope":"Design System Plus","de":"Universalgrün","en":"Universal green","nl":"Universeel groen","fr":"Vert universel"},{"hex":"#05784d","code":"160 40 55","scope":"Design System Plus","de":"Säuleneichengrün","en":"Column of oak green","nl":"Kolom eik groen","fr":"Vert chêne colonnaire"},{"hex":"#79817c","code":"160 50 05","scope":"Design System Plus","de":"Arktisflechtengrün","en":"Arctic lichen green","nl":"Arctisch korstmos groen","fr":"Vert lichen arctique"},{"hex":"#708278","code":"160 50 10","scope":"Design System Plus","de":"Atlaszedergrün","en":"Atlas cedar green","nl":"Atlas cedergroen","fr":"Vert cèdre de l'Atlas"},{"hex":"#6a8476","code":"160 50 15","scope":"Design System Plus","de":"Steinzypressengrün","en":"Stone cypress green","nl":"Steen cipres groen","fr":"Vert cyprès de roche"},{"hex":"#638674","code":"160 50 20","scope":"Design System Plus","de":"Wacholdergrün","en":"Juniper green","nl":"Juniper groen","fr":"Vert de genièvre"},{"hex":"#5b8770","code":"160 50 25","scope":"Design System Plus","de":"Sportplatzgrün","en":"Sports field green","nl":"Sportveld groen","fr":"Espaces verts des terrains de sport"},{"hex":"#54896e","code":"160 50 30","scope":"Design System Plus","de":"Freizeitgrün","en":"Leisure green","nl":"Vrije tijd groen","fr":"Vert de loisirs"},{"hex":"#4e8b6b","code":"160 50 35","scope":"Design System Plus","de":"Adamingrün","en":"Adamite green","nl":"Adamine groen","fr":"Vert adamantin"},{"hex":"#3f8c68","code":"160 50 40","scope":"Design System Plus","de":"Metallgrün","en":"Metallic green","nl":"Metaal groen","fr":"Vert métal"},{"hex":"#398f68","code":"160 50 45","scope":"Design System Plus","de":"Vitalgrün","en":"Vital green","nl":"Vitaal groen","fr":"Vert vital"},{"hex":"#298e62","code":"160 50 50","scope":"Design System Plus","de":"Golfgrün","en":"Golf green","nl":"Golfbaan","fr":"Vert de golf"},{"hex":"#109161","code":"160 50 55","scope":"Design System Plus","de":"Islandgrün","en":"Iceland green","nl":"IJsland groen","fr":"Vert Islande"},{"hex":"#00905c","code":"160 50 60","scope":"Design System Plus","de":"Echttürkis","en":"Real turquoise","nl":"Echt turkoois","fr":"Turquoise véritable"},{"hex":"#8f9893","code":"160 60 05","scope":"Design System Plus","de":"Sandsteingraugrün","en":"Sandstone grey green","nl":"Zandsteen grijsgroen","fr":"Vert grès gris"},{"hex":"#86998f","code":"160 60 10","scope":"Design System Plus","de":"Schiefergrün","en":"Slate green","nl":"Leigroen","fr":"Vert ardoise"},{"hex":"#809d8d","code":"160 60 15","scope":"Design System Plus","de":"Mildgrün","en":"Mild green","nl":"Mild groen","fr":"Vert lait"},{"hex":"#779e89","code":"160 60 20","scope":"Design System Plus","de":"Douglasiengrün","en":"Douglas fir green","nl":"Douglas groen","fr":"Vert douglas"},{"hex":"#709f84","code":"160 60 25","scope":"Design System Plus","de":"Praxisgrün","en":"Practice green","nl":"Oefengreen","fr":"Vert de pratique"},{"hex":"#68a183","code":"160 60 30","scope":"Design System Plus","de":"Memphisgrün","en":"Memphis green","nl":"Memphis groen","fr":"Vert Memphis"},{"hex":"#5fa582","code":"160 60 35","scope":"Design System Plus","de":"Werbegrün","en":"Advertising green","nl":"Reclame groen","fr":"Verdure publicitaire"},{"hex":"#55a47e","code":"160 60 40","scope":"Design System Plus","de":"Jägergrün","en":"Hunter green","nl":"Jagergroen","fr":"Vert chasseur"},{"hex":"#4ca77c","code":"160 60 45","scope":"Design System Plus","de":"Linoleumgrün","en":"Linoleum green","nl":"Linoleum groen","fr":"Vert linoléum"},{"hex":"#3ba878","code":"160 60 50","scope":"Design System Plus","de":"Sittichgrün","en":"Parakeet green","nl":"Parkiet groen","fr":"Vert perruche"},{"hex":"#32a774","code":"160 60 55","scope":"Design System Plus","de":"Smaragdhellgrün","en":"Emerald light green","nl":"Smaragdgroen lichtgroen","fr":"Vert émeraude clair"},{"hex":"#1ca971","code":"160 60 58","scope":"Design System Plus","de":"Alhambragrün","en":"Alhambra green","nl":"Alhambra groen","fr":"Vert alhambra"},{"hex":"#a7b2ac","code":"160 70 05","scope":"Design System Plus","de":"Grünlichgrau","en":"Greenish grey","nl":"Groenachtig grijs","fr":"Gris verdâtre"},{"hex":"#9eb3a7","code":"160 70 10","scope":"Design System Plus","de":"Schwachgrün","en":"Weak green","nl":"Lichtgroen","fr":"Vert faible"},{"hex":"#96b4a3","code":"160 70 15","scope":"Design System Plus","de":"Andeerschiefer","en":"Andean slate","nl":"Andeer leisteen","fr":"Schiste d'Andeer"},{"hex":"#90b7a1","code":"160 70 20","scope":"Design System Plus","de":"Keramikgrün","en":"Ceramic green","nl":"Groen keramiek","fr":"Vert céramique"},{"hex":"#88bb9f","code":"160 70 25","scope":"Design System Plus","de":"Wassergrün","en":"Water green","nl":"Water groen","fr":"Vert d'eau"},{"hex":"#7dbc9c","code":"160 70 30","scope":"Design System Plus","de":"Bergseegrün","en":"Mountain lake green","nl":"Bergmeer groen","fr":"Vert du lac de montagne"},{"hex":"#74bd99","code":"160 70 35","scope":"Design System Plus","de":"Amerikanischgrün","en":"American green","nl":"Amerikaans groen","fr":"Vert américain"},{"hex":"#6ac096","code":"160 70 40","scope":"Design System Plus","de":"Technotürkis","en":"Techno turquoise","nl":"Technoturquoise","fr":"Technotürkis"},{"hex":"#5ec292","code":"160 70 45","scope":"Design System Plus","de":"Grellgrün","en":"Garish green","nl":"Heldergroen","fr":"Vert vif"},{"hex":"#54c391","code":"160 70 50","scope":"Design System Plus","de":"Malachitgrün","en":"Malachite green","nl":"Malachietgroen","fr":"Vert malachite"},{"hex":"#bfcac4","code":"160 80 05","scope":"Design System Plus","de":"Nebelgrün","en":"Fog green","nl":"Mist groen","fr":"Vert brume"},{"hex":"#b8cdc0","code":"160 80 10","scope":"Design System Plus","de":"Jademattgrün","en":"Matte jade green","nl":"Jadegroen","fr":"Vert jade"},{"hex":"#afcfbd","code":"160 80 15","scope":"Design System Plus","de":"Sonnengrün","en":"Sun yellow","nl":"Zon groen","fr":"Vert soleil"},{"hex":"#a7d2ba","code":"160 80 20","scope":"Design System Plus","de":"Federngrün","en":"Feather green","nl":"Veder groen","fr":"Vert plume"},{"hex":"#a1d4b8","code":"160 80 25","scope":"Design System Plus","de":"Mentholgrün","en":"Menthol green","nl":"Menthol groen","fr":"Vert menthol"},{"hex":"#99d7b6","code":"160 80 30","scope":"Design System Plus","de":"Seidengrün","en":"Silk green","nl":"Zijde groen","fr":"Vert soie"},{"hex":"#cad6cf","code":"160 85 05","scope":"Design System Plus","de":"Leichtgrün","en":"Light green","nl":"Lichtgroen","fr":"Vert léger"},{"hex":"#c3d8cc","code":"160 85 10","scope":"Design System Plus","de":"Glimmergrün","en":"Micaceous green","nl":"Mica groen","fr":"Vert mica"},{"hex":"#bbdbc7","code":"160 85 15","scope":"Design System Plus","de":"Mondsteingrün","en":"Moonstone green","nl":"Maansteen groen","fr":"Vert pierre de lune"},{"hex":"#dbe5dc","code":"160 90 05","scope":"Design System Plus","de":"Aquarellweiß","en":"Watercolour white","nl":"Aquarel wit","fr":"Blanc aquarelle"},{"hex":"#d3e8d9","code":"160 90 10","scope":"Design System Plus","de":"Mondscheingrün","en":"Moonlight green","nl":"Maanlicht groen","fr":"Vert clair de lune"},{"hex":"#ccead6","code":"160 90 15","scope":"Design System Plus","de":"Gletscherwassergrün","en":"Glacial water green","nl":"Gletsjerwater groen","fr":"Vert eau de glacier"},{"hex":"#e0ece6","code":"160 93 05","scope":"Design System Plus","de":"Bergkristallsilber","en":"Mountain crystal silver","nl":"Bergkristal zilver","fr":"Argent cristal de roche"},{"hex":"#3e4a46","code":"170 20 10","scope":"Design System Plus","de":"Tiefgrün","en":"Deep green","nl":"Diepgroen","fr":"Vert profond"},{"hex":"#394a45","code":"170 20 15","scope":"Design System Plus","de":"Intensivgrün","en":"Intense green","nl":"Intens groen","fr":"Vert intense"},{"hex":"#334c45","code":"170 20 20","scope":"Design System Plus","de":"Wagengrün","en":"Coach green","nl":"Auto groen","fr":"Vert wagon"},{"hex":"#2f4c42","code":"170 20 25","scope":"Design System Plus","de":"Offroadgrün","en":"Off-road green","nl":"Off-road groen","fr":"Vert offroad"},{"hex":"#4c5b55","code":"170 30 10","scope":"Design System Plus","de":"Granatschwarzgrün","en":"Garnet black green","nl":"Granaat zwart groen","fr":"Vert grenat noir"},{"hex":"#435b52","code":"170 30 15","scope":"Design System Plus","de":"Dunkelgrün","en":"Dark green","nl":"Donkergroen","fr":"Vert foncé"},{"hex":"#3e5b51","code":"170 30 20","scope":"Design System Plus","de":"Distelgrün","en":"Thistle green","nl":"Distel groen","fr":"Vert chardon"},{"hex":"#355e50","code":"170 30 25","scope":"Design System Plus","de":"Himbeerblattgrün","en":"Raspberry leaf green","nl":"Frambozenblad groen","fr":"Vert feuille de framboisier"},{"hex":"#2f5e50","code":"170 30 30","scope":"Design System Plus","de":"Chrysokolldunkelgrün","en":"Chrysocolla dark green","nl":"Chrysocolla donkergroen","fr":"Chrysocolle vert foncé"},{"hex":"#26604f","code":"170 30 35","scope":"Design System Plus","de":"Trappergrün","en":"Trapper green","nl":"Vallenzetter groen","fr":"Vert trappeur"},{"hex":"#16624e","code":"170 30 40","scope":"Design System Plus","de":"Permanentgrün","en":"Permanent green","nl":"Permanent groen","fr":"Vert permanent"},{"hex":"#5b6c65","code":"170 40 10","scope":"Design System Plus","de":"Chalcedongrün","en":"Chalcedony green","nl":"Chalcedoon groen","fr":"Vert calcédoine"},{"hex":"#536d63","code":"170 40 15","scope":"Design System Plus","de":"Schlossgrün","en":"Palace green","nl":"Kasteelgroen","fr":"Vert château"},{"hex":"#4b7063","code":"170 40 20","scope":"Design System Plus","de":"Breitwegerichgrün","en":"Plantain green","nl":"Groenbladige weegbree","fr":"Vert plantain"},{"hex":"#457060","code":"170 40 25","scope":"Design System Plus","de":"Erzgebirgsgrün","en":"Ore mountains green","nl":"Ertsberg groen","fr":"Vert archipel"},{"hex":"#3d7561","code":"170 40 30","scope":"Design System Plus","de":"Traktorgrün","en":"Tractor green","nl":"Trekker groen","fr":"Vert tracteur"},{"hex":"#2f745e","code":"170 40 35","scope":"Design System Plus","de":"Viktoriagrün","en":"Victoria green","nl":"Victoria groen","fr":"Vert victoria"},{"hex":"#20755e","code":"170 40 40","scope":"Design System Plus","de":"Gerätegrün","en":"Device green","nl":"Apparaat groen","fr":"Verdure des appareils"},{"hex":"#08765d","code":"170 40 45","scope":"Design System Plus","de":"Umweltgrün","en":"Environmental green","nl":"Milieuvriendelijk groen","fr":"Vert environnemental"},{"hex":"#00765a","code":"170 40 50","scope":"Design System Plus","de":"Vegangrün","en":"Vegan green","nl":"Veganistisch groen","fr":"Vert végétal"},{"hex":"#6e827b","code":"170 50 10","scope":"Design System Plus","de":"Rödelerzgrün","en":"Bournonite green","nl":"Rödelerzgrün","fr":"Rödelerzgrün"},{"hex":"#67867a","code":"170 50 15","scope":"Design System Plus","de":"Fuchsitgrün","en":"Fuchsite green","nl":"Fuchsietgroen","fr":"Vert fuchsia"},{"hex":"#5f8678","code":"170 50 20","scope":"Design System Plus","de":"Brombeerblattgrün","en":"Blackberry leaf green","nl":"Bramenblad groen","fr":"Vert feuille de ronce"},{"hex":"#568876","code":"170 50 25","scope":"Design System Plus","de":"Turmalinblau","en":"Tourmaline blue","nl":"Toermalijn blauw","fr":"Bleu tourmaline"},{"hex":"#4a8a75","code":"170 50 30","scope":"Design System Plus","de":"Traumgrün","en":"Dream green","nl":"Droomgroen","fr":"Vert de rêve"},{"hex":"#3e8b73","code":"170 50 35","scope":"Design System Plus","de":"Akzentgrünblau","en":"Accent green blue","nl":"Accent groen-blauw","fr":"Bleu vert accentué"},{"hex":"#308d71","code":"170 50 40","scope":"Design System Plus","de":"Spektralgrün","en":"Spectral green","nl":"Spectraal groen","fr":"Vert spectral"},{"hex":"#1e8e71","code":"170 50 45","scope":"Design System Plus","de":"Stockentengrün","en":"Mallard green","nl":"Wilde eend groen","fr":"Vert colvert"},{"hex":"#00916f","code":"170 50 50","scope":"Design System Plus","de":"Chagallgrün","en":"Chagall green","nl":"Chagall groen","fr":"Vert chagall"},{"hex":"#00906d","code":"170 50 55","scope":"Design System Plus","de":"Absinthtürkis","en":"Absinthe turquoise","nl":"Absint turquoise","fr":"Turquoise d'absinthe"},{"hex":"#849a92","code":"170 60 10","scope":"Design System Plus","de":"Quantumgrün","en":"Quantum green","nl":"Kwantumgroen","fr":"Vert quantique"},{"hex":"#7e9d90","code":"170 60 15","scope":"Design System Plus","de":"Bitterkleegrün","en":"Bitter clover green","nl":"Bittere klaver groen","fr":"Vert de trèfle amer"},{"hex":"#739f8f","code":"170 60 20","scope":"Design System Plus","de":"Cyperngrün","en":"Cyprus green","nl":"Cyprus groen","fr":"Vert cyprès"},{"hex":"#6aa08e","code":"170 60 25","scope":"Design System Plus","de":"Saftiggrün","en":"Succulent green","nl":"Sappig groen","fr":"Vert juteux"},{"hex":"#5ea28c","code":"170 60 30","scope":"Design System Plus","de":"Lebendiggrün","en":"Vibrant green","nl":"Groen leven","fr":"Vert vif"},{"hex":"#50a68a","code":"170 60 35","scope":"Design System Plus","de":"Klimtgrün","en":"Klimt green","nl":"Klimt groen","fr":"Vert climat"},{"hex":"#44a689","code":"170 60 40","scope":"Design System Plus","de":"Persischgrün","en":"Persian green","nl":"Perzisch groen","fr":"Vert persan"},{"hex":"#33a685","code":"170 60 45","scope":"Design System Plus","de":"Sportgrün","en":"Sport green","nl":"Sportief groen","fr":"Vert sport"},{"hex":"#1baa87","code":"170 60 50","scope":"Design System Plus","de":"Aktivgrün","en":"Active green","nl":"Actief groen","fr":"Vert actif"},{"hex":"#9db4ab","code":"170 70 10","scope":"Design System Plus","de":"Liebstöckelgrün","en":"Lovage green","nl":"Lavas groen","fr":"Vert de livèche"},{"hex":"#95b6a8","code":"170 70 15","scope":"Design System Plus","de":"Chrysopalhellgrün","en":"Chrysopal light green","nl":"Chrysopal lichtgroen","fr":"Vert chrysopal clair"},{"hex":"#8bb9a7","code":"170 70 20","scope":"Design System Plus","de":"Quellgrün","en":"Source green","nl":"Lentegroen","fr":"Vert source"},{"hex":"#83bba6","code":"170 70 25","scope":"Design System Plus","de":"Orientmosaikgrün","en":"Orient mosaic green","nl":"Oosters mozaïekgroen","fr":"Vert mosaïque d'Orient"},{"hex":"#75bea5","code":"170 70 30","scope":"Design System Plus","de":"Minzkaltgrün","en":"Mint cold green","nl":"Munt koud groen","fr":"Vert menthe froid"},{"hex":"#6abea2","code":"170 70 35","scope":"Design System Plus","de":"Emeraldgrün","en":"Emerald green","nl":"Smaragdgroen","fr":"Vert émeraude"},{"hex":"#5fbfa0","code":"170 70 40","scope":"Design System Plus","de":"Expressionismusgrün","en":"Expressionism green","nl":"Expressionisme groen","fr":"Vert expressionniste"},{"hex":"#b7cec5","code":"170 80 10","scope":"Design System Plus","de":"Fluoritblau","en":"Fluorite blue","nl":"Fluoriet blauw","fr":"Bleu fluorite"},{"hex":"#acd0c3","code":"170 80 15","scope":"Design System Plus","de":"Schwimmbadgrün","en":"Swimming pool green","nl":"Zwembad groen","fr":"Vert de la piscine"},{"hex":"#a4d5c2","code":"170 80 20","scope":"Design System Plus","de":"Himmelgrün","en":"Sky green","nl":"Hemels groen","fr":"Vert ciel"},{"hex":"#99d4bf","code":"170 80 25","scope":"Design System Plus","de":"Larimargrün","en":"Larimar green","nl":"Larimar groen","fr":"Vert larimar"},{"hex":"#cbd7d2","code":"170 85 05","scope":"Design System Plus","de":"Silikathelltürkis","en":"Silicate light turquoise","nl":"Silicaat licht turkoois","fr":"Turquoise clair silicaté"},{"hex":"#c3dad0","code":"170 85 10","scope":"Design System Plus","de":"Topasgrün","en":"Topaz green","nl":"Topaasgroen","fr":"Vert topaze"},{"hex":"#b8ddcd","code":"170 85 15","scope":"Design System Plus","de":"Kühlschrankgrün","en":"Refrigerator green","nl":"Koelkast groen","fr":"Vert frigo"},{"hex":"#b0e0cb","code":"170 85 20","scope":"Design System Plus","de":"Kristallglasgrün","en":"Crystal glass green","nl":"Kristalglas groen","fr":"Vert cristal"},{"hex":"#dae5de","code":"170 90 05","scope":"Design System Plus","de":"Kristallsalzweiß","en":"Crystal salt white","nl":"Kristalzout wit","fr":"Blanc cristal de sel"},{"hex":"#d1e9dd","code":"170 90 10","scope":"Design System Plus","de":"Türkisweiß","en":"Turquoise white","nl":"Turkoois wit","fr":"Blanc turquoise"},{"hex":"#e2ede7","code":"170 93 05","scope":"Design System Plus","de":"Schneekristallgrün","en":"Snow crystal green","nl":"Sneeuwkristal groen","fr":"Vert cristal de neige"},{"hex":"#454c4b","code":"180 20 05","scope":"Design System Plus","de":"Pechgrün","en":"Pitch green","nl":"Standplaats groen","fr":"Vert poix"},{"hex":"#3e4a47","code":"180 20 10","scope":"Design System Plus","de":"Lackgrün","en":"Lacquer green","nl":"Groen patent","fr":"Vert laque"},{"hex":"#374b48","code":"180 20 15","scope":"Design System Plus","de":"Zaungrün","en":"Fence green","nl":"Hek groen","fr":"Vert de clôture"},{"hex":"#304c48","code":"180 20 20","scope":"Design System Plus","de":"Myrtengrün","en":"Myrtle green","nl":"Myrtle groen","fr":"Vert myrte"},{"hex":"#535b59","code":"180 30 05","scope":"Design System Plus","de":"Amazonasgrün","en":"Amazon green","nl":"Amazonegroen","fr":"Vert amazonien"},{"hex":"#4a5a56","code":"180 30 10","scope":"Design System Plus","de":"Sattgrautürkis","en":"Rich grey turquoise","nl":"Rijk grijs turkoois","fr":"Turquoise gris saturé"},{"hex":"#435c57","code":"180 30 15","scope":"Design System Plus","de":"Tafelgrün","en":"Blackboard green","nl":"Tabel groen","fr":"Vert de table"},{"hex":"#3c5d56","code":"180 30 20","scope":"Design System Plus","de":"Schwedengrün","en":"Swedish green","nl":"Zweeds groen","fr":"Vert suédois"},{"hex":"#335e56","code":"180 30 25","scope":"Design System Plus","de":"Fjordgrün","en":"Fjord green","nl":"Fjordgroen","fr":"Vert fjord"},{"hex":"#295f56","code":"180 30 30","scope":"Design System Plus","de":"Stadtgrün","en":"Urban green","nl":"Stedelijk groen","fr":"Espaces verts de la ville"},{"hex":"#196054","code":"180 30 35","scope":"Design System Plus","de":"Dschungelgrün","en":"Jungle green","nl":"Oerwoudgroen","fr":"Vert jungle"},{"hex":"#626c69","code":"180 40 05","scope":"Design System Plus","de":"Erdgrün","en":"Earth green","nl":"Aarde groen","fr":"Vert terre"},{"hex":"#5a6e69","code":"180 40 10","scope":"Design System Plus","de":"Kiefergrün","en":"Pine green","nl":"Dennengroen","fr":"Vert pin"},{"hex":"#516f68","code":"180 40 15","scope":"Design System Plus","de":"Forstgrün","en":"Forest greenery","nl":"Bosgroen","fr":"Verdure forestière"},{"hex":"#477168","code":"180 40 20","scope":"Design System Plus","de":"Meergrün","en":"Sea green","nl":"Zeegroen","fr":"Vert mer"},{"hex":"#3e7268","code":"180 40 25","scope":"Design System Plus","de":"Eukalyptusgrün","en":"Eucalyptus green","nl":"Eucalyptus groen","fr":"Vert eucalyptus"},{"hex":"#2f7469","code":"180 40 30","scope":"Design System Plus","de":"Efeufrischgrün","en":"Fresh ivy green","nl":"Klimop fris groen","fr":"Vert lierre frais"},{"hex":"#1c7566","code":"180 40 35","scope":"Design System Plus","de":"Chrysokollmittelgrün","en":"Chrysocolla medium green","nl":"Chrysocolla middengroen","fr":"Vert chrysocolle"},{"hex":"#007565","code":"180 40 40","scope":"Design System Plus","de":"Plakatgrün","en":"Poster green","nl":"Poster groen","fr":"Vert d'affiche"},{"hex":"#007666","code":"180 40 45","scope":"Design System Plus","de":"Petroldunkelgrün","en":"Teal dark green","nl":"Petroleum donkergroen","fr":"Vert pétrole foncé"},{"hex":"#788280","code":"180 50 05","scope":"Design System Plus","de":"Dämmergrün","en":"Dusk green","nl":"Schemergroen","fr":"Vert crépuscule"},{"hex":"#6d827d","code":"180 50 10","scope":"Design System Plus","de":"Erquickungsgrün","en":"Refreshing green","nl":"Verfrissend groen","fr":"Vert rafraîchissant"},{"hex":"#63857d","code":"180 50 15","scope":"Design System Plus","de":"Stumpftürkis","en":"Dull turquoise","nl":"Mat turkoois","fr":"Turquoise terne"},{"hex":"#59867d","code":"180 50 20","scope":"Design System Plus","de":"Azuritwassergrün","en":"Azurite water green","nl":"Azuriet watergroen","fr":"Vert d'eau azurite"},{"hex":"#4d897e","code":"180 50 25","scope":"Design System Plus","de":"Kupfermineralgrün","en":"Copper mineral green","nl":"Koper mineraal groen","fr":"Vert minéral de cuivre"},{"hex":"#408b7c","code":"180 50 30","scope":"Design System Plus","de":"Glasgrün","en":"Glass green","nl":"Glas groen","fr":"Vert verre"},{"hex":"#318c7d","code":"180 50 35","scope":"Design System Plus","de":"Sommertürkis","en":"Summer turquoise","nl":"Zomerturquoise","fr":"Turquoise d'été"},{"hex":"#1b8c7b","code":"180 50 40","scope":"Design System Plus","de":"Weihnachtsgrün","en":"Christmas green","nl":"Kerstgroeten","fr":"Vert de Noël"},{"hex":"#00907b","code":"180 50 45","scope":"Design System Plus","de":"Industrietürkis","en":"Industrial turquoise","nl":"Industrieel turkoois","fr":"Turquoise industrielle"},{"hex":"#00907a","code":"180 50 50","scope":"Design System Plus","de":"Ozeangrün","en":"Ocean green","nl":"Oceaangroen","fr":"Vert océan"},{"hex":"#8d9996","code":"180 60 05","scope":"Design System Plus","de":"Marmorgrüngrau","en":"Marble green-grey","nl":"Marmer groen grijs","fr":"Gris marbré vert"},{"hex":"#829a95","code":"180 60 10","scope":"Design System Plus","de":"Kachelgrün","en":"Tile green","nl":"Tegel groen","fr":"Vert carreau"},{"hex":"#789d94","code":"180 60 15","scope":"Design System Plus","de":"Kupferdachgrün","en":"Copper roof green","nl":"Koperen dak groen","fr":"Vert toit cuivré"},{"hex":"#6e9f94","code":"180 60 20","scope":"Design System Plus","de":"Salbeigrün","en":"Sage green","nl":"Saliegroen","fr":"Vert sauge"},{"hex":"#61a093","code":"180 60 25","scope":"Design System Plus","de":"Petrolgrün","en":"Petrol green","nl":"Benzine groen","fr":"Vert pétrole"},{"hex":"#54a394","code":"180 60 30","scope":"Design System Plus","de":"Dioptasgrün","en":"Dioptase green","nl":"Dioptasegroen","fr":"Vert dioptas"},{"hex":"#46a593","code":"180 60 35","scope":"Design System Plus","de":"Stempelkissengrün","en":"Stamp pad green","nl":"Stempelkussen groen","fr":"Tampon encreur vert"},{"hex":"#2fa794","code":"180 60 40","scope":"Design System Plus","de":"Leuchttürkis","en":"Light turquoise","nl":"Lichtgevend turkoois","fr":"Turquoise fluo"},{"hex":"#02a994","code":"180 60 45","scope":"Design System Plus","de":"Karibikgrün","en":"Caribbean green","nl":"Caribisch groen","fr":"Vert caraïbe"},{"hex":"#00aa93","code":"180 60 50","scope":"Design System Plus","de":"Brillanttürkis","en":"Brilliant turquoise","nl":"Schitterend turquoise","fr":"Turquoise brillant"},{"hex":"#a6b1ae","code":"180 70 05","scope":"Design System Plus","de":"Feldspatsilber","en":"Feldspar silver","nl":"Veldspaat zilver","fr":"Argent feldspathique"},{"hex":"#98b3ad","code":"180 70 10","scope":"Design System Plus","de":"Grazilgrün","en":"Delicate green","nl":"Sierlijk groen","fr":"Vert gracile"},{"hex":"#8fb6ad","code":"180 70 15","scope":"Design System Plus","de":"Silikatgrün","en":"Silicate green","nl":"Silicaat groen","fr":"Vert silicate"},{"hex":"#85b9ad","code":"180 70 20","scope":"Design System Plus","de":"Mintbonbongrün","en":"Mint bonbon green","nl":"Mint snoepgroen","fr":"Vert menthe bonbon"},{"hex":"#78baac","code":"180 70 25","scope":"Design System Plus","de":"Gletschergrün","en":"Glacial green","nl":"Gletsjer groen","fr":"Vert glacier"},{"hex":"#6dbdad","code":"180 70 30","scope":"Design System Plus","de":"Badtürkis","en":"Bath turquoise","nl":"Bad turquoise","fr":"Turquoise de bain"},{"hex":"#5bbfac","code":"180 70 35","scope":"Design System Plus","de":"Bergseeazur","en":"Mountain lake azure","nl":"Bergmeer","fr":"Lac de montagneavec"},{"hex":"#4ac2ad","code":"180 70 40","scope":"Design System Plus","de":"Reincyan","en":"Pure cyan","nl":"Reincyanium","fr":"Reincyan"},{"hex":"#bfcbc6","code":"180 80 05","scope":"Design System Plus","de":"Aragonitweiß","en":"Aragonite white","nl":"Aragoniet wit","fr":"Blanc aragonite"},{"hex":"#b4cec7","code":"180 80 10","scope":"Design System Plus","de":"Lichtpetrol","en":"Light teal","nl":"Lichte benzine","fr":"Pétrole de lumière"},{"hex":"#abd2c8","code":"180 80 15","scope":"Design System Plus","de":"Whirlpoolgrün","en":"Whirlpool green","nl":"Whirlpool groen","fr":"Vert bouillonnant"},{"hex":"#9cd3c6","code":"180 80 20","scope":"Design System Plus","de":"Opaltürkis","en":"Opal turquoise","nl":"Opaal turkoois","fr":"Turquoise opale"},{"hex":"#91d5c6","code":"180 80 25","scope":"Design System Plus","de":"Caprihellgrün","en":"Light Capri green","nl":"Capri lichtgroen","fr":"Vert caprihell"},{"hex":"#89dac8","code":"180 80 30","scope":"Design System Plus","de":"Zarttürkis","en":"Tender turquoise","nl":"Licht turkoois","fr":"Turquoise tendre"},{"hex":"#cad7d3","code":"180 85 05","scope":"Design System Plus","de":"Meerdunstgrau","en":"Sea haze grey","nl":"Zeemist grijs","fr":"Gris brume de mer"},{"hex":"#c0dad3","code":"180 85 10","scope":"Design System Plus","de":"Feuerlandmeergrün","en":"Tierra del Fuego sea green","nl":"Vuurland zeegroen","fr":"Vert de la mer de la Terre de Feu"},{"hex":"#b8ded2","code":"180 85 15","scope":"Design System Plus","de":"Bergseehelltürkis","en":"Pale mountain lake turquoise","nl":"Bergmeer licht turquoise","fr":"Lac de montagne turquoise"},{"hex":"#aadfcf","code":"180 85 20","scope":"Design System Plus","de":"Korallgrün","en":"Coral green","nl":"Koraalgroen","fr":"Vert corail"},{"hex":"#dbe7e2","code":"180 90 05","scope":"Design System Plus","de":"Transparentgrün","en":"Transparent green","nl":"Transparant groen","fr":"Vert transparent"},{"hex":"#d0ece3","code":"180 90 10","scope":"Design System Plus","de":"Eiswassergrün","en":"Ice water green","nl":"IJswater groen","fr":"Vert eau glacée"},{"hex":"#e2eeea","code":"180 93 05","scope":"Design System Plus","de":"Arktisweiß","en":"Arctic white","nl":"Arctisch wit","fr":"Blanc arctique"},{"hex":"#2f4d4a","code":"190 20 20","scope":"Design System Plus","de":"Nachttürkis","en":"Night turquoise","nl":"Nacht turquoise","fr":"Turquoise nuit"},{"hex":"#415c5a","code":"190 30 15","scope":"Design System Plus","de":"Kutschengrün","en":"Carriage green","nl":"Rijtuig groen","fr":"Kutschengrün"},{"hex":"#375d5b","code":"190 30 20","scope":"Design System Plus","de":"Lattenzaungrün","en":"Stockade green","nl":"Piketomheining groen","fr":"Verdure de clôture en lattes"},{"hex":"#2d5e5b","code":"190 30 25","scope":"Design System Plus","de":"Aktionsgrün","en":"Action green","nl":"Actie groen","fr":"Vert d'action"},{"hex":"#20605d","code":"190 30 30","scope":"Design System Plus","de":"Myrtentiefgrün","en":"Myrtle deep green","nl":"Mirte diepgroen","fr":"Vert myrte"},{"hex":"#0e605d","code":"190 30 35","scope":"Design System Plus","de":"Planktongrün","en":"Plankton green","nl":"Plankton groen","fr":"Vert plancton"},{"hex":"#586c6a","code":"190 40 10","scope":"Design System Plus","de":"Schlammgrün","en":"Mud green","nl":"Moddergroen","fr":"Vert boue"},{"hex":"#4f6f6d","code":"190 40 15","scope":"Design System Plus","de":"Moorteichgrün","en":"Moor pond green","nl":"Moerasvijver groen","fr":"Vert étang de tourbe"},{"hex":"#44716e","code":"190 40 20","scope":"Design System Plus","de":"Üppiggrün","en":"Lush green","nl":"Weelderig groen","fr":"Vert luxuriant"},{"hex":"#37726f","code":"190 40 25","scope":"Design System Plus","de":"Schmetterlingsgrün","en":"Butterfly green","nl":"Vlinder groen","fr":"Vert papillon"},{"hex":"#267470","code":"190 40 30","scope":"Design System Plus","de":"Modeblau","en":"Fashion blue","nl":"Mode blauw","fr":"Bleu mode"},{"hex":"#097671","code":"190 40 35","scope":"Design System Plus","de":"Officeblaugrün","en":"Office blue green","nl":"Kantoor blauwgroen","fr":"Vert bleu office"},{"hex":"#007771","code":"190 40 40","scope":"Design System Plus","de":"Leguangrün","en":"Iguana green","nl":"Leguaan groen","fr":"Vert iguane"},{"hex":"#007a73","code":"190 40 45","scope":"Design System Plus","de":"Dunkelpetrol","en":"Dark teal","nl":"Donkere benzine","fr":"Pétrole foncé"},{"hex":"#6d8481","code":"190 50 10","scope":"Design System Plus","de":"Sturmgrün","en":"Storm green","nl":"Stormgroen","fr":"Vert tempête"},{"hex":"#628682","code":"190 50 15","scope":"Design System Plus","de":"Dunkeltürkis","en":"Dark turquoise","nl":"Donker turkoois","fr":"Turquoise foncé"},{"hex":"#578884","code":"190 50 20","scope":"Design System Plus","de":"Tannenblau","en":"Fir blue","nl":"Dennenblauw","fr":"Bleu sapin"},{"hex":"#488984","code":"190 50 25","scope":"Design System Plus","de":"Apatitblau","en":"Apatite blue","nl":"Apatiet blauw","fr":"Bleu apatite"},{"hex":"#368b86","code":"190 50 30","scope":"Design System Plus","de":"Ägyptischgrün","en":"Egyptian green","nl":"Egyptisch groen","fr":"Vert égyptien"},{"hex":"#208c86","code":"190 50 35","scope":"Design System Plus","de":"Schmucktürkis","en":"Ornamental turquoise","nl":"Sieraden turkoois","fr":"Turquoise à paillettes"},{"hex":"#008f89","code":"190 50 40","scope":"Design System Plus","de":"Lidschattentürkis","en":"Eyeshadow turquoise","nl":"Oogschaduw turquoise","fr":"Turquoise à paupières"},{"hex":"#00908a","code":"190 50 45","scope":"Design System Plus","de":"Klartürkis","en":"Clear turquoise","nl":"Helder turkoois","fr":"Turquoise clair"},{"hex":"#829b98","code":"190 60 10","scope":"Design System Plus","de":"Dezenttürkis","en":"Subtle turquoise","nl":"Fatsoenlijk turkoois","fr":"Turquoise décent"},{"hex":"#779d98","code":"190 60 15","scope":"Design System Plus","de":"Hellgrünspan","en":"Pale verdigris","nl":"Lichtgroen schaafsel","fr":"Span vert clair"},{"hex":"#6ea09b","code":"190 60 20","scope":"Design System Plus","de":"Gänseteichgrün","en":"Goose pond green","nl":"Ganzenvijver groen","fr":"Vert pâquerette"},{"hex":"#5ea39d","code":"190 60 25","scope":"Design System Plus","de":"Turmalintürkis","en":"Tourmaline turquoise","nl":"Toermalijn turkoois","fr":"Turmaline turquoise"},{"hex":"#4da49e","code":"190 60 30","scope":"Design System Plus","de":"Baltikgrün","en":"Baltic green","nl":"Baltisch groen","fr":"Vert baltique"},{"hex":"#39a6a0","code":"190 60 35","scope":"Design System Plus","de":"Keramikbleutürkis","en":"Ceramic blue turquoise","nl":"Keramische loodturkoois","fr":"Turquoise plombé céramique"},{"hex":"#0ca8a1","code":"190 60 40","scope":"Design System Plus","de":"Baltiktürkis","en":"Baltic turquoise","nl":"Baltisch turkoois","fr":"Turquoise baltique"},{"hex":"#00a8a0","code":"190 60 45","scope":"Design System Plus","de":"Tirolitblaugrün","en":"Tyrolite blue-green","nl":"Tiroliet blauwgroen","fr":"Vert bleu tirolite"},{"hex":"#9ab4b1","code":"190 70 10","scope":"Design System Plus","de":"Marmorgrün","en":"Marble green","nl":"Marmer groen","fr":"Vert marbre"},{"hex":"#8fb6b1","code":"190 70 15","scope":"Design System Plus","de":"Jadegrün","en":"Jade green","nl":"Jadegroen","fr":"Vert jade"},{"hex":"#82b8b2","code":"190 70 20","scope":"Design System Plus","de":"Quellwassertürkis","en":"Spring water turquoise","nl":"Bronwater turquoise","fr":"Turquoise d'eau de source"},{"hex":"#75bbb5","code":"190 70 25","scope":"Design System Plus","de":"Floridatürkis","en":"Florida turquoise","nl":"Florida turquoise","fr":"Turquoise de Floride"},{"hex":"#69beb8","code":"190 70 30","scope":"Design System Plus","de":"Hygienegrün","en":"Hygiene green","nl":"Hygiënisch groen","fr":"Vert hygiénique"},{"hex":"#55bfb7","code":"190 70 35","scope":"Design System Plus","de":"Arktisgrün","en":"Arctic green","nl":"Arctisch groen","fr":"Vert arctique"},{"hex":"#b3cfca","code":"190 80 10","scope":"Design System Plus","de":"Andenopalgrün","en":"Andean opal green","nl":"Andes opaal groen","fr":"Vert opale des Andes"},{"hex":"#a9d2cd","code":"190 80 15","scope":"Design System Plus","de":"Kalttürkis","en":"Cold turquoise","nl":"Koud turkoois","fr":"Turquoise froide"},{"hex":"#9bd2cd","code":"190 80 20","scope":"Design System Plus","de":"Petroleumblau","en":"Teal blue","nl":"Petroleum blauw","fr":"Bleu pétrole"},{"hex":"#8fd5cf","code":"190 80 25","scope":"Design System Plus","de":"Poolgrün","en":"Pool green","nl":"Zwembad groen","fr":"Vert de piscine"},{"hex":"#c5d9d6","code":"190 85 05","scope":"Design System Plus","de":"Morgentauweiß","en":"Morning dew white","nl":"Ochtenddauw wit","fr":"Blanc rosée du matin"},{"hex":"#badcd6","code":"190 85 10","scope":"Design System Plus","de":"Badesalzgrün","en":"Bath salt green","nl":"Badzout groen","fr":"Vert de sel de bain"},{"hex":"#aadfd6","code":"190 85 15","scope":"Design System Plus","de":"Capriwasserblau","en":"Capri water blue","nl":"Capri waterblauw","fr":"Bleu eau de capri"},{"hex":"#9ce2d7","code":"190 85 20","scope":"Design System Plus","de":"Horizontblau","en":"Horizon blue","nl":"Horizon blauw","fr":"Bleu horizon"},{"hex":"#dbe6e2","code":"190 90 05","scope":"Design System Plus","de":"Kaltweiß","en":"Cool white","nl":"Koud wit","fr":"Blanc froid"},{"hex":"#cfeae5","code":"190 90 10","scope":"Design System Plus","de":"Quellblau","en":"Source blue","nl":"Lente blauw","fr":"Bleu source"},{"hex":"#e3edeb","code":"190 93 05","scope":"Design System Plus","de":"Ägyptischweiß","en":"Egyptian white","nl":"Egyptisch wit","fr":"Blanc égyptien"},{"hex":"#444a4a","code":"200 20 05","scope":"Design System Plus","de":"Tarngrün","en":"Concealed green","nl":"Camouflagegroen","fr":"Vert camouflage"},{"hex":"#3c4a4b","code":"200 20 10","scope":"Design System Plus","de":"Dunkelkiefergrün","en":"Dark pine green","nl":"Donker dennengroen","fr":"Vert pin foncé"},{"hex":"#374a4b","code":"200 20 15","scope":"Design System Plus","de":"Dachziegelgrün","en":"Roof tile green","nl":"Dakpan groen","fr":"Vert tuile"},{"hex":"#304c4e","code":"200 20 20","scope":"Design System Plus","de":"Buschgrün","en":"Shrub green","nl":"Struikgroen","fr":"Vert buisson"},{"hex":"#264d4f","code":"200 20 23","scope":"Design System Plus","de":"Zollgrün","en":"Customs green","nl":"Douane groen","fr":"Zollgrün"},{"hex":"#4f5858","code":"200 30 05","scope":"Design System Plus","de":"Finsternisgrün","en":"Darkness green","nl":"Eclips groen","fr":"Vert éclipse"},{"hex":"#485b5b","code":"200 30 10","scope":"Design System Plus","de":"Baumrindengrün","en":"Tree bark green","nl":"Boomschors groen","fr":"Vert écorce d'arbre"},{"hex":"#405d5d","code":"200 30 15","scope":"Design System Plus","de":"Hornblendegrün","en":"Hornblende green","nl":"Hoornblende groen","fr":"Vert cornu"},{"hex":"#385e5f","code":"200 30 20","scope":"Design System Plus","de":"Malachitblautürkis","en":"Malachite blue turquoise","nl":"Malachiet blauw turkoois","fr":"Turquoise bleue malachite"},{"hex":"#285d5e","code":"200 30 25","scope":"Design System Plus","de":"Antiktürkis","en":"Antique turquoise","nl":"Antiek turkoois","fr":"Turquoise antique"},{"hex":"#1a5f62","code":"200 30 30","scope":"Design System Plus","de":"Wolltürkis","en":"Wool turquoise","nl":"Wol turkoois","fr":"Turquoise de laine"},{"hex":"#006164","code":"200 30 33","scope":"Design System Plus","de":"Eisdunkeltürkis","en":"Ice dark turquoise","nl":"Ijs donker turkoois","fr":"Turquoise foncé glacé"},{"hex":"#616c6c","code":"200 40 05","scope":"Design System Plus","de":"Kalkspatgraugrün","en":"Calcite grey green","nl":"Kalk spar grijsgroen","fr":"Vert spath calcaire"},{"hex":"#596d6e","code":"200 40 10","scope":"Design System Plus","de":"Brochantitgrün","en":"Brochantite green","nl":"Brochantiet groen","fr":"Vert de brochantite"},{"hex":"#4f6f6f","code":"200 40 15","scope":"Design System Plus","de":"Eisenkiesgrün","en":"Pyrite green","nl":"IJzerpyriet groen","fr":"Vert de fer et de gravier"},{"hex":"#427172","code":"200 40 20","scope":"Design System Plus","de":"Alpendämmerblau","en":"Dusky alpine blue","nl":"Alpine schemerblauw","fr":"Bleu crépuscule des Alpes"},{"hex":"#377374","code":"200 40 25","scope":"Design System Plus","de":"Badgrün","en":"Bath green","nl":"Badgroen","fr":"Vert de bain"},{"hex":"#237477","code":"200 40 30","scope":"Design System Plus","de":"Mayablau","en":"Mayan blue","nl":"Maya blauw","fr":"Bleu maya"},{"hex":"#007579","code":"200 40 35","scope":"Design System Plus","de":"Byzantinischblau","en":"Byzantine blue","nl":"Byzantijns blauw","fr":"Bleu byzantin"},{"hex":"#00787d","code":"200 40 40","scope":"Design System Plus","de":"Aktivtürkis","en":"Active turquoise","nl":"Actief turkoois","fr":"Turquoise active"},{"hex":"#748080","code":"200 50 05","scope":"Design System Plus","de":"Nordgrau","en":"North grey","nl":"Noordgrijs","fr":"Gris nord"},{"hex":"#6c8384","code":"200 50 10","scope":"Design System Plus","de":"Augengrau","en":"Eye grey","nl":"Oog grijs","fr":"Gris des yeux"},{"hex":"#618686","code":"200 50 15","scope":"Design System Plus","de":"Nickelerzgrün","en":"Nickel ore green","nl":"Nikkelerts groen","fr":"Vert nickelé"},{"hex":"#548788","code":"200 50 20","scope":"Design System Plus","de":"Gischtgrün","en":"Seafoam green","nl":"Spuitgroen","fr":"Vert givré"},{"hex":"#46898c","code":"200 50 25","scope":"Design System Plus","de":"Kandinskytürkis","en":"Kandinsky turquoise","nl":"Kandinsky turkoois","fr":"Kandinsky turquoise"},{"hex":"#308b8d","code":"200 50 30","scope":"Design System Plus","de":"Karibiktürkis","en":"Caribbean turquoise","nl":"Caribisch turkoois","fr":"Turquoise des Caraïbes"},{"hex":"#118e92","code":"200 50 35","scope":"Design System Plus","de":"Brunnenblau","en":"Well blue","nl":"Fontein blauw","fr":"Bleu foncé"},{"hex":"#008f93","code":"200 50 40","scope":"Design System Plus","de":"Industrieblau","en":"Industrial blue","nl":"Industrieel blauw","fr":"Bleu industriel"},{"hex":"#009096","code":"200 50 45","scope":"Design System Plus","de":"Indiablau","en":"India blue","nl":"India blauw","fr":"Bleu indien"},{"hex":"#8c9999","code":"200 60 05","scope":"Design System Plus","de":"Schattengrau","en":"Shady grey","nl":"Schaduwgrijs","fr":"Gris ombre"},{"hex":"#829a9b","code":"200 60 10","scope":"Design System Plus","de":"Nordkapgrau","en":"North Cape grey","nl":"Noordkaap grijs","fr":"Gris cap nord"},{"hex":"#769d9e","code":"200 60 15","scope":"Design System Plus","de":"Waidindigo","en":"Woad indigo","nl":"Waidindigo","fr":"Waidindigo"},{"hex":"#6aa0a1","code":"200 60 20","scope":"Design System Plus","de":"Jugendstiltürkis","en":"Art nouveau turquoise","nl":"Jugendstil turkoois","fr":"Turquoise art nouveau"},{"hex":"#59a1a2","code":"200 60 25","scope":"Design System Plus","de":"Kühlboxeistürkis","en":"Coolbox ice turquoise","nl":"Koelbox turquoise","fr":"Boxe réfrigéréeisturquoise"},{"hex":"#48a4a5","code":"200 60 30","scope":"Design System Plus","de":"Aquamarinblau","en":"Aquamarine blue","nl":"Aquamarijnblauw","fr":"Bleu aigue-marine"},{"hex":"#33a5a9","code":"200 60 35","scope":"Design System Plus","de":"Arktisblau","en":"Arctic blue","nl":"Arctisch blauw","fr":"Bleu arctique"},{"hex":"#05a8ac","code":"200 60 40","scope":"Design System Plus","de":"Wachsstiftblau","en":"Wax crayon blue","nl":"Waskrijt blauw","fr":"Bleu crayon de cire"},{"hex":"#a5b1b1","code":"200 70 05","scope":"Design System Plus","de":"Prinzengrau","en":"Prince grey","nl":"Prins grijs","fr":"Gris prince"},{"hex":"#9ab5b5","code":"200 70 10","scope":"Design System Plus","de":"Calcitblau","en":"Calcite blue","nl":"Calciet blauw","fr":"Bleu calcite"},{"hex":"#8cb6b6","code":"200 70 15","scope":"Design System Plus","de":"Kaltfrontgrün","en":"Cold front green","nl":"Koud front groen","fr":"Vert à front froid"},{"hex":"#82b9b9","code":"200 70 20","scope":"Design System Plus","de":"Eisvogeltürkis","en":"Kingfisher turquoise","nl":"IJsvogel turquoise","fr":"Turquoise martin-pêcheur"},{"hex":"#74bcbf","code":"200 70 25","scope":"Design System Plus","de":"Frischbleu","en":"Fresh soft blue","nl":"Vers lood","fr":"Plomb frais"},{"hex":"#bfcbca","code":"200 80 05","scope":"Design System Plus","de":"Chinalichtgrün","en":"China light green","nl":"Chinees lichtgroen","fr":"Vert clair de Chine"},{"hex":"#b2cece","code":"200 80 10","scope":"Design System Plus","de":"Barockkalkbleu","en":"Baroque chalk soft blue","nl":"Barok kalklood","fr":"Bleu de chaux baroque"},{"hex":"#a6cfce","code":"200 80 15","scope":"Design System Plus","de":"Eisboutiquetürkis","en":"Ice boutique turquoise","nl":"Ijs boetiek turquoise","fr":"Boutique de glace turquoise"},{"hex":"#9ad4d3","code":"200 80 20","scope":"Design System Plus","de":"Sommerbleu","en":"Summer soft blue","nl":"Zomer leiden","fr":"Plomb d'été"},{"hex":"#8cd5d6","code":"200 80 25","scope":"Design System Plus","de":"Bergseeblau","en":"Mountain lake blue","nl":"Bergzee blauw","fr":"Bleu lac de montagne"},{"hex":"#cad7d7","code":"200 85 05","scope":"Design System Plus","de":"Bastlichtgrau","en":"Raffia light grey","nl":"Bast lichtgrijs","fr":"Gris raphia"},{"hex":"#c0dada","code":"200 85 10","scope":"Design System Plus","de":"Kaltlufttürkis","en":"Cold air turquoise","nl":"Koude lucht turquoise","fr":"Turquoise froid"},{"hex":"#b3dddd","code":"200 85 15","scope":"Design System Plus","de":"Frosthellbleu","en":"Frosty soft blue","nl":"Frosthell lood","fr":"Frosthellbleu"},{"hex":"#a6e0df","code":"200 85 20","scope":"Design System Plus","de":"Eiskristallblau","en":"Ice crystal blue","nl":"Ijskristalblauw","fr":"Bleu cristal de glace"},{"hex":"#dbe8e5","code":"200 90 05","scope":"Design System Plus","de":"Frostgrün","en":"Frosty green","nl":"Vorstgroen","fr":"Vert givré"},{"hex":"#cee9e5","code":"200 90 10","scope":"Design System Plus","de":"Frostweißblau","en":"Frosty white blue","nl":"Vorst wit blauw","fr":"Bleu blanc givré"},{"hex":"#e2eeeb","code":"200 93 05","scope":"Design System Plus","de":"Klirrendweiß","en":"Chilly white","nl":"Klinkend wit","fr":"Blanc éclatant"},{"hex":"#4a5a5c","code":"210 30 10","scope":"Design System Plus","de":"Graphitschwarzgrün","en":"Graphite black green","nl":"Grafiet zwart groen","fr":"Vert noir graphite"},{"hex":"#415c60","code":"210 30 15","scope":"Design System Plus","de":"Stockentenblau","en":"Mallard blue","nl":"Wilde eend blauw","fr":"Bleu canard colvert"},{"hex":"#365e64","code":"210 30 20","scope":"Design System Plus","de":"Transportergrün","en":"Transporter green","nl":"Transporteur groen","fr":"Vert transporteur"},{"hex":"#2b5e65","code":"210 30 25","scope":"Design System Plus","de":"Tiefatlantikblau","en":"Deep Atlantic blue","nl":"Diep Atlantisch blauw","fr":"Bleu Atlantique profond"},{"hex":"#175f68","code":"210 30 30","scope":"Design System Plus","de":"Kaliblau","en":"Kali blue","nl":"Kaliber blauw","fr":"Bleu de potassium"},{"hex":"#586c6f","code":"210 40 10","scope":"Design System Plus","de":"Leinengrau","en":"Linen grey","nl":"Linnen grijs","fr":"Gris lin"},{"hex":"#4f6f74","code":"210 40 15","scope":"Design System Plus","de":"Chinagrünblau","en":"China green blue","nl":"Chinees groen blauw","fr":"Bleu vert de Chine"},{"hex":"#437177","code":"210 40 20","scope":"Design System Plus","de":"Dämmerblau","en":"Dusk blue","nl":"Schemerblauw","fr":"Bleu crépuscule"},{"hex":"#347178","code":"210 40 25","scope":"Design System Plus","de":"Hosenblau","en":"Trouser blue","nl":"Broek blauw","fr":"Bleu pantalon"},{"hex":"#1e737d","code":"210 40 30","scope":"Design System Plus","de":"Indigoblau","en":"Indigo blue","nl":"Indigo blauw","fr":"Bleu indigo"},{"hex":"#007681","code":"210 40 35","scope":"Design System Plus","de":"Kaltblau","en":"Cold blue","nl":"Koud blauw","fr":"Bleu froid"},{"hex":"#007481","code":"210 40 38","scope":"Design System Plus","de":"Marienblau","en":"Mary blue","nl":"Maria blauw","fr":"Bleu marie"},{"hex":"#6b8386","code":"210 50 10","scope":"Design System Plus","de":"Uniformgrüngrau","en":"Uniform green grey","nl":"Uniform groen-grijs","fr":"Gris vert uniforme"},{"hex":"#628488","code":"210 50 15","scope":"Design System Plus","de":"Labradoritgrün","en":"Labradorite green","nl":"Labradoriet groen","fr":"Vert labradorite"},{"hex":"#54868d","code":"210 50 20","scope":"Design System Plus","de":"Emailleantikgrün","en":"Enamel antique green","nl":"Email antiek groen","fr":"Vert antique émaillé"},{"hex":"#458990","code":"210 50 25","scope":"Design System Plus","de":"Cranachblau","en":"Cranach blue","nl":"Cranach blauw","fr":"Bleu cranach"},{"hex":"#2d8a94","code":"210 50 30","scope":"Design System Plus","de":"Chinablau","en":"China blue","nl":"China blauw","fr":"Bleu chine"},{"hex":"#148c98","code":"210 50 35","scope":"Design System Plus","de":"Gletscherblau","en":"Glacier blue","nl":"Gletsjerblauw","fr":"Bleu glacier"},{"hex":"#008e9b","code":"210 50 40","scope":"Design System Plus","de":"Curaçaoblau","en":"Curaçao blue","nl":"Curaçao blauw","fr":"Bleu curaçao"},{"hex":"#008f9e","code":"210 50 45","scope":"Design System Plus","de":"Atlantikblau","en":"Atlantic blue","nl":"Atlantisch blauw","fr":"Bleu atlantique"},{"hex":"#829a9d","code":"210 60 10","scope":"Design System Plus","de":"Aschblau","en":"Ash blue","nl":"Asblauw","fr":"Bleu cendré"},{"hex":"#769ca0","code":"210 60 15","scope":"Design System Plus","de":"Baltikblau","en":"Baltic blue","nl":"Baltisch blauw","fr":"Bleu baltique"},{"hex":"#6ba1a7","code":"210 60 20","scope":"Design System Plus","de":"Strandblau","en":"Beach blue","nl":"Strand blauw","fr":"Bleu de la plage"},{"hex":"#5aa4ab","code":"210 60 25","scope":"Design System Plus","de":"Basilikablau","en":"Basilica blue","nl":"Basiliek blauw","fr":"Bleu basilic"},{"hex":"#48a5af","code":"210 60 30","scope":"Design System Plus","de":"Donaublau","en":"Danube blue","nl":"Donau blauw","fr":"Bleu du Danube"},{"hex":"#2ca5b1","code":"210 60 35","scope":"Design System Plus","de":"Altdorferhimmelblau","en":"Altdorf sky blue","nl":"Altdorfer hemelsblauw","fr":"Altdorferhimmelblau"},{"hex":"#00a8b5","code":"210 60 40","scope":"Design System Plus","de":"Grellblau","en":"Garish blue","nl":"Helderblauw","fr":"Bleu vif"},{"hex":"#9bb4b7","code":"210 70 10","scope":"Design System Plus","de":"Sturmgrau","en":"Storm grey","nl":"Stormgrijs","fr":"Gris tempête"},{"hex":"#8fb6ba","code":"210 70 15","scope":"Design System Plus","de":"Persischblau","en":"Persian blue","nl":"Perzisch blauw","fr":"Bleu persan"},{"hex":"#81b9bf","code":"210 70 20","scope":"Design System Plus","de":"Aquablau","en":"Aqua blue","nl":"Aqua blauw","fr":"Bleu aqua"},{"hex":"#73bbc3","code":"210 70 25","scope":"Design System Plus","de":"Maritimbleu","en":"Maritime soft blue","nl":"Maritieme leiding","fr":"Bleu marine"},{"hex":"#61bec8","code":"210 70 30","scope":"Design System Plus","de":"Bergblau","en":"Mountain blue","nl":"Blauw in de bergen","fr":"Bleu montagne"},{"hex":"#4cc0cb","code":"210 70 35","scope":"Design System Plus","de":"Weitsichtblau","en":"Panorama blue","nl":"Verziend blauw","fr":"Bleu large"},{"hex":"#b7d0d1","code":"210 80 10","scope":"Design System Plus","de":"Türkisgrau","en":"Turquoise grey","nl":"Turquoise grijs","fr":"Gris turquoise"},{"hex":"#aad2d4","code":"210 80 15","scope":"Design System Plus","de":"Delphinblau","en":"Dolphin blue","nl":"Dolfijn blauw","fr":"Bleu dauphin"},{"hex":"#9cd3d8","code":"210 80 20","scope":"Design System Plus","de":"Duftblau","en":"Aroma blue","nl":"Blauw geparfumeerd","fr":"Bleu parfumé"},{"hex":"#8fd6dd","code":"210 80 25","scope":"Design System Plus","de":"Knallbleu","en":"Vibrant soft blue","nl":"Helderblauw","fr":"Bleu vif"},{"hex":"#c9d8d9","code":"210 85 05","scope":"Design System Plus","de":"Siestaweiß","en":"Siesta white","nl":"Siestawit","fr":"Siestablanc"},{"hex":"#baddde","code":"210 85 10","scope":"Design System Plus","de":"Mintblau","en":"Mint blue","nl":"Mintblauw","fr":"Bleu menthe"},{"hex":"#b5dedf","code":"210 85 15","scope":"Design System Plus","de":"Feinblau","en":"Fine blue","nl":"Fijn blauw","fr":"Bleu fin"},{"hex":"#a7e0e1","code":"210 85 20","scope":"Design System Plus","de":"Blassblau","en":"Pale blue","nl":"Lichtblauw","fr":"Bleu pâle"},{"hex":"#dae7e5","code":"210 90 05","scope":"Design System Plus","de":"Tüllbleu","en":"Tulle soft blue","nl":"Tule lood","fr":"Plomb de tulle"},{"hex":"#cde9e7","code":"210 90 10","scope":"Design System Plus","de":"Antarktisblau","en":"Antarctic blue","nl":"Antarctisch blauw","fr":"Bleu antarctique"},{"hex":"#43494b","code":"220 20 05","scope":"Design System Plus","de":"Navyschwarz","en":"Navy black","nl":"Marine zwart","fr":"Noir navy"},{"hex":"#3c4a4e","code":"220 20 10","scope":"Design System Plus","de":"Indigokarmin","en":"Indigo carmine","nl":"Indigo karmijn","fr":"Carmin d'indigo"},{"hex":"#344a50","code":"220 20 15","scope":"Design System Plus","de":"Künstlerblau","en":"Artist blue","nl":"Kunstenaar blauw","fr":"Bleu artiste"},{"hex":"#2d4b53","code":"220 20 20","scope":"Design System Plus","de":"Naturindigo","en":"Natural indigo","nl":"Natuurlijk indigo","fr":"Indigo naturel"},{"hex":"#51595a","code":"220 30 05","scope":"Design System Plus","de":"Pandaschwarz","en":"Panda black","nl":"Panda zwart","fr":"Noir panda"},{"hex":"#4a5b5e","code":"220 30 10","scope":"Design System Plus","de":"Pallasitblau","en":"Pallasite blue","nl":"Pallasiet blauw","fr":"Bleu pallasite"},{"hex":"#435d64","code":"220 30 15","scope":"Design System Plus","de":"Orkangrünblau","en":"Hurricane green blue","nl":"Gagelgroen blauw","fr":"Bleu vert orcane"},{"hex":"#385e66","code":"220 30 20","scope":"Design System Plus","de":"Aquarellblau","en":"Watercolour blue","nl":"Aquarel blauw","fr":"Bleu aquarelle"},{"hex":"#2e606b","code":"220 30 25","scope":"Design System Plus","de":"Korallenblau","en":"Coral blue","nl":"Koraalblauw","fr":"Bleu corail"},{"hex":"#155f6d","code":"220 30 30","scope":"Design System Plus","de":"Sandelholzblau","en":"Sandalwood grey blue","nl":"Sandelhout blauw","fr":"Bleu santal"},{"hex":"#626c6e","code":"220 40 05","scope":"Design System Plus","de":"Limousinengraublau","en":"Limousine grey blue","nl":"Limousine grijs blauw","fr":"Gris limousine"},{"hex":"#5a6e72","code":"220 40 10","scope":"Design System Plus","de":"Korundblau","en":"Corundum blue","nl":"Korund blauw","fr":"Bleu corail"},{"hex":"#4f6f77","code":"220 40 15","scope":"Design System Plus","de":"Kittelblau","en":"Smock blue","nl":"Smok blauw","fr":"Bleu blouse"},{"hex":"#45717b","code":"220 40 20","scope":"Design System Plus","de":"Beizeblau","en":"Mordant blue","nl":"Blauwe vlek","fr":"Bleu mordoré"},{"hex":"#37737f","code":"220 40 25","scope":"Design System Plus","de":"Baumwollindigo","en":"Cotton indigo","nl":"Katoen indigo","fr":"Indigo en coton"},{"hex":"#1f7586","code":"220 40 30","scope":"Design System Plus","de":"Fjordblau","en":"Fjord blue","nl":"Fjordblauw","fr":"Bleu fjord"},{"hex":"#007689","code":"220 40 35","scope":"Design System Plus","de":"Azurgrünblau","en":"Azure green blue","nl":"Azuurgroen blauw","fr":"Bleu azur"},{"hex":"#00788e","code":"220 40 40","scope":"Design System Plus","de":"Cyanblau","en":"Cyan blue","nl":"Cyaanblauw","fr":"Bleu cyan"},{"hex":"#788284","code":"220 50 05","scope":"Design System Plus","de":"Winterwolkengrau","en":"Winter cloud grey","nl":"Winterwolk grijs","fr":"Gris des nuages d'hiver"},{"hex":"#6f8388","code":"220 50 10","scope":"Design System Plus","de":"Kadettgrau","en":"Cadet grey","nl":"Cadet grijs","fr":"Gris cadet"},{"hex":"#62858d","code":"220 50 15","scope":"Design System Plus","de":"Holbeinblaugrau","en":"Holbein blue grey","nl":"Holbein blauw-grijs","fr":"Gris bleu holbein"},{"hex":"#558791","code":"220 50 20","scope":"Design System Plus","de":"Schattenblau","en":"Shady blue","nl":"Schaduwblauw","fr":"Bleu ombre"},{"hex":"#488895","code":"220 50 25","scope":"Design System Plus","de":"Frescoblau","en":"Fresco blue","nl":"Fresco blauw","fr":"Bleu fresco"},{"hex":"#318899","code":"220 50 30","scope":"Design System Plus","de":"Handwerkerblau","en":"Craftsman blue","nl":"Ambachtelijk blauw","fr":"Bleu artisan"},{"hex":"#198ca0","code":"220 50 35","scope":"Design System Plus","de":"Markerblau","en":"Marker blue","nl":"Marker blauw","fr":"Bleu marqueur"},{"hex":"#008ea5","code":"220 50 40","scope":"Design System Plus","de":"Spielzeugblau","en":"Toy blue","nl":"Speelgoed blauw","fr":"Bleu jouet"},{"hex":"#8e989a","code":"220 60 05","scope":"Design System Plus","de":"Tiefseegrau","en":"Deep sea grey","nl":"Diep zeegrijs","fr":"Gris océan profond"},{"hex":"#839ba0","code":"220 60 10","scope":"Design System Plus","de":"Kachelblau","en":"Tile blue","nl":"Tegel blauw","fr":"Bleu faïence"},{"hex":"#799da5","code":"220 60 15","scope":"Design System Plus","de":"Morgenblau","en":"Morning blue","nl":"Ochtendblauw","fr":"Bleu du matin"},{"hex":"#699fab","code":"220 60 20","scope":"Design System Plus","de":"Frostblau","en":"Frost blue","nl":"Vorstblauw","fr":"Bleu givré"},{"hex":"#5ba1b0","code":"220 60 25","scope":"Design System Plus","de":"Sommertürkisblau","en":"Summer turquoise blue","nl":"Zomer turquoise blauw","fr":"Bleu turquoise d'été"},{"hex":"#4aa4b5","code":"220 60 30","scope":"Design System Plus","de":"Fischerblau","en":"Fischer blue","nl":"Visser blauw","fr":"Bleu pêcheur"},{"hex":"#36a3b8","code":"220 60 35","scope":"Design System Plus","de":"Planetblau","en":"Planet blue","nl":"Planeet blauw","fr":"Bleu planète"},{"hex":"#00a5bd","code":"220 60 40","scope":"Design System Plus","de":"Januarblau","en":"January blue","nl":"Januari blauw","fr":"Bleu de janvier"},{"hex":"#a6b2b5","code":"220 70 05","scope":"Design System Plus","de":"Temperiertgrau","en":"Tempered grey","nl":"Getemperd grijs","fr":"Gris tempéré"},{"hex":"#9db5bb","code":"220 70 10","scope":"Design System Plus","de":"Mohairbleugrau","en":"Mohair soft blue grey","nl":"Mohair loodgrijs","fr":"Gris plomb mohair"},{"hex":"#90b8c0","code":"220 70 15","scope":"Design System Plus","de":"Küchenblau","en":"Kitchen blue","nl":"Keuken blauw","fr":"Bleu cuisine"},{"hex":"#84b9c4","code":"220 70 20","scope":"Design System Plus","de":"Gastronomieblau","en":"Culinary blue","nl":"Gastronomie blauw","fr":"Bleu gastronomique"},{"hex":"#72bac9","code":"220 70 25","scope":"Design System Plus","de":"Blousonblau","en":"Blouson blue","nl":"Blouson blauw","fr":"Blouson bleu"},{"hex":"#61bacc","code":"220 70 30","scope":"Design System Plus","de":"Gebirgsblau","en":"Mountain range blue","nl":"Blauw in de bergen","fr":"Bleu montagne"},{"hex":"#4bbfd4","code":"220 70 35","scope":"Design System Plus","de":"Ferienblau","en":"Holiday blue","nl":"Vakantie blauw","fr":"Bleu de vacances"},{"hex":"#bfcccd","code":"220 80 05","scope":"Design System Plus","de":"Pastellblau","en":"Pastel blue","nl":"Pastelblauw","fr":"Bleu pastel"},{"hex":"#b5d0d5","code":"220 80 10","scope":"Design System Plus","de":"Klinischbleu","en":"Clinical soft blue","nl":"Klinische leiding","fr":"Plomb clinique"},{"hex":"#a6cfd8","code":"220 80 15","scope":"Design System Plus","de":"Kinderbleu","en":"Children's soft blue","nl":"Lood voor kinderen","fr":"Plomb pour enfants"},{"hex":"#9ed4e0","code":"220 80 20","scope":"Design System Plus","de":"Turmalinwasserblau","en":"Tourmaline water blue","nl":"Toermalijn waterblauw","fr":"Bleu d'eau de tourmaline"},{"hex":"#92d7e3","code":"220 80 25","scope":"Design System Plus","de":"Frischblau","en":"Fresh blue","nl":"Fris blauw","fr":"Bleu frais"},{"hex":"#ccd9dc","code":"220 85 05","scope":"Design System Plus","de":"Transparentbleu","en":"Transparent blue","nl":"Transparant lood","fr":"Bleu transparent"},{"hex":"#c0dce1","code":"220 85 10","scope":"Design System Plus","de":"Eisscherbenbleu","en":"Ice shard soft blue","nl":"Ijsscherf lood","fr":"Plomb de glace"},{"hex":"#b3dee6","code":"220 85 15","scope":"Design System Plus","de":"Polarblau","en":"Polar blue","nl":"Polair blauw","fr":"Bleu polaire"},{"hex":"#dae7e6","code":"220 90 05","scope":"Design System Plus","de":"Kaltlichtbleu","en":"Cold soft blue","nl":"Koud lood","fr":"Plomb de lumière froide"},{"hex":"#cde7e7","code":"220 90 10","scope":"Design System Plus","de":"Vollmondgrau","en":"Full moon grey","nl":"Volle maan grijs","fr":"Gris pleine lune"},{"hex":"#3f4b50","code":"230 20 10","scope":"Design System Plus","de":"Erzblauschwarz","en":"Ore bluish black","nl":"Boog blauw-zwart","fr":"Noir bleu archaïque"},{"hex":"#384b53","code":"230 20 15","scope":"Design System Plus","de":"Firmamentblau","en":"Firmanent blue","nl":"Firmament blauw","fr":"Bleu menthe"},{"hex":"#2d4955","code":"230 20 20","scope":"Design System Plus","de":"Preußischblau","en":"Prussian blue","nl":"Pruisisch blauw","fr":"Bleu de Prusse"},{"hex":"#4d5b61","code":"230 30 10","scope":"Design System Plus","de":"Galenitblau","en":"Galenite blue","nl":"Galena blauw","fr":"Bleu de galène"},{"hex":"#435b65","code":"230 30 15","scope":"Design System Plus","de":"Beerenblaugrün","en":"Berry blue green","nl":"Bessen blauwgroen","fr":"Bleu-vert baie"},{"hex":"#3a5d6a","code":"230 30 20","scope":"Design System Plus","de":"Petroldunkelblau","en":"Teal dark blue","nl":"Petroleum donkerblauw","fr":"Bleu pétrole foncé"},{"hex":"#2d5e6f","code":"230 30 25","scope":"Design System Plus","de":"Gewitterblau","en":"Thunderstorm blue","nl":"Onweer blauw","fr":"Bleu orage"},{"hex":"#5b6d74","code":"230 40 10","scope":"Design System Plus","de":"Zapfengrünblau","en":"Cone green blue","nl":"Kegel groen blauw","fr":"Bleu vert pomme de pin"},{"hex":"#536e79","code":"230 40 15","scope":"Design System Plus","de":"Wacholderbeerenblau","en":"Juniper berry blue","nl":"Jeneverbes blauw","fr":"Bleu genévrier"},{"hex":"#48717f","code":"230 40 20","scope":"Design System Plus","de":"Sterntauchertürkis","en":"Loon turquoise","nl":"Turquoise met ster","fr":"Plongeon turquoise étoilé"},{"hex":"#387184","code":"230 40 25","scope":"Design System Plus","de":"Werkstattblau","en":"Workshop blue","nl":"Workshop blauw","fr":"Bleu atelier"},{"hex":"#2c738a","code":"230 40 30","scope":"Design System Plus","de":"Pilotenblau","en":"Pilot blue","nl":"Piloot blauw","fr":"Bleu pilote"},{"hex":"#007590","code":"230 40 35","scope":"Design System Plus","de":"Tintenblau","en":"Ink blue","nl":"Inkt blauw","fr":"Bleu encre"},{"hex":"#007593","code":"230 40 40","scope":"Design System Plus","de":"Technoblau","en":"Techno blue","nl":"Technoblauw","fr":"Bleu techno"},{"hex":"#6f838a","code":"230 50 10","scope":"Design System Plus","de":"Kiesgraublau","en":"Gravel grey blue","nl":"Grindgrijs blauw","fr":"Bleu gris gravier"},{"hex":"#658690","code":"230 50 15","scope":"Design System Plus","de":"Fichtenblau","en":"Spruce blue","nl":"Vurenblauw","fr":"Bleu épicéa"},{"hex":"#5a8797","code":"230 50 20","scope":"Design System Plus","de":"Freizeitblau","en":"Casual blue","nl":"Vrije tijd blauw","fr":"Bleu loisir"},{"hex":"#4d889b","code":"230 50 25","scope":"Design System Plus","de":"Vergissmeinnichtblau","en":"Forget-me-not blue","nl":"Vergeet-me-nietje blauw","fr":"Bleu myosotis"},{"hex":"#378ba3","code":"230 50 30","scope":"Design System Plus","de":"Zirkonblau","en":"Zircon blue","nl":"Zirkoonblauw","fr":"Bleu zircon"},{"hex":"#1f8ba6","code":"230 50 35","scope":"Design System Plus","de":"Lagunenblau","en":"Lagoon blue","nl":"Lagune blauw","fr":"Bleu lagon"},{"hex":"#008cad","code":"230 50 40","scope":"Design System Plus","de":"Azorenblau","en":"Azores blue","nl":"Azoren blauw","fr":"Bleu azur"},{"hex":"#869ca4","code":"230 60 10","scope":"Design System Plus","de":"Eisvogelgrau","en":"Kingfisher grey","nl":"IJsvogel grijs","fr":"Gris martin-pêcheur"},{"hex":"#7b9ca7","code":"230 60 15","scope":"Design System Plus","de":"Silbertannenblau","en":"Silver fir blue","nl":"Zilverspar blauw","fr":"Bleu sapin argenté"},{"hex":"#6e9eae","code":"230 60 20","scope":"Design System Plus","de":"Pyjamablau","en":"Pyjama blue","nl":"Pyjama blauw","fr":"Bleu pyjama"},{"hex":"#5e9fb4","code":"230 60 25","scope":"Design System Plus","de":"Sternblütenblau","en":"Starflower blue","nl":"Sterrenbloem blauw","fr":"Bleu fleur d'étoile"},{"hex":"#4fa0b9","code":"230 60 30","scope":"Design System Plus","de":"Sportblau","en":"Sports blue","nl":"Sport blauw","fr":"Bleu sport"},{"hex":"#37a3c1","code":"230 60 35","scope":"Design System Plus","de":"Griechischblau","en":"Greek blue","nl":"Grieks blauw","fr":"Bleu grec"},{"hex":"#00a4c7","code":"230 60 40","scope":"Design System Plus","de":"Alpenblau","en":"Alpine blue","nl":"Alpine blauw","fr":"Bleu des Alpes"},{"hex":"#a0b6be","code":"230 70 10","scope":"Design System Plus","de":"Eismövengraublau","en":"Ice gull grey blue","nl":"IJzig grijsblauw","fr":"Gris goéland glacé"},{"hex":"#91b6c2","code":"230 70 15","scope":"Design System Plus","de":"Distelblütenbleu","en":"Thistleblossom soft blue","nl":"Distelbloesem lood","fr":"Plomb de la fleur de chardon"},{"hex":"#85b8c9","code":"230 70 20","scope":"Design System Plus","de":"Tennisblau","en":"Tennis blue","nl":"Tennis blauw","fr":"Bleu tennis"},{"hex":"#7abacf","code":"230 70 25","scope":"Design System Plus","de":"Oldtimerblau","en":"Vintage blue","nl":"Vintage auto blauw","fr":"Bleu oldtimer"},{"hex":"#68bbd4","code":"230 70 30","scope":"Design System Plus","de":"Fitnessblau","en":"Fitness blue","nl":"Fitness blauw","fr":"Bleu fitness"},{"hex":"#b7cfd6","code":"230 80 10","scope":"Design System Plus","de":"Bleichblau","en":"Pallid blue","nl":"Lichtblauw","fr":"Bleu pâle"},{"hex":"#abceda","code":"230 80 15","scope":"Design System Plus","de":"Alpenmorgenblau","en":"Alpine morning blue","nl":"Alpine ochtendblauw","fr":"Bleu matin alpin"},{"hex":"#a1d2e2","code":"230 80 20","scope":"Design System Plus","de":"Hellblau","en":"Light blue","nl":"Lichtblauw","fr":"Bleu clair"},{"hex":"#ced9dd","code":"230 85 05","scope":"Design System Plus","de":"Polarkaltbleu","en":"Polar soft blue","nl":"Poolkoud lood","fr":"Plomb froid polaire"},{"hex":"#c1d9e1","code":"230 85 10","scope":"Design System Plus","de":"Waschpulverweiß","en":"Washing powder white","nl":"Waspoeder wit","fr":"Blanc en poudre de lavage"},{"hex":"#b8dce7","code":"230 85 15","scope":"Design System Plus","de":"Himalayaweißblau","en":"Himalaya white blue","nl":"Himalaya wit blauw","fr":"Bleu blanc Himalaya"},{"hex":"#abdeee","code":"230 85 20","scope":"Design System Plus","de":"Atmosphärenbleu","en":"Atmospheric soft blue","nl":"Atmosferisch lood","fr":"Plomb atmosphérique"},{"hex":"#dbe6e6","code":"230 90 05","scope":"Design System Plus","de":"Strahlendweiß","en":"Brilliant white","nl":"Gitwit","fr":"Blanc éclatant"},{"hex":"#454a4d","code":"240 20 05","scope":"Design System Plus","de":"Nachtschattenblau","en":"Nightshade blue","nl":"Nachtschade blauw","fr":"bleu nuit"},{"hex":"#3f4a51","code":"240 20 10","scope":"Design System Plus","de":"Holunderschwarz","en":"Elderberry black","nl":"Vlierbes zwart","fr":"Noir sureau"},{"hex":"#394a55","code":"240 20 15","scope":"Design System Plus","de":"Metallblau","en":"Metal blue","nl":"Metaal blauw","fr":"Bleu métal"},{"hex":"#334b59","code":"240 20 20","scope":"Design System Plus","de":"Krähenbeerenblau","en":"Crowberry blue","nl":"Kraaihei blauw","fr":"Bleu corbeau"},{"hex":"#294a5b","code":"240 20 22","scope":"Design System Plus","de":"Sattblau","en":"Rich blue","nl":"Verzadigd blauw","fr":"Bleu satiné"},{"hex":"#52595c","code":"240 30 05","scope":"Design System Plus","de":"Diamantgrau","en":"Diamond grey","nl":"Diamant grijs","fr":"Gris diamant"},{"hex":"#4c5a62","code":"240 30 10","scope":"Design System Plus","de":"Schmutzblau","en":"Dirty blue","nl":"Vuilblauw","fr":"Bleu sale"},{"hex":"#455b67","code":"240 30 15","scope":"Design System Plus","de":"Tiefseeblau","en":"Deep sea blue","nl":"Diep zeeblauw","fr":"Bleu profond"},{"hex":"#3c5c6c","code":"240 30 20","scope":"Design System Plus","de":"Lasuritblau","en":"Lasurite blue","nl":"Glazuriet blauw","fr":"Bleu lasurite"},{"hex":"#2f5c72","code":"240 30 25","scope":"Design System Plus","de":"Arbeitsblau","en":"Work blue","nl":"Blauw werken","fr":"Bleu de travail"},{"hex":"#215d77","code":"240 30 30","scope":"Design System Plus","de":"Schmucksteinblau","en":"Gemstone blue","nl":"Sieraden steen blauw","fr":"Bleu pierre précieuse"},{"hex":"#065f7c","code":"240 30 35","scope":"Design System Plus","de":"Kapitänsblau","en":"Captain blue","nl":"Blauw van de kapitein","fr":"Bleu capitaine"},{"hex":"#646b70","code":"240 40 05","scope":"Design System Plus","de":"Blauanthrazit","en":"Blue anthracite","nl":"Blauw antraciet","fr":"Bleu anthracite"},{"hex":"#5c6d76","code":"240 40 10","scope":"Design System Plus","de":"Schwarzdornblau","en":"Blackthorn blue","nl":"Sleedoorn blauw","fr":"Bleu épine noire"},{"hex":"#536e7d","code":"240 40 15","scope":"Design System Plus","de":"Celesteblau","en":"Celeste blue","nl":"Celeste blauw","fr":"Bleu Céleste"},{"hex":"#486f82","code":"240 40 20","scope":"Design System Plus","de":"Jeansblau","en":"Denim blue","nl":"Denimblauw","fr":"Bleu jean"},{"hex":"#3c708a","code":"240 40 25","scope":"Design System Plus","de":"Orientblau","en":"Orient blue","nl":"Oosters blauw","fr":"Bleu oriental"},{"hex":"#28718f","code":"240 40 30","scope":"Design System Plus","de":"Matrosenblau","en":"Sailor blue","nl":"Matroos blauw","fr":"Bleu marin"},{"hex":"#007295","code":"240 40 35","scope":"Design System Plus","de":"Steinblau","en":"Stone blue","nl":"Steenblauw","fr":"Bleu pierre"},{"hex":"#00749a","code":"240 40 40","scope":"Design System Plus","de":"Reinbleu","en":"Pure light blue","nl":"Reinbleu","fr":"Reinbleu"},{"hex":"#798186","code":"240 50 05","scope":"Design System Plus","de":"Rauchblau","en":"Smoky blue","nl":"Rook blauw","fr":"Bleu fumée"},{"hex":"#6f828c","code":"240 50 10","scope":"Design System Plus","de":"Werkzeugblau","en":"Tool blue","nl":"Gereedschap blauw","fr":"Bleu outil"},{"hex":"#668494","code":"240 50 15","scope":"Design System Plus","de":"Technikblau","en":"Technical blue","nl":"Technisch blauw","fr":"Bleu technique"},{"hex":"#5a859a","code":"240 50 20","scope":"Design System Plus","de":"Coelinblau","en":"Coelin blue","nl":"Coelin blauw","fr":"Bleu célin"},{"hex":"#4c86a0","code":"240 50 25","scope":"Design System Plus","de":"Grönlandblau","en":"Greenland blue","nl":"Groenland blauw","fr":"Bleu groenland"},{"hex":"#3c87a6","code":"240 50 30","scope":"Design System Plus","de":"Sommerblau","en":"Summer blue","nl":"Zomerblauw","fr":"Bleu d'été"},{"hex":"#1f88ad","code":"240 50 35","scope":"Design System Plus","de":"Werbeblau","en":"Advertising blue","nl":"Reclame blauw","fr":"Bleu publicitaire"},{"hex":"#0088b2","code":"240 50 40","scope":"Design System Plus","de":"Tuschblau","en":"Indian inc blue","nl":"Inkt blauw","fr":"Bleu encre"},{"hex":"#8f999e","code":"240 60 05","scope":"Design System Plus","de":"Brieftaubenblau","en":"Carrier pigeon blue","nl":"Postduif blauw","fr":"Bleu pigeon voyageur"},{"hex":"#8297a2","code":"240 60 10","scope":"Design System Plus","de":"Vogelblau","en":"Bird blue","nl":"Vogelblauw","fr":"Bleu oiseau"},{"hex":"#7a9aaa","code":"240 60 15","scope":"Design System Plus","de":"Architekturblau","en":"Architecture blue","nl":"Architectonisch blauw","fr":"Bleu architectural"},{"hex":"#709db3","code":"240 60 20","scope":"Design System Plus","de":"Hemdblau","en":"Shirt blue","nl":"Overhemd blauw","fr":"Bleu foncé"},{"hex":"#639eba","code":"240 60 25","scope":"Design System Plus","de":"Stahlhellblau","en":"Steel light blue","nl":"Staal lichtblauw","fr":"Bleu clair acier"},{"hex":"#519fc0","code":"240 60 30","scope":"Design System Plus","de":"Märchenblau","en":"Fairytale blue","nl":"Sprookjesachtig blauw","fr":"Bleu de conte de fées"},{"hex":"#3ca0c8","code":"240 60 35","scope":"Design System Plus","de":"Prinzessblau","en":"Princess blue","nl":"Prinses blauw","fr":"Bleu princesse"},{"hex":"#1ba3cb","code":"240 60 40","scope":"Design System Plus","de":"Klarblau","en":"Clear blue","nl":"Helder blauw","fr":"Bleu clair"},{"hex":"#a7b1b7","code":"240 70 05","scope":"Design System Plus","de":"Wäscheblau","en":"Laundry blue","nl":"Wasserij blauw","fr":"Bleu linge"},{"hex":"#9eb2bd","code":"240 70 10","scope":"Design System Plus","de":"Augenblau","en":"Eye blue","nl":"Oog blauw","fr":"Bleu des yeux"},{"hex":"#93b5c5","code":"240 70 15","scope":"Design System Plus","de":"Bermudablau","en":"Bermuda blue","nl":"Bermuda blauw","fr":"Bleu bermuda"},{"hex":"#88b5cb","code":"240 70 20","scope":"Design System Plus","de":"Meerblau","en":"Sea blue","nl":"Zee blauw","fr":"Bleu mer"},{"hex":"#7bb8d3","code":"240 70 25","scope":"Design System Plus","de":"Madonnablau","en":"Madonna blue","nl":"Madonna blauw","fr":"Bleu madonna"},{"hex":"#6bb8d8","code":"240 70 30","scope":"Design System Plus","de":"Karibikblau","en":"Caribbean blue","nl":"Caribisch blauw","fr":"Bleu caraïbe"},{"hex":"#bfcacf","code":"240 80 05","scope":"Design System Plus","de":"Dunstblau","en":"Hazy blue","nl":"Haze blauw","fr":"Bleu brumeux"},{"hex":"#b9cfd9","code":"240 80 10","scope":"Design System Plus","de":"Topashellbleu","en":"Light topaz soft blue","nl":"Topashell lood","fr":"Bleu topaze"},{"hex":"#aecfde","code":"240 80 15","scope":"Design System Plus","de":"Babyblau","en":"Baby blue","nl":"Baby blauw","fr":"Bleu bébé"},{"hex":"#a1d1e6","code":"240 80 20","scope":"Design System Plus","de":"Kristallblau","en":"Crystal blue","nl":"Kristalblauw","fr":"Bleu cristal"},{"hex":"#cdd7dd","code":"240 85 05","scope":"Design System Plus","de":"Eisgrau","en":"Ice grey","nl":"IJsgrijs","fr":"Gris glace"},{"hex":"#c2d8e3","code":"240 85 10","scope":"Design System Plus","de":"Luftblau","en":"Air blue","nl":"Lucht blauw","fr":"Bleu aérien"},{"hex":"#b7dbeb","code":"240 85 15","scope":"Design System Plus","de":"Pariserblau","en":"Paris blue","nl":"Parijs blauw","fr":"Bleu parisien"},{"hex":"#dce7e9","code":"240 90 05","scope":"Design System Plus","de":"Bleuweiß","en":"Soft blue white","nl":"Loodwit","fr":"Blanc de plomb"},{"hex":"#cfe8ef","code":"240 90 10","scope":"Design System Plus","de":"Kalkbleu","en":"Chalky blue white","nl":"Kalklood","fr":"Plomb de chaux"},{"hex":"#334a5b","code":"250 20 20","scope":"Design System Plus","de":"Kosmosblau","en":"Cosmos blue","nl":"Kosmos blauw","fr":"Bleu cosmos"},{"hex":"#2f4a5f","code":"250 20 25","scope":"Design System Plus","de":"Dunkeljeansblau","en":"Dark denim blue","nl":"Donker denimblauw","fr":"Bleu jean foncé"},{"hex":"#455968","code":"250 30 15","scope":"Design System Plus","de":"Schwarzwaldblau","en":"Black Forest blue","nl":"Zwarte woud blauw","fr":"Bleu Forêt Noire"},{"hex":"#3b5a6e","code":"250 30 20","scope":"Design System Plus","de":"Schwalbenblau","en":"Swallow blue","nl":"Zwaluw blauw","fr":"Bleu hirondelle"},{"hex":"#335b74","code":"250 30 25","scope":"Design System Plus","de":"Marinedunkelblau","en":"Navy dark blue","nl":"Marine donkerblauw","fr":"Bleu marine foncé"},{"hex":"#235b7b","code":"250 30 30","scope":"Design System Plus","de":"Pompejiblau","en":"Pompeii blue","nl":"Pompeii blauw","fr":"Bleu pompéi"},{"hex":"#5e6c77","code":"250 40 10","scope":"Design System Plus","de":"Trekkingblau","en":"Trekking blue","nl":"Trekking blauw","fr":"Bleu trekking"},{"hex":"#556c7d","code":"250 40 15","scope":"Design System Plus","de":"Stahlblaugrau","en":"Steel blue grey","nl":"Staalblauw-grijs","fr":"Gris bleu acier"},{"hex":"#4a6c83","code":"250 40 20","scope":"Design System Plus","de":"Beerenblau","en":"Berry blue","nl":"Bessenblauw","fr":"Bleu baie"},{"hex":"#3f6e8b","code":"250 40 25","scope":"Design System Plus","de":"Leinenblau","en":"Linen blue","nl":"Linnen blauw","fr":"Bleu lin"},{"hex":"#336f93","code":"250 40 30","scope":"Design System Plus","de":"Poolblau","en":"Pool blue","nl":"Blauw zwembad","fr":"Bleu piscine"},{"hex":"#1a6f97","code":"250 40 35","scope":"Design System Plus","de":"Eisvogelblau","en":"Kingfisher blue","nl":"IJsvogel blauw","fr":"Bleu martin-pêcheur"},{"hex":"#00719c","code":"250 40 40","scope":"Design System Plus","de":"Europablau","en":"Europe blue","nl":"Europees blauw","fr":"Bleu Europe"},{"hex":"#72818d","code":"250 50 10","scope":"Design System Plus","de":"Metallgrau","en":"Metal grey","nl":"Metaalgrijs","fr":"Gris métal"},{"hex":"#688194","code":"250 50 15","scope":"Design System Plus","de":"Titanblau","en":"Titanium blue","nl":"Titaanblauw","fr":"Bleu titane"},{"hex":"#60839b","code":"250 50 20","scope":"Design System Plus","de":"Mallorcablau","en":"Mallorca blue","nl":"Mallorca blauw","fr":"Mallorcablau"},{"hex":"#5583a3","code":"250 50 25","scope":"Design System Plus","de":"Linoleumblau","en":"Linoleum blue","nl":"Linoleum blauw","fr":"Bleu linoléum"},{"hex":"#4684ab","code":"250 50 30","scope":"Design System Plus","de":"Prominentblau","en":"Prominent blue","nl":"Prominent blauw","fr":"Bleu proéminent"},{"hex":"#3386b2","code":"250 50 35","scope":"Design System Plus","de":"Türkischblau","en":"Turkish blue","nl":"Turks blauw","fr":"Bleu turquoise"},{"hex":"#0487b9","code":"250 50 40","scope":"Design System Plus","de":"Urblau","en":"Primal blue","nl":"Primair blauw","fr":"Urblau"},{"hex":"#8798a5","code":"250 60 10","scope":"Design System Plus","de":"Vogelblaugrau","en":"Bird blue grey","nl":"Vogel blauw-grijs","fr":"Gris bleu oiseau"},{"hex":"#7f99ad","code":"250 60 15","scope":"Design System Plus","de":"Sanftblau","en":"Gentle blue","nl":"Zacht blauw","fr":"Bleu doux"},{"hex":"#749ab4","code":"250 60 20","scope":"Design System Plus","de":"Aragonitblau","en":"Aragonite blue","nl":"Aragoniet blauw","fr":"Bleu aragonite"},{"hex":"#699bbc","code":"250 60 25","scope":"Design System Plus","de":"Perlblau","en":"Pearl blue","nl":"Parelblauw","fr":"Bleu perle"},{"hex":"#5c9dc3","code":"250 60 30","scope":"Design System Plus","de":"Topasblau","en":"Topaz blue","nl":"Topaas blauw","fr":"Bleu topaze"},{"hex":"#4d9dca","code":"250 60 35","scope":"Design System Plus","de":"Stratosblau","en":"Stratos blue","nl":"Stratos blauw","fr":"Bleu stratos"},{"hex":"#3a9fd3","code":"250 60 40","scope":"Design System Plus","de":"Bauwerkblau","en":"Structural blue","nl":"Blauw gebouw","fr":"Bleu de chantier"},{"hex":"#9fb2be","code":"250 70 10","scope":"Design System Plus","de":"Nebelblau","en":"Foggy blue","nl":"Mistig blauw","fr":"Bleu brume"},{"hex":"#97b3c7","code":"250 70 15","scope":"Design System Plus","de":"Kreideblau","en":"Chalk blue","nl":"Krijtblauw","fr":"Bleu craie"},{"hex":"#8cb3ce","code":"250 70 20","scope":"Design System Plus","de":"Mittelblau","en":"Medium blue","nl":"Medium blauw","fr":"Bleu moyen"},{"hex":"#82b5d5","code":"250 70 25","scope":"Design System Plus","de":"Wiesenblütenblau","en":"Meadow blossom blue","nl":"Weidebloesem blauw","fr":"Bleu fleur des champs"},{"hex":"#75b5dc","code":"250 70 30","scope":"Design System Plus","de":"Ginsterfalterblau","en":"Broom butterfly blue","nl":"Bezem vlinder blauw","fr":"Bleu papillon de genêt"},{"hex":"#b9cbd8","code":"250 80 10","scope":"Design System Plus","de":"Hellcyan","en":"Light cyan","nl":"Hellcyan","fr":"Hellcyan"},{"hex":"#b2cee0","code":"250 80 15","scope":"Design System Plus","de":"Himalayablau","en":"Himalaya blue","nl":"Himalaya blauw","fr":"Bleu Himalaya"},{"hex":"#a4cbe5","code":"250 80 20","scope":"Design System Plus","de":"Samtblau","en":"Velvet blue","nl":"Fluweelblauw","fr":"Bleu velours"},{"hex":"#ccd4da","code":"250 85 05","scope":"Design System Plus","de":"Weißblau","en":"White blue","nl":"Witblauw","fr":"Bleu blanc"},{"hex":"#c2d5e2","code":"250 85 10","scope":"Design System Plus","de":"Waschmittelbleu","en":"Washing powder soft blue","nl":"Wasmiddel lood","fr":"Bleu de lessive"},{"hex":"#bcd8ea","code":"250 85 15","scope":"Design System Plus","de":"Diamantbleu","en":"Diamond soft blue","nl":"Diamantlood","fr":"Bleu diamant"},{"hex":"#dbe3e7","code":"250 90 05","scope":"Design System Plus","de":"Eisweiß","en":"Ice white","nl":"Ijs wit","fr":"Blanc glacé"},{"hex":"#474a4e","code":"260 20 05","scope":"Design System Plus","de":"Blauschwarz","en":"Blue-black","nl":"Blauw-zwart","fr":"Bleu-noir"},{"hex":"#424952","code":"260 20 10","scope":"Design System Plus","de":"Natoblau","en":"Nato blue","nl":"Natuurlijk blauw","fr":"Bleu nato"},{"hex":"#3b4856","code":"260 20 15","scope":"Design System Plus","de":"Anzugblau","en":"Suit blue","nl":"Pak blauw","fr":"Bleu de costume"},{"hex":"#384a5c","code":"260 20 20","scope":"Design System Plus","de":"Halitblau","en":"Halite blue","nl":"Haliet blauw","fr":"Bleu halite"},{"hex":"#54595e","code":"260 30 05","scope":"Design System Plus","de":"Bergentengrau","en":"Alpine duck grey","nl":"Bergeend grijs","fr":"Gris canard des montagnes"},{"hex":"#505a65","code":"260 30 10","scope":"Design System Plus","de":"Bronzeblau","en":"Bronze blue","nl":"Bronsblauw","fr":"Bleu bronze"},{"hex":"#4a596a","code":"260 30 15","scope":"Design System Plus","de":"Berlinerblau","en":"Berlin blue","nl":"Berlijn blauw","fr":"Bleu berlinois"},{"hex":"#445a70","code":"260 30 20","scope":"Design System Plus","de":"Frankreichblau","en":"French blue","nl":"Frankrijk blauw","fr":"Bleu France"},{"hex":"#3a5a75","code":"260 30 25","scope":"Design System Plus","de":"Tansanitblau","en":"Tanzanite blue","nl":"Tanzaniet blauw","fr":"Bleu tanzanite"},{"hex":"#345b7d","code":"260 30 30","scope":"Design System Plus","de":"Opalblau","en":"Opal blue","nl":"Opaalblauw","fr":"Bleu opale"},{"hex":"#1e5b85","code":"260 30 35","scope":"Design System Plus","de":"Königsblau","en":"Royal blue","nl":"Koningsblauw","fr":"Bleu roi"},{"hex":"#666a70","code":"260 40 05","scope":"Design System Plus","de":"Schwedenblau","en":"Swedish blue","nl":"Zweeds blauw","fr":"Bleu suédois"},{"hex":"#626d79","code":"260 40 10","scope":"Design System Plus","de":"Schotenblau","en":"Sheet blue","nl":"Pod blauw","fr":"Bleu cosse"},{"hex":"#5c6d80","code":"260 40 15","scope":"Design System Plus","de":"Zwetschgenblau","en":"Plum blue","nl":"Pruim blauw","fr":"Bleu quetsche"},{"hex":"#526c85","code":"260 40 20","scope":"Design System Plus","de":"Kadettblau","en":"Cadet blue","nl":"Cadet blauw","fr":"Bleu cadet"},{"hex":"#4b6e8c","code":"260 40 25","scope":"Design System Plus","de":"Emailleblau","en":"Enamel blue","nl":"Emaille blauw","fr":"Bleu émail"},{"hex":"#426e92","code":"260 40 30","scope":"Design System Plus","de":"Kopenhagenerblau","en":"Copenhagen blue","nl":"Kopenhagen blauw","fr":"Bleu Copenhague"},{"hex":"#356e99","code":"260 40 35","scope":"Design System Plus","de":"Bauhausblau","en":"Bauhaus blue","nl":"Bauhaus blauw","fr":"Bleu Bauhaus"},{"hex":"#1e70a3","code":"260 40 40","scope":"Design System Plus","de":"Marineblau","en":"Navy blue","nl":"Marineblauw","fr":"Bleu marine"},{"hex":"#0070a9","code":"260 40 45","scope":"Design System Plus","de":"LEDblau","en":"LED blue","nl":"LED blauw","fr":"LED bleu"},{"hex":"#797e85","code":"260 50 05","scope":"Design System Plus","de":"Spitzbergenblau","en":"Spitsbergen blue","nl":"Spitsbergen blauw","fr":"Bleu Spitzberg"},{"hex":"#75808d","code":"260 50 10","scope":"Design System Plus","de":"Zypressengraublau","en":"Cypress grey blue","nl":"Cypres grijs blauw","fr":"Bleu gris cyprès"},{"hex":"#6e8194","code":"260 50 15","scope":"Design System Plus","de":"Mahonienbeerenblau","en":"Mahonia berry blue","nl":"Mahonia bessenblauw","fr":"Bleu mahonia"},{"hex":"#6a849d","code":"260 50 20","scope":"Design System Plus","de":"Kröpperblau","en":"Doves blue","nl":"Kröpper blauw","fr":"Bleu kröpper"},{"hex":"#6084a6","code":"260 50 25","scope":"Design System Plus","de":"Biedermeierblau","en":"Biedermeier blue","nl":"Biedermeier blauw","fr":"Bleu Biedermeier"},{"hex":"#5485af","code":"260 50 30","scope":"Design System Plus","de":"Pekingblau","en":"Beijing blue","nl":"Peking blauw","fr":"Bleu pékin"},{"hex":"#4784b3","code":"260 50 35","scope":"Design System Plus","de":"Vermeerblau","en":"Vermeer blue","nl":"Vermeer blauw","fr":"Bleu Vermeer"},{"hex":"#3586bd","code":"260 50 40","scope":"Design System Plus","de":"Porzellanblau","en":"Meissen blue","nl":"Porseleinblauw","fr":"Bleu porcelaine"},{"hex":"#91979e","code":"260 60 05","scope":"Design System Plus","de":"Seehundgrau","en":"Seal grey","nl":"Seal grijs","fr":"Gris phoque"},{"hex":"#8b97a5","code":"260 60 10","scope":"Design System Plus","de":"Diopsidblau","en":"Diopside blue","nl":"Diopside blauw","fr":"Bleu diopside"},{"hex":"#879bb0","code":"260 60 15","scope":"Design System Plus","de":"Nordlandblau","en":"Nordland blue","nl":"Nordland blauw","fr":"Bleu du Nord"},{"hex":"#7e9ab5","code":"260 60 20","scope":"Design System Plus","de":"Moorbeerenblau","en":"Cranberry blue","nl":"Moorbes blauw","fr":"Bleu canneberge"},{"hex":"#759bbe","code":"260 60 25","scope":"Design System Plus","de":"Lupinenblau","en":"Lupine blue","nl":"Lupine blauw","fr":"Bleu lupin"},{"hex":"#6b9cc6","code":"260 60 30","scope":"Design System Plus","de":"Sadebeerenbleu","en":"Blueberry soft blue","nl":"Sadeberry lood","fr":"Plomb aux baies de Sade"},{"hex":"#5f9dcd","code":"260 60 35","scope":"Design System Plus","de":"Leuchtendblau","en":"Brilliant blue","nl":"Helderblauw","fr":"Bleu vif"},{"hex":"#abb1b8","code":"260 70 05","scope":"Design System Plus","de":"Nordlichtgrau","en":"Northern light grey","nl":"Noorderlicht grijs","fr":"Gris lumière du nord"},{"hex":"#a5b2c0","code":"260 70 10","scope":"Design System Plus","de":"Sturmvogelblaugrau","en":"Petrel blue grey","nl":"Stormvogel blauwgrijs","fr":"Gris-bleu tempête"},{"hex":"#9cb2c8","code":"260 70 15","scope":"Design System Plus","de":"Nordlandhellblau","en":"Nordland light blue","nl":"Nordland lichtblauw","fr":"Bleu clair du Nordland"},{"hex":"#96b4d0","code":"260 70 20","scope":"Design System Plus","de":"Mattblau","en":"Matte blue","nl":"Matblauw","fr":"Bleu mat"},{"hex":"#8cb4d8","code":"260 70 25","scope":"Design System Plus","de":"Pazifikblau","en":"Pacific blue","nl":"Pacifisch blauw","fr":"Bleu pacifique"},{"hex":"#c3cad1","code":"260 80 05","scope":"Design System Plus","de":"Lichtblaugrau","en":"Light blue grey","nl":"Licht blauw-grijs","fr":"Gris bleu clair"},{"hex":"#bdcbd9","code":"260 80 10","scope":"Design System Plus","de":"Puderbleu","en":"Powder soft blue","nl":"Poederlood","fr":"Plomb en poudre"},{"hex":"#b5cce0","code":"260 80 15","scope":"Design System Plus","de":"Windblau","en":"Wind blue","nl":"Wind blauw","fr":"Bleu vent"},{"hex":"#cdd3d9","code":"260 85 05","scope":"Design System Plus","de":"Satinweiß","en":"Satin white","nl":"Satijn wit","fr":"Blanc satiné"},{"hex":"#c8d7e5","code":"260 85 10","scope":"Design System Plus","de":"Meeresbrisengrün","en":"Sea breeze green","nl":"Zeewind groen","fr":"Vert cassis de mer"},{"hex":"#dde3e7","code":"260 90 05","scope":"Design System Plus","de":"Milchblau","en":"Milk blue","nl":"Melkblauw","fr":"Bleu lait"},{"hex":"#3a475c","code":"270 20 20","scope":"Design System Plus","de":"Krähenschwarzblau","en":"Crow black blue","nl":"Kraai zwart blauw","fr":"Bleu noir corbeau"},{"hex":"#344660","code":"270 20 25","scope":"Design System Plus","de":"Indigoschwarz","en":"Indigo black","nl":"Indigo zwart","fr":"Noir indigo"},{"hex":"#2e4667","code":"270 20 29","scope":"Design System Plus","de":"Kraftblau","en":"Effervescent blue","nl":"Blauw vermogen","fr":"Bleu kraft"},{"hex":"#4c5768","code":"270 30 15","scope":"Design System Plus","de":"Mitternachtsblau","en":"Midnight blue","nl":"Middernachtblauw","fr":"Bleu minuit"},{"hex":"#47576f","code":"270 30 20","scope":"Design System Plus","de":"Dunkelblau","en":"Dark blue","nl":"Donkerblauw","fr":"Bleu foncé"},{"hex":"#415776","code":"270 30 25","scope":"Design System Plus","de":"Traubenblau","en":"Grape blue","nl":"Druifblauw","fr":"Bleu raisin"},{"hex":"#39567c","code":"270 30 30","scope":"Design System Plus","de":"Mediciblau","en":"Medici blue","nl":"Medici blauw","fr":"Bleu medici"},{"hex":"#2f5682","code":"270 30 35","scope":"Design System Plus","de":"Kolibriblau","en":"Kolibri blue","nl":"Kolibrie blauw","fr":"Bleu colibri"},{"hex":"#1f568a","code":"270 30 40","scope":"Design System Plus","de":"Prinzenblau","en":"Prince blue","nl":"Prins blauw","fr":"Bleu prince"},{"hex":"#5f6b7f","code":"270 40 15","scope":"Design System Plus","de":"Zinngrau","en":"Pewter grey","nl":"Tinnen grijs","fr":"Gris étain"},{"hex":"#576a85","code":"270 40 20","scope":"Design System Plus","de":"Salonblau","en":"Parlour blue","nl":"Salon blauw","fr":"Bleu salon"},{"hex":"#536b8d","code":"270 40 25","scope":"Design System Plus","de":"Funktionsblau","en":"Functional blue","nl":"Functioneel blauw","fr":"Bleu fonctionnel"},{"hex":"#4a6a94","code":"270 40 30","scope":"Design System Plus","de":"Schminkblau","en":"Make-up blue","nl":"Make-up blauw","fr":"Bleu maquillage"},{"hex":"#406a9b","code":"270 40 35","scope":"Design System Plus","de":"Lapislazuliblau","en":"Lapis lazuli blue","nl":"Lapis lazuli blauw","fr":"Bleu lapis-lazuli"},{"hex":"#3469a2","code":"270 40 40","scope":"Design System Plus","de":"Zauberblau","en":"Magic blue","nl":"Magisch blauw","fr":"Bleu magique"},{"hex":"#77808f","code":"270 50 10","scope":"Design System Plus","de":"Brokatblau","en":"Brocade blue","nl":"Brokaatblauw","fr":"Bleu brocart"},{"hex":"#738197","code":"270 50 15","scope":"Design System Plus","de":"Edelblau","en":"Noble blue","nl":"Edel blauw","fr":"Bleu précieux"},{"hex":"#6d819e","code":"270 50 20","scope":"Design System Plus","de":"Delfterblau","en":"Delft blue","nl":"Delfts blauw","fr":"Bleu Delft"},{"hex":"#6780a6","code":"270 50 25","scope":"Design System Plus","de":"Cocktailblau","en":"Cocktail blue","nl":"Cocktail blauw","fr":"Bleu cocktail"},{"hex":"#5e80ad","code":"270 50 30","scope":"Design System Plus","de":"Salbeiblütenblau","en":"Sage blossom blue","nl":"Saliebloesem blauw","fr":"Bleu fleur de sauge"},{"hex":"#557fb2","code":"270 50 35","scope":"Design System Plus","de":"Wienerblau","en":"Viennese blue","nl":"Wenen blauw","fr":"Bleu viennois"},{"hex":"#4a81bd","code":"270 50 40","scope":"Design System Plus","de":"Kornblumenblau","en":"Cornflower blue","nl":"Korenbloemblauw","fr":"Bleu bleuet"},{"hex":"#8c97a7","code":"270 60 10","scope":"Design System Plus","de":"Fantasiegrau","en":"Fantasy grey","nl":"Fantasie grijs","fr":"Gris fantaisie"},{"hex":"#8998b0","code":"270 60 15","scope":"Design System Plus","de":"Fliederblau","en":"Lilac blue","nl":"Lila blauw","fr":"Bleu lilas"},{"hex":"#8398b7","code":"270 60 20","scope":"Design System Plus","de":"Lavendelblau","en":"Lavender blue","nl":"Lavendelblauw","fr":"Bleu lavande"},{"hex":"#7d98bf","code":"270 60 25","scope":"Design System Plus","de":"Ritterspornblau","en":"Delphinium blue","nl":"Ridderspoor blauw","fr":"Bleu éperon d'or"},{"hex":"#7699c8","code":"270 60 30","scope":"Design System Plus","de":"Lidschattenblau","en":"Eyeshadow blue","nl":"Oogschaduw blauw","fr":"Bleu de l'ombre à paupières"},{"hex":"#6b97ce","code":"270 60 35","scope":"Design System Plus","de":"Argusfalterblau","en":"Butterfly blue","nl":"Argus vlinder blauw","fr":"Bleu arguspapillon"},{"hex":"#a7b1c1","code":"270 70 10","scope":"Design System Plus","de":"Federbleu","en":"Feather soft blue","nl":"Voorjaarslood","fr":"Plomb pour ressort"},{"hex":"#a1b1c9","code":"270 70 15","scope":"Design System Plus","de":"Satinbleu","en":"Satin soft blue","nl":"Satijnlood","fr":"Bleu satin"},{"hex":"#9cb2d2","code":"270 70 20","scope":"Design System Plus","de":"Engelblau","en":"Angel blue","nl":"Engelenblauw","fr":"Bleu ange"},{"hex":"#93afd8","code":"270 70 25","scope":"Design System Plus","de":"Knabenblau","en":"Boy blue","nl":"Blauw voor jongens","fr":"Bleu garçon"},{"hex":"#c1cad9","code":"270 80 10","scope":"Design System Plus","de":"Perlhellbleu","en":"Light pearl soft blue","nl":"Parel lichtsnoer","fr":"Bleu perle clair"},{"hex":"#b9c9e1","code":"270 80 15","scope":"Design System Plus","de":"Retinableu","en":"Retina soft blue","nl":"Retinableu","fr":"Retinableu"},{"hex":"#d1d4da","code":"270 85 05","scope":"Design System Plus","de":"Engelshaarsilber","en":"Angel hair silver","nl":"Engelenhaar zilver","fr":"Cheveux d'ange argentés"},{"hex":"#cad4e4","code":"270 85 10","scope":"Design System Plus","de":"Perlmuttsilber","en":"Mother-of-pearl silver","nl":"Parelmoer zilver","fr":"Argent nacré"},{"hex":"#c4d4ec","code":"270 85 15","scope":"Design System Plus","de":"Muranobleu","en":"Murano soft blue","nl":"Muranobleu","fr":"Muranobleu"},{"hex":"#e0e3e8","code":"270 90 05","scope":"Design System Plus","de":"Bleichweiß","en":"Bleached white","nl":"Licht wit","fr":"Blanc pâle"},{"hex":"#4a4a4e","code":"280 20 05","scope":"Design System Plus","de":"Granitschwarz","en":"Granite black","nl":"Graniet zwart","fr":"Noir granit"},{"hex":"#474a53","code":"280 20 10","scope":"Design System Plus","de":"Diamantschwarz","en":"Diamond black","nl":"Diamant zwart","fr":"Noir diamant"},{"hex":"#444958","code":"280 20 15","scope":"Design System Plus","de":"Krähenschwarz","en":"Crow black","nl":"Kraai zwart","fr":"Noir corbeau"},{"hex":"#41485b","code":"280 20 20","scope":"Design System Plus","de":"Manganschwarz","en":"Manganese black","nl":"Mangaan zwart","fr":"Noir de manganèse"},{"hex":"#3f4862","code":"280 20 25","scope":"Design System Plus","de":"Elitenblau","en":"Elite blue","nl":"Elite blauw","fr":"Bleu élite"},{"hex":"#3a4868","code":"280 20 30","scope":"Design System Plus","de":"Ambassadorblau","en":"Ambassador blue","nl":"Ambassadeur blauw","fr":"Bleu ambassador"},{"hex":"#57585d","code":"280 30 05","scope":"Design System Plus","de":"Smokingnachtblau","en":"Smoking night blue","nl":"Dinerjas nachtblauw","fr":"Bleu nuit smoking"},{"hex":"#555965","code":"280 30 10","scope":"Design System Plus","de":"Meteoritschwarzblau","en":"Meteorite black blue","nl":"Meteoriet zwart blauw","fr":"Bleu météorite noir"},{"hex":"#52596b","code":"280 30 15","scope":"Design System Plus","de":"Kohlesteinblau","en":"Anthracite blue","nl":"Houtskoolblauw","fr":"Bleu pierre de charbon"},{"hex":"#4f5972","code":"280 30 20","scope":"Design System Plus","de":"Granatsteinblau","en":"Garnet stone blue","nl":"Granaatsteen blauw","fr":"Bleu pierre de grenat"},{"hex":"#4c5977","code":"280 30 25","scope":"Design System Plus","de":"Wasserstoffblau","en":"Hydrogen blue","nl":"Waterstof blauw","fr":"Bleu hydrogène"},{"hex":"#45577e","code":"280 30 30","scope":"Design System Plus","de":"Tiefblau","en":"Deep blue","nl":"Diepblauw","fr":"Bleu profond"},{"hex":"#425783","code":"280 30 35","scope":"Design System Plus","de":"Theaterblau","en":"Theatre blue","nl":"Theater blauw","fr":"Bleu théâtre"},{"hex":"#3d588a","code":"280 30 40","scope":"Design System Plus","de":"Plakatblau","en":"Poster blue","nl":"Poster blauw","fr":"Bleu affiche"},{"hex":"#696b71","code":"280 40 05","scope":"Design System Plus","de":"Galeriegrau","en":"Gallery grey","nl":"Galerij grijs","fr":"Gris galerie"},{"hex":"#666a78","code":"280 40 10","scope":"Design System Plus","de":"Wildlederindigo","en":"Suede indigo","nl":"Suède indigo","fr":"Indigo en daim"},{"hex":"#636a7f","code":"280 40 15","scope":"Design System Plus","de":"Dunkellavendel","en":"Dark lavender","nl":"Donker lavendel","fr":"Lavande sombre"},{"hex":"#5f6a86","code":"280 40 20","scope":"Design System Plus","de":"Sternenhimmelblau","en":"Starry sky blue","nl":"Hemelsblauw","fr":"Bleu ciel étoilé"},{"hex":"#5d6b8e","code":"280 40 25","scope":"Design System Plus","de":"Indigomarineblau","en":"Indigo navy blue","nl":"Indigo blauw","fr":"Bleu indigo"},{"hex":"#586a94","code":"280 40 30","scope":"Design System Plus","de":"Abendblau","en":"Evening blue","nl":"Avondblauw","fr":"Bleu soir"},{"hex":"#526b9b","code":"280 40 35","scope":"Design System Plus","de":"Portugalblau","en":"Portuguese blue","nl":"Portugal blauw","fr":"Bleu Portugal"},{"hex":"#4a6aa3","code":"280 40 40","scope":"Design System Plus","de":"Neptunblau","en":"Neptune blue","nl":"Neptunus blauw","fr":"Bleu neptune"},{"hex":"#4169aa","code":"280 40 45","scope":"Design System Plus","de":"Hyazinthenblau","en":"Hyacinth blue","nl":"Hyacint blauw","fr":"Bleu jacinthe"},{"hex":"#7d8087","code":"280 50 05","scope":"Design System Plus","de":"Nobelgrau","en":"Noble grey","nl":"Edel grijs","fr":"Gris Nobel"},{"hex":"#7b808f","code":"280 50 10","scope":"Design System Plus","de":"Eisblaugrau","en":"Ice blue grey","nl":"IJsblauw grijs","fr":"Gris bleu glacé"},{"hex":"#788096","code":"280 50 15","scope":"Design System Plus","de":"Granitblau","en":"Granite blue","nl":"Granietblauw","fr":"Bleu granit"},{"hex":"#747f9e","code":"280 50 20","scope":"Design System Plus","de":"Lavendellila","en":"Lavender mauve","nl":"Lavendelpaars","fr":"Violet lavande"},{"hex":"#717fa5","code":"280 50 25","scope":"Design System Plus","de":"Kostümblau","en":"Costume blue","nl":"Kostuum blauw","fr":"Bleu de costume"},{"hex":"#6c7fad","code":"280 50 30","scope":"Design System Plus","de":"Helllila","en":"Light mauve","nl":"Licht lila","fr":"Violet clair"},{"hex":"#667eb3","code":"280 50 35","scope":"Design System Plus","de":"Saphirschimmerblau","en":"Sapphire shimmer blue","nl":"Saffierglans blauw","fr":"Bleu saphir scintillant"},{"hex":"#6180be","code":"280 50 40","scope":"Design System Plus","de":"Divenviolett","en":"Diva violet","nl":"Diva violet","fr":"Violet de diva"},{"hex":"#94979e","code":"280 60 05","scope":"Design System Plus","de":"Tüllgrau","en":"Tulle grey","nl":"Tule grijs","fr":"Gris tulle"},{"hex":"#9196a6","code":"280 60 10","scope":"Design System Plus","de":"Süßlavendel","en":"Sweet lavender","nl":"Zoete lavendel","fr":"Lavande douce"},{"hex":"#8e96ae","code":"280 60 15","scope":"Design System Plus","de":"Marmorblau","en":"Marble blue","nl":"Marmerblauw","fr":"Bleu marbré"},{"hex":"#8b96b7","code":"280 60 20","scope":"Design System Plus","de":"Nebelviolett","en":"Misty violet","nl":"Mist violet","fr":"Violet brumeux"},{"hex":"#8695be","code":"280 60 25","scope":"Design System Plus","de":"Opalviolett","en":"Opal violet","nl":"Opaal violet","fr":"Violet opalin"},{"hex":"#8296c5","code":"280 60 30","scope":"Design System Plus","de":"Persischviolett","en":"Persian violet","nl":"Perzisch viooltje","fr":"Violet persan"},{"hex":"#7e97cf","code":"280 60 35","scope":"Design System Plus","de":"Organzaviolett","en":"Organza violet","nl":"Organza violet","fr":"Violet d'organza"},{"hex":"#acaeb6","code":"280 70 05","scope":"Design System Plus","de":"Taupegrau","en":"Taupe grey","nl":"Taupegrijs","fr":"Gris taupe"},{"hex":"#abb0bf","code":"280 70 10","scope":"Design System Plus","de":"Tüllviolett","en":"Tulle violet","nl":"Tule violet","fr":"Violet de tulle"},{"hex":"#a8b0c8","code":"280 70 15","scope":"Design System Plus","de":"Sandglöckchenviola","en":"Foxflower viola","nl":"Zandloper altviool","fr":"Viola sablonneuse"},{"hex":"#a3afd1","code":"280 70 20","scope":"Design System Plus","de":"Fliederduftbleu","en":"Lilac scent soft blue","nl":"Lila geparfumeerd lood","fr":"Bleu de parfum de lilas"},{"hex":"#a1b0da","code":"280 70 25","scope":"Design System Plus","de":"Asterblütenblau","en":"Aster flower blue","nl":"Asterbloem blauw","fr":"Bleu fleur d'aster"},{"hex":"#c8cad1","code":"280 80 05","scope":"Design System Plus","de":"Violaeisgrau","en":"Viola ice grey","nl":"Viool ijsgrijs","fr":"Gris violet"},{"hex":"#c4c9d9","code":"280 80 10","scope":"Design System Plus","de":"Hyazinthenweißbleu","en":"Hyacinth white soft blue","nl":"Hyacint wit lood","fr":"Bleu blanc jacinthe"},{"hex":"#bfc8e0","code":"280 80 15","scope":"Design System Plus","de":"Veilchenduftbleu","en":"Violet scent soft blue","nl":"Bleu met viooltjesgeur","fr":"Bleu de parfum de violette"},{"hex":"#d2d5db","code":"280 85 05","scope":"Design System Plus","de":"Kieselbleuweiß","en":"Pebble soft blue white","nl":"Kiezel lood wit","fr":"Blanc plomb galet"},{"hex":"#cdd4e4","code":"280 85 10","scope":"Design System Plus","de":"Schmuckweiß","en":"Jewellery white","nl":"Juwelen wit","fr":"Blanc éclatant"},{"hex":"#e0e3e8","code":"280 90 05","scope":"Design System Plus","de":"Lilaweiß","en":"Mauve white","nl":"Paars wit","fr":"Blanc lilas"},{"hex":"#e8eaf0","code":"280 93 05","scope":"Design System Plus","de":"Porzellanweiß","en":"Porcelain white","nl":"Porselein wit","fr":"Blanc porcelaine"},{"hex":"#454650","code":"290 20 10","scope":"Design System Plus","de":"Spinellsteinschwarz","en":"Spinel stone black","nl":"Spinelsteen zwart","fr":"Noir pierre spinelle"},{"hex":"#474655","code":"290 20 15","scope":"Design System Plus","de":"Schwarzviolett","en":"Black violet","nl":"Zwart viooltje","fr":"Noir violet"},{"hex":"#47485d","code":"290 20 20","scope":"Design System Plus","de":"Tropennachtblau","en":"Tropical night blue","nl":"Tropisch nachtblauw","fr":"Bleu nuit tropical"},{"hex":"#434661","code":"290 20 25","scope":"Design System Plus","de":"Indigoviolett","en":"Indigo violet","nl":"Indigo violet","fr":"Violet indigo"},{"hex":"#404465","code":"290 20 30","scope":"Design System Plus","de":"Ultramarinviolett","en":"Ultramarine violet","nl":"Ultramarijn violet","fr":"Violet outremer"},{"hex":"#3e446c","code":"290 20 35","scope":"Design System Plus","de":"Trollingerblau","en":"Schiava blue","nl":"Trollinger blauw","fr":"Bleu trollinger"},{"hex":"#565562","code":"290 30 10","scope":"Design System Plus","de":"Flintsteinblau","en":"Flintstone blue","nl":"Vuursteenblauw","fr":"Bleu silex"},{"hex":"#555669","code":"290 30 15","scope":"Design System Plus","de":"Spinellschwarz","en":"Spinel black","nl":"Spinel zwart","fr":"Noir spinelle"},{"hex":"#52536d","code":"290 30 20","scope":"Design System Plus","de":"Kirchenblau","en":"Church blue","nl":"Kerk blauw","fr":"Bleu église"},{"hex":"#525475","code":"290 30 25","scope":"Design System Plus","de":"Finsternisblau","en":"Gloomy blue","nl":"Donkerblauw","fr":"Bleu éclipse"},{"hex":"#4f537b","code":"290 30 30","scope":"Design System Plus","de":"Lembergerblau","en":"Lviv blue","nl":"Lemberger blauw","fr":"Bleu Lemberger"},{"hex":"#4d5483","code":"290 30 35","scope":"Design System Plus","de":"Britischlila","en":"British mauve","nl":"Brits paars","fr":"Violet britannique"},{"hex":"#495389","code":"290 30 40","scope":"Design System Plus","de":"Amtsviolett","en":"Official violet","nl":"Officieel violet","fr":"Violet officiel"},{"hex":"#696876","code":"290 40 10","scope":"Design System Plus","de":"Sturmtaucherschwarz","en":"Shearwater black","nl":"Pijlstormvogel zwart","fr":"Noir plongeur de tempête"},{"hex":"#68687d","code":"290 40 15","scope":"Design System Plus","de":"Achatviolett","en":"Agate violet","nl":"Agaat violet","fr":"Violet agate"},{"hex":"#656785","code":"290 40 20","scope":"Design System Plus","de":"Tieflavendel","en":"Deep lavender","nl":"Diep lavendel","fr":"Lavande profonde"},{"hex":"#63658b","code":"290 40 25","scope":"Design System Plus","de":"Dämmerungslila","en":"Dusk mauve","nl":"Schemerpaars","fr":"Violet crépusculaire"},{"hex":"#606592","code":"290 40 30","scope":"Design System Plus","de":"Reichviolett","en":"Rich violet","nl":"Rijk violet","fr":"Violet riche"},{"hex":"#5e6498","code":"290 40 35","scope":"Design System Plus","de":"Zwiebelschalenblau","en":"Onion skin blue","nl":"Uienschil blauw","fr":"Bleu pelure d'oignon"},{"hex":"#5b65a1","code":"290 40 40","scope":"Design System Plus","de":"Schwertlilienblau","en":"Iris blue","nl":"Iris blauw","fr":"Bleu iris"},{"hex":"#5664a7","code":"290 40 45","scope":"Design System Plus","de":"Veilchenblau","en":"Violet blue","nl":"Violetblauw","fr":"Bleu violet"},{"hex":"#7c7c8c","code":"290 50 10","scope":"Design System Plus","de":"Aschlila","en":"Ash mauve","nl":"Ashlila","fr":"Aschlila"},{"hex":"#7b7c92","code":"290 50 15","scope":"Design System Plus","de":"Sturmlila","en":"Stormy mauve","nl":"Stormpaars","fr":"Violet de tempête"},{"hex":"#797a9b","code":"290 50 20","scope":"Design System Plus","de":"Seidenkrepplila","en":"Silk crepe mauve","nl":"Zijde crêpe paars","fr":"Crêpe de soie violet"},{"hex":"#797ba4","code":"290 50 25","scope":"Design System Plus","de":"Hyazinthenlila","en":"Hyacinth mauve","nl":"Hyacint paars","fr":"Mauve jacinthe"},{"hex":"#777aaa","code":"290 50 30","scope":"Design System Plus","de":"Bergblumenlila","en":"Mountain flower mauve","nl":"Bergbloem paars","fr":"Fleurs de montagne violettes"},{"hex":"#7379b2","code":"290 50 35","scope":"Design System Plus","de":"Chalcedonviolett","en":"Chalcedony violet","nl":"Chalcedoon violet","fr":"Violet de calcédoine"},{"hex":"#7079ba","code":"290 50 40","scope":"Design System Plus","de":"Gladiolenblau","en":"Gladiola blue","nl":"Gladiolen blauw","fr":"Bleu glaïeul"},{"hex":"#9293a5","code":"290 60 10","scope":"Design System Plus","de":"Lavendelblütengrau","en":"Lavender blossom grey","nl":"Lavendelbloesem grijs","fr":"Gris fleur de lavande"},{"hex":"#9393ac","code":"290 60 15","scope":"Design System Plus","de":"Grazilviolett","en":"Delicate violet","nl":"Grijsviolet","fr":"Violet gracile"},{"hex":"#8f91b5","code":"290 60 20","scope":"Design System Plus","de":"Opernlila","en":"Opera mauve","nl":"Opera paars","fr":"Violet d'opéra"},{"hex":"#9092bd","code":"290 60 25","scope":"Design System Plus","de":"Bleulavendel","en":"Soft blue lavender","nl":"Lavendel","fr":"Lavande de plomb"},{"hex":"#8d91c4","code":"290 60 30","scope":"Design System Plus","de":"Plisseelila","en":"Pleated mauve","nl":"Geplooide lelie","fr":"Plisseelila"},{"hex":"#888fca","code":"290 60 35","scope":"Design System Plus","de":"Echtlavendel","en":"True lavender","nl":"Echte lavendel","fr":"Lavande vraie"},{"hex":"#adadbf","code":"290 70 10","scope":"Design System Plus","de":"Cremeviolett","en":"Cream violet","nl":"Crème violet","fr":"Violet crème"},{"hex":"#ababc7","code":"290 70 15","scope":"Design System Plus","de":"Glyzinienhellbleu","en":"Wisteria light soft blue","nl":"Wisteria lichtsnoer","fr":"Bleu clair glycine"},{"hex":"#a8abce","code":"290 70 20","scope":"Design System Plus","de":"Blütenlila","en":"Blossom mauve","nl":"Bloesempaars","fr":"Violet de fleur"},{"hex":"#a7aad7","code":"290 70 25","scope":"Design System Plus","de":"Sorbeteislila","en":"Sorbet ice mauve","nl":"Sorbetijs lila","fr":"Violet de sorbetière"},{"hex":"#c6c6d7","code":"290 80 10","scope":"Design System Plus","de":"Tulipanbleu","en":"Tulip soft blue","nl":"Tulpanbleu","fr":"Tulipanbleu"},{"hex":"#c6c6de","code":"290 80 15","scope":"Design System Plus","de":"Blasslila","en":"Pale lilac","nl":"Lichtpaars","fr":"Violet pâle"},{"hex":"#d5d5da","code":"290 85 05","scope":"Design System Plus","de":"Kalklila","en":"Limestone mauve","nl":"Kalklila","fr":"Violet de chaux"},{"hex":"#d0d3e9","code":"290 85 10","scope":"Design System Plus","de":"Orchideenweiß","en":"Orchid white","nl":"Orchidee wit","fr":"Blanc orchidée"},{"hex":"#dadbe0","code":"290 90 05","scope":"Design System Plus","de":"Violettweiß","en":"Violet white","nl":"Paars wit","fr":"Blanc violet"},{"hex":"#e8e9ef","code":"290 93 05","scope":"Design System Plus","de":"Fliederweiß","en":"Lilac white","nl":"Lila wit","fr":"Blanc lilas"},{"hex":"#4b494e","code":"300 20 05","scope":"Design System Plus","de":"Nachtschwarz","en":"Night black","nl":"Nacht zwart","fr":"Noir nuit"},{"hex":"#494650","code":"300 20 10","scope":"Design System Plus","de":"Reiherblau","en":"Heron blue","nl":"Reiger blauw","fr":"Bleu héron"},{"hex":"#494655","code":"300 20 15","scope":"Design System Plus","de":"Violaschwarz","en":"Viola black","nl":"Viola zwart","fr":"Noir viola"},{"hex":"#49455a","code":"300 20 20","scope":"Design System Plus","de":"Brombeerschwarz","en":"Blackberry black","nl":"Bramen zwart","fr":"Noir mûre"},{"hex":"#49445c","code":"300 20 25","scope":"Design System Plus","de":"Kardinallila","en":"Cardinal mauve","nl":"Kardinaal paars","fr":"Violet de cardinal"},{"hex":"#474364","code":"300 20 30","scope":"Design System Plus","de":"Zeremonienpurpur","en":"Ceremonial purple","nl":"Ceremonieel paars","fr":"Pourpre de cérémonie"},{"hex":"#59575d","code":"300 30 05","scope":"Design System Plus","de":"Nachtgrau","en":"Night grey","nl":"Nacht grijs","fr":"Gris nuit"},{"hex":"#585562","code":"300 30 10","scope":"Design System Plus","de":"Trauerviolett","en":"Mourning violet","nl":"Rouwviooltje","fr":"Violet funèbre"},{"hex":"#595466","code":"300 30 15","scope":"Design System Plus","de":"Clubgrau","en":"Club grey","nl":"Club grijs","fr":"Gris club"},{"hex":"#59536c","code":"300 30 20","scope":"Design System Plus","de":"Maulbeerlilaschwarz","en":"Mulberry mauve black","nl":"Moerbei lila zwart","fr":"Noir silver mûrier"},{"hex":"#595272","code":"300 30 25","scope":"Design System Plus","de":"Abendlila","en":"Evening mauve","nl":"Avondlila","fr":"Mauve du soir"},{"hex":"#595278","code":"300 30 30","scope":"Design System Plus","de":"Opernblau","en":"Opera blue","nl":"Opera blauw","fr":"Bleu opéra"},{"hex":"#57517e","code":"300 30 35","scope":"Design System Plus","de":"Tiefviolett","en":"Deep violet","nl":"Diep violet","fr":"Violet profond"},{"hex":"#565084","code":"300 30 40","scope":"Design System Plus","de":"Salbeiviolett","en":"Sage violet","nl":"Salieviolet","fr":"Violet sauge"},{"hex":"#6c6a70","code":"300 40 05","scope":"Design System Plus","de":"Barockgrau","en":"Baroque grey","nl":"Barok grijs","fr":"Gris baroque"},{"hex":"#6b6775","code":"300 40 10","scope":"Design System Plus","de":"Gobelinlila","en":"Gobelin mauve","nl":"Wandtapijt paars","fr":"Violet de tapisserie"},{"hex":"#6b657b","code":"300 40 15","scope":"Design System Plus","de":"Orchideengrau","en":"Orchid grey","nl":"Orchidee grijs","fr":"Gris orchidée"},{"hex":"#6c6581","code":"300 40 20","scope":"Design System Plus","de":"Altlila","en":"Old mauve","nl":"Oud paars","fr":"Vieux violet"},{"hex":"#6c6488","code":"300 40 25","scope":"Design System Plus","de":"Parmalila","en":"Parma mauve","nl":"Parmalila","fr":"Parmalila"},{"hex":"#6c638e","code":"300 40 30","scope":"Design System Plus","de":"Wollviolett","en":"Wool violet","nl":"Wolviolet","fr":"Violet de laine"},{"hex":"#6b6293","code":"300 40 35","scope":"Design System Plus","de":"Edelpurpur","en":"Fine purple","nl":"Edel paars","fr":"Pourpre noble"},{"hex":"#696099","code":"300 40 40","scope":"Design System Plus","de":"Clematisblau","en":"Clematis blue","nl":"Clematis blauw","fr":"Bleu clématite"},{"hex":"#6860a1","code":"300 40 45","scope":"Design System Plus","de":"Krönungsblau","en":"Coronation blue","nl":"Kroningsblauw","fr":"Bleu couronnement"},{"hex":"#807e85","code":"300 50 05","scope":"Design System Plus","de":"Falkengrau","en":"Hawk grey","nl":"Valk grijs","fr":"Gris faucon"},{"hex":"#817c8b","code":"300 50 10","scope":"Design System Plus","de":"Veilchengrau","en":"Violet grey","nl":"Paars grijs","fr":"Gris violet"},{"hex":"#817b92","code":"300 50 15","scope":"Design System Plus","de":"Auerhahnlila","en":"Capercaillie mauve","nl":"Auerhoen paars","fr":"Mauve coq de bruyère"},{"hex":"#817999","code":"300 50 20","scope":"Design System Plus","de":"Pariserviolett","en":"Parisian violet","nl":"Parijs viooltje","fr":"Violet de Paris"},{"hex":"#8178a0","code":"300 50 25","scope":"Design System Plus","de":"Tulpenviolett","en":"Tulip violet","nl":"Tulpviooltje","fr":"Violet tulipe"},{"hex":"#8177a7","code":"300 50 30","scope":"Design System Plus","de":"Spielzeuglila","en":"Toy mauve","nl":"Speelgoed paars","fr":"Violet de jouet"},{"hex":"#8277ae","code":"300 50 35","scope":"Design System Plus","de":"Winterzeitlila","en":"Wintertime mauve","nl":"Winterpaars","fr":"Temps d'hiverlila"},{"hex":"#8075b4","code":"300 50 40","scope":"Design System Plus","de":"Klarlila","en":"Clear mauve","nl":"Helder paars","fr":"Violet clair"},{"hex":"#98969e","code":"300 60 05","scope":"Design System Plus","de":"Rebhuhngrau","en":"Partridge grey","nl":"Patrijs grijs","fr":"Gris perdrix"},{"hex":"#9893a3","code":"300 60 10","scope":"Design System Plus","de":"Rosengrau","en":"Rose grey","nl":"Roze grijs","fr":"Gris rose"},{"hex":"#9992ab","code":"300 60 15","scope":"Design System Plus","de":"Antikviola","en":"Antique viola","nl":"Antieke altviool","fr":"Antikviola"},{"hex":"#9990b1","code":"300 60 20","scope":"Design System Plus","de":"Ritterspornviolett","en":"Larkspur violet","nl":"Ridderspoor paars","fr":"Violet d'aconit"},{"hex":"#988eb8","code":"300 60 25","scope":"Design System Plus","de":"Seidenflieder","en":"Silk lilac","nl":"Lila","fr":"Lilas de soie"},{"hex":"#988dc0","code":"300 60 30","scope":"Design System Plus","de":"Heliotroplila","en":"Heliotropic mauve","nl":"Heliotroop paars","fr":"Héliotrope violet"},{"hex":"#978bc6","code":"300 60 35","scope":"Design System Plus","de":"Amethystgrau","en":"Amethyst grey","nl":"Amethist grijs","fr":"Gris améthyste"},{"hex":"#b0aeb7","code":"300 70 05","scope":"Design System Plus","de":"Samtgrau","en":"Velvet grey","nl":"Fluweel grijs","fr":"Gris velours"},{"hex":"#b1abbc","code":"300 70 10","scope":"Design System Plus","de":"Morgendunstgrau","en":"Morning mist grey","nl":"Ochtendmist grijs","fr":"Gris de brume matinale"},{"hex":"#b1aac4","code":"300 70 15","scope":"Design System Plus","de":"Lidschattenviola","en":"Eyeshadow viola","nl":"Oogschaduw violet","fr":"Viola d'ombre à paupières"},{"hex":"#b2a9cb","code":"300 70 20","scope":"Design System Plus","de":"Lavendelviolett","en":"Lavender violet","nl":"Lavendelviolet","fr":"Violet lavande"},{"hex":"#b2a7d2","code":"300 70 25","scope":"Design System Plus","de":"Pinklavendel","en":"Pink lavender","nl":"Roze lavendel","fr":"Lavande rose"},{"hex":"#cac8d0","code":"300 80 05","scope":"Design System Plus","de":"Dunstlila","en":"Hazy mauve","nl":"Damp paars","fr":"Voile de brume"},{"hex":"#c9c5d8","code":"300 80 10","scope":"Design System Plus","de":"Blassviolett","en":"Pale violet","nl":"Licht violet","fr":"Violet pâle"},{"hex":"#cbc4de","code":"300 80 15","scope":"Design System Plus","de":"Eislila","en":"Ice mauve","nl":"IJspaars","fr":"Violet glacé"},{"hex":"#d5d4da","code":"300 85 05","scope":"Design System Plus","de":"Zartviola","en":"Delicate viola","nl":"Zartviola","fr":"Viole de gambe"},{"hex":"#d8d1e4","code":"300 85 10","scope":"Design System Plus","de":"Puderviolaweiß","en":"Powder viola white","nl":"Poeder violet wit","fr":"Blanc poudré violet"},{"hex":"#e4e2e8","code":"300 90 05","scope":"Design System Plus","de":"Lasurweiß","en":"Translucent white","nl":"Glazuur wit","fr":"Blanc lasuré"},{"hex":"#4f4658","code":"310 20 20","scope":"Design System Plus","de":"Obsidianlavaschwarz","en":"Obsidian lava black","nl":"Obsidiaan lava zwart","fr":"Noir lave obsidienne"},{"hex":"#51445d","code":"310 20 25","scope":"Design System Plus","de":"Operettenlila","en":"Operetta mauve","nl":"Operette paars","fr":"Violet d'opérette"},{"hex":"#4f4261","code":"310 20 30","scope":"Design System Plus","de":"Machtviolett","en":"Powerful violet","nl":"Kracht violet","fr":"Violet de puissance"},{"hex":"#5f5667","code":"310 30 15","scope":"Design System Plus","de":"Dunkelgraulila","en":"Dark grey mauve","nl":"Donkergrijs paars","fr":"Violet foncé"},{"hex":"#5e536b","code":"310 30 20","scope":"Design System Plus","de":"Machtlila","en":"Powerful mauve","nl":"Kracht paars","fr":"Violet de puissance"},{"hex":"#615270","code":"310 30 25","scope":"Design System Plus","de":"Englischviolett","en":"English violet","nl":"Engels viooltje","fr":"Violet anglais"},{"hex":"#635176","code":"310 30 30","scope":"Design System Plus","de":"Kristallpurpur","en":"Crystal purple","nl":"Kristalpaars","fr":"Pourpre de cristal"},{"hex":"#625078","code":"310 30 35","scope":"Design System Plus","de":"Prägnantviolett","en":"Succinct violet","nl":"Beknopt violet","fr":"Violet incisif"},{"hex":"#654f7f","code":"310 30 40","scope":"Design System Plus","de":"Lodenpurpur","en":"Loden purple","nl":"Loden paars","fr":"Pourpre de lodge"},{"hex":"#706976","code":"310 40 10","scope":"Design System Plus","de":"Dunkelpink","en":"Dark pink","nl":"Donkerroze","fr":"Rose foncé"},{"hex":"#73687c","code":"310 40 15","scope":"Design System Plus","de":"Schleierviolett","en":"Violet haze","nl":"Sluier violet","fr":"Violet voilé"},{"hex":"#756781","code":"310 40 20","scope":"Design System Plus","de":"Indigorot","en":"Indigo red","nl":"Indigorood","fr":"Indigorot"},{"hex":"#766587","code":"310 40 25","scope":"Design System Plus","de":"Charoitviolett","en":"Charoite violet","nl":"Charoiet violet","fr":"Violet de charoit"},{"hex":"#76628a","code":"310 40 30","scope":"Design System Plus","de":"Königspurpur","en":"Royal purple","nl":"Koningspaars","fr":"Pourpre royale"},{"hex":"#776190","code":"310 40 35","scope":"Design System Plus","de":"Magentaveilchen","en":"Magenta violet","nl":"Magenta viooltjes","fr":"Violette de Magenta"},{"hex":"#7a6196","code":"310 40 40","scope":"Design System Plus","de":"Purlila","en":"Pure mauve","nl":"Paars","fr":"Pourpre"},{"hex":"#857d8c","code":"310 50 10","scope":"Design System Plus","de":"Trüblila","en":"Dull mauve","nl":"Bewolkt paars","fr":"Violet trouble"},{"hex":"#867c92","code":"310 50 15","scope":"Design System Plus","de":"Batikflieder","en":"Batik lilac","nl":"Batik seringen","fr":"Lilas batik"},{"hex":"#8a7b97","code":"310 50 20","scope":"Design System Plus","de":"Provenceviolett","en":"Provence violet","nl":"Provençaals viooltje","fr":"Violet de Provence"},{"hex":"#8c799e","code":"310 50 25","scope":"Design System Plus","de":"Baronesslila","en":"Baroness mauve","nl":"Barones paars","fr":"Baronesslila"},{"hex":"#8d77a4","code":"310 50 30","scope":"Design System Plus","de":"Bitterviolett","en":"Bitter violet","nl":"Bitter viooltje","fr":"Violet amer"},{"hex":"#8d75a8","code":"310 50 35","scope":"Design System Plus","de":"Violettrosé","en":"Violet rose","nl":"Violette roos","fr":"Rose violacé"},{"hex":"#8f74ae","code":"310 50 40","scope":"Design System Plus","de":"Orchideenlila","en":"Orchid mauve","nl":"Orchidee paars","fr":"Violet d'orchidée"},{"hex":"#9b93a3","code":"310 60 10","scope":"Design System Plus","de":"Dezentlila","en":"Gentle mauve","nl":"Fatsoenlijk paars","fr":"Violet discret"},{"hex":"#9f92aa","code":"310 60 15","scope":"Design System Plus","de":"Rauchlila","en":"Smoky mauve","nl":"Rookpaars","fr":"Violet de fumée"},{"hex":"#a291b0","code":"310 60 20","scope":"Design System Plus","de":"Safranblütenlila","en":"Saffron blossom mauve","nl":"Saffraanbloesem paars","fr":"Violet fleur de safran"},{"hex":"#a48fb5","code":"310 60 25","scope":"Design System Plus","de":"Kokettpink","en":"Flirty pink","nl":"Coquett roze","fr":"Rose cocotte"},{"hex":"#a58dba","code":"310 60 30","scope":"Design System Plus","de":"Pfingstrosenlila","en":"Peony mauve","nl":"Pioen paars","fr":"Mauve pivoine"},{"hex":"#a78ac3","code":"310 60 35","scope":"Design System Plus","de":"Lilapurpur","en":"Lilac purple","nl":"Paars","fr":"Lilapurpur"},{"hex":"#b5acbb","code":"310 70 10","scope":"Design System Plus","de":"Amorphrosé","en":"Amorphous rose","nl":"Amorfrosé","fr":"Amorphrosé"},{"hex":"#b8aac2","code":"310 70 15","scope":"Design System Plus","de":"Transparentlila","en":"Transparent mauve","nl":"Transparant paars","fr":"Violet transparent"},{"hex":"#b9a8c7","code":"310 70 20","scope":"Design System Plus","de":"Blaurosa","en":"Blue pink","nl":"Blauw roze","fr":"Rose bleu"},{"hex":"#bba7ce","code":"310 70 25","scope":"Design System Plus","de":"Glasviolett","en":"Glass violet","nl":"Glasviolet","fr":"Violet de verre"},{"hex":"#cdc5d5","code":"310 80 10","scope":"Design System Plus","de":"Puderviola","en":"Powder viola","nl":"Puderviola","fr":"Puderviola"},{"hex":"#d1c4db","code":"310 80 15","scope":"Design System Plus","de":"Orchideenviolett","en":"Orchid violet","nl":"Orchidee viooltje","fr":"Violet d'orchidée"},{"hex":"#d6d3da","code":"310 85 05","scope":"Design System Plus","de":"Feenrosa","en":"Fairy pink","nl":"Feeënroze","fr":"Rose fée"},{"hex":"#dbd1e2","code":"310 85 10","scope":"Design System Plus","de":"Tricotfliederweiß","en":"Tricot lilac white","nl":"Tricot lila wit","fr":"Blanc tricot lilas"},{"hex":"#e8e3e7","code":"310 90 05","scope":"Design System Plus","de":"Mauerblümchenweiß","en":"Wallflower white","nl":"Muurbloem wit","fr":"Fleur de mur blanc"},{"hex":"#4d494e","code":"320 20 05","scope":"Design System Plus","de":"Lavaschwarz","en":"Lava black","nl":"Lavazwart","fr":"Noir lave"},{"hex":"#4e464f","code":"320 20 10","scope":"Design System Plus","de":"Obsidianrot","en":"Obsidian red","nl":"Obsidiaan rood","fr":"Rouge obsidienne"},{"hex":"#4f4451","code":"320 20 15","scope":"Design System Plus","de":"Spinellviolett","en":"Spinel violet","nl":"Spinel violet","fr":"Violet spinelle"},{"hex":"#534455","code":"320 20 20","scope":"Design System Plus","de":"Auberginenlila","en":"Aubergine mauve","nl":"Aubergine paars","fr":"Violet d'aubergine"},{"hex":"#534259","code":"320 20 25","scope":"Design System Plus","de":"Dunkelpurpur","en":"Dark purple","nl":"Donkerpaars","fr":"Pourpre foncé"},{"hex":"#5b565b","code":"320 30 05","scope":"Design System Plus","de":"Violettschwarz","en":"Violet black","nl":"Paars zwart","fr":"Noir violet"},{"hex":"#5d545e","code":"320 30 10","scope":"Design System Plus","de":"Steinviolett","en":"Stone violet","nl":"Steenviolet","fr":"Violet pierre"},{"hex":"#605161","code":"320 30 15","scope":"Design System Plus","de":"Amethystdunkelviolett","en":"Amethyst dark violet","nl":"Amethist donker violet","fr":"Améthyste violet foncé"},{"hex":"#634f66","code":"320 30 20","scope":"Design System Plus","de":"Dunkelbrombeer","en":"Dark blackberry","nl":"Donkere braam","fr":"Mûre foncée"},{"hex":"#664e6a","code":"320 30 25","scope":"Design System Plus","de":"Purpuritviolett","en":"Purpurite violet","nl":"Purpuriet violet","fr":"Violet pourpre"},{"hex":"#674c6e","code":"320 30 30","scope":"Design System Plus","de":"Zwetschgenlila","en":"Damson mauve","nl":"Pruim paars","fr":"Violet prune"},{"hex":"#694b73","code":"320 30 35","scope":"Design System Plus","de":"Traubenpurpur","en":"Grape purple","nl":"Druif paars","fr":"Pourpre de raisin"},{"hex":"#6c4b77","code":"320 30 37","scope":"Design System Plus","de":"Loungeviolett","en":"Lounge violet","nl":"Lounge violet","fr":"Violet lounge"},{"hex":"#6e696f","code":"320 40 05","scope":"Design System Plus","de":"Schieferlila","en":"Slate mauve","nl":"Leisteen paars","fr":"Violet ardoise"},{"hex":"#716672","code":"320 40 10","scope":"Design System Plus","de":"Olivinbasalt","en":"Olivine basalt","nl":"Olivijn basalt","fr":"Basalte d'olivine"},{"hex":"#746477","code":"320 40 15","scope":"Design System Plus","de":"Antikgrau","en":"Antique grey","nl":"Antiek grijs","fr":"Gris antique"},{"hex":"#77627b","code":"320 40 20","scope":"Design System Plus","de":"Basilikumlila","en":"Basil mauve","nl":"Basilicum paars","fr":"Violet de basilic"},{"hex":"#796080","code":"320 40 25","scope":"Design System Plus","de":"Gladiolenviolett","en":"Gladiola violet","nl":"Gladiolus viooltje","fr":"Violet glaïeul"},{"hex":"#7d5d83","code":"320 40 30","scope":"Design System Plus","de":"Krautblütenviolett","en":"Cabbage blossom violet","nl":"Kruidenbloesem viooltje","fr":"Violet de fleur d'herbe"},{"hex":"#7f5a87","code":"320 40 35","scope":"Design System Plus","de":"Fliederviolett","en":"Lilac violet","nl":"Lila viooltje","fr":"Violet lilas"},{"hex":"#82598e","code":"320 40 40","scope":"Design System Plus","de":"Veilchenpurpur","en":"Violet purple","nl":"Violetpaars","fr":"Pourpre violette"},{"hex":"#827c83","code":"320 50 05","scope":"Design System Plus","de":"Grauviolett","en":"Grey violet","nl":"Grijsviolet","fr":"Violet gris"},{"hex":"#867987","code":"320 50 10","scope":"Design System Plus","de":"Britischgrauviolett","en":"British grey mauve","nl":"Brits grijs viooltje","fr":"Violet gris britannique"},{"hex":"#89778c","code":"320 50 15","scope":"Design System Plus","de":"Parmagrau","en":"Parma grey","nl":"Parma grijs","fr":"Gris parme"},{"hex":"#8e7793","code":"320 50 20","scope":"Design System Plus","de":"Alpenveilchen","en":"Cyclamen","nl":"Cyclamen","fr":"Cyclamen"},{"hex":"#907397","code":"320 50 25","scope":"Design System Plus","de":"Poesielila","en":"Poetry mauve","nl":"Poëzie paars","fr":"Poesielila"},{"hex":"#94729d","code":"320 50 30","scope":"Design System Plus","de":"Violagrau","en":"Viola grey","nl":"Viola grijs","fr":"Gris violacé"},{"hex":"#966d9f","code":"320 50 35","scope":"Design System Plus","de":"Astervioletta","en":"Aster violetta","nl":"Asterviolet","fr":"Astervioletta"},{"hex":"#996fa7","code":"320 50 40","scope":"Design System Plus","de":"Empireviolett","en":"Empire violet","nl":"Empire violet","fr":"Violet empire"},{"hex":"#9a949c","code":"320 60 05","scope":"Design System Plus","de":"Aragonitgrau","en":"Aragonite grey","nl":"Aragoniet grijs","fr":"Gris aragonite"},{"hex":"#9e929f","code":"320 60 10","scope":"Design System Plus","de":"Kreideviolett","en":"Chalk violet","nl":"Krijtviolet","fr":"Violet craie"},{"hex":"#a28fa5","code":"320 60 15","scope":"Design System Plus","de":"Amethystgrauviolett","en":"Amethyst grey violet","nl":"Amethist grijs violet","fr":"Violet gris améthyste"},{"hex":"#a58ba9","code":"320 60 20","scope":"Design System Plus","de":"Wunderveilchen","en":"Wonder violet","nl":"Wonderviooltje","fr":"Violette miraculeuse"},{"hex":"#a889af","code":"320 60 25","scope":"Design System Plus","de":"Nachtschattenviolett","en":"Nightshade violet","nl":"Nachtschadeviooltje","fr":"Violet ombre de nuit"},{"hex":"#ac87b5","code":"320 60 30","scope":"Design System Plus","de":"Lobbylila","en":"Lobby lilac","nl":"Lobby paars","fr":"Lobbylila"},{"hex":"#ae85b9","code":"320 60 35","scope":"Design System Plus","de":"Sorbetbrombeer","en":"Blackberry sorbet","nl":"Sorbet braambes","fr":"Mûre sorbet"},{"hex":"#b2acb3","code":"320 70 05","scope":"Design System Plus","de":"Holundergrau","en":"Elderberry grey","nl":"Vlierbes grijs","fr":"Gris sureau"},{"hex":"#b6a9b9","code":"320 70 10","scope":"Design System Plus","de":"Glockenblumenviolett","en":"Bellflower violet","nl":"Klokjesviooltje","fr":"Violet de campanule"},{"hex":"#b9a6be","code":"320 70 15","scope":"Design System Plus","de":"Quarzviolett","en":"Quartz violet","nl":"Kwarts violet","fr":"Violet de quartz"},{"hex":"#c0a5c6","code":"320 70 20","scope":"Design System Plus","de":"Strandflieder","en":"Beach lilac","nl":"Strand lila","fr":"Lilas de plage"},{"hex":"#c3a2ca","code":"320 70 25","scope":"Design System Plus","de":"Fliederpink","en":"Lilac pink","nl":"Lila roze","fr":"Rose lilas"},{"hex":"#cdc7cd","code":"320 80 05","scope":"Design System Plus","de":"Hellviolett","en":"Light violet","nl":"Licht violet","fr":"Violet clair"},{"hex":"#d1c4d3","code":"320 80 10","scope":"Design System Plus","de":"Amethysthellviolett","en":"Amethyst light violet","nl":"Ametherschaal viooltje","fr":"Violet d'améthyste"},{"hex":"#d4c0d6","code":"320 80 15","scope":"Design System Plus","de":"Kosmetiklila","en":"Cosmetic mauve","nl":"Cosmetisch paars","fr":"Violet cosmétique"},{"hex":"#d8d1d9","code":"320 85 05","scope":"Design System Plus","de":"Brombeercreme","en":"Blackberry cream","nl":"Bramencrème","fr":"Crème de mûres"},{"hex":"#ddcfdf","code":"320 85 10","scope":"Design System Plus","de":"Ametrinquarz","en":"Ametrine quartz","nl":"Ametrien kwarts","fr":"Quartz amétrine"},{"hex":"#e8e1e6","code":"320 90 05","scope":"Design System Plus","de":"Apatitrosa","en":"Apatite pink","nl":"Apatitrosa","fr":"Apatitrosa"},{"hex":"#554251","code":"330 20 20","scope":"Design System Plus","de":"Tiefgrundlila","en":"Profound mauve","nl":"Diep basispaars","fr":"Violet profond"},{"hex":"#5a4256","code":"330 20 25","scope":"Design System Plus","de":"Opulentlila","en":"Opulent mauve","nl":"Weelderig paars","fr":"Violet opulent"},{"hex":"#645361","code":"330 30 15","scope":"Design System Plus","de":"Korinthenviolett","en":"Currant violet","nl":"Korinthisch viooltje","fr":"Violet de Corinthe"},{"hex":"#685164","code":"330 30 20","scope":"Design System Plus","de":"Mexikanischpurpur","en":"Mexican purple","nl":"Mexicaans paars","fr":"Pourpre mexicain"},{"hex":"#6b4e66","code":"330 30 25","scope":"Design System Plus","de":"Parmapflaumenrot","en":"Parma plum red","nl":"Parma pruimenrood","fr":"Rouge parme prune"},{"hex":"#704c6a","code":"330 30 30","scope":"Design System Plus","de":"Intensivpurpur","en":"Intense purple","nl":"Intens paars","fr":"Pourpre intense"},{"hex":"#734b6e","code":"330 30 35","scope":"Design System Plus","de":"Opulentpurpur","en":"Opulent purple","nl":"Weelderig paars","fr":"Pourpre opulent"},{"hex":"#75476f","code":"330 30 40","scope":"Design System Plus","de":"Intensivlila","en":"Intense mauve","nl":"Intens paars","fr":"Violet intense"},{"hex":"#746772","code":"330 40 10","scope":"Design System Plus","de":"Patinaviolett","en":"Patina violet","nl":"Patina violet","fr":"Violet patiné"},{"hex":"#786576","code":"330 40 15","scope":"Design System Plus","de":"Dunkelpurpurgrau","en":"Dark purple grey","nl":"Donkerpaars grijs","fr":"Gris pourpre foncé"},{"hex":"#7d647a","code":"330 40 20","scope":"Design System Plus","de":"Amaranthrot","en":"Amaranth red","nl":"Amarant rood","fr":"Rouge amarante"},{"hex":"#81627d","code":"330 40 25","scope":"Design System Plus","de":"Tiefmagenta","en":"Deep magenta","nl":"Diep magenta","fr":"Magenta profond"},{"hex":"#885f81","code":"330 40 30","scope":"Design System Plus","de":"Phloxblumenviolett","en":"Phloxflower violet","nl":"Phlox bloem viooltje","fr":"Violet de fleur de phlox"},{"hex":"#8b5d84","code":"330 40 35","scope":"Design System Plus","de":"Distellila","en":"Thistle mauve","nl":"Distel paars","fr":"Distellila"},{"hex":"#8c5885","code":"330 40 40","scope":"Design System Plus","de":"Visionarot","en":"Visiona red","nl":"Visionarot","fr":"Visionarot"},{"hex":"#8f5788","code":"330 40 45","scope":"Design System Plus","de":"Purpuritrot","en":"Purpurite red","nl":"Paars rood","fr":"Rouge pourpre"},{"hex":"#897a86","code":"330 50 10","scope":"Design System Plus","de":"Jutegrau","en":"Burlap grey","nl":"Jute grijs","fr":"Gris jute"},{"hex":"#8f7a8c","code":"330 50 15","scope":"Design System Plus","de":"Saphirrosa","en":"Sapphire pink","nl":"Saffierroze","fr":"Rose saphir"},{"hex":"#947790","code":"330 50 20","scope":"Design System Plus","de":"Prachtnelkenlila","en":"Dianthus mauve","nl":"Prachtige anjer paars","fr":"Violet magnifique"},{"hex":"#987593","code":"330 50 25","scope":"Design System Plus","de":"Kristallrosa","en":"Crystal pink","nl":"Kristalroze","fr":"Rose cristal"},{"hex":"#9d7399","code":"330 50 30","scope":"Design System Plus","de":"Tulipanviolett","en":"Tulipan violet","nl":"Tulpenviooltje","fr":"Violet de tulipes"},{"hex":"#a0709c","code":"330 50 35","scope":"Design System Plus","de":"Violettrot","en":"Violet red","nl":"Paarsrood","fr":"Rouge violet"},{"hex":"#a56d9e","code":"330 50 40","scope":"Design System Plus","de":"Orchideenpurpur","en":"Orchid purple","nl":"Orchidee paars","fr":"Pourpre d'orchidée"},{"hex":"#a1929f","code":"330 60 10","scope":"Design System Plus","de":"Greigeviolett","en":"Greige violet","nl":"Grijsviolet","fr":"Greige violet"},{"hex":"#a791a4","code":"330 60 15","scope":"Design System Plus","de":"Vesuvianviolett","en":"Vesuvian violet","nl":"Vesuviaans viooltje","fr":"Violet vesuvian"},{"hex":"#ad8ea8","code":"330 60 20","scope":"Design System Plus","de":"Enzianviolett","en":"Gentian violet","nl":"Gentiaanviooltje","fr":"Violet gentiane"},{"hex":"#af8aa9","code":"330 60 25","scope":"Design System Plus","de":"Gründerzeitpink","en":"Wilhelminian pink","nl":"Wilhelminiaans roze","fr":"Rose des fondateurs"},{"hex":"#b588af","code":"330 60 30","scope":"Design System Plus","de":"Bühnenlila","en":"Stage mauve","nl":"Podium paars","fr":"Violet de scène"},{"hex":"#bb85b3","code":"330 60 35","scope":"Design System Plus","de":"Pfingstnelkenlila","en":"Cheddar pink mauve","nl":"Pinksteranjer paars","fr":"Violet de pivoine"},{"hex":"#be82b7","code":"330 60 40","scope":"Design System Plus","de":"Colomborotlila","en":"Colombo red mauve","nl":"Colomborot paars","fr":"Colomborotlila"},{"hex":"#bcabb9","code":"330 70 10","scope":"Design System Plus","de":"Nebelrosa","en":"Mist pink","nl":"Mistig roze","fr":"Rose brumeux"},{"hex":"#bfa7bb","code":"330 70 15","scope":"Design System Plus","de":"Lauchblütenpink","en":"Leek blossom pink","nl":"Preibloesem roze","fr":"Rose fleur de poireau"},{"hex":"#c5a6c0","code":"330 70 20","scope":"Design System Plus","de":"Erdbeerrosa","en":"Strawberry pink","nl":"Aardbeiroze","fr":"Rose fraise"},{"hex":"#cca3c5","code":"330 70 25","scope":"Design System Plus","de":"Purpurrosa","en":"Purple pink","nl":"Paars roze","fr":"Rose pourpre"},{"hex":"#d0a1c7","code":"330 70 30","scope":"Design System Plus","de":"Kleeblütenrosa","en":"Clover pink","nl":"Klaverbloesem roze","fr":"Rose de trèfle"},{"hex":"#d5c4d1","code":"330 80 10","scope":"Design System Plus","de":"Purpurweiß","en":"Purple white","nl":"Paars wit","fr":"Blanc pourpre"},{"hex":"#dac1d5","code":"330 80 15","scope":"Design System Plus","de":"Lieblichrosa","en":"Lovely pink","nl":"Mooi roze","fr":"Rose tendre"},{"hex":"#e2bfd9","code":"330 80 20","scope":"Design System Plus","de":"Designerrosa","en":"Designer pink","nl":"Ontwerper roze","fr":"Rose design"},{"hex":"#d9d3d9","code":"330 85 05","scope":"Design System Plus","de":"Hellmagnolienrosé","en":"Light magnolia rose","nl":"Lichte magnolia rosé","fr":"Rose magnolia clair"},{"hex":"#e2d1de","code":"330 85 10","scope":"Design System Plus","de":"Himbeerrosa","en":"Raspberry pink","nl":"Framboos roze","fr":"Rose framboise"},{"hex":"#e8cee1","code":"330 85 15","scope":"Design System Plus","de":"Himmlischrosa","en":"Heavenly pink","nl":"Hemels roze","fr":"Rose céleste"},{"hex":"#ebe2e5","code":"330 90 05","scope":"Design System Plus","de":"Delikatessweiß","en":"Delicacy white","nl":"Delicatesse wit","fr":"Blanc délicat"},{"hex":"#4d474b","code":"340 20 05","scope":"Design System Plus","de":"Lakritzschwarz","en":"Liquorice black","nl":"Zoethout zwart","fr":"Noir réglisse"},{"hex":"#50444a","code":"340 20 10","scope":"Design System Plus","de":"Mangostanoviolett","en":"Mangosteen violet","nl":"Mangosteenviooltje","fr":"Violet de mangoustan"},{"hex":"#53414b","code":"340 20 15","scope":"Design System Plus","de":"Sitterrot","en":"Sitter red","nl":"Zitter rood","fr":"Rouge de Sitter"},{"hex":"#58414e","code":"340 20 20","scope":"Design System Plus","de":"Saftviolett","en":"Juice violet","nl":"Sap viooltje","fr":"Violet de jus"},{"hex":"#5f4252","code":"340 20 25","scope":"Design System Plus","de":"Prestigelila","en":"Prestige mauve","nl":"Prestige paars","fr":"Prestigelila"},{"hex":"#5c5559","code":"340 30 05","scope":"Design System Plus","de":"Apfelkrautschwarz","en":"Apple herb black","nl":"Appelkruid zwart","fr":"Noir pomme-gris"},{"hex":"#61525a","code":"340 30 10","scope":"Design System Plus","de":"Passionsfruchtlila","en":"Passionfruit mauve","nl":"Passievrucht paars","fr":"Mauve fruit de la passion"},{"hex":"#66505c","code":"340 30 15","scope":"Design System Plus","de":"Dunkelfeigenviolett","en":"Dark fig violet","nl":"Donker vijgenviolet","fr":"Violet figue foncé"},{"hex":"#6a4e5e","code":"340 30 20","scope":"Design System Plus","de":"Rubinviolett","en":"Ruby violet","nl":"Robijnviolet","fr":"Violet rubis"},{"hex":"#6f4c62","code":"340 30 25","scope":"Design System Plus","de":"Brombeertiefrot","en":"Blackberry deep red","nl":"Framboos dieprood","fr":"Mûre profonde"},{"hex":"#714963","code":"340 30 30","scope":"Design System Plus","de":"Tiefrot","en":"Deep red","nl":"Diep rood","fr":"Rouge profond"},{"hex":"#754664","code":"340 30 35","scope":"Design System Plus","de":"Samtlila","en":"Velvet mauve","nl":"Fluweelpaars","fr":"Violet velours"},{"hex":"#7a4366","code":"340 30 38","scope":"Design System Plus","de":"Waldfruchtrot","en":"Forest fruit red","nl":"Bosvruchten rood","fr":"Rouge fruit de forêt"},{"hex":"#6f676b","code":"340 40 05","scope":"Design System Plus","de":"Lilabraun","en":"Mauve brown","nl":"Paarsbruin","fr":"Marron lilas"},{"hex":"#76646d","code":"340 40 10","scope":"Design System Plus","de":"Spinellgrau","en":"Spinel grey","nl":"Spinel grijs","fr":"Gris spinelle"},{"hex":"#7b6270","code":"340 40 15","scope":"Design System Plus","de":"Erdbraunviolett","en":"Earth brown violet","nl":"Aarde bruin violet","fr":"Marron terre violet"},{"hex":"#805f72","code":"340 40 20","scope":"Design System Plus","de":"Dahlienmattrot","en":"Dahlia matte red","nl":"Dahlia mat rood","fr":"Dahlia mat"},{"hex":"#855d76","code":"340 40 25","scope":"Design System Plus","de":"Brokatviolett","en":"Brocade violet","nl":"Brokaatviolet","fr":"Violet de brocart"},{"hex":"#895a78","code":"340 40 30","scope":"Design System Plus","de":"Krappmagenta","en":"Madder magenta","nl":"Madder magenta","fr":"Magenta de garance"},{"hex":"#8b557a","code":"340 40 35","scope":"Design System Plus","de":"Clublila","en":"Club mauve","nl":"Club paars","fr":"Clublila"},{"hex":"#90527b","code":"340 40 40","scope":"Design System Plus","de":"Kirschrot","en":"Cherry red","nl":"Kersenrood","fr":"Rouge cerise"},{"hex":"#994f80","code":"340 40 45","scope":"Design System Plus","de":"Magentarot","en":"Magenta red","nl":"Magenta rood","fr":"Rouge magenta"},{"hex":"#857c81","code":"340 50 05","scope":"Design System Plus","de":"Jubiläumsgrau","en":"Jubilee grey","nl":"Jubileum grijs","fr":"Gris anniversaire"},{"hex":"#8c7984","code":"340 50 10","scope":"Design System Plus","de":"Portweinrot","en":"Port wine red","nl":"Portwijn rood","fr":"Rouge porto"},{"hex":"#927686","code":"340 50 15","scope":"Design System Plus","de":"Rohgranatviola","en":"Raw garnet viola","nl":"Granaat altviool","fr":"Viola brute à la grenade"},{"hex":"#987489","code":"340 50 20","scope":"Design System Plus","de":"Kreuzblumenrot","en":"Milkwort red","nl":"Kruisbloem rood","fr":"Rouge fleur de trèfle"},{"hex":"#9d708b","code":"340 50 25","scope":"Design System Plus","de":"Rostmagenta","en":"Rust magenta","nl":"Roest magenta","fr":"Magenta rouillé"},{"hex":"#a26d8e","code":"340 50 30","scope":"Design System Plus","de":"Himbeergeleerot","en":"Raspberry jelly red","nl":"Frambozengelei rood","fr":"Rouge gélifié à la framboise"},{"hex":"#a56890","code":"340 50 35","scope":"Design System Plus","de":"Fingerhutrot","en":"Thimble red","nl":"Vingerhoedskruid rood","fr":"Rouge dé à coudre"},{"hex":"#ad6693","code":"340 50 40","scope":"Design System Plus","de":"Cyclamonrot","en":"Cyclamen red","nl":"Cyclamen rood","fr":"Rouge cyclamon"},{"hex":"#b26295","code":"340 50 45","scope":"Design System Plus","de":"Brillantkarmin","en":"Brilliant carmine","nl":"Schitterende karmijn","fr":"Carmin brillant"},{"hex":"#9e959a","code":"340 60 05","scope":"Design System Plus","de":"Erikarotgrau","en":"Heather red grey","nl":"Erika rood grijs","fr":"Gris Éricarot"},{"hex":"#a48f9b","code":"340 60 10","scope":"Design System Plus","de":"Pianomauve","en":"Piano mauve","nl":"Piano mauve","fr":"Pianomauve"},{"hex":"#ac8d9f","code":"340 60 15","scope":"Design System Plus","de":"Abendrosa","en":"Evening pink","nl":"Avondroze","fr":"Rose du soir"},{"hex":"#b08aa1","code":"340 60 20","scope":"Design System Plus","de":"Caprimodepink","en":"Capri fashion pink","nl":"Caprimode roze","fr":"Caprimodepink"},{"hex":"#b587a3","code":"340 60 25","scope":"Design System Plus","de":"Antikpink","en":"Antique hot pink","nl":"Antiek roze","fr":"Rose antique"},{"hex":"#ba84a6","code":"340 60 30","scope":"Design System Plus","de":"Wangenrot","en":"Cheek red","nl":"Wangen rood","fr":"Rouge joue"},{"hex":"#c181a9","code":"340 60 35","scope":"Design System Plus","de":"Malvenblütenpink","en":"Hollyhock blossom pink","nl":"Wilgenbloesem roze","fr":"Rose fleur de mauve"},{"hex":"#c87cad","code":"340 60 40","scope":"Design System Plus","de":"Bischofsrot","en":"Bishop red","nl":"Rood van de bisschop","fr":"Bischofsrot"},{"hex":"#b6acb1","code":"340 70 05","scope":"Design System Plus","de":"Lilagrau","en":"Mauve grey","nl":"Paars grijs","fr":"Gris lilas"},{"hex":"#bca8b3","code":"340 70 10","scope":"Design System Plus","de":"Buchweizenlila","en":"Buckwheat mauve","nl":"Boekweit paars","fr":"Violet sarrasin"},{"hex":"#c5a6b8","code":"340 70 15","scope":"Design System Plus","de":"Malvenrosa","en":"Hollyhock pink","nl":"Mauve roze","fr":"Rose mauve"},{"hex":"#cba3bb","code":"340 70 20","scope":"Design System Plus","de":"Idyllenrosa","en":"Idyllic pink","nl":"Idyllisch roze","fr":"Rose idyllique"},{"hex":"#ce9fbb","code":"340 70 25","scope":"Design System Plus","de":"Windenblütenpink","en":"Morning glory pink","nl":"Lierbloesem roze","fr":"Rose fleur de liseron"},{"hex":"#d69cc0","code":"340 70 30","scope":"Design System Plus","de":"Softfuchsia","en":"Soft fuschia","nl":"Zacht fuchsia","fr":"Softfuchsia"},{"hex":"#dd99c4","code":"340 70 35","scope":"Design System Plus","de":"Prallpink","en":"Firm pink","nl":"Impact roze","fr":"Rose vif"},{"hex":"#d1c7ca","code":"340 80 05","scope":"Design System Plus","de":"Pianograurosé","en":"Piano grey rose","nl":"Pianograurosé","fr":"Pianograurosé"},{"hex":"#d9c4d0","code":"340 80 10","scope":"Design System Plus","de":"Minzblütenrosé","en":"Mint blossom rose","nl":"Rosé met muntbloesem","fr":"Rose fleur de menthe"},{"hex":"#e0c0d2","code":"340 80 15","scope":"Design System Plus","de":"Skandalrosé","en":"Scandalous rose","nl":"Schandalige rosé","fr":"Rose scandale"},{"hex":"#e7bdd4","code":"340 80 20","scope":"Design System Plus","de":"Bonbonrosa","en":"Bonbon rose","nl":"Snoeproze","fr":"Rose bonbon"},{"hex":"#ddd2d8","code":"340 85 05","scope":"Design System Plus","de":"Erdbeercreme","en":"Strawberry cream","nl":"Aardbeiencrème","fr":"Crème à la fraise"},{"hex":"#e5cfdb","code":"340 85 10","scope":"Design System Plus","de":"Hellflamingopink","en":"Light flamingo pink","nl":"Licht flamingo roze","fr":"Rose flamant clair"},{"hex":"#eecddf","code":"340 85 15","scope":"Design System Plus","de":"Lacklila","en":"Lacquer mauve","nl":"Paars octrooi","fr":"Violet laqué"},{"hex":"#ebe1e4","code":"340 90 05","scope":"Design System Plus","de":"Rosenweiß","en":"Rose white","nl":"Roze wit","fr":"Blanc de rose"},{"hex":"#f1e8ed","code":"340 93 05","scope":"Design System Plus","de":"Kleiderrosa","en":"Dress pink","nl":"Jurk roze","fr":"Robe rose"},{"hex":"#514449","code":"350 20 10","scope":"Design System Plus","de":"Glühweinrot","en":"Mulled wine red","nl":"Glühwein rood","fr":"Rouge vin chaud"},{"hex":"#57444b","code":"350 20 15","scope":"Design System Plus","de":"Sanftrot","en":"Soft red","nl":"Zacht rood","fr":"Rouge doux"},{"hex":"#5c414b","code":"350 20 20","scope":"Design System Plus","de":"Sternrubin","en":"Star ruby","nl":"Ster robijn","fr":"Rubis étoile"},{"hex":"#5f404c","code":"350 20 25","scope":"Design System Plus","de":"Chilischwarzrot","en":"Chilli black red","nl":"Chili zwart rood","fr":"Rouge chili noir"},{"hex":"#653d4e","code":"350 20 30","scope":"Design System Plus","de":"Tulpenbaumpurpur","en":"Tulip poplar purple","nl":"Tulpenboom paars","fr":"Pourpre de tulipier"},{"hex":"#625158","code":"350 30 10","scope":"Design System Plus","de":"Sperlinggraurot","en":"Sparrow grey red","nl":"Sperling grijs-rood","fr":"Gris éperlan"},{"hex":"#684f59","code":"350 30 15","scope":"Design System Plus","de":"Kieselrot","en":"Siliceous red","nl":"Kiezelrood","fr":"Rouge silex"},{"hex":"#6f4e5b","code":"350 30 20","scope":"Design System Plus","de":"Likörrot","en":"Liqueur red","nl":"Likeur rood","fr":"Rouge liqueur"},{"hex":"#744b5c","code":"350 30 25","scope":"Design System Plus","de":"Weingummirot","en":"Wine gummy red","nl":"Wijngom rood","fr":"Rouge gomme vin"},{"hex":"#7a4a5e","code":"350 30 30","scope":"Design System Plus","de":"Burlatrot","en":"Burlat red","nl":"Jute rood","fr":"Rouge burlat"},{"hex":"#7b465e","code":"350 30 35","scope":"Design System Plus","de":"Bordeauxrot","en":"Bordeaux red","nl":"Bordeaux rood","fr":"Rouge bordeaux"},{"hex":"#804360","code":"350 30 40","scope":"Design System Plus","de":"Trockenblumenpurpur","en":"Dried flower purple","nl":"Gedroogde bloem paars","fr":"Pourpre de fleurs séchées"},{"hex":"#77656c","code":"350 40 10","scope":"Design System Plus","de":"Auberginengrau","en":"Aubergine grey","nl":"Aubergine grijs","fr":"Gris aubergine"},{"hex":"#7d626d","code":"350 40 15","scope":"Design System Plus","de":"Schlafmohnmauve","en":"Opium mauve","nl":"Opiumpapaver mauve","fr":"Mauve coquelicot"},{"hex":"#835f6f","code":"350 40 20","scope":"Design System Plus","de":"Graukarmin","en":"Grey carmine","nl":"Grijs karmijn","fr":"Carmin gris"},{"hex":"#875c6f","code":"350 40 25","scope":"Design System Plus","de":"Nektarrot","en":"Nectar red","nl":"Nectar rood","fr":"Rouge nectar"},{"hex":"#8f5971","code":"350 40 30","scope":"Design System Plus","de":"Dunkelrosé","en":"Dark rose","nl":"Donkere roos","fr":"Rose foncé"},{"hex":"#945573","code":"350 40 35","scope":"Design System Plus","de":"Bonbonrot","en":"Bonbon red","nl":"Snoeprood","fr":"Rouge bonbon"},{"hex":"#985374","code":"350 40 40","scope":"Design System Plus","de":"Zyclamenrot","en":"Cyclamen red","nl":"Cyclamen rood","fr":"Rouge cyclamen"},{"hex":"#9d5075","code":"350 40 45","scope":"Design System Plus","de":"Puderrot","en":"Powder red","nl":"Poederrood","fr":"Rouge poudré"},{"hex":"#a24b76","code":"350 40 50","scope":"Design System Plus","de":"Krapprot","en":"Madder red","nl":"Madder rood","fr":"Rouge garance"},{"hex":"#8d7981","code":"350 50 10","scope":"Design System Plus","de":"Unschuldsrosa","en":"Innocent pink","nl":"Onschuldig roze","fr":"Rose innocent"},{"hex":"#937682","code":"350 50 15","scope":"Design System Plus","de":"Stumpfviolett","en":"Blunt violet","nl":"Saai paars","fr":"Violet terne"},{"hex":"#9b7385","code":"350 50 20","scope":"Design System Plus","de":"Korundrot","en":"Corundum red","nl":"Korund rood","fr":"Rouge corindon"},{"hex":"#a27086","code":"350 50 25","scope":"Design System Plus","de":"Batikpink","en":"Batik pink","nl":"Batik roze","fr":"Rose batik"},{"hex":"#a76e88","code":"350 50 30","scope":"Design System Plus","de":"Beryllrot","en":"Beryl red","nl":"Beryllrood","fr":"Rouge béryl"},{"hex":"#af6888","code":"350 50 35","scope":"Design System Plus","de":"Hochrot","en":"Crimson","nl":"Hoog rood","fr":"Rouge vif"},{"hex":"#b56589","code":"350 50 40","scope":"Design System Plus","de":"Krapprosa","en":"Madder rose","nl":"Rozer roze","fr":"Rose crapaud"},{"hex":"#b6618b","code":"350 50 45","scope":"Design System Plus","de":"Signalpink","en":"Signal pink","nl":"Signaal roze","fr":"Rose de signalisation"},{"hex":"#c25e8b","code":"350 50 50","scope":"Design System Plus","de":"Nagellackpink","en":"Nail polish pink","nl":"Nagellak roze","fr":"Vernis à ongles rose"},{"hex":"#a59099","code":"350 60 10","scope":"Design System Plus","de":"Jugendstilviolett","en":"Art Nouveau violet","nl":"Art Nouveau violet","fr":"Violet art nouveau"},{"hex":"#ac8c9a","code":"350 60 15","scope":"Design System Plus","de":"Mohairrosa","en":"Mohair pink","nl":"Mohair roze","fr":"Rose mohair"},{"hex":"#b58b9d","code":"350 60 20","scope":"Design System Plus","de":"Heideblumenviolett","en":"Heather violet","nl":"Heidebloem viooltje","fr":"Violet de bruyère"},{"hex":"#bc869d","code":"350 60 25","scope":"Design System Plus","de":"Heidekrautrosé","en":"Heather rose","nl":"Heide rosé","fr":"Rose bruyère"},{"hex":"#c4839f","code":"350 60 30","scope":"Design System Plus","de":"Venetianerrosa","en":"Venetian pink","nl":"Venetiaans roze","fr":"Rose vénitien"},{"hex":"#c87fa0","code":"350 60 35","scope":"Design System Plus","de":"Dolomitrot","en":"Dolomite red","nl":"Dolomiet rood","fr":"Rouge dolomite"},{"hex":"#d07ca1","code":"350 60 40","scope":"Design System Plus","de":"Kamelienrosa","en":"Camellia pink","nl":"Camelia roze","fr":"Rose camélia"},{"hex":"#d378a4","code":"350 60 45","scope":"Design System Plus","de":"Persischrosa","en":"Persian pink","nl":"Perzisch roze","fr":"Rose persan"},{"hex":"#bfaab1","code":"350 70 10","scope":"Design System Plus","de":"Kaltrosa","en":"Cold pink","nl":"Koud roze","fr":"Rose froid"},{"hex":"#c7a5b3","code":"350 70 15","scope":"Design System Plus","de":"Schattenrosa","en":"Shady pink","nl":"Schaduwroze","fr":"Rose d'ombre"},{"hex":"#cb9fb3","code":"350 70 20","scope":"Design System Plus","de":"Grasnelkenrosa","en":"Lady's cushions pink","nl":"Anjer roze","fr":"Rose girofle"},{"hex":"#d69fb6","code":"350 70 25","scope":"Design System Plus","de":"Korallenrosa","en":"Coral pink","nl":"Koraalroze","fr":"Rose corail"},{"hex":"#de9bb8","code":"350 70 30","scope":"Design System Plus","de":"Technorosa","en":"Techno pink","nl":"Technorosa","fr":"Technorosa"},{"hex":"#e498b9","code":"350 70 35","scope":"Design System Plus","de":"Kaugummipink","en":"Chewing gum pink","nl":"Kauwgom roze","fr":"Rose chewing-gum"},{"hex":"#d9c1ca","code":"350 80 10","scope":"Design System Plus","de":"Magnolienweiß","en":"Magnolia white","nl":"Magnolia wit","fr":"Blanc magnolia"},{"hex":"#e0bfcb","code":"350 80 15","scope":"Design System Plus","de":"Frühlingsrosa","en":"Spring pink","nl":"Lente roze","fr":"Rose printanier"},{"hex":"#e9bccf","code":"350 80 20","scope":"Design System Plus","de":"Hellpink","en":"Light pink","nl":"Lichtroze","fr":"Rose clair"},{"hex":"#ddd2d7","code":"350 85 05","scope":"Design System Plus","de":"Elfenweiß","en":"Fairy white","nl":"Feeënwit","fr":"Blanc ivoire"},{"hex":"#e7cfd9","code":"350 85 10","scope":"Design System Plus","de":"Orchideenrosé","en":"Orchid rose","nl":"Rosé orchidee","fr":"Rose orchidée"},{"hex":"#eeccd9","code":"350 85 15","scope":"Design System Plus","de":"Blasspink","en":"Pale pink","nl":"Blasspink","fr":"Blasspink"},{"hex":"#eee1e2","code":"350 90 05","scope":"Design System Plus","de":"Lichtrosé","en":"Light rose","nl":"Lichtroze","fr":"Rose lumineuse"},{"hex":"#f4dbe5","code":"350 90 10","scope":"Design System Plus","de":"Windröschenweiß","en":"Ranuncula white","nl":"Anemoon wit","fr":"Blanc anémone"},{"hex":"#f4e8ec","code":"350 93 05","scope":"Design System Plus","de":"Clichyweiß","en":"Clichy white","nl":"Clichywit","fr":"Clichy blanc"},{"hex":"#574247","code":"360 20 15","scope":"Design System Plus","de":"Piermontsteinrot","en":"Piermont stone red","nl":"Piermont steenrood","fr":"Rouge pierre de Piermont"},{"hex":"#5d5456","code":"360 30 05","scope":"Design System Plus","de":"Rußrot","en":"Soot red","nl":"Roet rood","fr":"Rouge suie"},{"hex":"#635156","code":"360 30 10","scope":"Design System Plus","de":"Pfefferkornrot","en":"Peppercorn red","nl":"Peperkorrel rood","fr":"Rouge grain de poivre"},{"hex":"#684e56","code":"360 30 15","scope":"Design System Plus","de":"Primitivoweinrot","en":"Zinfandel red","nl":"Primitieve wijn rood","fr":"Rouge vin primitif"},{"hex":"#704d57","code":"360 30 20","scope":"Design System Plus","de":"Artdecorot","en":"Art deco red","nl":"Artdecorot","fr":"Artdecorot"},{"hex":"#734956","code":"360 30 25","scope":"Design System Plus","de":"Klinkerrot","en":"Clinker red","nl":"Klinkerrood","fr":"Rouge brique"},{"hex":"#784657","code":"360 30 30","scope":"Design System Plus","de":"Kirschsaftrot","en":"Cherry juice red","nl":"Kersensap rood","fr":"Rouge jus de cerise"},{"hex":"#814456","code":"360 30 35","scope":"Design System Plus","de":"Schlossrot","en":"Palace red","nl":"Kasteel rood","fr":"Rouge château"},{"hex":"#834257","code":"360 30 40","scope":"Design System Plus","de":"Glutrot","en":"Ember red","nl":"Ember rood","fr":"Rouge incandescent"},{"hex":"#726769","code":"360 40 05","scope":"Design System Plus","de":"Röstschwarz","en":"Roasted black","nl":"Geroosterd zwart","fr":"Noir torréfié"},{"hex":"#766369","code":"360 40 10","scope":"Design System Plus","de":"Mokkabraun","en":"Mocha brown","nl":"Mokka bruin","fr":"Marron moka"},{"hex":"#7d6069","code":"360 40 15","scope":"Design System Plus","de":"Rubingrau","en":"Ruby grey","nl":"Robijngrijs","fr":"Gris rubis"},{"hex":"#845d69","code":"360 40 20","scope":"Design System Plus","de":"Barockrot","en":"Baroque red","nl":"Barok rood","fr":"Rouge baroque"},{"hex":"#8a5a68","code":"360 40 25","scope":"Design System Plus","de":"Rauschrot","en":"Frenzied red","nl":"Donkerrood","fr":"Rouge brumeux"},{"hex":"#91576a","code":"360 40 30","scope":"Design System Plus","de":"Johannisbeerrot","en":"Redcurrant","nl":"Zwarte bessen rood","fr":"Rouge groseille"},{"hex":"#97546b","code":"360 40 35","scope":"Design System Plus","de":"Orientpink","en":"Orient pink","nl":"Oosters roze","fr":"Rose oriental"},{"hex":"#9e506c","code":"360 40 40","scope":"Design System Plus","de":"Auroramagenta","en":"Aurora magenta","nl":"Auroramagenta","fr":"Auroramagenta"},{"hex":"#a24d6a","code":"360 40 45","scope":"Design System Plus","de":"Kardinalrot","en":"Cardinal red","nl":"Kardinaalrood","fr":"Rouge cardinal"},{"hex":"#a94669","code":"360 40 50","scope":"Design System Plus","de":"Salonrot","en":"Parlour red","nl":"Salon rood","fr":"Rouge salon"},{"hex":"#887c7e","code":"360 50 05","scope":"Design System Plus","de":"Bimssteingrau","en":"Pumice grey","nl":"Puimsteen grijs","fr":"Gris pierre ponce"},{"hex":"#8d787e","code":"360 50 10","scope":"Design System Plus","de":"Tresterrot","en":"Pomace red","nl":"Pomace rood","fr":"Rouge marc"},{"hex":"#95747e","code":"360 50 15","scope":"Design System Plus","de":"Abendpurpur","en":"Evening crimson","nl":"Avond paars","fr":"Pourpre du soir"},{"hex":"#9b727f","code":"360 50 20","scope":"Design System Plus","de":"Kupferrosa","en":"Copper pink","nl":"Koperroze","fr":"Rose cuivré"},{"hex":"#a46e7d","code":"360 50 25","scope":"Design System Plus","de":"Jugendstilrosa","en":"Art Nouveau pink","nl":"Art Nouveau roze","fr":"Rose art nouveau"},{"hex":"#aa6b80","code":"360 50 30","scope":"Design System Plus","de":"Kosmetikrot","en":"Cosmetic red","nl":"Cosmetisch rood","fr":"Rouge cosmétique"},{"hex":"#b26780","code":"360 50 35","scope":"Design System Plus","de":"Indischpink","en":"Indian pink","nl":"Indisch roze","fr":"Rose indien"},{"hex":"#b96680","code":"360 50 40","scope":"Design System Plus","de":"Kirroyalrosé","en":"Kir royale rose","nl":"Kirroyal rosé","fr":"Rose cerise"},{"hex":"#c06281","code":"360 50 45","scope":"Design System Plus","de":"Hahnenkammrot","en":"Cockscomb red","nl":"Hanenkam rood","fr":"Rouge crête de coq"},{"hex":"#c45d80","code":"360 50 50","scope":"Design System Plus","de":"Persischrot","en":"Persian red","nl":"Perzisch rood","fr":"Rouge persan"},{"hex":"#9f9497","code":"360 60 05","scope":"Design System Plus","de":"Aschrosa","en":"Ash pink","nl":"Asroze","fr":"Rose cendré"},{"hex":"#a58f95","code":"360 60 10","scope":"Design System Plus","de":"Majolikamauve","en":"Majolica mauve","nl":"Majolica mauve","fr":"Majolikamauve"},{"hex":"#ae8d96","code":"360 60 15","scope":"Design System Plus","de":"Feigenfruchtlila","en":"Fig fruit mauve","nl":"Vijgenvrucht paars","fr":"Mauve fruit de la figue"},{"hex":"#b78a97","code":"360 60 20","scope":"Design System Plus","de":"Edelflieder","en":"Noble lilac","nl":"Edele sering","fr":"Lilas noble"},{"hex":"#bd8597","code":"360 60 25","scope":"Design System Plus","de":"Hellrot","en":"Light red","nl":"Licht rood","fr":"Rouge clair"},{"hex":"#b9adb0","code":"360 70 05","scope":"Design System Plus","de":"Teeblütenrosa","en":"Tea blossom pink","nl":"Theebloesem roze","fr":"Rose fleur de thé"},{"hex":"#c0a7ae","code":"360 70 10","scope":"Design System Plus","de":"Quarzrosa","en":"Quartz pink","nl":"Kwartsroze","fr":"Rose quartz"},{"hex":"#c9a5af","code":"360 70 15","scope":"Design System Plus","de":"Opalinrosa","en":"Opaline pink","nl":"Opaline roze","fr":"Rose opalin"},{"hex":"#d3c7c9","code":"360 80 05","scope":"Design System Plus","de":"Perlmuttrosa","en":"Mother-of-pearl pink","nl":"Parelmoer roze","fr":"Rose nacré"},{"hex":"#dbc2c8","code":"360 80 10","scope":"Design System Plus","de":"Venezianerrosa","en":"Venetian pink","nl":"Venetiaans roze","fr":"Rose vénitien"},{"hex":"#e4bfc9","code":"360 80 15","scope":"Design System Plus","de":"Seifenrosa","en":"Soap pink","nl":"Zeep roze","fr":"Rose savonnette"},{"hex":"#e0d2d4","code":"360 85 05","scope":"Design System Plus","de":"Theaterpuderrosé","en":"Theatre powder rose","nl":"Theaterpoeder rosé","fr":"Rose théâtral"},{"hex":"#e8cfd5","code":"360 85 10","scope":"Design System Plus","de":"Lotusrosa","en":"Lotus pink","nl":"Lotus roze","fr":"Rose lotus"},{"hex":"#f1e2e1","code":"360 90 05","scope":"Design System Plus","de":"Eisrosa","en":"Ice pink","nl":"IJsroze","fr":"Rose glacé"},{"hex":"#f7dde3","code":"360 90 10","scope":"Design System Plus","de":"Tortencreme","en":"Cake frosting","nl":"Taartcrème","fr":"Crème à tarte"},{"hex":"#f6e8e9","code":"360 93 05","scope":"Design System Plus","de":"Pfeilkrautweiß","en":"Arrowhead white","nl":"Pijlpunt wit","fr":"Arrowbow white"},{"hex":"#E6E7E6","code":"110-1","scope":"Effect"},{"hex":"#DEDDD5","code":"110-2","scope":"Effect"},{"hex":"#C8C6BE","code":"110-3","scope":"Effect"},{"hex":"#C6C7C4","code":"110-4","scope":"Effect"},{"hex":"#C9CCC6","code":"110-5","scope":"Effect"},{"hex":"#C8C8C7","code":"110-6","scope":"Effect"},{"hex":"#A0A2A4","code":"110-M","scope":"Effect"},{"hex":"#EDEDEA","code":"120-1","scope":"Effect"},{"hex":"#F2F1EC","code":"120-2","scope":"Effect"},{"hex":"#F0EEE5","code":"120-3","scope":"Effect"},{"hex":"#E9E1D4","code":"120-4","scope":"Effect"},{"hex":"#E2D9C6","code":"120-5","scope":"Effect"},{"hex":"#EAE1CE","code":"120-6","scope":"Effect"},{"hex":"#8F8D87","code":"120-M","scope":"Effect"},{"hex":"#F2EDBB","code":"130-1","scope":"Effect"},{"hex":"#F1EEC3","code":"130-2","scope":"Effect"},{"hex":"#F0EECD","code":"130-3","scope":"Effect"},{"hex":"#F8F0CF","code":"130-4","scope":"Effect"},{"hex":"#EDE4BC","code":"130-5","scope":"Effect"},{"hex":"#FBE5B0","code":"130-6","scope":"Effect"},{"hex":"#ABAB90","code":"130-M","scope":"Effect"},{"hex":"#FAD3A9","code":"140-1","scope":"Effect"},{"hex":"#FEDAA6","code":"140-2","scope":"Effect"},{"hex":"#FEE3C1","code":"140-3","scope":"Effect"},{"hex":"#FDDFBE","code":"140-4","scope":"Effect"},{"hex":"#F8E4C8","code":"140-5","scope":"Effect"},{"hex":"#E5D2B6","code":"140-6","scope":"Effect"},{"hex":"#B09E7E","code":"140-M","scope":"Effect"},{"hex":"#F7EFE9","code":"150-1","scope":"Effect"},{"hex":"#F9EBE3","code":"150-2","scope":"Effect"},{"hex":"#EEE1D7","code":"150-3","scope":"Effect"},{"hex":"#FBE3D4","code":"150-4","scope":"Effect"},{"hex":"#FAE8DC","code":"150-5","scope":"Effect"},{"hex":"#F8DFD7","code":"150-6","scope":"Effect"},{"hex":"#AB978A","code":"150-M","scope":"Effect"},{"hex":"#E3E1EC","code":"160-1","scope":"Effect"},{"hex":"#E7E2E8","code":"160-2","scope":"Effect"},{"hex":"#EDE8E8","code":"160-3","scope":"Effect"},{"hex":"#EEE1E2","code":"160-4","scope":"Effect"},{"hex":"#EFE4E0","code":"160-5","scope":"Effect"},{"hex":"#ECE4E9","code":"160-6","scope":"Effect"},{"hex":"#ADA6B5","code":"160-M","scope":"Effect"},{"hex":"#C7C9D0","code":"170-1","scope":"Effect"},{"hex":"#A6ADBD","code":"170-2","scope":"Effect"},{"hex":"#BAC8DA","code":"170-3","scope":"Effect"},{"hex":"#CEDBEC","code":"170-4","scope":"Effect"},{"hex":"#C3C6D6","code":"170-5","scope":"Effect"},{"hex":"#C6C5D6","code":"170-6","scope":"Effect"},{"hex":"#A7A8B9","code":"170-M","scope":"Effect"},{"hex":"#AEBCC6","code":"180-1","scope":"Effect"},{"hex":"#B9CDDD","code":"180-2","scope":"Effect"},{"hex":"#C7DBEB","code":"180-3","scope":"Effect"},{"hex":"#C9E1EC","code":"180-4","scope":"Effect"},{"hex":"#C7DDE1","code":"180-5","scope":"Effect"},{"hex":"#DBE9EB","code":"180-6","scope":"Effect"},{"hex":"#96A4A9","code":"180-M","scope":"Effect"},{"hex":"#A5DADF","code":"190-1","scope":"Effect"},{"hex":"#B9E6F2","code":"190-2","scope":"Effect"},{"hex":"#C0DEE1","code":"190-3","scope":"Effect"},{"hex":"#BDDAD7","code":"190-4","scope":"Effect"},{"hex":"#D4E5E7","code":"190-5","scope":"Effect"},{"hex":"#A3C1BF","code":"190-6","scope":"Effect"},{"hex":"#92B4B2","code":"190-M","scope":"Effect"},{"hex":"#CFC6B2","code":"210-1","scope":"Effect"},{"hex":"#ECE7D2","code":"210-2","scope":"Effect"},{"hex":"#E3E4D9","code":"210-3","scope":"Effect"},{"hex":"#D6E6E3","code":"210-4","scope":"Effect"},{"hex":"#D8E8E0","code":"210-5","scope":"Effect"},{"hex":"#D8E9D6","code":"210-6","scope":"Effect"},{"hex":"#A5A99B","code":"210-M","scope":"Effect"},{"hex":"#66B872","code":"220-1","scope":"Effect"},{"hex":"#339A51","code":"220-2","scope":"Effect"},{"hex":"#006F3C","code":"220-3","scope":"Effect"},{"hex":"#088554","code":"220-4","scope":"Effect"},{"hex":"#267E51","code":"220-5","scope":"Effect"},{"hex":"#006A4D","code":"220-6","scope":"Effect"},{"hex":"#007F3E","code":"220-M","scope":"Effect"},{"hex":"#BBDB9A","code":"230-1","scope":"Effect"},{"hex":"#96C86C","code":"230-2","scope":"Effect"},{"hex":"#7DB344","code":"230-3","scope":"Effect"},{"hex":"#5F973A","code":"230-4","scope":"Effect"},{"hex":"#396938","code":"230-5","scope":"Effect"},{"hex":"#365C30","code":"230-6","scope":"Effect"},{"hex":"#62A74E","code":"230-M","scope":"Effect"},{"hex":"#DCD691","code":"240-1","scope":"Effect"},{"hex":"#AAAF66","code":"240-2","scope":"Effect"},{"hex":"#939755","code":"240-3","scope":"Effect"},{"hex":"#7E7E42","code":"240-4","scope":"Effect"},{"hex":"#5D6D3C","code":"240-5","scope":"Effect"},{"hex":"#4F6D35","code":"240-6","scope":"Effect"},{"hex":"#627439","code":"240-M","scope":"Effect"},{"hex":"#EEE6A5","code":"250-1","scope":"Effect"},{"hex":"#E8DE6F","code":"250-2","scope":"Effect"},{"hex":"#BFB700","code":"250-3","scope":"Effect"},{"hex":"#A4A541","code":"250-4","scope":"Effect"},{"hex":"#919138","code":"250-5","scope":"Effect"},{"hex":"#69652C","code":"250-6","scope":"Effect"},{"hex":"#AEA73B","code":"250-M","scope":"Effect"},{"hex":"#F3E9B4","code":"260-1","scope":"Effect"},{"hex":"#F1E483","code":"260-2","scope":"Effect"},{"hex":"#F3D446","code":"260-3","scope":"Effect"},{"hex":"#E8C01F","code":"260-4","scope":"Effect"},{"hex":"#DEB02D","code":"260-5","scope":"Effect"},{"hex":"#EFB416","code":"260-6","scope":"Effect"},{"hex":"#B8944F","code":"260-M","scope":"Effect"},{"hex":"#FFDE83","code":"270-1","scope":"Effect"},{"hex":"#FACC39","code":"270-2","scope":"Effect"},{"hex":"#F4BD16","code":"270-3","scope":"Effect"},{"hex":"#EBB100","code":"270-4","scope":"Effect"},{"hex":"#F6B600","code":"270-5","scope":"Effect"},{"hex":"#FEC43F","code":"270-6","scope":"Effect"},{"hex":"#CB9437","code":"270-M","scope":"Effect"},{"hex":"#FDE193","code":"280-1","scope":"Effect"},{"hex":"#F0D391","code":"280-2","scope":"Effect"},{"hex":"#E1BE78","code":"280-3","scope":"Effect"},{"hex":"#D6AE5F","code":"280-4","scope":"Effect"},{"hex":"#DCA140","code":"280-5","scope":"Effect"},{"hex":"#D0973C","code":"280-6","scope":"Effect"},{"hex":"#B28740","code":"280-M","scope":"Effect"},{"hex":"#D89B50","code":"290-1","scope":"Effect"},{"hex":"#BF853B","code":"290-2","scope":"Effect"},{"hex":"#D8A960","code":"290-3","scope":"Effect"},{"hex":"#CC921B","code":"290-4","scope":"Effect"},{"hex":"#E6B03E","code":"290-5","scope":"Effect"},{"hex":"#FCAB04","code":"290-6","scope":"Effect"},{"hex":"#B87E32","code":"290-M","scope":"Effect"},{"hex":"#F5D6B4","code":"310-1","scope":"Effect"},{"hex":"#EBC297","code":"310-2","scope":"Effect"},{"hex":"#DFAB73","code":"310-3","scope":"Effect"},{"hex":"#D09355","code":"310-4","scope":"Effect"},{"hex":"#BA7C43","code":"310-5","scope":"Effect"},{"hex":"#8E5B2D","code":"310-6","scope":"Effect"},{"hex":"#B87D4F","code":"310-M","scope":"Effect"},{"hex":"#D2A96C","code":"320-1","scope":"Effect"},{"hex":"#AE8151","code":"320-2","scope":"Effect"},{"hex":"#B9864C","code":"320-3","scope":"Effect"},{"hex":"#A06735","code":"320-4","scope":"Effect"},{"hex":"#7F4E2E","code":"320-5","scope":"Effect"},{"hex":"#6E4428","code":"320-6","scope":"Effect"},{"hex":"#B9731E","code":"320-M","scope":"Effect"},{"hex":"#A86859","code":"330-1","scope":"Effect"},{"hex":"#8E4B35","code":"330-2","scope":"Effect"},{"hex":"#794E3E","code":"330-3","scope":"Effect"},{"hex":"#5C3B2D","code":"330-4","scope":"Effect"},{"hex":"#50312A","code":"330-5","scope":"Effect"},{"hex":"#46322E","code":"330-6","scope":"Effect"},{"hex":"#8B5943","code":"330-M","scope":"Effect"},{"hex":"#BEA4A9","code":"340-1","scope":"Effect"},{"hex":"#A48C92","code":"340-2","scope":"Effect"},{"hex":"#7F5452","code":"340-3","scope":"Effect"},{"hex":"#683D40","code":"340-4","scope":"Effect"},{"hex":"#4F2A2D","code":"340-5","scope":"Effect"},{"hex":"#4F2B31","code":"340-6","scope":"Effect"},{"hex":"#53353B","code":"340-M","scope":"Effect"},{"hex":"#9D311F","code":"350-1","scope":"Effect"},{"hex":"#A73F32","code":"350-2","scope":"Effect"},{"hex":"#A24733","code":"350-3","scope":"Effect"},{"hex":"#813021","code":"350-4","scope":"Effect"},{"hex":"#783122","code":"350-5","scope":"Effect"},{"hex":"#66322B","code":"350-6","scope":"Effect"},{"hex":"#582F2A","code":"350-M","scope":"Effect"},{"hex":"#E07D29","code":"360-1","scope":"Effect"},{"hex":"#D9751E","code":"360-2","scope":"Effect"},{"hex":"#C66217","code":"360-3","scope":"Effect"},{"hex":"#B75629","code":"360-4","scope":"Effect"},{"hex":"#9A4F2C","code":"360-5","scope":"Effect"},{"hex":"#915033","code":"360-6","scope":"Effect"},{"hex":"#A45633","code":"360-M","scope":"Effect"},{"hex":"#FFAE47","code":"370-1","scope":"Effect"},{"hex":"#FF9B38","code":"370-2","scope":"Effect"},{"hex":"#FF901D","code":"370-3","scope":"Effect"},{"hex":"#E68316","code":"370-4","scope":"Effect"},{"hex":"#D4781F","code":"370-5","scope":"Effect"},{"hex":"#CD6C10","code":"370-6","scope":"Effect"},{"hex":"#B47A3C","code":"370-M","scope":"Effect"},{"hex":"#FF9B29","code":"380-1","scope":"Effect"},{"hex":"#FF9204","code":"380-2","scope":"Effect"},{"hex":"#FA841A","code":"380-3","scope":"Effect"},{"hex":"#E27121","code":"380-4","scope":"Effect"},{"hex":"#F2782F","code":"380-5","scope":"Effect"},{"hex":"#EA6A24","code":"380-6","scope":"Effect"},{"hex":"#A7552A","code":"380-M","scope":"Effect"},{"hex":"#EB773F","code":"390-1","scope":"Effect"},{"hex":"#E36125","code":"390-2","scope":"Effect"},{"hex":"#DE5411","code":"390-3","scope":"Effect"},{"hex":"#D8511C","code":"390-4","scope":"Effect"},{"hex":"#D8480F","code":"390-5","scope":"Effect"},{"hex":"#CD5E2A","code":"390-6","scope":"Effect"},{"hex":"#BF633B","code":"390-M","scope":"Effect"},{"hex":"#ED8165","code":"410-1","scope":"Effect"},{"hex":"#EA734F","code":"410-2","scope":"Effect"},{"hex":"#E46440","code":"410-3","scope":"Effect"},{"hex":"#DC5D38","code":"410-4","scope":"Effect"},{"hex":"#D25535","code":"410-5","scope":"Effect"},{"hex":"#D05D42","code":"410-6","scope":"Effect"},{"hex":"#AB4924","code":"410-M","scope":"Effect"},{"hex":"#EDAE9A","code":"420-1","scope":"Effect"},{"hex":"#F29D86","code":"420-2","scope":"Effect"},{"hex":"#E98A6C","code":"420-3","scope":"Effect"},{"hex":"#E46443","code":"420-4","scope":"Effect"},{"hex":"#CC5738","code":"420-5","scope":"Effect"},{"hex":"#BF502E","code":"420-6","scope":"Effect"},{"hex":"#9D4B32","code":"420-M","scope":"Effect"},{"hex":"#F2C2B6","code":"430-1","scope":"Effect"},{"hex":"#EC998B","code":"430-2","scope":"Effect"},{"hex":"#E48074","code":"430-3","scope":"Effect"},{"hex":"#DD5A4C","code":"430-4","scope":"Effect"},{"hex":"#D5433C","code":"430-5","scope":"Effect"},{"hex":"#BE3A24","code":"430-6","scope":"Effect"},{"hex":"#A84C45","code":"430-M","scope":"Effect"},{"hex":"#CA383C","code":"440-1","scope":"Effect"},{"hex":"#D34C49","code":"440-2","scope":"Effect"},{"hex":"#BA3C3E","code":"440-3","scope":"Effect"},{"hex":"#9B2929","code":"440-4","scope":"Effect"},{"hex":"#A63129","code":"440-5","scope":"Effect"},{"hex":"#B93525","code":"440-6","scope":"Effect"},{"hex":"#9B252C","code":"440-M","scope":"Effect"},{"hex":"#F4C7CA","code":"450-1","scope":"Effect"},{"hex":"#EDA5AA","code":"450-2","scope":"Effect"},{"hex":"#E07A81","code":"450-3","scope":"Effect"},{"hex":"#C85862","code":"450-4","scope":"Effect"},{"hex":"#B2312F","code":"450-5","scope":"Effect"},{"hex":"#BB201D","code":"450-6","scope":"Effect"},{"hex":"#A71616","code":"450-M","scope":"Effect"},{"hex":"#EFA3A7","code":"460-1","scope":"Effect"},{"hex":"#E37F89","code":"460-2","scope":"Effect"},{"hex":"#DF6368","code":"460-3","scope":"Effect"},{"hex":"#D35254","code":"460-4","scope":"Effect"},{"hex":"#A8373B","code":"460-5","scope":"Effect"},{"hex":"#8B1B28","code":"460-6","scope":"Effect"},{"hex":"#AE363B","code":"460-M","scope":"Effect"},{"hex":"#F0B3C1","code":"470-1","scope":"Effect"},{"hex":"#E68B9D","code":"470-2","scope":"Effect"},{"hex":"#DE7383","code":"470-3","scope":"Effect"},{"hex":"#CA4D67","code":"470-4","scope":"Effect"},{"hex":"#AC2D4C","code":"470-5","scope":"Effect"},{"hex":"#9C223F","code":"470-6","scope":"Effect"},{"hex":"#B14F5D","code":"470-M","scope":"Effect"},{"hex":"#F5CAC9","code":"480-1","scope":"Effect"},{"hex":"#F5C0BE","code":"480-2","scope":"Effect"},{"hex":"#EEBABC","code":"480-3","scope":"Effect"},{"hex":"#EEA5B1","code":"480-4","scope":"Effect"},{"hex":"#E9909E","code":"480-5","scope":"Effect"},{"hex":"#DA6C82","code":"480-6","scope":"Effect"},{"hex":"#A87579","code":"480-M","scope":"Effect"},{"hex":"#F3CFD0","code":"490-1","scope":"Effect"},{"hex":"#F7CAC3","code":"490-2","scope":"Effect"},{"hex":"#E89A92","code":"490-3","scope":"Effect"},{"hex":"#C37B77","code":"490-4","scope":"Effect"},{"hex":"#BE7F8C","code":"490-5","scope":"Effect"},{"hex":"#D29EA8","code":"490-6","scope":"Effect"},{"hex":"#A77D88","code":"490-M","scope":"Effect"},{"hex":"#ECC8DC","code":"510-1","scope":"Effect"},{"hex":"#E0A5CB","code":"510-2","scope":"Effect"},{"hex":"#D584B1","code":"510-3","scope":"Effect"},{"hex":"#C4638D","code":"510-4","scope":"Effect"},{"hex":"#BA4877","code":"510-5","scope":"Effect"},{"hex":"#9A3B6A","code":"510-6","scope":"Effect"},{"hex":"#8C3D71","code":"510-M","scope":"Effect"},{"hex":"#EFD2DF","code":"520-1","scope":"Effect"},{"hex":"#E8BAD2","code":"520-2","scope":"Effect"},{"hex":"#DCA5C0","code":"520-3","scope":"Effect"},{"hex":"#BA7293","code":"520-4","scope":"Effect"},{"hex":"#A04E6F","code":"520-5","scope":"Effect"},{"hex":"#92526E","code":"520-6","scope":"Effect"},{"hex":"#9E588B","code":"520-M","scope":"Effect"},{"hex":"#98444D","code":"530-1","scope":"Effect"},{"hex":"#8F3F4E","code":"530-2","scope":"Effect"},{"hex":"#793644","code":"530-3","scope":"Effect"},{"hex":"#7C2F4B","code":"530-4","scope":"Effect"},{"hex":"#66253D","code":"530-5","scope":"Effect"},{"hex":"#61294A","code":"530-6","scope":"Effect"},{"hex":"#5C2D3A","code":"530-M","scope":"Effect"},{"hex":"#D4C1D7","code":"540-1","scope":"Effect"},{"hex":"#BEA1C1","code":"540-2","scope":"Effect"},{"hex":"#805F83","code":"540-3","scope":"Effect"},{"hex":"#966B98","code":"540-4","scope":"Effect"},{"hex":"#81537A","code":"540-5","scope":"Effect"},{"hex":"#562C51","code":"540-6","scope":"Effect"},{"hex":"#562F4E","code":"540-M","scope":"Effect"},{"hex":"#E0D1D9","code":"550-1","scope":"Effect"},{"hex":"#D0BBC9","code":"550-2","scope":"Effect"},{"hex":"#B292A8","code":"550-3","scope":"Effect"},{"hex":"#9C7488","code":"550-4","scope":"Effect"},{"hex":"#8D6177","code":"550-5","scope":"Effect"},{"hex":"#784C5E","code":"550-6","scope":"Effect"},{"hex":"#A78890","code":"550-M","scope":"Effect"},{"hex":"#CCBCC7","code":"560-1","scope":"Effect"},{"hex":"#B09CAD","code":"560-2","scope":"Effect"},{"hex":"#8C6F80","code":"560-3","scope":"Effect"},{"hex":"#775460","code":"560-4","scope":"Effect"},{"hex":"#85727F","code":"560-5","scope":"Effect"},{"hex":"#7D6E7F","code":"560-6","scope":"Effect"},{"hex":"#A592A4","code":"560-M","scope":"Effect"},{"hex":"#D1CEE8","code":"570-1","scope":"Effect"},{"hex":"#C3BFE1","code":"570-2","scope":"Effect"},{"hex":"#ADADDD","code":"570-3","scope":"Effect"},{"hex":"#9B9ACF","code":"570-4","scope":"Effect"},{"hex":"#8078B3","code":"570-5","scope":"Effect"},{"hex":"#79689B","code":"570-6","scope":"Effect"},{"hex":"#6B589A","code":"570-M","scope":"Effect"},{"hex":"#C2CFE6","code":"580-1","scope":"Effect"},{"hex":"#BCC7E0","code":"580-2","scope":"Effect"},{"hex":"#A7B2D1","code":"580-3","scope":"Effect"},{"hex":"#69749A","code":"580-4","scope":"Effect"},{"hex":"#41506E","code":"580-5","scope":"Effect"},{"hex":"#243154","code":"580-6","scope":"Effect"},{"hex":"#636C86","code":"580-M","scope":"Effect"},{"hex":"#666D9B","code":"590-1","scope":"Effect"},{"hex":"#424276","code":"590-2","scope":"Effect"},{"hex":"#2A366B","code":"590-3","scope":"Effect"},{"hex":"#272F5B","code":"590-4","scope":"Effect"},{"hex":"#142D58","code":"590-5","scope":"Effect"},{"hex":"#093B7A","code":"590-6","scope":"Effect"},{"hex":"#293862","code":"590-M","scope":"Effect"},{"hex":"#6E8FAB","code":"610-1","scope":"Effect"},{"hex":"#617A94","code":"610-2","scope":"Effect"},{"hex":"#6D95B9","code":"610-3","scope":"Effect"},{"hex":"#89B2D8","code":"610-4","scope":"Effect"},{"hex":"#4777AE","code":"610-5","scope":"Effect"},{"hex":"#436999","code":"610-6","scope":"Effect"},{"hex":"#7897B5","code":"610-M","scope":"Effect"},{"hex":"#34688A","code":"620-1","scope":"Effect"},{"hex":"#6092AC","code":"620-2","scope":"Effect"},{"hex":"#64818F","code":"620-3","scope":"Effect"},{"hex":"#3A5A6A","code":"620-4","scope":"Effect"},{"hex":"#14354B","code":"620-5","scope":"Effect"},{"hex":"#1E2D3F","code":"620-6","scope":"Effect"},{"hex":"#093246","code":"620-M","scope":"Effect"},{"hex":"#51A3D3","code":"630-1","scope":"Effect"},{"hex":"#446B8E","code":"630-2","scope":"Effect"},{"hex":"#2E4E6F","code":"630-3","scope":"Effect"},{"hex":"#2D4A6E","code":"630-4","scope":"Effect"},{"hex":"#1F3454","code":"630-5","scope":"Effect"},{"hex":"#193654","code":"630-6","scope":"Effect"},{"hex":"#16304C","code":"630-M","scope":"Effect"},{"hex":"#49A0C5","code":"640-1","scope":"Effect"},{"hex":"#0087B5","code":"640-2","scope":"Effect"},{"hex":"#007BAE","code":"640-3","scope":"Effect"},{"hex":"#005C8C","code":"640-4","scope":"Effect"},{"hex":"#00548A","code":"640-5","scope":"Effect"},{"hex":"#004F7D","code":"640-6","scope":"Effect"},{"hex":"#004E87","code":"640-M","scope":"Effect"},{"hex":"#64B5D6","code":"650-1","scope":"Effect"},{"hex":"#0077A0","code":"650-2","scope":"Effect"},{"hex":"#006C97","code":"650-3","scope":"Effect"},{"hex":"#005577","code":"650-4","scope":"Effect"},{"hex":"#1D5B78","code":"650-5","scope":"Effect"},{"hex":"#0A4962","code":"650-6","scope":"Effect"},{"hex":"#00719D","code":"650-M","scope":"Effect"},{"hex":"#0094B0","code":"660-1","scope":"Effect"},{"hex":"#0B8DA8","code":"660-2","scope":"Effect"},{"hex":"#51A5B8","code":"660-3","scope":"Effect"},{"hex":"#3FB8CF","code":"660-4","scope":"Effect"},{"hex":"#6CC3D4","code":"660-5","scope":"Effect"},{"hex":"#8AC8D5","code":"660-6","scope":"Effect"},{"hex":"#5597A9","code":"660-M","scope":"Effect"},{"hex":"#8AD3EA","code":"670-1","scope":"Effect"},{"hex":"#97DAEF","code":"670-2","scope":"Effect"},{"hex":"#8FC5D6","code":"670-3","scope":"Effect"},{"hex":"#69BBD3","code":"670-4","scope":"Effect"},{"hex":"#5BB9D5","code":"670-5","scope":"Effect"},{"hex":"#4EC2E6","code":"670-6","scope":"Effect"},{"hex":"#74A7B8","code":"670-M","scope":"Effect"},{"hex":"#72AABA","code":"680-1","scope":"Effect"},{"hex":"#338FA4","code":"680-2","scope":"Effect"},{"hex":"#177185","code":"680-3","scope":"Effect"},{"hex":"#26768D","code":"680-4","scope":"Effect"},{"hex":"#006A85","code":"680-5","scope":"Effect"},{"hex":"#005B74","code":"680-6","scope":"Effect"},{"hex":"#0E455C","code":"680-M","scope":"Effect"},{"hex":"#3FBFCB","code":"690-1","scope":"Effect"},{"hex":"#00A2AD","code":"690-2","scope":"Effect"},{"hex":"#00838E","code":"690-3","scope":"Effect"},{"hex":"#006C7B","code":"690-4","scope":"Effect"},{"hex":"#00535F","code":"690-5","scope":"Effect"},{"hex":"#005160","code":"690-6","scope":"Effect"},{"hex":"#006773","code":"690-M","scope":"Effect"},{"hex":"#78D1CD","code":"710-1","scope":"Effect"},{"hex":"#00AAA7","code":"710-2","scope":"Effect"},{"hex":"#058A8B","code":"710-3","scope":"Effect"},{"hex":"#007476","code":"710-4","scope":"Effect"},{"hex":"#005C60","code":"710-5","scope":"Effect"},{"hex":"#0C4746","code":"710-6","scope":"Effect"},{"hex":"#00686B","code":"710-M","scope":"Effect"},{"hex":"#C2E3DE","code":"720-1","scope":"Effect"},{"hex":"#A4E2DB","code":"720-2","scope":"Effect"},{"hex":"#86D3D4","code":"720-3","scope":"Effect"},{"hex":"#58BEC1","code":"720-4","scope":"Effect"},{"hex":"#3393A0","code":"720-5","scope":"Effect"},{"hex":"#197C86","code":"720-6","scope":"Effect"},{"hex":"#1A949A","code":"720-M","scope":"Effect"},{"hex":"#CBE7E2","code":"730-1","scope":"Effect"},{"hex":"#98D3D3","code":"730-2","scope":"Effect"},{"hex":"#7DB8BA","code":"730-3","scope":"Effect"},{"hex":"#7BB9B4","code":"730-4","scope":"Effect"},{"hex":"#79ACAC","code":"730-5","scope":"Effect"},{"hex":"#46877F","code":"730-6","scope":"Effect"},{"hex":"#62A293","code":"730-M","scope":"Effect"},{"hex":"#C5DCCE","code":"740-1","scope":"Effect"},{"hex":"#B3D6C9","code":"740-2","scope":"Effect"},{"hex":"#95C3B2","code":"740-3","scope":"Effect"},{"hex":"#498574","code":"740-4","scope":"Effect"},{"hex":"#006F5B","code":"740-5","scope":"Effect"},{"hex":"#005D4E","code":"740-6","scope":"Effect"},{"hex":"#3A6F5F","code":"740-M","scope":"Effect"},{"hex":"#BFD7C9","code":"750-1","scope":"Effect"},{"hex":"#8FB4A0","code":"750-2","scope":"Effect"},{"hex":"#3D7461","code":"750-3","scope":"Effect"},{"hex":"#164234","code":"750-4","scope":"Effect"},{"hex":"#335449","code":"750-5","scope":"Effect"},{"hex":"#2E3C3B","code":"750-6","scope":"Effect"},{"hex":"#17372D","code":"750-M","scope":"Effect"},{"hex":"#D5E3CA","code":"760-1","scope":"Effect"},{"hex":"#B8CDAA","code":"760-2","scope":"Effect"},{"hex":"#B0BE9B","code":"760-3","scope":"Effect"},{"hex":"#8B9B7A","code":"760-4","scope":"Effect"},{"hex":"#6D7E5C","code":"760-5","scope":"Effect"},{"hex":"#4A6448","code":"760-6","scope":"Effect"},{"hex":"#334B2E","code":"760-M","scope":"Effect"},{"hex":"#989D84","code":"770-1","scope":"Effect"},{"hex":"#A9A88F","code":"770-2","scope":"Effect"},{"hex":"#7A755A","code":"770-3","scope":"Effect"},{"hex":"#817A66","code":"770-4","scope":"Effect"},{"hex":"#B4AF9F","code":"770-5","scope":"Effect"},{"hex":"#7E8273","code":"770-6","scope":"Effect"},{"hex":"#8D8864","code":"770-M","scope":"Effect"},{"hex":"#E9DECC","code":"780-1","scope":"Effect"},{"hex":"#E7D6B9","code":"780-2","scope":"Effect"},{"hex":"#DDC49A","code":"780-3","scope":"Effect"},{"hex":"#D1B186","code":"780-4","scope":"Effect"},{"hex":"#A38E79","code":"780-5","scope":"Effect"},{"hex":"#74695C","code":"780-6","scope":"Effect"},{"hex":"#B2A074","code":"780-M","scope":"Effect"},{"hex":"#3E4849","code":"790-1","scope":"Effect"},{"hex":"#3B4147","code":"790-2","scope":"Effect"},{"hex":"#313538","code":"790-3","scope":"Effect"},{"hex":"#302F32","code":"790-4","scope":"Effect"},{"hex":"#212224","code":"790-5","scope":"Effect"},{"hex":"#21232D","code":"790-6","scope":"Effect"},{"hex":"#221F1D","code":"790-M","scope":"Effect"},{"hex":"#979DA2","code":"810-1","scope":"Effect"},{"hex":"#8A9499","code":"810-2","scope":"Effect"},{"hex":"#79888E","code":"810-3","scope":"Effect"},{"hex":"#5E6B73","code":"810-4","scope":"Effect"},{"hex":"#51595D","code":"810-5","scope":"Effect"},{"hex":"#394146","code":"810-6","scope":"Effect"},{"hex":"#404649","code":"810-M","scope":"Effect"},{"hex":"#C5C8CA","code":"820-1","scope":"Effect"},{"hex":"#A9AEB2","code":"820-2","scope":"Effect"},{"hex":"#8D9395","code":"820-3","scope":"Effect"},{"hex":"#7D8589","code":"820-4","scope":"Effect"},{"hex":"#50555C","code":"820-5","scope":"Effect"},{"hex":"#444951","code":"820-6","scope":"Effect"},{"hex":"#929191","code":"820-M","scope":"Effect"},{"hex":"#BABCBA","code":"830-1","scope":"Effect"},{"hex":"#A4A7A5","code":"830-2","scope":"Effect"},{"hex":"#8D9291","code":"830-3","scope":"Effect"},{"hex":"#6C706D","code":"830-4","scope":"Effect"},{"hex":"#515554","code":"830-5","scope":"Effect"},{"hex":"#575E60","code":"830-6","scope":"Effect"},{"hex":"#82817F","code":"830-M","scope":"Effect"},{"hex":"#E7E3D8","code":"840-1","scope":"Effect"},{"hex":"#D7D5CC","code":"840-2","scope":"Effect"},{"hex":"#B8B4A8","code":"840-3","scope":"Effect"},{"hex":"#808077","code":"840-4","scope":"Effect"},{"hex":"#5A5D54","code":"840-5","scope":"Effect"},{"hex":"#474135","code":"840-6","scope":"Effect"},{"hex":"#494440","code":"840-M","scope":"Effect"},{"hex":"#C3C2B9","code":"850-1","scope":"Effect"},{"hex":"#B1B1AA","code":"850-2","scope":"Effect"},{"hex":"#A6A6A0","code":"850-3","scope":"Effect"},{"hex":"#918D85","code":"850-4","scope":"Effect"},{"hex":"#6B6760","code":"850-5","scope":"Effect"},{"hex":"#4C4B46","code":"850-6","scope":"Effect"},{"hex":"#625E59","code":"850-M","scope":"Effect"},{"hex":"#D8DADB","code":"860-1","scope":"Effect"},{"hex":"#CFD2D5","code":"860-2","scope":"Effect"},{"hex":"#C1C2C4","code":"860-3","scope":"Effect"},{"hex":"#9A9A9B","code":"860-4","scope":"Effect"},{"hex":"#7A7A79","code":"860-5","scope":"Effect"},{"hex":"#5B5F5F","code":"860-6","scope":"Effect"},{"hex":"#A4A09F","code":"860-M","scope":"Effect"},{"hex":"#D3D0D0","code":"870-1","scope":"Effect"},{"hex":"#969392","code":"870-2","scope":"Effect"},{"hex":"#636164","code":"870-3","scope":"Effect"},{"hex":"#514D4E","code":"870-4","scope":"Effect"},{"hex":"#4A4747","code":"870-5","scope":"Effect"},{"hex":"#3D3737","code":"870-6","scope":"Effect"},{"hex":"#4D4747","code":"870-M","scope":"Effect"},{"hex":"#69473e","code":"DB301","scope":"DB","de":"DB 301","en":"DB 301","dontAddPrefix":true,"nl":"DB 301","fr":"DB 301"},{"hex":"#52251f","code":"DB310","scope":"DB","de":"DB 310","en":"DB 310","dontAddPrefix":true,"nl":"DB 310","fr":"DB 310"},{"hex":"#638a89","code":"DB501","scope":"DB","de":"DB 501","en":"DB 501","dontAddPrefix":true,"nl":"DB 501","fr":"DB 501"},{"hex":"#294b4c","code":"DB502","scope":"DB","de":"DB 502","en":"DB 502","dontAddPrefix":true,"nl":"DB 502","fr":"DB 502"},{"hex":"#203d45","code":"DB503","scope":"DB","de":"DB 503","en":"DB 503","dontAddPrefix":true,"nl":"DB 503","fr":"DB 503"},{"hex":"#2f5063","code":"DB510","scope":"DB","de":"DB 510","en":"DB 510","dontAddPrefix":true,"nl":"DB 510","fr":"DB 510"},{"hex":"#537250","code":"DB601","scope":"DB","de":"DB 601","en":"DB 601","dontAddPrefix":true,"nl":"DB 601","fr":"DB 601"},{"hex":"#41624d","code":"DB603","scope":"DB","de":"DB 603","en":"DB 603","dontAddPrefix":true,"nl":"DB 603","fr":"DB 603"},{"hex":"#2b6954","code":"DB610","scope":"DB","de":"DB 610","en":"DB 610","dontAddPrefix":true,"nl":"DB 610","fr":"DB 610"},{"hex":"#8b9e9a","code":"DB701","scope":"DB","de":"DB 701","en":"DB 701","dontAddPrefix":true,"nl":"DB 701","fr":"DB 701"},{"hex":"#5f7165","code":"DB702","scope":"DB","de":"DB 702","en":"DB 702","dontAddPrefix":true,"nl":"DB 702","fr":"DB 702"},{"hex":"#2d3e34","code":"DB703","scope":"DB","de":"DB 703","en":"DB 703","dontAddPrefix":true,"nl":"DB 703","fr":"DB 703"}];

const ralColorsByHex = indexBy(ralColor => ralColor.hex, ralColorsComplete);

const RALColorSelectTmp = ({
  variable,
  value,
  values,
  onChange,
  disabled: _disabled = false
}) => {
  const templateOptions = getTemplateOptions(variable);
  const currentRALColors = useMemo(() => flow(map(value => Object.assign({}, ralColorsByHex[value.value], {
    valueId: value.id
  })),
  // TODO: Neu erstellte Values haben null als value.value. Daher müssen
  // die undefined Einträge entfernt werden.
  compact$1)(values), [values]);
  const handleChange = useCallback(hexColor => {
    const currentValue = values.find(value => value.value === hexColor);
    onChange(currentValue.id);
  }, [values, onChange]);
  const language = useTypedSelector(selectLanguage);
  const borderRadius = isNumber$1(templateOptions == null ? void 0 : templateOptions.borderRadius) ? templateOptions == null ? void 0 : templateOptions.borderRadius : 1;
  return jsx(OCRALColorSelect, {
    disabled: _disabled,
    label: jsx(VariableLabel, {
      variable: variable
    }),
    ralColors: currentRALColors,
    value: (value == null ? void 0 : value.value) || "",
    onChange: handleChange,
    language: language,
    visibleColorCount: templateOptions == null ? void 0 : templateOptions.numberOfColorsShown,
    borderRadius: borderRadius
  });
};
const RALColorSelect = flow(WithHideDisableTemplateOptions, withComponentExtension("ralColorSelect"))(RALColorSelectTmp);

const sxStyles$h = {
  root: {
    width: 1.0
  }
};
const OCRadiobuttons = props => {
  var _props$value2;
  const handleClick = e => {
    var _props$value;
    const newValue = parseInt(e.target.value);
    if (newValue === ((_props$value = props.value) == null ? void 0 : _props$value.id)) {
      props.onChange && props.onChange(parseInt(e.target.value));
    }
  };
  return jsxs(FormControl$1, {
    "data-cy": `RadioButtons`,
    sx: sxStyles$h.root,
    disabled: props.disabled,
    component: "fieldset",
    children: [jsx(Typography, {
      color: "textSecondary",
      children: props.label
    }), jsx(RadioGroup, {
      value: ((_props$value2 = props.value) == null ? void 0 : _props$value2.id) || null,
      onChange: e => {
        props.onChange && props.onChange(parseInt(e.target.value));
      },
      children: props.values.map(value => jsx(FormControlLabel, {
        "data-cy": "radioButton",
        sx: props.LabelStyle || {},
        disabled: props.disabled,
        value: (value == null ? void 0 : value.id) || "",
        control: jsx(Radio$1, {
          "data-cy": `radio`,
          onClick: handleClick
        }),
        disableTypography: true,
        label: props.disableTypography ? value == null ? void 0 : value.label : jsx(Typography, {
          component: "span",
          sx: Object.assign({}, props.LabelStyle || {}, {
            typography: {
              color: "text.primary"
            }
          }),
          "data-cy": "radioLabel",
          children: (value == null ? void 0 : value.label) || ""
        }),
        color: "inherit"
      }, value.id))
    })]
  });
};

const RadioTmp = ({
  variable,
  value,
  values,
  onChange,
  disabled
}) => {
  return jsx(OCRadiobuttons, {
    disabled: disabled,
    label: jsx(VariableLabel, {
      variable: variable
    }),
    value: value || -1,
    values: values.map(value => ({
      id: value.id,
      label: jsx(Box, {
        component: "div",
        sx: {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 1
        },
        children: jsx(ValueDetails, {
          value: value.id,
          variable: variable,
          variableValue: value,
          templateOptions: getTemplateOptions(variable),
          infoIconButtons: jsxs(Fragment, {
            children: [jsx(InfoSelectionIcon, {
              variable: variable,
              value: value
            }), jsx(InvalidSelectionWarning, {
              valueId: value == null ? void 0 : value.id
            })]
          })
        }, value.id)
      })
    })),
    LabelStyle: {
      width: "100%"
    },
    disableTypography: true,
    onChange: onChange
  });
};
const Radio = flow(WithHideDisableTemplateOptions, withComponentExtension("radio"))(RadioTmp);

const RadioCardTmp = ({
  variable,
  value,
  values,
  onChange,
  disabled
}) => {
  const noSelection = useMemo(() => values.find(v => v.key === noSelectionKey), [values]);
  const currentValueId = value == null ? void 0 : value.id;
  const change = (_, valueId) => {
    if (valueId) {
      onChange(valueId);
    } else {
      // valueId is null if we click the current element again
      // in that case we want to deselect it, if possible.
      if (noSelection) {
        onChange(noSelection.id);
      }
      // in case there is no "noSelection" we simply do not change the value
    }
  };

  const valuesData = values.filter(v => v.key !== noSelectionKey).map(value => ({
    id: value.id,
    name: value.label,
    label: jsx(Box, {
      component: "div",
      sx: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"
      },
      "data-cy": `box-${variable.label}`,
      children: jsx(ValueDetails, {
        value: value.id,
        variable: variable,
        variableValue: value,
        templateOptions: getTemplateOptions(variable),
        infoIconButtons: jsxs(Fragment, {
          children: [jsx(InfoSelectionIcon, {
            variable: variable,
            value: value
          }), jsx(InvalidSelectionWarning, {
            valueId: value == null ? void 0 : value.id
          })]
        })
      }, value.id)
    })
  }));
  const variableLabel = jsx(VariableLabel, {
    variable: variable
  });
  return jsxs(FormControl$1, {
    sx: {
      width: 1
    },
    children: [variableLabel, jsx(ToggleButtonGroup, {
      value: currentValueId,
      exclusive: true,
      fullWidth: true,
      sx: {
        gap: 1
      },
      orientation: "vertical",
      onChange: change,
      "aria-label": "text alignment",
      children: valuesData.map(value => jsx(ToggleButton, {
        "data-cy": `card-${value.name}`,
        fullWidth: true,
        value: value == null ? void 0 : value.id,
        color: "primary",
        disabled: disabled,
        sx: Object.assign({
          border: "1px solid #0000001f !important",
          borderColor: "divider !important",
          borderRadius: "8px  !important",
          justifyContent: "flex-start",
          textAlign: "left"
        }, currentValueId !== value.id && {
          "& .MuiTypography-root": {
            color: "text.primary"
          }
        }),
        children: value.label
      }, value == null ? void 0 : value.id))
    })]
  });
};
const RadioCard = flow(WithHideDisableTemplateOptions, withComponentExtension("radioCard"))(RadioCardTmp);

const SelectComponent = ({
  disabled: _disabled = false,
  onChange,
  value,
  values,
  variable
}) => {
  var _value$id$toString, _value$id;
  const templateOptions = getTemplateOptions(variable);
  return jsx(OCSelect, {
    "data-cy": `selectOc`,
    disabled: _disabled,
    label: jsx(VariableLabel, {
      variable: variable
    }),
    value: (_value$id$toString = value == null ? void 0 : (_value$id = value.id) == null ? void 0 : _value$id.toString()) != null ? _value$id$toString : "",
    onChange: valueId => onChange(isArray$4(valueId) ? +valueId[0] : +valueId),
    SelectProps: {
      inputProps: {
        sx: {
          p: 0
        }
      },
      renderValue: valueId => {
        const variableValue = values.find(value => value.id == valueId);
        if (!variableValue) {
          return null;
        }
        return jsx(SelectMenuItem, {
          dense: true,
          "data-cy": "select_" + variableValue.label,
          value: valueId,
          variable: variable,
          variableValue: variableValue,
          templateOptions: templateOptions,
          infoIconButtons: jsx(InfoSelectionIcon, {
            variable: variable,
            value: variableValue
          })
        });
      }
    },
    children: values.map(value => jsx(SelectMenuItem, {
      "data-cy": "selection_" + value.label,
      value: value.id,
      variable: variable,
      variableValue: value,
      templateOptions: getTemplateOptions(variable),
      infoIconButtons: jsxs(Fragment, {
        children: [jsx(InfoSelectionIcon, {
          variable: variable,
          value: value
        }), jsx(InvalidSelectionWarning, {
          valueId: value == null ? void 0 : value.id
        })]
      })
    }, value.id))
  });
};
const Select = flow(WithHideDisableTemplateOptions, withComponentExtension("select"))(SelectComponent);

const SwitchTmp = ({
  variable,
  value,
  values,
  onChange,
  disabled
}) => {
  const {
    checked,
    onBooleanChange
  } = useBooleanChangeHandler(onChange, value, variable, values);
  const description = typeof value === "object" ? value.label : value;
  return jsxs(Fragment, {
    children: [jsx(VariableLabel, {
      fullWidth: true,
      variable: variable
    }), jsx(OCSwitch, {
      "data-cy": `ocswitch-${variable == null ? void 0 : variable.label}`,
      description: jsx(Fragment, {
        children: description
      }),
      checked: checked,
      onChange: onBooleanChange,
      SwitchProps: {
        disabled,
        "data-cy": `switch-${variable == null ? void 0 : variable.id}`
      }
    })]
  });
};
const Switch = flow(WithHideDisableTemplateOptions, withComponentExtension("switch"))(SwitchTmp);

const SwitchCardTmp = ({
  variable,
  value,
  values,
  onChange
}) => {
  const {
    checked,
    onBooleanChange
  } = useBooleanChangeHandler(onChange, value, variable, values);
  useTypedSelector(selectShowEditorUi);
  useTypedSelector(selectIsAdminPanel);
  return jsxs(Fragment, {
    children: [jsx(VariableLabel, {
      fullWidth: true,
      variable: variable
    }), jsx(ToggleButton, {
      "data-cy": `toggle`,
      fullWidth: true,
      color: "primary",
      value: value == null ? void 0 : value.id,
      selected: checked,
      onChange: () => {
        onBooleanChange(!checked);
      },
      sx: {
        border: "1px solid #0000001f !important",
        borderRadius: "8px  !important",
        justifyContent: "flex-start",
        textAlign: "left"
      },
      children: jsx(Box, {
        component: "div",
        sx: {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between"
        },
        children: jsx(ValueDetails, {
          value: value == null ? void 0 : value.id,
          variable: variable,
          variableValue: Object.assign({}, value, {
            label: value == null ? void 0 : value.label
          }),
          templateOptions: getTemplateOptions(variable),
          infoIconButtons: jsxs(Fragment, {
            children: [jsx(InfoSelectionIcon, {
              variable: variable,
              value: value
            }), jsx(InvalidSelectionWarning, {
              valueId: value == null ? void 0 : value.id
            })]
          })
        }, value == null ? void 0 : value.id)
      })
    }, value == null ? void 0 : value.id)]
  });
};
const SwitchCard = flow(WithHideDisableTemplateOptions, withComponentExtension("switchCard"))(SwitchCardTmp);

const InternalText = function InternalText(variableComponentProps) {
  const {
    variable
  } = variableComponentProps;
  const {
    text,
    onChange
  } = useTextChangeHandler(variableComponentProps);
  return jsx(OCTextInput, {
    "data-cy": `text-${variable == null ? void 0 : variable.label}`,
    label: jsx(VariableLabel, {
      variable: variable
    }),
    fullWidth: true,
    value: text,
    onChange: onChange
  });
};
const Text = withEditorHideDisableTemplateOptions(InternalText);

const TextAreaTmp = variableComponentProps => {
  const {
    variable
  } = variableComponentProps;
  const {
    text,
    onChange
  } = useTextChangeHandler(variableComponentProps);
  return jsx(OCTextInput, {
    "data-cy": `textArea-${variable == null ? void 0 : variable.label}`,
    label: jsx(VariableLabel, {
      variable: variable
    }),
    fullWidth: true,
    multiline: true,
    TextFieldProps: {
      minRows: 2,
      maxRows: 8
    },
    value: text,
    onChange: onChange
  });
};
const TextArea = withComponentExtension("textArea")(TextAreaTmp);

const TemplateComponentsByType = {
  [VariableTemplateType.Checkbox]: Checkbox,
  [VariableTemplateType.Hidden]: Hidden,
  [VariableTemplateType.Radio]: Radio,
  [VariableTemplateType.RadioCard]: RadioCard,
  [VariableTemplateType.Select]: Select,
  [VariableTemplateType.Text]: Text,
  [VariableTemplateType.Textarea]: TextArea,
  [VariableTemplateType.Number]: Number$1,
  [VariableTemplateType.Switch]: Switch,
  [VariableTemplateType.SwitchCard]: SwitchCard,
  [VariableTemplateType.ColorSelect]: ColorSelect,
  [VariableTemplateType.ColorDropdown]: Select,
  [VariableTemplateType.ColorRadio]: Radio,
  [VariableTemplateType.RALColorSelect]: RALColorSelect,
  [VariableTemplateType.ImageUpload]: ImageUpload,
  [VariableTemplateType.ComponentList]: ComponentList,
  [VariableTemplateType.ComponentListPopup]: ComponentListPopup
};

const useHandleChange = () => {
  const dispatch = useTypedDispatch();
  return useCallback(variable => (value, data) => dispatch(changeVariableThunk(value, variable.id, data)), [dispatch]);
};

const VariableTemplateWrapper = ({
  variable,
  handleChange,
  withPaperWrapper
}) => {
  var _variable$settings2, _variable$settings2$t;
  const location = useLocation();
  const isEditor = useTypedSelector(selectShowEditorUi);
  const variableIsHiddenToRuntime = useTypedSelector(selectIsVariableHiddenBecause(variable));
  const dispatch = useTypedDispatch();
  const handleFocus = useCallback(() => {
    dispatch(driveToCam({
      type: "variable",
      id: variable.id
    }));
  }, [dispatch, variable == null ? void 0 : variable.id]);
  const ref = useRef(null);
  // add listeners for when the variable is scrolled into view
  useEffect(() => {
    var _variable$settings, _variable$settings$te;
    let observer;
    if (variable != null && (_variable$settings = variable.settings) != null && (_variable$settings$te = _variable$settings.templateOptions) != null && _variable$settings$te.focusOnScroll) {
      const element = ref.current;
      if (element) {
        observer = new IntersectionObserver(entries => {
          if (entries[0].isIntersecting) {
            handleFocus();
          }
        }, {
          threshold: [0.5]
        });
        observer.observe(element);
      }
    }
    //cleanup observer
    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [handleFocus, ref, variable == null ? void 0 : (_variable$settings2 = variable.settings) == null ? void 0 : (_variable$settings2$t = _variable$settings2.templateOptions) == null ? void 0 : _variable$settings2$t.focusOnScroll]);
  const componentProps = useComponentProps(variable);
  const TemplateComponent = useMemo(() => withEditorHideDisableTemplateOptions(TemplateComponentsByType[getTemplate(variable)]), [variable]);
  // When a variable is "hidden" it can still appear in admin-panel
  // In frontend this variable should really be hidden!
  if (!isEditor && variableIsHiddenToRuntime) {
    return null;
  }
  if (withPaperWrapper) {
    return jsx(Paper, {
      ref: ref,
      className: variable.key || undefined,
      onFocus: handleFocus,
      id: "variableContainer_" + variable.id,
      "data-cy": "variableContainer_" + variable.label,
      elevation: location != null && location.pathname.includes(`variables/${variable.id}`) ? 4 : 0,
      sx: {
        pt: 0,
        pb: 2,
        pl: 2,
        pr: 2,
        transition: "all 0.3s"
      },
      children: jsx(TemplateComponent, Object.assign({
        onChange: handleChange(variable)
      }, componentProps), variable.id)
    }, variable.id);
  } else {
    return jsx(TemplateComponent, Object.assign({
      onChange: handleChange(variable)
    }, componentProps), variable.id);
  }
};
/** Render a single variable.
 * Pass the variables key as required prop.
 * Normally only renders the variable if it matches the current group.
 * If you always want to render it, set `renderDespiteCurrentGroup` to true.
 * */
const StandaloneVariable = props => {
  const handleChange = useHandleChange();
  const variable = useTypedSelector(selectVariableByKey(props.variableKey));
  const group = useTypedSelector(selectCurrentGroup);
  if (!variable) {
    console.error(`No variable with key ${props.variableKey} found`, props);
    return null;
  }
  if (!props.sticky && variable.groupId !== (group == null ? void 0 : group.id)) {
    return null;
  }
  return jsx(VariableTemplateWrapper, {
    variable: variable,
    handleChange: handleChange,
    withPaperWrapper: props.withPaperWrapper
  });
};
const useComponentProps = variable => {
  const onlyValidOptions = useTypedSelector(selectOnlyValidOptions(getTemplateOptions(variable)));
  const info = useTypedSelector(selectRuleEngineInfo);
  return useMemo(() => {
    var _ruleEngineState$stat, _ruleEngineState$stat2;
    const {
      ruleEngineState,
      ruleEngineInput,
      openInstance
    } = info;
    const selection = ruleEngineState == null ? void 0 : ruleEngineState.state.all.selections.find(s => s.variableId === variable.id && s.instance.id === openInstance.id);
    const validOptions = (ruleEngineState == null ? void 0 : (_ruleEngineState$stat = ruleEngineState.state.all.validOptions[openInstance.id]) == null ? void 0 : _ruleEngineState$stat[variable.id]) || [];
    const invalidOptions = (ruleEngineState == null ? void 0 : (_ruleEngineState$stat2 = ruleEngineState.state.all.invalidOptions[openInstance.id]) == null ? void 0 : _ruleEngineState$stat2[variable.id]) || [];
    const hiddenValues = ruleEngineInput == null ? void 0 : ruleEngineInput.hiddenValuesMap[openInstance.id];
    const values = ((ruleEngineInput == null ? void 0 : ruleEngineInput.values.byVarId.all[variable.id]) || []).filter(value => !(hiddenValues != null && hiddenValues[value.id])).filter(onlyValidOptions).sort(byOrder);
    const value = values.find(v => v.id === (selection == null ? void 0 : selection.valueId));
    return {
      selection,
      validOptions,
      invalidOptions,
      value,
      variable,
      values
    };
  }, [info, variable, onlyValidOptions]);
};

const useVariableIsInstanceCount = () => {
  const countVariable = useTypedSelector(selectVariableByKey("k3_cart_count"));
  return variableId => variableId == (countVariable == null ? void 0 : countVariable.parentId);
};
const useInstanceCountVariableChangeHandler = instanceId => {
  const dispatch = useTypedDispatch();
  const globalCartCountVariable = useTypedSelector(selectVariableByKey("k3_cart_count"));
  const selection = useTypedSelector(selectSelectionByVariableIdAndInstanceId(globalCartCountVariable.id, instanceId));
  const localCartCountVariable = useTypedSelector(selectVariableById(selection.variableId));
  const values = useComponentProps(localCartCountVariable);
  return useNumberVariableChangeHandler((value, data) => dispatch(changeVariableThunk(value, localCartCountVariable.id, data, selection)), selection, localCartCountVariable, values.values);
};

const InstanceCountInput = ({
  instanceId,
  variable
}) => {
  const countVariableChangeHandler = useInstanceCountVariableChangeHandler(instanceId);
  if (!countVariableChangeHandler) return null;
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    jsx("div", {
      onClick: event => event.stopPropagation(),
      onMouseDown: event => event.stopPropagation(),
      style: {
        width: "120px",
        marginRight: "10px"
      },
      children: jsx(NumberWarningTooltip, {
        placement: "top",
        isInRange: countVariableChangeHandler.isInRange,
        resetNumber: countVariableChangeHandler.resetNumber,
        variable: variable,
        children: jsx(OCNumberInput, {
          buttons: true,
          "data-cy": "count",
          onChange: countVariableChangeHandler.onNumberChange,
          onChangeByStep: countVariableChangeHandler.onInputBlur,
          onBlur: countVariableChangeHandler.onInputBlur,
          value: countVariableChangeHandler.pureNumber,
          TextFieldProps: {
            error: !countVariableChangeHandler.isInRange
          }
        })
      })
    })
  );
};

const useIsMobile = () => {
  const editorDevice = useTypedSelector(selectPreviewDevice);
  const matchesSmartphone = useMediaQuery("(min-width: 0) and (max-width: 480px)");
  return useMemo(() => editorDevice === "phone" || matchesSmartphone, [editorDevice, matchesSmartphone]);
};

const MobileVariableRow = ({
  row,
  hasCVariables: _hasCVariables = false,
  onClose,
  onShowPriceInfo,
  position,
  open,
  setOpen,
  hideArticles
}) => {
  var _row$group, _row$subVariables, _row$variable;
  const {
    t
  } = useTranslation();
  const priceFormatter = useTypedSelector(selectPriceFormatter);
  return jsxs(Stack, {
    children: [row.index == 0 && jsxs(Fragment, {
      children: [position !== "first" && jsx(Divider, {
        sx: {
          my: 1
        }
      }), jsx(Typography, {
        variant: "h6",
        children: (_row$group = row.group) == null ? void 0 : _row$group.label
      })]
    }), jsxs(Stack, {
      sx: {
        display: "flex",
        flexDirection: "row",
        pt: 1
      },
      children: [_hasCVariables && jsxs(Stack, {
        sx: {
          width: "24px"
        },
        children: [!!((_row$subVariables = row.subVariables) != null && _row$subVariables.length) && jsx(IconButton, {
          "data-cy": `priceSmh`,
          size: "small",
          sx: {
            p: 0
          },
          onClick: () => setOpen(!open),
          children: open ? jsx(KeyboardArrowUpIcon, {}) : jsx(KeyboardArrowDownIcon, {})
        }), open && jsx(Stack, {
          sx: {
            display: "flex",
            flexGrow: 1,
            borderRight: "1px solid rgba(0, 0, 0, 0.54)",
            mr: 1.5
          }
        })]
      }), jsxs(Stack, {
        sx: {
          display: "flex",
          flexDirection: "column"
        },
        children: [jsx(Typography, {
          variant: "body1",
          children: row.variable.label
        }), jsxs(Stack, {
          sx: {
            display: "flex",
            flexDirection: "row"
          },
          children: [jsx(Typography, {
            variant: "body2",
            children: row.selectionLabel
          }), row.bom.priceTotal > 0 && !hideArticles && jsxs(Typography, {
            variant: "body2",
            children: [", ", t("Preis: "), "(", priceFormatter.format(row.bom.priceTotal), ")", jsx(IconButton, {
              size: "small",
              onClick: onShowPriceInfo,
              sx: {
                p: 0,
                ml: 1
              },
              "data-cy": `info-${(_row$variable = row.variable) == null ? void 0 : _row$variable.id}`,
              children: jsx(InfoOutlined, {
                fontSize: "inherit"
              })
            })]
          })]
        }), jsx(Collapse, {
          in: open,
          timeout: "auto",
          unmountOnExit: true,
          children: jsx(PriceTable$1, {
            dense: false,
            rows: row.subVariables,
            onClose: onClose,
            onShowPriceInfo: onShowPriceInfo,
            hideArticles: hideArticles
          })
        })]
      })]
    })]
  });
};
const VariableRow = props => {
  var _row$group2, _row$subVariables2, _row$variable2, _row$variable3;
  const isMobile = useIsMobile();
  const {
    row,
    showPrice = true,
    hasCVariables = false,
    onClose,
    onShowPriceInfo,
    rowCount,
    hideArticles
  } = props;
  const [open, setOpen] = React__default.useState(false);
  const priceFormatter = useTypedSelector(selectPriceFormatter);
  const dispatch = useTypedDispatch();
  const isControlledByRules = useTypedSelector(isControlledByInstanceActions(row.variable.id));
  const isCountVariable = useVariableIsInstanceCount();
  const parentSelection = useTypedSelector(selectParentSelections(row.selection)).find(s => s.id !== row.selection.instance.belongsToInstanceId);
  const setGroup = () => {
    parentSelection && dispatch(setOpenInstance(parentSelection));
    dispatch(setFocusGroupId(row.group.id));
    onClose();
  };
  const deleteInstance = useSafeDeleteInstance();
  if (isMobile) {
    return jsx(MobileVariableRow, Object.assign({}, props, {
      open: open,
      setOpen: setOpen
    }));
  }
  return jsxs(Fragment, {
    children: [jsxs(TableRow$1, {
      sx: {
        "&:last-child td, &:last-child th": {
          border: 0
        }
      },
      children: [jsx(TableCell$1, {
        children: row.index == 0 && ((_row$group2 = row.group) == null ? void 0 : _row$group2.label)
      }), hasCVariables && jsx(TableCell$1, {
        children: !!((_row$subVariables2 = row.subVariables) != null && _row$subVariables2.length) && jsx(IconButton, {
          "data-cy": `priceSmh`,
          "aria-label": "expand row",
          size: "small",
          onClick: () => setOpen(!open),
          children: open ? jsx(KeyboardArrowUpIcon, {}) : jsx(KeyboardArrowDownIcon, {})
        })
      }), jsx(TableCell$1, {
        component: "th",
        scope: "row",
        children: row.variable.label
      }), jsx(TableCell$1, {
        children: row.selectionLabel
      }), showPrice && jsx(TableCell$1, {
        align: "right",
        children: row.bom.priceTotal > 0 && priceFormatter.format(row.bom.priceTotal)
      }), jsx(TableCell$1, {
        align: "right",
        width: "60px",
        children: jsxs("div", {
          style: {
            display: "flex",
            flexDirection: "row"
          },
          children: [isCountVariable(row.selection.variableId) && !!row.selection.id && jsx(InstanceCountInput, {
            instanceId: row.selection.id,
            variable: props.variable
          }), rowCount > 1 && row.variable.type === "components" && !isControlledByRules && jsx(IconButton, {
            size: "small",
            onClick: () => deleteInstance(row.selection),
            "data-cy": `deleteInstances`,
            children: jsx(Delete, {
              fontSize: "inherit"
            })
          }), row.variable.type !== "components" && jsx(IconButton, {
            size: "small",
            onClick: setGroup,
            "data-cy": `edit-${(_row$variable2 = row.variable) == null ? void 0 : _row$variable2.id}`,
            children: jsx(Edit$4, {
              fontSize: "inherit"
            })
          }), row.bom.priceTotal > 0 && !hideArticles && jsx(IconButton, {
            size: "small",
            onClick: onShowPriceInfo,
            "data-cy": `info-${(_row$variable3 = row.variable) == null ? void 0 : _row$variable3.id}`,
            children: jsx(InfoOutlined, {
              fontSize: "inherit"
            })
          })]
        })
      })]
    }), jsx(TableRow$1, {
      children: jsx(TableCell$1, {
        style: {
          paddingBottom: 0,
          paddingTop: 0
        },
        colSpan: 6,
        children: jsx(Collapse, {
          in: open,
          timeout: "auto",
          unmountOnExit: true,
          children: jsx(PriceTable$1, {
            dense: false,
            rows: row.subVariables,
            onClose: onClose,
            onShowPriceInfo: onShowPriceInfo,
            hideArticles: hideArticles
          })
        })
      })
    })]
  });
};
const PriceTableChoiceInner = ({
  dense,
  onShowPriceInfo,
  onClose,
  hideArticles
}) => {
  const displayedRows = useTypedSelector(selectVisibleRows);
  return jsx(PriceTable$1, {
    dense: dense,
    rows: displayedRows,
    onClose: onClose,
    onShowPriceInfo: onShowPriceInfo,
    hideArticles: hideArticles
  });
};
function PriceTable$1({
  dense,
  rows,
  onClose,
  onShowPriceInfo,
  hideArticles
}) {
  useTranslation();
  const hasCVariables = useTypedSelector(hasComponentVariables);
  const showPrice = useTypedSelector(selectFrontendAppShowPrice);
  const dynamicTranslation = useDynamicTranslation();
  const isMobile = useIsMobile();
  const getPosition = i => {
    if (!i) return "first";
    if (i === rows.length - 1) return "last";
    return "mid";
  };
  if (isMobile) {
    return jsx(Stack, {
      children: rows.map((row, index) => jsx(VariableRow, {
        hasCVariables: hasCVariables,
        showPrice: showPrice,
        row: row,
        onClose: onClose,
        onShowPriceInfo: () => onShowPriceInfo(row.bom),
        position: getPosition(index),
        rowCount: rows.length,
        hideArticles: hideArticles,
        variable: row.variable
      }, row.selection.id))
    });
  }
  return jsx(PriceTableContainer, {
    children: jsx(TableContainer, {
      component: Paper$1,
      children: jsxs(Table$1, {
        sx: dense ? {
          width: 1
        } : {
          minWidth: 400
        },
        size: dense ? "small" : "medium",
        children: [jsx(TableHead, {
          children: jsxs(TableRow$1, {
            children: [jsx(TableCell$1, {
              align: "left",
              children: dynamicTranslation(DynamicSettingsKeys.ORDER_DIALOG_OVERVIEW_STEP)
            }), hasCVariables && jsx(TableCell$1, {}), jsx(TableCell$1, {
              align: "left",
              children: dynamicTranslation(DynamicSettingsKeys.ORDER_DIALOG_OVERVIEW_VARIABLE)
            }), jsx(TableCell$1, {
              align: "left",
              children: dynamicTranslation(DynamicSettingsKeys.ORDER_DIALOG_OVERVIEW_SELECTION)
            }), showPrice && jsx(TableCell$1, {
              align: "right",
              children: dynamicTranslation(DynamicSettingsKeys.ORDER_DIALOG_OVERVIEW_PRICE)
            }), jsx(TableCell$1, {
              align: "right"
            })]
          })
        }), jsx(TableBody$1, {
          children: rows.map((row, index) => jsx(VariableRow, {
            hasCVariables: hasCVariables,
            showPrice: showPrice,
            row: row,
            onClose: onClose,
            onShowPriceInfo: () => onShowPriceInfo(row.bom),
            position: getPosition(index),
            rowCount: rows.length,
            hideArticles: hideArticles,
            variable: row.variable
          }, row.selection.id))
        })]
      })
    })
  });
}
const PriceTableChoice = withExtensions({
  app: {
    orderDialog: {
      priceTable: {
        selectionList: {
          root: true
        }
      }
    }
  }
})(PriceTableChoiceInner);

const PriceTableTotalInner = ({
  dense,
  onShowPriceInfo,
  hideArticles
}) => {
  const dynamicTranslation = useDynamicTranslation();
  const overallPrice = useTypedSelector(selectOverallFormattedPrice);
  return jsx(PriceTableContainer, {
    children: jsx(TableContainer, {
      component: Paper$1,
      children: jsx(Table$1, {
        sx: dense ? {
          width: 1
        } : {
          minWidth: 400
        },
        size: dense ? "small" : "medium",
        children: jsx(TableBody$1, {
          children: jsxs(TableRow$1, {
            sx: {
              padding: 0
            },
            children: [jsx(TableCell$1, {
              align: "left",
              sx: {
                fontWeight: "600"
              },
              children: dynamicTranslation(DynamicSettingsKeys.ORDER_DIALOG_OVERVIEW_TOTALPRICE)
            }), jsx(TableCell$1, {
              align: "right",
              children: overallPrice
            }), jsx(TableCell$1, {
              align: "right",
              width: "60px",
              children: !hideArticles && jsx(IconButton, {
                size: "small",
                "data-cy": `infoPrice`,
                onClick: onShowPriceInfo,
                children: jsx(InfoOutlined, {
                  fontSize: "inherit"
                })
              })
            })]
          }, "overall-price")
        })
      })
    })
  });
};
const PriceTableTotal = withExtensions({
  app: {
    orderDialog: {
      priceTable: {
        total: {
          root: true
        }
      }
    }
  }
})(PriceTableTotalInner);

function PriceTableTmp({
  dense = false,
  onClose,
  action
}) {
  const bom = useTypedSelector(selectAllArticlesAndPrices);
  const showPrice = useTypedSelector(selectFrontendAppShowPrice);
  const [priceInfo, setPriceInfo] = useState(null);
  const {
    t
  } = useTranslation();
  const dynamicTranslation = useDynamicTranslation();
  if (action.overviewType === "articlesOnly") {
    return jsx(Box, {
      component: "div",
      className: "orderDialogArticleTable",
      children: jsx(PriceTableArticle, {
        showPrice: true,
        bom: bom,
        dense: false
      })
    });
  } else {
    return jsxs(Box, {
      component: "div",
      className: "orderDialogPriceTable",
      children: [jsx(Typography, {
        color: "primary",
        variant: "h6",
        children: showPrice ? dynamicTranslation(DynamicSettingsKeys.ORDER_DIALOG_OVERVIEW_SELECTIONPRICE) : t("Auswahlen")
      }), jsx(PriceTableChoice, {
        dense: dense,
        onShowPriceInfo: setPriceInfo,
        onClose: onClose,
        hideArticles: action.overviewType === "variablesOnly"
      }), showPrice && jsx(PriceTableTotal, {
        dense: dense,
        onShowPriceInfo: () => setPriceInfo(bom),
        hideArticles: action.overviewType === "variablesOnly"
      }), jsx(PriceInfoDialog, {
        bom: priceInfo,
        showPrice: showPrice,
        onClose: () => setPriceInfo(null)
      })]
    });
  }
}
const PriceTable = withExtensions({
  app: {
    orderDialog: {
      priceTable: {
        root: true
      }
    }
  }
})(PriceTableTmp);

const selectPrivateData = state => state.order.privateData;
const selectPrivateDataText = state => state.order.privateDataText;

const PrivateDataCheckboxLabel = ({
  action
}) => {
  var _searchLink;
  const privateDataText = useTypedSelector(selectPrivateDataText);
  const searchLink = () => {
    var _action$formular;
    let dataPrivacy = action == null ? void 0 : (_action$formular = action.formular) == null ? void 0 : _action$formular.dataPrivacy;
    if (!dataPrivacy) return null;
    dataPrivacy = dataPrivacy.replace("<a", '<a style="text-decoration: underline"');
    return parse(dataPrivacy);
  };
  searchLink();
  return jsx(Box$2, {
    component: "div",
    display: "flex",
    width: 1,
    children: jsx(Typography, {
      children: (_searchLink = searchLink()) != null ? _searchLink : privateDataText
    })
  });
};

const error = {
  nameNumber: "Namen dürfen keine Zahlen enthalten",
  nameRequired: "Bitte geben Sie Ihren Namen ein",
  emailValid: "Bitte geben Sie eine korrekte E-Mail ein",
  emailRequired: "Bitte geben Sie Ihre E-Mail ein",
  addressRequired: "Bitte geben Sie Ihre Adresse ein",
  cityRequired: "Bitte geben Sie den Namen Ihrer Stadt ein",
  zipRequired: "Bitte geben Sie Ihre Postleitzahl an",
  zipError: "Eine Postleitzahl darf nur aus 4 oder 5 Ziffern bestehen",
  taxIDRequired: "Bitte geben Sie Ihre UST-ID ein",
  companyRequired: "Bitte geben Sie Ihren Firmennamen an",
  cityError: "Geben Sie bitte einen gültigen Städtenamen an"
};
const schemaobject = {
  name: yup.string().matches(/^([^0-9]*)$/, error.nameNumber).required(error.nameRequired),
  email: yup.string().email(error.emailValid).required(error.emailRequired),
  address: yup.string().required(error.addressRequired),
  city: yup.string().matches(/^([a-zA-Z\u0080-\u024F]+(?:. |-| |'))*[a-zA-Z\u0080-\u024F]*$/, error.cityError).required(error.cityRequired),
  zip: yup.string().matches(/^\d{4,5}$/, error.zipError).required(error.zipRequired),
  remark: yup.string(),
  taxID: yup.string().required(error.taxIDRequired),
  company: yup.string().required(error.companyRequired)
};
const schema = yup.object().shape(schemaobject);

const initialState$1 = {
  privateData: {
    name: "",
    email: "",
    phone: "",
    address: "",
    remark: "",
    company: "",
    taxID: "",
    checkbox: false,
    city: "",
    zip: ""
  },
  privateDataText: "Die Datenschutzhinweise habe ich zur Kenntnis genommen und akzeptiere sie."
};
const orderSlice = createSlice({
  name: "order",
  initialState: initialState$1,
  reducers: {
    updatePrivateData: (state, action) => {
      state.privateData = action.payload;
    }
  }
});
const {
  updatePrivateData
} = orderSlice.actions;
const orderReducer = orderSlice.reducer;

const updatePrivateDataObjectThunk = object => (dispatch, getState) => {
  const privateData = selectPrivateData(getState());
  dispatch(updatePrivateData(Object.assign({}, privateData, object)));
};

const IContactFields = ({
  action,
  handleChange,
  errors,
  register,
  getHelperText,
  privateData
}) => {
  if (!action || !action.formular) return null;
  const {
    name,
    sendCustomerEmail,
    phone,
    address,
    remark,
    company,
    taxID,
    optionalFields
  } = action.formular;
  const getRequiredLabel = (label, field) => {
    return isRequired(field) ? `${label}*` : label;
  };
  const isRequired = field => {
    return !(optionalFields != null && optionalFields[field]);
  };
  return jsxs(Fragment, {
    children: [name && jsx(OCTextInput, {
      "data-cy": `name`,
      value: privateData.name,
      label: getRequiredLabel("Name", "name"),
      debounced: true,
      required: isRequired("name"),
      autoFocus: true,
      TextFieldProps: Object.assign({
        error: isRequired("name") && !!errors.name,
        helperText: getHelperText("name"),
        sx: {
          marginBottom: 0.5
        }
      }, register("name")),
      onChange: handleChange("name")
    }), sendCustomerEmail && jsx(OCTextInput, {
      "data-cy": `email`,
      value: privateData.email,
      label: getRequiredLabel("E-Mail", "sendCustomerEmail"),
      debounced: true,
      autoComplete: "email",
      required: isRequired("sendCustomerEmail"),
      TextFieldProps: Object.assign({
        type: "email",
        error: isRequired("sendCustomerEmail") && !!errors.email,
        helperText: getHelperText("email"),
        sx: {
          marginBottom: 0.5
        }
      }, register("email")),
      onChange: handleChange("email")
    }), phone && jsx(OCTextInput, {
      value: privateData.phone,
      "data-cy": "Telefon*",
      label: getRequiredLabel("Telefon", "phone"),
      debounced: true,
      required: isRequired("phone"),
      TextFieldProps: Object.assign({
        error: isRequired("phone") && !!errors.phone,
        helperText: getHelperText("phone"),
        sx: {
          marginBottom: 0.5
        }
      }, register("phone")),
      onChange: handleChange("phone")
    }), address && jsx(OCTextInput, {
      value: privateData.address,
      "data-cy": "Straße",
      label: getRequiredLabel("Straße und Hausnummer", "address"),
      debounced: true,
      required: isRequired("address"),
      TextFieldProps: Object.assign({
        error: !!errors.address,
        helperText: getHelperText("address"),
        sx: {
          marginBottom: 0.5
        }
      }, register("address")),
      onChange: handleChange("address")
    }), address && jsx(OCTextInput, {
      value: privateData.zip,
      "data-cy": "PLZ*",
      label: getRequiredLabel("PLZ", "address"),
      debounced: true,
      required: isRequired("address"),
      TextFieldProps: Object.assign({
        error: isRequired("address") && !!errors.zip,
        helperText: getHelperText("zip"),
        sx: {
          marginBottom: 0.5
        }
      }, register("zip")),
      onChange: handleChange("zip")
    }), address && jsx(OCTextInput, {
      value: privateData.city,
      "data-cy": "Stadt*",
      label: getRequiredLabel("Stadt", "address"),
      debounced: true,
      required: isRequired("address"),
      TextFieldProps: Object.assign({
        error: isRequired("address") && !!errors.city,
        helperText: getHelperText("city"),
        sx: {
          marginBottom: 0.5
        }
      }, register("city")),
      onChange: handleChange("city")
    }), remark && jsx(OCTextInput, {
      value: privateData.remark,
      "data-cy": "Bemerkung",
      label: getRequiredLabel("Bemerkung", "remark"),
      debounced: true,
      multiline: true,
      required: isRequired("remark"),
      TextFieldProps: Object.assign({
        error: isRequired("remark") && !!errors.remark,
        helperText: getHelperText("remark"),
        sx: {
          marginBottom: 0.5
        }
      }, register("remark")),
      onChange: handleChange("remark")
    }), company && jsx(OCTextInput, {
      value: privateData.company,
      "data-cy": "Firma*",
      label: getRequiredLabel("Firma", "company"),
      debounced: true,
      required: isRequired("company"),
      TextFieldProps: Object.assign({
        error: isRequired("company") && !!errors.company,
        helperText: getHelperText("company"),
        sx: {
          marginBottom: 0.5
        }
      }, register("company")),
      onChange: handleChange("company")
    }), taxID && jsx(OCTextInput, {
      value: privateData.taxID,
      "data-cy": "UST",
      label: getRequiredLabel("UST-ID", "taxID"),
      debounced: true,
      required: isRequired("taxID"),
      TextFieldProps: Object.assign({
        error: isRequired("taxID") && !!errors.taxID,
        helperText: getHelperText("taxID"),
        sx: {
          marginBottom: 0.5
        }
      }, register("taxID")),
      onChange: handleChange("taxID")
    })]
  });
};
const ContactFields = withExtensions({
  app: {
    orderDialog: {
      contact: {
        fields: {
          root: true
        }
      }
    }
  }
})(IContactFields);
const PrivateData = ({
  action
}) => {
  var _privateData$checkbox;
  const dispatch = useTypedDispatch();
  const privateData = useTypedSelector(selectPrivateData);
  const handleChange = key => value => {
    dispatch(updatePrivateDataObjectThunk({
      [key]: value
    }));
  };
  const {
    register,
    formState: {
      errors
    }
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(schema)
  });
  const getHelperText = field => {
    var _errors$field, _errors$field2;
    return typeof (errors == null ? void 0 : (_errors$field = errors[field]) == null ? void 0 : _errors$field.message) === "string" ? errors == null ? void 0 : (_errors$field2 = errors[field]) == null ? void 0 : _errors$field2.message : "";
  };
  return jsxs(Box$2, {
    component: "div",
    display: "flex",
    flexDirection: "column",
    className: "orderDialogPrivateData",
    children: [jsx(ContactFields, Object.assign({}, {
      action,
      handleChange,
      errors,
      getHelperText,
      register,
      privateData
    })), jsx(Box$2, {
      component: "div",
      display: "flex",
      sx: {
        alignItems: "center"
      },
      children: jsx(OCCheckbox, {
        "data-cy": `privData`,
        label: jsx(PrivateDataCheckboxLabel, {
          action: action
        }),
        checked: (_privateData$checkbox = privateData.checkbox) != null ? _privateData$checkbox : false,
        onChange: handleChange("checkbox")
      })
    })]
  });
};

const OrderDialogBody = ({
  action,
  step,
  result,
  onClose
}) => {
  const {
    t
  } = useTranslation();
  const variable = useStartInstance();
  const addInstanceToVariable = useAddInstanceToVariable(variable);
  const [newItem, setNewItem] = useState(undefined);
  return jsxs(DialogContent$1, {
    className: "orderDialogContent",
    sx: {
      height: 615,
      zIndex: "tooltip"
    },
    children: [step === "overview" && jsxs(Fragment, {
      children: [jsx(PriceTable, {
        dense: true,
        onClose: onClose,
        action: action
      }), variable && jsxs(Box, {
        component: "div",
        sx: {
          width: "500px",
          display: "flex",
          float: "right",
          gap: "8px"
        },
        children: [jsx(AddItemsDropdown, {
          label: t("Neues Produkt auswählen"),
          variable: variable,
          onSelected: setNewItem,
          value: newItem
        }), jsx(Button, {
          "data-cy": `addNewProduct`,
          variant: "contained",
          disabled: !newItem,
          onClick: () => {
            if (!newItem) return;
            addInstanceToVariable(newItem);
            setNewItem(undefined);
          },
          children: t("Neues Produkt hinzufügen")
        })]
      })]
    }), step === "contact" && jsx(PrivateData, {
      action: action
    }), step === "confirmation" && result && jsx(OrderConfirmation, {
      action: action,
      result: result
    })]
  });
};

const _excluded$d = ["checkbox"];
const steps = ["overview", "contact", "confirmation"];
class DialogHelper {}
DialogHelper.proceedDisabled = (actions, privateData, step) => {
  const {
      checkbox: checkboxOrder
    } = privateData,
    formular = _objectWithoutPropertiesLoose(privateData, _excluded$d);
  const hasFormular = !!(actions != null && actions.formular);
  return (!checkboxOrder || !DialogHelper.inputsVerify(actions, formular)) && step === "contact" && hasFormular;
};
DialogHelper.stepTriggersSave = (action, step) => {
  const available = DialogHelper.availableSteps(action);
  return available.length - available.indexOf(step) === 2;
};
DialogHelper.buttonBack = (action, step) => {
  const stepIndex = DialogHelper.availableSteps(action).indexOf(step);
  return stepIndex === 0 ? "Abbrechen" : "Zurück";
};
DialogHelper.forwardButton = (action, step) => {
  if (DialogHelper.stepTriggersSave(action, step)) return action == null ? void 0 : action.label;
  if (step === "confirmation") return {
    de: `Schliessen`
  };
  return {
    de: `Weiter`
  };
};
DialogHelper.stepTitleKeys = [DynamicSettingsKeys.ORDER_DIALOG_OVERVIEW, DynamicSettingsKeys.ORDER_DIALOG_DATA, DynamicSettingsKeys.ORDER_DIALOG_CONFIRMATION];
DialogHelper.titleKeyForStep = step => DialogHelper.stepTitleKeys[steps.indexOf(step)];
DialogHelper.keysForStep = step => {
  switch (step) {
    case "overview":
      return [DynamicSettingsKeys.ORDER_DIALOG_OVERVIEW, DynamicSettingsKeys.ORDER_DIALOG_OVERVIEW_SELECTIONPRICE, DynamicSettingsKeys.ORDER_DIALOG_OVERVIEW_STEP, DynamicSettingsKeys.ORDER_DIALOG_OVERVIEW_VARIABLE, DynamicSettingsKeys.ORDER_DIALOG_OVERVIEW_SELECTION, DynamicSettingsKeys.ORDER_DIALOG_OVERVIEW_TOTALPRICE, DynamicSettingsKeys.ORDER_DIALOG_OVERVIEW_PRICE, DynamicSettingsKeys.ORDER_DIALOG_OVERVIEW_PRICEINFO];
    case "contact":
      return [DynamicSettingsKeys.ORDER_DIALOG_DATA];
    case "confirmation":
      return [DynamicSettingsKeys.ORDER_DIALOG_CONFIRMATION];
    default:
      return [];
  }
};
DialogHelper.availableSteps = action => steps.filter(DialogHelper.isStepAvailable(action));
DialogHelper.handleStep = (action, step, direction) => {
  const available = DialogHelper.availableSteps(action);
  const index = steps.indexOf(step);
  return direction === "add" ? available[index + 1] : available[index - 1];
};
DialogHelper.isStepAvailable = action => step => {
  switch (step) {
    case "overview":
      return (action == null ? void 0 : action.overviewType) !== "noOverview";
    case "contact":
      return action == null ? void 0 : action.formular;
    default:
      return true;
  }
};
DialogHelper.customer = (action, privateData, privateDataText) => {
  var _action$formular, _action$formular$data, _action$formular2, _action$formular3, _action$formular4, _action$formular5, _action$formular6, _action$formular7, _action$formular8, _action$formular9, _action$formular10;
  return action != null && action.formular ? {
    address: action != null && (_action$formular = action.formular) != null && _action$formular.address ? privateData.address : null,
    dataPrivacy: (_action$formular$data = action == null ? void 0 : (_action$formular2 = action.formular) == null ? void 0 : _action$formular2.dataPrivacy) != null ? _action$formular$data : privateDataText,
    name: action != null && (_action$formular3 = action.formular) != null && _action$formular3.name ? privateData.name : null,
    email: action != null && (_action$formular4 = action.formular) != null && _action$formular4.sendCustomerEmail ? privateData.email : null,
    phone: action != null && (_action$formular5 = action.formular) != null && _action$formular5.phone ? privateData.phone : null,
    remark: action != null && (_action$formular6 = action.formular) != null && _action$formular6.remark ? privateData.remark : null,
    company: action != null && (_action$formular7 = action.formular) != null && _action$formular7.company ? privateData.company : null,
    taxID: action != null && (_action$formular8 = action.formular) != null && _action$formular8.taxID ? privateData.taxID : null,
    checkboxAccepted: privateData.checkbox,
    city: action != null && (_action$formular9 = action.formular) != null && _action$formular9.address ? privateData.city : null,
    zip: action != null && (_action$formular10 = action.formular) != null && _action$formular10.address ? privateData.zip : null
  } : null;
};
DialogHelper.inputsVerify = (actions, formular) => {
  var _actions$formular, _actions$formular2, _actions$formular2$op, _actions$formular3, _actions$formular4, _actions$formular4$op, _actions$formular5, _actions$formular6, _actions$formular6$op, _actions$formular7, _actions$formular8, _actions$formular8$op, _actions$formular9, _actions$formular10, _actions$formular10$o, _actions$formular11, _actions$formular12, _actions$formular12$o, _actions$formular13, _actions$formular14, _actions$formular14$o;
  const fieldsRequired = {
    name: (actions == null ? void 0 : (_actions$formular = actions.formular) == null ? void 0 : _actions$formular.name) && !(actions != null && (_actions$formular2 = actions.formular) != null && (_actions$formular2$op = _actions$formular2.optionalFields) != null && _actions$formular2$op.name),
    email: (actions == null ? void 0 : (_actions$formular3 = actions.formular) == null ? void 0 : _actions$formular3.sendCustomerEmail) && !(actions != null && (_actions$formular4 = actions.formular) != null && (_actions$formular4$op = _actions$formular4.optionalFields) != null && _actions$formular4$op.sendCustomerEmail),
    address: (actions == null ? void 0 : (_actions$formular5 = actions.formular) == null ? void 0 : _actions$formular5.address) && !(actions != null && (_actions$formular6 = actions.formular) != null && (_actions$formular6$op = _actions$formular6.optionalFields) != null && _actions$formular6$op.address),
    city: (actions == null ? void 0 : (_actions$formular7 = actions.formular) == null ? void 0 : _actions$formular7.address) && !(actions != null && (_actions$formular8 = actions.formular) != null && (_actions$formular8$op = _actions$formular8.optionalFields) != null && _actions$formular8$op.address),
    zip: (actions == null ? void 0 : (_actions$formular9 = actions.formular) == null ? void 0 : _actions$formular9.address) && !(actions != null && (_actions$formular10 = actions.formular) != null && (_actions$formular10$o = _actions$formular10.optionalFields) != null && _actions$formular10$o.address),
    taxID: (actions == null ? void 0 : (_actions$formular11 = actions.formular) == null ? void 0 : _actions$formular11.taxID) && !(actions != null && (_actions$formular12 = actions.formular) != null && (_actions$formular12$o = _actions$formular12.optionalFields) != null && _actions$formular12$o.taxID),
    company: (actions == null ? void 0 : (_actions$formular13 = actions.formular) == null ? void 0 : _actions$formular13.company) && !(actions != null && (_actions$formular14 = actions.formular) != null && (_actions$formular14$o = _actions$formular14.optionalFields) != null && _actions$formular14$o.company)
  };
  const validateObject = _$1.pick(schemaobject,
  // @ts-ignore
  Object.keys(fieldsRequired).filter(key => fieldsRequired[key] === true));
  const isValid = yup.object(validateObject).isValidSync(formular);
  return isValid;
};

const _excluded$c = ["checkbox"];
const OrderDialogFooter = ({
  step,
  action,
  onSave,
  onClose,
  onStep
}) => {
  const {
    t
  } = useTranslation();
  !!(action != null && action.formular);
  const privateData = useTypedSelector(selectPrivateData);
  const formular = _objectWithoutPropertiesLoose(privateData, _excluded$c);
  // Moves a step forward and completes the dialog
  const handleForward = () => {
    if (DialogHelper.stepTriggersSave(action, step) && DialogHelper.inputsVerify(action, formular)) {
      onSave();
      return;
    }
    if (step === "confirmation") {
      onClose();
      return;
    }
    onStep("add");
  };
  // Moves a step back and closes the dialog
  const handleBack = () => {
    if (DialogHelper.availableSteps(action)[0] === step) {
      onClose();
    } else {
      onStep("sub");
    }
  };
  const disabled = DialogHelper.proceedDisabled(action, privateData, step);
  const backButton = DialogHelper.buttonBack(action, step);
  const forwardButton = DialogHelper.forwardButton(action, step);
  return jsx(Box$2, {
    component: "div",
    px: 3,
    py: 2,
    className: "orderDialogFooter",
    children: jsxs(DialogActions$1, {
      children: [step !== "confirmation" && jsx(Button$1, {
        "data-cy": `orderDialogBack`,
        className: "orderDialogBack",
        variant: "outlined",
        onClick: handleBack,
        sx: {
          minWidth: 118
        },
        children: t(backButton)
      }), jsx(Button$1, {
        "data-cy": `orderDialogForward`,
        className: "orderDialogForward",
        variant: "contained",
        disabled: disabled,
        sx: {
          minWidth: 118
        },
        onClick: handleForward,
        children: jsx(LocalizedText, {
          value: forwardButton
        })
      })]
    })
  });
};

const StepperPlain = ({
  headlines,
  step
}) => jsx(Stepper, {
  activeStep: step,
  alternativeLabel: false,
  children: headlines.map(label => jsx(Step, {
    children: jsx(StepLabel, {})
  }, label))
});

const StepperContainer = ({
  children
}) => {
  return jsx(Box$2, {
    component: "div",
    position: "absolute",
    width: 0.8,
    sx: {
      left: "50%",
      transform: "translate(-50%, 32px)"
    },
    children: children
  });
};

const IOrderDialogTitle = props => {
  return jsx(Typography$1, {
    variant: "h5",
    component: "div",
    children: props.title
  });
};
const OrderDialogTitle = withExtensions({
  app: {
    orderDialog: {
      headline: {
        root: true
      }
    }
  }
})(IOrderDialogTitle);
const OrderDialogHeader = ({
  step,
  action,
  onClose
}) => {
  const {
    t
  } = useTranslation();
  const [headlines, stepIndex] = useHeadlines()(action, step);
  !!(action != null && action.formular);
  return jsxs(Fragment, {
    children: [action && jsx(Box$2, {
      component: "div",
      className: "orderDialogStepperContainer",
      children: jsx(StepperContainer, {
        children: jsx(StepperPlain, {
          headlines: headlines,
          step: stepIndex
        })
      })
    }), jsxs(DialogTitle$1, {
      className: "orderDialogTitle",
      children: [jsxs(Box$2, {
        component: "div",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: 1,
        pt: 8,
        textAlign: "right",
        children: [jsxs(Box$2, {
          component: "div",
          display: "flex",
          alignItems: "center",
          children: [jsx(OrderDialogTitle, {
            title: headlines[stepIndex],
            allHeadlines: headlines,
            step: stepIndex
          }), jsx(EditDynamicSettings, {
            keys: DialogHelper.keysForStep(step),
            boxProps: {
              ml: 1
            },
            display: "dialog"
          })]
        }), jsx(IconButton$1, {
          "data-cy": `close`,
          edge: "start",
          color: "inherit",
          onClick: onClose,
          "aria-label": "close",
          size: "large",
          children: jsx(CloseIcon, {})
        })]
      }), jsx(Typography$1, {
        variant: "body2",
        color: "GrayText",
        sx: {
          opacity: step === "contact" ? 1 : 0
        },
        children: "* " + t("Pflichtfeld")
      })]
    })]
  });
};
const useHeadlines = () => {
  const translation = useDynamicTranslation();
  return useCallback((action, step) => {
    const available = DialogHelper.availableSteps(action);
    return [available.map((step, i) => {
      const key = DialogHelper.titleKeyForStep(step);
      return `${i + 1}. ${translation(key)}`;
    }), available.indexOf(step)];
  }, [translation]);
};

const saveOnScreenshotsCompleted = (screenshotting, action) => async (dispatch, getState) => {
  const state = getState();
  const currentAction = action || selectCurrentAppSettingAction(state);
  if (!currentAction) return null;
  if (!screenshotting || screenshotting === "creating") return null;
  console.debug("Starting save");
  const customer = DialogHelper.customer(currentAction, selectPrivateData(state), selectPrivateDataText(state));
  const result = await dispatch(saveCurrentConfigurationThunk("Configuration", currentAction, customer));
  console.debug("Ending save");
  dispatch(resetScreenshotting());
  return result;
};

/** Implement this hook anywhere in your app, so it is running on configuration save.
 * Included in OrderDialog already.
 * If you don't pass an action it uses the one set by useTriggerAction. */
const useExecuteSave = (onSuccess, action) => {
  const dispatch = useTypedDispatch();
  const screenshotting = useTypedSelector(selectScreenshotting);
  useEffect(() => {
    const save = async () => {
      const result = await dispatch(saveOnScreenshotsCompleted(screenshotting, action));
      if (!result) return;
      onSuccess(result);
    };
    save();
  }, [screenshotting]);
};

const OrderDialogWithData = () => {
  const action = useTypedSelector(selectCurrentAppSettingAction);
  if (!action) return null;
  return jsx(WOrderDialog, {
    action: action
  });
};
const WOrderDialog = ({
  action
}) => {
  const [saveResult, setSaveResult] = useState(undefined);
  const [step, setStep] = useState(DialogHelper.availableSteps(action)[0]);
  const dispatch = useTypedDispatch();
  useEffect(() => {
    const availableSteps = DialogHelper.availableSteps(action);
    setStep(availableSteps[0]);
    if (availableSteps.length <= 1) handleSave();
  }, [action]);
  useExecuteSave(result => {
    setSaveResult(result);
    setStep("confirmation");
  });
  const handleSave = async () => {
    dispatch(triggerSaveThunk());
  };
  const handleClose = () => {
    dispatch(setCurrentAction(null));
    setSaveResult(undefined);
  };
  const handleStep = direction => {
    const nextStep = DialogHelper.handleStep(action, step, direction);
    setStep(nextStep);
  };
  return jsx(OrderDialog, {
    action: action,
    handleClose: handleClose,
    step: step,
    saveResult: saveResult,
    handleSave: handleSave,
    handleStep: handleStep
  });
};
const IOrderDialog = ({
  action,
  handleClose,
  step,
  saveResult,
  handleSave,
  handleStep
}) => {
  return jsxs(Dialog$1, {
    className: "orderDialog",
    open: !!action,
    fullWidth: true,
    maxWidth: "md",
    onClose: handleClose,
    children: [jsx(OrderDialogHeader, {
      step: step,
      action: action,
      onClose: handleClose
    }), jsx(OrderDialogBody, {
      step: step,
      action: action,
      result: saveResult,
      onClose: handleClose
    }), jsx(OrderDialogFooter, {
      step: step,
      action: action,
      onSave: handleSave,
      onStep: handleStep,
      onClose: handleClose
    })]
  });
};
const OrderDialog = withExtensions({
  app: {
    orderDialog: {
      root: true
    }
  }
})(IOrderDialog);

function Modals() {
  return jsxs(Fragment, {
    children: [jsx(InvalidRuleModalWrapper, {}), jsx(K3Loading, {}), jsx(AppInformation, {}), jsx(InfoSelectionDialog, {}), jsx(VariableInfoDialog, {}), jsx(ArDialog, {}), jsx(OrderDialogWithData, {}), jsx(MultipleActionsDialogWithData, {}), jsx(MountedWhenLoaded, {})]
  });
}

const lazyLoadedComponents = {
  // mui components
  Typography: /*#__PURE__*/React__default.lazy(() => import('@mui/material/Typography')),
  Switch: /*#__PURE__*/React__default.lazy(() => import('@mui/material/Switch')),
  Box: /*#__PURE__*/React__default.lazy(() => import('@mui/material/Box')),
  Button: /*#__PURE__*/React__default.lazy(() => import('@mui/material/Button')),
  Divider: /*#__PURE__*/React__default.lazy(() => import('@mui/material/Divider')),
  // mui icons
  ExpandCircleDownIcon: /*#__PURE__*/React__default.lazy(() => import('@mui/icons-material/ExpandCircleDown')),
  KeyboardArrowDownIcon: /*#__PURE__*/React__default.lazy(() => import('@mui/icons-material/KeyboardArrowDown')),
  CloseIcon: /*#__PURE__*/React__default.lazy(() => import('@mui/icons-material/Close')),
  MoreVertIcon: /*#__PURE__*/React__default.lazy(() => import('@mui/icons-material/MoreVert'))
};
// https://gist.github.com/goldhand/70de06a3bdbdb51565878ad1ee37e92b
const parseStyles = styles => styles.split(";").filter(style => style.split(":")[0] && style.split(":")[1]).map(style => [style.split(":")[0].trim().replace(/-./g, c => c.substr(1).toUpperCase()), style.split(":")[1].trim()]).reduce((styleObj, style) => Object.assign({}, styleObj, {
  [style[0]]: style[1]
}), {});
const parseProp = prop => {
  if (prop === "true") return true;
  if (prop === "false") return false;
  const n = +prop;
  if (n || n === 0) return n;
  return prop;
};
const getComponentFromTemplate = (components, node, index = 0) => {
  if (node.nodeType == Node.TEXT_NODE) {
    return node.textContent;
  }
  const children = [];
  node.childNodes.forEach(node => children.push(node));
  const props = {
    key: `${node.nodeName}_${index}`
  };
  for (let i = 0; i < node.attributes.length; i++) {
    const item = node.attributes.item(i);
    switch (item.name) {
      case "style":
        props[item.name] = parseStyles(item.value);
        break;
      default:
        props[item.name] = parseProp(item.value);
        break;
    }
  }
  return /*#__PURE__*/React__default.createElement(components[node.nodeName] || node.nodeName, props, children.filter(node => node.nodeType == Node.ELEMENT_NODE || node.nodeType == Node.TEXT_NODE).map((node, index) => getComponentFromTemplate(components, node, index)));
};
const XMLStringToReact = ({
  xmlString: _xmlString = "",
  components: _components = {}
}) => {
  const layout = useMemo(() => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(_xmlString, "text/xml");
    return getComponentFromTemplate(_components, doc.getRootNode().firstChild);
  }, [_components, _xmlString]);
  return jsx(Suspense, {
    fallback: jsx(Fragment, {}),
    children: layout
  });
};

const sxStyles$g = {
  root: {
    display: "grid",
    width: 1.0,
    height: 1.0,
    overflow: "hidden",
    gap: "0px 0px",
    gridAutoFlow: "row",
    gridTemplateRows: "1fr",
    gridTemplateColumns: "1fr max-content"
  },
  layoutSidebarLeft: {
    gridTemplateAreas: `
          "Sidebar Preview"`
  },
  layoutSidebarRight: {
    gridTemplateAreas: `
          "Preview Sidebar"`
  },
  gridAreaPreview: {
    gridArea: "Preview"
  },
  gridAreaSidebar: {
    gridArea: "Sidebar",
    height: "100%",
    overflow: "hidden"
  }
};
const AccordionLayout = ({
  sidebar,
  content,
  sidebarRight
}) => jsxs(Box$2, {
  component: "div",
  sx: Object.assign({}, sxStyles$g.root, sidebarRight ? sxStyles$g.layoutSidebarRight : sxStyles$g.layoutSidebarLeft),
  children: [jsx(Box$2, {
    component: "div",
    sx: sxStyles$g.gridAreaPreview,
    children: content
  }), jsx(Box$2, {
    component: "div",
    sx: sxStyles$g.gridAreaSidebar,
    children: sidebar
  })]
});

const sidebarSxStyles = {
  root: {
    display: "grid",
    width: 1.0,
    height: 1.0,
    overflow: "hidden",
    gap: "0px 0px",
    gridAutoFlow: "row",
    gridTemplateRows: "min-content 1fr"
  },
  layoutSidebarRight: {
    gridTemplateColumns: "minmax(0, 1fr) max-content",
    gridTemplateAreas: `
          "AppBar AppBar"
          "Preview Sidebar"`
  },
  layoutSidebarLeft: {
    gridTemplateColumns: "max-content 1fr",
    gridTemplateAreas: `
          "AppBar AppBar"
          "Sidebar Preview"`
  },
  gridAreaAppBar: {
    gridArea: "AppBar"
  },
  gridAreaPreview: {
    gridArea: "Preview"
  },
  gridAreaSidebar: {
    zIndex: 1,
    gridArea: "Sidebar",
    overflow: "hidden",
    boxShadow: theme => theme.shadows[3]
  }
};
const SidebarLayout = ({
  header,
  sidebar,
  content,
  sidebarRight
}) => {
  return jsxs(Box$2, {
    component: "div",
    sx: Object.assign({}, sidebarSxStyles.root, sidebarRight ? sidebarSxStyles.layoutSidebarRight : sidebarSxStyles.layoutSidebarLeft),
    children: [header && jsx(Box$2, {
      component: "div",
      sx: sidebarSxStyles.gridAreaAppBar,
      children: header
    }), jsx(Box$2, {
      component: "div",
      sx: sidebarSxStyles.gridAreaPreview,
      children: content
    }), jsx(Box$2, {
      component: "div",
      sx: sidebarSxStyles.gridAreaSidebar,
      children: sidebar
    })]
  });
};

const sxStyles$f = createStyleObject({
  parentItem: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    gap: "0.5rem"
  },
  root: {
    minWidth: "auto",
    overflow: "hidden",
    padding: 1,
    whiteSpace: "nowrap",
    alignItems: "center"
  },
  breadcrumbs: {
    paddingLeft: 2,
    boxSizing: "border-box"
  }
});
const ComponentBreadcrumbs = ({
  useDivider,
  useDelete
}) => {
  const openInstance = useTypedSelector(selectOpenInstance);
  const {
    t
  } = useTranslation();
  const pseudoRootSelection = useTypedSelector(selectPseudoRootSelection) || rootSelection;
  const parentSelections = useTypedSelector(selectParentSelections(openInstance)).reverse();
  const parentVariables = useTypedSelector(selectParentVariablePath(openInstance.variableId));
  const currentParentVariable = useTypedSelector(selectVariableById(openInstance.variableId));
  const currentValue = useTypedSelector(selectValueById(openInstance.valueId));
  const dispatch = useTypedDispatch();
  const handleParentSelectionClick = selection => () => {
    dispatch(goBackToInstance(selection));
  };
  const [close, setClose] = React.useState();
  const handleDelete = () => {
    dispatch(removeInstanceThunk(openInstance));
    handleHomeClick();
  };
  const handleHomeClick = useCallback(() => {
    setClose(undefined);
    dispatch(goBackToInstance(pseudoRootSelection, openInstance.variableId));
  }, [dispatch, openInstance.variableId, pseudoRootSelection]);
  if (!currentParentVariable || openInstance.variableId === pseudoRootSelection.variableId) {
    return null;
  }
  return jsxs(Fragment, {
    children: [jsx(Slide, {
      in: close !== undefined ? !close : !!currentParentVariable,
      direction: "right",
      // mountOnEnter
      timeout: 300,
      onExited: handleHomeClick,
      children: jsxs(Stack, {
        direction: "row",
        sx: sxStyles$f.root,
        children: [jsxs(Breadcrumbs, {
          "aria-label": "breadcrumb",
          separator: jsx(NavigateNext, {
            fontSize: "small"
          }),
          maxItems: 3,
          itemsAfterCollapse: 2,
          itemsBeforeCollapse: 1,
          children: [jsx(Link, {
            component: Button,
            "data-cy": `parent`,
            color: "inherit",
            noWrap: true,
            sx: sxStyles$f.parentItem,
            underline: "none",
            variant: "subtitle1",
            startIcon: jsx(ArrowBack, {}),
            onClick: () => setClose(true),
            children: jsx(Typography$1, {
              variant: "subtitle1",
              "data-cy": "buttonLabel",
              children: t("Zurück")
            })
          }), mapExtra(selection => {
            const variable = parentVariables.find(v => v.id == selection.variableId);
            return jsxs(Link, {
              "data-cy": `crumb-${selection.variableId}`,
              color: "inherit",
              onClick: handleParentSelectionClick(selection),
              sx: sxStyles$f.parentItem,
              underline: "hover",
              variant: "subtitle1",
              noWrap: true,
              children: [(variable == null ? void 0 : variable.label) && jsx(Typography$1, {
                variant: "subtitle1",
                "data-cy": "variableLabel",
                children: `${variable == null ? void 0 : variable.label} `
              }), jsx(Typography$1, {
                variant: "subtitle1",
                "data-cy": "selectionSort",
                children: `(${selection.sort}): `
              }), jsx(Typography$1, {
                variant: "subtitle1",
                "data-cy": "selectionValue",
                children: `${selection.debuggingValue}`
              })]
            }, selection.id);
          }, parentSelections.filter(s => s.id !== pseudoRootSelection.id)), currentValue && jsxs(Box, {
            component: "div",
            sx: {
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "0.5rem"
            },
            "data-cy": "currentCrumb",
            children: [(currentParentVariable == null ? void 0 : currentParentVariable.label) && jsx(Fragment, {
              children: jsx(Typography$1, {
                noWrap: true,
                variant: "subtitle1",
                "data-cy": "variableLabel",
                children: `${currentParentVariable == null ? void 0 : currentParentVariable.label}`
              })
            }), jsx(Typography$1, {
              noWrap: true,
              variant: "subtitle1",
              "data-cy": "selectionSort",
              children: `(${openInstance.sort}):`
            }), jsx(Typography$1, {
              noWrap: true,
              variant: "subtitle1",
              "data-cy": "selectionValue",
              children: `${openInstance.debuggingValue}`
            })]
          })]
        }), useDelete && jsx(IconButton, {
          onClick: handleDelete,
          "data-cy": "delete",
          children: jsx(Delete, {})
        })]
      })
    }), useDivider && jsx(Divider, {})]
  });
};

const useKeyDown = (callback, keys) => {
  const onKeyDown = useCallback(event => {
    const wasAnyKeyPressed = keys.some(key => event.key === key);
    if (wasAnyKeyPressed) {
      callback({
        key: event.key,
        ctrl: event.ctrlKey
      });
    }
  }, [callback, keys]);
  useEffect(() => {
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [onKeyDown]);
};

const FullscreenButton = () => {
  const dispatch = useTypedDispatch();
  const isFullScreen = useTypedSelector(isFullscreen3DView);
  const isEditor = useTypedSelector(selectShowEditorUi);
  const translation = useDynamicTranslation();
  useKeyDown(({
    key
  }) => {
    if (isFullScreen && (key === "Escape" || key === " ")) {
      dispatch(toggleFullScreen3DView());
    }
  }, ["Escape", " "]);
  const onClick = () => {
    dispatch(toggleFullScreen3DView());
  };
  return jsxs(Stack, {
    direction: "row",
    children: [jsx(SecondaryButton, {
      "data-cy": "fullscreenButton",
      onClick: onClick,
      className: "fullscreenButton",
      variant: "contained",
      fullWidth: true,
      startIcon: isFullScreen ? jsx(FullscreenExitIcon, {}) : jsx(FullscreenIcon, {}),
      children: translation(DynamicSettingsKeys.FULLSCREEN_BUTTON)
    }), Boolean(isEditor) && jsx(EditDynamicSettings, {
      keys: [DynamicSettingsKeys.FULLSCREEN_BUTTON]
    })]
  });
};

/* eslint-disable @typescript-eslint/no-empty-interface */
// @mui has a custom border-radius constant. We use that for overrides
const {
  palette,
  shape: {
    borderRadius
  }
} = createTheme();
const themeOptions = {
  // all corners are softer
  shape: {
    borderRadius: borderRadius * 2
  },
  palette: {
    mode: "light",
    editor: {
      main: grey["800"],
      contrastText: "#fff"
    },
    primary: {
      main: "#00A4DD",
      contrastText: "#fff"
    },
    secondary: {
      main: grey["100"],
      contrastText: "#000"
    },
    content: {
      main: "white",
      contrastText: "#000"
    },
    scrollbar: {
      default: "lightgrey"
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          whiteSpace: "nowrap",
          minWidth: "auto",
          borderRadius
        }
      }
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          textTransform: "none"
        }
      }
    },
    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: "none"
        }
      }
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          display: "none"
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "none",
          "&:hover": {
            color: palette.text.primary
          }
        }
      }
    },
    MuiCardHeader: {
      styleOverrides: {
        root: {
          height: "100%",
          alignItems: "start"
        },
        content: {
          width: "100%"
        }
      }
    },
    MuiCardActions: {
      styleOverrides: {
        root: {
          justifyContent: "space-between"
        }
      }
    },
    MuiCardActionArea: {
      styleOverrides: {
        root: {
          color: palette.primary.main
        }
      }
    },
    MuiCard: {
      defaultProps: {
        raised: true
      }
    }
  },
  typography: {
    fontFamily: ["Nunito Sans", "Arial", "sans-serif", '"Apple Color Emoji"', '"Segoe UI Emoji"', '"Segoe UI Symbol"'].join(",")
  }
};
const theme = createTheme(themeOptions, deDE);
// export function createDynamicTheme(prefersDarkMode: boolean) {
//   const dynamicTheme: any = _.cloneDeep(baseTheme);
//   dynamicTheme.palette.mode = prefersDarkMode ? "dark" : "light";
//   return createTheme(dynamicTheme);
// }

const useAppTheme = () => {
  var _useTypedSelector, _useTypedSelector$app, _dealerApp$settings, _dealerApp$settings$e, _dealerApp$settings$e2;
  const {
    themeOptionsCreator
  } = useProvidedExtensions();
  const app = useTypedSelector(selectFrontendApp);
  const dealerApp = (_useTypedSelector = useTypedSelector(selectDealerData)) == null ? void 0 : (_useTypedSelector$app = _useTypedSelector.apps) == null ? void 0 : _useTypedSelector$app.find(da => da.appId == (app == null ? void 0 : app.id));
  const internalApp = dealerApp != null && (_dealerApp$settings = dealerApp.settings) != null && (_dealerApp$settings$e = _dealerApp$settings.ext) != null && (_dealerApp$settings$e2 = _dealerApp$settings$e.theme) != null && _dealerApp$settings$e2.palette ? dealerApp : app;
  return useMemo(() => {
    var _internalApp$settings, _internalApp$settings2, _internalApp$settings3, _themeOptionsCreator;
    const appThemeOptions = (_internalApp$settings = internalApp == null ? void 0 : (_internalApp$settings2 = internalApp.settings) == null ? void 0 : (_internalApp$settings3 = _internalApp$settings2.ext) == null ? void 0 : _internalApp$settings3.theme) != null ? _internalApp$settings : {};
    const mergedOptions = deepmerge(themeOptions, appThemeOptions);
    const options = (_themeOptionsCreator = themeOptionsCreator == null ? void 0 : themeOptionsCreator(cloneDeep(mergedOptions))) != null ? _themeOptionsCreator : mergedOptions;
    const theme = createTheme(options, deDE);
    return theme;
  }, [internalApp, themeOptionsCreator]);
};

const buttonSx = {
  position: "absolute",
  color: "primary.main",
  top: "50%",
  transform: "translateY(-50%)",
  zIndex: 1,
  padding: 0
};
const iconSx = {
  width: "48px",
  height: "48px"
};
const DefaultGalleryContent = /*#__PURE__*/React__default.forwardRef((_props, _ref) => {
  const images = useTypedSelector(selectCurrentImages);
  const [currentSlide, setCurrentSlide] = useState(0);
  const urls = useMemo(() => images.slice().sort((i1, i2) => i1.label > i2.label ? +1 : -1).map(image => image.url), [images]);
  const stringifiedUrls = useMemo(() => JSON.stringify(urls), [urls]);
  useEffect(() => {
    setCurrentSlide(0);
  }, [stringifiedUrls]);
  const [containerRef, measures] = useMeasure();
  const theme = useAppTheme();
  return jsx("div", {
    ref: containerRef,
    style: {
      height: "100%",
      width: "auto"
    },
    children: jsx(Carousel, {
      swipeable: true,
      showStatus: false,
      infiniteLoop: true,
      emulateTouch: true,
      showThumbs: false,
      selectedItem: currentSlide,
      onChange: newIndex => setCurrentSlide(newIndex),
      renderArrowNext: (onClickHandler, hasNext, _label) => {
        if (!hasNext) {
          return null;
        }
        return jsx(IconButton, {
          onClick: onClickHandler,
          "data-cy": "showNext",
          sx: Object.assign({}, buttonSx, {
            right: "16px"
          }),
          children: jsx(ArrowCircleRight, {
            sx: iconSx
          })
        });
      },
      renderArrowPrev: (onClickHandler, hasNext, _label) => {
        if (!hasNext) {
          return null;
        }
        return jsx(IconButton, {
          onClick: onClickHandler,
          "data-cy": "showPrevious",
          sx: Object.assign({}, buttonSx, {
            left: "16px"
          }),
          children: jsx(ArrowCircleLeft, {
            sx: iconSx
          })
        });
      },
      renderIndicator: (onClickHandler, isActive) => jsx(Stack, {
        component: "li",
        className: clsx("dot", isActive && "selected"),
        onClick: onClickHandler,
        sx: {
          backgroundColor: theme.palette.primary.main + "!important"
        }
      }),
      children: urls.map((url, i) => jsx("div", {
        style: {
          height: measures.height,
          width: "100%",
          margin: "auto",
          // no interactions so swipe can occur instead of dragging the image
          pointerEvents: "none",
          backgroundImage: `url(${url})`,
          backgroundSize: "contain",
          objectFit: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center"
        }
      }, i))
    })
  });
});
const GalleryContent = withExtensions({
  app: {
    gallery: {
      root: true
    }
  }
})(DefaultGalleryContent);

class K3DError extends React__default.Component {
  constructor(props) {
    super(props);
    this.onUnhandledRejection = event => {
      event.promise.catch(error => {
        this.setState(K3DError.getDerivedStateFromError(error));
      });
    };
    this.state = {
      hasError: false,
      error: null,
      template: props.template
    };
  }
  static getDerivedStateFromError(_error) {
    return {
      hasError: true,
      error: _error
    };
  }
  componentDidMount() {
    window.addEventListener("unhandledrejection", this.onUnhandledRejection);
  }
  componentWillUnmount() {
    window.removeEventListener("unhandledrejection", this.onUnhandledRejection);
  }
  componentDidCatch(error, errorInfo) {
    console.error("Unexpected error occurred!", error, errorInfo);
  }
  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.template) !== JSON.stringify(this.props.template)) {
      this.setState({
        hasError: false,
        error: null,
        template: this.props.template
      });
    }
  }
  render() {
    if (this.state.hasError && this.state.error) {
      return jsx(Box, {
        component: "div",
        sx: {
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        },
        children: jsxs(Typography, {
          children: ["3D-Parsing-Error: Maybe something wrong with Custom-Scene-Setting?", " ", jsx("br", {}), this.state.error.message]
        })
      });
    }
    return this.props.children;
  }
}

const isSubset = (xs, ys) => xs.size <= ys.size && [...xs].every(x => ys.has(x));
const useAreK3ModelsOfActionsLoading = () => {
  const progress = useProgress();
  const {
    scene
  } = useThree();
  const modelActions = useTypedSelector(selectModelActions);
  const foundModelActions = useRef();
  const isLoadingModels = useRef(-1);
  const loadedModelIds = useRef();
  const [, kickTheMachine] = useState(0);
  if (!equals(modelActions, foundModelActions.current)) {
    isLoadingModels.current = 1;
  }
  useFrame(() => {
    if (!progress.active && modelActions !== foundModelActions.current) {
      const modelIds = new Set(modelActions.map(a => a.modelId));
      const loadedModels = new Set();
      scene.traverse(object => {
        var _object$userData;
        const modelId = object == null ? void 0 : (_object$userData = object.userData) == null ? void 0 : _object$userData.modelId;
        if (modelId) {
          loadedModels.add(modelId);
        }
      });
      const currentIsLoading = !isSubset(modelIds, loadedModels);
      if (!currentIsLoading) {
        foundModelActions.current = modelActions;
        loadedModelIds.current = [...loadedModels];
      } else {
        loadedModelIds.current = undefined;
      }
      kickTheMachine(Math.random());
      isLoadingModels.current = currentIsLoading ? 1 : 0;
    }
  });
  const result = progress.active || isLoadingModels.current === 1;
  const isLoadingState = useTypedSelector(selectIsLoadingScene);
  const dispatch = useTypedDispatch();
  if (result !== isLoadingState) {
    dispatch(setIsLoading(result));
    dispatch(setLoadedModelIds(result ? undefined : loadedModelIds.current));
  }
  return result;
};

const useCleanUpImageActionCanvases = () => {
  const modelIds = useTypedSelector(selectLoadedModelIds);
  const isLoadingScene = useTypedSelector(selectIsLoadingScene);
  useMemo(() => {
    if (isLoadingScene) return;
    const canvases = getPrintCanvases();
    const canvasDataToDestroy = [];
    canvases == null ? void 0 : canvases.forEach(child => {
      var _child$dataset$modelI;
      // eslint-disable-next-line:@typescript-eslint/ban-ts-comment
      // @ts-ignore
      const modelId = parseInt((_child$dataset$modelI = child == null ? void 0 : child.dataset.modelId) != null ? _child$dataset$modelI : "");
      if (!modelIds.includes(modelId)) {
        // eslint-disable-next-line:@typescript-eslint/ban-ts-comment
        // @ts-ignore
        const stageId = child.id;
        const konvaStage = konvaStageMap.get(stageId);
        if (konvaStage) {
          canvasDataToDestroy.push({
            konvaStage,
            canvasDiv: child
          });
        }
      }
    });
    canvasDataToDestroy.forEach(stuff => {
      const {
        konvaStage,
        canvasDiv
      } = stuff;
      // eslint-disable-next-line:@typescript-eslint/ban-ts-comment
      // @ts-ignore
      konvaStageMap.delete(canvasDiv.id);
      konvaStage.destroy();
      canvasDiv.remove();
    });
  }, [modelIds, isLoadingScene]);
};

const K3DHooks = () => {
  useAreK3ModelsOfActionsLoading();
  useCleanUpImageActionCanvases();
  return null;
};

const createDefaultSceneTemplate = () => {
  return {
    canvasProps: {
      gl: {
        preserveDrawingBuffer: true
      },
      camera: {
        near: 0.001,
        fov: 35,
        position: [3, 2, 3]
      }
    },
    children: [{
      component: "OrbitControls",
      props: {
        maxPolarAngle: Math.PI / 2.1,
        makeDefault: true
      }
    }, {
      component: "ContactShadows",
      props: {
        resolution: 1024,
        position: [0, 0, 0],
        scale: 10,
        blur: 3,
        opacity: 1,
        far: 10
      }
    }, {
      component: "Environment",
      props: {
        background: false,
        files: getDreiPresetUrl("city")
      }
    }, {
      component: "Sky",
      props: {
        distance: 45000,
        sunPosition: [0, 1, 0],
        inclination: 1,
        azimuth: 0.1
      }
    },
    // TODO: Cam: We might be forced to remove the bounds
    {
      component: "Bounds",
      props: {
        margin: 1.3,
        damping: 10
      },
      children: [{
        component: "K3BoundsFocus",
        props: {
          animateOnMissed: true,
          animate: false
        },
        children: [{
          component: "K3D",
          props: {}
        }]
      }]
    }]
  };
};
const createNightSceneTemplate = () => {
  return {
    canvasProps: {
      gl: {
        preserveDrawingBuffer: true
      },
      camera: {
        near: 0.001,
        fov: 35,
        position: [3, 2, 3]
      },
      style: {
        backgroundColor: "black"
      }
    },
    children: [{
      component: "OrbitControls",
      props: {
        maxPolarAngle: Math.PI / 2.1,
        makeDefault: true
      }
    }, {
      component: "ContactShadows",
      props: {
        resolution: 1024,
        frames: 1,
        position: [0, 0, 0],
        scale: 10,
        blur: 3,
        opacity: 1,
        far: 10
      }
    }, {
      component: "Environment",
      props: {
        background: false,
        files: getDreiPresetUrl("night")
      }
    }, {
      component: "Stars",
      props: {}
    }, {
      component: "K3BoundsFocus",
      props: {
        animateOnMissed: true,
        animate: false
      },
      children: [{
        component: "K3D",
        props: {}
      }]
    }]
  };
};
const SceneTemplates = [{
  name: "Default",
  template: createDefaultSceneTemplate()
}, {
  name: "Night",
  template: createNightSceneTemplate()
}];

const MpHighlighters = () => {
  const instanceSelectionsAndVariables = useTypedSelector(selectInstanceSelectionsAndVariables);
  const launchedProps = instanceSelectionsAndVariables.filter(({
    variable
  }) => getTemplateOptions(variable).highlightHovered).map(({
    selection,
    variable
  }) => {
    var _to$highlightColor, _to$highlightOpacity;
    const to = getTemplateOptions(variable);
    return {
      selection,
      color: (_to$highlightColor = to.highlightColor) != null ? _to$highlightColor : "white",
      targetOpacity: (_to$highlightOpacity = to.highlightOpacity) != null ? _to$highlightOpacity : 0.5
    };
  });
  return jsx(Fragment, {
    children: launchedProps.map(props => createElement$2(MpHighlighter, Object.assign({}, props, {
      key: props.selection.id
    })))
  });
};
const opacityThreshold = 0.01;
const MpHighlighter = props => {
  var _materialRef$current3, _materialRef$current$2, _materialRef$current4;
  const highlights = useRapidStore(state => state.hoveredSelections);
  const materialRef = useRef();
  const {
    scene,
    invalidate
  } = useThree();
  const {
    center,
    size
  } = useMemo(() => {
    const boundingBox = new Box3();
    scene.traverse(object => {
      if (object.name.includes(props.selection.id)) {
        const box = new Box3().setFromObject(object);
        boundingBox.union(box);
      }
    });
    return {
      center: boundingBox.getCenter(new Vector3()),
      size: boundingBox.getSize(new Vector3())
    };
  }, [props.selection, scene, highlights]);
  useEffect(() => {
    if (!materialRef.current) return;
    materialRef.current.opacity = 0;
  }, [materialRef.current]);
  const highlight = highlights.some(h => h === props.selection.id);
  const goal = highlight ? props.targetOpacity : 0;
  useFrame((_state, delta) => {
    var _materialRef$current$, _materialRef$current, _materialRef$current2;
    if (delta > 0.1) {
      invalidate();
      return;
    }
    if (!materialRef.current) return;
    materialRef.current.opacity = MathUtils.damp((_materialRef$current$ = (_materialRef$current = materialRef.current) == null ? void 0 : _materialRef$current.opacity) != null ? _materialRef$current$ : 0, goal, 15, delta);
    if (Math.abs(goal - ((_materialRef$current2 = materialRef.current) == null ? void 0 : _materialRef$current2.opacity)) >= opacityThreshold) {
      invalidate();
    } else {
      materialRef.current.opacity = goal;
    }
  });
  const isVisible = (materialRef == null ? void 0 : materialRef.current) && (Math.abs(goal - ((_materialRef$current3 = materialRef.current) == null ? void 0 : _materialRef$current3.opacity)) >= opacityThreshold || goal > 0);
  return jsxs("mesh", {
    visible: isVisible,
    position: center.toArray(),
    scale: size.toArray(),
    castShadow: false,
    children: [jsx("boxGeometry", {
      args: [1, 1, 1]
    }), jsx("meshBasicMaterial", {
      ref: materialRef,
      color: props.color,
      transparent: true,
      depthTest: false,
      opacity: (_materialRef$current$2 = materialRef == null ? void 0 : (_materialRef$current4 = materialRef.current) == null ? void 0 : _materialRef$current4.opacity) != null ? _materialRef$current$2 : 0
    })]
  });
};

function Loader() {
  const bounds = useBounds();
  const box3 = bounds == null ? void 0 : bounds.getSize();
  const {
    progress
  } = useProgress();
  return jsx(Html, {
    position: box3 == null ? void 0 : box3.center,
    children: jsxs(Box$2, {
      component: "div",
      sx: {
        position: "absolute"
      },
      children: [jsx(CircularProgress$1, {
        sx: {
          position: "absolute"
        },
        size: 60,
        disableShrink: true
      }), jsx(Typography$1, {
        sx: {
          position: "absolute",
          left: 15,
          top: 20
        },
        variant: "caption",
        component: "div",
        color: "text.secondary",
        children: `${Math.round(progress)}%`
      })]
    })
  });
}

const K3ModelInternal = /*#__PURE__*/forwardRef((props, ref) => {
  const editMode = useTypedSelector(selectEditMode);
  return editMode ? jsx(ModelReposition, Object.assign({}, props, {
    children: jsx(DynamicOrGlbModel, Object.assign({
      ref: ref
    }, props))
  })) : jsx(DynamicOrGlbModel, Object.assign({
    ref: ref
  }, props));
});
const K3Model = withExtensions({
  app: {
    k3d: {
      sceneComponents: {
        K3Model: {
          root: true
        }
      }
    }
  }
})(K3ModelInternal);
const deconstructMatrix = matrix => {
  const newPosition = new Vector3();
  const newRotation = new Vector3();
  const quaternion = new Quaternion();
  const dump = new Vector3();
  matrix.decompose(newPosition, quaternion, dump);
  newRotation.setFromEuler(new Euler().setFromQuaternion(quaternion));
  return {
    newPosition,
    newRotation
  };
};
const getOffsetVec = (pos, rotation) => {
  // Step 5: Apply the rotation to the position
  const matrix = new Matrix4().makeRotationFromEuler(new Euler().setFromVector3(rotation, "XYZ"));
  return pos.clone().applyMatrix4(matrix).sub(pos);
};
/** Sorry. This thing is full of hacks. Whoever can do better, may. */
const ModelReposition = props => {
  var _meshProps$position;
  const {
    meshProps,
    modelAction
  } = props;
  const dispatch = useTypedDispatch();
  const ref = useRef(null);
  return jsx(PivotControls, {
    scale: 0.5,
    anchor: [0, 0, 0],
    rotation: meshProps == null ? void 0 : meshProps.rotation,
    depthTest: false,
    ref: ref,
    annotations: true,
    autoTransform: true,
    onDragEnd: () => {
      var _modelAction$ruleItem, _modelAction$ruleItem2;
      const ruleItemId = (_modelAction$ruleItem = modelAction == null ? void 0 : (_modelAction$ruleItem2 = modelAction.ruleItem) == null ? void 0 : _modelAction$ruleItem2.id) != null ? _modelAction$ruleItem : "main";
      const {
        newPosition,
        newRotation
      } = deconstructMatrix(ref.current.matrix);
      const initialPosition = new Vector3(...((meshProps == null ? void 0 : meshProps.position) || []));
      const initialRotation = new Vector3(...((meshProps == null ? void 0 : meshProps.rotation) || []));
      const rotationOffset = getOffsetVec(initialPosition, newRotation);
      const finalPosition = initialPosition.clone().add(newPosition).add(rotationOffset).toArray();
      const finalRotation = initialRotation.clone().add(newRotation).toArray();
      dispatch(setModelRuleData({
        ruleItemId: ruleItemId,
        modelId: props.model.id,
        position: finalPosition,
        rotation: finalRotation
      }));
    },
    children: props.children
  }, (meshProps == null ? void 0 : (_meshProps$position = meshProps.position) == null ? void 0 : _meshProps$position.toString == null ? void 0 : _meshProps$position.toString()) || 0);
};
const DynamicOrGlbModel = /*#__PURE__*/forwardRef((props, ref) => {
  if (props.component) {
    var _props$modelAction, _props$model$id, _props$model;
    return jsx(props.component, Object.assign({
      ref: ref,
      modelAction: props.modelAction,
      name: (_props$modelAction = props.modelAction) == null ? void 0 : _props$modelAction.unique
    }, props.meshProps, {
      id: (_props$model$id = (_props$model = props.model) == null ? void 0 : _props$model.id) != null ? _props$model$id : -1
    }));
  }
  return jsx(GlbModel, Object.assign({
    ref: ref
  }, props));
});
const GlbModel = /*#__PURE__*/forwardRef((props, ref) => {
  var _props$modelAction2;
  const k3GltfWithMaterials = useGLTFWithAppliedActions(props);
  return jsx("mesh", {
    ref: ref,
    name: (_props$modelAction2 = props.modelAction) == null ? void 0 : _props$modelAction2.unique,
    children: jsx("primitive", {
      object: k3GltfWithMaterials.scene
    })
  });
});

const backgroundTag = {
  id: "background"
};
const isBackgroundModel = model => {
  var _model$settings$tags$, _model$settings, _model$settings$tags;
  return (_model$settings$tags$ = model == null ? void 0 : (_model$settings = model.settings) == null ? void 0 : (_model$settings$tags = _model$settings.tags) == null ? void 0 : _model$settings$tags.includes(backgroundTag.id)) != null ? _model$settings$tags$ : false;
};

function ModelSpawner({
  data,
  colorActions,
  materialActions,
  printActions
}) {
  return jsx(Suspense, {
    fallback: jsx(Loader, {}),
    children: jsx(K3Model, {
      model: data.model,
      meshProps: data.modelAction.props,
      fileURL: data.model.path,
      colorActions: colorActions,
      materialActions: materialActions,
      printActions: printActions,
      modelAction: data.modelAction,
      component: data.component
    }, "k3model" + data.modelAction.unique)
  });
}
/** Renders all 3D Models into the Scene */
function K3D() {
  var _modelData$filter;
  const k3dRef = useRef();
  const modelActions = useTypedSelector(selectModelActions);
  const materialActions = useTypedSelector(selectMaterialActions);
  const colorActions = useTypedSelector(selectColorActions);
  const printActions = useTypedSelector(selectPrintActions);
  const modelData = modelActions.map(modelAction => {
    const model = modelAction.model;
    let component = undefined;
    if (model.type === "dynamic") {
      component = getDynamicModelComponent(model, modelAction);
    }
    return {
      model,
      component,
      modelAction
    };
  }).filter(Boolean);
  return jsxs(Fragment, {
    children: [jsxs("group", {
      name: "k3d",
      ref: k3dRef,
      children: [jsx(MpHighlighters, {}), modelData == null ? void 0 : (_modelData$filter = modelData.filter(data => (data.model.path || data.component) && !isBackgroundModel(data.model))) == null ? void 0 : _modelData$filter.map((data, i) => {
        var _data$modelAction$uni;
        return jsx(ModelSpawner, {
          data: data,
          colorActions: colorActions,
          materialActions: materialActions,
          printActions: printActions
        }, (_data$modelAction$uni = data.modelAction.unique) != null ? _data$modelAction$uni : i);
      })]
    }, "k3d"), jsx("group", {
      name: "k3d-background",
      children: modelData.filter(data => (data.model.path || data.component) && isBackgroundModel(data.model)).map((data, i) => {
        var _data$modelAction$uni2;
        return jsx(ModelSpawner, {
          data: data,
          colorActions: colorActions,
          materialActions: materialActions,
          printActions: printActions
        }, (_data$modelAction$uni2 = data.modelAction.unique) != null ? _data$modelAction$uni2 : i);
      })
    }, "k3d-background")]
  });
}

const sleep = ms => new Promise(resolve => {
  setTimeout(resolve, ms);
});

function useFocusOnK3dScene() {
  const {
    scene
  } = useThree();
  const k3dRef = scene.getObjectByName("k3d");
  const bounds = useBounds();
  const camera = useTypedSelector(selectNextCameraPosition);
  const areModelsLoading = useTypedSelector(selectIsLoadingScene);
  useMemo(() => {
    if (!bounds) {
      return;
    }
    if (!camera && !areModelsLoading) {
      if (bounds && k3dRef) {
        bounds.refresh(k3dRef);
        bounds.fit();
      }
    }
    return () => {
      if (!camera && !areModelsLoading) {
        if (bounds && k3dRef) {
          bounds.refresh(k3dRef);
          bounds.fit();
        }
      }
    };
  }, [areModelsLoading, bounds, camera, k3dRef]);
}

const _excluded$b = ["animateOnMissed", "animate"];
const hasNoDefinedTargets = camera => isEmpty(camera == null ? void 0 : camera.modelIds) && isEmpty(camera == null ? void 0 : camera.objectNames);
const hasOnlyInvisibleTargets = (camera, boundingBox) => {
  const hasTargets = !hasNoDefinedTargets(camera);
  const areAllTargetsInvisible = boundingBox.isEmpty();
  return hasTargets && areAllTargetsInvisible;
};
const prewarmFrameCount = 2;
const extractSelectionIdFromModelname = modelName => {
  const regex = /anchoringSelectionId_(.+)/;
  const match = modelName.match(regex);
  return match ? match[1] : "";
};
/** When called with loading, it just returns null.
 * When called without state non-matching mp models are not filtered
 */
const selectFocusBoundingBox = (camera, scene, loading) => state => {
  if (loading) return null;
  const openInstance = state ? selectOpenInstance(state) : undefined;
  const parents = state ? selectParentSelections(openInstance, true)(state) : [];
  const modelIdsMap = ((camera == null ? void 0 : camera.modelIds) || []).reduce((acc, id) => Object.assign({}, acc, {
    [id]: true
  }), {});
  const objectNameMap = ((camera == null ? void 0 : camera.objectNames) || []).reduce((acc, name) => Object.assign({}, acc, {
    [name]: true
  }), {});
  const boundingBox = new Box3();
  if (!isEmpty(camera == null ? void 0 : camera.modelIds) || !isEmpty(camera == null ? void 0 : camera.objectNames)) {
    scene.traverse(object => {
      var _object$userData;
      if (!object.visible) {
        return;
      }
      const modelId = object == null ? void 0 : (_object$userData = object.userData) == null ? void 0 : _object$userData.modelId;
      if (modelId && modelIdsMap[modelId] || objectNameMap[object.name]) {
        const selectionId = extractSelectionIdFromModelname(object.name);
        if (state && selectionId) {
          const selection = selectSelectionById(selectionId)(state);
          if (selection &&
          // if the openSelection is "deep enough" our anchoring Selection could be part in its parents
          parents.some(s => s.variableId === selection.variableId) &&
          // but it actually is not
          !parents.some(s => selectionHasSamePosition(s, selection))) {
            // we do NOT want to focus our selection
            return;
          }
        }
        boundingBox.expandByObject(object);
      }
    });
  }
  return boundingBox;
};
function getNewCameraData(camera, focusBoundingBox, boundsApi) {
  var _boundsInfo;
  const [x, y, z] = camera.position;
  const cameraPosition = new Vector3(x, y, z);
  const focusOnAllObjects = hasNoDefinedTargets(camera);
  const objectToFit = focusOnAllObjects ? undefined : focusBoundingBox;
  let boundsInfo;
  // The boundsApi uses an internal ref on its child group when undefined is
  // passed in. Sometimes this ref is not set yet. So we need to catch this
  // error.
  try {
    var _boundsApi$refresh;
    boundsInfo = (_boundsApi$refresh = boundsApi.refresh(objectToFit)) == null ? void 0 : _boundsApi$refresh.getSize();
  } catch (e) {
    console.warn("BoundsApi not ready yet.");
  }
  if (!boundsInfo) {
    return {
      newPosition: cameraPosition.toArray(),
      newTarget: camera.lookAt
    };
  }
  const direction = new Vector3().subVectors(cameraPosition, new Vector3(...camera.lookAt)).normalize();
  const newPosition = direction.multiplyScalar(boundsInfo.distance).add(boundsInfo.center).toArray();
  const newTarget = (_boundsInfo = boundsInfo) == null ? void 0 : _boundsInfo.center.toArray();
  return {
    newPosition,
    newTarget
  };
}
function getCameraChangesRespectingBounds(camera, boundsApi, scene) {
  const focusBoundingBox = selectFocusBoundingBox(camera, scene, false)();
  const result = {
    position: camera.position,
    lookAt: camera.lookAt
  };
  if (boundsApi && camera && !hasOnlyInvisibleTargets(camera, focusBoundingBox)) {
    const {
      newPosition,
      newTarget
    } = getNewCameraData(camera, focusBoundingBox, boundsApi);
    result.position = newPosition;
    result.lookAt = newTarget;
  }
  return result;
}
/** Takes care of bounds and camera movement through groups and variables */
function K3CameraEffects(_ref) {
  let {
      animateOnMissed = false,
      animate = false
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$b);
  const contextBoundsApi = useBounds();
  const boundsApi = props.boundsApi || contextBoundsApi;
  const {
    scene,
    invalidate
  } = useThree();
  const camera = useTypedSelector(selectNextCameraPosition);
  useTypedSelector(selectForceNextCameraPosition);
  const isLoadingModelsOfActions = useTypedSelector(selectIsLoadingScene);
  const isLoadingScene = props.isLoadingSceneOverride === undefined ? isLoadingModelsOfActions : props.isLoadingSceneOverride;
  useFocusOnK3dScene();
  const clickAnimation = e => {
    e.stopPropagation();
    if (boundsApi && animate && e.delta <= 2) {
      boundsApi.refresh(e.object).fit();
    }
  };
  const k3dRef = scene.getObjectByName("k3d");
  const onPointerMissedAnimation = e => {
    if (boundsApi && animateOnMissed) {
      e.button === 0 && boundsApi.refresh(k3dRef).fit();
    }
  };
  const focus = useRef();
  const focusBoundingBox = useTypedSelector(selectFocusBoundingBox(camera, scene, isLoadingScene));
  // Somehow the useEffect hook we used here before did not trigger reliably.
  // Somehow the useMemo hook does. So erm ... yeah. useEffect is dead, long
  // live useMemo!
  useMemo(() => {
    if (!focusBoundingBox || isLoadingScene) return;
    const areTargetsInvisible = camera && hasOnlyInvisibleTargets(camera, focusBoundingBox);
    if (!boundsApi || !camera || areTargetsInvisible) {
      return;
    }
    const {
      newPosition,
      newTarget
    } = getNewCameraData(camera, focusBoundingBox, boundsApi);
    focus.current = {
      position: newPosition,
      target: newTarget,
      frameCount: 0
    };
    invalidate();
    return focus;
  }, [boundsApi, camera, invalidate, isLoadingScene]);
  // The following complexity is due to a bug in the bounds.to method. Since
  // this method does not take the on-demand render mode of the Canvas component
  // into account it might just jump to the final camera position without any
  // interpolation at all. This happens due to the delta time being too high in
  // on-demand render mode since the last rendered frame was potentially quite a
  // while ago. So my workaround triggers some initial renders. These
  // produce a "normal" delta time and afterwards I actually start the
  // interpolation to the new camera transformation. - Cl
  useFrame(() => {
    var _focus$current, _focus$current2;
    if (!(focus != null && focus.current)) return;
    if ((focus == null ? void 0 : (_focus$current = focus.current) == null ? void 0 : _focus$current.frameCount) < prewarmFrameCount) {
      focus.current.frameCount += 1;
      invalidate();
    } else if ((focus == null ? void 0 : (_focus$current2 = focus.current) == null ? void 0 : _focus$current2.frameCount) >= prewarmFrameCount) {
      boundsApi.to(focus.current);
      focus.current = undefined;
    }
  });
  return jsx("group", {
    onClick: clickAnimation,
    onPointerMissed: onPointerMissedAnimation,
    children: props.children
  });
}

const createCamera = (camera, boundsApi, scene) => {
  const dim = getScreenshotDimensions(1);
  const c = new PerspectiveCamera(camera.baseSettings.fov, dim.width / dim.height, camera.baseSettings.near, camera.baseSettings.far);
  const {
    position,
    lookAt
  } = getCameraChangesRespectingBounds(camera, boundsApi, scene);
  c.position.set(...position);
  c.lookAt(...lookAt);
  c.updateProjectionMatrix();
  return c;
};
const createScreenshotForThreeCam = async (app, state, threeCam) => {
  var _app$settings$screens, _app$settings;
  const quality = (_app$settings$screens = app == null ? void 0 : (_app$settings = app.settings) == null ? void 0 : _app$settings.screenshotQuality) != null ? _app$settings$screens : 0.8;
  // replace camera in three for the duration
  const oldCam = state.camera.clone();
  // @ts-ignore
  state.camera.copy(threeCam);
  state.camera.updateProjectionMatrix();
  await sleep(100); // ensure camera and content is updated
  state.gl.render(state.scene, threeCam);
  return await new Promise(resolve => {
    // @ts-ignore
    state.gl.domElement.toBlob(resolve, "image/jpeg", quality);
  }).then(blob => {
    // reset camera
    // @ts-ignore
    state.camera.copy(oldCam);
    state.camera.updateProjectionMatrix();
    return blob;
  });
};
const getScreenshotDimensions = numberOfScreenshots => {
  const originalDimensions = screenshotDimensions(numberOfScreenshots);
  return applyCallback("getScreenshotDimensions", originalDimensions);
};
const screenshotDimensions = numberOfScreenshots => {
  if (numberOfScreenshots < 3) return {
    width: 1920,
    height: 1080
  };
  if (numberOfScreenshots < 6) return {
    width: 1280,
    height: 720
  };
  return {
    width: 960,
    height: 540
  };
};
const createScreenshotForCamera = async (app, state, boundsApi, camera, index) => {
  const threeCam = createCamera(camera, boundsApi, state.scene);
  const blob = await createScreenshotForThreeCam(app, state, threeCam);
  // use index as camera key instead of id for easier pdf creation
  return {
    key: `camera_${index}`,
    file: URL.createObjectURL(blob)
  };
};
const useCreateScreenshotsOfCanvas = beforeScreenshot => {
  console.debug("Executing useCreateScreenshotsOfCanvas");
  const app = useTypedSelector(selectFrontendApp);
  const dispatch = useTypedDispatch();
  const cameras = useTypedSelector(selectModifiedGeneralCameras);
  const dim = getScreenshotDimensions(cameras.length);
  const threeState = useThree();
  const boundsApi = useBounds();
  const takePrettyPictures = useCallback(async () => {
    console.debug("Begin to take pictures");
    // this keeps filesize consistent
    threeState.gl.setPixelRatio(1);
    const screenshots = [];
    if (cameras.length) {
      // because we need the individual cameras to run sync, we need to use manual for loop instead of map
      for (let i = 0; i < cameras.length; i++) {
        const camera = cameras[i];
        screenshots.push(await createScreenshotForCamera(app, threeState, boundsApi, camera, i));
      }
    } else {
      // we clone the real cam, so we dont mutate what the user sees
      const clonedCam = threeState.camera.clone(true);
      clonedCam.aspect = dim.width / dim.height;
      clonedCam.updateProjectionMatrix();
      const blob = await createScreenshotForThreeCam(app, threeState, clonedCam);
      screenshots.push({
        key: "camera_0",
        file: URL.createObjectURL(blob)
      });
    }
    console.debug("Finish taking pictures");
    dispatch(setScreenshotting(screenshots));
    console.debug("Finish committing pictures to redux");
  }, [threeState, cameras, dispatch, app, boundsApi, dim.width, dim.height]);
  const triggerScreenshot = useCallback(async () => {
    var _window$oc;
    let retries = 0;
    while (retries < 20) {
      const state = threeState.get();
      // sometimes three seems to work with floats here (such as 1440.000001).
      // This is not a problem, but it is here without round.
      // breaking here because i want to use the state in the loop
      if (Math.round(state.size.width) == dim.width) break;
      console.debug("Screenshot hasn't resized yet. Should be attempted again soon.", state.size.width, dim.width, state.size, dim.height);
      await sleep(100);
      retries++;
    }
    if (retries === 20) {
      console.error("Attempted to screenshot for 2 seconds. Aborting.");
      dispatch(setScreenshotting([]));
      return;
    }
    const mountedState = (_window$oc = window.oc3) == null ? void 0 : _window$oc.get();
    if (!mountedState) {
      console.warn("Not screenshotting due to missing state");
      dispatch(setScreenshotting([]));
      return;
    }
    beforeScreenshot == null ? void 0 : beforeScreenshot();
    takePrettyPictures();
  }, [takePrettyPictures, dim, beforeScreenshot, dispatch, threeState]);
  useEffect(() => {
    triggerScreenshot();
  }, []);
};

const ScreenshotContext = /*#__PURE__*/createContext(() => {});
const K3CameraControl = props => {
  const dispatch = useTypedDispatch();
  useEffect(() => {
    dispatch(setIsScreenshottingPossible(true));
    return () => {
      dispatch(setIsScreenshottingPossible(false));
    };
  }, []);
  const isScreenshotting = useTypedSelector(selectScreenshotting) == "creating";
  const beforeScreenshot = useContext(ScreenshotContext);
  return jsxs(Fragment, {
    children: [isScreenshotting && jsx(Screenshotter, {
      beforeScreenshot: beforeScreenshot
    }), jsx(K3CameraEffects, Object.assign({}, props))]
  });
};
function Screenshotter({
  beforeScreenshot
}) {
  useCreateScreenshotsOfCanvas(beforeScreenshot);
  return null;
}

const K3Components = {
  K3D: K3D,
  K3BoundsFocus: K3CameraControl,
  K3Model: K3Model
};

const threeKeys = new Set(Object.keys(THREE));
/**
 * Thanks to https://medium.com/@Carmichaelize/dynamic-tag-names-in-react-and-jsx-17e366a684e9
 */
const loadThree = componentName => {
  if (threeKeys.has(componentName)) {
    return props => {
      const ComponentName = componentName;
      return jsx(ComponentName, Object.assign({}, props));
    };
  }
  return null;
};
const stub = componentName => {
  console.error("unknown 3D component", componentName);
  return () => jsx("group", {});
};
const getExternalComponent = componentName =>
// @ts-ignore
R3F[componentName] ||
// @ts-ignore
Drei[componentName] ||
// @ts-ignore
K3Components[componentName] ||
// @ts-ignore
PP[componentName] ||
// @ts-ignore
React__default[componentName] || loadThree(componentName) || stub(componentName);
const getExtendedSceneComponent = componentName => withExtensions({
  app: {
    k3d: {
      sceneComponents: {
        [componentName]: {
          root: true
        }
      }
    }
  }
})(getExternalComponent(componentName));

const K3Canvas = /*#__PURE__*/React__default.forwardRef((props, ref) => {
  return jsx(Canvas, Object.assign({}, props, {
    ref: ref,
    frameloop: "demand",
    children: props.children
  }));
});

/**
 * Creates your main canvas
 *
 * Uses a canvas you provide or the default fiber canvas.
 *
 * It also takes care of bridging the Contexts you specified in K3Main into
 * your 3D Scene and handles AR.
 */
const CanvasWithScreenshotting = ({
  canvas,
  canvasProps,
  beforeScreenshot,
  children
}) => {
  var _canvasProps$gl$logar, _canvasProps$gl;
  const {
    contexts
  } = useProvidedExtensions();
  const MainCanvas = canvas || Canvas;
  const isScreenshotting = useTypedSelector(selectScreenshotting) == "creating";
  const ContextBridge = useContextBridge(ExtensionContext, ...contexts);
  const cameras = useTypedSelector(selectModifiedGeneralCameras);
  const dimensions = useMemo(() => getScreenshotDimensions(cameras.length), [cameras]);
  return jsx(Box, {
    component: "div",
    sx: {
      height: "100%",
      width: "100%",
      bgcolor: "background.default"
    },
    children: jsx(Box, {
      component: "div",
      sx: Object.assign({
        height: "100%"
      }, isScreenshotting ? Object.assign({}, dimensions, {
        position: "absolute",
        visibility: "hidden"
      }) : {}),
      children: jsx(MainCanvas, Object.assign({}, canvasProps, {
        gl: Object.assign({}, canvasProps == null ? void 0 : canvasProps.gl, {
          logarithmicDepthBuffer: // We are using a logarithmic depth buffer for better depth
          // precision. If it for the rare case should be a performance
          // problem, you can disable it in the scene settings of the specific
          // configurator.
          // Here is a nice demo of this problem:
          // https://threejs.org/examples/#webgl_camera_logarithmicdepthbuffer
          (_canvasProps$gl$logar = canvasProps == null ? void 0 : (_canvasProps$gl = canvasProps.gl) == null ? void 0 : _canvasProps$gl.logarithmicDepthBuffer) != null ? _canvasProps$gl$logar : true
        }),
        onCreated: state => {
          window.oc3 = state;
          canvasProps == null ? void 0 : canvasProps.onCreated == null ? void 0 : canvasProps.onCreated(state);
        },
        children: jsx(ScreenshotContext.Provider, {
          value: beforeScreenshot,
          children: jsx(ContextBridge, {
            children: children
          })
        })
      }))
    })
  });
};

const TemplateChild = ({
  child
}) => {
  const DynamicComponent = useMemo(() => getExtendedSceneComponent(child.component), [child.component]);
  return jsx(DynamicComponent, Object.assign({}, child.props, {
    children: jsx(TemplateComponent, {
      sceneChildren: child.children
    })
  }));
};
const TemplateComponent = props => {
  const sceneChildren = props.sceneChildren || [];
  return jsx(Fragment, {
    children: sceneChildren.map((child, index) => jsx(TemplateChild, {
      child: child
    }, `${child.component}_${index}`))
  });
};
const removeComponentFromTemplate = (children = [], component = "", replaceWith) => {
  return children.map(child => {
    return child.component == component ? replaceWith : Object.assign({}, child, {
      children: removeComponentFromTemplate(child.children, component, replaceWith)
    });
  }).filter(c => c);
};
const DefaultK3DContent = /*#__PURE__*/React__default.forwardRef((props, ref) => {
  const app = useTypedSelector(selectFrontendApp);
  const editMode = useTypedSelector(selectEditMode);
  const template = useMemo(() => {
    return app != null && app.env ? app.env.template : SceneTemplates[0].template;
  }, [app]);
  const sceneChildren = useMemo(() => {
    return props.K3DReplace ? removeComponentFromTemplate(template.children, "K3D", props.K3DReplace) : template.children;
  }, [props.K3DReplace, template.children]);
  return jsx(K3DError, {
    template: template,
    children: jsxs(CanvasWithScreenshotting
    // @ts-ignore
    , {
      // @ts-ignore
      canvas: K3Canvas,
      canvasProps: Object.assign({}, template.canvasProps, {
        ref
      }),
      children: [editMode && jsx("axesHelper", {
        args: [5]
      }), !env.disable3D && jsxs(Fragment, {
        children: [jsx(TemplateComponent, {
          sceneChildren: sceneChildren
        }), jsx(K3DHooks, {})]
      }), props.children]
    })
  });
});
const K3DContent = withExtensions({
  app: {
    k3d: {
      root: true
    }
  }
})(DefaultK3DContent);

const Stage = ({
  app
}) => {
  switch (app == null ? void 0 : app.stage) {
    case StageType._3D:
      return jsx(K3DContent, {});
    case StageType.GALLERY:
      return jsx(GalleryContent, {});
    default:
      return null;
  }
};

const getContentBackgroundColor = theme => {
  var _theme$palette, _theme$palette$conten;
  return (theme == null ? void 0 : (_theme$palette = theme.palette) == null ? void 0 : (_theme$palette$conten = _theme$palette.content) == null ? void 0 : _theme$palette$conten.main) || "white";
};

const ContentViewTmp = ({
  app,
  children
}) => {
  const appTheme = useAppTheme();
  const is2D = useTypedSelector(selectIsApp2D(app));
  const isFullscreen = useTypedSelector(isFullscreen3DView);
  return jsxs(Box, {
    component: "div",
    sx: Object.assign({}, sxStyles$e.content, is2D ? sxStyles$e.content2d : sxStyles$e.content3d, {
      backgroundColor: getContentBackgroundColor(appTheme)
    }, isFullscreen ? fullscreenStyle : {}),
    children: [isFullscreen ? jsx(Box, {
      component: "div",
      sx: fullscreenButtonStyle,
      "data-cy": "fullscreenOverlays",
      children: jsx(FullscreenButton, {})
    }) : null, jsx(Stage, {
      app: app
    }), children]
  });
};
const ContentView = withExtensions({
  app: {
    contentView: {
      root: true
    }
  }
})(ContentViewTmp);
const fullscreenStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  zIndex: 5
};
// Wieso geht hier nicht 50vh? Sieht dann falsch aus...
const fullscreenButtonStyle = {
  position: "absolute",
  top: 16,
  right: 16,
  zIndex: 1001
};
const sxStyles$e = {
  content: {
    position: "relative",
    width: 1.0,
    height: 1.0
  },
  content3d: {},
  content2d: {
    backgroundColor: "#BBBBBB"
  }
};

const ExitButtonGroupWithData = () => {
  const dispatch = useTypedDispatch();
  const app = useTypedSelector(selectFrontendApp);
  const actions = getSettingsActions(app);
  return jsx(ExitButtonGroup, {
    actions: actions,
    setSelectedAction: action => dispatch(setCurrentAction(action))
  });
};
const IExitButtonGroup = ({
  setSelectedAction,
  actions
}) => {
  const md = new MobileDetect(window.navigator.userAgent);
  return jsx(Box, {
    component: "div",
    "data-cy": "actionButtons",
    children: jsx(ButtonGroup, {
      variant: "contained",
      orientation: md.mobile() ? "vertical" : "horizontal",
      children: actions.filter(action => !action.isDealerExit).map(action => jsx(Button, {
        "data-cy": `exit-${action.label.de}`,
        onClick: () => setSelectedAction(action),
        children: jsx(Typography, {
          noWrap: true,
          sx: {
            maxWidth: 150
          },
          children: jsx(LocalizedText, {
            value: action.label
          })
        })
      }, action.id))
    })
  });
};
const ExitButtonGroup = withExtensions({
  app: {
    exitButtons: {
      root: true
    }
  }
})(IExitButtonGroup);

const sxStyles$d = createStyleObject({
  label: {
    whiteSpace: "nowrap"
  },
  useContrastTextColor: {
    color: theme => theme.palette.primary.contrastText
  }
});
function GroupLabel({
  group,
  onClick,
  useContrastTextColor
}) {
  const ctx = useContext(ExtensionContext);
  const Label = useMemo(() => ctx.extendGroupLabel(({
    group,
    useContrastTextColor
  }) => jsx(Box, {
    component: "span",
    sx: mergeStyles(sxStyles$d.label,
    // @ts-ignore
    useContrastTextColor && sxStyles$d.useContrastTextColor),
    onClick: onClick,
    "data-cy": "group_" + (group == null ? void 0 : group.id),
    className: "group-label",
    children: group == null ? void 0 : group.label
  })), [ctx, onClick]);
  return jsx(Label, {
    group: group,
    useContrastTextColor: useContrastTextColor
  });
}

const HiddenGroupTooltip = ({
  children
}) => {
  const {
    t
  } = useTranslation();
  return jsx(Tooltip, {
    title: t("hiddenGroup"),
    children: children
  });
};

const _excluded$a = ["group", "isHiddenGroup", "iconPosition"];
const GroupTab = _ref => {
  var _group$settings, _group$settings$iconS, _group$settings2, _group$settings$iconS2, _group$settings3, _group$settings4, _group$settings$iconP, _group$settings5;
  let {
      group,
      isHiddenGroup,
      iconPosition
    } = _ref,
    tabProps = _objectWithoutPropertiesLoose(_ref, _excluded$a);
  const groupsTouchedByUser = useTypedSelector(selectVisibleGroupsTouchedByUser);
  const addCheckMarkToVisitedTabs = useTypedSelector(selectAddCheckMarkToVisitedTabs);
  const location = useLocation();
  const revealTabs = useTypedSelector(selectRevealGroups);
  const isGroupRevealed = useTypedSelector(selectIsGroupRevealed(group));
  const sxStyle = useMemo(() => Object.assign({}, tabProps.sx, revealTabs && !isGroupRevealed ? {
    opacity: 0,
    pointerEvents: "none"
  } : {}, {
    minHeight: "unset"
  }), [isGroupRevealed, revealTabs, tabProps.sx]);
  return jsx(Tab, Object.assign({
    className: isGroupRevealed ? "groupHeaderTab" : "invisibleGroupHeaderTab"
  }, tabProps, {
    sx: sxStyle,
    value: group.id,
    icon: group != null && (_group$settings = group.settings) != null && _group$settings.icon ? jsx("img", {
      alt: "",
      width: (_group$settings$iconS = group == null ? void 0 : (_group$settings2 = group.settings) == null ? void 0 : _group$settings2.iconSize) != null ? _group$settings$iconS : 24,
      height: (_group$settings$iconS2 = group == null ? void 0 : (_group$settings3 = group.settings) == null ? void 0 : _group$settings3.iconSize) != null ? _group$settings$iconS2 : 24,
      src: group == null ? void 0 : (_group$settings4 = group.settings) == null ? void 0 : _group$settings4.icon
    }) : null,
    iconPosition: iconPosition ? iconPosition : (_group$settings$iconP = group == null ? void 0 : (_group$settings5 = group.settings) == null ? void 0 : _group$settings5.iconPosition) != null ? _group$settings$iconP : "top",
    label: jsxs(Stack, {
      component: Paper,
      elevation: location != null && location.pathname.includes(`groups/${group.id}`) ? 4 : 0,
      direction: "row",
      spacing: 2,
      alignItems: "center",
      sx: {
        transition: "all 0.3s",
        color: location != null && location.pathname.includes(`groups/${group.id}`) ? "common.black" : "inherit",
        bgcolor: location != null && location.pathname.includes(`groups/${group.id}`) ? "common.white" : "transparent",
        pl: location != null && location.pathname.includes(`edit/conf`) ? 2 : 0
      },
      children: [isHiddenGroup && jsx(HiddenGroupTooltip, {
        children: jsx(VisibilityOffIcon, {
          sx: {
            color: theme => theme.palette.secondary.main
          }
        })
      }), addCheckMarkToVisitedTabs && jsx(Checkbox$1, {
        "data-cy": `visited`,
        color: "secondary",
        size: "small",
        sx: {
          p: 0,
          pr: "2px"
        },
        disableRipple: true,
        disableFocusRipple: true,
        checkedIcon: jsx(Check, {}),
        icon: jsx(Check, {
          style: {
            visibility: "hidden"
          }
        }),
        checked: !!groupsTouchedByUser.find(g => g.id === group.id)
      }), jsx(GroupLabel, {
        group: group
      })]
    })
  }));
};
const StandaloneGroupWrapper = props => {
  const group = useTypedSelector(selectGroupByKey(props.groupKey));
  const dispatch = useTypedDispatch();
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    jsx("div", {
      onClick: () => {
        dispatch(changeGroupThunk(group.id, true));
      },
      style: Object.assign({
        cursor: "pointer"
      }, props.style),
      children: props.children
    })
  );
};

const LocalizedHTML = ({
  value
}) => {
  const language = useTypedSelector(selectContentLanguage);
  return value && jsx(HTMLStringToReact, {
    htmlString: value[language]
  });
};

const sxStyles$c = {
  root: {
    overflow: "hidden"
  },
  labelContainer: {
    maxHeight: 24 * 6,
    boxSizing: "border-box",
    overflowY: "auto",
    overflowX: "hidden"
  }
};
const LabelActionsDisplayWithData = () => {
  const labelActions = useTypedSelector(selectLabelActions);
  return jsx(LabelActionsDisplay, {
    labelActions: labelActions
  });
};
const ILabelActionsDisplay = ({
  labelActions
}) => {
  if ((labelActions == null ? void 0 : labelActions.length) === 0) return null;
  return jsx(Box, {
    component: "div",
    sx: sxStyles$c.root,
    children: jsx(Box, {
      component: "div",
      sx: Object.assign({
        p: (labelActions == null ? void 0 : labelActions.length) && 0
      }, sxStyles$c.labelContainer),
      children: map(labelAction => jsx(Typography, {
        color: "text.primary",
        gutterBottom: true,
        children: jsx(LocalizedHTML, {
          value: labelAction.label
        })
      }, labelAction.ruleItemId), labelActions)
    })
  });
};
const LabelActionsDisplay = withExtensions({
  app: {
    labelActionDisplay: {
      root: true
    }
  }
})(ILabelActionsDisplay);

const selectSwitchVariable = key => state => {
  return state.layoutDesigner.switchVariables[key];
};

const initialState = {
  switchVariables: {}
};
const layoutDesignerSlice = createSlice({
  name: "layoutDesigner",
  initialState,
  reducers: {
    setSwitchVariable: (state, action) => {
      state.switchVariables[action.payload.key] = action.payload.value;
    }
  }
});
const {
  setSwitchVariable
} = layoutDesignerSlice.actions;
const layoutDesignerReducer = layoutDesignerSlice.reducer;

const SwitchButton = ({
  name,
  children
}) => {
  const dispatch = useTypedDispatch();
  const isStateOn = useTypedSelector(selectSwitchVariable(name));
  const handleClick = () => {
    dispatch(setSwitchVariable({
      key: name,
      value: !isStateOn
    }));
  };
  return jsx(Button, {
    onClick: handleClick,
    "data-cy": "customButton_" + name,
    children: children
  });
};

const SwitchState = ({
  enabled: _enabled = false,
  name,
  variableKey,
  children
}) => {
  const isStateOnFromLayout = useTypedSelector(selectSwitchVariable(name || ""));
  const isStateOnFromVariable = useSelectedValueByVariableKey(variableKey || "");
  const valueAsBoolean = !!(isStateOnFromVariable != null && isStateOnFromVariable.value) && (isStateOnFromVariable == null ? void 0 : isStateOnFromVariable.value) !== "false" && (isStateOnFromVariable == null ? void 0 : isStateOnFromVariable.value) !== "0";
  const showContent = !!name && !!isStateOnFromLayout || !!variableKey && valueAsBoolean ? _enabled : !_enabled;
  return showContent ? jsx(Fragment, {
    children: children
  }) : null;
};
const SwitchStateOn = ({
  name,
  variableKey,
  children
}) => {
  return jsx(SwitchState, {
    name: name,
    variableKey: variableKey,
    enabled: true,
    children: children
  });
};
const SwitchStateOff = ({
  name,
  variableKey,
  children
}) => {
  return jsx(SwitchState, {
    name: name,
    variableKey: variableKey,
    enabled: false,
    children: children
  });
};

const getLogoSettings = app => {
  var _app$settings, _app$settings$ext, _app$settings$ext$the;
  return app == null ? void 0 : (_app$settings = app.settings) == null ? void 0 : (_app$settings$ext = _app$settings.ext) == null ? void 0 : (_app$settings$ext$the = _app$settings$ext.theme) == null ? void 0 : _app$settings$ext$the.logo;
};

const getLogoLink = app => {
  var _getLogoSettings;
  return ((_getLogoSettings = getLogoSettings(app)) == null ? void 0 : _getLogoSettings.link) || "";
};
const getSafeLogoLink = app => {
  var _getLogoSettings2;
  const link = ((_getLogoSettings2 = getLogoSettings(app)) == null ? void 0 : _getLogoSettings2.link) || "";
  if (!link) return link;
  if (link.startsWith("http")) return link;
  return `https://${link}`;
};

const getLogoOpacity = app => {
  var _getLogoSettings;
  return ((_getLogoSettings = getLogoSettings(app)) == null ? void 0 : _getLogoSettings.opacity) || 0.75;
};

const getLogoSize = app => {
  var _getLogoSettings;
  const size = (_getLogoSettings = getLogoSettings(app)) == null ? void 0 : _getLogoSettings.size;
  return size ? +size : 200;
};

const getLogoUrl = app => {
  var _app$settings;
  return app == null ? void 0 : (_app$settings = app.settings) == null ? void 0 : _app$settings.logo;
};

const LogoWithData = ({
  app
}) => {
  var _useTypedSelector, _useTypedSelector$app;
  const dealerApp = (_useTypedSelector = useTypedSelector(selectDealerData)) == null ? void 0 : (_useTypedSelector$app = _useTypedSelector.apps) == null ? void 0 : _useTypedSelector$app.find(da => da.appId == app.id);
  const internalApp = dealerApp && getLogoUrl(dealerApp) ? dealerApp : app;
  const logoUrl = getLogoUrl(internalApp) || "";
  const logoSize = getLogoSize(internalApp);
  const logoOpacity = getLogoOpacity(internalApp);
  const logoLink = getSafeLogoLink(internalApp);
  return jsx(Logo, {
    logoUrl: logoUrl,
    logoSize: logoSize,
    logoOpacity: logoOpacity,
    link: logoLink
  });
};
const ILogo = ({
  logoUrl,
  logoSize,
  logoOpacity,
  link
}) => {
  const {
    t
  } = useTranslation();
  const showEditor = useTypedSelector(selectShowEditorUi);
  const isAdmin = useTypedSelector(selectIsAdminPanel);
  const nav = useNavigate();
  const openLink = () => {
    if (!link) return;
    window.open(link, "_blank");
  };
  return jsxs(Stack, {
    direction: "row",
    spacing: 2,
    sx: {
      alignItems: "center",
      cursor: link ? "pointer" : "default"
    },
    children: [logoUrl && jsx(Box, {
      component: "div",
      sx: {
        width: logoSize
      },
      onClick: openLink,
      children: jsx("img", {
        style: {
          height: "auto",
          width: logoSize,
          boxSizing: "border-box",
          padding: 1,
          opacity: logoOpacity,
          position: "relative"
        },
        alt: "logo",
        src: logoUrl,
        "data-cy": "logoImage"
      })
    }), showEditor && isAdmin && jsx(EditButton, {
      "data-cy": "editLogoButton",
      tooltip: t("change logo"),
      onClick: () => nav("logo")
    })]
  });
};
const Logo = withExtensions({
  app: {
    logo: {
      root: true
    }
  }
})(ILogo);

const PriceWithData = () => {
  const showPrice = useTypedSelector(selectFrontendAppShowPrice);
  const overallPrice = useTypedSelector(selectOverallPrice);
  const priceFormatter = useTypedSelector(selectPriceFormatter);
  return showPrice ? jsx(Price, {
    price: overallPrice,
    priceFormatter: priceFormatter
  }) : null;
};
const PriceDataFromVariable = props => {
  var _currencyByAttribute$;
  const currencyByVariable = useSelectedValueByVariableKey(props.currencyVariableKey || "currency");
  const currencyByAttribute = useSelectedValueAttributesByKeys(props.currencyVariableKey, [props.currencyAttributeKey])[0];
  const lang = useTypedSelector(selectContentLanguage);
  //currencyByVariable?.label can in other languages return "[currency]" instead of "currency". So we remove the brackets.
  const currency = (currencyByAttribute == null ? void 0 : (_currencyByAttribute$ = currencyByAttribute.value) == null ? void 0 : _currencyByAttribute$.toString()) || (currencyByVariable == null ? void 0 : currencyByVariable.label.replace(/\[|\]/g, "")) || "EUR";
  return jsx(PriceData, {
    currency: currency,
    type: "overall",
    language: lang
  });
};
const PriceData = props => {
  const showPrice = useTypedSelector(selectFrontendAppShowPrice);
  const overallPrice = useTypedSelector(selectOverallPrice);
  const nettoPrice = useMemo(() => overallPrice / (1 + (props.mwst || 0)), [overallPrice, props.mwst]);
  const mwstPrice = useMemo(() => overallPrice - nettoPrice, [nettoPrice, overallPrice]);
  const defaultPriceFormatter = useTypedSelector(selectPriceFormatter);
  const priceFormatter = useMemo(() => {
    if (props.language && props.currency) return new Intl.NumberFormat(props.language, {
      style: "currency",
      currency: props.currency
    });
    return defaultPriceFormatter;
  }, [props.currency, props.language, defaultPriceFormatter]);
  const priceToShow = useMemo(() => priceFormatter.format(props.type === "overall" ? overallPrice : props.type === "netto" ? nettoPrice : mwstPrice), [props.type, overallPrice, nettoPrice, mwstPrice, priceFormatter]);
  return showPrice ? jsx(Fragment, {
    children: priceToShow
  }) : null;
};
const IPrice = props => {
  var _app$productDetails;
  const {
    price,
    priceFormatter,
    sx
  } = props;
  const app = useTypedSelector(selectFrontendApp);
  if (!((_app$productDetails = app.productDetails) != null && _app$productDetails.price)) return null;
  return jsx(Typography, {
    sx: Object.assign({
      display: "grid",
      bgcolor: "background.default",
      borderRadius: 1,
      color: "text.primary",
      placeContent: "center",
      px: 2,
      py: 1,
      height: "max-content"
    }, sx),
    "data-cy": "price",
    children: priceFormatter.format(price)
  });
};
const Price = withExtensions({
  app: {
    price: {
      root: true
    }
  }
})(IPrice);

const InternalSceneButtonGroup = ({
  children
}) => {
  const app = useTypedSelector(selectFrontendApp);
  const isEditor = useTypedSelector(selectShowEditorUi);
  return jsxs(Stack, {
    direction: "column",
    spacing: 1,
    children: [app.stage === "3D" && jsxs(Stack, {
      direction: "row",
      children: [jsx(ARButton, {}), Boolean(isEditor) && jsx(EditDynamicSettings, {
        keys: [DynamicSettingsKeys.AR_BUTTON]
      })]
    }), children]
  });
};
const SceneButtonGroup = withExtensions({
  app: {
    sceneButtons: {
      root: true
    }
  }
})(InternalSceneButtonGroup);

const socialData = [{
  key: "facebook",
  label: "Facebook",
  href: "https://www.facebook.com/sharer/sharer.php?u=",
  Icon: jsx(Facebook, {
    fontSize: "inherit"
  })
}, {
  key: "linkedin",
  label: "LinkedIn",
  href: "https://twitter.com/intent/tweet?text=&url=",
  Icon: jsx(Twitter, {
    fontSize: "inherit"
  })
}, {
  key: "twitter",
  label: "Twitter",
  href: "https://www.linkedin.com/shareArticle?mini=true&url=",
  Icon: jsx(LinkedIn, {
    fontSize: "inherit"
  })
}];
function SocialShareButtons() {
  const dispatch = useTypedDispatch();
  const app = useTypedSelector(selectFrontendApp);
  const handleClick = async href => {
    const id = dispatch(requestLoadingThunk("social"));
    const code = await dispatch(saveCurrentConfigurationThunk("Configuration", {
      id: "social-share",
      label: {}
    }, {}));
    const url = getAppUrl(app, code == null ? void 0 : code.code);
    window.open(href + url, "_blank");
    dispatch(finishLoading(id));
  };
  return jsx(Stack, {
    direction: "row",
    spacing: 1,
    justifyContent: "end",
    children: socialData.map(({
      key,
      label,
      href,
      Icon
    }) => {
      var _app$settings, _app$settings$share;
      return (
        // @ts-ignore
        (app == null ? void 0 : (_app$settings = app.settings) == null ? void 0 : (_app$settings$share = _app$settings.share) == null ? void 0 : _app$settings$share[key]) && jsx(Tooltip, {
          title: `Auf ${label} teilen.`,
          children: jsx(IconButton, {
            "data-cy": `social-${key}`,
            size: "large",
            color: "primary",
            onClick: () => handleClick(href),
            children: Icon
          }, key)
        }, key)
      );
    })
  });
}

const updateRuleItemThunk = updatedRuleItem => async dispatch => {
  dispatch(updateRuleItem(updatedRuleItem));
  return api_updateResource("ruleitem", updatedRuleItem);
};

function EditScene() {
  const modelsData = useTypedSelector(selectModelRuleData);
  const ruleItems = useTypedSelector(selectRuleItems);
  const editMode = useTypedSelector(selectEditMode);
  const models = useTypedSelector(selectModels);
  const isEditor = useTypedSelector(selectShowEditorUi);
  const app = useTypedSelector(selectFrontendApp);
  const dispatch = useTypedDispatch();
  const t = useTranslation().t;
  const queryClient = useQueryClient();
  const modelActions = useTypedSelector(selectModelActions);
  const cancel = () => {
    queryClient.resetQueries(["metadata"]);
    dispatch(clearModelRuleData());
    dispatch(setEditMode(false));
  };
  const findRuleItem = data => ruleItems.find(ruleItem => {
    var _Object$values, _Object$values$find, _ruleItem$values;
    return Number(data.ruleItemId) == (ruleItem == null ? void 0 : ruleItem.id) && (data == null ? void 0 : data.modelId) == ((_Object$values = Object.values((_ruleItem$values = ruleItem == null ? void 0 : ruleItem.values) != null ? _ruleItem$values : [])) == null ? void 0 : (_Object$values$find = _Object$values.find(val => isModelActionRuleValue(val) && (val == null ? void 0 : val.modelId))) == null ? void 0 : _Object$values$find.modelId);
  });
  const findModelAction = data => modelActions.find(ma => {
    var _ma$ruleItem;
    return (data.ruleItemId === "main" ? !ma.ruleItem : ((_ma$ruleItem = ma.ruleItem) == null ? void 0 : _ma$ruleItem.id) === +data.ruleItemId) && ma.model.id === data.modelId;
  });
  const warnings = useMemo(() => Object.entries(modelsData).flatMap(([ruleItemId, value]) => {
    var _propMapper;
    const modelAction = findModelAction(value);
    if (!modelAction) return [];
    const dynamicModel = modelAction.model.dynamicModelKey ? getDynamicModels().find(m => m.type === modelAction.model.dynamicModelKey) : undefined;
    const propMapper = (dynamicModel == null ? void 0 : dynamicModel.repositionApplicator) || defaultRepositionApplicator;
    const newProps = (_propMapper = propMapper("number")(modelAction.props, modelAction.expressionProps)(value.position, value.rotation)) != null ? _propMapper : {};
    const changes = Object.entries(modelAction.props).flatMap(([key, prop]) => {
      const isPropArray = isArray$6(prop);
      const valueArray = isPropArray ? prop : [prop];
      const newPropArray = isArray$6(newProps[key]) ? newProps[key] : [newProps[key]];
      const originalPropArray = isArray$6(modelAction.expressionProps[key]) ? modelAction.expressionProps[key] : [modelAction.expressionProps[key]];
      return valueArray.map((v, i) => {
        if (isNumber(v) && v !== newPropArray[i] && isNonPrimitiveExpression(originalPropArray[i])) {
          return isPropArray && prop.length === 3 ? `${"XYZ"[i]}-${key}` : key;
        }
        return null;
      }).filter(Boolean);
    });
    return changes.map(change => ({
      message: `Derzeit wird eine Expression genutzt, um die ${change} des Modells ${modelAction.model.label} zu setzen. Diese wird überschrieben.`
    }));
  }), [modelsData]);
  function updateModelRules() {
    return async () => {
      const updatePromises = Object.entries(modelsData).map(async ([ruleItemId, value]) => {
        const modelAction = findModelAction(value);
        if (!modelAction) return;
        const dynamicModel = modelAction.model.dynamicModelKey ? getDynamicModels().find(m => m.type === modelAction.model.dynamicModelKey) : undefined;
        const propMapper = (dynamicModel == null ? void 0 : dynamicModel.repositionApplicator) || defaultRepositionApplicator;
        const newProps = propMapper("expression")(modelAction.props, modelAction.expressionProps)(value.position, value.rotation);
        // main model
        if (ruleItemId == "main") {
          const model = cloneDeep(models.find(model => model.id == value.modelId));
          if (!model) return;
          model.props = Object.assign({}, model.props, newProps);
          await dispatch(updateModelThunk(model));
        } else {
          const ruleItem = cloneDeep(findRuleItem(value));
          if (!ruleItem) return;
          const ruleItemModelActionValue = Object.values(ruleItem.values).find(val => isModelActionRuleValue(val) && val.modelId);
          if (!ruleItemModelActionValue) return;
          ruleItemModelActionValue.props = Object.assign({}, ruleItemModelActionValue.props, newProps);
          await dispatch(updateRuleItemThunk(ruleItem));
        }
      });
      await Promise.all(updatePromises);
      dispatch(setEditMode(false));
      dispatch(clearModelRuleData());
    };
  }
  if (!isEditor || app.stage !== "3D") return null;
  return jsxs(Stack, {
    spacing: 1,
    sx: {
      zIndex: 500
    },
    children: [jsx(Button, {
      "data-cy": "edit-positions",
      onClick: () => dispatch(setEditMode(!editMode)),
      startIcon: jsx(CropRotate, {}),
      variant: "outlined",
      children: t("edit-positions")
    }), editMode && jsxs(Stack, {
      direction: "row",
      sx: {
        justifyContent: "space-around"
      },
      children: [!!warnings.length && jsx(Tooltip, {
        title: jsxs(Stack, {
          children: [warnings.map(w => {
            return jsx(Typography, {
              mb: 2,
              children: w.message
            }, w.message);
          }), jsx(Typography, {
            children: t("Klicken um abzubrechen.")
          })]
        }),
        children: jsx(IconButton, {
          "data-cy": "cancel-scene-positions",
          color: "error",
          onClick: () => cancel(),
          children: jsx(WarningIcon, {
            className: "changeWarning",
            color: "error"
          })
        })
      }), jsx(Tooltip, {
        title: t("cancel"),
        children: jsx(IconButton, {
          "data-cy": "cancel-scene-positions",
          color: "error",
          onClick: () => cancel(),
          children: jsx(Cancel$4, {})
        })
      }), jsx(Tooltip, {
        title: t("save"),
        children: jsx(IconButton, {
          "data-cy": "save-scene-positions",
          color: "primary",
          onClick: updateModelRules(),
          children: jsx(SaveAs, {})
        })
      })]
    })]
  });
}

const AdditionalGroups = props => {
  const ctx = useContext(ExtensionContext);
  const AdditionalGroups = ctx.extendAdditionalGroups(() => null);
  return jsx(AdditionalGroups, {
    design: props.design
  });
};

const _excluded$9 = ["children", "onDragEnd", "isDragDisabled"],
  _excluded2 = ["children"];
const sxStyles$b = createStyleObject({
  listItemContainer: {
    position: "relative"
  },
  dragHandleContainer: {
    position: "absolute",
    width: "20px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    visibility: "visible",
    top: "4px",
    left: "-4px",
    bottom: "0",
    fontSize: "1.25em"
  },
  visible: {
    visibility: "visible"
  },
  hidden: {
    visibility: "hidden"
  },
  dragHandle: {
    cursor: "grabbing"
  }
});
const DragHandle$1 = ({
  disabled: _disabled = false,
  provided
}) => jsx(Box, {
  component: "div",
  sx: mergeStyles(sxStyles$b.dragHandleContainer, _disabled ? sxStyles$b.hidden : sxStyles$b.visible),
  children: jsx("div", Object.assign({}, provided.dragHandleProps, {
    children: jsx(DragIndicator, {
      color: "inherit",
      sx: sxStyles$b.dragHandle
    })
  }))
});
function DnDTabs(_ref) {
  let {
      children,
      onDragEnd,
      isDragDisabled = false
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$9);
  const handleDragEnd = useCallback(result => {
    if (!result.destination) {
      return;
    }
    if (onDragEnd) onDragEnd(result);
  }, [onDragEnd]);
  const disabled = !onDragEnd || isDragDisabled;
  const newChildren = useMemo(() => React__default.Children.map(children, (child, index) => {
    const key = child.key;
    return /*#__PURE__*/React__default.cloneElement(child, {
      component: /*#__PURE__*/React__default.forwardRef((_ref2, refTab) => {
        let {
            children
          } = _ref2,
          props = _objectWithoutPropertiesLoose(_ref2, _excluded2);
        return jsx(Draggable, {
          draggableId: key,
          index: index,
          isDragDisabled: disabled,
          children: provided => jsx(Box, Object.assign({
            component: "div"
          }, provided.draggableProps, {
            ref: provided.innerRef,
            children: jsxs(Stack, Object.assign({
              component: "div",
              direction: "row",
              spacing: 1
            }, props, {
              ref: refTab,
              children: [children, jsx(DragHandle$1, {
                provided: provided,
                disabled: disabled
              })]
            }))
          }))
        }, key);
      })
    });
  }), [children, disabled]);
  return jsx(DragDropContext, {
    onDragEnd: handleDragEnd,
    children: jsx(Droppable, {
      droppableId: "droppableADF",
      direction: "horizontal",
      children: (provided, snapshot) => jsxs(Tabs, Object.assign({
        id: "VFOTEST"
      }, props, provided.droppableProps, {
        ref: provided.innerRef,
        value: snapshot.isDraggingOver ? false : props.value,
        sx: {
          ".MuiTabs-flexContainer": {
            alignItems: "center"
          },
          ".MuiTabs-scroller": {
            display: "flex",
            alignItems: "center"
          }
        },
        children: [newChildren, provided.placeholder]
      }))
    })
  });
}

const withHeaderExtension = WrappedHeader => props => {
  const ctx = useContext(ExtensionContext);
  // @ts-ignore
  const Header = useMemo(() => ctx.extendHeader(WrappedHeader), [ctx]);
  return jsx(Header, Object.assign({}, props));
};

const GroupsNavigation = ({
  children
}) => {
  const sidebarGroups = useTypedSelector(selectGroupsForOpenInstance);
  const focusGroupId = useTypedSelector(selectFocusGroupId);
  if (!sidebarGroups) {
    return null;
  }
  return jsx(Header, {
    groups: sidebarGroups,
    focusGroupId: focusGroupId,
    children: children
  });
};
const HeaderTabs = ({
  openInstance,
  group,
  groups,
  handleTabChange,
  onDragEnd,
  invisibleGroups,
  showEditorUi
}) => {
  var _group$id;
  return jsxs(Fragment, {
    children: [(openInstance == null ? void 0 : openInstance.variableId) && jsx(ComponentBreadcrumbs, {
      useDelete: true
    }), jsx(DnDTabs, {
      "data-cy": `GroupsNavigationTabs`,
      variant: "scrollable",
      scrollButtons: "auto",
      textColor: "inherit",
      value: (group == null ? void 0 : (_group$id = group.id) == null ? void 0 : _group$id.toString()) || false,
      sx: {
        flexGrow: 1,
        color: "white"
      },
      onChange: handleTabChange,
      onDragEnd: onDragEnd,
      children: groups.reduce((acc, group) => {
        var _group$id2, _group$id3;
        const isHiddenGroup = isHidden(group, invisibleGroups);
        if (!showEditorUi && isHiddenGroup) {
          return acc;
        }
        return [...acc, jsx(GroupTab, {
          "data-cy": `group-${group.label}`,
          value: (_group$id2 = group.id) == null ? void 0 : _group$id2.toString(),
          group: group,
          isHiddenGroup: isHiddenGroup
        }, (_group$id3 = group.id) == null ? void 0 : _group$id3.toString())];
      }, [])
    }), jsx(AdditionalGroups, {
      design: "topmenu"
    })]
  });
};
const HeaderBarI = props => {
  return jsxs(AppBar, {
    sx: {
      display: "grid",
      gridTemplateColumns: "max-content 1fr max-content",
      overflow: "auto"
    },
    position: "static",
    "data-cy": "groupHeader",
    children: [jsx(Toolbar, {
      children: jsx(HeaderTabs, Object.assign({}, props))
    }), props.children]
  });
};
const HeaderBar = withExtensions({
  app: {
    header: {
      root: true
    }
  }
})(HeaderBarI);
const HeaderTmp = function HeaderTmp(props) {
  const {
    groups = [],
    focusGroupId,
    onDragEnd,
    children
  } = props;
  const showEditorUi = useTypedSelector(selectShowEditorUi);
  const dispatch = useTypedDispatch();
  const group = groups.find(group => group.id == focusGroupId);
  const invisibleGroups = useTypedSelector(selectInvisibleGroups);
  const openInstance = useTypedSelector(selectOpenInstance);
  const handleTabChange = useCallback((_, newFocusGroupIdString) => {
    const groupId = maybeParseInt(newFocusGroupIdString);
    dispatch(changeGroupThunk(groupId, false));
  }, [dispatch]);
  return jsx(HeaderBar, Object.assign({}, props, {
    showEditorUi: showEditorUi,
    group: group,
    invisibleGroups: invisibleGroups,
    openInstance: openInstance,
    handleTabChange: handleTabChange
  }));
};
const Header = withHeaderExtension(HeaderTmp);

const AdditionalVariables = function AdditionalVariables({
  group,
  variables
}) {
  const ctx = useContext(ExtensionContext);
  const AdditionalVariables = ctx.extendAdditionalVars(() => null);
  return jsx(AdditionalVariables, {
    group: group,
    variables: variables
  });
};

const DragHandle = ({
  disabled,
  provided
}) => {
  return jsx(Box$2, {
    component: "div",
    sx: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "center",
      visibility: disabled ? "hidden" : "visible"
    },
    children: jsx(IconButton, Object.assign({
      disableRipple: true,
      component: "div"
    }, provided.dragHandleProps, {
      children: jsx(DragIndicator, {
        color: "action",
        sx: {
          cursor: "grabbing"
        }
      })
    }))
  });
};

const DragHandleContext = /*#__PURE__*/createContext(null);
const DnDListChildren = ({
  id,
  child,
  isDisabled
}) => {
  var _newChild$key;
  const newChild = /*#__PURE__*/cloneElement(child);
  const key = ((_newChild$key = newChild.key) == null ? void 0 : _newChild$key.toString()) || "";
  const childrenContainer = useRef(null);
  const [hasHeight, setHasHeight] = useState(true);
  useLayoutEffect(() => {
    setHasHeight((childrenContainer == null ? void 0 : childrenContainer.current) === null || childrenContainer.current.clientHeight > 0);
  }, [child]);
  return jsx(Draggable, {
    draggableId: key,
    index: id,
    isDragDisabled: isDisabled,
    children: provided => jsx(Grid, Object.assign({
      item: true,
      ref: provided.innerRef
    }, provided.draggableProps, {
      sx: hasHeight ? {
        position: "relative",
        paddingTop: 1,
        paddingLeft: 1,
        paddingRight: 1,
        marginBottom: 2,
        boxSizing: "border-box"
      } : {},
      children: jsx(Box$2, {
        component: "div",
        ref: childrenContainer,
        children: jsx(Fragment, {
          children: jsx(DragHandleContext.Provider, {
            value: jsx(DragHandle, {
              provided: provided,
              disabled: isDisabled
            }),
            children: newChild
          })
        })
      })
    }), key)
  });
};

function DnDList({
  sx,
  children,
  isDragDisabled = false,
  onDragEnd
}) {
  const handleDragEnd = result => {
    if (!result.destination) {
      return;
    }
    const sourceIndex = result.source.index;
    const destinationIndex = result.destination.index;
    if (sourceIndex === destinationIndex) {
      return;
    }
    if (onDragEnd) onDragEnd(result);
  };
  const disabled = !onDragEnd || isDragDisabled;
  return jsx(DragDropContext, {
    onDragEnd: handleDragEnd,
    children: jsx(Droppable, {
      droppableId: "droppable",
      children: (provided, _) => jsxs(Grid, Object.assign({
        container: true,
        direction: "column",
        sx: sx,
        ref: provided.innerRef
      }, provided.droppableProps, {
        children: [Children.map(children, (child, index) => jsx(DnDListChildren, {
          id: index,
          isDisabled: disabled,
          child: child
        }, index)), provided.placeholder]
      }))
    })
  });
}

const withGroupPanelExtension = GroupPanel => props => {
  const ctx = useContext(ExtensionContext);
  const WrappedGroupPanel = useMemo(() => ctx != null && ctx.extendGroupPanel ? ctx == null ? void 0 : ctx.extendGroupPanel(GroupPanel) : GroupPanel, [ctx]);
  return jsx(WrappedGroupPanel, Object.assign({}, props));
};

const GroupPanelTmp = ({
  onDragEnd,
  group
}) => {
  const {
    openInstance
  } = useTypedSelector(selectRuleEngineInfo);
  const handleChange = useHandleChange();
  const allVariables = useTypedSelector(selectVariablesOfGroup(group == null ? void 0 : group.id)).filter(variable => {
    return openInstance.id === "" ? variable.groupId === (group == null ? void 0 : group.id) : openInstance.variableId === variable.parentId;
  });
  return jsxs(Box, {
    component: "div",
    children: [jsx(DnDList, {
      sx: {
        marginTop: 0
      },
      onDragEnd: onDragEnd,
      children: allVariables == null ? void 0 : allVariables.filter(v => TemplateComponentsByType[getTemplate(v)] && !getTemplateOptions(v).hideFromGroup).sort(byOrder).map(variable => jsx(VariableTemplateWrapper, {
        variable: variable,
        handleChange: handleChange,
        withPaperWrapper: true
      }, variable.id))
    }), jsx(AdditionalVariables, {
      group: group,
      variables: allVariables
    })]
  });
};
const GroupPanel = withGroupPanelExtension(GroupPanelTmp);

const AccordionGroupPanel = ({
  group,
  isHiddenGroup
}) => {
  const dispatch = useTypedDispatch();
  const focusGroupId = useTypedSelector(selectFocusGroupId);
  const handleExpansion = (groupID, prevGroupID) => () => {
    if (prevGroupID) {
      dispatch(setTouchedByUserFromFocusGroupChangeThunk(prevGroupID));
    }
    dispatch(setGroup(groupID === prevGroupID ? null : groupID));
  };
  const groupsTouchedByUser = useTypedSelector(selectVisibleGroupsTouchedByUser);
  const addCheckMarkToVisitedTabs = useTypedSelector(selectAddCheckMarkToVisitedTabs);
  const isGroupRevealed = useTypedSelector(selectIsGroupRevealed(group));
  return jsxs(Accordion, {
    expanded: focusGroupId === group.id,
    onChange: handleExpansion(group.id, focusGroupId),
    className: isGroupRevealed ? "groupAccordion" : "invisibleGroupAccordion",
    sx: !isGroupRevealed ? {
      visibility: "hidden"
    } : {},
    children: [jsx(AccordionSummary, {
      expandIcon: jsx(ExpandMore, {}),
      className: "groupAccordionSummary",
      children: jsx(Typography, {
        component: "div",
        children: jsxs(Box, {
          component: "div",
          sx: {
            display: "flex",
            alignItems: "center"
          },
          children: [addCheckMarkToVisitedTabs && jsx(Checkbox$1, {
            "data-cy": `visitedTabs`,
            color: "secondary",
            disableRipple: true,
            disableFocusRipple: true,
            checked: !!groupsTouchedByUser.find(g => g.id === group.id)
          }), jsx(GroupLabel, {
            group: group
          }), isHiddenGroup && jsx(HiddenGroupTooltip, {
            children: jsx(VisibilityOffIcon, {
              sx: {
                color: theme => theme.palette.secondary.main,
                marginLeft: 1,
                marginRight: 1
              }
            })
          })]
        })
      })
    }), jsx(AccordionDetails, {
      sx: {
        backgroundColor: theme => theme.palette.background.default
      },
      children: jsx(GroupPanel, {
        group: group
      })
    })]
  });
};

const SidebarWithData = ({
  design,
  scrollable,
  hideBreadcrumb
}) => {
  const sidebarGroups = useTypedSelector(selectGroupsForOpenInstance);
  const invisibleGroups = useTypedSelector(selectInvisibleGroups);
  const currentGroup = useTypedSelector(selectCurrentGroup);
  return jsx(Sidebar, {
    invisibleGroups: invisibleGroups,
    groups: sidebarGroups,
    group: currentGroup,
    design: design,
    scrollable: scrollable,
    hideBreadcrumb: hideBreadcrumb
  });
};
const SidebarTmp = props => {
  const {
    design,
    group,
    groups,
    invisibleGroups,
    scrollable,
    hideBreadcrumb
  } = props;
  const showEditorUi = useTypedSelector(selectShowEditorUi);
  return jsx(Box, {
    component: "div",
    sx: {
      height: "100%",
      width: "100%",
      pt: 2,
      overflowY: scrollable ? "scroll" : "auto"
    },
    "data-cy": "sidebarWrapper",
    children:
    // @ts-ignore
    {
      accordion: jsxs(Fragment, {
        children: [!hideBreadcrumb && jsx(ComponentBreadcrumbs, {
          useDivider: true
        }), jsx(SidebarHeader, Object.assign({}, props)), groups.map(group => {
          const isHiddenGroup = isHidden(group, invisibleGroups);
          if (!showEditorUi && isHiddenGroup) {
            return null;
          }
          return jsx(AccordionGroupPanel, {
            group: group,
            isHiddenGroup: isHiddenGroup
          }, group.id);
        }).filter(c => !!c), jsx(AdditionalGroups, {
          design: design
        }), jsx(SidebarFooter, Object.assign({}, props))]
      }),
      topmenu: jsxs(Fragment, {
        children: [!hideBreadcrumb && jsx(ComponentBreadcrumbs, {
          useDivider: true
        }), " ", jsx(SidebarHeader, Object.assign({}, props)), group && jsx(GroupPanel, {
          invisibleGroups: invisibleGroups,
          group: group
        }), jsx(SidebarFooter, Object.assign({}, props))]
      }),
      onlysidebar: jsxs(Box, {
        component: "div",
        "data-cy": "sidebar",
        children: [!hideBreadcrumb && jsx(ComponentBreadcrumbs, {
          useDivider: true
        }), jsx(SidebarHeader, Object.assign({}, props)), groups.map(group => {
          const isHiddenGroup = isHidden(group, invisibleGroups);
          if (!showEditorUi && isHiddenGroup) return null;
          return jsxs(Box, {
            component: "div",
            children: [jsxs(Typography, {
              variant: "h6",
              sx: {
                paddingLeft: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              },
              children: [isHiddenGroup && jsx(HiddenGroupTooltip, {
                children: jsx(VisibilityOffIcon, {
                  sx: {
                    color: theme => theme.palette.secondary.main,
                    marginLeft: 1,
                    marginRight: 1
                  }
                })
              }), jsx(GroupLabel, {
                group: group
              })]
            }), jsx(GroupPanel, {
              group: group,
              invisibleGroups: invisibleGroups
            })]
          }, group.id);
        }).filter(c => !!c), jsx(AdditionalGroups, {
          design: design
        }), jsx(SidebarFooter, Object.assign({}, props))]
      })
    }[design]
  });
};
const IFooter = props => null;
const SidebarFooter = withExtensions({
  app: {
    sidebar: {
      footer: {
        root: true
      }
    }
  }
})(IFooter);
const IHeader = props => null;
const SidebarHeader = withExtensions({
  app: {
    sidebar: {
      header: {
        root: true
      }
    }
  }
})(IHeader);
const Sidebar = withExtensions({
  app: {
    sidebar: {
      root: true,
      components: {
        checkbox: true,
        colorSelect: true,
        colorDropdown: true,
        colorRadio: true,
        ralColorSelect: true,
        hidden: true,
        number: true,
        radio: true,
        radioCard: true,
        select: true,
        switch: true,
        switchCard: true,
        text: true,
        textArea: true
      }
    }
  }
})(SidebarTmp);

const sxStyles$a = {
  container: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    color: "text.primary"
  }
};
const MobileCheckboxSelector = ({
  variable,
  value,
  values,
  onChange
}) => {
  const {
    checked,
    onBooleanChange
  } = useBooleanChangeHandler(onChange, value, variable, values);
  return jsx(Box$2, {
    component: "div",
    sx: sxStyles$a.container,
    children: jsx(OCCheckbox, {
      "data-cy": `variableCheck-${variable == null ? void 0 : variable.label}`,
      checked: checked,
      onChange: onBooleanChange,
      label: variable == null ? void 0 : variable.label
    })
  });
};

const _excluded$8 = ["labelPosition", "label", "icon", "subLabel", "price", "showPrice", "variable", "sx"];
const sxStyles$9 = {
  tab: {
    display: "grid",
    gridTemplateRows: "min-content 1fr repeat(min-content)",
    justifyItems: "center",
    minWidth: 100,
    height: 74,
    py: 1
  },
  label: {
    maxWidth: 150
  }
};
const MobileLabelTab = _ref => {
  let {
      labelPosition = "top",
      label,
      icon = null,
      subLabel = null,
      price = null,
      showPrice = false,
      variable,
      sx = {}
    } = _ref,
    tabProps = _objectWithoutPropertiesLoose(_ref, _excluded$8);
  return jsx(Tab$1, Object.assign({}, tabProps, {
    "data-cy": "mobileLabelTab",
    sx: Object.assign({}, sxStyles$9.tab, sx),
    icon: jsxs(Fragment, {
      children: [jsxs("div", {
        children: [labelPosition === "top" ? label || " " : null, (variable == null ? void 0 : variable.info) && jsx(VariableInfoIcon, {
          variable: variable,
          sx: {
            p: 0,
            ml: 1
          }
        })]
      }), icon || " ", subLabel ? jsx(Typography$1, {
        noWrap: true,
        sx: sxStyles$9.label,
        variant: "body1",
        gutterBottom: false,
        children: subLabel
      }) : " ", showPrice && jsx(Typography$1, {
        noWrap: true,
        sx: Object.assign({}, sxStyles$9.label, price ? {} : {
          visibility: "hidden"
        }),
        variant: "body2",
        gutterBottom: false,
        children: price ? jsx("i", {
          children: `${price}€`
        }) : "M"
      }), jsx(Zoom, {
        in: tabProps.selected,
        children: jsx(Box, {
          component: "div",
          sx: {
            backgroundColor: theme => theme.palette.secondary.main,
            position: "absolute",
            bottom: 3,
            width: 30,
            height: 3
          }
        })
      })]
    }),
    label: labelPosition === "bottom" ? label : undefined
  }));
};

const _excluded$7 = ["color", "label", "value"];
const sxStyles$8 = {
  colorPreview: {
    width: 22,
    height: 22,
    borderRadius: "100%"
  }
};
const ColorPreviewTab = _ref => {
  let {
      color,
      label,
      value
    } = _ref,
    tabProps = _objectWithoutPropertiesLoose(_ref, _excluded$7);
  return jsx(MobileLabelTab, Object.assign({}, tabProps, {
    value: value,
    icon: jsxs(Box$2, {
      component: "div",
      sx: {
        display: "flex",
        flexDirection: "row"
      },
      children: [jsx(Box$2, {
        component: "div",
        sx: Object.assign({}, sxStyles$8.colorPreview, {
          backgroundColor: color,
          border: "1px solid black"
        })
      }), jsx(InvalidSelectionWarning, {
        iconSx: {
          marginLeft: 1
        },
        valueId: value
      })]
    }),
    label: label
  }));
};

const _excluded$6 = ["variableValue", "showPrice"];
const ColorValueTab = _ref => {
  let {
      variableValue,
      showPrice
    } = _ref,
    tabProps = _objectWithoutPropertiesLoose(_ref, _excluded$6);
  return jsx(ColorPreviewTab, Object.assign({}, tabProps, {
    value: variableValue.id,
    color: variableValue.value,
    label: variableValue == null ? void 0 : variableValue.label,
    price: variableValue == null ? void 0 : variableValue.price,
    showPrice: showPrice
  }));
};

const sxStyles$7 = {
  tabRoot: {
    height: 1.0,
    alignItems: "center",
    position: "relative"
  },
  coloredTabRoot: {
    backgroundColor: "primary.main",
    color: "primary.contrastText"
  },
  selectedTab: {
    backgroundColor: "background.default",
    color: "primary.main"
  }
};
const StyledTabs$1 = styled(props => jsx(Tabs$1, Object.assign({}, props, {
  TabIndicatorProps: {
    children: jsx("span", {
      className: "MuiTabs-indicatorSpan"
    })
  }
})))(({
  theme
}) => ({
  "& .MuiTabs-indicator": {
    // display: 'flex',
    display: "none",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "transparent",
    height: 10
  },
  "& .MuiTabs-indicatorSpan": {
    height: 3,
    maxWidth: 40,
    width: "100%",
    backgroundColor: theme.palette.secondary.main
  },
  "& .MuiTabs-scrollButtons": {
    height: "100%"
  }
}));
const MobileSelector = function MobileSelector({
  value = 0,
  values = [],
  onChange,
  onRenderTab,
  variant = "scrollable",
  color,
  height = 74,
  children = null
}) {
  const handleTabChange = (_, tabKey) => {
    onChange(tabKey);
  };
  return jsx(Box$2, {
    component: "div",
    sx: Object.assign({
      height
    }, color ? sxStyles$7.coloredTabRoot : {}),
    children: jsxs(StyledTabs$1, {
      "data-cy": `mobileSelectTabs`,
      sx: sxStyles$7.tabRoot,
      value: value,
      onChange: handleTabChange,
      variant: variant,
      scrollButtons: true,
      allowScrollButtonsMobile: true,
      textColor: color ? "inherit" : undefined,
      children: [!onRenderTab ? values.map(currentValue => jsx(Tab$1, {
        sx: Object.assign({}, value === currentValue.id ? sxStyles$7.selectedTab : {}, {
          height
        }),
        label: jsx(Typography$1, {
          variant: "body1",
          children: currentValue == null ? void 0 : currentValue.label
        }),
        value: currentValue.id,
        "data-cy": "mobileSelectTab-" + (currentValue == null ? void 0 : currentValue.label)
      }, currentValue.id)) : flow(map(onRenderTab), compact$1)(values), children ? children : null]
    })
  });
};

const anyPricesDefined = some$1(get$3("Price"));
const MobileColorSelector = ({
  variable,
  value,
  values,
  onChange
}) => {
  return jsx(MobileSelector, {
    value: value == null ? void 0 : value.id,
    values: values,
    onChange: valueId => onChange(+valueId),
    onRenderTab: value => jsx(ColorValueTab, {
      variable: variable,
      "data-cy": `color-${value.label}`,
      value: value.id,
      variableValue: value,
      showPrice: anyPricesDefined(values)
    }, value.id),
    variant: (values == null ? void 0 : values.length) < 5 ? "fullWidth" : "scrollable"
  }, variable.id);
};

const sxStyles$6 = {
  tabRoot: {
    height: 1.0,
    alignItems: "center"
  },
  coloredTabRoot: {
    backgroundColor: "primary.main",
    color: "primary.contrastText"
  },
  selectedTab: {
    backgroundColor: "background.default",
    color: "black"
  }
};
const StyledTabs = styled(props => jsx(Tabs$1, Object.assign({}, props, {
  TabIndicatorProps: {
    children: jsx("span", {
      className: "MuiTabs-indicatorSpan"
    })
  }
})))(({
  theme
}) => ({
  "& .MuiTabs-indicator": {
    // display: 'flex',
    display: "none",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "transparent",
    height: 10
  },
  "& .MuiTabs-indicatorSpan": {
    height: 3,
    maxWidth: 40,
    width: "100%",
    backgroundColor: theme.palette.secondary.main
  }
}));
const MobileComponentListSelector = function MobileComponentListSelector({
  value = 0,
  valuesAndSelections = [],
  onChange,
  onRenderTab,
  variant = "scrollable",
  color,
  height = 74,
  children = null
}) {
  const handleTabChange = (_, tabKey) => {
    onChange(tabKey);
  };
  return jsx(Box$2, {
    component: "div",
    sx: Object.assign({
      height
    }, color ? sxStyles$6.coloredTabRoot : {}),
    children: jsxs(StyledTabs, {
      "data-cy": `mobileComponentTabs`,
      sx: sxStyles$6.tabRoot,
      value: value,
      onChange: handleTabChange,
      variant: variant,
      scrollButtons: false,
      allowScrollButtonsMobile: true,
      textColor: color ? "inherit" : undefined,
      children: [!onRenderTab ? valuesAndSelections.map(valueAndSelection => {
        var _valueAndSelection$va;
        return jsx(Tab$1, {
          sx: Object.assign({}, value === valueAndSelection.selection.id ? sxStyles$6.selectedTab : {}, {
            height
          }),
          label: jsxs(Typography$1, {
            variant: "body1",
            children: [(_valueAndSelection$va = valueAndSelection.value) == null ? void 0 : _valueAndSelection$va.label, " "]
          }),
          value: valueAndSelection.selection.id
        }, valueAndSelection.selection.id);
      }) : flow(map(onRenderTab), compact$1)(valuesAndSelections), children ? children : null]
    })
  });
};

const handleRenderTab$1 = valueAndSelection => {
  var _valueAndSelection$va;
  return jsx(Tab, {
    label: jsxs(Typography, {
      variant: "body1",
      children: [(_valueAndSelection$va = valueAndSelection.value) == null ? void 0 : _valueAndSelection$va.label, " "]
    }),
    value: valueAndSelection.selection.id
  }, valueAndSelection.selection.id);
};
const MobileComponentSelector = props => {
  const {
    t
  } = useTranslation();
  const dispatch = useTypedDispatch();
  const [open, setOpen] = React__default.useState(false);
  const values = props.values;
  const selectionMap = useSelectionMap(props.variable, true);
  const handleChange = selectionId => {
    if (selectionId !== "ADD") {
      dispatch(openInstanceById(selectionId));
      dispatch(setSelectedVariableId(undefined));
      dispatch(setInitialFocusGroupKey());
    }
  };
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const hasInstanceActions = useTypedSelector(isControlledByInstanceActions(props.variable.id));
  const addComponent = newValue => {
    const value = values.find(value => value.id === newValue.id);
    if (value) {
      dispatch(addInstanceThunk(value));
      handleClose();
    }
  };
  return jsxs(Box, {
    component: "div",
    children: [jsx(MobileComponentListSelector, {
      value: false,
      valuesAndSelections: selectionMap,
      onChange: handleChange,
      onRenderTab: handleRenderTab$1,
      children: !hasInstanceActions && jsx(Tab, {
        label: jsx(Button, {
          "data-cy": `addComponent`,
          onClick: handleClickOpen,
          variant: "outlined",
          endIcon: jsx(AddIcon, {}),
          children: t("Hinzufügen")
        }),
        value: "ADD"
      }, "ADD")
    }), jsxs(Dialog, {
      disableEscapeKeyDown: true,
      open: open,
      onClose: handleClose,
      children: [jsx(DialogTitle, {
        children: t("Welches Teil soll hinzugefügt werden?")
      }), jsx(DialogContent, {
        children: jsx(List, {
          children: values.map(value => {
            return jsx(ListItem, {
              disablePadding: true,
              onClick: () => addComponent(value),
              children: jsx(ListItemButton, {
                children: jsx(ListItemText, {
                  primary: value.label
                })
              })
            });
          })
        })
      })]
    })]
  });
};

const MobileImageInput = ({
  variable,
  onChange,
  selection,
  values
}) => {
  var _selection$data, _variable$settings$te;
  const app = useTypedSelector(selectConfiguratorApp);
  const handleDelete = useCallback(() => {
    onChange(null);
  }, [onChange]);
  const handleImageChange = useCallback(newValue => {
    const realValue = values.find(value => value.variableId == variable.id && value.value == (newValue.length ? "1" : "0"));
    onChange(realValue.id, {
      url: newValue,
      leftright: 50,
      topbottom: 50,
      scale: 75
    });
  }, [onChange, values, variable]);
  return jsx(OCImageUpload, {
    storeLocally: true,
    url: (selection == null ? void 0 : (_selection$data = selection.data) == null ? void 0 : _selection$data.url) || "",
    app: app,
    onDelete: handleDelete,
    onUrlChange: handleImageChange,
    acceptedImageFormats: (_variable$settings$te = variable.settings.templateOptions.fileFormat) == null ? void 0 : _variable$settings$te.split(",").map(format => format.toLowerCase()),
    mobile: true,
    "data-cy": "mobileImageUpload"
  });
};

const _excluded$5 = ["label", "sx", "templateOptions", "variableValue"];
const sxStyles$5 = {
  tab: {
    height: 74,
    py: 1
  },
  layoutAll: {
    display: "grid",
    gridTemplateColumns: "minmax(0, max-content) minmax(0, 1fr) minmax(0, max-content)",
    gridTemplateRows: "minmax(0, min-content) minmax(0, min-content) minmax(0, min-content)",
    gridColumnGap: "2px",
    gridTemplateAreas: `
          "Thumbnail Label Price"
          "Thumbnail Description Description"
          "Thumbnail Url Url"
    `
  },
  layoutThumbOnly: {
    display: "grid",
    gridTemplateColumns: "minmax(0, max-content)",
    gridTemplateRows: "minmax(0, min-content) minmax(0, min-content)",
    gridColumnGap: "2px",
    gridTemplateAreas: `
          "Thumbnail"
          "Label"
    `
  },
  layoutLabelPrice: {
    display: "grid",
    gridTemplateColumns: "minmax(0, max-content)",
    gridTemplateRows: "minmax(0, min-content) minmax(0, min-content)",
    gridColumnGap: "2px",
    justifyItems: "center",
    gridTemplateAreas: `
          "Label"
          "Price"
          "Url"
    `
  },
  layoutLabelPriceDescription: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr) minmax(0, max-content)",
    gridTemplateRows: "minmax(0, min-content) minmax(0, min-content)",
    gridColumnGap: "2px",
    gridTemplateAreas: `
          "Label Price"
          "Description Description"
          "Url Url"
    `
  },
  label: {
    maxWidth: 150
  },
  tabIndicator: {
    backgroundColor: theme => theme.palette.secondary.main,
    position: "absolute",
    bottom: 3,
    width: 30,
    height: 3
  },
  gridAreaThumbnail: {
    gridArea: "Thumbnail",
    width: "75px",
    height: "75px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  },
  gridAreaThumbnailOnly: {
    gridArea: "Thumbnail",
    width: "75px",
    height: "50px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  },
  gridAreaLabel: {
    gridArea: "Label",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    height: "100%"
  },
  gridAreaDescription: {
    gridArea: "Description",
    whiteSpace: "break-spaces",
    display: "-webkit-box",
    WebkitLineClamp: "2",
    WebkitBoxOrient: "vertical",
    overflow: "hidden"
  },
  gridAreaUrl: {
    gridArea: "Url",
    display: "flex",
    justifyContent: "center"
  },
  gridAreaPrice: {
    gridArea: "Price",
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  },
  gridAreaInfo: {
    gridArea: "Info",
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  }
};
const MobileSelectTab = _ref => {
  let {
      sx = {},
      templateOptions,
      variableValue
    } = _ref,
    tabProps = _objectWithoutPropertiesLoose(_ref, _excluded$5);
  const formatter = useTypedSelector(selectPriceFormatter);
  const {
    showLabel,
    showPrice,
    showDescription,
    showUrl,
    showThumbnail
  } = templateOptions;
  const thumbOnly = showLabel && showThumbnail && !showDescription && !showPrice;
  let layoutStyle = sxStyles$5.layoutAll;
  if (showLabel && showPrice && showDescription && showThumbnail) {
    layoutStyle = sxStyles$5.layoutAll;
  } else if (thumbOnly) {
    layoutStyle = sxStyles$5.layoutThumbOnly;
  } else if (showLabel && showPrice && showDescription) {
    layoutStyle = sxStyles$5.layoutLabelPriceDescription;
  } else if (showLabel && showPrice) {
    layoutStyle = sxStyles$5.layoutLabelPrice;
  }
  return jsx(Tab$1, Object.assign({}, tabProps, {
    sx: mergeStyles(sxStyles$5.tab, sx),
    icon: jsxs(Fragment, {
      children: [jsxs(Box, {
        component: "div",
        sx: layoutStyle,
        children: [(templateOptions == null ? void 0 : templateOptions.showThumbnail) && jsx(Box, {
          component: "div",
          sx: thumbOnly ? sxStyles$5.gridAreaThumbnailOnly : sxStyles$5.gridAreaThumbnail,
          children: jsx(Thumbnail, {
            url: variableValue.thumbnail
          })
        }), (templateOptions == null ? void 0 : templateOptions.showLabel) && jsxs(Box, {
          component: "div",
          sx: sxStyles$5.gridAreaLabel,
          children: [jsx(Typography$1, {
            variant: "body1",
            noWrap: true,
            children: variableValue.label
          }), jsx(InvalidSelectionWarning, {
            valueId: variableValue.id,
            alwaysDisplay: tabProps.icon,
            iconSx: {
              marginLeft: 1
            }
          })]
        }), (templateOptions == null ? void 0 : templateOptions.showDescription) && jsx(Box, {
          component: "div",
          sx: showUrl ? mergeStyles(sxStyles$5.gridAreaDescription, {
            WebkitLineClamp: "1"
          }) : sxStyles$5.gridAreaDescription,
          children: jsx(Typography$1, {
            variant: "body2",
            children: variableValue.description
          })
        }), (templateOptions == null ? void 0 : templateOptions.showUrl) && jsx(Box, {
          component: "div",
          sx: sxStyles$5.gridAreaUrl,
          children: jsx(Link, {
            "data-cy": `mobileLink`,
            align: "center",
            variant: "caption",
            href: variableValue.url,
            target: "_blank",
            children: variableValue.url
          })
        }), (templateOptions == null ? void 0 : templateOptions.showPrice) && jsx(Box, {
          component: "div",
          sx: sxStyles$5.gridAreaPrice,
          children: jsx(Typography$1, {
            variant: "body2",
            children: formatter.format(variableValue.price)
          })
        })]
      }), jsx(Zoom, {
        in: tabProps.selected,
        children: jsx(Box, {
          component: "div",
          sx: sxStyles$5.tabIndicator
        })
      })]
    })
  }));
};

const _excluded$4 = ["variable", "variableValue"];
const ListItemTab = _ref => {
  let {
      variable,
      variableValue
    } = _ref,
    tabProps = _objectWithoutPropertiesLoose(_ref, _excluded$4);
  return jsx(MobileSelectTab, Object.assign({}, tabProps, {
    templateOptions: getTemplateOptions(variable),
    variableValue: variableValue,
    label: jsx(Fragment, {
      children: variableValue == null ? void 0 : variableValue.label
    }),
    icon: jsx(InvalidSelectionWarning, {
      valueId: variableValue.id,
      alwaysDisplay: tabProps.icon
    })
  }));
};
const MobileListItemSelector = ({
  variable,
  onChange,
  values
}) => {
  const selectedValue = useTypedSelector(selectSelectedValue(variable == null ? void 0 : variable.id));
  const handleRenderTab = variable => value => jsx(ListItemTab, {
    value: value.id,
    variable: variable,
    variableValue: value
  }, value.id);
  return jsx(MobileSelector, {
    value: selectedValue == null ? void 0 : selectedValue.id,
    values: values,
    onChange: valueId => onChange(+valueId),
    onRenderTab: handleRenderTab(variable)
  }, variable.id);
};

const sxStyles$4 = {
  root: {
    display: "flex",
    flexDirection: "row",
    overflowX: "auto",
    width: 1.0,
    height: 1.0
  },
  checkBoxContainer: {
    minWidth: 100,
    display: "grid",
    gridTemplateColumns: "min-content 1fr",
    justifyItems: "stretch",
    alignItems: "center",
    padding: 1
  }
};
const MobileMultiSelector = ({
  variable
}) => {
  useTypedDispatch();
  const possibleValues = useTypedSelector(selectValuesByVariableId(variable == null ? void 0 : variable.id));
  useTypedSelector(selectSelectionByVariableId(variable == null ? void 0 : variable.id));
  return jsx(Box$2, {
    component: "div",
    sx: sxStyles$4.root,
    children: map$1(possibleValues, v =>
    // TODO: Check auch hier!
    jsxs(Box$2, {
      component: "div",
      sx: sxStyles$4.checkBoxContainer,
      children: [jsx(Checkbox$2, {
        checked: /* includes(selectedValues, v.id) */true,
        "data-cy": `mobileMulti`
      }), jsx(Typography$1, {
        variant: "body1",
        children: v.label
      })]
    }, v.id))
  });
};

const sxStyles$3 = {
  root: {
    p: 1
  }
};
const MobileNumberInputTmp = ({
  variable,
  values,
  onChange,
  selection
}) => {
  const {
    onNumberChange,
    onInputBlur,
    isInRange,
    resetNumber,
    pureNumber
  } = useNumberVariableChangeHandler(onChange, selection, variable, values);
  return jsx(Box, {
    component: "div",
    sx: sxStyles$3.root,
    children: jsx(NumberWarningTooltip, {
      placement: "top",
      isInRange: isInRange,
      resetNumber: resetNumber,
      variable: variable,
      children: jsx(OCNumberInput, Object.assign({
        "data-cy": "numberInput",
        fullWidth: true,
        value: pureNumber,
        onChange: onNumberChange,
        onChangeByStep: onInputBlur,
        debounced: true,
        debounceTimeMs: 100,
        TextFieldProps: {
          error: !isInRange
        },
        onBlur: onInputBlur
      }, flow(getTemplateOptions, omit$1(["min", "max"]))(variable)))
    })
  });
};
const MobileNumberInput = withComponentExtension("number")(MobileNumberInputTmp);

const _excluded$3 = ["type"];
const sxStyles$2 = {
  root: {
    padding: 1
  }
};
const MobileTextInput = _ref => {
  let {
      type = "text"
    } = _ref,
    variableComponentProps = _objectWithoutPropertiesLoose(_ref, _excluded$3);
  const {
    text,
    onChange
  } = useTextChangeHandler(variableComponentProps);
  const {
    selection,
    variable
  } = variableComponentProps;
  return jsx(Box, {
    component: "div",
    sx: sxStyles$2.root,
    children: jsx(OCTextInput, {
      "data-cy": `mobileText-${variable == null ? void 0 : variable.label}`,
      multiline: isTextArea(variable),
      TextFieldProps: {
        label: variable == null ? void 0 : variable.label,
        rows: 2,
        type,
        value: text,
        InputLabelProps: {
          shrink: !!selection
        }
      },
      onChange: onChange,
      fullWidth: true
    })
  });
};

function getComponent(variable) {
  switch (variable == null ? void 0 : variable.type) {
    case VariableType.Color:
      return MobileColorSelector;
    case VariableType.Boolean:
      return MobileCheckboxSelector;
    case VariableType.Text:
      return MobileTextInput;
    case VariableType.Number:
      return MobileNumberInput;
    case VariableType.Components:
      return MobileComponentSelector;
    case VariableType.List:
      return MobileListItemSelector;
    case VariableType.MultiSelect:
      return MobileMultiSelector;
    case VariableType.Image:
      return MobileImageInput;
    default:
      return () => null;
  }
}
const ValuesView = () => {
  const info = useTypedSelector(selectRuleEngineInfo);
  const {
    ruleEngineInput
  } = info;
  const variableId = useTypedSelector(selectSelectedVariableId);
  const variable = ruleEngineInput == null ? void 0 : ruleEngineInput.variables.byVarId.all[variableId];
  return jsx(Box$2, {
    component: "div",
    sx: {
      transition: "all 0.3s",
      height: variable ? 74 : 0,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center"
    },
    "data-cy": "valuesView",
    children: variable && jsx(VariableComponent, {
      variable: variable
    })
  });
};
const VariableComponent = ({
  variable
}) => {
  const handleChange = useHandleChange();
  const Component = getComponent(variable);
  const componentProps = useComponentProps(variable);
  return jsx(Component, Object.assign({
    onChange: handleChange(variable)
  }, componentProps), variable == null ? void 0 : variable.id);
};

const BoolVariableTab = tabProps => {
  const {
    variable
  } = tabProps;
  const value = useTypedSelector(selectSelectedValue(variable == null ? void 0 : variable.id));
  const {
    values
  } = useComponentProps(variable);
  const onChange = useHandleChange()(variable);
  const {
    checked
  } = useBooleanChangeHandler(onChange, value, variable, values);
  return jsx(MobileLabelTab, Object.assign({}, tabProps, {
    icon: checked ? values.length > 0 && values[0].label ? jsx(Typography, {
      sx: {
        color: "primary.main"
      },
      children: values[0].label
    }) : jsx(CheckIcon, {
      sx: {
        color: "primary.main"
      }
    }) : values.length > 1 && values[1].label ? jsx(Typography, {
      sx: {
        color: "primary.main"
      },
      children: values[1].label
    }) : jsx(CloseIcon, {}),
    label: variable == null ? void 0 : variable.label
  }));
};

const useHideOrDisableProps = variable => {
  const templateOptions = getTemplateOptions(variable);
  const validOptions = useTypedSelector(selectValidValuesByVarIdOfInstance(variable.id));
  const validOptionsCount = validOptions.length || 0;
  let hide = false;
  if (templateOptions != null && templateOptions.hideIfNoOptions && validOptionsCount === 0) {
    hide = true;
  } else if (templateOptions != null && templateOptions.hideIfSingleOption && validOptionsCount <= 1) {
    hide = true;
  }
  const disabled = (templateOptions == null ? void 0 : templateOptions.disableIfSingleOption) && validOptionsCount <= 1;
  return {
    hide,
    disabled
  };
};

const ColorVariableTab = tabProps => {
  const {
    variable
  } = tabProps;
  const color = useTypedSelector(selectSelectedValue(variable == null ? void 0 : variable.id));
  const {
    disabled,
    hide
  } = useHideOrDisableProps(variable);
  if (hide) {
    return null;
  }
  return jsx(ColorPreviewTab, Object.assign({}, tabProps, {
    disabled: disabled,
    color: color == null ? void 0 : color.value,
    label: variable == null ? void 0 : variable.label
  }));
};

const ComponentsLabelTab = tabProps => {
  const {
    variable
  } = tabProps;
  const validValuesAndSelections = useTypedSelector(selectValidValuesAndSelectionsForVariableId(variable.id));
  const {
    t
  } = useTranslation();
  const label = flow(map(value => value.label), join$4(", "))(validValuesAndSelections.map(a => a.value));
  const {
    disabled,
    hide
  } = useHideOrDisableProps(variable);
  if (hide) {
    return null;
  }
  return jsx(MobileLabelTab, Object.assign({}, tabProps, {
    disabled: disabled,
    subLabel: jsx(Typography, {
      component: "span",
      sx: {
        maxWidth: 150
      },
      noWrap: true,
      children: label || t("Keine Auswahl")
    }),
    label: variable == null ? void 0 : variable.label
  }));
};

const _excluded$2 = ["variable"];
const GenericLabelTab = _ref => {
  let {
      variable
    } = _ref,
    tabProps = _objectWithoutPropertiesLoose(_ref, _excluded$2);
  return jsx(MobileLabelTab, Object.assign({}, tabProps, {
    label: variable == null ? void 0 : variable.label
  }));
};

const MultipleSelectedValueLabelTabTmp = tabProps => {
  const {
    variable
  } = tabProps;
  const values = useTypedSelector(state => {
    // TODO Die Komponente muss auch an den aktuellen Selection Typ angepasst
    // werden!
    const valueKeys = selectSelectionByVariableId(variable == null ? void 0 : variable.id)(state);
    return chain(valueKeys).map(valueKey => {
      var _selectValueById;
      return (_selectValueById = selectValueById(valueKey)(state)) == null ? void 0 : _selectValueById.label;
    }).join(", ").value();
  });
  const {
    disabled,
    hide
  } = useHideOrDisableProps(variable);
  if (hide) {
    return null;
  }
  return jsx(MobileLabelTab, Object.assign({}, tabProps, {
    disabled: disabled,
    subLabel: values,
    label: variable == null ? void 0 : variable.label
  }));
};
const MultipleSelectedValueLabelTab = WithHideDisableTemplateOptions(MultipleSelectedValueLabelTabTmp);

const SelectedValueLabelTab = tabProps => {
  const {
    variable
  } = tabProps;
  const value = useTypedSelector(selectSelectedValue(variable == null ? void 0 : variable.id));
  const {
    disabled,
    hide
  } = useHideOrDisableProps(variable);
  if (hide) {
    return null;
  }
  return jsx(MobileLabelTab, Object.assign({}, tabProps, {
    disabled: disabled,
    subLabel: value == null ? void 0 : value.label,
    label: variable == null ? void 0 : variable.label
  }));
};

/** Get the input value of a selection */
const getInputValue = selection => {
  var _selection$data;
  return toNumber((selection == null ? void 0 : (_selection$data = selection.data) == null ? void 0 : _selection$data.inputValue) || 0);
};

const _excluded$1 = ["variable"];
const SelectionLabelTab = _ref => {
  var _getTemplateOptions;
  let {
      variable
    } = _ref,
    tabProps = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  const selection = useTypedSelector(selectSelectionByVariableId(variable == null ? void 0 : variable.id));
  const unit = (_getTemplateOptions = getTemplateOptions(variable)) == null ? void 0 : _getTemplateOptions.unit;
  return jsx(MobileLabelTab, Object.assign({}, tabProps, {
    subLabel: getInputValue(selection) + (unit ? " " + unit : ""),
    label: variable == null ? void 0 : variable.label
  }));
};

const handleRenderTab = (variable, index) => {
  let Component;
  switch (variable.type) {
    case VariableType.Color:
      {
        Component = ColorVariableTab;
        break;
      }
    case VariableType.Components:
      {
        Component = ComponentsLabelTab;
        break;
      }
    case VariableType.List:
      {
        Component = SelectedValueLabelTab;
        break;
      }
    case VariableType.MultiSelect:
      {
        Component = MultipleSelectedValueLabelTab;
        break;
      }
    case VariableType.Boolean:
      {
        Component = BoolVariableTab;
        break;
      }
    case VariableType.Text:
    case VariableType.Number:
      Component = SelectionLabelTab;
      break;
    default:
      Component = GenericLabelTab;
      break;
  }
  return jsx(Component, {
    value: variable.id,
    variable: variable,
    "data-cy": "variableTab",
    sx: {
      alignItems: "start"
    }
  }, variable.id);
};
const VariablesNavigation = function VariablesNavigation() {
  const selectedVariableId = useTypedSelector(selectSelectedVariableId);
  const focusGroupId = useTypedSelector(selectFocusGroupId);
  const groupVariables = useTypedSelector(selectVisibleVariablesOfGroup(focusGroupId));
  const dispatch = useTypedDispatch();
  const handleVariableSelect = useCallback(variableId => {
    dispatch(setSelectedVariableId(variableId));
    dispatch(driveToCam({
      type: "variable",
      id: variableId
    }));
  }, [dispatch]);
  useEffect(() => {
    //If none of the variables in the current group are selected, select the first one
    if ((groupVariables == null ? void 0 : groupVariables.length) > 0 && !groupVariables.find(v => v.id === selectedVariableId)) {
      var _groupVariables$;
      handleVariableSelect((_groupVariables$ = groupVariables[0]) == null ? void 0 : _groupVariables$.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupVariables]);
  return jsx(MobileSelector, {
    value: selectedVariableId || false,
    values: groupVariables,
    onChange: handleVariableSelect,
    onRenderTab: handleRenderTab
  });
};

const AlignmentBox = ({
  p,
  spacing,
  children,
  direction: _direction = "column",
  gridArea,
  placeSelf
}) => {
  var _ref;
  return jsx(Box, {
    component: "div",
    sx: {
      zIndex: 0,
      p: +((_ref = p != null ? p : spacing) != null ? _ref : 0),
      gridArea,
      placeSelf,
      pointerEvents: "none"
    },
    children: jsx(Stack, {
      sx: {
        pointerEvents: "all"
      },
      direction: _direction,
      children: children
    })
  });
};
const TranslatableText = ({
  text
}) => {
  const getTranslation = useDynamicTranslation();
  const dynamicSettings = useTypedSelector(selectDynamicTranslationKeys);
  const updateSettings = useSetDynamicTranslations();
  const key = text;
  useEffect(() => {
    if (!dynamicSettings.find(s => s.key == key)) updateSettings([{
      key,
      defaultValue: text
    }]);
  }, [dynamicSettings, key, text, updateSettings]);
  return jsxs(Fragment, {
    children: [getTranslation(key, text), jsx(EditDynamicSettings, {
      keys: [key],
      display: "dialog",
      boxProps: {
        width: 0,
        height: 0,
        display: "inline"
      }
    })]
  });
};
const Empty = () => null;
const getDynamicComponents = componentName => withExtensions({
  app: {
    customLayoutComponents: {
      [componentName]: {
        root: true
      }
    }
  }
})(Empty);
const CustomLayoutComponent = props => {
  const Component = useMemo(() => getDynamicComponents(props.name), [props.name]);
  return jsx(Component, Object.assign({}, props));
};
const useComponents = (app, isMobile) => {
  const spacing = isMobile ? 2 : 3;
  const Content = useMemo(() => jsx(ContentView, {
    app: app
  }), [app]);
  const components = useMemo(() => Object.assign({}, lazyLoadedComponents, {
    CustomLayoutComponent,
    GroupsNavigation,
    VariablesNavigation,
    GroupsView: SidebarWithData,
    StandaloneVariable,
    StandaloneGroupWrapper,
    ValuesView,
    ComponentBreadcrumbs,
    SceneView: () => Content,
    SocialShareButtons,
    SceneButtons: ({
      children
    }) => jsx(SceneButtonGroup, {
      mobile: isMobile,
      children: children
    }),
    EditScene,
    //tools
    SwitchState,
    SwitchStateOn,
    SwitchStateOff,
    SwitchButton,
    TranslatableText,
    // has wrapper
    PriceData: PriceData,
    PriceDataFromVariable: PriceDataFromVariable,
    Price: PriceWithData,
    ExitButtons: ExitButtonGroupWithData,
    Logo: () => jsx(LogoWithData, {
      app: app
    }),
    FullScreenButton: FullscreenButton,
    NavigationButtons: NavigationButtonsWithData,
    OcBranding: Branding,
    LabelActionsDisplay: LabelActionsDisplayWithData,
    // deprecated
    // TODO: Wrapper fehlt --> Props für Extensions
    Header: GroupsNavigation,
    Sidebar: SidebarWithData,
    Content: () => Content,
    TopLeft: ({
      p,
      children,
      direction: _direction2 = "row"
    }) => jsx(AlignmentBox, {
      p: p,
      spacing: spacing,
      direction: _direction2,
      gridArea: "top-left",
      placeSelf: "start start",
      children: children
    }),
    TopCenter: ({
      p,
      children,
      direction: _direction3 = "row"
    }) => jsx(AlignmentBox, {
      p: p,
      spacing: spacing,
      direction: _direction3,
      gridArea: "top-center",
      placeSelf: "start center",
      children: children
    }),
    TopRight: ({
      p,
      children,
      direction: _direction4 = "column"
    }) => jsx(AlignmentBox, {
      p: p,
      spacing: spacing,
      direction: _direction4,
      gridArea: "top-right",
      placeSelf: "start end",
      children: children
    }),
    MidLeft: ({
      p,
      children,
      direction: _direction5 = "row"
    }) => jsx(AlignmentBox, {
      p: p,
      spacing: spacing,
      direction: _direction5,
      gridArea: "mid-left",
      placeSelf: "center start",
      children: children
    }),
    MidCenter: ({
      p,
      children,
      direction: _direction6 = "row"
    }) => jsx(AlignmentBox, {
      p: p,
      spacing: spacing,
      direction: _direction6,
      gridArea: "mid-center",
      placeSelf: "center center",
      children: children
    }),
    MidRight: ({
      p,
      children,
      direction: _direction7 = "row"
    }) => jsx(AlignmentBox, {
      p: p,
      spacing: spacing,
      direction: _direction7,
      gridArea: "mid-right",
      placeSelf: "center end",
      children: children
    }),
    BotLeft: ({
      p,
      children,
      direction: _direction8 = "row"
    }) => jsx(AlignmentBox, {
      p: p,
      spacing: spacing,
      direction: _direction8,
      gridArea: "bot-left",
      placeSelf: "end start",
      children: children
    }),
    BotCenter: ({
      p,
      children,
      direction: _direction9 = "row"
    }) => jsx(AlignmentBox, {
      p: p,
      spacing: spacing,
      direction: _direction9,
      gridArea: "bot-center",
      placeSelf: "end center",
      children: children
    }),
    BotRight: ({
      p,
      children,
      direction: _direction10 = "row"
    }) => jsx(AlignmentBox, {
      p: p,
      spacing: spacing,
      direction: _direction10,
      gridArea: "bot-right",
      placeSelf: "end end",
      children: children
    })
  }), [Content, app]);
  return {
    components,
    Content
  };
};

const GroupOutlet = props => {
  var _groupWithDesign$sett, _groupWithDesign$sett2, _groupWithDesign$sett3;
  const device = props.isMobile ? "phone" : "desktop";
  const groupWithDesign = useTypedSelector(selectFirstGroupWithDesign(device));
  const {
    components
  } = useComponents(props.app, props.isMobile);
  const design = groupWithDesign == null ? void 0 : (_groupWithDesign$sett = groupWithDesign.settings) == null ? void 0 : (_groupWithDesign$sett2 = _groupWithDesign$sett.theme) == null ? void 0 : (_groupWithDesign$sett3 = _groupWithDesign$sett2[device]) == null ? void 0 : _groupWithDesign$sett3.custom;
  if (!design) return null;
  return jsx(XMLStringToReact, {
    xmlString: design,
    components: components
  });
};

const getDesign = app => {
  var _app$layout;
  return app == null ? void 0 : (_app$layout = app.layout) == null ? void 0 : _app$layout.design;
};

const isSidebarPositionRight = app => getSidebarPosition(app) === SidebarPositionType.Right;

const getLayouts = ({
  muiTheme
}) => {
  const spacing = arg => muiTheme.spacing(arg);
  const boxShadow = "6px 0 4px -4px #999, -6px 0 4px -4px #999";
  const sidebarWidth = "30rem";
  return [{
    id: "defaultRight",
    label: "Reiter - Rechts",
    content: `
<div style="
  height: 100%;
  display: grid;
  grid:
    'header   header     header    header'    min-content
    'top-left top-center top-right sidebar'   1fr
    'mid-left mid-center mid-right sidebar'   1fr
    'bot-left bot-center bot-right sidebar'   1fr
    / minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) ${sidebarWidth};
">
  <header style="gridArea: header;">
    <Header/>
  </header>
  <section style="gridArea: 2 / 1 / span 3 / span 3">
    <SceneView/>
  </section>
  <TopLeft>
    <Logo/>
  </TopLeft>
  <TopCenter>
    <EditScene/>
  </TopCenter>
  <TopRight>
      <SceneButtons>
        <FullScreenButton />
      </SceneButtons>
      <SocialShareButtons/>
  </TopRight>
  <BotRight>
    <Price/>
    <ExitButtons/>
  </BotRight>
  <div style="
    gridArea: sidebar;
    background: ${muiTheme.palette.background.default};
    overflowY: scroll;
    zIndex:1;
    box-shadow: ${boxShadow};
    display: grid;
    alignContent: space-between;
  ">
    <Sidebar design="topmenu"></Sidebar>
    <footer style="
      position: sticky;
      bottom: 0;
      background: ${muiTheme.palette.background.default};
      display: grid;
      gap: ${spacing(2)};
      padding: ${spacing(3)}
    ">
      <LabelActionsDisplay></LabelActionsDisplay>
      <NavigationButtons></NavigationButtons>
    </footer>
  </div>
</div>`
  }, {
    id: "defaultLeft",
    label: "Reiter - Links",
    content: `
<div style="
  height: 100%;
  display:grid;
  grid:
    'header  header   header     header'      min-content
    'sidebar top-left top-center top-right'   1fr
    'sidebar mid-left mid-center mid-right'   1fr
    'sidebar bot-left bot-center bot-right'   1fr
    / ${sidebarWidth} minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
">
  <header style="gridArea: header;">
    <Header/>
  </header>
  <section style="gridArea: 2 / 2 / span 3 / span 3">
    <SceneView/>
  </section>
  <TopLeft>
    <Logo/>
  </TopLeft>
  <TopCenter>
    <EditScene/>
  </TopCenter>
  <TopRight>
    <SceneButtons>
      <FullScreenButton />
    </SceneButtons>
    <SocialShareButtons/>
  </TopRight>
  <BotRight>
    <Price/>
    <ExitButtons/>
  </BotRight>
  <div style="
    gridArea: sidebar;
    background: ${muiTheme.palette.background.default};
    overflowY: scroll;
    zIndex:1;
    box-shadow: ${boxShadow};
    display: grid;
    alignContent: space-between;
  ">
    <Sidebar design="topmenu"></Sidebar>
    <footer style="
      position: sticky;
      bottom: 0;
      background: ${muiTheme.palette.background.default};
      display: grid;
      gap: ${spacing(2)};
      padding: ${spacing(3)}
    ">
      <LabelActionsDisplay></LabelActionsDisplay>
      <NavigationButtons></NavigationButtons>
    </footer>
  </div>
</div>`
  }, {
    id: "flyaway",
    label: "Flyaway Reiter - Links",
    content: `
<div style="
  height: 100%;
  display:grid;
  grid:
    'space header  top-left top-center top-right'   min-content
    'space sidebar top-left top-center top-right'   1fr
    'space sidebar mid-left mid-center mid-right'   1fr
    'space sidebar bot-left bot-center bot-right'   1fr
    / 5vw ${sidebarWidth} minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
">
  <header style="gridArea: header; zIndex: 1;">
    <Header/>
  </header>
  <section style="gridArea: 1 / 1 / span 22 / span 22">
    <SceneView/>
  </section>
  <div style="gridArea: top-left; padding: ${spacing(3)};">
    <Logo/>
  </div>
  <TopCenter>
    <EditScene/>
  </TopCenter>
  <TopRight>
      <SceneButtons>
        <FullScreenButton />
      </SceneButtons>
      <SocialShareButtons/>
  </TopRight>
  <BotRight>
    <Price/>
    <ExitButtons/>
  </BotRight>
  <div style="
    gridArea: sidebar;
    height: 60%;
    overflow: hidden;
    borderRadius: 0 0 16px 16px;
    background: #ffffff75;
    box-shadow: 0 0.28571429rem 0.28571429rem rgb(0 0 0 / 25%);
    zIndex:1;
  ">
    <div style="
      overflowY: scroll;
      height: 100%;
      display: grid;
      alignContent: space-between;
    ">
      <Sidebar design="topmenu"></Sidebar>
      <footer style=" display: grid; gap: ${spacing(2)}; padding: ${spacing(3)}">
        <LabelActionsDisplay></LabelActionsDisplay>
        <NavigationButtons></NavigationButtons>
      </footer>
    </div>
  </div>
</div>`
  }, {
    id: "noheaderLeft",
    label: "Einfach - Links",
    content: `
<div style="
  height: 100%;
  display:grid;
  grid:
    'sidebar top-left top-center top-right'   1fr
    'sidebar mid-left mid-center mid-right'   1fr
    'sidebar bot-left bot-center bot-right'   1fr
    / ${sidebarWidth} minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
">
  <section style="gridArea: 1 / 2 / span 11 / span 11">
    <SceneView/>
  </section>
  <TopLeft>
    <Logo/>
  </TopLeft>
  <TopCenter>
    <EditScene/>
  </TopCenter>
  <TopRight>
      <SceneButtons>
        <FullScreenButton />
      </SceneButtons>
      <SocialShareButtons/>
  </TopRight>
  <BotRight>
    <Price/>
    <ExitButtons/>
  </BotRight>
  <div style="
    gridArea: sidebar;
    background: #fff;
    overflow: auto;
    zIndex:1;
    box-shadow: ${boxShadow};
    display: grid;
    alignContent: space-between;
  ">
    <Sidebar design="onlysidebar"/>
    <footer style="position: sticky; bottom: 0; background: #fff; display: grid; gap: ${spacing(2)}; padding: ${spacing(3)}">
      <LabelActionsDisplay></LabelActionsDisplay>
      <OcBranding></OcBranding>
    </footer>
  </div>
</div>`
  }, {
    id: "noheaderRight",
    label: "Akkordeons - Rechts",
    content: `
<div style="
  height: 100%;
  display:grid;
  grid:
    'header header header header' min-content
    'top-left top-center top-right sidebar' 1fr
    'mid-left mid-center mid-right sidebar' 1fr
    'bot-left bot-center bot-right sidebar' 1fr
    / minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) ${sidebarWidth};
">
  <section style="gridArea: 2 / 1 / span 3 / span 3">
    <SceneView/>
  </section>
  <TopLeft>
    <Logo/>
  </TopLeft>
  <TopCenter>
    <EditScene/>
  </TopCenter>
  <TopRight>
      <SceneButtons>
        <FullScreenButton />
      </SceneButtons>
      <SocialShareButtons/>
  </TopRight>
  <BotRight>
    <Price/>
    <ExitButtons/>
  </BotRight>
  <div style="
    gridArea: sidebar;
    background: #fff;
    overflowY: scroll;
    zIndex:1;
    box-shadow: ${boxShadow};
    display: grid;
    alignContent: space-between;
  ">
    <Sidebar design="accordion"/>
    <footer style="position: sticky; bottom: 0; background: #fff; display: grid; gap: ${spacing(2)}; padding: ${spacing(3)}">
      <LabelActionsDisplay/>
    </footer>
  </div>
</div>`
  }, {
    id: "noviz",
    label: "Fullscreen Formular",
    content: `
<div style="
  height: 100%;
  display:grid;
  grid:
    'header' min-content
    'sidebar' 1fr
    'sidebar' 1fr
    'sidebar' 1fr
    / 1fr;
">
  <header style="gridArea: header;">
    <Header/>
  </header>
  <div style="
    gridArea: sidebar;
    background: #fff;
    overflow: auto;
    zIndex:1;
    box-shadow: ${boxShadow};
    display: grid;
    alignContent: space-between;
  ">
    <Sidebar design="topmenu"/>
    <footer style="position: sticky; bottom: 0; background: #fff; display: grid; gap: ${spacing(2)}; padding: ${spacing(3)}">
      <LabelActionsDisplay/>
      <NavigationButtons/>
    </footer>
  </div>
</div>`
  }];
};

const getMobileLayouts = ({
  muiTheme
}) => {
  return [{
    id: "mobileDefault",
    label: "Mobile default",
    content: `<div style="
  display: grid;
  height: 100%;
  overflow: hidden;
  pointer-events: all;
  grid:
    'top-left top-center top-right'   2fr
    'mid-left mid-center mid-right'   2fr
    'bot-left bot-center bot-right'   2fr
    'groups groups groups' min-content
    'variables variables variables' min-content
    'values values values' min-content
    / 1fr 1fr 1fr
">
  <section style="gridArea: 1/1/4/4">
    <SceneView/>
  </section>
  <TopRight>
    <SceneButtons  />
  </TopRight>
  <BotRight>
    <ExitButtons />
  </BotRight>
  <BotLeft>
    <Price />
  </BotLeft>
  <div style="gridArea: groups;">
    <GroupsNavigation />
  </div>
  <div style="gridArea: variables;">
    <VariablesNavigation />
  </div>
  <div style="gridArea: values;">
    <ValuesView />
  </div>
</div>`
  }, {
    id: "mobileScrollable",
    label: "Mobile Scrollable",
    content: `<div id="content" style="
      display: grid;
      height: 100%;
      width:100%;
      overflow: hidden;
      pointer-events: all;
      grid:
        'top'   2fr
        'mid'   min-content
        'bot'   50%
        / 100%
    ">
      <section style="gridArea: 1 / 1 / 3 / 1;">
        <SceneView/>
      </section>
      <div style="gridArea:top; width: fit-content;
      flex-grow:1;
    height: fit-content;
    margin: 6px;
    margin-right: 6px;
    margin-left: auto;">
        <SceneButtons  />
      </div>
      <div style="gridArea:mid; display: flex;
    flex-flow: wrap;
    background-color: transparent;
    justify-content: space-between;
    gap: 6px;
    margin: 6px;
    z-index: 10;
    flex-wrap: wrap;
    align-items: flex-end;">

        <Price />
        <ExitButtons />
      </div>
      <div style="gridArea: bot; display:flex; flex-direction:column-reverse; position:relative">
        <Sidebar design="topmenu" style="margin:0; z-index:2; min-width:unset !important;"></Sidebar>
        <GroupsNavigation style="z-index:100; position:absolute"/>
        
      </div>
      <style>
        #content .MuiPaper-elevation0 {
        background-color:unset;
        }
        #content *::-webkit-scrollbar {
        height:5px;
        }
        </style>
    </div>`
  }];
};

const ILayoutBuilder = ({
  app,
  isMobile
}) => {
  const muiTheme = useAppTheme();
  const layouts = isMobile ? getMobileLayouts({
    muiTheme
  }) : getLayouts({
    muiTheme
  });
  const {
    components: componentsWithoutGroupOutlet,
    Content
  } = useComponents(app, isMobile);
  const components = useMemo(() => Object.assign({}, componentsWithoutGroupOutlet, {
    GroupOutlet
  }), [componentsWithoutGroupOutlet]);
  const layout = useMemo(() => {
    if (!app) return null;
    const theme = isMobile ? app.settings.themeMobile : app.settings.theme;
    // theme.custom soll nie gelöscht werden.
    // Wenn aber ein theme.selected gesetzt ist, soll das verwendet werden
    // Gibts Probleme, dann das erste Theme verwenden.
    const content = theme != null && theme.selected ?
    // @ts-ignore
    (layouts.find(t => t.id == theme.selected) || layouts[0]).content : (theme == null ? void 0 : theme.custom) || layouts[0].content;
    // @ts-ignore
    return jsx(XMLStringToReact, {
      xmlString: content,
      components: components
    });
  }, [app, components, isMobile, layouts]);
  if (!app) return null;
  if (app.settings.theme) {
    return layout;
  }
  // FIXME: Das ist zu deprecaten
  const design = getDesign(app);
  const sidebarRight = isSidebarPositionRight(app);
  return jsxs(Fragment, {
    children: [design === DesignType.accordion && jsx(AccordionLayout, {
      content: Content,
      sidebar: jsx(SidebarWithData, {
        design: design
      }),
      sidebarRight: sidebarRight
    }), design === DesignType.topmenu && jsx(SidebarLayout, {
      header: jsx(GroupsNavigation, {}),
      content: Content,
      sidebar: jsx(SidebarWithData, {
        design: design
      }),
      sidebarRight: sidebarRight
    }), design === DesignType.onlysidebar && jsx(SidebarLayout, {
      content: Content,
      sidebar: jsx(SidebarWithData, {
        design: design
      }),
      sidebarRight: sidebarRight
    })]
  });
};
const LayoutBuilder = withExtensions({
  app: {
    root: true
  }
})(ILayoutBuilder);

const ExtendAdditionalGroupsHoc = () => function ExtendAdditionalGroups(props) {
  useTypedDispatch();
  const {
    t
  } = useTranslation();
  const focusGroup = useTypedSelector(selectFocusGroup);
  const isAccordion = props.design === "accordion";
  return jsx(Box, {
    component: "div",
    sx: {
      px: 3,
      my: 1,
      marginY: "auto"
    },
    children: jsx(Button, {
      component: Link$1,
      color: "editor",
      to: `groups/create` + (focusGroup != null && focusGroup.parentId ? `/${focusGroup == null ? void 0 : focusGroup.parentId}` : ""),
      "data-cy": "newGroup",
      variant: "contained",
      startIcon: jsx(AddCircle, {}),
      children: isAccordion ? t("Abschnitt") : t("Reiter")
    })
  });
};

const ExtendAdditionalVarsHoc = Groups => function ExtendAdditionalVars({
  group
}) {
  const {
    t
  } = useTranslation();
  const groups = useTypedSelector(selectGroups);
  const parentId = useTypedSelector(selectOpenInstance).variableId;
  return jsx(Box, {
    component: "div",
    sx: {
      px: 3,
      my: 1
    },
    children: groups.length > 0 ? jsx(Button, {
      color: "editor",
      "data-cy": "newVariable",
      fullWidth: true,
      component: Link$1,
      to: `variables/create/${group.id}/${parentId}`,
      variant: "contained",
      startIcon: jsx(AddCircle, {}),
      children: t("Merkmal")
    }) : jsx(Typography, {
      children: t("Bitte legen Sie einen Reiter an!")
    })
  });
};

const setGroupThunk = group => dispatch => {
  dispatch(setConfiguratorGroup(group));
};

const sxStyles$1 = createStyleObject({
  container: {
    display: "grid",
    alignItems: "center",
    gridAutoColumns: "min-content",
    gridAutoFlow: "column"
  },
  icon: {
    cursor: "pointer",
    fontSize: "1.25em"
  },
  useContrastTextColor: {
    color: theme => theme.palette.primary.contrastText
  },
  label: {
    whiteSpace: "nowrap"
  }
});
const ExtendGroupLabelHoc = Label => function ExtendGroupLabel(props) {
  const navigate = useNavigate();
  const appId = +useParams().appId;
  const {
    t
  } = useTranslation();
  const dispatch = useTypedDispatch();
  const handleEditGroup = useCallback(() => {
    dispatch(setGroupThunk(props.group));
    navigate(`/admin/apps/${appId}/edit/configurator/groups/${props.group.id}`);
  }, [appId, dispatch, navigate, props.group]);
  return jsxs(Box, {
    component: "span",
    sx: sxStyles$1.container,
    children: [jsx(Label, Object.assign({}, props)), jsx(EditButton, {
      "data-cy": "editGroup",
      tooltip: t("Gruppe editieren"),
      onClick: handleEditGroup
    })]
  });
};

const updateVariableThunk = variable => async (dispatch, getState) => {
  const state = getState();
  const language = selectContentLanguage(state);
  dispatch(updateVariable(variable));
  return await api_updateResource("variable", variable, {
    lang: language
  });
};

const moveVariableThunk = (variable, direction) => async (dispatch, getState) => {
  const state = getState();
  let groupVariables = getVariablesByGroupId(state, variable.groupId);
  groupVariables = move(groupVariables, variable, direction);
  batch(async () => await Promise.all(groupVariables.map(groupVariable => dispatch(updateVariableThunk(groupVariable)))));
};

const ExtendGroupPanelHoc = GroupPanel => function ExtendGroupPanel(props) {
  const dispatch = useTypedDispatch();
  const throwError = useAsyncError();
  const variables = useTypedSelector(selectVariables);
  const handleDragEnd = result => {
    const draggedVariableId = parseInt(result.draggableId);
    const variable = variables.find(v => v.id == draggedVariableId);
    dispatch(moveVariableThunk(variable, result.destination.index - result.source.index)).catch(throwError);
  };
  return jsx(GroupPanel, Object.assign({}, props, {
    onDragEnd: handleDragEnd
  }));
};

const updateGroupThunk = group => async (dispatch, getState) => {
  const state = getState();
  const language = selectContentLanguage(state);
  dispatch(updateGroup(group));
  return api_updateResource("group", group, {
    lang: language
  });
};

const moveGroupThunk = (group, direction) => async (dispatch, getState) => {
  const state = getState();
  const groups = selectGroups(state);
  const newGroups = move(groups, group, direction);
  dispatch(updateGroups(newGroups));
  batch(async () => await Promise.all(newGroups.map(group => dispatch(updateGroupThunk(group)))));
};

const ExtendHeaderHoc = Header => function ExtendHeader(props) {
  const dispatch = useTypedDispatch();
  const throwError = useAsyncError();
  const groups = useTypedSelector(selectGroups);
  const handleDragEnd = result => {
    const groupId = parseInt(result.draggableId);
    const group = groups.find(v => v.id == groupId);
    dispatch(moveGroupThunk(group, result.destination.index - result.source.index)).catch(throwError);
  };
  return jsx(Header, Object.assign({}, props, {
    onDragEnd: handleDragEnd
  }));
};

const ExtendPriceButtonsHoc = Wrapped => function ExtendPriceButtons(props) {
  const {
    t
  } = useTranslation();
  const nav = useNavigate();
  return jsxs(Box, {
    component: "div",
    sx: {
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    },
    children: [jsx(Wrapped, Object.assign({}, props)), jsx(Box, {
      component: "div",
      sx: {
        marginLeft: 1
      },
      children: jsx(EditButton, {
        tooltip: t("Bestelloptionen"),
        onClick: () => nav("order"),
        "data-cy": `editPrice`
      })
    })]
  });
};

const sxStyles = {
  container: {
    width: 1.0,
    display: "grid",
    alignItems: "center",
    gridTemplateColumns: "1fr min-content",
    gridAutoFlow: "column"
  },
  icon: {
    cursor: "pointer",
    fontSize: "1.25em"
  }
};
const ExtendVariableLabelHoc = Label => function ExtendVariableLabel({
  variable,
  children
}) {
  const navigate = useNavigate();
  const {
    t
  } = useTranslation();
  const appId = +useParams().appId;
  const dragHandle = useContext(DragHandleContext);
  return jsxs(Box, {
    component: "div",
    sx: sxStyles.container,
    children: [jsx(Label, {
      variable: variable,
      children: children
    }), jsx(EditButton, {
      "data-cy": "editVariable",
      tooltip: t("Merkmal editieren"),
      onClick: () => {
        navigate(`/admin/apps/${appId}/edit/configurator/variables/${variable.id}/options`);
      }
    }), dragHandle]
  });
};

const adminExtensions = {
  extendGroupLabel: ExtendGroupLabelHoc,
  extendAdditionalGroups: ExtendAdditionalGroupsHoc,
  extendVariableLabel: ExtendVariableLabelHoc,
  extendAdditionalVars: ExtendAdditionalVarsHoc,
  extendHeader: ExtendHeaderHoc,
  extendGroupPanel: ExtendGroupPanelHoc,
  app: {
    exitButtons: {
      root: ExtendPriceButtonsHoc
    }
  }
};
const createAdminExtensionsForPath = (providedForPath, adminForPath) => {
  const newForPath = Object.assign({}, adminForPath);
  Object.entries(adminForPath).forEach(([key, value]) => {
    if (isRecord(value)) {
      // @ts-ignore
      const nextPath = providedForPath == null ? void 0 : providedForPath[key];
      if (!isRecord(nextPath)) {
        return;
      }
      // @ts-ignore
      newForPath[key] = createAdminExtensionsForPath(nextPath, value);
    } else {
      // @ts-ignore
      const providedExtension = providedForPath == null ? void 0 : providedForPath[key];
      if (providedExtension) {
        const adminExtension = value;
        // @ts-ignore
        newForPath[key] = mergeExtensions(adminExtension, providedExtension);
      }
    }
  });
  return newForPath;
};
const createNewAdminExtensions = providedExtensions => createAdminExtensionsForPath(providedExtensions, adminExtensions);
const mergeExtensions = (Higher, Lower) => {
  return Wrapped => props => {
    const NewWrapped = useMemo(() => Higher(Lower(Wrapped)), [Higher, Lower, Wrapped]);
    return jsx(NewWrapped, Object.assign({}, props));
  };
};

/** Preprocess rules, ruleItems, values and variables to the A2Input.
 * It does a couple of things:
 * 1. Create every necessary ruleItem for "Alle Werte"/*. This might actually
 *    not be necessary anymore.
 * 2. Create Intervals for ruled numbers
 * 3. Creates mock values for variables that need one, e.g. text or number variables
 *    without any already present values. Used to store their input as additionalData.
 */
const actionEnginePreprocessor = (rules, ruleItems, values, variables) => {
  const engineInput = enginePreprocessor(variables, false)({
    rules,
    ruleItems,
    values
  });
  const valueMap = generateValueMap(variables, engineInput.newValues);
  return {
    variables: variables,
    ruleItems: {
      byRuleId: groupBy(engineInput.newRuleItems, "ruleId"),
      flat: engineInput.newRuleItems
    },
    values: {
      byVarId: valueMap,
      flat: engineInput.newValues
    },
    rules: engineInput.newRules
  };
};

/** This hook is resposible for handling the different engines and their impact on eachother.
 * */
const useEngine = () => {
  var _dealerData$apps, _dealerApp$query;
  const dispatch = useTypedDispatch();
  const rules = useTypedSelector(selectRules);
  const variables = useTypedSelector(selectVariables);
  const models = useTypedSelector(selectModels);
  const values = useTypedSelector(selectValues);
  const ruleItems = useTypedSelector(selectRuleItems);
  const init = useTypedSelector(selectConfigurationInitialization);
  const app = useTypedSelector(selectFrontendApp);
  const dealerData = useTypedSelector(selectDealerData);
  const dealerApp = (_dealerData$apps = dealerData.apps) == null ? void 0 : _dealerData$apps.find(da => da.appId == app.id);
  const dealerQuery = (_dealerApp$query = dealerApp == null ? void 0 : dealerApp.query) != null ? _dealerApp$query : "";
  const ruleEngineState = useTypedSelector(selectRuleEngineState);
  /** This initializes our engines when loading or switching configurators */
  useEffect(() => {
    try {
      const input = ruleEnginePreprocessor(rules, ruleItems, values, variables);
      let newState;
      if (init) {
        newState = restoreSelections(input, backendToFrontendSelections(input, init.configuration), init.checkSelections, !init.configuration.inspiration && init.configuration.json.touched || {});
      } else {
        newState = ruleEngineState &&
        // this checks if the existing state belongs to our app.
        ruleEngineState.state.all.selections.some(s => input.values.byVarId.all[s.variableId]) ? restoreSelections(input, ruleEngineState.state.all.selections, true, ruleEngineState.state.all.touched) : fillInitial(input);
      }
      if (!newState) throw new Error("Unable to calculate initial rule engine state");
      newState = setVariablesByQuery(input, newState, dealerQuery);
      const actionEngineInput = actionEnginePreprocessor(rules, ruleItems, values, variables);
      dispatch(setConfigurationInitialization(null));
      dispatch(setStableEngineState(newState, input, actionEngineInput));
      dispatch(setRuleEngineError());
    } catch (e) {
      dispatch(setRuleEngineError(e.message));
      console.error(e);
    }
    //  Dependency arrays are in-complete by purpose to avoid unnecessary iterations.
  }, [values, variables, rules, ruleItems, dealerData, models]);
};
const setVariablesByQuery = (input, state, dealerQuery) => flow(() => new URLSearchParams(window.location.search + `&${dealerQuery}`), Object.fromEntries, omit$1(["app", "code", "dealer"]), bulkChangeVariables(input, state))();

const WithInitializedEngine = props => {
  useEngine();
  const state = useTypedSelector(selectRuleEngineState);
  const ruleEngineError = useTypedSelector(selectRuleEngineError);
  if (!state && !ruleEngineError) {
    return null;
  }
  if (ruleEngineError) {
    return jsxs(Box, {
      component: "div",
      sx: {
        border: "4px solid red",
        borderColor: "error.main",
        boxSizing: "border-box",
        height: 1.0,
        width: 1.0
      },
      children: [jsx(Snackbar, {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center"
        },
        open: !!ruleEngineError,
        children: jsx(Alert, {
          icon: false,
          severity: "error",
          sx: {
            width: "100%"
          },
          children: jsxs(Box, {
            component: "div",
            sx: {
              display: "flex",
              alignItems: "center"
            },
            children: [jsx(ErrorOutline, {
              sx: {
                mr: 1
              },
              color: "error"
            }), jsx(Typography, {
              sx: {
                fontWeight: "bold"
              },
              children: ruleEngineError
            })]
          })
        })
      }), props.children]
    });
  }
  return jsx(Fragment, {
    children: props.children
  });
};

const injectCss = path => {
  const hasLink = document.querySelector('[data-link="custom-css"]');
  const href = path;
  if (hasLink) {
    hasLink.setAttribute("href", href);
  } else {
    const head = document.head || document.getElementsByTagName("head")[0];
    const link = document.createElement("link");
    link.setAttribute("data-link", "custom-css");
    link.setAttribute("rel", "stylesheet");
    link.setAttribute("href", href);
    head.appendChild(link);
  }
};

const useInjectCss = () => {
  const app = useTypedSelector(selectFrontendApp);
  useEffect(() => {
    var _app$settings, _app$settings$ext;
    injectCss((app == null ? void 0 : (_app$settings = app.settings) == null ? void 0 : (_app$settings$ext = _app$settings.ext) == null ? void 0 : _app$settings$ext.css) || "");
  }, [app]);
};

const _excluded = ["editorUi"];
const ConfiguratorComponent = ({
  app,
  mobile
}) => {
  useInjectCss();
  const matchesSmartphone = useMediaQuery("(min-width: 0) and (max-width: 480px)");
  const focusGroupId = useTypedSelector(selectFocusGroupId);
  const group = useTypedSelector(selectGroupById(focusGroupId));
  const isMobile = useMemo(() => mobile || matchesSmartphone, [mobile, matchesSmartphone]);
  const dispatch = useTypedDispatch();
  const rootVariable = useStartInstance();
  const selection = useTypedSelector(selectSelectionByVariableId(rootVariable == null ? void 0 : rootVariable.id));
  useEffect(() => {
    let sel = rootSelection;
    if (rootSelection && selection) {
      sel = selection;
    }
    dispatch(setPseudoRootSelection(sel));
    dispatch(setOpenInstance(sel));
    dispatch(setInitialFocusGroupKey());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [app.id]);
  return jsxs(Box, {
    component: "div",
    className: `configurator ${group != null && group.key ? group.key : ""}`,
    sx: {
      overflow: "hidden",
      height: "100%"
    },
    children: [jsx(Modals, {}), jsx(LayoutBuilder, {
      app: app,
      isMobile: isMobile
    })]
  });
};
const ConfiguratorWithExtensionContext = withExtensionContext(withExtensions({
  app: {
    configurator: {
      root: true
    }
  }
})(ConfiguratorComponent));
const Configurator = _ref => {
  let {
      editorUi
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const providedExtensions = useProvidedExtensions().extensions;
  /** Merges admin and normal extensions */
  const appliedExtensions = useMemo(() => {
    if (!editorUi) {
      return providedExtensions;
    }
    const merged = {};
    _$1.merge(merged, providedExtensions, createNewAdminExtensions(providedExtensions));
    return merged;
  }, [editorUi, providedExtensions]);
  return jsx(WithInitializedEngine, {
    children: jsx(ConfiguratorWithExtensionContext, Object.assign({}, props, {
      extensions: appliedExtensions
    }))
  });
};

function useAppIdQuery(id, enabled = true, language) {
  const adminLang = useTypedSelector(selectAdminLanguage);
  const lang = language != null ? language : adminLang;
  const cachingKey = ["app", {
    id,
    lang
  }];
  return useQuery(cachingKey, async ({
    queryKey: [type, {
      id,
      lang
    }]
  }) => {
    return await api_getResourceById(type, String(id), {
      lang
    });
  }, {
    enabled
  });
}

/** Ensures that the correct FE Bundle is loaded. Redirects the user if not */
const useCorrectConfiguratorBundle = () => {
  const appId = +useParams().appId;
  const app = useAppIdQuery(appId).data;
  const appCode = getAppCodeFromQuery();
  if ((app == null ? void 0 : app.code) === appCode) {
    console.warn("Not switching bundle because no app could be found. " + "This is most likely a race condition somewhere, but we will be forgiving here, " + "as it is very likely that the user will be redirected correctly eventually.");
    return;
  }
  setLocationBasedOnAppType(app, false);
};
const setLocationBasedOnAppType = (app, useFrontendURL) => {
  if (!app) return;
  const location = getLocationInfo();
  const type = app.type || defaultApp;
  if (location.currentAppType === type ||
  // sadly we don't have multiple apps on localhost so we stay here.
  !location.host.includes(env.originalDomain)) {
    return;
  }
  const target = `${window.location.protocol}//${location.host}/${type}${useFrontendURL ? "" : "/#"}/${location.path}`;
  window.location.replace(target);
};

/***
 * Mac OS X hides scrollbars by default. This is annoying for UI design because it means users might not realize that certain areas are scrollable.
 * https://gist.github.com/pjobson/c45f9c3dfa4b7fc3f30f0de29d1beaa1
 */
function makeScrollbarsVisible() {
  if (!areScrollbarsVisible()) {
    document.body.classList.add("force-show-scrollbars");
  }
}
function areScrollbarsVisible() {
  const scrollableElem = document.createElement("div"),
    innerElem = document.createElement("div");
  scrollableElem.style.width = "30px";
  scrollableElem.style.height = "30px";
  scrollableElem.style.overflow = "scroll";
  scrollableElem.style.borderWidth = "0";
  innerElem.style.width = "30px";
  innerElem.style.height = "60px";
  scrollableElem.appendChild(innerElem);
  document.body.appendChild(scrollableElem); // Elements only have width if they're in the layout
  const diff = scrollableElem.offsetWidth - scrollableElem.clientWidth;
  document.body.removeChild(scrollableElem);
  return diff > 0;
}
const scrollbarStyles = color => {
  return {
    "*": {
      scrollbarWidth: "thin",
      scrollbarColor: `${color} transparent`
    },
    "*::-webkit-scrollbar": {
      width: "5px"
    },
    "*::-webkit-scrollbar-track": {
      backgroundColor: "transparent"
    },
    "*::-webkit-scrollbar-thumb": {
      background: `${color}`,
      borderRadius: "2px"
    },
    "*::-webkit-scrollbar-thumb:hover": {
      background: `linear-gradient(rgba(0,0,0,.1),rgba(0,0,0,.1)) ${color}`
    }
  };
};
const forceVisibleScrollbarStyles = {
  ".force-show-scrollbars ::-webkit-scrollbar": {
    webkitAppearance: "none"
    // "background-color": "#FAFAFA",
  },

  ".force-show-scrollbars ::-webkit-scrollbar-thumb": {
    backgroundClip: "padding-box",
    borderColor: "transparent",
    borderStyle: "solid",
    borderWidth: "1px 0px 1px 0px" /* Workaround because margins aren't supported */
  }
};

function FrontendApp() {
  const app = useTypedSelector(selectFrontendApp);
  useEffect(() => {
    document.title = (app == null ? void 0 : app.label) || "Konfigurator";
  }, [app]);
  setLocationBasedOnAppType(app, true);
  const appTheme = useAppTheme();
  // avoid recomputing the styles on every render otherwise it crashes sometimes
  // https://mui.com/material-ui/customization/how-to-customize/#4-global-css-override
  const globalStylesComponent = useMemo(() => jsx(GlobalStyles, {
    styles: scrollbarStyles(appTheme.palette.scrollbar.default)
  }), [appTheme.palette.scrollbar.default]);
  return jsxs(ThemeProvider, {
    theme: appTheme,
    children: [globalStylesComponent, app ? jsx(Configurator, {
      app: app,
      editorUi: false
    }) : jsx(AppLoader, {})]
  });
}

function QuerySuspenseLoader() {
  return jsx(Backdrop, {
    open: true,
    children: jsx(MoonLoader, {
      size: 50,
      color: "white"
    })
  });
}

function SupportForm() {
  const {
    t
  } = useTranslation();
  return jsx(Link, {
    "data-cy": `supportForm`,
    href: "https://form.asana.com/?k=jdYe6sK2psLWak-zkUjxnw&d=4828816729443",
    target: "_blank",
    children: jsx(Typography, {
      children: t("Sie können uns den Vorfall hier melden!")
    })
  });
}

function FrontendErrorDialog(props) {
  const {
    t
  } = useTranslation();
  const navigate = useNavigate();
  const propsBody = props.body ? _$1.isString(props.body) ? t(props.body) : props.body : t("Fatal_Error_Text");
  return jsxs(Dialog, {
    open: true,
    "aria-labelledby": "alert-dialog-title",
    "aria-describedby": "alert-dialog-description",
    children: [jsx(DialogTitle, {
      id: "alert-dialog-title",
      children: props.heading ? t(props.heading) : t("Fatal_Error")
    }), jsxs(DialogContent, {
      children: [jsxs(DialogContentText, {
        id: "alert-dialog-description",
        children: [propsBody, jsx(SupportForm, {})]
      }), props.error && jsxs(Fragment, {
        children: [jsx("hr", {}), jsx(DialogContentText, {
          children: t("Fehlermeldung:")
        }), jsx(DialogContentText, {
          children: t(props.error.message)
        })]
      })]
    }), jsxs(DialogActions, {
      children: [jsx(Button, {
        "data-cy": `goHome`,
        onClick: () => {
          navigate("/admin");
          navigate(0);
        },
        children: t("Zur Startseite")
      }), jsx(Button, {
        onClick: () => window.location.reload(),
        "data-cy": `reload`,
        children: t("Neu Laden")
      }), jsx(Button, {
        "data-cy": `restart`,
        onClick: () => {
          window.localStorage.clear();
          window.location.reload();
        },
        children: t("Cleanup und Neu Laden")
      })]
    })]
  });
}

var FrontendErrorType;
(function (FrontendErrorType) {
  FrontendErrorType[FrontendErrorType["CONFIGURATION_NOT_FOUND"] = 0] = "CONFIGURATION_NOT_FOUND";
  FrontendErrorType[FrontendErrorType["APP_NOT_FOUND"] = 1] = "APP_NOT_FOUND";
  FrontendErrorType[FrontendErrorType["NO_DEALER_ACCESS"] = 2] = "NO_DEALER_ACCESS";
})(FrontendErrorType || (FrontendErrorType = {}));
class FrontendError extends Error {
  constructor(type) {
    super();
    this.type = void 0;
    this.type = FrontendErrorType[type];
    this.name = FrontendErrorType[type];
    this.message = FrontendErrorType[type];
  }
  isType(type) {
    return this.type === type;
  }
}

class FrontendTopLevelErrorBoundary extends React__default.Component {
  constructor(props) {
    super(props);
    this.onUnhandledRejection = event => {
      event.promise.catch(error => {
        this.setState(FrontendTopLevelErrorBoundary.getDerivedStateFromError(error));
      });
    };
    this.state = {
      hasError: false,
      error: null,
      isApiError: false
    };
    this.handleCloseError = this.handleCloseError.bind(this);
  }
  static getDerivedStateFromError(_error) {
    return {
      hasError: true,
      error: _error,
      isApiError: _error instanceof ApiError
    };
  }
  componentDidMount() {
    window.addEventListener("unhandledrejection", this.onUnhandledRejection);
  }
  componentWillUnmount() {
    window.removeEventListener("unhandledrejection", this.onUnhandledRejection);
  }
  componentDidCatch(error, errorInfo) {
    console.error("Unexpected error occurred!", error, errorInfo);
  }
  handleCloseError() {
    this.setState({
      hasError: false,
      error: null,
      isApiError: false
    });
  }
  render() {
    if (!this.state.error) return this.props.children;
    if (this.state.error instanceof FrontendError) {
      return {
        CONFIGURATION_NOT_FOUND: jsx(FrontendErrorDialog, {
          heading: "Ladevorgang fehlgeschlagen",
          body: "Die Konfiguration konnte nicht geladen werden! Bitte versuchen Sie es sp\u00E4ter erneut!"
        }),
        APP_NOT_FOUND: jsx(FrontendErrorDialog, {
          heading: "Ladevorgang fehlgeschlagen",
          body: "Es liegt keine ver\u00F6ffentlichte Version der App vor."
        }),
        NO_DEALER_ACCESS: jsx(FrontendErrorDialog, {
          heading: "Ladevorgang fehlgeschlagen",
          body: "Der H\u00E4ndler Konfigurator ist nicht aktiv. Bitte wenden sie sich an ihren Betreiber."
        })
      }[this.state.error.type];
    } else {
      if (this.state.hasError) {
        return this.state.isApiError ? jsxs(Fragment, {
          children: [jsx(Snackbar$1, {
            open: true,
            color: "alert",
            children: jsx(Alert, {
              onClose: this.handleCloseError,
              severity: "error",
              sx: {
                width: "100%"
              },
              children: this.state.error.message
            })
          }), this.props.children]
        }) : jsx(FrontendErrorDialog, {
          error: this.state.error
        });
      }
    }
  }
}

function ErrorDialog(props) {
  const {
    t
  } = useTranslation();
  const navigate = useNavigate();
  return jsxs(Dialog, {
    open: true,
    "aria-labelledby": "alert-dialog-title",
    "aria-describedby": "alert-dialog-description",
    children: [jsx(DialogTitle, {
      id: "alert-dialog-title",
      children: props.heading ? props.heading : t("Fatal_Error")
    }), jsxs(DialogContent, {
      children: [jsxs(DialogContentText, {
        component: "div",
        id: "alert-dialog-description",
        children: [props.body ? props.body : t("Fatal_Error_Text"), jsx(SupportForm, {})]
      }), props.error && jsxs(Fragment, {
        children: [jsx("hr", {}), jsx(DialogContentText, {
          children: t("Error_Message")
        }), jsx(DialogContentText, {
          children: props.error.message
        })]
      })]
    }), jsxs(DialogActions, {
      children: [jsx(Button, {
        "data-cy": `goHome`,
        onClick: () => {
          navigate("/admin");
          navigate(0);
        },
        children: t("Zur Startseite")
      }), jsx(Button, {
        onClick: () => navigate(0),
        "data-cy": `reload`,
        children: t("Neu Laden")
      }), jsx(Button, {
        "data-cy": `restart`,
        onClick: () => {
          window.localStorage.clear();
          navigate(0);
        },
        children: t("Cleanup und Neu Laden")
      })]
    })]
  });
}

class TopLevelErrorBoundary extends React__default.Component {
  constructor(props) {
    super(props);
    this.onUnhandledRejection = event => {
      event.promise.catch(error => {
        this.setState({
          error: null,
          unhandledError: error
        });
      });
    };
    this.state = {
      error: null,
      unhandledError: null
    };
  }
  static getDerivedStateFromError(error) {
    return {
      error: error,
      unhandledError: error
    };
  }
  componentDidMount() {
    window.addEventListener("unhandledrejection", this.onUnhandledRejection);
  }
  componentWillUnmount() {
    window.removeEventListener("unhandledrejection", this.onUnhandledRejection);
  }
  componentDidCatch(error) {
    this.setState({
      error,
      unhandledError: null
    });
  }
  handleCloseError() {
    this.setState({
      error: null,
      unhandledError: null
    });
  }
  render() {
    var _this$state$unhandled;
    if (this.state.error) return jsx(ErrorDialog, {
      error: this.state.error
    });
    return jsxs(Fragment, {
      children: [jsx(Snackbar$1, {
        open: !!this.state.unhandledError,
        color: "alert",
        children: jsxs(Alert, {
          severity: "error",
          sx: {
            width: "100%"
          },
          action: jsxs(Stack, {
            direction: "row",
            children: [jsx(IconButton, {
              "data-cy": `reload`,
              color: "primary",
              onClick: () => {
                window.location.reload();
              },
              children: jsx(Refresh, {})
            }), jsx(IconButton, {
              "aria-label": "close",
              onClick: () => this.handleCloseError(),
              "data-cy": `close`,
              children: jsx(Close, {
                fontSize: "inherit"
              })
            })]
          }),
          children: [jsx(Typography, {
            variant: "body1",
            children: (_this$state$unhandled = this.state.unhandledError) == null ? void 0 : _this$state$unhandled.message
          }), jsx(Typography, {
            variant: "body1",
            children: i18n.t("You may need to reload the page")
          })]
        })
      }), this.props.children]
    });
  }
}

const load = async () => {
  return {
    default: (await import('./AdminRoutes.js')).AdminRoutes
  };
};
const AdminApp = /*#__PURE__*/lazy(load);
function Router() {
  return jsxs(Routes, {
    children: [jsx(Route, {
      path: "admin/*",
      element: jsx(Administration, {})
    }), jsx(Route, {
      path: "*",
      element: jsx(Frontend, {})
    })]
  });
}
function Administration() {
  return jsx(TopLevelErrorBoundary, {
    children: jsx(Suspense, {
      fallback: jsx(QuerySuspenseLoader, {}),
      children: jsx(AdminApp, {})
    })
  });
}
function Frontend() {
  return jsx(FrontendTopLevelErrorBoundary, {
    children: jsx(FrontendApp, {})
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // cacheTime,
      // enabled,
      // initialData,
      // initialDataUpdatedAt,
      // isDataEqual,
      // keepPreviousData,
      // meta,
      // networkMode,
      // notifyOnChangeProps,
      // onError,
      // onSettled,
      // onSuccess,
      // placeholderData,
      // queryKeyHashFn,
      // refetchInterval,
      // refetchIntervalInBackground,
      // refetchOnMount,
      // refetchOnReconnect,
      // refetchOnWindowFocus: false,
      retry: false,
      // retryDelay,
      // retryOnMount,
      // select,
      // staleTime: Infinity,
      // structuralSharing,
      suspense: true,
      useErrorBoundary: true
    },
    mutations: {
      // cacheTime,
      // meta,
      // mutationKey,
      // networkMode,
      // onError,
      // onMutate,
      // onSettled,
      // onSuccess,
      // retry,
      // retryDelay,
      // useErrorBoundary: true,
    }
  }
});

const reduxStore = configureStore({
  reducer: {
    common: commonReducer,
    configurator: configuratorReducer,
    ruleEngine: ruleEngineReducer,
    actionEngine: actionEngineReducer,
    frontend: frontendReducer,
    k3d: k3dReducer,
    order: orderReducer,
    layoutDesigner: layoutDesignerReducer,
    metadata: combineReducers({
      articles: articlesReducer,
      client: clientReducer,
      groups: groupsReducer,
      images: imagesReducer,
      materials: materialsReducer,
      models: modelsReducer,
      prices: pricesReducer,
      ruleItems: ruleItemsReducer,
      rules: rulesReducer,
      values: valuesReducer,
      variables: variablesReducer
    })
  }
});

const globalStyles = Object.assign({}, k3GlobalStylePreset, {
  a: {
    textDecoration: "none",
    color: "rgba(0, 0, 0, 0.6)"
  },
  canvas: {
    border: "none",
    outline: "none"
  }
});

// Having the license set here is actually fine, see: https://mui.com/x/introduction/licensing/#security
LicenseInfo.setLicenseKey("9e1cb1654be631eaf1fa9b254d045a04T1JERVI6Mzk2MzEsRVhQSVJZPTE2Nzg4NzE3NjYwMDAsS0VZVkVSU0lPTj0x");
let router = jsx(Router, {});
// Ermöglicht in Cypress zugriff auf den Store...
if (window.Cypress) window.store = reduxStore;
if (env.bugsnagKey) {
  Bugsnag.start({
    apiKey: env.bugsnagKey,
    plugins: [new BugsnagPluginReact()]
  });
  const ErrorBoundary = Bugsnag.getPlugin("react").createErrorBoundary(React__default);
  router = jsx(ErrorBoundary, {
    children: router
  });
}
// Ermöglicht in Cypress zugriff auf den Store...
if (window.Cypress) window.store = reduxStore;
// Make scrollbars on Mac OS X visible
makeScrollbarsVisible();
const mergedStyles = Object.assign({}, globalStyles, forceVisibleScrollbarStyles);
// avoid recomputing the styles on every render otherwise it crashes sometimes
// https://mui.com/material-ui/customization/how-to-customize/#4-global-css-override
const globalStylesComponent = jsx(GlobalStyles, {
  styles: mergedStyles
});
/** Main entry point into the K3.
 * Allows to specify data needed for the extension.
 *
 * In general have a look at the interfaces/types.
 * Most things are further documented there.
 * In this case, check out `ProvidedExtensionsType` and then `K3Extensions` etc.
 */
const K3Main = props => {
  var _parent$additionalDyn, _parent$contexts;
  // parent only is here to maintain backwards compatibility with the deprecated
  // exposed Provider. Can be removed when ProvidedExtensionsProvider is removed.
  const parent = useProvidedExtensions();
  useEffect(() => {
    console.log(`K3 Version: ${K3_PACKAGE_VERSION}`);
  }, []);
  return jsx(providedExtensionsContext.Provider, {
    value: {
      extensions: Object.keys(parent.extensions).length ? parent.extensions : props.extensions || {},
      additionalDynamicSettings: (_parent$additionalDyn = parent.additionalDynamicSettings) != null && _parent$additionalDyn.length ? parent.additionalDynamicSettings : props.additionalDynamicSettings || [],
      contexts: (_parent$contexts = parent.contexts) != null && _parent$contexts.length ? parent.contexts : props.contexts || [],
      themeOptionsCreator: props.themeOptionsCreator
    },
    children: jsxs(QueryClientProvider, {
      client: queryClient,
      children: [jsx(Provider, {
        store: reduxStore,
        context: K3ReduxContext,
        children: jsxs(ThemeProvider$1, {
          theme: theme,
          children: [jsx(ScopedCssBaseline, {
            enableColorScheme: true
          }), globalStylesComponent, jsx(HashRouter, {
            children: router
          }), jsx(K3Loading, {})]
        })
      }), jsx(ReactQueryDevtools, {
        initialIsOpen: false
      })]
    })
  });
};

const useApplyValuesFromInstanceToInstance = variableKeysToSkip => {
  const input = useTypedSelector(selectRuleEngineInput);
  const state = useTypedSelector(selectRuleEngineState);
  const dispatch = useTypedDispatch();
  if (!input || !state) {
    console.warn("Rule engine not initialized!");
    return () => state;
  }
  return (from, to, customState = state, apply = true) => {
    const newState = applyPreset(input, input.variables.flat.all)(from, to, customState);
    apply && dispatch(applyRuleEngineStateThunk(newState));
    return newState;
  };
};
const applyPreset = (input, variablesToChange) => (from, to, state) => {
  let newCurrentState = state;
  const relevant = variablesToChange.filter(v => v.parentId === from.variableId);
  const findValue = selection => input.values.byVarId.all[selection.variableId].find(v => v.id === selection.valueId);
  relevant.forEach(variable => {
    const selections = newCurrentState.state.all.selections;
    const selectionsFrom = selections.filter(s => s.variableId === variable.id && realDirectParent(s) === from.id);
    const selectionsTo = selections.filter(s => s.variableId === variable.id && realDirectParent(s) === to.id);
    if (isMultiVariable(variable)) {
      const newFromAndTo = [];
      selectionsTo.forEach(selectionTo => {
        const res = removeInstance(input, newCurrentState.state, selectionTo);
        if (res) newCurrentState = res;
      });
      selectionsFrom.forEach(selectionFrom => {
        const res = addInstance(input, newCurrentState.state, to, findValue(selectionFrom), selectionFrom.sort, selectionFrom.data);
        if (res) {
          newCurrentState = res;
          newFromAndTo.push([selectionFrom, res.lastManualChange]);
        }
      });
      newFromAndTo.forEach(([newFrom, newTo]) => {
        newCurrentState = applyPreset(input, variablesToChange)(newFrom, newTo, newCurrentState);
      });
    } else {
      const selectionFrom = selectionsFrom[0];
      const res = changeVariable(input, newCurrentState.state, to, findValue(selectionFrom), selectionFrom.data);
      if (res) newCurrentState = res;
    }
  });
  return newCurrentState;
};

const inIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

const ModelSelector = ({
  label: _label = "Modell",
  modelKey: _modelKey = "",
  multiple: _multiple = false,
  onChange,
  onChangeMultiple
}) => {
  var _useModels, _models$find;
  const models = ((_useModels = useModels()) != null ? _useModels : []).filter(model => model.key);
  const handleModelChange = newValue => {
    if (Array.isArray(newValue)) {
      const keys = newValue.reduce((acc, model) => model.key ? [...acc, model.key] : acc, []);
      onChangeMultiple == null ? void 0 : onChangeMultiple(keys);
    } else {
      if (newValue != null && newValue.key) {
        onChange == null ? void 0 : onChange(newValue.key);
      }
    }
  };
  const value = _multiple ? models.filter(model => model.key && _modelKey.includes(model.key)) : (_models$find = models == null ? void 0 : models.find(model => model.key === _modelKey)) != null ? _models$find : null;
  return jsx(Autocomplete, {
    id: "model-selector",
    "data-cy": "modelSelector",
    options: models,
    multiple: _multiple,
    sx: {
      maxWidth: 1.0
    },
    disableCloseOnSelect: _multiple,
    value: value,
    renderInput: params => jsx(TextField, Object.assign({}, params, {
      label: _label
    })),
    onChange: (_event, newValue) => {
      if (newValue) {
        handleModelChange(newValue);
      }
    }
  });
};

export { langMap as $, fails$A as A, functionApply as B, isRegexp as C, arraySliceSimple as D, regexpExec$2 as E, regexpStickyHelpers as F, useTypedSelector as G, selectFrontendApp as H, selectConfiguratorApp as I, useUpdateResourceMutation as J, selectIsApp3D as K, selectAdminLanguage as L, useTypedDispatch as M, selectCurrentGroup as N, OCImageUpload as O, selectRules as P, selectVariables as Q, setHelpTopic as R, transform as S, OCSelect as T, api_request as U, useAsyncError as V, useDeleteResourceMutation as W, selectContentLanguage as X, selectModelById as Y, OCTextInput as Z, _objectWithoutPropertiesLoose as _, isMaterialActionColumn as a, LocalizedText as a$, defaultContentLangs as a0, socialData as a1, StageType as a2, OCSwitch as a3, OCNumberInput as a4, setContentLanguage as a5, api_exportApp as a6, selectSearch as a7, api_queryResources as a8, api_undeleteResource as a9, api_getConfigurationPdf as aA, pdfToDataUrl as aB, env as aC, OCCheckbox as aD, api_connectShop as aE, loadFullAppByCode as aF, api_getResourceById as aG, api_getDocs as aH, handleLoadedApp as aI, setDealerData as aJ, setConfiguratorApp as aK, selectModels as aL, useAppTheme as aM, api_logout as aN, api_login as aO, initializeGoogleAnalytics as aP, analyticsFunnel as aQ, SearchField as aR, setSearchString as aS, api_fetchRaw as aT, api_fetch as aU, setEngineState as aV, resetMetadata as aW, getLogoUrl as aX, applyCallback as aY, ConfigurationState as aZ, getSettingsActions as a_, api_queryResourceTrash as aa, useAppIdQuery as ab, useCreateResourceMutation as ac, getAppUrl as ad, addLabels as ae, maybeParseInt as af, modulo as ag, getLanguages as ah, Loading as ai, api_updateResource as aj, api_bulkUpdateResource as ak, createStyleObject as al, api_getFullApp as am, getSettings as an, monacoOptions as ao, requestLoadingThunk as ap, api_getDocumentTmpl as aq, finishLoading as ar, _export as as, functionUncurryThisClause as at, objectGetOwnPropertyDescriptor as au, notARegexp as av, correctIsRegexpLogic as aw, useApp as ax, selectLanguage as ay, api_uploadDocument as az, isInstanceActionColumn as b, OCColorPicker as b$, api_getConfigurationShop as b0, selectPriceFormatter as b1, isWithId as b2, isString as b3, selectArticleById as b4, selectCurrentArticleCatories as b5, forEachExtra as b6, selectVariableByAttribute as b7, noSelectionKey as b8, selectRuleItemsByValueId as b9, selectCurrentPrices as bA, api_importArticles as bB, api_publish_articles as bC, setConfiguratorVariable as bD, selectPreviewDevice as bE, selectShowEditorUi as bF, setShowEditorUi as bG, scrollbarStyles as bH, Configurator as bI, selectIsApp2D as bJ, api_getFullAppFromJsonWithLangDefault as bK, api_publish as bL, useInjectCss as bM, selectMaterials as bN, selectGroups as bO, selectRuleEngineError as bP, setPreviewDevice as bQ, EditButton as bR, useCorrectConfiguratorBundle as bS, WithInitializedEngine as bT, selectImages as bU, setImages as bV, selectCurrentImageFolders as bW, selectDevmode as bX, OCRALColorSelect as bY, ralColorsComplete as bZ, ColorButton as b_, selectRulesByVariableId as ba, getTemplateOptions as bb, selectValuesByVariableId as bc, selectGroupsByParentId as bd, selectVariablesOfGroup as be, isMaterialActionModelTarget as bf, selectCameras as bg, selectVariableById as bh, selectGroupById as bi, isExpression as bj, selectRuleItems as bk, isActionRuleItemValue as bl, isRecord as bm, api_createResource as bn, createPrice as bo, deletePrice as bp, api_deleteResource as bq, updatePrice as br, selectConfiguratorAppId as bs, selectPricesByArticleId as bt, CurrencyType as bu, PriceType as bv, createArticle as bw, deleteArticle as bx, updateArticle as by, selectCurrentArticles as bz, isModelActionColumn as c, setConfiguratorGroup as c$, loadMaterialWithTextures as c0, getDreiPresetUrl as c1, stringRepeat as c2, engineUserAgent as c3, deleteMaterial as c4, selectActionEngineInput as c5, safeGetLocalStorage as c6, isMaterialActionRuleValue as c7, theme as c8, getDynamicModels as c9, DesignType as cA, SidebarType as cB, api_copyApp as cC, GroupTemplateType as cD, queryClient as cE, downloadFileByUrl as cF, allLocales as cG, setLanguage as cH, setDevmode as cI, selectCamerasByScope as cJ, setNextCameraPosition as cK, forceNextCameraPosition as cL, api_products as cM, api_book as cN, selectHelpTopic as cO, selectDealerData as cP, Unfoldable as cQ, createGroup as cR, createGroupCommon as cS, isNewGroup as cT, isGroup as cU, updateGroupThunk as cV, deleteGroup as cW, selectGroupsForOpenInstance as cX, selectableGroupActions as cY, addItemAction as cZ, getLocalizedText as c_, PositionRotationScale as ca, updateRuleItemThunk as cb, api_bulkCreateResource as cc, setMaterials as cd, selectRuleEngineInput as ce, selectSelections as cf, isBackgroundModel as cg, K3DContent as ch, evaluateModelProps as ci, getBasicSceneInformation as cj, setIsRenderingScreenshot as ck, sleep as cl, api_uploadResourceContent as cm, backgroundTag as cn, rootSelection as co, setModels as cp, selectModelsByAppId as cq, selectRulesByAppId as cr, createRule as cs, selectRuleItemsByRuleId as ct, deleteRuleItem as cu, deleteRule as cv, selectCurrentRules as cw, api_importApp as cx, SupportedLocale as cy, SidebarPositionType as cz, isLabelActionColumn as d, isVariableId as d$, setGroup as d0, getLayouts as d1, selectShowThemeDialog as d2, selectShowMobileThemeDialog as d3, setShowThemeDialog as d4, getMobileLayouts as d5, setShowMobileThemeDialog as d6, getLogoLink as d7, getLogoOpacity as d8, getLogoSize as d9, setVariableTemplateOptions as dA, VariableType as dB, reduceExtra as dC, createBasicValue as dD, SelectMenuItem as dE, InfoSelectionIcon as dF, OCRadiobuttons as dG, VariableLabel as dH, ValueDetails as dI, InvalidSelectionWarning as dJ, OCColorSelect as dK, ComponentListTmp as dL, OCSelectListItem as dM, ComponentListPopupTmp as dN, RadioCard as dO, Switch as dP, SwitchCard as dQ, when as dR, pickByExtra as dS, setVariableTemplate as dT, setVariableType as dU, getTemplate as dV, RuleColumnType as dW, selectVariablesByType as dX, indexById as dY, isMaterialActionGlobalTarget as dZ, Thumbnail as d_, OCSlider as da, isEntity as db, overwriteDealerApp as dc, selectPrivateDataText as dd, overviewType as de, DnDList as df, moveItem as dg, SceneTemplates as dh, injectCss as di, mapValuesExtra as dj, mapExtra as dk, ImageFormat as dl, selectOpenInstance as dm, filterAllSelectionsInHierarchy as dn, isVariable as dp, ExpressionEditorPreview as dq, ExpressionEditorDialog as dr, selectGroupsByIdMap as ds, VariableTemplateType as dt, selectNoSelectionValue as du, updateVariableThunk as dv, showSelection$4 as dw, deleteNoSelectionValueForVariable as dx, createNoSelectionValueForVariable as dy, HTMLStringToReact as dz, isConcealVariableActionColumn as e, DynamicSettingsLaunch as e$, updateRuleItem as e0, updateRule as e1, selectCurrentVariables as e2, selectRuleById as e3, selectCurrentMaterials as e4, set$1 as e5, createRuleItem as e6, isRALTemplate as e7, selectValueById as e8, updateValue as e9, selectVariablesByAppId as eA, selectValuesByAppId as eB, isColorVariable as eC, selectCurrentGroups as eD, selectValues as eE, selectRuleColumnById as eF, isIntervalRuleItemValue as eG, LocalizedHTML as eH, updateRuleItems as eI, parseInterval as eJ, isActionColumn as eK, hasRememberedToken as eL, K3_PACKAGE_VERSION as eM, K3_EXTERNAL_VERSION as eN, K3Main as eO, ProvidedExtensionsProvider as eP, providedExtensionsContext as eQ, useProvidedExtensions as eR, findClosestValue as eS, useNumberVariableChangeHandler as eT, getMinimumDeviation as eU, selectRuleEngineInfo as eV, useHandleChange as eW, addCallbacks as eX, removeCallbacks as eY, useComponentProps as eZ, LightTooltip as e_, selectActionsByTypeId as ea, ActionIds as eb, ExpressionEditor as ec, selectMaterialById as ed, selectCurrentModels as ee, updateValues as ef, move as eg, createValueThunk as eh, ralColorsByHex as ei, deleteValueThunk as ej, isNumberVariable as ek, directionForBAfterA as el, createVariable as em, deleteVariable as en, isNewVariable as eo, VariableEditorStep as ep, isBooleanVariable as eq, createBooleanVariableDefaultValues as er, isImageVariable as es, createImageVariableDefaultValues as et, getVariablesByGroupId as eu, useSetDynamicSettings as ev, DynamicSettingsForm as ew, isValueReferencingRuleItemValue as ex, isValueIdArray as ey, isValueId as ez, isConcealGroupActionColumn as f, usePriceFormatter as f$, EditDynamicSettings as f0, PriceTableArticle as f1, ExpressionInput as f2, NumberWarningTooltip as f3, getInputValue as f4, getMinMaxTemplateOptions as f5, useApplyValuesFromInstanceToInstance as f6, useMaterialReplacedGLTF as f7, useGLTFWithAppliedActions as f8, useModelWithAppliedActions as f9, NavigationButtons as fA, NavigationButtonsWithData as fB, StandaloneVariable as fC, inIframe as fD, ModelSelector as fE, getDynamicModelComponent as fF, BasicDynamicModelEditor as fG, Dimensions as fH, TransformationAndDimensions as fI, useIsMobile as fJ, useGroups as fK, useFocusedGroupId as fL, useSetFocusedGroup as fM, useGroupById as fN, useGroupByKey as fO, useVariables as fP, useVariableByKey as fQ, useVariablesByGroupId as fR, useVariableById as fS, useValues as fT, useValueByKey as fU, useValueById as fV, useValuesByVariableId as fW, useRules as fX, useRuleItems as fY, useArticles as fZ, useAllArticlesAndPrices as f_, useGLTF_GDPRCompliant as fa, useExecuteSave as fb, useSelectionMap as fc, CanvasWithScreenshotting as fd, K3CameraEffects as fe, K3CameraControl as ff, K3D as fg, K3Model as fh, ContentView as fi, Header as fj, HeaderTabs as fk, GroupsNavigation as fl, LogoWithData as fm, Logo as fn, EditScene as fo, SceneButtonGroup as fp, FullscreenButton as fq, SocialShareButtons as fr, PriceWithData as fs, Price as ft, ExitButtonGroupWithData as fu, ExitButtonGroup as fv, Sidebar as fw, SidebarWithData as fx, LabelActionsDisplayWithData as fy, LabelActionsDisplay as fz, isHideVariableActionColumn as g, usePrices as g0, useShouldDisplayPrice as g1, useModels as g2, useMaterials as g3, useImages as g4, useActions as g5, useOpenInstance as g6, useIsOpenInstanceFirstOfSiblings as g7, useSelections as g8, useSelectionByVariableId as g9, useIsEditor as gA, useAddInstanceToVariable as gB, useSafeDeleteInstance as gC, useAnchoringSelections as gD, useConfiguration as gE, useGetDynamicSettingNoDefault as gF, useDynamicTranslation as gG, useDynamicSetting as gH, useDynamicSettingArray as gI, useSetDynamicTranslations as gJ, useSetDynamicSetting as gK, DynamicSettingValueType as gL, DynamicSettingsKeys as gM, dynamicSettings as gN, useDynamicSettings as gO, vectorValidator as gP, arrayValidator as gQ, useSelectedValueByVariableKey as ga, useSelectedNumberByVariableKey as gb, useSelectionByVariableKey as gc, useInstanceSelectionsByValueKey as gd, useSelectedValueAttributeByKey as ge, useSelectedValueAttributesByKeys as gf, useSetNextCamera as gg, useRuleEngineInput as gh, useRuleEngineState as gi, useRuleEngineValues as gj, useActionEngineState as gk, useRuleEngineValueByVarId as gl, useChangeVariable as gm, useAddInstance as gn, useRemoveInstance as go, useRuleEngineConflict as gp, useAcceptAlternative as gq, useRejectAlternative as gr, useAdminLanguage as gs, useContentLanguage as gt, usePrice as gu, useStartAr as gv, useTriggerAction as gw, useTriggerSave as gx, useChangeGroup as gy, useIsAdminPanel as gz, isHideGroupActionColumn as h, isArticleActionColumn as i, isHideValuesActionColumn as j, isImage2DActionColumn as k, isColorActionColumn as l, isImageActionColumn as m, isVariableColumn as n, functionCall as o, functionUncurryThis as p, fixRegexpWellKnownSymbolLogic as q, anObject$k as r, isNullOrUndefined$8 as s, requireObjectCoercible$b as t, speciesConstructor$3 as u, advanceStringIndex$3 as v, toLength$9 as w, toString$g as x, getMethod$7 as y, regexpExecAbstract as z };
